import _objectWithoutProperties2 from "/builds/gositeinc/gosite-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _inherits from "/builds/gositeinc/gosite-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/builds/gositeinc/gosite-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/builds/gositeinc/gosite-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _taggedTemplateLiteral from "/builds/gositeinc/gosite-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
import _toConsumableArray from "/builds/gositeinc/gosite-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _construct from "/builds/gositeinc/gosite-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/construct";
import _classCallCheck from "/builds/gositeinc/gosite-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/gositeinc/gosite-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _toArray from "/builds/gositeinc/gosite-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toArray";
import _defineProperty2 from "/builds/gositeinc/gosite-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/builds/gositeinc/gosite-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/builds/gositeinc/gosite-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
var _excluded4 = ["styles"],
    _excluded5 = ["styles"],
    _excluded6 = ["styles"],
    _excluded7 = ["styles"],
    _excluded8 = ["styles"],
    _excluded9 = ["styles"],
    _excluded10 = ["styles"],
    _excluded11 = ["styles"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _styled;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e61) { throw _e61; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e62) { didErr = true; err = _e62; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread2(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty2(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import require$$2, { jsx as jsx$1, jsxs, Fragment } from "react/jsx-runtime";
import * as React from "react";
import React__default, { useState, useEffect, useRef, Fragment as Fragment$1, Children, isValidElement, cloneElement, useReducer, useLayoutEffect, useMemo, createElement as createElement$1, useCallback, useContext } from "react";
import Slider from "react-slick";
import { styled as styled$2, Button as Button$1, buttonClasses, Link as Link$2, SvgIcon as SvgIcon$2, svgIconClasses, useTheme as useTheme$4, useMediaQuery, Typography as Typography$2, Box, ToggleButtonGroup as ToggleButtonGroup$1, toggleButtonClasses, FormControl, FormLabel, FormHelperText, OutlinedInput, NativeSelect, Checkbox, FormControlLabel, RadioGroup, Radio, FormGroup, CircularProgress as CircularProgress$2, Alert, Card, Paper as Paper$1, InputBase, IconButton as IconButton$2, colors, Stack as Stack$2, Container, Grid as Grid$2, Rating, ButtonBase as ButtonBase$1, darken as darken$1, Divider, Avatar, List, ListItem, ListItemAvatar, ListItemText, ListItemIcon, CardContent, TextField, Chip, paperClasses, Modal as Modal$1, InputAdornment as InputAdornment$2, AppBar, containerClasses, toolbarClasses, Toolbar, Drawer, backdropClasses, ListItemButton, Collapse as Collapse$1, appBarClasses, createTheme as createTheme$2, ThemeProvider, Accordion as Accordion$3, accordionSummaryClasses as accordionSummaryClasses$1, AccordionSummary as AccordionSummary$2, AccordionDetails as AccordionDetails$2, Slider as Slider$1, Tooltip, tooltipClasses, ToggleButton, cardContentClasses, iconButtonClasses as iconButtonClasses$1, Dialog } from "@mui/material";
export * from "@mui/material";
export { useForkRef } from "@mui/material";
export * from "react-intersection-observer";
import { useLocalstorageState } from "rooks";
export { useLocalstorageState } from "rooks";
import { useFormContext, useController, useForm, FormProvider } from "react-hook-form";
export * from "react-hook-form";
import fetch$1 from "cross-fetch";
import { config as config$1, useSpringRef, useTransition, animated } from "@react-spring/web";
import ReactDOMServer from "react-dom/server";
import { createReactEditorJS } from "react-editor-js";
import clsx from "clsx";
import emStyled from "@emotion/styled";
import { keyframes, css as css$2 } from "@emotion/react";
import createCache from "@emotion/cache";
import FadeIn from "react-fade-in";
import { InlineSVG as InlineSVG$1 } from "svg-inline-react";
import ReactPlayer from "react-player";
import { useTime } from "react-timer-hook";
import { differenceInMinutes as differenceInMinutes$1, addMinutes as addMinutes$1, isSameHour as isSameHour$1, isSameMinute, format as format$1, lastDayOfMonth, addMonths as addMonths$1, fromUnixTime, getUnixTime } from "date-fns";
import hexToRgba from "hex-to-rgba";
import { SpectrumVisualizer, SpectrumVisualizerTheme } from "react-audio-visualizers";
import * as ReactDOM from "react-dom";
import ReactDOM__default from "react-dom";
import CookieConsentBar from "react-cookie-consent";
import Markdown from "react-markdown";
import validator$1 from "validator";
import { Base64 } from "js-base64";
import PopupState, { bindHover, bindPopover } from "material-ui-popup-state";
import "editorjs-data-parser";
import "@segment/analytics-next";
import { gsap } from "gsap";
import classNames from "classnames";
import $ from "jquery";
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var _assign$ = function __assign$1() {
  return _assign$ = Object.assign || function (e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      for (var a in t = arguments[r]) {
        Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
      }
    }

    return e;
  }, _assign$.apply(this, arguments);
};

function __rest$1(e, t) {
  var r = {};

  for (var n in e) {
    Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  }

  if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
    var a = 0;

    for (n = Object.getOwnPropertySymbols(e); a < n.length; a++) {
      t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
    }
  }

  return r;
}

function __awaiter(e, t, r, n) {
  return new (r || (r = Promise))(function (a, o) {
    function i(e) {
      try {
        l(n.next(e));
      } catch (e) {
        o(e);
      }
    }

    function s(e) {
      try {
        l(n.throw(e));
      } catch (e) {
        o(e);
      }
    }

    function l(e) {
      var t;
      e.done ? a(e.value) : (t = e.value, t instanceof r ? t : new r(function (e) {
        e(t);
      })).then(i, s);
    }

    l((n = n.apply(e, t || [])).next());
  });
}

function __generator(e, t) {
  var r,
      n,
      a,
      o,
      i = {
    label: 0,
    sent: function sent() {
      if (1 & a[0]) throw a[1];
      return a[1];
    },
    trys: [],
    ops: []
  };
  return o = {
    next: s(0),
    throw: s(1),
    return: s(2)
  }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
    return this;
  }), o;

  function s(o) {
    return function (s) {
      return function (o) {
        if (r) throw new TypeError("Generator is already executing.");

        for (; i;) {
          try {
            if (r = 1, n && (a = 2 & o[0] ? n.return : o[0] ? n.throw || ((a = n.return) && a.call(n), 0) : n.next) && !(a = a.call(n, o[1])).done) return a;

            switch (n = 0, a && (o = [2 & o[0], a.value]), o[0]) {
              case 0:
              case 1:
                a = o;
                break;

              case 4:
                return i.label++, {
                  value: o[1],
                  done: !1
                };

              case 5:
                i.label++, n = o[1], o = [0];
                continue;

              case 7:
                o = i.ops.pop(), i.trys.pop();
                continue;

              default:
                if (!(a = i.trys, (a = a.length > 0 && a[a.length - 1]) || 6 !== o[0] && 2 !== o[0])) {
                  i = 0;
                  continue;
                }

                if (3 === o[0] && (!a || o[1] > a[0] && o[1] < a[3])) {
                  i.label = o[1];
                  break;
                }

                if (6 === o[0] && i.label < a[1]) {
                  i.label = a[1], a = o;
                  break;
                }

                if (a && i.label < a[2]) {
                  i.label = a[2], i.ops.push(o);
                  break;
                }

                a[2] && i.ops.pop(), i.trys.pop();
                continue;
            }

            o = t.call(e, i);
          } catch (e) {
            o = [6, e], n = 0;
          } finally {
            r = a = 0;
          }
        }

        if (5 & o[0]) throw o[1];
        return {
          value: o[0] ? o[1] : void 0,
          done: !0
        };
      }([o, s]);
    };
  }
}

function __spreadArray(e, t, r) {
  if (r || 2 === arguments.length) for (var n, a = 0, o = t.length; a < o; a++) {
    !n && a in t || (n || (n = Array.prototype.slice.call(t, 0, a)), n[a] = t[a]);
  }
  return e.concat(n || Array.prototype.slice.call(t));
}

function styleInject(e, t) {
  void 0 === t && (t = {});
  var r = t.insertAt;

  if (e && "undefined" != typeof document) {
    var n = document.head || document.getElementsByTagName("head")[0],
        a = document.createElement("style");
    a.type = "text/css", "top" === r && n.firstChild ? n.insertBefore(a, n.firstChild) : n.appendChild(a), a.styleSheet ? a.styleSheet.cssText = e : a.appendChild(document.createTextNode(e));
  }
}

var css_248z$2 = "/* Slider */\n.slick-slider\n{\n    position: relative;\n\n    display: block;\n    box-sizing: border-box;\n\n    -webkit-user-select: none;\n            user-select: none;\n\n    -webkit-touch-callout: none;\n    -khtml-user-select: none;\n    touch-action: pan-y;\n    -webkit-tap-highlight-color: transparent;\n}\n\n.slick-list\n{\n    position: relative;\n\n    display: block;\n    overflow: hidden;\n\n    margin: 0;\n    padding: 0;\n}\n.slick-list:focus\n{\n    outline: none;\n}\n.slick-list.dragging\n{\n    cursor: pointer;\n    cursor: hand;\n}\n\n.slick-slider .slick-track,\n.slick-slider .slick-list\n{\n    transform: translate3d(0, 0, 0);\n}\n\n.slick-track\n{\n    position: relative;\n    top: 0;\n    left: 0;\n\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n}\n.slick-track:before,\n.slick-track:after\n{\n    display: table;\n\n    content: '';\n}\n.slick-track:after\n{\n    clear: both;\n}\n.slick-loading .slick-track\n{\n    visibility: hidden;\n}\n\n.slick-slide\n{\n    display: none;\n    float: left;\n\n    height: 100%;\n    min-height: 1px;\n}\n[dir='rtl'] .slick-slide\n{\n    float: right;\n}\n.slick-slide img\n{\n    display: block;\n}\n.slick-slide.slick-loading img\n{\n    display: none;\n}\n.slick-slide.dragging img\n{\n    pointer-events: none;\n}\n.slick-initialized .slick-slide\n{\n    display: block;\n}\n.slick-loading .slick-slide\n{\n    visibility: hidden;\n}\n.slick-vertical .slick-slide\n{\n    display: block;\n\n    height: auto;\n\n    border: 1px solid transparent;\n}\n.slick-arrow.slick-hidden {\n    display: none;\n}\n";
styleInject(css_248z$2);
var css_248z$1 = "@charset 'UTF-8';\n/* Slider */\n.slick-loading .slick-list\n{\n    background: #fff url('./ajax-loader.gif') center center no-repeat;\n}\n\n/* Icons */\n@font-face\n{\n    font-family: 'slick';\n    font-weight: normal;\n    font-style: normal;\n\n    src: url('./fonts/slick.eot');\n    src: url('./fonts/slick.eot?#iefix') format('embedded-opentype'), url('./fonts/slick.woff') format('woff'), url('./fonts/slick.ttf') format('truetype'), url('./fonts/slick.svg#slick') format('svg');\n}\n/* Arrows */\n.slick-prev,\n.slick-next\n{\n    font-size: 0;\n    line-height: 0;\n\n    position: absolute;\n    top: 50%;\n\n    display: block;\n\n    width: 20px;\n    height: 20px;\n    padding: 0;\n    transform: translate(0, -50%);\n\n    cursor: pointer;\n\n    color: transparent;\n    border: none;\n    outline: none;\n    background: transparent;\n}\n.slick-prev:hover,\n.slick-prev:focus,\n.slick-next:hover,\n.slick-next:focus\n{\n    color: transparent;\n    outline: none;\n    background: transparent;\n}\n.slick-prev:hover:before,\n.slick-prev:focus:before,\n.slick-next:hover:before,\n.slick-next:focus:before\n{\n    opacity: 1;\n}\n.slick-prev.slick-disabled:before,\n.slick-next.slick-disabled:before\n{\n    opacity: .25;\n}\n\n.slick-prev:before,\n.slick-next:before\n{\n    font-family: 'slick';\n    font-size: 20px;\n    line-height: 1;\n\n    opacity: .75;\n    color: white;\n\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n.slick-prev\n{\n    left: -25px;\n}\n[dir='rtl'] .slick-prev\n{\n    right: -25px;\n    left: auto;\n}\n.slick-prev:before\n{\n    content: '←';\n}\n[dir='rtl'] .slick-prev:before\n{\n    content: '→';\n}\n\n.slick-next\n{\n    right: -25px;\n}\n[dir='rtl'] .slick-next\n{\n    right: auto;\n    left: -25px;\n}\n.slick-next:before\n{\n    content: '→';\n}\n[dir='rtl'] .slick-next:before\n{\n    content: '←';\n}\n\n/* Dots */\n.slick-dotted.slick-slider\n{\n    margin-bottom: 30px;\n}\n\n.slick-dots\n{\n    position: absolute;\n    bottom: -25px;\n\n    display: block;\n\n    width: 100%;\n    padding: 0;\n    margin: 0;\n\n    list-style: none;\n\n    text-align: center;\n}\n.slick-dots li\n{\n    position: relative;\n\n    display: inline-block;\n\n    width: 20px;\n    height: 20px;\n    margin: 0 5px;\n    padding: 0;\n\n    cursor: pointer;\n}\n.slick-dots li button\n{\n    font-size: 0;\n    line-height: 0;\n\n    display: block;\n\n    width: 20px;\n    height: 20px;\n    padding: 5px;\n\n    cursor: pointer;\n\n    color: transparent;\n    border: 0;\n    outline: none;\n    background: transparent;\n}\n.slick-dots li button:hover,\n.slick-dots li button:focus\n{\n    outline: none;\n}\n.slick-dots li button:hover:before,\n.slick-dots li button:focus:before\n{\n    opacity: 1;\n}\n.slick-dots li button:before\n{\n    font-family: 'slick';\n    font-size: 6px;\n    line-height: 20px;\n\n    position: absolute;\n    top: 0;\n    left: 0;\n\n    width: 20px;\n    height: 20px;\n\n    content: '•';\n    text-align: center;\n\n    opacity: .25;\n    color: black;\n\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n}\n.slick-dots li.slick-active button:before\n{\n    opacity: .75;\n    color: black;\n}\n";
styleInject(css_248z$1);

var getFormFieldWidth = function getFormFieldWidth(e) {
  switch (e) {
    case "full":
    default:
      return "100%";

    case "oneThird":
      return "33.3%";

    case "oneFourth":
      return "25%";

    case "twoThird":
      return "66.6%";

    case "half":
      return "50%";

    case "threeFourth":
      return "75%";
  }
},
    flattenControlsHavingNameProperty = function flattenControlsHavingNameProperty(e, t) {
  return "items" in t && t.items.every(function (e) {
    return "name" in e;
  }) ? t.items.forEach(function (r) {
    "name" in r && e.push(_assign$(_assign$({}, t), r));
  }) : e.push(t), e;
},
    getUpdatedPrice = function getUpdatedPrice(e) {
  var t,
      r = e.sku,
      n = e.discount,
      a = e.users,
      o = e.locations,
      i = r.includedLocations,
      s = r.includedUsers,
      l = r.maxLocationCount,
      c = r.maxUserCount,
      u = r.optionalProducts,
      d = r.includedTools,
      p = r.basePrice,
      g = r.addOnPrice,
      m = r.memberPrice,
      f = r.locationPrice,
      h = 0,
      b = !1,
      y = null !== (t = u.filter(function (e) {
    return e.selected;
  }).length) && void 0 !== t ? t : 0;
  return o > l || a > c ? b = !0 : (b = !1, h = p, y > d && (h = Number(h) + Number(g) * (Number(y) - d)), o > i && (h = Number(h) + Number(f) * Number(o - i)), a > s && (h = Number(h) + Number(m) * Number(a - s)), null != n && (h *= 1 - n / 100)), {
    hidePrice: b,
    price: h
  };
},
    getEnvVars = function getEnvVars() {
  var e,
      t,
      r = null !== (e = process.env.NEXT_PUBLIC_LOCAL_STRAPI_API_URL) && void 0 !== e ? e : "";

  switch (console.log("NEXT_PUBLIC_APP_ENV:", process.env.NEXT_PUBLIC_APP_ENV), process.env.NEXT_PUBLIC_APP_ENV) {
    case "local":
      r = process.env.NEXT_PUBLIC_LOCAL_STRAPI_API_URL;
      break;

    case "development":
      r = process.env.NEXT_PUBLIC_DEVELOPMENT_STRAPI_API_URL;
      break;

    case "test":
      r = process.env.NEXT_PUBLIC_TEST_STRAPI_API_URL;
      break;

    case "production":
      r = process.env.NEXT_PUBLIC_PRODUCTION_STRAPI_API_URL;
  }

  return console.log("STRAPI_URL:", r), {
    appEnv: null !== (t = process.env.NEXT_PUBLIC_APP_ENV) && void 0 !== t ? t : "",
    strapiDomain: r
  };
},
    env = _assign$({}, getEnvVars());

function getStrapiMedia(e) {
  return null == e ? null : e.startsWith("http") || e.startsWith("//") ? e : "".concat(env.strapiDomain).concat(e);
}

var useAnalytics$1 = function useAnalytics$1() {
  var e = useState(null),
      t = e[0],
      r = e[1];
  return useEffect(function () {
    "undefined" != typeof window && r(window);
  }, []), null == t ? null : null == t ? void 0 : t.analytics;
},
    useButton = function useButton() {
  return {
    getVariant: function getVariant(e) {
      switch (e) {
        case "outlined":
          return "outlined";

        case "link":
          return "text";

        default:
          return "contained";
      }
    }
  };
},
    useButtonStyles = function useButtonStyles() {
  return {
    getVariant: function getVariant(e) {
      switch (e) {
        case "outlined":
          return "outlined";

        case "link":
          return "text";

        default:
          return "contained";
      }
    }
  };
},
    useDeviceDetect = function useDeviceDetect() {
  var e = function e() {
    return window.innerWidth < 767.98;
  },
      t = useState(e()),
      r = t[0],
      n = t[1];

  return useEffect(function () {
    var t = function t() {
      n(e);
    };

    return window.addEventListener("resize", t), window.addEventListener("orientationchange", t), window.addEventListener("load", t), window.addEventListener("reload", t), function () {
      window.removeEventListener("resize", t), window.removeEventListener("orientationchange", t), window.removeEventListener("load", t), window.removeEventListener("reload", t);
    };
  }, []), {
    isMobile: r
  };
},
    usePricing = function usePricing() {
  return {
    getPrice: function getPrice(e) {
      var t,
          r = e.sku,
          n = e.discount,
          a = e.users,
          o = e.locations,
          i = r.includedLocations,
          s = r.includedUsers,
          l = r.maxLocationCount,
          c = r.maxUserCount,
          u = r.optionalProducts,
          d = r.includedTools,
          p = r.basePrice,
          g = r.addOnPrice,
          m = r.memberPrice,
          f = r.locationPrice,
          h = 0,
          b = !1,
          y = null !== (t = u.filter(function (e) {
        return e.selected;
      }).length) && void 0 !== t ? t : 0;
      return o > l || a > c ? b = !0 : (b = !1, h = p, y > d && (h = Number(h) + Number(g) * (Number(y) - d)), o > i && (h = Number(h) + Number(f) * Number(o - i)), a > s && (h = Number(h) + Number(m) * Number(a - s)), null != n && (h *= 1 - n / 100)), {
        hidePrice: b,
        price: h
      };
    }
  };
},
    commonjsGlobal = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};

function getDefaultExportFromCjs(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}

function getAugmentedNamespace(e) {
  if (e.__esModule) return e;
  var t = Object.defineProperty({}, "__esModule", {
    value: !0
  });
  return Object.keys(e).forEach(function (r) {
    var n = Object.getOwnPropertyDescriptor(e, r);
    Object.defineProperty(t, r, n.get ? n : {
      enumerable: !0,
      get: function get() {
        return e[r];
      }
    });
  }), t;
}

function listCacheClear$1() {
  this.__data__ = [], this.size = 0;
}

var _listCacheClear = listCacheClear$1;

function eq$5(e, t) {
  return e === t || e != e && t != t;
}

var eq_1 = eq$5,
    eq$4 = eq_1;

function assocIndexOf$4(e, t) {
  for (var r = e.length; r--;) {
    if (eq$4(e[r][0], t)) return r;
  }

  return -1;
}

var _assocIndexOf = assocIndexOf$4,
    assocIndexOf$3 = _assocIndexOf,
    arrayProto = Array.prototype,
    splice = arrayProto.splice;

function listCacheDelete$1(e) {
  var t = this.__data__,
      r = assocIndexOf$3(t, e);
  return !(r < 0) && (r == t.length - 1 ? t.pop() : splice.call(t, r, 1), --this.size, !0);
}

var _listCacheDelete = listCacheDelete$1,
    assocIndexOf$2 = _assocIndexOf;

function listCacheGet$1(e) {
  var t = this.__data__,
      r = assocIndexOf$2(t, e);
  return r < 0 ? void 0 : t[r][1];
}

var _listCacheGet = listCacheGet$1,
    assocIndexOf$1 = _assocIndexOf;

function listCacheHas$1(e) {
  return assocIndexOf$1(this.__data__, e) > -1;
}

var _listCacheHas = listCacheHas$1,
    assocIndexOf = _assocIndexOf;

function listCacheSet$1(e, t) {
  var r = this.__data__,
      n = assocIndexOf(r, e);
  return n < 0 ? (++this.size, r.push([e, t])) : r[n][1] = t, this;
}

var _listCacheSet = listCacheSet$1,
    listCacheClear = _listCacheClear,
    listCacheDelete = _listCacheDelete,
    listCacheGet = _listCacheGet,
    listCacheHas = _listCacheHas,
    listCacheSet = _listCacheSet;

function ListCache$4(e) {
  var t = -1,
      r = null == e ? 0 : e.length;

  for (this.clear(); ++t < r;) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}

ListCache$4.prototype.clear = listCacheClear, ListCache$4.prototype.delete = listCacheDelete, ListCache$4.prototype.get = listCacheGet, ListCache$4.prototype.has = listCacheHas, ListCache$4.prototype.set = listCacheSet;
var _ListCache = ListCache$4,
    ListCache$3 = _ListCache;

function stackClear$1() {
  this.__data__ = new ListCache$3(), this.size = 0;
}

var _stackClear = stackClear$1;

function stackDelete$1(e) {
  var t = this.__data__,
      r = t.delete(e);
  return this.size = t.size, r;
}

var _stackDelete = stackDelete$1;

function stackGet$1(e) {
  return this.__data__.get(e);
}

var _stackGet = stackGet$1;

function stackHas$1(e) {
  return this.__data__.has(e);
}

var _stackHas = stackHas$1,
    freeGlobal$1 = "object" == typeof commonjsGlobal && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal,
    _freeGlobal = freeGlobal$1,
    freeGlobal = _freeGlobal,
    freeSelf = "object" == typeof self && self && self.Object === Object && self,
    root$4 = freeGlobal || freeSelf || Function("return this")(),
    _root = root$4,
    root$3 = _root,
    Symbol$4 = root$3.Symbol,
    _Symbol = Symbol$4,
    Symbol$3 = _Symbol,
    objectProto$d = Object.prototype,
    hasOwnProperty$d = objectProto$d.hasOwnProperty,
    nativeObjectToString$1 = objectProto$d.toString,
    symToStringTag$1 = Symbol$3 ? Symbol$3.toStringTag : void 0;

function getRawTag$1(e) {
  var t = hasOwnProperty$d.call(e, symToStringTag$1),
      r = e[symToStringTag$1];

  try {
    e[symToStringTag$1] = void 0;
    var n = !0;
  } catch (e) {}

  var a = nativeObjectToString$1.call(e);
  return n && (t ? e[symToStringTag$1] = r : delete e[symToStringTag$1]), a;
}

var _getRawTag = getRawTag$1,
    objectProto$c = Object.prototype,
    nativeObjectToString = objectProto$c.toString;

function objectToString$1(e) {
  return nativeObjectToString.call(e);
}

var _objectToString = objectToString$1,
    Symbol$2 = _Symbol,
    getRawTag = _getRawTag,
    objectToString = _objectToString,
    nullTag = "[object Null]",
    undefinedTag = "[object Undefined]",
    symToStringTag = Symbol$2 ? Symbol$2.toStringTag : void 0;

function baseGetTag$6(e) {
  return null == e ? void 0 === e ? undefinedTag : nullTag : symToStringTag && symToStringTag in Object(e) ? getRawTag(e) : objectToString(e);
}

var _baseGetTag = baseGetTag$6;

function isObject$7(e) {
  var t = typeof e;
  return null != e && ("object" == t || "function" == t);
}

var isObject_1 = isObject$7,
    baseGetTag$5 = _baseGetTag,
    isObject$6 = isObject_1,
    asyncTag = "[object AsyncFunction]",
    funcTag$1 = "[object Function]",
    genTag = "[object GeneratorFunction]",
    proxyTag = "[object Proxy]";

function isFunction$3(e) {
  if (!isObject$6(e)) return !1;
  var t = baseGetTag$5(e);
  return t == funcTag$1 || t == genTag || t == asyncTag || t == proxyTag;
}

var isFunction_1 = isFunction$3,
    root$2 = _root,
    coreJsData$1 = root$2["__core-js_shared__"],
    _coreJsData = coreJsData$1,
    coreJsData = _coreJsData,
    maskSrcKey = (uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || ""), uid ? "Symbol(src)_1." + uid : ""),
    uid;

function isMasked$1(e) {
  return !!maskSrcKey && maskSrcKey in e;
}

var _isMasked = isMasked$1,
    funcProto$2 = Function.prototype,
    funcToString$2 = funcProto$2.toString;

function toSource$1(e) {
  if (null != e) {
    try {
      return funcToString$2.call(e);
    } catch (e) {}

    try {
      return e + "";
    } catch (e) {}
  }

  return "";
}

var _toSource = toSource$1,
    isFunction$2 = isFunction_1,
    isMasked = _isMasked,
    isObject$5 = isObject_1,
    toSource = _toSource,
    reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
    reIsHostCtor = /^\[object .+?Constructor\]$/,
    funcProto$1 = Function.prototype,
    objectProto$b = Object.prototype,
    funcToString$1 = funcProto$1.toString,
    hasOwnProperty$c = objectProto$b.hasOwnProperty,
    reIsNative = RegExp("^" + funcToString$1.call(hasOwnProperty$c).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");

function baseIsNative$1(e) {
  return !(!isObject$5(e) || isMasked(e)) && (isFunction$2(e) ? reIsNative : reIsHostCtor).test(toSource(e));
}

var _baseIsNative = baseIsNative$1;

function getValue$3(e, t) {
  return null == e ? void 0 : e[t];
}

var _getValue = getValue$3,
    baseIsNative = _baseIsNative,
    getValue$2 = _getValue;

function getNative$3(e, t) {
  var r = getValue$2(e, t);
  return baseIsNative(r) ? r : void 0;
}

var _getNative = getNative$3,
    getNative$2 = _getNative,
    root$1 = _root,
    Map$3 = getNative$2(root$1, "Map"),
    _Map = Map$3,
    getNative$1 = _getNative,
    nativeCreate$4 = getNative$1(Object, "create"),
    _nativeCreate = nativeCreate$4,
    nativeCreate$3 = _nativeCreate;

function hashClear$1() {
  this.__data__ = nativeCreate$3 ? nativeCreate$3(null) : {}, this.size = 0;
}

var _hashClear = hashClear$1;

function hashDelete$1(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}

var _hashDelete = hashDelete$1,
    nativeCreate$2 = _nativeCreate,
    HASH_UNDEFINED$1 = "__lodash_hash_undefined__",
    objectProto$a = Object.prototype,
    hasOwnProperty$b = objectProto$a.hasOwnProperty;

function hashGet$1(e) {
  var t = this.__data__;

  if (nativeCreate$2) {
    var r = t[e];
    return r === HASH_UNDEFINED$1 ? void 0 : r;
  }

  return hasOwnProperty$b.call(t, e) ? t[e] : void 0;
}

var _hashGet = hashGet$1,
    nativeCreate$1 = _nativeCreate,
    objectProto$9 = Object.prototype,
    hasOwnProperty$a = objectProto$9.hasOwnProperty;

function hashHas$1(e) {
  var t = this.__data__;
  return nativeCreate$1 ? void 0 !== t[e] : hasOwnProperty$a.call(t, e);
}

var _hashHas = hashHas$1,
    nativeCreate = _nativeCreate,
    HASH_UNDEFINED = "__lodash_hash_undefined__";

function hashSet$1(e, t) {
  var r = this.__data__;
  return this.size += this.has(e) ? 0 : 1, r[e] = nativeCreate && void 0 === t ? HASH_UNDEFINED : t, this;
}

var _hashSet = hashSet$1,
    hashClear = _hashClear,
    hashDelete = _hashDelete,
    hashGet = _hashGet,
    hashHas = _hashHas,
    hashSet = _hashSet;

function Hash$1(e) {
  var t = -1,
      r = null == e ? 0 : e.length;

  for (this.clear(); ++t < r;) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}

Hash$1.prototype.clear = hashClear, Hash$1.prototype.delete = hashDelete, Hash$1.prototype.get = hashGet, Hash$1.prototype.has = hashHas, Hash$1.prototype.set = hashSet;
var _Hash = Hash$1,
    Hash = _Hash,
    ListCache$2 = _ListCache,
    Map$2 = _Map;

function mapCacheClear$1() {
  this.size = 0, this.__data__ = {
    hash: new Hash(),
    map: new (Map$2 || ListCache$2)(),
    string: new Hash()
  };
}

var _mapCacheClear = mapCacheClear$1;

function isKeyable$1(e) {
  var t = typeof e;
  return "string" == t || "number" == t || "symbol" == t || "boolean" == t ? "__proto__" !== e : null === e;
}

var _isKeyable = isKeyable$1,
    isKeyable = _isKeyable;

function getMapData$4(e, t) {
  var r = e.__data__;
  return isKeyable(t) ? r["string" == typeof t ? "string" : "hash"] : r.map;
}

var _getMapData = getMapData$4,
    getMapData$3 = _getMapData;

function mapCacheDelete$1(e) {
  var t = getMapData$3(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}

var _mapCacheDelete = mapCacheDelete$1,
    getMapData$2 = _getMapData;

function mapCacheGet$1(e) {
  return getMapData$2(this, e).get(e);
}

var _mapCacheGet = mapCacheGet$1,
    getMapData$1 = _getMapData;

function mapCacheHas$1(e) {
  return getMapData$1(this, e).has(e);
}

var _mapCacheHas = mapCacheHas$1,
    getMapData = _getMapData;

function mapCacheSet$1(e, t) {
  var r = getMapData(this, e),
      n = r.size;
  return r.set(e, t), this.size += r.size == n ? 0 : 1, this;
}

var _mapCacheSet = mapCacheSet$1,
    mapCacheClear = _mapCacheClear,
    mapCacheDelete = _mapCacheDelete,
    mapCacheGet = _mapCacheGet,
    mapCacheHas = _mapCacheHas,
    mapCacheSet = _mapCacheSet;

function MapCache$1(e) {
  var t = -1,
      r = null == e ? 0 : e.length;

  for (this.clear(); ++t < r;) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}

MapCache$1.prototype.clear = mapCacheClear, MapCache$1.prototype.delete = mapCacheDelete, MapCache$1.prototype.get = mapCacheGet, MapCache$1.prototype.has = mapCacheHas, MapCache$1.prototype.set = mapCacheSet;
var _MapCache = MapCache$1,
    ListCache$1 = _ListCache,
    Map$1 = _Map,
    MapCache = _MapCache,
    LARGE_ARRAY_SIZE = 200;

function stackSet$1(e, t) {
  var r = this.__data__;

  if (r instanceof ListCache$1) {
    var n = r.__data__;
    if (!Map$1 || n.length < LARGE_ARRAY_SIZE - 1) return n.push([e, t]), this.size = ++r.size, this;
    r = this.__data__ = new MapCache(n);
  }

  return r.set(e, t), this.size = r.size, this;
}

var _stackSet = stackSet$1,
    ListCache = _ListCache,
    stackClear = _stackClear,
    stackDelete = _stackDelete,
    stackGet = _stackGet,
    stackHas = _stackHas,
    stackSet = _stackSet;

function Stack$1(e) {
  var t = this.__data__ = new ListCache(e);
  this.size = t.size;
}

Stack$1.prototype.clear = stackClear, Stack$1.prototype.delete = stackDelete, Stack$1.prototype.get = stackGet, Stack$1.prototype.has = stackHas, Stack$1.prototype.set = stackSet;

var _Stack = Stack$1,
    getNative = _getNative,
    defineProperty$3 = function () {
  try {
    var e = getNative(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch (e) {}
}(),
    _defineProperty$1 = defineProperty$3,
    defineProperty$2 = _defineProperty$1;

function baseAssignValue$3(e, t, r) {
  "__proto__" == t && defineProperty$2 ? defineProperty$2(e, t, {
    configurable: !0,
    enumerable: !0,
    value: r,
    writable: !0
  }) : e[t] = r;
}

var _baseAssignValue = baseAssignValue$3,
    baseAssignValue$2 = _baseAssignValue,
    eq$3 = eq_1;

function assignMergeValue$2(e, t, r) {
  (void 0 !== r && !eq$3(e[t], r) || void 0 === r && !(t in e)) && baseAssignValue$2(e, t, r);
}

var _assignMergeValue = assignMergeValue$2;

function createBaseFor$1(e) {
  return function (t, r, n) {
    for (var a = -1, o = Object(t), i = n(t), s = i.length; s--;) {
      var l = i[e ? s : ++a];
      if (!1 === r(o[l], l, o)) break;
    }

    return t;
  };
}

var _createBaseFor = createBaseFor$1,
    createBaseFor = _createBaseFor,
    baseFor$1 = createBaseFor(),
    _baseFor = baseFor$1,
    _cloneBuffer = {
  exports: {}
};
!function (e, t) {
  var r = _root,
      n = t && !t.nodeType && t,
      a = n && e && !e.nodeType && e,
      o = a && a.exports === n ? r.Buffer : void 0,
      i = o ? o.allocUnsafe : void 0;

  e.exports = function (e, t) {
    if (t) return e.slice();
    var r = e.length,
        n = i ? i(r) : new e.constructor(r);
    return e.copy(n), n;
  };
}(_cloneBuffer, _cloneBuffer.exports);
var root = _root,
    Uint8Array$1 = root.Uint8Array,
    _Uint8Array = Uint8Array$1,
    Uint8Array = _Uint8Array;

function cloneArrayBuffer$1(e) {
  var t = new e.constructor(e.byteLength);
  return new Uint8Array(t).set(new Uint8Array(e)), t;
}

var _cloneArrayBuffer = cloneArrayBuffer$1,
    cloneArrayBuffer = _cloneArrayBuffer;

function cloneTypedArray$1(e, t) {
  var r = t ? cloneArrayBuffer(e.buffer) : e.buffer;
  return new e.constructor(r, e.byteOffset, e.length);
}

var _cloneTypedArray = cloneTypedArray$1;

function copyArray$1(e, t) {
  var r = -1,
      n = e.length;

  for (t || (t = Array(n)); ++r < n;) {
    t[r] = e[r];
  }

  return t;
}

var _copyArray = copyArray$1,
    isObject$4 = isObject_1,
    objectCreate = Object.create,
    baseCreate$1 = function () {
  function e() {}

  return function (t) {
    if (!isObject$4(t)) return {};
    if (objectCreate) return objectCreate(t);
    e.prototype = t;
    var r = new e();
    return e.prototype = void 0, r;
  };
}(),
    _baseCreate = baseCreate$1;

function overArg$2(e, t) {
  return function (r) {
    return e(t(r));
  };
}

var _overArg = overArg$2,
    overArg$1 = _overArg,
    getPrototype$2 = overArg$1(Object.getPrototypeOf, Object),
    _getPrototype = getPrototype$2,
    objectProto$8 = Object.prototype;

function isPrototype$3(e) {
  var t = e && e.constructor;
  return e === ("function" == typeof t && t.prototype || objectProto$8);
}

var _isPrototype = isPrototype$3,
    baseCreate = _baseCreate,
    getPrototype$1 = _getPrototype,
    isPrototype$2 = _isPrototype;

function initCloneObject$1(e) {
  return "function" != typeof e.constructor || isPrototype$2(e) ? {} : baseCreate(getPrototype$1(e));
}

var _initCloneObject = initCloneObject$1;

function isObjectLike$7(e) {
  return null != e && "object" == typeof e;
}

var isObjectLike_1 = isObjectLike$7,
    baseGetTag$4 = _baseGetTag,
    isObjectLike$6 = isObjectLike_1,
    argsTag$1 = "[object Arguments]";

function baseIsArguments$1(e) {
  return isObjectLike$6(e) && baseGetTag$4(e) == argsTag$1;
}

var _baseIsArguments = baseIsArguments$1,
    baseIsArguments = _baseIsArguments,
    isObjectLike$5 = isObjectLike_1,
    objectProto$7 = Object.prototype,
    hasOwnProperty$9 = objectProto$7.hasOwnProperty,
    propertyIsEnumerable = objectProto$7.propertyIsEnumerable,
    isArguments$2 = baseIsArguments(function () {
  return arguments;
}()) ? baseIsArguments : function (e) {
  return isObjectLike$5(e) && hasOwnProperty$9.call(e, "callee") && !propertyIsEnumerable.call(e, "callee");
},
    isArguments_1 = isArguments$2,
    isArray$3 = Array.isArray,
    isArray_1 = isArray$3,
    MAX_SAFE_INTEGER$1 = 9007199254740991;

function isLength$2(e) {
  return "number" == typeof e && e > -1 && e % 1 == 0 && e <= MAX_SAFE_INTEGER$1;
}

var isLength_1 = isLength$2,
    isFunction$1 = isFunction_1,
    isLength$1 = isLength_1;

function isArrayLike$4(e) {
  return null != e && isLength$1(e.length) && !isFunction$1(e);
}

var isArrayLike_1 = isArrayLike$4,
    isArrayLike$3 = isArrayLike_1,
    isObjectLike$4 = isObjectLike_1;

function isArrayLikeObject$1(e) {
  return isObjectLike$4(e) && isArrayLike$3(e);
}

var isArrayLikeObject_1 = isArrayLikeObject$1,
    isBuffer$2 = {
  exports: {}
};

function stubFalse() {
  return !1;
}

var stubFalse_1 = stubFalse;
!function (e, t) {
  var r = _root,
      n = stubFalse_1,
      a = t && !t.nodeType && t,
      o = a && e && !e.nodeType && e,
      i = o && o.exports === a ? r.Buffer : void 0,
      s = (i ? i.isBuffer : void 0) || n;
  e.exports = s;
}(isBuffer$2, isBuffer$2.exports);
var baseGetTag$3 = _baseGetTag,
    getPrototype = _getPrototype,
    isObjectLike$3 = isObjectLike_1,
    objectTag$1 = "[object Object]",
    funcProto = Function.prototype,
    objectProto$6 = Object.prototype,
    funcToString = funcProto.toString,
    hasOwnProperty$8 = objectProto$6.hasOwnProperty,
    objectCtorString = funcToString.call(Object);

function isPlainObject$3(e) {
  if (!isObjectLike$3(e) || baseGetTag$3(e) != objectTag$1) return !1;
  var t = getPrototype(e);
  if (null === t) return !0;
  var r = hasOwnProperty$8.call(t, "constructor") && t.constructor;
  return "function" == typeof r && r instanceof r && funcToString.call(r) == objectCtorString;
}

var isPlainObject_1 = isPlainObject$3,
    baseGetTag$2 = _baseGetTag,
    isLength = isLength_1,
    isObjectLike$2 = isObjectLike_1,
    argsTag = "[object Arguments]",
    arrayTag = "[object Array]",
    boolTag = "[object Boolean]",
    dateTag = "[object Date]",
    errorTag$1 = "[object Error]",
    funcTag = "[object Function]",
    mapTag = "[object Map]",
    numberTag = "[object Number]",
    objectTag = "[object Object]",
    regexpTag = "[object RegExp]",
    setTag = "[object Set]",
    stringTag = "[object String]",
    weakMapTag = "[object WeakMap]",
    arrayBufferTag = "[object ArrayBuffer]",
    dataViewTag = "[object DataView]",
    float32Tag = "[object Float32Array]",
    float64Tag = "[object Float64Array]",
    int8Tag = "[object Int8Array]",
    int16Tag = "[object Int16Array]",
    int32Tag = "[object Int32Array]",
    uint8Tag = "[object Uint8Array]",
    uint8ClampedTag = "[object Uint8ClampedArray]",
    uint16Tag = "[object Uint16Array]",
    uint32Tag = "[object Uint32Array]",
    typedArrayTags = {};

function baseIsTypedArray$1(e) {
  return isObjectLike$2(e) && isLength(e.length) && !!typedArrayTags[baseGetTag$2(e)];
}

typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = !0, typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag$1] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = !1;
var _baseIsTypedArray = baseIsTypedArray$1;

function baseUnary$1(e) {
  return function (t) {
    return e(t);
  };
}

var _baseUnary = baseUnary$1,
    _nodeUtil = {
  exports: {}
};
!function (e, t) {
  var r = _freeGlobal,
      n = t && !t.nodeType && t,
      a = n && e && !e.nodeType && e,
      o = a && a.exports === n && r.process,
      i = function () {
    try {
      var e = a && a.require && a.require("util").types;

      return e || o && o.binding && o.binding("util");
    } catch (e) {}
  }();

  e.exports = i;
}(_nodeUtil, _nodeUtil.exports);
var baseIsTypedArray = _baseIsTypedArray,
    baseUnary = _baseUnary,
    nodeUtil = _nodeUtil.exports,
    nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray,
    isTypedArray$2 = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray,
    isTypedArray_1 = isTypedArray$2;

function safeGet$2(e, t) {
  if (("constructor" !== t || "function" != typeof e[t]) && "__proto__" != t) return e[t];
}

var _safeGet = safeGet$2,
    baseAssignValue$1 = _baseAssignValue,
    eq$2 = eq_1,
    objectProto$5 = Object.prototype,
    hasOwnProperty$7 = objectProto$5.hasOwnProperty;

function assignValue$1(e, t, r) {
  var n = e[t];
  hasOwnProperty$7.call(e, t) && eq$2(n, r) && (void 0 !== r || t in e) || baseAssignValue$1(e, t, r);
}

var _assignValue = assignValue$1,
    assignValue = _assignValue,
    baseAssignValue = _baseAssignValue;

function copyObject$2(e, t, r, n) {
  var a = !r;
  r || (r = {});

  for (var o = -1, i = t.length; ++o < i;) {
    var s = t[o],
        l = n ? n(r[s], e[s], s, r, e) : void 0;
    void 0 === l && (l = e[s]), a ? baseAssignValue(r, s, l) : assignValue(r, s, l);
  }

  return r;
}

var _copyObject = copyObject$2;

function baseTimes$1(e, t) {
  for (var r = -1, n = Array(e); ++r < e;) {
    n[r] = t(r);
  }

  return n;
}

var _baseTimes = baseTimes$1,
    MAX_SAFE_INTEGER = 9007199254740991,
    reIsUint = /^(?:0|[1-9]\d*)$/;

function isIndex$2(e, t) {
  var r = typeof e;
  return !!(t = null == t ? MAX_SAFE_INTEGER : t) && ("number" == r || "symbol" != r && reIsUint.test(e)) && e > -1 && e % 1 == 0 && e < t;
}

var _isIndex = isIndex$2,
    baseTimes = _baseTimes,
    isArguments$1 = isArguments_1,
    isArray$2 = isArray_1,
    isBuffer$1 = isBuffer$2.exports,
    isIndex$1 = _isIndex,
    isTypedArray$1 = isTypedArray_1,
    objectProto$4 = Object.prototype,
    hasOwnProperty$6 = objectProto$4.hasOwnProperty;

function arrayLikeKeys$2(e, t) {
  var r = isArray$2(e),
      n = !r && isArguments$1(e),
      a = !r && !n && isBuffer$1(e),
      o = !r && !n && !a && isTypedArray$1(e),
      i = r || n || a || o,
      s = i ? baseTimes(e.length, String) : [],
      l = s.length;

  for (var c in e) {
    !t && !hasOwnProperty$6.call(e, c) || i && ("length" == c || a && ("offset" == c || "parent" == c) || o && ("buffer" == c || "byteLength" == c || "byteOffset" == c) || isIndex$1(c, l)) || s.push(c);
  }

  return s;
}

var _arrayLikeKeys = arrayLikeKeys$2;

function nativeKeysIn$1(e) {
  var t = [];
  if (null != e) for (var r in Object(e)) {
    t.push(r);
  }
  return t;
}

var _nativeKeysIn = nativeKeysIn$1,
    isObject$3 = isObject_1,
    isPrototype$1 = _isPrototype,
    nativeKeysIn = _nativeKeysIn,
    objectProto$3 = Object.prototype,
    hasOwnProperty$5 = objectProto$3.hasOwnProperty;

function baseKeysIn$1(e) {
  if (!isObject$3(e)) return nativeKeysIn(e);
  var t = isPrototype$1(e),
      r = [];

  for (var n in e) {
    ("constructor" != n || !t && hasOwnProperty$5.call(e, n)) && r.push(n);
  }

  return r;
}

var _baseKeysIn = baseKeysIn$1,
    arrayLikeKeys$1 = _arrayLikeKeys,
    baseKeysIn = _baseKeysIn,
    isArrayLike$2 = isArrayLike_1;

function keysIn$3(e) {
  return isArrayLike$2(e) ? arrayLikeKeys$1(e, !0) : baseKeysIn(e);
}

var keysIn_1 = keysIn$3,
    copyObject$1 = _copyObject,
    keysIn$2 = keysIn_1;

function toPlainObject$1(e) {
  return copyObject$1(e, keysIn$2(e));
}

var toPlainObject_1 = toPlainObject$1,
    assignMergeValue$1 = _assignMergeValue,
    cloneBuffer = _cloneBuffer.exports,
    cloneTypedArray = _cloneTypedArray,
    copyArray = _copyArray,
    initCloneObject = _initCloneObject,
    isArguments = isArguments_1,
    isArray$1 = isArray_1,
    isArrayLikeObject = isArrayLikeObject_1,
    isBuffer = isBuffer$2.exports,
    isFunction = isFunction_1,
    isObject$2 = isObject_1,
    isPlainObject$2 = isPlainObject_1,
    isTypedArray = isTypedArray_1,
    safeGet$1 = _safeGet,
    toPlainObject = toPlainObject_1;

function baseMergeDeep$1(e, t, r, n, a, o, i) {
  var s = safeGet$1(e, r),
      l = safeGet$1(t, r),
      c = i.get(l);
  if (c) assignMergeValue$1(e, r, c);else {
    var u = o ? o(s, l, r + "", e, t, i) : void 0,
        d = void 0 === u;

    if (d) {
      var p = isArray$1(l),
          g = !p && isBuffer(l),
          m = !p && !g && isTypedArray(l);
      u = l, p || g || m ? isArray$1(s) ? u = s : isArrayLikeObject(s) ? u = copyArray(s) : g ? (d = !1, u = cloneBuffer(l, !0)) : m ? (d = !1, u = cloneTypedArray(l, !0)) : u = [] : isPlainObject$2(l) || isArguments(l) ? (u = s, isArguments(s) ? u = toPlainObject(s) : isObject$2(s) && !isFunction(s) || (u = initCloneObject(l))) : d = !1;
    }

    d && (i.set(l, u), a(u, l, n, o, i), i.delete(l)), assignMergeValue$1(e, r, u);
  }
}

var _baseMergeDeep = baseMergeDeep$1,
    Stack = _Stack,
    assignMergeValue = _assignMergeValue,
    baseFor = _baseFor,
    baseMergeDeep = _baseMergeDeep,
    isObject$1 = isObject_1,
    keysIn$1 = keysIn_1,
    safeGet = _safeGet;

function baseMerge$1(e, t, r, n, a) {
  e !== t && baseFor(t, function (o, i) {
    if (a || (a = new Stack()), isObject$1(o)) baseMergeDeep(e, t, i, r, baseMerge$1, n, a);else {
      var s = n ? n(safeGet(e, i), o, i + "", e, t, a) : void 0;
      void 0 === s && (s = o), assignMergeValue(e, i, s);
    }
  }, keysIn$1);
}

var _baseMerge = baseMerge$1;

function identity$2(e) {
  return e;
}

var identity_1 = identity$2;

function apply$2(e, t, r) {
  switch (r.length) {
    case 0:
      return e.call(t);

    case 1:
      return e.call(t, r[0]);

    case 2:
      return e.call(t, r[0], r[1]);

    case 3:
      return e.call(t, r[0], r[1], r[2]);
  }

  return e.apply(t, r);
}

var _apply = apply$2,
    apply$1 = _apply,
    nativeMax = Math.max;

function overRest$1(e, t, r) {
  return t = nativeMax(void 0 === t ? e.length - 1 : t, 0), function () {
    for (var n = arguments, a = -1, o = nativeMax(n.length - t, 0), i = Array(o); ++a < o;) {
      i[a] = n[t + a];
    }

    a = -1;

    for (var s = Array(t + 1); ++a < t;) {
      s[a] = n[a];
    }

    return s[t] = r(i), apply$1(e, this, s);
  };
}

var _overRest = overRest$1;

function constant$1(e) {
  return function () {
    return e;
  };
}

var constant_1 = constant$1,
    constant = constant_1,
    defineProperty$1 = _defineProperty$1,
    identity$1 = identity_1,
    baseSetToString$1 = defineProperty$1 ? function (e, t) {
  return defineProperty$1(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: constant(t),
    writable: !0
  });
} : identity$1,
    _baseSetToString = baseSetToString$1,
    HOT_COUNT = 800,
    HOT_SPAN = 16,
    nativeNow = Date.now;

function shortOut$1(e) {
  var t = 0,
      r = 0;
  return function () {
    var n = nativeNow(),
        a = HOT_SPAN - (n - r);

    if (r = n, a > 0) {
      if (++t >= HOT_COUNT) return arguments[0];
    } else t = 0;

    return e.apply(void 0, arguments);
  };
}

var _shortOut = shortOut$1,
    baseSetToString = _baseSetToString,
    shortOut = _shortOut,
    setToString$1 = shortOut(baseSetToString),
    _setToString = setToString$1,
    identity = identity_1,
    overRest = _overRest,
    setToString = _setToString;

function baseRest$2(e, t) {
  return setToString(overRest(e, t, identity), e + "");
}

var _baseRest = baseRest$2,
    eq$1 = eq_1,
    isArrayLike$1 = isArrayLike_1,
    isIndex = _isIndex,
    isObject = isObject_1;

function isIterateeCall$2(e, t, r) {
  if (!isObject(r)) return !1;
  var n = typeof t;
  return !!("number" == n ? isArrayLike$1(r) && isIndex(t, r.length) : "string" == n && t in r) && eq$1(r[t], e);
}

var _isIterateeCall = isIterateeCall$2,
    baseRest$1 = _baseRest,
    isIterateeCall$1 = _isIterateeCall;

function createAssigner$2(e) {
  return baseRest$1(function (t, r) {
    var n = -1,
        a = r.length,
        o = a > 1 ? r[a - 1] : void 0,
        i = a > 2 ? r[2] : void 0;

    for (o = e.length > 3 && "function" == typeof o ? (a--, o) : void 0, i && isIterateeCall$1(r[0], r[1], i) && (o = a < 3 ? void 0 : o, a = 1), t = Object(t); ++n < a;) {
      var s = r[n];
      s && e(t, s, n, o);
    }

    return t;
  });
}

var _createAssigner = createAssigner$2,
    baseMerge = _baseMerge,
    createAssigner$1 = _createAssigner,
    merge$3 = createAssigner$1(function (e, t, r) {
  baseMerge(e, t, r);
}),
    merge_1$1 = merge$3;

function postAPI(e, t) {
  return void 0 === t && (t = {}), __awaiter(this, void 0, void 0, function () {
    var r, n;
    return __generator(this, function (a) {
      switch (a.label) {
        case 0:
          return r = {
            method: "POST",
            body: JSON.stringify(_assign$({}, t)),
            headers: {
              "Content-Type": "application/json"
            }
          }, [4, fetch$1(e, r)];

        case 1:
          return (n = a.sent()).ok || console.error(n.statusText), [2, n];
      }
    });
  });
}

function sendSMS(e) {
  return __awaiter(this, void 0, void 0, function () {
    return __generator(this, function (t) {
      switch (t.label) {
        case 0:
          return [4, postAPI("https://webapi.gosite.run/api/twilio/public/send-sms", e)];

        case 1:
          return [2, t.sent()];
      }
    });
  });
}

var postFormData = function postFormData(e, t, r) {
  return void 0 === e && (e = ""), void 0 === t && (t = {}), __awaiter(void 0, void 0, void 0, function () {
    var n;
    return __generator(this, function (a) {
      switch (a.label) {
        case 0:
          return n = merge_1$1({
            method: "POST",
            mode: "cors",
            cache: "no-cache",
            credentials: "same-origin",
            headers: {
              "Content-Type": "application/json"
            },
            redirect: "follow",
            referrerPolicy: "no-referrer"
          }, r), [4, fetch$1(e, _assign$(_assign$({}, n), {
            body: JSON.stringify(t)
          }))];

        case 1:
          return [4, a.sent().json()];

        case 2:
          return [2, a.sent()];
      }
    });
  });
},
    publicSignUp = function publicSignUp(e) {
  return __awaiter(void 0, void 0, void 0, function () {
    var t;
    return __generator(this, function (r) {
      switch (r.label) {
        case 0:
          return t = {
            role: "trial",
            gclid: "",
            hb_pageUrl: "function getPageURL() {return window.location.href}",
            signup_url: "signup",
            hb_pageName: "function getPageTitle() {return document.title}",
            isFromWidget: !0
          }, [4, postFormData("https://webapi.gosite.com/api/users/public-signup", _assign$(_assign$({}, e), t))];

        case 1:
          return [2, r.sent()];
      }
    });
  });
},
    _login = function login(e) {
  return __awaiter(void 0, void 0, void 0, function () {
    var t;
    return __generator(this, function (r) {
      switch (r.label) {
        case 0:
          return t = {
            isFromWidget: !0
          }, [4, postFormData("https://webapi.gosite.com/api/users/login", _assign$(_assign$({}, e), t))];

        case 1:
          return [2, r.sent()];
      }
    });
  });
},
    usePublicAuth = function usePublicAuth() {
  return {
    login: function login(e, t) {
      _login({
        email: e,
        password: t
      }).then(function (e) {
        if ("success" === e.message.toLowerCase()) {
          var t = e.data,
              r = t.token,
              n = t.status,
              a = t.role,
              o = t.user_unique_id,
              i = "https://cloud.gosite.com/home?t=".concat(r, "&s=").concat(n, "&r=").concat(a, "&uuid=").concat(o),
              s = window.location.href.split("?")[1];
          i.includes("?") ? window.location.href = "".concat(i, "&").concat(s) : window.location.href = "".concat(i, "?").concat(s);
        }
      }).catch(function (e) {
        console.log("Login failure", e);
      });
    }
  };
},
    getUtmParams = function getUtmParams() {
  var e,
      t,
      r,
      n,
      a,
      o = "";

  if ("undefined" != typeof window) {
    var i = new URL(window.location.href),
        s = new URLSearchParams(i.search),
        l = "";
    null == s.get("utm_content") && null == s.get("utm_medium") && null == s.get("utm_source") && null == s.get("utm_campaign") && null == s.get("utm_term") || (null != s.get("utm_content") && (l += "utm_content=".concat(null !== (e = s.get("utm_content")) && void 0 !== e ? e : "")), null != s.get("utm_medium") && (l += l.length > 1 ? "&" : "", l += "utm_medium=".concat(null !== (t = s.get("utm_medium")) && void 0 !== t ? t : "")), null != s.get("utm_campaign") && (l += l.length > 1 ? "&" : "", l += "utm_campaign=".concat(null !== (r = s.get("utm_campaign")) && void 0 !== r ? r : "")), null != s.get("utm_source") && (l += l.length > 1 ? "&" : "", l += "utm_source=".concat(null !== (n = s.get("utm_source")) && void 0 !== n ? n : "")), null != s.get("utm_term") && (l += l.length > 1 ? "&" : "", l += "utm_term=".concat(null !== (a = s.get("utm_term")) && void 0 !== a ? a : ""))), o = l;
  }

  return o;
},
    Button = function Button(e) {
  return jsx$1(StyledButton, _assign$({}, e));
},
    StyledButton = styled$2(Button$1)(function (e) {
  var t,
      r = e.theme;
  return (t = {})["&.".concat(buttonClasses.root)] = {
    borderWidth: 2,
    boxShadow: "none",
    paddingTop: r.spacing(1.3),
    paddingBottom: r.spacing(1.3)
  }, t["&.".concat(buttonClasses.outlinedPrimary, ":hover")] = {
    color: r.palette.common.white,
    backgroundColor: r.palette.primary.main,
    borderColor: r.palette.primary.main
  }, t;
}),
    link$1 = {};

function _typeof$2(e) {
  return _typeof_1 = _typeof$2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, _typeof$2(e);
}

var _typeof_1 = _typeof$2,
    _typeof$1 = _typeof_1;

function _getRequireWildcardCache$4() {
  if ("function" != typeof WeakMap) return null;
  var e = new WeakMap();
  return _getRequireWildcardCache$4 = function _getRequireWildcardCache$4() {
    return e;
  }, e;
}

function _interopRequireWildcard$6(e) {
  if (e && e.__esModule) return e;
  if (null === e || "object" !== _typeof$1(e) && "function" != typeof e) return {
    default: e
  };

  var t = _getRequireWildcardCache$4();

  if (t && t.has(e)) return t.get(e);
  var r = {},
      n = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var a in e) {
    if (Object.prototype.hasOwnProperty.call(e, a)) {
      var o = n ? Object.getOwnPropertyDescriptor(e, a) : null;
      o && (o.get || o.set) ? Object.defineProperty(r, a, o) : r[a] = e[a];
    }
  }

  return r.default = e, t && t.set(e, r), r;
}

var interopRequireWildcard = _interopRequireWildcard$6,
    router$2 = {},
    normalizeTrailingSlash = {};

function removePathTrailingSlash(e) {
  return e.endsWith("/") && "/" !== e ? e.slice(0, -1) : e;
}

normalizeTrailingSlash.__esModule = !0, normalizeTrailingSlash.removePathTrailingSlash = removePathTrailingSlash, normalizeTrailingSlash.normalizePathTrailingSlash = void 0;
var normalizePathTrailingSlash = process.env.__NEXT_TRAILING_SLASH ? function (e) {
  return /\.[^/]+\/?$/.test(e) ? removePathTrailingSlash(e) : e.endsWith("/") ? e : e + "/";
} : removePathTrailingSlash;
normalizeTrailingSlash.normalizePathTrailingSlash = normalizePathTrailingSlash;
var routeLoader = {};

function _interopRequireDefault$8(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}

var interopRequireDefault$2 = _interopRequireDefault$8,
    getAssetPathFromRoute$1 = {};

function getAssetPathFromRoute(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  return ("/" === e ? "/index" : /^\/index(\/|$)/.test(e) ? "/index".concat(e) : "".concat(e)) + t;
}

getAssetPathFromRoute$1.__esModule = !0, getAssetPathFromRoute$1.default = getAssetPathFromRoute;
var requestIdleCallback$1 = {
  __esModule: !0
};
requestIdleCallback$1.cancelIdleCallback = requestIdleCallback$1.requestIdleCallback = void 0;

var requestIdleCallback = "undefined" != typeof self && self.requestIdleCallback || function (e) {
  var t = Date.now();
  return setTimeout(function () {
    e({
      didTimeout: !1,
      timeRemaining: function timeRemaining() {
        return Math.max(0, 50 - (Date.now() - t));
      }
    });
  }, 1);
};

requestIdleCallback$1.requestIdleCallback = requestIdleCallback;

var cancelIdleCallback = "undefined" != typeof self && self.cancelIdleCallback || function (e) {
  return clearTimeout(e);
};

requestIdleCallback$1.cancelIdleCallback = cancelIdleCallback;
var _interopRequireDefault$7 = interopRequireDefault$2;
routeLoader.__esModule = !0, routeLoader.markAssetError = markAssetError, routeLoader.isAssetError = isAssetError, routeLoader.getClientBuildManifest = getClientBuildManifest, routeLoader.default = void 0;

var _getAssetPathFromRoute = _interopRequireDefault$7(getAssetPathFromRoute$1),
    _requestIdleCallback$1 = requestIdleCallback$1;

var MS_MAX_IDLE_DELAY = 3800;

function withFuture(e, t, r) {
  var n,
      a = t.get(e);
  if (a) return "future" in a ? a.future : Promise.resolve(a);
  var o = new Promise(function (e) {
    n = e;
  });
  return t.set(e, a = {
    resolve: n,
    future: o
  }), r ? r().then(function (e) {
    return n(e), e;
  }) : o;
}

function hasPrefetch(e) {
  try {
    return e = document.createElement("link"), !!window.MSInputMethodContext && !!document.documentMode || e.relList.supports("prefetch");
  } catch (e) {
    return !1;
  }
}

var canPrefetch = hasPrefetch();

function prefetchViaDom(e, t, r) {
  return new Promise(function (n, a) {
    if (document.querySelector("link[rel=\"prefetch\"][href^=\"".concat(e, "\"]"))) return n();
    r = document.createElement("link"), t && (r.as = t), r.rel = "prefetch", r.crossOrigin = process.env.__NEXT_CROSS_ORIGIN, r.onload = n, r.onerror = a, r.href = e, document.head.appendChild(r);
  });
}

var ASSET_LOAD_ERROR = Symbol("ASSET_LOAD_ERROR");

function markAssetError(e) {
  return Object.defineProperty(e, ASSET_LOAD_ERROR, {});
}

function isAssetError(e) {
  return e && ASSET_LOAD_ERROR in e;
}

function appendScript(e, t) {
  return new Promise(function (r, n) {
    (t = document.createElement("script")).onload = r, t.onerror = function () {
      return n(markAssetError(new Error("Failed to load script: ".concat(e))));
    }, t.crossOrigin = process.env.__NEXT_CROSS_ORIGIN, t.src = e, document.body.appendChild(t);
  });
}

function resolvePromiseWithTimeout(e, t, r) {
  return new Promise(function (n, a) {
    var o = !1;
    e.then(function (e) {
      o = !0, n(e);
    }).catch(a), (0, _requestIdleCallback$1.requestIdleCallback)(function () {
      return setTimeout(function () {
        o || a(r);
      }, t);
    });
  });
}

function getClientBuildManifest() {
  if (self.__BUILD_MANIFEST) return Promise.resolve(self.__BUILD_MANIFEST);
  return resolvePromiseWithTimeout(new Promise(function (e) {
    var t = self.__BUILD_MANIFEST_CB;

    self.__BUILD_MANIFEST_CB = function () {
      e(self.__BUILD_MANIFEST), t && t();
    };
  }), MS_MAX_IDLE_DELAY, markAssetError(new Error("Failed to load client build manifest")));
}

function getFilesForRoute(e, t) {
  return "development" === process.env.NODE_ENV ? Promise.resolve({
    scripts: [e + "/_next/static/chunks/pages" + encodeURI((0, _getAssetPathFromRoute.default)(t, ".js"))],
    css: []
  }) : getClientBuildManifest().then(function (r) {
    if (!(t in r)) throw markAssetError(new Error("Failed to lookup route: ".concat(t)));
    var n = r[t].map(function (t) {
      return e + "/_next/" + encodeURI(t);
    });
    return {
      scripts: n.filter(function (e) {
        return e.endsWith(".js");
      }),
      css: n.filter(function (e) {
        return e.endsWith(".css");
      })
    };
  });
}

function createRouteLoader(e) {
  var t = new Map(),
      r = new Map(),
      n = new Map(),
      a = new Map();

  function o(e) {
    var t = r.get(e);
    return t || (document.querySelector("script[src^=\"".concat(e, "\"]")) ? Promise.resolve() : (r.set(e, t = appendScript(e)), t));
  }

  function i(e) {
    var t = n.get(e);
    return t || (n.set(e, t = fetch(e).then(function (t) {
      if (!t.ok) throw new Error("Failed to load stylesheet: ".concat(e));
      return t.text().then(function (t) {
        return {
          href: e,
          content: t
        };
      });
    }).catch(function (e) {
      throw markAssetError(e);
    })), t);
  }

  return {
    whenEntrypoint: function whenEntrypoint(e) {
      return withFuture(e, t);
    },
    onEntrypoint: function onEntrypoint(e, r) {
      Promise.resolve(r).then(function (e) {
        return e();
      }).then(function (e) {
        return {
          component: e && e.default || e,
          exports: e
        };
      }, function (e) {
        return {
          error: e
        };
      }).then(function (r) {
        var n = t.get(e);
        t.set(e, r), n && "resolve" in n && n.resolve(r);
      });
    },
    loadRoute: function loadRoute(r, n) {
      var _this = this;

      return withFuture(r, a, function () {
        return resolvePromiseWithTimeout(getFilesForRoute(e, r).then(function (_ref) {
          var e = _ref.scripts,
              n = _ref.css;
          return Promise.all([t.has(r) ? [] : Promise.all(e.map(o)), Promise.all(n.map(i))]);
        }).then(function (e) {
          return _this.whenEntrypoint(r).then(function (t) {
            return {
              entrypoint: t,
              styles: e[1]
            };
          });
        }), MS_MAX_IDLE_DELAY, markAssetError(new Error("Route did not complete loading: ".concat(r)))).then(function (_ref2) {
          var e = _ref2.entrypoint,
              t = _ref2.styles;
          var r = Object.assign({
            styles: t
          }, e);
          return "error" in e ? e : r;
        }).catch(function (e) {
          if (n) throw e;
          return {
            error: e
          };
        });
      });
    },
    prefetch: function prefetch(t) {
      var _this2 = this;

      var r;
      return (r = navigator.connection) && (r.saveData || /2g/.test(r.effectiveType)) ? Promise.resolve() : getFilesForRoute(e, t).then(function (e) {
        return Promise.all(canPrefetch ? e.scripts.map(function (e) {
          return prefetchViaDom(e, "script");
        }) : []);
      }).then(function () {
        (0, _requestIdleCallback$1.requestIdleCallback)(function () {
          return _this2.loadRoute(t, !0).catch(function () {});
        });
      }).catch(function () {});
    }
  };
}

var _default$5 = createRouteLoader;
routeLoader.default = _default$5;
var denormalizePagePath$1 = {};

function normalizePathSep(e) {
  return e.replace(/\\/g, "/");
}

function denormalizePagePath(e) {
  return (e = normalizePathSep(e)).startsWith("/index/") ? e = e.slice(6) : "/index" === e && (e = "/"), e;
}

denormalizePagePath$1.__esModule = !0, denormalizePagePath$1.normalizePathSep = normalizePathSep, denormalizePagePath$1.denormalizePagePath = denormalizePagePath;
var normalizeLocalePath$1 = {};

function normalizeLocalePath(e, t) {
  var r;
  var n = e.split("/");
  return (t || []).some(function (t) {
    return n[1].toLowerCase() === t.toLowerCase() && (r = t, n.splice(1, 1), e = n.join("/") || "/", !0);
  }), {
    pathname: e,
    detectedLocale: r
  };
}

normalizeLocalePath$1.__esModule = !0, normalizeLocalePath$1.normalizeLocalePath = normalizeLocalePath;
var mitt$1 = {};

function mitt() {
  var e = Object.create(null);
  return {
    on: function on(t, r) {
      (e[t] || (e[t] = [])).push(r);
    },
    off: function off(t, r) {
      e[t] && e[t].splice(e[t].indexOf(r) >>> 0, 1);
    },
    emit: function emit(t) {
      for (var _len = arguments.length, r = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        r[_key - 1] = arguments[_key];
      }

      (e[t] || []).slice().map(function (e) {
        e.apply(void 0, r);
      });
    }
  };
}

mitt$1.__esModule = !0, mitt$1.default = mitt;
var utils$1 = {},
    formatUrl$1 = {},
    querystring$1 = {};

function searchParamsToUrlQuery(e) {
  var t = {};
  return e.forEach(function (e, r) {
    void 0 === t[r] ? t[r] = e : Array.isArray(t[r]) ? t[r].push(e) : t[r] = [t[r], e];
  }), t;
}

function stringifyUrlQueryParam(e) {
  return "string" == typeof e || "number" == typeof e && !isNaN(e) || "boolean" == typeof e ? String(e) : "";
}

function urlQueryToSearchParams(e) {
  var t = new URLSearchParams();
  return Object.entries(e).forEach(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        e = _ref4[0],
        r = _ref4[1];

    Array.isArray(r) ? r.forEach(function (r) {
      return t.append(e, stringifyUrlQueryParam(r));
    }) : t.set(e, stringifyUrlQueryParam(r));
  }), t;
}

function assign$2(e) {
  for (var _len2 = arguments.length, t = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    t[_key2 - 1] = arguments[_key2];
  }

  return t.forEach(function (t) {
    Array.from(t.keys()).forEach(function (t) {
      return e.delete(t);
    }), t.forEach(function (t, r) {
      return e.append(r, t);
    });
  }), e;
}

querystring$1.__esModule = !0, querystring$1.searchParamsToUrlQuery = searchParamsToUrlQuery, querystring$1.urlQueryToSearchParams = urlQueryToSearchParams, querystring$1.assign = assign$2, formatUrl$1.__esModule = !0, formatUrl$1.formatUrl = formatUrl;

var querystring = _interopRequireWildcard$5(querystring$1);

function _getRequireWildcardCache$3() {
  if ("function" != typeof WeakMap) return null;
  var e = new WeakMap();
  return _getRequireWildcardCache$3 = function _getRequireWildcardCache$3() {
    return e;
  }, e;
}

function _interopRequireWildcard$5(e) {
  if (e && e.__esModule) return e;
  if (null === e || "object" != typeof e && "function" != typeof e) return {
    default: e
  };

  var t = _getRequireWildcardCache$3();

  if (t && t.has(e)) return t.get(e);
  var r = {},
      n = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var a in e) {
    if (Object.prototype.hasOwnProperty.call(e, a)) {
      var o = n ? Object.getOwnPropertyDescriptor(e, a) : null;
      o && (o.get || o.set) ? Object.defineProperty(r, a, o) : r[a] = e[a];
    }
  }

  return r.default = e, t && t.set(e, r), r;
}

var slashedProtocols = /https?|ftp|gopher|file/;

function formatUrl(e) {
  var t = e.auth,
      r = e.hostname,
      n = e.protocol || "",
      a = e.pathname || "",
      o = e.hash || "",
      i = e.query || "",
      s = !1;
  t = t ? encodeURIComponent(t).replace(/%3A/i, ":") + "@" : "", e.host ? s = t + e.host : r && (s = t + (~r.indexOf(":") ? "[".concat(r, "]") : r), e.port && (s += ":" + e.port)), i && "object" == typeof i && (i = String(querystring.urlQueryToSearchParams(i)));
  var l = e.search || i && "?".concat(i) || "";
  return n && ":" !== n.substr(-1) && (n += ":"), e.slashes || (!n || slashedProtocols.test(n)) && !1 !== s ? (s = "//" + (s || ""), a && "/" !== a[0] && (a = "/" + a)) : s || (s = ""), o && "#" !== o[0] && (o = "#" + o), l && "?" !== l[0] && (l = "?" + l), a = a.replace(/[?#]/g, encodeURIComponent), l = l.replace("#", "%23"), "".concat(n).concat(s).concat(a).concat(l).concat(o);
}

utils$1.__esModule = !0, utils$1.execOnce = execOnce, utils$1.getLocationOrigin = getLocationOrigin, utils$1.getURL = getURL, utils$1.getDisplayName = getDisplayName$1, utils$1.isResSent = isResSent, utils$1.loadGetInitialProps = loadGetInitialProps, utils$1.formatWithValidation = formatWithValidation, utils$1.ST = utils$1.SP = utils$1.urlObjectKeys = void 0;
var _formatUrl = formatUrl$1;

function execOnce(e) {
  var t,
      r = !1;
  return function () {
    return r || (r = !0, t = e.apply(void 0, arguments)), t;
  };
}

function getLocationOrigin() {
  var _window$location = window.location,
      e = _window$location.protocol,
      t = _window$location.hostname,
      r = _window$location.port;
  return "".concat(e, "//").concat(t).concat(r ? ":" + r : "");
}

function getURL() {
  var e = window.location.href,
      t = getLocationOrigin();
  return e.substring(t.length);
}

function getDisplayName$1(e) {
  return "string" == typeof e ? e : e.displayName || e.name || "Unknown";
}

function isResSent(e) {
  return e.finished || e.headersSent;
}

function loadGetInitialProps(_x, _x2) {
  return _loadGetInitialProps.apply(this, arguments);
}

function _loadGetInitialProps() {
  _loadGetInitialProps = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(e, t) {
    var r, _t48, n, a, _t49;

    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            if (!("production" !== process.env.NODE_ENV && null != (r = e.prototype) && r.getInitialProps)) {
              _context6.next = 3;
              break;
            }

            _t48 = "\"".concat(getDisplayName$1(e), ".getInitialProps()\" is defined as an instance method - visit https://nextjs.org/docs/messages/get-initial-props-as-an-instance-method for more information.");
            throw new Error(_t48);

          case 3:
            n = t.res || t.ctx && t.ctx.res;

            if (e.getInitialProps) {
              _context6.next = 14;
              break;
            }

            if (!(t.ctx && t.Component)) {
              _context6.next = 12;
              break;
            }

            _context6.next = 8;
            return loadGetInitialProps(t.Component, t.ctx);

          case 8:
            _context6.t1 = _context6.sent;
            _context6.t0 = {
              pageProps: _context6.t1
            };
            _context6.next = 13;
            break;

          case 12:
            _context6.t0 = {};

          case 13:
            return _context6.abrupt("return", _context6.t0);

          case 14:
            _context6.next = 16;
            return e.getInitialProps(t);

          case 16:
            a = _context6.sent;

            if (!(n && isResSent(n))) {
              _context6.next = 19;
              break;
            }

            return _context6.abrupt("return", a);

          case 19:
            if (a) {
              _context6.next = 22;
              break;
            }

            _t49 = "\"".concat(getDisplayName$1(e), ".getInitialProps()\" should resolve to an object. But found \"").concat(a, "\" instead.");
            throw new Error(_t49);

          case 22:
            return _context6.abrupt("return", ("production" !== process.env.NODE_ENV && (0 !== Object.keys(a).length || t.ctx || console.warn("".concat(getDisplayName$1(e), " returned an empty object from `getInitialProps`. This de-optimizes and prevents automatic static optimization. https://nextjs.org/docs/messages/empty-object-getInitialProps"))), a));

          case 23:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _loadGetInitialProps.apply(this, arguments);
}

var urlObjectKeys = ["auth", "hash", "host", "hostname", "href", "path", "pathname", "port", "protocol", "query", "search", "slashes"];

function formatWithValidation(e) {
  return "development" === process.env.NODE_ENV && null !== e && "object" == typeof e && Object.keys(e).forEach(function (e) {
    -1 === urlObjectKeys.indexOf(e) && console.warn("Unknown key passed via urlObject into url.format: ".concat(e));
  }), (0, _formatUrl.formatUrl)(e);
}

utils$1.urlObjectKeys = urlObjectKeys;
var SP = "undefined" != typeof performance;
utils$1.SP = SP;
var ST = SP && "function" == typeof performance.mark && "function" == typeof performance.measure;
utils$1.ST = ST;
var isDynamic = {
  __esModule: !0
};
isDynamic.isDynamicRoute = isDynamicRoute;
var TEST_ROUTE = /\/\[[^/]+?\](?=\/|$)/;

function isDynamicRoute(e) {
  return TEST_ROUTE.test(e);
}

var parseRelativeUrl$1 = {
  __esModule: !0
};
parseRelativeUrl$1.parseRelativeUrl = parseRelativeUrl;
var _utils$1 = utils$1,
    _querystring$2 = querystring$1;

function parseRelativeUrl(e, t) {
  var r = new URL("undefined" == typeof window ? "http://n" : (0, _utils$1.getLocationOrigin)()),
      n = t ? new URL(t, r) : r,
      _URL = new URL(e, n),
      a = _URL.pathname,
      o = _URL.searchParams,
      i = _URL.search,
      s = _URL.hash,
      l = _URL.href,
      c = _URL.origin;

  if (c !== r.origin) throw new Error("invariant: invalid relative URL, router received ".concat(e));
  return {
    pathname: a,
    query: (0, _querystring$2.searchParamsToUrlQuery)(o),
    search: i,
    hash: s,
    href: l.slice(r.origin.length)
  };
}

var resolveRewrites$1 = {},
    pathMatch = {},
    pathToRegexp$3 = {};

function lexer(e) {
  for (var t = [], r = 0; r < e.length;) {
    var n = e[r];
    if ("*" !== n && "+" !== n && "?" !== n) {
      if ("\\" !== n) {
        if ("{" !== n) {
          if ("}" !== n) {
            if (":" !== n) {
              if ("(" !== n) t.push({
                type: "CHAR",
                index: r,
                value: e[r++]
              });else {
                var a = 1,
                    o = "";
                if ("?" === e[s = r + 1]) throw new TypeError('Pattern cannot start with "?" at ' + s);

                for (; s < e.length;) {
                  if ("\\" !== e[s]) {
                    if (")" === e[s]) {
                      if (0 === --a) {
                        s++;
                        break;
                      }
                    } else if ("(" === e[s] && (a++, "?" !== e[s + 1])) throw new TypeError("Capturing groups are not allowed at " + s);

                    o += e[s++];
                  } else o += e[s++] + e[s++];
                }

                if (a) throw new TypeError("Unbalanced pattern at " + r);
                if (!o) throw new TypeError("Missing pattern at " + r);
                t.push({
                  type: "PATTERN",
                  index: r,
                  value: o
                }), r = s;
              }
            } else {
              for (var i = "", s = r + 1; s < e.length;) {
                var l = e.charCodeAt(s);
                if (!(l >= 48 && l <= 57 || l >= 65 && l <= 90 || l >= 97 && l <= 122 || 95 === l)) break;
                i += e[s++];
              }

              if (!i) throw new TypeError("Missing parameter name at " + r);
              t.push({
                type: "NAME",
                index: r,
                value: i
              }), r = s;
            }
          } else t.push({
            type: "CLOSE",
            index: r,
            value: e[r++]
          });
        } else t.push({
          type: "OPEN",
          index: r,
          value: e[r++]
        });
      } else t.push({
        type: "ESCAPED_CHAR",
        index: r++,
        value: e[r++]
      });
    } else t.push({
      type: "MODIFIER",
      index: r,
      value: e[r++]
    });
  }

  return t.push({
    type: "END",
    index: r,
    value: ""
  }), t;
}

function parse$5(e, t) {
  void 0 === t && (t = {});

  for (var r = lexer(e), n = t.prefixes, a = void 0 === n ? "./" : n, o = "[^" + escapeString(t.delimiter || "/#?") + "]+?", i = [], s = 0, l = 0, c = "", u = function u(e) {
    if (l < r.length && r[l].type === e) return r[l++].value;
  }, d = function d(e) {
    var t = u(e);
    if (void 0 !== t) return t;
    var n = r[l],
        a = n.type,
        o = n.index;
    throw new TypeError("Unexpected " + a + " at " + o + ", expected " + e);
  }, p = function p() {
    for (var e, t = ""; e = u("CHAR") || u("ESCAPED_CHAR");) {
      t += e;
    }

    return t;
  }; l < r.length;) {
    var g = u("CHAR"),
        m = u("NAME"),
        f = u("PATTERN");

    if (m || f) {
      var h = g || "";
      -1 === a.indexOf(h) && (c += h, h = ""), c && (i.push(c), c = ""), i.push({
        name: m || s++,
        prefix: h,
        suffix: "",
        pattern: f || o,
        modifier: u("MODIFIER") || ""
      });
    } else {
      var b = g || u("ESCAPED_CHAR");
      if (b) c += b;else if (c && (i.push(c), c = ""), u("OPEN")) {
        h = p();

        var y = u("NAME") || "",
            v = u("PATTERN") || "",
            _ = p();

        d("CLOSE"), i.push({
          name: y || (v ? s++ : ""),
          pattern: y && !v ? o : v,
          prefix: h,
          suffix: _,
          modifier: u("MODIFIER") || ""
        });
      } else d("END");
    }
  }

  return i;
}

function compile(e, t) {
  return tokensToFunction(parse$5(e, t), t);
}

function tokensToFunction(e, t) {
  void 0 === t && (t = {});
  var r = flags(t),
      n = t.encode,
      a = void 0 === n ? function (e) {
    return e;
  } : n,
      o = t.validate,
      i = void 0 === o || o,
      s = e.map(function (e) {
    if ("object" == typeof e) return new RegExp("^(?:" + e.pattern + ")$", r);
  });
  return function (t) {
    for (var r = "", n = 0; n < e.length; n++) {
      var o = e[n];

      if ("string" != typeof o) {
        var l = t ? t[o.name] : void 0,
            c = "?" === o.modifier || "*" === o.modifier,
            u = "*" === o.modifier || "+" === o.modifier;

        if (Array.isArray(l)) {
          if (!u) throw new TypeError('Expected "' + o.name + '" to not repeat, but got an array');

          if (0 === l.length) {
            if (c) continue;
            throw new TypeError('Expected "' + o.name + '" to not be empty');
          }

          for (var d = 0; d < l.length; d++) {
            var p = a(l[d], o);
            if (i && !s[n].test(p)) throw new TypeError('Expected all "' + o.name + '" to match "' + o.pattern + '", but got "' + p + '"');
            r += o.prefix + p + o.suffix;
          }
        } else if ("string" != typeof l && "number" != typeof l) {
          if (!c) {
            var g = u ? "an array" : "a string";
            throw new TypeError('Expected "' + o.name + '" to be ' + g);
          }
        } else {
          p = a(String(l), o);
          if (i && !s[n].test(p)) throw new TypeError('Expected "' + o.name + '" to match "' + o.pattern + '", but got "' + p + '"');
          r += o.prefix + p + o.suffix;
        }
      } else r += o;
    }

    return r;
  };
}

function match$1(e, t) {
  var r = [];
  return regexpToFunction(pathToRegexp$2(e, r, t), r, t);
}

function regexpToFunction(e, t, r) {
  void 0 === r && (r = {});
  var n = r.decode,
      a = void 0 === n ? function (e) {
    return e;
  } : n;
  return function (r) {
    var n = e.exec(r);
    if (!n) return !1;

    for (var o = n[0], i = n.index, s = Object.create(null), l = function l(e) {
      if (void 0 === n[e]) return "continue";
      var r = t[e - 1];
      "*" === r.modifier || "+" === r.modifier ? s[r.name] = n[e].split(r.prefix + r.suffix).map(function (e) {
        return a(e, r);
      }) : s[r.name] = a(n[e], r);
    }, c = 1; c < n.length; c++) {
      l(c);
    }

    return {
      path: o,
      index: i,
      params: s
    };
  };
}

function escapeString(e) {
  return e.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
}

function flags(e) {
  return e && e.sensitive ? "" : "i";
}

function regexpToRegexp(e, t) {
  if (!t) return e;
  var r = e.source.match(/\((?!\?)/g);
  if (r) for (var n = 0; n < r.length; n++) {
    t.push({
      name: n,
      prefix: "",
      suffix: "",
      modifier: "",
      pattern: ""
    });
  }
  return e;
}

function arrayToRegexp(e, t, r) {
  var n = e.map(function (e) {
    return pathToRegexp$2(e, t, r).source;
  });
  return new RegExp("(?:" + n.join("|") + ")", flags(r));
}

function stringToRegexp(e, t, r) {
  return tokensToRegexp(parse$5(e, r), t, r);
}

function tokensToRegexp(e, t, r) {
  void 0 === r && (r = {});

  for (var n = r.strict, a = void 0 !== n && n, o = r.start, i = void 0 === o || o, s = r.end, l = void 0 === s || s, c = r.encode, u = void 0 === c ? function (e) {
    return e;
  } : c, d = "[" + escapeString(r.endsWith || "") + "]|$", p = "[" + escapeString(r.delimiter || "/#?") + "]", g = i ? "^" : "", m = 0, f = e; m < f.length; m++) {
    var h = f[m];
    if ("string" == typeof h) g += escapeString(u(h));else {
      var b = escapeString(u(h.prefix)),
          y = escapeString(u(h.suffix));
      if (h.pattern) {
        if (t && t.push(h), b || y) {
          if ("+" === h.modifier || "*" === h.modifier) {
            var v = "*" === h.modifier ? "?" : "";
            g += "(?:" + b + "((?:" + h.pattern + ")(?:" + y + b + "(?:" + h.pattern + "))*)" + y + ")" + v;
          } else g += "(?:" + b + "(" + h.pattern + ")" + y + ")" + h.modifier;
        } else g += "(" + h.pattern + ")" + h.modifier;
      } else g += "(?:" + b + y + ")" + h.modifier;
    }
  }

  if (l) a || (g += p + "?"), g += r.endsWith ? "(?=" + d + ")" : "$";else {
    var _ = e[e.length - 1],
        T = "string" == typeof _ ? p.indexOf(_[_.length - 1]) > -1 : void 0 === _;
    a || (g += "(?:" + p + "(?=" + d + "))?"), T || (g += "(?=" + p + "|" + d + ")");
  }
  return new RegExp(g, flags(r));
}

function pathToRegexp$2(e, t, r) {
  return e instanceof RegExp ? regexpToRegexp(e, t) : Array.isArray(e) ? arrayToRegexp(e, t, r) : stringToRegexp(e, t, r);
}

Object.defineProperty(pathToRegexp$3, "__esModule", {
  value: !0
}), pathToRegexp$3.parse = parse$5, pathToRegexp$3.compile = compile, pathToRegexp$3.tokensToFunction = tokensToFunction, pathToRegexp$3.match = match$1, pathToRegexp$3.regexpToFunction = regexpToFunction, pathToRegexp$3.tokensToRegexp = tokensToRegexp, pathToRegexp$3.pathToRegexp = pathToRegexp$2, pathMatch.__esModule = !0, pathMatch.pathToRegexp = pathMatch.default = pathMatch.customRouteMatcherOptions = pathMatch.matcherOptions = void 0;

var pathToRegexp$1 = _interopRequireWildcard$4(pathToRegexp$3);

function _getRequireWildcardCache$2() {
  if ("function" != typeof WeakMap) return null;
  var e = new WeakMap();
  return _getRequireWildcardCache$2 = function _getRequireWildcardCache$2() {
    return e;
  }, e;
}

function _interopRequireWildcard$4(e) {
  if (e && e.__esModule) return e;
  if (null === e || "object" != typeof e && "function" != typeof e) return {
    default: e
  };

  var t = _getRequireWildcardCache$2();

  if (t && t.has(e)) return t.get(e);
  var r = {},
      n = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var a in e) {
    if (Object.prototype.hasOwnProperty.call(e, a)) {
      var o = n ? Object.getOwnPropertyDescriptor(e, a) : null;
      o && (o.get || o.set) ? Object.defineProperty(r, a, o) : r[a] = e[a];
    }
  }

  return r.default = e, t && t.set(e, r), r;
}

pathMatch.pathToRegexp = pathToRegexp$1;
var matcherOptions = {
  sensitive: !1,
  delimiter: "/"
};
pathMatch.matcherOptions = matcherOptions;

var customRouteMatcherOptions = _objectSpread2(_objectSpread2({}, matcherOptions), {}, {
  strict: !0
});

pathMatch.customRouteMatcherOptions = customRouteMatcherOptions;

var _default$4 = function _default$4() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
  return function (t) {
    var r = [],
        n = pathToRegexp$1.pathToRegexp(t, r, e ? customRouteMatcherOptions : matcherOptions),
        a = pathToRegexp$1.regexpToFunction(n, r);
    return function (t, n) {
      var o = null != t && a(t);
      if (!o) return !1;

      if (e) {
        var _iterator = _createForOfIteratorHelper(r),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _e2 = _step.value;
            "number" == typeof _e2.name && delete o.params[_e2.name];
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }

      return _objectSpread2(_objectSpread2({}, n), o.params);
    };
  };
};

pathMatch.default = _default$4;
var prepareDestination$1 = {
  __esModule: !0
};
prepareDestination$1.matchHas = matchHas, prepareDestination$1.compileNonPath = compileNonPath, prepareDestination$1.default = prepareDestination, prepareDestination$1.getSafeParamName = void 0;

var _querystring$1 = querystring$1,
    _parseRelativeUrl$2 = parseRelativeUrl$1,
    pathToRegexp = _interopRequireWildcard$3(pathToRegexp$3);

function _getRequireWildcardCache$1() {
  if ("function" != typeof WeakMap) return null;
  var e = new WeakMap();
  return _getRequireWildcardCache$1 = function _getRequireWildcardCache$1() {
    return e;
  }, e;
}

function _interopRequireWildcard$3(e) {
  if (e && e.__esModule) return e;
  if (null === e || "object" != typeof e && "function" != typeof e) return {
    default: e
  };

  var t = _getRequireWildcardCache$1();

  if (t && t.has(e)) return t.get(e);
  var r = {},
      n = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var a in e) {
    if (Object.prototype.hasOwnProperty.call(e, a)) {
      var o = n ? Object.getOwnPropertyDescriptor(e, a) : null;
      o && (o.get || o.set) ? Object.defineProperty(r, a, o) : r[a] = e[a];
    }
  }

  return r.default = e, t && t.set(e, r), r;
}

var getSafeParamName = function getSafeParamName(e) {
  var t = "";

  for (var _r = 0; _r < e.length; _r++) {
    var _n = e.charCodeAt(_r);

    (_n > 64 && _n < 91 || _n > 96 && _n < 123) && (t += e[_r]);
  }

  return t;
};

function matchHas(e, t, r) {
  var n = {};
  var a = [];
  "undefined" == typeof window && (a = Object.values(e.__NEXT_INIT_QUERY)), "undefined" != typeof window && (a = Array.from(new URLSearchParams(location.search).values()));
  return !!t.every(function (t) {
    var o,
        i = t.key;

    switch (t.type) {
      case "header":
        i = i.toLowerCase(), o = e.headers[i];
        break;

      case "cookie":
        o = e.cookies[t.key];
        break;

      case "query":
        o = r[i], a.includes(o || "") && (o = encodeURIComponent(o));
        break;

      case "host":
        {
          var _ref5 = (null == e ? void 0 : e.headers) || {},
              _t5 = _ref5.host;

          o = null == _t5 ? void 0 : _t5.split(":")[0].toLowerCase();
          break;
        }
    }

    if (!t.value && o) return n[getSafeParamName(i)] = o, !0;

    if (o) {
      var _e3 = new RegExp("^".concat(t.value, "$")),
          _r2 = o.match(_e3);

      if (_r2) return _r2.groups ? Object.keys(_r2.groups).forEach(function (e) {
        n[e] = _r2.groups[e];
      }) : "host" === t.type && _r2[0] && (n.host = _r2[0]), !0;
    }

    return !1;
  }) && n;
}

function compileNonPath(e, t) {
  if (!e.includes(":")) return e;

  for (var _i = 0, _Object$keys = Object.keys(t); _i < _Object$keys.length; _i++) {
    var _r3 = _Object$keys[_i];
    e.includes(":".concat(_r3)) && (e = e.replace(new RegExp(":".concat(_r3, "\\*"), "g"), ":".concat(_r3, "--ESCAPED_PARAM_ASTERISKS")).replace(new RegExp(":".concat(_r3, "\\?"), "g"), ":".concat(_r3, "--ESCAPED_PARAM_QUESTION")).replace(new RegExp(":".concat(_r3, "\\+"), "g"), ":".concat(_r3, "--ESCAPED_PARAM_PLUS")).replace(new RegExp(":".concat(_r3, "(?!\\w)"), "g"), "--ESCAPED_PARAM_COLON".concat(_r3)));
  }

  return e = e.replace(/(:|\*|\?|\+|\(|\)|\{|\})/g, "\\$1").replace(/--ESCAPED_PARAM_PLUS/g, "+").replace(/--ESCAPED_PARAM_COLON/g, ":").replace(/--ESCAPED_PARAM_QUESTION/g, "?").replace(/--ESCAPED_PARAM_ASTERISKS/g, "*"), pathToRegexp.compile("/".concat(e), {
    validate: !1
  })(t).substr(1);
}

function prepareDestination(e, t, r, n) {
  var a = {};

  var o = (r = Object.assign({}, r)).__nextLocale;

  if (delete r.__nextLocale, delete r.__nextDefaultLocale, e.startsWith("/")) a = (0, _parseRelativeUrl$2.parseRelativeUrl)(e);else {
    var _URL2 = new URL(e),
        _t6 = _URL2.pathname,
        _r4 = _URL2.searchParams,
        _n2 = _URL2.hash,
        _o = _URL2.hostname,
        _i2 = _URL2.port,
        _s = _URL2.protocol,
        _l = _URL2.search,
        _c2 = _URL2.href;

    a = {
      pathname: _t6,
      query: (0, _querystring$1.searchParamsToUrlQuery)(_r4),
      hash: _n2,
      protocol: _s,
      hostname: _o,
      port: _i2,
      search: _l,
      href: _c2
    };
  }
  var i = a.query,
      s = "".concat(a.pathname).concat(a.hash || ""),
      l = [];
  pathToRegexp.pathToRegexp(s, l);
  var c = l.map(function (e) {
    return e.name;
  });
  var u,
      d = pathToRegexp.compile(s, {
    validate: !1
  });

  for (var _i3 = 0, _Object$entries = Object.entries(i); _i3 < _Object$entries.length; _i3++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i3], 2),
        _e4 = _Object$entries$_i[0],
        _r5 = _Object$entries$_i[1];

    var _n3 = Array.isArray(_r5) ? _r5[0] : _r5;

    _n3 && (_n3 = compileNonPath(_n3, t)), i[_e4] = _n3;
  }

  var p = Object.keys(t);

  if (o && (p = p.filter(function (e) {
    return "nextInternalLocale" !== e;
  })), n && !p.some(function (e) {
    return c.includes(e);
  })) {
    var _iterator2 = _createForOfIteratorHelper(p),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _e5 = _step2.value;
        _e5 in i || (i[_e5] = t[_e5]);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  try {
    u = d(t);

    var _u$split = u.split("#"),
        _u$split2 = _slicedToArray(_u$split, 2),
        _e6 = _u$split2[0],
        _r6 = _u$split2[1];

    a.pathname = _e6, a.hash = "".concat(_r6 ? "#" : "").concat(_r6 || ""), delete a.search;
  } catch (e) {
    if (e.message.match(/Expected .*? to not repeat, but got an array/)) throw new Error("To use a multi-match in the destination you must add `*` at the end of the param name to signify it should repeat. https://nextjs.org/docs/messages/invalid-multi-match");
    throw e;
  }

  return a.query = _objectSpread2(_objectSpread2({}, r), a.query), {
    newUrl: u,
    parsedDestination: a
  };
}

prepareDestination$1.getSafeParamName = getSafeParamName, resolveRewrites$1.__esModule = !0, resolveRewrites$1.default = resolveRewrites;

var _pathMatch = _interopRequireDefault$6(pathMatch),
    _prepareDestination = _interopRequireWildcard$2(prepareDestination$1),
    _normalizeTrailingSlash$1 = normalizeTrailingSlash,
    _normalizeLocalePath$1 = normalizeLocalePath$1,
    _parseRelativeUrl$1 = parseRelativeUrl$1,
    _router$2 = router$2;

function _getRequireWildcardCache() {
  if ("function" != typeof WeakMap) return null;
  var e = new WeakMap();
  return _getRequireWildcardCache = function _getRequireWildcardCache() {
    return e;
  }, e;
}

function _interopRequireWildcard$2(e) {
  if (e && e.__esModule) return e;
  if (null === e || "object" != typeof e && "function" != typeof e) return {
    default: e
  };

  var t = _getRequireWildcardCache();

  if (t && t.has(e)) return t.get(e);
  var r = {},
      n = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var a in e) {
    if (Object.prototype.hasOwnProperty.call(e, a)) {
      var o = n ? Object.getOwnPropertyDescriptor(e, a) : null;
      o && (o.get || o.set) ? Object.defineProperty(r, a, o) : r[a] = e[a];
    }
  }

  return r.default = e, t && t.set(e, r), r;
}

function _interopRequireDefault$6(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}

var customRouteMatcher = (0, _pathMatch.default)(!0);

function resolveRewrites(e, t, r, n, a, o) {
  var i,
      s = !1,
      l = (0, _parseRelativeUrl$1.parseRelativeUrl)(e),
      c = (0, _normalizeTrailingSlash$1.removePathTrailingSlash)((0, _normalizeLocalePath$1.normalizeLocalePath)((0, _router$2.delBasePath)(l.pathname), o).pathname);

  var u = function u(r) {
    var u = customRouteMatcher(r.source)(l.pathname);

    if (r.has && u) {
      var _e7 = (0, _prepareDestination.matchHas)({
        headers: {
          host: document.location.hostname
        },
        cookies: document.cookie.split("; ").reduce(function (e, t) {
          var _t$split = t.split("="),
              _t$split2 = _toArray(_t$split),
              r = _t$split2[0],
              n = _t$split2.slice(1);

          return e[r] = n.join("="), e;
        }, {})
      }, r.has, l.query);

      _e7 ? Object.assign(u, _e7) : u = !1;
    }

    if (u) {
      if (!r.destination) return !0;

      var _d2 = (0, _prepareDestination.default)(r.destination, u, n, !0);

      if (l = _d2.parsedDestination, e = _d2.newUrl, Object.assign(n, _d2.parsedDestination.query), c = (0, _normalizeTrailingSlash$1.removePathTrailingSlash)((0, _normalizeLocalePath$1.normalizeLocalePath)((0, _router$2.delBasePath)(e), o).pathname), t.includes(c)) return s = !0, i = c, !0;
      if (i = a(c), i !== e && t.includes(i)) return s = !0, !0;
    }
  };

  var d = !1;

  for (var _e8 = 0; _e8 < r.beforeFiles.length; _e8++) {
    u(r.beforeFiles[_e8]);
  }

  if (s = t.includes(c), !s) {
    if (!d) for (var _e9 = 0; _e9 < r.afterFiles.length; _e9++) {
      if (u(r.afterFiles[_e9])) {
        d = !0;
        break;
      }
    }
    if (d || (i = a(c), s = t.includes(i), d = s), !d) for (var _e10 = 0; _e10 < r.fallback.length; _e10++) {
      if (u(r.fallback[_e10])) {
        d = !0;
        break;
      }
    }
  }

  return {
    asPath: e,
    parsedAs: l,
    matchedPage: s,
    resolvedHref: i
  };
}

var routeMatcher = {};

function getRouteMatcher(e) {
  var t = e.re,
      r = e.groups;
  return function (e) {
    var n = t.exec(e);
    if (!n) return !1;

    var a = function a(e) {
      try {
        return decodeURIComponent(e);
      } catch (e) {
        var _t7 = new Error("failed to decode param");

        throw _t7.code = "DECODE_FAILED", _t7;
      }
    },
        o = {};

    return Object.keys(r).forEach(function (e) {
      var t = r[e],
          i = n[t.pos];
      void 0 !== i && (o[e] = ~i.indexOf("/") ? i.split("/").map(function (e) {
        return a(e);
      }) : t.repeat ? [a(i)] : a(i));
    }), o;
  };
}

routeMatcher.__esModule = !0, routeMatcher.getRouteMatcher = getRouteMatcher;
var routeRegex = {};

function escapeRegex(e) {
  return e.replace(/[|\\{}()[\]^$+*?.-]/g, "\\$&");
}

function parseParameter(e) {
  var t = e.startsWith("[") && e.endsWith("]");
  t && (e = e.slice(1, -1));
  var r = e.startsWith("...");
  return r && (e = e.slice(3)), {
    key: e,
    repeat: r,
    optional: t
  };
}

function getRouteRegex(e) {
  var t = (e.replace(/\/$/, "") || "/").slice(1).split("/"),
      r = {};
  var n = 1;
  var a = t.map(function (e) {
    if (e.startsWith("[") && e.endsWith("]")) {
      var _parseParameter = parseParameter(e.slice(1, -1)),
          _t8 = _parseParameter.key,
          _a2 = _parseParameter.optional,
          o = _parseParameter.repeat;

      return r[_t8] = {
        pos: n++,
        repeat: o,
        optional: _a2
      }, o ? _a2 ? "(?:/(.+?))?" : "/(.+?)" : "/([^/]+?)";
    }

    return "/".concat(escapeRegex(e));
  }).join("");

  if ("undefined" == typeof window) {
    var _e11 = 97,
        _n4 = 1;

    var o = function o() {
      var t = "";

      for (var _r7 = 0; _r7 < _n4; _r7++) {
        t += String.fromCharCode(_e11), _e11++, _e11 > 122 && (_n4++, _e11 = 97);
      }

      return t;
    },
        i = {};

    var s = t.map(function (e) {
      if (e.startsWith("[") && e.endsWith("]")) {
        var _parseParameter2 = parseParameter(e.slice(1, -1)),
            _t9 = _parseParameter2.key,
            _r8 = _parseParameter2.optional,
            _n5 = _parseParameter2.repeat;

        var _a3 = _t9.replace(/\W/g, ""),
            _s2 = !1;

        return (0 === _a3.length || _a3.length > 30) && (_s2 = !0), isNaN(parseInt(_a3.substr(0, 1))) || (_s2 = !0), _s2 && (_a3 = o()), i[_a3] = _t9, _n5 ? _r8 ? "(?:/(?<".concat(_a3, ">.+?))?") : "/(?<".concat(_a3, ">.+?)") : "/(?<".concat(_a3, ">[^/]+?)");
      }

      return "/".concat(escapeRegex(e));
    }).join("");
    return {
      re: new RegExp("^".concat(a, "(?:/)?$")),
      groups: r,
      routeKeys: i,
      namedRegex: "^".concat(s, "(?:/)?$")
    };
  }

  return {
    re: new RegExp("^".concat(a, "(?:/)?$")),
    groups: r
  };
}

routeRegex.__esModule = !0, routeRegex.getRouteRegex = getRouteRegex;
var detectDomainLocale$2 = {};

function detectDomainLocale$1(e, t, r) {
  var n;

  if (e) {
    r && (r = r.toLowerCase());

    var _iterator3 = _createForOfIteratorHelper(e),
        _step3;

    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var i = _step3.value;
        var a, o;

        if (t === (null == (a = i.domain) ? void 0 : a.split(":")[0].toLowerCase()) || r === i.defaultLocale.toLowerCase() || null != (o = i.locales) && o.some(function (e) {
          return e.toLowerCase() === r;
        })) {
          n = i;
          break;
        }
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  }

  return n;
}

detectDomainLocale$2.__esModule = !0, detectDomainLocale$2.detectDomainLocale = detectDomainLocale$1;
var reactIs$1 = {
  exports: {}
},
    reactIs_production_min$1 = {},
    b$1 = 60103,
    c$2 = 60106,
    d$2 = 60107,
    e$1 = 60108,
    f$1 = 60114,
    g$2 = 60109,
    h$2 = 60110,
    k$1 = 60112,
    l$2 = 60113,
    m$1 = 60120,
    n$1 = 60115,
    p$1 = 60116,
    q$2 = 60121,
    r$2 = 60122,
    u = 60117,
    v$2 = 60129,
    w$1 = 60131;

if ("function" == typeof Symbol && Symbol.for) {
  var x$1 = Symbol.for;
  b$1 = x$1("react.element"), c$2 = x$1("react.portal"), d$2 = x$1("react.fragment"), e$1 = x$1("react.strict_mode"), f$1 = x$1("react.profiler"), g$2 = x$1("react.provider"), h$2 = x$1("react.context"), k$1 = x$1("react.forward_ref"), l$2 = x$1("react.suspense"), m$1 = x$1("react.suspense_list"), n$1 = x$1("react.memo"), p$1 = x$1("react.lazy"), q$2 = x$1("react.block"), r$2 = x$1("react.server.block"), u = x$1("react.fundamental"), v$2 = x$1("react.debug_trace_mode"), w$1 = x$1("react.legacy_hidden");
}

function y$1(e) {
  if ("object" == typeof e && null !== e) {
    var t = e.$$typeof;

    switch (t) {
      case b$1:
        switch (e = e.type) {
          case d$2:
          case f$1:
          case e$1:
          case l$2:
          case m$1:
            return e;

          default:
            switch (e = e && e.$$typeof) {
              case h$2:
              case k$1:
              case p$1:
              case n$1:
              case g$2:
                return e;

              default:
                return t;
            }

        }

      case c$2:
        return t;
    }
  }
}

var z$1 = g$2,
    A$1 = b$1,
    B = k$1,
    C = d$2,
    D = p$1,
    E = n$1,
    F = c$2,
    G$1 = f$1,
    H = e$1,
    I = l$2;
reactIs_production_min$1.ContextConsumer = h$2, reactIs_production_min$1.ContextProvider = z$1, reactIs_production_min$1.Element = A$1, reactIs_production_min$1.ForwardRef = B, reactIs_production_min$1.Fragment = C, reactIs_production_min$1.Lazy = D, reactIs_production_min$1.Memo = E, reactIs_production_min$1.Portal = F, reactIs_production_min$1.Profiler = G$1, reactIs_production_min$1.StrictMode = H, reactIs_production_min$1.Suspense = I, reactIs_production_min$1.isAsyncMode = function () {
  return !1;
}, reactIs_production_min$1.isConcurrentMode = function () {
  return !1;
}, reactIs_production_min$1.isContextConsumer = function (e) {
  return y$1(e) === h$2;
}, reactIs_production_min$1.isContextProvider = function (e) {
  return y$1(e) === g$2;
}, reactIs_production_min$1.isElement = function (e) {
  return "object" == typeof e && null !== e && e.$$typeof === b$1;
}, reactIs_production_min$1.isForwardRef = function (e) {
  return y$1(e) === k$1;
}, reactIs_production_min$1.isFragment = function (e) {
  return y$1(e) === d$2;
}, reactIs_production_min$1.isLazy = function (e) {
  return y$1(e) === p$1;
}, reactIs_production_min$1.isMemo = function (e) {
  return y$1(e) === n$1;
}, reactIs_production_min$1.isPortal = function (e) {
  return y$1(e) === c$2;
}, reactIs_production_min$1.isProfiler = function (e) {
  return y$1(e) === f$1;
}, reactIs_production_min$1.isStrictMode = function (e) {
  return y$1(e) === e$1;
}, reactIs_production_min$1.isSuspense = function (e) {
  return y$1(e) === l$2;
}, reactIs_production_min$1.isValidElementType = function (e) {
  return "string" == typeof e || "function" == typeof e || e === d$2 || e === f$1 || e === v$2 || e === e$1 || e === l$2 || e === m$1 || e === w$1 || "object" == typeof e && null !== e && (e.$$typeof === p$1 || e.$$typeof === n$1 || e.$$typeof === g$2 || e.$$typeof === h$2 || e.$$typeof === k$1 || e.$$typeof === u || e.$$typeof === q$2 || e[0] === r$2);
}, reactIs_production_min$1.typeOf = y$1;
var reactIs_development$1 = {};
/** @license React v17.0.2
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

"production" !== process.env.NODE_ENV && function () {
  var e = 60103,
      t = 60106,
      r = 60107,
      n = 60108,
      a = 60114,
      o = 60109,
      i = 60110,
      s = 60112,
      l = 60113,
      c = 60120,
      u = 60115,
      d = 60116,
      p = 60121,
      g = 60122,
      m = 60117,
      f = 60129,
      h = 60131;

  if ("function" == typeof Symbol && Symbol.for) {
    var b = Symbol.for;
    e = b("react.element"), t = b("react.portal"), r = b("react.fragment"), n = b("react.strict_mode"), a = b("react.profiler"), o = b("react.provider"), i = b("react.context"), s = b("react.forward_ref"), l = b("react.suspense"), c = b("react.suspense_list"), u = b("react.memo"), d = b("react.lazy"), p = b("react.block"), g = b("react.server.block"), m = b("react.fundamental"), b("react.scope"), b("react.opaque.id"), f = b("react.debug_trace_mode"), b("react.offscreen"), h = b("react.legacy_hidden");
  }

  function y(p) {
    if ("object" == typeof p && null !== p) {
      var g = p.$$typeof;

      switch (g) {
        case e:
          var m = p.type;

          switch (m) {
            case r:
            case a:
            case n:
            case l:
            case c:
              return m;

            default:
              var f = m && m.$$typeof;

              switch (f) {
                case i:
                case s:
                case d:
                case u:
                case o:
                  return f;

                default:
                  return g;
              }

          }

        case t:
          return g;
      }
    }
  }

  var v = i,
      _ = o,
      T = e,
      E = s,
      S = r,
      x = d,
      w = u,
      C = t,
      k = a,
      $ = n,
      R = l,
      A = !1,
      I = !1;
  reactIs_development$1.ContextConsumer = v, reactIs_development$1.ContextProvider = _, reactIs_development$1.Element = T, reactIs_development$1.ForwardRef = E, reactIs_development$1.Fragment = S, reactIs_development$1.Lazy = x, reactIs_development$1.Memo = w, reactIs_development$1.Portal = C, reactIs_development$1.Profiler = k, reactIs_development$1.StrictMode = $, reactIs_development$1.Suspense = R, reactIs_development$1.isAsyncMode = function (e) {
    return A || (A = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
  }, reactIs_development$1.isConcurrentMode = function (e) {
    return I || (I = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
  }, reactIs_development$1.isContextConsumer = function (e) {
    return y(e) === i;
  }, reactIs_development$1.isContextProvider = function (e) {
    return y(e) === o;
  }, reactIs_development$1.isElement = function (t) {
    return "object" == typeof t && null !== t && t.$$typeof === e;
  }, reactIs_development$1.isForwardRef = function (e) {
    return y(e) === s;
  }, reactIs_development$1.isFragment = function (e) {
    return y(e) === r;
  }, reactIs_development$1.isLazy = function (e) {
    return y(e) === d;
  }, reactIs_development$1.isMemo = function (e) {
    return y(e) === u;
  }, reactIs_development$1.isPortal = function (e) {
    return y(e) === t;
  }, reactIs_development$1.isProfiler = function (e) {
    return y(e) === a;
  }, reactIs_development$1.isStrictMode = function (e) {
    return y(e) === n;
  }, reactIs_development$1.isSuspense = function (e) {
    return y(e) === l;
  }, reactIs_development$1.isValidElementType = function (e) {
    return "string" == typeof e || "function" == typeof e || e === r || e === a || e === f || e === n || e === l || e === c || e === h || "object" == typeof e && null !== e && (e.$$typeof === d || e.$$typeof === u || e.$$typeof === o || e.$$typeof === i || e.$$typeof === s || e.$$typeof === m || e.$$typeof === p || e[0] === g);
  }, reactIs_development$1.typeOf = y;
}(), "production" === process.env.NODE_ENV ? reactIs$1.exports = reactIs_production_min$1 : reactIs$1.exports = reactIs_development$1, router$2.__esModule = !0, router$2.getDomainLocale = getDomainLocale, router$2.addLocale = addLocale, router$2.delLocale = delLocale, router$2.hasBasePath = hasBasePath, router$2.addBasePath = addBasePath, router$2.delBasePath = delBasePath, router$2.isLocalURL = isLocalURL, router$2.interpolateAs = interpolateAs, router$2.resolveHref = resolveHref, router$2.default = void 0;

var _normalizeTrailingSlash = normalizeTrailingSlash,
    _routeLoader = routeLoader,
    _denormalizePagePath = denormalizePagePath$1,
    _normalizeLocalePath = normalizeLocalePath$1,
    _mitt = _interopRequireDefault$5(mitt$1),
    _utils = utils$1,
    _isDynamic = isDynamic,
    _parseRelativeUrl = parseRelativeUrl$1,
    _querystring = querystring$1,
    _resolveRewrites = _interopRequireDefault$5(resolveRewrites$1),
    _routeMatcher = routeMatcher,
    _routeRegex = routeRegex;

function _interopRequireDefault$5(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}

var detectDomainLocale;
process.env.__NEXT_I18N_SUPPORT && (detectDomainLocale = detectDomainLocale$2.detectDomainLocale);
var basePath = process.env.__NEXT_ROUTER_BASEPATH || "";

function buildCancellationError() {
  return Object.assign(new Error("Route Cancelled"), {
    cancelled: !0
  });
}

function addPathPrefix(e, t) {
  return t && e.startsWith("/") ? "/" === e ? (0, _normalizeTrailingSlash.normalizePathTrailingSlash)(t) : "".concat(t).concat("/" === pathNoQueryHash(e) ? e.substring(1) : e) : e;
}

function getDomainLocale(e, t, r, n) {
  if (process.env.__NEXT_I18N_SUPPORT) {
    t = t || (0, _normalizeLocalePath.normalizeLocalePath)(e, r).detectedLocale;
    var a = detectDomainLocale(n, void 0, t);
    return !!a && "http".concat(a.http ? "" : "s", "://").concat(a.domain).concat(basePath || "").concat(t === a.defaultLocale ? "" : "/".concat(t)).concat(e);
  }

  return !1;
}

function addLocale(e, t, r) {
  if (process.env.__NEXT_I18N_SUPPORT) {
    var _n6 = pathNoQueryHash(e).toLowerCase(),
        a = t && t.toLowerCase();

    return t && t !== r && !_n6.startsWith("/" + a + "/") && _n6 !== "/" + a ? addPathPrefix(e, "/" + t) : e;
  }

  return e;
}

function delLocale(e, t) {
  if (process.env.__NEXT_I18N_SUPPORT) {
    var _r9 = pathNoQueryHash(e),
        _n7 = _r9.toLowerCase(),
        a = t && t.toLowerCase();

    return t && (_n7.startsWith("/" + a + "/") || _n7 === "/" + a) ? (_r9.length === t.length + 1 ? "/" : "") + e.substr(t.length + 1) : e;
  }

  return e;
}

function pathNoQueryHash(e) {
  var t = e.indexOf("?"),
      r = e.indexOf("#");
  return (t > -1 || r > -1) && (e = e.substring(0, t > -1 ? t : r)), e;
}

function hasBasePath(e) {
  return (e = pathNoQueryHash(e)) === basePath || e.startsWith(basePath + "/");
}

function addBasePath(e) {
  return addPathPrefix(e, basePath);
}

function delBasePath(e) {
  return (e = e.slice(basePath.length)).startsWith("/") || (e = "/".concat(e)), e;
}

function isLocalURL(e) {
  if (e.startsWith("/") || e.startsWith("#") || e.startsWith("?")) return !0;

  try {
    var _t10 = (0, _utils.getLocationOrigin)(),
        _r10 = new URL(e, _t10);

    return _r10.origin === _t10 && hasBasePath(_r10.pathname);
  } catch (e) {
    return !1;
  }
}

function interpolateAs(e, t, r) {
  var n = "";
  var a = (0, _routeRegex.getRouteRegex)(e),
      o = a.groups,
      i = (t !== e ? (0, _routeMatcher.getRouteMatcher)(a)(t) : "") || r;
  n = e;
  var s = Object.keys(o);
  return s.every(function (e) {
    var t = i[e] || "";
    var _o$e = o[e],
        r = _o$e.repeat,
        a = _o$e.optional;
    var s = "[".concat(r ? "..." : "").concat(e, "]");
    return a && (s = "".concat(t ? "" : "/", "[").concat(s, "]")), r && !Array.isArray(t) && (t = [t]), (a || e in i) && (n = n.replace(s, r ? t.map(function (e) {
      return encodeURIComponent(e);
    }).join("/") : encodeURIComponent(t)) || "/");
  }) || (n = ""), {
    params: s,
    result: n
  };
}

function omitParmsFromQuery(e, t) {
  var r = {};
  return Object.keys(e).forEach(function (n) {
    t.includes(n) || (r[n] = e[n]);
  }), r;
}

function resolveHref(e, t, r) {
  var n;
  var a = "string" == typeof t ? t : (0, _utils.formatWithValidation)(t);

  try {
    n = new URL(a.startsWith("#") ? e.asPath : e.pathname, "http://n");
  } catch (e) {
    n = new URL("/", "http://n");
  }

  if (!isLocalURL(a)) return r ? [a] : a;

  try {
    var _e12 = new URL(a, n);

    _e12.pathname = (0, _normalizeTrailingSlash.normalizePathTrailingSlash)(_e12.pathname);
    var _t11 = "";

    if ((0, _isDynamic.isDynamicRoute)(_e12.pathname) && _e12.searchParams && r) {
      var _r11 = (0, _querystring.searchParamsToUrlQuery)(_e12.searchParams),
          _interpolateAs = interpolateAs(_e12.pathname, _e12.pathname, _r11),
          _n8 = _interpolateAs.result,
          _a4 = _interpolateAs.params;

      _n8 && (_t11 = (0, _utils.formatWithValidation)({
        pathname: _n8,
        hash: _e12.hash,
        query: omitParmsFromQuery(_r11, _a4)
      }));
    }

    var o = _e12.origin === n.origin ? _e12.href.slice(_e12.origin.length) : _e12.href;
    return r ? [o, _t11 || o] : o;
  } catch (e) {
    return r ? [a] : a;
  }
}

function stripOrigin(e) {
  var t = (0, _utils.getLocationOrigin)();
  return e.startsWith(t) ? e.substring(t.length) : e;
}

function prepareUrlAs(e, t, r) {
  var _resolveHref = resolveHref(e, t, !0),
      _resolveHref2 = _slicedToArray(_resolveHref, 2),
      n = _resolveHref2[0],
      a = _resolveHref2[1];

  var o = (0, _utils.getLocationOrigin)(),
      i = n.startsWith(o),
      s = a && a.startsWith(o);
  n = stripOrigin(n), a = a ? stripOrigin(a) : a;
  var l = i ? n : addBasePath(n),
      c = r ? stripOrigin(resolveHref(e, r)) : a || n;
  return {
    url: l,
    as: s ? c : addBasePath(c)
  };
}

function resolveDynamicRoute(e, t) {
  var r = (0, _normalizeTrailingSlash.removePathTrailingSlash)((0, _denormalizePagePath.denormalizePagePath)(e));
  return "/404" === r || "/_error" === r ? e : (t.includes(r) || t.some(function (t) {
    if ((0, _isDynamic.isDynamicRoute)(t) && (0, _routeRegex.getRouteRegex)(t).re.test(r)) return e = t, !0;
  }), (0, _normalizeTrailingSlash.removePathTrailingSlash)(e));
}

var manualScrollRestoration = process.env.__NEXT_SCROLL_RESTORATION && "undefined" != typeof window && "scrollRestoration" in window.history && !!function () {
  try {
    var _e13 = "__next";
    return sessionStorage.setItem(_e13, _e13), sessionStorage.removeItem(_e13), !0;
  } catch (e) {}
}(),
    SSG_DATA_NOT_FOUND = Symbol("SSG_DATA_NOT_FOUND");

function fetchRetry(e, t) {
  return fetch(e, {
    credentials: "same-origin"
  }).then(function (r) {
    if (!r.ok) {
      if (t > 1 && r.status >= 500) return fetchRetry(e, t - 1);
      if (404 === r.status) return r.json().then(function (e) {
        if (e.notFound) return {
          notFound: SSG_DATA_NOT_FOUND
        };
        throw new Error("Failed to load static props");
      });
      throw new Error("Failed to load static props");
    }

    return r.json();
  });
}

function fetchNextData(e, t) {
  return fetchRetry(e, t ? 3 : 1).catch(function (e) {
    throw t || (0, _routeLoader.markAssetError)(e), e;
  });
}

var Router = /*#__PURE__*/function () {
  function Router(e, t, r, _ref6) {
    var _this3 = this;

    var n = _ref6.initialProps,
        a = _ref6.pageLoader,
        o = _ref6.App,
        i = _ref6.wrapApp,
        s = _ref6.Component,
        l = _ref6.err,
        c = _ref6.subscription,
        u = _ref6.isFallback,
        d = _ref6.locale,
        p = _ref6.locales,
        g = _ref6.defaultLocale,
        m = _ref6.domainLocales,
        f = _ref6.isPreview;

    _classCallCheck(this, Router);

    this.route = void 0, this.pathname = void 0, this.query = void 0, this.asPath = void 0, this.basePath = void 0, this.components = void 0, this.sdc = {}, this.sdr = {}, this.sub = void 0, this.clc = void 0, this.pageLoader = void 0, this._bps = void 0, this.events = void 0, this._wrapApp = void 0, this.isSsr = void 0, this.isFallback = void 0, this._inFlightRoute = void 0, this._shallow = void 0, this.locale = void 0, this.locales = void 0, this.defaultLocale = void 0, this.domainLocales = void 0, this.isReady = void 0, this.isPreview = void 0, this.isLocaleDomain = void 0, this._idx = 0, this.onPopState = function (e) {
      var t = e.state;

      if (!t) {
        var _e14 = _this3.pathname,
            _t12 = _this3.query;
        return void _this3.changeState("replaceState", (0, _utils.formatWithValidation)({
          pathname: addBasePath(_e14),
          query: _t12
        }), (0, _utils.getURL)());
      }

      if (!t.__N) return;
      var r;
      var n = t.url,
          a = t.as,
          o = t.options,
          i = t.idx;

      if (process.env.__NEXT_SCROLL_RESTORATION && manualScrollRestoration && _this3._idx !== i) {
        try {
          sessionStorage.setItem("__next_scroll_" + _this3._idx, JSON.stringify({
            x: self.pageXOffset,
            y: self.pageYOffset
          }));
        } catch (e) {}

        try {
          var _e15 = sessionStorage.getItem("__next_scroll_" + i);

          r = JSON.parse(_e15);
        } catch (e) {
          r = {
            x: 0,
            y: 0
          };
        }
      }

      _this3._idx = i;

      var _ref7 = (0, _parseRelativeUrl.parseRelativeUrl)(n),
          s = _ref7.pathname;

      _this3.isSsr && a === _this3.asPath && s === _this3.pathname || _this3._bps && !_this3._bps(t) || _this3.change("replaceState", n, a, Object.assign({}, o, {
        shallow: o.shallow && _this3._shallow,
        locale: o.locale || _this3.defaultLocale
      }), r);
    }, this.route = (0, _normalizeTrailingSlash.removePathTrailingSlash)(e), this.components = {}, "/_error" !== e && (this.components[this.route] = {
      Component: s,
      initial: !0,
      props: n,
      err: l,
      __N_SSG: n && n.__N_SSG,
      __N_SSP: n && n.__N_SSP
    }), this.components["/_app"] = {
      Component: o,
      styleSheets: []
    }, this.events = Router.events, this.pageLoader = a, this.pathname = e, this.query = t;

    var h = (0, _isDynamic.isDynamicRoute)(e) && self.__NEXT_DATA__.autoExport;

    if (this.asPath = h ? e : r, this.basePath = basePath, this.sub = c, this.clc = null, this._wrapApp = i, this.isSsr = !0, this.isFallback = u, this.isReady = !(!self.__NEXT_DATA__.gssp && !self.__NEXT_DATA__.gip && (h || self.location.search || process.env.__NEXT_HAS_REWRITES)), this.isPreview = !!f, this.isLocaleDomain = !1, process.env.__NEXT_I18N_SUPPORT && (this.locale = d, this.locales = p, this.defaultLocale = g, this.domainLocales = m, this.isLocaleDomain = !!detectDomainLocale(m, self.location.hostname)), "undefined" != typeof window) {
      if ("//" !== r.substr(0, 2)) {
        var _n9 = {
          locale: d
        };
        _n9._shouldResolveHref = r !== e, this.changeState("replaceState", (0, _utils.formatWithValidation)({
          pathname: addBasePath(e),
          query: t
        }), (0, _utils.getURL)(), _n9);
      }

      window.addEventListener("popstate", this.onPopState), process.env.__NEXT_SCROLL_RESTORATION && manualScrollRestoration && (window.history.scrollRestoration = "manual");
    }
  }

  _createClass(Router, [{
    key: "reload",
    value: function reload() {
      window.location.reload();
    }
  }, {
    key: "back",
    value: function back() {
      window.history.back();
    }
  }, {
    key: "push",
    value: function push(e, t) {
      var _prepareUrlAs;

      var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      if (process.env.__NEXT_SCROLL_RESTORATION && manualScrollRestoration) try {
        sessionStorage.setItem("__next_scroll_" + this._idx, JSON.stringify({
          x: self.pageXOffset,
          y: self.pageYOffset
        }));
      } catch (e) {}
      return (_prepareUrlAs = prepareUrlAs(this, e, t), e = _prepareUrlAs.url, t = _prepareUrlAs.as), this.change("pushState", e, t, r);
    }
  }, {
    key: "replace",
    value: function replace(e, t) {
      var _prepareUrlAs2;

      var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return (_prepareUrlAs2 = prepareUrlAs(this, e, t), e = _prepareUrlAs2.url, t = _prepareUrlAs2.as), this.change("replaceState", e, t, r);
    }
  }, {
    key: "change",
    value: function () {
      var _change = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(e, t, r, n, a) {
        var o, i, _e16, _a5, _o2, s, _i4, _e17, _n$shallow, l, c, u, d, p, g, m, f, _yield, h, _e18, b, _e19, _n10, _a6, _o3, _i5, _s3, _e20, y, v, _, _o4, _o5, _i6, _s4, _l2, _p, _t13, _r12, _prepareUrlAs3, _a7, _o6, _e21, _e22, _g, T;

        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (isLocalURL(t)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", (window.location.href = t, !1));

              case 2:
                o = t === r || n._h || n._shouldResolveHref;
                n._h && (this.isReady = !0);
                i = n.locale !== this.locale;

                if (!process.env.__NEXT_I18N_SUPPORT) {
                  _context.next = 15;
                  break;
                }

                this.locale = !1 === n.locale ? this.defaultLocale : n.locale || this.locale, void 0 === n.locale && (n.locale = this.locale);
                _e16 = (0, _parseRelativeUrl.parseRelativeUrl)(hasBasePath(r) ? delBasePath(r) : r), _a5 = (0, _normalizeLocalePath.normalizeLocalePath)(_e16.pathname, this.locales);
                _a5.detectedLocale && (this.locale = _a5.detectedLocale, _e16.pathname = addBasePath(_e16.pathname), r = (0, _utils.formatWithValidation)(_e16), t = addBasePath((0, _normalizeLocalePath.normalizeLocalePath)(hasBasePath(t) ? delBasePath(t) : t, this.locales).pathname));
                _o2 = !1;
                if (process.env.__NEXT_I18N_SUPPORT) null != (s = this.locales) && s.includes(this.locale) || (_e16.pathname = addLocale(_e16.pathname, this.locale), window.location.href = (0, _utils.formatWithValidation)(_e16), _o2 = !0);
                _i4 = detectDomainLocale(this.domainLocales, void 0, this.locale);

                if (process.env.__NEXT_I18N_SUPPORT && !_o2 && _i4 && this.isLocaleDomain && self.location.hostname !== _i4.domain) {
                  _e17 = delBasePath(r);
                  window.location.href = "http".concat(_i4.http ? "" : "s", "://").concat(_i4.domain).concat(addBasePath("".concat(this.locale === _i4.defaultLocale ? "" : "/".concat(this.locale)).concat("/" === _e17 ? "" : _e17) || "/")), _o2 = !0;
                }

                if (!_o2) {
                  _context.next = 15;
                  break;
                }

                return _context.abrupt("return", new Promise(function () {}));

              case 15:
                n._h || (this.isSsr = !1), _utils.ST && performance.mark("routeChange");
                _n$shallow = n.shallow, l = _n$shallow === void 0 ? !1 : _n$shallow, c = {
                  shallow: l
                };
                this._inFlightRoute && this.abortComponentLoad(this._inFlightRoute, c), r = addBasePath(addLocale(hasBasePath(r) ? delBasePath(r) : r, n.locale, this.defaultLocale));
                u = delLocale(hasBasePath(r) ? delBasePath(r) : r, this.locale);

                if (!(this._inFlightRoute = r, !n._h && this.onlyAHashChange(u))) {
                  _context.next = 21;
                  break;
                }

                return _context.abrupt("return", (this.asPath = u, Router.events.emit("hashChangeStart", r, c), this.changeState(e, t, r, n), this.scrollToHash(u), this.notify(this.components[this.route], null), Router.events.emit("hashChangeComplete", r, c), !0));

              case 21:
                g = (0, _parseRelativeUrl.parseRelativeUrl)(t), m = g.pathname, f = g.query;
                _context.prev = 22;
                _context.next = 25;
                return this.pageLoader.getPageList();

              case 25:
                d = _context.sent;
                _context.next = 28;
                return (0, _routeLoader.getClientBuildManifest)();

              case 28:
                _yield = _context.sent;
                p = _yield.__rewrites;
                _context.next = 35;
                break;

              case 32:
                _context.prev = 32;
                _context.t0 = _context["catch"](22);
                return _context.abrupt("return", (window.location.href = r, !1));

              case 35:
                this.urlIsNew(u) || i || (e = "replaceState");
                h = r;
                if (m = m ? (0, _normalizeTrailingSlash.removePathTrailingSlash)(delBasePath(m)) : m, o && "/_error" !== m) if (n._shouldResolveHref = !0, process.env.__NEXT_HAS_REWRITES && r.startsWith("/")) {
                  _e18 = (0, _resolveRewrites.default)(addBasePath(addLocale(u, this.locale)), d, p, f, function (e) {
                    return resolveDynamicRoute(e, d);
                  }, this.locales);
                  h = _e18.asPath, _e18.matchedPage && _e18.resolvedHref && (m = _e18.resolvedHref, g.pathname = addBasePath(m), t = (0, _utils.formatWithValidation)(g));
                } else g.pathname = resolveDynamicRoute(m, d), g.pathname !== m && (m = g.pathname, g.pathname = addBasePath(m), t = (0, _utils.formatWithValidation)(g));
                b = (0, _normalizeTrailingSlash.removePathTrailingSlash)(m);

                if (isLocalURL(r)) {
                  _context.next = 43;
                  break;
                }

                if (!("production" !== process.env.NODE_ENV)) {
                  _context.next = 42;
                  break;
                }

                throw new Error("Invalid href: \"".concat(t, "\" and as: \"").concat(r, "\", received relative href and external as\nSee more info: https://nextjs.org/docs/messages/invalid-relative-url-external-as"));

              case 42:
                return _context.abrupt("return", (window.location.href = r, !1));

              case 43:
                if (!(h = delLocale(delBasePath(h), this.locale), (0, _isDynamic.isDynamicRoute)(b))) {
                  _context.next = 52;
                  break;
                }

                _e19 = (0, _parseRelativeUrl.parseRelativeUrl)(h), _n10 = _e19.pathname, _a6 = (0, _routeRegex.getRouteRegex)(b), _o3 = (0, _routeMatcher.getRouteMatcher)(_a6)(_n10), _i5 = b === _n10, _s3 = _i5 ? interpolateAs(b, _n10, f) : {};

                if (!(!_o3 || _i5 && !_s3.result)) {
                  _context.next = 51;
                  break;
                }

                _e20 = Object.keys(_a6.groups).filter(function (e) {
                  return !f[e];
                });

                if (!(_e20.length > 0)) {
                  _context.next = 49;
                  break;
                }

                throw "production" !== process.env.NODE_ENV && console.warn((_i5 ? "Interpolating href" : "Mismatching `as` and `href`") + " failed to manually provide " + "the params: ".concat(_e20.join(", "), " in the `href`'s `query`")), new Error((_i5 ? "The provided `href` (".concat(t, ") value is missing query values (").concat(_e20.join(", "), ") to be interpolated properly. ") : "The provided `as` value (".concat(_n10, ") is incompatible with the `href` value (").concat(b, "). ")) + "Read more: https://nextjs.org/docs/messages/" + (_i5 ? "href-interpolation-failed" : "incompatible-href-as"));

              case 49:
                _context.next = 52;
                break;

              case 51:
                _i5 ? r = (0, _utils.formatWithValidation)(Object.assign({}, _e19, {
                  pathname: _s3.result,
                  query: omitParmsFromQuery(f, _s3.params)
                })) : Object.assign(f, _o3);

              case 52:
                Router.events.emit("routeChangeStart", r, c);
                _context.prev = 53;
                _context.next = 56;
                return this.getRouteInfo(b, m, f, r, h, c);

              case 56:
                _o4 = _context.sent;
                _o5 = _o4;
                _i6 = _o5.error;
                _s4 = _o5.props;
                _l2 = _o5.__N_SSG;
                _p = _o5.__N_SSP;

                if (!((_l2 || _p) && _s4)) {
                  _context.next = 84;
                  break;
                }

                if (!(_s4.pageProps && _s4.pageProps.__N_REDIRECT)) {
                  _context.next = 71;
                  break;
                }

                _t13 = _s4.pageProps.__N_REDIRECT;

                if (!_t13.startsWith("/")) {
                  _context.next = 70;
                  break;
                }

                _r12 = (0, _parseRelativeUrl.parseRelativeUrl)(_t13);
                _r12.pathname = resolveDynamicRoute(_r12.pathname, d);
                _prepareUrlAs3 = prepareUrlAs(this, _t13, _t13), _a7 = _prepareUrlAs3.url, _o6 = _prepareUrlAs3.as;
                return _context.abrupt("return", this.change(e, _a7, _o6, n));

              case 70:
                return _context.abrupt("return", (window.location.href = _t13, new Promise(function () {})));

              case 71:
                if (!(this.isPreview = !!_s4.__N_PREVIEW, _s4.notFound === SSG_DATA_NOT_FOUND)) {
                  _context.next = 84;
                  break;
                }

                _context.prev = 72;
                _context.next = 75;
                return this.fetchComponent("/404");

              case 75:
                _e21 = "/404";
                _context.next = 81;
                break;

              case 78:
                _context.prev = 78;
                _context.t1 = _context["catch"](72);
                _e21 = "/_error";

              case 81:
                _context.next = 83;
                return this.getRouteInfo(_e21, _e21, f, r, h, {
                  shallow: !1
                });

              case 83:
                _o4 = _context.sent;

              case 84:
                if (Router.events.emit("beforeHistoryChange", r, c), this.changeState(e, t, r, n), "production" !== process.env.NODE_ENV) {
                  _e22 = this.components["/_app"].Component;
                  window.next.isPrerendered = _e22.getInitialProps === _e22.origGetInitialProps && !_o4.Component.getInitialProps;
                }

                n._h && "/_error" === m && 500 === (null == (y = self.__NEXT_DATA__.props) || null == (v = y.pageProps) ? void 0 : v.statusCode) && null != _s4 && _s4.pageProps && (_s4.pageProps.statusCode = 500);
                _g = n.shallow && this.route === b, T = (null != (_ = n.scroll) ? _ : !_g) ? {
                  x: 0,
                  y: 0
                } : null;
                _context.next = 89;
                return this.set(b, m, f, u, _o4, null != a ? a : T).catch(function (e) {
                  if (!e.cancelled) throw e;
                  _i6 = _i6 || e;
                });

              case 89:
                if (!_i6) {
                  _context.next = 91;
                  break;
                }

                throw Router.events.emit("routeChangeError", _i6, u, c), _i6;

              case 91:
                return _context.abrupt("return", (process.env.__NEXT_I18N_SUPPORT && this.locale && (document.documentElement.lang = this.locale), Router.events.emit("routeChangeComplete", r, c), !0));

              case 94:
                _context.prev = 94;
                _context.t2 = _context["catch"](53);

                if (!_context.t2.cancelled) {
                  _context.next = 98;
                  break;
                }

                return _context.abrupt("return", !1);

              case 98:
                throw _context.t2;

              case 99:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[22, 32], [53, 94], [72, 78]]);
      }));

      function change(_x3, _x4, _x5, _x6, _x7) {
        return _change.apply(this, arguments);
      }

      return change;
    }()
  }, {
    key: "changeState",
    value: function changeState(e, t, r) {
      var n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

      if ("production" !== process.env.NODE_ENV) {
        if (void 0 === window.history) return void console.error("Warning: window.history is not available.");
        if (void 0 === window.history[e]) return void console.error("Warning: window.history.".concat(e, " is not available"));
      }

      "pushState" === e && (0, _utils.getURL)() === r || (this._shallow = n.shallow, window.history[e]({
        url: t,
        as: r,
        options: n,
        __N: !0,
        idx: this._idx = "pushState" !== e ? this._idx : this._idx + 1
      }, "", r));
    }
  }, {
    key: "handleRouteInfoError",
    value: function () {
      var _handleRouteInfoError = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(e, t, r, n, a, o) {
        var _yield$this$fetchComp, _n11, _a8, _o7, i;

        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!e.cancelled) {
                  _context2.next = 2;
                  break;
                }

                throw e;

              case 2:
                if (!((0, _routeLoader.isAssetError)(e) || o)) {
                  _context2.next = 4;
                  break;
                }

                throw Router.events.emit("routeChangeError", e, n, a), window.location.href = n, buildCancellationError();

              case 4:
                _context2.prev = 4;
                _context2.t0 = void 0 !== _n11 && void 0 !== _a8;

                if (_context2.t0) {
                  _context2.next = 13;
                  break;
                }

                _context2.next = 9;
                return this.fetchComponent("/_error");

              case 9:
                _yield$this$fetchComp = _context2.sent;
                _n11 = _yield$this$fetchComp.page;
                _a8 = _yield$this$fetchComp.styleSheets;
                _yield$this$fetchComp;

              case 13:
                i = {
                  props: _o7,
                  Component: _n11,
                  styleSheets: _a8,
                  err: e,
                  error: e
                };

                if (i.props) {
                  _context2.next = 24;
                  break;
                }

                _context2.prev = 15;
                _context2.next = 18;
                return this.getInitialProps(_n11, {
                  err: e,
                  pathname: t,
                  query: r
                });

              case 18:
                i.props = _context2.sent;
                _context2.next = 24;
                break;

              case 21:
                _context2.prev = 21;
                _context2.t1 = _context2["catch"](15);
                console.error("Error in error page `getInitialProps`: ", _context2.t1), i.props = {};

              case 24:
                return _context2.abrupt("return", i);

              case 27:
                _context2.prev = 27;
                _context2.t2 = _context2["catch"](4);
                return _context2.abrupt("return", this.handleRouteInfoError(_context2.t2, t, r, n, a, !0));

              case 30:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[4, 27], [15, 21]]);
      }));

      function handleRouteInfoError(_x8, _x9, _x10, _x11, _x12, _x13) {
        return _handleRouteInfoError.apply(this, arguments);
      }

      return handleRouteInfoError;
    }()
  }, {
    key: "getRouteInfo",
    value: function () {
      var _getRouteInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(e, t, r, n, a, o) {
        var _this4 = this;

        var i, s, _l3, _c3, _u, _d3, _e23, _p2, _g2;

        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                i = this.components[e];

                if (!(o.shallow && i && this.route === e)) {
                  _context3.next = 4;
                  break;
                }

                return _context3.abrupt("return", i);

              case 4:
                s = i && "initial" in i ? void 0 : i;
                _context3.t0 = s;

                if (_context3.t0) {
                  _context3.next = 10;
                  break;
                }

                _context3.next = 9;
                return this.fetchComponent(e).then(function (e) {
                  return {
                    Component: e.page,
                    styleSheets: e.styleSheets,
                    __N_SSG: e.mod.__N_SSG,
                    __N_SSP: e.mod.__N_SSP
                  };
                });

              case 9:
                _context3.t0 = _context3.sent;

              case 10:
                _l3 = _context3.t0;
                _c3 = _l3.Component;
                _u = _l3.__N_SSG;
                _d3 = _l3.__N_SSP;

                if (!("production" !== process.env.NODE_ENV)) {
                  _context3.next = 18;
                  break;
                }

                _e23 = reactIs$1.exports.isValidElementType;

                if (_e23(_c3)) {
                  _context3.next = 18;
                  break;
                }

                throw new Error("The default export is not a React Component in page: \"".concat(t, "\""));

              case 18:
                (_u || _d3) && (_p2 = this.pageLoader.getDataHref((0, _utils.formatWithValidation)({
                  pathname: t,
                  query: r
                }), a, _u, this.locale));
                _context3.next = 21;
                return this._getData(function () {
                  return _u ? _this4._getStaticData(_p2) : _d3 ? _this4._getServerData(_p2) : _this4.getInitialProps(_c3, {
                    pathname: t,
                    query: r,
                    asPath: n,
                    locale: _this4.locale,
                    locales: _this4.locales,
                    defaultLocale: _this4.defaultLocale
                  });
                });

              case 21:
                _g2 = _context3.sent;
                return _context3.abrupt("return", (_l3.props = _g2, this.components[e] = _l3, _l3));

              case 25:
                _context3.prev = 25;
                _context3.t1 = _context3["catch"](0);
                return _context3.abrupt("return", this.handleRouteInfoError(_context3.t1, t, r, n, o));

              case 28:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 25]]);
      }));

      function getRouteInfo(_x14, _x15, _x16, _x17, _x18, _x19) {
        return _getRouteInfo.apply(this, arguments);
      }

      return getRouteInfo;
    }()
  }, {
    key: "set",
    value: function set(e, t, r, n, a, o) {
      return this.isFallback = !1, this.route = e, this.pathname = t, this.query = r, this.asPath = n, this.notify(a, o);
    }
  }, {
    key: "beforePopState",
    value: function beforePopState(e) {
      this._bps = e;
    }
  }, {
    key: "onlyAHashChange",
    value: function onlyAHashChange(e) {
      if (!this.asPath) return !1;

      var _this$asPath$split = this.asPath.split("#"),
          _this$asPath$split2 = _slicedToArray(_this$asPath$split, 2),
          t = _this$asPath$split2[0],
          r = _this$asPath$split2[1],
          _e$split = e.split("#"),
          _e$split2 = _slicedToArray(_e$split, 2),
          n = _e$split2[0],
          a = _e$split2[1];

      return !(!a || t !== n || r !== a) || t === n && r !== a;
    }
  }, {
    key: "scrollToHash",
    value: function scrollToHash(e) {
      var _e$split3 = e.split("#"),
          _e$split4 = _slicedToArray(_e$split3, 2),
          t = _e$split4[1];

      if ("" === t || "top" === t) return void window.scrollTo(0, 0);
      var r = document.getElementById(t);
      if (r) return void r.scrollIntoView();
      var n = document.getElementsByName(t)[0];
      n && n.scrollIntoView();
    }
  }, {
    key: "urlIsNew",
    value: function urlIsNew(e) {
      return this.asPath !== e;
    }
  }, {
    key: "prefetch",
    value: function () {
      var _prefetch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(e) {
        var _this5 = this;

        var t,
            r,
            n,
            a,
            _o8,
            _i7,
            o,
            i,
            _r13,
            _yield2,
            _s5,
            s,
            _args4 = arguments;

        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                t = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : e;
                r = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : {};
                n = (0, _parseRelativeUrl.parseRelativeUrl)(e), a = n.pathname;

                if (process.env.__NEXT_I18N_SUPPORT && !1 === r.locale) {
                  a = (0, _normalizeLocalePath.normalizeLocalePath)(a, this.locales).pathname, n.pathname = a, e = (0, _utils.formatWithValidation)(n);
                  _o8 = (0, _parseRelativeUrl.parseRelativeUrl)(t);
                  _i7 = (0, _normalizeLocalePath.normalizeLocalePath)(_o8.pathname, this.locales);
                  _o8.pathname = _i7.pathname, r.locale = _i7.detectedLocale || this.defaultLocale, t = (0, _utils.formatWithValidation)(_o8);
                }

                _context4.next = 6;
                return this.pageLoader.getPageList();

              case 6:
                o = _context4.sent;
                i = t;

                if (!(process.env.__NEXT_HAS_REWRITES && t.startsWith("/"))) {
                  _context4.next = 17;
                  break;
                }

                _context4.next = 11;
                return (0, _routeLoader.getClientBuildManifest)();

              case 11:
                _yield2 = _context4.sent;
                _r13 = _yield2.__rewrites;
                _s5 = (0, _resolveRewrites.default)(addBasePath(addLocale(t, this.locale)), o, _r13, n.query, function (e) {
                  return resolveDynamicRoute(e, o);
                }, this.locales);
                i = delLocale(delBasePath(_s5.asPath), this.locale), _s5.matchedPage && _s5.resolvedHref && (a = _s5.resolvedHref, n.pathname = a, e = (0, _utils.formatWithValidation)(n));
                _context4.next = 18;
                break;

              case 17:
                n.pathname = resolveDynamicRoute(n.pathname, o), n.pathname !== a && (a = n.pathname, n.pathname = a, e = (0, _utils.formatWithValidation)(n));

              case 18:
                s = (0, _normalizeTrailingSlash.removePathTrailingSlash)(a);
                _context4.t0 = "production" === process.env.NODE_ENV;

                if (!_context4.t0) {
                  _context4.next = 23;
                  break;
                }

                _context4.next = 23;
                return Promise.all([this.pageLoader._isSsg(s).then(function (t) {
                  return !!t && _this5._getStaticData(_this5.pageLoader.getDataHref(e, i, !0, void 0 !== r.locale ? r.locale : _this5.locale));
                }), this.pageLoader[r.priority ? "loadPage" : "prefetch"](s)]);

              case 23:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function prefetch(_x20) {
        return _prefetch.apply(this, arguments);
      }

      return prefetch;
    }()
  }, {
    key: "fetchComponent",
    value: function () {
      var _fetchComponent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(e) {
        var t, r, n, _t14;

        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                t = !1;

                r = this.clc = function () {
                  t = !0;
                };

                _context5.next = 4;
                return this.pageLoader.loadPage(e);

              case 4:
                n = _context5.sent;

                if (!t) {
                  _context5.next = 8;
                  break;
                }

                _t14 = new Error("Abort fetching component for route: \"".concat(e, "\""));
                throw _t14.cancelled = !0, _t14;

              case 8:
                return _context5.abrupt("return", (r === this.clc && (this.clc = null), n));

              case 9:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function fetchComponent(_x21) {
        return _fetchComponent.apply(this, arguments);
      }

      return fetchComponent;
    }()
  }, {
    key: "_getData",
    value: function _getData(e) {
      var _this6 = this;

      var t = !1;

      var r = function r() {
        t = !0;
      };

      return this.clc = r, e().then(function (e) {
        if (r === _this6.clc && (_this6.clc = null), t) {
          var _e24 = new Error("Loading initial props cancelled");

          throw _e24.cancelled = !0, _e24;
        }

        return e;
      });
    }
  }, {
    key: "_getStaticData",
    value: function _getStaticData(e) {
      var _this7 = this;

      var _URL3 = new URL(e, window.location.href),
          t = _URL3.href;

      return "production" === process.env.NODE_ENV && !this.isPreview && this.sdc[t] ? Promise.resolve(this.sdc[t]) : fetchNextData(e, this.isSsr).then(function (e) {
        return _this7.sdc[t] = e, e;
      });
    }
  }, {
    key: "_getServerData",
    value: function _getServerData(e) {
      var _this8 = this;

      var _URL4 = new URL(e, window.location.href),
          t = _URL4.href;

      return this.sdr[t] ? this.sdr[t] : this.sdr[t] = fetchNextData(e, this.isSsr).then(function (e) {
        return delete _this8.sdr[t], e;
      }).catch(function (e) {
        throw delete _this8.sdr[t], e;
      });
    }
  }, {
    key: "getInitialProps",
    value: function getInitialProps(e, t) {
      var r = this.components["/_app"].Component,
          n = this._wrapApp(r);

      return t.AppTree = n, (0, _utils.loadGetInitialProps)(r, {
        AppTree: n,
        Component: e,
        router: this,
        ctx: t
      });
    }
  }, {
    key: "abortComponentLoad",
    value: function abortComponentLoad(e, t) {
      this.clc && (Router.events.emit("routeChangeError", buildCancellationError(), e, t), this.clc(), this.clc = null);
    }
  }, {
    key: "notify",
    value: function notify(e, t) {
      return this.sub(e, this.components["/_app"].Component, t);
    }
  }]);

  return Router;
}();

router$2.default = Router, Router.events = (0, _mitt.default)();

var router$1 = {},
    routerContext = {
  __esModule: !0,
  RouterContext: void 0
},
    _react$4 = _interopRequireDefault$4(React__default);

function _interopRequireDefault$4(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}

var RouterContext = _react$4.default.createContext(null);

routerContext.RouterContext = RouterContext, "production" !== process.env.NODE_ENV && (RouterContext.displayName = "RouterContext");
var withRouter$1 = {},
    _interopRequireDefault$3 = interopRequireDefault$2;
withRouter$1.__esModule = !0, withRouter$1.default = withRouter;

var _react$3 = _interopRequireDefault$3(React__default),
    _router$1 = router$1;

function withRouter(e) {
  function t(t) {
    return _react$3.default.createElement(e, Object.assign({
      router: (0, _router$1.useRouter)()
    }, t));
  }

  if (t.getInitialProps = e.getInitialProps, t.origGetInitialProps = e.origGetInitialProps, "production" !== process.env.NODE_ENV) {
    var _r14 = e.displayName || e.name || "Unknown";

    t.displayName = "withRouter(".concat(_r14, ")");
  }

  return t;
}

var _interopRequireWildcard$1 = interopRequireWildcard,
    _interopRequireDefault$2 = interopRequireDefault$2;
router$1.__esModule = !0, router$1.useRouter = useRouter, router$1.makePublicRouterInstance = makePublicRouterInstance, router$1.createRouter = router$1.withRouter = router$1.default = void 0;

var _react$2 = _interopRequireDefault$2(React__default),
    _router2$1 = _interopRequireWildcard$1(router$2);

router$1.Router = _router2$1.default, router$1.NextRouter = _router2$1.NextRouter;

var _routerContext = routerContext,
    _withRouter = _interopRequireDefault$2(withRouter$1);

router$1.withRouter = _withRouter.default;
var singletonRouter = {
  router: null,
  readyCallbacks: [],
  ready: function ready(e) {
    if (this.router) return e();
    "undefined" != typeof window && this.readyCallbacks.push(e);
  }
},
    urlPropertyFields = ["pathname", "route", "query", "asPath", "components", "isFallback", "basePath", "locale", "locales", "defaultLocale", "isReady", "isPreview", "isLocaleDomain", "domainLocales"],
    routerEvents = ["routeChangeStart", "beforeHistoryChange", "routeChangeComplete", "routeChangeError", "hashChangeStart", "hashChangeComplete"],
    coreMethodFields = ["push", "replace", "reload", "back", "prefetch", "beforePopState"];

function getRouter() {
  if (!singletonRouter.router) {
    throw new Error('No router instance found.\nYou should only use "next/router" on the client side of your app.\n');
  }

  return singletonRouter.router;
}

Object.defineProperty(singletonRouter, "events", {
  get: function get() {
    return _router2$1.default.events;
  }
}), urlPropertyFields.forEach(function (e) {
  Object.defineProperty(singletonRouter, e, {
    get: function get() {
      return getRouter()[e];
    }
  });
}), coreMethodFields.forEach(function (e) {
  singletonRouter[e] = function () {
    var _getRouter;

    return (_getRouter = getRouter())[e].apply(_getRouter, arguments);
  };
}), routerEvents.forEach(function (e) {
  singletonRouter.ready(function () {
    _router2$1.default.events.on(e, function () {
      var r = "on".concat(e.charAt(0).toUpperCase()).concat(e.substring(1)),
          n = singletonRouter;
      if (n[r]) try {
        n[r].apply(n, arguments);
      } catch (e) {
        console.error("Error when running the Router event: ".concat(r)), console.error("".concat(e.message, "\n").concat(e.stack));
      }
    });
  });
});
var _default$3 = singletonRouter;

function useRouter() {
  return _react$2.default.useContext(_routerContext.RouterContext);
}

router$1.default = _default$3;

var createRouter = function createRouter() {
  for (var _len3 = arguments.length, e = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    e[_key3] = arguments[_key3];
  }

  return singletonRouter.router = _construct(_router2$1.default, e), singletonRouter.readyCallbacks.forEach(function (e) {
    return e();
  }), singletonRouter.readyCallbacks = [], singletonRouter.router;
};

function makePublicRouterInstance(e) {
  var t = e,
      r = {};

  var _iterator4 = _createForOfIteratorHelper(urlPropertyFields),
      _step4;

  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var _e25 = _step4.value;
      "object" != typeof t[_e25] ? r[_e25] = t[_e25] : r[_e25] = Object.assign(Array.isArray(t[_e25]) ? [] : {}, t[_e25]);
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }

  return r.events = _router2$1.default.events, coreMethodFields.forEach(function (e) {
    r[e] = function () {
      return t[e].apply(t, arguments);
    };
  }), r;
}

router$1.createRouter = createRouter;
var useIntersection$1 = {
  __esModule: !0
};
useIntersection$1.useIntersection = useIntersection;
var _react$1 = React__default,
    _requestIdleCallback = requestIdleCallback$1;
var hasIntersectionObserver = "undefined" != typeof IntersectionObserver;

function useIntersection(_ref8) {
  var e = _ref8.rootMargin,
      t = _ref8.disabled;

  var r = t || !hasIntersectionObserver,
      n = (0, _react$1.useRef)(),
      _ref9 = (0, _react$1.useState)(!1),
      _ref10 = _slicedToArray(_ref9, 2),
      a = _ref10[0],
      o = _ref10[1],
      i = (0, _react$1.useCallback)(function (t) {
    n.current && (n.current(), n.current = void 0), r || a || t && t.tagName && (n.current = observe(t, function (e) {
      return e && o(e);
    }, {
      rootMargin: e
    }));
  }, [r, e, a]);

  return (0, _react$1.useEffect)(function () {
    if (!hasIntersectionObserver && !a) {
      var _e26 = (0, _requestIdleCallback.requestIdleCallback)(function () {
        return o(!0);
      });

      return function () {
        return (0, _requestIdleCallback.cancelIdleCallback)(_e26);
      };
    }
  }, [a]), [i, a];
}

function observe(e, t, r) {
  var _createObserver = createObserver(r),
      n = _createObserver.id,
      a = _createObserver.observer,
      o = _createObserver.elements;

  return o.set(e, t), a.observe(e), function () {
    o.delete(e), a.unobserve(e), 0 === o.size && (a.disconnect(), observers.delete(n));
  };
}

var observers = new Map();

function createObserver(e) {
  var t = e.rootMargin || "";
  var r = observers.get(t);
  if (r) return r;
  var n = new Map(),
      a = new IntersectionObserver(function (e) {
    e.forEach(function (e) {
      var t = n.get(e.target),
          r = e.isIntersecting || e.intersectionRatio > 0;
      t && r && t(r);
    });
  }, e);
  return observers.set(t, r = {
    id: t,
    observer: a,
    elements: n
  }), r;
}

var _interopRequireWildcard = interopRequireWildcard;
link$1.__esModule = !0, link$1.default = void 0;

var _react = _interopRequireWildcard(React__default),
    _router = router$2,
    _router2 = router$1,
    _useIntersection = useIntersection$1;

var prefetched = {};

function prefetch(e, t, r, n) {
  if ("undefined" == typeof window || !e) return;
  if (!(0, _router.isLocalURL)(t)) return;
  e.prefetch(t, r, n).catch(function (e) {
    if ("production" !== process.env.NODE_ENV) throw e;
  });
  var a = n && void 0 !== n.locale ? n.locale : e && e.locale;
  prefetched[t + "%" + r + (a ? "%" + a : "")] = !0;
}

function isModifiedEvent(e) {
  var t = e.currentTarget.target;
  return t && "_self" !== t || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.nativeEvent && 2 === e.nativeEvent.which;
}

function linkClicked(e, t, r, n, a, o, i, s) {
  var l = e.currentTarget.nodeName;
  ("A" !== l || !isModifiedEvent(e) && (0, _router.isLocalURL)(r)) && (e.preventDefault(), null == i && n.indexOf("#") >= 0 && (i = !1), t[a ? "replace" : "push"](r, n, {
    shallow: o,
    locale: s,
    scroll: i
  }));
}

function Link$1(e) {
  if ("production" !== process.env.NODE_ENV) {
    var _t15 = function _t15(e) {
      return new Error("Failed prop type: The prop `".concat(e.key, "` expects a ").concat(e.expected, " in `<Link>`, but got `").concat(e.actual, "` instead.") + ("undefined" != typeof window ? "\nOpen your browser's console to view the Component stack trace." : ""));
    };

    var _r15 = {
      href: !0
    };
    Object.keys(_r15).forEach(function (r) {
      if ("href" === r && (null == e[r] || "string" != typeof e[r] && "object" != typeof e[r])) throw _t15({
        key: r,
        expected: "`string` or `object`",
        actual: null === e[r] ? "null" : typeof e[r]
      });
    });
    var _n12 = {
      as: !0,
      replace: !0,
      scroll: !0,
      shallow: !0,
      passHref: !0,
      prefetch: !0,
      locale: !0
    };
    Object.keys(_n12).forEach(function (r) {
      var n = typeof e[r];

      if ("as" === r) {
        if (e[r] && "string" !== n && "object" !== n) throw _t15({
          key: r,
          expected: "`string` or `object`",
          actual: n
        });
      } else if ("locale" === r) {
        if (e[r] && "string" !== n) throw _t15({
          key: r,
          expected: "`string`",
          actual: n
        });
      } else if (("replace" === r || "scroll" === r || "shallow" === r || "passHref" === r || "prefetch" === r) && null != e[r] && "boolean" !== n) throw _t15({
        key: r,
        expected: "`boolean`",
        actual: n
      });
    });

    var _a9 = _react.default.useRef(!1);

    e.prefetch && !_a9.current && (_a9.current = !0, console.warn("Next.js auto-prefetches automatically based on viewport. The prefetch attribute is no longer needed. More: https://nextjs.org/docs/messages/prefetch-true-deprecated"));
  }

  var r = !1 !== e.prefetch,
      n = (0, _router2.useRouter)(),
      _react$default$useMem = _react.default.useMemo(function () {
    var _ref11 = (0, _router.resolveHref)(n, e.href, !0),
        _ref12 = _slicedToArray(_ref11, 2),
        t = _ref12[0],
        r = _ref12[1];

    return {
      href: t,
      as: e.as ? (0, _router.resolveHref)(n, e.as) : r || t
    };
  }, [n, e.href, e.as]),
      a = _react$default$useMem.href,
      o = _react$default$useMem.as;

  var i,
      s = e.children,
      l = e.replace,
      c = e.shallow,
      u = e.scroll,
      d = e.locale;
  if ("string" == typeof s && (s = _react.default.createElement("a", null, s)), "development" === process.env.NODE_ENV) try {
    i = _react.Children.only(s);
  } catch (t) {
    throw new Error("Multiple children were passed to <Link> with `href` of `".concat(e.href, "` but only one child is supported https://nextjs.org/docs/messages/link-multiple-children") + ("undefined" != typeof window ? "\nOpen your browser's console to view the Component stack trace." : ""));
  } else i = _react.Children.only(s);

  var p = i && "object" == typeof i && i.ref,
      _ref13 = (0, _useIntersection.useIntersection)({
    rootMargin: "200px"
  }),
      _ref14 = _slicedToArray(_ref13, 2),
      g = _ref14[0],
      m = _ref14[1],
      f = _react.default.useCallback(function (e) {
    g(e), p && ("function" == typeof p ? p(e) : "object" == typeof p && (p.current = e));
  }, [p, g]);

  (0, _react.useEffect)(function () {
    var e = m && r && (0, _router.isLocalURL)(a),
        t = void 0 !== d ? d : n && n.locale,
        i = prefetched[a + "%" + o + (t ? "%" + t : "")];
    e && !i && prefetch(n, a, o, {
      locale: t
    });
  }, [o, a, m, d, r, n]);
  var h = {
    ref: f,
    onClick: function onClick(e) {
      i.props && "function" == typeof i.props.onClick && i.props.onClick(e), e.defaultPrevented || linkClicked(e, n, a, o, l, c, u, d);
    },
    onMouseEnter: function onMouseEnter(e) {
      (0, _router.isLocalURL)(a) && (i.props && "function" == typeof i.props.onMouseEnter && i.props.onMouseEnter(e), prefetch(n, a, o, {
        priority: !0
      }));
    }
  };

  if (e.passHref || "a" === i.type && !("href" in i.props)) {
    var _e27 = void 0 !== d ? d : n && n.locale,
        _t16 = n && n.isLocaleDomain && (0, _router.getDomainLocale)(o, _e27, n && n.locales, n && n.domainLocales);

    h.href = _t16 || (0, _router.addBasePath)((0, _router.addLocale)(o, _e27, n && n.defaultLocale));
  }

  return _react.default.cloneElement(i, h);
}

var _default$2 = Link$1;
link$1.default = _default$2;

var link = link$1,
    Link = function Link(e) {
  var t,
      r = e.href,
      n = e.link,
      a = e.children,
      o = e.component,
      i = e.sx,
      s = __rest$1(e, ["href", "link", "children", "component", "sx"]),
      l = _assign$({
    sx: _assign$({
      cursor: "pointer",
      textDecoration: "none"
    }, i),
    component: null != o ? o : "a"
  }, s),
      c = null != r ? r : null !== (t = null == n ? void 0 : n.url) && void 0 !== t ? t : "";

  return void 0 === r && void 0 === n ? jsx$1(Link$2, _assign$({}, l, {
    children: a
  })) : c.startsWith("/") ? jsx$1(link, _assign$({
    href: "/[[...slug]]",
    as: c
  }, {
    children: jsx$1(Link$2, _assign$({}, l, {
      children: a
    }))
  })) : "boolean" == typeof (null == n ? void 0 : n.newTab) && (null == n ? void 0 : n.newTab) ? jsx$1(Link$2, _assign$({}, l, {
    href: c,
    target: "_blank",
    rel: "noopener noreferrer"
  }, {
    children: a
  })) : jsx$1(Link$2, _assign$({}, l, {
    href: c,
    target: "_self"
  }, {
    children: a
  }));
},
    SvgIcon$1 = function SvgIcon$1(e) {
  var t,
      r = e.component,
      n = e.pathColor,
      a = e.sx,
      o = __rest$1(e, ["component", "pathColor", "sx"]);

  return jsx$1(SvgIcon$2, _assign$({}, o, {
    styleProps: {
      pathColor: n
    },
    component: r,
    sx: _assign$((t = {}, t["&.".concat(svgIconClasses.root, " path")] = {
      fill: n
    }, t), a)
  }));
},
    replace = "".replace,
    es = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34);/g,
    unes = {
  "&amp;": "&",
  "&#38;": "&",
  "&lt;": "<",
  "&#60;": "<",
  "&gt;": ">",
  "&#62;": ">",
  "&apos;": "'",
  "&#39;": "'",
  "&quot;": '"',
  "&#34;": '"'
};

function unescape(e) {
  return replace.call(e, es, cape);
}

function cape(e) {
  return unes[e];
}

var copyObject = _copyObject,
    createAssigner = _createAssigner,
    keysIn = keysIn_1,
    assignInWith$1 = createAssigner(function (e, t, r, n) {
  copyObject(t, keysIn(t), e, n);
}),
    assignInWith_1 = assignInWith$1,
    baseGetTag$1 = _baseGetTag,
    isObjectLike$1 = isObjectLike_1,
    isPlainObject$1 = isPlainObject_1,
    domExcTag = "[object DOMException]",
    errorTag = "[object Error]";

function isError$2(e) {
  if (!isObjectLike$1(e)) return !1;
  var t = baseGetTag$1(e);
  return t == errorTag || t == domExcTag || "string" == typeof e.message && "string" == typeof e.name && !isPlainObject$1(e);
}

var isError_1 = isError$2,
    apply = _apply,
    baseRest = _baseRest,
    isError$1 = isError_1,
    attempt$1 = baseRest(function (e, t) {
  try {
    return apply(e, void 0, t);
  } catch (e) {
    return isError$1(e) ? e : new Error(e);
  }
}),
    attempt_1 = attempt$1;

function arrayMap$2(e, t) {
  for (var r = -1, n = null == e ? 0 : e.length, a = Array(n); ++r < n;) {
    a[r] = t(e[r], r, e);
  }

  return a;
}

var _arrayMap = arrayMap$2,
    arrayMap$1 = _arrayMap;

function baseValues$1(e, t) {
  return arrayMap$1(t, function (t) {
    return e[t];
  });
}

var _baseValues = baseValues$1,
    eq = eq_1,
    objectProto$2 = Object.prototype,
    hasOwnProperty$4 = objectProto$2.hasOwnProperty;

function customDefaultsAssignIn$1(e, t, r, n) {
  return void 0 === e || eq(e, objectProto$2[r]) && !hasOwnProperty$4.call(n, r) ? t : e;
}

var _customDefaultsAssignIn = customDefaultsAssignIn$1,
    stringEscapes = {
  "\\": "\\",
  "'": "'",
  "\n": "n",
  "\r": "r",
  "\u2028": "u2028",
  "\u2029": "u2029"
};

function escapeStringChar$1(e) {
  return "\\" + stringEscapes[e];
}

var _escapeStringChar = escapeStringChar$1,
    overArg = _overArg,
    nativeKeys$1 = overArg(Object.keys, Object),
    _nativeKeys = nativeKeys$1,
    isPrototype = _isPrototype,
    nativeKeys = _nativeKeys,
    objectProto$1 = Object.prototype,
    hasOwnProperty$3 = objectProto$1.hasOwnProperty;

function baseKeys$1(e) {
  if (!isPrototype(e)) return nativeKeys(e);
  var t = [];

  for (var r in Object(e)) {
    hasOwnProperty$3.call(e, r) && "constructor" != r && t.push(r);
  }

  return t;
}

var _baseKeys = baseKeys$1,
    arrayLikeKeys = _arrayLikeKeys,
    baseKeys = _baseKeys,
    isArrayLike = isArrayLike_1;

function keys$1(e) {
  return isArrayLike(e) ? arrayLikeKeys(e) : baseKeys(e);
}

var keys_1 = keys$1,
    reInterpolate$2 = /<%=([\s\S]+?)%>/g,
    _reInterpolate = reInterpolate$2;

function basePropertyOf$1(e) {
  return function (t) {
    return null == e ? void 0 : e[t];
  };
}

var _basePropertyOf = basePropertyOf$1,
    basePropertyOf = _basePropertyOf,
    htmlEscapes = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;"
},
    escapeHtmlChar$1 = basePropertyOf(htmlEscapes),
    _escapeHtmlChar = escapeHtmlChar$1,
    baseGetTag = _baseGetTag,
    isObjectLike = isObjectLike_1,
    symbolTag = "[object Symbol]";

function isSymbol$1(e) {
  return "symbol" == typeof e || isObjectLike(e) && baseGetTag(e) == symbolTag;
}

var isSymbol_1 = isSymbol$1,
    Symbol$1 = _Symbol,
    arrayMap = _arrayMap,
    isArray = isArray_1,
    isSymbol = isSymbol_1,
    INFINITY = 1 / 0,
    symbolProto = Symbol$1 ? Symbol$1.prototype : void 0,
    symbolToString = symbolProto ? symbolProto.toString : void 0;

function baseToString$1(e) {
  if ("string" == typeof e) return e;
  if (isArray(e)) return arrayMap(e, baseToString$1) + "";
  if (isSymbol(e)) return symbolToString ? symbolToString.call(e) : "";
  var t = e + "";
  return "0" == t && 1 / e == -INFINITY ? "-0" : t;
}

var _baseToString = baseToString$1,
    baseToString = _baseToString;

function toString$2(e) {
  return null == e ? "" : baseToString(e);
}

var toString_1 = toString$2,
    escapeHtmlChar = _escapeHtmlChar,
    toString$1 = toString_1,
    reUnescapedHtml = /[&<>"']/g,
    reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

function escape$1(e) {
  return (e = toString$1(e)) && reHasUnescapedHtml.test(e) ? e.replace(reUnescapedHtml, escapeHtmlChar) : e;
}

var _escape = escape$1,
    reEscape$1 = /<%-([\s\S]+?)%>/g,
    _reEscape = reEscape$1,
    reEvaluate$1 = /<%([\s\S]+?)%>/g,
    _reEvaluate = reEvaluate$1,
    escape = _escape,
    reEscape = _reEscape,
    reEvaluate = _reEvaluate,
    reInterpolate$1 = _reInterpolate,
    templateSettings$1 = {
  escape: reEscape,
  evaluate: reEvaluate,
  interpolate: reInterpolate$1,
  variable: "",
  imports: {
    _: {
      escape: escape
    }
  }
},
    templateSettings_1 = templateSettings$1,
    assignInWith = assignInWith_1,
    attempt = attempt_1,
    baseValues = _baseValues,
    customDefaultsAssignIn = _customDefaultsAssignIn,
    escapeStringChar = _escapeStringChar,
    isError = isError_1,
    isIterateeCall = _isIterateeCall,
    keys = keys_1,
    reInterpolate = _reInterpolate,
    templateSettings = templateSettings_1,
    toString = toString_1,
    INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`",
    reEmptyStringLeading = /\b__p \+= '';/g,
    reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
    reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g,
    reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/,
    reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g,
    reNoMatch = /($^)/,
    reUnescapedString = /['\n\r\u2028\u2029\\]/g,
    objectProto = Object.prototype,
    hasOwnProperty$2 = objectProto.hasOwnProperty;

function template(e, t, r) {
  var n = templateSettings.imports._.templateSettings || templateSettings;
  r && isIterateeCall(e, t, r) && (t = void 0), e = toString(e), t = assignInWith({}, t, n, customDefaultsAssignIn);
  var a,
      o,
      i = assignInWith({}, t.imports, n.imports, customDefaultsAssignIn),
      s = keys(i),
      l = baseValues(i, s),
      c = 0,
      u = t.interpolate || reNoMatch,
      d = "__p += '",
      p = RegExp((t.escape || reNoMatch).source + "|" + u.source + "|" + (u === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (t.evaluate || reNoMatch).source + "|$", "g"),
      g = hasOwnProperty$2.call(t, "sourceURL") ? "//# sourceURL=" + (t.sourceURL + "").replace(/\s/g, " ") + "\n" : "";
  e.replace(p, function (t, r, n, i, s, l) {
    return n || (n = i), d += e.slice(c, l).replace(reUnescapedString, escapeStringChar), r && (a = !0, d += "' +\n__e(" + r + ") +\n'"), s && (o = !0, d += "';\n" + s + ";\n__p += '"), n && (d += "' +\n((__t = (" + n + ")) == null ? '' : __t) +\n'"), c = l + t.length, t;
  }), d += "';\n";
  var m = hasOwnProperty$2.call(t, "variable") && t.variable;

  if (m) {
    if (reForbiddenIdentifierChars.test(m)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
  } else d = "with (obj) {\n" + d + "\n}\n";

  d = (o ? d.replace(reEmptyStringLeading, "") : d).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;"), d = "function(" + (m || "obj") + ") {\n" + (m ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (a ? ", __e = _.escape" : "") + (o ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + d + "return __p\n}";
  var f = attempt(function () {
    return Function(s, g + "return " + d).apply(void 0, l);
  });
  if (f.source = d, isError(f)) throw f;
  return f;
}

var template_1 = template,
    RichText = function RichText(e) {
  var t = e.removeLineBreaksInSmallerScreen,
      r = void 0 === t || t,
      n = e.template,
      a = e.children,
      o = useTheme$4(),
      i = useMediaQuery(o.breakpoints.down("md"));
  if (null == a) return null;

  try {
    var s = unescape(a);
    if (r && i && (s = s.split("<br>").join(" ").split("</br>").join(" ").split("<br/>").join(" ")), s = s.replaceAll("&lt;%", "<%").replaceAll("%&gt;", "%>"), null != n) s = template_1(s)(n);
    var l = JSON.parse(s);
    if (null == l || null == (null == l ? void 0 : l.blocks)) return null;
    var c = l.blocks.map(function (e, t) {
      return EditorJsDataParser(e, t);
    });
    return c;
  } catch (e) {
    return null;
  }
},
    Feature;

!function (e) {
  e.Booking = "booking", e.ContactHub = "contact-hub", e.EmailCampaign = "email-campaign", e.Invoices = "invoices", e.Messenger = "messenger", e.Payment = "payment", e.Placement = "placement", e.Reviews = "reviews", e.SitesPage = "sites";
}(Feature || (Feature = {}));
var projectName = "GoSite",
    Section,
    FormType,
    FormSubmitStatus;
!function (e) {
  e.Form = "sections.form", e.Hero = "sections.hero", e.HeroBooking = "sections.hero-booking", e.FeatureColumnsGroup = "sections.feature-columns-group", e.FeatureRowsGroup = "sections.feature-rows-group", e.ProductCta = "sections.product-cta", e.DownloadMobileApp = "sections.download-mobile-app", e.FeatureWide = "sections.feature-wide", e.Testimonial = "sections.testimonial";
}(Section || (Section = {})), function (e) {
  e.CustomForm = "forms.custom-form", e.PublicSignupForm = "forms.public-signup-form";
}(FormType || (FormType = {})), function (e) {
  e.Success = "success", e.Failure = "failure", e.Loading = "loading", e.Idle = "idle";
}(FormSubmitStatus || (FormSubmitStatus = {}));

var MEDIA_FORMATS = {
  IMAGES: ["png", "jpg", "jpeg", "giff", "svg", "tiff", "ico", "dvu", "webp"],
  VIDEOS: ["mpeg", "mp4", "mov", "qt", "wmv", "avi", "flv"],
  AUDIOS: ["mp3", "wav"],
  FILES: ["csv", "zip", "pdf", "excel", "json"]
},
    HERO_WIDGET_ANIMATION_CONFIG = {
  from: {
    opacity: 0,
    marginTop: 0,
    transform: "perspective(900px) rotateY(90deg)"
  },
  enter: {
    opacity: 1,
    marginTop: 0,
    transform: "perspective(900px) rotateY(0deg)"
  },
  leave: {
    opacity: 0,
    marginTop: -2e3
  },
  delay: 0,
  config: {
    mass: 15,
    tension: 300,
    friction: 60
  }
},
    HERO_CTA_CONFIG = {
  from: {
    opacity: 0,
    marginTop: -100,
    top: 0
  },
  enter: {
    opacity: 1,
    marginTop: 0,
    top: 0
  },
  leave: {
    opacity: 0,
    marginTop: 0,
    top: 500
  },
  delay: 0,
  config: config$1.gentle
},
    HERO_WIDGET_INTERACTION_RESULT_ANIMATION_CONFIG = {
  from: {
    opacity: 0,
    marginBottom: -100,
    left: "auto"
  },
  enter: {
    opacity: 1,
    marginBottom: 0,
    left: "auto"
  },
  leave: {
    opacity: 0,
    marginBottom: 200,
    left: -1e4
  },
  delay: 400,
  config: config$1.wobbly
},
    HERO_SIGN_UP_FORM_ANIMATION_CONFIG = {
  from: {
    opacity: 0,
    marginBottom: -100
  },
  enter: {
    opacity: 1,
    marginBottom: 0
  },
  leave: {
    opacity: 0,
    marginBottom: 200
  },
  delay: 500,
  config: config$1.wobbly
},
    HERO_CTA_BUTTON_ANIMATION_CONFIG = {
  from: {
    opacity: 0
  },
  enter: {
    opacity: 1
  },
  leave: {
    opacity: 0
  },
  delay: 500,
  config: config$1.molasses
},
    MESSENGER_CHAT_BUBBLE_ANIMATION_CONFIG = {
  config: {
    duration: 4e3
  },
  from: {
    opacity: 0
  },
  to: {
    opacity: 1
  },
  enter: {
    opacity: 1
  },
  leave: {
    opacity: 0
  },
  delay: 100
},
    SITES_PAGE_DATA = {
  sections: [{
    __component: "sites-header",
    logotext: "Greener Lawn and Garden",
    menuList: [{
      id: 1,
      text: "ABOUT"
    }, {
      id: 2,
      text: "SERVICES"
    }, {
      id: 3,
      text: "REVIEWS"
    }, {
      id: 4,
      text: "CONTACT US"
    }, {
      id: 5,
      text: "FAQ"
    }]
  }, {
    __component: "sites-hero",
    id: 1,
    title: "Lawn and Garden",
    description: "- Lawn Architect -",
    edit: !0,
    ctaButton: [{
      id: 1,
      text: "OUR SERVICES",
      icon: "/images/gosite-sites-services.svg",
      alt: "our-services",
      variant: "contained"
    }, {
      id: 2,
      text: "BOOK NOW",
      icon: "/images/gosite-sites-book-now.svg",
      alt: "book-now",
      variant: "outlined"
    }],
    heroBgImage: {
      url: "/images/Image.png",
      alternativeText: "string",
      width: 50,
      height: 50,
      ext: "string"
    }
  }, {
    __component: "sites-services",
    id: 1,
    title: "SERVICES",
    description: "We’re here for your landscaping needs",
    serviceList: [{
      id: 1,
      text: "Service name"
    }, {
      id: 2,
      text: "This is what a 2-line service name would look like. It would drop to a second line"
    }, {
      id: 3,
      text: "An example of a longer service name"
    }, {
      id: 4,
      text: "An example of a longer service name"
    }]
  }, {
    __component: "sites-about-us",
    id: 1,
    title: "ABOUT US",
    description: "We provide the best lawn architect service in Denver since 2003.",
    aboutUs: [{
      id: 1,
      icon: "/images/gosite-sites-union-1.svg",
      title: "We accept these payment types:",
      description: [{
        id: 1,
        text: "Credit cards"
      }, {
        id: 2,
        text: "Cheques"
      }]
    }, {
      id: 2,
      icon: "/images/gosite-sites-union-2.svg",
      title: "We're 8 year in business!",
      description: []
    }, {
      id: 3,
      icon: "/images/gosite-sites-location.svg",
      title: "We service these areas:",
      description: [{
        id: 1,
        text: "Manhattan"
      }, {
        id: 2,
        text: "Brooklyn"
      }, {
        id: 3,
        text: "Bronx"
      }]
    }]
  }, {
    __component: "sites-reviews",
    id: 1,
    title: "REVIEWS",
    description: "Our Customer love us!",
    imageList: [{
      id: 1,
      image: "/images/gosite-sites-carousal-4.svg"
    }, {
      id: 2,
      image: "/images/gosite-sites-carousal-3.svg"
    }, {
      id: 3,
      image: "/images/gosite-sites-carousal-2.svg"
    }, {
      id: 4,
      image: "/images/gosite-sites-carousal-1.svg"
    }, {
      id: 5,
      image: "/images/gosite-sites-carousal-3.svg"
    }],
    customerReviews: [{
      id: 1,
      text: "Aaron was super responsive and got me and my job scheduled quickly. He was on time, kept the area",
      rating: 5,
      customerName: "Arnold K",
      date: "Feb 2021"
    }, {
      id: 2,
      text: "Aaron was amazing! There’s nothing better than working with a small business owner who truly",
      rating: 5,
      customerName: "Cindy A",
      date: "Feb 2021"
    }, {
      id: 3,
      text: "Aaron did a great job for us. He responded almost immediately and was very flexible to work with our",
      rating: 5,
      customerName: "Roger N",
      date: "Feb 2021"
    }, {
      id: 4,
      text: "Aaron was super responsive and got me and my job scheduled quickly. He was on time, kept the area",
      rating: 5,
      customerName: "Roger N",
      date: "Feb 2021"
    }, {
      id: 5,
      text: "Aaron did a great job for us. He responded almost immediately and was very flexible to work with our clients and dash",
      rating: 5,
      customerName: "Roger N",
      date: "Feb 2021"
    }]
  }, {
    __component: "sites-contact-us",
    id: 1,
    title: "CONTACT",
    description: "Lets Chat!",
    chatDescription: "Lorem ipsum start a chat with us and if we’re not around to respond we’ll followup via email",
    startChatButtonText: "START CHAT",
    contactDetail: [{
      id: 1,
      label: "PHONE",
      text: "(310) 593-8300",
      chipText: null
    }, {
      id: 2,
      label: "ADDRESS",
      text: "395 Santa Monica Pl, Ste 172,Santa Monica, CA 90401",
      chipText: null
    }, {
      id: 3,
      label: "OPERATING HOURS",
      chipText: "CLOSED",
      operatingHours: [{
        id: 1,
        day: "Monday",
        time: "11 AM - 12 PM \n 2 PM - 4 PM",
        highlightWorkingday: !1
      }, {
        id: 2,
        day: "Tuesday",
        time: "10 AM - 10 PM",
        highlightWorkingday: !1
      }, {
        id: 3,
        day: "Wednesday",
        time: "11 AM - 10 PM",
        highlightWorkingday: !0
      }, {
        id: 4,
        day: "Thursday",
        time: "12 PM - 9 PM",
        highlightWorkingday: !1
      }, {
        id: 5,
        day: "Friday",
        time: "12.30 PM - 6.30 PM",
        highlightWorkingday: !1
      }, {
        id: 6,
        day: "Saturday",
        time: "Closed",
        highlightWorkingday: !1
      }, {
        id: 7,
        day: "Sunday",
        time: "Closed",
        highlightWorkingday: !1
      }]
    }]
  }, {
    __component: "sites-footer",
    id: 1,
    text: [{
      id: 1,
      text: "© Copyright YOUR COMPANY NAME HERE"
    }, {
      id: 2,
      text: "Website by Gosite"
    }]
  }]
},
    getComponentClassNamesObject = function getComponentClassNamesObject(e) {
  for (var t = [], r = 1; r < arguments.length; r++) {
    t[r - 1] = arguments[r];
  }

  var n = {};
  return t.forEach(function (t) {
    var r;
    n = _assign$(_assign$({}, n), ((r = {})[t] = "".concat(projectName).concat(e, "-").concat(t), r));
  }), n;
},
    textClasses = getComponentClassNamesObject("Text", "root", "rich"),
    heroMainClasses = getComponentClassNamesObject("HeroMain", "title", "description", "foregroundMedia"),
    heroBusinessClasses = getComponentClassNamesObject("HeroBusinessSearchResult", "title", "description", "notes"),
    headerClasses = getComponentClassNamesObject("Header", "root", "logo", "navbarLinks", "buttonLinks", "buttonLink"),
    heroClasses = getComponentClassNamesObject("Hero", "title", "description", "foregroundMedia", "mediaWidget"),
    featureColumnsGroupClasses = getComponentClassNamesObject("FeatureColumnsGroup", "root", "title", "description", "items", "item"),
    featureColumnClasses = getComponentClassNamesObject("FeatureColumn", "root", "title", "description"),
    featureRowBodyClasses = getComponentClassNamesObject("FeatureRowBody", "root", "title", "description", "media", "content", "valuePropositionTitle", "valuePropositionDescription"),
    productCTAClasses = getComponentClassNamesObject("ProductCTA", "root", "title", "subtitle", "description", "media", "content"),
    testimonial3Classes = getComponentClassNamesObject("Testimonial3", "root", "topBannerText"),
    testimonialTabItemClasses = getComponentClassNamesObject("TestimonialTabItem", "root", "content", "media", "quote", "company", "companyLogo", "author"),
    downloadMobileAppClasses = getComponentClassNamesObject("DownloadMobileApp", "root", "agreementText", "media", "title"),
    featureOverviewClasses = getComponentClassNamesObject("FeatureOverview", "root", "title", "description"),
    testimonialColumnsGroupClasses = getComponentClassNamesObject("TestimonialColumnsGroup", "root", "title", "description", "quote", "company", "companyLogo", "author"),
    testimonial2Classes = getComponentClassNamesObject("Testimonial2", "root", "content", "quote", "company", "author"),
    heroCTAClasses = getComponentClassNamesObject("HeroCTA", "root", "title"),
    engagementEmailBodyClasses = getComponentClassNamesObject("EngagementEmailBody", "root", "title", "description", "ctaText", "businessName"),
    messengerEmailConfirmationClasses = getComponentClassNamesObject("MessengerEmailConfirmation", "root", "emailContent"),
    reviewEmailConfirmationClasses = getComponentClassNamesObject("ReviewEmailConfirmation", "root", "emailContent"),
    tabPanelItemClasses = getComponentClassNamesObject("TabPanelItemClasses", "root", "title", "content"),
    tabPanelViewClasses = getComponentClassNamesObject("TabPanelViewClasses", "root", "title"),
    articleClasses = getComponentClassNamesObject("Article", "root", "title", "description", "content", "media"),
    articleColumnsGroupClasses = getComponentClassNamesObject("ArticleColumnsGroup", "root", "title", "description", "columns", "column"),
    pricingPlanClasses = getComponentClassNamesObject("PricingPlan", "root", "body", "popular", "popularPlanTag", "title", "subtitle", "description", "price", "buttons", "productTitle", "optionalProducts", "product", "footerContent", "includedProducts", "optionalProductsTitle", "includedProductsTitle", "noPrice"),
    mediaCarouselClasses = getComponentClassNamesObject("MediaCarousel", "root", "title", "description", "media"),
    pricingTableClasses = getComponentClassNamesObject("PricingTable", "root", "title"),
    appLinkNotificationBannerClasess = getComponentClassNamesObject("AppLinkNotificationBanner", "root", "logo", "title", "description", "rating", "buttons", "button", "textButton", "imageButton"),
    accordianGroupClasses = getComponentClassNamesObject("AccordianGroup", "root", "title", "items"),
    accordianGroupItemClasses = getComponentClassNamesObject("AccordianGroupItem", "root", "title", "description"),
    Text = function Text(e) {
  var t = e.rich,
      r = void 0 !== t && t,
      n = e.sx,
      a = e.component,
      o = void 0 === a ? "div" : a,
      i = e.children,
      s = e.template,
      l = e.className,
      c = __rest$1(e, ["rich", "sx", "component", "children", "template", "className"]),
      u = useTheme$4(),
      d = null != l && "" !== l ? "".concat(l, " ") : "";

  return d = d.concat(" ", textClasses.root), r && null != i && "string" == typeof i ? (d = d.concat(" ", textClasses.rich), jsx$1(Typography$2, _assign$({
    component: o,
    className: d,
    sx: _assign$({
      "& > *": {
        margin: 0,
        padding: 0
      },
      "& h1": u.typography.h1,
      "& h2": u.typography.h2,
      "& h3": u.typography.h3,
      "& h4": u.typography.h4,
      "& h5": u.typography.h5,
      "& h6": u.typography.h6,
      "& p": u.typography.body1
    }, n)
  }, c, {
    children: jsx$1(RichText, _assign$({
      template: s
    }, {
      children: i
    }))
  }))) : jsx$1(Typography$2, _assign$({}, c, {
    className: d,
    component: o,
    sx: n
  }, {
    children: i
  }));
},
    ToggleButtonGroup = function ToggleButtonGroup(e) {
  var t = useState(e.value),
      r = t[0],
      n = t[1],
      a = useState({
    width: 0,
    left: 0
  }),
      o = a[0],
      i = a[1],
      s = useRef(null),
      l = _assign$(_assign$({}, e), {
    onChange: function onChange(t, r) {
      null != e.onChange && null != r && (n(r), null == e || e.onChange(t, r));
    }
  });

  return useEffect(function () {
    null != e.value && n(e.value);
  }, [e.value]), useEffect(function () {
    if (null != s.current) {
      var e = s.current.querySelectorAll("[value=".concat(r, "]"))[0];
      i({
        width: null == e ? void 0 : e.clientWidth,
        left: (null == e ? void 0 : e.getBoundingClientRect().left) - s.current.getBoundingClientRect().left
      });
    }
  }, [r]), "pill" === e.variant ? jsxs(PillToggleButtonGroupRoot, _assign$({
    sx: e.rootSx,
    className: "".concat(null != e.className ? e.className + " " : "", "GoSitePillToggleButtonGroup-root")
  }, {
    children: [jsx$1(PillToggleButtonGroup, _assign$({
      ref: s
    }, l, {
      value: r,
      className: "".concat(null != e.className ? e.className + " " : "", "GoSiteToggleButtonGroup-pill")
    })), jsx$1(SelectionIndicator, {
      sx: _assign$(_assign$({}, o), {
        width: o.width + 2
      })
    })]
  })) : jsx$1(ToggleButtonGroup$1, _assign$({}, l));
},
    PillToggleButtonGroupRoot = styled$2("div")(function (e) {
  return e.theme, {
    display: "inline-block",
    position: "relative"
  };
}),
    SelectionIndicator = styled$2(Box)(function (e) {
  return {
    backgroundColor: e.theme.palette.primary.main,
    borderRadius: "500px !important",
    position: "absolute",
    left: 5,
    top: 5,
    right: 5,
    bottom: 5,
    transition: "all 0.2s ease-in-out",
    width: "106px"
  };
}),
    PillToggleButtonGroup = styled$2(ToggleButtonGroup$1)(function (e) {
  var t,
      r = e.theme;
  return (t = {
    border: "2px solid ".concat(r.palette.primary.main),
    borderRadius: 500,
    position: "relative",
    padding: 4,
    zIndex: 1
  })["& .".concat(toggleButtonClasses.root)] = {
    borderColor: "transparent",
    color: r.palette.primary.main
  }, t["& .".concat(toggleButtonClasses.root, ":not(.").concat(toggleButtonClasses.selected, "):hover")] = {
    borderRadius: "500px !important"
  }, t["& .".concat(toggleButtonClasses.selected, ":hover")] = {
    backgroundColor: "transparent"
  }, t["& .".concat(toggleButtonClasses.selected)] = {
    backgroundColor: r.palette.primary.main,
    borderRadius: "500px !important",
    color: r.palette.primary.contrastText,
    "& .MuiChip-root": {
      color: r.palette.primary.main,
      backgroundColor: "#E6EEFF"
    },
    "& .MuiTypography-root": {
      color: "#fff"
    }
  }, t;
}),
    css_248z = "/* https://codepen.io/designcouch/pen/Atyop */\n/* Icon 1 */\n\n.GoSiteAnimatedMenuIcon-root {\n  width: 23px;\n  height: 21px;\n  position: relative;\n  /* margin: 50px auto; */\n  transform: rotate(0deg);\n  transition: .5s ease-in-out;\n  cursor: pointer;\n}\n\n.GoSiteAnimatedMenuIcon-root span {\n  display: block;\n  position: absolute;\n  height: 3px;\n  background: #082244;\n  opacity: 1;\n  transform: rotate(0deg);\n  transition: .25s ease-in-out;\n}\n\n.GoSiteAnimatedMenuIcon-variant1 span, .GoSiteAnimatedMenuIcon-variant3 span, .GoSiteAnimatedMenuIcon-variant4 span {\n  width: 100%;\n  border-radius: 3px;\n  left: 0;\n}\n\n.GoSiteAnimatedMenuIcon-variant1 span:nth-child(1) {\n  top: 0px;\n}\n\n.GoSiteAnimatedMenuIcon-variant1 span:nth-child(2) {\n  top: 8px;\n}\n\n.GoSiteAnimatedMenuIcon-variant1 span:nth-child(3) {\n  top: 16px;\n}\n\n.GoSiteAnimatedMenuIcon-variant1.GoSiteAnimatedMenuIcon-open span:nth-child(1) {\n  top: 8px;\n  transform: rotate(135deg);\n}\n\n.GoSiteAnimatedMenuIcon-variant1.GoSiteAnimatedMenuIcon-open span:nth-child(2) {\n  opacity: 0;\n  left: -60px;\n}\n\n.GoSiteAnimatedMenuIcon-variant1.GoSiteAnimatedMenuIcon-open span:nth-child(3) {\n  top: 8px;\n  transform: rotate(-135deg);\n}\n\n/* Icon 2 */\n\n.GoSiteAnimatedMenuIcon-variant2 {\n}\n\n.GoSiteAnimatedMenuIcon-variant2 span {\n  width: 50%;\n}\n\n.GoSiteAnimatedMenuIcon-variant2 span:nth-child(even) {\n  left: 50%;\n  border-radius: 0 3px 3px 0;\n}\n\n.GoSiteAnimatedMenuIcon-variant2 span:nth-child(odd) {\n  left:0px;\n  border-radius: 3px 0 0 3px;\n}\n\n.GoSiteAnimatedMenuIcon-variant2 span:nth-child(1), .GoSiteAnimatedMenuIcon-variant2 span:nth-child(2) {\n  top: 0px;\n}\n\n.GoSiteAnimatedMenuIcon-variant2 span:nth-child(3), .GoSiteAnimatedMenuIcon-variant2 span:nth-child(4) {\n  top: 8px;\n}\n\n.GoSiteAnimatedMenuIcon-variant2 span:nth-child(5), .GoSiteAnimatedMenuIcon-variant2 span:nth-child(6) {\n  top: 16px;\n}\n\n.GoSiteAnimatedMenuIcon-variant2.GoSiteAnimatedMenuIcon-open span:nth-child(1),.GoSiteAnimatedMenuIcon-variant2.GoSiteAnimatedMenuIcon-open span:nth-child(6) {\n  transform: rotate(45deg);\n}\n\n.GoSiteAnimatedMenuIcon-variant2.GoSiteAnimatedMenuIcon-open span:nth-child(2),.GoSiteAnimatedMenuIcon-variant2.GoSiteAnimatedMenuIcon-open span:nth-child(5) {\n  transform: rotate(-45deg);\n}\n\n.GoSiteAnimatedMenuIcon-variant2.GoSiteAnimatedMenuIcon-open span:nth-child(1) {\n  left: 5px;\n  top: 7px;\n}\n\n.GoSiteAnimatedMenuIcon-variant2.GoSiteAnimatedMenuIcon-open span:nth-child(2) {\n  left: calc(50% - 5px);\n  top: 7px;\n}\n\n.GoSiteAnimatedMenuIcon-variant2.GoSiteAnimatedMenuIcon-open span:nth-child(3) {\n  left: -50%;\n  opacity: 0;\n}\n\n.GoSiteAnimatedMenuIcon-variant2.GoSiteAnimatedMenuIcon-open span:nth-child(4) {\n  left: 100%;\n  opacity: 0;\n}\n\n.GoSiteAnimatedMenuIcon-variant2.GoSiteAnimatedMenuIcon-open span:nth-child(5) {\n  left: 5px;\n  top: 10px;\n}\n\n.GoSiteAnimatedMenuIcon-variant2.GoSiteAnimatedMenuIcon-open span:nth-child(6) {\n  left: calc(50% - 5px);\n  top: 10px;\n}\n\n/* Icon 3 */\n\n.GoSiteAnimatedMenuIcon-variant3 span:nth-child(1) {\n  top: 0px;\n}\n\n.GoSiteAnimatedMenuIcon-variant3 span:nth-child(2),.GoSiteAnimatedMenuIcon-variant3 span:nth-child(3) {\n  top: 8px;\n}\n\n.GoSiteAnimatedMenuIcon-variant3 span:nth-child(4) {\n  top: 16px;\n}\n\n.GoSiteAnimatedMenuIcon-variant3.GoSiteAnimatedMenuIcon-open span:nth-child(1) {\n  top: 8px;\n  width: 0%;\n  left: 50%;\n}\n\n.GoSiteAnimatedMenuIcon-variant3.GoSiteAnimatedMenuIcon-open span:nth-child(2) {\n  transform: rotate(45deg);\n}\n\n.GoSiteAnimatedMenuIcon-variant3.GoSiteAnimatedMenuIcon-open span:nth-child(3) {\n  transform: rotate(-45deg);\n}\n\n.GoSiteAnimatedMenuIcon-variant3.GoSiteAnimatedMenuIcon-open span:nth-child(4) {\n  top: 8px;\n  width: 0%;\n  left: 50%;\n}\n\n/* Icon 4 */\n\n.GoSiteAnimatedMenuIcon-variant4 {\n}\n\n.GoSiteAnimatedMenuIcon-variant4 span:nth-child(1) {\n  top: 0px;\n  transform-origin: left center;\n}\n\n.GoSiteAnimatedMenuIcon-variant4 span:nth-child(2) {\n  top: 8px;\n  transform-origin: left center;\n}\n\n.GoSiteAnimatedMenuIcon-variant4 span:nth-child(3) {\n  top: 16px;\n  transform-origin: left center;\n}\n\n.GoSiteAnimatedMenuIcon-variant4.GoSiteAnimatedMenuIcon-open span:nth-child(1) {\n  transform: rotate(45deg);\n  top: -3px;\n  left: 8px;\n}\n\n.GoSiteAnimatedMenuIcon-variant4.GoSiteAnimatedMenuIcon-open span:nth-child(2) {\n  width: 0%;\n  opacity: 0;\n}\n\n.GoSiteAnimatedMenuIcon-variant4.GoSiteAnimatedMenuIcon-open span:nth-child(3) {\n  transform: rotate(-45deg);\n  top: 33px;\n  left: 8px;\n}\n\n.css-52oi9o {\n  color: '#ff0000'\n}";

styleInject(css_248z);

var AnimatedMenuIcon = function AnimatedMenuIcon(e) {
  var t = e.open,
      r = void 0 !== t && t,
      n = e.variant,
      a = void 0 === n ? 1 : n,
      o = __rest$1(e, ["open", "variant"]),
      i = "".concat(animatedMenuIconClasses.root, " ").concat(componentVariantClassName).concat(null != a ? a : 2),
      s = "".concat(i, " ").concat(animatedMenuIconClasses.closed),
      l = "".concat(i, " ").concat(animatedMenuIconClasses.open);

  return jsx$1(Box, _assign$({}, o, {
    className: r ? l : s,
    sx: _assign$(_assign$({}, o.sx), {
      "& span": {
        backgroundColor: o.color
      }
    })
  }, {
    children: function () {
      switch (a) {
        case 2:
          return jsxs(Fragment, {
            children: [jsx$1("span", {}), jsx$1("span", {}), jsx$1("span", {}), jsx$1("span", {}), jsx$1("span", {}), jsx$1("span", {})]
          });

        case 3:
          return jsxs(Fragment, {
            children: [jsx$1("span", {}), jsx$1("span", {}), jsx$1("span", {}), jsx$1("span", {})]
          });

        default:
          return jsxs(Fragment, {
            children: [jsx$1("span", {}), jsx$1("span", {}), jsx$1("span", {})]
          });
      }
    }()
  }));
},
    componentClassNamePrefix = "GoSiteAnimatedMenuIcon-",
    componentVariantClassName = "".concat(componentClassNamePrefix, "variant"),
    animatedMenuIconClasses = {
  root: "".concat(componentClassNamePrefix, "root"),
  open: "".concat(componentClassNamePrefix, "open"),
  closed: "".concat(componentClassNamePrefix, "closed")
},
    AudioVisualizers = React__default.forwardRef(function (e, t) {
  var r,
      n,
      a,
      o,
      i,
      s = e.imageFile,
      l = e.songFile,
      c = e.onClick,
      u = useState(!1),
      d = u[0],
      p = u[1],
      g = useState(!1),
      m = g[0],
      f = g[1],
      h = useState(!1),
      b = h[0],
      y = h[1];
  useEffect(function () {
    p(!0), setTimeout(function () {
      _();
    }, 2e3);
  }, [d]);

  var v = function v(e) {
    return [e % 3600 / 60, e % 60].map(function (e) {
      return "0".concat(Math.floor(e)).slice(-2);
    }).join(":");
  },
      _ = function _() {
    for (var e = document.querySelectorAll("audio"), t = document.getElementsByClassName("outer-ring"), r = function r(_r16) {
      if (null === e || isNaN(e["".concat(_r16)].duration)) t["".concat(_r16)].innerHTML = "m:s", setTimeout(function () {
        var e = document.querySelectorAll("audio")["".concat(_r16)].duration;
        t["".concat(_r16)].innerHTML = v(e);
      }, 2e3);else {
        var n = e["".concat(_r16)].duration;
        t["".concat(_r16)].innerHTML = v(n);
      }
    }, n = 0; n < t.length; n++) {
      r(n);
    }
  },
      T = "";

  null == l || null == (null == l ? void 0 : l.url) || (null === (r = null == l ? void 0 : l.url) || void 0 === r ? void 0 : r.includes("http")) || (null === (n = null == l ? void 0 : l.url) || void 0 === n ? void 0 : n.includes("cloudfront.net")) && (null === (a = null == l ? void 0 : l.url) || void 0 === a ? void 0 : a.includes("http")) ? T = "" : (null === (o = null == l ? void 0 : l.url) || void 0 === o ? void 0 : o.includes("cloudfront.net")) && !(null === (i = null == l ? void 0 : l.url) || void 0 === i ? void 0 : i.includes("http")) && (T = "https://");
  var E = "".concat(T).concat(null != l.url ? l.url : "");
  return jsxs(Root$C, {
    children: [d && jsxs(AudioSpectrum, _assign$({
      onMouseEnter: function onMouseEnter() {
        return y(!0);
      },
      onMouseLeave: function onMouseLeave() {
        y(!1);
      }
    }, {
      children: [jsxs(SpectrumContainer, _assign$({
        onClick: c,
        className: m ? "on-hover" : ""
      }, {
        children: [jsx$1(AudioTag, {
          children: jsx$1("audio", _assign$({
            controls: !0,
            muted: !0,
            crossOrigin: "anonymous",
            ref: t,
            onPlaying: function onPlaying() {
              y(!0), f(!0);
            },
            onPause: function onPause() {
              return f(!1);
            },
            onEnded: function onEnded() {
              return p(!1), void f(!1);
            }
          }, {
            children: jsx$1("source", {
              src: E,
              type: "audio/mpeg"
            })
          }))
        }), jsx$1(SpectrumVisualizer, {
          audio: E,
          theme: SpectrumVisualizerTheme.line,
          colors: ["#0357FF"],
          iconsColor: "#26a69a",
          showMainActionIcon: !1,
          showLoaderIcon: !1
        })]
      })), m && jsx$1(SpectrumOverlay, {
        className: "css-overlay"
      })]
    })), jsxs(CanvasImg, {
      children: [jsx$1(CmsImage, {
        media: s,
        component: "img"
      }), b && jsx$1(AudioPlayButton, _assign$({
        className: "play-button"
      }, {
        children: d && jsx$1(PlayPauseIcon, {
          className: m ? "play-pause-icon toggle" : "play-pause-icon"
        })
      }))]
    })]
  });
}),
    Root$C = styled$2(Box)(function (e) {
  var t,
      r = e.theme;
  return (t = {})[r.breakpoints.down("md")] = {
    height: "180px"
  }, t[r.breakpoints.up("md")] = {
    marginTop: r.spacing(7),
    marginLeft: "auto",
    marginRight: "auto",
    height: "240px"
  }, t.position = "relative", t;
}),
    AudioSpectrum = styled$2(Box)(function (e) {
  var t;
  return (t = {
    height: 200,
    width: 160,
    borderRadius: "50%",
    margin: "auto"
  })[e.theme.breakpoints.down("sm")] = {
    height: 140,
    width: 100
  }, t;
}),
    AudioPlayButton = styled$2(Box)(function (e) {
  var t,
      r,
      n = e.theme;
  return (t = {
    "-webkit-appearance": "none",
    "-moz-appearance": "none",
    appearance: "none",
    width: 36,
    height: 36,
    position: "absolute",
    cursor: "pointer",
    top: "25%",
    left: "35%",
    display: "block"
  })[n.breakpoints.down("sm")] = {
    width: 16,
    height: 16
  }, t["&::after"] = ((r = {
    display: "block",
    position: "absolute",
    width: 42,
    height: 42,
    borderRadius: "50%",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    margin: "auto"
  })[n.breakpoints.down("sm")] = {
    width: 20,
    height: 20
  }, r), t;
}),
    PlayPauseIcon = styled$2(Box)(function (e) {
  var t,
      r,
      n,
      a,
      o,
      i,
      s,
      l,
      c = e.theme;
  return (t = {
    position: "relative",
    zIndex: 1,
    height: "22px",
    width: "4px",
    background: "rgba(255,255,255, 1)",
    borderRadius: "3px",
    margin: "8px 20px 0 12px",
    left: 0,
    transition: "background 0.2s ease",
    animationDelay: "1s",
    boxShadow: "2px 0 0 #012b7c"
  })[c.breakpoints.down("sm")] = {
    height: "10px",
    width: "2px",
    margin: "3px 5px"
  }, t["&::before, &::after"] = ((r = {
    display: "block",
    position: "absolute",
    content: "''",
    height: "20px",
    width: "4px",
    background: "inherit",
    borderRadius: "3px",
    left: "15px",
    transition: "all 0.5s ease",
    boxShadow: "2px 0 0 #012b7c"
  })[c.breakpoints.down("sm")] = {
    height: "8px",
    width: "2px",
    left: "7px"
  }, r), t["&::before"] = ((n = {
    top: "11px",
    transform: "rotate(56deg)",
    transformOrigin: "top center"
  })[c.breakpoints.down("sm")] = {
    top: "5px"
  }, n), t["&::after"] = ((a = {
    top: "-8px",
    transform: "rotate(-56deg)",
    transformOrigin: "bottom center"
  })[c.breakpoints.down("sm")] = {
    top: "-3px"
  }, a), t["&.toggle"] = ((o = {
    height: 22,
    background: "rgba(1, 88, 255,1)"
  })[c.breakpoints.down("sm")] = {
    height: 10
  }, o["&::before,&::after"] = ((i = {
    transform: "rotate(0deg)",
    left: 10,
    height: 13
  })[c.breakpoints.down("sm")] = {
    height: 6,
    left: 5
  }, i), o["&::before"] = ((s = {
    top: 9
  })[c.breakpoints.down("sm")] = {
    top: 0
  }, s), o["&::after"] = ((l = {
    transform: "rotate(0deg)",
    top: 0
  })[c.breakpoints.down("sm")] = {
    top: 4
  }, l), o), t;
}),
    CanvasImg = styled$2(Box)(function (e) {
  var t,
      r,
      n = e.theme;
  return (t = {
    height: 125,
    width: 125,
    position: "absolute",
    background: "transparent",
    top: "24%",
    left: 0,
    right: 0,
    margin: "auto",
    borderRadius: "50%"
  })[n.breakpoints.down("sm")] = {
    height: 86,
    width: 86,
    top: "29%"
  }, t["& img"] = ((r = {
    width: 120,
    height: 120,
    borderRadius: "50%",
    margin: "auto"
  })[n.breakpoints.down("sm")] = {
    width: 76,
    height: 76
  }, r), t;
}),
    AudioTag = styled$2(Box)(function (e) {
  return e.theme, {
    display: "none",
    position: "absolute",
    top: "34%",
    height: 54
  };
}),
    SpectrumContainer = styled$2(Box)(function (e) {
  var t,
      r = e.theme;
  return (t = {
    height: "54px",
    top: "42%",
    position: "absolute",
    marginTop: "-20px",
    left: "61px",
    right: "42px",
    zIndex: 2,
    marginLeft: "auto",
    marginRight: "auto",
    opacity: "0.01",
    backgroundColor: "rgba(255, 255, 255, 0.6)",
    "&.on-hover": {
      opacity: 1
    }
  })[r.breakpoints.down("sm")] = {
    height: 40,
    top: "50%",
    left: 18,
    right: 0,
    width: 128
  }, t[r.breakpoints.only("sm")] = {
    top: "50%",
    left: 18,
    right: 0,
    width: 178
  }, t[r.breakpoints.only("md")] = {
    left: 31,
    right: 14
  }, t[r.breakpoints.up("lg")] = {
    left: 18,
    right: 0,
    width: 190
  }, t;
}),
    SpectrumOverlay = styled$2(Box)(function (e) {
  return e.theme, {
    height: 160,
    width: 160,
    borderRadius: "50%",
    backgroundColor: "rgba(255, 255, 255, 0.01)",
    top: "50%",
    marginTop: "-80px",
    right: 20,
    left: 20,
    zIndex: 1,
    position: "absolute",
    marginLeft: "auto",
    marginRight: "auto"
  };
}),
    Media = function Media(e) {
  var t,
      r,
      n,
      a,
      o,
      i = e.media,
      s = e.embeddedMedia;
  e.component;

  var l,
      c,
      u,
      d = e.objectFit,
      p = void 0 === d ? "contain" : d,
      g = e.objectPosition,
      m = void 0 === g ? "relative" : g,
      f = e.fadeInDuration,
      h = e.fadeInDelay,
      b = e.rootStyle,
      y = e.mediaStyle,
      v = e.autoplay,
      _ = void 0 !== v && v,
      T = e.height,
      E = e.width,
      S = "",
      x = !1;

  return null == i || null == (null == i ? void 0 : i.url) || (null === (t = null == i ? void 0 : i.url) || void 0 === t ? void 0 : t.includes("http")) || (null === (r = null == i ? void 0 : i.url) || void 0 === r ? void 0 : r.includes("cloudfront.net")) && (null === (n = null == i ? void 0 : i.url) || void 0 === n ? void 0 : n.includes("http")) ? S = "" : (null === (a = null == i ? void 0 : i.url) || void 0 === a ? void 0 : a.includes("cloudfront.net")) && !(null === (o = null == i ? void 0 : i.url) || void 0 === o ? void 0 : o.includes("http")) && (S = "https://"), null != (null == s ? void 0 : s.provider_name) && null != (null == s ? void 0 : s.mime) && s.mime.includes("video") ? (x = !0, l = s.url, c = null != E ? E : s.width, u = null != T ? T : s.height) : null != (null == i ? void 0 : i.url) && MEDIA_FORMATS.VIDEOS.includes(i.ext.substring(1)) && (x = !0, l = "".concat(S).concat(i.url), c = E, u = T), x ? jsx$1(ReactPlayer, {
    url: l,
    playing: _,
    controls: !0,
    width: c,
    height: u,
    style: y
  }) : null != (null == i ? void 0 : i.url) && MEDIA_FORMATS.IMAGES.includes(i.ext.substring(1)) ? jsx$1(Image, {
    src: "".concat(S).concat(i.url),
    fit: p,
    position: m,
    duration: f,
    delay: h,
    style: y,
    wrapperClassName: "GoSiteMedia-root",
    wrapperStyle: b,
    className: "GoSiteMedia-image GoSiteMedia-media",
    height: T,
    width: E,
    alt: null == i ? void 0 : i.alternativeText
  }) : null != (null == i ? void 0 : i.url) && MEDIA_FORMATS.AUDIOS.includes(i.ext.substring(1)) ? jsx$1("audio", {
    src: "".concat(S).concat(i.url),
    controls: !0,
    autoPlay: !0
  }) : jsx$1(Fragment, {});
},
    BackgroundMedia$1 = function BackgroundMedia$1(e) {
  var t = e.backgroundMedia;
  return jsx$1(Root$B, _assign$({
    className: "GoSiteBackgoundMedia-root"
  }, {
    children: jsx$1(Media, {
      media: t
    })
  }));
},
    Root$B = styled$2(Box)(function (e) {
  return e.theme, {
    width: "100%",
    height: "100%",
    position: "absolute",
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    display: "flex"
  };
}),
    CmsImage = function CmsImage(e) {
  var t,
      r,
      n,
      a,
      o,
      i = e.media;
  e.component, e.objectFit, e.objectPosition;

  var s = __rest$1(e, ["media", "component", "objectFit", "objectPosition"]),
      l = "";

  return null == i || null == (null == i ? void 0 : i.url) || (null === (t = null == i ? void 0 : i.url) || void 0 === t ? void 0 : t.includes("http")) || (null === (r = null == i ? void 0 : i.url) || void 0 === r ? void 0 : r.includes("cloudfront.net")) && (null === (n = null == i ? void 0 : i.url) || void 0 === n ? void 0 : n.includes("http")) ? l = "" : (null === (a = null == i ? void 0 : i.url) || void 0 === a ? void 0 : a.includes("cloudfront.net")) && !(null === (o = null == i ? void 0 : i.url) || void 0 === o ? void 0 : o.includes("http")) && (l = "https://"), null == i || null == (null == i ? void 0 : i.url) ? jsx$1(Fragment, {}) : void 0 !== s.width && void 0 !== s.height ? jsx$1("img", {
    className: "GoSite-media",
    src: "".concat(l).concat(i.url),
    alt: null !== (null == i ? void 0 : i.alternativeText) ? null == i ? void 0 : i.alternativeText : "",
    width: s.width,
    height: s.height,
    style: s.styles
  }) : jsx$1("img", {
    className: "GoSite-media",
    width: null == i ? void 0 : i.width,
    height: null == i ? void 0 : i.height,
    src: "".concat(l).concat(i.url),
    alt: null !== (null == i ? void 0 : i.alternativeText) ? null == i ? void 0 : i.alternativeText : "",
    style: s.styles
  });
};

function _objectWithoutPropertiesLoose$5(e, t) {
  if (null == e) return {};
  var r,
      n,
      a = {},
      o = Object.keys(e);

  for (n = 0; n < o.length; n++) {
    r = o[n], t.indexOf(r) >= 0 || (a[r] = e[r]);
  }

  return a;
}

function _objectWithoutProperties(e, t) {
  if (null == e) return {};

  var r,
      n,
      a = _objectWithoutPropertiesLoose$5(e, t);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);

    for (n = 0; n < o.length; n++) {
      r = o[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (a[r] = e[r]);
    }
  }

  return a;
}

function _defineProperty(e, t, r) {
  return t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}

function _objectSpread(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? Object(arguments[t]) : {},
        n = Object.keys(r);
    "function" == typeof Object.getOwnPropertySymbols && n.push.apply(n, Object.getOwnPropertySymbols(r).filter(function (e) {
      return Object.getOwnPropertyDescriptor(r, e).enumerable;
    })), n.forEach(function (t) {
      _defineProperty(e, t, r[t]);
    });
  }

  return e;
}

function _extends$f() {
  return _extends$f = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];

      for (var n in r) {
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
    }

    return e;
  }, _extends$f.apply(this, arguments);
}

function createStyleObject(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
      r = arguments.length > 2 ? arguments[2] : void 0;
  return e.reduce(function (e, t) {
    return _objectSpread({}, e, r[t]);
  }, t);
}

function createClassNameString(e) {
  return e.join(" ");
}

function createChildren(e, t) {
  var r = 0;
  return function (n) {
    return r += 1, n.map(function (n, a) {
      return createElement({
        node: n,
        stylesheet: e,
        useInlineStyles: t,
        key: "code-segment-".concat(r, "-").concat(a)
      });
    });
  };
}

function createElement(e) {
  var t = e.node,
      r = e.stylesheet,
      n = e.style,
      a = void 0 === n ? {} : n,
      o = e.useInlineStyles,
      i = e.key,
      s = t.properties,
      l = t.type,
      c = t.tagName,
      u = t.value;
  if ("text" === l) return u;

  if (c) {
    var d = createChildren(r, o),
        p = o && s.className && s.className.filter(function (e) {
      return !r[e];
    }),
        g = p && p.length ? p : void 0,
        m = o ? _objectSpread({}, s, {
      className: g && createClassNameString(g)
    }, {
      style: createStyleObject(s.className, Object.assign({}, s.style, a), r)
    }) : _objectSpread({}, s, {
      className: createClassNameString(s.className)
    }),
        f = d(t.children);
    return React__default.createElement(c, _extends$f({
      key: i
    }, m), f);
  }
}

var checkForListedLanguage = function checkForListedLanguage(e, t) {
  return -1 !== e.listLanguages().indexOf(t);
},
    newLineRegex = /\n/g;

function getNewLines(e) {
  return e.match(newLineRegex);
}

function getAllLineNumbers(e) {
  var t = e.lines,
      r = e.startingLineNumber,
      n = e.style;
  return t.map(function (e, t) {
    var a = t + r;
    return React__default.createElement("span", {
      key: "line-".concat(t),
      className: "react-syntax-highlighter-line-number",
      style: "function" == typeof n ? n(a) : n
    }, "".concat(a, "\n"));
  });
}

function AllLineNumbers(e) {
  var t = e.codeString,
      r = e.codeStyle,
      n = e.containerStyle,
      a = void 0 === n ? {
    float: "left",
    paddingRight: "10px"
  } : n,
      o = e.numberStyle,
      i = void 0 === o ? {} : o,
      s = e.startingLineNumber;
  return React__default.createElement("code", {
    style: Object.assign({}, r, a)
  }, getAllLineNumbers({
    lines: t.replace(/\n$/, "").split("\n"),
    style: i,
    startingLineNumber: s
  }));
}

function getEmWidthOfNumber(e) {
  var t = e.toString().length;
  return "".concat(t, "em");
}

function getInlineLineNumber(e, t) {
  return {
    type: "element",
    tagName: "span",
    properties: {
      key: "line-number--".concat(e),
      className: ["comment", "linenumber", "react-syntax-highlighter-line-number"],
      style: t
    },
    children: [{
      type: "text",
      value: e
    }]
  };
}

function assembleLineNumberStyles(e, t, r) {
  return _objectSpread({}, {
    display: "inline-block",
    minWidth: getEmWidthOfNumber(r),
    paddingRight: "1em",
    textAlign: "right",
    userSelect: "none"
  }, "function" == typeof e ? e(t) : e);
}

function createLineElement(e) {
  var t = e.children,
      r = e.lineNumber,
      n = e.lineNumberStyle,
      a = e.largestLineNumber,
      o = e.showInlineLineNumbers,
      i = e.lineProps,
      s = void 0 === i ? {} : i,
      l = e.className,
      c = void 0 === l ? [] : l,
      u = "function" == typeof s ? s(r) : s;

  if (u.className = c, r && o) {
    var d = assembleLineNumberStyles(n, r, a);
    t.unshift(getInlineLineNumber(r, d));
  }

  return {
    type: "element",
    tagName: "span",
    properties: u,
    children: t
  };
}

function flattenCodeTree(e) {
  for (var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [], r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : [], n = 0; n < e.length; n++) {
    var a = e[n];
    if ("text" === a.type) r.push(createLineElement({
      children: [a],
      className: t
    }));else if (a.children) {
      var o = t.concat(a.properties.className);
      r = r.concat(flattenCodeTree(a.children, o));
    }
  }

  return r;
}

function processLines(e, t, r, n, a, o, i, s) {
  var l,
      c = flattenCodeTree(e.value),
      u = [],
      d = -1,
      p = 0;

  function g(e, t) {
    var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : [];
    return createLineElement({
      children: e,
      lineNumber: t,
      lineNumberStyle: s,
      largestLineNumber: i,
      showInlineLineNumbers: a,
      lineProps: r,
      className: n
    });
  }

  function m(e, t) {
    if (t && a) {
      var r = assembleLineNumberStyles(s, t, i);
      e.unshift(getInlineLineNumber(t, r));
    }

    return e;
  }

  function f(e, r) {
    var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : [];
    return t || n.length > 0 ? g(e, r, n) : m(e, r);
  }

  for (var h = function h() {
    var e = c[p],
        t = e.children[0].value;

    if (getNewLines(t)) {
      var r = t.split("\n");
      r.forEach(function (t, a) {
        var i = n && u.length + o,
            s = {
          type: "text",
          value: "".concat(t, "\n")
        };

        if (0 === a) {
          var l = f(c.slice(d + 1, p).concat(createLineElement({
            children: [s],
            className: e.properties.className
          })), i);
          u.push(l);
        } else if (a === r.length - 1) {
          if (c[p + 1] && c[p + 1].children && c[p + 1].children[0]) {
            var g = createLineElement({
              children: [{
                type: "text",
                value: "".concat(t)
              }],
              className: e.properties.className
            });
            c.splice(p + 1, 0, g);
          } else {
            var m = f([s], i, e.properties.className);
            u.push(m);
          }
        } else {
          var h = f([s], i, e.properties.className);
          u.push(h);
        }
      }), d = p;
    }

    p++;
  }; p < c.length;) {
    h();
  }

  if (d !== c.length - 1) {
    var b = c.slice(d + 1, c.length);

    if (b && b.length) {
      var y = f(b, u.length + o);
      u.push(y);
    }
  }

  return t ? u : (l = []).concat.apply(l, u);
}

function defaultRenderer(e) {
  var t = e.rows,
      r = e.stylesheet,
      n = e.useInlineStyles;
  return t.map(function (e, t) {
    return createElement({
      node: e,
      stylesheet: r,
      useInlineStyles: n,
      key: "code-segement".concat(t)
    });
  });
}

function isHighlightJs(e) {
  return e && void 0 !== e.highlightAuto;
}

function getCodeTree(e) {
  var t = e.astGenerator,
      r = e.language,
      n = e.code,
      a = e.defaultCodeValue;

  if (isHighlightJs(t)) {
    var o = checkForListedLanguage(t, r);
    return "text" === r ? {
      value: a,
      language: "text"
    } : o ? t.highlight(r, n) : t.highlightAuto(n);
  }

  try {
    return r && "text" !== r ? {
      value: t.highlight(n, r)
    } : {
      value: a
    };
  } catch (e) {
    return {
      value: a
    };
  }
}

function highlight$1(e, t) {
  return function (r) {
    var n = r.language,
        a = r.children,
        o = r.style,
        i = void 0 === o ? t : o,
        s = r.customStyle,
        l = void 0 === s ? {} : s,
        c = r.codeTagProps,
        u = void 0 === c ? {
      className: n ? "language-".concat(n) : void 0,
      style: i['code[class*="language-"]']
    } : c,
        d = r.useInlineStyles,
        p = void 0 === d || d,
        g = r.showLineNumbers,
        m = void 0 !== g && g,
        f = r.showInlineLineNumbers,
        h = void 0 !== f && f,
        b = r.startingLineNumber,
        y = void 0 === b ? 1 : b,
        v = r.lineNumberContainerStyle,
        _ = r.lineNumberStyle,
        T = void 0 === _ ? {} : _,
        E = r.wrapLines,
        S = r.lineProps,
        x = void 0 === S ? {} : S,
        w = r.renderer,
        C = r.PreTag,
        k = void 0 === C ? "pre" : C,
        $ = r.CodeTag,
        R = void 0 === $ ? "code" : $,
        A = r.code,
        I = void 0 === A ? Array.isArray(a) ? a[0] : a : A,
        N = r.astGenerator,
        P = _objectWithoutProperties(r, ["language", "children", "style", "customStyle", "codeTagProps", "useInlineStyles", "showLineNumbers", "showInlineLineNumbers", "startingLineNumber", "lineNumberContainerStyle", "lineNumberStyle", "wrapLines", "lineProps", "renderer", "PreTag", "CodeTag", "code", "astGenerator"]);

    N = N || e;
    var O = m ? React__default.createElement(AllLineNumbers, {
      containerStyle: v,
      codeStyle: u.style || {},
      numberStyle: T,
      startingLineNumber: y,
      codeString: I
    }) : null,
        D = i.hljs || i['pre[class*="language-"]'] || {
      backgroundColor: "#fff"
    },
        L = isHighlightJs(N) ? "hljs" : "prismjs",
        M = p ? Object.assign({}, P, {
      style: Object.assign({}, D, l)
    }) : Object.assign({}, P, {
      className: P.className ? "".concat(L, " ").concat(P.className) : L,
      style: Object.assign({}, l)
    });
    if (!N) return React__default.createElement(k, M, O, React__default.createElement(R, u, I));
    E = !(!w || void 0 !== E) || E, w = w || defaultRenderer;
    var F = [{
      type: "text",
      value: I
    }],
        j = getCodeTree({
      astGenerator: N,
      language: n,
      code: I,
      defaultCodeValue: F
    });
    null === j.language && (j.value = F);
    var B = processLines(j, E, x, m, h, y, j.value.length + y, T);
    return React__default.createElement(k, M, React__default.createElement(R, u, !h && O, w({
      rows: B,
      stylesheet: i,
      useInlineStyles: p
    })));
  };
}

var supportedLanguages = ["abap", "abnf", "actionscript", "ada", "agda", "al", "antlr4", "apacheconf", "apl", "applescript", "aql", "arduino", "arff", "asciidoc", "asm6502", "aspnet", "autohotkey", "autoit", "bash", "basic", "batch", "bbcode", "bison", "bnf", "brainfuck", "brightscript", "bro", "c", "cil", "clike", "clojure", "cmake", "coffeescript", "concurnas", "cpp", "crystal", "csharp", "csp", "css-extras", "css", "cypher", "d", "dart", "dax", "dhall", "diff", "django", "dns-zone-file", "docker", "ebnf", "editorconfig", "eiffel", "ejs", "elixir", "elm", "erb", "erlang", "etlua", "excel-formula", "factor", "firestore-security-rules", "flow", "fortran", "fsharp", "ftl", "gcode", "gdscript", "gedcom", "gherkin", "git", "glsl", "gml", "go", "graphql", "groovy", "haml", "handlebars", "haskell", "haxe", "hcl", "hlsl", "hpkp", "hsts", "http", "ichigojam", "icon", "iecst", "ignore", "inform7", "ini", "io", "j", "java", "javadoc", "javadoclike", "javascript", "javastacktrace", "jolie", "jq", "js-extras", "js-templates", "jsdoc", "json", "json5", "jsonp", "jsstacktrace", "jsx", "julia", "keyman", "kotlin", "latex", "latte", "less", "lilypond", "liquid", "lisp", "livescript", "llvm", "lolcode", "lua", "makefile", "markdown", "markup-templating", "markup", "matlab", "mel", "mizar", "monkey", "moonscript", "n1ql", "n4js", "nand2tetris-hdl", "nasm", "neon", "nginx", "nim", "nix", "nsis", "objectivec", "ocaml", "opencl", "oz", "parigp", "parser", "pascal", "pascaligo", "pcaxis", "peoplecode", "perl", "php-extras", "php", "phpdoc", "plsql", "powerquery", "powershell", "processing", "prolog", "properties", "protobuf", "pug", "puppet", "pure", "purebasic", "python", "q", "qml", "qore", "r", "racket", "reason", "regex", "renpy", "rest", "rip", "roboconf", "robotframework", "ruby", "rust", "sas", "sass", "scala", "scheme", "scss", "shell-session", "smali", "smalltalk", "smarty", "solidity", "solution-file", "soy", "sparql", "splunk-spl", "sqf", "sql", "stylus", "swift", "t4-cs", "t4-templating", "t4-vb", "tap", "tcl", "textile", "toml", "tsx", "tt2", "turtle", "twig", "typescript", "unrealscript", "vala", "vbnet", "velocity", "verilog", "vhdl", "vim", "visual-basic", "warpscript", "wasm", "wiki", "xeora", "xml-doc", "xojo", "xquery", "yaml", "yang", "zig"],
    immutable = extend,
    hasOwnProperty$1 = Object.prototype.hasOwnProperty;

function extend() {
  for (var e = {}, t = 0; t < arguments.length; t++) {
    var r = arguments[t];

    for (var n in r) {
      hasOwnProperty$1.call(r, n) && (e[n] = r[n]);
    }
  }

  return e;
}

var schema$1 = Schema$2,
    proto$1 = Schema$2.prototype;

function Schema$2(e, t, r) {
  this.property = e, this.normal = t, r && (this.space = r);
}

proto$1.space = null, proto$1.normal = {}, proto$1.property = {};
var xtend = immutable,
    Schema$1 = schema$1,
    merge_1 = merge$2;

function merge$2(e) {
  for (var t, r, n = e.length, a = [], o = [], i = -1; ++i < n;) {
    t = e[i], a.push(t.property), o.push(t.normal), r = t.space;
  }

  return new Schema$1(xtend.apply(null, a), xtend.apply(null, o), r);
}

var normalize_1 = normalize$3;

function normalize$3(e) {
  return e.toLowerCase();
}

var info = Info$2,
    proto = Info$2.prototype;

function Info$2(e, t) {
  this.property = e, this.attribute = t;
}

proto.space = null, proto.attribute = null, proto.property = null, proto.boolean = !1, proto.booleanish = !1, proto.overloadedBoolean = !1, proto.number = !1, proto.commaSeparated = !1, proto.spaceSeparated = !1, proto.commaOrSpaceSeparated = !1, proto.mustUseProperty = !1, proto.defined = !1;
var types$3 = {},
    powers = 0;

function increment() {
  return Math.pow(2, ++powers);
}

types$3.boolean = increment(), types$3.booleanish = increment(), types$3.overloadedBoolean = increment(), types$3.number = increment(), types$3.spaceSeparated = increment(), types$3.commaSeparated = increment(), types$3.commaOrSpaceSeparated = increment();
var Info$1 = info,
    types$2 = types$3,
    definedInfo = DefinedInfo$2;
DefinedInfo$2.prototype = new Info$1(), DefinedInfo$2.prototype.defined = !0;
var checks = ["boolean", "booleanish", "overloadedBoolean", "number", "commaSeparated", "spaceSeparated", "commaOrSpaceSeparated"],
    checksLength = checks.length;

function DefinedInfo$2(e, t, r, n) {
  var a,
      o = -1;

  for (mark(this, "space", n), Info$1.call(this, e, t); ++o < checksLength;) {
    mark(this, a = checks[o], (r & types$2[a]) === types$2[a]);
  }
}

function mark(e, t, r) {
  r && (e[t] = r);
}

var normalize$2 = normalize_1,
    Schema = schema$1,
    DefinedInfo$1 = definedInfo,
    create_1 = create$5;

function create$5(e) {
  var t,
      r,
      n = e.space,
      a = e.mustUseProperty || [],
      o = e.attributes || {},
      i = e.properties,
      s = e.transform,
      l = {},
      c = {};

  for (t in i) {
    r = new DefinedInfo$1(t, s(o, t), i[t], n), -1 !== a.indexOf(t) && (r.mustUseProperty = !0), l[t] = r, c[normalize$2(t)] = t, c[normalize$2(r.attribute)] = t;
  }

  return new Schema(l, c, n);
}

var create$4 = create_1,
    xlink$1 = create$4({
  space: "xlink",
  transform: xlinkTransform,
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
});

function xlinkTransform(e, t) {
  return "xlink:" + t.slice(5).toLowerCase();
}

var create$3 = create_1,
    xml$1 = create$3({
  space: "xml",
  transform: xmlTransform,
  properties: {
    xmlLang: null,
    xmlBase: null,
    xmlSpace: null
  }
});

function xmlTransform(e, t) {
  return "xml:" + t.slice(3).toLowerCase();
}

var caseSensitiveTransform_1 = caseSensitiveTransform$1;

function caseSensitiveTransform$1(e, t) {
  return t in e ? e[t] : t;
}

var caseSensitiveTransform = caseSensitiveTransform_1,
    caseInsensitiveTransform_1 = caseInsensitiveTransform$2;

function caseInsensitiveTransform$2(e, t) {
  return caseSensitiveTransform(e, t.toLowerCase());
}

var create$2 = create_1,
    caseInsensitiveTransform$1 = caseInsensitiveTransform_1,
    xmlns$1 = create$2({
  space: "xmlns",
  attributes: {
    xmlnsxlink: "xmlns:xlink"
  },
  transform: caseInsensitiveTransform$1,
  properties: {
    xmlns: null,
    xmlnsXLink: null
  }
}),
    types$1 = types$3,
    create$1 = create_1,
    booleanish$1 = types$1.booleanish,
    number$1 = types$1.number,
    spaceSeparated$1 = types$1.spaceSeparated,
    aria$1 = create$1({
  transform: ariaTransform,
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: booleanish$1,
    ariaAutoComplete: null,
    ariaBusy: booleanish$1,
    ariaChecked: booleanish$1,
    ariaColCount: number$1,
    ariaColIndex: number$1,
    ariaColSpan: number$1,
    ariaControls: spaceSeparated$1,
    ariaCurrent: null,
    ariaDescribedBy: spaceSeparated$1,
    ariaDetails: null,
    ariaDisabled: booleanish$1,
    ariaDropEffect: spaceSeparated$1,
    ariaErrorMessage: null,
    ariaExpanded: booleanish$1,
    ariaFlowTo: spaceSeparated$1,
    ariaGrabbed: booleanish$1,
    ariaHasPopup: null,
    ariaHidden: booleanish$1,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: spaceSeparated$1,
    ariaLevel: number$1,
    ariaLive: null,
    ariaModal: booleanish$1,
    ariaMultiLine: booleanish$1,
    ariaMultiSelectable: booleanish$1,
    ariaOrientation: null,
    ariaOwns: spaceSeparated$1,
    ariaPlaceholder: null,
    ariaPosInSet: number$1,
    ariaPressed: booleanish$1,
    ariaReadOnly: booleanish$1,
    ariaRelevant: null,
    ariaRequired: booleanish$1,
    ariaRoleDescription: spaceSeparated$1,
    ariaRowCount: number$1,
    ariaRowIndex: number$1,
    ariaRowSpan: number$1,
    ariaSelected: booleanish$1,
    ariaSetSize: number$1,
    ariaSort: null,
    ariaValueMax: number$1,
    ariaValueMin: number$1,
    ariaValueNow: number$1,
    ariaValueText: null,
    role: null
  }
});

function ariaTransform(e, t) {
  return "role" === t ? t : "aria-" + t.slice(4).toLowerCase();
}

var types = types$3,
    create = create_1,
    caseInsensitiveTransform = caseInsensitiveTransform_1,
    boolean = types.boolean,
    overloadedBoolean = types.overloadedBoolean,
    booleanish = types.booleanish,
    number = types.number,
    spaceSeparated = types.spaceSeparated,
    commaSeparated = types.commaSeparated,
    html$2 = create({
  space: "html",
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  transform: caseInsensitiveTransform,
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    abbr: null,
    accept: commaSeparated,
    acceptCharset: spaceSeparated,
    accessKey: spaceSeparated,
    action: null,
    allow: null,
    allowFullScreen: boolean,
    allowPaymentRequest: boolean,
    allowUserMedia: boolean,
    alt: null,
    as: null,
    async: boolean,
    autoCapitalize: null,
    autoComplete: spaceSeparated,
    autoFocus: boolean,
    autoPlay: boolean,
    capture: boolean,
    charSet: null,
    checked: boolean,
    cite: null,
    className: spaceSeparated,
    cols: number,
    colSpan: null,
    content: null,
    contentEditable: booleanish,
    controls: boolean,
    controlsList: spaceSeparated,
    coords: number | commaSeparated,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: boolean,
    defer: boolean,
    dir: null,
    dirName: null,
    disabled: boolean,
    download: overloadedBoolean,
    draggable: booleanish,
    encType: null,
    enterKeyHint: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: boolean,
    formTarget: null,
    headers: spaceSeparated,
    height: number,
    hidden: boolean,
    high: number,
    href: null,
    hrefLang: null,
    htmlFor: spaceSeparated,
    httpEquiv: spaceSeparated,
    id: null,
    imageSizes: null,
    imageSrcSet: commaSeparated,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: boolean,
    itemId: null,
    itemProp: spaceSeparated,
    itemRef: spaceSeparated,
    itemScope: boolean,
    itemType: spaceSeparated,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: boolean,
    low: number,
    manifest: null,
    max: null,
    maxLength: number,
    media: null,
    method: null,
    min: null,
    minLength: number,
    multiple: boolean,
    muted: boolean,
    name: null,
    nonce: null,
    noModule: boolean,
    noValidate: boolean,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforePrint: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextMenu: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: boolean,
    optimum: number,
    pattern: null,
    ping: spaceSeparated,
    placeholder: null,
    playsInline: boolean,
    poster: null,
    preload: null,
    readOnly: boolean,
    referrerPolicy: null,
    rel: spaceSeparated,
    required: boolean,
    reversed: boolean,
    rows: number,
    rowSpan: number,
    sandbox: spaceSeparated,
    scope: null,
    scoped: boolean,
    seamless: boolean,
    selected: boolean,
    shape: null,
    size: number,
    sizes: null,
    slot: null,
    span: number,
    spellCheck: booleanish,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: commaSeparated,
    start: number,
    step: null,
    style: null,
    tabIndex: number,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: boolean,
    useMap: null,
    value: booleanish,
    width: number,
    wrap: null,
    align: null,
    aLink: null,
    archive: spaceSeparated,
    axis: null,
    background: null,
    bgColor: null,
    border: number,
    borderColor: null,
    bottomMargin: number,
    cellPadding: null,
    cellSpacing: null,
    char: null,
    charOff: null,
    classId: null,
    clear: null,
    code: null,
    codeBase: null,
    codeType: null,
    color: null,
    compact: boolean,
    declare: boolean,
    event: null,
    face: null,
    frame: null,
    frameBorder: null,
    hSpace: number,
    leftMargin: number,
    link: null,
    longDesc: null,
    lowSrc: null,
    marginHeight: number,
    marginWidth: number,
    noResize: boolean,
    noHref: boolean,
    noShade: boolean,
    noWrap: boolean,
    object: null,
    profile: null,
    prompt: null,
    rev: null,
    rightMargin: number,
    rules: null,
    scheme: null,
    scrolling: booleanish,
    standby: null,
    summary: null,
    text: null,
    topMargin: number,
    valueType: null,
    version: null,
    vAlign: null,
    vLink: null,
    vSpace: number,
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: boolean,
    disableRemotePlayback: boolean,
    prefix: null,
    property: null,
    results: number,
    security: null,
    unselectable: null
  }
}),
    merge$1 = merge_1,
    xlink = xlink$1,
    xml = xml$1,
    xmlns = xmlns$1,
    aria = aria$1,
    html$1 = html$2,
    html_1$1 = merge$1([xml, xlink, xmlns, aria, html$1]),
    normalize$1 = normalize_1,
    DefinedInfo = definedInfo,
    Info = info,
    data = "data",
    find_1 = find$1,
    valid = /^data[-\w.:]+$/i,
    dash$1 = /-[a-z]/g,
    cap$1 = /[A-Z]/g;

function find$1(e, t) {
  var r = normalize$1(t),
      n = t,
      a = Info;
  return r in e.normal ? e.property[e.normal[r]] : (r.length > 4 && r.slice(0, 4) === data && valid.test(t) && ("-" === t.charAt(4) ? n = datasetToProperty(t) : t = datasetToAttribute(t), a = DefinedInfo), new a(n, t));
}

function datasetToProperty(e) {
  var t = e.slice(5).replace(dash$1, camelcase);
  return data + t.charAt(0).toUpperCase() + t.slice(1);
}

function datasetToAttribute(e) {
  var t = e.slice(4);
  return dash$1.test(t) ? e : ("-" !== (t = t.replace(cap$1, kebab)).charAt(0) && (t = "-" + t), data + t);
}

function kebab(e) {
  return "-" + e.toLowerCase();
}

function camelcase(e) {
  return e.charAt(1).toUpperCase();
}

var hastUtilParseSelector = parse$4,
    search = /[#.]/g;

function parse$4(e, t) {
  for (var r, n, a, o = e || "", i = t || "div", s = {}, l = 0; l < o.length;) {
    search.lastIndex = l, a = search.exec(o), (r = o.slice(l, a ? a.index : o.length)) && (n ? "#" === n ? s.id = r : s.className ? s.className.push(r) : s.className = [r] : i = r, l += r.length), a && (n = a[0], l++);
  }

  return {
    type: "element",
    tagName: i,
    properties: s,
    children: []
  };
}

var spaceSeparatedTokens = {};
spaceSeparatedTokens.parse = parse$3, spaceSeparatedTokens.stringify = stringify$2;
var empty$2 = "",
    space$2 = " ",
    whiteSpace$1 = /[ \t\n\r\f]+/g;

function parse$3(e) {
  var t = String(e || empty$2).trim();
  return t === empty$2 ? [] : t.split(whiteSpace$1);
}

function stringify$2(e) {
  return e.join(space$2).trim();
}

var commaSeparatedTokens = {};
commaSeparatedTokens.parse = parse$2, commaSeparatedTokens.stringify = stringify$1;
var comma$1 = ",",
    space$1 = " ",
    empty$1 = "";

function parse$2(e) {
  for (var t, r = [], n = String(e || empty$1), a = n.indexOf(comma$1), o = 0, i = !1; !i;) {
    -1 === a && (a = n.length, i = !0), !(t = n.slice(o, a).trim()) && i || r.push(t), o = a + 1, a = n.indexOf(comma$1, o);
  }

  return r;
}

function stringify$1(e, t) {
  var r = t || {},
      n = !1 === r.padLeft ? empty$1 : space$1,
      a = r.padRight ? space$1 : empty$1;
  return e[e.length - 1] === empty$1 && (e = e.concat(empty$1)), e.join(a + comma$1 + n).trim();
}

var find = find_1,
    normalize = normalize_1,
    parseSelector = hastUtilParseSelector,
    spaces = spaceSeparatedTokens.parse,
    commas = commaSeparatedTokens.parse,
    factory_1 = factory$1,
    own$3 = {}.hasOwnProperty;

function factory$1(e, t, r) {
  var n = r ? createAdjustMap(r) : null;
  return function (e, r) {
    var o,
        i = parseSelector(e, t),
        s = Array.prototype.slice.call(arguments, 2),
        l = i.tagName.toLowerCase();
    i.tagName = n && own$3.call(n, l) ? n[l] : l, r && isChildren(r, i) && (s.unshift(r), r = null);
    if (r) for (o in r) {
      a(i.properties, o, r[o]);
    }
    addChild(i.children, s), "template" === i.tagName && (i.content = {
      type: "root",
      children: i.children
    }, i.children = []);
    return i;
  };

  function a(t, r, n) {
    var a, o, i;
    null != n && n == n && (o = (a = find(e, r)).property, "string" == typeof (i = n) && (a.spaceSeparated ? i = spaces(i) : a.commaSeparated ? i = commas(i) : a.commaOrSpaceSeparated && (i = spaces(commas(i).join(" ")))), "style" === o && "string" != typeof n && (i = style$2(i)), "className" === o && t.className && (i = t.className.concat(i)), t[o] = parsePrimitives(a, o, i));
  }
}

function isChildren(e, t) {
  return "string" == typeof e || "length" in e || isNode(t.tagName, e);
}

function isNode(e, t) {
  var r = t.type;
  return !("input" === e || !r || "string" != typeof r) && ("object" == typeof t.children && "length" in t.children || (r = r.toLowerCase(), "button" === e ? "menu" !== r && "submit" !== r && "reset" !== r && "button" !== r : "value" in t));
}

function addChild(e, t) {
  var r, n;
  if ("string" != typeof t && "number" != typeof t) {
    if ("object" == typeof t && "length" in t) for (r = -1, n = t.length; ++r < n;) {
      addChild(e, t[r]);
    } else {
      if ("object" != typeof t || !("type" in t)) throw new Error("Expected node, nodes, or string, got `" + t + "`");
      e.push(t);
    }
  } else e.push({
    type: "text",
    value: String(t)
  });
}

function parsePrimitives(e, t, r) {
  var n, a, o;
  if ("object" != typeof r || !("length" in r)) return parsePrimitive(e, t, r);

  for (a = r.length, n = -1, o = []; ++n < a;) {
    o[n] = parsePrimitive(e, t, r[n]);
  }

  return o;
}

function parsePrimitive(e, t, r) {
  var n = r;
  return e.number || e.positiveNumber ? isNaN(n) || "" === n || (n = Number(n)) : (e.boolean || e.overloadedBoolean) && ("string" != typeof n || "" !== n && normalize(r) !== normalize(t) || (n = !0)), n;
}

function style$2(e) {
  var t,
      r = [];

  for (t in e) {
    r.push([t, e[t]].join(": "));
  }

  return r.join("; ");
}

function createAdjustMap(e) {
  for (var t, r = e.length, n = -1, a = {}; ++n < r;) {
    a[(t = e[n]).toLowerCase()] = t;
  }

  return a;
}

var schema = html_1$1,
    factory = factory_1,
    html = factory(schema, "div");
html.displayName = "html";
var html_1 = html,
    hastscript = html_1,
    AElig$1 = "Æ",
    AMP$1 = "&",
    Aacute$1 = "Á",
    Acirc$1 = "Â",
    Agrave$1 = "À",
    Aring$1 = "Å",
    Atilde$1 = "Ã",
    Auml$1 = "Ä",
    COPY$1 = "©",
    Ccedil$1 = "Ç",
    ETH$1 = "Ð",
    Eacute$1 = "É",
    Ecirc$1 = "Ê",
    Egrave$1 = "È",
    Euml$1 = "Ë",
    GT$1 = ">",
    Iacute$1 = "Í",
    Icirc$1 = "Î",
    Igrave$1 = "Ì",
    Iuml$1 = "Ï",
    LT$1 = "<",
    Ntilde$1 = "Ñ",
    Oacute$1 = "Ó",
    Ocirc$1 = "Ô",
    Ograve$1 = "Ò",
    Oslash$1 = "Ø",
    Otilde$1 = "Õ",
    Ouml$1 = "Ö",
    QUOT$1 = '"',
    REG$1 = "®",
    THORN$1 = "Þ",
    Uacute$1 = "Ú",
    Ucirc$1 = "Û",
    Ugrave$1 = "Ù",
    Uuml$1 = "Ü",
    Yacute$1 = "Ý",
    aacute$1 = "á",
    acirc$1 = "â",
    acute$1 = "´",
    aelig$1 = "æ",
    agrave$1 = "à",
    amp$1 = "&",
    aring$1 = "å",
    atilde$1 = "ã",
    auml$1 = "ä",
    brvbar$1 = "¦",
    ccedil$1 = "ç",
    cedil$1 = "¸",
    cent$1 = "¢",
    copy$1 = "©",
    curren$1 = "¤",
    deg$1 = "°",
    divide$1 = "÷",
    eacute$1 = "é",
    ecirc$1 = "ê",
    egrave$1 = "è",
    eth$1 = "ð",
    euml$1 = "ë",
    frac12$1 = "½",
    frac14$1 = "¼",
    frac34$1 = "¾",
    gt$1 = ">",
    iacute$1 = "í",
    icirc$1 = "î",
    iexcl$1 = "¡",
    igrave$1 = "ì",
    iquest$1 = "¿",
    iuml$1 = "ï",
    laquo$1 = "«",
    lt$1 = "<",
    macr$1 = "¯",
    micro$1 = "µ",
    middot$1 = "·",
    nbsp$1 = " ",
    not$1 = "¬",
    ntilde$1 = "ñ",
    oacute$1 = "ó",
    ocirc$1 = "ô",
    ograve$1 = "ò",
    ordf$1 = "ª",
    ordm$1 = "º",
    oslash$1 = "ø",
    otilde$1 = "õ",
    ouml$1 = "ö",
    para$1 = "¶",
    plusmn$1 = "±",
    pound$1 = "£",
    quot$1 = '"',
    raquo$1 = "»",
    reg$1 = "®",
    sect$1 = "§",
    shy$1 = "­",
    sup1$1 = "¹",
    sup2$1 = "²",
    sup3$1 = "³",
    szlig$1 = "ß",
    thorn$1 = "þ",
    times$1 = "×",
    uacute$1 = "ú",
    ucirc$1 = "û",
    ugrave$1 = "ù",
    uml$1 = "¨",
    uuml$1 = "ü",
    yacute$1 = "ý",
    yen$1 = "¥",
    yuml$1 = "ÿ",
    require$$0$2 = {
  AElig: AElig$1,
  AMP: AMP$1,
  Aacute: Aacute$1,
  Acirc: Acirc$1,
  Agrave: Agrave$1,
  Aring: Aring$1,
  Atilde: Atilde$1,
  Auml: Auml$1,
  COPY: COPY$1,
  Ccedil: Ccedil$1,
  ETH: ETH$1,
  Eacute: Eacute$1,
  Ecirc: Ecirc$1,
  Egrave: Egrave$1,
  Euml: Euml$1,
  GT: GT$1,
  Iacute: Iacute$1,
  Icirc: Icirc$1,
  Igrave: Igrave$1,
  Iuml: Iuml$1,
  LT: LT$1,
  Ntilde: Ntilde$1,
  Oacute: Oacute$1,
  Ocirc: Ocirc$1,
  Ograve: Ograve$1,
  Oslash: Oslash$1,
  Otilde: Otilde$1,
  Ouml: Ouml$1,
  QUOT: QUOT$1,
  REG: REG$1,
  THORN: THORN$1,
  Uacute: Uacute$1,
  Ucirc: Ucirc$1,
  Ugrave: Ugrave$1,
  Uuml: Uuml$1,
  Yacute: Yacute$1,
  aacute: aacute$1,
  acirc: acirc$1,
  acute: acute$1,
  aelig: aelig$1,
  agrave: agrave$1,
  amp: amp$1,
  aring: aring$1,
  atilde: atilde$1,
  auml: auml$1,
  brvbar: brvbar$1,
  ccedil: ccedil$1,
  cedil: cedil$1,
  cent: cent$1,
  copy: copy$1,
  curren: curren$1,
  deg: deg$1,
  divide: divide$1,
  eacute: eacute$1,
  ecirc: ecirc$1,
  egrave: egrave$1,
  eth: eth$1,
  euml: euml$1,
  frac12: frac12$1,
  frac14: frac14$1,
  frac34: frac34$1,
  gt: gt$1,
  iacute: iacute$1,
  icirc: icirc$1,
  iexcl: iexcl$1,
  igrave: igrave$1,
  iquest: iquest$1,
  iuml: iuml$1,
  laquo: laquo$1,
  lt: lt$1,
  macr: macr$1,
  micro: micro$1,
  middot: middot$1,
  nbsp: nbsp$1,
  not: not$1,
  ntilde: ntilde$1,
  oacute: oacute$1,
  ocirc: ocirc$1,
  ograve: ograve$1,
  ordf: ordf$1,
  ordm: ordm$1,
  oslash: oslash$1,
  otilde: otilde$1,
  ouml: ouml$1,
  para: para$1,
  plusmn: plusmn$1,
  pound: pound$1,
  quot: quot$1,
  raquo: raquo$1,
  reg: reg$1,
  sect: sect$1,
  shy: shy$1,
  sup1: sup1$1,
  sup2: sup2$1,
  sup3: sup3$1,
  szlig: szlig$1,
  thorn: thorn$1,
  times: times$1,
  uacute: uacute$1,
  ucirc: ucirc$1,
  ugrave: ugrave$1,
  uml: uml$1,
  uuml: uuml$1,
  yacute: yacute$1,
  yen: yen$1,
  yuml: yuml$1
},
    require$$1 = {
  0: "�",
  128: "€",
  130: "‚",
  131: "ƒ",
  132: "„",
  133: "…",
  134: "†",
  135: "‡",
  136: "ˆ",
  137: "‰",
  138: "Š",
  139: "‹",
  140: "Œ",
  142: "Ž",
  145: "‘",
  146: "’",
  147: "“",
  148: "”",
  149: "•",
  150: "–",
  151: "—",
  152: "˜",
  153: "™",
  154: "š",
  155: "›",
  156: "œ",
  158: "ž",
  159: "Ÿ"
},
    isDecimal = decimal$2;

function decimal$2(e) {
  var t = "string" == typeof e ? e.charCodeAt(0) : e;
  return t >= 48 && t <= 57;
}

var isHexadecimal = hexadecimal$1;

function hexadecimal$1(e) {
  var t = "string" == typeof e ? e.charCodeAt(0) : e;
  return t >= 97 && t <= 102 || t >= 65 && t <= 70 || t >= 48 && t <= 57;
}

var isAlphabetical = alphabetical$1;

function alphabetical$1(e) {
  var t = "string" == typeof e ? e.charCodeAt(0) : e;
  return t >= 97 && t <= 122 || t >= 65 && t <= 90;
}

var alphabetical = isAlphabetical,
    decimal$1 = isDecimal,
    isAlphanumerical = alphanumerical$1;

function alphanumerical$1(e) {
  return alphabetical(e) || decimal$1(e);
}

var AEli = "Æ",
    AElig = "Æ",
    AM = "&",
    AMP = "&",
    Aacut = "Á",
    Aacute = "Á",
    Abreve = "Ă",
    Acir = "Â",
    Acirc = "Â",
    Acy = "А",
    Afr = "𝔄",
    Agrav = "À",
    Agrave = "À",
    Alpha = "Α",
    Amacr = "Ā",
    And = "⩓",
    Aogon = "Ą",
    Aopf = "𝔸",
    ApplyFunction = "⁡",
    Arin = "Å",
    Aring = "Å",
    Ascr = "𝒜",
    Assign = "≔",
    Atild = "Ã",
    Atilde = "Ã",
    Aum = "Ä",
    Auml = "Ä",
    Backslash = "∖",
    Barv = "⫧",
    Barwed = "⌆",
    Bcy = "Б",
    Because = "∵",
    Bernoullis = "ℬ",
    Beta = "Β",
    Bfr = "𝔅",
    Bopf = "𝔹",
    Breve = "˘",
    Bscr = "ℬ",
    Bumpeq = "≎",
    CHcy = "Ч",
    COP = "©",
    COPY = "©",
    Cacute = "Ć",
    Cap = "⋒",
    CapitalDifferentialD = "ⅅ",
    Cayleys = "ℭ",
    Ccaron = "Č",
    Ccedi = "Ç",
    Ccedil = "Ç",
    Ccirc = "Ĉ",
    Cconint = "∰",
    Cdot = "Ċ",
    Cedilla = "¸",
    CenterDot = "·",
    Cfr = "ℭ",
    Chi = "Χ",
    CircleDot = "⊙",
    CircleMinus = "⊖",
    CirclePlus = "⊕",
    CircleTimes = "⊗",
    ClockwiseContourIntegral = "∲",
    CloseCurlyDoubleQuote = "”",
    CloseCurlyQuote = "’",
    Colon = "∷",
    Colone = "⩴",
    Congruent = "≡",
    Conint = "∯",
    ContourIntegral = "∮",
    Copf = "ℂ",
    Coproduct = "∐",
    CounterClockwiseContourIntegral = "∳",
    Cross = "⨯",
    Cscr = "𝒞",
    Cup = "⋓",
    CupCap = "≍",
    DD = "ⅅ",
    DDotrahd = "⤑",
    DJcy = "Ђ",
    DScy = "Ѕ",
    DZcy = "Џ",
    Dagger = "‡",
    Darr = "↡",
    Dashv = "⫤",
    Dcaron = "Ď",
    Dcy = "Д",
    Del = "∇",
    Delta = "Δ",
    Dfr = "𝔇",
    DiacriticalAcute = "´",
    DiacriticalDot = "˙",
    DiacriticalDoubleAcute = "˝",
    DiacriticalGrave = "`",
    DiacriticalTilde = "˜",
    Diamond = "⋄",
    DifferentialD = "ⅆ",
    Dopf = "𝔻",
    Dot = "¨",
    DotDot = "⃜",
    DotEqual = "≐",
    DoubleContourIntegral = "∯",
    DoubleDot = "¨",
    DoubleDownArrow = "⇓",
    DoubleLeftArrow = "⇐",
    DoubleLeftRightArrow = "⇔",
    DoubleLeftTee = "⫤",
    DoubleLongLeftArrow = "⟸",
    DoubleLongLeftRightArrow = "⟺",
    DoubleLongRightArrow = "⟹",
    DoubleRightArrow = "⇒",
    DoubleRightTee = "⊨",
    DoubleUpArrow = "⇑",
    DoubleUpDownArrow = "⇕",
    DoubleVerticalBar = "∥",
    DownArrow = "↓",
    DownArrowBar = "⤓",
    DownArrowUpArrow = "⇵",
    DownBreve = "̑",
    DownLeftRightVector = "⥐",
    DownLeftTeeVector = "⥞",
    DownLeftVector = "↽",
    DownLeftVectorBar = "⥖",
    DownRightTeeVector = "⥟",
    DownRightVector = "⇁",
    DownRightVectorBar = "⥗",
    DownTee = "⊤",
    DownTeeArrow = "↧",
    Downarrow = "⇓",
    Dscr = "𝒟",
    Dstrok = "Đ",
    ENG = "Ŋ",
    ET = "Ð",
    ETH = "Ð",
    Eacut = "É",
    Eacute = "É",
    Ecaron = "Ě",
    Ecir = "Ê",
    Ecirc = "Ê",
    Ecy = "Э",
    Edot = "Ė",
    Efr = "𝔈",
    Egrav = "È",
    Egrave = "È",
    Element$1 = "∈",
    Emacr = "Ē",
    EmptySmallSquare = "◻",
    EmptyVerySmallSquare = "▫",
    Eogon = "Ę",
    Eopf = "𝔼",
    Epsilon = "Ε",
    Equal = "⩵",
    EqualTilde = "≂",
    Equilibrium = "⇌",
    Escr = "ℰ",
    Esim = "⩳",
    Eta = "Η",
    Eum = "Ë",
    Euml = "Ë",
    Exists = "∃",
    ExponentialE = "ⅇ",
    Fcy = "Ф",
    Ffr = "𝔉",
    FilledSmallSquare = "◼",
    FilledVerySmallSquare = "▪",
    Fopf = "𝔽",
    ForAll = "∀",
    Fouriertrf = "ℱ",
    Fscr = "ℱ",
    GJcy = "Ѓ",
    G = ">",
    GT = ">",
    Gamma = "Γ",
    Gammad = "Ϝ",
    Gbreve = "Ğ",
    Gcedil = "Ģ",
    Gcirc = "Ĝ",
    Gcy = "Г",
    Gdot = "Ġ",
    Gfr = "𝔊",
    Gg = "⋙",
    Gopf = "𝔾",
    GreaterEqual = "≥",
    GreaterEqualLess = "⋛",
    GreaterFullEqual = "≧",
    GreaterGreater = "⪢",
    GreaterLess = "≷",
    GreaterSlantEqual = "⩾",
    GreaterTilde = "≳",
    Gscr = "𝒢",
    Gt = "≫",
    HARDcy = "Ъ",
    Hacek = "ˇ",
    Hat = "^",
    Hcirc = "Ĥ",
    Hfr = "ℌ",
    HilbertSpace = "ℋ",
    Hopf = "ℍ",
    HorizontalLine = "─",
    Hscr = "ℋ",
    Hstrok = "Ħ",
    HumpDownHump = "≎",
    HumpEqual = "≏",
    IEcy = "Е",
    IJlig = "Ĳ",
    IOcy = "Ё",
    Iacut = "Í",
    Iacute = "Í",
    Icir = "Î",
    Icirc = "Î",
    Icy = "И",
    Idot = "İ",
    Ifr = "ℑ",
    Igrav = "Ì",
    Igrave = "Ì",
    Im = "ℑ",
    Imacr = "Ī",
    ImaginaryI = "ⅈ",
    Implies = "⇒",
    Int = "∬",
    Integral = "∫",
    Intersection = "⋂",
    InvisibleComma = "⁣",
    InvisibleTimes = "⁢",
    Iogon = "Į",
    Iopf = "𝕀",
    Iota = "Ι",
    Iscr = "ℐ",
    Itilde = "Ĩ",
    Iukcy = "І",
    Ium = "Ï",
    Iuml = "Ï",
    Jcirc = "Ĵ",
    Jcy = "Й",
    Jfr = "𝔍",
    Jopf = "𝕁",
    Jscr = "𝒥",
    Jsercy = "Ј",
    Jukcy = "Є",
    KHcy = "Х",
    KJcy = "Ќ",
    Kappa = "Κ",
    Kcedil = "Ķ",
    Kcy = "К",
    Kfr = "𝔎",
    Kopf = "𝕂",
    Kscr = "𝒦",
    LJcy = "Љ",
    L = "<",
    LT = "<",
    Lacute = "Ĺ",
    Lambda = "Λ",
    Lang = "⟪",
    Laplacetrf = "ℒ",
    Larr = "↞",
    Lcaron = "Ľ",
    Lcedil = "Ļ",
    Lcy = "Л",
    LeftAngleBracket = "⟨",
    LeftArrow = "←",
    LeftArrowBar = "⇤",
    LeftArrowRightArrow = "⇆",
    LeftCeiling = "⌈",
    LeftDoubleBracket = "⟦",
    LeftDownTeeVector = "⥡",
    LeftDownVector = "⇃",
    LeftDownVectorBar = "⥙",
    LeftFloor = "⌊",
    LeftRightArrow = "↔",
    LeftRightVector = "⥎",
    LeftTee = "⊣",
    LeftTeeArrow = "↤",
    LeftTeeVector = "⥚",
    LeftTriangle = "⊲",
    LeftTriangleBar = "⧏",
    LeftTriangleEqual = "⊴",
    LeftUpDownVector = "⥑",
    LeftUpTeeVector = "⥠",
    LeftUpVector = "↿",
    LeftUpVectorBar = "⥘",
    LeftVector = "↼",
    LeftVectorBar = "⥒",
    Leftarrow = "⇐",
    Leftrightarrow = "⇔",
    LessEqualGreater = "⋚",
    LessFullEqual = "≦",
    LessGreater = "≶",
    LessLess = "⪡",
    LessSlantEqual = "⩽",
    LessTilde = "≲",
    Lfr = "𝔏",
    Ll = "⋘",
    Lleftarrow = "⇚",
    Lmidot = "Ŀ",
    LongLeftArrow = "⟵",
    LongLeftRightArrow = "⟷",
    LongRightArrow = "⟶",
    Longleftarrow = "⟸",
    Longleftrightarrow = "⟺",
    Longrightarrow = "⟹",
    Lopf = "𝕃",
    LowerLeftArrow = "↙",
    LowerRightArrow = "↘",
    Lscr = "ℒ",
    Lsh = "↰",
    Lstrok = "Ł",
    Lt = "≪",
    Mcy = "М",
    MediumSpace = " ",
    Mellintrf = "ℳ",
    Mfr = "𝔐",
    MinusPlus = "∓",
    Mopf = "𝕄",
    Mscr = "ℳ",
    Mu = "Μ",
    NJcy = "Њ",
    Nacute = "Ń",
    Ncaron = "Ň",
    Ncedil = "Ņ",
    Ncy = "Н",
    NegativeMediumSpace = "​",
    NegativeThickSpace = "​",
    NegativeThinSpace = "​",
    NegativeVeryThinSpace = "​",
    NestedGreaterGreater = "≫",
    NestedLessLess = "≪",
    NewLine = "\n",
    Nfr = "𝔑",
    NoBreak = "⁠",
    NonBreakingSpace = " ",
    Nopf = "ℕ",
    Not = "⫬",
    NotCongruent = "≢",
    NotCupCap = "≭",
    NotDoubleVerticalBar = "∦",
    NotElement = "∉",
    NotEqual = "≠",
    NotEqualTilde = "≂̸",
    NotExists = "∄",
    NotGreater = "≯",
    NotGreaterEqual = "≱",
    NotGreaterFullEqual = "≧̸",
    NotGreaterGreater = "≫̸",
    NotGreaterLess = "≹",
    NotGreaterSlantEqual = "⩾̸",
    NotGreaterTilde = "≵",
    NotHumpDownHump = "≎̸",
    NotHumpEqual = "≏̸",
    NotLeftTriangle = "⋪",
    NotLeftTriangleBar = "⧏̸",
    NotLeftTriangleEqual = "⋬",
    NotLess = "≮",
    NotLessEqual = "≰",
    NotLessGreater = "≸",
    NotLessLess = "≪̸",
    NotLessSlantEqual = "⩽̸",
    NotLessTilde = "≴",
    NotNestedGreaterGreater = "⪢̸",
    NotNestedLessLess = "⪡̸",
    NotPrecedes = "⊀",
    NotPrecedesEqual = "⪯̸",
    NotPrecedesSlantEqual = "⋠",
    NotReverseElement = "∌",
    NotRightTriangle = "⋫",
    NotRightTriangleBar = "⧐̸",
    NotRightTriangleEqual = "⋭",
    NotSquareSubset = "⊏̸",
    NotSquareSubsetEqual = "⋢",
    NotSquareSuperset = "⊐̸",
    NotSquareSupersetEqual = "⋣",
    NotSubset = "⊂⃒",
    NotSubsetEqual = "⊈",
    NotSucceeds = "⊁",
    NotSucceedsEqual = "⪰̸",
    NotSucceedsSlantEqual = "⋡",
    NotSucceedsTilde = "≿̸",
    NotSuperset = "⊃⃒",
    NotSupersetEqual = "⊉",
    NotTilde = "≁",
    NotTildeEqual = "≄",
    NotTildeFullEqual = "≇",
    NotTildeTilde = "≉",
    NotVerticalBar = "∤",
    Nscr = "𝒩",
    Ntild = "Ñ",
    Ntilde = "Ñ",
    Nu = "Ν",
    OElig = "Œ",
    Oacut = "Ó",
    Oacute = "Ó",
    Ocir = "Ô",
    Ocirc = "Ô",
    Ocy = "О",
    Odblac = "Ő",
    Ofr = "𝔒",
    Ograv = "Ò",
    Ograve = "Ò",
    Omacr = "Ō",
    Omega = "Ω",
    Omicron = "Ο",
    Oopf = "𝕆",
    OpenCurlyDoubleQuote = "“",
    OpenCurlyQuote = "‘",
    Or = "⩔",
    Oscr = "𝒪",
    Oslas = "Ø",
    Oslash = "Ø",
    Otild = "Õ",
    Otilde = "Õ",
    Otimes = "⨷",
    Oum = "Ö",
    Ouml = "Ö",
    OverBar = "‾",
    OverBrace = "⏞",
    OverBracket = "⎴",
    OverParenthesis = "⏜",
    PartialD = "∂",
    Pcy = "П",
    Pfr = "𝔓",
    Phi = "Φ",
    Pi = "Π",
    PlusMinus = "±",
    Poincareplane = "ℌ",
    Popf = "ℙ",
    Pr = "⪻",
    Precedes = "≺",
    PrecedesEqual = "⪯",
    PrecedesSlantEqual = "≼",
    PrecedesTilde = "≾",
    Prime = "″",
    Product = "∏",
    Proportion = "∷",
    Proportional = "∝",
    Pscr = "𝒫",
    Psi = "Ψ",
    QUO = '"',
    QUOT = '"',
    Qfr = "𝔔",
    Qopf = "ℚ",
    Qscr = "𝒬",
    RBarr = "⤐",
    RE = "®",
    REG = "®",
    Racute = "Ŕ",
    Rang = "⟫",
    Rarr = "↠",
    Rarrtl = "⤖",
    Rcaron = "Ř",
    Rcedil = "Ŗ",
    Rcy = "Р",
    Re = "ℜ",
    ReverseElement = "∋",
    ReverseEquilibrium = "⇋",
    ReverseUpEquilibrium = "⥯",
    Rfr = "ℜ",
    Rho = "Ρ",
    RightAngleBracket = "⟩",
    RightArrow$1 = "→",
    RightArrowBar = "⇥",
    RightArrowLeftArrow = "⇄",
    RightCeiling = "⌉",
    RightDoubleBracket = "⟧",
    RightDownTeeVector = "⥝",
    RightDownVector = "⇂",
    RightDownVectorBar = "⥕",
    RightFloor = "⌋",
    RightTee = "⊢",
    RightTeeArrow = "↦",
    RightTeeVector = "⥛",
    RightTriangle = "⊳",
    RightTriangleBar = "⧐",
    RightTriangleEqual = "⊵",
    RightUpDownVector = "⥏",
    RightUpTeeVector = "⥜",
    RightUpVector = "↾",
    RightUpVectorBar = "⥔",
    RightVector = "⇀",
    RightVectorBar = "⥓",
    Rightarrow = "⇒",
    Ropf = "ℝ",
    RoundImplies = "⥰",
    Rrightarrow = "⇛",
    Rscr = "ℛ",
    Rsh = "↱",
    RuleDelayed = "⧴",
    SHCHcy = "Щ",
    SHcy = "Ш",
    SOFTcy = "Ь",
    Sacute = "Ś",
    Sc = "⪼",
    Scaron = "Š",
    Scedil = "Ş",
    Scirc = "Ŝ",
    Scy = "С",
    Sfr = "𝔖",
    ShortDownArrow = "↓",
    ShortLeftArrow = "←",
    ShortRightArrow = "→",
    ShortUpArrow = "↑",
    Sigma = "Σ",
    SmallCircle = "∘",
    Sopf = "𝕊",
    Sqrt = "√",
    Square = "□",
    SquareIntersection = "⊓",
    SquareSubset = "⊏",
    SquareSubsetEqual = "⊑",
    SquareSuperset = "⊐",
    SquareSupersetEqual = "⊒",
    SquareUnion = "⊔",
    Sscr = "𝒮",
    Star = "⋆",
    Sub = "⋐",
    Subset = "⋐",
    SubsetEqual = "⊆",
    Succeeds = "≻",
    SucceedsEqual = "⪰",
    SucceedsSlantEqual = "≽",
    SucceedsTilde = "≿",
    SuchThat = "∋",
    Sum = "∑",
    Sup = "⋑",
    Superset = "⊃",
    SupersetEqual = "⊇",
    Supset = "⋑",
    THOR = "Þ",
    THORN = "Þ",
    TRADE = "™",
    TSHcy = "Ћ",
    TScy = "Ц",
    Tab = "\t",
    Tau = "Τ",
    Tcaron = "Ť",
    Tcedil = "Ţ",
    Tcy = "Т",
    Tfr = "𝔗",
    Therefore = "∴",
    Theta = "Θ",
    ThickSpace = "  ",
    ThinSpace = " ",
    Tilde = "∼",
    TildeEqual = "≃",
    TildeFullEqual = "≅",
    TildeTilde = "≈",
    Topf = "𝕋",
    TripleDot = "⃛",
    Tscr = "𝒯",
    Tstrok = "Ŧ",
    Uacut = "Ú",
    Uacute = "Ú",
    Uarr = "↟",
    Uarrocir = "⥉",
    Ubrcy = "Ў",
    Ubreve = "Ŭ",
    Ucir = "Û",
    Ucirc = "Û",
    Ucy = "У",
    Udblac = "Ű",
    Ufr = "𝔘",
    Ugrav = "Ù",
    Ugrave = "Ù",
    Umacr = "Ū",
    UnderBar = "_",
    UnderBrace = "⏟",
    UnderBracket = "⎵",
    UnderParenthesis = "⏝",
    Union = "⋃",
    UnionPlus = "⊎",
    Uogon = "Ų",
    Uopf = "𝕌",
    UpArrow = "↑",
    UpArrowBar = "⤒",
    UpArrowDownArrow = "⇅",
    UpDownArrow = "↕",
    UpEquilibrium = "⥮",
    UpTee = "⊥",
    UpTeeArrow = "↥",
    Uparrow = "⇑",
    Updownarrow = "⇕",
    UpperLeftArrow = "↖",
    UpperRightArrow = "↗",
    Upsi = "ϒ",
    Upsilon = "Υ",
    Uring = "Ů",
    Uscr = "𝒰",
    Utilde = "Ũ",
    Uum = "Ü",
    Uuml = "Ü",
    VDash = "⊫",
    Vbar = "⫫",
    Vcy = "В",
    Vdash = "⊩",
    Vdashl = "⫦",
    Vee = "⋁",
    Verbar = "‖",
    Vert = "‖",
    VerticalBar = "∣",
    VerticalLine = "|",
    VerticalSeparator = "❘",
    VerticalTilde = "≀",
    VeryThinSpace = " ",
    Vfr = "𝔙",
    Vopf = "𝕍",
    Vscr = "𝒱",
    Vvdash = "⊪",
    Wcirc = "Ŵ",
    Wedge = "⋀",
    Wfr = "𝔚",
    Wopf = "𝕎",
    Wscr = "𝒲",
    Xfr = "𝔛",
    Xi = "Ξ",
    Xopf = "𝕏",
    Xscr = "𝒳",
    YAcy = "Я",
    YIcy = "Ї",
    YUcy = "Ю",
    Yacut = "Ý",
    Yacute = "Ý",
    Ycirc = "Ŷ",
    Ycy = "Ы",
    Yfr = "𝔜",
    Yopf = "𝕐",
    Yscr = "𝒴",
    Yuml = "Ÿ",
    ZHcy = "Ж",
    Zacute = "Ź",
    Zcaron = "Ž",
    Zcy = "З",
    Zdot = "Ż",
    ZeroWidthSpace = "​",
    Zeta = "Ζ",
    Zfr = "ℨ",
    Zopf = "ℤ",
    Zscr = "𝒵",
    aacut = "á",
    aacute = "á",
    abreve = "ă",
    ac = "∾",
    acE = "∾̳",
    acd = "∿",
    acir = "â",
    acirc = "â",
    acut = "´",
    acute = "´",
    acy = "а",
    aeli = "æ",
    aelig = "æ",
    af = "⁡",
    afr = "𝔞",
    agrav = "à",
    agrave = "à",
    alefsym = "ℵ",
    aleph = "ℵ",
    alpha$1 = "α",
    amacr = "ā",
    amalg = "⨿",
    am = "&",
    amp = "&",
    and = "∧",
    andand = "⩕",
    andd = "⩜",
    andslope = "⩘",
    andv = "⩚",
    ang = "∠",
    ange = "⦤",
    angle = "∠",
    angmsd = "∡",
    angmsdaa = "⦨",
    angmsdab = "⦩",
    angmsdac = "⦪",
    angmsdad = "⦫",
    angmsdae = "⦬",
    angmsdaf = "⦭",
    angmsdag = "⦮",
    angmsdah = "⦯",
    angrt = "∟",
    angrtvb = "⊾",
    angrtvbd = "⦝",
    angsph = "∢",
    angst = "Å",
    angzarr = "⍼",
    aogon = "ą",
    aopf = "𝕒",
    ap = "≈",
    apE = "⩰",
    apacir = "⩯",
    ape = "≊",
    apid = "≋",
    apos = "'",
    approx = "≈",
    approxeq = "≊",
    arin = "å",
    aring = "å",
    ascr = "𝒶",
    ast = "*",
    asymp = "≈",
    asympeq = "≍",
    atild = "ã",
    atilde = "ã",
    aum = "ä",
    auml = "ä",
    awconint = "∳",
    awint = "⨑",
    bNot = "⫭",
    backcong = "≌",
    backepsilon = "϶",
    backprime = "‵",
    backsim = "∽",
    backsimeq = "⋍",
    barvee = "⊽",
    barwed = "⌅",
    barwedge = "⌅",
    bbrk = "⎵",
    bbrktbrk = "⎶",
    bcong = "≌",
    bcy = "б",
    bdquo = "„",
    becaus = "∵",
    because = "∵",
    bemptyv = "⦰",
    bepsi = "϶",
    bernou = "ℬ",
    beta = "β",
    beth = "ℶ",
    between = "≬",
    bfr = "𝔟",
    bigcap = "⋂",
    bigcirc = "◯",
    bigcup = "⋃",
    bigodot = "⨀",
    bigoplus = "⨁",
    bigotimes = "⨂",
    bigsqcup = "⨆",
    bigstar = "★",
    bigtriangledown = "▽",
    bigtriangleup = "△",
    biguplus = "⨄",
    bigvee = "⋁",
    bigwedge = "⋀",
    bkarow = "⤍",
    blacklozenge = "⧫",
    blacksquare = "▪",
    blacktriangle = "▴",
    blacktriangledown = "▾",
    blacktriangleleft = "◂",
    blacktriangleright = "▸",
    blank = "␣",
    blk12 = "▒",
    blk14 = "░",
    blk34 = "▓",
    block = "█",
    bne = "=⃥",
    bnequiv = "≡⃥",
    bnot = "⌐",
    bopf = "𝕓",
    bot = "⊥",
    bottom$1 = "⊥",
    bowtie = "⋈",
    boxDL = "╗",
    boxDR = "╔",
    boxDl = "╖",
    boxDr = "╓",
    boxH = "═",
    boxHD = "╦",
    boxHU = "╩",
    boxHd = "╤",
    boxHu = "╧",
    boxUL = "╝",
    boxUR = "╚",
    boxUl = "╜",
    boxUr = "╙",
    boxV = "║",
    boxVH = "╬",
    boxVL = "╣",
    boxVR = "╠",
    boxVh = "╫",
    boxVl = "╢",
    boxVr = "╟",
    boxbox = "⧉",
    boxdL = "╕",
    boxdR = "╒",
    boxdl = "┐",
    boxdr = "┌",
    boxh = "─",
    boxhD = "╥",
    boxhU = "╨",
    boxhd = "┬",
    boxhu = "┴",
    boxminus = "⊟",
    boxplus = "⊞",
    boxtimes = "⊠",
    boxuL = "╛",
    boxuR = "╘",
    boxul = "┘",
    boxur = "└",
    boxv = "│",
    boxvH = "╪",
    boxvL = "╡",
    boxvR = "╞",
    boxvh = "┼",
    boxvl = "┤",
    boxvr = "├",
    bprime = "‵",
    breve = "˘",
    brvba = "¦",
    brvbar = "¦",
    bscr = "𝒷",
    bsemi = "⁏",
    bsim = "∽",
    bsime = "⋍",
    bsol = "\\",
    bsolb = "⧅",
    bsolhsub = "⟈",
    bull = "•",
    bullet = "•",
    bump = "≎",
    bumpE = "⪮",
    bumpe = "≏",
    bumpeq = "≏",
    cacute = "ć",
    cap = "∩",
    capand = "⩄",
    capbrcup = "⩉",
    capcap = "⩋",
    capcup = "⩇",
    capdot = "⩀",
    caps = "∩︀",
    caret = "⁁",
    caron = "ˇ",
    ccaps = "⩍",
    ccaron = "č",
    ccedi = "ç",
    ccedil = "ç",
    ccirc = "ĉ",
    ccups = "⩌",
    ccupssm = "⩐",
    cdot = "ċ",
    cedi = "¸",
    cedil = "¸",
    cemptyv = "⦲",
    cen = "¢",
    cent = "¢",
    centerdot = "·",
    cfr = "𝔠",
    chcy = "ч",
    check = "✓",
    checkmark = "✓",
    chi = "χ",
    cir = "○",
    cirE = "⧃",
    circ = "ˆ",
    circeq = "≗",
    circlearrowleft = "↺",
    circlearrowright = "↻",
    circledR = "®",
    circledS = "Ⓢ",
    circledast = "⊛",
    circledcirc = "⊚",
    circleddash = "⊝",
    cire = "≗",
    cirfnint = "⨐",
    cirmid = "⫯",
    cirscir = "⧂",
    clubs = "♣",
    clubsuit = "♣",
    colon = ":",
    colone = "≔",
    coloneq = "≔",
    comma = ",",
    commat = "@",
    comp = "∁",
    compfn = "∘",
    complement = "∁",
    complexes = "ℂ",
    cong = "≅",
    congdot = "⩭",
    conint = "∮",
    copf = "𝕔",
    coprod = "∐",
    cop = "©",
    copy = "©",
    copysr = "℗",
    crarr = "↵",
    cross = "✗",
    cscr = "𝒸",
    csub = "⫏",
    csube = "⫑",
    csup = "⫐",
    csupe = "⫒",
    ctdot = "⋯",
    cudarrl = "⤸",
    cudarrr = "⤵",
    cuepr = "⋞",
    cuesc = "⋟",
    cularr = "↶",
    cularrp = "⤽",
    cup = "∪",
    cupbrcap = "⩈",
    cupcap = "⩆",
    cupcup = "⩊",
    cupdot = "⊍",
    cupor = "⩅",
    cups = "∪︀",
    curarr = "↷",
    curarrm = "⤼",
    curlyeqprec = "⋞",
    curlyeqsucc = "⋟",
    curlyvee = "⋎",
    curlywedge = "⋏",
    curre = "¤",
    curren = "¤",
    curvearrowleft = "↶",
    curvearrowright = "↷",
    cuvee = "⋎",
    cuwed = "⋏",
    cwconint = "∲",
    cwint = "∱",
    cylcty = "⌭",
    dArr = "⇓",
    dHar = "⥥",
    dagger = "†",
    daleth = "ℸ",
    darr = "↓",
    dash = "‐",
    dashv = "⊣",
    dbkarow = "⤏",
    dblac = "˝",
    dcaron = "ď",
    dcy = "д",
    dd = "ⅆ",
    ddagger = "‡",
    ddarr = "⇊",
    ddotseq = "⩷",
    de = "°",
    deg = "°",
    delta = "δ",
    demptyv = "⦱",
    dfisht = "⥿",
    dfr = "𝔡",
    dharl = "⇃",
    dharr = "⇂",
    diam = "⋄",
    diamond = "⋄",
    diamondsuit = "♦",
    diams = "♦",
    die = "¨",
    digamma = "ϝ",
    disin = "⋲",
    div = "÷",
    divid = "÷",
    divide = "÷",
    divideontimes = "⋇",
    divonx = "⋇",
    djcy = "ђ",
    dlcorn = "⌞",
    dlcrop = "⌍",
    dollar = "$",
    dopf = "𝕕",
    dot$1 = "˙",
    doteq = "≐",
    doteqdot = "≑",
    dotminus = "∸",
    dotplus = "∔",
    dotsquare = "⊡",
    doublebarwedge = "⌆",
    downarrow = "↓",
    downdownarrows = "⇊",
    downharpoonleft = "⇃",
    downharpoonright = "⇂",
    drbkarow = "⤐",
    drcorn = "⌟",
    drcrop = "⌌",
    dscr = "𝒹",
    dscy = "ѕ",
    dsol = "⧶",
    dstrok = "đ",
    dtdot = "⋱",
    dtri = "▿",
    dtrif = "▾",
    duarr = "⇵",
    duhar = "⥯",
    dwangle = "⦦",
    dzcy = "џ",
    dzigrarr = "⟿",
    eDDot = "⩷",
    eDot = "≑",
    eacut = "é",
    eacute = "é",
    easter = "⩮",
    ecaron = "ě",
    ecir = "ê",
    ecirc = "ê",
    ecolon = "≕",
    ecy = "э",
    edot = "ė",
    ee = "ⅇ",
    efDot = "≒",
    efr = "𝔢",
    eg = "⪚",
    egrav = "è",
    egrave = "è",
    egs = "⪖",
    egsdot = "⪘",
    el = "⪙",
    elinters = "⏧",
    ell = "ℓ",
    els = "⪕",
    elsdot = "⪗",
    emacr = "ē",
    empty = "∅",
    emptyset = "∅",
    emptyv = "∅",
    emsp13 = " ",
    emsp14 = " ",
    emsp = " ",
    eng = "ŋ",
    ensp = " ",
    eogon = "ę",
    eopf = "𝕖",
    epar = "⋕",
    eparsl = "⧣",
    eplus = "⩱",
    epsi = "ε",
    epsilon = "ε",
    epsiv = "ϵ",
    eqcirc = "≖",
    eqcolon = "≕",
    eqsim = "≂",
    eqslantgtr = "⪖",
    eqslantless = "⪕",
    equals = "=",
    equest = "≟",
    equiv = "≡",
    equivDD = "⩸",
    eqvparsl = "⧥",
    erDot = "≓",
    erarr = "⥱",
    escr = "ℯ",
    esdot = "≐",
    esim = "≂",
    eta = "η",
    et = "ð",
    eth = "ð",
    eum = "ë",
    euml = "ë",
    euro = "€",
    excl = "!",
    exist = "∃",
    expectation = "ℰ",
    exponentiale = "ⅇ",
    fallingdotseq = "≒",
    fcy = "ф",
    female = "♀",
    ffilig = "ﬃ",
    fflig = "ﬀ",
    ffllig = "ﬄ",
    ffr = "𝔣",
    filig = "ﬁ",
    fjlig = "fj",
    flat = "♭",
    fllig = "ﬂ",
    fltns = "▱",
    fnof = "ƒ",
    fopf = "𝕗",
    forall = "∀",
    fork = "⋔",
    forkv = "⫙",
    fpartint = "⨍",
    frac1 = "¼",
    frac12 = "½",
    frac13 = "⅓",
    frac14 = "¼",
    frac15 = "⅕",
    frac16 = "⅙",
    frac18 = "⅛",
    frac23 = "⅔",
    frac25 = "⅖",
    frac3 = "¾",
    frac34 = "¾",
    frac35 = "⅗",
    frac38 = "⅜",
    frac45 = "⅘",
    frac56 = "⅚",
    frac58 = "⅝",
    frac78 = "⅞",
    frasl = "⁄",
    frown = "⌢",
    fscr = "𝒻",
    gE = "≧",
    gEl = "⪌",
    gacute = "ǵ",
    gamma = "γ",
    gammad = "ϝ",
    gap$2 = "⪆",
    gbreve = "ğ",
    gcirc = "ĝ",
    gcy = "г",
    gdot = "ġ",
    ge = "≥",
    gel = "⋛",
    geq = "≥",
    geqq = "≧",
    geqslant = "⩾",
    ges = "⩾",
    gescc = "⪩",
    gesdot = "⪀",
    gesdoto = "⪂",
    gesdotol = "⪄",
    gesl = "⋛︀",
    gesles = "⪔",
    gfr = "𝔤",
    gg = "≫",
    ggg = "⋙",
    gimel = "ℷ",
    gjcy = "ѓ",
    gl = "≷",
    glE = "⪒",
    gla = "⪥",
    glj = "⪤",
    gnE = "≩",
    gnap = "⪊",
    gnapprox = "⪊",
    gne = "⪈",
    gneq = "⪈",
    gneqq = "≩",
    gnsim = "⋧",
    gopf = "𝕘",
    grave = "`",
    gscr = "ℊ",
    gsim = "≳",
    gsime = "⪎",
    gsiml = "⪐",
    g$1 = ">",
    gt = ">",
    gtcc = "⪧",
    gtcir = "⩺",
    gtdot = "⋗",
    gtlPar = "⦕",
    gtquest = "⩼",
    gtrapprox = "⪆",
    gtrarr = "⥸",
    gtrdot = "⋗",
    gtreqless = "⋛",
    gtreqqless = "⪌",
    gtrless = "≷",
    gtrsim = "≳",
    gvertneqq = "≩︀",
    gvnE = "≩︀",
    hArr = "⇔",
    hairsp = " ",
    half = "½",
    hamilt = "ℋ",
    hardcy = "ъ",
    harr = "↔",
    harrcir = "⥈",
    harrw = "↭",
    hbar = "ℏ",
    hcirc = "ĥ",
    hearts = "♥",
    heartsuit = "♥",
    hellip = "…",
    hercon = "⊹",
    hfr = "𝔥",
    hksearow = "⤥",
    hkswarow = "⤦",
    hoarr = "⇿",
    homtht = "∻",
    hookleftarrow = "↩",
    hookrightarrow = "↪",
    hopf = "𝕙",
    horbar = "―",
    hscr = "𝒽",
    hslash = "ℏ",
    hstrok = "ħ",
    hybull = "⁃",
    hyphen = "‐",
    iacut = "í",
    iacute = "í",
    ic = "⁣",
    icir = "î",
    icirc = "î",
    icy = "и",
    iecy = "е",
    iexc = "¡",
    iexcl = "¡",
    iff = "⇔",
    ifr = "𝔦",
    igrav = "ì",
    igrave = "ì",
    ii = "ⅈ",
    iiiint = "⨌",
    iiint = "∭",
    iinfin = "⧜",
    iiota = "℩",
    ijlig = "ĳ",
    imacr = "ī",
    image = "ℑ",
    imagline = "ℐ",
    imagpart = "ℑ",
    imath = "ı",
    imof = "⊷",
    imped = "Ƶ",
    incare = "℅",
    infin = "∞",
    infintie = "⧝",
    inodot = "ı",
    int = "∫",
    intcal = "⊺",
    integers = "ℤ",
    intercal = "⊺",
    intlarhk = "⨗",
    intprod = "⨼",
    iocy = "ё",
    iogon = "į",
    iopf = "𝕚",
    iota = "ι",
    iprod = "⨼",
    iques = "¿",
    iquest = "¿",
    iscr = "𝒾",
    isin = "∈",
    isinE = "⋹",
    isindot = "⋵",
    isins = "⋴",
    isinsv = "⋳",
    isinv = "∈",
    it = "⁢",
    itilde = "ĩ",
    iukcy = "і",
    ium = "ï",
    iuml = "ï",
    jcirc = "ĵ",
    jcy = "й",
    jfr = "𝔧",
    jmath = "ȷ",
    jopf = "𝕛",
    jscr = "𝒿",
    jsercy = "ј",
    jukcy = "є",
    kappa = "κ",
    kappav = "ϰ",
    kcedil = "ķ",
    kcy = "к",
    kfr = "𝔨",
    kgreen = "ĸ",
    khcy = "х",
    kjcy = "ќ",
    kopf = "𝕜",
    kscr = "𝓀",
    lAarr = "⇚",
    lArr = "⇐",
    lAtail = "⤛",
    lBarr = "⤎",
    lE = "≦",
    lEg = "⪋",
    lHar = "⥢",
    lacute = "ĺ",
    laemptyv = "⦴",
    lagran = "ℒ",
    lambda = "λ",
    lang = "⟨",
    langd = "⦑",
    langle = "⟨",
    lap = "⪅",
    laqu = "«",
    laquo = "«",
    larr = "←",
    larrb = "⇤",
    larrbfs = "⤟",
    larrfs = "⤝",
    larrhk = "↩",
    larrlp = "↫",
    larrpl = "⤹",
    larrsim = "⥳",
    larrtl = "↢",
    lat = "⪫",
    latail = "⤙",
    late = "⪭",
    lates = "⪭︀",
    lbarr = "⤌",
    lbbrk = "❲",
    lbrace = "{",
    lbrack = "[",
    lbrke = "⦋",
    lbrksld = "⦏",
    lbrkslu = "⦍",
    lcaron = "ľ",
    lcedil = "ļ",
    lceil = "⌈",
    lcub = "{",
    lcy = "л",
    ldca = "⤶",
    ldquo = "“",
    ldquor = "„",
    ldrdhar = "⥧",
    ldrushar = "⥋",
    ldsh = "↲",
    le = "≤",
    leftarrow = "←",
    leftarrowtail = "↢",
    leftharpoondown = "↽",
    leftharpoonup = "↼",
    leftleftarrows = "⇇",
    leftrightarrow = "↔",
    leftrightarrows = "⇆",
    leftrightharpoons = "⇋",
    leftrightsquigarrow = "↭",
    leftthreetimes = "⋋",
    leg = "⋚",
    leq = "≤",
    leqq = "≦",
    leqslant = "⩽",
    les = "⩽",
    lescc = "⪨",
    lesdot = "⩿",
    lesdoto = "⪁",
    lesdotor = "⪃",
    lesg = "⋚︀",
    lesges = "⪓",
    lessapprox = "⪅",
    lessdot = "⋖",
    lesseqgtr = "⋚",
    lesseqqgtr = "⪋",
    lessgtr = "≶",
    lesssim = "≲",
    lfisht = "⥼",
    lfloor = "⌊",
    lfr = "𝔩",
    lg = "≶",
    lgE = "⪑",
    lhard = "↽",
    lharu = "↼",
    lharul = "⥪",
    lhblk = "▄",
    ljcy = "љ",
    ll = "≪",
    llarr = "⇇",
    llcorner = "⌞",
    llhard = "⥫",
    lltri = "◺",
    lmidot = "ŀ",
    lmoust = "⎰",
    lmoustache = "⎰",
    lnE = "≨",
    lnap = "⪉",
    lnapprox = "⪉",
    lne = "⪇",
    lneq = "⪇",
    lneqq = "≨",
    lnsim = "⋦",
    loang = "⟬",
    loarr = "⇽",
    lobrk = "⟦",
    longleftarrow = "⟵",
    longleftrightarrow = "⟷",
    longmapsto = "⟼",
    longrightarrow = "⟶",
    looparrowleft = "↫",
    looparrowright = "↬",
    lopar = "⦅",
    lopf = "𝕝",
    loplus = "⨭",
    lotimes = "⨴",
    lowast = "∗",
    lowbar = "_",
    loz = "◊",
    lozenge = "◊",
    lozf = "⧫",
    lpar = "(",
    lparlt = "⦓",
    lrarr = "⇆",
    lrcorner = "⌟",
    lrhar = "⇋",
    lrhard = "⥭",
    lrm = "‎",
    lrtri = "⊿",
    lsaquo = "‹",
    lscr = "𝓁",
    lsh = "↰",
    lsim = "≲",
    lsime = "⪍",
    lsimg = "⪏",
    lsqb = "[",
    lsquo = "‘",
    lsquor = "‚",
    lstrok = "ł",
    l$1 = "<",
    lt = "<",
    ltcc = "⪦",
    ltcir = "⩹",
    ltdot = "⋖",
    lthree = "⋋",
    ltimes = "⋉",
    ltlarr = "⥶",
    ltquest = "⩻",
    ltrPar = "⦖",
    ltri = "◃",
    ltrie = "⊴",
    ltrif = "◂",
    lurdshar = "⥊",
    luruhar = "⥦",
    lvertneqq = "≨︀",
    lvnE = "≨︀",
    mDDot = "∺",
    mac = "¯",
    macr = "¯",
    male = "♂",
    malt = "✠",
    maltese = "✠",
    map = "↦",
    mapsto = "↦",
    mapstodown = "↧",
    mapstoleft = "↤",
    mapstoup = "↥",
    marker = "▮",
    mcomma = "⨩",
    mcy = "м",
    mdash = "—",
    measuredangle = "∡",
    mfr = "𝔪",
    mho = "℧",
    micr = "µ",
    micro = "µ",
    mid = "∣",
    midast = "*",
    midcir = "⫰",
    middo = "·",
    middot = "·",
    minus = "−",
    minusb = "⊟",
    minusd = "∸",
    minusdu = "⨪",
    mlcp = "⫛",
    mldr = "…",
    mnplus = "∓",
    models = "⊧",
    mopf = "𝕞",
    mp = "∓",
    mscr = "𝓂",
    mstpos = "∾",
    mu = "μ",
    multimap = "⊸",
    mumap = "⊸",
    nGg = "⋙̸",
    nGt = "≫⃒",
    nGtv = "≫̸",
    nLeftarrow = "⇍",
    nLeftrightarrow = "⇎",
    nLl = "⋘̸",
    nLt = "≪⃒",
    nLtv = "≪̸",
    nRightarrow = "⇏",
    nVDash = "⊯",
    nVdash = "⊮",
    nabla = "∇",
    nacute = "ń",
    nang = "∠⃒",
    nap = "≉",
    napE = "⩰̸",
    napid = "≋̸",
    napos = "ŉ",
    napprox = "≉",
    natur = "♮",
    natural = "♮",
    naturals = "ℕ",
    nbs = " ",
    nbsp = " ",
    nbump = "≎̸",
    nbumpe = "≏̸",
    ncap = "⩃",
    ncaron = "ň",
    ncedil = "ņ",
    ncong = "≇",
    ncongdot = "⩭̸",
    ncup = "⩂",
    ncy = "н",
    ndash = "–",
    ne = "≠",
    neArr = "⇗",
    nearhk = "⤤",
    nearr = "↗",
    nearrow = "↗",
    nedot = "≐̸",
    nequiv = "≢",
    nesear = "⤨",
    nesim = "≂̸",
    nexist = "∄",
    nexists = "∄",
    nfr = "𝔫",
    ngE = "≧̸",
    nge = "≱",
    ngeq = "≱",
    ngeqq = "≧̸",
    ngeqslant = "⩾̸",
    nges = "⩾̸",
    ngsim = "≵",
    ngt = "≯",
    ngtr = "≯",
    nhArr = "⇎",
    nharr = "↮",
    nhpar = "⫲",
    ni = "∋",
    nis = "⋼",
    nisd = "⋺",
    niv = "∋",
    njcy = "њ",
    nlArr = "⇍",
    nlE = "≦̸",
    nlarr = "↚",
    nldr = "‥",
    nle = "≰",
    nleftarrow = "↚",
    nleftrightarrow = "↮",
    nleq = "≰",
    nleqq = "≦̸",
    nleqslant = "⩽̸",
    nles = "⩽̸",
    nless = "≮",
    nlsim = "≴",
    nlt = "≮",
    nltri = "⋪",
    nltrie = "⋬",
    nmid = "∤",
    nopf = "𝕟",
    no = "¬",
    not = "¬",
    notin = "∉",
    notinE = "⋹̸",
    notindot = "⋵̸",
    notinva = "∉",
    notinvb = "⋷",
    notinvc = "⋶",
    notni = "∌",
    notniva = "∌",
    notnivb = "⋾",
    notnivc = "⋽",
    npar = "∦",
    nparallel = "∦",
    nparsl = "⫽⃥",
    npart = "∂̸",
    npolint = "⨔",
    npr = "⊀",
    nprcue = "⋠",
    npre = "⪯̸",
    nprec = "⊀",
    npreceq = "⪯̸",
    nrArr = "⇏",
    nrarr = "↛",
    nrarrc = "⤳̸",
    nrarrw = "↝̸",
    nrightarrow = "↛",
    nrtri = "⋫",
    nrtrie = "⋭",
    nsc = "⊁",
    nsccue = "⋡",
    nsce = "⪰̸",
    nscr = "𝓃",
    nshortmid = "∤",
    nshortparallel = "∦",
    nsim = "≁",
    nsime = "≄",
    nsimeq = "≄",
    nsmid = "∤",
    nspar = "∦",
    nsqsube = "⋢",
    nsqsupe = "⋣",
    nsub = "⊄",
    nsubE = "⫅̸",
    nsube = "⊈",
    nsubset = "⊂⃒",
    nsubseteq = "⊈",
    nsubseteqq = "⫅̸",
    nsucc = "⊁",
    nsucceq = "⪰̸",
    nsup = "⊅",
    nsupE = "⫆̸",
    nsupe = "⊉",
    nsupset = "⊃⃒",
    nsupseteq = "⊉",
    nsupseteqq = "⫆̸",
    ntgl = "≹",
    ntild = "ñ",
    ntilde = "ñ",
    ntlg = "≸",
    ntriangleleft = "⋪",
    ntrianglelefteq = "⋬",
    ntriangleright = "⋫",
    ntrianglerighteq = "⋭",
    nu = "ν",
    num = "#",
    numero = "№",
    numsp = " ",
    nvDash = "⊭",
    nvHarr = "⤄",
    nvap = "≍⃒",
    nvdash = "⊬",
    nvge = "≥⃒",
    nvgt = ">⃒",
    nvinfin = "⧞",
    nvlArr = "⤂",
    nvle = "≤⃒",
    nvlt = "<⃒",
    nvltrie = "⊴⃒",
    nvrArr = "⤃",
    nvrtrie = "⊵⃒",
    nvsim = "∼⃒",
    nwArr = "⇖",
    nwarhk = "⤣",
    nwarr = "↖",
    nwarrow = "↖",
    nwnear = "⤧",
    oS = "Ⓢ",
    oacut = "ó",
    oacute = "ó",
    oast = "⊛",
    ocir = "ô",
    ocirc = "ô",
    ocy = "о",
    odash = "⊝",
    odblac = "ő",
    odiv = "⨸",
    odot = "⊙",
    odsold = "⦼",
    oelig = "œ",
    ofcir = "⦿",
    ofr = "𝔬",
    ogon = "˛",
    ograv = "ò",
    ograve = "ò",
    ogt = "⧁",
    ohbar = "⦵",
    ohm = "Ω",
    oint = "∮",
    olarr = "↺",
    olcir = "⦾",
    olcross = "⦻",
    oline = "‾",
    olt = "⧀",
    omacr = "ō",
    omega = "ω",
    omicron = "ο",
    omid = "⦶",
    ominus = "⊖",
    oopf = "𝕠",
    opar = "⦷",
    operp = "⦹",
    oplus = "⊕",
    or = "∨",
    orarr = "↻",
    ord = "º",
    order$1 = "ℴ",
    orderof = "ℴ",
    ordf = "ª",
    ordm = "º",
    origof = "⊶",
    oror = "⩖",
    orslope = "⩗",
    orv = "⩛",
    oscr = "ℴ",
    oslas = "ø",
    oslash = "ø",
    osol = "⊘",
    otild = "õ",
    otilde = "õ",
    otimes = "⊗",
    otimesas = "⨶",
    oum = "ö",
    ouml = "ö",
    ovbar = "⌽",
    par = "¶",
    para = "¶",
    parallel = "∥",
    parsim = "⫳",
    parsl = "⫽",
    part = "∂",
    pcy = "п",
    percnt = "%",
    period = ".",
    permil = "‰",
    perp = "⊥",
    pertenk = "‱",
    pfr = "𝔭",
    phi = "φ",
    phiv = "ϕ",
    phmmat = "ℳ",
    phone = "☎",
    pi = "π",
    pitchfork = "⋔",
    piv = "ϖ",
    planck = "ℏ",
    planckh = "ℎ",
    plankv = "ℏ",
    plus = "+",
    plusacir = "⨣",
    plusb = "⊞",
    pluscir = "⨢",
    plusdo = "∔",
    plusdu = "⨥",
    pluse = "⩲",
    plusm = "±",
    plusmn = "±",
    plussim = "⨦",
    plustwo = "⨧",
    pm = "±",
    pointint = "⨕",
    popf = "𝕡",
    poun = "£",
    pound = "£",
    pr = "≺",
    prE = "⪳",
    prap = "⪷",
    prcue = "≼",
    pre = "⪯",
    prec = "≺",
    precapprox = "⪷",
    preccurlyeq = "≼",
    preceq = "⪯",
    precnapprox = "⪹",
    precneqq = "⪵",
    precnsim = "⋨",
    precsim = "≾",
    prime = "′",
    primes = "ℙ",
    prnE = "⪵",
    prnap = "⪹",
    prnsim = "⋨",
    prod = "∏",
    profalar = "⌮",
    profline = "⌒",
    profsurf = "⌓",
    prop = "∝",
    propto = "∝",
    prsim = "≾",
    prurel = "⊰",
    pscr = "𝓅",
    psi = "ψ",
    puncsp = " ",
    qfr = "𝔮",
    qint = "⨌",
    qopf = "𝕢",
    qprime = "⁗",
    qscr = "𝓆",
    quaternions = "ℍ",
    quatint = "⨖",
    quest = "?",
    questeq = "≟",
    quo = '"',
    quot = '"',
    rAarr = "⇛",
    rArr = "⇒",
    rAtail = "⤜",
    rBarr = "⤏",
    rHar = "⥤",
    race = "∽̱",
    racute = "ŕ",
    radic = "√",
    raemptyv = "⦳",
    rang = "⟩",
    rangd = "⦒",
    range = "⦥",
    rangle = "⟩",
    raqu = "»",
    raquo = "»",
    rarr = "→",
    rarrap = "⥵",
    rarrb = "⇥",
    rarrbfs = "⤠",
    rarrc = "⤳",
    rarrfs = "⤞",
    rarrhk = "↪",
    rarrlp = "↬",
    rarrpl = "⥅",
    rarrsim = "⥴",
    rarrtl = "↣",
    rarrw = "↝",
    ratail = "⤚",
    ratio = "∶",
    rationals = "ℚ",
    rbarr = "⤍",
    rbbrk = "❳",
    rbrace = "}",
    rbrack = "]",
    rbrke = "⦌",
    rbrksld = "⦎",
    rbrkslu = "⦐",
    rcaron = "ř",
    rcedil = "ŗ",
    rceil = "⌉",
    rcub = "}",
    rcy = "р",
    rdca = "⤷",
    rdldhar = "⥩",
    rdquo = "”",
    rdquor = "”",
    rdsh = "↳",
    real = "ℜ",
    realine = "ℛ",
    realpart = "ℜ",
    reals = "ℝ",
    rect = "▭",
    re = "®",
    reg = "®",
    rfisht = "⥽",
    rfloor = "⌋",
    rfr = "𝔯",
    rhard = "⇁",
    rharu = "⇀",
    rharul = "⥬",
    rho = "ρ",
    rhov = "ϱ",
    rightarrow = "→",
    rightarrowtail = "↣",
    rightharpoondown = "⇁",
    rightharpoonup = "⇀",
    rightleftarrows = "⇄",
    rightleftharpoons = "⇌",
    rightrightarrows = "⇉",
    rightsquigarrow = "↝",
    rightthreetimes = "⋌",
    ring = "˚",
    risingdotseq = "≓",
    rlarr = "⇄",
    rlhar = "⇌",
    rlm = "‏",
    rmoust = "⎱",
    rmoustache = "⎱",
    rnmid = "⫮",
    roang = "⟭",
    roarr = "⇾",
    robrk = "⟧",
    ropar = "⦆",
    ropf = "𝕣",
    roplus = "⨮",
    rotimes = "⨵",
    rpar = ")",
    rpargt = "⦔",
    rppolint = "⨒",
    rrarr = "⇉",
    rsaquo = "›",
    rscr = "𝓇",
    rsh = "↱",
    rsqb = "]",
    rsquo = "’",
    rsquor = "’",
    rthree = "⋌",
    rtimes = "⋊",
    rtri = "▹",
    rtrie = "⊵",
    rtrif = "▸",
    rtriltri = "⧎",
    ruluhar = "⥨",
    rx = "℞",
    sacute = "ś",
    sbquo = "‚",
    sc = "≻",
    scE = "⪴",
    scap = "⪸",
    scaron = "š",
    sccue = "≽",
    sce = "⪰",
    scedil = "ş",
    scirc = "ŝ",
    scnE = "⪶",
    scnap = "⪺",
    scnsim = "⋩",
    scpolint = "⨓",
    scsim = "≿",
    scy = "с",
    sdot = "⋅",
    sdotb = "⊡",
    sdote = "⩦",
    seArr = "⇘",
    searhk = "⤥",
    searr = "↘",
    searrow = "↘",
    sec = "§",
    sect = "§",
    semi = ";",
    seswar = "⤩",
    setminus = "∖",
    setmn = "∖",
    sext = "✶",
    sfr = "𝔰",
    sfrown = "⌢",
    sharp = "♯",
    shchcy = "щ",
    shcy = "ш",
    shortmid = "∣",
    shortparallel = "∥",
    sh = "­",
    shy = "­",
    sigma = "σ",
    sigmaf = "ς",
    sigmav = "ς",
    sim = "∼",
    simdot = "⩪",
    sime = "≃",
    simeq = "≃",
    simg = "⪞",
    simgE = "⪠",
    siml = "⪝",
    simlE = "⪟",
    simne = "≆",
    simplus = "⨤",
    simrarr = "⥲",
    slarr = "←",
    smallsetminus = "∖",
    smashp = "⨳",
    smeparsl = "⧤",
    smid = "∣",
    smile = "⌣",
    smt = "⪪",
    smte = "⪬",
    smtes = "⪬︀",
    softcy = "ь",
    sol = "/",
    solb = "⧄",
    solbar = "⌿",
    sopf = "𝕤",
    spades = "♠",
    spadesuit = "♠",
    spar = "∥",
    sqcap = "⊓",
    sqcaps = "⊓︀",
    sqcup = "⊔",
    sqcups = "⊔︀",
    sqsub = "⊏",
    sqsube = "⊑",
    sqsubset = "⊏",
    sqsubseteq = "⊑",
    sqsup = "⊐",
    sqsupe = "⊒",
    sqsupset = "⊐",
    sqsupseteq = "⊒",
    squ = "□",
    square = "□",
    squarf = "▪",
    squf = "▪",
    srarr = "→",
    sscr = "𝓈",
    ssetmn = "∖",
    ssmile = "⌣",
    sstarf = "⋆",
    star = "☆",
    starf = "★",
    straightepsilon = "ϵ",
    straightphi = "ϕ",
    strns = "¯",
    sub = "⊂",
    subE = "⫅",
    subdot = "⪽",
    sube = "⊆",
    subedot = "⫃",
    submult = "⫁",
    subnE = "⫋",
    subne = "⊊",
    subplus = "⪿",
    subrarr = "⥹",
    subset = "⊂",
    subseteq = "⊆",
    subseteqq = "⫅",
    subsetneq = "⊊",
    subsetneqq = "⫋",
    subsim = "⫇",
    subsub = "⫕",
    subsup = "⫓",
    succ = "≻",
    succapprox = "⪸",
    succcurlyeq = "≽",
    succeq = "⪰",
    succnapprox = "⪺",
    succneqq = "⪶",
    succnsim = "⋩",
    succsim = "≿",
    sum = "∑",
    sung = "♪",
    sup = "⊃",
    sup1 = "¹",
    sup2 = "²",
    sup3 = "³",
    supE = "⫆",
    supdot = "⪾",
    supdsub = "⫘",
    supe = "⊇",
    supedot = "⫄",
    suphsol = "⟉",
    suphsub = "⫗",
    suplarr = "⥻",
    supmult = "⫂",
    supnE = "⫌",
    supne = "⊋",
    supplus = "⫀",
    supset = "⊃",
    supseteq = "⊇",
    supseteqq = "⫆",
    supsetneq = "⊋",
    supsetneqq = "⫌",
    supsim = "⫈",
    supsub = "⫔",
    supsup = "⫖",
    swArr = "⇙",
    swarhk = "⤦",
    swarr = "↙",
    swarrow = "↙",
    swnwar = "⤪",
    szli = "ß",
    szlig = "ß",
    target = "⌖",
    tau = "τ",
    tbrk = "⎴",
    tcaron = "ť",
    tcedil = "ţ",
    tcy = "т",
    tdot = "⃛",
    telrec = "⌕",
    tfr = "𝔱",
    there4 = "∴",
    therefore = "∴",
    theta = "θ",
    thetasym = "ϑ",
    thetav = "ϑ",
    thickapprox = "≈",
    thicksim = "∼",
    thinsp = " ",
    thkap = "≈",
    thksim = "∼",
    thor = "þ",
    thorn = "þ",
    tilde = "˜",
    time = "×",
    times = "×",
    timesb = "⊠",
    timesbar = "⨱",
    timesd = "⨰",
    tint = "∭",
    toea = "⤨",
    top$1 = "⊤",
    topbot = "⌶",
    topcir = "⫱",
    topf = "𝕥",
    topfork = "⫚",
    tosa = "⤩",
    tprime = "‴",
    trade = "™",
    triangle = "▵",
    triangledown = "▿",
    triangleleft = "◃",
    trianglelefteq = "⊴",
    triangleq = "≜",
    triangleright = "▹",
    trianglerighteq = "⊵",
    tridot = "◬",
    trie = "≜",
    triminus = "⨺",
    triplus = "⨹",
    trisb = "⧍",
    tritime = "⨻",
    trpezium = "⏢",
    tscr = "𝓉",
    tscy = "ц",
    tshcy = "ћ",
    tstrok = "ŧ",
    twixt = "≬",
    twoheadleftarrow = "↞",
    twoheadrightarrow = "↠",
    uArr = "⇑",
    uHar = "⥣",
    uacut = "ú",
    uacute = "ú",
    uarr = "↑",
    ubrcy = "ў",
    ubreve = "ŭ",
    ucir = "û",
    ucirc = "û",
    ucy = "у",
    udarr = "⇅",
    udblac = "ű",
    udhar = "⥮",
    ufisht = "⥾",
    ufr = "𝔲",
    ugrav = "ù",
    ugrave = "ù",
    uharl = "↿",
    uharr = "↾",
    uhblk = "▀",
    ulcorn = "⌜",
    ulcorner = "⌜",
    ulcrop = "⌏",
    ultri = "◸",
    umacr = "ū",
    um = "¨",
    uml = "¨",
    uogon = "ų",
    uopf = "𝕦",
    uparrow = "↑",
    updownarrow = "↕",
    upharpoonleft = "↿",
    upharpoonright = "↾",
    uplus = "⊎",
    upsi = "υ",
    upsih = "ϒ",
    upsilon = "υ",
    upuparrows = "⇈",
    urcorn = "⌝",
    urcorner = "⌝",
    urcrop = "⌎",
    uring = "ů",
    urtri = "◹",
    uscr = "𝓊",
    utdot = "⋰",
    utilde = "ũ",
    utri = "▵",
    utrif = "▴",
    uuarr = "⇈",
    uum = "ü",
    uuml = "ü",
    uwangle = "⦧",
    vArr = "⇕",
    vBar = "⫨",
    vBarv = "⫩",
    vDash = "⊨",
    vangrt = "⦜",
    varepsilon = "ϵ",
    varkappa = "ϰ",
    varnothing = "∅",
    varphi = "ϕ",
    varpi = "ϖ",
    varpropto = "∝",
    varr = "↕",
    varrho = "ϱ",
    varsigma = "ς",
    varsubsetneq = "⊊︀",
    varsubsetneqq = "⫋︀",
    varsupsetneq = "⊋︀",
    varsupsetneqq = "⫌︀",
    vartheta = "ϑ",
    vartriangleleft = "⊲",
    vartriangleright = "⊳",
    vcy = "в",
    vdash = "⊢",
    vee = "∨",
    veebar = "⊻",
    veeeq = "≚",
    vellip = "⋮",
    verbar = "|",
    vert = "|",
    vfr = "𝔳",
    vltri = "⊲",
    vnsub = "⊂⃒",
    vnsup = "⊃⃒",
    vopf = "𝕧",
    vprop = "∝",
    vrtri = "⊳",
    vscr = "𝓋",
    vsubnE = "⫋︀",
    vsubne = "⊊︀",
    vsupnE = "⫌︀",
    vsupne = "⊋︀",
    vzigzag = "⦚",
    wcirc = "ŵ",
    wedbar = "⩟",
    wedge = "∧",
    wedgeq = "≙",
    weierp = "℘",
    wfr = "𝔴",
    wopf = "𝕨",
    wp = "℘",
    wr = "≀",
    wreath = "≀",
    wscr = "𝓌",
    xcap = "⋂",
    xcirc = "◯",
    xcup = "⋃",
    xdtri = "▽",
    xfr = "𝔵",
    xhArr = "⟺",
    xharr = "⟷",
    xi = "ξ",
    xlArr = "⟸",
    xlarr = "⟵",
    xmap = "⟼",
    xnis = "⋻",
    xodot = "⨀",
    xopf = "𝕩",
    xoplus = "⨁",
    xotime = "⨂",
    xrArr = "⟹",
    xrarr = "⟶",
    xscr = "𝓍",
    xsqcup = "⨆",
    xuplus = "⨄",
    xutri = "△",
    xvee = "⋁",
    xwedge = "⋀",
    yacut = "ý",
    yacute = "ý",
    yacy = "я",
    ycirc = "ŷ",
    ycy = "ы",
    ye = "¥",
    yen = "¥",
    yfr = "𝔶",
    yicy = "ї",
    yopf = "𝕪",
    yscr = "𝓎",
    yucy = "ю",
    yum = "ÿ",
    yuml = "ÿ",
    zacute = "ź",
    zcaron = "ž",
    zcy = "з",
    zdot = "ż",
    zeetrf = "ℨ",
    zeta = "ζ",
    zfr = "𝔷",
    zhcy = "ж",
    zigrarr = "⇝",
    zopf = "𝕫",
    zscr = "𝓏",
    zwj = "‍",
    zwnj = "‌",
    require$$0$1 = {
  AEli: AEli,
  AElig: AElig,
  AM: AM,
  AMP: AMP,
  Aacut: Aacut,
  Aacute: Aacute,
  Abreve: Abreve,
  Acir: Acir,
  Acirc: Acirc,
  Acy: Acy,
  Afr: Afr,
  Agrav: Agrav,
  Agrave: Agrave,
  Alpha: Alpha,
  Amacr: Amacr,
  And: And,
  Aogon: Aogon,
  Aopf: Aopf,
  ApplyFunction: ApplyFunction,
  Arin: Arin,
  Aring: Aring,
  Ascr: Ascr,
  Assign: Assign,
  Atild: Atild,
  Atilde: Atilde,
  Aum: Aum,
  Auml: Auml,
  Backslash: Backslash,
  Barv: Barv,
  Barwed: Barwed,
  Bcy: Bcy,
  Because: Because,
  Bernoullis: Bernoullis,
  Beta: Beta,
  Bfr: Bfr,
  Bopf: Bopf,
  Breve: Breve,
  Bscr: Bscr,
  Bumpeq: Bumpeq,
  CHcy: CHcy,
  COP: COP,
  COPY: COPY,
  Cacute: Cacute,
  Cap: Cap,
  CapitalDifferentialD: CapitalDifferentialD,
  Cayleys: Cayleys,
  Ccaron: Ccaron,
  Ccedi: Ccedi,
  Ccedil: Ccedil,
  Ccirc: Ccirc,
  Cconint: Cconint,
  Cdot: Cdot,
  Cedilla: Cedilla,
  CenterDot: CenterDot,
  Cfr: Cfr,
  Chi: Chi,
  CircleDot: CircleDot,
  CircleMinus: CircleMinus,
  CirclePlus: CirclePlus,
  CircleTimes: CircleTimes,
  ClockwiseContourIntegral: ClockwiseContourIntegral,
  CloseCurlyDoubleQuote: CloseCurlyDoubleQuote,
  CloseCurlyQuote: CloseCurlyQuote,
  Colon: Colon,
  Colone: Colone,
  Congruent: Congruent,
  Conint: Conint,
  ContourIntegral: ContourIntegral,
  Copf: Copf,
  Coproduct: Coproduct,
  CounterClockwiseContourIntegral: CounterClockwiseContourIntegral,
  Cross: Cross,
  Cscr: Cscr,
  Cup: Cup,
  CupCap: CupCap,
  DD: DD,
  DDotrahd: DDotrahd,
  DJcy: DJcy,
  DScy: DScy,
  DZcy: DZcy,
  Dagger: Dagger,
  Darr: Darr,
  Dashv: Dashv,
  Dcaron: Dcaron,
  Dcy: Dcy,
  Del: Del,
  Delta: Delta,
  Dfr: Dfr,
  DiacriticalAcute: DiacriticalAcute,
  DiacriticalDot: DiacriticalDot,
  DiacriticalDoubleAcute: DiacriticalDoubleAcute,
  DiacriticalGrave: DiacriticalGrave,
  DiacriticalTilde: DiacriticalTilde,
  Diamond: Diamond,
  DifferentialD: DifferentialD,
  Dopf: Dopf,
  Dot: Dot,
  DotDot: DotDot,
  DotEqual: DotEqual,
  DoubleContourIntegral: DoubleContourIntegral,
  DoubleDot: DoubleDot,
  DoubleDownArrow: DoubleDownArrow,
  DoubleLeftArrow: DoubleLeftArrow,
  DoubleLeftRightArrow: DoubleLeftRightArrow,
  DoubleLeftTee: DoubleLeftTee,
  DoubleLongLeftArrow: DoubleLongLeftArrow,
  DoubleLongLeftRightArrow: DoubleLongLeftRightArrow,
  DoubleLongRightArrow: DoubleLongRightArrow,
  DoubleRightArrow: DoubleRightArrow,
  DoubleRightTee: DoubleRightTee,
  DoubleUpArrow: DoubleUpArrow,
  DoubleUpDownArrow: DoubleUpDownArrow,
  DoubleVerticalBar: DoubleVerticalBar,
  DownArrow: DownArrow,
  DownArrowBar: DownArrowBar,
  DownArrowUpArrow: DownArrowUpArrow,
  DownBreve: DownBreve,
  DownLeftRightVector: DownLeftRightVector,
  DownLeftTeeVector: DownLeftTeeVector,
  DownLeftVector: DownLeftVector,
  DownLeftVectorBar: DownLeftVectorBar,
  DownRightTeeVector: DownRightTeeVector,
  DownRightVector: DownRightVector,
  DownRightVectorBar: DownRightVectorBar,
  DownTee: DownTee,
  DownTeeArrow: DownTeeArrow,
  Downarrow: Downarrow,
  Dscr: Dscr,
  Dstrok: Dstrok,
  ENG: ENG,
  ET: ET,
  ETH: ETH,
  Eacut: Eacut,
  Eacute: Eacute,
  Ecaron: Ecaron,
  Ecir: Ecir,
  Ecirc: Ecirc,
  Ecy: Ecy,
  Edot: Edot,
  Efr: Efr,
  Egrav: Egrav,
  Egrave: Egrave,
  Element: Element$1,
  Emacr: Emacr,
  EmptySmallSquare: EmptySmallSquare,
  EmptyVerySmallSquare: EmptyVerySmallSquare,
  Eogon: Eogon,
  Eopf: Eopf,
  Epsilon: Epsilon,
  Equal: Equal,
  EqualTilde: EqualTilde,
  Equilibrium: Equilibrium,
  Escr: Escr,
  Esim: Esim,
  Eta: Eta,
  Eum: Eum,
  Euml: Euml,
  Exists: Exists,
  ExponentialE: ExponentialE,
  Fcy: Fcy,
  Ffr: Ffr,
  FilledSmallSquare: FilledSmallSquare,
  FilledVerySmallSquare: FilledVerySmallSquare,
  Fopf: Fopf,
  ForAll: ForAll,
  Fouriertrf: Fouriertrf,
  Fscr: Fscr,
  GJcy: GJcy,
  G: G,
  GT: GT,
  Gamma: Gamma,
  Gammad: Gammad,
  Gbreve: Gbreve,
  Gcedil: Gcedil,
  Gcirc: Gcirc,
  Gcy: Gcy,
  Gdot: Gdot,
  Gfr: Gfr,
  Gg: Gg,
  Gopf: Gopf,
  GreaterEqual: GreaterEqual,
  GreaterEqualLess: GreaterEqualLess,
  GreaterFullEqual: GreaterFullEqual,
  GreaterGreater: GreaterGreater,
  GreaterLess: GreaterLess,
  GreaterSlantEqual: GreaterSlantEqual,
  GreaterTilde: GreaterTilde,
  Gscr: Gscr,
  Gt: Gt,
  HARDcy: HARDcy,
  Hacek: Hacek,
  Hat: Hat,
  Hcirc: Hcirc,
  Hfr: Hfr,
  HilbertSpace: HilbertSpace,
  Hopf: Hopf,
  HorizontalLine: HorizontalLine,
  Hscr: Hscr,
  Hstrok: Hstrok,
  HumpDownHump: HumpDownHump,
  HumpEqual: HumpEqual,
  IEcy: IEcy,
  IJlig: IJlig,
  IOcy: IOcy,
  Iacut: Iacut,
  Iacute: Iacute,
  Icir: Icir,
  Icirc: Icirc,
  Icy: Icy,
  Idot: Idot,
  Ifr: Ifr,
  Igrav: Igrav,
  Igrave: Igrave,
  Im: Im,
  Imacr: Imacr,
  ImaginaryI: ImaginaryI,
  Implies: Implies,
  Int: Int,
  Integral: Integral,
  Intersection: Intersection,
  InvisibleComma: InvisibleComma,
  InvisibleTimes: InvisibleTimes,
  Iogon: Iogon,
  Iopf: Iopf,
  Iota: Iota,
  Iscr: Iscr,
  Itilde: Itilde,
  Iukcy: Iukcy,
  Ium: Ium,
  Iuml: Iuml,
  Jcirc: Jcirc,
  Jcy: Jcy,
  Jfr: Jfr,
  Jopf: Jopf,
  Jscr: Jscr,
  Jsercy: Jsercy,
  Jukcy: Jukcy,
  KHcy: KHcy,
  KJcy: KJcy,
  Kappa: Kappa,
  Kcedil: Kcedil,
  Kcy: Kcy,
  Kfr: Kfr,
  Kopf: Kopf,
  Kscr: Kscr,
  LJcy: LJcy,
  L: L,
  LT: LT,
  Lacute: Lacute,
  Lambda: Lambda,
  Lang: Lang,
  Laplacetrf: Laplacetrf,
  Larr: Larr,
  Lcaron: Lcaron,
  Lcedil: Lcedil,
  Lcy: Lcy,
  LeftAngleBracket: LeftAngleBracket,
  LeftArrow: LeftArrow,
  LeftArrowBar: LeftArrowBar,
  LeftArrowRightArrow: LeftArrowRightArrow,
  LeftCeiling: LeftCeiling,
  LeftDoubleBracket: LeftDoubleBracket,
  LeftDownTeeVector: LeftDownTeeVector,
  LeftDownVector: LeftDownVector,
  LeftDownVectorBar: LeftDownVectorBar,
  LeftFloor: LeftFloor,
  LeftRightArrow: LeftRightArrow,
  LeftRightVector: LeftRightVector,
  LeftTee: LeftTee,
  LeftTeeArrow: LeftTeeArrow,
  LeftTeeVector: LeftTeeVector,
  LeftTriangle: LeftTriangle,
  LeftTriangleBar: LeftTriangleBar,
  LeftTriangleEqual: LeftTriangleEqual,
  LeftUpDownVector: LeftUpDownVector,
  LeftUpTeeVector: LeftUpTeeVector,
  LeftUpVector: LeftUpVector,
  LeftUpVectorBar: LeftUpVectorBar,
  LeftVector: LeftVector,
  LeftVectorBar: LeftVectorBar,
  Leftarrow: Leftarrow,
  Leftrightarrow: Leftrightarrow,
  LessEqualGreater: LessEqualGreater,
  LessFullEqual: LessFullEqual,
  LessGreater: LessGreater,
  LessLess: LessLess,
  LessSlantEqual: LessSlantEqual,
  LessTilde: LessTilde,
  Lfr: Lfr,
  Ll: Ll,
  Lleftarrow: Lleftarrow,
  Lmidot: Lmidot,
  LongLeftArrow: LongLeftArrow,
  LongLeftRightArrow: LongLeftRightArrow,
  LongRightArrow: LongRightArrow,
  Longleftarrow: Longleftarrow,
  Longleftrightarrow: Longleftrightarrow,
  Longrightarrow: Longrightarrow,
  Lopf: Lopf,
  LowerLeftArrow: LowerLeftArrow,
  LowerRightArrow: LowerRightArrow,
  Lscr: Lscr,
  Lsh: Lsh,
  Lstrok: Lstrok,
  Lt: Lt,
  Map: "⤅",
  Mcy: Mcy,
  MediumSpace: MediumSpace,
  Mellintrf: Mellintrf,
  Mfr: Mfr,
  MinusPlus: MinusPlus,
  Mopf: Mopf,
  Mscr: Mscr,
  Mu: Mu,
  NJcy: NJcy,
  Nacute: Nacute,
  Ncaron: Ncaron,
  Ncedil: Ncedil,
  Ncy: Ncy,
  NegativeMediumSpace: NegativeMediumSpace,
  NegativeThickSpace: NegativeThickSpace,
  NegativeThinSpace: NegativeThinSpace,
  NegativeVeryThinSpace: NegativeVeryThinSpace,
  NestedGreaterGreater: NestedGreaterGreater,
  NestedLessLess: NestedLessLess,
  NewLine: NewLine,
  Nfr: Nfr,
  NoBreak: NoBreak,
  NonBreakingSpace: NonBreakingSpace,
  Nopf: Nopf,
  Not: Not,
  NotCongruent: NotCongruent,
  NotCupCap: NotCupCap,
  NotDoubleVerticalBar: NotDoubleVerticalBar,
  NotElement: NotElement,
  NotEqual: NotEqual,
  NotEqualTilde: NotEqualTilde,
  NotExists: NotExists,
  NotGreater: NotGreater,
  NotGreaterEqual: NotGreaterEqual,
  NotGreaterFullEqual: NotGreaterFullEqual,
  NotGreaterGreater: NotGreaterGreater,
  NotGreaterLess: NotGreaterLess,
  NotGreaterSlantEqual: NotGreaterSlantEqual,
  NotGreaterTilde: NotGreaterTilde,
  NotHumpDownHump: NotHumpDownHump,
  NotHumpEqual: NotHumpEqual,
  NotLeftTriangle: NotLeftTriangle,
  NotLeftTriangleBar: NotLeftTriangleBar,
  NotLeftTriangleEqual: NotLeftTriangleEqual,
  NotLess: NotLess,
  NotLessEqual: NotLessEqual,
  NotLessGreater: NotLessGreater,
  NotLessLess: NotLessLess,
  NotLessSlantEqual: NotLessSlantEqual,
  NotLessTilde: NotLessTilde,
  NotNestedGreaterGreater: NotNestedGreaterGreater,
  NotNestedLessLess: NotNestedLessLess,
  NotPrecedes: NotPrecedes,
  NotPrecedesEqual: NotPrecedesEqual,
  NotPrecedesSlantEqual: NotPrecedesSlantEqual,
  NotReverseElement: NotReverseElement,
  NotRightTriangle: NotRightTriangle,
  NotRightTriangleBar: NotRightTriangleBar,
  NotRightTriangleEqual: NotRightTriangleEqual,
  NotSquareSubset: NotSquareSubset,
  NotSquareSubsetEqual: NotSquareSubsetEqual,
  NotSquareSuperset: NotSquareSuperset,
  NotSquareSupersetEqual: NotSquareSupersetEqual,
  NotSubset: NotSubset,
  NotSubsetEqual: NotSubsetEqual,
  NotSucceeds: NotSucceeds,
  NotSucceedsEqual: NotSucceedsEqual,
  NotSucceedsSlantEqual: NotSucceedsSlantEqual,
  NotSucceedsTilde: NotSucceedsTilde,
  NotSuperset: NotSuperset,
  NotSupersetEqual: NotSupersetEqual,
  NotTilde: NotTilde,
  NotTildeEqual: NotTildeEqual,
  NotTildeFullEqual: NotTildeFullEqual,
  NotTildeTilde: NotTildeTilde,
  NotVerticalBar: NotVerticalBar,
  Nscr: Nscr,
  Ntild: Ntild,
  Ntilde: Ntilde,
  Nu: Nu,
  OElig: OElig,
  Oacut: Oacut,
  Oacute: Oacute,
  Ocir: Ocir,
  Ocirc: Ocirc,
  Ocy: Ocy,
  Odblac: Odblac,
  Ofr: Ofr,
  Ograv: Ograv,
  Ograve: Ograve,
  Omacr: Omacr,
  Omega: Omega,
  Omicron: Omicron,
  Oopf: Oopf,
  OpenCurlyDoubleQuote: OpenCurlyDoubleQuote,
  OpenCurlyQuote: OpenCurlyQuote,
  Or: Or,
  Oscr: Oscr,
  Oslas: Oslas,
  Oslash: Oslash,
  Otild: Otild,
  Otilde: Otilde,
  Otimes: Otimes,
  Oum: Oum,
  Ouml: Ouml,
  OverBar: OverBar,
  OverBrace: OverBrace,
  OverBracket: OverBracket,
  OverParenthesis: OverParenthesis,
  PartialD: PartialD,
  Pcy: Pcy,
  Pfr: Pfr,
  Phi: Phi,
  Pi: Pi,
  PlusMinus: PlusMinus,
  Poincareplane: Poincareplane,
  Popf: Popf,
  Pr: Pr,
  Precedes: Precedes,
  PrecedesEqual: PrecedesEqual,
  PrecedesSlantEqual: PrecedesSlantEqual,
  PrecedesTilde: PrecedesTilde,
  Prime: Prime,
  Product: Product,
  Proportion: Proportion,
  Proportional: Proportional,
  Pscr: Pscr,
  Psi: Psi,
  QUO: QUO,
  QUOT: QUOT,
  Qfr: Qfr,
  Qopf: Qopf,
  Qscr: Qscr,
  RBarr: RBarr,
  RE: RE,
  REG: REG,
  Racute: Racute,
  Rang: Rang,
  Rarr: Rarr,
  Rarrtl: Rarrtl,
  Rcaron: Rcaron,
  Rcedil: Rcedil,
  Rcy: Rcy,
  Re: Re,
  ReverseElement: ReverseElement,
  ReverseEquilibrium: ReverseEquilibrium,
  ReverseUpEquilibrium: ReverseUpEquilibrium,
  Rfr: Rfr,
  Rho: Rho,
  RightAngleBracket: RightAngleBracket,
  RightArrow: RightArrow$1,
  RightArrowBar: RightArrowBar,
  RightArrowLeftArrow: RightArrowLeftArrow,
  RightCeiling: RightCeiling,
  RightDoubleBracket: RightDoubleBracket,
  RightDownTeeVector: RightDownTeeVector,
  RightDownVector: RightDownVector,
  RightDownVectorBar: RightDownVectorBar,
  RightFloor: RightFloor,
  RightTee: RightTee,
  RightTeeArrow: RightTeeArrow,
  RightTeeVector: RightTeeVector,
  RightTriangle: RightTriangle,
  RightTriangleBar: RightTriangleBar,
  RightTriangleEqual: RightTriangleEqual,
  RightUpDownVector: RightUpDownVector,
  RightUpTeeVector: RightUpTeeVector,
  RightUpVector: RightUpVector,
  RightUpVectorBar: RightUpVectorBar,
  RightVector: RightVector,
  RightVectorBar: RightVectorBar,
  Rightarrow: Rightarrow,
  Ropf: Ropf,
  RoundImplies: RoundImplies,
  Rrightarrow: Rrightarrow,
  Rscr: Rscr,
  Rsh: Rsh,
  RuleDelayed: RuleDelayed,
  SHCHcy: SHCHcy,
  SHcy: SHcy,
  SOFTcy: SOFTcy,
  Sacute: Sacute,
  Sc: Sc,
  Scaron: Scaron,
  Scedil: Scedil,
  Scirc: Scirc,
  Scy: Scy,
  Sfr: Sfr,
  ShortDownArrow: ShortDownArrow,
  ShortLeftArrow: ShortLeftArrow,
  ShortRightArrow: ShortRightArrow,
  ShortUpArrow: ShortUpArrow,
  Sigma: Sigma,
  SmallCircle: SmallCircle,
  Sopf: Sopf,
  Sqrt: Sqrt,
  Square: Square,
  SquareIntersection: SquareIntersection,
  SquareSubset: SquareSubset,
  SquareSubsetEqual: SquareSubsetEqual,
  SquareSuperset: SquareSuperset,
  SquareSupersetEqual: SquareSupersetEqual,
  SquareUnion: SquareUnion,
  Sscr: Sscr,
  Star: Star,
  Sub: Sub,
  Subset: Subset,
  SubsetEqual: SubsetEqual,
  Succeeds: Succeeds,
  SucceedsEqual: SucceedsEqual,
  SucceedsSlantEqual: SucceedsSlantEqual,
  SucceedsTilde: SucceedsTilde,
  SuchThat: SuchThat,
  Sum: Sum,
  Sup: Sup,
  Superset: Superset,
  SupersetEqual: SupersetEqual,
  Supset: Supset,
  THOR: THOR,
  THORN: THORN,
  TRADE: TRADE,
  TSHcy: TSHcy,
  TScy: TScy,
  Tab: Tab,
  Tau: Tau,
  Tcaron: Tcaron,
  Tcedil: Tcedil,
  Tcy: Tcy,
  Tfr: Tfr,
  Therefore: Therefore,
  Theta: Theta,
  ThickSpace: ThickSpace,
  ThinSpace: ThinSpace,
  Tilde: Tilde,
  TildeEqual: TildeEqual,
  TildeFullEqual: TildeFullEqual,
  TildeTilde: TildeTilde,
  Topf: Topf,
  TripleDot: TripleDot,
  Tscr: Tscr,
  Tstrok: Tstrok,
  Uacut: Uacut,
  Uacute: Uacute,
  Uarr: Uarr,
  Uarrocir: Uarrocir,
  Ubrcy: Ubrcy,
  Ubreve: Ubreve,
  Ucir: Ucir,
  Ucirc: Ucirc,
  Ucy: Ucy,
  Udblac: Udblac,
  Ufr: Ufr,
  Ugrav: Ugrav,
  Ugrave: Ugrave,
  Umacr: Umacr,
  UnderBar: UnderBar,
  UnderBrace: UnderBrace,
  UnderBracket: UnderBracket,
  UnderParenthesis: UnderParenthesis,
  Union: Union,
  UnionPlus: UnionPlus,
  Uogon: Uogon,
  Uopf: Uopf,
  UpArrow: UpArrow,
  UpArrowBar: UpArrowBar,
  UpArrowDownArrow: UpArrowDownArrow,
  UpDownArrow: UpDownArrow,
  UpEquilibrium: UpEquilibrium,
  UpTee: UpTee,
  UpTeeArrow: UpTeeArrow,
  Uparrow: Uparrow,
  Updownarrow: Updownarrow,
  UpperLeftArrow: UpperLeftArrow,
  UpperRightArrow: UpperRightArrow,
  Upsi: Upsi,
  Upsilon: Upsilon,
  Uring: Uring,
  Uscr: Uscr,
  Utilde: Utilde,
  Uum: Uum,
  Uuml: Uuml,
  VDash: VDash,
  Vbar: Vbar,
  Vcy: Vcy,
  Vdash: Vdash,
  Vdashl: Vdashl,
  Vee: Vee,
  Verbar: Verbar,
  Vert: Vert,
  VerticalBar: VerticalBar,
  VerticalLine: VerticalLine,
  VerticalSeparator: VerticalSeparator,
  VerticalTilde: VerticalTilde,
  VeryThinSpace: VeryThinSpace,
  Vfr: Vfr,
  Vopf: Vopf,
  Vscr: Vscr,
  Vvdash: Vvdash,
  Wcirc: Wcirc,
  Wedge: Wedge,
  Wfr: Wfr,
  Wopf: Wopf,
  Wscr: Wscr,
  Xfr: Xfr,
  Xi: Xi,
  Xopf: Xopf,
  Xscr: Xscr,
  YAcy: YAcy,
  YIcy: YIcy,
  YUcy: YUcy,
  Yacut: Yacut,
  Yacute: Yacute,
  Ycirc: Ycirc,
  Ycy: Ycy,
  Yfr: Yfr,
  Yopf: Yopf,
  Yscr: Yscr,
  Yuml: Yuml,
  ZHcy: ZHcy,
  Zacute: Zacute,
  Zcaron: Zcaron,
  Zcy: Zcy,
  Zdot: Zdot,
  ZeroWidthSpace: ZeroWidthSpace,
  Zeta: Zeta,
  Zfr: Zfr,
  Zopf: Zopf,
  Zscr: Zscr,
  aacut: aacut,
  aacute: aacute,
  abreve: abreve,
  ac: ac,
  acE: acE,
  acd: acd,
  acir: acir,
  acirc: acirc,
  acut: acut,
  acute: acute,
  acy: acy,
  aeli: aeli,
  aelig: aelig,
  af: af,
  afr: afr,
  agrav: agrav,
  agrave: agrave,
  alefsym: alefsym,
  aleph: aleph,
  alpha: alpha$1,
  amacr: amacr,
  amalg: amalg,
  am: am,
  amp: amp,
  and: and,
  andand: andand,
  andd: andd,
  andslope: andslope,
  andv: andv,
  ang: ang,
  ange: ange,
  angle: angle,
  angmsd: angmsd,
  angmsdaa: angmsdaa,
  angmsdab: angmsdab,
  angmsdac: angmsdac,
  angmsdad: angmsdad,
  angmsdae: angmsdae,
  angmsdaf: angmsdaf,
  angmsdag: angmsdag,
  angmsdah: angmsdah,
  angrt: angrt,
  angrtvb: angrtvb,
  angrtvbd: angrtvbd,
  angsph: angsph,
  angst: angst,
  angzarr: angzarr,
  aogon: aogon,
  aopf: aopf,
  ap: ap,
  apE: apE,
  apacir: apacir,
  ape: ape,
  apid: apid,
  apos: apos,
  approx: approx,
  approxeq: approxeq,
  arin: arin,
  aring: aring,
  ascr: ascr,
  ast: ast,
  asymp: asymp,
  asympeq: asympeq,
  atild: atild,
  atilde: atilde,
  aum: aum,
  auml: auml,
  awconint: awconint,
  awint: awint,
  bNot: bNot,
  backcong: backcong,
  backepsilon: backepsilon,
  backprime: backprime,
  backsim: backsim,
  backsimeq: backsimeq,
  barvee: barvee,
  barwed: barwed,
  barwedge: barwedge,
  bbrk: bbrk,
  bbrktbrk: bbrktbrk,
  bcong: bcong,
  bcy: bcy,
  bdquo: bdquo,
  becaus: becaus,
  because: because,
  bemptyv: bemptyv,
  bepsi: bepsi,
  bernou: bernou,
  beta: beta,
  beth: beth,
  between: between,
  bfr: bfr,
  bigcap: bigcap,
  bigcirc: bigcirc,
  bigcup: bigcup,
  bigodot: bigodot,
  bigoplus: bigoplus,
  bigotimes: bigotimes,
  bigsqcup: bigsqcup,
  bigstar: bigstar,
  bigtriangledown: bigtriangledown,
  bigtriangleup: bigtriangleup,
  biguplus: biguplus,
  bigvee: bigvee,
  bigwedge: bigwedge,
  bkarow: bkarow,
  blacklozenge: blacklozenge,
  blacksquare: blacksquare,
  blacktriangle: blacktriangle,
  blacktriangledown: blacktriangledown,
  blacktriangleleft: blacktriangleleft,
  blacktriangleright: blacktriangleright,
  blank: blank,
  blk12: blk12,
  blk14: blk14,
  blk34: blk34,
  block: block,
  bne: bne,
  bnequiv: bnequiv,
  bnot: bnot,
  bopf: bopf,
  bot: bot,
  bottom: bottom$1,
  bowtie: bowtie,
  boxDL: boxDL,
  boxDR: boxDR,
  boxDl: boxDl,
  boxDr: boxDr,
  boxH: boxH,
  boxHD: boxHD,
  boxHU: boxHU,
  boxHd: boxHd,
  boxHu: boxHu,
  boxUL: boxUL,
  boxUR: boxUR,
  boxUl: boxUl,
  boxUr: boxUr,
  boxV: boxV,
  boxVH: boxVH,
  boxVL: boxVL,
  boxVR: boxVR,
  boxVh: boxVh,
  boxVl: boxVl,
  boxVr: boxVr,
  boxbox: boxbox,
  boxdL: boxdL,
  boxdR: boxdR,
  boxdl: boxdl,
  boxdr: boxdr,
  boxh: boxh,
  boxhD: boxhD,
  boxhU: boxhU,
  boxhd: boxhd,
  boxhu: boxhu,
  boxminus: boxminus,
  boxplus: boxplus,
  boxtimes: boxtimes,
  boxuL: boxuL,
  boxuR: boxuR,
  boxul: boxul,
  boxur: boxur,
  boxv: boxv,
  boxvH: boxvH,
  boxvL: boxvL,
  boxvR: boxvR,
  boxvh: boxvh,
  boxvl: boxvl,
  boxvr: boxvr,
  bprime: bprime,
  breve: breve,
  brvba: brvba,
  brvbar: brvbar,
  bscr: bscr,
  bsemi: bsemi,
  bsim: bsim,
  bsime: bsime,
  bsol: bsol,
  bsolb: bsolb,
  bsolhsub: bsolhsub,
  bull: bull,
  bullet: bullet,
  bump: bump,
  bumpE: bumpE,
  bumpe: bumpe,
  bumpeq: bumpeq,
  cacute: cacute,
  cap: cap,
  capand: capand,
  capbrcup: capbrcup,
  capcap: capcap,
  capcup: capcup,
  capdot: capdot,
  caps: caps,
  caret: caret,
  caron: caron,
  ccaps: ccaps,
  ccaron: ccaron,
  ccedi: ccedi,
  ccedil: ccedil,
  ccirc: ccirc,
  ccups: ccups,
  ccupssm: ccupssm,
  cdot: cdot,
  cedi: cedi,
  cedil: cedil,
  cemptyv: cemptyv,
  cen: cen,
  cent: cent,
  centerdot: centerdot,
  cfr: cfr,
  chcy: chcy,
  check: check,
  checkmark: checkmark,
  chi: chi,
  cir: cir,
  cirE: cirE,
  circ: circ,
  circeq: circeq,
  circlearrowleft: circlearrowleft,
  circlearrowright: circlearrowright,
  circledR: circledR,
  circledS: circledS,
  circledast: circledast,
  circledcirc: circledcirc,
  circleddash: circleddash,
  cire: cire,
  cirfnint: cirfnint,
  cirmid: cirmid,
  cirscir: cirscir,
  clubs: clubs,
  clubsuit: clubsuit,
  colon: colon,
  colone: colone,
  coloneq: coloneq,
  comma: comma,
  commat: commat,
  comp: comp,
  compfn: compfn,
  complement: complement,
  complexes: complexes,
  cong: cong,
  congdot: congdot,
  conint: conint,
  copf: copf,
  coprod: coprod,
  cop: cop,
  copy: copy,
  copysr: copysr,
  crarr: crarr,
  cross: cross,
  cscr: cscr,
  csub: csub,
  csube: csube,
  csup: csup,
  csupe: csupe,
  ctdot: ctdot,
  cudarrl: cudarrl,
  cudarrr: cudarrr,
  cuepr: cuepr,
  cuesc: cuesc,
  cularr: cularr,
  cularrp: cularrp,
  cup: cup,
  cupbrcap: cupbrcap,
  cupcap: cupcap,
  cupcup: cupcup,
  cupdot: cupdot,
  cupor: cupor,
  cups: cups,
  curarr: curarr,
  curarrm: curarrm,
  curlyeqprec: curlyeqprec,
  curlyeqsucc: curlyeqsucc,
  curlyvee: curlyvee,
  curlywedge: curlywedge,
  curre: curre,
  curren: curren,
  curvearrowleft: curvearrowleft,
  curvearrowright: curvearrowright,
  cuvee: cuvee,
  cuwed: cuwed,
  cwconint: cwconint,
  cwint: cwint,
  cylcty: cylcty,
  dArr: dArr,
  dHar: dHar,
  dagger: dagger,
  daleth: daleth,
  darr: darr,
  dash: dash,
  dashv: dashv,
  dbkarow: dbkarow,
  dblac: dblac,
  dcaron: dcaron,
  dcy: dcy,
  dd: dd,
  ddagger: ddagger,
  ddarr: ddarr,
  ddotseq: ddotseq,
  de: de,
  deg: deg,
  delta: delta,
  demptyv: demptyv,
  dfisht: dfisht,
  dfr: dfr,
  dharl: dharl,
  dharr: dharr,
  diam: diam,
  diamond: diamond,
  diamondsuit: diamondsuit,
  diams: diams,
  die: die,
  digamma: digamma,
  disin: disin,
  div: div,
  divid: divid,
  divide: divide,
  divideontimes: divideontimes,
  divonx: divonx,
  djcy: djcy,
  dlcorn: dlcorn,
  dlcrop: dlcrop,
  dollar: dollar,
  dopf: dopf,
  dot: dot$1,
  doteq: doteq,
  doteqdot: doteqdot,
  dotminus: dotminus,
  dotplus: dotplus,
  dotsquare: dotsquare,
  doublebarwedge: doublebarwedge,
  downarrow: downarrow,
  downdownarrows: downdownarrows,
  downharpoonleft: downharpoonleft,
  downharpoonright: downharpoonright,
  drbkarow: drbkarow,
  drcorn: drcorn,
  drcrop: drcrop,
  dscr: dscr,
  dscy: dscy,
  dsol: dsol,
  dstrok: dstrok,
  dtdot: dtdot,
  dtri: dtri,
  dtrif: dtrif,
  duarr: duarr,
  duhar: duhar,
  dwangle: dwangle,
  dzcy: dzcy,
  dzigrarr: dzigrarr,
  eDDot: eDDot,
  eDot: eDot,
  eacut: eacut,
  eacute: eacute,
  easter: easter,
  ecaron: ecaron,
  ecir: ecir,
  ecirc: ecirc,
  ecolon: ecolon,
  ecy: ecy,
  edot: edot,
  ee: ee,
  efDot: efDot,
  efr: efr,
  eg: eg,
  egrav: egrav,
  egrave: egrave,
  egs: egs,
  egsdot: egsdot,
  el: el,
  elinters: elinters,
  ell: ell,
  els: els,
  elsdot: elsdot,
  emacr: emacr,
  empty: empty,
  emptyset: emptyset,
  emptyv: emptyv,
  emsp13: emsp13,
  emsp14: emsp14,
  emsp: emsp,
  eng: eng,
  ensp: ensp,
  eogon: eogon,
  eopf: eopf,
  epar: epar,
  eparsl: eparsl,
  eplus: eplus,
  epsi: epsi,
  epsilon: epsilon,
  epsiv: epsiv,
  eqcirc: eqcirc,
  eqcolon: eqcolon,
  eqsim: eqsim,
  eqslantgtr: eqslantgtr,
  eqslantless: eqslantless,
  equals: equals,
  equest: equest,
  equiv: equiv,
  equivDD: equivDD,
  eqvparsl: eqvparsl,
  erDot: erDot,
  erarr: erarr,
  escr: escr,
  esdot: esdot,
  esim: esim,
  eta: eta,
  et: et,
  eth: eth,
  eum: eum,
  euml: euml,
  euro: euro,
  excl: excl,
  exist: exist,
  expectation: expectation,
  exponentiale: exponentiale,
  fallingdotseq: fallingdotseq,
  fcy: fcy,
  female: female,
  ffilig: ffilig,
  fflig: fflig,
  ffllig: ffllig,
  ffr: ffr,
  filig: filig,
  fjlig: fjlig,
  flat: flat,
  fllig: fllig,
  fltns: fltns,
  fnof: fnof,
  fopf: fopf,
  forall: forall,
  fork: fork,
  forkv: forkv,
  fpartint: fpartint,
  frac1: frac1,
  frac12: frac12,
  frac13: frac13,
  frac14: frac14,
  frac15: frac15,
  frac16: frac16,
  frac18: frac18,
  frac23: frac23,
  frac25: frac25,
  frac3: frac3,
  frac34: frac34,
  frac35: frac35,
  frac38: frac38,
  frac45: frac45,
  frac56: frac56,
  frac58: frac58,
  frac78: frac78,
  frasl: frasl,
  frown: frown,
  fscr: fscr,
  gE: gE,
  gEl: gEl,
  gacute: gacute,
  gamma: gamma,
  gammad: gammad,
  gap: gap$2,
  gbreve: gbreve,
  gcirc: gcirc,
  gcy: gcy,
  gdot: gdot,
  ge: ge,
  gel: gel,
  geq: geq,
  geqq: geqq,
  geqslant: geqslant,
  ges: ges,
  gescc: gescc,
  gesdot: gesdot,
  gesdoto: gesdoto,
  gesdotol: gesdotol,
  gesl: gesl,
  gesles: gesles,
  gfr: gfr,
  gg: gg,
  ggg: ggg,
  gimel: gimel,
  gjcy: gjcy,
  gl: gl,
  glE: glE,
  gla: gla,
  glj: glj,
  gnE: gnE,
  gnap: gnap,
  gnapprox: gnapprox,
  gne: gne,
  gneq: gneq,
  gneqq: gneqq,
  gnsim: gnsim,
  gopf: gopf,
  grave: grave,
  gscr: gscr,
  gsim: gsim,
  gsime: gsime,
  gsiml: gsiml,
  g: g$1,
  gt: gt,
  gtcc: gtcc,
  gtcir: gtcir,
  gtdot: gtdot,
  gtlPar: gtlPar,
  gtquest: gtquest,
  gtrapprox: gtrapprox,
  gtrarr: gtrarr,
  gtrdot: gtrdot,
  gtreqless: gtreqless,
  gtreqqless: gtreqqless,
  gtrless: gtrless,
  gtrsim: gtrsim,
  gvertneqq: gvertneqq,
  gvnE: gvnE,
  hArr: hArr,
  hairsp: hairsp,
  half: half,
  hamilt: hamilt,
  hardcy: hardcy,
  harr: harr,
  harrcir: harrcir,
  harrw: harrw,
  hbar: hbar,
  hcirc: hcirc,
  hearts: hearts,
  heartsuit: heartsuit,
  hellip: hellip,
  hercon: hercon,
  hfr: hfr,
  hksearow: hksearow,
  hkswarow: hkswarow,
  hoarr: hoarr,
  homtht: homtht,
  hookleftarrow: hookleftarrow,
  hookrightarrow: hookrightarrow,
  hopf: hopf,
  horbar: horbar,
  hscr: hscr,
  hslash: hslash,
  hstrok: hstrok,
  hybull: hybull,
  hyphen: hyphen,
  iacut: iacut,
  iacute: iacute,
  ic: ic,
  icir: icir,
  icirc: icirc,
  icy: icy,
  iecy: iecy,
  iexc: iexc,
  iexcl: iexcl,
  iff: iff,
  ifr: ifr,
  igrav: igrav,
  igrave: igrave,
  ii: ii,
  iiiint: iiiint,
  iiint: iiint,
  iinfin: iinfin,
  iiota: iiota,
  ijlig: ijlig,
  imacr: imacr,
  image: image,
  imagline: imagline,
  imagpart: imagpart,
  imath: imath,
  imof: imof,
  imped: imped,
  in: "∈",
  incare: incare,
  infin: infin,
  infintie: infintie,
  inodot: inodot,
  int: int,
  intcal: intcal,
  integers: integers,
  intercal: intercal,
  intlarhk: intlarhk,
  intprod: intprod,
  iocy: iocy,
  iogon: iogon,
  iopf: iopf,
  iota: iota,
  iprod: iprod,
  iques: iques,
  iquest: iquest,
  iscr: iscr,
  isin: isin,
  isinE: isinE,
  isindot: isindot,
  isins: isins,
  isinsv: isinsv,
  isinv: isinv,
  it: it,
  itilde: itilde,
  iukcy: iukcy,
  ium: ium,
  iuml: iuml,
  jcirc: jcirc,
  jcy: jcy,
  jfr: jfr,
  jmath: jmath,
  jopf: jopf,
  jscr: jscr,
  jsercy: jsercy,
  jukcy: jukcy,
  kappa: kappa,
  kappav: kappav,
  kcedil: kcedil,
  kcy: kcy,
  kfr: kfr,
  kgreen: kgreen,
  khcy: khcy,
  kjcy: kjcy,
  kopf: kopf,
  kscr: kscr,
  lAarr: lAarr,
  lArr: lArr,
  lAtail: lAtail,
  lBarr: lBarr,
  lE: lE,
  lEg: lEg,
  lHar: lHar,
  lacute: lacute,
  laemptyv: laemptyv,
  lagran: lagran,
  lambda: lambda,
  lang: lang,
  langd: langd,
  langle: langle,
  lap: lap,
  laqu: laqu,
  laquo: laquo,
  larr: larr,
  larrb: larrb,
  larrbfs: larrbfs,
  larrfs: larrfs,
  larrhk: larrhk,
  larrlp: larrlp,
  larrpl: larrpl,
  larrsim: larrsim,
  larrtl: larrtl,
  lat: lat,
  latail: latail,
  late: late,
  lates: lates,
  lbarr: lbarr,
  lbbrk: lbbrk,
  lbrace: lbrace,
  lbrack: lbrack,
  lbrke: lbrke,
  lbrksld: lbrksld,
  lbrkslu: lbrkslu,
  lcaron: lcaron,
  lcedil: lcedil,
  lceil: lceil,
  lcub: lcub,
  lcy: lcy,
  ldca: ldca,
  ldquo: ldquo,
  ldquor: ldquor,
  ldrdhar: ldrdhar,
  ldrushar: ldrushar,
  ldsh: ldsh,
  le: le,
  leftarrow: leftarrow,
  leftarrowtail: leftarrowtail,
  leftharpoondown: leftharpoondown,
  leftharpoonup: leftharpoonup,
  leftleftarrows: leftleftarrows,
  leftrightarrow: leftrightarrow,
  leftrightarrows: leftrightarrows,
  leftrightharpoons: leftrightharpoons,
  leftrightsquigarrow: leftrightsquigarrow,
  leftthreetimes: leftthreetimes,
  leg: leg,
  leq: leq,
  leqq: leqq,
  leqslant: leqslant,
  les: les,
  lescc: lescc,
  lesdot: lesdot,
  lesdoto: lesdoto,
  lesdotor: lesdotor,
  lesg: lesg,
  lesges: lesges,
  lessapprox: lessapprox,
  lessdot: lessdot,
  lesseqgtr: lesseqgtr,
  lesseqqgtr: lesseqqgtr,
  lessgtr: lessgtr,
  lesssim: lesssim,
  lfisht: lfisht,
  lfloor: lfloor,
  lfr: lfr,
  lg: lg,
  lgE: lgE,
  lhard: lhard,
  lharu: lharu,
  lharul: lharul,
  lhblk: lhblk,
  ljcy: ljcy,
  ll: ll,
  llarr: llarr,
  llcorner: llcorner,
  llhard: llhard,
  lltri: lltri,
  lmidot: lmidot,
  lmoust: lmoust,
  lmoustache: lmoustache,
  lnE: lnE,
  lnap: lnap,
  lnapprox: lnapprox,
  lne: lne,
  lneq: lneq,
  lneqq: lneqq,
  lnsim: lnsim,
  loang: loang,
  loarr: loarr,
  lobrk: lobrk,
  longleftarrow: longleftarrow,
  longleftrightarrow: longleftrightarrow,
  longmapsto: longmapsto,
  longrightarrow: longrightarrow,
  looparrowleft: looparrowleft,
  looparrowright: looparrowright,
  lopar: lopar,
  lopf: lopf,
  loplus: loplus,
  lotimes: lotimes,
  lowast: lowast,
  lowbar: lowbar,
  loz: loz,
  lozenge: lozenge,
  lozf: lozf,
  lpar: lpar,
  lparlt: lparlt,
  lrarr: lrarr,
  lrcorner: lrcorner,
  lrhar: lrhar,
  lrhard: lrhard,
  lrm: lrm,
  lrtri: lrtri,
  lsaquo: lsaquo,
  lscr: lscr,
  lsh: lsh,
  lsim: lsim,
  lsime: lsime,
  lsimg: lsimg,
  lsqb: lsqb,
  lsquo: lsquo,
  lsquor: lsquor,
  lstrok: lstrok,
  l: l$1,
  lt: lt,
  ltcc: ltcc,
  ltcir: ltcir,
  ltdot: ltdot,
  lthree: lthree,
  ltimes: ltimes,
  ltlarr: ltlarr,
  ltquest: ltquest,
  ltrPar: ltrPar,
  ltri: ltri,
  ltrie: ltrie,
  ltrif: ltrif,
  lurdshar: lurdshar,
  luruhar: luruhar,
  lvertneqq: lvertneqq,
  lvnE: lvnE,
  mDDot: mDDot,
  mac: mac,
  macr: macr,
  male: male,
  malt: malt,
  maltese: maltese,
  map: map,
  mapsto: mapsto,
  mapstodown: mapstodown,
  mapstoleft: mapstoleft,
  mapstoup: mapstoup,
  marker: marker,
  mcomma: mcomma,
  mcy: mcy,
  mdash: mdash,
  measuredangle: measuredangle,
  mfr: mfr,
  mho: mho,
  micr: micr,
  micro: micro,
  mid: mid,
  midast: midast,
  midcir: midcir,
  middo: middo,
  middot: middot,
  minus: minus,
  minusb: minusb,
  minusd: minusd,
  minusdu: minusdu,
  mlcp: mlcp,
  mldr: mldr,
  mnplus: mnplus,
  models: models,
  mopf: mopf,
  mp: mp,
  mscr: mscr,
  mstpos: mstpos,
  mu: mu,
  multimap: multimap,
  mumap: mumap,
  nGg: nGg,
  nGt: nGt,
  nGtv: nGtv,
  nLeftarrow: nLeftarrow,
  nLeftrightarrow: nLeftrightarrow,
  nLl: nLl,
  nLt: nLt,
  nLtv: nLtv,
  nRightarrow: nRightarrow,
  nVDash: nVDash,
  nVdash: nVdash,
  nabla: nabla,
  nacute: nacute,
  nang: nang,
  nap: nap,
  napE: napE,
  napid: napid,
  napos: napos,
  napprox: napprox,
  natur: natur,
  natural: natural,
  naturals: naturals,
  nbs: nbs,
  nbsp: nbsp,
  nbump: nbump,
  nbumpe: nbumpe,
  ncap: ncap,
  ncaron: ncaron,
  ncedil: ncedil,
  ncong: ncong,
  ncongdot: ncongdot,
  ncup: ncup,
  ncy: ncy,
  ndash: ndash,
  ne: ne,
  neArr: neArr,
  nearhk: nearhk,
  nearr: nearr,
  nearrow: nearrow,
  nedot: nedot,
  nequiv: nequiv,
  nesear: nesear,
  nesim: nesim,
  nexist: nexist,
  nexists: nexists,
  nfr: nfr,
  ngE: ngE,
  nge: nge,
  ngeq: ngeq,
  ngeqq: ngeqq,
  ngeqslant: ngeqslant,
  nges: nges,
  ngsim: ngsim,
  ngt: ngt,
  ngtr: ngtr,
  nhArr: nhArr,
  nharr: nharr,
  nhpar: nhpar,
  ni: ni,
  nis: nis,
  nisd: nisd,
  niv: niv,
  njcy: njcy,
  nlArr: nlArr,
  nlE: nlE,
  nlarr: nlarr,
  nldr: nldr,
  nle: nle,
  nleftarrow: nleftarrow,
  nleftrightarrow: nleftrightarrow,
  nleq: nleq,
  nleqq: nleqq,
  nleqslant: nleqslant,
  nles: nles,
  nless: nless,
  nlsim: nlsim,
  nlt: nlt,
  nltri: nltri,
  nltrie: nltrie,
  nmid: nmid,
  nopf: nopf,
  no: no,
  not: not,
  notin: notin,
  notinE: notinE,
  notindot: notindot,
  notinva: notinva,
  notinvb: notinvb,
  notinvc: notinvc,
  notni: notni,
  notniva: notniva,
  notnivb: notnivb,
  notnivc: notnivc,
  npar: npar,
  nparallel: nparallel,
  nparsl: nparsl,
  npart: npart,
  npolint: npolint,
  npr: npr,
  nprcue: nprcue,
  npre: npre,
  nprec: nprec,
  npreceq: npreceq,
  nrArr: nrArr,
  nrarr: nrarr,
  nrarrc: nrarrc,
  nrarrw: nrarrw,
  nrightarrow: nrightarrow,
  nrtri: nrtri,
  nrtrie: nrtrie,
  nsc: nsc,
  nsccue: nsccue,
  nsce: nsce,
  nscr: nscr,
  nshortmid: nshortmid,
  nshortparallel: nshortparallel,
  nsim: nsim,
  nsime: nsime,
  nsimeq: nsimeq,
  nsmid: nsmid,
  nspar: nspar,
  nsqsube: nsqsube,
  nsqsupe: nsqsupe,
  nsub: nsub,
  nsubE: nsubE,
  nsube: nsube,
  nsubset: nsubset,
  nsubseteq: nsubseteq,
  nsubseteqq: nsubseteqq,
  nsucc: nsucc,
  nsucceq: nsucceq,
  nsup: nsup,
  nsupE: nsupE,
  nsupe: nsupe,
  nsupset: nsupset,
  nsupseteq: nsupseteq,
  nsupseteqq: nsupseteqq,
  ntgl: ntgl,
  ntild: ntild,
  ntilde: ntilde,
  ntlg: ntlg,
  ntriangleleft: ntriangleleft,
  ntrianglelefteq: ntrianglelefteq,
  ntriangleright: ntriangleright,
  ntrianglerighteq: ntrianglerighteq,
  nu: nu,
  num: num,
  numero: numero,
  numsp: numsp,
  nvDash: nvDash,
  nvHarr: nvHarr,
  nvap: nvap,
  nvdash: nvdash,
  nvge: nvge,
  nvgt: nvgt,
  nvinfin: nvinfin,
  nvlArr: nvlArr,
  nvle: nvle,
  nvlt: nvlt,
  nvltrie: nvltrie,
  nvrArr: nvrArr,
  nvrtrie: nvrtrie,
  nvsim: nvsim,
  nwArr: nwArr,
  nwarhk: nwarhk,
  nwarr: nwarr,
  nwarrow: nwarrow,
  nwnear: nwnear,
  oS: oS,
  oacut: oacut,
  oacute: oacute,
  oast: oast,
  ocir: ocir,
  ocirc: ocirc,
  ocy: ocy,
  odash: odash,
  odblac: odblac,
  odiv: odiv,
  odot: odot,
  odsold: odsold,
  oelig: oelig,
  ofcir: ofcir,
  ofr: ofr,
  ogon: ogon,
  ograv: ograv,
  ograve: ograve,
  ogt: ogt,
  ohbar: ohbar,
  ohm: ohm,
  oint: oint,
  olarr: olarr,
  olcir: olcir,
  olcross: olcross,
  oline: oline,
  olt: olt,
  omacr: omacr,
  omega: omega,
  omicron: omicron,
  omid: omid,
  ominus: ominus,
  oopf: oopf,
  opar: opar,
  operp: operp,
  oplus: oplus,
  or: or,
  orarr: orarr,
  ord: ord,
  order: order$1,
  orderof: orderof,
  ordf: ordf,
  ordm: ordm,
  origof: origof,
  oror: oror,
  orslope: orslope,
  orv: orv,
  oscr: oscr,
  oslas: oslas,
  oslash: oslash,
  osol: osol,
  otild: otild,
  otilde: otilde,
  otimes: otimes,
  otimesas: otimesas,
  oum: oum,
  ouml: ouml,
  ovbar: ovbar,
  par: par,
  para: para,
  parallel: parallel,
  parsim: parsim,
  parsl: parsl,
  part: part,
  pcy: pcy,
  percnt: percnt,
  period: period,
  permil: permil,
  perp: perp,
  pertenk: pertenk,
  pfr: pfr,
  phi: phi,
  phiv: phiv,
  phmmat: phmmat,
  phone: phone,
  pi: pi,
  pitchfork: pitchfork,
  piv: piv,
  planck: planck,
  planckh: planckh,
  plankv: plankv,
  plus: plus,
  plusacir: plusacir,
  plusb: plusb,
  pluscir: pluscir,
  plusdo: plusdo,
  plusdu: plusdu,
  pluse: pluse,
  plusm: plusm,
  plusmn: plusmn,
  plussim: plussim,
  plustwo: plustwo,
  pm: pm,
  pointint: pointint,
  popf: popf,
  poun: poun,
  pound: pound,
  pr: pr,
  prE: prE,
  prap: prap,
  prcue: prcue,
  pre: pre,
  prec: prec,
  precapprox: precapprox,
  preccurlyeq: preccurlyeq,
  preceq: preceq,
  precnapprox: precnapprox,
  precneqq: precneqq,
  precnsim: precnsim,
  precsim: precsim,
  prime: prime,
  primes: primes,
  prnE: prnE,
  prnap: prnap,
  prnsim: prnsim,
  prod: prod,
  profalar: profalar,
  profline: profline,
  profsurf: profsurf,
  prop: prop,
  propto: propto,
  prsim: prsim,
  prurel: prurel,
  pscr: pscr,
  psi: psi,
  puncsp: puncsp,
  qfr: qfr,
  qint: qint,
  qopf: qopf,
  qprime: qprime,
  qscr: qscr,
  quaternions: quaternions,
  quatint: quatint,
  quest: quest,
  questeq: questeq,
  quo: quo,
  quot: quot,
  rAarr: rAarr,
  rArr: rArr,
  rAtail: rAtail,
  rBarr: rBarr,
  rHar: rHar,
  race: race,
  racute: racute,
  radic: radic,
  raemptyv: raemptyv,
  rang: rang,
  rangd: rangd,
  range: range,
  rangle: rangle,
  raqu: raqu,
  raquo: raquo,
  rarr: rarr,
  rarrap: rarrap,
  rarrb: rarrb,
  rarrbfs: rarrbfs,
  rarrc: rarrc,
  rarrfs: rarrfs,
  rarrhk: rarrhk,
  rarrlp: rarrlp,
  rarrpl: rarrpl,
  rarrsim: rarrsim,
  rarrtl: rarrtl,
  rarrw: rarrw,
  ratail: ratail,
  ratio: ratio,
  rationals: rationals,
  rbarr: rbarr,
  rbbrk: rbbrk,
  rbrace: rbrace,
  rbrack: rbrack,
  rbrke: rbrke,
  rbrksld: rbrksld,
  rbrkslu: rbrkslu,
  rcaron: rcaron,
  rcedil: rcedil,
  rceil: rceil,
  rcub: rcub,
  rcy: rcy,
  rdca: rdca,
  rdldhar: rdldhar,
  rdquo: rdquo,
  rdquor: rdquor,
  rdsh: rdsh,
  real: real,
  realine: realine,
  realpart: realpart,
  reals: reals,
  rect: rect,
  re: re,
  reg: reg,
  rfisht: rfisht,
  rfloor: rfloor,
  rfr: rfr,
  rhard: rhard,
  rharu: rharu,
  rharul: rharul,
  rho: rho,
  rhov: rhov,
  rightarrow: rightarrow,
  rightarrowtail: rightarrowtail,
  rightharpoondown: rightharpoondown,
  rightharpoonup: rightharpoonup,
  rightleftarrows: rightleftarrows,
  rightleftharpoons: rightleftharpoons,
  rightrightarrows: rightrightarrows,
  rightsquigarrow: rightsquigarrow,
  rightthreetimes: rightthreetimes,
  ring: ring,
  risingdotseq: risingdotseq,
  rlarr: rlarr,
  rlhar: rlhar,
  rlm: rlm,
  rmoust: rmoust,
  rmoustache: rmoustache,
  rnmid: rnmid,
  roang: roang,
  roarr: roarr,
  robrk: robrk,
  ropar: ropar,
  ropf: ropf,
  roplus: roplus,
  rotimes: rotimes,
  rpar: rpar,
  rpargt: rpargt,
  rppolint: rppolint,
  rrarr: rrarr,
  rsaquo: rsaquo,
  rscr: rscr,
  rsh: rsh,
  rsqb: rsqb,
  rsquo: rsquo,
  rsquor: rsquor,
  rthree: rthree,
  rtimes: rtimes,
  rtri: rtri,
  rtrie: rtrie,
  rtrif: rtrif,
  rtriltri: rtriltri,
  ruluhar: ruluhar,
  rx: rx,
  sacute: sacute,
  sbquo: sbquo,
  sc: sc,
  scE: scE,
  scap: scap,
  scaron: scaron,
  sccue: sccue,
  sce: sce,
  scedil: scedil,
  scirc: scirc,
  scnE: scnE,
  scnap: scnap,
  scnsim: scnsim,
  scpolint: scpolint,
  scsim: scsim,
  scy: scy,
  sdot: sdot,
  sdotb: sdotb,
  sdote: sdote,
  seArr: seArr,
  searhk: searhk,
  searr: searr,
  searrow: searrow,
  sec: sec,
  sect: sect,
  semi: semi,
  seswar: seswar,
  setminus: setminus,
  setmn: setmn,
  sext: sext,
  sfr: sfr,
  sfrown: sfrown,
  sharp: sharp,
  shchcy: shchcy,
  shcy: shcy,
  shortmid: shortmid,
  shortparallel: shortparallel,
  sh: sh,
  shy: shy,
  sigma: sigma,
  sigmaf: sigmaf,
  sigmav: sigmav,
  sim: sim,
  simdot: simdot,
  sime: sime,
  simeq: simeq,
  simg: simg,
  simgE: simgE,
  siml: siml,
  simlE: simlE,
  simne: simne,
  simplus: simplus,
  simrarr: simrarr,
  slarr: slarr,
  smallsetminus: smallsetminus,
  smashp: smashp,
  smeparsl: smeparsl,
  smid: smid,
  smile: smile,
  smt: smt,
  smte: smte,
  smtes: smtes,
  softcy: softcy,
  sol: sol,
  solb: solb,
  solbar: solbar,
  sopf: sopf,
  spades: spades,
  spadesuit: spadesuit,
  spar: spar,
  sqcap: sqcap,
  sqcaps: sqcaps,
  sqcup: sqcup,
  sqcups: sqcups,
  sqsub: sqsub,
  sqsube: sqsube,
  sqsubset: sqsubset,
  sqsubseteq: sqsubseteq,
  sqsup: sqsup,
  sqsupe: sqsupe,
  sqsupset: sqsupset,
  sqsupseteq: sqsupseteq,
  squ: squ,
  square: square,
  squarf: squarf,
  squf: squf,
  srarr: srarr,
  sscr: sscr,
  ssetmn: ssetmn,
  ssmile: ssmile,
  sstarf: sstarf,
  star: star,
  starf: starf,
  straightepsilon: straightepsilon,
  straightphi: straightphi,
  strns: strns,
  sub: sub,
  subE: subE,
  subdot: subdot,
  sube: sube,
  subedot: subedot,
  submult: submult,
  subnE: subnE,
  subne: subne,
  subplus: subplus,
  subrarr: subrarr,
  subset: subset,
  subseteq: subseteq,
  subseteqq: subseteqq,
  subsetneq: subsetneq,
  subsetneqq: subsetneqq,
  subsim: subsim,
  subsub: subsub,
  subsup: subsup,
  succ: succ,
  succapprox: succapprox,
  succcurlyeq: succcurlyeq,
  succeq: succeq,
  succnapprox: succnapprox,
  succneqq: succneqq,
  succnsim: succnsim,
  succsim: succsim,
  sum: sum,
  sung: sung,
  sup: sup,
  sup1: sup1,
  sup2: sup2,
  sup3: sup3,
  supE: supE,
  supdot: supdot,
  supdsub: supdsub,
  supe: supe,
  supedot: supedot,
  suphsol: suphsol,
  suphsub: suphsub,
  suplarr: suplarr,
  supmult: supmult,
  supnE: supnE,
  supne: supne,
  supplus: supplus,
  supset: supset,
  supseteq: supseteq,
  supseteqq: supseteqq,
  supsetneq: supsetneq,
  supsetneqq: supsetneqq,
  supsim: supsim,
  supsub: supsub,
  supsup: supsup,
  swArr: swArr,
  swarhk: swarhk,
  swarr: swarr,
  swarrow: swarrow,
  swnwar: swnwar,
  szli: szli,
  szlig: szlig,
  target: target,
  tau: tau,
  tbrk: tbrk,
  tcaron: tcaron,
  tcedil: tcedil,
  tcy: tcy,
  tdot: tdot,
  telrec: telrec,
  tfr: tfr,
  there4: there4,
  therefore: therefore,
  theta: theta,
  thetasym: thetasym,
  thetav: thetav,
  thickapprox: thickapprox,
  thicksim: thicksim,
  thinsp: thinsp,
  thkap: thkap,
  thksim: thksim,
  thor: thor,
  thorn: thorn,
  tilde: tilde,
  time: time,
  times: times,
  timesb: timesb,
  timesbar: timesbar,
  timesd: timesd,
  tint: tint,
  toea: toea,
  top: top$1,
  topbot: topbot,
  topcir: topcir,
  topf: topf,
  topfork: topfork,
  tosa: tosa,
  tprime: tprime,
  trade: trade,
  triangle: triangle,
  triangledown: triangledown,
  triangleleft: triangleleft,
  trianglelefteq: trianglelefteq,
  triangleq: triangleq,
  triangleright: triangleright,
  trianglerighteq: trianglerighteq,
  tridot: tridot,
  trie: trie,
  triminus: triminus,
  triplus: triplus,
  trisb: trisb,
  tritime: tritime,
  trpezium: trpezium,
  tscr: tscr,
  tscy: tscy,
  tshcy: tshcy,
  tstrok: tstrok,
  twixt: twixt,
  twoheadleftarrow: twoheadleftarrow,
  twoheadrightarrow: twoheadrightarrow,
  uArr: uArr,
  uHar: uHar,
  uacut: uacut,
  uacute: uacute,
  uarr: uarr,
  ubrcy: ubrcy,
  ubreve: ubreve,
  ucir: ucir,
  ucirc: ucirc,
  ucy: ucy,
  udarr: udarr,
  udblac: udblac,
  udhar: udhar,
  ufisht: ufisht,
  ufr: ufr,
  ugrav: ugrav,
  ugrave: ugrave,
  uharl: uharl,
  uharr: uharr,
  uhblk: uhblk,
  ulcorn: ulcorn,
  ulcorner: ulcorner,
  ulcrop: ulcrop,
  ultri: ultri,
  umacr: umacr,
  um: um,
  uml: uml,
  uogon: uogon,
  uopf: uopf,
  uparrow: uparrow,
  updownarrow: updownarrow,
  upharpoonleft: upharpoonleft,
  upharpoonright: upharpoonright,
  uplus: uplus,
  upsi: upsi,
  upsih: upsih,
  upsilon: upsilon,
  upuparrows: upuparrows,
  urcorn: urcorn,
  urcorner: urcorner,
  urcrop: urcrop,
  uring: uring,
  urtri: urtri,
  uscr: uscr,
  utdot: utdot,
  utilde: utilde,
  utri: utri,
  utrif: utrif,
  uuarr: uuarr,
  uum: uum,
  uuml: uuml,
  uwangle: uwangle,
  vArr: vArr,
  vBar: vBar,
  vBarv: vBarv,
  vDash: vDash,
  vangrt: vangrt,
  varepsilon: varepsilon,
  varkappa: varkappa,
  varnothing: varnothing,
  varphi: varphi,
  varpi: varpi,
  varpropto: varpropto,
  varr: varr,
  varrho: varrho,
  varsigma: varsigma,
  varsubsetneq: varsubsetneq,
  varsubsetneqq: varsubsetneqq,
  varsupsetneq: varsupsetneq,
  varsupsetneqq: varsupsetneqq,
  vartheta: vartheta,
  vartriangleleft: vartriangleleft,
  vartriangleright: vartriangleright,
  vcy: vcy,
  vdash: vdash,
  vee: vee,
  veebar: veebar,
  veeeq: veeeq,
  vellip: vellip,
  verbar: verbar,
  vert: vert,
  vfr: vfr,
  vltri: vltri,
  vnsub: vnsub,
  vnsup: vnsup,
  vopf: vopf,
  vprop: vprop,
  vrtri: vrtri,
  vscr: vscr,
  vsubnE: vsubnE,
  vsubne: vsubne,
  vsupnE: vsupnE,
  vsupne: vsupne,
  vzigzag: vzigzag,
  wcirc: wcirc,
  wedbar: wedbar,
  wedge: wedge,
  wedgeq: wedgeq,
  weierp: weierp,
  wfr: wfr,
  wopf: wopf,
  wp: wp,
  wr: wr,
  wreath: wreath,
  wscr: wscr,
  xcap: xcap,
  xcirc: xcirc,
  xcup: xcup,
  xdtri: xdtri,
  xfr: xfr,
  xhArr: xhArr,
  xharr: xharr,
  xi: xi,
  xlArr: xlArr,
  xlarr: xlarr,
  xmap: xmap,
  xnis: xnis,
  xodot: xodot,
  xopf: xopf,
  xoplus: xoplus,
  xotime: xotime,
  xrArr: xrArr,
  xrarr: xrarr,
  xscr: xscr,
  xsqcup: xsqcup,
  xuplus: xuplus,
  xutri: xutri,
  xvee: xvee,
  xwedge: xwedge,
  yacut: yacut,
  yacute: yacute,
  yacy: yacy,
  ycirc: ycirc,
  ycy: ycy,
  ye: ye,
  yen: yen,
  yfr: yfr,
  yicy: yicy,
  yopf: yopf,
  yscr: yscr,
  yucy: yucy,
  yum: yum,
  yuml: yuml,
  zacute: zacute,
  zcaron: zcaron,
  zcy: zcy,
  zdot: zdot,
  zeetrf: zeetrf,
  zeta: zeta,
  zfr: zfr,
  zhcy: zhcy,
  zigrarr: zigrarr,
  zopf: zopf,
  zscr: zscr,
  zwj: zwj,
  zwnj: zwnj
},
    characterEntities = require$$0$1,
    decodeEntity_1 = decodeEntity$1,
    own$2 = {}.hasOwnProperty;

function decodeEntity$1(e) {
  return !!own$2.call(characterEntities, e) && characterEntities[e];
}

var legacy = require$$0$2,
    invalid = require$$1,
    decimal = isDecimal,
    hexadecimal = isHexadecimal,
    alphanumerical = isAlphanumerical,
    decodeEntity = decodeEntity_1,
    parseEntities_1 = parseEntities,
    own$1 = {}.hasOwnProperty,
    fromCharCode = String.fromCharCode,
    noop$2 = Function.prototype,
    defaults = {
  warning: null,
  reference: null,
  text: null,
  warningContext: null,
  referenceContext: null,
  textContext: null,
  position: {},
  additional: null,
  attribute: !1,
  nonTerminated: !0
},
    tab = 9,
    lineFeed = 10,
    formFeed = 12,
    space = 32,
    ampersand = 38,
    semicolon = 59,
    lessThan = 60,
    equalsTo = 61,
    numberSign = 35,
    uppercaseX = 88,
    lowercaseX = 120,
    replacementCharacter = 65533,
    name = "named",
    hexa = "hexadecimal",
    deci = "decimal",
    bases = {};
bases[hexa] = 16, bases[deci] = 10;
var tests = {};
tests[name] = alphanumerical, tests[deci] = decimal, tests[hexa] = hexadecimal;
var namedNotTerminated = 1,
    numericNotTerminated = 2,
    namedEmpty = 3,
    numericEmpty = 4,
    namedUnknown = 5,
    numericDisallowed = 6,
    numericProhibited = 7,
    messages = {};

function parseEntities(e, t) {
  var r,
      n,
      a = {};

  for (n in t || (t = {}), defaults) {
    r = t[n], a[n] = null == r ? defaults[n] : r;
  }

  return (a.position.indent || a.position.start) && (a.indent = a.position.indent || [], a.position = a.position.start), parse$1(e, a);
}

function parse$1(e, t) {
  var r,
      n,
      a,
      o,
      i,
      s,
      l,
      c,
      u,
      d,
      p,
      g,
      m,
      f,
      h,
      b,
      y,
      v,
      _,
      T = t.additional,
      E = t.nonTerminated,
      S = t.text,
      x = t.reference,
      w = t.warning,
      C = t.textContext,
      k = t.referenceContext,
      $ = t.warningContext,
      R = t.position,
      A = t.indent || [],
      I = e.length,
      N = 0,
      P = -1,
      O = R.column || 1,
      D = R.line || 1,
      L = "",
      M = [];

  for ("string" == typeof T && (T = T.charCodeAt(0)), b = F(), c = w ? function (e, t) {
    var r = F();
    r.column += t, r.offset += t, w.call($, messages[e], r, e);
  } : noop$2, N--, I++; ++N < I;) {
    if (i === lineFeed && (O = A[P] || 1), (i = e.charCodeAt(N)) === ampersand) {
      if ((l = e.charCodeAt(N + 1)) === tab || l === lineFeed || l === formFeed || l === space || l === ampersand || l === lessThan || l != l || T && l === T) {
        L += fromCharCode(i), O++;
        continue;
      }

      for (g = m = N + 1, _ = m, l === numberSign ? (_ = ++g, (l = e.charCodeAt(_)) === uppercaseX || l === lowercaseX ? (f = hexa, _ = ++g) : f = deci) : f = name, r = "", p = "", o = "", h = tests[f], _--; ++_ < I && h(l = e.charCodeAt(_));) {
        o += fromCharCode(l), f === name && own$1.call(legacy, o) && (r = o, p = legacy[o]);
      }

      (a = e.charCodeAt(_) === semicolon) && (_++, (n = f === name && decodeEntity(o)) && (r = o, p = n)), v = 1 + _ - m, (a || E) && (o ? f === name ? (a && !p ? c(namedUnknown, 1) : (r !== o && (v = 1 + (_ = g + r.length) - g, a = !1), a || (u = r ? namedNotTerminated : namedEmpty, t.attribute ? (l = e.charCodeAt(_)) === equalsTo ? (c(u, v), p = null) : alphanumerical(l) ? p = null : c(u, v) : c(u, v))), s = p) : (a || c(numericNotTerminated, v), prohibited(s = parseInt(o, bases[f])) ? (c(numericProhibited, v), s = fromCharCode(replacementCharacter)) : s in invalid ? (c(numericDisallowed, v), s = invalid[s]) : (d = "", disallowed(s) && c(numericDisallowed, v), s > 65535 && (d += fromCharCode((s -= 65536) >>> 10 | 55296), s = 56320 | 1023 & s), s = d + fromCharCode(s))) : f !== name && c(numericEmpty, v)), s ? (j(), b = F(), N = _ - 1, O += _ - m + 1, M.push(s), (y = F()).offset++, x && x.call(k, s, {
        start: b,
        end: y
      }, e.slice(m - 1, _)), b = y) : (o = e.slice(m - 1, _), L += o, O += o.length, N = _ - 1);
    } else 10 === i && (D++, P++, O = 0), i == i ? (L += fromCharCode(i), O++) : j();
  }

  return M.join("");

  function F() {
    return {
      line: D,
      column: O,
      offset: N + (R.offset || 0)
    };
  }

  function j() {
    L && (M.push(L), S && S.call(C, L, {
      start: b,
      end: F()
    }), L = "");
  }
}

function prohibited(e) {
  return e >= 55296 && e <= 57343 || e > 1114111;
}

function disallowed(e) {
  return e >= 1 && e <= 8 || 11 === e || e >= 13 && e <= 31 || e >= 127 && e <= 159 || e >= 64976 && e <= 65007 || 65535 == (65535 & e) || 65534 == (65535 & e);
}

messages[namedNotTerminated] = "Named character references must be terminated by a semicolon", messages[numericNotTerminated] = "Numeric character references must be terminated by a semicolon", messages[namedEmpty] = "Named character references cannot be empty", messages[numericEmpty] = "Numeric character references cannot be empty", messages[namedUnknown] = "Named character references must be known", messages[numericDisallowed] = "Numeric character references cannot be disallowed", messages[numericProhibited] = "Numeric character references cannot be outside the permissible Unicode range";
var prismCore = {
  exports: {}
};
!function (e) {
  var t = function (e) {
    var t = /(?:^|\s)lang(?:uage)?-([\w-]+)(?=\s|$)/i,
        r = 0,
        n = {},
        a = {
      manual: e.Prism && e.Prism.manual,
      disableWorkerMessageHandler: e.Prism && e.Prism.disableWorkerMessageHandler,
      util: {
        encode: function e(t) {
          return t instanceof o ? new o(t.type, e(t.content), t.alias) : Array.isArray(t) ? t.map(e) : t.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/\u00a0/g, " ");
        },
        type: function type(e) {
          return Object.prototype.toString.call(e).slice(8, -1);
        },
        objId: function objId(e) {
          return e.__id || Object.defineProperty(e, "__id", {
            value: ++r
          }), e.__id;
        },
        clone: function e(t, r) {
          var n, o;

          switch (r = r || {}, a.util.type(t)) {
            case "Object":
              if (o = a.util.objId(t), r[o]) return r[o];

              for (var i in n = {}, r[o] = n, t) {
                t.hasOwnProperty(i) && (n[i] = e(t[i], r));
              }

              return n;

            case "Array":
              return o = a.util.objId(t), r[o] ? r[o] : (n = [], r[o] = n, t.forEach(function (t, a) {
                n[a] = e(t, r);
              }), n);

            default:
              return t;
          }
        },
        getLanguage: function getLanguage(e) {
          for (; e;) {
            var r = t.exec(e.className);
            if (r) return r[1].toLowerCase();
            e = e.parentElement;
          }

          return "none";
        },
        setLanguage: function setLanguage(e, r) {
          e.className = e.className.replace(RegExp(t, "gi"), ""), e.classList.add("language-" + r);
        },
        currentScript: function currentScript() {
          if ("undefined" == typeof document) return null;
          if ("currentScript" in document) return document.currentScript;

          try {
            throw new Error();
          } catch (n) {
            var e = (/at [^(\r\n]*\((.*):[^:]+:[^:]+\)$/i.exec(n.stack) || [])[1];

            if (e) {
              var t = document.getElementsByTagName("script");

              for (var r in t) {
                if (t[r].src == e) return t[r];
              }
            }

            return null;
          }
        },
        isActive: function isActive(e, t, r) {
          for (var n = "no-" + t; e;) {
            var a = e.classList;
            if (a.contains(t)) return !0;
            if (a.contains(n)) return !1;
            e = e.parentElement;
          }

          return !!r;
        }
      },
      languages: {
        plain: n,
        plaintext: n,
        text: n,
        txt: n,
        extend: function extend(e, t) {
          var r = a.util.clone(a.languages[e]);

          for (var n in t) {
            r[n] = t[n];
          }

          return r;
        },
        insertBefore: function insertBefore(e, t, r, n) {
          var o = (n = n || a.languages)[e],
              i = {};

          for (var s in o) {
            if (o.hasOwnProperty(s)) {
              if (s == t) for (var l in r) {
                r.hasOwnProperty(l) && (i[l] = r[l]);
              }
              r.hasOwnProperty(s) || (i[s] = o[s]);
            }
          }

          var c = n[e];
          return n[e] = i, a.languages.DFS(a.languages, function (t, r) {
            r === c && t != e && (this[t] = i);
          }), i;
        },
        DFS: function e(t, r, n, o) {
          o = o || {};
          var i = a.util.objId;

          for (var s in t) {
            if (t.hasOwnProperty(s)) {
              r.call(t, s, t[s], n || s);
              var l = t[s],
                  c = a.util.type(l);
              "Object" !== c || o[i(l)] ? "Array" !== c || o[i(l)] || (o[i(l)] = !0, e(l, r, s, o)) : (o[i(l)] = !0, e(l, r, null, o));
            }
          }
        }
      },
      plugins: {},
      highlightAll: function highlightAll(e, t) {
        a.highlightAllUnder(document, e, t);
      },
      highlightAllUnder: function highlightAllUnder(e, t, r) {
        var n = {
          callback: r,
          container: e,
          selector: 'code[class*="language-"], [class*="language-"] code, code[class*="lang-"], [class*="lang-"] code'
        };
        a.hooks.run("before-highlightall", n), n.elements = Array.prototype.slice.apply(n.container.querySelectorAll(n.selector)), a.hooks.run("before-all-elements-highlight", n);

        for (var o, i = 0; o = n.elements[i++];) {
          a.highlightElement(o, !0 === t, n.callback);
        }
      },
      highlightElement: function highlightElement(t, r, n) {
        var o = a.util.getLanguage(t),
            i = a.languages[o];
        a.util.setLanguage(t, o);
        var s = t.parentElement;
        s && "pre" === s.nodeName.toLowerCase() && a.util.setLanguage(s, o);
        var l = {
          element: t,
          language: o,
          grammar: i,
          code: t.textContent
        };

        function c(e) {
          l.highlightedCode = e, a.hooks.run("before-insert", l), l.element.innerHTML = l.highlightedCode, a.hooks.run("after-highlight", l), a.hooks.run("complete", l), n && n.call(l.element);
        }

        if (a.hooks.run("before-sanity-check", l), (s = l.element.parentElement) && "pre" === s.nodeName.toLowerCase() && !s.hasAttribute("tabindex") && s.setAttribute("tabindex", "0"), !l.code) return a.hooks.run("complete", l), void (n && n.call(l.element));
        if (a.hooks.run("before-highlight", l), l.grammar) {
          if (r && e.Worker) {
            var u = new Worker(a.filename);
            u.onmessage = function (e) {
              c(e.data);
            }, u.postMessage(JSON.stringify({
              language: l.language,
              code: l.code,
              immediateClose: !0
            }));
          } else c(a.highlight(l.code, l.grammar, l.language));
        } else c(a.util.encode(l.code));
      },
      highlight: function highlight(e, t, r) {
        var n = {
          code: e,
          grammar: t,
          language: r
        };
        if (a.hooks.run("before-tokenize", n), !n.grammar) throw new Error('The language "' + n.language + '" has no grammar.');
        return n.tokens = a.tokenize(n.code, n.grammar), a.hooks.run("after-tokenize", n), o.stringify(a.util.encode(n.tokens), n.language);
      },
      tokenize: function tokenize(e, t) {
        var r = t.rest;

        if (r) {
          for (var n in r) {
            t[n] = r[n];
          }

          delete t.rest;
        }

        var a = new l();
        return c(a, a.head, e), s(e, a, t, a.head, 0), function (e) {
          var t = [],
              r = e.head.next;

          for (; r !== e.tail;) {
            t.push(r.value), r = r.next;
          }

          return t;
        }(a);
      },
      hooks: {
        all: {},
        add: function add(e, t) {
          var r = a.hooks.all;
          r[e] = r[e] || [], r[e].push(t);
        },
        run: function run(e, t) {
          var r = a.hooks.all[e];
          if (r && r.length) for (var n, o = 0; n = r[o++];) {
            n(t);
          }
        }
      },
      Token: o
    };

    function o(e, t, r, n) {
      this.type = e, this.content = t, this.alias = r, this.length = 0 | (n || "").length;
    }

    function i(e, t, r, n) {
      e.lastIndex = t;
      var a = e.exec(r);

      if (a && n && a[1]) {
        var o = a[1].length;
        a.index += o, a[0] = a[0].slice(o);
      }

      return a;
    }

    function s(e, t, r, n, l, d) {
      for (var p in r) {
        if (r.hasOwnProperty(p) && r[p]) {
          var g = r[p];
          g = Array.isArray(g) ? g : [g];

          for (var m = 0; m < g.length; ++m) {
            if (d && d.cause == p + "," + m) return;
            var f = g[m],
                h = f.inside,
                b = !!f.lookbehind,
                y = !!f.greedy,
                v = f.alias;

            if (y && !f.pattern.global) {
              var _ = f.pattern.toString().match(/[imsuy]*$/)[0];
              f.pattern = RegExp(f.pattern.source, _ + "g");
            }

            for (var T = f.pattern || f, E = n.next, S = l; E !== t.tail && !(d && S >= d.reach); S += E.value.length, E = E.next) {
              var x = E.value;
              if (t.length > e.length) return;

              if (!(x instanceof o)) {
                var w,
                    C = 1;

                if (y) {
                  if (!(w = i(T, S, e, b)) || w.index >= e.length) break;
                  var k = w.index,
                      $ = w.index + w[0].length,
                      R = S;

                  for (R += E.value.length; k >= R;) {
                    R += (E = E.next).value.length;
                  }

                  if (S = R -= E.value.length, E.value instanceof o) continue;

                  for (var A = E; A !== t.tail && (R < $ || "string" == typeof A.value); A = A.next) {
                    C++, R += A.value.length;
                  }

                  C--, x = e.slice(S, R), w.index -= S;
                } else if (!(w = i(T, 0, x, b))) continue;

                k = w.index;
                var I = w[0],
                    N = x.slice(0, k),
                    P = x.slice(k + I.length),
                    O = S + x.length;
                d && O > d.reach && (d.reach = O);
                var D = E.prev;

                if (N && (D = c(t, D, N), S += N.length), u(t, D, C), E = c(t, D, new o(p, h ? a.tokenize(I, h) : I, v, I)), P && c(t, E, P), C > 1) {
                  var L = {
                    cause: p + "," + m,
                    reach: O
                  };
                  s(e, t, r, E.prev, S, L), d && L.reach > d.reach && (d.reach = L.reach);
                }
              }
            }
          }
        }
      }
    }

    function l() {
      var e = {
        value: null,
        prev: null,
        next: null
      },
          t = {
        value: null,
        prev: e,
        next: null
      };
      e.next = t, this.head = e, this.tail = t, this.length = 0;
    }

    function c(e, t, r) {
      var n = t.next,
          a = {
        value: r,
        prev: t,
        next: n
      };
      return t.next = a, n.prev = a, e.length++, a;
    }

    function u(e, t, r) {
      for (var n = t.next, a = 0; a < r && n !== e.tail; a++) {
        n = n.next;
      }

      t.next = n, n.prev = t, e.length -= a;
    }

    if (e.Prism = a, o.stringify = function e(t, r) {
      if ("string" == typeof t) return t;

      if (Array.isArray(t)) {
        var n = "";
        return t.forEach(function (t) {
          n += e(t, r);
        }), n;
      }

      var o = {
        type: t.type,
        content: e(t.content, r),
        tag: "span",
        classes: ["token", t.type],
        attributes: {},
        language: r
      },
          i = t.alias;
      i && (Array.isArray(i) ? Array.prototype.push.apply(o.classes, i) : o.classes.push(i)), a.hooks.run("wrap", o);
      var s = "";

      for (var l in o.attributes) {
        s += " " + l + '="' + (o.attributes[l] || "").replace(/"/g, "&quot;") + '"';
      }

      return "<" + o.tag + ' class="' + o.classes.join(" ") + '"' + s + ">" + o.content + "</" + o.tag + ">";
    }, !e.document) return e.addEventListener ? (a.disableWorkerMessageHandler || e.addEventListener("message", function (t) {
      var r = JSON.parse(t.data),
          n = r.language,
          o = r.code,
          i = r.immediateClose;
      e.postMessage(a.highlight(o, a.languages[n], n)), i && e.close();
    }, !1), a) : a;
    var d = a.util.currentScript();

    function p() {
      a.manual || a.highlightAll();
    }

    if (d && (a.filename = d.src, d.hasAttribute("data-manual") && (a.manual = !0)), !a.manual) {
      var g = document.readyState;
      "loading" === g || "interactive" === g && d && d.defer ? document.addEventListener("DOMContentLoaded", p) : window.requestAnimationFrame ? window.requestAnimationFrame(p) : window.setTimeout(p, 16);
    }

    return a;
  }("undefined" != typeof window ? window : "undefined" != typeof WorkerGlobalScope && self instanceof WorkerGlobalScope ? self : {});
  /**
   * Prism: Lightweight, robust, elegant syntax highlighting
   *
   * @license MIT <https://opensource.org/licenses/MIT>
   * @author Lea Verou <https://lea.verou.me>
   * @namespace
   * @public
   */


  e.exports && (e.exports = t), void 0 !== commonjsGlobal && (commonjsGlobal.Prism = t);
}(prismCore);
var markup_1 = markup$1;

function markup$1(e) {
  e.languages.markup = {
    comment: {
      pattern: /<!--(?:(?!<!--)[\s\S])*?-->/,
      greedy: !0
    },
    prolog: {
      pattern: /<\?[\s\S]+?\?>/,
      greedy: !0
    },
    doctype: {
      pattern: /<!DOCTYPE(?:[^>"'[\]]|"[^"]*"|'[^']*')+(?:\[(?:[^<"'\]]|"[^"]*"|'[^']*'|<(?!!--)|<!--(?:[^-]|-(?!->))*-->)*\]\s*)?>/i,
      greedy: !0,
      inside: {
        "internal-subset": {
          pattern: /(^[^\[]*\[)[\s\S]+(?=\]>$)/,
          lookbehind: !0,
          greedy: !0,
          inside: null
        },
        string: {
          pattern: /"[^"]*"|'[^']*'/,
          greedy: !0
        },
        punctuation: /^<!|>$|[[\]]/,
        "doctype-tag": /^DOCTYPE/i,
        name: /[^\s<>'"]+/
      }
    },
    cdata: {
      pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
      greedy: !0
    },
    tag: {
      pattern: /<\/?(?!\d)[^\s>\/=$<%]+(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?\s*\/?>/,
      greedy: !0,
      inside: {
        tag: {
          pattern: /^<\/?[^\s>\/]+/,
          inside: {
            punctuation: /^<\/?/,
            namespace: /^[^\s>\/:]+:/
          }
        },
        "special-attr": [],
        "attr-value": {
          pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+)/,
          inside: {
            punctuation: [{
              pattern: /^=/,
              alias: "attr-equals"
            }, /"|'/]
          }
        },
        punctuation: /\/?>/,
        "attr-name": {
          pattern: /[^\s>\/]+/,
          inside: {
            namespace: /^[^\s>\/:]+:/
          }
        }
      }
    },
    entity: [{
      pattern: /&[\da-z]{1,8};/i,
      alias: "named-entity"
    }, /&#x?[\da-f]{1,8};/i]
  }, e.languages.markup.tag.inside["attr-value"].inside.entity = e.languages.markup.entity, e.languages.markup.doctype.inside["internal-subset"].inside = e.languages.markup, e.hooks.add("wrap", function (e) {
    "entity" === e.type && (e.attributes.title = e.content.value.replace(/&amp;/, "&"));
  }), Object.defineProperty(e.languages.markup.tag, "addInlined", {
    value: function value(t, r) {
      var n = {};
      n["language-" + r] = {
        pattern: /(^<!\[CDATA\[)[\s\S]+?(?=\]\]>$)/i,
        lookbehind: !0,
        inside: e.languages[r]
      }, n.cdata = /^<!\[CDATA\[|\]\]>$/i;
      var a = {
        "included-cdata": {
          pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
          inside: n
        }
      };
      a["language-" + r] = {
        pattern: /[\s\S]+/,
        inside: e.languages[r]
      };
      var o = {};
      o[t] = {
        pattern: RegExp(/(<__[^>]*>)(?:<!\[CDATA\[(?:[^\]]|\](?!\]>))*\]\]>|(?!<!\[CDATA\[)[\s\S])*?(?=<\/__>)/.source.replace(/__/g, function () {
          return t;
        }), "i"),
        lookbehind: !0,
        greedy: !0,
        inside: a
      }, e.languages.insertBefore("markup", "cdata", o);
    }
  }), Object.defineProperty(e.languages.markup.tag, "addAttribute", {
    value: function value(t, r) {
      e.languages.markup.tag.inside["special-attr"].push({
        pattern: RegExp(/(^|["'\s])/.source + "(?:" + t + ")" + /\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))/.source, "i"),
        lookbehind: !0,
        inside: {
          "attr-name": /^[^\s=]+/,
          "attr-value": {
            pattern: /=[\s\S]+/,
            inside: {
              value: {
                pattern: /(^=\s*(["']|(?!["'])))\S[\s\S]*(?=\2$)/,
                lookbehind: !0,
                alias: [r, "language-" + r],
                inside: e.languages[r]
              },
              punctuation: [{
                pattern: /^=/,
                alias: "attr-equals"
              }, /"|'/]
            }
          }
        }
      });
    }
  }), e.languages.html = e.languages.markup, e.languages.mathml = e.languages.markup, e.languages.svg = e.languages.markup, e.languages.xml = e.languages.extend("markup", {}), e.languages.ssml = e.languages.xml, e.languages.atom = e.languages.xml, e.languages.rss = e.languages.xml;
}

markup$1.displayName = "markup", markup$1.aliases = ["html", "mathml", "svg", "xml", "ssml", "atom", "rss"];
var css_1 = css$1;

function css$1(e) {
  !function (e) {
    var t = /(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/;
    e.languages.css = {
      comment: /\/\*[\s\S]*?\*\//,
      atrule: {
        pattern: /@[\w-](?:[^;{\s]|\s+(?![\s{]))*(?:;|(?=\s*\{))/,
        inside: {
          rule: /^@[\w-]+/,
          "selector-function-argument": {
            pattern: /(\bselector\s*\(\s*(?![\s)]))(?:[^()\s]|\s+(?![\s)])|\((?:[^()]|\([^()]*\))*\))+(?=\s*\))/,
            lookbehind: !0,
            alias: "selector"
          },
          keyword: {
            pattern: /(^|[^\w-])(?:and|not|only|or)(?![\w-])/,
            lookbehind: !0
          }
        }
      },
      url: {
        pattern: RegExp("\\burl\\((?:" + t.source + "|" + /(?:[^\\\r\n()"']|\\[\s\S])*/.source + ")\\)", "i"),
        greedy: !0,
        inside: {
          function: /^url/i,
          punctuation: /^\(|\)$/,
          string: {
            pattern: RegExp("^" + t.source + "$"),
            alias: "url"
          }
        }
      },
      selector: {
        pattern: RegExp("(^|[{}\\s])[^{}\\s](?:[^{};\"'\\s]|\\s+(?![\\s{])|" + t.source + ")*(?=\\s*\\{)"),
        lookbehind: !0
      },
      string: {
        pattern: t,
        greedy: !0
      },
      property: {
        pattern: /(^|[^-\w\xA0-\uFFFF])(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*(?=\s*:)/i,
        lookbehind: !0
      },
      important: /!important\b/i,
      function: {
        pattern: /(^|[^-a-z0-9])[-a-z0-9]+(?=\()/i,
        lookbehind: !0
      },
      punctuation: /[(){};:,]/
    }, e.languages.css.atrule.inside.rest = e.languages.css;
    var r = e.languages.markup;
    r && (r.tag.addInlined("style", "css"), r.tag.addAttribute("style", "css"));
  }(e);
}

css$1.displayName = "css", css$1.aliases = [];
var clike_1 = clike$1;

function clike$1(e) {
  e.languages.clike = {
    comment: [{
      pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
      lookbehind: !0,
      greedy: !0
    }, {
      pattern: /(^|[^\\:])\/\/.*/,
      lookbehind: !0,
      greedy: !0
    }],
    string: {
      pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
      greedy: !0
    },
    "class-name": {
      pattern: /(\b(?:class|extends|implements|instanceof|interface|new|trait)\s+|\bcatch\s+\()[\w.\\]+/i,
      lookbehind: !0,
      inside: {
        punctuation: /[.\\]/
      }
    },
    keyword: /\b(?:break|catch|continue|do|else|finally|for|function|if|in|instanceof|new|null|return|throw|try|while)\b/,
    boolean: /\b(?:false|true)\b/,
    function: /\b\w+(?=\()/,
    number: /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
    operator: /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/,
    punctuation: /[{}[\];(),.:]/
  };
}

clike$1.displayName = "clike", clike$1.aliases = [];
var javascript_1 = javascript;

function javascript(e) {
  e.languages.javascript = e.languages.extend("clike", {
    "class-name": [e.languages.clike["class-name"], {
      pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:constructor|prototype))/,
      lookbehind: !0
    }],
    keyword: [{
      pattern: /((?:^|\})\s*)catch\b/,
      lookbehind: !0
    }, {
      pattern: /(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/,
      lookbehind: !0
    }],
    function: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/,
    number: {
      pattern: RegExp(/(^|[^\w$])/.source + "(?:" + /NaN|Infinity/.source + "|" + /0[bB][01]+(?:_[01]+)*n?/.source + "|" + /0[oO][0-7]+(?:_[0-7]+)*n?/.source + "|" + /0[xX][\dA-Fa-f]+(?:_[\dA-Fa-f]+)*n?/.source + "|" + /\d+(?:_\d+)*n/.source + "|" + /(?:\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[Ee][+-]?\d+(?:_\d+)*)?/.source + ")" + /(?![\w$])/.source),
      lookbehind: !0
    },
    operator: /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/
  }), e.languages.javascript["class-name"][0].pattern = /(\b(?:class|extends|implements|instanceof|interface|new)\s+)[\w.\\]+/, e.languages.insertBefore("javascript", "keyword", {
    regex: {
      pattern: /((?:^|[^$\w\xA0-\uFFFF."'\])\s]|\b(?:return|yield))\s*)\/(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}(?=(?:\s|\/\*(?:[^*]|\*(?!\/))*\*\/)*(?:$|[\r\n,.;:})\]]|\/\/))/,
      lookbehind: !0,
      greedy: !0,
      inside: {
        "regex-source": {
          pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
          lookbehind: !0,
          alias: "language-regex",
          inside: e.languages.regex
        },
        "regex-delimiter": /^\/|\/$/,
        "regex-flags": /^[a-z]+$/
      }
    },
    "function-variable": {
      pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
      alias: "function"
    },
    parameter: [{
      pattern: /(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/,
      lookbehind: !0,
      inside: e.languages.javascript
    }, {
      pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i,
      lookbehind: !0,
      inside: e.languages.javascript
    }, {
      pattern: /(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/,
      lookbehind: !0,
      inside: e.languages.javascript
    }, {
      pattern: /((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/,
      lookbehind: !0,
      inside: e.languages.javascript
    }],
    constant: /\b[A-Z](?:[A-Z_]|\dx?)*\b/
  }), e.languages.insertBefore("javascript", "string", {
    hashbang: {
      pattern: /^#!.*/,
      greedy: !0,
      alias: "comment"
    },
    "template-string": {
      pattern: /`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/,
      greedy: !0,
      inside: {
        "template-punctuation": {
          pattern: /^`|`$/,
          alias: "string"
        },
        interpolation: {
          pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
          lookbehind: !0,
          inside: {
            "interpolation-punctuation": {
              pattern: /^\$\{|\}$/,
              alias: "punctuation"
            },
            rest: e.languages.javascript
          }
        },
        string: /[\s\S]+/
      }
    },
    "string-property": {
      pattern: /((?:^|[,{])[ \t]*)(["'])(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2(?=\s*:)/m,
      lookbehind: !0,
      greedy: !0,
      alias: "property"
    }
  }), e.languages.insertBefore("javascript", "operator", {
    "literal-property": {
      pattern: /((?:^|[,{])[ \t]*)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/m,
      lookbehind: !0,
      alias: "property"
    }
  }), e.languages.markup && (e.languages.markup.tag.addInlined("script", "javascript"), e.languages.markup.tag.addAttribute(/on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)/.source, "javascript")), e.languages.js = e.languages.javascript;
}

javascript.displayName = "javascript", javascript.aliases = ["js"];
var ctx = "object" == typeof globalThis ? globalThis : "object" == typeof self ? self : "object" == typeof window ? window : "object" == typeof commonjsGlobal ? commonjsGlobal : {},
    restore = capture();
ctx.Prism = {
  manual: !0,
  disableWorkerMessageHandler: !0
};
var h$1 = hastscript,
    decode = parseEntities_1,
    Prism = prismCore.exports,
    markup = markup_1,
    css = css_1,
    clike = clike_1,
    js = javascript_1;
restore();
var own = {}.hasOwnProperty;

function Refractor() {}

Refractor.prototype = Prism;
var refract = new Refractor(),
    core = refract;

function register(e) {
  if ("function" != typeof e || !e.displayName) throw new Error("Expected `function` for `grammar`, got `" + e + "`");
  void 0 === refract.languages[e.displayName] && e(refract);
}

function alias(e, t) {
  var r,
      n,
      a,
      o,
      i = refract.languages,
      s = e;

  for (r in t && ((s = {})[e] = t), s) {
    for (a = (n = "string" == typeof (n = s[r]) ? [n] : n).length, o = -1; ++o < a;) {
      i[n[o]] = i[r];
    }
  }
}

function highlight(e, t) {
  var r,
      n = Prism.highlight;
  if ("string" != typeof e) throw new Error("Expected `string` for `value`, got `" + e + "`");
  if ("Object" === refract.util.type(t)) r = t, t = null;else {
    if ("string" != typeof t) throw new Error("Expected `string` for `name`, got `" + t + "`");
    if (!own.call(refract.languages, t)) throw new Error("Unknown language: `" + t + "` is not registered");
    r = refract.languages[t];
  }
  return n.call(this, e, r, t);
}

function registered(e) {
  if ("string" != typeof e) throw new Error("Expected `string` for `language`, got `" + e + "`");
  return own.call(refract.languages, e);
}

function listLanguages() {
  var e,
      t = refract.languages,
      r = [];

  for (e in t) {
    own.call(t, e) && "object" == typeof t[e] && r.push(e);
  }

  return r;
}

function stringify(e, t, r) {
  var n;
  return "string" == typeof e ? {
    type: "text",
    value: e
  } : "Array" === refract.util.type(e) ? stringifyAll(e, t) : (n = {
    type: e.type,
    content: refract.Token.stringify(e.content, t, r),
    tag: "span",
    classes: ["token", e.type],
    attributes: {},
    language: t,
    parent: r
  }, e.alias && (n.classes = n.classes.concat(e.alias)), refract.hooks.run("wrap", n), h$1(n.tag + "." + n.classes.join("."), attributes(n.attributes), n.content));
}

function stringifyAll(e, t) {
  for (var r, n = [], a = e.length, o = -1; ++o < a;) {
    "" !== (r = e[o]) && null != r && n.push(r);
  }

  for (o = -1, a = n.length; ++o < a;) {
    r = n[o], n[o] = refract.Token.stringify(r, t, n);
  }

  return n;
}

function encode(e) {
  return e;
}

function attributes(e) {
  var t;

  for (t in e) {
    e[t] = decode(e[t]);
  }

  return e;
}

function capture() {
  var e = ("Prism" in ctx),
      t = e ? ctx.Prism : void 0;
  return function () {
    e ? ctx.Prism = t : delete ctx.Prism;
    e = void 0, t = void 0;
  };
}

refract.highlight = highlight, refract.register = register, refract.alias = alias, refract.registered = registered, refract.listLanguages = listLanguages, register(markup), register(css), register(clike), register(js), refract.util.encode = encode, refract.Token.stringify = stringify;
var defaultStyle = {
  'code[class*="language-"]': {
    color: "black",
    background: "none",
    textShadow: "0 1px white",
    fontFamily: "Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace",
    fontSize: "1em",
    textAlign: "left",
    whiteSpace: "pre",
    wordSpacing: "normal",
    wordBreak: "normal",
    wordWrap: "normal",
    lineHeight: "1.5",
    MozTabSize: "4",
    OTabSize: "4",
    tabSize: "4",
    WebkitHyphens: "none",
    MozHyphens: "none",
    msHyphens: "none",
    hyphens: "none"
  },
  'pre[class*="language-"]': {
    color: "black",
    background: "#f5f2f0",
    textShadow: "0 1px white",
    fontFamily: "Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace",
    fontSize: "1em",
    textAlign: "left",
    whiteSpace: "pre",
    wordSpacing: "normal",
    wordBreak: "normal",
    wordWrap: "normal",
    lineHeight: "1.5",
    MozTabSize: "4",
    OTabSize: "4",
    tabSize: "4",
    WebkitHyphens: "none",
    MozHyphens: "none",
    msHyphens: "none",
    hyphens: "none",
    padding: "1em",
    margin: ".5em 0",
    overflow: "auto"
  },
  'pre[class*="language-"]::-moz-selection': {
    textShadow: "none",
    background: "#b3d4fc"
  },
  'pre[class*="language-"] ::-moz-selection': {
    textShadow: "none",
    background: "#b3d4fc"
  },
  'code[class*="language-"]::-moz-selection': {
    textShadow: "none",
    background: "#b3d4fc"
  },
  'code[class*="language-"] ::-moz-selection': {
    textShadow: "none",
    background: "#b3d4fc"
  },
  'pre[class*="language-"]::selection': {
    textShadow: "none",
    background: "#b3d4fc"
  },
  'pre[class*="language-"] ::selection': {
    textShadow: "none",
    background: "#b3d4fc"
  },
  'code[class*="language-"]::selection': {
    textShadow: "none",
    background: "#b3d4fc"
  },
  'code[class*="language-"] ::selection': {
    textShadow: "none",
    background: "#b3d4fc"
  },
  ':not(pre) > code[class*="language-"]': {
    background: "#f5f2f0",
    padding: ".1em",
    borderRadius: ".3em",
    whiteSpace: "normal"
  },
  comment: {
    color: "slategray"
  },
  prolog: {
    color: "slategray"
  },
  doctype: {
    color: "slategray"
  },
  cdata: {
    color: "slategray"
  },
  punctuation: {
    color: "#999"
  },
  namespace: {
    Opacity: ".7"
  },
  property: {
    color: "#905"
  },
  tag: {
    color: "#905"
  },
  boolean: {
    color: "#905"
  },
  number: {
    color: "#905"
  },
  constant: {
    color: "#905"
  },
  symbol: {
    color: "#905"
  },
  deleted: {
    color: "#905"
  },
  selector: {
    color: "#690"
  },
  "attr-name": {
    color: "#690"
  },
  string: {
    color: "#690"
  },
  char: {
    color: "#690"
  },
  builtin: {
    color: "#690"
  },
  inserted: {
    color: "#690"
  },
  operator: {
    color: "#9a6e3a",
    background: "hsla(0, 0%, 100%, .5)"
  },
  entity: {
    color: "#9a6e3a",
    background: "hsla(0, 0%, 100%, .5)",
    cursor: "help"
  },
  url: {
    color: "#9a6e3a",
    background: "hsla(0, 0%, 100%, .5)"
  },
  ".language-css .token.string": {
    color: "#9a6e3a",
    background: "hsla(0, 0%, 100%, .5)"
  },
  ".style .token.string": {
    color: "#9a6e3a",
    background: "hsla(0, 0%, 100%, .5)"
  },
  atrule: {
    color: "#07a"
  },
  "attr-value": {
    color: "#07a"
  },
  keyword: {
    color: "#07a"
  },
  function: {
    color: "#DD4A68"
  },
  "class-name": {
    color: "#DD4A68"
  },
  regex: {
    color: "#e90"
  },
  important: {
    color: "#e90",
    fontWeight: "bold"
  },
  variable: {
    color: "#e90"
  },
  bold: {
    fontWeight: "bold"
  },
  italic: {
    fontStyle: "italic"
  }
},
    abap_1 = abap;

function abap(e) {
  e.languages.abap = {
    comment: /^\*.*/m,
    string: /(`|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
    "string-template": {
      pattern: /([|}])(?:\\.|[^\\|{\r\n])*(?=[|{])/,
      lookbehind: !0,
      alias: "string"
    },
    "eol-comment": {
      pattern: /(^|\s)".*/m,
      lookbehind: !0,
      alias: "comment"
    },
    keyword: {
      pattern: /(\s|\.|^)(?:SCIENTIFIC_WITH_LEADING_ZERO|SCALE_PRESERVING_SCIENTIFIC|RMC_COMMUNICATION_FAILURE|END-ENHANCEMENT-SECTION|MULTIPLY-CORRESPONDING|SUBTRACT-CORRESPONDING|VERIFICATION-MESSAGE|DIVIDE-CORRESPONDING|ENHANCEMENT-SECTION|CURRENCY_CONVERSION|RMC_SYSTEM_FAILURE|START-OF-SELECTION|MOVE-CORRESPONDING|RMC_INVALID_STATUS|CUSTOMER-FUNCTION|END-OF-DEFINITION|ENHANCEMENT-POINT|SYSTEM-EXCEPTIONS|ADD-CORRESPONDING|SCALE_PRESERVING|SELECTION-SCREEN|CURSOR-SELECTION|END-OF-SELECTION|LOAD-OF-PROGRAM|SCROLL-BOUNDARY|SELECTION-TABLE|EXCEPTION-TABLE|IMPLEMENTATIONS|PARAMETER-TABLE|RIGHT-JUSTIFIED|UNIT_CONVERSION|AUTHORITY-CHECK|LIST-PROCESSING|SIGN_AS_POSTFIX|COL_BACKGROUND|IMPLEMENTATION|INTERFACE-POOL|TRANSFORMATION|IDENTIFICATION|ENDENHANCEMENT|LINE-SELECTION|INITIALIZATION|LEFT-JUSTIFIED|SELECT-OPTIONS|SELECTION-SETS|COMMUNICATION|CORRESPONDING|DECIMAL_SHIFT|PRINT-CONTROL|VALUE-REQUEST|CHAIN-REQUEST|FUNCTION-POOL|FIELD-SYMBOLS|FUNCTIONALITY|INVERTED-DATE|SELECTION-SET|CLASS-METHODS|OUTPUT-LENGTH|CLASS-CODING|COL_NEGATIVE|ERRORMESSAGE|FIELD-GROUPS|HELP-REQUEST|NO-EXTENSION|NO-TOPOFPAGE|REDEFINITION|DISPLAY-MODE|ENDINTERFACE|EXIT-COMMAND|FIELD-SYMBOL|NO-SCROLLING|SHORTDUMP-ID|ACCESSPOLICY|CLASS-EVENTS|COL_POSITIVE|DECLARATIONS|ENHANCEMENTS|FILTER-TABLE|SWITCHSTATES|SYNTAX-CHECK|TRANSPORTING|ASYNCHRONOUS|SYNTAX-TRACE|TOKENIZATION|USER-COMMAND|WITH-HEADING|ABAP-SOURCE|BREAK-POINT|CHAIN-INPUT|COMPRESSION|FIXED-POINT|NEW-SECTION|NON-UNICODE|OCCURRENCES|RESPONSIBLE|SYSTEM-CALL|TRACE-TABLE|ABBREVIATED|CHAR-TO-HEX|END-OF-FILE|ENDFUNCTION|ENVIRONMENT|ASSOCIATION|COL_HEADING|EDITOR-CALL|END-OF-PAGE|ENGINEERING|IMPLEMENTED|INTENSIFIED|RADIOBUTTON|SYSTEM-EXIT|TOP-OF-PAGE|TRANSACTION|APPLICATION|CONCATENATE|DESTINATION|ENHANCEMENT|IMMEDIATELY|NO-GROUPING|PRECOMPILED|REPLACEMENT|TITLE-LINES|ACTIVATION|BYTE-ORDER|CLASS-POOL|CONNECTION|CONVERSION|DEFINITION|DEPARTMENT|EXPIRATION|INHERITING|MESSAGE-ID|NO-HEADING|PERFORMING|QUEUE-ONLY|RIGHTSPACE|SCIENTIFIC|STATUSINFO|STRUCTURES|SYNCPOINTS|WITH-TITLE|ATTRIBUTES|BOUNDARIES|CLASS-DATA|COL_NORMAL|DD\/MM\/YYYY|DESCENDING|INTERFACES|LINE-COUNT|MM\/DD\/YYYY|NON-UNIQUE|PRESERVING|SELECTIONS|STATEMENTS|SUBROUTINE|TRUNCATION|TYPE-POOLS|ARITHMETIC|BACKGROUND|ENDPROVIDE|EXCEPTIONS|IDENTIFIER|INDEX-LINE|OBLIGATORY|PARAMETERS|PERCENTAGE|PUSHBUTTON|RESOLUTION|COMPONENTS|DEALLOCATE|DISCONNECT|DUPLICATES|FIRST-LINE|HEAD-LINES|NO-DISPLAY|OCCURRENCE|RESPECTING|RETURNCODE|SUBMATCHES|TRACE-FILE|ASCENDING|BYPASSING|ENDMODULE|EXCEPTION|EXCLUDING|EXPORTING|INCREMENT|MATCHCODE|PARAMETER|PARTIALLY|PREFERRED|REFERENCE|REPLACING|RETURNING|SELECTION|SEPARATED|SPECIFIED|STATEMENT|TIMESTAMP|TYPE-POOL|ACCEPTING|APPENDAGE|ASSIGNING|COL_GROUP|COMPARING|CONSTANTS|DANGEROUS|IMPORTING|INSTANCES|LEFTSPACE|LOG-POINT|QUICKINFO|READ-ONLY|SCROLLING|SQLSCRIPT|STEP-LOOP|TOP-LINES|TRANSLATE|APPENDING|AUTHORITY|CHARACTER|COMPONENT|CONDITION|DIRECTORY|DUPLICATE|MESSAGING|RECEIVING|SUBSCREEN|ACCORDING|COL_TOTAL|END-LINES|ENDMETHOD|ENDSELECT|EXPANDING|EXTENSION|INCLUDING|INFOTYPES|INTERFACE|INTERVALS|LINE-SIZE|PF-STATUS|PROCEDURE|PROTECTED|REQUESTED|RESUMABLE|RIGHTPLUS|SAP-SPOOL|SECONDARY|STRUCTURE|SUBSTRING|TABLEVIEW|NUMOFCHAR|ADJACENT|ANALYSIS|ASSIGNED|BACKWARD|CHANNELS|CHECKBOX|CONTINUE|CRITICAL|DATAINFO|DD\/MM\/YY|DURATION|ENCODING|ENDCLASS|FUNCTION|LEFTPLUS|LINEFEED|MM\/DD\/YY|OVERFLOW|RECEIVED|SKIPPING|SORTABLE|STANDARD|SUBTRACT|SUPPRESS|TABSTRIP|TITLEBAR|TRUNCATE|UNASSIGN|WHENEVER|ANALYZER|COALESCE|COMMENTS|CONDENSE|DECIMALS|DEFERRED|ENDWHILE|EXPLICIT|KEYWORDS|MESSAGES|POSITION|PRIORITY|RECEIVER|RENAMING|TIMEZONE|TRAILING|ALLOCATE|CENTERED|CIRCULAR|CONTROLS|CURRENCY|DELETING|DESCRIBE|DISTANCE|ENDCATCH|EXPONENT|EXTENDED|GENERATE|IGNORING|INCLUDES|INTERNAL|MAJOR-ID|MODIFIER|NEW-LINE|OPTIONAL|PROPERTY|ROLLBACK|STARTING|SUPPLIED|ABSTRACT|CHANGING|CONTEXTS|CREATING|CUSTOMER|DATABASE|DAYLIGHT|DEFINING|DISTINCT|DIVISION|ENABLING|ENDCHAIN|ESCAPING|HARMLESS|IMPLICIT|INACTIVE|LANGUAGE|MINOR-ID|MULTIPLY|NEW-PAGE|NO-TITLE|POS_HIGH|SEPARATE|TEXTPOOL|TRANSFER|SELECTOR|DBMAXLEN|ITERATOR|ARCHIVE|BIT-XOR|BYTE-CO|COLLECT|COMMENT|CURRENT|DEFAULT|DISPLAY|ENDFORM|EXTRACT|LEADING|LISTBOX|LOCATOR|MEMBERS|METHODS|NESTING|POS_LOW|PROCESS|PROVIDE|RAISING|RESERVE|SECONDS|SUMMARY|VISIBLE|BETWEEN|BIT-AND|BYTE-CS|CLEANUP|COMPUTE|CONTROL|CONVERT|DATASET|ENDCASE|FORWARD|HEADERS|HOTSPOT|INCLUDE|INVERSE|KEEPING|NO-ZERO|OBJECTS|OVERLAY|PADDING|PATTERN|PROGRAM|REFRESH|SECTION|SUMMING|TESTING|VERSION|WINDOWS|WITHOUT|BIT-NOT|BYTE-CA|BYTE-NA|CASTING|CONTEXT|COUNTRY|DYNAMIC|ENABLED|ENDLOOP|EXECUTE|FRIENDS|HANDLER|HEADING|INITIAL|\*-INPUT|LOGFILE|MAXIMUM|MINIMUM|NO-GAPS|NO-SIGN|PRAGMAS|PRIMARY|PRIVATE|REDUCED|REPLACE|REQUEST|RESULTS|UNICODE|WARNING|ALIASES|BYTE-CN|BYTE-NS|CALLING|COL_KEY|COLUMNS|CONNECT|ENDEXEC|ENTRIES|EXCLUDE|FILTERS|FURTHER|HELP-ID|LOGICAL|MAPPING|MESSAGE|NAMETAB|OPTIONS|PACKAGE|PERFORM|RECEIVE|STATICS|VARYING|BINDING|CHARLEN|GREATER|XSTRLEN|ACCEPT|APPEND|DETAIL|ELSEIF|ENDING|ENDTRY|FORMAT|FRAMES|GIVING|HASHED|HEADER|IMPORT|INSERT|MARGIN|MODULE|NATIVE|OBJECT|OFFSET|REMOTE|RESUME|SAVING|SIMPLE|SUBMIT|TABBED|TOKENS|UNIQUE|UNPACK|UPDATE|WINDOW|YELLOW|ACTUAL|ASPECT|CENTER|CURSOR|DELETE|DIALOG|DIVIDE|DURING|ERRORS|EVENTS|EXTEND|FILTER|HANDLE|HAVING|IGNORE|LITTLE|MEMORY|NO-GAP|OCCURS|OPTION|PERSON|PLACES|PUBLIC|REDUCE|REPORT|RESULT|SINGLE|SORTED|SWITCH|SYNTAX|TARGET|VALUES|WRITER|ASSERT|BLOCKS|BOUNDS|BUFFER|CHANGE|COLUMN|COMMIT|CONCAT|COPIES|CREATE|DDMMYY|DEFINE|ENDIAN|ESCAPE|EXPAND|KERNEL|LAYOUT|LEGACY|LEVELS|MMDDYY|NUMBER|OUTPUT|RANGES|READER|RETURN|SCREEN|SEARCH|SELECT|SHARED|SOURCE|STABLE|STATIC|SUBKEY|SUFFIX|TABLES|UNWIND|YYMMDD|ASSIGN|BACKUP|BEFORE|BINARY|BIT-OR|BLANKS|CLIENT|CODING|COMMON|DEMAND|DYNPRO|EXCEPT|EXISTS|EXPORT|FIELDS|GLOBAL|GROUPS|LENGTH|LOCALE|MEDIUM|METHOD|MODIFY|NESTED|OTHERS|REJECT|SCROLL|SUPPLY|SYMBOL|ENDFOR|STRLEN|ALIGN|BEGIN|BOUND|ENDAT|ENTRY|EVENT|FINAL|FLUSH|GRANT|INNER|SHORT|USING|WRITE|AFTER|BLACK|BLOCK|CLOCK|COLOR|COUNT|DUMMY|EMPTY|ENDDO|ENDON|GREEN|INDEX|INOUT|LEAVE|LEVEL|LINES|MODIF|ORDER|OUTER|RANGE|RESET|RETRY|RIGHT|SMART|SPLIT|STYLE|TABLE|THROW|UNDER|UNTIL|UPPER|UTF-8|WHERE|ALIAS|BLANK|CLEAR|CLOSE|EXACT|FETCH|FIRST|FOUND|GROUP|LLANG|LOCAL|OTHER|REGEX|SPOOL|TITLE|TYPES|VALID|WHILE|ALPHA|BOXED|CATCH|CHAIN|CHECK|CLASS|COVER|ENDIF|EQUIV|FIELD|FLOOR|FRAME|INPUT|LOWER|MATCH|NODES|PAGES|PRINT|RAISE|ROUND|SHIFT|SPACE|SPOTS|STAMP|STATE|TASKS|TIMES|TRMAC|ULINE|UNION|VALUE|WIDTH|EQUAL|LOG10|TRUNC|BLOB|CASE|CEIL|CLOB|COND|EXIT|FILE|GAPS|HOLD|INCL|INTO|KEEP|KEYS|LAST|LINE|LONG|LPAD|MAIL|MODE|OPEN|PINK|READ|ROWS|TEST|THEN|ZERO|AREA|BACK|BADI|BYTE|CAST|EDIT|EXEC|FAIL|FIND|FKEQ|FONT|FREE|GKEQ|HIDE|INIT|ITNO|LATE|LOOP|MAIN|MARK|MOVE|NEXT|NULL|RISK|ROLE|UNIT|WAIT|ZONE|BASE|CALL|CODE|DATA|DATE|FKGE|GKGE|HIGH|KIND|LEFT|LIST|MASK|MESH|NAME|NODE|PACK|PAGE|POOL|SEND|SIGN|SIZE|SOME|STOP|TASK|TEXT|TIME|USER|VARY|WITH|WORD|BLUE|CONV|COPY|DEEP|ELSE|FORM|FROM|HINT|ICON|JOIN|LIKE|LOAD|ONLY|PART|SCAN|SKIP|SORT|TYPE|UNIX|VIEW|WHEN|WORK|ACOS|ASIN|ATAN|COSH|EACH|FRAC|LESS|RTTI|SINH|SQRT|TANH|AVG|BIT|DIV|ISO|LET|OUT|PAD|SQL|ALL|CI_|CPI|END|LOB|LPI|MAX|MIN|NEW|OLE|RUN|SET|\?TO|YES|ABS|ADD|AND|BIG|FOR|HDB|JOB|LOW|NOT|SAP|TRY|VIA|XML|ANY|GET|IDS|KEY|MOD|OFF|PUT|RAW|RED|REF|SUM|TAB|XSD|CNT|COS|EXP|LOG|SIN|TAN|XOR|AT|CO|CP|DO|GT|ID|IF|NS|OR|BT|CA|CS|GE|NA|NB|EQ|IN|LT|NE|NO|OF|ON|PF|TO|AS|BY|CN|IS|LE|NP|UP|E|I|M|O|Z|C|X)\b/i,
      lookbehind: !0
    },
    number: /\b\d+\b/,
    operator: {
      pattern: /(\s)(?:\*\*?|<[=>]?|>=?|\?=|[-+\/=])(?=\s)/,
      lookbehind: !0
    },
    "string-operator": {
      pattern: /(\s)&&?(?=\s)/,
      lookbehind: !0,
      alias: "keyword"
    },
    "token-operator": [{
      pattern: /(\w)(?:->?|=>|[~|{}])(?=\w)/,
      lookbehind: !0,
      alias: "punctuation"
    }, {
      pattern: /[|{}]/,
      alias: "punctuation"
    }],
    punctuation: /[,.:()]/
  };
}

abap.displayName = "abap", abap.aliases = [];
var abnf_1 = abnf;

function abnf(e) {
  !function (e) {
    var t = "(?:ALPHA|BIT|CHAR|CR|CRLF|CTL|DIGIT|DQUOTE|HEXDIG|HTAB|LF|LWSP|OCTET|SP|VCHAR|WSP)";
    e.languages.abnf = {
      comment: /;.*/,
      string: {
        pattern: /(?:%[is])?"[^"\n\r]*"/,
        greedy: !0,
        inside: {
          punctuation: /^%[is]/
        }
      },
      range: {
        pattern: /%(?:b[01]+-[01]+|d\d+-\d+|x[A-F\d]+-[A-F\d]+)/i,
        alias: "number"
      },
      terminal: {
        pattern: /%(?:b[01]+(?:\.[01]+)*|d\d+(?:\.\d+)*|x[A-F\d]+(?:\.[A-F\d]+)*)/i,
        alias: "number"
      },
      repetition: {
        pattern: /(^|[^\w-])(?:\d*\*\d*|\d+)/,
        lookbehind: !0,
        alias: "operator"
      },
      definition: {
        pattern: /(^[ \t]*)(?:[a-z][\w-]*|<[^<>\r\n]*>)(?=\s*=)/m,
        lookbehind: !0,
        alias: "keyword",
        inside: {
          punctuation: /<|>/
        }
      },
      "core-rule": {
        pattern: RegExp("(?:(^|[^<\\w-])" + t + "|<" + t + ">)(?![\\w-])", "i"),
        lookbehind: !0,
        alias: ["rule", "constant"],
        inside: {
          punctuation: /<|>/
        }
      },
      rule: {
        pattern: /(^|[^<\w-])[a-z][\w-]*|<[^<>\r\n]*>/i,
        lookbehind: !0,
        inside: {
          punctuation: /<|>/
        }
      },
      operator: /=\/?|\//,
      punctuation: /[()\[\]]/
    };
  }(e);
}

abnf.displayName = "abnf", abnf.aliases = [];
var actionscript_1 = actionscript;

function actionscript(e) {
  e.languages.actionscript = e.languages.extend("javascript", {
    keyword: /\b(?:as|break|case|catch|class|const|default|delete|do|dynamic|each|else|extends|final|finally|for|function|get|if|implements|import|in|include|instanceof|interface|internal|is|namespace|native|new|null|override|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|use|var|void|while|with)\b/,
    operator: /\+\+|--|(?:[+\-*\/%^]|&&?|\|\|?|<<?|>>?>?|[!=]=?)=?|[~?@]/
  }), e.languages.actionscript["class-name"].alias = "function", delete e.languages.actionscript.parameter, delete e.languages.actionscript["literal-property"], e.languages.markup && e.languages.insertBefore("actionscript", "string", {
    xml: {
      pattern: /(^|[^.])<\/?\w+(?:\s+[^\s>\/=]+=("|')(?:\\[\s\S]|(?!\2)[^\\])*\2)*\s*\/?>/,
      lookbehind: !0,
      inside: e.languages.markup
    }
  });
}

actionscript.displayName = "actionscript", actionscript.aliases = [];
var ada_1 = ada;

function ada(e) {
  e.languages.ada = {
    comment: /--.*/,
    string: /"(?:""|[^"\r\f\n])*"/,
    number: [{
      pattern: /\b\d(?:_?\d)*#[\dA-F](?:_?[\dA-F])*(?:\.[\dA-F](?:_?[\dA-F])*)?#(?:E[+-]?\d(?:_?\d)*)?/i
    }, {
      pattern: /\b\d(?:_?\d)*(?:\.\d(?:_?\d)*)?(?:E[+-]?\d(?:_?\d)*)?\b/i
    }],
    "attr-name": /\b'\w+/,
    keyword: /\b(?:abort|abs|abstract|accept|access|aliased|all|and|array|at|begin|body|case|constant|declare|delay|delta|digits|do|else|elsif|end|entry|exception|exit|for|function|generic|goto|if|in|interface|is|limited|loop|mod|new|not|null|of|others|out|overriding|package|pragma|private|procedure|protected|raise|range|record|rem|renames|requeue|return|reverse|select|separate|some|subtype|synchronized|tagged|task|terminate|then|type|until|use|when|while|with|xor)\b/i,
    boolean: /\b(?:false|true)\b/i,
    operator: /<[=>]?|>=?|=>?|:=|\/=?|\*\*?|[&+-]/,
    punctuation: /\.\.?|[,;():]/,
    char: /'.'/,
    variable: /\b[a-z](?:\w)*\b/i
  };
}

ada.displayName = "ada", ada.aliases = [];
var agda_1 = agda;

function agda(e) {
  !function (e) {
    e.languages.agda = {
      comment: /\{-[\s\S]*?(?:-\}|$)|--.*/,
      string: {
        pattern: /"(?:\\(?:\r\n|[\s\S])|[^\\\r\n"])*"/,
        greedy: !0
      },
      punctuation: /[(){}⦃⦄.;@]/,
      "class-name": {
        pattern: /((?:data|record) +)\S+/,
        lookbehind: !0
      },
      function: {
        pattern: /(^[ \t]*)(?!\s)[^:\r\n]+(?=:)/m,
        lookbehind: !0
      },
      operator: {
        pattern: /(^\s*|\s)(?:[=|:∀→λ\\?_]|->)(?=\s)/,
        lookbehind: !0
      },
      keyword: /\b(?:Set|abstract|constructor|data|eta-equality|field|forall|hiding|import|in|inductive|infix|infixl|infixr|instance|let|macro|module|mutual|no-eta-equality|open|overlap|pattern|postulate|primitive|private|public|quote|quoteContext|quoteGoal|quoteTerm|record|renaming|rewrite|syntax|tactic|unquote|unquoteDecl|unquoteDef|using|variable|where|with)\b/
    };
  }(e);
}

agda.displayName = "agda", agda.aliases = [];
var al_1 = al;

function al(e) {
  e.languages.al = {
    comment: /\/\/.*|\/\*[\s\S]*?\*\//,
    string: {
      pattern: /'(?:''|[^'\r\n])*'(?!')|"(?:""|[^"\r\n])*"(?!")/,
      greedy: !0
    },
    function: {
      pattern: /(\b(?:event|procedure|trigger)\s+|(?:^|[^.])\.\s*)[a-z_]\w*(?=\s*\()/i,
      lookbehind: !0
    },
    keyword: [/\b(?:array|asserterror|begin|break|case|do|downto|else|end|event|exit|for|foreach|function|if|implements|in|indataset|interface|internal|local|of|procedure|program|protected|repeat|runonclient|securityfiltering|suppressdispose|temporary|then|to|trigger|until|var|while|with|withevents)\b/i, /\b(?:action|actions|addafter|addbefore|addfirst|addlast|area|assembly|chartpart|codeunit|column|controladdin|cuegroup|customizes|dataitem|dataset|dotnet|elements|enum|enumextension|extends|field|fieldattribute|fieldelement|fieldgroup|fieldgroups|fields|filter|fixed|grid|group|key|keys|label|labels|layout|modify|moveafter|movebefore|movefirst|movelast|page|pagecustomization|pageextension|part|profile|query|repeater|report|requestpage|schema|separator|systempart|table|tableelement|tableextension|textattribute|textelement|type|usercontrol|value|xmlport)\b/i],
    number: /\b(?:0x[\da-f]+|(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?)(?:F|LL?|U(?:LL?)?)?\b/i,
    boolean: /\b(?:false|true)\b/i,
    variable: /\b(?:Curr(?:FieldNo|Page|Report)|x?Rec|RequestOptionsPage)\b/,
    "class-name": /\b(?:automation|biginteger|bigtext|blob|boolean|byte|char|clienttype|code|completiontriggererrorlevel|connectiontype|database|dataclassification|datascope|date|dateformula|datetime|decimal|defaultlayout|dialog|dictionary|dotnetassembly|dotnettypedeclaration|duration|errorinfo|errortype|executioncontext|executionmode|fieldclass|fieldref|fieldtype|file|filterpagebuilder|guid|httpclient|httpcontent|httpheaders|httprequestmessage|httpresponsemessage|instream|integer|joker|jsonarray|jsonobject|jsontoken|jsonvalue|keyref|list|moduledependencyinfo|moduleinfo|none|notification|notificationscope|objecttype|option|outstream|pageresult|record|recordid|recordref|reportformat|securityfilter|sessionsettings|tableconnectiontype|tablefilter|testaction|testfield|testfilterfield|testpage|testpermissions|testrequestpage|text|textbuilder|textconst|textencoding|time|transactionmodel|transactiontype|variant|verbosity|version|view|views|webserviceactioncontext|webserviceactionresultcode|xmlattribute|xmlattributecollection|xmlcdata|xmlcomment|xmldeclaration|xmldocument|xmldocumenttype|xmlelement|xmlnamespacemanager|xmlnametable|xmlnode|xmlnodelist|xmlprocessinginstruction|xmlreadoptions|xmltext|xmlwriteoptions)\b/i,
    operator: /\.\.|:[=:]|[-+*/]=?|<>|[<>]=?|=|\b(?:and|div|mod|not|or|xor)\b/i,
    punctuation: /[()\[\]{}:.;,]/
  };
}

al.displayName = "al", al.aliases = [];
var antlr4_1 = antlr4;

function antlr4(e) {
  e.languages.antlr4 = {
    comment: /\/\/.*|\/\*[\s\S]*?(?:\*\/|$)/,
    string: {
      pattern: /'(?:\\.|[^\\'\r\n])*'/,
      greedy: !0
    },
    "character-class": {
      pattern: /\[(?:\\.|[^\\\]\r\n])*\]/,
      greedy: !0,
      alias: "regex",
      inside: {
        range: {
          pattern: /([^[]|(?:^|[^\\])(?:\\\\)*\\\[)-(?!\])/,
          lookbehind: !0,
          alias: "punctuation"
        },
        escape: /\\(?:u(?:[a-fA-F\d]{4}|\{[a-fA-F\d]+\})|[pP]\{[=\w-]+\}|[^\r\nupP])/,
        punctuation: /[\[\]]/
      }
    },
    action: {
      pattern: /\{(?:[^{}]|\{(?:[^{}]|\{(?:[^{}]|\{[^{}]*\})*\})*\})*\}/,
      greedy: !0,
      inside: {
        content: {
          pattern: /(\{)[\s\S]+(?=\})/,
          lookbehind: !0
        },
        punctuation: /[{}]/
      }
    },
    command: {
      pattern: /(->\s*(?!\s))(?:\s*(?:,\s*)?\b[a-z]\w*(?:\s*\([^()\r\n]*\))?)+(?=\s*;)/i,
      lookbehind: !0,
      inside: {
        function: /\b\w+(?=\s*(?:[,(]|$))/,
        punctuation: /[,()]/
      }
    },
    annotation: {
      pattern: /@\w+(?:::\w+)*/,
      alias: "keyword"
    },
    label: {
      pattern: /#[ \t]*\w+/,
      alias: "punctuation"
    },
    keyword: /\b(?:catch|channels|finally|fragment|grammar|import|lexer|locals|mode|options|parser|returns|throws|tokens)\b/,
    definition: [{
      pattern: /\b[a-z]\w*(?=\s*:)/,
      alias: ["rule", "class-name"]
    }, {
      pattern: /\b[A-Z]\w*(?=\s*:)/,
      alias: ["token", "constant"]
    }],
    constant: /\b[A-Z][A-Z_]*\b/,
    operator: /\.\.|->|[|~]|[*+?]\??/,
    punctuation: /[;:()=]/
  }, e.languages.g4 = e.languages.antlr4;
}

antlr4.displayName = "antlr4", antlr4.aliases = ["g4"];
var apacheconf_1 = apacheconf;

function apacheconf(e) {
  e.languages.apacheconf = {
    comment: /#.*/,
    "directive-inline": {
      pattern: /(^[\t ]*)\b(?:AcceptFilter|AcceptPathInfo|AccessFileName|Action|Add(?:Alt|AltByEncoding|AltByType|Charset|DefaultCharset|Description|Encoding|Handler|Icon|IconByEncoding|IconByType|InputFilter|Language|ModuleInfo|OutputFilter|OutputFilterByType|Type)|Alias|AliasMatch|Allow(?:CONNECT|EncodedSlashes|Methods|Override|OverrideList)?|Anonymous(?:_LogEmail|_MustGiveEmail|_NoUserID|_VerifyEmail)?|AsyncRequestWorkerFactor|Auth(?:BasicAuthoritative|BasicFake|BasicProvider|BasicUseDigestAlgorithm|DBDUserPWQuery|DBDUserRealmQuery|DBMGroupFile|DBMType|DBMUserFile|Digest(?:Algorithm|Domain|NonceLifetime|Provider|Qop|ShmemSize)|Form(?:Authoritative|Body|DisableNoStore|FakeBasicAuth|Location|LoginRequiredLocation|LoginSuccessLocation|LogoutLocation|Method|Mimetype|Password|Provider|SitePassphrase|Size|Username)|GroupFile|LDAP(?:AuthorizePrefix|BindAuthoritative|BindDN|BindPassword|CharsetConfig|CompareAsUser|CompareDNOnServer|DereferenceAliases|GroupAttribute|GroupAttributeIsDN|InitialBindAsUser|InitialBindPattern|MaxSubGroupDepth|RemoteUserAttribute|RemoteUserIsDN|SearchAsUser|SubGroupAttribute|SubGroupClass|Url)|Merging|Name|nCache(?:Context|Enable|ProvideFor|SOCache|Timeout)|nzFcgiCheckAuthnProvider|nzFcgiDefineProvider|Type|UserFile|zDBDLoginToReferer|zDBDQuery|zDBDRedirectQuery|zDBMType|zSendForbiddenOnFailure)|BalancerGrowth|BalancerInherit|BalancerMember|BalancerPersist|BrowserMatch|BrowserMatchNoCase|BufferedLogs|BufferSize|Cache(?:DefaultExpire|DetailHeader|DirLength|DirLevels|Disable|Enable|File|Header|IgnoreCacheControl|IgnoreHeaders|IgnoreNoLastMod|IgnoreQueryString|IgnoreURLSessionIdentifiers|KeyBaseURL|LastModifiedFactor|Lock|LockMaxAge|LockPath|MaxExpire|MaxFileSize|MinExpire|MinFileSize|NegotiatedDocs|QuickHandler|ReadSize|ReadTime|Root|Socache(?:MaxSize|MaxTime|MinTime|ReadSize|ReadTime)?|StaleOnError|StoreExpired|StoreNoStore|StorePrivate)|CGIDScriptTimeout|CGIMapExtension|CharsetDefault|CharsetOptions|CharsetSourceEnc|CheckCaseOnly|CheckSpelling|ChrootDir|ContentDigest|CookieDomain|CookieExpires|CookieName|CookieStyle|CookieTracking|CoreDumpDirectory|CustomLog|Dav|DavDepthInfinity|DavGenericLockDB|DavLockDB|DavMinTimeout|DBDExptime|DBDInitSQL|DBDKeep|DBDMax|DBDMin|DBDParams|DBDPersist|DBDPrepareSQL|DBDriver|DefaultIcon|DefaultLanguage|DefaultRuntimeDir|DefaultType|Define|Deflate(?:BufferSize|CompressionLevel|FilterNote|InflateLimitRequestBody|InflateRatio(?:Burst|Limit)|MemLevel|WindowSize)|Deny|DirectoryCheckHandler|DirectoryIndex|DirectoryIndexRedirect|DirectorySlash|DocumentRoot|DTracePrivileges|DumpIOInput|DumpIOOutput|EnableExceptionHook|EnableMMAP|EnableSendfile|Error|ErrorDocument|ErrorLog|ErrorLogFormat|Example|ExpiresActive|ExpiresByType|ExpiresDefault|ExtendedStatus|ExtFilterDefine|ExtFilterOptions|FallbackResource|FileETag|FilterChain|FilterDeclare|FilterProtocol|FilterProvider|FilterTrace|ForceLanguagePriority|ForceType|ForensicLog|GprofDir|GracefulShutdownTimeout|Group|Header|HeaderName|Heartbeat(?:Address|Listen|MaxServers|Storage)|HostnameLookups|IdentityCheck|IdentityCheckTimeout|ImapBase|ImapDefault|ImapMenu|Include|IncludeOptional|Index(?:HeadInsert|Ignore|IgnoreReset|Options|OrderDefault|StyleSheet)|InputSed|ISAPI(?:AppendLogToErrors|AppendLogToQuery|CacheFile|FakeAsync|LogNotSupported|ReadAheadBuffer)|KeepAlive|KeepAliveTimeout|KeptBodySize|LanguagePriority|LDAP(?:CacheEntries|CacheTTL|ConnectionPoolTTL|ConnectionTimeout|LibraryDebug|OpCacheEntries|OpCacheTTL|ReferralHopLimit|Referrals|Retries|RetryDelay|SharedCacheFile|SharedCacheSize|Timeout|TrustedClientCert|TrustedGlobalCert|TrustedMode|VerifyServerCert)|Limit(?:InternalRecursion|Request(?:Body|Fields|FieldSize|Line)|XMLRequestBody)|Listen|ListenBackLog|LoadFile|LoadModule|LogFormat|LogLevel|LogMessage|LuaAuthzProvider|LuaCodeCache|Lua(?:Hook(?:AccessChecker|AuthChecker|CheckUserID|Fixups|InsertFilter|Log|MapToStorage|TranslateName|TypeChecker)|Inherit|InputFilter|MapHandler|OutputFilter|PackageCPath|PackagePath|QuickHandler|Root|Scope)|Max(?:ConnectionsPerChild|KeepAliveRequests|MemFree|RangeOverlaps|RangeReversals|Ranges|RequestWorkers|SpareServers|SpareThreads|Threads)|MergeTrailers|MetaDir|MetaFiles|MetaSuffix|MimeMagicFile|MinSpareServers|MinSpareThreads|MMapFile|ModemStandard|ModMimeUsePathInfo|MultiviewsMatch|Mutex|NameVirtualHost|NoProxy|NWSSLTrustedCerts|NWSSLUpgradeable|Options|Order|OutputSed|PassEnv|PidFile|PrivilegesMode|Protocol|ProtocolEcho|Proxy(?:AddHeaders|BadHeader|Block|Domain|ErrorOverride|ExpressDBMFile|ExpressDBMType|ExpressEnable|FtpDirCharset|FtpEscapeWildcards|FtpListOnWildcard|HTML(?:BufSize|CharsetOut|DocType|Enable|Events|Extended|Fixups|Interp|Links|Meta|StripComments|URLMap)|IOBufferSize|MaxForwards|Pass(?:Inherit|InterpolateEnv|Match|Reverse|ReverseCookieDomain|ReverseCookiePath)?|PreserveHost|ReceiveBufferSize|Remote|RemoteMatch|Requests|SCGIInternalRedirect|SCGISendfile|Set|SourceAddress|Status|Timeout|Via)|ReadmeName|ReceiveBufferSize|Redirect|RedirectMatch|RedirectPermanent|RedirectTemp|ReflectorHeader|RemoteIP(?:Header|InternalProxy|InternalProxyList|ProxiesHeader|TrustedProxy|TrustedProxyList)|RemoveCharset|RemoveEncoding|RemoveHandler|RemoveInputFilter|RemoveLanguage|RemoveOutputFilter|RemoveType|RequestHeader|RequestReadTimeout|Require|Rewrite(?:Base|Cond|Engine|Map|Options|Rule)|RLimitCPU|RLimitMEM|RLimitNPROC|Satisfy|ScoreBoardFile|Script(?:Alias|AliasMatch|InterpreterSource|Log|LogBuffer|LogLength|Sock)?|SecureListen|SeeRequestTail|SendBufferSize|Server(?:Admin|Alias|Limit|Name|Path|Root|Signature|Tokens)|Session(?:Cookie(?:Name|Name2|Remove)|Crypto(?:Cipher|Driver|Passphrase|PassphraseFile)|DBD(?:CookieName|CookieName2|CookieRemove|DeleteLabel|InsertLabel|PerUser|SelectLabel|UpdateLabel)|Env|Exclude|Header|Include|MaxAge)?|SetEnv|SetEnvIf|SetEnvIfExpr|SetEnvIfNoCase|SetHandler|SetInputFilter|SetOutputFilter|SSIEndTag|SSIErrorMsg|SSIETag|SSILastModified|SSILegacyExprParser|SSIStartTag|SSITimeFormat|SSIUndefinedEcho|SSL(?:CACertificateFile|CACertificatePath|CADNRequestFile|CADNRequestPath|CARevocationCheck|CARevocationFile|CARevocationPath|CertificateChainFile|CertificateFile|CertificateKeyFile|CipherSuite|Compression|CryptoDevice|Engine|FIPS|HonorCipherOrder|InsecureRenegotiation|OCSP(?:DefaultResponder|Enable|OverrideResponder|ResponderTimeout|ResponseMaxAge|ResponseTimeSkew|UseRequestNonce)|OpenSSLConfCmd|Options|PassPhraseDialog|Protocol|Proxy(?:CACertificateFile|CACertificatePath|CARevocation(?:Check|File|Path)|CheckPeer(?:CN|Expire|Name)|CipherSuite|Engine|MachineCertificate(?:ChainFile|File|Path)|Protocol|Verify|VerifyDepth)|RandomSeed|RenegBufferSize|Require|RequireSSL|Session(?:Cache|CacheTimeout|TicketKeyFile|Tickets)|SRPUnknownUserSeed|SRPVerifierFile|Stapling(?:Cache|ErrorCacheTimeout|FakeTryLater|ForceURL|ResponderTimeout|ResponseMaxAge|ResponseTimeSkew|ReturnResponderErrors|StandardCacheTimeout)|StrictSNIVHostCheck|UserName|UseStapling|VerifyClient|VerifyDepth)|StartServers|StartThreads|Substitute|Suexec|SuexecUserGroup|ThreadLimit|ThreadsPerChild|ThreadStackSize|TimeOut|TraceEnable|TransferLog|TypesConfig|UnDefine|UndefMacro|UnsetEnv|Use|UseCanonicalName|UseCanonicalPhysicalPort|User|UserDir|VHostCGIMode|VHostCGIPrivs|VHostGroup|VHostPrivs|VHostSecure|VHostUser|Virtual(?:DocumentRoot|ScriptAlias)(?:IP)?|WatchdogInterval|XBitHack|xml2EncAlias|xml2EncDefault|xml2StartParse)\b/im,
      lookbehind: !0,
      alias: "property"
    },
    "directive-block": {
      pattern: /<\/?\b(?:Auth[nz]ProviderAlias|Directory|DirectoryMatch|Else|ElseIf|Files|FilesMatch|If|IfDefine|IfModule|IfVersion|Limit|LimitExcept|Location|LocationMatch|Macro|Proxy|Require(?:All|Any|None)|VirtualHost)\b.*>/i,
      inside: {
        "directive-block": {
          pattern: /^<\/?\w+/,
          inside: {
            punctuation: /^<\/?/
          },
          alias: "tag"
        },
        "directive-block-parameter": {
          pattern: /.*[^>]/,
          inside: {
            punctuation: /:/,
            string: {
              pattern: /("|').*\1/,
              inside: {
                variable: /[$%]\{?(?:\w\.?[-+:]?)+\}?/
              }
            }
          },
          alias: "attr-value"
        },
        punctuation: />/
      },
      alias: "tag"
    },
    "directive-flags": {
      pattern: /\[(?:[\w=],?)+\]/,
      alias: "keyword"
    },
    string: {
      pattern: /("|').*\1/,
      inside: {
        variable: /[$%]\{?(?:\w\.?[-+:]?)+\}?/
      }
    },
    variable: /[$%]\{?(?:\w\.?[-+:]?)+\}?/,
    regex: /\^?.*\$|\^.*\$?/
  };
}

apacheconf.displayName = "apacheconf", apacheconf.aliases = [];
var sql_1 = sql;

function sql(e) {
  e.languages.sql = {
    comment: {
      pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|(?:--|\/\/|#).*)/,
      lookbehind: !0
    },
    variable: [{
      pattern: /@(["'`])(?:\\[\s\S]|(?!\1)[^\\])+\1/,
      greedy: !0
    }, /@[\w.$]+/],
    string: {
      pattern: /(^|[^@\\])("|')(?:\\[\s\S]|(?!\2)[^\\]|\2\2)*\2/,
      greedy: !0,
      lookbehind: !0
    },
    identifier: {
      pattern: /(^|[^@\\])`(?:\\[\s\S]|[^`\\]|``)*`/,
      greedy: !0,
      lookbehind: !0,
      inside: {
        punctuation: /^`|`$/
      }
    },
    function: /\b(?:AVG|COUNT|FIRST|FORMAT|LAST|LCASE|LEN|MAX|MID|MIN|MOD|NOW|ROUND|SUM|UCASE)(?=\s*\()/i,
    keyword: /\b(?:ACTION|ADD|AFTER|ALGORITHM|ALL|ALTER|ANALYZE|ANY|APPLY|AS|ASC|AUTHORIZATION|AUTO_INCREMENT|BACKUP|BDB|BEGIN|BERKELEYDB|BIGINT|BINARY|BIT|BLOB|BOOL|BOOLEAN|BREAK|BROWSE|BTREE|BULK|BY|CALL|CASCADED?|CASE|CHAIN|CHAR(?:ACTER|SET)?|CHECK(?:POINT)?|CLOSE|CLUSTERED|COALESCE|COLLATE|COLUMNS?|COMMENT|COMMIT(?:TED)?|COMPUTE|CONNECT|CONSISTENT|CONSTRAINT|CONTAINS(?:TABLE)?|CONTINUE|CONVERT|CREATE|CROSS|CURRENT(?:_DATE|_TIME|_TIMESTAMP|_USER)?|CURSOR|CYCLE|DATA(?:BASES?)?|DATE(?:TIME)?|DAY|DBCC|DEALLOCATE|DEC|DECIMAL|DECLARE|DEFAULT|DEFINER|DELAYED|DELETE|DELIMITERS?|DENY|DESC|DESCRIBE|DETERMINISTIC|DISABLE|DISCARD|DISK|DISTINCT|DISTINCTROW|DISTRIBUTED|DO|DOUBLE|DROP|DUMMY|DUMP(?:FILE)?|DUPLICATE|ELSE(?:IF)?|ENABLE|ENCLOSED|END|ENGINE|ENUM|ERRLVL|ERRORS|ESCAPED?|EXCEPT|EXEC(?:UTE)?|EXISTS|EXIT|EXPLAIN|EXTENDED|FETCH|FIELDS|FILE|FILLFACTOR|FIRST|FIXED|FLOAT|FOLLOWING|FOR(?: EACH ROW)?|FORCE|FOREIGN|FREETEXT(?:TABLE)?|FROM|FULL|FUNCTION|GEOMETRY(?:COLLECTION)?|GLOBAL|GOTO|GRANT|GROUP|HANDLER|HASH|HAVING|HOLDLOCK|HOUR|IDENTITY(?:COL|_INSERT)?|IF|IGNORE|IMPORT|INDEX|INFILE|INNER|INNODB|INOUT|INSERT|INT|INTEGER|INTERSECT|INTERVAL|INTO|INVOKER|ISOLATION|ITERATE|JOIN|KEYS?|KILL|LANGUAGE|LAST|LEAVE|LEFT|LEVEL|LIMIT|LINENO|LINES|LINESTRING|LOAD|LOCAL|LOCK|LONG(?:BLOB|TEXT)|LOOP|MATCH(?:ED)?|MEDIUM(?:BLOB|INT|TEXT)|MERGE|MIDDLEINT|MINUTE|MODE|MODIFIES|MODIFY|MONTH|MULTI(?:LINESTRING|POINT|POLYGON)|NATIONAL|NATURAL|NCHAR|NEXT|NO|NONCLUSTERED|NULLIF|NUMERIC|OFF?|OFFSETS?|ON|OPEN(?:DATASOURCE|QUERY|ROWSET)?|OPTIMIZE|OPTION(?:ALLY)?|ORDER|OUT(?:ER|FILE)?|OVER|PARTIAL|PARTITION|PERCENT|PIVOT|PLAN|POINT|POLYGON|PRECEDING|PRECISION|PREPARE|PREV|PRIMARY|PRINT|PRIVILEGES|PROC(?:EDURE)?|PUBLIC|PURGE|QUICK|RAISERROR|READS?|REAL|RECONFIGURE|REFERENCES|RELEASE|RENAME|REPEAT(?:ABLE)?|REPLACE|REPLICATION|REQUIRE|RESIGNAL|RESTORE|RESTRICT|RETURN(?:ING|S)?|REVOKE|RIGHT|ROLLBACK|ROUTINE|ROW(?:COUNT|GUIDCOL|S)?|RTREE|RULE|SAVE(?:POINT)?|SCHEMA|SECOND|SELECT|SERIAL(?:IZABLE)?|SESSION(?:_USER)?|SET(?:USER)?|SHARE|SHOW|SHUTDOWN|SIMPLE|SMALLINT|SNAPSHOT|SOME|SONAME|SQL|START(?:ING)?|STATISTICS|STATUS|STRIPED|SYSTEM_USER|TABLES?|TABLESPACE|TEMP(?:ORARY|TABLE)?|TERMINATED|TEXT(?:SIZE)?|THEN|TIME(?:STAMP)?|TINY(?:BLOB|INT|TEXT)|TOP?|TRAN(?:SACTIONS?)?|TRIGGER|TRUNCATE|TSEQUAL|TYPES?|UNBOUNDED|UNCOMMITTED|UNDEFINED|UNION|UNIQUE|UNLOCK|UNPIVOT|UNSIGNED|UPDATE(?:TEXT)?|USAGE|USE|USER|USING|VALUES?|VAR(?:BINARY|CHAR|CHARACTER|YING)|VIEW|WAITFOR|WARNINGS|WHEN|WHERE|WHILE|WITH(?: ROLLUP|IN)?|WORK|WRITE(?:TEXT)?|YEAR)\b/i,
    boolean: /\b(?:FALSE|NULL|TRUE)\b/i,
    number: /\b0x[\da-f]+\b|\b\d+(?:\.\d*)?|\B\.\d+\b/i,
    operator: /[-+*\/=%^~]|&&?|\|\|?|!=?|<(?:=>?|<|>)?|>[>=]?|\b(?:AND|BETWEEN|DIV|ILIKE|IN|IS|LIKE|NOT|OR|REGEXP|RLIKE|SOUNDS LIKE|XOR)\b/i,
    punctuation: /[;[\]()`,.]/
  };
}

sql.displayName = "sql", sql.aliases = [];
var refractorSql$1 = sql_1,
    apex_1 = apex;

function apex(e) {
  e.register(refractorSql$1), function (e) {
    var t = /\b(?:(?:after|before)(?=\s+[a-z])|abstract|activate|and|any|array|as|asc|autonomous|begin|bigdecimal|blob|boolean|break|bulk|by|byte|case|cast|catch|char|class|collect|commit|const|continue|currency|date|datetime|decimal|default|delete|desc|do|double|else|end|enum|exception|exit|export|extends|final|finally|float|for|from|get(?=\s*[{};])|global|goto|group|having|hint|if|implements|import|in|inner|insert|instanceof|int|integer|interface|into|join|like|limit|list|long|loop|map|merge|new|not|null|nulls|number|object|of|on|or|outer|override|package|parallel|pragma|private|protected|public|retrieve|return|rollback|select|set|short|sObject|sort|static|string|super|switch|synchronized|system|testmethod|then|this|throw|time|transaction|transient|trigger|try|undelete|update|upsert|using|virtual|void|webservice|when|where|while|(?:inherited|with|without)\s+sharing)\b/i,
        r = /\b(?:(?=[a-z_]\w*\s*[<\[])|(?!<keyword>))[A-Z_]\w*(?:\s*\.\s*[A-Z_]\w*)*\b(?:\s*(?:\[\s*\]|<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>))*/.source.replace(/<keyword>/g, function () {
      return t.source;
    });

    function n(e) {
      return RegExp(e.replace(/<CLASS-NAME>/g, function () {
        return r;
      }), "i");
    }

    var a = {
      keyword: t,
      punctuation: /[()\[\]{};,:.<>]/
    };
    e.languages.apex = {
      comment: e.languages.clike.comment,
      string: e.languages.clike.string,
      sql: {
        pattern: /((?:[=,({:]|\breturn)\s*)\[[^\[\]]*\]/i,
        lookbehind: !0,
        greedy: !0,
        alias: "language-sql",
        inside: e.languages.sql
      },
      annotation: {
        pattern: /@\w+\b/,
        alias: "punctuation"
      },
      "class-name": [{
        pattern: n(/(\b(?:class|enum|extends|implements|instanceof|interface|new|trigger\s+\w+\s+on)\s+)<CLASS-NAME>/.source),
        lookbehind: !0,
        inside: a
      }, {
        pattern: n(/(\(\s*)<CLASS-NAME>(?=\s*\)\s*[\w(])/.source),
        lookbehind: !0,
        inside: a
      }, {
        pattern: n(/<CLASS-NAME>(?=\s*\w+\s*[;=,(){:])/.source),
        inside: a
      }],
      trigger: {
        pattern: /(\btrigger\s+)\w+\b/i,
        lookbehind: !0,
        alias: "class-name"
      },
      keyword: t,
      function: /\b[a-z_]\w*(?=\s*\()/i,
      boolean: /\b(?:false|true)\b/i,
      number: /(?:\B\.\d+|\b\d+(?:\.\d+|L)?)\b/i,
      operator: /[!=](?:==?)?|\?\.?|&&|\|\||--|\+\+|[-+*/^&|]=?|:|<<?=?|>{1,3}=?/,
      punctuation: /[()\[\]{};,.]/
    };
  }(e);
}

apex.displayName = "apex", apex.aliases = [];
var apl_1 = apl;

function apl(e) {
  e.languages.apl = {
    comment: /(?:⍝|#[! ]).*$/m,
    string: {
      pattern: /'(?:[^'\r\n]|'')*'/,
      greedy: !0
    },
    number: /¯?(?:\d*\.?\b\d+(?:e[+¯]?\d+)?|¯|∞)(?:j¯?(?:(?:\d+(?:\.\d+)?|\.\d+)(?:e[+¯]?\d+)?|¯|∞))?/i,
    statement: /:[A-Z][a-z][A-Za-z]*\b/,
    "system-function": {
      pattern: /⎕[A-Z]+/i,
      alias: "function"
    },
    constant: /[⍬⌾#⎕⍞]/,
    function: /[-+×÷⌈⌊∣|⍳⍸?*⍟○!⌹<≤=>≥≠≡≢∊⍷∪∩~∨∧⍱⍲⍴,⍪⌽⊖⍉↑↓⊂⊃⊆⊇⌷⍋⍒⊤⊥⍕⍎⊣⊢⍁⍂≈⍯↗¤→]/,
    "monadic-operator": {
      pattern: /[\\\/⌿⍀¨⍨⌶&∥]/,
      alias: "operator"
    },
    "dyadic-operator": {
      pattern: /[.⍣⍠⍤∘⌸@⌺⍥]/,
      alias: "operator"
    },
    assignment: {
      pattern: /←/,
      alias: "keyword"
    },
    punctuation: /[\[;\]()◇⋄]/,
    dfn: {
      pattern: /[{}⍺⍵⍶⍹∇⍫:]/,
      alias: "builtin"
    }
  };
}

apl.displayName = "apl", apl.aliases = [];
var applescript_1 = applescript;

function applescript(e) {
  e.languages.applescript = {
    comment: [/\(\*(?:\(\*(?:[^*]|\*(?!\)))*\*\)|(?!\(\*)[\s\S])*?\*\)/, /--.+/, /#.+/],
    string: /"(?:\\.|[^"\\\r\n])*"/,
    number: /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e-?\d+)?\b/i,
    operator: [/[&=≠≤≥*+\-\/÷^]|[<>]=?/, /\b(?:(?:begin|end|start)s? with|(?:contains?|(?:does not|doesn't) contain)|(?:is|isn't|is not) (?:contained by|in)|(?:(?:is|isn't|is not) )?(?:greater|less) than(?: or equal)?(?: to)?|(?:comes|(?:does not|doesn't) come) (?:after|before)|(?:is|isn't|is not) equal(?: to)?|(?:(?:does not|doesn't) equal|equal to|equals|is not|isn't)|(?:a )?(?:ref(?: to)?|reference to)|(?:and|as|div|mod|not|or))\b/],
    keyword: /\b(?:about|above|after|against|apart from|around|aside from|at|back|before|beginning|behind|below|beneath|beside|between|but|by|considering|continue|copy|does|eighth|else|end|equal|error|every|exit|false|fifth|first|for|fourth|from|front|get|given|global|if|ignoring|in|instead of|into|is|it|its|last|local|me|middle|my|ninth|of|on|onto|out of|over|prop|property|put|repeat|return|returning|second|set|seventh|since|sixth|some|tell|tenth|that|the|then|third|through|thru|timeout|times|to|transaction|true|try|until|where|while|whose|with|without)\b/,
    "class-name": /\b(?:POSIX file|RGB color|alias|application|boolean|centimeters|centimetres|class|constant|cubic centimeters|cubic centimetres|cubic feet|cubic inches|cubic meters|cubic metres|cubic yards|date|degrees Celsius|degrees Fahrenheit|degrees Kelvin|feet|file|gallons|grams|inches|integer|kilograms|kilometers|kilometres|list|liters|litres|meters|metres|miles|number|ounces|pounds|quarts|real|record|reference|script|square feet|square kilometers|square kilometres|square meters|square metres|square miles|square yards|text|yards)\b/,
    punctuation: /[{}():,¬«»《》]/
  };
}

applescript.displayName = "applescript", applescript.aliases = [];
var aql_1 = aql;

function aql(e) {
  e.languages.aql = {
    comment: /\/\/.*|\/\*[\s\S]*?\*\//,
    property: {
      pattern: /([{,]\s*)(?:(?!\d)\w+|(["'´`])(?:(?!\2)[^\\\r\n]|\\.)*\2)(?=\s*:)/,
      lookbehind: !0,
      greedy: !0
    },
    string: {
      pattern: /(["'])(?:(?!\1)[^\\\r\n]|\\.)*\1/,
      greedy: !0
    },
    identifier: {
      pattern: /([´`])(?:(?!\1)[^\\\r\n]|\\.)*\1/,
      greedy: !0
    },
    variable: /@@?\w+/,
    keyword: [{
      pattern: /(\bWITH\s+)COUNT(?=\s+INTO\b)/i,
      lookbehind: !0
    }, /\b(?:AGGREGATE|ALL|AND|ANY|ASC|COLLECT|DESC|DISTINCT|FILTER|FOR|GRAPH|IN|INBOUND|INSERT|INTO|K_PATHS|K_SHORTEST_PATHS|LET|LIKE|LIMIT|NONE|NOT|NULL|OR|OUTBOUND|REMOVE|REPLACE|RETURN|SHORTEST_PATH|SORT|UPDATE|UPSERT|WINDOW|WITH)\b/i, {
      pattern: /(^|[^\w.[])(?:KEEP|PRUNE|SEARCH|TO)\b/i,
      lookbehind: !0
    }, {
      pattern: /(^|[^\w.[])(?:CURRENT|NEW|OLD)\b/,
      lookbehind: !0
    }, {
      pattern: /\bOPTIONS(?=\s*\{)/i
    }],
    function: /\b(?!\d)\w+(?=\s*\()/,
    boolean: /\b(?:false|true)\b/i,
    range: {
      pattern: /\.\./,
      alias: "operator"
    },
    number: [/\b0b[01]+/i, /\b0x[0-9a-f]+/i, /(?:\B\.\d+|\b(?:0|[1-9]\d*)(?:\.\d+)?)(?:e[+-]?\d+)?/i],
    operator: /\*{2,}|[=!]~|[!=<>]=?|&&|\|\||[-+*/%]/,
    punctuation: /::|[?.:,;()[\]{}]/
  };
}

aql.displayName = "aql", aql.aliases = [];
var c_1 = c$1;

function c$1(e) {
  e.languages.c = e.languages.extend("clike", {
    comment: {
      pattern: /\/\/(?:[^\r\n\\]|\\(?:\r\n?|\n|(?![\r\n])))*|\/\*[\s\S]*?(?:\*\/|$)/,
      greedy: !0
    },
    string: {
      pattern: /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/,
      greedy: !0
    },
    "class-name": {
      pattern: /(\b(?:enum|struct)\s+(?:__attribute__\s*\(\([\s\S]*?\)\)\s*)?)\w+|\b[a-z]\w*_t\b/,
      lookbehind: !0
    },
    keyword: /\b(?:_Alignas|_Alignof|_Atomic|_Bool|_Complex|_Generic|_Imaginary|_Noreturn|_Static_assert|_Thread_local|__attribute__|asm|auto|break|case|char|const|continue|default|do|double|else|enum|extern|float|for|goto|if|inline|int|long|register|return|short|signed|sizeof|static|struct|switch|typedef|typeof|union|unsigned|void|volatile|while)\b/,
    function: /\b[a-z_]\w*(?=\s*\()/i,
    number: /(?:\b0x(?:[\da-f]+(?:\.[\da-f]*)?|\.[\da-f]+)(?:p[+-]?\d+)?|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?)[ful]{0,4}/i,
    operator: />>=?|<<=?|->|([-+&|:])\1|[?:~]|[-+*/%&|^!=<>]=?/
  }), e.languages.insertBefore("c", "string", {
    char: {
      pattern: /'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n]){0,32}'/,
      greedy: !0
    }
  }), e.languages.insertBefore("c", "string", {
    macro: {
      pattern: /(^[\t ]*)#\s*[a-z](?:[^\r\n\\/]|\/(?!\*)|\/\*(?:[^*]|\*(?!\/))*\*\/|\\(?:\r\n|[\s\S]))*/im,
      lookbehind: !0,
      greedy: !0,
      alias: "property",
      inside: {
        string: [{
          pattern: /^(#\s*include\s*)<[^>]+>/,
          lookbehind: !0
        }, e.languages.c.string],
        char: e.languages.c.char,
        comment: e.languages.c.comment,
        "macro-name": [{
          pattern: /(^#\s*define\s+)\w+\b(?!\()/i,
          lookbehind: !0
        }, {
          pattern: /(^#\s*define\s+)\w+\b(?=\()/i,
          lookbehind: !0,
          alias: "function"
        }],
        directive: {
          pattern: /^(#\s*)[a-z]+/,
          lookbehind: !0,
          alias: "keyword"
        },
        "directive-hash": /^#/,
        punctuation: /##|\\(?=[\r\n])/,
        expression: {
          pattern: /\S[\s\S]*/,
          inside: e.languages.c
        }
      }
    }
  }), e.languages.insertBefore("c", "function", {
    constant: /\b(?:EOF|NULL|SEEK_CUR|SEEK_END|SEEK_SET|__DATE__|__FILE__|__LINE__|__TIMESTAMP__|__TIME__|__func__|stderr|stdin|stdout)\b/
  }), delete e.languages.c.boolean;
}

c$1.displayName = "c", c$1.aliases = [];
var refractorC$5 = c_1,
    cpp_1 = cpp;

function cpp(e) {
  e.register(refractorC$5), function (e) {
    var t = /\b(?:alignas|alignof|asm|auto|bool|break|case|catch|char|char16_t|char32_t|char8_t|class|co_await|co_return|co_yield|compl|concept|const|const_cast|consteval|constexpr|constinit|continue|decltype|default|delete|do|double|dynamic_cast|else|enum|explicit|export|extern|final|float|for|friend|goto|if|import|inline|int|int16_t|int32_t|int64_t|int8_t|long|module|mutable|namespace|new|noexcept|nullptr|operator|override|private|protected|public|register|reinterpret_cast|requires|return|short|signed|sizeof|static|static_assert|static_cast|struct|switch|template|this|thread_local|throw|try|typedef|typeid|typename|uint16_t|uint32_t|uint64_t|uint8_t|union|unsigned|using|virtual|void|volatile|wchar_t|while)\b/,
        r = /\b(?!<keyword>)\w+(?:\s*\.\s*\w+)*\b/.source.replace(/<keyword>/g, function () {
      return t.source;
    });
    e.languages.cpp = e.languages.extend("c", {
      "class-name": [{
        pattern: RegExp(/(\b(?:class|concept|enum|struct|typename)\s+)(?!<keyword>)\w+/.source.replace(/<keyword>/g, function () {
          return t.source;
        })),
        lookbehind: !0
      }, /\b[A-Z]\w*(?=\s*::\s*\w+\s*\()/, /\b[A-Z_]\w*(?=\s*::\s*~\w+\s*\()/i, /\b\w+(?=\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>\s*::\s*\w+\s*\()/],
      keyword: t,
      number: {
        pattern: /(?:\b0b[01']+|\b0x(?:[\da-f']+(?:\.[\da-f']*)?|\.[\da-f']+)(?:p[+-]?[\d']+)?|(?:\b[\d']+(?:\.[\d']*)?|\B\.[\d']+)(?:e[+-]?[\d']+)?)[ful]{0,4}/i,
        greedy: !0
      },
      operator: />>=?|<<=?|->|--|\+\+|&&|\|\||[?:~]|<=>|[-+*/%&|^!=<>]=?|\b(?:and|and_eq|bitand|bitor|not|not_eq|or|or_eq|xor|xor_eq)\b/,
      boolean: /\b(?:false|true)\b/
    }), e.languages.insertBefore("cpp", "string", {
      module: {
        pattern: RegExp(/(\b(?:import|module)\s+)/.source + "(?:" + /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|<[^<>\r\n]*>/.source + "|" + /<mod-name>(?:\s*:\s*<mod-name>)?|:\s*<mod-name>/.source.replace(/<mod-name>/g, function () {
          return r;
        }) + ")"),
        lookbehind: !0,
        greedy: !0,
        inside: {
          string: /^[<"][\s\S]+/,
          operator: /:/,
          punctuation: /\./
        }
      },
      "raw-string": {
        pattern: /R"([^()\\ ]{0,16})\([\s\S]*?\)\1"/,
        alias: "string",
        greedy: !0
      }
    }), e.languages.insertBefore("cpp", "keyword", {
      "generic-function": {
        pattern: /\b(?!operator\b)[a-z_]\w*\s*<(?:[^<>]|<[^<>]*>)*>(?=\s*\()/i,
        inside: {
          function: /^\w+/,
          generic: {
            pattern: /<[\s\S]+/,
            alias: "class-name",
            inside: e.languages.cpp
          }
        }
      }
    }), e.languages.insertBefore("cpp", "operator", {
      "double-colon": {
        pattern: /::/,
        alias: "punctuation"
      }
    }), e.languages.insertBefore("cpp", "class-name", {
      "base-clause": {
        pattern: /(\b(?:class|struct)\s+\w+\s*:\s*)[^;{}"'\s]+(?:\s+[^;{}"'\s]+)*(?=\s*[;{])/,
        lookbehind: !0,
        greedy: !0,
        inside: e.languages.extend("cpp", {})
      }
    }), e.languages.insertBefore("inside", "double-colon", {
      "class-name": /\b[a-z_]\w*\b(?!\s*::)/i
    }, e.languages.cpp["base-clause"]);
  }(e);
}

cpp.displayName = "cpp", cpp.aliases = [];
var refractorCpp$1 = cpp_1,
    arduino_1 = arduino;

function arduino(e) {
  e.register(refractorCpp$1), e.languages.arduino = e.languages.extend("cpp", {
    keyword: /\b(?:String|array|bool|boolean|break|byte|case|catch|continue|default|do|double|else|finally|for|function|goto|if|in|instanceof|int|integer|long|loop|new|null|return|setup|string|switch|throw|try|void|while|word)\b/,
    constant: /\b(?:ANALOG_MESSAGE|DEFAULT|DIGITAL_MESSAGE|EXTERNAL|FIRMATA_STRING|HIGH|INPUT|INPUT_PULLUP|INTERNAL|INTERNAL1V1|INTERNAL2V56|LED_BUILTIN|LOW|OUTPUT|REPORT_ANALOG|REPORT_DIGITAL|SET_PIN_MODE|SYSEX_START|SYSTEM_RESET)\b/,
    builtin: /\b(?:Audio|BSSID|Bridge|Client|Console|EEPROM|Esplora|EsploraTFT|Ethernet|EthernetClient|EthernetServer|EthernetUDP|File|FileIO|FileSystem|Firmata|GPRS|GSM|GSMBand|GSMClient|GSMModem|GSMPIN|GSMScanner|GSMServer|GSMVoiceCall|GSM_SMS|HttpClient|IPAddress|IRread|Keyboard|KeyboardController|LiquidCrystal|LiquidCrystal_I2C|Mailbox|Mouse|MouseController|PImage|Process|RSSI|RobotControl|RobotMotor|SD|SPI|SSID|Scheduler|Serial|Server|Servo|SoftwareSerial|Stepper|Stream|TFT|Task|USBHost|WiFi|WiFiClient|WiFiServer|WiFiUDP|Wire|YunClient|YunServer|abs|addParameter|analogRead|analogReadResolution|analogReference|analogWrite|analogWriteResolution|answerCall|attach|attachGPRS|attachInterrupt|attached|autoscroll|available|background|beep|begin|beginPacket|beginSD|beginSMS|beginSpeaker|beginTFT|beginTransmission|beginWrite|bit|bitClear|bitRead|bitSet|bitWrite|blink|blinkVersion|buffer|changePIN|checkPIN|checkPUK|checkReg|circle|cityNameRead|cityNameWrite|clear|clearScreen|click|close|compassRead|config|connect|connected|constrain|cos|countryNameRead|countryNameWrite|createChar|cursor|debugPrint|delay|delayMicroseconds|detach|detachInterrupt|digitalRead|digitalWrite|disconnect|display|displayLogos|drawBMP|drawCompass|encryptionType|end|endPacket|endSMS|endTransmission|endWrite|exists|exitValue|fill|find|findUntil|flush|gatewayIP|get|getAsynchronously|getBand|getButton|getCurrentCarrier|getIMEI|getKey|getModifiers|getOemKey|getPINUsed|getResult|getSignalStrength|getSocket|getVoiceCallStatus|getXChange|getYChange|hangCall|height|highByte|home|image|interrupts|isActionDone|isDirectory|isListening|isPIN|isPressed|isValid|keyPressed|keyReleased|keyboardRead|knobRead|leftToRight|line|lineFollowConfig|listen|listenOnLocalhost|loadImage|localIP|lowByte|macAddress|maintain|map|max|messageAvailable|micros|millis|min|mkdir|motorsStop|motorsWrite|mouseDragged|mouseMoved|mousePressed|mouseReleased|move|noAutoscroll|noBlink|noBuffer|noCursor|noDisplay|noFill|noInterrupts|noListenOnLocalhost|noStroke|noTone|onReceive|onRequest|open|openNextFile|overflow|parseCommand|parseFloat|parseInt|parsePacket|pauseMode|peek|pinMode|playFile|playMelody|point|pointTo|position|pow|prepare|press|print|printFirmwareVersion|printVersion|println|process|processInput|pulseIn|put|random|randomSeed|read|readAccelerometer|readBlue|readButton|readBytes|readBytesUntil|readGreen|readJoystickButton|readJoystickSwitch|readJoystickX|readJoystickY|readLightSensor|readMessage|readMicrophone|readNetworks|readRed|readSlider|readString|readStringUntil|readTemperature|ready|rect|release|releaseAll|remoteIP|remoteNumber|remotePort|remove|requestFrom|retrieveCallingNumber|rewindDirectory|rightToLeft|rmdir|robotNameRead|robotNameWrite|run|runAsynchronously|runShellCommand|runShellCommandAsynchronously|running|scanNetworks|scrollDisplayLeft|scrollDisplayRight|seek|sendAnalog|sendDigitalPortPair|sendDigitalPorts|sendString|sendSysex|serialEvent|setBand|setBitOrder|setClockDivider|setCursor|setDNS|setDataMode|setFirmwareVersion|setMode|setPINUsed|setSpeed|setTextSize|setTimeout|shiftIn|shiftOut|shutdown|sin|size|sqrt|startLoop|step|stop|stroke|subnetMask|switchPIN|tan|tempoWrite|text|tone|transfer|tuneWrite|turn|updateIR|userNameRead|userNameWrite|voiceCall|waitContinue|width|write|writeBlue|writeGreen|writeJSON|writeMessage|writeMicroseconds|writeRGB|writeRed|yield)\b/
  }), e.languages.ino = e.languages.arduino;
}

arduino.displayName = "arduino", arduino.aliases = ["ino"];
var arff_1 = arff;

function arff(e) {
  e.languages.arff = {
    comment: /%.*/,
    string: {
      pattern: /(["'])(?:\\.|(?!\1)[^\\\r\n])*\1/,
      greedy: !0
    },
    keyword: /@(?:attribute|data|end|relation)\b/i,
    number: /\b\d+(?:\.\d+)?\b/,
    punctuation: /[{},]/
  };
}

arff.displayName = "arff", arff.aliases = [];
var asciidoc_1 = asciidoc;

function asciidoc(e) {
  !function (e) {
    var t = {
      pattern: /(^[ \t]*)\[(?!\[)(?:(["'$`])(?:(?!\2)[^\\]|\\.)*\2|\[(?:[^\[\]\\]|\\.)*\]|[^\[\]\\"'$`]|\\.)*\]/m,
      lookbehind: !0,
      inside: {
        quoted: {
          pattern: /([$`])(?:(?!\1)[^\\]|\\.)*\1/,
          inside: {
            punctuation: /^[$`]|[$`]$/
          }
        },
        interpreted: {
          pattern: /'(?:[^'\\]|\\.)*'/,
          inside: {
            punctuation: /^'|'$/
          }
        },
        string: /"(?:[^"\\]|\\.)*"/,
        variable: /\w+(?==)/,
        punctuation: /^\[|\]$|,/,
        operator: /=/,
        "attr-value": /(?!^\s+$).+/
      }
    },
        r = e.languages.asciidoc = {
      "comment-block": {
        pattern: /^(\/{4,})(?:\r?\n|\r)(?:[\s\S]*(?:\r?\n|\r))??\1/m,
        alias: "comment"
      },
      table: {
        pattern: /^\|={3,}(?:(?:\r?\n|\r(?!\n)).*)*?(?:\r?\n|\r)\|={3,}$/m,
        inside: {
          specifiers: {
            pattern: /(?:(?:(?:\d+(?:\.\d+)?|\.\d+)[+*](?:[<^>](?:\.[<^>])?|\.[<^>])?|[<^>](?:\.[<^>])?|\.[<^>])[a-z]*|[a-z]+)(?=\|)/,
            alias: "attr-value"
          },
          punctuation: {
            pattern: /(^|[^\\])[|!]=*/,
            lookbehind: !0
          }
        }
      },
      "passthrough-block": {
        pattern: /^(\+{4,})(?:\r?\n|\r)(?:[\s\S]*(?:\r?\n|\r))??\1$/m,
        inside: {
          punctuation: /^\++|\++$/
        }
      },
      "literal-block": {
        pattern: /^(-{4,}|\.{4,})(?:\r?\n|\r)(?:[\s\S]*(?:\r?\n|\r))??\1$/m,
        inside: {
          punctuation: /^(?:-+|\.+)|(?:-+|\.+)$/
        }
      },
      "other-block": {
        pattern: /^(--|\*{4,}|_{4,}|={4,})(?:\r?\n|\r)(?:[\s\S]*(?:\r?\n|\r))??\1$/m,
        inside: {
          punctuation: /^(?:-+|\*+|_+|=+)|(?:-+|\*+|_+|=+)$/
        }
      },
      "list-punctuation": {
        pattern: /(^[ \t]*)(?:-|\*{1,5}|\.{1,5}|(?:[a-z]|\d+)\.|[xvi]+\))(?= )/im,
        lookbehind: !0,
        alias: "punctuation"
      },
      "list-label": {
        pattern: /(^[ \t]*)[a-z\d].+(?::{2,4}|;;)(?=\s)/im,
        lookbehind: !0,
        alias: "symbol"
      },
      "indented-block": {
        pattern: /((\r?\n|\r)\2)([ \t]+)\S.*(?:(?:\r?\n|\r)\3.+)*(?=\2{2}|$)/,
        lookbehind: !0
      },
      comment: /^\/\/.*/m,
      title: {
        pattern: /^.+(?:\r?\n|\r)(?:={3,}|-{3,}|~{3,}|\^{3,}|\+{3,})$|^={1,5} .+|^\.(?![\s.]).*/m,
        alias: "important",
        inside: {
          punctuation: /^(?:\.|=+)|(?:=+|-+|~+|\^+|\++)$/
        }
      },
      "attribute-entry": {
        pattern: /^:[^:\r\n]+:(?: .*?(?: \+(?:\r?\n|\r).*?)*)?$/m,
        alias: "tag"
      },
      attributes: t,
      hr: {
        pattern: /^'{3,}$/m,
        alias: "punctuation"
      },
      "page-break": {
        pattern: /^<{3,}$/m,
        alias: "punctuation"
      },
      admonition: {
        pattern: /^(?:CAUTION|IMPORTANT|NOTE|TIP|WARNING):/m,
        alias: "keyword"
      },
      callout: [{
        pattern: /(^[ \t]*)<?\d*>/m,
        lookbehind: !0,
        alias: "symbol"
      }, {
        pattern: /<\d+>/,
        alias: "symbol"
      }],
      macro: {
        pattern: /\b[a-z\d][a-z\d-]*::?(?:[^\s\[\]]*\[(?:[^\]\\"']|(["'])(?:(?!\1)[^\\]|\\.)*\1|\\.)*\])/,
        inside: {
          function: /^[a-z\d-]+(?=:)/,
          punctuation: /^::?/,
          attributes: {
            pattern: /(?:\[(?:[^\]\\"']|(["'])(?:(?!\1)[^\\]|\\.)*\1|\\.)*\])/,
            inside: t.inside
          }
        }
      },
      inline: {
        pattern: /(^|[^\\])(?:(?:\B\[(?:[^\]\\"']|(["'])(?:(?!\2)[^\\]|\\.)*\2|\\.)*\])?(?:\b_(?!\s)(?: _|[^_\\\r\n]|\\.)+(?:(?:\r?\n|\r)(?: _|[^_\\\r\n]|\\.)+)*_\b|\B``(?!\s).+?(?:(?:\r?\n|\r).+?)*''\B|\B`(?!\s)(?:[^`'\s]|\s+\S)+['`]\B|\B(['*+#])(?!\s)(?: \3|(?!\3)[^\\\r\n]|\\.)+(?:(?:\r?\n|\r)(?: \3|(?!\3)[^\\\r\n]|\\.)+)*\3\B)|(?:\[(?:[^\]\\"']|(["'])(?:(?!\4)[^\\]|\\.)*\4|\\.)*\])?(?:(__|\*\*|\+\+\+?|##|\$\$|[~^]).+?(?:(?:\r?\n|\r).+?)*\5|\{[^}\r\n]+\}|\[\[\[?.+?(?:(?:\r?\n|\r).+?)*\]?\]\]|<<.+?(?:(?:\r?\n|\r).+?)*>>|\(\(\(?.+?(?:(?:\r?\n|\r).+?)*\)?\)\)))/m,
        lookbehind: !0,
        inside: {
          attributes: t,
          url: {
            pattern: /^(?:\[\[\[?.+?\]?\]\]|<<.+?>>)$/,
            inside: {
              punctuation: /^(?:\[\[\[?|<<)|(?:\]\]\]?|>>)$/
            }
          },
          "attribute-ref": {
            pattern: /^\{.+\}$/,
            inside: {
              variable: {
                pattern: /(^\{)[a-z\d,+_-]+/,
                lookbehind: !0
              },
              operator: /^[=?!#%@$]|!(?=[:}])/,
              punctuation: /^\{|\}$|::?/
            }
          },
          italic: {
            pattern: /^(['_])[\s\S]+\1$/,
            inside: {
              punctuation: /^(?:''?|__?)|(?:''?|__?)$/
            }
          },
          bold: {
            pattern: /^\*[\s\S]+\*$/,
            inside: {
              punctuation: /^\*\*?|\*\*?$/
            }
          },
          punctuation: /^(?:``?|\+{1,3}|##?|\$\$|[~^]|\(\(\(?)|(?:''?|\+{1,3}|##?|\$\$|[~^`]|\)?\)\))$/
        }
      },
      replacement: {
        pattern: /\((?:C|R|TM)\)/,
        alias: "builtin"
      },
      entity: /&#?[\da-z]{1,8};/i,
      "line-continuation": {
        pattern: /(^| )\+$/m,
        lookbehind: !0,
        alias: "punctuation"
      }
    };

    function n(e) {
      for (var t = {}, n = 0, a = (e = e.split(" ")).length; n < a; n++) {
        t[e[n]] = r[e[n]];
      }

      return t;
    }

    t.inside.interpreted.inside.rest = n("macro inline replacement entity"), r["passthrough-block"].inside.rest = n("macro"), r["literal-block"].inside.rest = n("callout"), r.table.inside.rest = n("comment-block passthrough-block literal-block other-block list-punctuation indented-block comment title attribute-entry attributes hr page-break admonition list-label callout macro inline replacement entity line-continuation"), r["other-block"].inside.rest = n("table list-punctuation indented-block comment attribute-entry attributes hr page-break admonition list-label macro inline replacement entity line-continuation"), r.title.inside.rest = n("macro inline replacement entity"), e.hooks.add("wrap", function (e) {
      "entity" === e.type && (e.attributes.title = e.content.value.replace(/&amp;/, "&"));
    }), e.languages.adoc = e.languages.asciidoc;
  }(e);
}

asciidoc.displayName = "asciidoc", asciidoc.aliases = ["adoc"];
var asm6502_1 = asm6502;

function asm6502(e) {
  e.languages.asm6502 = {
    comment: /;.*/,
    directive: {
      pattern: /\.\w+(?= )/,
      alias: "property"
    },
    string: /(["'`])(?:\\.|(?!\1)[^\\\r\n])*\1/,
    "op-code": {
      pattern: /\b(?:ADC|AND|ASL|BCC|BCS|BEQ|BIT|BMI|BNE|BPL|BRK|BVC|BVS|CLC|CLD|CLI|CLV|CMP|CPX|CPY|DEC|DEX|DEY|EOR|INC|INX|INY|JMP|JSR|LDA|LDX|LDY|LSR|NOP|ORA|PHA|PHP|PLA|PLP|ROL|ROR|RTI|RTS|SBC|SEC|SED|SEI|STA|STX|STY|TAX|TAY|TSX|TXA|TXS|TYA|adc|and|asl|bcc|bcs|beq|bit|bmi|bne|bpl|brk|bvc|bvs|clc|cld|cli|clv|cmp|cpx|cpy|dec|dex|dey|eor|inc|inx|iny|jmp|jsr|lda|ldx|ldy|lsr|nop|ora|pha|php|pla|plp|rol|ror|rti|rts|sbc|sec|sed|sei|sta|stx|sty|tax|tay|tsx|txa|txs|tya)\b/,
      alias: "keyword"
    },
    "hex-number": {
      pattern: /#?\$[\da-f]{1,4}\b/i,
      alias: "number"
    },
    "binary-number": {
      pattern: /#?%[01]+\b/,
      alias: "number"
    },
    "decimal-number": {
      pattern: /#?\b\d+\b/,
      alias: "number"
    },
    register: {
      pattern: /\b[xya]\b/i,
      alias: "variable"
    },
    punctuation: /[(),:]/
  };
}

asm6502.displayName = "asm6502", asm6502.aliases = [];
var asmatmel_1 = asmatmel;

function asmatmel(e) {
  e.languages.asmatmel = {
    comment: {
      pattern: /;.*/,
      greedy: !0
    },
    string: {
      pattern: /(["'`])(?:\\.|(?!\1)[^\\\r\n])*\1/,
      greedy: !0
    },
    constant: /\b(?:PORT[A-Z]|DDR[A-Z]|(?:DD|P)[A-Z](?:\d|[0-2]\d|3[01]))\b/,
    directive: {
      pattern: /\.\w+(?= )/,
      alias: "property"
    },
    "r-register": {
      pattern: /\br(?:\d|[12]\d|3[01])\b/,
      alias: "variable"
    },
    "op-code": {
      pattern: /\b(?:ADC|ADD|ADIW|AND|ANDI|ASR|BCLR|BLD|BRBC|BRBS|BRCC|BRCS|BREAK|BREQ|BRGE|BRHC|BRHS|BRID|BRIE|BRLO|BRLT|BRMI|BRNE|BRPL|BRSH|BRTC|BRTS|BRVC|BRVS|BSET|BST|CALL|CBI|CBR|CLC|CLH|CLI|CLN|CLR|CLS|CLT|CLV|CLZ|COM|CP|CPC|CPI|CPSE|DEC|DES|EICALL|EIJMP|ELPM|EOR|FMUL|FMULS|FMULSU|ICALL|IJMP|IN|INC|JMP|LAC|LAS|LAT|LD|LD[A-Za-z0-9]|LPM|LSL|LSR|MOV|MOVW|MUL|MULS|MULSU|NEG|NOP|OR|ORI|OUT|POP|PUSH|RCALL|RET|RETI|RJMP|ROL|ROR|SBC|SBCI|SBI|SBIC|SBIS|SBIW|SBR|SBRC|SBRS|SEC|SEH|SEI|SEN|SER|SES|SET|SEV|SEZ|SLEEP|SPM|ST|ST[A-Z0-9]|SUB|SUBI|SWAP|TST|WDR|XCH|adc|add|adiw|and|andi|asr|bclr|bld|brbc|brbs|brcc|brcs|break|breq|brge|brhc|brhs|brid|brie|brlo|brlt|brmi|brne|brpl|brsh|brtc|brts|brvc|brvs|bset|bst|call|cbi|cbr|clc|clh|cli|cln|clr|cls|clt|clv|clz|com|cp|cpc|cpi|cpse|dec|des|eicall|eijmp|elpm|eor|fmul|fmuls|fmulsu|icall|ijmp|in|inc|jmp|lac|las|lat|ld|ld[a-z0-9]|lpm|lsl|lsr|mov|movw|mul|muls|mulsu|neg|nop|or|ori|out|pop|push|rcall|ret|reti|rjmp|rol|ror|sbc|sbci|sbi|sbic|sbis|sbiw|sbr|sbrc|sbrs|sec|seh|sei|sen|ser|ses|set|sev|sez|sleep|spm|st|st[a-zA-Z0-9]|sub|subi|swap|tst|wdr|xch)\b/,
      alias: "keyword"
    },
    "hex-number": {
      pattern: /#?\$[\da-f]{2,4}\b/i,
      alias: "number"
    },
    "binary-number": {
      pattern: /#?%[01]+\b/,
      alias: "number"
    },
    "decimal-number": {
      pattern: /#?\b\d+\b/,
      alias: "number"
    },
    register: {
      pattern: /\b[acznvshtixy]\b/i,
      alias: "variable"
    },
    operator: />>=?|<<=?|&&?|\|\|?|[-+*/%&|^!=<>?]=?/,
    punctuation: /[(),:]/
  };
}

asmatmel.displayName = "asmatmel", asmatmel.aliases = [];
var csharp_1 = csharp;

function csharp(e) {
  !function (e) {
    function t(e, t) {
      return e.replace(/<<(\d+)>>/g, function (e, r) {
        return "(?:" + t[+r] + ")";
      });
    }

    function r(e, r, n) {
      return RegExp(t(e, r), n || "");
    }

    function n(e, t) {
      for (var r = 0; r < t; r++) {
        e = e.replace(/<<self>>/g, function () {
          return "(?:" + e + ")";
        });
      }

      return e.replace(/<<self>>/g, "[^\\s\\S]");
    }

    var a = "bool byte char decimal double dynamic float int long object sbyte short string uint ulong ushort var void",
        o = "class enum interface record struct",
        i = "add alias and ascending async await by descending from(?=\\s*(?:\\w|$)) get global group into init(?=\\s*;) join let nameof not notnull on or orderby partial remove select set unmanaged value when where with(?=\\s*{)",
        s = "abstract as base break case catch checked const continue default delegate do else event explicit extern finally fixed for foreach goto if implicit in internal is lock namespace new null operator out override params private protected public readonly ref return sealed sizeof stackalloc static switch this throw try typeof unchecked unsafe using virtual volatile while yield";

    function l(e) {
      return "\\b(?:" + e.trim().replace(/ /g, "|") + ")\\b";
    }

    var c = l(o),
        u = RegExp(l(a + " " + o + " " + i + " " + s)),
        d = l(o + " " + i + " " + s),
        p = l(a + " " + o + " " + s),
        g = n(/<(?:[^<>;=+\-*/%&|^]|<<self>>)*>/.source, 2),
        m = n(/\((?:[^()]|<<self>>)*\)/.source, 2),
        f = /@?\b[A-Za-z_]\w*\b/.source,
        h = t(/<<0>>(?:\s*<<1>>)?/.source, [f, g]),
        b = t(/(?!<<0>>)<<1>>(?:\s*\.\s*<<1>>)*/.source, [d, h]),
        y = /\[\s*(?:,\s*)*\]/.source,
        v = t(/<<0>>(?:\s*(?:\?\s*)?<<1>>)*(?:\s*\?)?/.source, [b, y]),
        _ = t(/[^,()<>[\];=+\-*/%&|^]|<<0>>|<<1>>|<<2>>/.source, [g, m, y]),
        T = t(/\(<<0>>+(?:,<<0>>+)+\)/.source, [_]),
        E = t(/(?:<<0>>|<<1>>)(?:\s*(?:\?\s*)?<<2>>)*(?:\s*\?)?/.source, [T, b, y]),
        S = {
      keyword: u,
      punctuation: /[<>()?,.:[\]]/
    },
        x = /'(?:[^\r\n'\\]|\\.|\\[Uux][\da-fA-F]{1,8})'/.source,
        w = /"(?:\\.|[^\\"\r\n])*"/.source,
        C = /@"(?:""|\\[\s\S]|[^\\"])*"(?!")/.source;

    e.languages.csharp = e.languages.extend("clike", {
      string: [{
        pattern: r(/(^|[^$\\])<<0>>/.source, [C]),
        lookbehind: !0,
        greedy: !0
      }, {
        pattern: r(/(^|[^@$\\])<<0>>/.source, [w]),
        lookbehind: !0,
        greedy: !0
      }],
      "class-name": [{
        pattern: r(/(\busing\s+static\s+)<<0>>(?=\s*;)/.source, [b]),
        lookbehind: !0,
        inside: S
      }, {
        pattern: r(/(\busing\s+<<0>>\s*=\s*)<<1>>(?=\s*;)/.source, [f, E]),
        lookbehind: !0,
        inside: S
      }, {
        pattern: r(/(\busing\s+)<<0>>(?=\s*=)/.source, [f]),
        lookbehind: !0
      }, {
        pattern: r(/(\b<<0>>\s+)<<1>>/.source, [c, h]),
        lookbehind: !0,
        inside: S
      }, {
        pattern: r(/(\bcatch\s*\(\s*)<<0>>/.source, [b]),
        lookbehind: !0,
        inside: S
      }, {
        pattern: r(/(\bwhere\s+)<<0>>/.source, [f]),
        lookbehind: !0
      }, {
        pattern: r(/(\b(?:is(?:\s+not)?|as)\s+)<<0>>/.source, [v]),
        lookbehind: !0,
        inside: S
      }, {
        pattern: r(/\b<<0>>(?=\s+(?!<<1>>|with\s*\{)<<2>>(?:\s*[=,;:{)\]]|\s+(?:in|when)\b))/.source, [E, p, f]),
        inside: S
      }],
      keyword: u,
      number: /(?:\b0(?:x[\da-f_]*[\da-f]|b[01_]*[01])|(?:\B\.\d+(?:_+\d+)*|\b\d+(?:_+\d+)*(?:\.\d+(?:_+\d+)*)?)(?:e[-+]?\d+(?:_+\d+)*)?)(?:[dflmu]|lu|ul)?\b/i,
      operator: />>=?|<<=?|[-=]>|([-+&|])\1|~|\?\?=?|[-+*/%&|^!=<>]=?/,
      punctuation: /\?\.?|::|[{}[\];(),.:]/
    }), e.languages.insertBefore("csharp", "number", {
      range: {
        pattern: /\.\./,
        alias: "operator"
      }
    }), e.languages.insertBefore("csharp", "punctuation", {
      "named-parameter": {
        pattern: r(/([(,]\s*)<<0>>(?=\s*:)/.source, [f]),
        lookbehind: !0,
        alias: "punctuation"
      }
    }), e.languages.insertBefore("csharp", "class-name", {
      namespace: {
        pattern: r(/(\b(?:namespace|using)\s+)<<0>>(?:\s*\.\s*<<0>>)*(?=\s*[;{])/.source, [f]),
        lookbehind: !0,
        inside: {
          punctuation: /\./
        }
      },
      "type-expression": {
        pattern: r(/(\b(?:default|sizeof|typeof)\s*\(\s*(?!\s))(?:[^()\s]|\s(?!\s)|<<0>>)*(?=\s*\))/.source, [m]),
        lookbehind: !0,
        alias: "class-name",
        inside: S
      },
      "return-type": {
        pattern: r(/<<0>>(?=\s+(?:<<1>>\s*(?:=>|[({]|\.\s*this\s*\[)|this\s*\[))/.source, [E, b]),
        inside: S,
        alias: "class-name"
      },
      "constructor-invocation": {
        pattern: r(/(\bnew\s+)<<0>>(?=\s*[[({])/.source, [E]),
        lookbehind: !0,
        inside: S,
        alias: "class-name"
      },
      "generic-method": {
        pattern: r(/<<0>>\s*<<1>>(?=\s*\()/.source, [f, g]),
        inside: {
          function: r(/^<<0>>/.source, [f]),
          generic: {
            pattern: RegExp(g),
            alias: "class-name",
            inside: S
          }
        }
      },
      "type-list": {
        pattern: r(/\b((?:<<0>>\s+<<1>>|record\s+<<1>>\s*<<5>>|where\s+<<2>>)\s*:\s*)(?:<<3>>|<<4>>|<<1>>\s*<<5>>|<<6>>)(?:\s*,\s*(?:<<3>>|<<4>>|<<6>>))*(?=\s*(?:where|[{;]|=>|$))/.source, [c, h, f, E, u.source, m, /\bnew\s*\(\s*\)/.source]),
        lookbehind: !0,
        inside: {
          "record-arguments": {
            pattern: r(/(^(?!new\s*\()<<0>>\s*)<<1>>/.source, [h, m]),
            lookbehind: !0,
            greedy: !0,
            inside: e.languages.csharp
          },
          keyword: u,
          "class-name": {
            pattern: RegExp(E),
            greedy: !0,
            inside: S
          },
          punctuation: /[,()]/
        }
      },
      preprocessor: {
        pattern: /(^[\t ]*)#.*/m,
        lookbehind: !0,
        alias: "property",
        inside: {
          directive: {
            pattern: /(#)\b(?:define|elif|else|endif|endregion|error|if|line|nullable|pragma|region|undef|warning)\b/,
            lookbehind: !0,
            alias: "keyword"
          }
        }
      }
    });
    var k = w + "|" + x,
        $ = t(/\/(?![*/])|\/\/[^\r\n]*[\r\n]|\/\*(?:[^*]|\*(?!\/))*\*\/|<<0>>/.source, [k]),
        R = n(t(/[^"'/()]|<<0>>|\(<<self>>*\)/.source, [$]), 2),
        A = /\b(?:assembly|event|field|method|module|param|property|return|type)\b/.source,
        I = t(/<<0>>(?:\s*\(<<1>>*\))?/.source, [b, R]);
    e.languages.insertBefore("csharp", "class-name", {
      attribute: {
        pattern: r(/((?:^|[^\s\w>)?])\s*\[\s*)(?:<<0>>\s*:\s*)?<<1>>(?:\s*,\s*<<1>>)*(?=\s*\])/.source, [A, I]),
        lookbehind: !0,
        greedy: !0,
        inside: {
          target: {
            pattern: r(/^<<0>>(?=\s*:)/.source, [A]),
            alias: "keyword"
          },
          "attribute-arguments": {
            pattern: r(/\(<<0>>*\)/.source, [R]),
            inside: e.languages.csharp
          },
          "class-name": {
            pattern: RegExp(b),
            inside: {
              punctuation: /\./
            }
          },
          punctuation: /[:,]/
        }
      }
    });
    var N = /:[^}\r\n]+/.source,
        P = n(t(/[^"'/()]|<<0>>|\(<<self>>*\)/.source, [$]), 2),
        O = t(/\{(?!\{)(?:(?![}:])<<0>>)*<<1>>?\}/.source, [P, N]),
        D = n(t(/[^"'/()]|\/(?!\*)|\/\*(?:[^*]|\*(?!\/))*\*\/|<<0>>|\(<<self>>*\)/.source, [k]), 2),
        L = t(/\{(?!\{)(?:(?![}:])<<0>>)*<<1>>?\}/.source, [D, N]);

    function M(t, n) {
      return {
        interpolation: {
          pattern: r(/((?:^|[^{])(?:\{\{)*)<<0>>/.source, [t]),
          lookbehind: !0,
          inside: {
            "format-string": {
              pattern: r(/(^\{(?:(?![}:])<<0>>)*)<<1>>(?=\}$)/.source, [n, N]),
              lookbehind: !0,
              inside: {
                punctuation: /^:/
              }
            },
            punctuation: /^\{|\}$/,
            expression: {
              pattern: /[\s\S]+/,
              alias: "language-csharp",
              inside: e.languages.csharp
            }
          }
        },
        string: /[\s\S]+/
      };
    }

    e.languages.insertBefore("csharp", "string", {
      "interpolation-string": [{
        pattern: r(/(^|[^\\])(?:\$@|@\$)"(?:""|\\[\s\S]|\{\{|<<0>>|[^\\{"])*"/.source, [O]),
        lookbehind: !0,
        greedy: !0,
        inside: M(O, P)
      }, {
        pattern: r(/(^|[^@\\])\$"(?:\\.|\{\{|<<0>>|[^\\"{])*"/.source, [L]),
        lookbehind: !0,
        greedy: !0,
        inside: M(L, D)
      }],
      char: {
        pattern: RegExp(x),
        greedy: !0
      }
    }), e.languages.dotnet = e.languages.cs = e.languages.csharp;
  }(e);
}

csharp.displayName = "csharp", csharp.aliases = ["dotnet", "cs"];
var refractorCsharp$2 = csharp_1,
    aspnet_1 = aspnet;

function aspnet(e) {
  e.register(refractorCsharp$2), e.languages.aspnet = e.languages.extend("markup", {
    "page-directive": {
      pattern: /<%\s*@.*%>/,
      alias: "tag",
      inside: {
        "page-directive": {
          pattern: /<%\s*@\s*(?:Assembly|Control|Implements|Import|Master(?:Type)?|OutputCache|Page|PreviousPageType|Reference|Register)?|%>/i,
          alias: "tag"
        },
        rest: e.languages.markup.tag.inside
      }
    },
    directive: {
      pattern: /<%.*%>/,
      alias: "tag",
      inside: {
        directive: {
          pattern: /<%\s*?[$=%#:]{0,2}|%>/,
          alias: "tag"
        },
        rest: e.languages.csharp
      }
    }
  }), e.languages.aspnet.tag.pattern = /<(?!%)\/?[^\s>\/]+(?:\s+[^\s>\/=]+(?:=(?:("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|[^\s'">=]+))?)*\s*\/?>/, e.languages.insertBefore("inside", "punctuation", {
    directive: e.languages.aspnet.directive
  }, e.languages.aspnet.tag.inside["attr-value"]), e.languages.insertBefore("aspnet", "comment", {
    "asp-comment": {
      pattern: /<%--[\s\S]*?--%>/,
      alias: ["asp", "comment"]
    }
  }), e.languages.insertBefore("aspnet", e.languages.javascript ? "script" : "tag", {
    "asp-script": {
      pattern: /(<script(?=.*runat=['"]?server\b)[^>]*>)[\s\S]*?(?=<\/script>)/i,
      lookbehind: !0,
      alias: ["asp", "script"],
      inside: e.languages.csharp || {}
    }
  });
}

aspnet.displayName = "aspnet", aspnet.aliases = [];
var autohotkey_1 = autohotkey;

function autohotkey(e) {
  e.languages.autohotkey = {
    comment: [{
      pattern: /(^|\s);.*/,
      lookbehind: !0
    }, {
      pattern: /(^[\t ]*)\/\*(?:[\r\n](?![ \t]*\*\/)|[^\r\n])*(?:[\r\n][ \t]*\*\/)?/m,
      lookbehind: !0,
      greedy: !0
    }],
    tag: {
      pattern: /^([ \t]*)[^\s,`":]+(?=:[ \t]*$)/m,
      lookbehind: !0
    },
    string: /"(?:[^"\n\r]|"")*"/,
    variable: /%\w+%/,
    number: /\b0x[\dA-Fa-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee]-?\d+)?/,
    operator: /\?|\/\/?=?|:=|\|[=|]?|&[=&]?|\+[=+]?|-[=-]?|\*[=*]?|<(?:<=?|>|=)?|>>?=?|[.^!=~]=?|\b(?:AND|NOT|OR)\b/,
    boolean: /\b(?:false|true)\b/,
    selector: /\b(?:AutoTrim|BlockInput|Break|Click|ClipWait|Continue|Control|ControlClick|ControlFocus|ControlGet|ControlGetFocus|ControlGetPos|ControlGetText|ControlMove|ControlSend|ControlSendRaw|ControlSetText|CoordMode|Critical|DetectHiddenText|DetectHiddenWindows|Drive|DriveGet|DriveSpaceFree|EnvAdd|EnvDiv|EnvGet|EnvMult|EnvSet|EnvSub|EnvUpdate|Exit|ExitApp|FileAppend|FileCopy|FileCopyDir|FileCreateDir|FileCreateShortcut|FileDelete|FileEncoding|FileGetAttrib|FileGetShortcut|FileGetSize|FileGetTime|FileGetVersion|FileInstall|FileMove|FileMoveDir|FileRead|FileReadLine|FileRecycle|FileRecycleEmpty|FileRemoveDir|FileSelectFile|FileSelectFolder|FileSetAttrib|FileSetTime|FormatTime|GetKeyState|Gosub|Goto|GroupActivate|GroupAdd|GroupClose|GroupDeactivate|Gui|GuiControl|GuiControlGet|Hotkey|ImageSearch|IniDelete|IniRead|IniWrite|Input|InputBox|KeyWait|ListHotkeys|ListLines|ListVars|Loop|Menu|MouseClick|MouseClickDrag|MouseGetPos|MouseMove|MsgBox|OnExit|OutputDebug|Pause|PixelGetColor|PixelSearch|PostMessage|Process|Progress|Random|RegDelete|RegRead|RegWrite|Reload|Repeat|Return|Run|RunAs|RunWait|Send|SendEvent|SendInput|SendMessage|SendMode|SendPlay|SendRaw|SetBatchLines|SetCapslockState|SetControlDelay|SetDefaultMouseSpeed|SetEnv|SetFormat|SetKeyDelay|SetMouseDelay|SetNumlockState|SetRegView|SetScrollLockState|SetStoreCapslockMode|SetTimer|SetTitleMatchMode|SetWinDelay|SetWorkingDir|Shutdown|Sleep|Sort|SoundBeep|SoundGet|SoundGetWaveVolume|SoundPlay|SoundSet|SoundSetWaveVolume|SplashImage|SplashTextOff|SplashTextOn|SplitPath|StatusBarGetText|StatusBarWait|StringCaseSense|StringGetPos|StringLeft|StringLen|StringLower|StringMid|StringReplace|StringRight|StringSplit|StringTrimLeft|StringTrimRight|StringUpper|Suspend|SysGet|Thread|ToolTip|Transform|TrayTip|URLDownloadToFile|WinActivate|WinActivateBottom|WinClose|WinGet|WinGetActiveStats|WinGetActiveTitle|WinGetClass|WinGetPos|WinGetText|WinGetTitle|WinHide|WinKill|WinMaximize|WinMenuSelectItem|WinMinimize|WinMinimizeAll|WinMinimizeAllUndo|WinMove|WinRestore|WinSet|WinSetTitle|WinShow|WinWait|WinWaitActive|WinWaitClose|WinWaitNotActive)\b/i,
    constant: /\b(?:a_ahkpath|a_ahkversion|a_appdata|a_appdatacommon|a_autotrim|a_batchlines|a_caretx|a_carety|a_computername|a_controldelay|a_cursor|a_dd|a_ddd|a_dddd|a_defaultmousespeed|a_desktop|a_desktopcommon|a_detecthiddentext|a_detecthiddenwindows|a_endchar|a_eventinfo|a_exitreason|a_fileencoding|a_formatfloat|a_formatinteger|a_gui|a_guicontrol|a_guicontrolevent|a_guievent|a_guiheight|a_guiwidth|a_guix|a_guiy|a_hour|a_iconfile|a_iconhidden|a_iconnumber|a_icontip|a_index|a_ipaddress1|a_ipaddress2|a_ipaddress3|a_ipaddress4|a_is64bitos|a_isadmin|a_iscompiled|a_iscritical|a_ispaused|a_issuspended|a_isunicode|a_keydelay|a_language|a_lasterror|a_linefile|a_linenumber|a_loopfield|a_loopfileattrib|a_loopfiledir|a_loopfileext|a_loopfilefullpath|a_loopfilelongpath|a_loopfilename|a_loopfileshortname|a_loopfileshortpath|a_loopfilesize|a_loopfilesizekb|a_loopfilesizemb|a_loopfiletimeaccessed|a_loopfiletimecreated|a_loopfiletimemodified|a_loopreadline|a_loopregkey|a_loopregname|a_loopregsubkey|a_loopregtimemodified|a_loopregtype|a_mday|a_min|a_mm|a_mmm|a_mmmm|a_mon|a_mousedelay|a_msec|a_mydocuments|a_now|a_nowutc|a_numbatchlines|a_ostype|a_osversion|a_priorhotkey|a_priorkey|a_programfiles|a_programs|a_programscommon|a_ptrsize|a_regview|a_screendpi|a_screenheight|a_screenwidth|a_scriptdir|a_scriptfullpath|a_scripthwnd|a_scriptname|a_sec|a_space|a_startmenu|a_startmenucommon|a_startup|a_startupcommon|a_stringcasesense|a_tab|a_temp|a_thisfunc|a_thishotkey|a_thislabel|a_thismenu|a_thismenuitem|a_thismenuitempos|a_tickcount|a_timeidle|a_timeidlephysical|a_timesincepriorhotkey|a_timesincethishotkey|a_titlematchmode|a_titlematchmodespeed|a_username|a_wday|a_windelay|a_windir|a_workingdir|a_yday|a_year|a_yweek|a_yyyy|clipboard|clipboardall|comspec|errorlevel|programfiles)\b/i,
    builtin: /\b(?:abs|acos|asc|asin|atan|ceil|chr|class|comobjactive|comobjarray|comobjconnect|comobjcreate|comobjerror|comobjflags|comobjget|comobjquery|comobjtype|comobjvalue|cos|dllcall|exp|fileexist|Fileopen|floor|format|il_add|il_create|il_destroy|instr|isfunc|islabel|IsObject|ln|log|ltrim|lv_add|lv_delete|lv_deletecol|lv_getcount|lv_getnext|lv_gettext|lv_insert|lv_insertcol|lv_modify|lv_modifycol|lv_setimagelist|mod|numget|numput|onmessage|regexmatch|regexreplace|registercallback|round|rtrim|sb_seticon|sb_setparts|sb_settext|sin|sqrt|strlen|strreplace|strsplit|substr|tan|tv_add|tv_delete|tv_get|tv_getchild|tv_getcount|tv_getnext|tv_getparent|tv_getprev|tv_getselection|tv_gettext|tv_modify|varsetcapacity|winactive|winexist|__Call|__Get|__New|__Set)\b/i,
    symbol: /\b(?:alt|altdown|altup|appskey|backspace|browser_back|browser_favorites|browser_forward|browser_home|browser_refresh|browser_search|browser_stop|bs|capslock|ctrl|ctrlbreak|ctrldown|ctrlup|del|delete|down|end|enter|esc|escape|f1|f10|f11|f12|f13|f14|f15|f16|f17|f18|f19|f2|f20|f21|f22|f23|f24|f3|f4|f5|f6|f7|f8|f9|home|ins|insert|joy1|joy10|joy11|joy12|joy13|joy14|joy15|joy16|joy17|joy18|joy19|joy2|joy20|joy21|joy22|joy23|joy24|joy25|joy26|joy27|joy28|joy29|joy3|joy30|joy31|joy32|joy4|joy5|joy6|joy7|joy8|joy9|joyaxes|joybuttons|joyinfo|joyname|joypov|joyr|joyu|joyv|joyx|joyy|joyz|lalt|launch_app1|launch_app2|launch_mail|launch_media|lbutton|lcontrol|lctrl|left|lshift|lwin|lwindown|lwinup|mbutton|media_next|media_play_pause|media_prev|media_stop|numlock|numpad0|numpad1|numpad2|numpad3|numpad4|numpad5|numpad6|numpad7|numpad8|numpad9|numpadadd|numpadclear|numpaddel|numpaddiv|numpaddot|numpaddown|numpadend|numpadenter|numpadhome|numpadins|numpadleft|numpadmult|numpadpgdn|numpadpgup|numpadright|numpadsub|numpadup|pgdn|pgup|printscreen|ralt|rbutton|rcontrol|rctrl|right|rshift|rwin|rwindown|rwinup|scrolllock|shift|shiftdown|shiftup|space|tab|up|volume_down|volume_mute|volume_up|wheeldown|wheelleft|wheelright|wheelup|xbutton1|xbutton2)\b/i,
    important: /#\b(?:AllowSameLineComments|ClipboardTimeout|CommentFlag|DerefChar|ErrorStdOut|EscapeChar|HotkeyInterval|HotkeyModifierTimeout|Hotstring|If|IfTimeout|IfWinActive|IfWinExist|IfWinNotActive|IfWinNotExist|Include|IncludeAgain|InputLevel|InstallKeybdHook|InstallMouseHook|KeyHistory|MaxHotkeysPerInterval|MaxMem|MaxThreads|MaxThreadsBuffer|MaxThreadsPerHotkey|MenuMaskKey|NoEnv|NoTrayIcon|Persistent|SingleInstance|UseHook|Warn|WinActivateForce)\b/i,
    keyword: /\b(?:Abort|AboveNormal|Add|ahk_class|ahk_exe|ahk_group|ahk_id|ahk_pid|All|Alnum|Alpha|AltSubmit|AltTab|AltTabAndMenu|AltTabMenu|AltTabMenuDismiss|AlwaysOnTop|AutoSize|Background|BackgroundTrans|BelowNormal|between|BitAnd|BitNot|BitOr|BitShiftLeft|BitShiftRight|BitXOr|Bold|Border|Button|ByRef|Catch|Checkbox|Checked|CheckedGray|Choose|ChooseString|Close|Color|ComboBox|Contains|ControlList|Count|Date|DateTime|Days|DDL|Default|DeleteAll|Delimiter|Deref|Destroy|Digit|Disable|Disabled|DropDownList|Edit|Eject|Else|Enable|Enabled|Error|Exist|Expand|ExStyle|FileSystem|Finally|First|Flash|Float|FloatFast|Focus|Font|for|global|Grid|Group|GroupBox|GuiClose|GuiContextMenu|GuiDropFiles|GuiEscape|GuiSize|Hdr|Hidden|Hide|High|HKCC|HKCR|HKCU|HKEY_CLASSES_ROOT|HKEY_CURRENT_CONFIG|HKEY_CURRENT_USER|HKEY_LOCAL_MACHINE|HKEY_USERS|HKLM|HKU|Hours|HScroll|Icon|IconSmall|ID|IDLast|If|IfEqual|IfExist|IfGreater|IfGreaterOrEqual|IfInString|IfLess|IfLessOrEqual|IfMsgBox|IfNotEqual|IfNotExist|IfNotInString|IfWinActive|IfWinExist|IfWinNotActive|IfWinNotExist|Ignore|ImageList|in|Integer|IntegerFast|Interrupt|is|italic|Join|Label|LastFound|LastFoundExist|Limit|Lines|List|ListBox|ListView|local|Lock|Logoff|Low|Lower|Lowercase|MainWindow|Margin|Maximize|MaximizeBox|MaxSize|Minimize|MinimizeBox|MinMax|MinSize|Minutes|MonthCal|Mouse|Move|Multi|NA|No|NoActivate|NoDefault|NoHide|NoIcon|NoMainWindow|norm|Normal|NoSort|NoSortHdr|NoStandard|Not|NoTab|NoTimers|Number|Off|Ok|On|OwnDialogs|Owner|Parse|Password|Picture|Pixel|Pos|Pow|Priority|ProcessName|Radio|Range|Read|ReadOnly|Realtime|Redraw|Region|REG_BINARY|REG_DWORD|REG_EXPAND_SZ|REG_MULTI_SZ|REG_SZ|Relative|Rename|Report|Resize|Restore|Retry|RGB|Screen|Seconds|Section|Serial|SetLabel|ShiftAltTab|Show|Single|Slider|SortDesc|Standard|static|Status|StatusBar|StatusCD|strike|Style|Submit|SysMenu|Tab2|TabStop|Text|Theme|Throw|Tile|ToggleCheck|ToggleEnable|ToolWindow|Top|Topmost|TransColor|Transparent|Tray|TreeView|Try|TryAgain|Type|UnCheck|underline|Unicode|Unlock|Until|UpDown|Upper|Uppercase|UseErrorLevel|Vis|VisFirst|Visible|VScroll|Wait|WaitClose|WantCtrlA|WantF2|WantReturn|While|Wrap|Xdigit|xm|xp|xs|Yes|ym|yp|ys)\b/i,
    function: /[^(); \t,\n+*\-=?>:\\\/<&%\[\]]+(?=\()/,
    punctuation: /[{}[\]():,]/
  };
}

autohotkey.displayName = "autohotkey", autohotkey.aliases = [];
var autoit_1 = autoit;

function autoit(e) {
  e.languages.autoit = {
    comment: [/;.*/, {
      pattern: /(^[\t ]*)#(?:comments-start|cs)[\s\S]*?^[ \t]*#(?:ce|comments-end)/m,
      lookbehind: !0
    }],
    url: {
      pattern: /(^[\t ]*#include\s+)(?:<[^\r\n>]+>|"[^\r\n"]+")/m,
      lookbehind: !0
    },
    string: {
      pattern: /(["'])(?:\1\1|(?!\1)[^\r\n])*\1/,
      greedy: !0,
      inside: {
        variable: /([%$@])\w+\1/
      }
    },
    directive: {
      pattern: /(^[\t ]*)#[\w-]+/m,
      lookbehind: !0,
      alias: "keyword"
    },
    function: /\b\w+(?=\()/,
    variable: /[$@]\w+/,
    keyword: /\b(?:Case|Const|Continue(?:Case|Loop)|Default|Dim|Do|Else(?:If)?|End(?:Func|If|Select|Switch|With)|Enum|Exit(?:Loop)?|For|Func|Global|If|In|Local|Next|Null|ReDim|Select|Static|Step|Switch|Then|To|Until|Volatile|WEnd|While|With)\b/i,
    number: /\b(?:0x[\da-f]+|\d+(?:\.\d+)?(?:e[+-]?\d+)?)\b/i,
    boolean: /\b(?:False|True)\b/i,
    operator: /<[=>]?|[-+*\/=&>]=?|[?^]|\b(?:And|Not|Or)\b/i,
    punctuation: /[\[\]().,:]/
  };
}

autoit.displayName = "autoit", autoit.aliases = [];
var avisynth_1 = avisynth;

function avisynth(e) {
  !function (e) {
    function t(e, t, r) {
      return RegExp(function (e, t) {
        return e.replace(/<<(\d+)>>/g, function (e, r) {
          return t[+r];
        });
      }(e, t), r || "");
    }

    var r = /bool|clip|float|int|string|val/.source,
        n = [[/is(?:bool|clip|float|int|string)|defined|(?:(?:internal)?function|var)?exists?/.source, /apply|assert|default|eval|import|nop|select|undefined/.source, /opt_(?:allowfloataudio|avipadscanlines|dwchannelmask|enable_(?:b64a|planartopackedrgb|v210|y3_10_10|y3_10_16)|usewaveextensible|vdubplanarhack)|set(?:cachemode|maxcpu|memorymax|planarlegacyalignment|workingdir)/.source, /hex(?:value)?|value/.source, /abs|ceil|continued(?:denominator|numerator)?|exp|floor|fmod|frac|log(?:10)?|max|min|muldiv|pi|pow|rand|round|sign|spline|sqrt/.source, /a?sinh?|a?cosh?|a?tan[2h]?/.source, /(?:bit(?:and|not|x?or|[lr]?shift[aslu]?|sh[lr]|sa[lr]|[lr]rotatel?|ro[rl]|te?st|set(?:count)?|cl(?:ea)?r|ch(?:an)?ge?))/.source, /average(?:[bgr]|chroma[uv]|luma)|(?:[rgb]|chroma[uv]|luma|rgb|[yuv](?=difference(?:fromprevious|tonext)))difference(?:fromprevious|tonext)?|[yuvrgb]plane(?:median|min|max|minmaxdifference)/.source, /getprocessinfo|logmsg|script(?:dir(?:utf8)?|file(?:utf8)?|name(?:utf8)?)|setlogparams/.source, /chr|(?:fill|find|left|mid|replace|rev|right)str|format|[lu]case|ord|str(?:cmpi?|fromutf8|len|toutf8)|time|trim(?:all|left|right)/.source, /isversionorgreater|version(?:number|string)/.source, /buildpixeltype|colorspacenametopixeltype/.source, /addautoloaddir|on(?:cpu|cuda)|prefetch|setfiltermtmode/.source].join("|"), [/has(?:audio|video)/.source, /height|width/.source, /frame(?:count|rate)|framerate(?:denominator|numerator)/.source, /getparity|is(?:field|frame)based/.source, /bitspercomponent|componentsize|hasalpha|is(?:planar(?:rgba?)?|interleaved|rgb(?:24|32|48|64)?|y(?:8|u(?:va?|y2))?|yv(?:12|16|24|411)|420|422|444|packedrgb)|numcomponents|pixeltype/.source, /audio(?:bits|channels|duration|length(?:[fs]|hi|lo)?|rate)|isaudio(?:float|int)/.source].join("|"), [/avi(?:file)?source|directshowsource|image(?:reader|source|sourceanim)|opendmlsource|segmented(?:avisource|directshowsource)|wavsource/.source, /coloryuv|convertbacktoyuy2|convertto(?:RGB(?:24|32|48|64)|(?:planar)?RGBA?|Y8?|YV(?:12|16|24|411)|YUVA?(?:411|420|422|444)|YUY2)|fixluminance|gr[ae]yscale|invert|levels|limiter|mergea?rgb|merge(?:chroma|luma)|rgbadjust|show(?:alpha|blue|green|red)|swapuv|tweak|[uv]toy8?|ytouv/.source, /(?:colorkey|reset)mask|layer|mask(?:hs)?|merge|overlay|subtract/.source, /addborders|(?:bicubic|bilinear|blackman|gauss|lanczos4|lanczos|point|sinc|spline(?:16|36|64))resize|crop(?:bottom)?|flip(?:horizontal|vertical)|(?:horizontal|vertical)?reduceby2|letterbox|skewrows|turn(?:180|left|right)/.source, /blur|fixbrokenchromaupsampling|generalconvolution|(?:spatial|temporal)soften|sharpen/.source, /trim|(?:un)?alignedsplice|(?:assume|assumescaled|change|convert)FPS|(?:delete|duplicate)frame|dissolve|fade(?:in|io|out)[02]?|freezeframe|interleave|loop|reverse|select(?:even|odd|(?:range)?every)/.source, /assume[bt]ff|assume(?:field|frame)based|bob|complementparity|doubleweave|peculiarblend|pulldown|separate(?:columns|fields|rows)|swapfields|weave(?:columns|rows)?/.source, /amplify(?:db)?|assumesamplerate|audiodub(?:ex)?|audiotrim|convertaudioto(?:(?:8|16|24|32)bit|float)|converttomono|delayaudio|ensurevbrmp3sync|get(?:left|right)?channel|kill(?:audio|video)|mergechannels|mixaudio|monotostereo|normalize|resampleaudio|ssrc|supereq|timestretch/.source, /animate|applyrange|conditional(?:filter|reader|select)|frameevaluate|scriptclip|tcp(?:server|source)|writefile(?:end|if|start)?/.source, /imagewriter/.source, /blackness|blankclip|colorbars(?:hd)?|compare|dumpfiltergraph|echo|histogram|info|messageclip|preroll|setgraphanalysis|show(?:framenumber|smpte|time)|showfiveversions|stack(?:horizontal|vertical)|subtitle|tone|version/.source].join("|")].join("|");
    e.languages.avisynth = {
      comment: [{
        pattern: /(^|[^\\])\[\*(?:[^\[*]|\[(?!\*)|\*(?!\])|\[\*(?:[^\[*]|\[(?!\*)|\*(?!\]))*\*\])*\*\]/,
        lookbehind: !0,
        greedy: !0
      }, {
        pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
        lookbehind: !0,
        greedy: !0
      }, {
        pattern: /(^|[^\\$])#.*/,
        lookbehind: !0,
        greedy: !0
      }],
      argument: {
        pattern: t(/\b(?:<<0>>)\s+("?)\w+\1/.source, [r], "i"),
        inside: {
          keyword: /^\w+/
        }
      },
      "argument-label": {
        pattern: /([,(][\s\\]*)\w+\s*=(?!=)/,
        lookbehind: !0,
        inside: {
          "argument-name": {
            pattern: /^\w+/,
            alias: "punctuation"
          },
          punctuation: /=$/
        }
      },
      string: [{
        pattern: /"""[\s\S]*?"""/,
        greedy: !0
      }, {
        pattern: /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/,
        greedy: !0,
        inside: {
          constant: {
            pattern: /\b(?:DEFAULT_MT_MODE|(?:MAINSCRIPT|PROGRAM|SCRIPT)DIR|(?:MACHINE|USER)_(?:CLASSIC|PLUS)_PLUGINS)\b/
          }
        }
      }],
      variable: /\b(?:last)\b/i,
      boolean: /\b(?:false|no|true|yes)\b/i,
      keyword: /\b(?:catch|else|for|function|global|if|return|try|while|__END__)\b/i,
      constant: /\bMT_(?:MULTI_INSTANCE|NICE_FILTER|SERIALIZED|SPECIAL_MT)\b/,
      "builtin-function": {
        pattern: t(/\b(?:<<0>>)\b/.source, [n], "i"),
        alias: "function"
      },
      "type-cast": {
        pattern: t(/\b(?:<<0>>)(?=\s*\()/.source, [r], "i"),
        alias: "keyword"
      },
      function: {
        pattern: /\b[a-z_]\w*(?=\s*\()|(\.)[a-z_]\w*\b/i,
        lookbehind: !0
      },
      "line-continuation": {
        pattern: /(^[ \t]*)\\|\\(?=[ \t]*$)/m,
        lookbehind: !0,
        alias: "punctuation"
      },
      number: /\B\$(?:[\da-f]{6}|[\da-f]{8})\b|(?:(?:\b|\B-)\d+(?:\.\d*)?\b|\B\.\d+\b)/i,
      operator: /\+\+?|[!=<>]=?|&&|\|\||[?:*/%-]/,
      punctuation: /[{}\[\]();,.]/
    }, e.languages.avs = e.languages.avisynth;
  }(e);
}

avisynth.displayName = "avisynth", avisynth.aliases = ["avs"];
var avroIdl_1 = avroIdl;

function avroIdl(e) {
  e.languages["avro-idl"] = {
    comment: {
      pattern: /\/\/.*|\/\*[\s\S]*?\*\//,
      greedy: !0
    },
    string: {
      pattern: /(^|[^\\])"(?:[^\r\n"\\]|\\.)*"/,
      lookbehind: !0,
      greedy: !0
    },
    annotation: {
      pattern: /@(?:[$\w.-]|`[^\r\n`]+`)+/,
      greedy: !0,
      alias: "function"
    },
    "function-identifier": {
      pattern: /`[^\r\n`]+`(?=\s*\()/,
      greedy: !0,
      alias: "function"
    },
    identifier: {
      pattern: /`[^\r\n`]+`/,
      greedy: !0
    },
    "class-name": {
      pattern: /(\b(?:enum|error|protocol|record|throws)\b\s+)[$\w]+/,
      lookbehind: !0,
      greedy: !0
    },
    keyword: /\b(?:array|boolean|bytes|date|decimal|double|enum|error|false|fixed|float|idl|import|int|local_timestamp_ms|long|map|null|oneway|protocol|record|schema|string|throws|time_ms|timestamp_ms|true|union|uuid|void)\b/,
    function: /\b[a-z_]\w*(?=\s*\()/i,
    number: [{
      pattern: /(^|[^\w.])-?(?:(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?|0x(?:[a-f0-9]+(?:\.[a-f0-9]*)?|\.[a-f0-9]+)(?:p[+-]?\d+)?)[dfl]?(?![\w.])/i,
      lookbehind: !0
    }, /-?\b(?:Infinity|NaN)\b/],
    operator: /=/,
    punctuation: /[()\[\]{}<>.:,;-]/
  }, e.languages.avdl = e.languages["avro-idl"];
}

avroIdl.displayName = "avroIdl", avroIdl.aliases = [];
var bash_1 = bash;

function bash(e) {
  !function (e) {
    var t = "\\b(?:BASH|BASHOPTS|BASH_ALIASES|BASH_ARGC|BASH_ARGV|BASH_CMDS|BASH_COMPLETION_COMPAT_DIR|BASH_LINENO|BASH_REMATCH|BASH_SOURCE|BASH_VERSINFO|BASH_VERSION|COLORTERM|COLUMNS|COMP_WORDBREAKS|DBUS_SESSION_BUS_ADDRESS|DEFAULTS_PATH|DESKTOP_SESSION|DIRSTACK|DISPLAY|EUID|GDMSESSION|GDM_LANG|GNOME_KEYRING_CONTROL|GNOME_KEYRING_PID|GPG_AGENT_INFO|GROUPS|HISTCONTROL|HISTFILE|HISTFILESIZE|HISTSIZE|HOME|HOSTNAME|HOSTTYPE|IFS|INSTANCE|JOB|LANG|LANGUAGE|LC_ADDRESS|LC_ALL|LC_IDENTIFICATION|LC_MEASUREMENT|LC_MONETARY|LC_NAME|LC_NUMERIC|LC_PAPER|LC_TELEPHONE|LC_TIME|LESSCLOSE|LESSOPEN|LINES|LOGNAME|LS_COLORS|MACHTYPE|MAILCHECK|MANDATORY_PATH|NO_AT_BRIDGE|OLDPWD|OPTERR|OPTIND|ORBIT_SOCKETDIR|OSTYPE|PAPERSIZE|PATH|PIPESTATUS|PPID|PS1|PS2|PS3|PS4|PWD|RANDOM|REPLY|SECONDS|SELINUX_INIT|SESSION|SESSIONTYPE|SESSION_MANAGER|SHELL|SHELLOPTS|SHLVL|SSH_AUTH_SOCK|TERM|UID|UPSTART_EVENTS|UPSTART_INSTANCE|UPSTART_JOB|UPSTART_SESSION|USER|WINDOWID|XAUTHORITY|XDG_CONFIG_DIRS|XDG_CURRENT_DESKTOP|XDG_DATA_DIRS|XDG_GREETER_DATA_DIR|XDG_MENU_PREFIX|XDG_RUNTIME_DIR|XDG_SEAT|XDG_SEAT_PATH|XDG_SESSION_DESKTOP|XDG_SESSION_ID|XDG_SESSION_PATH|XDG_SESSION_TYPE|XDG_VTNR|XMODIFIERS)\\b",
        r = {
      pattern: /(^(["']?)\w+\2)[ \t]+\S.*/,
      lookbehind: !0,
      alias: "punctuation",
      inside: null
    },
        n = {
      bash: r,
      environment: {
        pattern: RegExp("\\$" + t),
        alias: "constant"
      },
      variable: [{
        pattern: /\$?\(\([\s\S]+?\)\)/,
        greedy: !0,
        inside: {
          variable: [{
            pattern: /(^\$\(\([\s\S]+)\)\)/,
            lookbehind: !0
          }, /^\$\(\(/],
          number: /\b0x[\dA-Fa-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee]-?\d+)?/,
          operator: /--|\+\+|\*\*=?|<<=?|>>=?|&&|\|\||[=!+\-*/%<>^&|]=?|[?~:]/,
          punctuation: /\(\(?|\)\)?|,|;/
        }
      }, {
        pattern: /\$\((?:\([^)]+\)|[^()])+\)|`[^`]+`/,
        greedy: !0,
        inside: {
          variable: /^\$\(|^`|\)$|`$/
        }
      }, {
        pattern: /\$\{[^}]+\}/,
        greedy: !0,
        inside: {
          operator: /:[-=?+]?|[!\/]|##?|%%?|\^\^?|,,?/,
          punctuation: /[\[\]]/,
          environment: {
            pattern: RegExp("(\\{)" + t),
            lookbehind: !0,
            alias: "constant"
          }
        }
      }, /\$(?:\w+|[#?*!@$])/],
      entity: /\\(?:[abceEfnrtv\\"]|O?[0-7]{1,3}|U[0-9a-fA-F]{8}|u[0-9a-fA-F]{4}|x[0-9a-fA-F]{1,2})/
    };
    e.languages.bash = {
      shebang: {
        pattern: /^#!\s*\/.*/,
        alias: "important"
      },
      comment: {
        pattern: /(^|[^"{\\$])#.*/,
        lookbehind: !0
      },
      "function-name": [{
        pattern: /(\bfunction\s+)[\w-]+(?=(?:\s*\(?:\s*\))?\s*\{)/,
        lookbehind: !0,
        alias: "function"
      }, {
        pattern: /\b[\w-]+(?=\s*\(\s*\)\s*\{)/,
        alias: "function"
      }],
      "for-or-select": {
        pattern: /(\b(?:for|select)\s+)\w+(?=\s+in\s)/,
        alias: "variable",
        lookbehind: !0
      },
      "assign-left": {
        pattern: /(^|[\s;|&]|[<>]\()\w+(?=\+?=)/,
        inside: {
          environment: {
            pattern: RegExp("(^|[\\s;|&]|[<>]\\()" + t),
            lookbehind: !0,
            alias: "constant"
          }
        },
        alias: "variable",
        lookbehind: !0
      },
      string: [{
        pattern: /((?:^|[^<])<<-?\s*)(\w+)\s[\s\S]*?(?:\r?\n|\r)\2/,
        lookbehind: !0,
        greedy: !0,
        inside: n
      }, {
        pattern: /((?:^|[^<])<<-?\s*)(["'])(\w+)\2\s[\s\S]*?(?:\r?\n|\r)\3/,
        lookbehind: !0,
        greedy: !0,
        inside: {
          bash: r
        }
      }, {
        pattern: /(^|[^\\](?:\\\\)*)"(?:\\[\s\S]|\$\([^)]+\)|\$(?!\()|`[^`]+`|[^"\\`$])*"/,
        lookbehind: !0,
        greedy: !0,
        inside: n
      }, {
        pattern: /(^|[^$\\])'[^']*'/,
        lookbehind: !0,
        greedy: !0
      }, {
        pattern: /\$'(?:[^'\\]|\\[\s\S])*'/,
        greedy: !0,
        inside: {
          entity: n.entity
        }
      }],
      environment: {
        pattern: RegExp("\\$?" + t),
        alias: "constant"
      },
      variable: n.variable,
      function: {
        pattern: /(^|[\s;|&]|[<>]\()(?:add|apropos|apt|apt-cache|apt-get|aptitude|aspell|automysqlbackup|awk|basename|bash|bc|bconsole|bg|bzip2|cal|cat|cfdisk|chgrp|chkconfig|chmod|chown|chroot|cksum|clear|cmp|column|comm|composer|cp|cron|crontab|csplit|curl|cut|date|dc|dd|ddrescue|debootstrap|df|diff|diff3|dig|dir|dircolors|dirname|dirs|dmesg|docker|docker-compose|du|egrep|eject|env|ethtool|expand|expect|expr|fdformat|fdisk|fg|fgrep|file|find|fmt|fold|format|free|fsck|ftp|fuser|gawk|git|gparted|grep|groupadd|groupdel|groupmod|groups|grub-mkconfig|gzip|halt|head|hg|history|host|hostname|htop|iconv|id|ifconfig|ifdown|ifup|import|install|ip|jobs|join|kill|killall|less|link|ln|locate|logname|logrotate|look|lpc|lpr|lprint|lprintd|lprintq|lprm|ls|lsof|lynx|make|man|mc|mdadm|mkconfig|mkdir|mke2fs|mkfifo|mkfs|mkisofs|mknod|mkswap|mmv|more|most|mount|mtools|mtr|mutt|mv|nano|nc|netstat|nice|nl|node|nohup|notify-send|npm|nslookup|op|open|parted|passwd|paste|pathchk|ping|pkill|pnpm|podman|podman-compose|popd|pr|printcap|printenv|ps|pushd|pv|quota|quotacheck|quotactl|ram|rar|rcp|reboot|remsync|rename|renice|rev|rm|rmdir|rpm|rsync|scp|screen|sdiff|sed|sendmail|seq|service|sftp|sh|shellcheck|shuf|shutdown|sleep|slocate|sort|split|ssh|stat|strace|su|sudo|sum|suspend|swapon|sync|tac|tail|tar|tee|time|timeout|top|touch|tr|traceroute|tsort|tty|umount|uname|unexpand|uniq|units|unrar|unshar|unzip|update-grub|uptime|useradd|userdel|usermod|users|uudecode|uuencode|v|vcpkg|vdir|vi|vim|virsh|vmstat|wait|watch|wc|wget|whereis|which|who|whoami|write|xargs|xdg-open|yarn|yes|zenity|zip|zsh|zypper)(?=$|[)\s;|&])/,
        lookbehind: !0
      },
      keyword: {
        pattern: /(^|[\s;|&]|[<>]\()(?:case|do|done|elif|else|esac|fi|for|function|if|in|select|then|until|while)(?=$|[)\s;|&])/,
        lookbehind: !0
      },
      builtin: {
        pattern: /(^|[\s;|&]|[<>]\()(?:\.|:|alias|bind|break|builtin|caller|cd|command|continue|declare|echo|enable|eval|exec|exit|export|getopts|hash|help|let|local|logout|mapfile|printf|pwd|read|readarray|readonly|return|set|shift|shopt|source|test|times|trap|type|typeset|ulimit|umask|unalias|unset)(?=$|[)\s;|&])/,
        lookbehind: !0,
        alias: "class-name"
      },
      boolean: {
        pattern: /(^|[\s;|&]|[<>]\()(?:false|true)(?=$|[)\s;|&])/,
        lookbehind: !0
      },
      "file-descriptor": {
        pattern: /\B&\d\b/,
        alias: "important"
      },
      operator: {
        pattern: /\d?<>|>\||\+=|=[=~]?|!=?|<<[<-]?|[&\d]?>>|\d[<>]&?|[<>][&=]?|&[>&]?|\|[&|]?/,
        inside: {
          "file-descriptor": {
            pattern: /^\d/,
            alias: "important"
          }
        }
      },
      punctuation: /\$?\(\(?|\)\)?|\.\.|[{}[\];\\]/,
      number: {
        pattern: /(^|\s)(?:[1-9]\d*|0)(?:[.,]\d+)?\b/,
        lookbehind: !0
      }
    }, r.inside = e.languages.bash;

    for (var a = ["comment", "function-name", "for-or-select", "assign-left", "string", "environment", "function", "keyword", "builtin", "boolean", "file-descriptor", "operator", "punctuation", "number"], o = n.variable[1].inside, i = 0; i < a.length; i++) {
      o[a[i]] = e.languages.bash[a[i]];
    }

    e.languages.shell = e.languages.bash;
  }(e);
}

bash.displayName = "bash", bash.aliases = ["shell"];
var basic_1 = basic;

function basic(e) {
  e.languages.basic = {
    comment: {
      pattern: /(?:!|REM\b).+/i,
      inside: {
        keyword: /^REM/i
      }
    },
    string: {
      pattern: /"(?:""|[!#$%&'()*,\/:;<=>?^\w +\-.])*"/,
      greedy: !0
    },
    number: /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:E[+-]?\d+)?/i,
    keyword: /\b(?:AS|BEEP|BLOAD|BSAVE|CALL(?: ABSOLUTE)?|CASE|CHAIN|CHDIR|CLEAR|CLOSE|CLS|COM|COMMON|CONST|DATA|DECLARE|DEF(?: FN| SEG|DBL|INT|LNG|SNG|STR)|DIM|DO|DOUBLE|ELSE|ELSEIF|END|ENVIRON|ERASE|ERROR|EXIT|FIELD|FILES|FOR|FUNCTION|GET|GOSUB|GOTO|IF|INPUT|INTEGER|IOCTL|KEY|KILL|LINE INPUT|LOCATE|LOCK|LONG|LOOP|LSET|MKDIR|NAME|NEXT|OFF|ON(?: COM| ERROR| KEY| TIMER)?|OPEN|OPTION BASE|OUT|POKE|PUT|READ|REDIM|REM|RESTORE|RESUME|RETURN|RMDIR|RSET|RUN|SELECT CASE|SHARED|SHELL|SINGLE|SLEEP|STATIC|STEP|STOP|STRING|SUB|SWAP|SYSTEM|THEN|TIMER|TO|TROFF|TRON|TYPE|UNLOCK|UNTIL|USING|VIEW PRINT|WAIT|WEND|WHILE|WRITE)(?:\$|\b)/i,
    function: /\b(?:ABS|ACCESS|ACOS|ANGLE|AREA|ARITHMETIC|ARRAY|ASIN|ASK|AT|ATN|BASE|BEGIN|BREAK|CAUSE|CEIL|CHR|CLIP|COLLATE|COLOR|CON|COS|COSH|COT|CSC|DATE|DATUM|DEBUG|DECIMAL|DEF|DEG|DEGREES|DELETE|DET|DEVICE|DISPLAY|DOT|ELAPSED|EPS|ERASABLE|EXLINE|EXP|EXTERNAL|EXTYPE|FILETYPE|FIXED|FP|GO|GRAPH|HANDLER|IDN|IMAGE|IN|INT|INTERNAL|IP|IS|KEYED|LBOUND|LCASE|LEFT|LEN|LENGTH|LET|LINE|LINES|LOG|LOG10|LOG2|LTRIM|MARGIN|MAT|MAX|MAXNUM|MID|MIN|MISSING|MOD|NATIVE|NUL|NUMERIC|OF|OPTION|ORD|ORGANIZATION|OUTIN|OUTPUT|PI|POINT|POINTER|POINTS|POS|PRINT|PROGRAM|PROMPT|RAD|RADIANS|RANDOMIZE|RECORD|RECSIZE|RECTYPE|RELATIVE|REMAINDER|REPEAT|REST|RETRY|REWRITE|RIGHT|RND|ROUND|RTRIM|SAME|SEC|SELECT|SEQUENTIAL|SET|SETTER|SGN|SIN|SINH|SIZE|SKIP|SQR|STANDARD|STATUS|STR|STREAM|STYLE|TAB|TAN|TANH|TEMPLATE|TEXT|THERE|TIME|TIMEOUT|TRACE|TRANSFORM|TRUNCATE|UBOUND|UCASE|USE|VAL|VARIABLE|VIEWPORT|WHEN|WINDOW|WITH|ZER|ZONEWIDTH)(?:\$|\b)/i,
    operator: /<[=>]?|>=?|[+\-*\/^=&]|\b(?:AND|EQV|IMP|NOT|OR|XOR)\b/i,
    punctuation: /[,;:()]/
  };
}

basic.displayName = "basic", basic.aliases = [];
var batch_1 = batch;

function batch(e) {
  !function (e) {
    var t = /%%?[~:\w]+%?|!\S+!/,
        r = {
      pattern: /\/[a-z?]+(?=[ :]|$):?|-[a-z]\b|--[a-z-]+\b/im,
      alias: "attr-name",
      inside: {
        punctuation: /:/
      }
    },
        n = /"(?:[\\"]"|[^"])*"(?!")/,
        a = /(?:\b|-)\d+\b/;
    e.languages.batch = {
      comment: [/^::.*/m, {
        pattern: /((?:^|[&(])[ \t]*)rem\b(?:[^^&)\r\n]|\^(?:\r\n|[\s\S]))*/im,
        lookbehind: !0
      }],
      label: {
        pattern: /^:.*/m,
        alias: "property"
      },
      command: [{
        pattern: /((?:^|[&(])[ \t]*)for(?: \/[a-z?](?:[ :](?:"[^"]*"|[^\s"/]\S*))?)* \S+ in \([^)]+\) do/im,
        lookbehind: !0,
        inside: {
          keyword: /\b(?:do|in)\b|^for\b/i,
          string: n,
          parameter: r,
          variable: t,
          number: a,
          punctuation: /[()',]/
        }
      }, {
        pattern: /((?:^|[&(])[ \t]*)if(?: \/[a-z?](?:[ :](?:"[^"]*"|[^\s"/]\S*))?)* (?:not )?(?:cmdextversion \d+|defined \w+|errorlevel \d+|exist \S+|(?:"[^"]*"|(?!")(?:(?!==)\S)+)?(?:==| (?:equ|geq|gtr|leq|lss|neq) )(?:"[^"]*"|[^\s"]\S*))/im,
        lookbehind: !0,
        inside: {
          keyword: /\b(?:cmdextversion|defined|errorlevel|exist|not)\b|^if\b/i,
          string: n,
          parameter: r,
          variable: t,
          number: a,
          operator: /\^|==|\b(?:equ|geq|gtr|leq|lss|neq)\b/i
        }
      }, {
        pattern: /((?:^|[&()])[ \t]*)else\b/im,
        lookbehind: !0,
        inside: {
          keyword: /^else\b/i
        }
      }, {
        pattern: /((?:^|[&(])[ \t]*)set(?: \/[a-z](?:[ :](?:"[^"]*"|[^\s"/]\S*))?)* (?:[^^&)\r\n]|\^(?:\r\n|[\s\S]))*/im,
        lookbehind: !0,
        inside: {
          keyword: /^set\b/i,
          string: n,
          parameter: r,
          variable: [t, /\w+(?=(?:[*\/%+\-&^|]|<<|>>)?=)/],
          number: a,
          operator: /[*\/%+\-&^|]=?|<<=?|>>=?|[!~_=]/,
          punctuation: /[()',]/
        }
      }, {
        pattern: /((?:^|[&(])[ \t]*@?)\w+\b(?:"(?:[\\"]"|[^"])*"(?!")|[^"^&)\r\n]|\^(?:\r\n|[\s\S]))*/m,
        lookbehind: !0,
        inside: {
          keyword: /^\w+\b/,
          string: n,
          parameter: r,
          label: {
            pattern: /(^\s*):\S+/m,
            lookbehind: !0,
            alias: "property"
          },
          variable: t,
          number: a,
          operator: /\^/
        }
      }],
      operator: /[&@]/,
      punctuation: /[()']/
    };
  }(e);
}

batch.displayName = "batch", batch.aliases = [];
var bbcode_1 = bbcode;

function bbcode(e) {
  e.languages.bbcode = {
    tag: {
      pattern: /\[\/?[^\s=\]]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'"\]=]+))?(?:\s+[^\s=\]]+\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'"\]=]+))*\s*\]/,
      inside: {
        tag: {
          pattern: /^\[\/?[^\s=\]]+/,
          inside: {
            punctuation: /^\[\/?/
          }
        },
        "attr-value": {
          pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'"\]=]+)/,
          inside: {
            punctuation: [/^=/, {
              pattern: /^(\s*)["']|["']$/,
              lookbehind: !0
            }]
          }
        },
        punctuation: /\]/,
        "attr-name": /[^\s=\]]+/
      }
    }
  }, e.languages.shortcode = e.languages.bbcode;
}

bbcode.displayName = "bbcode", bbcode.aliases = ["shortcode"];
var bicep_1 = bicep;

function bicep(e) {
  e.languages.bicep = {
    comment: [{
      pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
      lookbehind: !0,
      greedy: !0
    }, {
      pattern: /(^|[^\\:])\/\/.*/,
      lookbehind: !0,
      greedy: !0
    }],
    property: [{
      pattern: /([\r\n][ \t]*)[a-z_]\w*(?=[ \t]*:)/i,
      lookbehind: !0
    }, {
      pattern: /([\r\n][ \t]*)'(?:\\.|\$(?!\{)|[^'\\\r\n$])*'(?=[ \t]*:)/,
      lookbehind: !0,
      greedy: !0
    }],
    string: [{
      pattern: /'''[^'][\s\S]*?'''/,
      greedy: !0
    }, {
      pattern: /(^|[^\\'])'(?:\\.|\$(?!\{)|[^'\\\r\n$])*'/,
      lookbehind: !0,
      greedy: !0
    }],
    "interpolated-string": {
      pattern: /(^|[^\\'])'(?:\\.|\$(?:(?!\{)|\{[^{}\r\n]*\})|[^'\\\r\n$])*'/,
      lookbehind: !0,
      greedy: !0,
      inside: {
        interpolation: {
          pattern: /\$\{[^{}\r\n]*\}/,
          inside: {
            expression: {
              pattern: /(^\$\{)[\s\S]+(?=\}$)/,
              lookbehind: !0
            },
            punctuation: /^\$\{|\}$/
          }
        },
        string: /[\s\S]+/
      }
    },
    datatype: {
      pattern: /(\b(?:output|param)\b[ \t]+\w+[ \t]+)\w+\b/,
      lookbehind: !0,
      alias: "class-name"
    },
    boolean: /\b(?:false|true)\b/,
    keyword: /\b(?:existing|for|if|in|module|null|output|param|resource|targetScope|var)\b/,
    decorator: /@\w+\b/,
    function: /\b[a-z_]\w*(?=[ \t]*\()/i,
    number: /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:E[+-]?\d+)?/i,
    operator: /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/,
    punctuation: /[{}[\];(),.:]/
  }, e.languages.bicep["interpolated-string"].inside.interpolation.inside.expression.inside = e.languages.bicep;
}

bicep.displayName = "bicep", bicep.aliases = [];
var birb_1 = birb;

function birb(e) {
  e.languages.birb = e.languages.extend("clike", {
    string: {
      pattern: /r?("|')(?:\\.|(?!\1)[^\\])*\1/,
      greedy: !0
    },
    "class-name": [/\b[A-Z](?:[\d_]*[a-zA-Z]\w*)?\b/, /\b(?:[A-Z]\w*|(?!(?:var|void)\b)[a-z]\w*)(?=\s+\w+\s*[;,=()])/],
    keyword: /\b(?:assert|break|case|class|const|default|else|enum|final|follows|for|grab|if|nest|new|next|noSeeb|return|static|switch|throw|var|void|while)\b/,
    operator: /\+\+|--|&&|\|\||<<=?|>>=?|~(?:\/=?)?|[+\-*\/%&^|=!<>]=?|\?|:/,
    variable: /\b[a-z_]\w*\b/
  }), e.languages.insertBefore("birb", "function", {
    metadata: {
      pattern: /<\w+>/,
      greedy: !0,
      alias: "symbol"
    }
  });
}

birb.displayName = "birb", birb.aliases = [];
var refractorC$4 = c_1,
    bison_1 = bison;

function bison(e) {
  e.register(refractorC$4), e.languages.bison = e.languages.extend("c", {}), e.languages.insertBefore("bison", "comment", {
    bison: {
      pattern: /^(?:[^%]|%(?!%))*%%[\s\S]*?%%/,
      inside: {
        c: {
          pattern: /%\{[\s\S]*?%\}|\{(?:\{[^}]*\}|[^{}])*\}/,
          inside: {
            delimiter: {
              pattern: /^%?\{|%?\}$/,
              alias: "punctuation"
            },
            "bison-variable": {
              pattern: /[$@](?:<[^\s>]+>)?[\w$]+/,
              alias: "variable",
              inside: {
                punctuation: /<|>/
              }
            },
            rest: e.languages.c
          }
        },
        comment: e.languages.c.comment,
        string: e.languages.c.string,
        property: /\S+(?=:)/,
        keyword: /%\w+/,
        number: {
          pattern: /(^|[^@])\b(?:0x[\da-f]+|\d+)/i,
          lookbehind: !0
        },
        punctuation: /%[%?]|[|:;\[\]<>]/
      }
    }
  });
}

bison.displayName = "bison", bison.aliases = [];
var bnf_1 = bnf;

function bnf(e) {
  e.languages.bnf = {
    string: {
      pattern: /"[^\r\n"]*"|'[^\r\n']*'/
    },
    definition: {
      pattern: /<[^<>\r\n\t]+>(?=\s*::=)/,
      alias: ["rule", "keyword"],
      inside: {
        punctuation: /^<|>$/
      }
    },
    rule: {
      pattern: /<[^<>\r\n\t]+>/,
      inside: {
        punctuation: /^<|>$/
      }
    },
    operator: /::=|[|()[\]{}*+?]|\.{3}/
  }, e.languages.rbnf = e.languages.bnf;
}

bnf.displayName = "bnf", bnf.aliases = ["rbnf"];
var brainfuck_1 = brainfuck;

function brainfuck(e) {
  e.languages.brainfuck = {
    pointer: {
      pattern: /<|>/,
      alias: "keyword"
    },
    increment: {
      pattern: /\+/,
      alias: "inserted"
    },
    decrement: {
      pattern: /-/,
      alias: "deleted"
    },
    branching: {
      pattern: /\[|\]/,
      alias: "important"
    },
    operator: /[.,]/,
    comment: /\S+/
  };
}

brainfuck.displayName = "brainfuck", brainfuck.aliases = [];
var brightscript_1 = brightscript;

function brightscript(e) {
  e.languages.brightscript = {
    comment: /(?:\brem|').*/i,
    "directive-statement": {
      pattern: /(^[\t ]*)#(?:const|else(?:[\t ]+if)?|end[\t ]+if|error|if).*/im,
      lookbehind: !0,
      alias: "property",
      inside: {
        "error-message": {
          pattern: /(^#error).+/,
          lookbehind: !0
        },
        directive: {
          pattern: /^#(?:const|else(?:[\t ]+if)?|end[\t ]+if|error|if)/,
          alias: "keyword"
        },
        expression: {
          pattern: /[\s\S]+/,
          inside: null
        }
      }
    },
    property: {
      pattern: /([\r\n{,][\t ]*)(?:(?!\d)\w+|"(?:[^"\r\n]|"")*"(?!"))(?=[ \t]*:)/,
      lookbehind: !0,
      greedy: !0
    },
    string: {
      pattern: /"(?:[^"\r\n]|"")*"(?!")/,
      greedy: !0
    },
    "class-name": {
      pattern: /(\bAs[\t ]+)\w+/i,
      lookbehind: !0
    },
    keyword: /\b(?:As|Dim|Each|Else|Elseif|End|Exit|For|Function|Goto|If|In|Print|Return|Step|Stop|Sub|Then|To|While)\b/i,
    boolean: /\b(?:false|true)\b/i,
    function: /\b(?!\d)\w+(?=[\t ]*\()/,
    number: /(?:\b\d+(?:\.\d+)?(?:[ed][+-]\d+)?|&h[a-f\d]+)\b[%&!#]?/i,
    operator: /--|\+\+|>>=?|<<=?|<>|[-+*/\\<>]=?|[:^=?]|\b(?:and|mod|not|or)\b/i,
    punctuation: /[.,;()[\]{}]/,
    constant: /\b(?:LINE_NUM)\b/i
  }, e.languages.brightscript["directive-statement"].inside.expression.inside = e.languages.brightscript;
}

brightscript.displayName = "brightscript", brightscript.aliases = [];
var bro_1 = bro;

function bro(e) {
  e.languages.bro = {
    comment: {
      pattern: /(^|[^\\$])#.*/,
      lookbehind: !0,
      inside: {
        italic: /\b(?:FIXME|TODO|XXX)\b/
      }
    },
    string: {
      pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
      greedy: !0
    },
    boolean: /\b[TF]\b/,
    function: {
      pattern: /(\b(?:event|function|hook)[ \t]+)\w+(?:::\w+)?/,
      lookbehind: !0
    },
    builtin: /(?:@(?:load(?:-(?:plugin|sigs))?|unload|prefixes|ifn?def|else|(?:end)?if|DIR|FILENAME))|(?:&?(?:add_func|create_expire|default|delete_func|encrypt|error_handler|expire_func|group|log|mergeable|optional|persistent|priority|raw_output|read_expire|redef|rotate_interval|rotate_size|synchronized|type_column|write_expire))/,
    constant: {
      pattern: /(\bconst[ \t]+)\w+/i,
      lookbehind: !0
    },
    keyword: /\b(?:add|addr|alarm|any|bool|break|const|continue|count|delete|double|else|enum|event|export|file|for|function|global|hook|if|in|int|interval|local|module|next|of|opaque|pattern|port|print|record|return|schedule|set|string|subnet|table|time|timeout|using|vector|when)\b/,
    operator: /--?|\+\+?|!=?=?|<=?|>=?|==?=?|&&|\|\|?|\?|\*|\/|~|\^|%/,
    number: /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
    punctuation: /[{}[\];(),.:]/
  };
}

bro.displayName = "bro", bro.aliases = [];
var bsl_1 = bsl;

function bsl(e) {
  e.languages.bsl = {
    comment: /\/\/.*/,
    string: [{
      pattern: /"(?:[^"]|"")*"(?!")/,
      greedy: !0
    }, {
      pattern: /'(?:[^'\r\n\\]|\\.)*'/
    }],
    keyword: [{
      pattern: /(^|[^\w\u0400-\u0484\u0487-\u052f\u1d2b\u1d78\u2de0-\u2dff\ua640-\ua69f\ufe2e\ufe2f])(?:пока|для|новый|прервать|попытка|исключение|вызватьисключение|иначе|конецпопытки|неопределено|функция|перем|возврат|конецфункции|если|иначеесли|процедура|конецпроцедуры|тогда|знач|экспорт|конецесли|из|каждого|истина|ложь|по|цикл|конеццикла|выполнить)(?![\w\u0400-\u0484\u0487-\u052f\u1d2b\u1d78\u2de0-\u2dff\ua640-\ua69f\ufe2e\ufe2f])/i,
      lookbehind: !0
    }, {
      pattern: /\b(?:break|do|each|else|elseif|enddo|endfunction|endif|endprocedure|endtry|except|execute|export|false|for|function|if|in|new|null|procedure|raise|return|then|to|true|try|undefined|val|var|while)\b/i
    }],
    number: {
      pattern: /(^(?=\d)|[^\w\u0400-\u0484\u0487-\u052f\u1d2b\u1d78\u2de0-\u2dff\ua640-\ua69f\ufe2e\ufe2f])(?:\d+(?:\.\d*)?|\.\d+)(?:E[+-]?\d+)?/i,
      lookbehind: !0
    },
    operator: [/[<>+\-*/]=?|[%=]/, {
      pattern: /(^|[^\w\u0400-\u0484\u0487-\u052f\u1d2b\u1d78\u2de0-\u2dff\ua640-\ua69f\ufe2e\ufe2f])(?:и|или|не)(?![\w\u0400-\u0484\u0487-\u052f\u1d2b\u1d78\u2de0-\u2dff\ua640-\ua69f\ufe2e\ufe2f])/i,
      lookbehind: !0
    }, {
      pattern: /\b(?:and|not|or)\b/i
    }],
    punctuation: /\(\.|\.\)|[()\[\]:;,.]/,
    directive: [{
      pattern: /^([ \t]*)&.*/m,
      lookbehind: !0,
      greedy: !0,
      alias: "important"
    }, {
      pattern: /^([ \t]*)#.*/gm,
      lookbehind: !0,
      greedy: !0,
      alias: "important"
    }]
  }, e.languages.oscript = e.languages.bsl;
}

bsl.displayName = "bsl", bsl.aliases = [];
var cfscript_1 = cfscript;

function cfscript(e) {
  e.languages.cfscript = e.languages.extend("clike", {
    comment: [{
      pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
      lookbehind: !0,
      inside: {
        annotation: {
          pattern: /(?:^|[^.])@[\w\.]+/,
          alias: "punctuation"
        }
      }
    }, {
      pattern: /(^|[^\\:])\/\/.*/,
      lookbehind: !0,
      greedy: !0
    }],
    keyword: /\b(?:abstract|break|catch|component|continue|default|do|else|extends|final|finally|for|function|if|in|include|package|private|property|public|remote|required|rethrow|return|static|switch|throw|try|var|while|xml)\b(?!\s*=)/,
    operator: [/\+\+|--|&&|\|\||::|=>|[!=]==|<=?|>=?|[-+*/%&|^!=<>]=?|\?(?:\.|:)?|[?:]/, /\b(?:and|contains|eq|equal|eqv|gt|gte|imp|is|lt|lte|mod|not|or|xor)\b/],
    scope: {
      pattern: /\b(?:application|arguments|cgi|client|cookie|local|session|super|this|variables)\b/,
      alias: "global"
    },
    type: {
      pattern: /\b(?:any|array|binary|boolean|date|guid|numeric|query|string|struct|uuid|void|xml)\b/,
      alias: "builtin"
    }
  }), e.languages.insertBefore("cfscript", "keyword", {
    "function-variable": {
      pattern: /[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
      alias: "function"
    }
  }), delete e.languages.cfscript["class-name"], e.languages.cfc = e.languages.cfscript;
}

cfscript.displayName = "cfscript", cfscript.aliases = [];
var refractorCpp = cpp_1,
    chaiscript_1 = chaiscript;

function chaiscript(e) {
  e.register(refractorCpp), e.languages.chaiscript = e.languages.extend("clike", {
    string: {
      pattern: /(^|[^\\])'(?:[^'\\]|\\[\s\S])*'/,
      lookbehind: !0,
      greedy: !0
    },
    "class-name": [{
      pattern: /(\bclass\s+)\w+/,
      lookbehind: !0
    }, {
      pattern: /(\b(?:attr|def)\s+)\w+(?=\s*::)/,
      lookbehind: !0
    }],
    keyword: /\b(?:attr|auto|break|case|catch|class|continue|def|default|else|finally|for|fun|global|if|return|switch|this|try|var|while)\b/,
    number: [e.languages.cpp.number, /\b(?:Infinity|NaN)\b/],
    operator: />>=?|<<=?|\|\||&&|:[:=]?|--|\+\+|[=!<>+\-*/%|&^]=?|[?~]|`[^`\r\n]{1,4}`/
  }), e.languages.insertBefore("chaiscript", "operator", {
    "parameter-type": {
      pattern: /([,(]\s*)\w+(?=\s+\w)/,
      lookbehind: !0,
      alias: "class-name"
    }
  }), e.languages.insertBefore("chaiscript", "string", {
    "string-interpolation": {
      pattern: /(^|[^\\])"(?:[^"$\\]|\\[\s\S]|\$(?!\{)|\$\{(?:[^{}]|\{(?:[^{}]|\{[^{}]*\})*\})*\})*"/,
      lookbehind: !0,
      greedy: !0,
      inside: {
        interpolation: {
          pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^{}]*\})*\})*\}/,
          lookbehind: !0,
          inside: {
            "interpolation-expression": {
              pattern: /(^\$\{)[\s\S]+(?=\}$)/,
              lookbehind: !0,
              inside: e.languages.chaiscript
            },
            "interpolation-punctuation": {
              pattern: /^\$\{|\}$/,
              alias: "punctuation"
            }
          }
        },
        string: /[\s\S]+/
      }
    }
  });
}

chaiscript.displayName = "chaiscript", chaiscript.aliases = [];
var cil_1 = cil;

function cil(e) {
  e.languages.cil = {
    comment: /\/\/.*/,
    string: {
      pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
      greedy: !0
    },
    directive: {
      pattern: /(^|\W)\.[a-z]+(?=\s)/,
      lookbehind: !0,
      alias: "class-name"
    },
    variable: /\[[\w\.]+\]/,
    keyword: /\b(?:abstract|ansi|assembly|auto|autochar|beforefieldinit|bool|bstr|byvalstr|catch|char|cil|class|currency|date|decimal|default|enum|error|explicit|extends|extern|famandassem|family|famorassem|final(?:ly)?|float32|float64|hidebysig|u?int(?:8|16|32|64)?|iant|idispatch|implements|import|initonly|instance|interface|iunknown|literal|lpstr|lpstruct|lptstr|lpwstr|managed|method|native(?:Type)?|nested|newslot|object(?:ref)?|pinvokeimpl|private|privatescope|public|reqsecobj|rtspecialname|runtime|sealed|sequential|serializable|specialname|static|string|struct|syschar|tbstr|unicode|unmanagedexp|unsigned|value(?:type)?|variant|virtual|void)\b/,
    function: /\b(?:(?:constrained|no|readonly|tail|unaligned|volatile)\.)?(?:conv\.(?:[iu][1248]?|ovf\.[iu][1248]?(?:\.un)?|r\.un|r4|r8)|ldc\.(?:i4(?:\.\d+|\.[mM]1|\.s)?|i8|r4|r8)|ldelem(?:\.[iu][1248]?|\.r[48]|\.ref|a)?|ldind\.(?:[iu][1248]?|r[48]|ref)|stelem\.?(?:i[1248]?|r[48]|ref)?|stind\.(?:i[1248]?|r[48]|ref)?|end(?:fault|filter|finally)|ldarg(?:\.[0-3s]|a(?:\.s)?)?|ldloc(?:\.\d+|\.s)?|sub(?:\.ovf(?:\.un)?)?|mul(?:\.ovf(?:\.un)?)?|add(?:\.ovf(?:\.un)?)?|stloc(?:\.[0-3s])?|refany(?:type|val)|blt(?:\.un)?(?:\.s)?|ble(?:\.un)?(?:\.s)?|bgt(?:\.un)?(?:\.s)?|bge(?:\.un)?(?:\.s)?|unbox(?:\.any)?|init(?:blk|obj)|call(?:i|virt)?|brfalse(?:\.s)?|bne\.un(?:\.s)?|ldloca(?:\.s)?|brzero(?:\.s)?|brtrue(?:\.s)?|brnull(?:\.s)?|brinst(?:\.s)?|starg(?:\.s)?|leave(?:\.s)?|shr(?:\.un)?|rem(?:\.un)?|div(?:\.un)?|clt(?:\.un)?|alignment|castclass|ldvirtftn|beq(?:\.s)?|ckfinite|ldsflda|ldtoken|localloc|mkrefany|rethrow|cgt\.un|arglist|switch|stsfld|sizeof|newobj|newarr|ldsfld|ldnull|ldflda|isinst|throw|stobj|stfld|ldstr|ldobj|ldlen|ldftn|ldfld|cpobj|cpblk|break|br\.s|xor|shl|ret|pop|not|nop|neg|jmp|dup|cgt|ceq|box|and|or|br)\b/,
    boolean: /\b(?:false|true)\b/,
    number: /\b-?(?:0x[0-9a-f]+|\d+)(?:\.[0-9a-f]+)?\b/i,
    punctuation: /[{}[\];(),:=]|IL_[0-9A-Za-z]+/
  };
}

cil.displayName = "cil", cil.aliases = [];
var clojure_1 = clojure;

function clojure(e) {
  e.languages.clojure = {
    comment: {
      pattern: /;.*/,
      greedy: !0
    },
    string: {
      pattern: /"(?:[^"\\]|\\.)*"/,
      greedy: !0
    },
    char: /\\\w+/,
    symbol: {
      pattern: /(^|[\s()\[\]{},])::?[\w*+!?'<>=/.-]+/,
      lookbehind: !0
    },
    keyword: {
      pattern: /(\()(?:-|->|->>|\.|\.\.|\*|\/|\+|<|<=|=|==|>|>=|accessor|agent|agent-errors|aget|alength|all-ns|alter|and|append-child|apply|array-map|aset|aset-boolean|aset-byte|aset-char|aset-double|aset-float|aset-int|aset-long|aset-short|assert|assoc|await|await-for|bean|binding|bit-and|bit-not|bit-or|bit-shift-left|bit-shift-right|bit-xor|boolean|branch\?|butlast|byte|cast|char|children|class|clear-agent-errors|comment|commute|comp|comparator|complement|concat|cond|conj|cons|constantly|construct-proxy|contains\?|count|create-ns|create-struct|cycle|dec|declare|def|def-|definline|definterface|defmacro|defmethod|defmulti|defn|defn-|defonce|defproject|defprotocol|defrecord|defstruct|deftype|deref|difference|disj|dissoc|distinct|do|doall|doc|dorun|doseq|dosync|dotimes|doto|double|down|drop|drop-while|edit|end\?|ensure|eval|every\?|false\?|ffirst|file-seq|filter|find|find-doc|find-ns|find-var|first|float|flush|fn|fnseq|for|frest|gensym|get|get-proxy-class|hash-map|hash-set|identical\?|identity|if|if-let|if-not|import|in-ns|inc|index|insert-child|insert-left|insert-right|inspect-table|inspect-tree|instance\?|int|interleave|intersection|into|into-array|iterate|join|key|keys|keyword|keyword\?|last|lazy-cat|lazy-cons|left|lefts|let|line-seq|list|list\*|load|load-file|locking|long|loop|macroexpand|macroexpand-1|make-array|make-node|map|map-invert|map\?|mapcat|max|max-key|memfn|merge|merge-with|meta|min|min-key|monitor-enter|name|namespace|neg\?|new|newline|next|nil\?|node|not|not-any\?|not-every\?|not=|ns|ns-imports|ns-interns|ns-map|ns-name|ns-publics|ns-refers|ns-resolve|ns-unmap|nth|nthrest|or|parse|partial|path|peek|pop|pos\?|pr|pr-str|print|print-str|println|println-str|prn|prn-str|project|proxy|proxy-mappings|quot|quote|rand|rand-int|range|re-find|re-groups|re-matcher|re-matches|re-pattern|re-seq|read|read-line|recur|reduce|ref|ref-set|refer|rem|remove|remove-method|remove-ns|rename|rename-keys|repeat|replace|replicate|resolve|rest|resultset-seq|reverse|rfirst|right|rights|root|rrest|rseq|second|select|select-keys|send|send-off|seq|seq-zip|seq\?|set|set!|short|slurp|some|sort|sort-by|sorted-map|sorted-map-by|sorted-set|special-symbol\?|split-at|split-with|str|string\?|struct|struct-map|subs|subvec|symbol|symbol\?|sync|take|take-nth|take-while|test|throw|time|to-array|to-array-2d|tree-seq|true\?|try|union|up|update-proxy|val|vals|var|var-get|var-set|var\?|vector|vector-zip|vector\?|when|when-first|when-let|when-not|with-local-vars|with-meta|with-open|with-out-str|xml-seq|xml-zip|zero\?|zipmap|zipper)(?=[\s)]|$)/,
      lookbehind: !0
    },
    boolean: /\b(?:false|nil|true)\b/,
    number: {
      pattern: /(^|[^\w$@])(?:\d+(?:[/.]\d+)?(?:e[+-]?\d+)?|0x[a-f0-9]+|[1-9]\d?r[a-z0-9]+)[lmn]?(?![\w$@])/i,
      lookbehind: !0
    },
    function: {
      pattern: /((?:^|[^'])\()[\w*+!?'<>=/.-]+(?=[\s)]|$)/,
      lookbehind: !0
    },
    operator: /[#@^`~]/,
    punctuation: /[{}\[\](),]/
  };
}

clojure.displayName = "clojure", clojure.aliases = [];
var cmake_1 = cmake;

function cmake(e) {
  e.languages.cmake = {
    comment: /#.*/,
    string: {
      pattern: /"(?:[^\\"]|\\.)*"/,
      greedy: !0,
      inside: {
        interpolation: {
          pattern: /\$\{(?:[^{}$]|\$\{[^{}$]*\})*\}/,
          inside: {
            punctuation: /\$\{|\}/,
            variable: /\w+/
          }
        }
      }
    },
    variable: /\b(?:CMAKE_\w+|\w+_(?:(?:BINARY|SOURCE)_DIR|DESCRIPTION|HOMEPAGE_URL|ROOT|VERSION(?:_MAJOR|_MINOR|_PATCH|_TWEAK)?)|(?:ANDROID|APPLE|BORLAND|BUILD_SHARED_LIBS|CACHE|CPACK_(?:ABSOLUTE_DESTINATION_FILES|COMPONENT_INCLUDE_TOPLEVEL_DIRECTORY|ERROR_ON_ABSOLUTE_INSTALL_DESTINATION|INCLUDE_TOPLEVEL_DIRECTORY|INSTALL_DEFAULT_DIRECTORY_PERMISSIONS|INSTALL_SCRIPT|PACKAGING_INSTALL_PREFIX|SET_DESTDIR|WARN_ON_ABSOLUTE_INSTALL_DESTINATION)|CTEST_(?:BINARY_DIRECTORY|BUILD_COMMAND|BUILD_NAME|BZR_COMMAND|BZR_UPDATE_OPTIONS|CHANGE_ID|CHECKOUT_COMMAND|CONFIGURATION_TYPE|CONFIGURE_COMMAND|COVERAGE_COMMAND|COVERAGE_EXTRA_FLAGS|CURL_OPTIONS|CUSTOM_(?:COVERAGE_EXCLUDE|ERROR_EXCEPTION|ERROR_MATCH|ERROR_POST_CONTEXT|ERROR_PRE_CONTEXT|MAXIMUM_FAILED_TEST_OUTPUT_SIZE|MAXIMUM_NUMBER_OF_(?:ERRORS|WARNINGS)|MAXIMUM_PASSED_TEST_OUTPUT_SIZE|MEMCHECK_IGNORE|POST_MEMCHECK|POST_TEST|PRE_MEMCHECK|PRE_TEST|TESTS_IGNORE|WARNING_EXCEPTION|WARNING_MATCH)|CVS_CHECKOUT|CVS_COMMAND|CVS_UPDATE_OPTIONS|DROP_LOCATION|DROP_METHOD|DROP_SITE|DROP_SITE_CDASH|DROP_SITE_PASSWORD|DROP_SITE_USER|EXTRA_COVERAGE_GLOB|GIT_COMMAND|GIT_INIT_SUBMODULES|GIT_UPDATE_CUSTOM|GIT_UPDATE_OPTIONS|HG_COMMAND|HG_UPDATE_OPTIONS|LABELS_FOR_SUBPROJECTS|MEMORYCHECK_(?:COMMAND|COMMAND_OPTIONS|SANITIZER_OPTIONS|SUPPRESSIONS_FILE|TYPE)|NIGHTLY_START_TIME|P4_CLIENT|P4_COMMAND|P4_OPTIONS|P4_UPDATE_OPTIONS|RUN_CURRENT_SCRIPT|SCP_COMMAND|SITE|SOURCE_DIRECTORY|SUBMIT_URL|SVN_COMMAND|SVN_OPTIONS|SVN_UPDATE_OPTIONS|TEST_LOAD|TEST_TIMEOUT|TRIGGER_SITE|UPDATE_COMMAND|UPDATE_OPTIONS|UPDATE_VERSION_ONLY|USE_LAUNCHERS)|CYGWIN|ENV|EXECUTABLE_OUTPUT_PATH|GHS-MULTI|IOS|LIBRARY_OUTPUT_PATH|MINGW|MSVC(?:10|11|12|14|60|70|71|80|90|_IDE|_TOOLSET_VERSION|_VERSION)?|MSYS|PROJECT_(?:BINARY_DIR|DESCRIPTION|HOMEPAGE_URL|NAME|SOURCE_DIR|VERSION|VERSION_(?:MAJOR|MINOR|PATCH|TWEAK))|UNIX|WIN32|WINCE|WINDOWS_PHONE|WINDOWS_STORE|XCODE|XCODE_VERSION))\b/,
    property: /\b(?:cxx_\w+|(?:ARCHIVE_OUTPUT_(?:DIRECTORY|NAME)|COMPILE_DEFINITIONS|COMPILE_PDB_NAME|COMPILE_PDB_OUTPUT_DIRECTORY|EXCLUDE_FROM_DEFAULT_BUILD|IMPORTED_(?:IMPLIB|LIBNAME|LINK_DEPENDENT_LIBRARIES|LINK_INTERFACE_LANGUAGES|LINK_INTERFACE_LIBRARIES|LINK_INTERFACE_MULTIPLICITY|LOCATION|NO_SONAME|OBJECTS|SONAME)|INTERPROCEDURAL_OPTIMIZATION|LIBRARY_OUTPUT_DIRECTORY|LIBRARY_OUTPUT_NAME|LINK_FLAGS|LINK_INTERFACE_LIBRARIES|LINK_INTERFACE_MULTIPLICITY|LOCATION|MAP_IMPORTED_CONFIG|OSX_ARCHITECTURES|OUTPUT_NAME|PDB_NAME|PDB_OUTPUT_DIRECTORY|RUNTIME_OUTPUT_DIRECTORY|RUNTIME_OUTPUT_NAME|STATIC_LIBRARY_FLAGS|VS_CSHARP|VS_DOTNET_REFERENCEPROP|VS_DOTNET_REFERENCE|VS_GLOBAL_SECTION_POST|VS_GLOBAL_SECTION_PRE|VS_GLOBAL|XCODE_ATTRIBUTE)_\w+|\w+_(?:CLANG_TIDY|COMPILER_LAUNCHER|CPPCHECK|CPPLINT|INCLUDE_WHAT_YOU_USE|OUTPUT_NAME|POSTFIX|VISIBILITY_PRESET)|ABSTRACT|ADDITIONAL_MAKE_CLEAN_FILES|ADVANCED|ALIASED_TARGET|ALLOW_DUPLICATE_CUSTOM_TARGETS|ANDROID_(?:ANT_ADDITIONAL_OPTIONS|API|API_MIN|ARCH|ASSETS_DIRECTORIES|GUI|JAR_DEPENDENCIES|NATIVE_LIB_DEPENDENCIES|NATIVE_LIB_DIRECTORIES|PROCESS_MAX|PROGUARD|PROGUARD_CONFIG_PATH|SECURE_PROPS_PATH|SKIP_ANT_STEP|STL_TYPE)|ARCHIVE_OUTPUT_DIRECTORY|ATTACHED_FILES|ATTACHED_FILES_ON_FAIL|AUTOGEN_(?:BUILD_DIR|ORIGIN_DEPENDS|PARALLEL|SOURCE_GROUP|TARGETS_FOLDER|TARGET_DEPENDS)|AUTOMOC|AUTOMOC_(?:COMPILER_PREDEFINES|DEPEND_FILTERS|EXECUTABLE|MACRO_NAMES|MOC_OPTIONS|SOURCE_GROUP|TARGETS_FOLDER)|AUTORCC|AUTORCC_EXECUTABLE|AUTORCC_OPTIONS|AUTORCC_SOURCE_GROUP|AUTOUIC|AUTOUIC_EXECUTABLE|AUTOUIC_OPTIONS|AUTOUIC_SEARCH_PATHS|BINARY_DIR|BUILDSYSTEM_TARGETS|BUILD_RPATH|BUILD_RPATH_USE_ORIGIN|BUILD_WITH_INSTALL_NAME_DIR|BUILD_WITH_INSTALL_RPATH|BUNDLE|BUNDLE_EXTENSION|CACHE_VARIABLES|CLEAN_NO_CUSTOM|COMMON_LANGUAGE_RUNTIME|COMPATIBLE_INTERFACE_(?:BOOL|NUMBER_MAX|NUMBER_MIN|STRING)|COMPILE_(?:DEFINITIONS|FEATURES|FLAGS|OPTIONS|PDB_NAME|PDB_OUTPUT_DIRECTORY)|COST|CPACK_DESKTOP_SHORTCUTS|CPACK_NEVER_OVERWRITE|CPACK_PERMANENT|CPACK_STARTUP_SHORTCUTS|CPACK_START_MENU_SHORTCUTS|CPACK_WIX_ACL|CROSSCOMPILING_EMULATOR|CUDA_EXTENSIONS|CUDA_PTX_COMPILATION|CUDA_RESOLVE_DEVICE_SYMBOLS|CUDA_SEPARABLE_COMPILATION|CUDA_STANDARD|CUDA_STANDARD_REQUIRED|CXX_EXTENSIONS|CXX_STANDARD|CXX_STANDARD_REQUIRED|C_EXTENSIONS|C_STANDARD|C_STANDARD_REQUIRED|DEBUG_CONFIGURATIONS|DEFINE_SYMBOL|DEFINITIONS|DEPENDS|DEPLOYMENT_ADDITIONAL_FILES|DEPLOYMENT_REMOTE_DIRECTORY|DISABLED|DISABLED_FEATURES|ECLIPSE_EXTRA_CPROJECT_CONTENTS|ECLIPSE_EXTRA_NATURES|ENABLED_FEATURES|ENABLED_LANGUAGES|ENABLE_EXPORTS|ENVIRONMENT|EXCLUDE_FROM_ALL|EXCLUDE_FROM_DEFAULT_BUILD|EXPORT_NAME|EXPORT_PROPERTIES|EXTERNAL_OBJECT|EchoString|FAIL_REGULAR_EXPRESSION|FIND_LIBRARY_USE_LIB32_PATHS|FIND_LIBRARY_USE_LIB64_PATHS|FIND_LIBRARY_USE_LIBX32_PATHS|FIND_LIBRARY_USE_OPENBSD_VERSIONING|FIXTURES_CLEANUP|FIXTURES_REQUIRED|FIXTURES_SETUP|FOLDER|FRAMEWORK|Fortran_FORMAT|Fortran_MODULE_DIRECTORY|GENERATED|GENERATOR_FILE_NAME|GENERATOR_IS_MULTI_CONFIG|GHS_INTEGRITY_APP|GHS_NO_SOURCE_GROUP_FILE|GLOBAL_DEPENDS_DEBUG_MODE|GLOBAL_DEPENDS_NO_CYCLES|GNUtoMS|HAS_CXX|HEADER_FILE_ONLY|HELPSTRING|IMPLICIT_DEPENDS_INCLUDE_TRANSFORM|IMPORTED|IMPORTED_(?:COMMON_LANGUAGE_RUNTIME|CONFIGURATIONS|GLOBAL|IMPLIB|LIBNAME|LINK_DEPENDENT_LIBRARIES|LINK_INTERFACE_(?:LANGUAGES|LIBRARIES|MULTIPLICITY)|LOCATION|NO_SONAME|OBJECTS|SONAME)|IMPORT_PREFIX|IMPORT_SUFFIX|INCLUDE_DIRECTORIES|INCLUDE_REGULAR_EXPRESSION|INSTALL_NAME_DIR|INSTALL_RPATH|INSTALL_RPATH_USE_LINK_PATH|INTERFACE_(?:AUTOUIC_OPTIONS|COMPILE_DEFINITIONS|COMPILE_FEATURES|COMPILE_OPTIONS|INCLUDE_DIRECTORIES|LINK_DEPENDS|LINK_DIRECTORIES|LINK_LIBRARIES|LINK_OPTIONS|POSITION_INDEPENDENT_CODE|SOURCES|SYSTEM_INCLUDE_DIRECTORIES)|INTERPROCEDURAL_OPTIMIZATION|IN_TRY_COMPILE|IOS_INSTALL_COMBINED|JOB_POOLS|JOB_POOL_COMPILE|JOB_POOL_LINK|KEEP_EXTENSION|LABELS|LANGUAGE|LIBRARY_OUTPUT_DIRECTORY|LINKER_LANGUAGE|LINK_(?:DEPENDS|DEPENDS_NO_SHARED|DIRECTORIES|FLAGS|INTERFACE_LIBRARIES|INTERFACE_MULTIPLICITY|LIBRARIES|OPTIONS|SEARCH_END_STATIC|SEARCH_START_STATIC|WHAT_YOU_USE)|LISTFILE_STACK|LOCATION|MACOSX_BUNDLE|MACOSX_BUNDLE_INFO_PLIST|MACOSX_FRAMEWORK_INFO_PLIST|MACOSX_PACKAGE_LOCATION|MACOSX_RPATH|MACROS|MANUALLY_ADDED_DEPENDENCIES|MEASUREMENT|MODIFIED|NAME|NO_SONAME|NO_SYSTEM_FROM_IMPORTED|OBJECT_DEPENDS|OBJECT_OUTPUTS|OSX_ARCHITECTURES|OUTPUT_NAME|PACKAGES_FOUND|PACKAGES_NOT_FOUND|PARENT_DIRECTORY|PASS_REGULAR_EXPRESSION|PDB_NAME|PDB_OUTPUT_DIRECTORY|POSITION_INDEPENDENT_CODE|POST_INSTALL_SCRIPT|PREDEFINED_TARGETS_FOLDER|PREFIX|PRE_INSTALL_SCRIPT|PRIVATE_HEADER|PROCESSORS|PROCESSOR_AFFINITY|PROJECT_LABEL|PUBLIC_HEADER|REPORT_UNDEFINED_PROPERTIES|REQUIRED_FILES|RESOURCE|RESOURCE_LOCK|RULE_LAUNCH_COMPILE|RULE_LAUNCH_CUSTOM|RULE_LAUNCH_LINK|RULE_MESSAGES|RUNTIME_OUTPUT_DIRECTORY|RUN_SERIAL|SKIP_AUTOGEN|SKIP_AUTOMOC|SKIP_AUTORCC|SKIP_AUTOUIC|SKIP_BUILD_RPATH|SKIP_RETURN_CODE|SOURCES|SOURCE_DIR|SOVERSION|STATIC_LIBRARY_FLAGS|STATIC_LIBRARY_OPTIONS|STRINGS|SUBDIRECTORIES|SUFFIX|SYMBOLIC|TARGET_ARCHIVES_MAY_BE_SHARED_LIBS|TARGET_MESSAGES|TARGET_SUPPORTS_SHARED_LIBS|TESTS|TEST_INCLUDE_FILE|TEST_INCLUDE_FILES|TIMEOUT|TIMEOUT_AFTER_MATCH|TYPE|USE_FOLDERS|VALUE|VARIABLES|VERSION|VISIBILITY_INLINES_HIDDEN|VS_(?:CONFIGURATION_TYPE|COPY_TO_OUT_DIR|DEBUGGER_(?:COMMAND|COMMAND_ARGUMENTS|ENVIRONMENT|WORKING_DIRECTORY)|DEPLOYMENT_CONTENT|DEPLOYMENT_LOCATION|DOTNET_REFERENCES|DOTNET_REFERENCES_COPY_LOCAL|GLOBAL_KEYWORD|GLOBAL_PROJECT_TYPES|GLOBAL_ROOTNAMESPACE|INCLUDE_IN_VSIX|IOT_STARTUP_TASK|KEYWORD|RESOURCE_GENERATOR|SCC_AUXPATH|SCC_LOCALPATH|SCC_PROJECTNAME|SCC_PROVIDER|SDK_REFERENCES|SHADER_(?:DISABLE_OPTIMIZATIONS|ENABLE_DEBUG|ENTRYPOINT|FLAGS|MODEL|OBJECT_FILE_NAME|OUTPUT_HEADER_FILE|TYPE|VARIABLE_NAME)|STARTUP_PROJECT|TOOL_OVERRIDE|USER_PROPS|WINRT_COMPONENT|WINRT_EXTENSIONS|WINRT_REFERENCES|XAML_TYPE)|WILL_FAIL|WIN32_EXECUTABLE|WINDOWS_EXPORT_ALL_SYMBOLS|WORKING_DIRECTORY|WRAP_EXCLUDE|XCODE_(?:EMIT_EFFECTIVE_PLATFORM_NAME|EXPLICIT_FILE_TYPE|FILE_ATTRIBUTES|LAST_KNOWN_FILE_TYPE|PRODUCT_TYPE|SCHEME_(?:ADDRESS_SANITIZER|ADDRESS_SANITIZER_USE_AFTER_RETURN|ARGUMENTS|DISABLE_MAIN_THREAD_CHECKER|DYNAMIC_LIBRARY_LOADS|DYNAMIC_LINKER_API_USAGE|ENVIRONMENT|EXECUTABLE|GUARD_MALLOC|MAIN_THREAD_CHECKER_STOP|MALLOC_GUARD_EDGES|MALLOC_SCRIBBLE|MALLOC_STACK|THREAD_SANITIZER(?:_STOP)?|UNDEFINED_BEHAVIOUR_SANITIZER(?:_STOP)?|ZOMBIE_OBJECTS))|XCTEST)\b/,
    keyword: /\b(?:add_compile_definitions|add_compile_options|add_custom_command|add_custom_target|add_definitions|add_dependencies|add_executable|add_library|add_link_options|add_subdirectory|add_test|aux_source_directory|break|build_command|build_name|cmake_host_system_information|cmake_minimum_required|cmake_parse_arguments|cmake_policy|configure_file|continue|create_test_sourcelist|ctest_build|ctest_configure|ctest_coverage|ctest_empty_binary_directory|ctest_memcheck|ctest_read_custom_files|ctest_run_script|ctest_sleep|ctest_start|ctest_submit|ctest_test|ctest_update|ctest_upload|define_property|else|elseif|enable_language|enable_testing|endforeach|endfunction|endif|endmacro|endwhile|exec_program|execute_process|export|export_library_dependencies|file|find_file|find_library|find_package|find_path|find_program|fltk_wrap_ui|foreach|function|get_cmake_property|get_directory_property|get_filename_component|get_property|get_source_file_property|get_target_property|get_test_property|if|include|include_directories|include_external_msproject|include_guard|include_regular_expression|install|install_files|install_programs|install_targets|link_directories|link_libraries|list|load_cache|load_command|macro|make_directory|mark_as_advanced|math|message|option|output_required_files|project|qt_wrap_cpp|qt_wrap_ui|remove|remove_definitions|return|separate_arguments|set|set_directory_properties|set_property|set_source_files_properties|set_target_properties|set_tests_properties|site_name|source_group|string|subdir_depends|subdirs|target_compile_definitions|target_compile_features|target_compile_options|target_include_directories|target_link_directories|target_link_libraries|target_link_options|target_sources|try_compile|try_run|unset|use_mangled_mesa|utility_source|variable_requires|variable_watch|while|write_file)(?=\s*\()\b/,
    boolean: /\b(?:FALSE|OFF|ON|TRUE)\b/,
    namespace: /\b(?:INTERFACE|PRIVATE|PROPERTIES|PUBLIC|SHARED|STATIC|TARGET_OBJECTS)\b/,
    operator: /\b(?:AND|DEFINED|EQUAL|GREATER|LESS|MATCHES|NOT|OR|STREQUAL|STRGREATER|STRLESS|VERSION_EQUAL|VERSION_GREATER|VERSION_LESS)\b/,
    inserted: {
      pattern: /\b\w+::\w+\b/,
      alias: "class-name"
    },
    number: /\b\d+(?:\.\d+)*\b/,
    function: /\b[a-z_]\w*(?=\s*\()\b/i,
    punctuation: /[()>}]|\$[<{]/
  };
}

cmake.displayName = "cmake", cmake.aliases = [];
var cobol_1 = cobol;

function cobol(e) {
  e.languages.cobol = {
    comment: {
      pattern: /\*>.*|(^[ \t]*)\*.*/m,
      lookbehind: !0,
      greedy: !0
    },
    string: {
      pattern: /[xzgn]?(?:"(?:[^\r\n"]|"")*"(?!")|'(?:[^\r\n']|'')*'(?!'))/i,
      greedy: !0
    },
    level: {
      pattern: /(^[ \t]*)\d+\b/m,
      lookbehind: !0,
      greedy: !0,
      alias: "number"
    },
    "class-name": {
      pattern: /(\bpic(?:ture)?\s+)(?:(?:[-\w$/,:*+<>]|\.(?!\s|$))(?:\(\d+\))?)+/i,
      lookbehind: !0,
      inside: {
        number: {
          pattern: /(\()\d+/,
          lookbehind: !0
        },
        punctuation: /[()]/
      }
    },
    keyword: {
      pattern: /(^|[^\w-])(?:ABORT|ACCEPT|ACCESS|ADD|ADDRESS|ADVANCING|AFTER|ALIGNED|ALL|ALPHABET|ALPHABETIC|ALPHABETIC-LOWER|ALPHABETIC-UPPER|ALPHANUMERIC|ALPHANUMERIC-EDITED|ALSO|ALTER|ALTERNATE|ANY|ARE|AREA|AREAS|AS|ASCENDING|ASCII|ASSIGN|ASSOCIATED-DATA|ASSOCIATED-DATA-LENGTH|AT|ATTRIBUTE|AUTHOR|AUTO|AUTO-SKIP|BACKGROUND-COLOR|BACKGROUND-COLOUR|BASIS|BEEP|BEFORE|BEGINNING|BELL|BINARY|BIT|BLANK|BLINK|BLOCK|BOTTOM|BOUNDS|BY|BYFUNCTION|BYTITLE|CALL|CANCEL|CAPABLE|CCSVERSION|CD|CF|CH|CHAINING|CHANGED|CHANNEL|CHARACTER|CHARACTERS|CLASS|CLASS-ID|CLOCK-UNITS|CLOSE|CLOSE-DISPOSITION|COBOL|CODE|CODE-SET|COL|COLLATING|COLUMN|COM-REG|COMMA|COMMITMENT|COMMON|COMMUNICATION|COMP|COMP-1|COMP-2|COMP-3|COMP-4|COMP-5|COMPUTATIONAL|COMPUTATIONAL-1|COMPUTATIONAL-2|COMPUTATIONAL-3|COMPUTATIONAL-4|COMPUTATIONAL-5|COMPUTE|CONFIGURATION|CONTAINS|CONTENT|CONTINUE|CONTROL|CONTROL-POINT|CONTROLS|CONVENTION|CONVERTING|COPY|CORR|CORRESPONDING|COUNT|CRUNCH|CURRENCY|CURSOR|DATA|DATA-BASE|DATE|DATE-COMPILED|DATE-WRITTEN|DAY|DAY-OF-WEEK|DBCS|DE|DEBUG-CONTENTS|DEBUG-ITEM|DEBUG-LINE|DEBUG-NAME|DEBUG-SUB-1|DEBUG-SUB-2|DEBUG-SUB-3|DEBUGGING|DECIMAL-POINT|DECLARATIVES|DEFAULT|DEFAULT-DISPLAY|DEFINITION|DELETE|DELIMITED|DELIMITER|DEPENDING|DESCENDING|DESTINATION|DETAIL|DFHRESP|DFHVALUE|DISABLE|DISK|DISPLAY|DISPLAY-1|DIVIDE|DIVISION|DONTCARE|DOUBLE|DOWN|DUPLICATES|DYNAMIC|EBCDIC|EGCS|EGI|ELSE|EMI|EMPTY-CHECK|ENABLE|END|END-ACCEPT|END-ADD|END-CALL|END-COMPUTE|END-DELETE|END-DIVIDE|END-EVALUATE|END-IF|END-MULTIPLY|END-OF-PAGE|END-PERFORM|END-READ|END-RECEIVE|END-RETURN|END-REWRITE|END-SEARCH|END-START|END-STRING|END-SUBTRACT|END-UNSTRING|END-WRITE|ENDING|ENTER|ENTRY|ENTRY-PROCEDURE|ENVIRONMENT|EOL|EOP|EOS|ERASE|ERROR|ESCAPE|ESI|EVALUATE|EVENT|EVERY|EXCEPTION|EXCLUSIVE|EXHIBIT|EXIT|EXPORT|EXTEND|EXTENDED|EXTERNAL|FD|FILE|FILE-CONTROL|FILLER|FINAL|FIRST|FOOTING|FOR|FOREGROUND-COLOR|FOREGROUND-COLOUR|FROM|FULL|FUNCTION|FUNCTION-POINTER|FUNCTIONNAME|GENERATE|GIVING|GLOBAL|GO|GOBACK|GRID|GROUP|HEADING|HIGH-VALUE|HIGH-VALUES|HIGHLIGHT|I-O|I-O-CONTROL|ID|IDENTIFICATION|IF|IMPLICIT|IMPORT|IN|INDEX|INDEXED|INDICATE|INITIAL|INITIALIZE|INITIATE|INPUT|INPUT-OUTPUT|INSPECT|INSTALLATION|INTEGER|INTO|INVALID|INVOKE|IS|JUST|JUSTIFIED|KANJI|KEPT|KEY|KEYBOARD|LABEL|LANGUAGE|LAST|LB|LD|LEADING|LEFT|LEFTLINE|LENGTH|LENGTH-CHECK|LIBACCESS|LIBPARAMETER|LIBRARY|LIMIT|LIMITS|LINAGE|LINAGE-COUNTER|LINE|LINE-COUNTER|LINES|LINKAGE|LIST|LOCAL|LOCAL-STORAGE|LOCK|LONG-DATE|LONG-TIME|LOW-VALUE|LOW-VALUES|LOWER|LOWLIGHT|MEMORY|MERGE|MESSAGE|MMDDYYYY|MODE|MODULES|MORE-LABELS|MOVE|MULTIPLE|MULTIPLY|NAMED|NATIONAL|NATIONAL-EDITED|NATIVE|NEGATIVE|NETWORK|NEXT|NO|NO-ECHO|NULL|NULLS|NUMBER|NUMERIC|NUMERIC-DATE|NUMERIC-EDITED|NUMERIC-TIME|OBJECT-COMPUTER|OCCURS|ODT|OF|OFF|OMITTED|ON|OPEN|OPTIONAL|ORDER|ORDERLY|ORGANIZATION|OTHER|OUTPUT|OVERFLOW|OVERLINE|OWN|PACKED-DECIMAL|PADDING|PAGE|PAGE-COUNTER|PASSWORD|PERFORM|PF|PH|PIC|PICTURE|PLUS|POINTER|PORT|POSITION|POSITIVE|PRINTER|PRINTING|PRIVATE|PROCEDURE|PROCEDURE-POINTER|PROCEDURES|PROCEED|PROCESS|PROGRAM|PROGRAM-ID|PROGRAM-LIBRARY|PROMPT|PURGE|QUEUE|QUOTE|QUOTES|RANDOM|RD|READ|READER|REAL|RECEIVE|RECEIVED|RECORD|RECORDING|RECORDS|RECURSIVE|REDEFINES|REEL|REF|REFERENCE|REFERENCES|RELATIVE|RELEASE|REMAINDER|REMARKS|REMOTE|REMOVAL|REMOVE|RENAMES|REPLACE|REPLACING|REPORT|REPORTING|REPORTS|REQUIRED|RERUN|RESERVE|RESET|RETURN|RETURN-CODE|RETURNING|REVERSE-VIDEO|REVERSED|REWIND|REWRITE|RF|RH|RIGHT|ROUNDED|RUN|SAME|SAVE|SCREEN|SD|SEARCH|SECTION|SECURE|SECURITY|SEGMENT|SEGMENT-LIMIT|SELECT|SEND|SENTENCE|SEPARATE|SEQUENCE|SEQUENTIAL|SET|SHARED|SHAREDBYALL|SHAREDBYRUNUNIT|SHARING|SHIFT-IN|SHIFT-OUT|SHORT-DATE|SIGN|SIZE|SORT|SORT-CONTROL|SORT-CORE-SIZE|SORT-FILE-SIZE|SORT-MERGE|SORT-MESSAGE|SORT-MODE-SIZE|SORT-RETURN|SOURCE|SOURCE-COMPUTER|SPACE|SPACES|SPECIAL-NAMES|STANDARD|STANDARD-1|STANDARD-2|START|STATUS|STOP|STRING|SUB-QUEUE-1|SUB-QUEUE-2|SUB-QUEUE-3|SUBTRACT|SUM|SUPPRESS|SYMBOL|SYMBOLIC|SYNC|SYNCHRONIZED|TABLE|TALLY|TALLYING|TAPE|TASK|TERMINAL|TERMINATE|TEST|TEXT|THEN|THREAD|THREAD-LOCAL|THROUGH|THRU|TIME|TIMER|TIMES|TITLE|TO|TODAYS-DATE|TODAYS-NAME|TOP|TRAILING|TRUNCATED|TYPE|TYPEDEF|UNDERLINE|UNIT|UNSTRING|UNTIL|UP|UPON|USAGE|USE|USING|VALUE|VALUES|VARYING|VIRTUAL|WAIT|WHEN|WHEN-COMPILED|WITH|WORDS|WORKING-STORAGE|WRITE|YEAR|YYYYDDD|YYYYMMDD|ZERO-FILL|ZEROES|ZEROS)(?![\w-])/i,
      lookbehind: !0
    },
    boolean: {
      pattern: /(^|[^\w-])(?:false|true)(?![\w-])/i,
      lookbehind: !0
    },
    number: {
      pattern: /(^|[^\w-])(?:[+-]?(?:(?:\d+(?:[.,]\d+)?|[.,]\d+)(?:e[+-]?\d+)?|zero))(?![\w-])/i,
      lookbehind: !0
    },
    operator: [/<>|[<>]=?|[=+*/&]/, {
      pattern: /(^|[^\w-])(?:-|and|equal|greater|less|not|or|than)(?![\w-])/i,
      lookbehind: !0
    }],
    punctuation: /[.:,()]/
  };
}

cobol.displayName = "cobol", cobol.aliases = [];
var coffeescript_1 = coffeescript;

function coffeescript(e) {
  !function (e) {
    var t = /#(?!\{).+/,
        r = {
      pattern: /#\{[^}]+\}/,
      alias: "variable"
    };
    e.languages.coffeescript = e.languages.extend("javascript", {
      comment: t,
      string: [{
        pattern: /'(?:\\[\s\S]|[^\\'])*'/,
        greedy: !0
      }, {
        pattern: /"(?:\\[\s\S]|[^\\"])*"/,
        greedy: !0,
        inside: {
          interpolation: r
        }
      }],
      keyword: /\b(?:and|break|by|catch|class|continue|debugger|delete|do|each|else|extend|extends|false|finally|for|if|in|instanceof|is|isnt|let|loop|namespace|new|no|not|null|of|off|on|or|own|return|super|switch|then|this|throw|true|try|typeof|undefined|unless|until|when|while|window|with|yes|yield)\b/,
      "class-member": {
        pattern: /@(?!\d)\w+/,
        alias: "variable"
      }
    }), e.languages.insertBefore("coffeescript", "comment", {
      "multiline-comment": {
        pattern: /###[\s\S]+?###/,
        alias: "comment"
      },
      "block-regex": {
        pattern: /\/{3}[\s\S]*?\/{3}/,
        alias: "regex",
        inside: {
          comment: t,
          interpolation: r
        }
      }
    }), e.languages.insertBefore("coffeescript", "string", {
      "inline-javascript": {
        pattern: /`(?:\\[\s\S]|[^\\`])*`/,
        inside: {
          delimiter: {
            pattern: /^`|`$/,
            alias: "punctuation"
          },
          script: {
            pattern: /[\s\S]+/,
            alias: "language-javascript",
            inside: e.languages.javascript
          }
        }
      },
      "multiline-string": [{
        pattern: /'''[\s\S]*?'''/,
        greedy: !0,
        alias: "string"
      }, {
        pattern: /"""[\s\S]*?"""/,
        greedy: !0,
        alias: "string",
        inside: {
          interpolation: r
        }
      }]
    }), e.languages.insertBefore("coffeescript", "keyword", {
      property: /(?!\d)\w+(?=\s*:(?!:))/
    }), delete e.languages.coffeescript["template-string"], e.languages.coffee = e.languages.coffeescript;
  }(e);
}

coffeescript.displayName = "coffeescript", coffeescript.aliases = ["coffee"];
var concurnas_1 = concurnas;

function concurnas(e) {
  e.languages.concurnas = {
    comment: {
      pattern: /(^|[^\\])(?:\/\*[\s\S]*?(?:\*\/|$)|\/\/.*)/,
      lookbehind: !0,
      greedy: !0
    },
    langext: {
      pattern: /\b\w+\s*\|\|[\s\S]+?\|\|/,
      greedy: !0,
      inside: {
        "class-name": /^\w+/,
        string: {
          pattern: /(^\s*\|\|)[\s\S]+(?=\|\|$)/,
          lookbehind: !0
        },
        punctuation: /\|\|/
      }
    },
    function: {
      pattern: /((?:^|\s)def[ \t]+)[a-zA-Z_]\w*(?=\s*\()/,
      lookbehind: !0
    },
    keyword: /\b(?:abstract|actor|also|annotation|assert|async|await|bool|boolean|break|byte|case|catch|changed|char|class|closed|constant|continue|def|default|del|double|elif|else|enum|every|extends|false|finally|float|for|from|global|gpudef|gpukernel|if|import|in|init|inject|int|lambda|local|long|loop|match|new|nodefault|null|of|onchange|open|out|override|package|parfor|parforsync|post|pre|private|protected|provide|provider|public|return|shared|short|single|size_t|sizeof|super|sync|this|throw|trait|trans|transient|true|try|typedef|unchecked|using|val|var|void|while|with)\b/,
    boolean: /\b(?:false|true)\b/,
    number: /\b0b[01][01_]*L?\b|\b0x(?:[\da-f_]*\.)?[\da-f_p+-]+\b|(?:\b\d[\d_]*(?:\.[\d_]*)?|\B\.\d[\d_]*)(?:e[+-]?\d[\d_]*)?[dfls]?/i,
    punctuation: /[{}[\];(),.:]/,
    operator: /<==|>==|=>|->|<-|<>|&==|&<>|\?:?|\.\?|\+\+|--|[-+*/=<>]=?|[!^~]|\b(?:and|as|band|bor|bxor|comp|is|isnot|mod|or)\b=?/,
    annotation: {
      pattern: /@(?:\w+:)?(?:\w+|\[[^\]]+\])?/,
      alias: "builtin"
    }
  }, e.languages.insertBefore("concurnas", "langext", {
    "regex-literal": {
      pattern: /\br("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
      greedy: !0,
      inside: {
        interpolation: {
          pattern: /((?:^|[^\\])(?:\\{2})*)\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
          lookbehind: !0,
          inside: e.languages.concurnas
        },
        regex: /[\s\S]+/
      }
    },
    "string-literal": {
      pattern: /(?:\B|\bs)("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
      greedy: !0,
      inside: {
        interpolation: {
          pattern: /((?:^|[^\\])(?:\\{2})*)\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
          lookbehind: !0,
          inside: e.languages.concurnas
        },
        string: /[\s\S]+/
      }
    }
  }), e.languages.conc = e.languages.concurnas;
}

concurnas.displayName = "concurnas", concurnas.aliases = ["conc"];
var coq_1 = coq;

function coq(e) {
  !function (e) {
    for (var t = /\(\*(?:[^(*]|\((?!\*)|\*(?!\))|<self>)*\*\)/.source, r = 0; r < 2; r++) {
      t = t.replace(/<self>/g, function () {
        return t;
      });
    }

    t = t.replace(/<self>/g, "[]"), e.languages.coq = {
      comment: RegExp(t),
      string: {
        pattern: /"(?:[^"]|"")*"(?!")/,
        greedy: !0
      },
      attribute: [{
        pattern: RegExp(/#\[(?:[^\[\]("]|"(?:[^"]|"")*"(?!")|\((?!\*)|<comment>)*\]/.source.replace(/<comment>/g, function () {
          return t;
        })),
        greedy: !0,
        alias: "attr-name",
        inside: {
          comment: RegExp(t),
          string: {
            pattern: /"(?:[^"]|"")*"(?!")/,
            greedy: !0
          },
          operator: /=/,
          punctuation: /^#\[|\]$|[,()]/
        }
      }, {
        pattern: /\b(?:Cumulative|Global|Local|Monomorphic|NonCumulative|Polymorphic|Private|Program)\b/,
        alias: "attr-name"
      }],
      keyword: /\b(?:Abort|About|Add|Admit|Admitted|All|Arguments|As|Assumptions|Axiom|Axioms|Back|BackTo|Backtrace|BinOp|BinOpSpec|BinRel|Bind|Blacklist|Canonical|Case|Cd|Check|Class|Classes|Close|CoFixpoint|CoInductive|Coercion|Coercions|Collection|Combined|Compute|Conjecture|Conjectures|Constant|Constants|Constraint|Constructors|Context|Corollary|Create|CstOp|Custom|Cut|Debug|Declare|Defined|Definition|Delimit|Dependencies|Dependent|Derive|Diffs|Drop|Elimination|End|Entry|Equality|Eval|Example|Existential|Existentials|Existing|Export|Extern|Extraction|Fact|Fail|Field|File|Firstorder|Fixpoint|Flags|Focus|From|Funclass|Function|Functional|GC|Generalizable|Goal|Grab|Grammar|Graph|Guarded|Haskell|Heap|Hide|Hint|HintDb|Hints|Hypotheses|Hypothesis|IF|Identity|Immediate|Implicit|Implicits|Import|Include|Induction|Inductive|Infix|Info|Initial|InjTyp|Inline|Inspect|Instance|Instances|Intro|Intros|Inversion|Inversion_clear|JSON|Language|Left|Lemma|Let|Lia|Libraries|Library|Load|LoadPath|Locate|Ltac|Ltac2|ML|Match|Method|Minimality|Module|Modules|Morphism|Next|NoInline|Notation|Number|OCaml|Obligation|Obligations|Opaque|Open|Optimize|Parameter|Parameters|Parametric|Path|Paths|Prenex|Preterm|Primitive|Print|Profile|Projections|Proof|Prop|PropBinOp|PropOp|PropUOp|Property|Proposition|Pwd|Qed|Quit|Rec|Record|Recursive|Redirect|Reduction|Register|Relation|Remark|Remove|Require|Reserved|Reset|Resolve|Restart|Rewrite|Right|Ring|Rings|SProp|Saturate|Save|Scheme|Scope|Scopes|Search|SearchHead|SearchPattern|SearchRewrite|Section|Separate|Set|Setoid|Show|Signatures|Solve|Solver|Sort|Sortclass|Sorted|Spec|Step|Strategies|Strategy|String|Structure|SubClass|Subgraph|SuchThat|Tactic|Term|TestCompile|Theorem|Time|Timeout|To|Transparent|Type|Typeclasses|Types|Typing|UnOp|UnOpSpec|Undelimit|Undo|Unfocus|Unfocused|Unfold|Universe|Universes|Unshelve|Variable|Variables|Variant|Verbose|View|Visibility|Zify|_|apply|as|at|by|cofix|else|end|exists|exists2|fix|for|forall|fun|if|in|let|match|measure|move|removed|return|struct|then|using|wf|where|with)\b/,
      number: /\b(?:0x[a-f0-9][a-f0-9_]*(?:\.[a-f0-9_]+)?(?:p[+-]?\d[\d_]*)?|\d[\d_]*(?:\.[\d_]+)?(?:e[+-]?\d[\d_]*)?)\b/i,
      punct: {
        pattern: /@\{|\{\||\[=|:>/,
        alias: "punctuation"
      },
      operator: /\/\\|\\\/|\.{2,3}|:{1,2}=|\*\*|[-=]>|<(?:->?|[+:=>]|<:)|>(?:=|->)|\|[-|]?|[-!%&*+/<=>?@^~']/,
      punctuation: /\.\(|`\(|@\{|`\{|\{\||\[=|:>|[:.,;(){}\[\]]/
    };
  }(e);
}

coq.displayName = "coq", coq.aliases = [];
var ruby_1 = ruby;

function ruby(e) {
  !function (e) {
    e.languages.ruby = e.languages.extend("clike", {
      comment: {
        pattern: /#.*|^=begin\s[\s\S]*?^=end/m,
        greedy: !0
      },
      "class-name": {
        pattern: /(\b(?:class|module)\s+|\bcatch\s+\()[\w.\\]+|\b[A-Z_]\w*(?=\s*\.\s*new\b)/,
        lookbehind: !0,
        inside: {
          punctuation: /[.\\]/
        }
      },
      keyword: /\b(?:BEGIN|END|alias|and|begin|break|case|class|def|define_method|defined|do|each|else|elsif|end|ensure|extend|for|if|in|include|module|new|next|nil|not|or|prepend|private|protected|public|raise|redo|require|rescue|retry|return|self|super|then|throw|undef|unless|until|when|while|yield)\b/,
      operator: /\.{2,3}|&\.|===|<?=>|[!=]?~|(?:&&|\|\||<<|>>|\*\*|[+\-*/%<>!^&|=])=?|[?:]/,
      punctuation: /[(){}[\].,;]/
    }), e.languages.insertBefore("ruby", "operator", {
      "double-colon": {
        pattern: /::/,
        alias: "punctuation"
      }
    });
    var t = {
      pattern: /((?:^|[^\\])(?:\\{2})*)#\{(?:[^{}]|\{[^{}]*\})*\}/,
      lookbehind: !0,
      inside: {
        content: {
          pattern: /^(#\{)[\s\S]+(?=\}$)/,
          lookbehind: !0,
          inside: e.languages.ruby
        },
        delimiter: {
          pattern: /^#\{|\}$/,
          alias: "punctuation"
        }
      }
    };
    delete e.languages.ruby.function;
    var r = "(?:" + [/([^a-zA-Z0-9\s{(\[<=])(?:(?!\1)[^\\]|\\[\s\S])*\1/.source, /\((?:[^()\\]|\\[\s\S]|\((?:[^()\\]|\\[\s\S])*\))*\)/.source, /\{(?:[^{}\\]|\\[\s\S]|\{(?:[^{}\\]|\\[\s\S])*\})*\}/.source, /\[(?:[^\[\]\\]|\\[\s\S]|\[(?:[^\[\]\\]|\\[\s\S])*\])*\]/.source, /<(?:[^<>\\]|\\[\s\S]|<(?:[^<>\\]|\\[\s\S])*>)*>/.source].join("|") + ")",
        n = /(?:"(?:\\.|[^"\\\r\n])*"|(?:\b[a-zA-Z_]\w*|[^\s\0-\x7F]+)[?!]?|\$.)/.source;
    e.languages.insertBefore("ruby", "keyword", {
      "regex-literal": [{
        pattern: RegExp(/%r/.source + r + /[egimnosux]{0,6}/.source),
        greedy: !0,
        inside: {
          interpolation: t,
          regex: /[\s\S]+/
        }
      }, {
        pattern: /(^|[^/])\/(?!\/)(?:\[[^\r\n\]]+\]|\\.|[^[/\\\r\n])+\/[egimnosux]{0,6}(?=\s*(?:$|[\r\n,.;})#]))/,
        lookbehind: !0,
        greedy: !0,
        inside: {
          interpolation: t,
          regex: /[\s\S]+/
        }
      }],
      variable: /[@$]+[a-zA-Z_]\w*(?:[?!]|\b)/,
      symbol: [{
        pattern: RegExp(/(^|[^:]):/.source + n),
        lookbehind: !0,
        greedy: !0
      }, {
        pattern: RegExp(/([\r\n{(,][ \t]*)/.source + n + /(?=:(?!:))/.source),
        lookbehind: !0,
        greedy: !0
      }],
      "method-definition": {
        pattern: /(\bdef\s+)\w+(?:\s*\.\s*\w+)?/,
        lookbehind: !0,
        inside: {
          function: /\b\w+$/,
          keyword: /^self\b/,
          "class-name": /^\w+/,
          punctuation: /\./
        }
      }
    }), e.languages.insertBefore("ruby", "string", {
      "string-literal": [{
        pattern: RegExp(/%[qQiIwWs]?/.source + r),
        greedy: !0,
        inside: {
          interpolation: t,
          string: /[\s\S]+/
        }
      }, {
        pattern: /("|')(?:#\{[^}]+\}|#(?!\{)|\\(?:\r\n|[\s\S])|(?!\1)[^\\#\r\n])*\1/,
        greedy: !0,
        inside: {
          interpolation: t,
          string: /[\s\S]+/
        }
      }, {
        pattern: /<<[-~]?([a-z_]\w*)[\r\n](?:.*[\r\n])*?[\t ]*\1/i,
        alias: "heredoc-string",
        greedy: !0,
        inside: {
          delimiter: {
            pattern: /^<<[-~]?[a-z_]\w*|\b[a-z_]\w*$/i,
            inside: {
              symbol: /\b\w+/,
              punctuation: /^<<[-~]?/
            }
          },
          interpolation: t,
          string: /[\s\S]+/
        }
      }, {
        pattern: /<<[-~]?'([a-z_]\w*)'[\r\n](?:.*[\r\n])*?[\t ]*\1/i,
        alias: "heredoc-string",
        greedy: !0,
        inside: {
          delimiter: {
            pattern: /^<<[-~]?'[a-z_]\w*'|\b[a-z_]\w*$/i,
            inside: {
              symbol: /\b\w+/,
              punctuation: /^<<[-~]?'|'$/
            }
          },
          string: /[\s\S]+/
        }
      }],
      "command-literal": [{
        pattern: RegExp(/%x/.source + r),
        greedy: !0,
        inside: {
          interpolation: t,
          command: {
            pattern: /[\s\S]+/,
            alias: "string"
          }
        }
      }, {
        pattern: /`(?:#\{[^}]+\}|#(?!\{)|\\(?:\r\n|[\s\S])|[^\\`#\r\n])*`/,
        greedy: !0,
        inside: {
          interpolation: t,
          command: {
            pattern: /[\s\S]+/,
            alias: "string"
          }
        }
      }]
    }), delete e.languages.ruby.string, e.languages.insertBefore("ruby", "number", {
      builtin: /\b(?:Array|Bignum|Binding|Class|Continuation|Dir|Exception|FalseClass|File|Fixnum|Float|Hash|IO|Integer|MatchData|Method|Module|NilClass|Numeric|Object|Proc|Range|Regexp|Stat|String|Struct|Symbol|TMS|Thread|ThreadGroup|Time|TrueClass)\b/,
      constant: /\b[A-Z][A-Z0-9_]*(?:[?!]|\b)/
    }), e.languages.rb = e.languages.ruby;
  }(e);
}

ruby.displayName = "ruby", ruby.aliases = ["rb"];
var refractorRuby$2 = ruby_1,
    crystal_1 = crystal;

function crystal(e) {
  e.register(refractorRuby$2), function (e) {
    e.languages.crystal = e.languages.extend("ruby", {
      keyword: [/\b(?:__DIR__|__END_LINE__|__FILE__|__LINE__|abstract|alias|annotation|as|asm|begin|break|case|class|def|do|else|elsif|end|ensure|enum|extend|for|fun|if|ifdef|include|instance_sizeof|lib|macro|module|next|of|out|pointerof|private|protected|ptr|require|rescue|return|select|self|sizeof|struct|super|then|type|typeof|undef|uninitialized|union|unless|until|when|while|with|yield)\b/, {
        pattern: /(\.\s*)(?:is_a|responds_to)\?/,
        lookbehind: !0
      }],
      number: /\b(?:0b[01_]*[01]|0o[0-7_]*[0-7]|0x[\da-fA-F_]*[\da-fA-F]|(?:\d(?:[\d_]*\d)?)(?:\.[\d_]*\d)?(?:[eE][+-]?[\d_]*\d)?)(?:_(?:[uif](?:8|16|32|64))?)?\b/,
      operator: [/->/, e.languages.ruby.operator],
      punctuation: /[(){}[\].,;\\]/
    }), e.languages.insertBefore("crystal", "string-literal", {
      attribute: {
        pattern: /@\[.*?\]/,
        inside: {
          delimiter: {
            pattern: /^@\[|\]$/,
            alias: "punctuation"
          },
          attribute: {
            pattern: /^(\s*)\w+/,
            lookbehind: !0,
            alias: "class-name"
          },
          args: {
            pattern: /\S(?:[\s\S]*\S)?/,
            inside: e.languages.crystal
          }
        }
      },
      expansion: {
        pattern: /\{(?:\{.*?\}|%.*?%)\}/,
        inside: {
          content: {
            pattern: /^(\{.)[\s\S]+(?=.\}$)/,
            lookbehind: !0,
            inside: e.languages.crystal
          },
          delimiter: {
            pattern: /^\{[\{%]|[\}%]\}$/,
            alias: "operator"
          }
        }
      },
      char: {
        pattern: /'(?:[^\\\r\n]{1,2}|\\(?:.|u(?:[A-Fa-f0-9]{1,4}|\{[A-Fa-f0-9]{1,6}\})))'/,
        greedy: !0
      }
    });
  }(e);
}

crystal.displayName = "crystal", crystal.aliases = [];
var refractorCsharp$1 = csharp_1,
    cshtml_1 = cshtml;

function cshtml(e) {
  e.register(refractorCsharp$1), function (e) {
    var t = /\/(?![/*])|\/\/.*[\r\n]|\/\*[^*]*(?:\*(?!\/)[^*]*)*\*\//.source,
        r = /@(?!")|"(?:[^\r\n\\"]|\\.)*"|@"(?:[^\\"]|""|\\[\s\S])*"(?!")/.source + "|" + /'(?:(?:[^\r\n'\\]|\\.|\\[Uux][\da-fA-F]{1,8})'|(?=[^\\](?!')))/.source;

    function n(e, n) {
      for (var a = 0; a < n; a++) {
        e = e.replace(/<self>/g, function () {
          return "(?:" + e + ")";
        });
      }

      return e.replace(/<self>/g, "[^\\s\\S]").replace(/<str>/g, "(?:" + r + ")").replace(/<comment>/g, "(?:" + t + ")");
    }

    var a = n(/\((?:[^()'"@/]|<str>|<comment>|<self>)*\)/.source, 2),
        o = n(/\[(?:[^\[\]'"@/]|<str>|<comment>|<self>)*\]/.source, 2),
        i = n(/\{(?:[^{}'"@/]|<str>|<comment>|<self>)*\}/.source, 2),
        s = n(/<(?:[^<>'"@/]|<str>|<comment>|<self>)*>/.source, 2),
        l = /(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?/.source,
        c = /(?!\d)[^\s>\/=$<%]+/.source + l + /\s*\/?>/.source,
        u = /\B@?/.source + "(?:" + /<([a-zA-Z][\w:]*)/.source + l + /\s*>/.source + "(?:" + /[^<]/.source + "|" + /<\/?(?!\1\b)/.source + c + "|" + n(/<\1/.source + l + /\s*>/.source + "(?:" + /[^<]/.source + "|" + /<\/?(?!\1\b)/.source + c + "|<self>)*" + /<\/\1\s*>/.source, 2) + ")*" + /<\/\1\s*>/.source + "|" + /</.source + c + ")";
    e.languages.cshtml = e.languages.extend("markup", {});
    var d = {
      pattern: /\S[\s\S]*/,
      alias: "language-csharp",
      inside: e.languages.insertBefore("csharp", "string", {
        html: {
          pattern: RegExp(u),
          greedy: !0,
          inside: e.languages.cshtml
        }
      }, {
        csharp: e.languages.extend("csharp", {})
      })
    };
    e.languages.insertBefore("cshtml", "prolog", {
      "razor-comment": {
        pattern: /@\*[\s\S]*?\*@/,
        greedy: !0,
        alias: "comment"
      },
      block: {
        pattern: RegExp(/(^|[^@])@/.source + "(?:" + [i, /(?:code|functions)\s*/.source + i, /(?:for|foreach|lock|switch|using|while)\s*/.source + a + /\s*/.source + i, /do\s*/.source + i + /\s*while\s*/.source + a + /(?:\s*;)?/.source, /try\s*/.source + i + /\s*catch\s*/.source + a + /\s*/.source + i + /\s*finally\s*/.source + i, /if\s*/.source + a + /\s*/.source + i + "(?:" + /\s*else/.source + "(?:" + /\s+if\s*/.source + a + ")?" + /\s*/.source + i + ")*"].join("|") + ")"),
        lookbehind: !0,
        greedy: !0,
        inside: {
          keyword: /^@\w*/,
          csharp: d
        }
      },
      directive: {
        pattern: /^([ \t]*)@(?:addTagHelper|attribute|implements|inherits|inject|layout|model|namespace|page|preservewhitespace|removeTagHelper|section|tagHelperPrefix|using)(?=\s).*/m,
        lookbehind: !0,
        greedy: !0,
        inside: {
          keyword: /^@\w+/,
          csharp: d
        }
      },
      value: {
        pattern: RegExp(/(^|[^@])@/.source + /(?:await\b\s*)?/.source + "(?:" + /\w+\b/.source + "|" + a + ")(?:" + /[?!]?\.\w+\b/.source + "|" + a + "|" + o + "|" + s + a + ")*"),
        lookbehind: !0,
        greedy: !0,
        alias: "variable",
        inside: {
          keyword: /^@/,
          csharp: d
        }
      },
      "delegate-operator": {
        pattern: /(^|[^@])@(?=<)/,
        lookbehind: !0,
        alias: "operator"
      }
    }), e.languages.razor = e.languages.cshtml;
  }(e);
}

cshtml.displayName = "cshtml", cshtml.aliases = ["razor"];
var csp_1 = csp;

function csp(e) {
  !function (e) {
    function t(e) {
      return RegExp(/([ \t])/.source + "(?:" + e + ")" + /(?=[\s;]|$)/.source, "i");
    }

    e.languages.csp = {
      directive: {
        pattern: /(^|[\s;])(?:base-uri|block-all-mixed-content|(?:child|connect|default|font|frame|img|manifest|media|object|prefetch|script|style|worker)-src|disown-opener|form-action|frame-(?:ancestors|options)|input-protection(?:-(?:clip|selectors))?|navigate-to|plugin-types|policy-uri|referrer|reflected-xss|report-(?:to|uri)|require-sri-for|sandbox|(?:script|style)-src-(?:attr|elem)|upgrade-insecure-requests)(?=[\s;]|$)/i,
        lookbehind: !0,
        alias: "property"
      },
      scheme: {
        pattern: t(/[a-z][a-z0-9.+-]*:/.source),
        lookbehind: !0
      },
      none: {
        pattern: t(/'none'/.source),
        lookbehind: !0,
        alias: "keyword"
      },
      nonce: {
        pattern: t(/'nonce-[-+/\w=]+'/.source),
        lookbehind: !0,
        alias: "number"
      },
      hash: {
        pattern: t(/'sha(?:256|384|512)-[-+/\w=]+'/.source),
        lookbehind: !0,
        alias: "number"
      },
      host: {
        pattern: t(/[a-z][a-z0-9.+-]*:\/\/[^\s;,']*/.source + "|" + /\*[^\s;,']*/.source + "|" + /[a-z0-9-]+(?:\.[a-z0-9-]+)+(?::[\d*]+)?(?:\/[^\s;,']*)?/.source),
        lookbehind: !0,
        alias: "url",
        inside: {
          important: /\*/
        }
      },
      keyword: [{
        pattern: t(/'unsafe-[a-z-]+'/.source),
        lookbehind: !0,
        alias: "unsafe"
      }, {
        pattern: t(/'[a-z-]+'/.source),
        lookbehind: !0,
        alias: "safe"
      }],
      punctuation: /;/
    };
  }(e);
}

csp.displayName = "csp", csp.aliases = [];
var cssExtras_1 = cssExtras;

function cssExtras(e) {
  !function (e) {
    var t,
        r = /("|')(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/;
    e.languages.css.selector = {
      pattern: e.languages.css.selector.pattern,
      lookbehind: !0,
      inside: t = {
        "pseudo-element": /:(?:after|before|first-letter|first-line|selection)|::[-\w]+/,
        "pseudo-class": /:[-\w]+/,
        class: /\.[-\w]+/,
        id: /#[-\w]+/,
        attribute: {
          pattern: RegExp("\\[(?:[^[\\]\"']|" + r.source + ")*\\]"),
          greedy: !0,
          inside: {
            punctuation: /^\[|\]$/,
            "case-sensitivity": {
              pattern: /(\s)[si]$/i,
              lookbehind: !0,
              alias: "keyword"
            },
            namespace: {
              pattern: /^(\s*)(?:(?!\s)[-*\w\xA0-\uFFFF])*\|(?!=)/,
              lookbehind: !0,
              inside: {
                punctuation: /\|$/
              }
            },
            "attr-name": {
              pattern: /^(\s*)(?:(?!\s)[-\w\xA0-\uFFFF])+/,
              lookbehind: !0
            },
            "attr-value": [r, {
              pattern: /(=\s*)(?:(?!\s)[-\w\xA0-\uFFFF])+(?=\s*$)/,
              lookbehind: !0
            }],
            operator: /[|~*^$]?=/
          }
        },
        "n-th": [{
          pattern: /(\(\s*)[+-]?\d*[\dn](?:\s*[+-]\s*\d+)?(?=\s*\))/,
          lookbehind: !0,
          inside: {
            number: /[\dn]+/,
            operator: /[+-]/
          }
        }, {
          pattern: /(\(\s*)(?:even|odd)(?=\s*\))/i,
          lookbehind: !0
        }],
        combinator: />|\+|~|\|\|/,
        punctuation: /[(),]/
      }
    }, e.languages.css.atrule.inside["selector-function-argument"].inside = t, e.languages.insertBefore("css", "property", {
      variable: {
        pattern: /(^|[^-\w\xA0-\uFFFF])--(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*/i,
        lookbehind: !0
      }
    });
    var n = {
      pattern: /(\b\d+)(?:%|[a-z]+(?![\w-]))/,
      lookbehind: !0
    },
        a = {
      pattern: /(^|[^\w.-])-?(?:\d+(?:\.\d+)?|\.\d+)/,
      lookbehind: !0
    };
    e.languages.insertBefore("css", "function", {
      operator: {
        pattern: /(\s)[+\-*\/](?=\s)/,
        lookbehind: !0
      },
      hexcode: {
        pattern: /\B#[\da-f]{3,8}\b/i,
        alias: "color"
      },
      color: [{
        pattern: /(^|[^\w-])(?:AliceBlue|AntiqueWhite|Aqua|Aquamarine|Azure|Beige|Bisque|Black|BlanchedAlmond|Blue|BlueViolet|Brown|BurlyWood|CadetBlue|Chartreuse|Chocolate|Coral|CornflowerBlue|Cornsilk|Crimson|Cyan|DarkBlue|DarkCyan|DarkGoldenRod|DarkGr[ae]y|DarkGreen|DarkKhaki|DarkMagenta|DarkOliveGreen|DarkOrange|DarkOrchid|DarkRed|DarkSalmon|DarkSeaGreen|DarkSlateBlue|DarkSlateGr[ae]y|DarkTurquoise|DarkViolet|DeepPink|DeepSkyBlue|DimGr[ae]y|DodgerBlue|FireBrick|FloralWhite|ForestGreen|Fuchsia|Gainsboro|GhostWhite|Gold|GoldenRod|Gr[ae]y|Green|GreenYellow|HoneyDew|HotPink|IndianRed|Indigo|Ivory|Khaki|Lavender|LavenderBlush|LawnGreen|LemonChiffon|LightBlue|LightCoral|LightCyan|LightGoldenRodYellow|LightGr[ae]y|LightGreen|LightPink|LightSalmon|LightSeaGreen|LightSkyBlue|LightSlateGr[ae]y|LightSteelBlue|LightYellow|Lime|LimeGreen|Linen|Magenta|Maroon|MediumAquaMarine|MediumBlue|MediumOrchid|MediumPurple|MediumSeaGreen|MediumSlateBlue|MediumSpringGreen|MediumTurquoise|MediumVioletRed|MidnightBlue|MintCream|MistyRose|Moccasin|NavajoWhite|Navy|OldLace|Olive|OliveDrab|Orange|OrangeRed|Orchid|PaleGoldenRod|PaleGreen|PaleTurquoise|PaleVioletRed|PapayaWhip|PeachPuff|Peru|Pink|Plum|PowderBlue|Purple|Red|RosyBrown|RoyalBlue|SaddleBrown|Salmon|SandyBrown|SeaGreen|SeaShell|Sienna|Silver|SkyBlue|SlateBlue|SlateGr[ae]y|Snow|SpringGreen|SteelBlue|Tan|Teal|Thistle|Tomato|Transparent|Turquoise|Violet|Wheat|White|WhiteSmoke|Yellow|YellowGreen)(?![\w-])/i,
        lookbehind: !0
      }, {
        pattern: /\b(?:hsl|rgb)\(\s*\d{1,3}\s*,\s*\d{1,3}%?\s*,\s*\d{1,3}%?\s*\)\B|\b(?:hsl|rgb)a\(\s*\d{1,3}\s*,\s*\d{1,3}%?\s*,\s*\d{1,3}%?\s*,\s*(?:0|0?\.\d+|1)\s*\)\B/i,
        inside: {
          unit: n,
          number: a,
          function: /[\w-]+(?=\()/,
          punctuation: /[(),]/
        }
      }],
      entity: /\\[\da-f]{1,8}/i,
      unit: n,
      number: a
    });
  }(e);
}

cssExtras.displayName = "cssExtras", cssExtras.aliases = [];
var csv_1 = csv;

function csv(e) {
  e.languages.csv = {
    value: /[^\r\n,"]+|"(?:[^"]|"")*"(?!")/,
    punctuation: /,/
  };
}

csv.displayName = "csv", csv.aliases = [];
var cypher_1 = cypher;

function cypher(e) {
  e.languages.cypher = {
    comment: /\/\/.*/,
    string: {
      pattern: /"(?:[^"\\\r\n]|\\.)*"|'(?:[^'\\\r\n]|\\.)*'/,
      greedy: !0
    },
    "class-name": {
      pattern: /(:\s*)(?:\w+|`(?:[^`\\\r\n])*`)(?=\s*[{):])/,
      lookbehind: !0,
      greedy: !0
    },
    relationship: {
      pattern: /(-\[\s*(?:\w+\s*|`(?:[^`\\\r\n])*`\s*)?:\s*|\|\s*:\s*)(?:\w+|`(?:[^`\\\r\n])*`)/,
      lookbehind: !0,
      greedy: !0,
      alias: "property"
    },
    identifier: {
      pattern: /`(?:[^`\\\r\n])*`/,
      greedy: !0
    },
    variable: /\$\w+/,
    keyword: /\b(?:ADD|ALL|AND|AS|ASC|ASCENDING|ASSERT|BY|CALL|CASE|COMMIT|CONSTRAINT|CONTAINS|CREATE|CSV|DELETE|DESC|DESCENDING|DETACH|DISTINCT|DO|DROP|ELSE|END|ENDS|EXISTS|FOR|FOREACH|IN|INDEX|IS|JOIN|KEY|LIMIT|LOAD|MANDATORY|MATCH|MERGE|NODE|NOT|OF|ON|OPTIONAL|OR|ORDER(?=\s+BY)|PERIODIC|REMOVE|REQUIRE|RETURN|SCALAR|SCAN|SET|SKIP|START|STARTS|THEN|UNION|UNIQUE|UNWIND|USING|WHEN|WHERE|WITH|XOR|YIELD)\b/i,
    function: /\b\w+\b(?=\s*\()/,
    boolean: /\b(?:false|null|true)\b/i,
    number: /\b(?:0x[\da-fA-F]+|\d+(?:\.\d+)?(?:[eE][+-]?\d+)?)\b/,
    operator: /:|<--?|--?>?|<>|=~?|[<>]=?|[+*/%^|]|\.\.\.?/,
    punctuation: /[()[\]{},;.]/
  };
}

cypher.displayName = "cypher", cypher.aliases = [];
var d_1 = d$1;

function d$1(e) {
  e.languages.d = e.languages.extend("clike", {
    comment: [{
      pattern: /^\s*#!.+/,
      greedy: !0
    }, {
      pattern: RegExp(/(^|[^\\])/.source + "(?:" + [/\/\+(?:\/\+(?:[^+]|\+(?!\/))*\+\/|(?!\/\+)[\s\S])*?\+\//.source, /\/\/.*/.source, /\/\*[\s\S]*?\*\//.source].join("|") + ")"),
      lookbehind: !0,
      greedy: !0
    }],
    string: [{
      pattern: RegExp([/\b[rx]"(?:\\[\s\S]|[^\\"])*"[cwd]?/.source, /\bq"(?:\[[\s\S]*?\]|\([\s\S]*?\)|<[\s\S]*?>|\{[\s\S]*?\})"/.source, /\bq"((?!\d)\w+)$[\s\S]*?^\1"/.source, /\bq"(.)[\s\S]*?\2"/.source, /(["`])(?:\\[\s\S]|(?!\3)[^\\])*\3[cwd]?/.source].join("|"), "m"),
      greedy: !0
    }, {
      pattern: /\bq\{(?:\{[^{}]*\}|[^{}])*\}/,
      greedy: !0,
      alias: "token-string"
    }],
    keyword: /\$|\b(?:__(?:(?:DATE|EOF|FILE|FUNCTION|LINE|MODULE|PRETTY_FUNCTION|TIMESTAMP|TIME|VENDOR|VERSION)__|gshared|parameters|traits|vector)|abstract|alias|align|asm|assert|auto|body|bool|break|byte|case|cast|catch|cdouble|cent|cfloat|char|class|const|continue|creal|dchar|debug|default|delegate|delete|deprecated|do|double|dstring|else|enum|export|extern|false|final|finally|float|for|foreach|foreach_reverse|function|goto|idouble|if|ifloat|immutable|import|inout|int|interface|invariant|ireal|lazy|long|macro|mixin|module|new|nothrow|null|out|override|package|pragma|private|protected|ptrdiff_t|public|pure|real|ref|return|scope|shared|short|size_t|static|string|struct|super|switch|synchronized|template|this|throw|true|try|typedef|typeid|typeof|ubyte|ucent|uint|ulong|union|unittest|ushort|version|void|volatile|wchar|while|with|wstring)\b/,
    number: [/\b0x\.?[a-f\d_]+(?:(?!\.\.)\.[a-f\d_]*)?(?:p[+-]?[a-f\d_]+)?[ulfi]{0,4}/i, {
      pattern: /((?:\.\.)?)(?:\b0b\.?|\b|\.)\d[\d_]*(?:(?!\.\.)\.[\d_]*)?(?:e[+-]?\d[\d_]*)?[ulfi]{0,4}/i,
      lookbehind: !0
    }],
    operator: /\|[|=]?|&[&=]?|\+[+=]?|-[-=]?|\.?\.\.|=[>=]?|!(?:i[ns]\b|<>?=?|>=?|=)?|\bi[ns]\b|(?:<[<>]?|>>?>?|\^\^|[*\/%^~])=?/
  }), e.languages.insertBefore("d", "string", {
    char: /'(?:\\(?:\W|\w+)|[^\\])'/
  }), e.languages.insertBefore("d", "keyword", {
    property: /\B@\w*/
  }), e.languages.insertBefore("d", "function", {
    register: {
      pattern: /\b(?:[ABCD][LHX]|E?(?:BP|DI|SI|SP)|[BS]PL|[ECSDGF]S|CR[0234]|[DS]IL|DR[012367]|E[ABCD]X|X?MM[0-7]|R(?:1[0-5]|[89])[BWD]?|R[ABCD]X|R[BS]P|R[DS]I|TR[3-7]|XMM(?:1[0-5]|[89])|YMM(?:1[0-5]|\d))\b|\bST(?:\([0-7]\)|\b)/,
      alias: "variable"
    }
  });
}

d$1.displayName = "d", d$1.aliases = [];
var dart_1 = dart;

function dart(e) {
  !function (e) {
    var t = [/\b(?:async|sync|yield)\*/, /\b(?:abstract|assert|async|await|break|case|catch|class|const|continue|covariant|default|deferred|do|dynamic|else|enum|export|extends|extension|external|factory|final|finally|for|get|hide|if|implements|import|in|interface|library|mixin|new|null|on|operator|part|rethrow|return|set|show|static|super|switch|sync|this|throw|try|typedef|var|void|while|with|yield)\b/],
        r = /(^|[^\w.])(?:[a-z]\w*\s*\.\s*)*(?:[A-Z]\w*\s*\.\s*)*/.source,
        n = {
      pattern: RegExp(r + /[A-Z](?:[\d_A-Z]*[a-z]\w*)?\b/.source),
      lookbehind: !0,
      inside: {
        namespace: {
          pattern: /^[a-z]\w*(?:\s*\.\s*[a-z]\w*)*(?:\s*\.)?/,
          inside: {
            punctuation: /\./
          }
        }
      }
    };
    e.languages.dart = e.languages.extend("clike", {
      "class-name": [n, {
        pattern: RegExp(r + /[A-Z]\w*(?=\s+\w+\s*[;,=()])/.source),
        lookbehind: !0,
        inside: n.inside
      }],
      keyword: t,
      operator: /\bis!|\b(?:as|is)\b|\+\+|--|&&|\|\||<<=?|>>=?|~(?:\/=?)?|[+\-*\/%&^|=!<>]=?|\?/
    }), e.languages.insertBefore("dart", "string", {
      "string-literal": {
        pattern: /r?(?:("""|''')[\s\S]*?\1|(["'])(?:\\.|(?!\2)[^\\\r\n])*\2(?!\2))/,
        greedy: !0,
        inside: {
          interpolation: {
            pattern: /((?:^|[^\\])(?:\\{2})*)\$(?:\w+|\{(?:[^{}]|\{[^{}]*\})*\})/,
            lookbehind: !0,
            inside: {
              punctuation: /^\$\{?|\}$/,
              expression: {
                pattern: /[\s\S]+/,
                inside: e.languages.dart
              }
            }
          },
          string: /[\s\S]+/
        }
      },
      string: void 0
    }), e.languages.insertBefore("dart", "class-name", {
      metadata: {
        pattern: /@\w+/,
        alias: "function"
      }
    }), e.languages.insertBefore("dart", "class-name", {
      generics: {
        pattern: /<(?:[\w\s,.&?]|<(?:[\w\s,.&?]|<(?:[\w\s,.&?]|<[\w\s,.&?]*>)*>)*>)*>/,
        inside: {
          "class-name": n,
          keyword: t,
          punctuation: /[<>(),.:]/,
          operator: /[?&|]/
        }
      }
    });
  }(e);
}

dart.displayName = "dart", dart.aliases = [];
var dataweave_1 = dataweave;

function dataweave(e) {
  !function (e) {
    e.languages.dataweave = {
      url: /\b[A-Za-z]+:\/\/[\w/:.?=&-]+|\burn:[\w:.?=&-]+/,
      property: {
        pattern: /(?:\b\w+#)?(?:"(?:\\.|[^\\"\r\n])*"|\b\w+)(?=\s*[:@])/,
        greedy: !0
      },
      string: {
        pattern: /(["'`])(?:\\[\s\S]|(?!\1)[^\\])*\1/,
        greedy: !0
      },
      "mime-type": /\b(?:application|audio|image|multipart|text|video)\/[\w+-]+/,
      date: {
        pattern: /\|[\w:+-]+\|/,
        greedy: !0
      },
      comment: [{
        pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
        lookbehind: !0,
        greedy: !0
      }, {
        pattern: /(^|[^\\:])\/\/.*/,
        lookbehind: !0,
        greedy: !0
      }],
      regex: {
        pattern: /\/(?:[^\\\/\r\n]|\\[^\r\n])+\//,
        greedy: !0
      },
      keyword: /\b(?:and|as|at|case|do|else|fun|if|input|is|match|not|ns|null|or|output|type|unless|update|using|var)\b/,
      function: /\b[A-Z_]\w*(?=\s*\()/i,
      number: /-?\b\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i,
      punctuation: /[{}[\];(),.:@]/,
      operator: /<<|>>|->|[<>~=]=?|!=|--?-?|\+\+?|!|\?/,
      boolean: /\b(?:false|true)\b/
    };
  }(e);
}

dataweave.displayName = "dataweave", dataweave.aliases = [];
var dax_1 = dax;

function dax(e) {
  e.languages.dax = {
    comment: {
      pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|(?:--|\/\/).*)/,
      lookbehind: !0
    },
    "data-field": {
      pattern: /'(?:[^']|'')*'(?!')(?:\[[ \w\xA0-\uFFFF]+\])?|\w+\[[ \w\xA0-\uFFFF]+\]/,
      alias: "symbol"
    },
    measure: {
      pattern: /\[[ \w\xA0-\uFFFF]+\]/,
      alias: "constant"
    },
    string: {
      pattern: /"(?:[^"]|"")*"(?!")/,
      greedy: !0
    },
    function: /\b(?:ABS|ACOS|ACOSH|ACOT|ACOTH|ADDCOLUMNS|ADDMISSINGITEMS|ALL|ALLCROSSFILTERED|ALLEXCEPT|ALLNOBLANKROW|ALLSELECTED|AND|APPROXIMATEDISTINCTCOUNT|ASIN|ASINH|ATAN|ATANH|AVERAGE|AVERAGEA|AVERAGEX|BETA\.DIST|BETA\.INV|BLANK|CALCULATE|CALCULATETABLE|CALENDAR|CALENDARAUTO|CEILING|CHISQ\.DIST|CHISQ\.DIST\.RT|CHISQ\.INV|CHISQ\.INV\.RT|CLOSINGBALANCEMONTH|CLOSINGBALANCEQUARTER|CLOSINGBALANCEYEAR|COALESCE|COMBIN|COMBINA|COMBINEVALUES|CONCATENATE|CONCATENATEX|CONFIDENCE\.NORM|CONFIDENCE\.T|CONTAINS|CONTAINSROW|CONTAINSSTRING|CONTAINSSTRINGEXACT|CONVERT|COS|COSH|COT|COTH|COUNT|COUNTA|COUNTAX|COUNTBLANK|COUNTROWS|COUNTX|CROSSFILTER|CROSSJOIN|CURRENCY|CURRENTGROUP|CUSTOMDATA|DATATABLE|DATE|DATEADD|DATEDIFF|DATESBETWEEN|DATESINPERIOD|DATESMTD|DATESQTD|DATESYTD|DATEVALUE|DAY|DEGREES|DETAILROWS|DISTINCT|DISTINCTCOUNT|DISTINCTCOUNTNOBLANK|DIVIDE|EARLIER|EARLIEST|EDATE|ENDOFMONTH|ENDOFQUARTER|ENDOFYEAR|EOMONTH|ERROR|EVEN|EXACT|EXCEPT|EXP|EXPON\.DIST|FACT|FALSE|FILTER|FILTERS|FIND|FIRSTDATE|FIRSTNONBLANK|FIRSTNONBLANKVALUE|FIXED|FLOOR|FORMAT|GCD|GENERATE|GENERATEALL|GENERATESERIES|GEOMEAN|GEOMEANX|GROUPBY|HASONEFILTER|HASONEVALUE|HOUR|IF|IF\.EAGER|IFERROR|IGNORE|INT|INTERSECT|ISBLANK|ISCROSSFILTERED|ISEMPTY|ISERROR|ISEVEN|ISFILTERED|ISINSCOPE|ISLOGICAL|ISNONTEXT|ISNUMBER|ISO\.CEILING|ISODD|ISONORAFTER|ISSELECTEDMEASURE|ISSUBTOTAL|ISTEXT|KEEPFILTERS|KEYWORDMATCH|LASTDATE|LASTNONBLANK|LASTNONBLANKVALUE|LCM|LEFT|LEN|LN|LOG|LOG10|LOOKUPVALUE|LOWER|MAX|MAXA|MAXX|MEDIAN|MEDIANX|MID|MIN|MINA|MINUTE|MINX|MOD|MONTH|MROUND|NATURALINNERJOIN|NATURALLEFTOUTERJOIN|NEXTDAY|NEXTMONTH|NEXTQUARTER|NEXTYEAR|NONVISUAL|NORM\.DIST|NORM\.INV|NORM\.S\.DIST|NORM\.S\.INV|NOT|NOW|ODD|OPENINGBALANCEMONTH|OPENINGBALANCEQUARTER|OPENINGBALANCEYEAR|OR|PARALLELPERIOD|PATH|PATHCONTAINS|PATHITEM|PATHITEMREVERSE|PATHLENGTH|PERCENTILE\.EXC|PERCENTILE\.INC|PERCENTILEX\.EXC|PERCENTILEX\.INC|PERMUT|PI|POISSON\.DIST|POWER|PREVIOUSDAY|PREVIOUSMONTH|PREVIOUSQUARTER|PREVIOUSYEAR|PRODUCT|PRODUCTX|QUARTER|QUOTIENT|RADIANS|RAND|RANDBETWEEN|RANK\.EQ|RANKX|RELATED|RELATEDTABLE|REMOVEFILTERS|REPLACE|REPT|RIGHT|ROLLUP|ROLLUPADDISSUBTOTAL|ROLLUPGROUP|ROLLUPISSUBTOTAL|ROUND|ROUNDDOWN|ROUNDUP|ROW|SAMEPERIODLASTYEAR|SAMPLE|SEARCH|SECOND|SELECTCOLUMNS|SELECTEDMEASURE|SELECTEDMEASUREFORMATSTRING|SELECTEDMEASURENAME|SELECTEDVALUE|SIGN|SIN|SINH|SQRT|SQRTPI|STARTOFMONTH|STARTOFQUARTER|STARTOFYEAR|STDEV\.P|STDEV\.S|STDEVX\.P|STDEVX\.S|SUBSTITUTE|SUBSTITUTEWITHINDEX|SUM|SUMMARIZE|SUMMARIZECOLUMNS|SUMX|SWITCH|T\.DIST|T\.DIST\.2T|T\.DIST\.RT|T\.INV|T\.INV\.2T|TAN|TANH|TIME|TIMEVALUE|TODAY|TOPN|TOPNPERLEVEL|TOPNSKIP|TOTALMTD|TOTALQTD|TOTALYTD|TREATAS|TRIM|TRUE|TRUNC|UNICHAR|UNICODE|UNION|UPPER|USERELATIONSHIP|USERNAME|USEROBJECTID|USERPRINCIPALNAME|UTCNOW|UTCTODAY|VALUE|VALUES|VAR\.P|VAR\.S|VARX\.P|VARX\.S|WEEKDAY|WEEKNUM|XIRR|XNPV|YEAR|YEARFRAC)(?=\s*\()/i,
    keyword: /\b(?:DEFINE|EVALUATE|MEASURE|ORDER\s+BY|RETURN|VAR|START\s+AT|ASC|DESC)\b/i,
    boolean: {
      pattern: /\b(?:FALSE|NULL|TRUE)\b/i,
      alias: "constant"
    },
    number: /\b\d+(?:\.\d*)?|\B\.\d+\b/,
    operator: /:=|[-+*\/=^]|&&?|\|\||<(?:=>?|<|>)?|>[>=]?|\b(?:IN|NOT)\b/i,
    punctuation: /[;\[\](){}`,.]/
  };
}

dax.displayName = "dax", dax.aliases = [];
var dhall_1 = dhall;

function dhall(e) {
  e.languages.dhall = {
    comment: /--.*|\{-(?:[^-{]|-(?!\})|\{(?!-)|\{-(?:[^-{]|-(?!\})|\{(?!-))*-\})*-\}/,
    string: {
      pattern: /"(?:[^"\\]|\\.)*"|''(?:[^']|'(?!')|'''|''\$\{)*''(?!'|\$)/,
      greedy: !0,
      inside: {
        interpolation: {
          pattern: /\$\{[^{}]*\}/,
          inside: {
            expression: {
              pattern: /(^\$\{)[\s\S]+(?=\}$)/,
              lookbehind: !0,
              alias: "language-dhall",
              inside: null
            },
            punctuation: /\$\{|\}/
          }
        }
      }
    },
    label: {
      pattern: /`[^`]*`/,
      greedy: !0
    },
    url: {
      pattern: /\bhttps?:\/\/[\w.:%!$&'*+;=@~-]+(?:\/[\w.:%!$&'*+;=@~-]*)*(?:\?[/?\w.:%!$&'*+;=@~-]*)?/,
      greedy: !0
    },
    env: {
      pattern: /\benv:(?:(?!\d)\w+|"(?:[^"\\=]|\\.)*")/,
      greedy: !0,
      inside: {
        function: /^env/,
        operator: /^:/,
        variable: /[\s\S]+/
      }
    },
    hash: {
      pattern: /\bsha256:[\da-fA-F]{64}\b/,
      inside: {
        function: /sha256/,
        operator: /:/,
        number: /[\da-fA-F]{64}/
      }
    },
    keyword: /\b(?:as|assert|else|forall|if|in|let|merge|missing|then|toMap|using|with)\b|\u2200/,
    builtin: /\b(?:None|Some)\b/,
    boolean: /\b(?:False|True)\b/,
    number: /\bNaN\b|-?\bInfinity\b|[+-]?\b(?:0x[\da-fA-F]+|\d+(?:\.\d+)?(?:e[+-]?\d+)?)\b/,
    operator: /\/\\|\/\/\\\\|&&|\|\||===|[!=]=|\/\/|->|\+\+|::|[+*#@=:?<>|\\\u2227\u2a53\u2261\u2afd\u03bb\u2192]/,
    punctuation: /\.\.|[{}\[\](),./]/,
    "class-name": /\b[A-Z]\w*\b/
  }, e.languages.dhall.string.inside.interpolation.inside.expression.inside = e.languages.dhall;
}

dhall.displayName = "dhall", dhall.aliases = [];
var diff_1 = diff;

function diff(e) {
  !function (e) {
    e.languages.diff = {
      coord: [/^(?:\*{3}|-{3}|\+{3}).*$/m, /^@@.*@@$/m, /^\d.*$/m]
    };
    var t = {
      "deleted-sign": "-",
      "deleted-arrow": "<",
      "inserted-sign": "+",
      "inserted-arrow": ">",
      unchanged: " ",
      diff: "!"
    };
    Object.keys(t).forEach(function (r) {
      var n = t[r],
          a = [];
      /^\w+$/.test(r) || a.push(/\w+/.exec(r)[0]), "diff" === r && a.push("bold"), e.languages.diff[r] = {
        pattern: RegExp("^(?:[" + n + "].*(?:\r\n?|\n|(?![\\s\\S])))+", "m"),
        alias: a,
        inside: {
          line: {
            pattern: /(.)(?=[\s\S]).*(?:\r\n?|\n)?/,
            lookbehind: !0
          },
          prefix: {
            pattern: /[\s\S]/,
            alias: /\w+/.exec(r)[0]
          }
        }
      };
    }), Object.defineProperty(e.languages.diff, "PREFIXES", {
      value: t
    });
  }(e);
}

diff.displayName = "diff", diff.aliases = [];
var markupTemplating_1 = markupTemplating;

function markupTemplating(e) {
  !function (e) {
    function t(e, t) {
      return "___" + e.toUpperCase() + t + "___";
    }

    Object.defineProperties(e.languages["markup-templating"] = {}, {
      buildPlaceholders: {
        value: function value(r, n, a, o) {
          if (r.language === n) {
            var i = r.tokenStack = [];
            r.code = r.code.replace(a, function (e) {
              if ("function" == typeof o && !o(e)) return e;

              for (var a, s = i.length; -1 !== r.code.indexOf(a = t(n, s));) {
                ++s;
              }

              return i[s] = e, a;
            }), r.grammar = e.languages.markup;
          }
        }
      },
      tokenizePlaceholders: {
        value: function value(r, n) {
          if (r.language === n && r.tokenStack) {
            r.grammar = e.languages[n];
            var a = 0,
                o = Object.keys(r.tokenStack);
            !function i(s) {
              for (var l = 0; l < s.length && !(a >= o.length); l++) {
                var c = s[l];

                if ("string" == typeof c || c.content && "string" == typeof c.content) {
                  var u = o[a],
                      d = r.tokenStack[u],
                      p = "string" == typeof c ? c : c.content,
                      g = t(n, u),
                      m = p.indexOf(g);

                  if (m > -1) {
                    ++a;
                    var f = p.substring(0, m),
                        h = new e.Token(n, e.tokenize(d, r.grammar), "language-" + n, d),
                        b = p.substring(m + g.length),
                        y = [];
                    f && y.push.apply(y, i([f])), y.push(h), b && y.push.apply(y, i([b])), "string" == typeof c ? s.splice.apply(s, [l, 1].concat(y)) : c.content = y;
                  }
                } else c.content && i(c.content);
              }

              return s;
            }(r.tokens);
          }
        }
      }
    });
  }(e);
}

markupTemplating.displayName = "markupTemplating", markupTemplating.aliases = [];
var refractorMarkupTemplating$c = markupTemplating_1,
    django_1 = django;

function django(e) {
  e.register(refractorMarkupTemplating$c), function (e) {
    e.languages.django = {
      comment: /^\{#[\s\S]*?#\}$/,
      tag: {
        pattern: /(^\{%[+-]?\s*)\w+/,
        lookbehind: !0,
        alias: "keyword"
      },
      delimiter: {
        pattern: /^\{[{%][+-]?|[+-]?[}%]\}$/,
        alias: "punctuation"
      },
      string: {
        pattern: /("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
        greedy: !0
      },
      filter: {
        pattern: /(\|)\w+/,
        lookbehind: !0,
        alias: "function"
      },
      test: {
        pattern: /(\bis\s+(?:not\s+)?)(?!not\b)\w+/,
        lookbehind: !0,
        alias: "function"
      },
      function: /\b[a-z_]\w+(?=\s*\()/i,
      keyword: /\b(?:and|as|by|else|for|if|import|in|is|loop|not|or|recursive|with|without)\b/,
      operator: /[-+%=]=?|!=|\*\*?=?|\/\/?=?|<[<=>]?|>[=>]?|[&|^~]/,
      number: /\b\d+(?:\.\d+)?\b/,
      boolean: /[Ff]alse|[Nn]one|[Tt]rue/,
      variable: /\b\w+\b/,
      punctuation: /[{}[\](),.:;]/
    };
    var t = /\{\{[\s\S]*?\}\}|\{%[\s\S]*?%\}|\{#[\s\S]*?#\}/g,
        r = e.languages["markup-templating"];
    e.hooks.add("before-tokenize", function (e) {
      r.buildPlaceholders(e, "django", t);
    }), e.hooks.add("after-tokenize", function (e) {
      r.tokenizePlaceholders(e, "django");
    }), e.languages.jinja2 = e.languages.django, e.hooks.add("before-tokenize", function (e) {
      r.buildPlaceholders(e, "jinja2", t);
    }), e.hooks.add("after-tokenize", function (e) {
      r.tokenizePlaceholders(e, "jinja2");
    });
  }(e);
}

django.displayName = "django", django.aliases = ["jinja2"];
var dnsZoneFile_1 = dnsZoneFile;

function dnsZoneFile(e) {
  e.languages["dns-zone-file"] = {
    comment: /;.*/,
    string: {
      pattern: /"(?:\\.|[^"\\\r\n])*"/,
      greedy: !0
    },
    variable: [{
      pattern: /(^\$ORIGIN[ \t]+)\S+/m,
      lookbehind: !0
    }, {
      pattern: /(^|\s)@(?=\s|$)/,
      lookbehind: !0
    }],
    keyword: /^\$(?:INCLUDE|ORIGIN|TTL)(?=\s|$)/m,
    class: {
      pattern: /(^|\s)(?:CH|CS|HS|IN)(?=\s|$)/,
      lookbehind: !0,
      alias: "keyword"
    },
    type: {
      pattern: /(^|\s)(?:A|A6|AAAA|AFSDB|APL|ATMA|CAA|CDNSKEY|CDS|CERT|CNAME|DHCID|DLV|DNAME|DNSKEY|DS|EID|GID|GPOS|HINFO|HIP|IPSECKEY|ISDN|KEY|KX|LOC|MAILA|MAILB|MB|MD|MF|MG|MINFO|MR|MX|NAPTR|NB|NBSTAT|NIMLOC|NINFO|NS|NSAP|NSAP-PTR|NSEC|NSEC3|NSEC3PARAM|NULL|NXT|OPENPGPKEY|PTR|PX|RKEY|RP|RRSIG|RT|SIG|SINK|SMIMEA|SOA|SPF|SRV|SSHFP|TA|TKEY|TLSA|TSIG|TXT|UID|UINFO|UNSPEC|URI|WKS|X25)(?=\s|$)/,
      lookbehind: !0,
      alias: "keyword"
    },
    punctuation: /[()]/
  }, e.languages["dns-zone"] = e.languages["dns-zone-file"];
}

dnsZoneFile.displayName = "dnsZoneFile", dnsZoneFile.aliases = [];
var docker_1 = docker;

function docker(e) {
  !function (e) {
    var t = /\\[\r\n](?:\s|\\[\r\n]|#.*(?!.))*(?![\s#]|\\[\r\n])/.source,
        r = /(?:[ \t]+(?![ \t])(?:<SP_BS>)?|<SP_BS>)/.source.replace(/<SP_BS>/g, function () {
      return t;
    }),
        n = /"(?:[^"\\\r\n]|\\(?:\r\n|[\s\S]))*"|'(?:[^'\\\r\n]|\\(?:\r\n|[\s\S]))*'/.source,
        a = /--[\w-]+=(?:<STR>|(?!["'])(?:[^\s\\]|\\.)+)/.source.replace(/<STR>/g, function () {
      return n;
    }),
        o = {
      pattern: RegExp(n),
      greedy: !0
    },
        i = {
      pattern: /(^[ \t]*)#.*/m,
      lookbehind: !0,
      greedy: !0
    };

    function s(e, t) {
      return e = e.replace(/<OPT>/g, function () {
        return a;
      }).replace(/<SP>/g, function () {
        return r;
      }), RegExp(e, t);
    }

    e.languages.docker = {
      instruction: {
        pattern: /(^[ \t]*)(?:ADD|ARG|CMD|COPY|ENTRYPOINT|ENV|EXPOSE|FROM|HEALTHCHECK|LABEL|MAINTAINER|ONBUILD|RUN|SHELL|STOPSIGNAL|USER|VOLUME|WORKDIR)(?=\s)(?:\\.|[^\r\n\\])*(?:\\$(?:\s|#.*$)*(?![\s#])(?:\\.|[^\r\n\\])*)*/im,
        lookbehind: !0,
        greedy: !0,
        inside: {
          options: {
            pattern: s(/(^(?:ONBUILD<SP>)?\w+<SP>)<OPT>(?:<SP><OPT>)*/.source, "i"),
            lookbehind: !0,
            greedy: !0,
            inside: {
              property: {
                pattern: /(^|\s)--[\w-]+/,
                lookbehind: !0
              },
              string: [o, {
                pattern: /(=)(?!["'])(?:[^\s\\]|\\.)+/,
                lookbehind: !0
              }],
              operator: /\\$/m,
              punctuation: /=/
            }
          },
          keyword: [{
            pattern: s(/(^(?:ONBUILD<SP>)?HEALTHCHECK<SP>(?:<OPT><SP>)*)(?:CMD|NONE)\b/.source, "i"),
            lookbehind: !0,
            greedy: !0
          }, {
            pattern: s(/(^(?:ONBUILD<SP>)?FROM<SP>(?:<OPT><SP>)*(?!--)[^ \t\\]+<SP>)AS/.source, "i"),
            lookbehind: !0,
            greedy: !0
          }, {
            pattern: s(/(^ONBUILD<SP>)\w+/.source, "i"),
            lookbehind: !0,
            greedy: !0
          }, {
            pattern: /^\w+/,
            greedy: !0
          }],
          comment: i,
          string: o,
          variable: /\$(?:\w+|\{[^{}"'\\]*\})/,
          operator: /\\$/m
        }
      },
      comment: i
    }, e.languages.dockerfile = e.languages.docker;
  }(e);
}

docker.displayName = "docker", docker.aliases = ["dockerfile"];
var dot_1 = dot;

function dot(e) {
  !function (e) {
    var t = "(?:" + [/[a-zA-Z_\x80-\uFFFF][\w\x80-\uFFFF]*/.source, /-?(?:\.\d+|\d+(?:\.\d*)?)/.source, /"[^"\\]*(?:\\[\s\S][^"\\]*)*"/.source, /<(?:[^<>]|(?!<!--)<(?:[^<>"']|"[^"]*"|'[^']*')+>|<!--(?:[^-]|-(?!->))*-->)*>/.source].join("|") + ")",
        r = {
      markup: {
        pattern: /(^<)[\s\S]+(?=>$)/,
        lookbehind: !0,
        alias: ["language-markup", "language-html", "language-xml"],
        inside: e.languages.markup
      }
    };

    function n(e, r) {
      return RegExp(e.replace(/<ID>/g, function () {
        return t;
      }), r);
    }

    e.languages.dot = {
      comment: {
        pattern: /\/\/.*|\/\*[\s\S]*?\*\/|^#.*/m,
        greedy: !0
      },
      "graph-name": {
        pattern: n(/(\b(?:digraph|graph|subgraph)[ \t\r\n]+)<ID>/.source, "i"),
        lookbehind: !0,
        greedy: !0,
        alias: "class-name",
        inside: r
      },
      "attr-value": {
        pattern: n(/(=[ \t\r\n]*)<ID>/.source),
        lookbehind: !0,
        greedy: !0,
        inside: r
      },
      "attr-name": {
        pattern: n(/([\[;, \t\r\n])<ID>(?=[ \t\r\n]*=)/.source),
        lookbehind: !0,
        greedy: !0,
        inside: r
      },
      keyword: /\b(?:digraph|edge|graph|node|strict|subgraph)\b/i,
      "compass-point": {
        pattern: /(:[ \t\r\n]*)(?:[ewc_]|[ns][ew]?)(?![\w\x80-\uFFFF])/,
        lookbehind: !0,
        alias: "builtin"
      },
      node: {
        pattern: n(/(^|[^-.\w\x80-\uFFFF\\])<ID>/.source),
        lookbehind: !0,
        greedy: !0,
        inside: r
      },
      operator: /[=:]|-[->]/,
      punctuation: /[\[\]{};,]/
    }, e.languages.gv = e.languages.dot;
  }(e);
}

dot.displayName = "dot", dot.aliases = ["gv"];
var ebnf_1 = ebnf;

function ebnf(e) {
  e.languages.ebnf = {
    comment: /\(\*[\s\S]*?\*\)/,
    string: {
      pattern: /"[^"\r\n]*"|'[^'\r\n]*'/,
      greedy: !0
    },
    special: {
      pattern: /\?[^?\r\n]*\?/,
      greedy: !0,
      alias: "class-name"
    },
    definition: {
      pattern: /^([\t ]*)[a-z]\w*(?:[ \t]+[a-z]\w*)*(?=\s*=)/im,
      lookbehind: !0,
      alias: ["rule", "keyword"]
    },
    rule: /\b[a-z]\w*(?:[ \t]+[a-z]\w*)*\b/i,
    punctuation: /\([:/]|[:/]\)|[.,;()[\]{}]/,
    operator: /[-=|*/!]/
  };
}

ebnf.displayName = "ebnf", ebnf.aliases = [];
var editorconfig_1 = editorconfig;

function editorconfig(e) {
  e.languages.editorconfig = {
    comment: /[;#].*/,
    section: {
      pattern: /(^[ \t]*)\[.+\]/m,
      lookbehind: !0,
      alias: "selector",
      inside: {
        regex: /\\\\[\[\]{},!?.*]/,
        operator: /[!?]|\.\.|\*{1,2}/,
        punctuation: /[\[\]{},]/
      }
    },
    key: {
      pattern: /(^[ \t]*)[^\s=]+(?=[ \t]*=)/m,
      lookbehind: !0,
      alias: "attr-name"
    },
    value: {
      pattern: /=.*/,
      alias: "attr-value",
      inside: {
        punctuation: /^=/
      }
    }
  };
}

editorconfig.displayName = "editorconfig", editorconfig.aliases = [];
var eiffel_1 = eiffel;

function eiffel(e) {
  e.languages.eiffel = {
    comment: /--.*/,
    string: [{
      pattern: /"([^[]*)\[[\s\S]*?\]\1"/,
      greedy: !0
    }, {
      pattern: /"([^{]*)\{[\s\S]*?\}\1"/,
      greedy: !0
    }, {
      pattern: /"(?:%(?:(?!\n)\s)*\n\s*%|%\S|[^%"\r\n])*"/,
      greedy: !0
    }],
    char: /'(?:%.|[^%'\r\n])+'/,
    keyword: /\b(?:across|agent|alias|all|and|as|assign|attached|attribute|check|class|convert|create|Current|debug|deferred|detachable|do|else|elseif|end|ensure|expanded|export|external|feature|from|frozen|if|implies|inherit|inspect|invariant|like|local|loop|not|note|obsolete|old|once|or|Precursor|redefine|rename|require|rescue|Result|retry|select|separate|some|then|undefine|until|variant|Void|when|xor)\b/i,
    boolean: /\b(?:False|True)\b/i,
    "class-name": /\b[A-Z][\dA-Z_]*\b/,
    number: [/\b0[xcb][\da-f](?:_*[\da-f])*\b/i, /(?:\b\d(?:_*\d)*)?\.(?:(?:\d(?:_*\d)*)?e[+-]?)?\d(?:_*\d)*\b|\b\d(?:_*\d)*\b\.?/i],
    punctuation: /:=|<<|>>|\(\||\|\)|->|\.(?=\w)|[{}[\];(),:?]/,
    operator: /\\\\|\|\.\.\||\.\.|\/[~\/=]?|[><]=?|[-+*^=~]/
  };
}

eiffel.displayName = "eiffel", eiffel.aliases = [];
var refractorMarkupTemplating$b = markupTemplating_1,
    ejs_1 = ejs;

function ejs(e) {
  e.register(refractorMarkupTemplating$b), function (e) {
    e.languages.ejs = {
      delimiter: {
        pattern: /^<%[-_=]?|[-_]?%>$/,
        alias: "punctuation"
      },
      comment: /^#[\s\S]*/,
      "language-javascript": {
        pattern: /[\s\S]+/,
        inside: e.languages.javascript
      }
    }, e.hooks.add("before-tokenize", function (t) {
      e.languages["markup-templating"].buildPlaceholders(t, "ejs", /<%(?!%)[\s\S]+?%>/g);
    }), e.hooks.add("after-tokenize", function (t) {
      e.languages["markup-templating"].tokenizePlaceholders(t, "ejs");
    }), e.languages.eta = e.languages.ejs;
  }(e);
}

ejs.displayName = "ejs", ejs.aliases = ["eta"];
var elixir_1 = elixir;

function elixir(e) {
  e.languages.elixir = {
    doc: {
      pattern: /@(?:doc|moduledoc)\s+(?:("""|''')[\s\S]*?\1|("|')(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2)/,
      inside: {
        attribute: /^@\w+/,
        string: /['"][\s\S]+/
      }
    },
    comment: {
      pattern: /#.*/,
      greedy: !0
    },
    regex: {
      pattern: /~[rR](?:("""|''')(?:\\[\s\S]|(?!\1)[^\\])+\1|([\/|"'])(?:\\.|(?!\2)[^\\\r\n])+\2|\((?:\\.|[^\\)\r\n])+\)|\[(?:\\.|[^\\\]\r\n])+\]|\{(?:\\.|[^\\}\r\n])+\}|<(?:\\.|[^\\>\r\n])+>)[uismxfr]*/,
      greedy: !0
    },
    string: [{
      pattern: /~[cCsSwW](?:("""|''')(?:\\[\s\S]|(?!\1)[^\\])+\1|([\/|"'])(?:\\.|(?!\2)[^\\\r\n])+\2|\((?:\\.|[^\\)\r\n])+\)|\[(?:\\.|[^\\\]\r\n])+\]|\{(?:\\.|#\{[^}]+\}|#(?!\{)|[^#\\}\r\n])+\}|<(?:\\.|[^\\>\r\n])+>)[csa]?/,
      greedy: !0,
      inside: {}
    }, {
      pattern: /("""|''')[\s\S]*?\1/,
      greedy: !0,
      inside: {}
    }, {
      pattern: /("|')(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
      greedy: !0,
      inside: {}
    }],
    atom: {
      pattern: /(^|[^:]):\w+/,
      lookbehind: !0,
      alias: "symbol"
    },
    module: {
      pattern: /\b[A-Z]\w*\b/,
      alias: "class-name"
    },
    "attr-name": /\b\w+\??:(?!:)/,
    argument: {
      pattern: /(^|[^&])&\d+/,
      lookbehind: !0,
      alias: "variable"
    },
    attribute: {
      pattern: /@\w+/,
      alias: "variable"
    },
    function: /\b[_a-zA-Z]\w*[?!]?(?:(?=\s*(?:\.\s*)?\()|(?=\/\d))/,
    number: /\b(?:0[box][a-f\d_]+|\d[\d_]*)(?:\.[\d_]+)?(?:e[+-]?[\d_]+)?\b/i,
    keyword: /\b(?:after|alias|and|case|catch|cond|def(?:callback|delegate|exception|impl|macro|module|n|np|p|protocol|struct)?|do|else|end|fn|for|if|import|not|or|quote|raise|require|rescue|try|unless|unquote|use|when)\b/,
    boolean: /\b(?:false|nil|true)\b/,
    operator: [/\bin\b|&&?|\|[|>]?|\\\\|::|\.\.\.?|\+\+?|-[->]?|<[-=>]|>=|!==?|\B!|=(?:==?|[>~])?|[*\/^]/, {
      pattern: /([^<])<(?!<)/,
      lookbehind: !0
    }, {
      pattern: /([^>])>(?!>)/,
      lookbehind: !0
    }],
    punctuation: /<<|>>|[.,%\[\]{}()]/
  }, e.languages.elixir.string.forEach(function (t) {
    t.inside = {
      interpolation: {
        pattern: /#\{[^}]+\}/,
        inside: {
          delimiter: {
            pattern: /^#\{|\}$/,
            alias: "punctuation"
          },
          rest: e.languages.elixir
        }
      }
    };
  });
}

elixir.displayName = "elixir", elixir.aliases = [];
var elm_1 = elm;

function elm(e) {
  e.languages.elm = {
    comment: /--.*|\{-[\s\S]*?-\}/,
    char: {
      pattern: /'(?:[^\\'\r\n]|\\(?:[abfnrtv\\']|\d+|x[0-9a-fA-F]+|u\{[0-9a-fA-F]+\}))'/,
      greedy: !0
    },
    string: [{
      pattern: /"""[\s\S]*?"""/,
      greedy: !0
    }, {
      pattern: /"(?:[^\\"\r\n]|\\.)*"/,
      greedy: !0
    }],
    "import-statement": {
      pattern: /(^[\t ]*)import\s+[A-Z]\w*(?:\.[A-Z]\w*)*(?:\s+as\s+(?:[A-Z]\w*)(?:\.[A-Z]\w*)*)?(?:\s+exposing\s+)?/m,
      lookbehind: !0,
      inside: {
        keyword: /\b(?:as|exposing|import)\b/
      }
    },
    keyword: /\b(?:alias|as|case|else|exposing|if|in|infixl|infixr|let|module|of|then|type)\b/,
    builtin: /\b(?:abs|acos|always|asin|atan|atan2|ceiling|clamp|compare|cos|curry|degrees|e|flip|floor|fromPolar|identity|isInfinite|isNaN|logBase|max|min|negate|never|not|pi|radians|rem|round|sin|sqrt|tan|toFloat|toPolar|toString|truncate|turns|uncurry|xor)\b/,
    number: /\b(?:\d+(?:\.\d+)?(?:e[+-]?\d+)?|0x[0-9a-f]+)\b/i,
    operator: /\s\.\s|[+\-/*=.$<>:&|^?%#@~!]{2,}|[+\-/*=$<>:&|^?%#@~!]/,
    hvariable: /\b(?:[A-Z]\w*\.)*[a-z]\w*\b/,
    constant: /\b(?:[A-Z]\w*\.)*[A-Z]\w*\b/,
    punctuation: /[{}[\]|(),.:]/
  };
}

elm.displayName = "elm", elm.aliases = [];
var refractorRuby$1 = ruby_1,
    refractorMarkupTemplating$a = markupTemplating_1,
    erb_1 = erb;

function erb(e) {
  e.register(refractorRuby$1), e.register(refractorMarkupTemplating$a), function (e) {
    e.languages.erb = {
      delimiter: {
        pattern: /^(\s*)<%=?|%>(?=\s*$)/,
        lookbehind: !0,
        alias: "punctuation"
      },
      ruby: {
        pattern: /\s*\S[\s\S]*/,
        alias: "language-ruby",
        inside: e.languages.ruby
      }
    }, e.hooks.add("before-tokenize", function (t) {
      e.languages["markup-templating"].buildPlaceholders(t, "erb", /<%=?(?:[^\r\n]|[\r\n](?!=begin)|[\r\n]=begin\s(?:[^\r\n]|[\r\n](?!=end))*[\r\n]=end)+?%>/g);
    }), e.hooks.add("after-tokenize", function (t) {
      e.languages["markup-templating"].tokenizePlaceholders(t, "erb");
    });
  }(e);
}

erb.displayName = "erb", erb.aliases = [];
var erlang_1 = erlang;

function erlang(e) {
  e.languages.erlang = {
    comment: /%.+/,
    string: {
      pattern: /"(?:\\.|[^\\"\r\n])*"/,
      greedy: !0
    },
    "quoted-function": {
      pattern: /'(?:\\.|[^\\'\r\n])+'(?=\()/,
      alias: "function"
    },
    "quoted-atom": {
      pattern: /'(?:\\.|[^\\'\r\n])+'/,
      alias: "atom"
    },
    boolean: /\b(?:false|true)\b/,
    keyword: /\b(?:after|case|catch|end|fun|if|of|receive|try|when)\b/,
    number: [/\$\\?./, /\b\d+#[a-z0-9]+/i, /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i],
    function: /\b[a-z][\w@]*(?=\()/,
    variable: {
      pattern: /(^|[^@])(?:\b|\?)[A-Z_][\w@]*/,
      lookbehind: !0
    },
    operator: [/[=\/<>:]=|=[:\/]=|\+\+?|--?|[=*\/!]|\b(?:and|andalso|band|bnot|bor|bsl|bsr|bxor|div|not|or|orelse|rem|xor)\b/, {
      pattern: /(^|[^<])<(?!<)/,
      lookbehind: !0
    }, {
      pattern: /(^|[^>])>(?!>)/,
      lookbehind: !0
    }],
    atom: /\b[a-z][\w@]*/,
    punctuation: /[()[\]{}:;,.#|]|<<|>>/
  };
}

erlang.displayName = "erlang", erlang.aliases = [];
var lua_1 = lua;

function lua(e) {
  e.languages.lua = {
    comment: /^#!.+|--(?:\[(=*)\[[\s\S]*?\]\1\]|.*)/m,
    string: {
      pattern: /(["'])(?:(?!\1)[^\\\r\n]|\\z(?:\r\n|\s)|\\(?:\r\n|[^z]))*\1|\[(=*)\[[\s\S]*?\]\2\]/,
      greedy: !0
    },
    number: /\b0x[a-f\d]+(?:\.[a-f\d]*)?(?:p[+-]?\d+)?\b|\b\d+(?:\.\B|(?:\.\d*)?(?:e[+-]?\d+)?\b)|\B\.\d+(?:e[+-]?\d+)?\b/i,
    keyword: /\b(?:and|break|do|else|elseif|end|false|for|function|goto|if|in|local|nil|not|or|repeat|return|then|true|until|while)\b/,
    function: /(?!\d)\w+(?=\s*(?:[({]))/,
    operator: [/[-+*%^&|#]|\/\/?|<[<=]?|>[>=]?|[=~]=?/, {
      pattern: /(^|[^.])\.\.(?!\.)/,
      lookbehind: !0
    }],
    punctuation: /[\[\](){},;]|\.+|:+/
  };
}

lua.displayName = "lua", lua.aliases = [];
var refractorLua = lua_1,
    refractorMarkupTemplating$9 = markupTemplating_1,
    etlua_1 = etlua;

function etlua(e) {
  e.register(refractorLua), e.register(refractorMarkupTemplating$9), function (e) {
    e.languages.etlua = {
      delimiter: {
        pattern: /^<%[-=]?|-?%>$/,
        alias: "punctuation"
      },
      "language-lua": {
        pattern: /[\s\S]+/,
        inside: e.languages.lua
      }
    }, e.hooks.add("before-tokenize", function (t) {
      e.languages["markup-templating"].buildPlaceholders(t, "etlua", /<%[\s\S]+?%>/g);
    }), e.hooks.add("after-tokenize", function (t) {
      e.languages["markup-templating"].tokenizePlaceholders(t, "etlua");
    });
  }(e);
}

etlua.displayName = "etlua", etlua.aliases = [];
var excelFormula_1 = excelFormula;

function excelFormula(e) {
  e.languages["excel-formula"] = {
    comment: {
      pattern: /(\bN\(\s*)"(?:[^"]|"")*"(?=\s*\))/i,
      lookbehind: !0,
      greedy: !0
    },
    string: {
      pattern: /"(?:[^"]|"")*"(?!")/,
      greedy: !0
    },
    reference: {
      pattern: /(?:'[^']*'|(?:[^\s()[\]{}<>*?"';,$&]*\[[^^\s()[\]{}<>*?"']+\])?\w+)!/,
      greedy: !0,
      alias: "string",
      inside: {
        operator: /!$/,
        punctuation: /'/,
        sheet: {
          pattern: /[^[\]]+$/,
          alias: "function"
        },
        file: {
          pattern: /\[[^[\]]+\]$/,
          inside: {
            punctuation: /[[\]]/
          }
        },
        path: /[\s\S]+/
      }
    },
    "function-name": {
      pattern: /\b[A-Z]\w*(?=\()/i,
      alias: "keyword"
    },
    range: {
      pattern: /\$?\b(?:[A-Z]+\$?\d+:\$?[A-Z]+\$?\d+|[A-Z]+:\$?[A-Z]+|\d+:\$?\d+)\b/i,
      alias: "property",
      inside: {
        operator: /:/,
        cell: /\$?[A-Z]+\$?\d+/i,
        column: /\$?[A-Z]+/i,
        row: /\$?\d+/
      }
    },
    cell: {
      pattern: /\b[A-Z]+\d+\b|\$[A-Za-z]+\$?\d+\b|\b[A-Za-z]+\$\d+\b/,
      alias: "property"
    },
    number: /(?:\b\d+(?:\.\d+)?|\B\.\d+)(?:e[+-]?\d+)?\b/i,
    boolean: /\b(?:FALSE|TRUE)\b/i,
    operator: /[-+*/^%=&,]|<[=>]?|>=?/,
    punctuation: /[[\]();{}|]/
  }, e.languages.xlsx = e.languages.xls = e.languages["excel-formula"];
}

excelFormula.displayName = "excelFormula", excelFormula.aliases = [];
var factor_1 = factor;

function factor(e) {
  !function (e) {
    var t = {
      function: /\b(?:BUGS?|FIX(?:MES?)?|NOTES?|TODOS?|XX+|HACKS?|WARN(?:ING)?|\?{2,}|!{2,})\b/
    },
        r = {
      number: /\\[^\s']|%\w/
    },
        n = {
      comment: [{
        pattern: /(^|\s)(?:! .*|!$)/,
        lookbehind: !0,
        inside: t
      }, {
        pattern: /(^|\s)\/\*\s[\s\S]*?\*\/(?=\s|$)/,
        lookbehind: !0,
        greedy: !0,
        inside: t
      }, {
        pattern: /(^|\s)!\[(={0,6})\[\s[\s\S]*?\]\2\](?=\s|$)/,
        lookbehind: !0,
        greedy: !0,
        inside: t
      }],
      number: [{
        pattern: /(^|\s)[+-]?\d+(?=\s|$)/,
        lookbehind: !0
      }, {
        pattern: /(^|\s)[+-]?0(?:b[01]+|o[0-7]+|d\d+|x[\dA-F]+)(?=\s|$)/i,
        lookbehind: !0
      }, {
        pattern: /(^|\s)[+-]?\d+\/\d+\.?(?=\s|$)/,
        lookbehind: !0
      }, {
        pattern: /(^|\s)\+?\d+\+\d+\/\d+(?=\s|$)/,
        lookbehind: !0
      }, {
        pattern: /(^|\s)-\d+-\d+\/\d+(?=\s|$)/,
        lookbehind: !0
      }, {
        pattern: /(^|\s)[+-]?(?:\d*\.\d+|\d+\.\d*|\d+)(?:e[+-]?\d+)?(?=\s|$)/i,
        lookbehind: !0
      }, {
        pattern: /(^|\s)NAN:\s+[\da-fA-F]+(?=\s|$)/,
        lookbehind: !0
      }, {
        pattern: /(^|\s)[+-]?0(?:b1\.[01]*|o1\.[0-7]*|d1\.\d*|x1\.[\dA-F]*)p\d+(?=\s|$)/i,
        lookbehind: !0
      }],
      regexp: {
        pattern: /(^|\s)R\/\s(?:\\\S|[^\\/])*\/(?:[idmsr]*|[idmsr]+-[idmsr]+)(?=\s|$)/,
        lookbehind: !0,
        alias: "number",
        inside: {
          variable: /\\\S/,
          keyword: /[+?*\[\]^$(){}.|]/,
          operator: {
            pattern: /(\/)[idmsr]+(?:-[idmsr]+)?/,
            lookbehind: !0
          }
        }
      },
      boolean: {
        pattern: /(^|\s)[tf](?=\s|$)/,
        lookbehind: !0
      },
      "custom-string": {
        pattern: /(^|\s)[A-Z0-9\-]+"\s(?:\\\S|[^"\\])*"/,
        lookbehind: !0,
        greedy: !0,
        alias: "string",
        inside: {
          number: /\\\S|%\w|\//
        }
      },
      "multiline-string": [{
        pattern: /(^|\s)STRING:\s+\S+(?:\n|\r\n).*(?:\n|\r\n)\s*;(?=\s|$)/,
        lookbehind: !0,
        greedy: !0,
        alias: "string",
        inside: {
          number: r.number,
          "semicolon-or-setlocal": {
            pattern: /([\r\n][ \t]*);(?=\s|$)/,
            lookbehind: !0,
            alias: "function"
          }
        }
      }, {
        pattern: /(^|\s)HEREDOC:\s+\S+(?:\n|\r\n).*(?:\n|\r\n)\s*\S+(?=\s|$)/,
        lookbehind: !0,
        greedy: !0,
        alias: "string",
        inside: r
      }, {
        pattern: /(^|\s)\[(={0,6})\[\s[\s\S]*?\]\2\](?=\s|$)/,
        lookbehind: !0,
        greedy: !0,
        alias: "string",
        inside: r
      }],
      "special-using": {
        pattern: /(^|\s)USING:(?:\s\S+)*(?=\s+;(?:\s|$))/,
        lookbehind: !0,
        alias: "function",
        inside: {
          string: {
            pattern: /(\s)[^:\s]+/,
            lookbehind: !0
          }
        }
      },
      "stack-effect-delimiter": [{
        pattern: /(^|\s)(?:call|eval|execute)?\((?=\s)/,
        lookbehind: !0,
        alias: "operator"
      }, {
        pattern: /(\s)--(?=\s)/,
        lookbehind: !0,
        alias: "operator"
      }, {
        pattern: /(\s)\)(?=\s|$)/,
        lookbehind: !0,
        alias: "operator"
      }],
      combinators: {
        pattern: null,
        lookbehind: !0,
        alias: "keyword"
      },
      "kernel-builtin": {
        pattern: null,
        lookbehind: !0,
        alias: "variable"
      },
      "sequences-builtin": {
        pattern: null,
        lookbehind: !0,
        alias: "variable"
      },
      "math-builtin": {
        pattern: null,
        lookbehind: !0,
        alias: "variable"
      },
      "constructor-word": {
        pattern: /(^|\s)<(?!=+>|-+>)\S+>(?=\s|$)/,
        lookbehind: !0,
        alias: "keyword"
      },
      "other-builtin-syntax": {
        pattern: null,
        lookbehind: !0,
        alias: "operator"
      },
      "conventionally-named-word": {
        pattern: /(^|\s)(?!")(?:(?:change|new|set|with)-\S+|\$\S+|>[^>\s]+|[^:>\s]+>|[^>\s]+>[^>\s]+|\+[^+\s]+\+|[^?\s]+\?|\?[^?\s]+|[^>\s]+>>|>>[^>\s]+|[^<\s]+<<|\([^()\s]+\)|[^!\s]+!|[^*\s]\S*\*|[^.\s]\S*\.)(?=\s|$)/,
        lookbehind: !0,
        alias: "keyword"
      },
      "colon-syntax": {
        pattern: /(^|\s)(?:[A-Z0-9\-]+#?)?:{1,2}\s+(?:;\S+|(?!;)\S+)(?=\s|$)/,
        lookbehind: !0,
        greedy: !0,
        alias: "function"
      },
      "semicolon-or-setlocal": {
        pattern: /(\s)(?:;|:>)(?=\s|$)/,
        lookbehind: !0,
        alias: "function"
      },
      "curly-brace-literal-delimiter": [{
        pattern: /(^|\s)[a-z]*\{(?=\s)/i,
        lookbehind: !0,
        alias: "operator"
      }, {
        pattern: /(\s)\}(?=\s|$)/,
        lookbehind: !0,
        alias: "operator"
      }],
      "quotation-delimiter": [{
        pattern: /(^|\s)\[(?=\s)/,
        lookbehind: !0,
        alias: "operator"
      }, {
        pattern: /(\s)\](?=\s|$)/,
        lookbehind: !0,
        alias: "operator"
      }],
      "normal-word": {
        pattern: /(^|\s)[^"\s]\S*(?=\s|$)/,
        lookbehind: !0
      },
      string: {
        pattern: /"(?:\\\S|[^"\\])*"/,
        greedy: !0,
        inside: r
      }
    },
        a = function a(e) {
      return (e + "").replace(/([.?*+\^$\[\]\\(){}|\-])/g, "\\$1");
    },
        o = function o(e) {
      return new RegExp("(^|\\s)(?:" + e.map(a).join("|") + ")(?=\\s|$)");
    },
        i = {
      "kernel-builtin": ["or", "2nipd", "4drop", "tuck", "wrapper", "nip", "wrapper?", "callstack>array", "die", "dupd", "callstack", "callstack?", "3dup", "hashcode", "pick", "4nip", "build", ">boolean", "nipd", "clone", "5nip", "eq?", "?", "=", "swapd", "2over", "clear", "2dup", "get-retainstack", "not", "tuple?", "dup", "3nipd", "call", "-rotd", "object", "drop", "assert=", "assert?", "-rot", "execute", "boa", "get-callstack", "curried?", "3drop", "pickd", "overd", "over", "roll", "3nip", "swap", "and", "2nip", "rotd", "throw", "(clone)", "hashcode*", "spin", "reach", "4dup", "equal?", "get-datastack", "assert", "2drop", "<wrapper>", "boolean?", "identity-hashcode", "identity-tuple?", "null", "composed?", "new", "5drop", "rot", "-roll", "xor", "identity-tuple", "boolean"],
      "other-builtin-syntax": ["=======", "recursive", "flushable", ">>", "<<<<<<", "M\\", "B", "PRIVATE>", "\\", "======", "final", "inline", "delimiter", "deprecated", "<PRIVATE", ">>>>>>", "<<<<<<<", "parse-complex", "malformed-complex", "read-only", ">>>>>>>", "call-next-method", "<<", "foldable", "$", "$[", "${"],
      "sequences-builtin": ["member-eq?", "mismatch", "append", "assert-sequence=", "longer", "repetition", "clone-like", "3sequence", "assert-sequence?", "last-index-from", "reversed", "index-from", "cut*", "pad-tail", "join-as", "remove-eq!", "concat-as", "but-last", "snip", "nths", "nth", "sequence", "longest", "slice?", "<slice>", "remove-nth", "tail-slice", "empty?", "tail*", "member?", "virtual-sequence?", "set-length", "drop-prefix", "iota", "unclip", "bounds-error?", "unclip-last-slice", "non-negative-integer-expected", "non-negative-integer-expected?", "midpoint@", "longer?", "?set-nth", "?first", "rest-slice", "prepend-as", "prepend", "fourth", "sift", "subseq-start", "new-sequence", "?last", "like", "first4", "1sequence", "reverse", "slice", "virtual@", "repetition?", "set-last", "index", "4sequence", "max-length", "set-second", "immutable-sequence", "first2", "first3", "supremum", "unclip-slice", "suffix!", "insert-nth", "tail", "3append", "short", "suffix", "concat", "flip", "immutable?", "reverse!", "2sequence", "sum", "delete-all", "indices", "snip-slice", "<iota>", "check-slice", "sequence?", "head", "append-as", "halves", "sequence=", "collapse-slice", "?second", "slice-error?", "product", "bounds-check?", "bounds-check", "immutable", "virtual-exemplar", "harvest", "remove", "pad-head", "last", "set-fourth", "cartesian-product", "remove-eq", "shorten", "shorter", "reversed?", "shorter?", "shortest", "head-slice", "pop*", "tail-slice*", "but-last-slice", "iota?", "append!", "cut-slice", "new-resizable", "head-slice*", "sequence-hashcode", "pop", "set-nth", "?nth", "second", "join", "immutable-sequence?", "<reversed>", "3append-as", "virtual-sequence", "subseq?", "remove-nth!", "length", "last-index", "lengthen", "assert-sequence", "copy", "move", "third", "first", "tail?", "set-first", "prefix", "bounds-error", "<repetition>", "exchange", "surround", "cut", "min-length", "set-third", "push-all", "head?", "subseq-start-from", "delete-slice", "rest", "sum-lengths", "head*", "infimum", "remove!", "glue", "slice-error", "subseq", "push", "replace-slice", "subseq-as", "unclip-last"],
      "math-builtin": ["number=", "next-power-of-2", "?1+", "fp-special?", "imaginary-part", "float>bits", "number?", "fp-infinity?", "bignum?", "fp-snan?", "denominator", "gcd", "*", "+", "fp-bitwise=", "-", "u>=", "/", ">=", "bitand", "power-of-2?", "log2-expects-positive", "neg?", "<", "log2", ">", "integer?", "number", "bits>double", "2/", "zero?", "bits>float", "float?", "shift", "ratio?", "rect>", "even?", "ratio", "fp-sign", "bitnot", ">fixnum", "complex?", "/i", "integer>fixnum", "/f", "sgn", ">bignum", "next-float", "u<", "u>", "mod", "recip", "rational", ">float", "2^", "integer", "fixnum?", "neg", "fixnum", "sq", "bignum", ">rect", "bit?", "fp-qnan?", "simple-gcd", "complex", "<fp-nan>", "real", ">fraction", "double>bits", "bitor", "rem", "fp-nan-payload", "real-part", "log2-expects-positive?", "prev-float", "align", "unordered?", "float", "fp-nan?", "abs", "bitxor", "integer>fixnum-strict", "u<=", "odd?", "<=", "/mod", ">integer", "real?", "rational?", "numerator"]
    };

    Object.keys(i).forEach(function (e) {
      n[e].pattern = o(i[e]);
    });
    n.combinators.pattern = o(["2bi", "while", "2tri", "bi*", "4dip", "both?", "same?", "tri@", "curry", "prepose", "3bi", "?if", "tri*", "2keep", "3keep", "curried", "2keepd", "when", "2bi*", "2tri*", "4keep", "bi@", "keepdd", "do", "unless*", "tri-curry", "if*", "loop", "bi-curry*", "when*", "2bi@", "2tri@", "with", "2with", "either?", "bi", "until", "3dip", "3curry", "tri-curry*", "tri-curry@", "bi-curry", "keepd", "compose", "2dip", "if", "3tri", "unless", "tuple", "keep", "2curry", "tri", "most", "while*", "dip", "composed", "bi-curry@", "find-last-from", "trim-head-slice", "map-as", "each-from", "none?", "trim-tail", "partition", "if-empty", "accumulate*", "reject!", "find-from", "accumulate-as", "collector-for-as", "reject", "map", "map-sum", "accumulate!", "2each-from", "follow", "supremum-by", "map!", "unless-empty", "collector", "padding", "reduce-index", "replicate-as", "infimum-by", "trim-tail-slice", "count", "find-index", "filter", "accumulate*!", "reject-as", "map-integers", "map-find", "reduce", "selector", "interleave", "2map", "filter-as", "binary-reduce", "map-index-as", "find", "produce", "filter!", "replicate", "cartesian-map", "cartesian-each", "find-index-from", "map-find-last", "3map-as", "3map", "find-last", "selector-as", "2map-as", "2map-reduce", "accumulate", "each", "each-index", "accumulate*-as", "when-empty", "all?", "collector-as", "push-either", "new-like", "collector-for", "2selector", "push-if", "2all?", "map-reduce", "3each", "any?", "trim-slice", "2reduce", "change-nth", "produce-as", "2each", "trim", "trim-head", "cartesian-find", "map-index", "if-zero", "each-integer", "unless-zero", "(find-integer)", "when-zero", "find-last-integer", "(all-integers?)", "times", "(each-integer)", "find-integer", "all-integers?", "unless-negative", "if-positive", "when-positive", "when-negative", "unless-positive", "if-negative", "case", "2cleave", "cond>quot", "case>quot", "3cleave", "wrong-values", "to-fixed-point", "alist>quot", "cond", "cleave", "call-effect", "recursive-hashcode", "spread", "deep-spread>quot", "2||", "0||", "n||", "0&&", "2&&", "3||", "1||", "1&&", "n&&", "3&&", "smart-unless*", "keep-inputs", "reduce-outputs", "smart-when*", "cleave>array", "smart-with", "smart-apply", "smart-if", "inputs/outputs", "output>sequence-n", "map-outputs", "map-reduce-outputs", "dropping", "output>array", "smart-map-reduce", "smart-2map-reduce", "output>array-n", "nullary", "input<sequence", "append-outputs", "drop-inputs", "inputs", "smart-2reduce", "drop-outputs", "smart-reduce", "preserving", "smart-when", "outputs", "append-outputs-as", "smart-unless", "smart-if*", "sum-outputs", "input<sequence-unsafe", "output>sequence"]), e.languages.factor = n;
  }(e);
}

factor.displayName = "factor", factor.aliases = [];
var _false = $false;

function $false(e) {
  !function (e) {
    e.languages.false = {
      comment: {
        pattern: /\{[^}]*\}/
      },
      string: {
        pattern: /"[^"]*"/,
        greedy: !0
      },
      "character-code": {
        pattern: /'(?:[^\r]|\r\n?)/,
        alias: "number"
      },
      "assembler-code": {
        pattern: /\d+`/,
        alias: "important"
      },
      number: /\d+/,
      operator: /[-!#$%&'*+,./:;=>?@\\^_`|~ßø]/,
      punctuation: /\[|\]/,
      variable: /[a-z]/,
      "non-standard": {
        pattern: /[()<BDO®]/,
        alias: "bold"
      }
    };
  }(e);
}

$false.displayName = "$false", $false.aliases = [];
var firestoreSecurityRules_1 = firestoreSecurityRules;

function firestoreSecurityRules(e) {
  e.languages["firestore-security-rules"] = e.languages.extend("clike", {
    comment: /\/\/.*/,
    keyword: /\b(?:allow|function|if|match|null|return|rules_version|service)\b/,
    operator: /&&|\|\||[<>!=]=?|[-+*/%]|\b(?:in|is)\b/
  }), delete e.languages["firestore-security-rules"]["class-name"], e.languages.insertBefore("firestore-security-rules", "keyword", {
    path: {
      pattern: /(^|[\s(),])(?:\/(?:[\w\xA0-\uFFFF]+|\{[\w\xA0-\uFFFF]+(?:=\*\*)?\}|\$\([\w\xA0-\uFFFF.]+\)))+/,
      lookbehind: !0,
      greedy: !0,
      inside: {
        variable: {
          pattern: /\{[\w\xA0-\uFFFF]+(?:=\*\*)?\}|\$\([\w\xA0-\uFFFF.]+\)/,
          inside: {
            operator: /=/,
            keyword: /\*\*/,
            punctuation: /[.$(){}]/
          }
        },
        punctuation: /\//
      }
    },
    method: {
      pattern: /(\ballow\s+)[a-z]+(?:\s*,\s*[a-z]+)*(?=\s*[:;])/,
      lookbehind: !0,
      alias: "builtin",
      inside: {
        punctuation: /,/
      }
    }
  });
}

firestoreSecurityRules.displayName = "firestoreSecurityRules", firestoreSecurityRules.aliases = [];
var flow_1 = flow;

function flow(e) {
  !function (e) {
    e.languages.flow = e.languages.extend("javascript", {}), e.languages.insertBefore("flow", "keyword", {
      type: [{
        pattern: /\b(?:[Bb]oolean|Function|[Nn]umber|[Ss]tring|any|mixed|null|void)\b/,
        alias: "tag"
      }]
    }), e.languages.flow["function-variable"].pattern = /(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=\s*(?:function\b|(?:\([^()]*\)(?:\s*:\s*\w+)?|(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/i, delete e.languages.flow.parameter, e.languages.insertBefore("flow", "operator", {
      "flow-punctuation": {
        pattern: /\{\||\|\}/,
        alias: "punctuation"
      }
    }), Array.isArray(e.languages.flow.keyword) || (e.languages.flow.keyword = [e.languages.flow.keyword]), e.languages.flow.keyword.unshift({
      pattern: /(^|[^$]\b)(?:Class|declare|opaque|type)\b(?!\$)/,
      lookbehind: !0
    }, {
      pattern: /(^|[^$]\B)\$(?:Diff|Enum|Exact|Keys|ObjMap|PropertyType|Record|Shape|Subtype|Supertype|await)\b(?!\$)/,
      lookbehind: !0
    });
  }(e);
}

flow.displayName = "flow", flow.aliases = [];
var fortran_1 = fortran;

function fortran(e) {
  e.languages.fortran = {
    "quoted-number": {
      pattern: /[BOZ](['"])[A-F0-9]+\1/i,
      alias: "number"
    },
    string: {
      pattern: /(?:\b\w+_)?(['"])(?:\1\1|&(?:\r\n?|\n)(?:[ \t]*!.*(?:\r\n?|\n)|(?![ \t]*!))|(?!\1).)*(?:\1|&)/,
      inside: {
        comment: {
          pattern: /(&(?:\r\n?|\n)\s*)!.*/,
          lookbehind: !0
        }
      }
    },
    comment: {
      pattern: /!.*/,
      greedy: !0
    },
    boolean: /\.(?:FALSE|TRUE)\.(?:_\w+)?/i,
    number: /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[ED][+-]?\d+)?(?:_\w+)?/i,
    keyword: [/\b(?:CHARACTER|COMPLEX|DOUBLE ?PRECISION|INTEGER|LOGICAL|REAL)\b/i, /\b(?:END ?)?(?:BLOCK ?DATA|DO|FILE|FORALL|FUNCTION|IF|INTERFACE|MODULE(?! PROCEDURE)|PROGRAM|SELECT|SUBROUTINE|TYPE|WHERE)\b/i, /\b(?:ALLOCATABLE|ALLOCATE|BACKSPACE|CALL|CASE|CLOSE|COMMON|CONTAINS|CONTINUE|CYCLE|DATA|DEALLOCATE|DIMENSION|DO|END|EQUIVALENCE|EXIT|EXTERNAL|FORMAT|GO ?TO|IMPLICIT(?: NONE)?|INQUIRE|INTENT|INTRINSIC|MODULE PROCEDURE|NAMELIST|NULLIFY|OPEN|OPTIONAL|PARAMETER|POINTER|PRINT|PRIVATE|PUBLIC|READ|RETURN|REWIND|SAVE|SELECT|STOP|TARGET|WHILE|WRITE)\b/i, /\b(?:ASSIGNMENT|DEFAULT|ELEMENTAL|ELSE|ELSEIF|ELSEWHERE|ENTRY|IN|INCLUDE|INOUT|KIND|NULL|ONLY|OPERATOR|OUT|PURE|RECURSIVE|RESULT|SEQUENCE|STAT|THEN|USE)\b/i],
    operator: [/\*\*|\/\/|=>|[=\/]=|[<>]=?|::|[+\-*=%]|\.[A-Z]+\./i, {
      pattern: /(^|(?!\().)\/(?!\))/,
      lookbehind: !0
    }],
    punctuation: /\(\/|\/\)|[(),;:&]/
  };
}

fortran.displayName = "fortran", fortran.aliases = [];
var fsharp_1 = fsharp;

function fsharp(e) {
  e.languages.fsharp = e.languages.extend("clike", {
    comment: [{
      pattern: /(^|[^\\])\(\*(?!\))[\s\S]*?\*\)/,
      lookbehind: !0,
      greedy: !0
    }, {
      pattern: /(^|[^\\:])\/\/.*/,
      lookbehind: !0,
      greedy: !0
    }],
    string: {
      pattern: /(?:"""[\s\S]*?"""|@"(?:""|[^"])*"|"(?:\\[\s\S]|[^\\"])*")B?/,
      greedy: !0
    },
    "class-name": {
      pattern: /(\b(?:exception|inherit|interface|new|of|type)\s+|\w\s*:\s*|\s:\??>\s*)[.\w]+\b(?:\s*(?:->|\*)\s*[.\w]+\b)*(?!\s*[:.])/,
      lookbehind: !0,
      inside: {
        operator: /->|\*/,
        punctuation: /\./
      }
    },
    keyword: /\b(?:let|return|use|yield)(?:!\B|\b)|\b(?:abstract|and|as|asr|assert|atomic|base|begin|break|checked|class|component|const|constraint|constructor|continue|default|delegate|do|done|downcast|downto|eager|elif|else|end|event|exception|extern|external|false|finally|fixed|for|fun|function|functor|global|if|in|include|inherit|inline|interface|internal|land|lazy|lor|lsl|lsr|lxor|match|member|method|mixin|mod|module|mutable|namespace|new|not|null|object|of|open|or|override|parallel|private|process|protected|public|pure|rec|sealed|select|sig|static|struct|tailcall|then|to|trait|true|try|type|upcast|val|virtual|void|volatile|when|while|with)\b/,
    number: [/\b0x[\da-fA-F]+(?:LF|lf|un)?\b/, /\b0b[01]+(?:uy|y)?\b/, /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[fm]|e[+-]?\d+)?\b/i, /\b\d+(?:[IlLsy]|UL|u[lsy]?)?\b/],
    operator: /([<>~&^])\1\1|([*.:<>&])\2|<-|->|[!=:]=|<?\|{1,3}>?|\??(?:<=|>=|<>|[-+*/%=<>])\??|[!?^&]|~[+~-]|:>|:\?>?/
  }), e.languages.insertBefore("fsharp", "keyword", {
    preprocessor: {
      pattern: /(^[\t ]*)#.*/m,
      lookbehind: !0,
      alias: "property",
      inside: {
        directive: {
          pattern: /(^#)\b(?:else|endif|if|light|line|nowarn)\b/,
          lookbehind: !0,
          alias: "keyword"
        }
      }
    }
  }), e.languages.insertBefore("fsharp", "punctuation", {
    "computation-expression": {
      pattern: /\b[_a-z]\w*(?=\s*\{)/i,
      alias: "keyword"
    }
  }), e.languages.insertBefore("fsharp", "string", {
    annotation: {
      pattern: /\[<.+?>\]/,
      greedy: !0,
      inside: {
        punctuation: /^\[<|>\]$/,
        "class-name": {
          pattern: /^\w+$|(^|;\s*)[A-Z]\w*(?=\()/,
          lookbehind: !0
        },
        "annotation-content": {
          pattern: /[\s\S]+/,
          inside: e.languages.fsharp
        }
      }
    },
    char: {
      pattern: /'(?:[^\\']|\\(?:.|\d{3}|x[a-fA-F\d]{2}|u[a-fA-F\d]{4}|U[a-fA-F\d]{8}))'B?/,
      greedy: !0
    }
  });
}

fsharp.displayName = "fsharp", fsharp.aliases = [];
var refractorMarkupTemplating$8 = markupTemplating_1,
    ftl_1 = ftl;

function ftl(e) {
  e.register(refractorMarkupTemplating$8), function (e) {
    for (var t = /[^<()"']|\((?:<expr>)*\)|<(?!#--)|<#--(?:[^-]|-(?!->))*-->|"(?:[^\\"]|\\.)*"|'(?:[^\\']|\\.)*'/.source, r = 0; r < 2; r++) {
      t = t.replace(/<expr>/g, function () {
        return t;
      });
    }

    t = t.replace(/<expr>/g, /[^\s\S]/.source);
    var n = {
      comment: /<#--[\s\S]*?-->/,
      string: [{
        pattern: /\br("|')(?:(?!\1)[^\\]|\\.)*\1/,
        greedy: !0
      }, {
        pattern: RegExp(/("|')(?:(?!\1|\$\{)[^\\]|\\.|\$\{(?:(?!\})(?:<expr>))*\})*\1/.source.replace(/<expr>/g, function () {
          return t;
        })),
        greedy: !0,
        inside: {
          interpolation: {
            pattern: RegExp(/((?:^|[^\\])(?:\\\\)*)\$\{(?:(?!\})(?:<expr>))*\}/.source.replace(/<expr>/g, function () {
              return t;
            })),
            lookbehind: !0,
            inside: {
              "interpolation-punctuation": {
                pattern: /^\$\{|\}$/,
                alias: "punctuation"
              },
              rest: null
            }
          }
        }
      }],
      keyword: /\b(?:as)\b/,
      boolean: /\b(?:false|true)\b/,
      "builtin-function": {
        pattern: /((?:^|[^?])\?\s*)\w+/,
        lookbehind: !0,
        alias: "function"
      },
      function: /\b\w+(?=\s*\()/,
      number: /\b\d+(?:\.\d+)?\b/,
      operator: /\.\.[<*!]?|->|--|\+\+|&&|\|\||\?{1,2}|[-+*/%!=<>]=?|\b(?:gt|gte|lt|lte)\b/,
      punctuation: /[,;.:()[\]{}]/
    };
    n.string[1].inside.interpolation.inside.rest = n, e.languages.ftl = {
      "ftl-comment": {
        pattern: /^<#--[\s\S]*/,
        alias: "comment"
      },
      "ftl-directive": {
        pattern: /^<[\s\S]+>$/,
        inside: {
          directive: {
            pattern: /(^<\/?)[#@][a-z]\w*/i,
            lookbehind: !0,
            alias: "keyword"
          },
          punctuation: /^<\/?|\/?>$/,
          content: {
            pattern: /\s*\S[\s\S]*/,
            alias: "ftl",
            inside: n
          }
        }
      },
      "ftl-interpolation": {
        pattern: /^\$\{[\s\S]*\}$/,
        inside: {
          punctuation: /^\$\{|\}$/,
          content: {
            pattern: /\s*\S[\s\S]*/,
            alias: "ftl",
            inside: n
          }
        }
      }
    }, e.hooks.add("before-tokenize", function (r) {
      var n = RegExp(/<#--[\s\S]*?-->|<\/?[#@][a-zA-Z](?:<expr>)*?>|\$\{(?:<expr>)*?\}/.source.replace(/<expr>/g, function () {
        return t;
      }), "gi");
      e.languages["markup-templating"].buildPlaceholders(r, "ftl", n);
    }), e.hooks.add("after-tokenize", function (t) {
      e.languages["markup-templating"].tokenizePlaceholders(t, "ftl");
    });
  }(e);
}

ftl.displayName = "ftl", ftl.aliases = [];
var gap_1 = gap$1;

function gap$1(e) {
  e.languages.gap = {
    shell: {
      pattern: /^gap>[\s\S]*?(?=^gap>|$(?![\s\S]))/m,
      greedy: !0,
      inside: {
        gap: {
          pattern: /^(gap>).+(?:(?:\r(?:\n|(?!\n))|\n)>.*)*/,
          lookbehind: !0,
          inside: null
        },
        punctuation: /^gap>/
      }
    },
    comment: {
      pattern: /#.*/,
      greedy: !0
    },
    string: {
      pattern: /(^|[^\\'"])(?:'(?:[^\r\n\\']|\\.){1,10}'|"(?:[^\r\n\\"]|\\.)*"(?!")|"""[\s\S]*?""")/,
      lookbehind: !0,
      greedy: !0,
      inside: {
        continuation: {
          pattern: /([\r\n])>/,
          lookbehind: !0,
          alias: "punctuation"
        }
      }
    },
    keyword: /\b(?:Assert|Info|IsBound|QUIT|TryNextMethod|Unbind|and|atomic|break|continue|do|elif|else|end|fi|for|function|if|in|local|mod|not|od|or|quit|readonly|readwrite|rec|repeat|return|then|until|while)\b/,
    boolean: /\b(?:false|true)\b/,
    function: /\b[a-z_]\w*(?=\s*\()/i,
    number: {
      pattern: /(^|[^\w.]|\.\.)(?:\d+(?:\.\d*)?|\.\d+)(?:[eE][+-]?\d+)?(?:_[a-z]?)?(?=$|[^\w.]|\.\.)/,
      lookbehind: !0
    },
    continuation: {
      pattern: /([\r\n])>/,
      lookbehind: !0,
      alias: "punctuation"
    },
    operator: /->|[-+*/^~=!]|<>|[<>]=?|:=|\.\./,
    punctuation: /[()[\]{},;.:]/
  }, e.languages.gap.shell.inside.gap.inside = e.languages.gap;
}

gap$1.displayName = "gap", gap$1.aliases = [];
var gcode_1 = gcode;

function gcode(e) {
  e.languages.gcode = {
    comment: /;.*|\B\(.*?\)\B/,
    string: {
      pattern: /"(?:""|[^"])*"/,
      greedy: !0
    },
    keyword: /\b[GM]\d+(?:\.\d+)?\b/,
    property: /\b[A-Z]/,
    checksum: {
      pattern: /(\*)\d+/,
      lookbehind: !0,
      alias: "number"
    },
    punctuation: /[:*]/
  };
}

gcode.displayName = "gcode", gcode.aliases = [];
var gdscript_1 = gdscript;

function gdscript(e) {
  e.languages.gdscript = {
    comment: /#.*/,
    string: {
      pattern: /@?(?:("|')(?:(?!\1)[^\n\\]|\\[\s\S])*\1(?!"|')|"""(?:[^\\]|\\[\s\S])*?""")/,
      greedy: !0
    },
    "class-name": {
      pattern: /(^(?:class|class_name|extends)[ \t]+|^export\([ \t]*|\bas[ \t]+|(?:\b(?:const|var)[ \t]|[,(])[ \t]*\w+[ \t]*:[ \t]*|->[ \t]*)[a-zA-Z_]\w*/m,
      lookbehind: !0
    },
    keyword: /\b(?:and|as|assert|break|breakpoint|class|class_name|const|continue|elif|else|enum|export|extends|for|func|if|in|is|master|mastersync|match|not|null|onready|or|pass|preload|puppet|puppetsync|remote|remotesync|return|self|setget|signal|static|tool|var|while|yield)\b/,
    function: /\b[a-z_]\w*(?=[ \t]*\()/i,
    variable: /\$\w+/,
    number: [/\b0b[01_]+\b|\b0x[\da-fA-F_]+\b|(?:\b\d[\d_]*(?:\.[\d_]*)?|\B\.[\d_]+)(?:e[+-]?[\d_]+)?\b/, /\b(?:INF|NAN|PI|TAU)\b/],
    constant: /\b[A-Z][A-Z_\d]*\b/,
    boolean: /\b(?:false|true)\b/,
    operator: /->|:=|&&|\|\||<<|>>|[-+*/%&|!<>=]=?|[~^]/,
    punctuation: /[.:,;()[\]{}]/
  };
}

gdscript.displayName = "gdscript", gdscript.aliases = [];
var gedcom_1 = gedcom;

function gedcom(e) {
  e.languages.gedcom = {
    "line-value": {
      pattern: /(^[\t ]*\d+ +(?:@\w[\w!"$%&'()*+,\-./:;<=>?[\\\]^`{|}~\x80-\xfe #]*@ +)?\w+ ).+/m,
      lookbehind: !0,
      inside: {
        pointer: {
          pattern: /^@\w[\w!"$%&'()*+,\-./:;<=>?[\\\]^`{|}~\x80-\xfe #]*@$/,
          alias: "variable"
        }
      }
    },
    tag: {
      pattern: /(^[\t ]*\d+ +(?:@\w[\w!"$%&'()*+,\-./:;<=>?[\\\]^`{|}~\x80-\xfe #]*@ +)?)\w+/m,
      lookbehind: !0,
      alias: "string"
    },
    level: {
      pattern: /(^[\t ]*)\d+/m,
      lookbehind: !0,
      alias: "number"
    },
    pointer: {
      pattern: /@\w[\w!"$%&'()*+,\-./:;<=>?[\\\]^`{|}~\x80-\xfe #]*@/,
      alias: "variable"
    }
  };
}

gedcom.displayName = "gedcom", gedcom.aliases = [];
var gherkin_1 = gherkin;

function gherkin(e) {
  !function (e) {
    var t = /(?:\r?\n|\r)[ \t]*\|.+\|(?:(?!\|).)*/.source;
    e.languages.gherkin = {
      pystring: {
        pattern: /("""|''')[\s\S]+?\1/,
        alias: "string"
      },
      comment: {
        pattern: /(^[ \t]*)#.*/m,
        lookbehind: !0
      },
      tag: {
        pattern: /(^[ \t]*)@\S*/m,
        lookbehind: !0
      },
      feature: {
        pattern: /((?:^|\r?\n|\r)[ \t]*)(?:Ability|Ahoy matey!|Arwedd|Aspekt|Besigheid Behoefte|Business Need|Caracteristica|Característica|Egenskab|Egenskap|Eiginleiki|Feature|Fīča|Fitur|Fonctionnalité|Fonksyonalite|Funcionalidade|Funcionalitat|Functionalitate|Funcţionalitate|Funcționalitate|Functionaliteit|Fungsi|Funkcia|Funkcija|Funkcionalitāte|Funkcionalnost|Funkcja|Funksie|Funktionalität|Funktionalitéit|Funzionalità|Hwaet|Hwæt|Jellemző|Karakteristik|Lastnost|Mak|Mogucnost|laH|Mogućnost|Moznosti|Možnosti|OH HAI|Omadus|Ominaisuus|Osobina|Özellik|Potrzeba biznesowa|perbogh|poQbogh malja'|Požadavek|Požiadavka|Pretty much|Qap|Qu'meH 'ut|Savybė|Tính năng|Trajto|Vermoë|Vlastnosť|Właściwość|Značilnost|Δυνατότητα|Λειτουργία|Могућност|Мөмкинлек|Особина|Свойство|Үзенчәлеклелек|Функционал|Функционалност|Функция|Функціонал|תכונה|خاصية|خصوصیت|صلاحیت|کاروبار کی ضرورت|وِیژگی|रूप लेख|ਖਾਸੀਅਤ|ਨਕਸ਼ ਨੁਹਾਰ|ਮੁਹਾਂਦਰਾ|గుణము|ಹೆಚ್ಚಳ|ความต้องการทางธุรกิจ|ความสามารถ|โครงหลัก|기능|フィーチャ|功能|機能):(?:[^:\r\n]+(?:\r?\n|\r|$))*/,
        lookbehind: !0,
        inside: {
          important: {
            pattern: /(:)[^\r\n]+/,
            lookbehind: !0
          },
          keyword: /[^:\r\n]+:/
        }
      },
      scenario: {
        pattern: /(^[ \t]*)(?:Abstract Scenario|Abstrakt Scenario|Achtergrond|Aer|Ær|Agtergrond|All y'all|Antecedentes|Antecedents|Atburðarás|Atburðarásir|Awww, look mate|B4|Background|Baggrund|Bakgrund|Bakgrunn|Bakgrunnur|Beispiele|Beispiller|Bối cảnh|Cefndir|Cenario|Cenário|Cenario de Fundo|Cenário de Fundo|Cenarios|Cenários|Contesto|Context|Contexte|Contexto|Conto|Contoh|Contone|Dæmi|Dasar|Dead men tell no tales|Delineacao do Cenario|Delineação do Cenário|Dis is what went down|Dữ liệu|Dyagram Senaryo|Dyagram senaryo|Egzanp|Ejemplos|Eksempler|Ekzemploj|Enghreifftiau|Esbozo do escenario|Escenari|Escenario|Esempi|Esquema de l'escenari|Esquema del escenario|Esquema do Cenario|Esquema do Cenário|EXAMPLZ|Examples|Exempel|Exemple|Exemples|Exemplos|First off|Fono|Forgatókönyv|Forgatókönyv vázlat|Fundo|Geçmiş|Grundlage|Hannergrond|ghantoH|Háttér|Heave to|Istorik|Juhtumid|Keadaan|Khung kịch bản|Khung tình huống|Kịch bản|Koncept|Konsep skenario|Kontèks|Kontekst|Kontekstas|Konteksts|Kontext|Konturo de la scenaro|Latar Belakang|lut chovnatlh|lut|lutmey|Lýsing Atburðarásar|Lýsing Dæma|MISHUN SRSLY|MISHUN|Menggariskan Senario|mo'|Náčrt Scenára|Náčrt Scénáře|Náčrt Scenáru|Oris scenarija|Örnekler|Osnova|Osnova Scenára|Osnova scénáře|Osnutek|Ozadje|Paraugs|Pavyzdžiai|Példák|Piemēri|Plan du scénario|Plan du Scénario|Plan Senaryo|Plan senaryo|Plang vum Szenario|Pozadí|Pozadie|Pozadina|Príklady|Příklady|Primer|Primeri|Primjeri|Przykłady|Raamstsenaarium|Reckon it's like|Rerefons|Scenár|Scénář|Scenarie|Scenarij|Scenarijai|Scenarijaus šablonas|Scenariji|Scenārijs|Scenārijs pēc parauga|Scenarijus|Scenario|Scénario|Scenario Amlinellol|Scenario Outline|Scenario Template|Scenariomal|Scenariomall|Scenarios|Scenariu|Scenariusz|Scenaro|Schema dello scenario|Se ðe|Se the|Se þe|Senario|Senaryo Deskripsyon|Senaryo deskripsyon|Senaryo|Senaryo taslağı|Shiver me timbers|Situācija|Situai|Situasie Uiteensetting|Situasie|Skenario konsep|Skenario|Skica|Structura scenariu|Structură scenariu|Struktura scenarija|Stsenaarium|Swa hwaer swa|Swa|Swa hwær swa|Szablon scenariusza|Szenario|Szenariogrundriss|Tapaukset|Tapaus|Tapausaihio|Taust|Tausta|Template Keadaan|Template Senario|Template Situai|The thing of it is|Tình huống|Variantai|Voorbeelde|Voorbeelden|Wharrimean is|Yo-ho-ho|You'll wanna|Założenia|Παραδείγματα|Περιγραφή Σεναρίου|Σενάρια|Σενάριο|Υπόβαθρο|Кереш|Контекст|Концепт|Мисаллар|Мисоллар|Основа|Передумова|Позадина|Предистория|Предыстория|Приклади|Пример|Примери|Примеры|Рамка на сценарий|Скица|Структура сценарија|Структура сценария|Структура сценарію|Сценарий|Сценарий структураси|Сценарийның төзелеше|Сценарији|Сценарио|Сценарій|Тарих|Үрнәкләр|דוגמאות|רקע|תבנית תרחיש|תרחיש|الخلفية|الگوی سناریو|امثلة|پس منظر|زمینه|سناریو|سيناريو|سيناريو مخطط|مثالیں|منظر نامے کا خاکہ|منظرنامہ|نمونه ها|उदाहरण|परिदृश्य|परिदृश्य रूपरेखा|पृष्ठभूमि|ਉਦਾਹਰਨਾਂ|ਪਟਕਥਾ|ਪਟਕਥਾ ਢਾਂਚਾ|ਪਟਕਥਾ ਰੂਪ ਰੇਖਾ|ਪਿਛੋਕੜ|ఉదాహరణలు|కథనం|నేపథ్యం|సన్నివేశం|ಉದಾಹರಣೆಗಳು|ಕಥಾಸಾರಾಂಶ|ವಿವರಣೆ|ಹಿನ್ನೆಲೆ|โครงสร้างของเหตุการณ์|ชุดของตัวอย่าง|ชุดของเหตุการณ์|แนวคิด|สรุปเหตุการณ์|เหตุการณ์|배경|시나리오|시나리오 개요|예|サンプル|シナリオ|シナリオアウトライン|シナリオテンプレ|シナリオテンプレート|テンプレ|例|例子|剧本|剧本大纲|劇本|劇本大綱|场景|场景大纲|場景|場景大綱|背景):[^:\r\n]*/m,
        lookbehind: !0,
        inside: {
          important: {
            pattern: /(:)[^\r\n]*/,
            lookbehind: !0
          },
          keyword: /[^:\r\n]+:/
        }
      },
      "table-body": {
        pattern: RegExp("(" + t + ")(?:" + t + ")+"),
        lookbehind: !0,
        inside: {
          outline: {
            pattern: /<[^>]+>/,
            alias: "variable"
          },
          td: {
            pattern: /\s*[^\s|][^|]*/,
            alias: "string"
          },
          punctuation: /\|/
        }
      },
      "table-head": {
        pattern: RegExp(t),
        inside: {
          th: {
            pattern: /\s*[^\s|][^|]*/,
            alias: "variable"
          },
          punctuation: /\|/
        }
      },
      atrule: {
        pattern: /(^[ \t]+)(?:'a|'ach|'ej|7|a|A také|A taktiež|A tiež|A zároveň|Aber|Ac|Adott|Akkor|Ak|Aleshores|Ale|Ali|Allora|Alors|Als|Ama|Amennyiben|Amikor|Ampak|an|AN|Ananging|And y'all|And|Angenommen|Anrhegedig a|An|Apabila|Atès|Atesa|Atunci|Avast!|Aye|A|awer|Bagi|Banjur|Bet|Biết|Blimey!|Buh|But at the end of the day I reckon|But y'all|But|BUT|Cal|Când|Cand|Cando|Ce|Cuando|Če|Ða ðe|Ða|Dadas|Dada|Dados|Dado|DaH ghu' bejlu'|dann|Dann|Dano|Dan|Dar|Dat fiind|Data|Date fiind|Date|Dati fiind|Dati|Daţi fiind|Dați fiind|DEN|Dato|De|Den youse gotta|Dengan|Diberi|Diyelim ki|Donada|Donat|Donitaĵo|Do|Dun|Duota|Ðurh|Eeldades|Ef|Eğer ki|Entao|Então|Entón|E|En|Entonces|Epi|És|Etant donnée|Etant donné|Et|Étant données|Étant donnée|Étant donné|Etant données|Etant donnés|Étant donnés|Fakat|Gangway!|Gdy|Gegeben seien|Gegeben sei|Gegeven|Gegewe|ghu' noblu'|Gitt|Given y'all|Given|Givet|Givun|Ha|Cho|I CAN HAZ|In|Ir|It's just unbelievable|I|Ja|Jeśli|Jeżeli|Kad|Kada|Kadar|Kai|Kaj|Když|Keď|Kemudian|Ketika|Khi|Kiedy|Ko|Kuid|Kui|Kun|Lan|latlh|Le sa a|Let go and haul|Le|Lè sa a|Lè|Logo|Lorsqu'<|Lorsque|mä|Maar|Mais|Mając|Ma|Majd|Maka|Manawa|Mas|Men|Menawa|Mutta|Nalika|Nalikaning|Nanging|Når|När|Nato|Nhưng|Niin|Njuk|O zaman|Och|Og|Oletetaan|Ond|Onda|Oraz|Pak|Pero|Però|Podano|Pokiaľ|Pokud|Potem|Potom|Privzeto|Pryd|Quan|Quand|Quando|qaSDI'|Så|Sed|Se|Siis|Sipoze ke|Sipoze Ke|Sipoze|Si|Şi|Și|Soit|Stel|Tada|Tad|Takrat|Tak|Tapi|Ter|Tetapi|Tha the|Tha|Then y'all|Then|Thì|Thurh|Toda|Too right|Un|Und|ugeholl|Và|vaj|Vendar|Ve|wann|Wanneer|WEN|Wenn|When y'all|When|Wtedy|Wun|Y'know|Yeah nah|Yna|Youse know like when|Youse know when youse got|Y|Za predpokladu|Za předpokladu|Zadan|Zadani|Zadano|Zadate|Zadato|Zakładając|Zaradi|Zatati|Þa þe|Þa|Þá|Þegar|Þurh|Αλλά|Δεδομένου|Και|Όταν|Τότε|А також|Агар|Але|Али|Аммо|А|Әгәр|Әйтик|Әмма|Бирок|Ва|Вә|Дадено|Дано|Допустим|Если|Задате|Задати|Задато|И|І|К тому же|Када|Кад|Когато|Когда|Коли|Ләкин|Лекин|Нәтиҗәдә|Нехай|Но|Онда|Припустимо, що|Припустимо|Пусть|Также|Та|Тогда|Тоді|То|Унда|Һәм|Якщо|אבל|אזי|אז|בהינתן|וגם|כאשר|آنگاه|اذاً|اگر|اما|اور|با فرض|بالفرض|بفرض|پھر|تب|ثم|جب|عندما|فرض کیا|لكن|لیکن|متى|هنگامی|و|अगर|और|कदा|किन्तु|चूंकि|जब|तथा|तदा|तब|परन्तु|पर|यदि|ਅਤੇ|ਜਦੋਂ|ਜਿਵੇਂ ਕਿ|ਜੇਕਰ|ਤਦ|ਪਰ|అప్పుడు|ఈ పరిస్థితిలో|కాని|చెప్పబడినది|మరియు|ಆದರೆ|ನಂತರ|ನೀಡಿದ|ಮತ್ತು|ಸ್ಥಿತಿಯನ್ನು|กำหนดให้|ดังนั้น|แต่|เมื่อ|และ|그러면<|그리고<|단<|만약<|만일<|먼저<|조건<|하지만<|かつ<|しかし<|ただし<|ならば<|もし<|並且<|但し<|但是<|假如<|假定<|假設<|假设<|前提<|同时<|同時<|并且<|当<|當<|而且<|那么<|那麼<)(?=[ \t])/m,
        lookbehind: !0
      },
      string: {
        pattern: /"(?:\\.|[^"\\\r\n])*"|'(?:\\.|[^'\\\r\n])*'/,
        inside: {
          outline: {
            pattern: /<[^>]+>/,
            alias: "variable"
          }
        }
      },
      outline: {
        pattern: /<[^>]+>/,
        alias: "variable"
      }
    };
  }(e);
}

gherkin.displayName = "gherkin", gherkin.aliases = [];
var git_1 = git;

function git(e) {
  e.languages.git = {
    comment: /^#.*/m,
    deleted: /^[-–].*/m,
    inserted: /^\+.*/m,
    string: /("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
    command: {
      pattern: /^.*\$ git .*$/m,
      inside: {
        parameter: /\s--?\w+/
      }
    },
    coord: /^@@.*@@$/m,
    "commit-sha1": /^commit \w{40}$/m
  };
}

git.displayName = "git", git.aliases = [];
var refractorC$3 = c_1,
    glsl_1 = glsl;

function glsl(e) {
  e.register(refractorC$3), e.languages.glsl = e.languages.extend("c", {
    keyword: /\b(?:active|asm|atomic_uint|attribute|[ibdu]?vec[234]|bool|break|buffer|case|cast|centroid|class|coherent|common|const|continue|d?mat[234](?:x[234])?|default|discard|do|double|else|enum|extern|external|false|filter|fixed|flat|float|for|fvec[234]|goto|half|highp|hvec[234]|[iu]?sampler2DMS(?:Array)?|[iu]?sampler2DRect|[iu]?samplerBuffer|[iu]?samplerCube|[iu]?samplerCubeArray|[iu]?sampler[123]D|[iu]?sampler[12]DArray|[iu]?image2DMS(?:Array)?|[iu]?image2DRect|[iu]?imageBuffer|[iu]?imageCube|[iu]?imageCubeArray|[iu]?image[123]D|[iu]?image[12]DArray|if|in|inline|inout|input|int|interface|invariant|layout|long|lowp|mediump|namespace|noinline|noperspective|out|output|partition|patch|precise|precision|public|readonly|resource|restrict|return|sample|sampler[12]DArrayShadow|sampler[12]DShadow|sampler2DRectShadow|sampler3DRect|samplerCubeArrayShadow|samplerCubeShadow|shared|short|sizeof|smooth|static|struct|subroutine|superp|switch|template|this|true|typedef|uint|uniform|union|unsigned|using|varying|void|volatile|while|writeonly)\b/
  });
}

glsl.displayName = "glsl", glsl.aliases = [];
var gml_1 = gml;

function gml(e) {
  e.languages.gamemakerlanguage = e.languages.gml = e.languages.extend("clike", {
    keyword: /\b(?:break|case|continue|default|do|else|enum|exit|for|globalvar|if|repeat|return|switch|until|var|while)\b/,
    number: /(?:\b0x[\da-f]+|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?)[ulf]{0,4}/i,
    operator: /--|\+\+|[-+%/=]=?|!=|\*\*?=?|<[<=>]?|>[=>]?|&&?|\^\^?|\|\|?|~|\b(?:and|at|not|or|with|xor)\b/,
    constant: /\b(?:GM_build_date|GM_version|action_(?:continue|restart|reverse|stop)|all|gamespeed_(?:fps|microseconds)|global|local|noone|other|pi|pointer_(?:invalid|null)|self|timezone_(?:local|utc)|undefined|ev_(?:create|destroy|step|alarm|keyboard|mouse|collision|other|draw|draw_(?:begin|end|post|pre)|keypress|keyrelease|trigger|(?:left|middle|no|right)_button|(?:left|middle|right)_press|(?:left|middle|right)_release|mouse_(?:enter|leave|wheel_down|wheel_up)|global_(?:left|middle|right)_button|global_(?:left|middle|right)_press|global_(?:left|middle|right)_release|joystick(?:1|2)_(?:button1|button2|button3|button4|button5|button6|button7|button8|down|left|right|up)|outside|boundary|game_start|game_end|room_start|room_end|no_more_lives|animation_end|end_of_path|no_more_health|user\d|gui|gui_begin|gui_end|step_(?:begin|end|normal))|vk_(?:alt|anykey|backspace|control|delete|down|end|enter|escape|home|insert|left|nokey|pagedown|pageup|pause|printscreen|return|right|shift|space|tab|up|f\d|numpad\d|add|decimal|divide|lalt|lcontrol|lshift|multiply|ralt|rcontrol|rshift|subtract)|achievement_(?:filter_(?:all_players|favorites_only|friends_only)|friends_info|info|leaderboard_info|our_info|pic_loaded|show_(?:achievement|bank|friend_picker|leaderboard|profile|purchase_prompt|ui)|type_challenge|type_score_challenge)|asset_(?:font|object|path|room|script|shader|sound|sprite|tiles|timeline|unknown)|audio_(?:3d|falloff_(?:exponent_distance|exponent_distance_clamped|inverse_distance|inverse_distance_clamped|linear_distance|linear_distance_clamped|none)|mono|new_system|old_system|stereo)|bm_(?:add|complex|dest_alpha|dest_color|dest_colour|inv_dest_alpha|inv_dest_color|inv_dest_colour|inv_src_alpha|inv_src_color|inv_src_colour|max|normal|one|src_alpha|src_alpha_sat|src_color|src_colour|subtract|zero)|browser_(?:chrome|firefox|ie|ie_mobile|not_a_browser|opera|safari|safari_mobile|tizen|unknown|windows_store)|buffer_(?:bool|f16|f32|f64|fast|fixed|generalerror|grow|invalidtype|network|outofbounds|outofspace|s16|s32|s8|seek_end|seek_relative|seek_start|string|text|u16|u32|u64|u8|vbuffer|wrap)|c_(?:aqua|black|blue|dkgray|fuchsia|gray|green|lime|ltgray|maroon|navy|olive|orange|purple|red|silver|teal|white|yellow)|cmpfunc_(?:always|equal|greater|greaterequal|less|lessequal|never|notequal)|cr_(?:appstart|arrow|beam|cross|default|drag|handpoint|hourglass|none|size_all|size_nesw|size_ns|size_nwse|size_we|uparrow)|cull_(?:clockwise|counterclockwise|noculling)|device_(?:emulator|tablet)|device_ios_(?:ipad|ipad_retina|iphone|iphone5|iphone6|iphone6plus|iphone_retina|unknown)|display_(?:landscape|landscape_flipped|portrait|portrait_flipped)|dll_(?:cdecl|cdel|stdcall)|ds_type_(?:grid|list|map|priority|queue|stack)|ef_(?:cloud|ellipse|explosion|firework|flare|rain|ring|smoke|smokeup|snow|spark|star)|fa_(?:archive|bottom|center|directory|hidden|left|middle|readonly|right|sysfile|top|volumeid)|fb_login_(?:default|fallback_to_webview|forcing_safari|forcing_webview|no_fallback_to_webview|use_system_account)|iap_(?:available|canceled|ev_consume|ev_product|ev_purchase|ev_restore|ev_storeload|failed|purchased|refunded|status_available|status_loading|status_processing|status_restoring|status_unavailable|status_uninitialised|storeload_failed|storeload_ok|unavailable)|leaderboard_type_(?:number|time_mins_secs)|lighttype_(?:dir|point)|matrix_(?:projection|view|world)|mb_(?:any|left|middle|none|right)|network_(?:config_(?:connect_timeout|disable_reliable_udp|enable_reliable_udp|use_non_blocking_socket)|socket_(?:bluetooth|tcp|udp)|type_(?:connect|data|disconnect|non_blocking_connect))|of_challenge_(?:lose|tie|win)|os_(?:android|ios|linux|macosx|ps3|ps4|psvita|unknown|uwp|win32|win8native|windows|winphone|xboxone)|phy_debug_render_(?:aabb|collision_pairs|coms|core_shapes|joints|obb|shapes)|phy_joint_(?:anchor_1_x|anchor_1_y|anchor_2_x|anchor_2_y|angle|angle_limits|damping_ratio|frequency|length_1|length_2|lower_angle_limit|max_force|max_length|max_motor_force|max_motor_torque|max_torque|motor_force|motor_speed|motor_torque|reaction_force_x|reaction_force_y|reaction_torque|speed|translation|upper_angle_limit)|phy_particle_data_flag_(?:category|color|colour|position|typeflags|velocity)|phy_particle_flag_(?:colormixing|colourmixing|elastic|powder|spring|tensile|viscous|wall|water|zombie)|phy_particle_group_flag_(?:rigid|solid)|pr_(?:linelist|linestrip|pointlist|trianglefan|trianglelist|trianglestrip)|ps_(?:distr|shape)_(?:diamond|ellipse|gaussian|invgaussian|line|linear|rectangle)|pt_shape_(?:circle|cloud|disk|explosion|flare|line|pixel|ring|smoke|snow|spark|sphere|square|star)|ty_(?:real|string)|gp_(?:face\d|axislh|axislv|axisrh|axisrv|padd|padl|padr|padu|select|shoulderl|shoulderlb|shoulderr|shoulderrb|start|stickl|stickr)|lb_disp_(?:none|numeric|time_ms|time_sec)|lb_sort_(?:ascending|descending|none)|ov_(?:achievements|community|friends|gamegroup|players|settings)|ugc_(?:filetype_(?:community|microtrans)|list_(?:Favorited|Followed|Published|Subscribed|UsedOrPlayed|VotedDown|VotedOn|VotedUp|WillVoteLater)|match_(?:AllGuides|Artwork|Collections|ControllerBindings|IntegratedGuides|Items|Items_Mtx|Items_ReadyToUse|Screenshots|UsableInGame|Videos|WebGuides)|query_(?:AcceptedForGameRankedByAcceptanceDate|CreatedByFriendsRankedByPublicationDate|FavoritedByFriendsRankedByPublicationDate|NotYetRated)|query_RankedBy(?:NumTimesReported|PublicationDate|TextSearch|TotalVotesAsc|Trend|Vote|VotesUp)|result_success|sortorder_CreationOrder(?:Asc|Desc)|sortorder_(?:ForModeration|LastUpdatedDesc|SubscriptionDateDesc|TitleAsc|VoteScoreDesc)|visibility_(?:friends_only|private|public))|vertex_usage_(?:binormal|blendindices|blendweight|color|colour|depth|fog|normal|position|psize|sample|tangent|texcoord|textcoord)|vertex_type_(?:float\d|color|colour|ubyte4)|input_type|layerelementtype_(?:background|instance|oldtilemap|particlesystem|sprite|tile|tilemap|undefined)|se_(?:chorus|compressor|echo|equalizer|flanger|gargle|none|reverb)|text_type|tile_(?:flip|index_mask|mirror|rotate)|(?:obj|rm|scr|spr)\w+)\b/,
    variable: /\b(?:alarm|application_surface|async_load|background_(?:alpha|blend|color|colour|foreground|height|hspeed|htiled|index|showcolor|showcolour|visible|vspeed|vtiled|width|x|xscale|y|yscale)|bbox_(?:bottom|left|right|top)|browser_(?:height|width)|caption_(?:health|lives|score)|current_(?:day|hour|minute|month|second|time|weekday|year)|cursor_sprite|debug_mode|delta_time|direction|display_aa|error_(?:last|occurred)|event_(?:action|number|object|type)|fps|fps_real|friction|game_(?:display|project|save)_(?:id|name)|gamemaker_(?:pro|registered|version)|gravity|gravity_direction|(?:h|v)speed|health|iap_data|id|image_(?:alpha|angle|blend|depth|index|number|speed|xscale|yscale)|instance_(?:count|id)|keyboard_(?:key|lastchar|lastkey|string)|layer|lives|mask_index|mouse_(?:button|lastbutton|x|y)|object_index|os_(?:browser|device|type|version)|path_(?:endaction|index|orientation|position|positionprevious|scale|speed)|persistent|phy_(?:rotation|(?:col_normal|collision|com|linear_velocity|position|speed)_(?:x|y)|angular_(?:damping|velocity)|position_(?:x|y)previous|speed|linear_damping|bullet|fixed_rotation|active|mass|inertia|dynamic|kinematic|sleeping|collision_points)|pointer_(?:invalid|null)|room|room_(?:caption|first|height|last|persistent|speed|width)|score|secure_mode|show_(?:health|lives|score)|solid|speed|sprite_(?:height|index|width|xoffset|yoffset)|temp_directory|timeline_(?:index|loop|position|running|speed)|transition_(?:color|kind|steps)|undefined|view_(?:angle|current|enabled|(?:h|v)(?:border|speed)|(?:h|w|x|y)port|(?:h|w|x|y)view|object|surface_id|visible)|visible|webgl_enabled|working_directory|(?:x|y)(?:previous|start)|x|y|argument(?:_relitive|_count|\d)|argument|global|local|other|self)\b/
  });
}

gml.displayName = "gml", gml.aliases = [];
var gn_1 = gn;

function gn(e) {
  e.languages.gn = {
    comment: {
      pattern: /#.*/,
      greedy: !0
    },
    "string-literal": {
      pattern: /(^|[^\\"])"(?:[^\r\n"\\]|\\.)*"/,
      lookbehind: !0,
      greedy: !0,
      inside: {
        interpolation: {
          pattern: /((?:^|[^\\])(?:\\{2})*)\$(?:\{[\s\S]*?\}|[a-zA-Z_]\w*|0x[a-fA-F0-9]{2})/,
          lookbehind: !0,
          inside: {
            number: /^\$0x[\s\S]{2}$/,
            variable: /^\$\w+$/,
            "interpolation-punctuation": {
              pattern: /^\$\{|\}$/,
              alias: "punctuation"
            },
            expression: {
              pattern: /[\s\S]+/,
              inside: null
            }
          }
        },
        string: /[\s\S]+/
      }
    },
    keyword: /\b(?:else|if)\b/,
    boolean: /\b(?:false|true)\b/,
    "builtin-function": {
      pattern: /\b(?:assert|defined|foreach|import|pool|print|template|tool|toolchain)(?=\s*\()/i,
      alias: "keyword"
    },
    function: /\b[a-z_]\w*(?=\s*\()/i,
    constant: /\b(?:current_cpu|current_os|current_toolchain|default_toolchain|host_cpu|host_os|root_build_dir|root_gen_dir|root_out_dir|target_cpu|target_gen_dir|target_os|target_out_dir)\b/,
    number: /-?\b\d+\b/,
    operator: /[-+!=<>]=?|&&|\|\|/,
    punctuation: /[(){}[\],.]/
  }, e.languages.gn["string-literal"].inside.interpolation.inside.expression.inside = e.languages.gn, e.languages.gni = e.languages.gn;
}

gn.displayName = "gn", gn.aliases = ["gni"];
var goModule_1 = goModule;

function goModule(e) {
  e.languages["go-mod"] = e.languages["go-module"] = {
    comment: {
      pattern: /\/\/.*/,
      greedy: !0
    },
    version: {
      pattern: /(^|[\s()[\],])v\d+\.\d+\.\d+(?:[+-][-+.\w]*)?(?![^\s()[\],])/,
      lookbehind: !0,
      alias: "number"
    },
    "go-version": {
      pattern: /((?:^|\s)go\s+)\d+(?:\.\d+){1,2}/,
      lookbehind: !0,
      alias: "number"
    },
    keyword: {
      pattern: /^([ \t]*)(?:exclude|go|module|replace|require|retract)\b/m,
      lookbehind: !0
    },
    operator: /=>/,
    punctuation: /[()[\],]/
  };
}

goModule.displayName = "goModule", goModule.aliases = [];
var go_1 = go;

function go(e) {
  e.languages.go = e.languages.extend("clike", {
    string: {
      pattern: /(^|[^\\])"(?:\\.|[^"\\\r\n])*"|`[^`]*`/,
      lookbehind: !0,
      greedy: !0
    },
    keyword: /\b(?:break|case|chan|const|continue|default|defer|else|fallthrough|for|func|go(?:to)?|if|import|interface|map|package|range|return|select|struct|switch|type|var)\b/,
    boolean: /\b(?:_|false|iota|nil|true)\b/,
    number: [/\b0(?:b[01_]+|o[0-7_]+)i?\b/i, /\b0x(?:[a-f\d_]+(?:\.[a-f\d_]*)?|\.[a-f\d_]+)(?:p[+-]?\d+(?:_\d+)*)?i?(?!\w)/i, /(?:\b\d[\d_]*(?:\.[\d_]*)?|\B\.\d[\d_]*)(?:e[+-]?[\d_]+)?i?(?!\w)/i],
    operator: /[*\/%^!=]=?|\+[=+]?|-[=-]?|\|[=|]?|&(?:=|&|\^=?)?|>(?:>=?|=)?|<(?:<=?|=|-)?|:=|\.\.\./,
    builtin: /\b(?:append|bool|byte|cap|close|complex|complex(?:64|128)|copy|delete|error|float(?:32|64)|u?int(?:8|16|32|64)?|imag|len|make|new|panic|print(?:ln)?|real|recover|rune|string|uintptr)\b/
  }), e.languages.insertBefore("go", "string", {
    char: {
      pattern: /'(?:\\.|[^'\\\r\n]){0,10}'/,
      greedy: !0
    }
  }), delete e.languages.go["class-name"];
}

go.displayName = "go", go.aliases = [];
var graphql_1 = graphql;

function graphql(e) {
  e.languages.graphql = {
    comment: /#.*/,
    description: {
      pattern: /(?:"""(?:[^"]|(?!""")")*"""|"(?:\\.|[^\\"\r\n])*")(?=\s*[a-z_])/i,
      greedy: !0,
      alias: "string",
      inside: {
        "language-markdown": {
          pattern: /(^"(?:"")?)(?!\1)[\s\S]+(?=\1$)/,
          lookbehind: !0,
          inside: e.languages.markdown
        }
      }
    },
    string: {
      pattern: /"""(?:[^"]|(?!""")")*"""|"(?:\\.|[^\\"\r\n])*"/,
      greedy: !0
    },
    number: /(?:\B-|\b)\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i,
    boolean: /\b(?:false|true)\b/,
    variable: /\$[a-z_]\w*/i,
    directive: {
      pattern: /@[a-z_]\w*/i,
      alias: "function"
    },
    "attr-name": {
      pattern: /\b[a-z_]\w*(?=\s*(?:\((?:[^()"]|"(?:\\.|[^\\"\r\n])*")*\))?:)/i,
      greedy: !0
    },
    "atom-input": {
      pattern: /\b[A-Z]\w*Input\b/,
      alias: "class-name"
    },
    scalar: /\b(?:Boolean|Float|ID|Int|String)\b/,
    constant: /\b[A-Z][A-Z_\d]*\b/,
    "class-name": {
      pattern: /(\b(?:enum|implements|interface|on|scalar|type|union)\s+|&\s*|:\s*|\[)[A-Z_]\w*/,
      lookbehind: !0
    },
    fragment: {
      pattern: /(\bfragment\s+|\.{3}\s*(?!on\b))[a-zA-Z_]\w*/,
      lookbehind: !0,
      alias: "function"
    },
    "definition-mutation": {
      pattern: /(\bmutation\s+)[a-zA-Z_]\w*/,
      lookbehind: !0,
      alias: "function"
    },
    "definition-query": {
      pattern: /(\bquery\s+)[a-zA-Z_]\w*/,
      lookbehind: !0,
      alias: "function"
    },
    keyword: /\b(?:directive|enum|extend|fragment|implements|input|interface|mutation|on|query|repeatable|scalar|schema|subscription|type|union)\b/,
    operator: /[!=|&]|\.{3}/,
    "property-query": /\w+(?=\s*\()/,
    object: /\w+(?=\s*\{)/,
    punctuation: /[!(){}\[\]:=,]/,
    property: /\w+/
  }, e.hooks.add("after-tokenize", function (e) {
    if ("graphql" === e.language) for (var t = e.tokens.filter(function (e) {
      return "string" != typeof e && "comment" !== e.type && "scalar" !== e.type;
    }), r = 0; r < t.length;) {
      var n = t[r++];

      if ("keyword" === n.type && "mutation" === n.content) {
        var a = [];

        if (d(["definition-mutation", "punctuation"]) && "(" === u(1).content) {
          r += 2;
          var o = p(/^\($/, /^\)$/);
          if (-1 === o) continue;

          for (; r < o; r++) {
            var i = u(0);
            "variable" === i.type && (g(i, "variable-input"), a.push(i.content));
          }

          r = o + 1;
        }

        if (d(["punctuation", "property-query"]) && "{" === u(0).content && (r++, g(u(0), "property-mutation"), a.length > 0)) {
          var s = p(/^\{$/, /^\}$/);
          if (-1 === s) continue;

          for (var l = r; l < s; l++) {
            var c = t[l];
            "variable" === c.type && a.indexOf(c.content) >= 0 && g(c, "variable-input");
          }
        }
      }
    }

    function u(e) {
      return t[r + e];
    }

    function d(e, t) {
      t = t || 0;

      for (var r = 0; r < e.length; r++) {
        var n = u(r + t);
        if (!n || n.type !== e[r]) return !1;
      }

      return !0;
    }

    function p(e, n) {
      for (var a = 1, o = r; o < t.length; o++) {
        var i = t[o],
            s = i.content;
        if ("punctuation" === i.type && "string" == typeof s) if (e.test(s)) a++;else if (n.test(s) && 0 === --a) return o;
      }

      return -1;
    }

    function g(e, t) {
      var r = e.alias;
      r ? Array.isArray(r) || (e.alias = r = [r]) : e.alias = r = [], r.push(t);
    }
  });
}

graphql.displayName = "graphql", graphql.aliases = [];
var groovy_1 = groovy;

function groovy(e) {
  e.languages.groovy = e.languages.extend("clike", {
    string: [{
      pattern: /("""|''')(?:[^\\]|\\[\s\S])*?\1|\$\/(?:[^/$]|\$(?:[/$]|(?![/$]))|\/(?!\$))*\/\$/,
      greedy: !0
    }, {
      pattern: /(["'/])(?:\\.|(?!\1)[^\\\r\n])*\1/,
      greedy: !0
    }],
    keyword: /\b(?:abstract|as|assert|boolean|break|byte|case|catch|char|class|const|continue|def|default|do|double|else|enum|extends|final|finally|float|for|goto|if|implements|import|in|instanceof|int|interface|long|native|new|package|private|protected|public|return|short|static|strictfp|super|switch|synchronized|this|throw|throws|trait|transient|try|void|volatile|while)\b/,
    number: /\b(?:0b[01_]+|0x[\da-f_]+(?:\.[\da-f_p\-]+)?|[\d_]+(?:\.[\d_]+)?(?:e[+-]?\d+)?)[glidf]?\b/i,
    operator: {
      pattern: /(^|[^.])(?:~|==?~?|\?[.:]?|\*(?:[.=]|\*=?)?|\.[@&]|\.\.<|\.\.(?!\.)|-[-=>]?|\+[+=]?|!=?|<(?:<=?|=>?)?|>(?:>>?=?|=)?|&[&=]?|\|[|=]?|\/=?|\^=?|%=?)/,
      lookbehind: !0
    },
    punctuation: /\.+|[{}[\];(),:$]/
  }), e.languages.insertBefore("groovy", "string", {
    shebang: {
      pattern: /#!.+/,
      alias: "comment"
    }
  }), e.languages.insertBefore("groovy", "punctuation", {
    "spock-block": /\b(?:and|cleanup|expect|given|setup|then|when|where):/
  }), e.languages.insertBefore("groovy", "function", {
    annotation: {
      pattern: /(^|[^.])@\w+/,
      lookbehind: !0,
      alias: "punctuation"
    }
  }), e.hooks.add("wrap", function (t) {
    if ("groovy" === t.language && "string" === t.type) {
      var r = t.content.value[0];

      if ("'" != r) {
        var n = /([^\\])(?:\$(?:\{.*?\}|[\w.]+))/;
        "$" === r && (n = /([^\$])(?:\$(?:\{.*?\}|[\w.]+))/), t.content.value = t.content.value.replace(/&lt;/g, "<").replace(/&amp;/g, "&"), t.content = e.highlight(t.content.value, {
          expression: {
            pattern: n,
            lookbehind: !0,
            inside: e.languages.groovy
          }
        }), t.classes.push("/" === r ? "regex" : "gstring");
      }
    }
  });
}

groovy.displayName = "groovy", groovy.aliases = [];
var refractorRuby = ruby_1,
    haml_1 = haml;

function haml(e) {
  e.register(refractorRuby), function (e) {
    e.languages.haml = {
      "multiline-comment": {
        pattern: /((?:^|\r?\n|\r)([\t ]*))(?:\/|-#).*(?:(?:\r?\n|\r)\2[\t ].+)*/,
        lookbehind: !0,
        alias: "comment"
      },
      "multiline-code": [{
        pattern: /((?:^|\r?\n|\r)([\t ]*)(?:[~-]|[&!]?=)).*,[\t ]*(?:(?:\r?\n|\r)\2[\t ].*,[\t ]*)*(?:(?:\r?\n|\r)\2[\t ].+)/,
        lookbehind: !0,
        inside: e.languages.ruby
      }, {
        pattern: /((?:^|\r?\n|\r)([\t ]*)(?:[~-]|[&!]?=)).*\|[\t ]*(?:(?:\r?\n|\r)\2[\t ].*\|[\t ]*)*/,
        lookbehind: !0,
        inside: e.languages.ruby
      }],
      filter: {
        pattern: /((?:^|\r?\n|\r)([\t ]*)):[\w-]+(?:(?:\r?\n|\r)(?:\2[\t ].+|\s*?(?=\r?\n|\r)))+/,
        lookbehind: !0,
        inside: {
          "filter-name": {
            pattern: /^:[\w-]+/,
            alias: "symbol"
          }
        }
      },
      markup: {
        pattern: /((?:^|\r?\n|\r)[\t ]*)<.+/,
        lookbehind: !0,
        inside: e.languages.markup
      },
      doctype: {
        pattern: /((?:^|\r?\n|\r)[\t ]*)!!!(?: .+)?/,
        lookbehind: !0
      },
      tag: {
        pattern: /((?:^|\r?\n|\r)[\t ]*)[%.#][\w\-#.]*[\w\-](?:\([^)]+\)|\{(?:\{[^}]+\}|[^{}])+\}|\[[^\]]+\])*[\/<>]*/,
        lookbehind: !0,
        inside: {
          attributes: [{
            pattern: /(^|[^#])\{(?:\{[^}]+\}|[^{}])+\}/,
            lookbehind: !0,
            inside: e.languages.ruby
          }, {
            pattern: /\([^)]+\)/,
            inside: {
              "attr-value": {
                pattern: /(=\s*)(?:"(?:\\.|[^\\"\r\n])*"|[^)\s]+)/,
                lookbehind: !0
              },
              "attr-name": /[\w:-]+(?=\s*!?=|\s*[,)])/,
              punctuation: /[=(),]/
            }
          }, {
            pattern: /\[[^\]]+\]/,
            inside: e.languages.ruby
          }],
          punctuation: /[<>]/
        }
      },
      code: {
        pattern: /((?:^|\r?\n|\r)[\t ]*(?:[~-]|[&!]?=)).+/,
        lookbehind: !0,
        inside: e.languages.ruby
      },
      interpolation: {
        pattern: /#\{[^}]+\}/,
        inside: {
          delimiter: {
            pattern: /^#\{|\}$/,
            alias: "punctuation"
          },
          ruby: {
            pattern: /[\s\S]+/,
            inside: e.languages.ruby
          }
        }
      },
      punctuation: {
        pattern: /((?:^|\r?\n|\r)[\t ]*)[~=\-&!]+/,
        lookbehind: !0
      }
    };

    for (var t = ["css", {
      filter: "coffee",
      language: "coffeescript"
    }, "erb", "javascript", "less", "markdown", "ruby", "scss", "textile"], r = {}, n = 0, a = t.length; n < a; n++) {
      var o = t[n];
      o = "string" == typeof o ? {
        filter: o,
        language: o
      } : o, e.languages[o.language] && (r["filter-" + o.filter] = {
        pattern: RegExp("((?:^|\\r?\\n|\\r)([\\t ]*)):{{filter_name}}(?:(?:\\r?\\n|\\r)(?:\\2[\\t ].+|\\s*?(?=\\r?\\n|\\r)))+".replace("{{filter_name}}", function () {
          return o.filter;
        })),
        lookbehind: !0,
        inside: {
          "filter-name": {
            pattern: /^:[\w-]+/,
            alias: "symbol"
          },
          text: {
            pattern: /[\s\S]+/,
            alias: [o.language, "language-" + o.language],
            inside: e.languages[o.language]
          }
        }
      });
    }

    e.languages.insertBefore("haml", "filter", r);
  }(e);
}

haml.displayName = "haml", haml.aliases = [];
var refractorMarkupTemplating$7 = markupTemplating_1,
    handlebars_1 = handlebars;

function handlebars(e) {
  e.register(refractorMarkupTemplating$7), function (e) {
    e.languages.handlebars = {
      comment: /\{\{![\s\S]*?\}\}/,
      delimiter: {
        pattern: /^\{\{\{?|\}\}\}?$/,
        alias: "punctuation"
      },
      string: /(["'])(?:\\.|(?!\1)[^\\\r\n])*\1/,
      number: /\b0x[\dA-Fa-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee][+-]?\d+)?/,
      boolean: /\b(?:false|true)\b/,
      block: {
        pattern: /^(\s*(?:~\s*)?)[#\/]\S+?(?=\s*(?:~\s*)?$|\s)/,
        lookbehind: !0,
        alias: "keyword"
      },
      brackets: {
        pattern: /\[[^\]]+\]/,
        inside: {
          punctuation: /\[|\]/,
          variable: /[\s\S]+/
        }
      },
      punctuation: /[!"#%&':()*+,.\/;<=>@\[\\\]^`{|}~]/,
      variable: /[^!"#%&'()*+,\/;<=>@\[\\\]^`{|}~\s]+/
    }, e.hooks.add("before-tokenize", function (t) {
      e.languages["markup-templating"].buildPlaceholders(t, "handlebars", /\{\{\{[\s\S]+?\}\}\}|\{\{[\s\S]+?\}\}/g);
    }), e.hooks.add("after-tokenize", function (t) {
      e.languages["markup-templating"].tokenizePlaceholders(t, "handlebars");
    }), e.languages.hbs = e.languages.handlebars;
  }(e);
}

handlebars.displayName = "handlebars", handlebars.aliases = ["hbs"];
var haskell_1 = haskell;

function haskell(e) {
  e.languages.haskell = {
    comment: {
      pattern: /(^|[^-!#$%*+=?&@|~.:<>^\\\/])(?:--(?:(?=.)[^-!#$%*+=?&@|~.:<>^\\\/].*|$)|\{-[\s\S]*?-\})/m,
      lookbehind: !0
    },
    char: {
      pattern: /'(?:[^\\']|\\(?:[abfnrtv\\"'&]|\^[A-Z@[\]^_]|ACK|BEL|BS|CAN|CR|DC1|DC2|DC3|DC4|DEL|DLE|EM|ENQ|EOT|ESC|ETB|ETX|FF|FS|GS|HT|LF|NAK|NUL|RS|SI|SO|SOH|SP|STX|SUB|SYN|US|VT|\d+|o[0-7]+|x[0-9a-fA-F]+))'/,
      alias: "string"
    },
    string: {
      pattern: /"(?:[^\\"]|\\(?:\S|\s+\\))*"/,
      greedy: !0
    },
    keyword: /\b(?:case|class|data|deriving|do|else|if|in|infixl|infixr|instance|let|module|newtype|of|primitive|then|type|where)\b/,
    "import-statement": {
      pattern: /(^[\t ]*)import\s+(?:qualified\s+)?(?:[A-Z][\w']*)(?:\.[A-Z][\w']*)*(?:\s+as\s+(?:[A-Z][\w']*)(?:\.[A-Z][\w']*)*)?(?:\s+hiding\b)?/m,
      lookbehind: !0,
      inside: {
        keyword: /\b(?:as|hiding|import|qualified)\b/,
        punctuation: /\./
      }
    },
    builtin: /\b(?:abs|acos|acosh|all|and|any|appendFile|approxRational|asTypeOf|asin|asinh|atan|atan2|atanh|basicIORun|break|catch|ceiling|chr|compare|concat|concatMap|const|cos|cosh|curry|cycle|decodeFloat|denominator|digitToInt|div|divMod|drop|dropWhile|either|elem|encodeFloat|enumFrom|enumFromThen|enumFromThenTo|enumFromTo|error|even|exp|exponent|fail|filter|flip|floatDigits|floatRadix|floatRange|floor|fmap|foldl|foldl1|foldr|foldr1|fromDouble|fromEnum|fromInt|fromInteger|fromIntegral|fromRational|fst|gcd|getChar|getContents|getLine|group|head|id|inRange|index|init|intToDigit|interact|ioError|isAlpha|isAlphaNum|isAscii|isControl|isDenormalized|isDigit|isHexDigit|isIEEE|isInfinite|isLower|isNaN|isNegativeZero|isOctDigit|isPrint|isSpace|isUpper|iterate|last|lcm|length|lex|lexDigits|lexLitChar|lines|log|logBase|lookup|map|mapM|mapM_|max|maxBound|maximum|maybe|min|minBound|minimum|mod|negate|not|notElem|null|numerator|odd|or|ord|otherwise|pack|pi|pred|primExitWith|print|product|properFraction|putChar|putStr|putStrLn|quot|quotRem|range|rangeSize|read|readDec|readFile|readFloat|readHex|readIO|readInt|readList|readLitChar|readLn|readOct|readParen|readSigned|reads|readsPrec|realToFrac|recip|rem|repeat|replicate|return|reverse|round|scaleFloat|scanl|scanl1|scanr|scanr1|seq|sequence|sequence_|show|showChar|showInt|showList|showLitChar|showParen|showSigned|showString|shows|showsPrec|significand|signum|sin|sinh|snd|sort|span|splitAt|sqrt|subtract|succ|sum|tail|take|takeWhile|tan|tanh|threadToIOResult|toEnum|toInt|toInteger|toLower|toRational|toUpper|truncate|uncurry|undefined|unlines|until|unwords|unzip|unzip3|userError|words|writeFile|zip|zip3|zipWith|zipWith3)\b/,
    number: /\b(?:\d+(?:\.\d+)?(?:e[+-]?\d+)?|0o[0-7]+|0x[0-9a-f]+)\b/i,
    operator: [{
      pattern: /`(?:[A-Z][\w']*\.)*[_a-z][\w']*`/,
      greedy: !0
    }, {
      pattern: /(\s)\.(?=\s)/,
      lookbehind: !0
    }, /[-!#$%*+=?&@|~:<>^\\\/][-!#$%*+=?&@|~.:<>^\\\/]*|\.[-!#$%*+=?&@|~.:<>^\\\/]+/],
    hvariable: {
      pattern: /\b(?:[A-Z][\w']*\.)*[_a-z][\w']*/,
      inside: {
        punctuation: /\./
      }
    },
    constant: {
      pattern: /\b(?:[A-Z][\w']*\.)*[A-Z][\w']*/,
      inside: {
        punctuation: /\./
      }
    },
    punctuation: /[{}[\];(),.:]/
  }, e.languages.hs = e.languages.haskell;
}

haskell.displayName = "haskell", haskell.aliases = ["hs"];
var haxe_1 = haxe;

function haxe(e) {
  e.languages.haxe = e.languages.extend("clike", {
    string: {
      pattern: /"(?:[^"\\]|\\[\s\S])*"/,
      greedy: !0
    },
    "class-name": [{
      pattern: /(\b(?:abstract|class|enum|extends|implements|interface|new|typedef)\s+)[A-Z_]\w*/,
      lookbehind: !0
    }, /\b[A-Z]\w*/],
    keyword: /\bthis\b|\b(?:abstract|as|break|case|cast|catch|class|continue|default|do|dynamic|else|enum|extends|extern|final|for|from|function|if|implements|import|in|inline|interface|macro|new|null|operator|overload|override|package|private|public|return|static|super|switch|throw|to|try|typedef|untyped|using|var|while)(?!\.)\b/,
    function: {
      pattern: /\b[a-z_]\w*(?=\s*(?:<[^<>]*>\s*)?\()/i,
      greedy: !0
    },
    operator: /\.{3}|\+\+|--|&&|\|\||->|=>|(?:<<?|>{1,3}|[-+*/%!=&|^])=?|[?:~]/
  }), e.languages.insertBefore("haxe", "string", {
    "string-interpolation": {
      pattern: /'(?:[^'\\]|\\[\s\S])*'/,
      greedy: !0,
      inside: {
        interpolation: {
          pattern: /(^|[^\\])\$(?:\w+|\{[^{}]+\})/,
          lookbehind: !0,
          inside: {
            "interpolation-punctuation": {
              pattern: /^\$\{?|\}$/,
              alias: "punctuation"
            },
            expression: {
              pattern: /[\s\S]+/,
              inside: e.languages.haxe
            }
          }
        },
        string: /[\s\S]+/
      }
    }
  }), e.languages.insertBefore("haxe", "class-name", {
    regex: {
      pattern: /~\/(?:[^\/\\\r\n]|\\.)+\/[a-z]*/,
      greedy: !0,
      inside: {
        "regex-flags": /\b[a-z]+$/,
        "regex-source": {
          pattern: /^(~\/)[\s\S]+(?=\/$)/,
          lookbehind: !0,
          alias: "language-regex",
          inside: e.languages.regex
        },
        "regex-delimiter": /^~\/|\/$/
      }
    }
  }), e.languages.insertBefore("haxe", "keyword", {
    preprocessor: {
      pattern: /#(?:else|elseif|end|if)\b.*/,
      alias: "property"
    },
    metadata: {
      pattern: /@:?[\w.]+/,
      alias: "symbol"
    },
    reification: {
      pattern: /\$(?:\w+|(?=\{))/,
      alias: "important"
    }
  });
}

haxe.displayName = "haxe", haxe.aliases = [];
var hcl_1 = hcl;

function hcl(e) {
  e.languages.hcl = {
    comment: /(?:\/\/|#).*|\/\*[\s\S]*?(?:\*\/|$)/,
    heredoc: {
      pattern: /<<-?(\w+\b)[\s\S]*?^[ \t]*\1/m,
      greedy: !0,
      alias: "string"
    },
    keyword: [{
      pattern: /(?:data|resource)\s+(?:"(?:\\[\s\S]|[^\\"])*")(?=\s+"[\w-]+"\s+\{)/i,
      inside: {
        type: {
          pattern: /(resource|data|\s+)(?:"(?:\\[\s\S]|[^\\"])*")/i,
          lookbehind: !0,
          alias: "variable"
        }
      }
    }, {
      pattern: /(?:backend|module|output|provider|provisioner|variable)\s+(?:[\w-]+|"(?:\\[\s\S]|[^\\"])*")\s+(?=\{)/i,
      inside: {
        type: {
          pattern: /(backend|module|output|provider|provisioner|variable)\s+(?:[\w-]+|"(?:\\[\s\S]|[^\\"])*")\s+/i,
          lookbehind: !0,
          alias: "variable"
        }
      }
    }, /[\w-]+(?=\s+\{)/],
    property: [/[-\w\.]+(?=\s*=(?!=))/, /"(?:\\[\s\S]|[^\\"])+"(?=\s*[:=])/],
    string: {
      pattern: /"(?:[^\\$"]|\\[\s\S]|\$(?:(?=")|\$+(?!\$)|[^"${])|\$\{(?:[^{}"]|"(?:[^\\"]|\\[\s\S])*")*\})*"/,
      greedy: !0,
      inside: {
        interpolation: {
          pattern: /(^|[^$])\$\{(?:[^{}"]|"(?:[^\\"]|\\[\s\S])*")*\}/,
          lookbehind: !0,
          inside: {
            type: {
              pattern: /(\b(?:count|data|local|module|path|self|terraform|var)\b\.)[\w\*]+/i,
              lookbehind: !0,
              alias: "variable"
            },
            keyword: /\b(?:count|data|local|module|path|self|terraform|var)\b/i,
            function: /\w+(?=\()/,
            string: {
              pattern: /"(?:\\[\s\S]|[^\\"])*"/,
              greedy: !0
            },
            number: /\b0x[\da-f]+\b|\b\d+(?:\.\d*)?(?:e[+-]?\d+)?/i,
            punctuation: /[!\$#%&'()*+,.\/;<=>@\[\\\]^`{|}~?:]/
          }
        }
      }
    },
    number: /\b0x[\da-f]+\b|\b\d+(?:\.\d*)?(?:e[+-]?\d+)?/i,
    boolean: /\b(?:false|true)\b/i,
    punctuation: /[=\[\]{}]/
  };
}

hcl.displayName = "hcl", hcl.aliases = [];
var refractorC$2 = c_1,
    hlsl_1 = hlsl;

function hlsl(e) {
  e.register(refractorC$2), e.languages.hlsl = e.languages.extend("c", {
    "class-name": [e.languages.c["class-name"], /\b(?:AppendStructuredBuffer|BlendState|Buffer|ByteAddressBuffer|CompileShader|ComputeShader|ConsumeStructuredBuffer|DepthStencilState|DepthStencilView|DomainShader|GeometryShader|Hullshader|InputPatch|LineStream|OutputPatch|PixelShader|PointStream|RWBuffer|RWByteAddressBuffer|RWStructuredBuffer|RWTexture(?:1D|1DArray|2D|2DArray|3D)|RasterizerState|RenderTargetView|SamplerComparisonState|SamplerState|StructuredBuffer|Texture(?:1D|1DArray|2D|2DArray|2DMS|2DMSArray|3D|Cube|CubeArray)|TriangleStream|VertexShader)\b/],
    keyword: [/\b(?:asm|asm_fragment|auto|break|case|catch|cbuffer|centroid|char|class|column_major|compile|compile_fragment|const|const_cast|continue|default|delete|discard|do|dynamic_cast|else|enum|explicit|export|extern|for|friend|fxgroup|goto|groupshared|if|in|inline|inout|interface|line|lineadj|linear|long|matrix|mutable|namespace|new|nointerpolation|noperspective|operator|out|packoffset|pass|pixelfragment|point|precise|private|protected|public|register|reinterpret_cast|return|row_major|sample|sampler|shared|short|signed|sizeof|snorm|stateblock|stateblock_state|static|static_cast|string|struct|switch|tbuffer|technique|technique10|technique11|template|texture|this|throw|triangle|triangleadj|try|typedef|typename|uniform|union|unorm|unsigned|using|vector|vertexfragment|virtual|void|volatile|while)\b/, /\b(?:bool|double|dword|float|half|int|min(?:10float|12int|16(?:float|int|uint))|uint)(?:[1-4](?:x[1-4])?)?\b/],
    number: /(?:(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[eE][+-]?\d+)?|\b0x[\da-fA-F]+)[fFhHlLuU]?\b/,
    boolean: /\b(?:false|true)\b/
  });
}

hlsl.displayName = "hlsl", hlsl.aliases = [];
var hoon_1 = hoon;

function hoon(e) {
  e.languages.hoon = {
    comment: {
      pattern: /::.*/,
      greedy: !0
    },
    string: {
      pattern: /"[^"]*"|'[^']*'/,
      greedy: !0
    },
    constant: /%(?:\.[ny]|[\w-]+)/,
    "class-name": /@(?:[a-z0-9-]*[a-z0-9])?|\*/i,
    function: /(?:\+[-+] {2})?(?:[a-z](?:[a-z0-9-]*[a-z0-9])?)/,
    keyword: /\.[\^\+\*=\?]|![><:\.=\?!]|=[>|:,\.\-\^<+;/~\*\?]|\?[>|:\.\-\^<\+&~=@!]|\|[\$_%:\.\-\^~\*=@\?]|\+[|\$\+\*]|:[_\-\^\+~\*]|%[_:\.\-\^\+~\*=]|\^[|:\.\-\+&~\*=\?]|\$[|_%:<>\-\^&~@=\?]|;[:<\+;\/~\*=]|~[>|\$_%<\+\/&=\?!]|--|==/
  };
}

hoon.displayName = "hoon", hoon.aliases = [];
var hpkp_1 = hpkp;

function hpkp(e) {
  e.languages.hpkp = {
    directive: {
      pattern: /\b(?:includeSubDomains|max-age|pin-sha256|preload|report-to|report-uri|strict)(?=[\s;=]|$)/i,
      alias: "property"
    },
    operator: /=/,
    punctuation: /;/
  };
}

hpkp.displayName = "hpkp", hpkp.aliases = [];
var hsts_1 = hsts;

function hsts(e) {
  e.languages.hsts = {
    directive: {
      pattern: /\b(?:includeSubDomains|max-age|preload)(?=[\s;=]|$)/i,
      alias: "property"
    },
    operator: /=/,
    punctuation: /;/
  };
}

hsts.displayName = "hsts", hsts.aliases = [];
var http_1 = http;

function http(e) {
  !function (e) {
    function t(e) {
      return RegExp("(^(?:" + e + "):[ \t]*(?![ \t]))[^]+", "i");
    }

    e.languages.http = {
      "request-line": {
        pattern: /^(?:CONNECT|DELETE|GET|HEAD|OPTIONS|PATCH|POST|PRI|PUT|SEARCH|TRACE)\s(?:https?:\/\/|\/)\S*\sHTTP\/[\d.]+/m,
        inside: {
          method: {
            pattern: /^[A-Z]+\b/,
            alias: "property"
          },
          "request-target": {
            pattern: /^(\s)(?:https?:\/\/|\/)\S*(?=\s)/,
            lookbehind: !0,
            alias: "url",
            inside: e.languages.uri
          },
          "http-version": {
            pattern: /^(\s)HTTP\/[\d.]+/,
            lookbehind: !0,
            alias: "property"
          }
        }
      },
      "response-status": {
        pattern: /^HTTP\/[\d.]+ \d+ .+/m,
        inside: {
          "http-version": {
            pattern: /^HTTP\/[\d.]+/,
            alias: "property"
          },
          "status-code": {
            pattern: /^(\s)\d+(?=\s)/,
            lookbehind: !0,
            alias: "number"
          },
          "reason-phrase": {
            pattern: /^(\s).+/,
            lookbehind: !0,
            alias: "string"
          }
        }
      },
      header: {
        pattern: /^[\w-]+:.+(?:(?:\r\n?|\n)[ \t].+)*/m,
        inside: {
          "header-value": [{
            pattern: t(/Content-Security-Policy/.source),
            lookbehind: !0,
            alias: ["csp", "languages-csp"],
            inside: e.languages.csp
          }, {
            pattern: t(/Public-Key-Pins(?:-Report-Only)?/.source),
            lookbehind: !0,
            alias: ["hpkp", "languages-hpkp"],
            inside: e.languages.hpkp
          }, {
            pattern: t(/Strict-Transport-Security/.source),
            lookbehind: !0,
            alias: ["hsts", "languages-hsts"],
            inside: e.languages.hsts
          }, {
            pattern: t(/[^:]+/.source),
            lookbehind: !0
          }],
          "header-name": {
            pattern: /^[^:]+/,
            alias: "keyword"
          },
          punctuation: /^:/
        }
      }
    };
    var r,
        n = e.languages,
        a = {
      "application/javascript": n.javascript,
      "application/json": n.json || n.javascript,
      "application/xml": n.xml,
      "text/xml": n.xml,
      "text/html": n.html,
      "text/css": n.css,
      "text/plain": n.plain
    },
        o = {
      "application/json": !0,
      "application/xml": !0
    };

    function i(e) {
      var t = e.replace(/^[a-z]+\//, "");
      return "(?:" + e + "|" + ("\\w+/(?:[\\w.-]+\\+)+" + t + "(?![+\\w.-])") + ")";
    }

    for (var s in a) {
      if (a[s]) {
        r = r || {};
        var l = o[s] ? i(s) : s;
        r[s.replace(/\//g, "-")] = {
          pattern: RegExp("(" + /content-type:\s*/.source + l + /(?:(?:\r\n?|\n)[\w-].*)*(?:\r(?:\n|(?!\n))|\n)/.source + ")" + /[^ \t\w-][\s\S]*/.source, "i"),
          lookbehind: !0,
          inside: a[s]
        };
      }
    }

    r && e.languages.insertBefore("http", "header", r);
  }(e);
}

http.displayName = "http", http.aliases = [];
var ichigojam_1 = ichigojam;

function ichigojam(e) {
  e.languages.ichigojam = {
    comment: /(?:\B'|REM)(?:[^\n\r]*)/i,
    string: {
      pattern: /"(?:""|[!#$%&'()*,\/:;<=>?^\w +\-.])*"/,
      greedy: !0
    },
    number: /\B#[0-9A-F]+|\B`[01]+|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:E[+-]?\d+)?/i,
    keyword: /\b(?:BEEP|BPS|CASE|CLEAR|CLK|CLO|CLP|CLS|CLT|CLV|CONT|COPY|ELSE|END|FILE|FILES|FOR|GOSUB|GOTO|GSB|IF|INPUT|KBD|LED|LET|LIST|LOAD|LOCATE|LRUN|NEW|NEXT|OUT|PLAY|POKE|PRINT|PWM|REM|RENUM|RESET|RETURN|RIGHT|RTN|RUN|SAVE|SCROLL|SLEEP|SRND|STEP|STOP|SUB|TEMPO|THEN|TO|UART|VIDEO|WAIT)(?:\$|\b)/i,
    function: /\b(?:ABS|ANA|ASC|BIN|BTN|DEC|END|FREE|HELP|HEX|I2CR|I2CW|IN|INKEY|LEN|LINE|PEEK|RND|SCR|SOUND|STR|TICK|USR|VER|VPEEK|ZER)(?:\$|\b)/i,
    label: /(?:\B@\S+)/,
    operator: /<[=>]?|>=?|\|\||&&|[+\-*\/=|&^~!]|\b(?:AND|NOT|OR)\b/i,
    punctuation: /[\[,;:()\]]/
  };
}

ichigojam.displayName = "ichigojam", ichigojam.aliases = [];
var icon_1 = icon;

function icon(e) {
  e.languages.icon = {
    comment: /#.*/,
    string: {
      pattern: /(["'])(?:(?!\1)[^\\\r\n_]|\\.|_(?!\1)(?:\r\n|[\s\S]))*\1/,
      greedy: !0
    },
    number: /\b(?:\d+r[a-z\d]+|\d+(?:\.\d+)?(?:e[+-]?\d+)?)\b|\.\d+\b/i,
    "builtin-keyword": {
      pattern: /&(?:allocated|ascii|clock|collections|cset|current|date|dateline|digits|dump|e|error(?:number|text|value)?|errout|fail|features|file|host|input|lcase|letters|level|line|main|null|output|phi|pi|pos|progname|random|regions|source|storage|subject|time|trace|ucase|version)\b/,
      alias: "variable"
    },
    directive: {
      pattern: /\$\w+/,
      alias: "builtin"
    },
    keyword: /\b(?:break|by|case|create|default|do|else|end|every|fail|global|if|initial|invocable|link|local|next|not|of|procedure|record|repeat|return|static|suspend|then|to|until|while)\b/,
    function: /\b(?!\d)\w+(?=\s*[({]|\s*!\s*\[)/,
    operator: /[+-]:(?!=)|(?:[\/?@^%&]|\+\+?|--?|==?=?|~==?=?|\*\*?|\|\|\|?|<(?:->?|<?=?)|>>?=?)(?::=)?|:(?:=:?)?|[!.\\|~]/,
    punctuation: /[\[\](){},;]/
  };
}

icon.displayName = "icon", icon.aliases = [];
var icuMessageFormat_1 = icuMessageFormat;

function icuMessageFormat(e) {
  !function (e) {
    function t(e, r) {
      return r <= 0 ? /[]/.source : e.replace(/<SELF>/g, function () {
        return t(e, r - 1);
      });
    }

    var r = /'[{}:=,](?:[^']|'')*'(?!')/,
        n = {
      pattern: /''/,
      greedy: !0,
      alias: "operator"
    },
        a = {
      pattern: r,
      greedy: !0,
      inside: {
        escape: n
      }
    },
        o = t(/\{(?:[^{}']|'(?![{},'])|''|<STR>|<SELF>)*\}/.source.replace(/<STR>/g, function () {
      return r.source;
    }), 8),
        i = {
      pattern: RegExp(o),
      inside: {
        message: {
          pattern: /^(\{)[\s\S]+(?=\}$)/,
          lookbehind: !0,
          inside: null
        },
        "message-delimiter": {
          pattern: /./,
          alias: "punctuation"
        }
      }
    };
    e.languages["icu-message-format"] = {
      argument: {
        pattern: RegExp(o),
        greedy: !0,
        inside: {
          content: {
            pattern: /^(\{)[\s\S]+(?=\}$)/,
            lookbehind: !0,
            inside: {
              "argument-name": {
                pattern: /^(\s*)[^{}:=,\s]+/,
                lookbehind: !0
              },
              "choice-style": {
                pattern: /^(\s*,\s*choice\s*,\s*)\S(?:[\s\S]*\S)?/,
                lookbehind: !0,
                inside: {
                  punctuation: /\|/,
                  range: {
                    pattern: /^(\s*)[+-]?(?:\d+(?:\.\d*)?|\u221e)\s*[<#\u2264]/,
                    lookbehind: !0,
                    inside: {
                      operator: /[<#\u2264]/,
                      number: /\S+/
                    }
                  },
                  rest: null
                }
              },
              "plural-style": {
                pattern: /^(\s*,\s*(?:plural|selectordinal)\s*,\s*)\S(?:[\s\S]*\S)?/,
                lookbehind: !0,
                inside: {
                  offset: /^offset:\s*\d+/,
                  "nested-message": i,
                  selector: {
                    pattern: /=\d+|[^{}:=,\s]+/,
                    inside: {
                      keyword: /^(?:few|many|one|other|two|zero)$/
                    }
                  }
                }
              },
              "select-style": {
                pattern: /^(\s*,\s*select\s*,\s*)\S(?:[\s\S]*\S)?/,
                lookbehind: !0,
                inside: {
                  "nested-message": i,
                  selector: {
                    pattern: /[^{}:=,\s]+/,
                    inside: {
                      keyword: /^other$/
                    }
                  }
                }
              },
              keyword: /\b(?:choice|plural|select|selectordinal)\b/,
              "arg-type": {
                pattern: /\b(?:date|duration|number|ordinal|spellout|time)\b/,
                alias: "keyword"
              },
              "arg-skeleton": {
                pattern: /(,\s*)::[^{}:=,\s]+/,
                lookbehind: !0
              },
              "arg-style": {
                pattern: /(,\s*)(?:currency|full|integer|long|medium|percent|short)(?=\s*$)/,
                lookbehind: !0
              },
              "arg-style-text": {
                pattern: RegExp(/(^\s*,\s*(?=\S))/.source + t(/(?:[^{}']|'[^']*'|\{(?:<SELF>)?\})+/.source, 8) + "$"),
                lookbehind: !0,
                alias: "string"
              },
              punctuation: /,/
            }
          },
          "argument-delimiter": {
            pattern: /./,
            alias: "operator"
          }
        }
      },
      escape: n,
      string: a
    }, i.inside.message.inside = e.languages["icu-message-format"], e.languages["icu-message-format"].argument.inside.content.inside["choice-style"].inside.rest = e.languages["icu-message-format"];
  }(e);
}

icuMessageFormat.displayName = "icuMessageFormat", icuMessageFormat.aliases = [];
var refractorHaskell$1 = haskell_1,
    idris_1 = idris;

function idris(e) {
  e.register(refractorHaskell$1), e.languages.idris = e.languages.extend("haskell", {
    comment: {
      pattern: /(?:(?:--|\|\|\|).*$|\{-[\s\S]*?-\})/m
    },
    keyword: /\b(?:Type|case|class|codata|constructor|corecord|data|do|dsl|else|export|if|implementation|implicit|import|impossible|in|infix|infixl|infixr|instance|interface|let|module|mutual|namespace|of|parameters|partial|postulate|private|proof|public|quoteGoal|record|rewrite|syntax|then|total|using|where|with)\b/,
    builtin: void 0
  }), e.languages.insertBefore("idris", "keyword", {
    "import-statement": {
      pattern: /(^\s*import\s+)(?:[A-Z][\w']*)(?:\.[A-Z][\w']*)*/m,
      lookbehind: !0,
      inside: {
        punctuation: /\./
      }
    }
  }), e.languages.idr = e.languages.idris;
}

idris.displayName = "idris", idris.aliases = ["idr"];
var iecst_1 = iecst;

function iecst(e) {
  e.languages.iecst = {
    comment: [{
      pattern: /(^|[^\\])(?:\/\*[\s\S]*?(?:\*\/|$)|\(\*[\s\S]*?(?:\*\)|$)|\{[\s\S]*?(?:\}|$))/,
      lookbehind: !0,
      greedy: !0
    }, {
      pattern: /(^|[^\\:])\/\/.*/,
      lookbehind: !0,
      greedy: !0
    }],
    string: {
      pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
      greedy: !0
    },
    keyword: [/\b(?:END_)?(?:PROGRAM|CONFIGURATION|INTERFACE|FUNCTION_BLOCK|FUNCTION|ACTION|TRANSITION|TYPE|STRUCT|(?:INITIAL_)?STEP|NAMESPACE|LIBRARY|CHANNEL|FOLDER|RESOURCE|VAR_(?:ACCESS|CONFIG|EXTERNAL|GLOBAL|INPUT|IN_OUT|OUTPUT|TEMP)|VAR|METHOD|PROPERTY)\b/i, /\b(?:AT|BY|(?:END_)?(?:CASE|FOR|IF|REPEAT|WHILE)|CONSTANT|CONTINUE|DO|ELSE|ELSIF|EXIT|EXTENDS|FROM|GET|GOTO|IMPLEMENTS|JMP|NON_RETAIN|OF|PRIVATE|PROTECTED|PUBLIC|RETAIN|RETURN|SET|TASK|THEN|TO|UNTIL|USING|WITH|__CATCH|__ENDTRY|__FINALLY|__TRY)\b/],
    "class-name": /\b(?:ANY|ARRAY|BOOL|BYTE|U?(?:D|L|S)?INT|(?:D|L)?WORD|DATE(?:_AND_TIME)?|DT|L?REAL|POINTER|STRING|TIME(?:_OF_DAY)?|TOD)\b/,
    address: {
      pattern: /%[IQM][XBWDL][\d.]*|%[IQ][\d.]*/,
      alias: "symbol"
    },
    number: /\b(?:16#[\da-f]+|2#[01_]+|0x[\da-f]+)\b|\b(?:D|DT|T|TOD)#[\d_shmd:]*|\b[A-Z]*#[\d.,_]*|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
    boolean: /\b(?:FALSE|NULL|TRUE)\b/,
    operator: /S?R?:?=>?|&&?|\*\*?|<[=>]?|>=?|[-:^/+#]|\b(?:AND|EQ|EXPT|GE|GT|LE|LT|MOD|NE|NOT|OR|XOR)\b/,
    function: /\b[a-z_]\w*(?=\s*\()/i,
    punctuation: /[()[\].,;]/
  };
}

iecst.displayName = "iecst", iecst.aliases = [];
var ignore_1 = ignore;

function ignore(e) {
  !function (e) {
    e.languages.ignore = {
      comment: /^#.*/m,
      entry: {
        pattern: /\S(?:.*(?:(?:\\ )|\S))?/,
        alias: "string",
        inside: {
          operator: /^!|\*\*?|\?/,
          regex: {
            pattern: /(^|[^\\])\[[^\[\]]*\]/,
            lookbehind: !0
          },
          punctuation: /\//
        }
      }
    }, e.languages.gitignore = e.languages.ignore, e.languages.hgignore = e.languages.ignore, e.languages.npmignore = e.languages.ignore;
  }(e);
}

ignore.displayName = "ignore", ignore.aliases = ["gitignore", "hgignore", "npmignore"];
var inform7_1 = inform7;

function inform7(e) {
  e.languages.inform7 = {
    string: {
      pattern: /"[^"]*"/,
      inside: {
        substitution: {
          pattern: /\[[^\[\]]+\]/,
          inside: {
            delimiter: {
              pattern: /\[|\]/,
              alias: "punctuation"
            }
          }
        }
      }
    },
    comment: {
      pattern: /\[[^\[\]]+\]/,
      greedy: !0
    },
    title: {
      pattern: /^[ \t]*(?:book|chapter|part(?! of)|section|table|volume)\b.+/im,
      alias: "important"
    },
    number: {
      pattern: /(^|[^-])(?:\b\d+(?:\.\d+)?(?:\^\d+)?(?:(?!\d)\w+)?|\b(?:eight|eleven|five|four|nine|one|seven|six|ten|three|twelve|two))\b(?!-)/i,
      lookbehind: !0
    },
    verb: {
      pattern: /(^|[^-])\b(?:answering|applying to|are|asking|attacking|be(?:ing)?|burning|buying|called|carries|carry(?! out)|carrying|climbing|closing|conceal(?:ing|s)?|consulting|contain(?:ing|s)?|cutting|drinking|dropping|eating|enclos(?:es?|ing)|entering|examining|exiting|getting|giving|going|ha(?:s|ve|ving)|hold(?:ing|s)?|impl(?:ies|y)|incorporat(?:es?|ing)|inserting|is|jumping|kissing|listening|locking|looking|mean(?:ing|s)?|opening|provid(?:es?|ing)|pulling|pushing|putting|relat(?:es?|ing)|removing|searching|see(?:ing|s)?|setting|showing|singing|sleeping|smelling|squeezing|support(?:ing|s)?|swearing|switching|taking|tasting|telling|thinking|throwing|touching|turning|tying|unlock(?:ing|s)?|var(?:ies|y|ying)|waiting|waking|waving|wear(?:ing|s)?)\b(?!-)/i,
      lookbehind: !0,
      alias: "operator"
    },
    keyword: {
      pattern: /(^|[^-])\b(?:after|before|carry out|check|continue the action|definition(?= *:)|do nothing|else|end (?:if|the story|unless)|every turn|if|include|instead(?: of)?|let|move|no|now|otherwise|repeat|report|resume the story|rule for|running through|say(?:ing)?|stop the action|test|try(?:ing)?|understand|unless|use|when|while|yes)\b(?!-)/i,
      lookbehind: !0
    },
    property: {
      pattern: /(^|[^-])\b(?:adjacent(?! to)|carried|closed|concealed|contained|dark|described|edible|empty|enclosed|enterable|even|female|fixed in place|full|handled|held|improper-named|incorporated|inedible|invisible|lighted|lit|lock(?:able|ed)|male|marked for listing|mentioned|negative|neuter|non-(?:empty|full|recurring)|odd|opaque|open(?:able)?|plural-named|portable|positive|privately-named|proper-named|provided|publically-named|pushable between rooms|recurring|related|rubbing|scenery|seen|singular-named|supported|swinging|switch(?:able|ed(?: off| on)?)|touch(?:able|ed)|transparent|unconcealed|undescribed|unlit|unlocked|unmarked for listing|unmentioned|unopenable|untouchable|unvisited|variable|visible|visited|wearable|worn)\b(?!-)/i,
      lookbehind: !0,
      alias: "symbol"
    },
    position: {
      pattern: /(^|[^-])\b(?:above|adjacent to|back side of|below|between|down|east|everywhere|front side|here|in|inside(?: from)?|north(?:east|west)?|nowhere|on(?: top of)?|other side|outside(?: from)?|parts? of|regionally in|south(?:east|west)?|through|up|west|within)\b(?!-)/i,
      lookbehind: !0,
      alias: "keyword"
    },
    type: {
      pattern: /(^|[^-])\b(?:actions?|activit(?:ies|y)|actors?|animals?|backdrops?|containers?|devices?|directions?|doors?|holders?|kinds?|lists?|m[ae]n|nobody|nothing|nouns?|numbers?|objects?|people|persons?|player(?:'s holdall)?|regions?|relations?|rooms?|rule(?:book)?s?|scenes?|someone|something|supporters?|tables?|texts?|things?|time|vehicles?|wom[ae]n)\b(?!-)/i,
      lookbehind: !0,
      alias: "variable"
    },
    punctuation: /[.,:;(){}]/
  }, e.languages.inform7.string.inside.substitution.inside.rest = e.languages.inform7, e.languages.inform7.string.inside.substitution.inside.rest.text = {
    pattern: /\S(?:\s*\S)*/,
    alias: "comment"
  };
}

inform7.displayName = "inform7", inform7.aliases = [];
var ini_1 = ini;

function ini(e) {
  e.languages.ini = {
    comment: {
      pattern: /(^[ \f\t\v]*)[#;][^\n\r]*/m,
      lookbehind: !0
    },
    section: {
      pattern: /(^[ \f\t\v]*)\[[^\n\r\]]*\]?/m,
      lookbehind: !0,
      inside: {
        "section-name": {
          pattern: /(^\[[ \f\t\v]*)[^ \f\t\v\]]+(?:[ \f\t\v]+[^ \f\t\v\]]+)*/,
          lookbehind: !0,
          alias: "selector"
        },
        punctuation: /\[|\]/
      }
    },
    key: {
      pattern: /(^[ \f\t\v]*)[^ \f\n\r\t\v=]+(?:[ \f\t\v]+[^ \f\n\r\t\v=]+)*(?=[ \f\t\v]*=)/m,
      lookbehind: !0,
      alias: "attr-name"
    },
    value: {
      pattern: /(=[ \f\t\v]*)[^ \f\n\r\t\v]+(?:[ \f\t\v]+[^ \f\n\r\t\v]+)*/,
      lookbehind: !0,
      alias: "attr-value",
      inside: {
        "inner-value": {
          pattern: /^("|').+(?=\1$)/,
          lookbehind: !0
        }
      }
    },
    punctuation: /=/
  };
}

ini.displayName = "ini", ini.aliases = [];
var io_1 = io;

function io(e) {
  e.languages.io = {
    comment: {
      pattern: /(^|[^\\])(?:\/\*[\s\S]*?(?:\*\/|$)|\/\/.*|#.*)/,
      lookbehind: !0,
      greedy: !0
    },
    "triple-quoted-string": {
      pattern: /"""(?:\\[\s\S]|(?!""")[^\\])*"""/,
      greedy: !0,
      alias: "string"
    },
    string: {
      pattern: /"(?:\\.|[^\\\r\n"])*"/,
      greedy: !0
    },
    keyword: /\b(?:activate|activeCoroCount|asString|block|break|call|catch|clone|collectGarbage|compileString|continue|do|doFile|doMessage|doString|else|elseif|exit|for|foreach|forward|getEnvironmentVariable|getSlot|hasSlot|if|ifFalse|ifNil|ifNilEval|ifTrue|isActive|isNil|isResumable|list|message|method|parent|pass|pause|perform|performWithArgList|print|println|proto|raise|raiseResumable|removeSlot|resend|resume|schedulerSleepSeconds|self|sender|setSchedulerSleepSeconds|setSlot|shallowCopy|slotNames|super|system|then|thisBlock|thisContext|try|type|uniqueId|updateSlot|wait|while|write|yield)\b/,
    builtin: /\b(?:Array|AudioDevice|AudioMixer|BigNum|Block|Box|Buffer|CFunction|CGI|Color|Curses|DBM|DNSResolver|DOConnection|DOProxy|DOServer|Date|Directory|Duration|DynLib|Error|Exception|FFT|File|Fnmatch|Font|Future|GL|GLE|GLScissor|GLU|GLUCylinder|GLUQuadric|GLUSphere|GLUT|Host|Image|Importer|LinkList|List|Lobby|Locals|MD5|MP3Decoder|MP3Encoder|Map|Message|Movie|Notification|Number|Object|OpenGL|Point|Protos|Random|Regex|SGML|SGMLElement|SGMLParser|SQLite|Sequence|Server|ShowMessage|SleepyCat|SleepyCatCursor|Socket|SocketManager|Sound|Soup|Store|String|Tree|UDPSender|UPDReceiver|URL|User|Warning|WeakLink)\b/,
    boolean: /\b(?:false|nil|true)\b/,
    number: /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e-?\d+)?/i,
    operator: /[=!*/%+\-^&|]=|>>?=?|<<?=?|:?:?=|\+\+?|--?|\*\*?|\/\/?|%|\|\|?|&&?|\b(?:and|not|or|return)\b|@@?|\?\??|\.\./,
    punctuation: /[{}[\];(),.:]/
  };
}

io.displayName = "io", io.aliases = [];
var j_1 = j;

function j(e) {
  e.languages.j = {
    comment: {
      pattern: /\bNB\..*/,
      greedy: !0
    },
    string: {
      pattern: /'(?:''|[^'\r\n])*'/,
      greedy: !0
    },
    keyword: /\b(?:(?:CR|LF|adverb|conjunction|def|define|dyad|monad|noun|verb)\b|(?:assert|break|case|catch[dt]?|continue|do|else|elseif|end|fcase|for|for_\w+|goto_\w+|if|label_\w+|return|select|throw|try|while|whilst)\.)/,
    verb: {
      pattern: /(?!\^:|;\.|[=!][.:])(?:\{(?:\.|::?)?|p(?:\.\.?|:)|[=!\]]|[<>+*\-%$|,#][.:]?|[?^]\.?|[;\[]:?|[~}"i][.:]|[ACeEIjLor]\.|(?:[_\/\\qsux]|_?\d):)/,
      alias: "keyword"
    },
    number: /\b_?(?:(?!\d:)\d+(?:\.\d+)?(?:(?:ad|ar|[ejpx])_?\d+(?:\.\d+)?)*(?:b_?[\da-z]+(?:\.[\da-z]+)?)?|_\b(?!\.))/,
    adverb: {
      pattern: /[~}]|[\/\\]\.?|[bfM]\.|t[.:]/,
      alias: "builtin"
    },
    operator: /[=a][.:]|_\./,
    conjunction: {
      pattern: /&(?:\.:?|:)?|[.:@][.:]?|[!D][.:]|[;dHT]\.|`:?|[\^LS]:|"/,
      alias: "variable"
    },
    punctuation: /[()]/
  };
}

j.displayName = "j", j.aliases = [];
var java_1 = java;

function java(e) {
  !function (e) {
    var t = /\b(?:abstract|assert|boolean|break|byte|case|catch|char|class|const|continue|default|do|double|else|enum|exports|extends|final|finally|float|for|goto|if|implements|import|instanceof|int|interface|long|module|native|new|non-sealed|null|open|opens|package|permits|private|protected|provides|public|record|requires|return|sealed|short|static|strictfp|super|switch|synchronized|this|throw|throws|to|transient|transitive|try|uses|var|void|volatile|while|with|yield)\b/,
        r = /(^|[^\w.])(?:[a-z]\w*\s*\.\s*)*(?:[A-Z]\w*\s*\.\s*)*/.source,
        n = {
      pattern: RegExp(r + /[A-Z](?:[\d_A-Z]*[a-z]\w*)?\b/.source),
      lookbehind: !0,
      inside: {
        namespace: {
          pattern: /^[a-z]\w*(?:\s*\.\s*[a-z]\w*)*(?:\s*\.)?/,
          inside: {
            punctuation: /\./
          }
        },
        punctuation: /\./
      }
    };
    e.languages.java = e.languages.extend("clike", {
      string: {
        pattern: /(^|[^\\])"(?:\\.|[^"\\\r\n])*"/,
        lookbehind: !0,
        greedy: !0
      },
      "class-name": [n, {
        pattern: RegExp(r + /[A-Z]\w*(?=\s+\w+\s*[;,=()])/.source),
        lookbehind: !0,
        inside: n.inside
      }],
      keyword: t,
      function: [e.languages.clike.function, {
        pattern: /(::\s*)[a-z_]\w*/,
        lookbehind: !0
      }],
      number: /\b0b[01][01_]*L?\b|\b0x(?:\.[\da-f_p+-]+|[\da-f_]+(?:\.[\da-f_p+-]+)?)\b|(?:\b\d[\d_]*(?:\.[\d_]*)?|\B\.\d[\d_]*)(?:e[+-]?\d[\d_]*)?[dfl]?/i,
      operator: {
        pattern: /(^|[^.])(?:<<=?|>>>?=?|->|--|\+\+|&&|\|\||::|[?:~]|[-+*/%&|^!=<>]=?)/m,
        lookbehind: !0
      }
    }), e.languages.insertBefore("java", "string", {
      "triple-quoted-string": {
        pattern: /"""[ \t]*[\r\n](?:(?:"|"")?(?:\\.|[^"\\]))*"""/,
        greedy: !0,
        alias: "string"
      },
      char: {
        pattern: /'(?:\\.|[^'\\\r\n]){1,6}'/,
        greedy: !0
      }
    }), e.languages.insertBefore("java", "class-name", {
      annotation: {
        pattern: /(^|[^.])@\w+(?:\s*\.\s*\w+)*/,
        lookbehind: !0,
        alias: "punctuation"
      },
      generics: {
        pattern: /<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&))*>)*>)*>)*>/,
        inside: {
          "class-name": n,
          keyword: t,
          punctuation: /[<>(),.:]/,
          operator: /[?&|]/
        }
      },
      namespace: {
        pattern: RegExp(/(\b(?:exports|import(?:\s+static)?|module|open|opens|package|provides|requires|to|transitive|uses|with)\s+)(?!<keyword>)[a-z]\w*(?:\.[a-z]\w*)*\.?/.source.replace(/<keyword>/g, function () {
          return t.source;
        })),
        lookbehind: !0,
        inside: {
          punctuation: /\./
        }
      }
    });
  }(e);
}

java.displayName = "java", java.aliases = [];
var javadoclike_1 = javadoclike;

function javadoclike(e) {
  !function (e) {
    var t = e.languages.javadoclike = {
      parameter: {
        pattern: /(^[\t ]*(?:\/{3}|\*|\/\*\*)\s*@(?:arg|arguments|param)\s+)\w+/m,
        lookbehind: !0
      },
      keyword: {
        pattern: /(^[\t ]*(?:\/{3}|\*|\/\*\*)\s*|\{)@[a-z][a-zA-Z-]+\b/m,
        lookbehind: !0
      },
      punctuation: /[{}]/
    };
    Object.defineProperty(t, "addSupport", {
      value: function value(t, r) {
        "string" == typeof t && (t = [t]), t.forEach(function (t) {
          !function (t, r) {
            var n = "doc-comment",
                a = e.languages[t];

            if (a) {
              var o = a[n];

              if (!o) {
                var i = {
                  "doc-comment": {
                    pattern: /(^|[^\\])\/\*\*[^/][\s\S]*?(?:\*\/|$)/,
                    lookbehind: !0,
                    alias: "comment"
                  }
                };
                o = (a = e.languages.insertBefore(t, "comment", i))[n];
              }

              if (o instanceof RegExp && (o = a[n] = {
                pattern: o
              }), Array.isArray(o)) for (var s = 0, l = o.length; s < l; s++) {
                o[s] instanceof RegExp && (o[s] = {
                  pattern: o[s]
                }), r(o[s]);
              } else r(o);
            }
          }(t, function (e) {
            e.inside || (e.inside = {}), e.inside.rest = r;
          });
        });
      }
    }), t.addSupport(["java", "javascript", "php"], t);
  }(e);
}

javadoclike.displayName = "javadoclike", javadoclike.aliases = [];
var refractorJava$1 = java_1,
    refractorJavadoclike$2 = javadoclike_1,
    javadoc_1 = javadoc;

function javadoc(e) {
  e.register(refractorJava$1), e.register(refractorJavadoclike$2), function (e) {
    var t = /(^(?:[\t ]*(?:\*\s*)*))[^*\s].*$/m,
        r = /#\s*\w+(?:\s*\([^()]*\))?/.source,
        n = /(?:\b[a-zA-Z]\w+\s*\.\s*)*\b[A-Z]\w*(?:\s*<mem>)?|<mem>/.source.replace(/<mem>/g, function () {
      return r;
    });
    e.languages.javadoc = e.languages.extend("javadoclike", {}), e.languages.insertBefore("javadoc", "keyword", {
      reference: {
        pattern: RegExp(/(@(?:exception|link|linkplain|see|throws|value)\s+(?:\*\s*)?)/.source + "(?:" + n + ")"),
        lookbehind: !0,
        inside: {
          function: {
            pattern: /(#\s*)\w+(?=\s*\()/,
            lookbehind: !0
          },
          field: {
            pattern: /(#\s*)\w+/,
            lookbehind: !0
          },
          namespace: {
            pattern: /\b(?:[a-z]\w*\s*\.\s*)+/,
            inside: {
              punctuation: /\./
            }
          },
          "class-name": /\b[A-Z]\w*/,
          keyword: e.languages.java.keyword,
          punctuation: /[#()[\],.]/
        }
      },
      "class-name": {
        pattern: /(@param\s+)<[A-Z]\w*>/,
        lookbehind: !0,
        inside: {
          punctuation: /[.<>]/
        }
      },
      "code-section": [{
        pattern: /(\{@code\s+(?!\s))(?:[^\s{}]|\s+(?![\s}])|\{(?:[^{}]|\{(?:[^{}]|\{(?:[^{}]|\{[^{}]*\})*\})*\})*\})+(?=\s*\})/,
        lookbehind: !0,
        inside: {
          code: {
            pattern: t,
            lookbehind: !0,
            inside: e.languages.java,
            alias: "language-java"
          }
        }
      }, {
        pattern: /(<(code|pre|tt)>(?!<code>)\s*)\S(?:\S|\s+\S)*?(?=\s*<\/\2>)/,
        lookbehind: !0,
        inside: {
          line: {
            pattern: t,
            lookbehind: !0,
            inside: {
              tag: e.languages.markup.tag,
              entity: e.languages.markup.entity,
              code: {
                pattern: /.+/,
                inside: e.languages.java,
                alias: "language-java"
              }
            }
          }
        }
      }],
      tag: e.languages.markup.tag,
      entity: e.languages.markup.entity
    }), e.languages.javadoclike.addSupport("java", e.languages.javadoc);
  }(e);
}

javadoc.displayName = "javadoc", javadoc.aliases = [];
var javastacktrace_1 = javastacktrace;

function javastacktrace(e) {
  e.languages.javastacktrace = {
    summary: {
      pattern: /^([\t ]*)(?:(?:Caused by:|Suppressed:|Exception in thread "[^"]*")[\t ]+)?[\w$.]+(?::.*)?$/m,
      lookbehind: !0,
      inside: {
        keyword: {
          pattern: /^([\t ]*)(?:(?:Caused by|Suppressed)(?=:)|Exception in thread)/m,
          lookbehind: !0
        },
        string: {
          pattern: /^(\s*)"[^"]*"/,
          lookbehind: !0
        },
        exceptions: {
          pattern: /^(:?\s*)[\w$.]+(?=:|$)/,
          lookbehind: !0,
          inside: {
            "class-name": /[\w$]+$/,
            namespace: /\b[a-z]\w*\b/,
            punctuation: /\./
          }
        },
        message: {
          pattern: /(:\s*)\S.*/,
          lookbehind: !0,
          alias: "string"
        },
        punctuation: /:/
      }
    },
    "stack-frame": {
      pattern: /^([\t ]*)at (?:[\w$./]|@[\w$.+-]*\/)+(?:<init>)?\([^()]*\)/m,
      lookbehind: !0,
      inside: {
        keyword: {
          pattern: /^(\s*)at(?= )/,
          lookbehind: !0
        },
        source: [{
          pattern: /(\()\w+\.\w+:\d+(?=\))/,
          lookbehind: !0,
          inside: {
            file: /^\w+\.\w+/,
            punctuation: /:/,
            "line-number": {
              pattern: /\b\d+\b/,
              alias: "number"
            }
          }
        }, {
          pattern: /(\()[^()]*(?=\))/,
          lookbehind: !0,
          inside: {
            keyword: /^(?:Native Method|Unknown Source)$/
          }
        }],
        "class-name": /[\w$]+(?=\.(?:<init>|[\w$]+)\()/,
        function: /(?:<init>|[\w$]+)(?=\()/,
        "class-loader": {
          pattern: /(\s)[a-z]\w*(?:\.[a-z]\w*)*(?=\/[\w@$.]*\/)/,
          lookbehind: !0,
          alias: "namespace",
          inside: {
            punctuation: /\./
          }
        },
        module: {
          pattern: /([\s/])[a-z]\w*(?:\.[a-z]\w*)*(?:@[\w$.+-]*)?(?=\/)/,
          lookbehind: !0,
          inside: {
            version: {
              pattern: /(@)[\s\S]+/,
              lookbehind: !0,
              alias: "number"
            },
            punctuation: /[@.]/
          }
        },
        namespace: {
          pattern: /(?:\b[a-z]\w*\.)+/,
          inside: {
            punctuation: /\./
          }
        },
        punctuation: /[()/.]/
      }
    },
    more: {
      pattern: /^([\t ]*)\.{3} \d+ [a-z]+(?: [a-z]+)*/m,
      lookbehind: !0,
      inside: {
        punctuation: /\.{3}/,
        number: /\d+/,
        keyword: /\b[a-z]+(?: [a-z]+)*\b/
      }
    }
  };
}

javastacktrace.displayName = "javastacktrace", javastacktrace.aliases = [];
var jexl_1 = jexl;

function jexl(e) {
  e.languages.jexl = {
    string: /(["'])(?:\\[\s\S]|(?!\1)[^\\])*\1/,
    transform: {
      pattern: /(\|\s*)[a-zA-Zа-яА-Я_\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF$][\wа-яА-Я\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF$]*/,
      alias: "function",
      lookbehind: !0
    },
    function: /[a-zA-Zа-яА-Я_\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF$][\wа-яА-Я\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF$]*\s*(?=\()/,
    number: /\b\d+(?:\.\d+)?\b|\B\.\d+\b/,
    operator: /[<>!]=?|-|\+|&&|==|\|\|?|\/\/?|[?:*^%]/,
    boolean: /\b(?:false|true)\b/,
    keyword: /\bin\b/,
    punctuation: /[{}[\](),.]/
  };
}

jexl.displayName = "jexl", jexl.aliases = [];
var jolie_1 = jolie;

function jolie(e) {
  e.languages.jolie = e.languages.extend("clike", {
    string: {
      pattern: /(^|[^\\])"(?:\\[\s\S]|[^"\\])*"/,
      lookbehind: !0,
      greedy: !0
    },
    "class-name": {
      pattern: /((?:\b(?:as|courier|embed|in|inputPort|outputPort|service)\b|@)[ \t]*)\w+/,
      lookbehind: !0
    },
    keyword: /\b(?:as|cH|comp|concurrent|constants|courier|cset|csets|default|define|else|embed|embedded|execution|exit|extender|for|foreach|forward|from|global|if|import|in|include|init|inputPort|install|instanceof|interface|is_defined|linkIn|linkOut|main|new|nullProcess|outputPort|over|private|provide|public|scope|sequential|service|single|spawn|synchronized|this|throw|throws|type|undef|until|while|with)\b/,
    function: /\b[a-z_]\w*(?=[ \t]*[@(])/i,
    number: /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?l?/i,
    operator: /-[-=>]?|\+[+=]?|<[<=]?|[>=*!]=?|&&|\|\||[?\/%^@|]/,
    punctuation: /[()[\]{},;.:]/,
    builtin: /\b(?:Byte|any|bool|char|double|enum|float|int|length|long|ranges|regex|string|undefined|void)\b/
  }), e.languages.insertBefore("jolie", "keyword", {
    aggregates: {
      pattern: /(\bAggregates\s*:\s*)(?:\w+(?:\s+with\s+\w+)?\s*,\s*)*\w+(?:\s+with\s+\w+)?/,
      lookbehind: !0,
      inside: {
        keyword: /\bwith\b/,
        "class-name": /\w+/,
        punctuation: /,/
      }
    },
    redirects: {
      pattern: /(\bRedirects\s*:\s*)(?:\w+\s*=>\s*\w+\s*,\s*)*(?:\w+\s*=>\s*\w+)/,
      lookbehind: !0,
      inside: {
        punctuation: /,/,
        "class-name": /\w+/,
        operator: /=>/
      }
    },
    property: {
      pattern: /\b(?:Aggregates|[Ii]nterfaces|Java|Javascript|Jolie|[Ll]ocation|OneWay|[Pp]rotocol|Redirects|RequestResponse)\b(?=[ \t]*:)/
    }
  });
}

jolie.displayName = "jolie", jolie.aliases = [];
var jq_1 = jq;

function jq(e) {
  !function (e) {
    var t = /\\\((?:[^()]|\([^()]*\))*\)/.source,
        r = RegExp(/(^|[^\\])"(?:[^"\r\n\\]|\\[^\r\n(]|__)*"/.source.replace(/__/g, function () {
      return t;
    })),
        n = {
      interpolation: {
        pattern: RegExp(/((?:^|[^\\])(?:\\{2})*)/.source + t),
        lookbehind: !0,
        inside: {
          content: {
            pattern: /^(\\\()[\s\S]+(?=\)$)/,
            lookbehind: !0,
            inside: null
          },
          punctuation: /^\\\(|\)$/
        }
      }
    },
        a = e.languages.jq = {
      comment: /#.*/,
      property: {
        pattern: RegExp(r.source + /(?=\s*:(?!:))/.source),
        lookbehind: !0,
        greedy: !0,
        inside: n
      },
      string: {
        pattern: r,
        lookbehind: !0,
        greedy: !0,
        inside: n
      },
      function: {
        pattern: /(\bdef\s+)[a-z_]\w+/i,
        lookbehind: !0
      },
      variable: /\B\$\w+/,
      "property-literal": {
        pattern: /\b[a-z_]\w*(?=\s*:(?!:))/i,
        alias: "property"
      },
      keyword: /\b(?:as|break|catch|def|elif|else|end|foreach|if|import|include|label|module|modulemeta|null|reduce|then|try|while)\b/,
      boolean: /\b(?:false|true)\b/,
      number: /(?:\b\d+\.|\B\.)?\b\d+(?:[eE][+-]?\d+)?\b/,
      operator: [{
        pattern: /\|=?/,
        alias: "pipe"
      }, /\.\.|[!=<>]?=|\?\/\/|\/\/=?|[-+*/%]=?|[<>?]|\b(?:and|not|or)\b/],
      "c-style-function": {
        pattern: /\b[a-z_]\w*(?=\s*\()/i,
        alias: "function"
      },
      punctuation: /::|[()\[\]{},:;]|\.(?=\s*[\[\w$])/,
      dot: {
        pattern: /\./,
        alias: "important"
      }
    };
    n.interpolation.inside.content.inside = a;
  }(e);
}

jq.displayName = "jq", jq.aliases = [];
var jsExtras_1 = jsExtras;

function jsExtras(e) {
  !function (e) {
    function t(e, t) {
      return RegExp(e.replace(/<ID>/g, function () {
        return /(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*/.source;
      }), t);
    }

    e.languages.insertBefore("javascript", "function-variable", {
      "method-variable": {
        pattern: RegExp("(\\.\\s*)" + e.languages.javascript["function-variable"].pattern.source),
        lookbehind: !0,
        alias: ["function-variable", "method", "function", "property-access"]
      }
    }), e.languages.insertBefore("javascript", "function", {
      method: {
        pattern: RegExp("(\\.\\s*)" + e.languages.javascript.function.source),
        lookbehind: !0,
        alias: ["function", "property-access"]
      }
    }), e.languages.insertBefore("javascript", "constant", {
      "known-class-name": [{
        pattern: /\b(?:(?:Float(?:32|64)|(?:Int|Uint)(?:8|16|32)|Uint8Clamped)?Array|ArrayBuffer|BigInt|Boolean|DataView|Date|Error|Function|Intl|JSON|(?:Weak)?(?:Map|Set)|Math|Number|Object|Promise|Proxy|Reflect|RegExp|String|Symbol|WebAssembly)\b/,
        alias: "class-name"
      }, {
        pattern: /\b(?:[A-Z]\w*)Error\b/,
        alias: "class-name"
      }]
    }), e.languages.insertBefore("javascript", "keyword", {
      imports: {
        pattern: t(/(\bimport\b\s*)(?:<ID>(?:\s*,\s*(?:\*\s*as\s+<ID>|\{[^{}]*\}))?|\*\s*as\s+<ID>|\{[^{}]*\})(?=\s*\bfrom\b)/.source),
        lookbehind: !0,
        inside: e.languages.javascript
      },
      exports: {
        pattern: t(/(\bexport\b\s*)(?:\*(?:\s*as\s+<ID>)?(?=\s*\bfrom\b)|\{[^{}]*\})/.source),
        lookbehind: !0,
        inside: e.languages.javascript
      }
    }), e.languages.javascript.keyword.unshift({
      pattern: /\b(?:as|default|export|from|import)\b/,
      alias: "module"
    }, {
      pattern: /\b(?:await|break|catch|continue|do|else|finally|for|if|return|switch|throw|try|while|yield)\b/,
      alias: "control-flow"
    }, {
      pattern: /\bnull\b/,
      alias: ["null", "nil"]
    }, {
      pattern: /\bundefined\b/,
      alias: "nil"
    }), e.languages.insertBefore("javascript", "operator", {
      spread: {
        pattern: /\.{3}/,
        alias: "operator"
      },
      arrow: {
        pattern: /=>/,
        alias: "operator"
      }
    }), e.languages.insertBefore("javascript", "punctuation", {
      "property-access": {
        pattern: t(/(\.\s*)#?<ID>/.source),
        lookbehind: !0
      },
      "maybe-class-name": {
        pattern: /(^|[^$\w\xA0-\uFFFF])[A-Z][$\w\xA0-\uFFFF]+/,
        lookbehind: !0
      },
      dom: {
        pattern: /\b(?:document|(?:local|session)Storage|location|navigator|performance|window)\b/,
        alias: "variable"
      },
      console: {
        pattern: /\bconsole(?=\s*\.)/,
        alias: "class-name"
      }
    });

    for (var r = ["function", "function-variable", "method", "method-variable", "property-access"], n = 0; n < r.length; n++) {
      var a = r[n],
          o = e.languages.javascript[a];
      "RegExp" === e.util.type(o) && (o = e.languages.javascript[a] = {
        pattern: o
      });
      var i = o.inside || {};
      o.inside = i, i["maybe-class-name"] = /^[A-Z][\s\S]*/;
    }
  }(e);
}

jsExtras.displayName = "jsExtras", jsExtras.aliases = [];
var jsTemplates_1 = jsTemplates;

function jsTemplates(e) {
  !function (e) {
    var t = e.languages.javascript["template-string"],
        r = t.pattern.source,
        n = t.inside.interpolation,
        a = n.inside["interpolation-punctuation"],
        o = n.pattern.source;

    function i(t, n) {
      if (e.languages[t]) return {
        pattern: RegExp("((?:" + n + ")\\s*)" + r),
        lookbehind: !0,
        greedy: !0,
        inside: {
          "template-punctuation": {
            pattern: /^`|`$/,
            alias: "string"
          },
          "embedded-code": {
            pattern: /[\s\S]+/,
            alias: t
          }
        }
      };
    }

    function s(e, t) {
      return "___" + t.toUpperCase() + "_" + e + "___";
    }

    function l(t, r, n) {
      var a = {
        code: t,
        grammar: r,
        language: n
      };
      return e.hooks.run("before-tokenize", a), a.tokens = e.tokenize(a.code, a.grammar), e.hooks.run("after-tokenize", a), a.tokens;
    }

    function c(t) {
      var r = {};
      r["interpolation-punctuation"] = a;
      var o = e.tokenize(t, r);

      if (3 === o.length) {
        var i = [1, 1];
        i.push.apply(i, l(o[1], e.languages.javascript, "javascript")), o.splice.apply(o, i);
      }

      return new e.Token("interpolation", o, n.alias, t);
    }

    function u(t, r, n) {
      var a = e.tokenize(t, {
        interpolation: {
          pattern: RegExp(o),
          lookbehind: !0
        }
      }),
          i = 0,
          u = {},
          d = l(a.map(function (e) {
        if ("string" == typeof e) return e;

        for (var r, a = e.content; -1 !== t.indexOf(r = s(i++, n));) {
          ;
        }

        return u[r] = a, r;
      }).join(""), r, n),
          p = Object.keys(u);
      return i = 0, function e(t) {
        for (var r = 0; r < t.length; r++) {
          if (i >= p.length) return;
          var n = t[r];

          if ("string" == typeof n || "string" == typeof n.content) {
            var a = p[i],
                o = "string" == typeof n ? n : n.content,
                s = o.indexOf(a);

            if (-1 !== s) {
              ++i;
              var l = o.substring(0, s),
                  d = c(u[a]),
                  g = o.substring(s + a.length),
                  m = [];

              if (l && m.push(l), m.push(d), g) {
                var f = [g];
                e(f), m.push.apply(m, f);
              }

              "string" == typeof n ? (t.splice.apply(t, [r, 1].concat(m)), r += m.length - 1) : n.content = m;
            }
          } else {
            var h = n.content;
            Array.isArray(h) ? e(h) : e([h]);
          }
        }
      }(d), new e.Token(n, d, "language-" + n, t);
    }

    e.languages.javascript["template-string"] = [i("css", /\b(?:styled(?:\([^)]*\))?(?:\s*\.\s*\w+(?:\([^)]*\))*)*|css(?:\s*\.\s*(?:global|resolve))?|createGlobalStyle|keyframes)/.source), i("html", /\bhtml|\.\s*(?:inner|outer)HTML\s*\+?=/.source), i("svg", /\bsvg/.source), i("markdown", /\b(?:markdown|md)/.source), i("graphql", /\b(?:gql|graphql(?:\s*\.\s*experimental)?)/.source), i("sql", /\bsql/.source), t].filter(Boolean);
    var d = {
      javascript: !0,
      js: !0,
      typescript: !0,
      ts: !0,
      jsx: !0,
      tsx: !0
    };

    function p(e) {
      return "string" == typeof e ? e : Array.isArray(e) ? e.map(p).join("") : p(e.content);
    }

    e.hooks.add("after-tokenize", function (t) {
      t.language in d && function t(r) {
        for (var n = 0, a = r.length; n < a; n++) {
          var o = r[n];

          if ("string" != typeof o) {
            var i = o.content;
            if (Array.isArray(i)) {
              if ("template-string" === o.type) {
                var s = i[1];

                if (3 === i.length && "string" != typeof s && "embedded-code" === s.type) {
                  var l = p(s),
                      c = s.alias,
                      d = Array.isArray(c) ? c[0] : c,
                      g = e.languages[d];
                  if (!g) continue;
                  i[1] = u(l, g, d);
                }
              } else t(i);
            } else "string" != typeof i && t([i]);
          }
        }
      }(t.tokens);
    });
  }(e);
}

jsTemplates.displayName = "jsTemplates", jsTemplates.aliases = [];
var typescript_1 = typescript;

function typescript(e) {
  !function (e) {
    e.languages.typescript = e.languages.extend("javascript", {
      "class-name": {
        pattern: /(\b(?:class|extends|implements|instanceof|interface|new|type)\s+)(?!keyof\b)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?:\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>)?/,
        lookbehind: !0,
        greedy: !0,
        inside: null
      },
      builtin: /\b(?:Array|Function|Promise|any|boolean|console|never|number|string|symbol|unknown)\b/
    }), e.languages.typescript.keyword.push(/\b(?:abstract|declare|is|keyof|readonly|require)\b/, /\b(?:asserts|infer|interface|module|namespace|type)\b(?=\s*(?:[{_$a-zA-Z\xA0-\uFFFF]|$))/, /\btype\b(?=\s*(?:[\{*]|$))/), delete e.languages.typescript.parameter, delete e.languages.typescript["literal-property"];
    var t = e.languages.extend("typescript", {});
    delete t["class-name"], e.languages.typescript["class-name"].inside = t, e.languages.insertBefore("typescript", "function", {
      decorator: {
        pattern: /@[$\w\xA0-\uFFFF]+/,
        inside: {
          at: {
            pattern: /^@/,
            alias: "operator"
          },
          function: /^[\s\S]+/
        }
      },
      "generic-function": {
        pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>(?=\s*\()/,
        greedy: !0,
        inside: {
          function: /^#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*/,
          generic: {
            pattern: /<[\s\S]+/,
            alias: "class-name",
            inside: t
          }
        }
      }
    }), e.languages.ts = e.languages.typescript;
  }(e);
}

typescript.displayName = "typescript", typescript.aliases = ["ts"];
var refractorJavadoclike$1 = javadoclike_1,
    refractorTypescript$1 = typescript_1,
    jsdoc_1 = jsdoc;

function jsdoc(e) {
  e.register(refractorJavadoclike$1), e.register(refractorTypescript$1), function (e) {
    var t = e.languages.javascript,
        r = /\{(?:[^{}]|\{(?:[^{}]|\{[^{}]*\})*\})+\}/.source,
        n = "(@(?:arg|argument|param|property)\\s+(?:" + r + "\\s+)?)";
    e.languages.jsdoc = e.languages.extend("javadoclike", {
      parameter: {
        pattern: RegExp(n + /(?:(?!\s)[$\w\xA0-\uFFFF.])+(?=\s|$)/.source),
        lookbehind: !0,
        inside: {
          punctuation: /\./
        }
      }
    }), e.languages.insertBefore("jsdoc", "keyword", {
      "optional-parameter": {
        pattern: RegExp(n + /\[(?:(?!\s)[$\w\xA0-\uFFFF.])+(?:=[^[\]]+)?\](?=\s|$)/.source),
        lookbehind: !0,
        inside: {
          parameter: {
            pattern: /(^\[)[$\w\xA0-\uFFFF\.]+/,
            lookbehind: !0,
            inside: {
              punctuation: /\./
            }
          },
          code: {
            pattern: /(=)[\s\S]*(?=\]$)/,
            lookbehind: !0,
            inside: t,
            alias: "language-javascript"
          },
          punctuation: /[=[\]]/
        }
      },
      "class-name": [{
        pattern: RegExp(/(@(?:augments|class|extends|interface|memberof!?|template|this|typedef)\s+(?:<TYPE>\s+)?)[A-Z]\w*(?:\.[A-Z]\w*)*/.source.replace(/<TYPE>/g, function () {
          return r;
        })),
        lookbehind: !0,
        inside: {
          punctuation: /\./
        }
      }, {
        pattern: RegExp("(@[a-z]+\\s+)" + r),
        lookbehind: !0,
        inside: {
          string: t.string,
          number: t.number,
          boolean: t.boolean,
          keyword: e.languages.typescript.keyword,
          operator: /=>|\.\.\.|[&|?:*]/,
          punctuation: /[.,;=<>{}()[\]]/
        }
      }],
      example: {
        pattern: /(@example\s+(?!\s))(?:[^@\s]|\s+(?!\s))+?(?=\s*(?:\*\s*)?(?:@\w|\*\/))/,
        lookbehind: !0,
        inside: {
          code: {
            pattern: /^([\t ]*(?:\*\s*)?)\S.*$/m,
            lookbehind: !0,
            inside: t,
            alias: "language-javascript"
          }
        }
      }
    }), e.languages.javadoclike.addSupport("javascript", e.languages.jsdoc);
  }(e);
}

jsdoc.displayName = "jsdoc", jsdoc.aliases = [];
var json_1 = json;

function json(e) {
  e.languages.json = {
    property: {
      pattern: /(^|[^\\])"(?:\\.|[^\\"\r\n])*"(?=\s*:)/,
      lookbehind: !0,
      greedy: !0
    },
    string: {
      pattern: /(^|[^\\])"(?:\\.|[^\\"\r\n])*"(?!\s*:)/,
      lookbehind: !0,
      greedy: !0
    },
    comment: {
      pattern: /\/\/.*|\/\*[\s\S]*?(?:\*\/|$)/,
      greedy: !0
    },
    number: /-?\b\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i,
    punctuation: /[{}[\],]/,
    operator: /:/,
    boolean: /\b(?:false|true)\b/,
    null: {
      pattern: /\bnull\b/,
      alias: "keyword"
    }
  }, e.languages.webmanifest = e.languages.json;
}

json.displayName = "json", json.aliases = ["webmanifest"];
var refractorJson$1 = json_1,
    json5_1 = json5;

function json5(e) {
  e.register(refractorJson$1), function (e) {
    var t = /("|')(?:\\(?:\r\n?|\n|.)|(?!\1)[^\\\r\n])*\1/;
    e.languages.json5 = e.languages.extend("json", {
      property: [{
        pattern: RegExp(t.source + "(?=\\s*:)"),
        greedy: !0
      }, {
        pattern: /(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/,
        alias: "unquoted"
      }],
      string: {
        pattern: t,
        greedy: !0
      },
      number: /[+-]?\b(?:NaN|Infinity|0x[a-fA-F\d]+)\b|[+-]?(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[eE][+-]?\d+\b)?/
    });
  }(e);
}

json5.displayName = "json5", json5.aliases = [];
var refractorJson = json_1,
    jsonp_1 = jsonp;

function jsonp(e) {
  e.register(refractorJson), e.languages.jsonp = e.languages.extend("json", {
    punctuation: /[{}[\]();,.]/
  }), e.languages.insertBefore("jsonp", "punctuation", {
    function: /(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*\()/
  });
}

jsonp.displayName = "jsonp", jsonp.aliases = [];
var jsstacktrace_1 = jsstacktrace;

function jsstacktrace(e) {
  e.languages.jsstacktrace = {
    "error-message": {
      pattern: /^\S.*/m,
      alias: "string"
    },
    "stack-frame": {
      pattern: /(^[ \t]+)at[ \t].*/m,
      lookbehind: !0,
      inside: {
        "not-my-code": {
          pattern: /^at[ \t]+(?!\s)(?:node\.js|<unknown>|.*(?:node_modules|\(<anonymous>\)|\(<unknown>|<anonymous>$|\(internal\/|\(node\.js)).*/m,
          alias: "comment"
        },
        filename: {
          pattern: /(\bat\s+(?!\s)|\()(?:[a-zA-Z]:)?[^():]+(?=:)/,
          lookbehind: !0,
          alias: "url"
        },
        function: {
          pattern: /(\bat\s+(?:new\s+)?)(?!\s)[_$a-zA-Z\xA0-\uFFFF<][.$\w\xA0-\uFFFF<>]*/,
          lookbehind: !0,
          inside: {
            punctuation: /\./
          }
        },
        punctuation: /[()]/,
        keyword: /\b(?:at|new)\b/,
        alias: {
          pattern: /\[(?:as\s+)?(?!\s)[_$a-zA-Z\xA0-\uFFFF][$\w\xA0-\uFFFF]*\]/,
          alias: "variable"
        },
        "line-number": {
          pattern: /:\d+(?::\d+)?\b/,
          alias: "number",
          inside: {
            punctuation: /:/
          }
        }
      }
    }
  };
}

jsstacktrace.displayName = "jsstacktrace", jsstacktrace.aliases = [];
var jsx_1 = jsx;

function jsx(e) {
  !function (e) {
    var t = e.util.clone(e.languages.javascript),
        r = /(?:\s|\/\/.*(?!.)|\/\*(?:[^*]|\*(?!\/))\*\/)/.source,
        n = /(?:\{(?:\{(?:\{[^{}]*\}|[^{}])*\}|[^{}])*\})/.source,
        a = /(?:\{<S>*\.{3}(?:[^{}]|<BRACES>)*\})/.source;

    function o(e, t) {
      return e = e.replace(/<S>/g, function () {
        return r;
      }).replace(/<BRACES>/g, function () {
        return n;
      }).replace(/<SPREAD>/g, function () {
        return a;
      }), RegExp(e, t);
    }

    a = o(a).source, e.languages.jsx = e.languages.extend("markup", t), e.languages.jsx.tag.pattern = o(/<\/?(?:[\w.:-]+(?:<S>+(?:[\w.:$-]+(?:=(?:"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*'|[^\s{'"/>=]+|<BRACES>))?|<SPREAD>))*<S>*\/?)?>/.source), e.languages.jsx.tag.inside.tag.pattern = /^<\/?[^\s>\/]*/, e.languages.jsx.tag.inside["attr-value"].pattern = /=(?!\{)(?:"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*'|[^\s'">]+)/, e.languages.jsx.tag.inside.tag.inside["class-name"] = /^[A-Z]\w*(?:\.[A-Z]\w*)*$/, e.languages.jsx.tag.inside.comment = t.comment, e.languages.insertBefore("inside", "attr-name", {
      spread: {
        pattern: o(/<SPREAD>/.source),
        inside: e.languages.jsx
      }
    }, e.languages.jsx.tag), e.languages.insertBefore("inside", "special-attr", {
      script: {
        pattern: o(/=<BRACES>/.source),
        alias: "language-javascript",
        inside: {
          "script-punctuation": {
            pattern: /^=(?=\{)/,
            alias: "punctuation"
          },
          rest: e.languages.jsx
        }
      }
    }, e.languages.jsx.tag);

    var i = function i(e) {
      return e ? "string" == typeof e ? e : "string" == typeof e.content ? e.content : e.content.map(i).join("") : "";
    },
        s = function s(t) {
      for (var r = [], n = 0; n < t.length; n++) {
        var a = t[n],
            o = !1;

        if ("string" != typeof a && ("tag" === a.type && a.content[0] && "tag" === a.content[0].type ? "</" === a.content[0].content[0].content ? r.length > 0 && r[r.length - 1].tagName === i(a.content[0].content[1]) && r.pop() : "/>" === a.content[a.content.length - 1].content || r.push({
          tagName: i(a.content[0].content[1]),
          openedBraces: 0
        }) : r.length > 0 && "punctuation" === a.type && "{" === a.content ? r[r.length - 1].openedBraces++ : r.length > 0 && r[r.length - 1].openedBraces > 0 && "punctuation" === a.type && "}" === a.content ? r[r.length - 1].openedBraces-- : o = !0), (o || "string" == typeof a) && r.length > 0 && 0 === r[r.length - 1].openedBraces) {
          var l = i(a);
          n < t.length - 1 && ("string" == typeof t[n + 1] || "plain-text" === t[n + 1].type) && (l += i(t[n + 1]), t.splice(n + 1, 1)), n > 0 && ("string" == typeof t[n - 1] || "plain-text" === t[n - 1].type) && (l = i(t[n - 1]) + l, t.splice(n - 1, 1), n--), t[n] = new e.Token("plain-text", l, null, l);
        }

        a.content && "string" != typeof a.content && s(a.content);
      }
    };

    e.hooks.add("after-tokenize", function (e) {
      "jsx" !== e.language && "tsx" !== e.language || s(e.tokens);
    });
  }(e);
}

jsx.displayName = "jsx", jsx.aliases = [];
var julia_1 = julia;

function julia(e) {
  e.languages.julia = {
    comment: {
      pattern: /(^|[^\\])(?:#=(?:[^#=]|=(?!#)|#(?!=)|#=(?:[^#=]|=(?!#)|#(?!=))*=#)*=#|#.*)/,
      lookbehind: !0
    },
    regex: {
      pattern: /r"(?:\\.|[^"\\\r\n])*"[imsx]{0,4}/,
      greedy: !0
    },
    string: {
      pattern: /"""[\s\S]+?"""|(?:\b\w+)?"(?:\\.|[^"\\\r\n])*"|`(?:[^\\`\r\n]|\\.)*`/,
      greedy: !0
    },
    char: {
      pattern: /(^|[^\w'])'(?:\\[^\r\n][^'\r\n]*|[^\\\r\n])'/,
      lookbehind: !0,
      greedy: !0
    },
    keyword: /\b(?:abstract|baremodule|begin|bitstype|break|catch|ccall|const|continue|do|else|elseif|end|export|finally|for|function|global|if|immutable|import|importall|in|let|local|macro|module|print|println|quote|return|struct|try|type|typealias|using|while)\b/,
    boolean: /\b(?:false|true)\b/,
    number: /(?:\b(?=\d)|\B(?=\.))(?:0[box])?(?:[\da-f]+(?:_[\da-f]+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[efp][+-]?\d+(?:_\d+)*)?j?/i,
    operator: /&&|\|\||[-+*^%÷⊻&$\\]=?|\/[\/=]?|!=?=?|\|[=>]?|<(?:<=?|[=:|])?|>(?:=|>>?=?)?|==?=?|[~≠≤≥'√∛]/,
    punctuation: /::?|[{}[\]();,.?]/,
    constant: /\b(?:(?:Inf|NaN)(?:16|32|64)?|im|pi)\b|[πℯ]/
  };
}

julia.displayName = "julia", julia.aliases = [];
var keepalived_1 = keepalived;

function keepalived(e) {
  e.languages.keepalived = {
    comment: {
      pattern: /[#!].*/,
      greedy: !0
    },
    string: {
      pattern: /(^|[^\\])(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/,
      lookbehind: !0,
      greedy: !0
    },
    ip: {
      pattern: RegExp(/\b(?:(?:(?:[\da-f]{1,4}:){7}[\da-f]{1,4}|(?:[\da-f]{1,4}:){6}:[\da-f]{1,4}|(?:[\da-f]{1,4}:){5}:(?:[\da-f]{1,4}:)?[\da-f]{1,4}|(?:[\da-f]{1,4}:){4}:(?:[\da-f]{1,4}:){0,2}[\da-f]{1,4}|(?:[\da-f]{1,4}:){3}:(?:[\da-f]{1,4}:){0,3}[\da-f]{1,4}|(?:[\da-f]{1,4}:){2}:(?:[\da-f]{1,4}:){0,4}[\da-f]{1,4}|(?:[\da-f]{1,4}:){6}<ipv4>|(?:[\da-f]{1,4}:){0,5}:<ipv4>|::(?:[\da-f]{1,4}:){0,5}<ipv4>|[\da-f]{1,4}::(?:[\da-f]{1,4}:){0,5}[\da-f]{1,4}|::(?:[\da-f]{1,4}:){0,6}[\da-f]{1,4}|(?:[\da-f]{1,4}:){1,7}:)(?:\/\d{1,3})?|<ipv4>(?:\/\d{1,2})?)\b/.source.replace(/<ipv4>/g, function () {
        return /(?:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)\.){3}(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d))/.source;
      }), "i"),
      alias: "number"
    },
    path: {
      pattern: /(\s)\/(?:[^\/\s]+\/)*[^\/\s]*|\b[a-zA-Z]:\\(?:[^\\\s]+\\)*[^\\\s]*/,
      lookbehind: !0,
      alias: "string"
    },
    variable: /\$\{?\w+\}?/,
    email: {
      pattern: /[\w-]+@[\w-]+(?:\.[\w-]{2,3}){1,2}/,
      alias: "string"
    },
    "conditional-configuration": {
      pattern: /@\^?[\w-]+/,
      alias: "variable"
    },
    operator: /=/,
    property: /\b(?:BFD_CHECK|DNS_CHECK|FILE_CHECK|HTTP_GET|MISC_CHECK|NAME|PING_CHECK|SCRIPTS|SMTP_CHECK|SSL|SSL_GET|TCP_CHECK|UDP_CHECK|accept|advert_int|alpha|auth_pass|auth_type|authentication|bfd_cpu_affinity|bfd_instance|bfd_no_swap|bfd_priority|bfd_process_name|bfd_rlimit_rttime|bfd_rt_priority|bind_if|bind_port|bindto|ca|certificate|check_unicast_src|checker|checker_cpu_affinity|checker_log_all_failures|checker_no_swap|checker_priority|checker_rlimit_rttime|checker_rt_priority|child_wait_time|connect_ip|connect_port|connect_timeout|dbus_service_name|debug|default_interface|delay|delay_before_retry|delay_loop|digest|dont_track_primary|dynamic|dynamic_interfaces|enable_(?:dbus|script_security|sni|snmp_checker|snmp_rfc|snmp_rfcv2|snmp_rfcv3|snmp_vrrp|traps)|end|fall|fast_recovery|file|flag-[123]|fork_delay|full_command|fwmark|garp_group|garp_interval|garp_lower_prio_delay|garp_lower_prio_repeat|garp_master_delay|garp_master_refresh|garp_master_refresh_repeat|garp_master_repeat|global_defs|global_tracking|gna_interval|group|ha_suspend|hashed|helo_name|higher_prio_send_advert|hoplimit|http_protocol|hysteresis|idle_tx|include|inhibit_on_failure|init_fail|init_file|instance|interface|interfaces|interval|ip_family|ipvs_process_name|keepalived.conf|kernel_rx_buf_size|key|linkbeat_interfaces|linkbeat_use_polling|log_all_failures|log_unknown_vrids|lower_prio_no_advert|lthreshold|lvs_flush|lvs_flush_onstop|lvs_method|lvs_netlink_cmd_rcv_bufs|lvs_netlink_cmd_rcv_bufs_force|lvs_netlink_monitor_rcv_bufs|lvs_netlink_monitor_rcv_bufs_force|lvs_notify_fifo|lvs_notify_fifo_script|lvs_sched|lvs_sync_daemon|max_auto_priority|max_hops|mcast_src_ip|mh-fallback|mh-port|min_auto_priority_delay|min_rx|min_tx|misc_dynamic|misc_path|misc_timeout|multiplier|name|namespace_with_ipsets|native_ipv6|neighbor_ip|net_namespace|net_namespace_ipvs|nftables|nftables_counters|nftables_ifindex|nftables_priority|no_accept|no_checker_emails|no_email_faults|nopreempt|notification_email|notification_email_from|notify|notify_backup|notify_deleted|notify_down|notify_fault|notify_fifo|notify_fifo_script|notify_master|notify_master_rx_lower_pri|notify_priority_changes|notify_stop|notify_up|old_unicast_checksum|omega|ops|param_match|passive|password|path|persistence_engine|persistence_granularity|persistence_timeout|preempt|preempt_delay|priority|process|process_monitor_rcv_bufs|process_monitor_rcv_bufs_force|process_name|process_names|promote_secondaries|protocol|proxy_arp|proxy_arp_pvlan|quorum|quorum_down|quorum_max|quorum_up|random_seed|real_server|regex|regex_max_offset|regex_min_offset|regex_no_match|regex_options|regex_stack|reload_repeat|reload_time_file|require_reply|retry|rise|router_id|rs_init_notifies|script|script_user|sh-fallback|sh-port|shutdown_script|shutdown_script_timeout|skip_check_adv_addr|smtp_alert|smtp_alert_checker|smtp_alert_vrrp|smtp_connect_timeout|smtp_helo_name|smtp_server|snmp_socket|sorry_server|sorry_server_inhibit|sorry_server_lvs_method|source_ip|start|startup_script|startup_script_timeout|state|static_ipaddress|static_routes|static_rules|status_code|step|strict_mode|sync_group_tracking_weight|terminate_delay|timeout|track_bfd|track_file|track_group|track_interface|track_process|track_script|track_src_ip|ttl|type|umask|unicast_peer|unicast_src_ip|unicast_ttl|url|use_ipvlan|use_pid_dir|use_vmac|user|uthreshold|val[123]|version|virtual_ipaddress|virtual_ipaddress_excluded|virtual_router_id|virtual_routes|virtual_rules|virtual_server|virtual_server_group|virtualhost|vmac_xmit_base|vrrp|vrrp_(?:check_unicast_src|cpu_affinity|garp_interval|garp_lower_prio_delay|garp_lower_prio_repeat|garp_master_delay|garp_master_refresh|garp_master_refresh_repeat|garp_master_repeat|gna_interval|higher_prio_send_advert|instance|ipsets|iptables|lower_prio_no_advert|mcast_group4|mcast_group6|min_garp|netlink_cmd_rcv_bufs|netlink_cmd_rcv_bufs_force|netlink_monitor_rcv_bufs|netlink_monitor_rcv_bufs_force|no_swap|notify_fifo|notify_fifo_script|notify_priority_changes|priority|process_name|rlimit_rttime|rt_priority|rx_bufs_multiplier|rx_bufs_policy|script|skip_check_adv_addr|startup_delay|strict|sync_group|track_process|version)|warmup|weight)\b/,
    constant: /\b(?:A|AAAA|AH|BACKUP|CNAME|DR|MASTER|MX|NAT|NS|PASS|SCTP|SOA|TCP|TUN|TXT|UDP|dh|fo|lblc|lblcr|lc|mh|nq|ovf|rr|sed|sh|wlc|wrr)\b/,
    number: {
      pattern: /(^|[^\w.-])-?\d+(?:\.\d+)?/,
      lookbehind: !0
    },
    boolean: /\b(?:false|no|off|on|true|yes)\b/,
    punctuation: /[\{\}]/
  };
}

keepalived.displayName = "keepalived", keepalived.aliases = [];
var keyman_1 = keyman;

function keyman(e) {
  e.languages.keyman = {
    comment: {
      pattern: /\bc .*/i,
      greedy: !0
    },
    string: {
      pattern: /"[^"\r\n]*"|'[^'\r\n]*'/,
      greedy: !0
    },
    "virtual-key": {
      pattern: /\[\s*(?:(?:ALT|CAPS|CTRL|LALT|LCTRL|NCAPS|RALT|RCTRL|SHIFT)\s+)*(?:[TKU]_[\w?]+|[A-E]\d\d?|"[^"\r\n]*"|'[^'\r\n]*')\s*\]/i,
      greedy: !0,
      alias: "function"
    },
    "header-keyword": {
      pattern: /&\w+/,
      alias: "bold"
    },
    "header-statement": {
      pattern: /\b(?:bitmap|bitmaps|caps always off|caps on only|copyright|hotkey|language|layout|message|name|shift frees caps|version)\b/i,
      alias: "bold"
    },
    "rule-keyword": {
      pattern: /\b(?:any|baselayout|beep|call|context|deadkey|dk|if|index|layer|notany|nul|outs|platform|reset|return|save|set|store|use)\b/i,
      alias: "keyword"
    },
    "structural-keyword": {
      pattern: /\b(?:ansi|begin|group|match|nomatch|unicode|using keys)\b/i,
      alias: "keyword"
    },
    "compile-target": {
      pattern: /\$(?:keyman|keymanonly|keymanweb|kmfl|weaver):/i,
      alias: "property"
    },
    number: /\b(?:U\+[\dA-F]+|d\d+|x[\da-f]+|\d+)\b/i,
    operator: /[+>\\$]|\.\./,
    punctuation: /[()=,]/
  };
}

keyman.displayName = "keyman", keyman.aliases = [];
var kotlin_1 = kotlin;

function kotlin(e) {
  !function (e) {
    e.languages.kotlin = e.languages.extend("clike", {
      keyword: {
        pattern: /(^|[^.])\b(?:abstract|actual|annotation|as|break|by|catch|class|companion|const|constructor|continue|crossinline|data|do|dynamic|else|enum|expect|external|final|finally|for|fun|get|if|import|in|infix|init|inline|inner|interface|internal|is|lateinit|noinline|null|object|open|operator|out|override|package|private|protected|public|reified|return|sealed|set|super|suspend|tailrec|this|throw|to|try|typealias|val|var|vararg|when|where|while)\b/,
        lookbehind: !0
      },
      function: [{
        pattern: /(?:`[^\r\n`]+`|\b\w+)(?=\s*\()/,
        greedy: !0
      }, {
        pattern: /(\.)(?:`[^\r\n`]+`|\w+)(?=\s*\{)/,
        lookbehind: !0,
        greedy: !0
      }],
      number: /\b(?:0[xX][\da-fA-F]+(?:_[\da-fA-F]+)*|0[bB][01]+(?:_[01]+)*|\d+(?:_\d+)*(?:\.\d+(?:_\d+)*)?(?:[eE][+-]?\d+(?:_\d+)*)?[fFL]?)\b/,
      operator: /\+[+=]?|-[-=>]?|==?=?|!(?:!|==?)?|[\/*%<>]=?|[?:]:?|\.\.|&&|\|\||\b(?:and|inv|or|shl|shr|ushr|xor)\b/
    }), delete e.languages.kotlin["class-name"];
    var t = {
      "interpolation-punctuation": {
        pattern: /^\$\{?|\}$/,
        alias: "punctuation"
      },
      expression: {
        pattern: /[\s\S]+/,
        inside: e.languages.kotlin
      }
    };
    e.languages.insertBefore("kotlin", "string", {
      "string-literal": [{
        pattern: /"""(?:[^$]|\$(?:(?!\{)|\{[^{}]*\}))*?"""/,
        alias: "multiline",
        inside: {
          interpolation: {
            pattern: /\$(?:[a-z_]\w*|\{[^{}]*\})/i,
            inside: t
          },
          string: /[\s\S]+/
        }
      }, {
        pattern: /"(?:[^"\\\r\n$]|\\.|\$(?:(?!\{)|\{[^{}]*\}))*"/,
        alias: "singleline",
        inside: {
          interpolation: {
            pattern: /((?:^|[^\\])(?:\\{2})*)\$(?:[a-z_]\w*|\{[^{}]*\})/i,
            lookbehind: !0,
            inside: t
          },
          string: /[\s\S]+/
        }
      }],
      char: {
        pattern: /'(?:[^'\\\r\n]|\\(?:.|u[a-fA-F0-9]{0,4}))'/,
        greedy: !0
      }
    }), delete e.languages.kotlin.string, e.languages.insertBefore("kotlin", "keyword", {
      annotation: {
        pattern: /\B@(?:\w+:)?(?:[A-Z]\w*|\[[^\]]+\])/,
        alias: "builtin"
      }
    }), e.languages.insertBefore("kotlin", "function", {
      label: {
        pattern: /\b\w+@|@\w+\b/,
        alias: "symbol"
      }
    }), e.languages.kt = e.languages.kotlin, e.languages.kts = e.languages.kotlin;
  }(e);
}

kotlin.displayName = "kotlin", kotlin.aliases = ["kt", "kts"];
var kumir_1 = kumir;

function kumir(e) {
  !function (e) {
    var t = /\s\x00-\x1f\x22-\x2f\x3a-\x3f\x5b-\x5e\x60\x7b-\x7e/.source;

    function r(e, r) {
      return RegExp(e.replace(/<nonId>/g, t), r);
    }

    e.languages.kumir = {
      comment: {
        pattern: /\|.*/
      },
      prolog: {
        pattern: /#.*/,
        greedy: !0
      },
      string: {
        pattern: /"[^\n\r"]*"|'[^\n\r']*'/,
        greedy: !0
      },
      boolean: {
        pattern: r(/(^|[<nonId>])(?:да|нет)(?=[<nonId>]|$)/.source),
        lookbehind: !0
      },
      "operator-word": {
        pattern: r(/(^|[<nonId>])(?:и|или|не)(?=[<nonId>]|$)/.source),
        lookbehind: !0,
        alias: "keyword"
      },
      "system-variable": {
        pattern: r(/(^|[<nonId>])знач(?=[<nonId>]|$)/.source),
        lookbehind: !0,
        alias: "keyword"
      },
      type: [{
        pattern: r(/(^|[<nonId>])(?:вещ|лит|лог|сим|цел)(?:\x20*таб)?(?=[<nonId>]|$)/.source),
        lookbehind: !0,
        alias: "builtin"
      }, {
        pattern: r(/(^|[<nonId>])(?:компл|сканкод|файл|цвет)(?=[<nonId>]|$)/.source),
        lookbehind: !0,
        alias: "important"
      }],
      keyword: {
        pattern: r(/(^|[<nonId>])(?:алг|арг(?:\x20*рез)?|ввод|ВКЛЮЧИТЬ|вс[её]|выбор|вывод|выход|дано|для|до|дс|если|иначе|исп|использовать|кон(?:(?:\x20+|_)исп)?|кц(?:(?:\x20+|_)при)?|надо|нач|нс|нц|от|пауза|пока|при|раза?|рез|стоп|таб|то|утв|шаг)(?=[<nonId>]|$)/.source),
        lookbehind: !0
      },
      name: {
        pattern: r(/(^|[<nonId>])[^\d<nonId>][^<nonId>]*(?:\x20+[^<nonId>]+)*(?=[<nonId>]|$)/.source),
        lookbehind: !0
      },
      number: {
        pattern: r(/(^|[<nonId>])(?:\B\$[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?)(?=[<nonId>]|$)/.source, "i"),
        lookbehind: !0
      },
      punctuation: /:=|[(),:;\[\]]/,
      "operator-char": {
        pattern: /\*\*?|<[=>]?|>=?|[-+/=]/,
        alias: "operator"
      }
    }, e.languages.kum = e.languages.kumir;
  }(e);
}

kumir.displayName = "kumir", kumir.aliases = ["kum"];
var kusto_1 = kusto;

function kusto(e) {
  e.languages.kusto = {
    comment: {
      pattern: /\/\/.*/,
      greedy: !0
    },
    string: {
      pattern: /```[\s\S]*?```|[hH]?(?:"(?:[^\r\n\\"]|\\.)*"|'(?:[^\r\n\\']|\\.)*'|@(?:"[^\r\n"]*"|'[^\r\n']*'))/,
      greedy: !0
    },
    verb: {
      pattern: /(\|\s*)[a-z][\w-]*/i,
      lookbehind: !0,
      alias: "keyword"
    },
    command: {
      pattern: /\.[a-z][a-z\d-]*\b/,
      alias: "keyword"
    },
    "class-name": /\b(?:bool|datetime|decimal|dynamic|guid|int|long|real|string|timespan)\b/,
    keyword: /\b(?:access|alias|and|anti|as|asc|auto|between|by|(?:contains|(?:ends|starts)with|has(?:perfix|suffix)?)(?:_cs)?|database|declare|desc|external|from|fullouter|has_all|in|ingestion|inline|inner|innerunique|into|(?:left|right)(?:anti(?:semi)?|inner|outer|semi)?|let|like|local|not|of|on|or|pattern|print|query_parameters|range|restrict|schema|set|step|table|tables|to|view|where|with|matches\s+regex|nulls\s+(?:first|last))(?![\w-])/,
    boolean: /\b(?:false|null|true)\b/,
    function: /\b[a-z_]\w*(?=\s*\()/,
    datetime: [{
      pattern: /\b(?:(?:Fri|Friday|Mon|Monday|Sat|Saturday|Sun|Sunday|Thu|Thursday|Tue|Tuesday|Wed|Wednesday)\s*,\s*)?\d{1,2}(?:\s+|-)(?:Apr|Aug|Dec|Feb|Jan|Jul|Jun|Mar|May|Nov|Oct|Sep)(?:\s+|-)\d{2}\s+\d{2}:\d{2}(?::\d{2})?(?:\s*(?:\b(?:[A-Z]|(?:[ECMT][DS]|GM|U)T)|[+-]\d{4}))?\b/,
      alias: "number"
    }, {
      pattern: /[+-]?\b(?:\d{4}-\d{2}-\d{2}(?:[ T]\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?)?|\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?)Z?/,
      alias: "number"
    }],
    number: /\b(?:0x[0-9A-Fa-f]+|\d+(?:\.\d+)?(?:[Ee][+-]?\d+)?)(?:(?:min|sec|[mnµ]s|[dhms]|microsecond|tick)\b)?|[+-]?\binf\b/,
    operator: /=>|[!=]~|[!=<>]=?|[-+*/%|]|\.\./,
    punctuation: /[()\[\]{},;.:]/
  };
}

kusto.displayName = "kusto", kusto.aliases = [];
var latex_1 = latex;

function latex(e) {
  !function (e) {
    var t = /\\(?:[^a-z()[\]]|[a-z*]+)/i,
        r = {
      "equation-command": {
        pattern: t,
        alias: "regex"
      }
    };
    e.languages.latex = {
      comment: /%.*/,
      cdata: {
        pattern: /(\\begin\{((?:lstlisting|verbatim)\*?)\})[\s\S]*?(?=\\end\{\2\})/,
        lookbehind: !0
      },
      equation: [{
        pattern: /\$\$(?:\\[\s\S]|[^\\$])+\$\$|\$(?:\\[\s\S]|[^\\$])+\$|\\\([\s\S]*?\\\)|\\\[[\s\S]*?\\\]/,
        inside: r,
        alias: "string"
      }, {
        pattern: /(\\begin\{((?:align|eqnarray|equation|gather|math|multline)\*?)\})[\s\S]*?(?=\\end\{\2\})/,
        lookbehind: !0,
        inside: r,
        alias: "string"
      }],
      keyword: {
        pattern: /(\\(?:begin|cite|documentclass|end|label|ref|usepackage)(?:\[[^\]]+\])?\{)[^}]+(?=\})/,
        lookbehind: !0
      },
      url: {
        pattern: /(\\url\{)[^}]+(?=\})/,
        lookbehind: !0
      },
      headline: {
        pattern: /(\\(?:chapter|frametitle|paragraph|part|section|subparagraph|subsection|subsubparagraph|subsubsection|subsubsubparagraph)\*?(?:\[[^\]]+\])?\{)[^}]+(?=\})/,
        lookbehind: !0,
        alias: "class-name"
      },
      function: {
        pattern: t,
        alias: "selector"
      },
      punctuation: /[[\]{}&]/
    }, e.languages.tex = e.languages.latex, e.languages.context = e.languages.latex;
  }(e);
}

latex.displayName = "latex", latex.aliases = ["tex", "context"];
var refractorMarkupTemplating$6 = markupTemplating_1,
    php_1 = php;

function php(e) {
  e.register(refractorMarkupTemplating$6), function (e) {
    var t = /\/\*[\s\S]*?\*\/|\/\/.*|#(?!\[).*/,
        r = [{
      pattern: /\b(?:false|true)\b/i,
      alias: "boolean"
    }, {
      pattern: /(::\s*)\b[a-z_]\w*\b(?!\s*\()/i,
      greedy: !0,
      lookbehind: !0
    }, {
      pattern: /(\b(?:case|const)\s+)\b[a-z_]\w*(?=\s*[;=])/i,
      greedy: !0,
      lookbehind: !0
    }, /\b(?:null)\b/i, /\b[A-Z_][A-Z0-9_]*\b(?!\s*\()/],
        n = /\b0b[01]+(?:_[01]+)*\b|\b0o[0-7]+(?:_[0-7]+)*\b|\b0x[\da-f]+(?:_[\da-f]+)*\b|(?:\b\d+(?:_\d+)*\.?(?:\d+(?:_\d+)*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
        a = /<?=>|\?\?=?|\.{3}|\??->|[!=]=?=?|::|\*\*=?|--|\+\+|&&|\|\||<<|>>|[?~]|[/^|%*&<>.+-]=?/,
        o = /[{}\[\](),:;]/;
    e.languages.php = {
      delimiter: {
        pattern: /\?>$|^<\?(?:php(?=\s)|=)?/i,
        alias: "important"
      },
      comment: t,
      variable: /\$+(?:\w+\b|(?=\{))/,
      package: {
        pattern: /(namespace\s+|use\s+(?:function\s+)?)(?:\\?\b[a-z_]\w*)+\b(?!\\)/i,
        lookbehind: !0,
        inside: {
          punctuation: /\\/
        }
      },
      "class-name-definition": {
        pattern: /(\b(?:class|enum|interface|trait)\s+)\b[a-z_]\w*(?!\\)\b/i,
        lookbehind: !0,
        alias: "class-name"
      },
      "function-definition": {
        pattern: /(\bfunction\s+)[a-z_]\w*(?=\s*\()/i,
        lookbehind: !0,
        alias: "function"
      },
      keyword: [{
        pattern: /(\(\s*)\b(?:array|bool|boolean|float|int|integer|object|string)\b(?=\s*\))/i,
        alias: "type-casting",
        greedy: !0,
        lookbehind: !0
      }, {
        pattern: /([(,?]\s*)\b(?:array(?!\s*\()|bool|callable|(?:false|null)(?=\s*\|)|float|int|iterable|mixed|object|self|static|string)\b(?=\s*\$)/i,
        alias: "type-hint",
        greedy: !0,
        lookbehind: !0
      }, {
        pattern: /(\)\s*:\s*(?:\?\s*)?)\b(?:array(?!\s*\()|bool|callable|(?:false|null)(?=\s*\|)|float|int|iterable|mixed|object|self|static|string|void)\b/i,
        alias: "return-type",
        greedy: !0,
        lookbehind: !0
      }, {
        pattern: /\b(?:array(?!\s*\()|bool|float|int|iterable|mixed|object|string|void)\b/i,
        alias: "type-declaration",
        greedy: !0
      }, {
        pattern: /(\|\s*)(?:false|null)\b|\b(?:false|null)(?=\s*\|)/i,
        alias: "type-declaration",
        greedy: !0,
        lookbehind: !0
      }, {
        pattern: /\b(?:parent|self|static)(?=\s*::)/i,
        alias: "static-context",
        greedy: !0
      }, {
        pattern: /(\byield\s+)from\b/i,
        lookbehind: !0
      }, /\bclass\b/i, {
        pattern: /((?:^|[^\s>:]|(?:^|[^-])>|(?:^|[^:]):)\s*)\b(?:abstract|and|array|as|break|callable|case|catch|clone|const|continue|declare|default|die|do|echo|else|elseif|empty|enddeclare|endfor|endforeach|endif|endswitch|endwhile|enum|eval|exit|extends|final|finally|fn|for|foreach|function|global|goto|if|implements|include|include_once|instanceof|insteadof|interface|isset|list|match|namespace|new|or|parent|print|private|protected|public|require|require_once|return|self|static|switch|throw|trait|try|unset|use|var|while|xor|yield|__halt_compiler)\b/i,
        lookbehind: !0
      }],
      "argument-name": {
        pattern: /([(,]\s+)\b[a-z_]\w*(?=\s*:(?!:))/i,
        lookbehind: !0
      },
      "class-name": [{
        pattern: /(\b(?:extends|implements|instanceof|new(?!\s+self|\s+static))\s+|\bcatch\s*\()\b[a-z_]\w*(?!\\)\b/i,
        greedy: !0,
        lookbehind: !0
      }, {
        pattern: /(\|\s*)\b[a-z_]\w*(?!\\)\b/i,
        greedy: !0,
        lookbehind: !0
      }, {
        pattern: /\b[a-z_]\w*(?!\\)\b(?=\s*\|)/i,
        greedy: !0
      }, {
        pattern: /(\|\s*)(?:\\?\b[a-z_]\w*)+\b/i,
        alias: "class-name-fully-qualified",
        greedy: !0,
        lookbehind: !0,
        inside: {
          punctuation: /\\/
        }
      }, {
        pattern: /(?:\\?\b[a-z_]\w*)+\b(?=\s*\|)/i,
        alias: "class-name-fully-qualified",
        greedy: !0,
        inside: {
          punctuation: /\\/
        }
      }, {
        pattern: /(\b(?:extends|implements|instanceof|new(?!\s+self\b|\s+static\b))\s+|\bcatch\s*\()(?:\\?\b[a-z_]\w*)+\b(?!\\)/i,
        alias: "class-name-fully-qualified",
        greedy: !0,
        lookbehind: !0,
        inside: {
          punctuation: /\\/
        }
      }, {
        pattern: /\b[a-z_]\w*(?=\s*\$)/i,
        alias: "type-declaration",
        greedy: !0
      }, {
        pattern: /(?:\\?\b[a-z_]\w*)+(?=\s*\$)/i,
        alias: ["class-name-fully-qualified", "type-declaration"],
        greedy: !0,
        inside: {
          punctuation: /\\/
        }
      }, {
        pattern: /\b[a-z_]\w*(?=\s*::)/i,
        alias: "static-context",
        greedy: !0
      }, {
        pattern: /(?:\\?\b[a-z_]\w*)+(?=\s*::)/i,
        alias: ["class-name-fully-qualified", "static-context"],
        greedy: !0,
        inside: {
          punctuation: /\\/
        }
      }, {
        pattern: /([(,?]\s*)[a-z_]\w*(?=\s*\$)/i,
        alias: "type-hint",
        greedy: !0,
        lookbehind: !0
      }, {
        pattern: /([(,?]\s*)(?:\\?\b[a-z_]\w*)+(?=\s*\$)/i,
        alias: ["class-name-fully-qualified", "type-hint"],
        greedy: !0,
        lookbehind: !0,
        inside: {
          punctuation: /\\/
        }
      }, {
        pattern: /(\)\s*:\s*(?:\?\s*)?)\b[a-z_]\w*(?!\\)\b/i,
        alias: "return-type",
        greedy: !0,
        lookbehind: !0
      }, {
        pattern: /(\)\s*:\s*(?:\?\s*)?)(?:\\?\b[a-z_]\w*)+\b(?!\\)/i,
        alias: ["class-name-fully-qualified", "return-type"],
        greedy: !0,
        lookbehind: !0,
        inside: {
          punctuation: /\\/
        }
      }],
      constant: r,
      function: {
        pattern: /(^|[^\\\w])\\?[a-z_](?:[\w\\]*\w)?(?=\s*\()/i,
        lookbehind: !0,
        inside: {
          punctuation: /\\/
        }
      },
      property: {
        pattern: /(->\s*)\w+/,
        lookbehind: !0
      },
      number: n,
      operator: a,
      punctuation: o
    };
    var i = {
      pattern: /\{\$(?:\{(?:\{[^{}]+\}|[^{}]+)\}|[^{}])+\}|(^|[^\\{])\$+(?:\w+(?:\[[^\r\n\[\]]+\]|->\w+)?)/,
      lookbehind: !0,
      inside: e.languages.php
    },
        s = [{
      pattern: /<<<'([^']+)'[\r\n](?:.*[\r\n])*?\1;/,
      alias: "nowdoc-string",
      greedy: !0,
      inside: {
        delimiter: {
          pattern: /^<<<'[^']+'|[a-z_]\w*;$/i,
          alias: "symbol",
          inside: {
            punctuation: /^<<<'?|[';]$/
          }
        }
      }
    }, {
      pattern: /<<<(?:"([^"]+)"[\r\n](?:.*[\r\n])*?\1;|([a-z_]\w*)[\r\n](?:.*[\r\n])*?\2;)/i,
      alias: "heredoc-string",
      greedy: !0,
      inside: {
        delimiter: {
          pattern: /^<<<(?:"[^"]+"|[a-z_]\w*)|[a-z_]\w*;$/i,
          alias: "symbol",
          inside: {
            punctuation: /^<<<"?|[";]$/
          }
        },
        interpolation: i
      }
    }, {
      pattern: /`(?:\\[\s\S]|[^\\`])*`/,
      alias: "backtick-quoted-string",
      greedy: !0
    }, {
      pattern: /'(?:\\[\s\S]|[^\\'])*'/,
      alias: "single-quoted-string",
      greedy: !0
    }, {
      pattern: /"(?:\\[\s\S]|[^\\"])*"/,
      alias: "double-quoted-string",
      greedy: !0,
      inside: {
        interpolation: i
      }
    }];
    e.languages.insertBefore("php", "variable", {
      string: s,
      attribute: {
        pattern: /#\[(?:[^"'\/#]|\/(?![*/])|\/\/.*$|#(?!\[).*$|\/\*(?:[^*]|\*(?!\/))*\*\/|"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*')+\](?=\s*[a-z$#])/im,
        greedy: !0,
        inside: {
          "attribute-content": {
            pattern: /^(#\[)[\s\S]+(?=\]$)/,
            lookbehind: !0,
            inside: {
              comment: t,
              string: s,
              "attribute-class-name": [{
                pattern: /([^:]|^)\b[a-z_]\w*(?!\\)\b/i,
                alias: "class-name",
                greedy: !0,
                lookbehind: !0
              }, {
                pattern: /([^:]|^)(?:\\?\b[a-z_]\w*)+/i,
                alias: ["class-name", "class-name-fully-qualified"],
                greedy: !0,
                lookbehind: !0,
                inside: {
                  punctuation: /\\/
                }
              }],
              constant: r,
              number: n,
              operator: a,
              punctuation: o
            }
          },
          delimiter: {
            pattern: /^#\[|\]$/,
            alias: "punctuation"
          }
        }
      }
    }), e.hooks.add("before-tokenize", function (t) {
      if (/<\?/.test(t.code)) {
        e.languages["markup-templating"].buildPlaceholders(t, "php", /<\?(?:[^"'/#]|\/(?![*/])|("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|(?:\/\/|#(?!\[))(?:[^?\n\r]|\?(?!>))*(?=$|\?>|[\r\n])|#\[|\/\*(?:[^*]|\*(?!\/))*(?:\*\/|$))*?(?:\?>|$)/g);
      }
    }), e.hooks.add("after-tokenize", function (t) {
      e.languages["markup-templating"].tokenizePlaceholders(t, "php");
    });
  }(e);
}

php.displayName = "php", php.aliases = [];
var refractorMarkupTemplating$5 = markupTemplating_1,
    refractorPhp$2 = php_1,
    latte_1 = latte;

function latte(e) {
  e.register(refractorMarkupTemplating$5), e.register(refractorPhp$2), function (e) {
    e.languages.latte = {
      comment: /^\{\*[\s\S]*/,
      "latte-tag": {
        pattern: /(^\{(?:\/(?=[a-z]))?)(?:[=_]|[a-z]\w*\b(?!\())/i,
        lookbehind: !0,
        alias: "important"
      },
      delimiter: {
        pattern: /^\{\/?|\}$/,
        alias: "punctuation"
      },
      php: {
        pattern: /\S(?:[\s\S]*\S)?/,
        alias: "language-php",
        inside: e.languages.php
      }
    };
    var t = e.languages.extend("markup", {});
    e.languages.insertBefore("inside", "attr-value", {
      "n-attr": {
        pattern: /n:[\w-]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+))?/,
        inside: {
          "attr-name": {
            pattern: /^[^\s=]+/,
            alias: "important"
          },
          "attr-value": {
            pattern: /=[\s\S]+/,
            inside: {
              punctuation: [/^=/, {
                pattern: /^(\s*)["']|["']$/,
                lookbehind: !0
              }],
              php: {
                pattern: /\S(?:[\s\S]*\S)?/,
                inside: e.languages.php
              }
            }
          }
        }
      }
    }, t.tag), e.hooks.add("before-tokenize", function (r) {
      if ("latte" === r.language) {
        e.languages["markup-templating"].buildPlaceholders(r, "latte", /\{\*[\s\S]*?\*\}|\{[^'"\s{}*](?:[^"'/{}]|\/(?![*/])|("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|\/\*(?:[^*]|\*(?!\/))*\*\/)*\}/g), r.grammar = t;
      }
    }), e.hooks.add("after-tokenize", function (t) {
      e.languages["markup-templating"].tokenizePlaceholders(t, "latte");
    });
  }(e);
}

latte.displayName = "latte", latte.aliases = [];
var less_1 = less;

function less(e) {
  e.languages.less = e.languages.extend("css", {
    comment: [/\/\*[\s\S]*?\*\//, {
      pattern: /(^|[^\\])\/\/.*/,
      lookbehind: !0
    }],
    atrule: {
      pattern: /@[\w-](?:\((?:[^(){}]|\([^(){}]*\))*\)|[^(){};\s]|\s+(?!\s))*?(?=\s*\{)/,
      inside: {
        punctuation: /[:()]/
      }
    },
    selector: {
      pattern: /(?:@\{[\w-]+\}|[^{};\s@])(?:@\{[\w-]+\}|\((?:[^(){}]|\([^(){}]*\))*\)|[^(){};@\s]|\s+(?!\s))*?(?=\s*\{)/,
      inside: {
        variable: /@+[\w-]+/
      }
    },
    property: /(?:@\{[\w-]+\}|[\w-])+(?:\+_?)?(?=\s*:)/,
    operator: /[+\-*\/]/
  }), e.languages.insertBefore("less", "property", {
    variable: [{
      pattern: /@[\w-]+\s*:/,
      inside: {
        punctuation: /:/
      }
    }, /@@?[\w-]+/],
    "mixin-usage": {
      pattern: /([{;]\s*)[.#](?!\d)[\w-].*?(?=[(;])/,
      lookbehind: !0,
      alias: "function"
    }
  });
}

less.displayName = "less", less.aliases = [];
var scheme_1 = scheme;

function scheme(e) {
  !function (e) {
    e.languages.scheme = {
      comment: /;.*|#;\s*(?:\((?:[^()]|\([^()]*\))*\)|\[(?:[^\[\]]|\[[^\[\]]*\])*\])|#\|(?:[^#|]|#(?!\|)|\|(?!#)|#\|(?:[^#|]|#(?!\|)|\|(?!#))*\|#)*\|#/,
      string: {
        pattern: /"(?:[^"\\]|\\.)*"/,
        greedy: !0
      },
      symbol: {
        pattern: /'[^()\[\]#'\s]+/,
        greedy: !0
      },
      char: {
        pattern: /#\\(?:[ux][a-fA-F\d]+\b|[-a-zA-Z]+\b|[\uD800-\uDBFF][\uDC00-\uDFFF]|\S)/,
        greedy: !0
      },
      "lambda-parameter": [{
        pattern: /((?:^|[^'`#])[(\[]lambda\s+)(?:[^|()\[\]'\s]+|\|(?:[^\\|]|\\.)*\|)/,
        lookbehind: !0
      }, {
        pattern: /((?:^|[^'`#])[(\[]lambda\s+[(\[])[^()\[\]']+/,
        lookbehind: !0
      }],
      keyword: {
        pattern: /((?:^|[^'`#])[(\[])(?:begin|case(?:-lambda)?|cond(?:-expand)?|define(?:-library|-macro|-record-type|-syntax|-values)?|defmacro|delay(?:-force)?|do|else|except|export|guard|if|import|include(?:-ci|-library-declarations)?|lambda|let(?:rec)?(?:-syntax|-values|\*)?|let\*-values|only|parameterize|prefix|(?:quasi-?)?quote|rename|set!|syntax-(?:case|rules)|unless|unquote(?:-splicing)?|when)(?=[()\[\]\s]|$)/,
        lookbehind: !0
      },
      builtin: {
        pattern: /((?:^|[^'`#])[(\[])(?:abs|and|append|apply|assoc|ass[qv]|binary-port\?|boolean=?\?|bytevector(?:-append|-copy|-copy!|-length|-u8-ref|-u8-set!|\?)?|caar|cadr|call-with-(?:current-continuation|port|values)|call\/cc|car|cdar|cddr|cdr|ceiling|char(?:->integer|-ready\?|\?|<\?|<=\?|=\?|>\?|>=\?)|close-(?:input-port|output-port|port)|complex\?|cons|current-(?:error|input|output)-port|denominator|dynamic-wind|eof-object\??|eq\?|equal\?|eqv\?|error|error-object(?:-irritants|-message|\?)|eval|even\?|exact(?:-integer-sqrt|-integer\?|\?)?|expt|features|file-error\?|floor(?:-quotient|-remainder|\/)?|flush-output-port|for-each|gcd|get-output-(?:bytevector|string)|inexact\??|input-port(?:-open\?|\?)|integer(?:->char|\?)|lcm|length|list(?:->string|->vector|-copy|-ref|-set!|-tail|\?)?|make-(?:bytevector|list|parameter|string|vector)|map|max|member|memq|memv|min|modulo|negative\?|newline|not|null\?|number(?:->string|\?)|numerator|odd\?|open-(?:input|output)-(?:bytevector|string)|or|output-port(?:-open\?|\?)|pair\?|peek-char|peek-u8|port\?|positive\?|procedure\?|quotient|raise|raise-continuable|rational\?|rationalize|read-(?:bytevector|bytevector!|char|error\?|line|string|u8)|real\?|remainder|reverse|round|set-c[ad]r!|square|string(?:->list|->number|->symbol|->utf8|->vector|-append|-copy|-copy!|-fill!|-for-each|-length|-map|-ref|-set!|\?|<\?|<=\?|=\?|>\?|>=\?)?|substring|symbol(?:->string|\?|=\?)|syntax-error|textual-port\?|truncate(?:-quotient|-remainder|\/)?|u8-ready\?|utf8->string|values|vector(?:->list|->string|-append|-copy|-copy!|-fill!|-for-each|-length|-map|-ref|-set!|\?)?|with-exception-handler|write-(?:bytevector|char|string|u8)|zero\?)(?=[()\[\]\s]|$)/,
        lookbehind: !0
      },
      operator: {
        pattern: /((?:^|[^'`#])[(\[])(?:[-+*%/]|[<>]=?|=>?)(?=[()\[\]\s]|$)/,
        lookbehind: !0
      },
      number: {
        pattern: RegExp(function (e) {
          for (var t in e) {
            e[t] = e[t].replace(/<[\w\s]+>/g, function (t) {
              return "(?:" + e[t].trim() + ")";
            });
          }

          return e[t];
        }({
          "<ureal dec>": /\d+(?:\/\d+)|(?:\d+(?:\.\d*)?|\.\d+)(?:[esfdl][+-]?\d+)?/.source,
          "<real dec>": /[+-]?<ureal dec>|[+-](?:inf|nan)\.0/.source,
          "<imaginary dec>": /[+-](?:<ureal dec>|(?:inf|nan)\.0)?i/.source,
          "<complex dec>": /<real dec>(?:@<real dec>|<imaginary dec>)?|<imaginary dec>/.source,
          "<num dec>": /(?:#d(?:#[ei])?|#[ei](?:#d)?)?<complex dec>/.source,
          "<ureal box>": /[0-9a-f]+(?:\/[0-9a-f]+)?/.source,
          "<real box>": /[+-]?<ureal box>|[+-](?:inf|nan)\.0/.source,
          "<imaginary box>": /[+-](?:<ureal box>|(?:inf|nan)\.0)?i/.source,
          "<complex box>": /<real box>(?:@<real box>|<imaginary box>)?|<imaginary box>/.source,
          "<num box>": /#[box](?:#[ei])?|(?:#[ei])?#[box]<complex box>/.source,
          "<number>": /(^|[()\[\]\s])(?:<num dec>|<num box>)(?=[()\[\]\s]|$)/.source
        }), "i"),
        lookbehind: !0
      },
      boolean: {
        pattern: /(^|[()\[\]\s])#(?:[ft]|false|true)(?=[()\[\]\s]|$)/,
        lookbehind: !0
      },
      function: {
        pattern: /((?:^|[^'`#])[(\[])(?:[^|()\[\]'\s]+|\|(?:[^\\|]|\\.)*\|)(?=[()\[\]\s]|$)/,
        lookbehind: !0
      },
      identifier: {
        pattern: /(^|[()\[\]\s])\|(?:[^\\|]|\\.)*\|(?=[()\[\]\s]|$)/,
        lookbehind: !0,
        greedy: !0
      },
      punctuation: /[()\[\]']/
    };
  }(e);
}

scheme.displayName = "scheme", scheme.aliases = [];
var refractorScheme$1 = scheme_1,
    lilypond_1 = lilypond;

function lilypond(e) {
  e.register(refractorScheme$1), function (e) {
    for (var t = /\((?:[^();"#\\]|\\[\s\S]|;.*(?!.)|"(?:[^"\\]|\\.)*"|#(?:\{(?:(?!#\})[\s\S])*#\}|[^{])|<expr>)*\)/.source, r = 0; r < 5; r++) {
      t = t.replace(/<expr>/g, function () {
        return t;
      });
    }

    t = t.replace(/<expr>/g, /[^\s\S]/.source);
    var n = e.languages.lilypond = {
      comment: /%(?:(?!\{).*|\{[\s\S]*?%\})/,
      "embedded-scheme": {
        pattern: RegExp(/(^|[=\s])#(?:"(?:[^"\\]|\\.)*"|[^\s()"]*(?:[^\s()]|<expr>))/.source.replace(/<expr>/g, function () {
          return t;
        }), "m"),
        lookbehind: !0,
        greedy: !0,
        inside: {
          scheme: {
            pattern: /^(#)[\s\S]+$/,
            lookbehind: !0,
            alias: "language-scheme",
            inside: {
              "embedded-lilypond": {
                pattern: /#\{[\s\S]*?#\}/,
                greedy: !0,
                inside: {
                  punctuation: /^#\{|#\}$/,
                  lilypond: {
                    pattern: /[\s\S]+/,
                    alias: "language-lilypond",
                    inside: null
                  }
                }
              },
              rest: e.languages.scheme
            }
          },
          punctuation: /#/
        }
      },
      string: {
        pattern: /"(?:[^"\\]|\\.)*"/,
        greedy: !0
      },
      "class-name": {
        pattern: /(\\new\s+)[\w-]+/,
        lookbehind: !0
      },
      keyword: {
        pattern: /\\[a-z][-\w]*/i,
        inside: {
          punctuation: /^\\/
        }
      },
      operator: /[=|]|<<|>>/,
      punctuation: {
        pattern: /(^|[a-z\d])(?:'+|,+|[_^]?-[_^]?(?:[-+^!>._]|(?=\d))|[_^]\.?|[.!])|[{}()[\]<>^~]|\\[()[\]<>\\!]|--|__/,
        lookbehind: !0
      },
      number: /\b\d+(?:\/\d+)?\b/
    };
    n["embedded-scheme"].inside.scheme.inside["embedded-lilypond"].inside.lilypond.inside = n, e.languages.ly = n;
  }(e);
}

lilypond.displayName = "lilypond", lilypond.aliases = [];
var refractorMarkupTemplating$4 = markupTemplating_1,
    liquid_1 = liquid;

function liquid(e) {
  e.register(refractorMarkupTemplating$4), e.languages.liquid = {
    comment: {
      pattern: /(^\{%\s*comment\s*%\})[\s\S]+(?=\{%\s*endcomment\s*%\}$)/,
      lookbehind: !0
    },
    delimiter: {
      pattern: /^\{(?:\{\{|[%\{])-?|-?(?:\}\}|[%\}])\}$/,
      alias: "punctuation"
    },
    string: {
      pattern: /"[^"]*"|'[^']*'/,
      greedy: !0
    },
    keyword: /\b(?:as|assign|break|(?:end)?(?:capture|case|comment|for|form|if|paginate|raw|style|tablerow|unless)|continue|cycle|decrement|echo|else|elsif|in|include|increment|limit|liquid|offset|range|render|reversed|section|when|with)\b/,
    object: /\b(?:address|all_country_option_tags|article|block|blog|cart|checkout|collection|color|country|country_option_tags|currency|current_page|current_tags|customer|customer_address|date|discount_allocation|discount_application|external_video|filter|filter_value|font|forloop|fulfillment|generic_file|gift_card|group|handle|image|line_item|link|linklist|localization|location|measurement|media|metafield|model|model_source|order|page|page_description|page_image|page_title|part|policy|product|product_option|recommendations|request|robots|routes|rule|script|search|selling_plan|selling_plan_allocation|selling_plan_group|shipping_method|shop|shop_locale|sitemap|store_availability|tax_line|template|theme|transaction|unit_price_measurement|user_agent|variant|video|video_source)\b/,
    function: [{
      pattern: /(\|\s*)\w+/,
      lookbehind: !0,
      alias: "filter"
    }, {
      pattern: /(\.\s*)(?:first|last|size)/,
      lookbehind: !0
    }],
    boolean: /\b(?:false|nil|true)\b/,
    range: {
      pattern: /\.\./,
      alias: "operator"
    },
    number: /\b\d+(?:\.\d+)?\b/,
    operator: /[!=]=|<>|[<>]=?|[|?:=-]|\b(?:and|contains(?=\s)|or)\b/,
    punctuation: /[.,\[\]()]/,
    empty: {
      pattern: /\bempty\b/,
      alias: "keyword"
    }
  }, e.hooks.add("before-tokenize", function (t) {
    var r = !1;
    e.languages["markup-templating"].buildPlaceholders(t, "liquid", /\{%\s*comment\s*%\}[\s\S]*?\{%\s*endcomment\s*%\}|\{(?:%[\s\S]*?%|\{\{[\s\S]*?\}\}|\{[\s\S]*?\})\}/g, function (e) {
      var t = /^\{%-?\s*(\w+)/.exec(e);

      if (t) {
        var n = t[1];
        if ("raw" === n && !r) return r = !0, !0;
        if ("endraw" === n) return r = !1, !0;
      }

      return !r;
    });
  }), e.hooks.add("after-tokenize", function (t) {
    e.languages["markup-templating"].tokenizePlaceholders(t, "liquid");
  });
}

liquid.displayName = "liquid", liquid.aliases = [];
var lisp_1 = lisp;

function lisp(e) {
  !function (e) {
    function t(e) {
      return RegExp(/(\()/.source + "(?:" + e + ")" + /(?=[\s\)])/.source);
    }

    function r(e) {
      return RegExp(/([\s([])/.source + "(?:" + e + ")" + /(?=[\s)])/.source);
    }

    var n = /(?!\d)[-+*/~!@$%^=<>{}\w]+/.source,
        a = "&" + n,
        o = "(\\()",
        i = /(?:[^()]|\((?:[^()]|\((?:[^()]|\((?:[^()]|\((?:[^()]|\([^()]*\))*\))*\))*\))*\))*/.source,
        s = {
      heading: {
        pattern: /;;;.*/,
        alias: ["comment", "title"]
      },
      comment: /;.*/,
      string: {
        pattern: /"(?:[^"\\]|\\.)*"/,
        greedy: !0,
        inside: {
          argument: /[-A-Z]+(?=[.,\s])/,
          symbol: RegExp("`" + n + "'")
        }
      },
      "quoted-symbol": {
        pattern: RegExp("#?'" + n),
        alias: ["variable", "symbol"]
      },
      "lisp-property": {
        pattern: RegExp(":" + n),
        alias: "property"
      },
      splice: {
        pattern: RegExp(",@?" + n),
        alias: ["symbol", "variable"]
      },
      keyword: [{
        pattern: RegExp("(\\()(?:and|(?:cl-)?letf|cl-loop|cond|cons|error|if|(?:lexical-)?let\\*?|message|not|null|or|provide|require|setq|unless|use-package|when|while)(?=\\s)"),
        lookbehind: !0
      }, {
        pattern: RegExp("(\\()(?:append|by|collect|concat|do|finally|for|in|return)(?=\\s)"),
        lookbehind: !0
      }],
      declare: {
        pattern: t(/declare/.source),
        lookbehind: !0,
        alias: "keyword"
      },
      interactive: {
        pattern: t(/interactive/.source),
        lookbehind: !0,
        alias: "keyword"
      },
      boolean: {
        pattern: r(/nil|t/.source),
        lookbehind: !0
      },
      number: {
        pattern: r(/[-+]?\d+(?:\.\d*)?/.source),
        lookbehind: !0
      },
      defvar: {
        pattern: RegExp("(\\()def(?:const|custom|group|var)\\s+" + n),
        lookbehind: !0,
        inside: {
          keyword: /^def[a-z]+/,
          variable: RegExp(n)
        }
      },
      defun: {
        pattern: RegExp(o + /(?:cl-)?(?:defmacro|defun\*?)\s+/.source + n + /\s+\(/.source + i + /\)/.source),
        lookbehind: !0,
        greedy: !0,
        inside: {
          keyword: /^(?:cl-)?def\S+/,
          arguments: null,
          function: {
            pattern: RegExp("(^\\s)" + n),
            lookbehind: !0
          },
          punctuation: /[()]/
        }
      },
      lambda: {
        pattern: RegExp("(\\()lambda\\s+\\(\\s*(?:&?" + n + "(?:\\s+&?" + n + ")*\\s*)?\\)"),
        lookbehind: !0,
        greedy: !0,
        inside: {
          keyword: /^lambda/,
          arguments: null,
          punctuation: /[()]/
        }
      },
      car: {
        pattern: RegExp(o + n),
        lookbehind: !0
      },
      punctuation: [/(?:['`,]?\(|[)\[\]])/, {
        pattern: /(\s)\.(?=\s)/,
        lookbehind: !0
      }]
    },
        l = {
      "lisp-marker": RegExp(a),
      varform: {
        pattern: RegExp(/\(/.source + n + /\s+(?=\S)/.source + i + /\)/.source),
        inside: s
      },
      argument: {
        pattern: RegExp(/(^|[\s(])/.source + n),
        lookbehind: !0,
        alias: "variable"
      },
      rest: s
    },
        c = "\\S+(?:\\s+\\S+)*",
        u = {
      pattern: RegExp(o + i + "(?=\\))"),
      lookbehind: !0,
      inside: {
        "rest-vars": {
          pattern: RegExp("&(?:body|rest)\\s+" + c),
          inside: l
        },
        "other-marker-vars": {
          pattern: RegExp("&(?:aux|optional)\\s+" + c),
          inside: l
        },
        keys: {
          pattern: RegExp("&key\\s+" + c + "(?:\\s+&allow-other-keys)?"),
          inside: l
        },
        argument: {
          pattern: RegExp(n),
          alias: "variable"
        },
        punctuation: /[()]/
      }
    };
    s.lambda.inside.arguments = u, s.defun.inside.arguments = e.util.clone(u), s.defun.inside.arguments.inside.sublist = u, e.languages.lisp = s, e.languages.elisp = s, e.languages.emacs = s, e.languages["emacs-lisp"] = s;
  }(e);
}

lisp.displayName = "lisp", lisp.aliases = [];
var livescript_1 = livescript;

function livescript(e) {
  e.languages.livescript = {
    comment: [{
      pattern: /(^|[^\\])\/\*[\s\S]*?\*\//,
      lookbehind: !0
    }, {
      pattern: /(^|[^\\])#.*/,
      lookbehind: !0
    }],
    "interpolated-string": {
      pattern: /(^|[^"])("""|")(?:\\[\s\S]|(?!\2)[^\\])*\2(?!")/,
      lookbehind: !0,
      greedy: !0,
      inside: {
        variable: {
          pattern: /(^|[^\\])#[a-z_](?:-?[a-z]|[\d_])*/m,
          lookbehind: !0
        },
        interpolation: {
          pattern: /(^|[^\\])#\{[^}]+\}/m,
          lookbehind: !0,
          inside: {
            "interpolation-punctuation": {
              pattern: /^#\{|\}$/,
              alias: "variable"
            }
          }
        },
        string: /[\s\S]+/
      }
    },
    string: [{
      pattern: /('''|')(?:\\[\s\S]|(?!\1)[^\\])*\1/,
      greedy: !0
    }, {
      pattern: /<\[[\s\S]*?\]>/,
      greedy: !0
    }, /\\[^\s,;\])}]+/],
    regex: [{
      pattern: /\/\/(?:\[[^\r\n\]]*\]|\\.|(?!\/\/)[^\\\[])+\/\/[gimyu]{0,5}/,
      greedy: !0,
      inside: {
        comment: {
          pattern: /(^|[^\\])#.*/,
          lookbehind: !0
        }
      }
    }, {
      pattern: /\/(?:\[[^\r\n\]]*\]|\\.|[^/\\\r\n\[])+\/[gimyu]{0,5}/,
      greedy: !0
    }],
    keyword: {
      pattern: /(^|(?!-).)\b(?:break|case|catch|class|const|continue|default|do|else|extends|fallthrough|finally|for(?: ever)?|function|if|implements|it|let|loop|new|null|otherwise|own|return|super|switch|that|then|this|throw|try|unless|until|var|void|when|while|yield)(?!-)\b/m,
      lookbehind: !0
    },
    "keyword-operator": {
      pattern: /(^|[^-])\b(?:(?:delete|require|typeof)!|(?:and|by|delete|export|from|import(?: all)?|in|instanceof|is(?: not|nt)?|not|of|or|til|to|typeof|with|xor)(?!-)\b)/m,
      lookbehind: !0,
      alias: "operator"
    },
    boolean: {
      pattern: /(^|[^-])\b(?:false|no|off|on|true|yes)(?!-)\b/m,
      lookbehind: !0
    },
    argument: {
      pattern: /(^|(?!\.&\.)[^&])&(?!&)\d*/m,
      lookbehind: !0,
      alias: "variable"
    },
    number: /\b(?:\d+~[\da-z]+|\d[\d_]*(?:\.\d[\d_]*)?(?:[a-z]\w*)?)/i,
    identifier: /[a-z_](?:-?[a-z]|[\d_])*/i,
    operator: [{
      pattern: /( )\.(?= )/,
      lookbehind: !0
    }, /\.(?:[=~]|\.\.?)|\.(?:[&|^]|<<|>>>?)\.|:(?:=|:=?)|&&|\|[|>]|<(?:<<?<?|--?!?|~~?!?|[|=?])?|>[>=?]?|-(?:->?|>)?|\+\+?|@@?|%%?|\*\*?|!(?:~?=|--?>|~?~>)?|~(?:~?>|=)?|==?|\^\^?|[\/?]/],
    punctuation: /[(){}\[\]|.,:;`]/
  }, e.languages.livescript["interpolated-string"].inside.interpolation.inside.rest = e.languages.livescript;
}

livescript.displayName = "livescript", livescript.aliases = [];
var llvm_1 = llvm;

function llvm(e) {
  !function (e) {
    e.languages.llvm = {
      comment: /;.*/,
      string: {
        pattern: /"[^"]*"/,
        greedy: !0
      },
      boolean: /\b(?:false|true)\b/,
      variable: /[%@!#](?:(?!\d)(?:[-$.\w]|\\[a-f\d]{2})+|\d+)/i,
      label: /(?!\d)(?:[-$.\w]|\\[a-f\d]{2})+:/i,
      type: {
        pattern: /\b(?:double|float|fp128|half|i[1-9]\d*|label|metadata|ppc_fp128|token|void|x86_fp80|x86_mmx)\b/,
        alias: "class-name"
      },
      keyword: /\b[a-z_][a-z_0-9]*\b/,
      number: /[+-]?\b\d+(?:\.\d+)?(?:[eE][+-]?\d+)?\b|\b0x[\dA-Fa-f]+\b|\b0xK[\dA-Fa-f]{20}\b|\b0x[ML][\dA-Fa-f]{32}\b|\b0xH[\dA-Fa-f]{4}\b/,
      punctuation: /[{}[\];(),.!*=<>]/
    };
  }(e);
}

llvm.displayName = "llvm", llvm.aliases = [];
var log_1 = log;

function log(e) {
  e.languages.log = {
    string: {
      pattern: /"(?:[^"\\\r\n]|\\.)*"|'(?![st] | \w)(?:[^'\\\r\n]|\\.)*'/,
      greedy: !0
    },
    exception: {
      pattern: /(^|[^\w.])[a-z][\w.]*(?:Error|Exception):.*(?:(?:\r\n?|\n)[ \t]*(?:at[ \t].+|\.{3}.*|Caused by:.*))+(?:(?:\r\n?|\n)[ \t]*\.\.\. .*)?/,
      lookbehind: !0,
      greedy: !0,
      alias: ["javastacktrace", "language-javastacktrace"],
      inside: e.languages.javastacktrace || {
        keyword: /\bat\b/,
        function: /[a-z_][\w$]*(?=\()/,
        punctuation: /[.:()]/
      }
    },
    level: [{
      pattern: /\b(?:ALERT|CRIT|CRITICAL|EMERG|EMERGENCY|ERR|ERROR|FAILURE|FATAL|SEVERE)\b/,
      alias: ["error", "important"]
    }, {
      pattern: /\b(?:WARN|WARNING|WRN)\b/,
      alias: ["warning", "important"]
    }, {
      pattern: /\b(?:DISPLAY|INF|INFO|NOTICE|STATUS)\b/,
      alias: ["info", "keyword"]
    }, {
      pattern: /\b(?:DBG|DEBUG|FINE)\b/,
      alias: ["debug", "keyword"]
    }, {
      pattern: /\b(?:FINER|FINEST|TRACE|TRC|VERBOSE|VRB)\b/,
      alias: ["trace", "comment"]
    }],
    property: {
      pattern: /((?:^|[\]|])[ \t]*)[a-z_](?:[\w-]|\b\/\b)*(?:[. ]\(?\w(?:[\w-]|\b\/\b)*\)?)*:(?=\s)/im,
      lookbehind: !0
    },
    separator: {
      pattern: /(^|[^-+])-{3,}|={3,}|\*{3,}|- - /m,
      lookbehind: !0,
      alias: "comment"
    },
    url: /\b(?:file|ftp|https?):\/\/[^\s|,;'"]*[^\s|,;'">.]/,
    email: {
      pattern: /(^|\s)[-\w+.]+@[a-z][a-z0-9-]*(?:\.[a-z][a-z0-9-]*)+(?=\s)/,
      lookbehind: !0,
      alias: "url"
    },
    "ip-address": {
      pattern: /\b(?:\d{1,3}(?:\.\d{1,3}){3})\b/,
      alias: "constant"
    },
    "mac-address": {
      pattern: /\b[a-f0-9]{2}(?::[a-f0-9]{2}){5}\b/i,
      alias: "constant"
    },
    domain: {
      pattern: /(^|\s)[a-z][a-z0-9-]*(?:\.[a-z][a-z0-9-]*)*\.[a-z][a-z0-9-]+(?=\s)/,
      lookbehind: !0,
      alias: "constant"
    },
    uuid: {
      pattern: /\b[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\b/i,
      alias: "constant"
    },
    hash: {
      pattern: /\b(?:[a-f0-9]{32}){1,2}\b/i,
      alias: "constant"
    },
    "file-path": {
      pattern: /\b[a-z]:[\\/][^\s|,;:(){}\[\]"']+|(^|[\s:\[\](>|])\.{0,2}\/\w[^\s|,;:(){}\[\]"']*/i,
      lookbehind: !0,
      greedy: !0,
      alias: "string"
    },
    date: {
      pattern: RegExp(/\b\d{4}[-/]\d{2}[-/]\d{2}(?:T(?=\d{1,2}:)|(?=\s\d{1,2}:))/.source + "|" + /\b\d{1,4}[-/ ](?:\d{1,2}|Apr|Aug|Dec|Feb|Jan|Jul|Jun|Mar|May|Nov|Oct|Sep)[-/ ]\d{2,4}T?\b/.source + "|" + /\b(?:(?:Fri|Mon|Sat|Sun|Thu|Tue|Wed)(?:\s{1,2}(?:Apr|Aug|Dec|Feb|Jan|Jul|Jun|Mar|May|Nov|Oct|Sep))?|Apr|Aug|Dec|Feb|Jan|Jul|Jun|Mar|May|Nov|Oct|Sep)\s{1,2}\d{1,2}\b/.source, "i"),
      alias: "number"
    },
    time: {
      pattern: /\b\d{1,2}:\d{1,2}:\d{1,2}(?:[.,:]\d+)?(?:\s?[+-]\d{2}:?\d{2}|Z)?\b/,
      alias: "number"
    },
    boolean: /\b(?:false|null|true)\b/i,
    number: {
      pattern: /(^|[^.\w])(?:0x[a-f0-9]+|0o[0-7]+|0b[01]+|v?\d[\da-f]*(?:\.\d+)*(?:e[+-]?\d+)?[a-z]{0,3}\b)\b(?!\.\w)/i,
      lookbehind: !0
    },
    operator: /[;:?<=>~/@!$%&+\-|^(){}*#]/,
    punctuation: /[\[\].,]/
  };
}

log.displayName = "log", log.aliases = [];
var lolcode_1 = lolcode;

function lolcode(e) {
  e.languages.lolcode = {
    comment: [/\bOBTW\s[\s\S]*?\sTLDR\b/, /\bBTW.+/],
    string: {
      pattern: /"(?::.|[^":])*"/,
      inside: {
        variable: /:\{[^}]+\}/,
        symbol: [/:\([a-f\d]+\)/i, /:\[[^\]]+\]/, /:[)>o":]/]
      },
      greedy: !0
    },
    number: /(?:\B-)?(?:\b\d+(?:\.\d*)?|\B\.\d+)/,
    symbol: {
      pattern: /(^|\s)(?:A )?(?:BUKKIT|NOOB|NUMBAR|NUMBR|TROOF|YARN)(?=\s|,|$)/,
      lookbehind: !0,
      inside: {
        keyword: /A(?=\s)/
      }
    },
    label: {
      pattern: /((?:^|\s)(?:IM IN YR|IM OUTTA YR) )[a-zA-Z]\w*/,
      lookbehind: !0,
      alias: "string"
    },
    function: {
      pattern: /((?:^|\s)(?:HOW IZ I|I IZ|IZ) )[a-zA-Z]\w*/,
      lookbehind: !0
    },
    keyword: [{
      pattern: /(^|\s)(?:AN|FOUND YR|GIMMEH|GTFO|HAI|HAS A|HOW IZ I|I HAS A|I IZ|IF U SAY SO|IM IN YR|IM OUTTA YR|IS NOW(?: A)?|ITZ(?: A)?|IZ|KTHX|KTHXBYE|LIEK(?: A)?|MAEK|MEBBE|MKAY|NERFIN|NO WAI|O HAI IM|O RLY\?|OIC|OMG|OMGWTF|R|SMOOSH|SRS|TIL|UPPIN|VISIBLE|WILE|WTF\?|YA RLY|YR)(?=\s|,|$)/,
      lookbehind: !0
    }, /'Z(?=\s|,|$)/],
    boolean: {
      pattern: /(^|\s)(?:FAIL|WIN)(?=\s|,|$)/,
      lookbehind: !0
    },
    variable: {
      pattern: /(^|\s)IT(?=\s|,|$)/,
      lookbehind: !0
    },
    operator: {
      pattern: /(^|\s)(?:NOT|BOTH SAEM|DIFFRINT|(?:ALL|ANY|BIGGR|BOTH|DIFF|EITHER|MOD|PRODUKT|QUOSHUNT|SMALLR|SUM|WON) OF)(?=\s|,|$)/,
      lookbehind: !0
    },
    punctuation: /\.{3}|…|,|!/
  };
}

lolcode.displayName = "lolcode", lolcode.aliases = [];
var magma_1 = magma;

function magma(e) {
  e.languages.magma = {
    output: {
      pattern: /^(>.*(?:\r(?:\n|(?!\n))|\n))(?!>)(?:.+|(?:\r(?:\n|(?!\n))|\n)(?!>).*)(?:(?:\r(?:\n|(?!\n))|\n)(?!>).*)*/m,
      lookbehind: !0,
      greedy: !0
    },
    comment: {
      pattern: /\/\/.*|\/\*[\s\S]*?\*\//,
      greedy: !0
    },
    string: {
      pattern: /(^|[^\\"])"(?:[^\r\n\\"]|\\.)*"/,
      lookbehind: !0,
      greedy: !0
    },
    keyword: /\b(?:_|adj|and|assert|assert2|assert3|assigned|break|by|case|cat|catch|clear|cmpeq|cmpne|continue|declare|default|delete|diff|div|do|elif|else|end|eq|error|eval|exists|exit|for|forall|forward|fprintf|freeze|function|ge|gt|if|iload|import|in|intrinsic|is|join|le|load|local|lt|meet|mod|ne|not|notadj|notin|notsubset|or|print|printf|procedure|quit|random|read|readi|repeat|require|requirege|requirerange|restore|return|save|sdiff|select|subset|then|time|to|try|until|vprint|vprintf|vtime|when|where|while|xor)\b/,
    boolean: /\b(?:false|true)\b/,
    generator: {
      pattern: /\b[a-z_]\w*(?=\s*<)/i,
      alias: "class-name"
    },
    function: /\b[a-z_]\w*(?=\s*\()/i,
    number: {
      pattern: /(^|[^\w.]|\.\.)(?:\d+(?:\.\d*)?|\.\d+)(?:[eE][+-]?\d+)?(?:_[a-z]?)?(?=$|[^\w.]|\.\.)/,
      lookbehind: !0
    },
    operator: /->|[-+*/^~!|#=]|:=|\.\./,
    punctuation: /[()[\]{}<>,;.:]/
  };
}

magma.displayName = "magma", magma.aliases = [];
var makefile_1 = makefile;

function makefile(e) {
  e.languages.makefile = {
    comment: {
      pattern: /(^|[^\\])#(?:\\(?:\r\n|[\s\S])|[^\\\r\n])*/,
      lookbehind: !0
    },
    string: {
      pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
      greedy: !0
    },
    "builtin-target": {
      pattern: /\.[A-Z][^:#=\s]+(?=\s*:(?!=))/,
      alias: "builtin"
    },
    target: {
      pattern: /^(?:[^:=\s]|[ \t]+(?![\s:]))+(?=\s*:(?!=))/m,
      alias: "symbol",
      inside: {
        variable: /\$+(?:(?!\$)[^(){}:#=\s]+|(?=[({]))/
      }
    },
    variable: /\$+(?:(?!\$)[^(){}:#=\s]+|\([@*%<^+?][DF]\)|(?=[({]))/,
    keyword: /-include\b|\b(?:define|else|endef|endif|export|ifn?def|ifn?eq|include|override|private|sinclude|undefine|unexport|vpath)\b/,
    function: {
      pattern: /(\()(?:abspath|addsuffix|and|basename|call|dir|error|eval|file|filter(?:-out)?|findstring|firstword|flavor|foreach|guile|if|info|join|lastword|load|notdir|or|origin|patsubst|realpath|shell|sort|strip|subst|suffix|value|warning|wildcard|word(?:list|s)?)(?=[ \t])/,
      lookbehind: !0
    },
    operator: /(?:::|[?:+!])?=|[|@]/,
    punctuation: /[:;(){}]/
  };
}

makefile.displayName = "makefile", makefile.aliases = [];
var markdown_1 = markdown;

function markdown(e) {
  !function (e) {
    var t = /(?:\\.|[^\\\n\r]|(?:\n|\r\n?)(?![\r\n]))/.source;

    function r(e) {
      return e = e.replace(/<inner>/g, function () {
        return t;
      }), RegExp(/((?:^|[^\\])(?:\\{2})*)/.source + "(?:" + e + ")");
    }

    var n = /(?:\\.|``(?:[^`\r\n]|`(?!`))+``|`[^`\r\n]+`|[^\\|\r\n`])+/.source,
        a = /\|?__(?:\|__)+\|?(?:(?:\n|\r\n?)|(?![\s\S]))/.source.replace(/__/g, function () {
      return n;
    }),
        o = /\|?[ \t]*:?-{3,}:?[ \t]*(?:\|[ \t]*:?-{3,}:?[ \t]*)+\|?(?:\n|\r\n?)/.source;
    e.languages.markdown = e.languages.extend("markup", {}), e.languages.insertBefore("markdown", "prolog", {
      "front-matter-block": {
        pattern: /(^(?:\s*[\r\n])?)---(?!.)[\s\S]*?[\r\n]---(?!.)/,
        lookbehind: !0,
        greedy: !0,
        inside: {
          punctuation: /^---|---$/,
          "front-matter": {
            pattern: /\S+(?:\s+\S+)*/,
            alias: ["yaml", "language-yaml"],
            inside: e.languages.yaml
          }
        }
      },
      blockquote: {
        pattern: /^>(?:[\t ]*>)*/m,
        alias: "punctuation"
      },
      table: {
        pattern: RegExp("^" + a + o + "(?:" + a + ")*", "m"),
        inside: {
          "table-data-rows": {
            pattern: RegExp("^(" + a + o + ")(?:" + a + ")*$"),
            lookbehind: !0,
            inside: {
              "table-data": {
                pattern: RegExp(n),
                inside: e.languages.markdown
              },
              punctuation: /\|/
            }
          },
          "table-line": {
            pattern: RegExp("^(" + a + ")" + o + "$"),
            lookbehind: !0,
            inside: {
              punctuation: /\||:?-{3,}:?/
            }
          },
          "table-header-row": {
            pattern: RegExp("^" + a + "$"),
            inside: {
              "table-header": {
                pattern: RegExp(n),
                alias: "important",
                inside: e.languages.markdown
              },
              punctuation: /\|/
            }
          }
        }
      },
      code: [{
        pattern: /((?:^|\n)[ \t]*\n|(?:^|\r\n?)[ \t]*\r\n?)(?: {4}|\t).+(?:(?:\n|\r\n?)(?: {4}|\t).+)*/,
        lookbehind: !0,
        alias: "keyword"
      }, {
        pattern: /^```[\s\S]*?^```$/m,
        greedy: !0,
        inside: {
          "code-block": {
            pattern: /^(```.*(?:\n|\r\n?))[\s\S]+?(?=(?:\n|\r\n?)^```$)/m,
            lookbehind: !0
          },
          "code-language": {
            pattern: /^(```).+/,
            lookbehind: !0
          },
          punctuation: /```/
        }
      }],
      title: [{
        pattern: /\S.*(?:\n|\r\n?)(?:==+|--+)(?=[ \t]*$)/m,
        alias: "important",
        inside: {
          punctuation: /==+$|--+$/
        }
      }, {
        pattern: /(^\s*)#.+/m,
        lookbehind: !0,
        alias: "important",
        inside: {
          punctuation: /^#+|#+$/
        }
      }],
      hr: {
        pattern: /(^\s*)([*-])(?:[\t ]*\2){2,}(?=\s*$)/m,
        lookbehind: !0,
        alias: "punctuation"
      },
      list: {
        pattern: /(^\s*)(?:[*+-]|\d+\.)(?=[\t ].)/m,
        lookbehind: !0,
        alias: "punctuation"
      },
      "url-reference": {
        pattern: /!?\[[^\]]+\]:[\t ]+(?:\S+|<(?:\\.|[^>\\])+>)(?:[\t ]+(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\)))?/,
        inside: {
          variable: {
            pattern: /^(!?\[)[^\]]+/,
            lookbehind: !0
          },
          string: /(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\))$/,
          punctuation: /^[\[\]!:]|[<>]/
        },
        alias: "url"
      },
      bold: {
        pattern: r(/\b__(?:(?!_)<inner>|_(?:(?!_)<inner>)+_)+__\b|\*\*(?:(?!\*)<inner>|\*(?:(?!\*)<inner>)+\*)+\*\*/.source),
        lookbehind: !0,
        greedy: !0,
        inside: {
          content: {
            pattern: /(^..)[\s\S]+(?=..$)/,
            lookbehind: !0,
            inside: {}
          },
          punctuation: /\*\*|__/
        }
      },
      italic: {
        pattern: r(/\b_(?:(?!_)<inner>|__(?:(?!_)<inner>)+__)+_\b|\*(?:(?!\*)<inner>|\*\*(?:(?!\*)<inner>)+\*\*)+\*/.source),
        lookbehind: !0,
        greedy: !0,
        inside: {
          content: {
            pattern: /(^.)[\s\S]+(?=.$)/,
            lookbehind: !0,
            inside: {}
          },
          punctuation: /[*_]/
        }
      },
      strike: {
        pattern: r(/(~~?)(?:(?!~)<inner>)+\2/.source),
        lookbehind: !0,
        greedy: !0,
        inside: {
          content: {
            pattern: /(^~~?)[\s\S]+(?=\1$)/,
            lookbehind: !0,
            inside: {}
          },
          punctuation: /~~?/
        }
      },
      "code-snippet": {
        pattern: /(^|[^\\`])(?:``[^`\r\n]+(?:`[^`\r\n]+)*``(?!`)|`[^`\r\n]+`(?!`))/,
        lookbehind: !0,
        greedy: !0,
        alias: ["code", "keyword"]
      },
      url: {
        pattern: r(/!?\[(?:(?!\])<inner>)+\](?:\([^\s)]+(?:[\t ]+"(?:\\.|[^"\\])*")?\)|[ \t]?\[(?:(?!\])<inner>)+\])/.source),
        lookbehind: !0,
        greedy: !0,
        inside: {
          operator: /^!/,
          content: {
            pattern: /(^\[)[^\]]+(?=\])/,
            lookbehind: !0,
            inside: {}
          },
          variable: {
            pattern: /(^\][ \t]?\[)[^\]]+(?=\]$)/,
            lookbehind: !0
          },
          url: {
            pattern: /(^\]\()[^\s)]+/,
            lookbehind: !0
          },
          string: {
            pattern: /(^[ \t]+)"(?:\\.|[^"\\])*"(?=\)$)/,
            lookbehind: !0
          }
        }
      }
    }), ["url", "bold", "italic", "strike"].forEach(function (t) {
      ["url", "bold", "italic", "strike", "code-snippet"].forEach(function (r) {
        t !== r && (e.languages.markdown[t].inside.content.inside[r] = e.languages.markdown[r]);
      });
    }), e.hooks.add("after-tokenize", function (e) {
      "markdown" !== e.language && "md" !== e.language || function e(t) {
        if (t && "string" != typeof t) for (var r = 0, n = t.length; r < n; r++) {
          var a = t[r];

          if ("code" === a.type) {
            var o = a.content[1],
                i = a.content[3];

            if (o && i && "code-language" === o.type && "code-block" === i.type && "string" == typeof o.content) {
              var s = o.content.replace(/\b#/g, "sharp").replace(/\b\+\+/g, "pp"),
                  l = "language-" + (s = (/[a-z][\w-]*/i.exec(s) || [""])[0].toLowerCase());
              i.alias ? "string" == typeof i.alias ? i.alias = [i.alias, l] : i.alias.push(l) : i.alias = [l];
            }
          } else e(a.content);
        }
      }(e.tokens);
    }), e.hooks.add("wrap", function (t) {
      if ("code-block" === t.type) {
        for (var r = "", n = 0, a = t.classes.length; n < a; n++) {
          var o = t.classes[n],
              c = /language-(.+)/.exec(o);

          if (c) {
            r = c[1];
            break;
          }
        }

        var u = e.languages[r];
        if (u) t.content = e.highlight(function (e) {
          var t = e.replace(i, "");
          return t = t.replace(/&(\w{1,8}|#x?[\da-f]{1,8});/gi, function (e, t) {
            var r;
            if ("#" === (t = t.toLowerCase())[0]) return r = "x" === t[1] ? parseInt(t.slice(2), 16) : Number(t.slice(1)), l(r);
            var n = s[t];
            return n || e;
          }), t;
        }(t.content.value), u, r);else if (r && "none" !== r && e.plugins.autoloader) {
          var d = "md-" + new Date().valueOf() + "-" + Math.floor(1e16 * Math.random());
          t.attributes.id = d, e.plugins.autoloader.loadLanguages(r, function () {
            var t = document.getElementById(d);
            t && (t.innerHTML = e.highlight(t.textContent, e.languages[r], r));
          });
        }
      }
    });
    var i = RegExp(e.languages.markup.tag.pattern.source, "gi"),
        s = {
      amp: "&",
      lt: "<",
      gt: ">",
      quot: '"'
    },
        l = String.fromCodePoint || String.fromCharCode;
    e.languages.md = e.languages.markdown;
  }(e);
}

markdown.displayName = "markdown", markdown.aliases = ["md"];
var matlab_1 = matlab;

function matlab(e) {
  e.languages.matlab = {
    comment: [/%\{[\s\S]*?\}%/, /%.+/],
    string: {
      pattern: /\B'(?:''|[^'\r\n])*'/,
      greedy: !0
    },
    number: /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[eE][+-]?\d+)?(?:[ij])?|\b[ij]\b/,
    keyword: /\b(?:NaN|break|case|catch|continue|else|elseif|end|for|function|if|inf|otherwise|parfor|pause|pi|return|switch|try|while)\b/,
    function: /\b(?!\d)\w+(?=\s*\()/,
    operator: /\.?[*^\/\\']|[+\-:@]|[<>=~]=?|&&?|\|\|?/,
    punctuation: /\.{3}|[.,;\[\](){}!]/
  };
}

matlab.displayName = "matlab", matlab.aliases = [];
var maxscript_1 = maxscript;

function maxscript(e) {
  !function (e) {
    var t = /\b(?:about|and|animate|as|at|attributes|by|case|catch|collect|continue|coordsys|do|else|exit|fn|for|from|function|global|if|in|local|macroscript|mapped|max|not|of|off|on|or|parameters|persistent|plugin|rcmenu|return|rollout|set|struct|then|throw|to|tool|try|undo|utility|when|where|while|with)\b/i;
    e.languages.maxscript = {
      comment: {
        pattern: /\/\*[\s\S]*?(?:\*\/|$)|--.*/,
        greedy: !0
      },
      string: {
        pattern: /(^|[^"\\@])(?:"(?:[^"\\]|\\[\s\S])*"|@"[^"]*")/,
        lookbehind: !0,
        greedy: !0
      },
      path: {
        pattern: /\$(?:[\w/\\.*?]|'[^']*')*/,
        greedy: !0,
        alias: "string"
      },
      "function-call": {
        pattern: RegExp("((?:" + /^/.source + "|" + /[;=<>+\-*/^({\[]/.source + "|" + /\b(?:and|by|case|catch|collect|do|else|if|in|not|or|return|then|to|try|where|while|with)\b/.source + ")[ \t]*)(?!" + t.source + ")" + /[a-z_]\w*\b/.source + "(?=[ \t]*(?:(?!" + t.source + ")" + /[a-z_]/.source + "|" + /\d|-\.?\d/.source + "|" + /[({'"$@#?]/.source + "))", "im"),
        lookbehind: !0,
        greedy: !0,
        alias: "function"
      },
      "function-definition": {
        pattern: /(\b(?:fn|function)\s+)\w+\b/i,
        lookbehind: !0,
        alias: "function"
      },
      argument: {
        pattern: /\b[a-z_]\w*(?=:)/i,
        alias: "attr-name"
      },
      keyword: t,
      boolean: /\b(?:false|true)\b/,
      time: {
        pattern: /(^|[^\w.])(?:(?:(?:\d+(?:\.\d*)?|\.\d+)(?:[eEdD][+-]\d+|[LP])?[msft])+|\d+:\d+(?:\.\d*)?)(?![\w.:])/,
        lookbehind: !0,
        alias: "number"
      },
      number: [{
        pattern: /(^|[^\w.])(?:(?:\d+(?:\.\d*)?|\.\d+)(?:[eEdD][+-]\d+|[LP])?|0x[a-fA-F0-9]+)(?![\w.:])/,
        lookbehind: !0
      }, /\b(?:e|pi)\b/],
      constant: /\b(?:dontcollect|ok|silentValue|undefined|unsupplied)\b/,
      color: {
        pattern: /\b(?:black|blue|brown|gray|green|orange|red|white|yellow)\b/i,
        alias: "constant"
      },
      operator: /[-+*/<>=!]=?|[&^?]|#(?!\()/,
      punctuation: /[()\[\]{}.:,;]|#(?=\()|\\$/m
    };
  }(e);
}

maxscript.displayName = "maxscript", maxscript.aliases = [];
var mel_1 = mel;

function mel(e) {
  e.languages.mel = {
    comment: /\/\/.*/,
    code: {
      pattern: /`(?:\\.|[^\\`\r\n])*`/,
      greedy: !0,
      alias: "italic",
      inside: {
        delimiter: {
          pattern: /^`|`$/,
          alias: "punctuation"
        }
      }
    },
    string: {
      pattern: /"(?:\\.|[^\\"\r\n])*"/,
      greedy: !0
    },
    variable: /\$\w+/,
    number: /\b0x[\da-fA-F]+\b|\b\d+(?:\.\d*)?|\B\.\d+/,
    flag: {
      pattern: /-[^\d\W]\w*/,
      alias: "operator"
    },
    keyword: /\b(?:break|case|continue|default|do|else|float|for|global|if|in|int|matrix|proc|return|string|switch|vector|while)\b/,
    function: /\b\w+(?=\()|\b(?:CBG|HfAddAttractorToAS|HfAssignAS|HfBuildEqualMap|HfBuildFurFiles|HfBuildFurImages|HfCancelAFR|HfConnectASToHF|HfCreateAttractor|HfDeleteAS|HfEditAS|HfPerformCreateAS|HfRemoveAttractorFromAS|HfSelectAttached|HfSelectAttractors|HfUnAssignAS|Mayatomr|about|abs|addAttr|addAttributeEditorNodeHelp|addDynamic|addNewShelfTab|addPP|addPanelCategory|addPrefixToName|advanceToNextDrivenKey|affectedNet|affects|aimConstraint|air|alias|aliasAttr|align|alignCtx|alignCurve|alignSurface|allViewFit|ambientLight|angle|angleBetween|animCone|animCurveEditor|animDisplay|animView|annotate|appendStringArray|applicationName|applyAttrPreset|applyTake|arcLenDimContext|arcLengthDimension|arclen|arrayMapper|art3dPaintCtx|artAttrCtx|artAttrPaintVertexCtx|artAttrSkinPaintCtx|artAttrTool|artBuildPaintMenu|artFluidAttrCtx|artPuttyCtx|artSelectCtx|artSetPaintCtx|artUserPaintCtx|assignCommand|assignInputDevice|assignViewportFactories|attachCurve|attachDeviceAttr|attachSurface|attrColorSliderGrp|attrCompatibility|attrControlGrp|attrEnumOptionMenu|attrEnumOptionMenuGrp|attrFieldGrp|attrFieldSliderGrp|attrNavigationControlGrp|attrPresetEditWin|attributeExists|attributeInfo|attributeMenu|attributeQuery|autoKeyframe|autoPlace|bakeClip|bakeFluidShading|bakePartialHistory|bakeResults|bakeSimulation|basename|basenameEx|batchRender|bessel|bevel|bevelPlus|binMembership|bindSkin|blend2|blendShape|blendShapeEditor|blendShapePanel|blendTwoAttr|blindDataType|boneLattice|boundary|boxDollyCtx|boxZoomCtx|bufferCurve|buildBookmarkMenu|buildKeyframeMenu|button|buttonManip|cacheFile|cacheFileCombine|cacheFileMerge|cacheFileTrack|camera|cameraView|canCreateManip|canvas|capitalizeString|catch|catchQuiet|ceil|changeSubdivComponentDisplayLevel|changeSubdivRegion|channelBox|character|characterMap|characterOutlineEditor|characterize|chdir|checkBox|checkBoxGrp|checkDefaultRenderGlobals|choice|circle|circularFillet|clamp|clear|clearCache|clip|clipEditor|clipEditorCurrentTimeCtx|clipSchedule|clipSchedulerOutliner|clipTrimBefore|closeCurve|closeSurface|cluster|cmdFileOutput|cmdScrollFieldExecuter|cmdScrollFieldReporter|cmdShell|coarsenSubdivSelectionList|collision|color|colorAtPoint|colorEditor|colorIndex|colorIndexSliderGrp|colorSliderButtonGrp|colorSliderGrp|columnLayout|commandEcho|commandLine|commandPort|compactHairSystem|componentEditor|compositingInterop|computePolysetVolume|condition|cone|confirmDialog|connectAttr|connectControl|connectDynamic|connectJoint|connectionInfo|constrain|constrainValue|constructionHistory|container|containsMultibyte|contextInfo|control|convertFromOldLayers|convertIffToPsd|convertLightmap|convertSolidTx|convertTessellation|convertUnit|copyArray|copyFlexor|copyKey|copySkinWeights|cos|cpButton|cpCache|cpClothSet|cpCollision|cpConstraint|cpConvClothToMesh|cpForces|cpGetSolverAttr|cpPanel|cpProperty|cpRigidCollisionFilter|cpSeam|cpSetEdit|cpSetSolverAttr|cpSolver|cpSolverTypes|cpTool|cpUpdateClothUVs|createDisplayLayer|createDrawCtx|createEditor|createLayeredPsdFile|createMotionField|createNewShelf|createNode|createRenderLayer|createSubdivRegion|cross|crossProduct|ctxAbort|ctxCompletion|ctxEditMode|ctxTraverse|currentCtx|currentTime|currentTimeCtx|currentUnit|curve|curveAddPtCtx|curveCVCtx|curveEPCtx|curveEditorCtx|curveIntersect|curveMoveEPCtx|curveOnSurface|curveSketchCtx|cutKey|cycleCheck|cylinder|dagPose|date|defaultLightListCheckBox|defaultNavigation|defineDataServer|defineVirtualDevice|deformer|deg_to_rad|delete|deleteAttr|deleteShadingGroupsAndMaterials|deleteShelfTab|deleteUI|deleteUnusedBrushes|delrandstr|detachCurve|detachDeviceAttr|detachSurface|deviceEditor|devicePanel|dgInfo|dgdirty|dgeval|dgtimer|dimWhen|directKeyCtx|directionalLight|dirmap|dirname|disable|disconnectAttr|disconnectJoint|diskCache|displacementToPoly|displayAffected|displayColor|displayCull|displayLevelOfDetail|displayPref|displayRGBColor|displaySmoothness|displayStats|displayString|displaySurface|distanceDimContext|distanceDimension|doBlur|dolly|dollyCtx|dopeSheetEditor|dot|dotProduct|doubleProfileBirailSurface|drag|dragAttrContext|draggerContext|dropoffLocator|duplicate|duplicateCurve|duplicateSurface|dynCache|dynControl|dynExport|dynExpression|dynGlobals|dynPaintEditor|dynParticleCtx|dynPref|dynRelEdPanel|dynRelEditor|dynamicLoad|editAttrLimits|editDisplayLayerGlobals|editDisplayLayerMembers|editRenderLayerAdjustment|editRenderLayerGlobals|editRenderLayerMembers|editor|editorTemplate|effector|emit|emitter|enableDevice|encodeString|endString|endsWith|env|equivalent|equivalentTol|erf|error|eval|evalDeferred|evalEcho|event|exactWorldBoundingBox|exclusiveLightCheckBox|exec|executeForEachObject|exists|exp|expression|expressionEditorListen|extendCurve|extendSurface|extrude|fcheck|fclose|feof|fflush|fgetline|fgetword|file|fileBrowserDialog|fileDialog|fileExtension|fileInfo|filetest|filletCurve|filter|filterCurve|filterExpand|filterStudioImport|findAllIntersections|findAnimCurves|findKeyframe|findMenuItem|findRelatedSkinCluster|finder|firstParentOf|fitBspline|flexor|floatEq|floatField|floatFieldGrp|floatScrollBar|floatSlider|floatSlider2|floatSliderButtonGrp|floatSliderGrp|floor|flow|fluidCacheInfo|fluidEmitter|fluidVoxelInfo|flushUndo|fmod|fontDialog|fopen|formLayout|format|fprint|frameLayout|fread|freeFormFillet|frewind|fromNativePath|fwrite|gamma|gauss|geometryConstraint|getApplicationVersionAsFloat|getAttr|getClassification|getDefaultBrush|getFileList|getFluidAttr|getInputDeviceRange|getMayaPanelTypes|getModifiers|getPanel|getParticleAttr|getPluginResource|getenv|getpid|glRender|glRenderEditor|globalStitch|gmatch|goal|gotoBindPose|grabColor|gradientControl|gradientControlNoAttr|graphDollyCtx|graphSelectContext|graphTrackCtx|gravity|grid|gridLayout|group|groupObjectsByName|hardenPointCurve|hardware|hardwareRenderPanel|headsUpDisplay|headsUpMessage|help|helpLine|hermite|hide|hilite|hitTest|hotBox|hotkey|hotkeyCheck|hsv_to_rgb|hudButton|hudSlider|hudSliderButton|hwReflectionMap|hwRender|hwRenderLoad|hyperGraph|hyperPanel|hyperShade|hypot|iconTextButton|iconTextCheckBox|iconTextRadioButton|iconTextRadioCollection|iconTextScrollList|iconTextStaticLabel|ikHandle|ikHandleCtx|ikHandleDisplayScale|ikSolver|ikSplineHandleCtx|ikSystem|ikSystemInfo|ikfkDisplayMethod|illustratorCurves|image|imfPlugins|inheritTransform|insertJoint|insertJointCtx|insertKeyCtx|insertKnotCurve|insertKnotSurface|instance|instanceable|instancer|intField|intFieldGrp|intScrollBar|intSlider|intSliderGrp|interToUI|internalVar|intersect|iprEngine|isAnimCurve|isConnected|isDirty|isParentOf|isSameObject|isTrue|isValidObjectName|isValidString|isValidUiName|isolateSelect|itemFilter|itemFilterAttr|itemFilterRender|itemFilterType|joint|jointCluster|jointCtx|jointDisplayScale|jointLattice|keyTangent|keyframe|keyframeOutliner|keyframeRegionCurrentTimeCtx|keyframeRegionDirectKeyCtx|keyframeRegionDollyCtx|keyframeRegionInsertKeyCtx|keyframeRegionMoveKeyCtx|keyframeRegionScaleKeyCtx|keyframeRegionSelectKeyCtx|keyframeRegionSetKeyCtx|keyframeRegionTrackCtx|keyframeStats|lassoContext|lattice|latticeDeformKeyCtx|launch|launchImageEditor|layerButton|layeredShaderPort|layeredTexturePort|layout|layoutDialog|lightList|lightListEditor|lightListPanel|lightlink|lineIntersection|linearPrecision|linstep|listAnimatable|listAttr|listCameras|listConnections|listDeviceAttachments|listHistory|listInputDeviceAxes|listInputDeviceButtons|listInputDevices|listMenuAnnotation|listNodeTypes|listPanelCategories|listRelatives|listSets|listTransforms|listUnselected|listerEditor|loadFluid|loadNewShelf|loadPlugin|loadPluginLanguageResources|loadPrefObjects|localizedPanelLabel|lockNode|loft|log|longNameOf|lookThru|ls|lsThroughFilter|lsType|lsUI|mag|makeIdentity|makeLive|makePaintable|makeRoll|makeSingleSurface|makeTubeOn|makebot|manipMoveContext|manipMoveLimitsCtx|manipOptions|manipRotateContext|manipRotateLimitsCtx|manipScaleContext|manipScaleLimitsCtx|marker|match|max|memory|menu|menuBarLayout|menuEditor|menuItem|menuItemToShelf|menuSet|menuSetPref|messageLine|min|minimizeApp|mirrorJoint|modelCurrentTimeCtx|modelEditor|modelPanel|mouse|movIn|movOut|move|moveIKtoFK|moveKeyCtx|moveVertexAlongDirection|multiProfileBirailSurface|mute|nParticle|nameCommand|nameField|namespace|namespaceInfo|newPanelItems|newton|nodeCast|nodeIconButton|nodeOutliner|nodePreset|nodeType|noise|nonLinear|normalConstraint|normalize|nurbsBoolean|nurbsCopyUVSet|nurbsCube|nurbsEditUV|nurbsPlane|nurbsSelect|nurbsSquare|nurbsToPoly|nurbsToPolygonsPref|nurbsToSubdiv|nurbsToSubdivPref|nurbsUVSet|nurbsViewDirectionVector|objExists|objectCenter|objectLayer|objectType|objectTypeUI|obsoleteProc|oceanNurbsPreviewPlane|offsetCurve|offsetCurveOnSurface|offsetSurface|openGLExtension|openMayaPref|optionMenu|optionMenuGrp|optionVar|orbit|orbitCtx|orientConstraint|outlinerEditor|outlinerPanel|overrideModifier|paintEffectsDisplay|pairBlend|palettePort|paneLayout|panel|panelConfiguration|panelHistory|paramDimContext|paramDimension|paramLocator|parent|parentConstraint|particle|particleExists|particleInstancer|particleRenderInfo|partition|pasteKey|pathAnimation|pause|pclose|percent|performanceOptions|pfxstrokes|pickWalk|picture|pixelMove|planarSrf|plane|play|playbackOptions|playblast|plugAttr|plugNode|pluginInfo|pluginResourceUtil|pointConstraint|pointCurveConstraint|pointLight|pointMatrixMult|pointOnCurve|pointOnSurface|pointPosition|poleVectorConstraint|polyAppend|polyAppendFacetCtx|polyAppendVertex|polyAutoProjection|polyAverageNormal|polyAverageVertex|polyBevel|polyBlendColor|polyBlindData|polyBoolOp|polyBridgeEdge|polyCacheMonitor|polyCheck|polyChipOff|polyClipboard|polyCloseBorder|polyCollapseEdge|polyCollapseFacet|polyColorBlindData|polyColorDel|polyColorPerVertex|polyColorSet|polyCompare|polyCone|polyCopyUV|polyCrease|polyCreaseCtx|polyCreateFacet|polyCreateFacetCtx|polyCube|polyCut|polyCutCtx|polyCylinder|polyCylindricalProjection|polyDelEdge|polyDelFacet|polyDelVertex|polyDuplicateAndConnect|polyDuplicateEdge|polyEditUV|polyEditUVShell|polyEvaluate|polyExtrudeEdge|polyExtrudeFacet|polyExtrudeVertex|polyFlipEdge|polyFlipUV|polyForceUV|polyGeoSampler|polyHelix|polyInfo|polyInstallAction|polyLayoutUV|polyListComponentConversion|polyMapCut|polyMapDel|polyMapSew|polyMapSewMove|polyMergeEdge|polyMergeEdgeCtx|polyMergeFacet|polyMergeFacetCtx|polyMergeUV|polyMergeVertex|polyMirrorFace|polyMoveEdge|polyMoveFacet|polyMoveFacetUV|polyMoveUV|polyMoveVertex|polyNormal|polyNormalPerVertex|polyNormalizeUV|polyOptUvs|polyOptions|polyOutput|polyPipe|polyPlanarProjection|polyPlane|polyPlatonicSolid|polyPoke|polyPrimitive|polyPrism|polyProjection|polyPyramid|polyQuad|polyQueryBlindData|polyReduce|polySelect|polySelectConstraint|polySelectConstraintMonitor|polySelectCtx|polySelectEditCtx|polySeparate|polySetToFaceNormal|polySewEdge|polyShortestPathCtx|polySmooth|polySoftEdge|polySphere|polySphericalProjection|polySplit|polySplitCtx|polySplitEdge|polySplitRing|polySplitVertex|polyStraightenUVBorder|polySubdivideEdge|polySubdivideFacet|polyToSubdiv|polyTorus|polyTransfer|polyTriangulate|polyUVSet|polyUnite|polyWedgeFace|popen|popupMenu|pose|pow|preloadRefEd|print|progressBar|progressWindow|projFileViewer|projectCurve|projectTangent|projectionContext|projectionManip|promptDialog|propModCtx|propMove|psdChannelOutliner|psdEditTextureFile|psdExport|psdTextureFile|putenv|pwd|python|querySubdiv|quit|rad_to_deg|radial|radioButton|radioButtonGrp|radioCollection|radioMenuItemCollection|rampColorPort|rand|randomizeFollicles|randstate|rangeControl|readTake|rebuildCurve|rebuildSurface|recordAttr|recordDevice|redo|reference|referenceEdit|referenceQuery|refineSubdivSelectionList|refresh|refreshAE|registerPluginResource|rehash|reloadImage|removeJoint|removeMultiInstance|removePanelCategory|rename|renameAttr|renameSelectionList|renameUI|render|renderGlobalsNode|renderInfo|renderLayerButton|renderLayerParent|renderLayerPostProcess|renderLayerUnparent|renderManip|renderPartition|renderQualityNode|renderSettings|renderThumbnailUpdate|renderWindowEditor|renderWindowSelectContext|renderer|reorder|reorderDeformers|requires|reroot|resampleFluid|resetAE|resetPfxToPolyCamera|resetTool|resolutionNode|retarget|reverseCurve|reverseSurface|revolve|rgb_to_hsv|rigidBody|rigidSolver|roll|rollCtx|rootOf|rot|rotate|rotationInterpolation|roundConstantRadius|rowColumnLayout|rowLayout|runTimeCommand|runup|sampleImage|saveAllShelves|saveAttrPreset|saveFluid|saveImage|saveInitialState|saveMenu|savePrefObjects|savePrefs|saveShelf|saveToolSettings|scale|scaleBrushBrightness|scaleComponents|scaleConstraint|scaleKey|scaleKeyCtx|sceneEditor|sceneUIReplacement|scmh|scriptCtx|scriptEditorInfo|scriptJob|scriptNode|scriptTable|scriptToShelf|scriptedPanel|scriptedPanelType|scrollField|scrollLayout|sculpt|searchPathArray|seed|selLoadSettings|select|selectContext|selectCurveCV|selectKey|selectKeyCtx|selectKeyframeRegionCtx|selectMode|selectPref|selectPriority|selectType|selectedNodes|selectionConnection|separator|setAttr|setAttrEnumResource|setAttrMapping|setAttrNiceNameResource|setConstraintRestPosition|setDefaultShadingGroup|setDrivenKeyframe|setDynamic|setEditCtx|setEditor|setFluidAttr|setFocus|setInfinity|setInputDeviceMapping|setKeyCtx|setKeyPath|setKeyframe|setKeyframeBlendshapeTargetWts|setMenuMode|setNodeNiceNameResource|setNodeTypeFlag|setParent|setParticleAttr|setPfxToPolyCamera|setPluginResource|setProject|setStampDensity|setStartupMessage|setState|setToolTo|setUITemplate|setXformManip|sets|shadingConnection|shadingGeometryRelCtx|shadingLightRelCtx|shadingNetworkCompare|shadingNode|shapeCompare|shelfButton|shelfLayout|shelfTabLayout|shellField|shortNameOf|showHelp|showHidden|showManipCtx|showSelectionInTitle|showShadingGroupAttrEditor|showWindow|sign|simplify|sin|singleProfileBirailSurface|size|sizeBytes|skinCluster|skinPercent|smoothCurve|smoothTangentSurface|smoothstep|snap2to2|snapKey|snapMode|snapTogetherCtx|snapshot|soft|softMod|softModCtx|sort|sound|soundControl|source|spaceLocator|sphere|sphrand|spotLight|spotLightPreviewPort|spreadSheetEditor|spring|sqrt|squareSurface|srtContext|stackTrace|startString|startsWith|stitchAndExplodeShell|stitchSurface|stitchSurfacePoints|strcmp|stringArrayCatenate|stringArrayContains|stringArrayCount|stringArrayInsertAtIndex|stringArrayIntersector|stringArrayRemove|stringArrayRemoveAtIndex|stringArrayRemoveDuplicates|stringArrayRemoveExact|stringArrayToString|stringToStringArray|strip|stripPrefixFromName|stroke|subdAutoProjection|subdCleanTopology|subdCollapse|subdDuplicateAndConnect|subdEditUV|subdListComponentConversion|subdMapCut|subdMapSewMove|subdMatchTopology|subdMirror|subdToBlind|subdToPoly|subdTransferUVsToCache|subdiv|subdivCrease|subdivDisplaySmoothness|substitute|substituteAllString|substituteGeometry|substring|surface|surfaceSampler|surfaceShaderList|swatchDisplayPort|switchTable|symbolButton|symbolCheckBox|sysFile|system|tabLayout|tan|tangentConstraint|texLatticeDeformContext|texManipContext|texMoveContext|texMoveUVShellContext|texRotateContext|texScaleContext|texSelectContext|texSelectShortestPathCtx|texSmudgeUVContext|texWinToolCtx|text|textCurves|textField|textFieldButtonGrp|textFieldGrp|textManip|textScrollList|textToShelf|textureDisplacePlane|textureHairColor|texturePlacementContext|textureWindow|threadCount|threePointArcCtx|timeControl|timePort|timerX|toNativePath|toggle|toggleAxis|toggleWindowVisibility|tokenize|tokenizeList|tolerance|tolower|toolButton|toolCollection|toolDropped|toolHasOptions|toolPropertyWindow|torus|toupper|trace|track|trackCtx|transferAttributes|transformCompare|transformLimits|translator|trim|trunc|truncateFluidCache|truncateHairCache|tumble|tumbleCtx|turbulence|twoPointArcCtx|uiRes|uiTemplate|unassignInputDevice|undo|undoInfo|ungroup|uniform|unit|unloadPlugin|untangleUV|untitledFileName|untrim|upAxis|updateAE|userCtx|uvLink|uvSnapshot|validateShelfName|vectorize|view2dToolCtx|viewCamera|viewClipPlane|viewFit|viewHeadOn|viewLookAt|viewManip|viewPlace|viewSet|visor|volumeAxis|vortex|waitCursor|warning|webBrowser|webBrowserPrefs|whatIs|window|windowPref|wire|wireContext|workspace|wrinkle|wrinkleContext|writeTake|xbmLangPathList|xform)\b/,
    operator: [/\+[+=]?|-[-=]?|&&|\|\||[<>]=|[*\/!=]=?|[%^]/, {
      pattern: /(^|[^<])<(?!<)/,
      lookbehind: !0
    }, {
      pattern: /(^|[^>])>(?!>)/,
      lookbehind: !0
    }],
    punctuation: /<<|>>|[.,:;?\[\](){}]/
  }, e.languages.mel.code.inside.rest = e.languages.mel;
}

mel.displayName = "mel", mel.aliases = [];
var mermaid_1 = mermaid;

function mermaid(e) {
  e.languages.mermaid = {
    comment: {
      pattern: /%%.*/,
      greedy: !0
    },
    style: {
      pattern: /^([ \t]*(?:classDef|linkStyle|style)[ \t]+[\w$-]+[ \t]+)\w.*[^\s;]/m,
      lookbehind: !0,
      inside: {
        property: /\b\w[\w-]*(?=[ \t]*:)/,
        operator: /:/,
        punctuation: /,/
      }
    },
    "inter-arrow-label": {
      pattern: /([^<>ox.=-])(?:-[-.]|==)(?![<>ox.=-])[ \t]*(?:"[^"\r\n]*"|[^\s".=-](?:[^\r\n.=-]*[^\s.=-])?)[ \t]*(?:\.+->?|--+[->]|==+[=>])(?![<>ox.=-])/,
      lookbehind: !0,
      greedy: !0,
      inside: {
        arrow: {
          pattern: /(?:\.+->?|--+[->]|==+[=>])$/,
          alias: "operator"
        },
        label: {
          pattern: /^([\s\S]{2}[ \t]*)\S(?:[\s\S]*\S)?/,
          lookbehind: !0,
          alias: "property"
        },
        "arrow-head": {
          pattern: /^\S+/,
          alias: ["arrow", "operator"]
        }
      }
    },
    arrow: [{
      pattern: /(^|[^{}|o.-])[|}][|o](?:--|\.\.)[|o][|{](?![{}|o.-])/,
      lookbehind: !0,
      alias: "operator"
    }, {
      pattern: /(^|[^<>ox.=-])(?:[<ox](?:==+|--+|-\.*-)[>ox]?|(?:==+|--+|-\.*-)[>ox]|===+|---+|-\.+-)(?![<>ox.=-])/,
      lookbehind: !0,
      alias: "operator"
    }, {
      pattern: /(^|[^<>()x-])(?:--?(?:>>|[x>)])(?![<>()x])|(?:<<|[x<(])--?(?!-))/,
      lookbehind: !0,
      alias: "operator"
    }, {
      pattern: /(^|[^<>|*o.-])(?:[*o]--|--[*o]|<\|?(?:--|\.\.)|(?:--|\.\.)\|?>|--|\.\.)(?![<>|*o.-])/,
      lookbehind: !0,
      alias: "operator"
    }],
    label: {
      pattern: /(^|[^|<])\|(?:[^\r\n"|]|"[^"\r\n]*")+\|/,
      lookbehind: !0,
      greedy: !0,
      alias: "property"
    },
    text: {
      pattern: /(?:[(\[{]+|\b>)(?:[^\r\n"()\[\]{}]|"[^"\r\n]*")+(?:[)\]}]+|>)/,
      alias: "string"
    },
    string: {
      pattern: /"[^"\r\n]*"/,
      greedy: !0
    },
    annotation: {
      pattern: /<<(?:abstract|choice|enumeration|fork|interface|join|service)>>|\[\[(?:choice|fork|join)\]\]/i,
      alias: "important"
    },
    keyword: [{
      pattern: /(^[ \t]*)(?:action|callback|class|classDef|classDiagram|click|direction|erDiagram|flowchart|gantt|gitGraph|graph|journey|link|linkStyle|pie|requirementDiagram|sequenceDiagram|stateDiagram|stateDiagram-v2|style|subgraph)(?![\w$-])/m,
      lookbehind: !0,
      greedy: !0
    }, {
      pattern: /(^[ \t]*)(?:activate|alt|and|as|autonumber|deactivate|else|end(?:[ \t]+note)?|loop|opt|par|participant|rect|state|note[ \t]+(?:over|(?:left|right)[ \t]+of))(?![\w$-])/im,
      lookbehind: !0,
      greedy: !0
    }],
    entity: /#[a-z0-9]+;/,
    operator: {
      pattern: /(\w[ \t]*)&(?=[ \t]*\w)|:::|:/,
      lookbehind: !0
    },
    punctuation: /[(){};]/
  };
}

mermaid.displayName = "mermaid", mermaid.aliases = [];
var mizar_1 = mizar;

function mizar(e) {
  e.languages.mizar = {
    comment: /::.+/,
    keyword: /@proof\b|\b(?:according|aggregate|all|and|antonym|are|as|associativity|assume|asymmetry|attr|be|begin|being|by|canceled|case|cases|clusters?|coherence|commutativity|compatibility|connectedness|consider|consistency|constructors|contradiction|correctness|def|deffunc|define|definitions?|defpred|do|does|end|environ|equals|ex|exactly|existence|for|from|func|given|hence|hereby|holds|idempotence|identity|iff?|implies|involutiveness|irreflexivity|is|it|let|means|mode|non|not|notations?|now|of|or|otherwise|over|per|pred|prefix|projectivity|proof|provided|qua|reconsider|redefine|reduce|reducibility|reflexivity|registrations?|requirements|reserve|sch|schemes?|section|selector|set|sethood|st|struct|such|suppose|symmetry|synonym|take|that|the|then|theorems?|thesis|thus|to|transitivity|uniqueness|vocabular(?:ies|y)|when|where|with|wrt)\b/,
    parameter: {
      pattern: /\$(?:10|\d)/,
      alias: "variable"
    },
    variable: /\b\w+(?=:)/,
    number: /(?:\b|-)\d+\b/,
    operator: /\.\.\.|->|&|\.?=/,
    punctuation: /\(#|#\)|[,:;\[\](){}]/
  };
}

mizar.displayName = "mizar", mizar.aliases = [];
var mongodb_1 = mongodb;

function mongodb(e) {
  !function (e) {
    var t = ["$eq", "$gt", "$gte", "$in", "$lt", "$lte", "$ne", "$nin", "$and", "$not", "$nor", "$or", "$exists", "$type", "$expr", "$jsonSchema", "$mod", "$regex", "$text", "$where", "$geoIntersects", "$geoWithin", "$near", "$nearSphere", "$all", "$elemMatch", "$size", "$bitsAllClear", "$bitsAllSet", "$bitsAnyClear", "$bitsAnySet", "$comment", "$elemMatch", "$meta", "$slice", "$currentDate", "$inc", "$min", "$max", "$mul", "$rename", "$set", "$setOnInsert", "$unset", "$addToSet", "$pop", "$pull", "$push", "$pullAll", "$each", "$position", "$slice", "$sort", "$bit", "$addFields", "$bucket", "$bucketAuto", "$collStats", "$count", "$currentOp", "$facet", "$geoNear", "$graphLookup", "$group", "$indexStats", "$limit", "$listLocalSessions", "$listSessions", "$lookup", "$match", "$merge", "$out", "$planCacheStats", "$project", "$redact", "$replaceRoot", "$replaceWith", "$sample", "$set", "$skip", "$sort", "$sortByCount", "$unionWith", "$unset", "$unwind", "$setWindowFields", "$abs", "$accumulator", "$acos", "$acosh", "$add", "$addToSet", "$allElementsTrue", "$and", "$anyElementTrue", "$arrayElemAt", "$arrayToObject", "$asin", "$asinh", "$atan", "$atan2", "$atanh", "$avg", "$binarySize", "$bsonSize", "$ceil", "$cmp", "$concat", "$concatArrays", "$cond", "$convert", "$cos", "$dateFromParts", "$dateToParts", "$dateFromString", "$dateToString", "$dayOfMonth", "$dayOfWeek", "$dayOfYear", "$degreesToRadians", "$divide", "$eq", "$exp", "$filter", "$first", "$floor", "$function", "$gt", "$gte", "$hour", "$ifNull", "$in", "$indexOfArray", "$indexOfBytes", "$indexOfCP", "$isArray", "$isNumber", "$isoDayOfWeek", "$isoWeek", "$isoWeekYear", "$last", "$last", "$let", "$literal", "$ln", "$log", "$log10", "$lt", "$lte", "$ltrim", "$map", "$max", "$mergeObjects", "$meta", "$min", "$millisecond", "$minute", "$mod", "$month", "$multiply", "$ne", "$not", "$objectToArray", "$or", "$pow", "$push", "$radiansToDegrees", "$range", "$reduce", "$regexFind", "$regexFindAll", "$regexMatch", "$replaceOne", "$replaceAll", "$reverseArray", "$round", "$rtrim", "$second", "$setDifference", "$setEquals", "$setIntersection", "$setIsSubset", "$setUnion", "$size", "$sin", "$slice", "$split", "$sqrt", "$stdDevPop", "$stdDevSamp", "$strcasecmp", "$strLenBytes", "$strLenCP", "$substr", "$substrBytes", "$substrCP", "$subtract", "$sum", "$switch", "$tan", "$toBool", "$toDate", "$toDecimal", "$toDouble", "$toInt", "$toLong", "$toObjectId", "$toString", "$toLower", "$toUpper", "$trim", "$trunc", "$type", "$week", "$year", "$zip", "$count", "$dateAdd", "$dateDiff", "$dateSubtract", "$dateTrunc", "$getField", "$rand", "$sampleRate", "$setField", "$unsetField", "$comment", "$explain", "$hint", "$max", "$maxTimeMS", "$min", "$orderby", "$query", "$returnKey", "$showDiskLoc", "$natural"],
        r = "(?:" + (t = t.map(function (e) {
      return e.replace("$", "\\$");
    })).join("|") + ")\\b";
    e.languages.mongodb = e.languages.extend("javascript", {}), e.languages.insertBefore("mongodb", "string", {
      property: {
        pattern: /(?:(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)(?=\s*:)/,
        greedy: !0,
        inside: {
          keyword: RegExp("^(['\"])?" + r + "(?:\\1)?$")
        }
      }
    }), e.languages.mongodb.string.inside = {
      url: {
        pattern: /https?:\/\/[-\w@:%.+~#=]{1,256}\.[a-z0-9()]{1,6}\b[-\w()@:%+.~#?&/=]*/i,
        greedy: !0
      },
      entity: {
        pattern: /\b(?:(?:[01]?\d\d?|2[0-4]\d|25[0-5])\.){3}(?:[01]?\d\d?|2[0-4]\d|25[0-5])\b/,
        greedy: !0
      }
    }, e.languages.insertBefore("mongodb", "constant", {
      builtin: {
        pattern: RegExp("\\b(?:" + ["ObjectId", "Code", "BinData", "DBRef", "Timestamp", "NumberLong", "NumberDecimal", "MaxKey", "MinKey", "RegExp", "ISODate", "UUID"].join("|") + ")\\b"),
        alias: "keyword"
      }
    });
  }(e);
}

mongodb.displayName = "mongodb", mongodb.aliases = [];
var monkey_1 = monkey;

function monkey(e) {
  e.languages.monkey = {
    comment: {
      pattern: /^#Rem\s[\s\S]*?^#End|'.+/im,
      greedy: !0
    },
    string: {
      pattern: /"[^"\r\n]*"/,
      greedy: !0
    },
    preprocessor: {
      pattern: /(^[ \t]*)#.+/m,
      lookbehind: !0,
      greedy: !0,
      alias: "property"
    },
    function: /\b\w+(?=\()/,
    "type-char": {
      pattern: /\b[?%#$]/,
      alias: "class-name"
    },
    number: {
      pattern: /((?:\.\.)?)(?:(?:\b|\B-\.?|\B\.)\d+(?:(?!\.\.)\.\d*)?|\$[\da-f]+)/i,
      lookbehind: !0
    },
    keyword: /\b(?:Abstract|Array|Bool|Case|Catch|Class|Const|Continue|Default|Eachin|Else|ElseIf|End|EndIf|Exit|Extends|Extern|False|Field|Final|Float|For|Forever|Function|Global|If|Implements|Import|Inline|Int|Interface|Local|Method|Module|New|Next|Null|Object|Private|Property|Public|Repeat|Return|Select|Self|Step|Strict|String|Super|Then|Throw|To|True|Try|Until|Void|Wend|While)\b/i,
    operator: /\.\.|<[=>]?|>=?|:?=|(?:[+\-*\/&~|]|\b(?:Mod|Shl|Shr)\b)=?|\b(?:And|Not|Or)\b/i,
    punctuation: /[.,:;()\[\]]/
  };
}

monkey.displayName = "monkey", monkey.aliases = [];
var moonscript_1 = moonscript;

function moonscript(e) {
  e.languages.moonscript = {
    comment: /--.*/,
    string: [{
      pattern: /'[^']*'|\[(=*)\[[\s\S]*?\]\1\]/,
      greedy: !0
    }, {
      pattern: /"[^"]*"/,
      greedy: !0,
      inside: {
        interpolation: {
          pattern: /#\{[^{}]*\}/,
          inside: {
            moonscript: {
              pattern: /(^#\{)[\s\S]+(?=\})/,
              lookbehind: !0,
              inside: null
            },
            "interpolation-punctuation": {
              pattern: /#\{|\}/,
              alias: "punctuation"
            }
          }
        }
      }
    }],
    "class-name": [{
      pattern: /(\b(?:class|extends)[ \t]+)\w+/,
      lookbehind: !0
    }, /\b[A-Z]\w*/],
    keyword: /\b(?:class|continue|do|else|elseif|export|extends|for|from|if|import|in|local|nil|return|self|super|switch|then|unless|using|when|while|with)\b/,
    variable: /@@?\w*/,
    property: {
      pattern: /\b(?!\d)\w+(?=:)|(:)(?!\d)\w+/,
      lookbehind: !0
    },
    function: {
      pattern: /\b(?:_G|_VERSION|assert|collectgarbage|coroutine\.(?:create|resume|running|status|wrap|yield)|debug\.(?:debug|getfenv|gethook|getinfo|getlocal|getmetatable|getregistry|getupvalue|setfenv|sethook|setlocal|setmetatable|setupvalue|traceback)|dofile|error|getfenv|getmetatable|io\.(?:close|flush|input|lines|open|output|popen|read|stderr|stdin|stdout|tmpfile|type|write)|ipairs|load|loadfile|loadstring|math\.(?:abs|acos|asin|atan|atan2|ceil|cos|cosh|deg|exp|floor|fmod|frexp|ldexp|log|log10|max|min|modf|pi|pow|rad|random|randomseed|sin|sinh|sqrt|tan|tanh)|module|next|os\.(?:clock|date|difftime|execute|exit|getenv|remove|rename|setlocale|time|tmpname)|package\.(?:cpath|loaded|loadlib|path|preload|seeall)|pairs|pcall|print|rawequal|rawget|rawset|require|select|setfenv|setmetatable|string\.(?:byte|char|dump|find|format|gmatch|gsub|len|lower|match|rep|reverse|sub|upper)|table\.(?:concat|insert|maxn|remove|sort)|tonumber|tostring|type|unpack|xpcall)\b/,
      inside: {
        punctuation: /\./
      }
    },
    boolean: /\b(?:false|true)\b/,
    number: /(?:\B\.\d+|\b\d+\.\d+|\b\d+(?=[eE]))(?:[eE][-+]?\d+)?\b|\b(?:0x[a-fA-F\d]+|\d+)(?:U?LL)?\b/,
    operator: /\.{3}|[-=]>|~=|(?:[-+*/%<>!=]|\.\.)=?|[:#^]|\b(?:and|or)\b=?|\b(?:not)\b/,
    punctuation: /[.,()[\]{}\\]/
  }, e.languages.moonscript.string[1].inside.interpolation.inside.moonscript.inside = e.languages.moonscript, e.languages.moon = e.languages.moonscript;
}

moonscript.displayName = "moonscript", moonscript.aliases = ["moon"];
var n1ql_1 = n1ql;

function n1ql(e) {
  e.languages.n1ql = {
    comment: {
      pattern: /\/\*[\s\S]*?(?:$|\*\/)|--.*/,
      greedy: !0
    },
    string: {
      pattern: /(["'])(?:\\[\s\S]|(?!\1)[^\\]|\1\1)*\1/,
      greedy: !0
    },
    identifier: {
      pattern: /`(?:\\[\s\S]|[^\\`]|``)*`/,
      greedy: !0
    },
    parameter: /\$[\w.]+/,
    keyword: /\b(?:ADVISE|ALL|ALTER|ANALYZE|AS|ASC|AT|BEGIN|BINARY|BOOLEAN|BREAK|BUCKET|BUILD|BY|CALL|CAST|CLUSTER|COLLATE|COLLECTION|COMMIT|COMMITTED|CONNECT|CONTINUE|CORRELATE|CORRELATED|COVER|CREATE|CURRENT|DATABASE|DATASET|DATASTORE|DECLARE|DECREMENT|DELETE|DERIVED|DESC|DESCRIBE|DISTINCT|DO|DROP|EACH|ELEMENT|EXCEPT|EXCLUDE|EXECUTE|EXPLAIN|FETCH|FILTER|FLATTEN|FLUSH|FOLLOWING|FOR|FORCE|FROM|FTS|FUNCTION|GOLANG|GRANT|GROUP|GROUPS|GSI|HASH|HAVING|IF|IGNORE|ILIKE|INCLUDE|INCREMENT|INDEX|INFER|INLINE|INNER|INSERT|INTERSECT|INTO|IS|ISOLATION|JAVASCRIPT|JOIN|KEY|KEYS|KEYSPACE|KNOWN|LANGUAGE|LAST|LEFT|LET|LETTING|LEVEL|LIMIT|LSM|MAP|MAPPING|MATCHED|MATERIALIZED|MERGE|MINUS|MISSING|NAMESPACE|NEST|NL|NO|NTH_VALUE|NULL|NULLS|NUMBER|OBJECT|OFFSET|ON|OPTION|OPTIONS|ORDER|OTHERS|OUTER|OVER|PARSE|PARTITION|PASSWORD|PATH|POOL|PRECEDING|PREPARE|PRIMARY|PRIVATE|PRIVILEGE|PROBE|PROCEDURE|PUBLIC|RANGE|RAW|REALM|REDUCE|RENAME|RESPECT|RETURN|RETURNING|REVOKE|RIGHT|ROLE|ROLLBACK|ROW|ROWS|SATISFIES|SAVEPOINT|SCHEMA|SCOPE|SELECT|SELF|SEMI|SET|SHOW|SOME|START|STATISTICS|STRING|SYSTEM|TIES|TO|TRAN|TRANSACTION|TRIGGER|TRUNCATE|UNBOUNDED|UNDER|UNION|UNIQUE|UNKNOWN|UNNEST|UNSET|UPDATE|UPSERT|USE|USER|USING|VALIDATE|VALUE|VALUES|VIA|VIEW|WHERE|WHILE|WINDOW|WITH|WORK|XOR)\b/i,
    function: /\b[a-z_]\w*(?=\s*\()/i,
    boolean: /\b(?:FALSE|TRUE)\b/i,
    number: /(?:\b\d+\.|\B\.)\d+e[+\-]?\d+\b|\b\d+(?:\.\d*)?|\B\.\d+\b/i,
    operator: /[-+*\/%]|!=|==?|\|\||<[>=]?|>=?|\b(?:AND|ANY|ARRAY|BETWEEN|CASE|ELSE|END|EVERY|EXISTS|FIRST|IN|LIKE|NOT|OR|THEN|VALUED|WHEN|WITHIN)\b/i,
    punctuation: /[;[\](),.{}:]/
  };
}

n1ql.displayName = "n1ql", n1ql.aliases = [];
var n4js_1 = n4js;

function n4js(e) {
  e.languages.n4js = e.languages.extend("javascript", {
    keyword: /\b(?:Array|any|boolean|break|case|catch|class|const|constructor|continue|debugger|declare|default|delete|do|else|enum|export|extends|false|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|module|new|null|number|package|private|protected|public|return|set|static|string|super|switch|this|throw|true|try|typeof|var|void|while|with|yield)\b/
  }), e.languages.insertBefore("n4js", "constant", {
    annotation: {
      pattern: /@+\w+/,
      alias: "operator"
    }
  }), e.languages.n4jsd = e.languages.n4js;
}

n4js.displayName = "n4js", n4js.aliases = ["n4jsd"];
var nand2tetrisHdl_1 = nand2tetrisHdl;

function nand2tetrisHdl(e) {
  e.languages["nand2tetris-hdl"] = {
    comment: /\/\/.*|\/\*[\s\S]*?(?:\*\/|$)/,
    keyword: /\b(?:BUILTIN|CHIP|CLOCKED|IN|OUT|PARTS)\b/,
    boolean: /\b(?:false|true)\b/,
    function: /\b[A-Za-z][A-Za-z0-9]*(?=\()/,
    number: /\b\d+\b/,
    operator: /=|\.\./,
    punctuation: /[{}[\];(),:]/
  };
}

nand2tetrisHdl.displayName = "nand2tetrisHdl", nand2tetrisHdl.aliases = [];
var naniscript_1 = naniscript;

function naniscript(e) {
  !function (e) {
    var t = /\{[^\r\n\[\]{}]*\}/,
        r = {
      "quoted-string": {
        pattern: /"(?:[^"\\]|\\.)*"/,
        alias: "operator"
      },
      "command-param-id": {
        pattern: /(\s)\w+:/,
        lookbehind: !0,
        alias: "property"
      },
      "command-param-value": [{
        pattern: t,
        alias: "selector"
      }, {
        pattern: /([\t ])\S+/,
        lookbehind: !0,
        greedy: !0,
        alias: "operator"
      }, {
        pattern: /\S(?:.*\S)?/,
        alias: "operator"
      }]
    };

    function n(e) {
      return "string" == typeof e ? e : Array.isArray(e) ? e.map(n).join("") : n(e.content);
    }

    e.languages.naniscript = {
      comment: {
        pattern: /^([\t ]*);.*/m,
        lookbehind: !0
      },
      define: {
        pattern: /^>.+/m,
        alias: "tag",
        inside: {
          value: {
            pattern: /(^>\w+[\t ]+)(?!\s)[^{}\r\n]+/,
            lookbehind: !0,
            alias: "operator"
          },
          key: {
            pattern: /(^>)\w+/,
            lookbehind: !0
          }
        }
      },
      label: {
        pattern: /^([\t ]*)#[\t ]*\w+[\t ]*$/m,
        lookbehind: !0,
        alias: "regex"
      },
      command: {
        pattern: /^([\t ]*)@\w+(?=[\t ]|$).*/m,
        lookbehind: !0,
        alias: "function",
        inside: {
          "command-name": /^@\w+/,
          expression: {
            pattern: t,
            greedy: !0,
            alias: "selector"
          },
          "command-params": {
            pattern: /\s*\S[\s\S]*/,
            inside: r
          }
        }
      },
      "generic-text": {
        pattern: /(^[ \t]*)[^#@>;\s].*/m,
        lookbehind: !0,
        alias: "punctuation",
        inside: {
          "escaped-char": /\\[{}\[\]"]/,
          expression: {
            pattern: t,
            greedy: !0,
            alias: "selector"
          },
          "inline-command": {
            pattern: /\[[\t ]*\w[^\r\n\[\]]*\]/,
            greedy: !0,
            alias: "function",
            inside: {
              "command-params": {
                pattern: /(^\[[\t ]*\w+\b)[\s\S]+(?=\]$)/,
                lookbehind: !0,
                inside: r
              },
              "command-param-name": {
                pattern: /^(\[[\t ]*)\w+/,
                lookbehind: !0,
                alias: "name"
              },
              "start-stop-char": /[\[\]]/
            }
          }
        }
      }
    }, e.languages.nani = e.languages.naniscript, e.hooks.add("after-tokenize", function (e) {
      e.tokens.forEach(function (e) {
        if ("string" != typeof e && "generic-text" === e.type) {
          var t = n(e);
          (function (e) {
            for (var t = "[]{}", r = [], n = 0; n < e.length; n++) {
              var a = e[n],
                  o = t.indexOf(a);
              if (-1 !== o) if (o % 2 == 0) r.push(o + 1);else if (r.pop() !== o) return !1;
            }

            return 0 === r.length;
          })(t) || (e.type = "bad-line", e.content = t);
        }
      });
    });
  }(e);
}

naniscript.displayName = "naniscript", naniscript.aliases = [];
var nasm_1 = nasm;

function nasm(e) {
  e.languages.nasm = {
    comment: /;.*$/m,
    string: /(["'`])(?:\\.|(?!\1)[^\\\r\n])*\1/,
    label: {
      pattern: /(^\s*)[A-Za-z._?$][\w.?$@~#]*:/m,
      lookbehind: !0,
      alias: "function"
    },
    keyword: [/\[?BITS (?:16|32|64)\]?/, {
      pattern: /(^\s*)section\s*[a-z.]+:?/im,
      lookbehind: !0
    }, /(?:extern|global)[^;\r\n]*/i, /(?:CPU|DEFAULT|FLOAT).*$/m],
    register: {
      pattern: /\b(?:st\d|[xyz]mm\d\d?|[cdt]r\d|r\d\d?[bwd]?|[er]?[abcd]x|[abcd][hl]|[er]?(?:bp|di|si|sp)|[cdefgs]s)\b/i,
      alias: "variable"
    },
    number: /(?:\b|(?=\$))(?:0[hx](?:\.[\da-f]+|[\da-f]+(?:\.[\da-f]+)?)(?:p[+-]?\d+)?|\d[\da-f]+[hx]|\$\d[\da-f]*|0[oq][0-7]+|[0-7]+[oq]|0[by][01]+|[01]+[by]|0[dt]\d+|(?:\d+(?:\.\d+)?|\.\d+)(?:\.?e[+-]?\d+)?[dt]?)\b/i,
    operator: /[\[\]*+\-\/%<>=&|$!]/
  };
}

nasm.displayName = "nasm", nasm.aliases = [];
var neon_1 = neon;

function neon(e) {
  e.languages.neon = {
    comment: {
      pattern: /#.*/,
      greedy: !0
    },
    datetime: {
      pattern: /(^|[[{(=:,\s])\d\d\d\d-\d\d?-\d\d?(?:(?:[Tt]| +)\d\d?:\d\d:\d\d(?:\.\d*)? *(?:Z|[-+]\d\d?(?::?\d\d)?)?)?(?=$|[\]}),\s])/,
      lookbehind: !0,
      alias: "number"
    },
    key: {
      pattern: /(^|[[{(,\s])[^,:=[\]{}()'"\s]+(?=\s*:(?:$|[\]}),\s])|\s*=)/,
      lookbehind: !0,
      alias: "atrule"
    },
    number: {
      pattern: /(^|[[{(=:,\s])[+-]?(?:0x[\da-fA-F]+|0o[0-7]+|0b[01]+|(?:\d+(?:\.\d*)?|\.?\d+)(?:[eE][+-]?\d+)?)(?=$|[\]}),:=\s])/,
      lookbehind: !0
    },
    boolean: {
      pattern: /(^|[[{(=:,\s])(?:false|no|true|yes)(?=$|[\]}),:=\s])/i,
      lookbehind: !0
    },
    null: {
      pattern: /(^|[[{(=:,\s])(?:null)(?=$|[\]}),:=\s])/i,
      lookbehind: !0,
      alias: "keyword"
    },
    string: {
      pattern: /(^|[[{(=:,\s])(?:('''|""")\r?\n(?:(?:[^\r\n]|\r?\n(?![\t ]*\2))*\r?\n)?[\t ]*\2|'[^'\r\n]*'|"(?:\\.|[^\\"\r\n])*")/,
      lookbehind: !0,
      greedy: !0
    },
    literal: {
      pattern: /(^|[[{(=:,\s])(?:[^#"',:=[\]{}()\s`-]|[:-][^"',=[\]{}()\s])(?:[^,:=\]})(\s]|:(?![\s,\]})]|$)|[ \t]+[^#,:=\]})(\s])*/,
      lookbehind: !0,
      alias: "string"
    },
    punctuation: /[,:=[\]{}()-]/
  };
}

neon.displayName = "neon", neon.aliases = [];
var nevod_1 = nevod;

function nevod(e) {
  e.languages.nevod = {
    comment: /\/\/.*|(?:\/\*[\s\S]*?(?:\*\/|$))/,
    string: {
      pattern: /(?:"(?:""|[^"])*"(?!")|'(?:''|[^'])*'(?!'))!?\*?/,
      greedy: !0,
      inside: {
        "string-attrs": /!$|!\*$|\*$/
      }
    },
    namespace: {
      pattern: /(@namespace\s+)[a-zA-Z0-9\-.]+(?=\s*\{)/,
      lookbehind: !0
    },
    pattern: {
      pattern: /(@pattern\s+)?#?[a-zA-Z0-9\-.]+(?:\s*\(\s*(?:~\s*)?[a-zA-Z0-9\-.]+\s*(?:,\s*(?:~\s*)?[a-zA-Z0-9\-.]*)*\))?(?=\s*=)/,
      lookbehind: !0,
      inside: {
        "pattern-name": {
          pattern: /^#?[a-zA-Z0-9\-.]+/,
          alias: "class-name"
        },
        fields: {
          pattern: /\(.*\)/,
          inside: {
            "field-name": {
              pattern: /[a-zA-Z0-9\-.]+/,
              alias: "variable"
            },
            punctuation: /[,()]/,
            operator: {
              pattern: /~/,
              alias: "field-hidden-mark"
            }
          }
        }
      }
    },
    search: {
      pattern: /(@search\s+|#)[a-zA-Z0-9\-.]+(?:\.\*)?(?=\s*;)/,
      alias: "function",
      lookbehind: !0
    },
    keyword: /@(?:having|inside|namespace|outside|pattern|require|search|where)\b/,
    "standard-pattern": {
      pattern: /\b(?:Alpha|AlphaNum|Any|Blank|End|LineBreak|Num|NumAlpha|Punct|Space|Start|Symbol|Word|WordBreak)\b(?:\([a-zA-Z0-9\-.,\s+]*\))?/,
      inside: {
        "standard-pattern-name": {
          pattern: /^[a-zA-Z0-9\-.]+/,
          alias: "builtin"
        },
        quantifier: {
          pattern: /\b\d+(?:\s*\+|\s*-\s*\d+)?(?!\w)/,
          alias: "number"
        },
        "standard-pattern-attr": {
          pattern: /[a-zA-Z0-9\-.]+/,
          alias: "builtin"
        },
        punctuation: /[,()]/
      }
    },
    quantifier: {
      pattern: /\b\d+(?:\s*\+|\s*-\s*\d+)?(?!\w)/,
      alias: "number"
    },
    operator: [{
      pattern: /=/,
      alias: "pattern-def"
    }, {
      pattern: /&/,
      alias: "conjunction"
    }, {
      pattern: /~/,
      alias: "exception"
    }, {
      pattern: /\?/,
      alias: "optionality"
    }, {
      pattern: /[[\]]/,
      alias: "repetition"
    }, {
      pattern: /[{}]/,
      alias: "variation"
    }, {
      pattern: /[+_]/,
      alias: "sequence"
    }, {
      pattern: /\.{2,3}/,
      alias: "span"
    }],
    "field-capture": [{
      pattern: /([a-zA-Z0-9\-.]+\s*\()\s*[a-zA-Z0-9\-.]+\s*:\s*[a-zA-Z0-9\-.]+(?:\s*,\s*[a-zA-Z0-9\-.]+\s*:\s*[a-zA-Z0-9\-.]+)*(?=\s*\))/,
      lookbehind: !0,
      inside: {
        "field-name": {
          pattern: /[a-zA-Z0-9\-.]+/,
          alias: "variable"
        },
        colon: /:/
      }
    }, {
      pattern: /[a-zA-Z0-9\-.]+\s*:/,
      inside: {
        "field-name": {
          pattern: /[a-zA-Z0-9\-.]+/,
          alias: "variable"
        },
        colon: /:/
      }
    }],
    punctuation: /[:;,()]/,
    name: /[a-zA-Z0-9\-.]+/
  };
}

nevod.displayName = "nevod", nevod.aliases = [];
var nginx_1 = nginx;

function nginx(e) {
  !function (e) {
    var t = /\$(?:\w[a-z\d]*(?:_[^\x00-\x1F\s"'\\()$]*)?|\{[^}\s"'\\]+\})/i;
    e.languages.nginx = {
      comment: {
        pattern: /(^|[\s{};])#.*/,
        lookbehind: !0,
        greedy: !0
      },
      directive: {
        pattern: /(^|\s)\w(?:[^;{}"'\\\s]|\\.|"(?:[^"\\]|\\.)*"|'(?:[^'\\]|\\.)*'|\s+(?:#.*(?!.)|(?![#\s])))*?(?=\s*[;{])/,
        lookbehind: !0,
        greedy: !0,
        inside: {
          string: {
            pattern: /((?:^|[^\\])(?:\\\\)*)(?:"(?:[^"\\]|\\.)*"|'(?:[^'\\]|\\.)*')/,
            lookbehind: !0,
            greedy: !0,
            inside: {
              escape: {
                pattern: /\\["'\\nrt]/,
                alias: "entity"
              },
              variable: t
            }
          },
          comment: {
            pattern: /(\s)#.*/,
            lookbehind: !0,
            greedy: !0
          },
          keyword: {
            pattern: /^\S+/,
            greedy: !0
          },
          boolean: {
            pattern: /(\s)(?:off|on)(?!\S)/,
            lookbehind: !0
          },
          number: {
            pattern: /(\s)\d+[a-z]*(?!\S)/i,
            lookbehind: !0
          },
          variable: t
        }
      },
      punctuation: /[{};]/
    };
  }(e);
}

nginx.displayName = "nginx", nginx.aliases = [];
var nim_1 = nim;

function nim(e) {
  e.languages.nim = {
    comment: {
      pattern: /#.*/,
      greedy: !0
    },
    string: {
      pattern: /(?:\b(?!\d)(?:\w|\\x[89a-fA-F][0-9a-fA-F])+)?(?:"""[\s\S]*?"""(?!")|"(?:\\[\s\S]|""|[^"\\])*")/,
      greedy: !0
    },
    char: {
      pattern: /'(?:\\(?:\d+|x[\da-fA-F]{0,2}|.)|[^'])'/,
      greedy: !0
    },
    function: {
      pattern: /(?:(?!\d)(?:\w|\\x[89a-fA-F][0-9a-fA-F])+|`[^`\r\n]+`)\*?(?:\[[^\]]+\])?(?=\s*\()/,
      greedy: !0,
      inside: {
        operator: /\*$/
      }
    },
    identifier: {
      pattern: /`[^`\r\n]+`/,
      greedy: !0,
      inside: {
        punctuation: /`/
      }
    },
    number: /\b(?:0[xXoObB][\da-fA-F_]+|\d[\d_]*(?:(?!\.\.)\.[\d_]*)?(?:[eE][+-]?\d[\d_]*)?)(?:'?[iuf]\d*)?/,
    keyword: /\b(?:addr|as|asm|atomic|bind|block|break|case|cast|concept|const|continue|converter|defer|discard|distinct|do|elif|else|end|enum|except|export|finally|for|from|func|generic|if|import|include|interface|iterator|let|macro|method|mixin|nil|object|out|proc|ptr|raise|ref|return|static|template|try|tuple|type|using|var|when|while|with|without|yield)\b/,
    operator: {
      pattern: /(^|[({\[](?=\.\.)|(?![({\[]\.).)(?:(?:[=+\-*\/<>@$~&%|!?^:\\]|\.\.|\.(?![)}\]]))+|\b(?:and|div|in|is|isnot|mod|not|notin|of|or|shl|shr|xor)\b)/m,
      lookbehind: !0
    },
    punctuation: /[({\[]\.|\.[)}\]]|[`(){}\[\],:]/
  };
}

nim.displayName = "nim", nim.aliases = [];
var nix_1 = nix;

function nix(e) {
  e.languages.nix = {
    comment: {
      pattern: /\/\*[\s\S]*?\*\/|#.*/,
      greedy: !0
    },
    string: {
      pattern: /"(?:[^"\\]|\\[\s\S])*"|''(?:(?!'')[\s\S]|''(?:'|\\|\$\{))*''/,
      greedy: !0,
      inside: {
        interpolation: {
          pattern: /(^|(?:^|(?!'').)[^\\])\$\{(?:[^{}]|\{[^}]*\})*\}/,
          lookbehind: !0,
          inside: null
        }
      }
    },
    url: [/\b(?:[a-z]{3,7}:\/\/)[\w\-+%~\/.:#=?&]+/, {
      pattern: /([^\/])(?:[\w\-+%~.:#=?&]*(?!\/\/)[\w\-+%~\/.:#=?&])?(?!\/\/)\/[\w\-+%~\/.:#=?&]*/,
      lookbehind: !0
    }],
    antiquotation: {
      pattern: /\$(?=\{)/,
      alias: "important"
    },
    number: /\b\d+\b/,
    keyword: /\b(?:assert|builtins|else|if|in|inherit|let|null|or|then|with)\b/,
    function: /\b(?:abort|add|all|any|attrNames|attrValues|baseNameOf|compareVersions|concatLists|currentSystem|deepSeq|derivation|dirOf|div|elem(?:At)?|fetch(?:Tarball|url)|filter(?:Source)?|fromJSON|genList|getAttr|getEnv|hasAttr|hashString|head|import|intersectAttrs|is(?:Attrs|Bool|Function|Int|List|Null|String)|length|lessThan|listToAttrs|map|mul|parseDrvName|pathExists|read(?:Dir|File)|removeAttrs|replaceStrings|seq|sort|stringLength|sub(?:string)?|tail|throw|to(?:File|JSON|Path|String|XML)|trace|typeOf)\b|\bfoldl'\B/,
    boolean: /\b(?:false|true)\b/,
    operator: /[=!<>]=?|\+\+?|\|\||&&|\/\/|->?|[?@]/,
    punctuation: /[{}()[\].,:;]/
  }, e.languages.nix.string.inside.interpolation.inside = e.languages.nix;
}

nix.displayName = "nix", nix.aliases = [];
var nsis_1 = nsis;

function nsis(e) {
  e.languages.nsis = {
    comment: {
      pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|[#;].*)/,
      lookbehind: !0,
      greedy: !0
    },
    string: {
      pattern: /("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
      greedy: !0
    },
    keyword: {
      pattern: /(^[\t ]*)(?:Abort|Add(?:BrandingImage|Size)|AdvSplash|Allow(?:RootDirInstall|SkipFiles)|AutoCloseWindow|BG(?:Font|Gradient|Image)|Banner|BrandingText|BringToFront|CRCCheck|Call(?:InstDLL)?|Caption|ChangeUI|CheckBitmap|ClearErrors|CompletedText|ComponentText|CopyFiles|Create(?:Directory|Font|ShortCut)|Delete(?:INISec|INIStr|RegKey|RegValue)?|Detail(?:Print|sButtonText)|Dialer|Dir(?:Text|Var|Verify)|EnableWindow|Enum(?:RegKey|RegValue)|Exch|Exec(?:Shell(?:Wait)?|Wait)?|ExpandEnvStrings|File(?:BufSize|Close|ErrorText|Open|Read|ReadByte|ReadUTF16LE|ReadWord|Seek|Write|WriteByte|WriteUTF16LE|WriteWord)?|Find(?:Close|First|Next|Window)|FlushINI|Get(?:CurInstType|CurrentAddress|DLLVersion(?:Local)?|DlgItem|ErrorLevel|FileTime(?:Local)?|FullPathName|Function(?:Address|End)?|InstDirError|LabelAddress|TempFileName)|Goto|HideWindow|Icon|If(?:Abort|Errors|FileExists|RebootFlag|Silent)|InitPluginsDir|InstProgressFlags|Inst(?:Type(?:GetText|SetText)?)|Install(?:ButtonText|Colors|Dir(?:RegKey)?)|Int(?:64|Ptr)?CmpU?|Int(?:64)?Fmt|Int(?:Ptr)?Op|IsWindow|Lang(?:DLL|String)|License(?:BkColor|Data|ForceSelection|LangString|Text)|LoadLanguageFile|LockWindow|Log(?:Set|Text)|Manifest(?:DPIAware|SupportedOS)|Math|MessageBox|MiscButtonText|NSISdl|Name|Nop|OutFile|PE(?:DllCharacteristics|SubsysVer)|Page(?:Callbacks)?|Pop|Push|Quit|RMDir|Read(?:EnvStr|INIStr|RegDWORD|RegStr)|Reboot|RegDLL|Rename|RequestExecutionLevel|ReserveFile|Return|SearchPath|Section(?:End|GetFlags|GetInstTypes|GetSize|GetText|Group|In|SetFlags|SetInstTypes|SetSize|SetText)?|SendMessage|Set(?:AutoClose|BrandingImage|Compress|Compressor(?:DictSize)?|CtlColors|CurInstType|DatablockOptimize|DateSave|Details(?:Print|View)|ErrorLevel|Errors|FileAttributes|Font|OutPath|Overwrite|PluginUnload|RebootFlag|RegView|ShellVarContext|Silent)|Show(?:InstDetails|UninstDetails|Window)|Silent(?:Install|UnInstall)|Sleep|SpaceTexts|Splash|StartMenu|Str(?:CmpS?|Cpy|Len)|SubCaption|System|UnRegDLL|Unicode|UninstPage|Uninstall(?:ButtonText|Caption|Icon|SubCaption|Text)|UserInfo|VI(?:AddVersionKey|FileVersion|ProductVersion)|VPatch|Var|WindowIcon|Write(?:INIStr|Reg(?:Bin|DWORD|ExpandStr|MultiStr|None|Str)|Uninstaller)|XPStyle|ns(?:Dialogs|Exec))\b/m,
      lookbehind: !0
    },
    property: /\b(?:ARCHIVE|FILE_(?:ATTRIBUTE_ARCHIVE|ATTRIBUTE_NORMAL|ATTRIBUTE_OFFLINE|ATTRIBUTE_READONLY|ATTRIBUTE_SYSTEM|ATTRIBUTE_TEMPORARY)|HK(?:(?:CR|CU|LM)(?:32|64)?|DD|PD|U)|HKEY_(?:CLASSES_ROOT|CURRENT_CONFIG|CURRENT_USER|DYN_DATA|LOCAL_MACHINE|PERFORMANCE_DATA|USERS)|ID(?:ABORT|CANCEL|IGNORE|NO|OK|RETRY|YES)|MB_(?:ABORTRETRYIGNORE|DEFBUTTON1|DEFBUTTON2|DEFBUTTON3|DEFBUTTON4|ICONEXCLAMATION|ICONINFORMATION|ICONQUESTION|ICONSTOP|OK|OKCANCEL|RETRYCANCEL|RIGHT|RTLREADING|SETFOREGROUND|TOPMOST|USERICON|YESNO)|NORMAL|OFFLINE|READONLY|SHCTX|SHELL_CONTEXT|SYSTEM|TEMPORARY|admin|all|auto|both|colored|false|force|hide|highest|lastused|leave|listonly|none|normal|notset|off|on|open|print|show|silent|silentlog|smooth|textonly|true|user)\b/,
    constant: /\$\{[!\w\.:\^-]+\}|\$\([!\w\.:\^-]+\)/,
    variable: /\$\w[\w\.]*/,
    number: /\b0x[\dA-Fa-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee]-?\d+)?/,
    operator: /--?|\+\+?|<=?|>=?|==?=?|&&?|\|\|?|[?*\/~^%]/,
    punctuation: /[{}[\];(),.:]/,
    important: {
      pattern: /(^[\t ]*)!(?:addincludedir|addplugindir|appendfile|cd|define|delfile|echo|else|endif|error|execute|finalize|getdllversion|gettlbversion|if|ifdef|ifmacrodef|ifmacrondef|ifndef|include|insertmacro|macro|macroend|makensis|packhdr|pragma|searchparse|searchreplace|system|tempfile|undef|verbose|warning)\b/im,
      lookbehind: !0
    }
  };
}

nsis.displayName = "nsis", nsis.aliases = [];
var refractorC$1 = c_1,
    objectivec_1 = objectivec;

function objectivec(e) {
  e.register(refractorC$1), e.languages.objectivec = e.languages.extend("c", {
    string: {
      pattern: /@?"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/,
      greedy: !0
    },
    keyword: /\b(?:asm|auto|break|case|char|const|continue|default|do|double|else|enum|extern|float|for|goto|if|in|inline|int|long|register|return|self|short|signed|sizeof|static|struct|super|switch|typedef|typeof|union|unsigned|void|volatile|while)\b|(?:@interface|@end|@implementation|@protocol|@class|@public|@protected|@private|@property|@try|@catch|@finally|@throw|@synthesize|@dynamic|@selector)\b/,
    operator: /-[->]?|\+\+?|!=?|<<?=?|>>?=?|==?|&&?|\|\|?|[~^%?*\/@]/
  }), delete e.languages.objectivec["class-name"], e.languages.objc = e.languages.objectivec;
}

objectivec.displayName = "objectivec", objectivec.aliases = ["objc"];
var ocaml_1 = ocaml;

function ocaml(e) {
  e.languages.ocaml = {
    comment: {
      pattern: /\(\*[\s\S]*?\*\)/,
      greedy: !0
    },
    char: {
      pattern: /'(?:[^\\\r\n']|\\(?:.|[ox]?[0-9a-f]{1,3}))'/i,
      greedy: !0
    },
    string: [{
      pattern: /"(?:\\(?:[\s\S]|\r\n)|[^\\\r\n"])*"/,
      greedy: !0
    }, {
      pattern: /\{([a-z_]*)\|[\s\S]*?\|\1\}/,
      greedy: !0
    }],
    number: [/\b(?:0b[01][01_]*|0o[0-7][0-7_]*)\b/i, /\b0x[a-f0-9][a-f0-9_]*(?:\.[a-f0-9_]*)?(?:p[+-]?\d[\d_]*)?(?!\w)/i, /\b\d[\d_]*(?:\.[\d_]*)?(?:e[+-]?\d[\d_]*)?(?!\w)/i],
    directive: {
      pattern: /\B#\w+/,
      alias: "property"
    },
    label: {
      pattern: /\B~\w+/,
      alias: "property"
    },
    "type-variable": {
      pattern: /\B'\w+/,
      alias: "function"
    },
    variant: {
      pattern: /`\w+/,
      alias: "symbol"
    },
    keyword: /\b(?:as|assert|begin|class|constraint|do|done|downto|else|end|exception|external|for|fun|function|functor|if|in|include|inherit|initializer|lazy|let|match|method|module|mutable|new|nonrec|object|of|open|private|rec|sig|struct|then|to|try|type|val|value|virtual|when|where|while|with)\b/,
    boolean: /\b(?:false|true)\b/,
    "operator-like-punctuation": {
      pattern: /\[[<>|]|[>|]\]|\{<|>\}/,
      alias: "punctuation"
    },
    operator: /\.[.~]|:[=>]|[=<>@^|&+\-*\/$%!?~][!$%&*+\-.\/:<=>?@^|~]*|\b(?:and|asr|land|lor|lsl|lsr|lxor|mod|or)\b/,
    punctuation: /;;|::|[(){}\[\].,:;#]|\b_\b/
  };
}

ocaml.displayName = "ocaml", ocaml.aliases = [];
var refractorC = c_1,
    opencl_1 = opencl;

function opencl(e) {
  e.register(refractorC), function (e) {
    e.languages.opencl = e.languages.extend("c", {
      keyword: /\b(?:(?:__)?(?:constant|global|kernel|local|private|read_only|read_write|write_only)|__attribute__|auto|(?:bool|u?(?:char|int|long|short)|half|quad)(?:2|3|4|8|16)?|break|case|complex|const|continue|(?:double|float)(?:16(?:x(?:1|2|4|8|16))?|1x(?:1|2|4|8|16)|2(?:x(?:1|2|4|8|16))?|3|4(?:x(?:1|2|4|8|16))?|8(?:x(?:1|2|4|8|16))?)?|default|do|else|enum|extern|for|goto|if|imaginary|inline|packed|pipe|register|restrict|return|signed|sizeof|static|struct|switch|typedef|uniform|union|unsigned|void|volatile|while)\b/,
      number: /(?:\b0x(?:[\da-f]+(?:\.[\da-f]*)?|\.[\da-f]+)(?:p[+-]?\d+)?|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?)[fuhl]{0,4}/i,
      boolean: /\b(?:false|true)\b/,
      "constant-opencl-kernel": {
        pattern: /\b(?:CHAR_(?:BIT|MAX|MIN)|CLK_(?:ADDRESS_(?:CLAMP(?:_TO_EDGE)?|NONE|REPEAT)|FILTER_(?:LINEAR|NEAREST)|(?:GLOBAL|LOCAL)_MEM_FENCE|NORMALIZED_COORDS_(?:FALSE|TRUE))|CL_(?:BGRA|(?:HALF_)?FLOAT|INTENSITY|LUMINANCE|A?R?G?B?[Ax]?|(?:(?:UN)?SIGNED|[US]NORM)_(?:INT(?:8|16|32))|UNORM_(?:INT_101010|SHORT_(?:555|565)))|(?:DBL|FLT|HALF)_(?:DIG|EPSILON|(?:MAX|MIN)(?:(?:_10)?_EXP)?|MANT_DIG)|FLT_RADIX|HUGE_VALF?|(?:INT|LONG|SCHAR|SHRT)_(?:MAX|MIN)|INFINITY|MAXFLOAT|M_(?:[12]_PI|2_SQRTPI|E|LN(?:2|10)|LOG(?:2|10)E?|PI(?:_[24])?|SQRT(?:1_2|2))(?:_F|_H)?|NAN|(?:UCHAR|UINT|ULONG|USHRT)_MAX)\b/,
        alias: "constant"
      }
    }), e.languages.insertBefore("opencl", "class-name", {
      "builtin-type": {
        pattern: /\b(?:_cl_(?:command_queue|context|device_id|event|kernel|mem|platform_id|program|sampler)|cl_(?:image_format|mem_fence_flags)|clk_event_t|event_t|image(?:1d_(?:array_|buffer_)?t|2d_(?:array_(?:depth_|msaa_depth_|msaa_)?|depth_|msaa_depth_|msaa_)?t|3d_t)|intptr_t|ndrange_t|ptrdiff_t|queue_t|reserve_id_t|sampler_t|size_t|uintptr_t)\b/,
        alias: "keyword"
      }
    });
    var t = {
      "type-opencl-host": {
        pattern: /\b(?:cl_(?:GLenum|GLint|GLuin|addressing_mode|bitfield|bool|buffer_create_type|build_status|channel_(?:order|type)|(?:u?(?:char|int|long|short)|double|float)(?:2|3|4|8|16)?|command_(?:queue(?:_info|_properties)?|type)|context(?:_info|_properties)?|device_(?:exec_capabilities|fp_config|id|info|local_mem_type|mem_cache_type|type)|(?:event|sampler)(?:_info)?|filter_mode|half|image_info|kernel(?:_info|_work_group_info)?|map_flags|mem(?:_flags|_info|_object_type)?|platform_(?:id|info)|profiling_info|program(?:_build_info|_info)?))\b/,
        alias: "keyword"
      },
      "boolean-opencl-host": {
        pattern: /\bCL_(?:FALSE|TRUE)\b/,
        alias: "boolean"
      },
      "constant-opencl-host": {
        pattern: /\bCL_(?:A|ABGR|ADDRESS_(?:CLAMP(?:_TO_EDGE)?|MIRRORED_REPEAT|NONE|REPEAT)|ARGB|BGRA|BLOCKING|BUFFER_CREATE_TYPE_REGION|BUILD_(?:ERROR|IN_PROGRESS|NONE|PROGRAM_FAILURE|SUCCESS)|COMMAND_(?:ACQUIRE_GL_OBJECTS|BARRIER|COPY_(?:BUFFER(?:_RECT|_TO_IMAGE)?|IMAGE(?:_TO_BUFFER)?)|FILL_(?:BUFFER|IMAGE)|MAP(?:_BUFFER|_IMAGE)|MARKER|MIGRATE(?:_SVM)?_MEM_OBJECTS|NATIVE_KERNEL|NDRANGE_KERNEL|READ_(?:BUFFER(?:_RECT)?|IMAGE)|RELEASE_GL_OBJECTS|SVM_(?:FREE|MAP|MEMCPY|MEMFILL|UNMAP)|TASK|UNMAP_MEM_OBJECT|USER|WRITE_(?:BUFFER(?:_RECT)?|IMAGE))|COMPILER_NOT_AVAILABLE|COMPILE_PROGRAM_FAILURE|COMPLETE|CONTEXT_(?:DEVICES|INTEROP_USER_SYNC|NUM_DEVICES|PLATFORM|PROPERTIES|REFERENCE_COUNT)|DEPTH(?:_STENCIL)?|DEVICE_(?:ADDRESS_BITS|AFFINITY_DOMAIN_(?:L[1-4]_CACHE|NEXT_PARTITIONABLE|NUMA)|AVAILABLE|BUILT_IN_KERNELS|COMPILER_AVAILABLE|DOUBLE_FP_CONFIG|ENDIAN_LITTLE|ERROR_CORRECTION_SUPPORT|EXECUTION_CAPABILITIES|EXTENSIONS|GLOBAL_(?:MEM_(?:CACHELINE_SIZE|CACHE_SIZE|CACHE_TYPE|SIZE)|VARIABLE_PREFERRED_TOTAL_SIZE)|HOST_UNIFIED_MEMORY|IL_VERSION|IMAGE(?:2D_MAX_(?:HEIGHT|WIDTH)|3D_MAX_(?:DEPTH|HEIGHT|WIDTH)|_BASE_ADDRESS_ALIGNMENT|_MAX_ARRAY_SIZE|_MAX_BUFFER_SIZE|_PITCH_ALIGNMENT|_SUPPORT)|LINKER_AVAILABLE|LOCAL_MEM_SIZE|LOCAL_MEM_TYPE|MAX_(?:CLOCK_FREQUENCY|COMPUTE_UNITS|CONSTANT_ARGS|CONSTANT_BUFFER_SIZE|GLOBAL_VARIABLE_SIZE|MEM_ALLOC_SIZE|NUM_SUB_GROUPS|ON_DEVICE_(?:EVENTS|QUEUES)|PARAMETER_SIZE|PIPE_ARGS|READ_IMAGE_ARGS|READ_WRITE_IMAGE_ARGS|SAMPLERS|WORK_GROUP_SIZE|WORK_ITEM_DIMENSIONS|WORK_ITEM_SIZES|WRITE_IMAGE_ARGS)|MEM_BASE_ADDR_ALIGN|MIN_DATA_TYPE_ALIGN_SIZE|NAME|NATIVE_VECTOR_WIDTH_(?:CHAR|DOUBLE|FLOAT|HALF|INT|LONG|SHORT)|NOT_(?:AVAILABLE|FOUND)|OPENCL_C_VERSION|PARENT_DEVICE|PARTITION_(?:AFFINITY_DOMAIN|BY_AFFINITY_DOMAIN|BY_COUNTS|BY_COUNTS_LIST_END|EQUALLY|FAILED|MAX_SUB_DEVICES|PROPERTIES|TYPE)|PIPE_MAX_(?:ACTIVE_RESERVATIONS|PACKET_SIZE)|PLATFORM|PREFERRED_(?:GLOBAL_ATOMIC_ALIGNMENT|INTEROP_USER_SYNC|LOCAL_ATOMIC_ALIGNMENT|PLATFORM_ATOMIC_ALIGNMENT|VECTOR_WIDTH_(?:CHAR|DOUBLE|FLOAT|HALF|INT|LONG|SHORT))|PRINTF_BUFFER_SIZE|PROFILE|PROFILING_TIMER_RESOLUTION|QUEUE_(?:ON_(?:DEVICE_(?:MAX_SIZE|PREFERRED_SIZE|PROPERTIES)|HOST_PROPERTIES)|PROPERTIES)|REFERENCE_COUNT|SINGLE_FP_CONFIG|SUB_GROUP_INDEPENDENT_FORWARD_PROGRESS|SVM_(?:ATOMICS|CAPABILITIES|COARSE_GRAIN_BUFFER|FINE_GRAIN_BUFFER|FINE_GRAIN_SYSTEM)|TYPE(?:_ACCELERATOR|_ALL|_CPU|_CUSTOM|_DEFAULT|_GPU)?|VENDOR(?:_ID)?|VERSION)|DRIVER_VERSION|EVENT_(?:COMMAND_(?:EXECUTION_STATUS|QUEUE|TYPE)|CONTEXT|REFERENCE_COUNT)|EXEC_(?:KERNEL|NATIVE_KERNEL|STATUS_ERROR_FOR_EVENTS_IN_WAIT_LIST)|FILTER_(?:LINEAR|NEAREST)|FLOAT|FP_(?:CORRECTLY_ROUNDED_DIVIDE_SQRT|DENORM|FMA|INF_NAN|ROUND_TO_INF|ROUND_TO_NEAREST|ROUND_TO_ZERO|SOFT_FLOAT)|GLOBAL|HALF_FLOAT|IMAGE_(?:ARRAY_SIZE|BUFFER|DEPTH|ELEMENT_SIZE|FORMAT|FORMAT_MISMATCH|FORMAT_NOT_SUPPORTED|HEIGHT|NUM_MIP_LEVELS|NUM_SAMPLES|ROW_PITCH|SLICE_PITCH|WIDTH)|INTENSITY|INVALID_(?:ARG_INDEX|ARG_SIZE|ARG_VALUE|BINARY|BUFFER_SIZE|BUILD_OPTIONS|COMMAND_QUEUE|COMPILER_OPTIONS|CONTEXT|DEVICE|DEVICE_PARTITION_COUNT|DEVICE_QUEUE|DEVICE_TYPE|EVENT|EVENT_WAIT_LIST|GLOBAL_OFFSET|GLOBAL_WORK_SIZE|GL_OBJECT|HOST_PTR|IMAGE_DESCRIPTOR|IMAGE_FORMAT_DESCRIPTOR|IMAGE_SIZE|KERNEL|KERNEL_ARGS|KERNEL_DEFINITION|KERNEL_NAME|LINKER_OPTIONS|MEM_OBJECT|MIP_LEVEL|OPERATION|PIPE_SIZE|PLATFORM|PROGRAM|PROGRAM_EXECUTABLE|PROPERTY|QUEUE_PROPERTIES|SAMPLER|VALUE|WORK_DIMENSION|WORK_GROUP_SIZE|WORK_ITEM_SIZE)|KERNEL_(?:ARG_(?:ACCESS_(?:NONE|QUALIFIER|READ_ONLY|READ_WRITE|WRITE_ONLY)|ADDRESS_(?:CONSTANT|GLOBAL|LOCAL|PRIVATE|QUALIFIER)|INFO_NOT_AVAILABLE|NAME|TYPE_(?:CONST|NAME|NONE|PIPE|QUALIFIER|RESTRICT|VOLATILE))|ATTRIBUTES|COMPILE_NUM_SUB_GROUPS|COMPILE_WORK_GROUP_SIZE|CONTEXT|EXEC_INFO_SVM_FINE_GRAIN_SYSTEM|EXEC_INFO_SVM_PTRS|FUNCTION_NAME|GLOBAL_WORK_SIZE|LOCAL_MEM_SIZE|LOCAL_SIZE_FOR_SUB_GROUP_COUNT|MAX_NUM_SUB_GROUPS|MAX_SUB_GROUP_SIZE_FOR_NDRANGE|NUM_ARGS|PREFERRED_WORK_GROUP_SIZE_MULTIPLE|PRIVATE_MEM_SIZE|PROGRAM|REFERENCE_COUNT|SUB_GROUP_COUNT_FOR_NDRANGE|WORK_GROUP_SIZE)|LINKER_NOT_AVAILABLE|LINK_PROGRAM_FAILURE|LOCAL|LUMINANCE|MAP_(?:FAILURE|READ|WRITE|WRITE_INVALIDATE_REGION)|MEM_(?:ALLOC_HOST_PTR|ASSOCIATED_MEMOBJECT|CONTEXT|COPY_HOST_PTR|COPY_OVERLAP|FLAGS|HOST_NO_ACCESS|HOST_PTR|HOST_READ_ONLY|HOST_WRITE_ONLY|KERNEL_READ_AND_WRITE|MAP_COUNT|OBJECT_(?:ALLOCATION_FAILURE|BUFFER|IMAGE1D|IMAGE1D_ARRAY|IMAGE1D_BUFFER|IMAGE2D|IMAGE2D_ARRAY|IMAGE3D|PIPE)|OFFSET|READ_ONLY|READ_WRITE|REFERENCE_COUNT|SIZE|SVM_ATOMICS|SVM_FINE_GRAIN_BUFFER|TYPE|USES_SVM_POINTER|USE_HOST_PTR|WRITE_ONLY)|MIGRATE_MEM_OBJECT_(?:CONTENT_UNDEFINED|HOST)|MISALIGNED_SUB_BUFFER_OFFSET|NONE|NON_BLOCKING|OUT_OF_(?:HOST_MEMORY|RESOURCES)|PIPE_(?:MAX_PACKETS|PACKET_SIZE)|PLATFORM_(?:EXTENSIONS|HOST_TIMER_RESOLUTION|NAME|PROFILE|VENDOR|VERSION)|PROFILING_(?:COMMAND_(?:COMPLETE|END|QUEUED|START|SUBMIT)|INFO_NOT_AVAILABLE)|PROGRAM_(?:BINARIES|BINARY_SIZES|BINARY_TYPE(?:_COMPILED_OBJECT|_EXECUTABLE|_LIBRARY|_NONE)?|BUILD_(?:GLOBAL_VARIABLE_TOTAL_SIZE|LOG|OPTIONS|STATUS)|CONTEXT|DEVICES|IL|KERNEL_NAMES|NUM_DEVICES|NUM_KERNELS|REFERENCE_COUNT|SOURCE)|QUEUED|QUEUE_(?:CONTEXT|DEVICE|DEVICE_DEFAULT|ON_DEVICE|ON_DEVICE_DEFAULT|OUT_OF_ORDER_EXEC_MODE_ENABLE|PROFILING_ENABLE|PROPERTIES|REFERENCE_COUNT|SIZE)|R|RA|READ_(?:ONLY|WRITE)_CACHE|RG|RGB|RGBA|RGBx|RGx|RUNNING|Rx|SAMPLER_(?:ADDRESSING_MODE|CONTEXT|FILTER_MODE|LOD_MAX|LOD_MIN|MIP_FILTER_MODE|NORMALIZED_COORDS|REFERENCE_COUNT)|(?:UN)?SIGNED_INT(?:8|16|32)|SNORM_INT(?:8|16)|SUBMITTED|SUCCESS|UNORM_INT(?:8|16|24|_101010|_101010_2)|UNORM_SHORT_(?:555|565)|VERSION_(?:1_0|1_1|1_2|2_0|2_1)|sBGRA|sRGB|sRGBA|sRGBx)\b/,
        alias: "constant"
      },
      "function-opencl-host": {
        pattern: /\bcl(?:BuildProgram|CloneKernel|CompileProgram|Create(?:Buffer|CommandQueue(?:WithProperties)?|Context|ContextFromType|Image|Image2D|Image3D|Kernel|KernelsInProgram|Pipe|ProgramWith(?:Binary|BuiltInKernels|IL|Source)|Sampler|SamplerWithProperties|SubBuffer|SubDevices|UserEvent)|Enqueue(?:(?:Barrier|Marker)(?:WithWaitList)?|Copy(?:Buffer(?:Rect|ToImage)?|Image(?:ToBuffer)?)|(?:Fill|Map)(?:Buffer|Image)|MigrateMemObjects|NDRangeKernel|NativeKernel|(?:Read|Write)(?:Buffer(?:Rect)?|Image)|SVM(?:Free|Map|MemFill|Memcpy|MigrateMem|Unmap)|Task|UnmapMemObject|WaitForEvents)|Finish|Flush|Get(?:CommandQueueInfo|ContextInfo|Device(?:AndHostTimer|IDs|Info)|Event(?:Profiling)?Info|ExtensionFunctionAddress(?:ForPlatform)?|HostTimer|ImageInfo|Kernel(?:ArgInfo|Info|SubGroupInfo|WorkGroupInfo)|MemObjectInfo|PipeInfo|Platform(?:IDs|Info)|Program(?:Build)?Info|SamplerInfo|SupportedImageFormats)|LinkProgram|(?:Release|Retain)(?:CommandQueue|Context|Device|Event|Kernel|MemObject|Program|Sampler)|SVM(?:Alloc|Free)|Set(?:CommandQueueProperty|DefaultDeviceCommandQueue|EventCallback|Kernel|Kernel(?:Arg(?:SVMPointer)?|ExecInfo)|MemObjectDestructorCallback|UserEventStatus)|Unload(?:Platform)?Compiler|WaitForEvents)\b/,
        alias: "function"
      }
    };
    e.languages.insertBefore("c", "keyword", t), e.languages.cpp && (t["type-opencl-host-cpp"] = {
      pattern: /\b(?:Buffer|BufferGL|BufferRenderGL|CommandQueue|Context|Device|DeviceCommandQueue|EnqueueArgs|Event|Image|Image1D|Image1DArray|Image1DBuffer|Image2D|Image2DArray|Image2DGL|Image3D|Image3DGL|ImageFormat|ImageGL|Kernel|KernelFunctor|LocalSpaceArg|Memory|NDRange|Pipe|Platform|Program|SVMAllocator|SVMTraitAtomic|SVMTraitCoarse|SVMTraitFine|SVMTraitReadOnly|SVMTraitReadWrite|SVMTraitWriteOnly|Sampler|UserEvent)\b/,
      alias: "keyword"
    }, e.languages.insertBefore("cpp", "keyword", t));
  }(e);
}

opencl.displayName = "opencl", opencl.aliases = [];
var openqasm_1 = openqasm;

function openqasm(e) {
  e.languages.openqasm = {
    comment: /\/\*[\s\S]*?\*\/|\/\/.*/,
    string: {
      pattern: /"[^"\r\n\t]*"|'[^'\r\n\t]*'/,
      greedy: !0
    },
    keyword: /\b(?:CX|OPENQASM|U|barrier|boxas|boxto|break|const|continue|ctrl|def|defcal|defcalgrammar|delay|else|end|for|gate|gphase|if|in|include|inv|kernel|lengthof|let|measure|pow|reset|return|rotary|stretchinf|while)\b|#pragma\b/,
    "class-name": /\b(?:angle|bit|bool|creg|fixed|float|int|length|qreg|qubit|stretch|uint)\b/,
    function: /\b(?:cos|exp|ln|popcount|rotl|rotr|sin|sqrt|tan)\b(?=\s*\()/,
    constant: /\b(?:euler|pi|tau)\b|π|𝜏|ℇ/,
    number: {
      pattern: /(^|[^.\w$])(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?(?:dt|ns|us|µs|ms|s)?/i,
      lookbehind: !0
    },
    operator: /->|>>=?|<<=?|&&|\|\||\+\+|--|[!=<>&|~^+\-*/%]=?|@/,
    punctuation: /[(){}\[\];,:.]/
  }, e.languages.qasm = e.languages.openqasm;
}

openqasm.displayName = "openqasm", openqasm.aliases = ["qasm"];
var oz_1 = oz;

function oz(e) {
  e.languages.oz = {
    comment: {
      pattern: /\/\*[\s\S]*?\*\/|%.*/,
      greedy: !0
    },
    string: {
      pattern: /"(?:[^"\\]|\\[\s\S])*"/,
      greedy: !0
    },
    atom: {
      pattern: /'(?:[^'\\]|\\[\s\S])*'/,
      greedy: !0,
      alias: "builtin"
    },
    keyword: /\$|\[\]|\b(?:_|at|attr|case|catch|choice|class|cond|declare|define|dis|else(?:case|if)?|end|export|fail|false|feat|finally|from|fun|functor|if|import|in|local|lock|meth|nil|not|of|or|prepare|proc|prop|raise|require|self|skip|then|thread|true|try|unit)\b/,
    function: [/\b[a-z][A-Za-z\d]*(?=\()/, {
      pattern: /(\{)[A-Z][A-Za-z\d]*\b/,
      lookbehind: !0
    }],
    number: /\b(?:0[bx][\da-f]+|\d+(?:\.\d*)?(?:e~?\d+)?)\b|&(?:[^\\]|\\(?:\d{3}|.))/i,
    variable: /`(?:[^`\\]|\\.)+`/,
    "attr-name": /\b\w+(?=[ \t]*:(?![:=]))/,
    operator: /:(?:=|::?)|<[-:=]?|=(?:=|<?:?)|>=?:?|\\=:?|!!?|[|#+\-*\/,~^@]|\b(?:andthen|div|mod|orelse)\b/,
    punctuation: /[\[\](){}.:;?]/
  };
}

oz.displayName = "oz", oz.aliases = [];
var parigp_1 = parigp;

function parigp(e) {
  var t;
  e.languages.parigp = {
    comment: /\/\*[\s\S]*?\*\/|\\\\.*/,
    string: {
      pattern: /"(?:[^"\\\r\n]|\\.)*"/,
      greedy: !0
    },
    keyword: (t = ["breakpoint", "break", "dbg_down", "dbg_err", "dbg_up", "dbg_x", "forcomposite", "fordiv", "forell", "forpart", "forprime", "forstep", "forsubgroup", "forvec", "for", "iferr", "if", "local", "my", "next", "return", "until", "while"], t = t.map(function (e) {
      return e.split("").join(" *");
    }).join("|"), RegExp("\\b(?:" + t + ")\\b")),
    function: /\b\w(?:[\w ]*\w)?(?= *\()/,
    number: {
      pattern: /((?:\. *\. *)?)(?:\b\d(?: *\d)*(?: *(?!\. *\.)\.(?: *\d)*)?|\. *\d(?: *\d)*)(?: *e *(?:[+-] *)?\d(?: *\d)*)?/i,
      lookbehind: !0
    },
    operator: /\. *\.|[*\/!](?: *=)?|%(?: *=|(?: *#)?(?: *')*)?|\+(?: *[+=])?|-(?: *[-=>])?|<(?: *>|(?: *<)?(?: *=)?)?|>(?: *>)?(?: *=)?|=(?: *=){0,2}|\\(?: *\/)?(?: *=)?|&(?: *&)?|\| *\||['#~^]/,
    punctuation: /[\[\]{}().,:;|]/
  };
}

parigp.displayName = "parigp", parigp.aliases = [];
var parser_1 = parser;

function parser(e) {
  !function (e) {
    var t = e.languages.parser = e.languages.extend("markup", {
      keyword: {
        pattern: /(^|[^^])(?:\^(?:case|eval|for|if|switch|throw)\b|@(?:BASE|CLASS|GET(?:_DEFAULT)?|OPTIONS|SET_DEFAULT|USE)\b)/,
        lookbehind: !0
      },
      variable: {
        pattern: /(^|[^^])\B\$(?:\w+|(?=[.{]))(?:(?:\.|::?)\w+)*(?:\.|::?)?/,
        lookbehind: !0,
        inside: {
          punctuation: /\.|:+/
        }
      },
      function: {
        pattern: /(^|[^^])\B[@^]\w+(?:(?:\.|::?)\w+)*(?:\.|::?)?/,
        lookbehind: !0,
        inside: {
          keyword: {
            pattern: /(^@)(?:GET_|SET_)/,
            lookbehind: !0
          },
          punctuation: /\.|:+/
        }
      },
      escape: {
        pattern: /\^(?:[$^;@()\[\]{}"':]|#[a-f\d]*)/i,
        alias: "builtin"
      },
      punctuation: /[\[\](){};]/
    });
    t = e.languages.insertBefore("parser", "keyword", {
      "parser-comment": {
        pattern: /(\s)#.*/,
        lookbehind: !0,
        alias: "comment"
      },
      expression: {
        pattern: /(^|[^^])\((?:[^()]|\((?:[^()]|\((?:[^()])*\))*\))*\)/,
        greedy: !0,
        lookbehind: !0,
        inside: {
          string: {
            pattern: /(^|[^^])(["'])(?:(?!\2)[^^]|\^[\s\S])*\2/,
            lookbehind: !0
          },
          keyword: t.keyword,
          variable: t.variable,
          function: t.function,
          boolean: /\b(?:false|true)\b/,
          number: /\b(?:0x[a-f\d]+|\d+(?:\.\d*)?(?:e[+-]?\d+)?)\b/i,
          escape: t.escape,
          operator: /[~+*\/\\%]|!(?:\|\|?|=)?|&&?|\|\|?|==|<[<=]?|>[>=]?|-[fd]?|\b(?:def|eq|ge|gt|in|is|le|lt|ne)\b/,
          punctuation: t.punctuation
        }
      }
    }), e.languages.insertBefore("inside", "punctuation", {
      expression: t.expression,
      keyword: t.keyword,
      variable: t.variable,
      function: t.function,
      escape: t.escape,
      "parser-punctuation": {
        pattern: t.punctuation,
        alias: "punctuation"
      }
    }, t.tag.inside["attr-value"]);
  }(e);
}

parser.displayName = "parser", parser.aliases = [];
var pascal_1 = pascal;

function pascal(e) {
  e.languages.pascal = {
    directive: {
      pattern: /\{\$[\s\S]*?\}/,
      greedy: !0,
      alias: ["marco", "property"]
    },
    comment: {
      pattern: /\(\*[\s\S]*?\*\)|\{[\s\S]*?\}|\/\/.*/,
      greedy: !0
    },
    string: {
      pattern: /(?:'(?:''|[^'\r\n])*'(?!')|#[&$%]?[a-f\d]+)+|\^[a-z]/i,
      greedy: !0
    },
    asm: {
      pattern: /(\basm\b)[\s\S]+?(?=\bend\s*[;[])/i,
      lookbehind: !0,
      greedy: !0,
      inside: null
    },
    keyword: [{
      pattern: /(^|[^&])\b(?:absolute|array|asm|begin|case|const|constructor|destructor|do|downto|else|end|file|for|function|goto|if|implementation|inherited|inline|interface|label|nil|object|of|operator|packed|procedure|program|record|reintroduce|repeat|self|set|string|then|to|type|unit|until|uses|var|while|with)\b/i,
      lookbehind: !0
    }, {
      pattern: /(^|[^&])\b(?:dispose|exit|false|new|true)\b/i,
      lookbehind: !0
    }, {
      pattern: /(^|[^&])\b(?:class|dispinterface|except|exports|finalization|finally|initialization|inline|library|on|out|packed|property|raise|resourcestring|threadvar|try)\b/i,
      lookbehind: !0
    }, {
      pattern: /(^|[^&])\b(?:absolute|abstract|alias|assembler|bitpacked|break|cdecl|continue|cppdecl|cvar|default|deprecated|dynamic|enumerator|experimental|export|external|far|far16|forward|generic|helper|implements|index|interrupt|iochecks|local|message|name|near|nodefault|noreturn|nostackframe|oldfpccall|otherwise|overload|override|pascal|platform|private|protected|public|published|read|register|reintroduce|result|safecall|saveregisters|softfloat|specialize|static|stdcall|stored|strict|unaligned|unimplemented|varargs|virtual|write)\b/i,
      lookbehind: !0
    }],
    number: [/(?:[&%]\d+|\$[a-f\d]+)/i, /\b\d+(?:\.\d+)?(?:e[+-]?\d+)?/i],
    operator: [/\.\.|\*\*|:=|<[<=>]?|>[>=]?|[+\-*\/]=?|[@^=]/, {
      pattern: /(^|[^&])\b(?:and|as|div|exclude|in|include|is|mod|not|or|shl|shr|xor)\b/,
      lookbehind: !0
    }],
    punctuation: /\(\.|\.\)|[()\[\]:;,.]/
  }, e.languages.pascal.asm.inside = e.languages.extend("pascal", {
    asm: void 0,
    keyword: void 0,
    operator: void 0
  }), e.languages.objectpascal = e.languages.pascal;
}

pascal.displayName = "pascal", pascal.aliases = ["objectpascal"];
var pascaligo_1 = pascaligo;

function pascaligo(e) {
  !function (e) {
    var t = /\((?:[^()]|\((?:[^()]|\([^()]*\))*\))*\)/.source,
        r = /(?:\b\w+(?:<braces>)?|<braces>)/.source.replace(/<braces>/g, function () {
      return t;
    }),
        n = e.languages.pascaligo = {
      comment: /\(\*[\s\S]+?\*\)|\/\/.*/,
      string: {
        pattern: /(["'`])(?:\\[\s\S]|(?!\1)[^\\])*\1|\^[a-z]/i,
        greedy: !0
      },
      "class-name": [{
        pattern: RegExp(/(\btype\s+\w+\s+is\s+)<type>/.source.replace(/<type>/g, function () {
          return r;
        }), "i"),
        lookbehind: !0,
        inside: null
      }, {
        pattern: RegExp(/<type>(?=\s+is\b)/.source.replace(/<type>/g, function () {
          return r;
        }), "i"),
        inside: null
      }, {
        pattern: RegExp(/(:\s*)<type>/.source.replace(/<type>/g, function () {
          return r;
        })),
        lookbehind: !0,
        inside: null
      }],
      keyword: {
        pattern: /(^|[^&])\b(?:begin|block|case|const|else|end|fail|for|from|function|if|is|nil|of|remove|return|skip|then|type|var|while|with)\b/i,
        lookbehind: !0
      },
      boolean: {
        pattern: /(^|[^&])\b(?:False|True)\b/i,
        lookbehind: !0
      },
      builtin: {
        pattern: /(^|[^&])\b(?:bool|int|list|map|nat|record|string|unit)\b/i,
        lookbehind: !0
      },
      function: /\b\w+(?=\s*\()/,
      number: [/%[01]+|&[0-7]+|\$[a-f\d]+/i, /\b\d+(?:\.\d+)?(?:e[+-]?\d+)?(?:mtz|n)?/i],
      operator: /->|=\/=|\.\.|\*\*|:=|<[<=>]?|>[>=]?|[+\-*\/]=?|[@^=|]|\b(?:and|mod|or)\b/,
      punctuation: /\(\.|\.\)|[()\[\]:;,.{}]/
    },
        a = ["comment", "keyword", "builtin", "operator", "punctuation"].reduce(function (e, t) {
      return e[t] = n[t], e;
    }, {});
    n["class-name"].forEach(function (e) {
      e.inside = a;
    });
  }(e);
}

pascaligo.displayName = "pascaligo", pascaligo.aliases = [];
var pcaxis_1 = pcaxis;

function pcaxis(e) {
  e.languages.pcaxis = {
    string: /"[^"]*"/,
    keyword: {
      pattern: /((?:^|;)\s*)[-A-Z\d]+(?:\s*\[[-\w]+\])?(?:\s*\("[^"]*"(?:,\s*"[^"]*")*\))?(?=\s*=)/,
      lookbehind: !0,
      greedy: !0,
      inside: {
        keyword: /^[-A-Z\d]+/,
        language: {
          pattern: /^(\s*)\[[-\w]+\]/,
          lookbehind: !0,
          inside: {
            punctuation: /^\[|\]$/,
            property: /[-\w]+/
          }
        },
        "sub-key": {
          pattern: /^(\s*)\S[\s\S]*/,
          lookbehind: !0,
          inside: {
            parameter: {
              pattern: /"[^"]*"/,
              alias: "property"
            },
            punctuation: /^\(|\)$|,/
          }
        }
      }
    },
    operator: /=/,
    tlist: {
      pattern: /TLIST\s*\(\s*\w+(?:(?:\s*,\s*"[^"]*")+|\s*,\s*"[^"]*"-"[^"]*")?\s*\)/,
      greedy: !0,
      inside: {
        function: /^TLIST/,
        property: {
          pattern: /^(\s*\(\s*)\w+/,
          lookbehind: !0
        },
        string: /"[^"]*"/,
        punctuation: /[(),]/,
        operator: /-/
      }
    },
    punctuation: /[;,]/,
    number: {
      pattern: /(^|\s)\d+(?:\.\d+)?(?!\S)/,
      lookbehind: !0
    },
    boolean: /NO|YES/
  }, e.languages.px = e.languages.pcaxis;
}

pcaxis.displayName = "pcaxis", pcaxis.aliases = ["px"];
var peoplecode_1 = peoplecode;

function peoplecode(e) {
  e.languages.peoplecode = {
    comment: RegExp([/\/\*[\s\S]*?\*\//.source, /\bREM[^;]*;/.source, /<\*(?:[^<*]|\*(?!>)|<(?!\*)|<\*(?:(?!\*>)[\s\S])*\*>)*\*>/.source, /\/\+[\s\S]*?\+\//.source].join("|")),
    string: {
      pattern: /'(?:''|[^'\r\n])*'(?!')|"(?:""|[^"\r\n])*"(?!")/,
      greedy: !0
    },
    variable: /%\w+/,
    "function-definition": {
      pattern: /((?:^|[^\w-])(?:function|method)\s+)\w+/i,
      lookbehind: !0,
      alias: "function"
    },
    "class-name": {
      pattern: /((?:^|[^-\w])(?:as|catch|class|component|create|extends|global|implements|instance|local|of|property|returns)\s+)\w+(?::\w+)*/i,
      lookbehind: !0,
      inside: {
        punctuation: /:/
      }
    },
    keyword: /\b(?:abstract|alias|as|catch|class|component|constant|create|declare|else|end-(?:class|evaluate|for|function|get|if|method|set|try|while)|evaluate|extends|for|function|get|global|if|implements|import|instance|library|local|method|null|of|out|peopleCode|private|program|property|protected|readonly|ref|repeat|returns?|set|step|then|throw|to|try|until|value|when(?:-other)?|while)\b/i,
    "operator-keyword": {
      pattern: /\b(?:and|not|or)\b/i,
      alias: "operator"
    },
    function: /[_a-z]\w*(?=\s*\()/i,
    boolean: /\b(?:false|true)\b/i,
    number: /\b\d+(?:\.\d+)?\b/,
    operator: /<>|[<>]=?|!=|\*\*|[-+*/|=@]/,
    punctuation: /[:.;,()[\]]/
  }, e.languages.pcode = e.languages.peoplecode;
}

peoplecode.displayName = "peoplecode", peoplecode.aliases = ["pcode"];
var perl_1 = perl;

function perl(e) {
  !function (e) {
    var t = /(?:\((?:[^()\\]|\\[\s\S])*\)|\{(?:[^{}\\]|\\[\s\S])*\}|\[(?:[^[\]\\]|\\[\s\S])*\]|<(?:[^<>\\]|\\[\s\S])*>)/.source;
    e.languages.perl = {
      comment: [{
        pattern: /(^\s*)=\w[\s\S]*?=cut.*/m,
        lookbehind: !0,
        greedy: !0
      }, {
        pattern: /(^|[^\\$])#.*/,
        lookbehind: !0,
        greedy: !0
      }],
      string: [{
        pattern: RegExp(/\b(?:q|qq|qw|qx)(?![a-zA-Z0-9])\s*/.source + "(?:" + [/([^a-zA-Z0-9\s{(\[<])(?:(?!\1)[^\\]|\\[\s\S])*\1/.source, /([a-zA-Z0-9])(?:(?!\2)[^\\]|\\[\s\S])*\2/.source, t].join("|") + ")"),
        greedy: !0
      }, {
        pattern: /("|`)(?:(?!\1)[^\\]|\\[\s\S])*\1/,
        greedy: !0
      }, {
        pattern: /'(?:[^'\\\r\n]|\\.)*'/,
        greedy: !0
      }],
      regex: [{
        pattern: RegExp(/\b(?:m|qr)(?![a-zA-Z0-9])\s*/.source + "(?:" + [/([^a-zA-Z0-9\s{(\[<])(?:(?!\1)[^\\]|\\[\s\S])*\1/.source, /([a-zA-Z0-9])(?:(?!\2)[^\\]|\\[\s\S])*\2/.source, t].join("|") + ")" + /[msixpodualngc]*/.source),
        greedy: !0
      }, {
        pattern: RegExp(/(^|[^-])\b(?:s|tr|y)(?![a-zA-Z0-9])\s*/.source + "(?:" + [/([^a-zA-Z0-9\s{(\[<])(?:(?!\2)[^\\]|\\[\s\S])*\2(?:(?!\2)[^\\]|\\[\s\S])*\2/.source, /([a-zA-Z0-9])(?:(?!\3)[^\\]|\\[\s\S])*\3(?:(?!\3)[^\\]|\\[\s\S])*\3/.source, t + /\s*/.source + t].join("|") + ")" + /[msixpodualngcer]*/.source),
        lookbehind: !0,
        greedy: !0
      }, {
        pattern: /\/(?:[^\/\\\r\n]|\\.)*\/[msixpodualngc]*(?=\s*(?:$|[\r\n,.;})&|\-+*~<>!?^]|(?:and|cmp|eq|ge|gt|le|lt|ne|not|or|x|xor)\b))/,
        greedy: !0
      }],
      variable: [/[&*$@%]\{\^[A-Z]+\}/, /[&*$@%]\^[A-Z_]/, /[&*$@%]#?(?=\{)/, /[&*$@%]#?(?:(?:::)*'?(?!\d)[\w$]+(?![\w$]))+(?:::)*/, /[&*$@%]\d+/, /(?!%=)[$@%][!"#$%&'()*+,\-.\/:;<=>?@[\\\]^_`{|}~]/],
      filehandle: {
        pattern: /<(?![<=])\S*?>|\b_\b/,
        alias: "symbol"
      },
      "v-string": {
        pattern: /v\d+(?:\.\d+)*|\d+(?:\.\d+){2,}/,
        alias: "string"
      },
      function: {
        pattern: /(\bsub[ \t]+)\w+/,
        lookbehind: !0
      },
      keyword: /\b(?:any|break|continue|default|delete|die|do|else|elsif|eval|for|foreach|given|goto|if|last|local|my|next|our|package|print|redo|require|return|say|state|sub|switch|undef|unless|until|use|when|while)\b/,
      number: /\b(?:0x[\dA-Fa-f](?:_?[\dA-Fa-f])*|0b[01](?:_?[01])*|(?:(?:\d(?:_?\d)*)?\.)?\d(?:_?\d)*(?:[Ee][+-]?\d+)?)\b/,
      operator: /-[rwxoRWXOezsfdlpSbctugkTBMAC]\b|\+[+=]?|-[-=>]?|\*\*?=?|\/\/?=?|=[=~>]?|~[~=]?|\|\|?=?|&&?=?|<(?:=>?|<=?)?|>>?=?|![~=]?|[%^]=?|\.(?:=|\.\.?)?|[\\?]|\bx(?:=|\b)|\b(?:and|cmp|eq|ge|gt|le|lt|ne|not|or|xor)\b/,
      punctuation: /[{}[\];(),:]/
    };
  }(e);
}

perl.displayName = "perl", perl.aliases = [];
var refractorPhp$1 = php_1,
    phpExtras_1 = phpExtras;

function phpExtras(e) {
  e.register(refractorPhp$1), e.languages.insertBefore("php", "variable", {
    this: {
      pattern: /\$this\b/,
      alias: "keyword"
    },
    global: /\$(?:GLOBALS|HTTP_RAW_POST_DATA|_(?:COOKIE|ENV|FILES|GET|POST|REQUEST|SERVER|SESSION)|argc|argv|http_response_header|php_errormsg)\b/,
    scope: {
      pattern: /\b[\w\\]+::/,
      inside: {
        keyword: /\b(?:parent|self|static)\b/,
        punctuation: /::|\\/
      }
    }
  });
}

phpExtras.displayName = "phpExtras", phpExtras.aliases = [];
var refractorPhp = php_1,
    refractorJavadoclike = javadoclike_1,
    phpdoc_1 = phpdoc;

function phpdoc(e) {
  e.register(refractorPhp), e.register(refractorJavadoclike), function (e) {
    var t = /(?:\b[a-zA-Z]\w*|[|\\[\]])+/.source;
    e.languages.phpdoc = e.languages.extend("javadoclike", {
      parameter: {
        pattern: RegExp("(@(?:global|param|property(?:-read|-write)?|var)\\s+(?:" + t + "\\s+)?)\\$\\w+"),
        lookbehind: !0
      }
    }), e.languages.insertBefore("phpdoc", "keyword", {
      "class-name": [{
        pattern: RegExp("(@(?:global|package|param|property(?:-read|-write)?|return|subpackage|throws|var)\\s+)" + t),
        lookbehind: !0,
        inside: {
          keyword: /\b(?:array|bool|boolean|callback|double|false|float|int|integer|mixed|null|object|resource|self|string|true|void)\b/,
          punctuation: /[|\\[\]()]/
        }
      }]
    }), e.languages.javadoclike.addSupport("php", e.languages.phpdoc);
  }(e);
}

phpdoc.displayName = "phpdoc", phpdoc.aliases = [];
var refractorSql = sql_1,
    plsql_1 = plsql;

function plsql(e) {
  e.register(refractorSql), e.languages.plsql = e.languages.extend("sql", {
    comment: {
      pattern: /\/\*[\s\S]*?\*\/|--.*/,
      greedy: !0
    },
    keyword: /\b(?:A|ACCESSIBLE|ADD|AGENT|AGGREGATE|ALL|ALTER|AND|ANY|ARRAY|AS|ASC|AT|ATTRIBUTE|AUTHID|AVG|BEGIN|BETWEEN|BFILE_BASE|BINARY|BLOB_BASE|BLOCK|BODY|BOTH|BOUND|BULK|BY|BYTE|C|CALL|CALLING|CASCADE|CASE|CHAR|CHARACTER|CHARSET|CHARSETFORM|CHARSETID|CHAR_BASE|CHECK|CLOB_BASE|CLONE|CLOSE|CLUSTER|CLUSTERS|COLAUTH|COLLECT|COLUMNS|COMMENT|COMMIT|COMMITTED|COMPILED|COMPRESS|CONNECT|CONSTANT|CONSTRUCTOR|CONTEXT|CONTINUE|CONVERT|COUNT|CRASH|CREATE|CREDENTIAL|CURRENT|CURSOR|CUSTOMDATUM|DANGLING|DATA|DATE|DATE_BASE|DAY|DECLARE|DEFAULT|DEFINE|DELETE|DESC|DETERMINISTIC|DIRECTORY|DISTINCT|DOUBLE|DROP|DURATION|ELEMENT|ELSE|ELSIF|EMPTY|END|ESCAPE|EXCEPT|EXCEPTION|EXCEPTIONS|EXCLUSIVE|EXECUTE|EXISTS|EXIT|EXTERNAL|FETCH|FINAL|FIRST|FIXED|FLOAT|FOR|FORALL|FORCE|FROM|FUNCTION|GENERAL|GOTO|GRANT|GROUP|HASH|HAVING|HEAP|HIDDEN|HOUR|IDENTIFIED|IF|IMMEDIATE|IMMUTABLE|IN|INCLUDING|INDEX|INDEXES|INDICATOR|INDICES|INFINITE|INSERT|INSTANTIABLE|INT|INTERFACE|INTERSECT|INTERVAL|INTO|INVALIDATE|IS|ISOLATION|JAVA|LANGUAGE|LARGE|LEADING|LENGTH|LEVEL|LIBRARY|LIKE|LIKE2|LIKE4|LIKEC|LIMIT|LIMITED|LOCAL|LOCK|LONG|LOOP|MAP|MAX|MAXLEN|MEMBER|MERGE|MIN|MINUS|MINUTE|MOD|MODE|MODIFY|MONTH|MULTISET|MUTABLE|NAME|NAN|NATIONAL|NATIVE|NCHAR|NEW|NOCOMPRESS|NOCOPY|NOT|NOWAIT|NULL|NUMBER_BASE|OBJECT|OCICOLL|OCIDATE|OCIDATETIME|OCIDURATION|OCIINTERVAL|OCILOBLOCATOR|OCINUMBER|OCIRAW|OCIREF|OCIREFCURSOR|OCIROWID|OCISTRING|OCITYPE|OF|OLD|ON|ONLY|OPAQUE|OPEN|OPERATOR|OPTION|OR|ORACLE|ORADATA|ORDER|ORGANIZATION|ORLANY|ORLVARY|OTHERS|OUT|OVERLAPS|OVERRIDING|PACKAGE|PARALLEL_ENABLE|PARAMETER|PARAMETERS|PARENT|PARTITION|PASCAL|PERSISTABLE|PIPE|PIPELINED|PLUGGABLE|POLYMORPHIC|PRAGMA|PRECISION|PRIOR|PRIVATE|PROCEDURE|PUBLIC|RAISE|RANGE|RAW|READ|RECORD|REF|REFERENCE|RELIES_ON|REM|REMAINDER|RENAME|RESOURCE|RESULT|RESULT_CACHE|RETURN|RETURNING|REVERSE|REVOKE|ROLLBACK|ROW|SAMPLE|SAVE|SAVEPOINT|SB1|SB2|SB4|SECOND|SEGMENT|SELECT|SELF|SEPARATE|SEQUENCE|SERIALIZABLE|SET|SHARE|SHORT|SIZE|SIZE_T|SOME|SPARSE|SQL|SQLCODE|SQLDATA|SQLNAME|SQLSTATE|STANDARD|START|STATIC|STDDEV|STORED|STRING|STRUCT|STYLE|SUBMULTISET|SUBPARTITION|SUBSTITUTABLE|SUBTYPE|SUM|SYNONYM|TABAUTH|TABLE|TDO|THE|THEN|TIME|TIMESTAMP|TIMEZONE_ABBR|TIMEZONE_HOUR|TIMEZONE_MINUTE|TIMEZONE_REGION|TO|TRAILING|TRANSACTION|TRANSACTIONAL|TRUSTED|TYPE|UB1|UB2|UB4|UNDER|UNION|UNIQUE|UNPLUG|UNSIGNED|UNTRUSTED|UPDATE|USE|USING|VALIST|VALUE|VALUES|VARIABLE|VARIANCE|VARRAY|VARYING|VIEW|VIEWS|VOID|WHEN|WHERE|WHILE|WITH|WORK|WRAPPED|WRITE|YEAR|ZONE)\b/i,
    operator: /:=?|=>|[<>^~!]=|\.\.|\|\||\*\*|[-+*/%<>=@]/
  }), e.languages.insertBefore("plsql", "operator", {
    label: {
      pattern: /<<\s*\w+\s*>>/,
      alias: "symbol"
    }
  });
}

plsql.displayName = "plsql", plsql.aliases = [];
var powerquery_1 = powerquery;

function powerquery(e) {
  e.languages.powerquery = {
    comment: {
      pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|\/\/.*)/,
      lookbehind: !0,
      greedy: !0
    },
    "quoted-identifier": {
      pattern: /#"(?:[^"\r\n]|"")*"(?!")/,
      greedy: !0
    },
    string: {
      pattern: /(?:#!)?"(?:[^"\r\n]|"")*"(?!")/,
      greedy: !0
    },
    constant: [/\bDay\.(?:Friday|Monday|Saturday|Sunday|Thursday|Tuesday|Wednesday)\b/, /\bTraceLevel\.(?:Critical|Error|Information|Verbose|Warning)\b/, /\bOccurrence\.(?:All|First|Last)\b/, /\bOrder\.(?:Ascending|Descending)\b/, /\bRoundingMode\.(?:AwayFromZero|Down|ToEven|TowardZero|Up)\b/, /\bMissingField\.(?:Error|Ignore|UseNull)\b/, /\bQuoteStyle\.(?:Csv|None)\b/, /\bJoinKind\.(?:FullOuter|Inner|LeftAnti|LeftOuter|RightAnti|RightOuter)\b/, /\bGroupKind\.(?:Global|Local)\b/, /\bExtraValues\.(?:Error|Ignore|List)\b/, /\bJoinAlgorithm\.(?:Dynamic|LeftHash|LeftIndex|PairwiseHash|RightHash|RightIndex|SortMerge)\b/, /\bJoinSide\.(?:Left|Right)\b/, /\bPrecision\.(?:Decimal|Double)\b/, /\bRelativePosition\.From(?:End|Start)\b/, /\bTextEncoding\.(?:Ascii|BigEndianUnicode|Unicode|Utf16|Utf8|Windows)\b/, /\b(?:Any|Binary|Date|DateTime|DateTimeZone|Duration|Function|Int16|Int32|Int64|Int8|List|Logical|None|Number|Record|Table|Text|Time)\.Type\b/, /\bnull\b/],
    boolean: /\b(?:false|true)\b/,
    keyword: /\b(?:and|as|each|else|error|if|in|is|let|meta|not|nullable|optional|or|otherwise|section|shared|then|try|type)\b|#(?:binary|date|datetime|datetimezone|duration|infinity|nan|sections|shared|table|time)\b/,
    function: {
      pattern: /(^|[^#\w.])[a-z_][\w.]*(?=\s*\()/i,
      lookbehind: !0
    },
    "data-type": {
      pattern: /\b(?:any|anynonnull|binary|date|datetime|datetimezone|duration|function|list|logical|none|number|record|table|text|time)\b/,
      alias: "class-name"
    },
    number: {
      pattern: /\b0x[\da-f]+\b|(?:[+-]?(?:\b\d+\.)?\b\d+|[+-]\.\d+|(^|[^.])\B\.\d+)(?:e[+-]?\d+)?\b/i,
      lookbehind: !0
    },
    operator: /[-+*\/&?@^]|<(?:=>?|>)?|>=?|=>?|\.\.\.?/,
    punctuation: /[,;\[\](){}]/
  }, e.languages.pq = e.languages.powerquery, e.languages.mscript = e.languages.powerquery;
}

powerquery.displayName = "powerquery", powerquery.aliases = [];
var powershell_1 = powershell;

function powershell(e) {
  !function (e) {
    var t = e.languages.powershell = {
      comment: [{
        pattern: /(^|[^`])<#[\s\S]*?#>/,
        lookbehind: !0
      }, {
        pattern: /(^|[^`])#.*/,
        lookbehind: !0
      }],
      string: [{
        pattern: /"(?:`[\s\S]|[^`"])*"/,
        greedy: !0,
        inside: null
      }, {
        pattern: /'(?:[^']|'')*'/,
        greedy: !0
      }],
      namespace: /\[[a-z](?:\[(?:\[[^\]]*\]|[^\[\]])*\]|[^\[\]])*\]/i,
      boolean: /\$(?:false|true)\b/i,
      variable: /\$\w+\b/,
      function: [/\b(?:Add|Approve|Assert|Backup|Block|Checkpoint|Clear|Close|Compare|Complete|Compress|Confirm|Connect|Convert|ConvertFrom|ConvertTo|Copy|Debug|Deny|Disable|Disconnect|Dismount|Edit|Enable|Enter|Exit|Expand|Export|Find|ForEach|Format|Get|Grant|Group|Hide|Import|Initialize|Install|Invoke|Join|Limit|Lock|Measure|Merge|Move|New|Open|Optimize|Out|Ping|Pop|Protect|Publish|Push|Read|Receive|Redo|Register|Remove|Rename|Repair|Request|Reset|Resize|Resolve|Restart|Restore|Resume|Revoke|Save|Search|Select|Send|Set|Show|Skip|Sort|Split|Start|Step|Stop|Submit|Suspend|Switch|Sync|Tee|Test|Trace|Unblock|Undo|Uninstall|Unlock|Unprotect|Unpublish|Unregister|Update|Use|Wait|Watch|Where|Write)-[a-z]+\b/i, /\b(?:ac|cat|chdir|clc|cli|clp|clv|compare|copy|cp|cpi|cpp|cvpa|dbp|del|diff|dir|ebp|echo|epal|epcsv|epsn|erase|fc|fl|ft|fw|gal|gbp|gc|gci|gcs|gdr|gi|gl|gm|gp|gps|group|gsv|gu|gv|gwmi|iex|ii|ipal|ipcsv|ipsn|irm|iwmi|iwr|kill|lp|ls|measure|mi|mount|move|mp|mv|nal|ndr|ni|nv|ogv|popd|ps|pushd|pwd|rbp|rd|rdr|ren|ri|rm|rmdir|rni|rnp|rp|rv|rvpa|rwmi|sal|saps|sasv|sbp|sc|select|set|shcm|si|sl|sleep|sls|sort|sp|spps|spsv|start|sv|swmi|tee|trcm|type|write)\b/i],
      keyword: /\b(?:Begin|Break|Catch|Class|Continue|Data|Define|Do|DynamicParam|Else|ElseIf|End|Exit|Filter|Finally|For|ForEach|From|Function|If|InlineScript|Parallel|Param|Process|Return|Sequence|Switch|Throw|Trap|Try|Until|Using|Var|While|Workflow)\b/i,
      operator: {
        pattern: /(^|\W)(?:!|-(?:b?(?:and|x?or)|as|(?:Not)?(?:Contains|In|Like|Match)|eq|ge|gt|is(?:Not)?|Join|le|lt|ne|not|Replace|sh[lr])\b|-[-=]?|\+[+=]?|[*\/%]=?)/i,
        lookbehind: !0
      },
      punctuation: /[|{}[\];(),.]/
    };
    t.string[0].inside = {
      function: {
        pattern: /(^|[^`])\$\((?:\$\([^\r\n()]*\)|(?!\$\()[^\r\n)])*\)/,
        lookbehind: !0,
        inside: t
      },
      boolean: t.boolean,
      variable: t.variable
    };
  }(e);
}

powershell.displayName = "powershell", powershell.aliases = [];
var processing_1 = processing;

function processing(e) {
  e.languages.processing = e.languages.extend("clike", {
    keyword: /\b(?:break|case|catch|class|continue|default|else|extends|final|for|if|implements|import|new|null|private|public|return|static|super|switch|this|try|void|while)\b/,
    function: /\b\w+(?=\s*\()/,
    operator: /<[<=]?|>[>=]?|&&?|\|\|?|[%?]|[!=+\-*\/]=?/
  }), e.languages.insertBefore("processing", "number", {
    constant: /\b(?!XML\b)[A-Z][A-Z\d_]+\b/,
    type: {
      pattern: /\b(?:boolean|byte|char|color|double|float|int|[A-Z]\w*)\b/,
      alias: "class-name"
    }
  });
}

processing.displayName = "processing", processing.aliases = [];
var prolog_1 = prolog;

function prolog(e) {
  e.languages.prolog = {
    comment: {
      pattern: /\/\*[\s\S]*?\*\/|%.*/,
      greedy: !0
    },
    string: {
      pattern: /(["'])(?:\1\1|\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1(?!\1)/,
      greedy: !0
    },
    builtin: /\b(?:fx|fy|xf[xy]?|yfx?)\b/,
    function: /\b[a-z]\w*(?:(?=\()|\/\d+)/,
    number: /\b\d+(?:\.\d*)?/,
    operator: /[:\\=><\-?*@\/;+^|!$.]+|\b(?:is|mod|not|xor)\b/,
    punctuation: /[(){}\[\],]/
  };
}

prolog.displayName = "prolog", prolog.aliases = [];
var promql_1 = promql;

function promql(e) {
  !function (e) {
    var t = ["on", "ignoring", "group_right", "group_left", "by", "without"],
        r = ["sum", "min", "max", "avg", "group", "stddev", "stdvar", "count", "count_values", "bottomk", "topk", "quantile"].concat(t, ["offset"]);
    e.languages.promql = {
      comment: {
        pattern: /(^[ \t]*)#.*/m,
        lookbehind: !0
      },
      "vector-match": {
        pattern: new RegExp("((?:" + t.join("|") + ")\\s*)\\([^)]*\\)"),
        lookbehind: !0,
        inside: {
          "label-key": {
            pattern: /\b[^,]+\b/,
            alias: "attr-name"
          },
          punctuation: /[(),]/
        }
      },
      "context-labels": {
        pattern: /\{[^{}]*\}/,
        inside: {
          "label-key": {
            pattern: /\b[a-z_]\w*(?=\s*(?:=|![=~]))/,
            alias: "attr-name"
          },
          "label-value": {
            pattern: /(["'`])(?:\\[\s\S]|(?!\1)[^\\])*\1/,
            greedy: !0,
            alias: "attr-value"
          },
          punctuation: /\{|\}|=~?|![=~]|,/
        }
      },
      "context-range": [{
        pattern: /\[[\w\s:]+\]/,
        inside: {
          punctuation: /\[|\]|:/,
          "range-duration": {
            pattern: /\b(?:\d+(?:[smhdwy]|ms))+\b/i,
            alias: "number"
          }
        }
      }, {
        pattern: /(\boffset\s+)\w+/,
        lookbehind: !0,
        inside: {
          "range-duration": {
            pattern: /\b(?:\d+(?:[smhdwy]|ms))+\b/i,
            alias: "number"
          }
        }
      }],
      keyword: new RegExp("\\b(?:" + r.join("|") + ")\\b", "i"),
      function: /\b[a-z_]\w*(?=\s*\()/i,
      number: /[-+]?(?:(?:\b\d+(?:\.\d+)?|\B\.\d+)(?:e[-+]?\d+)?\b|\b(?:0x[0-9a-f]+|nan|inf)\b)/i,
      operator: /[\^*/%+-]|==|!=|<=|<|>=|>|\b(?:and|or|unless)\b/i,
      punctuation: /[{};()`,.[\]]/
    };
  }(e);
}

promql.displayName = "promql", promql.aliases = [];
var properties_1 = properties$1;

function properties$1(e) {
  e.languages.properties = {
    comment: /^[ \t]*[#!].*$/m,
    "attr-value": {
      pattern: /(^[ \t]*(?:\\(?:\r\n|[\s\S])|[^\\\s:=])+(?: *[=:] *(?! )| ))(?:\\(?:\r\n|[\s\S])|[^\\\r\n])+/m,
      lookbehind: !0
    },
    "attr-name": /^[ \t]*(?:\\(?:\r\n|[\s\S])|[^\\\s:=])+(?= *[=:]| )/m,
    punctuation: /[=:]/
  };
}

properties$1.displayName = "properties", properties$1.aliases = [];
var protobuf_1 = protobuf;

function protobuf(e) {
  !function (e) {
    var t = /\b(?:bool|bytes|double|s?fixed(?:32|64)|float|[su]?int(?:32|64)|string)\b/;
    e.languages.protobuf = e.languages.extend("clike", {
      "class-name": [{
        pattern: /(\b(?:enum|extend|message|service)\s+)[A-Za-z_]\w*(?=\s*\{)/,
        lookbehind: !0
      }, {
        pattern: /(\b(?:rpc\s+\w+|returns)\s*\(\s*(?:stream\s+)?)\.?[A-Za-z_]\w*(?:\.[A-Za-z_]\w*)*(?=\s*\))/,
        lookbehind: !0
      }],
      keyword: /\b(?:enum|extend|extensions|import|message|oneof|option|optional|package|public|repeated|required|reserved|returns|rpc(?=\s+\w)|service|stream|syntax|to)\b(?!\s*=\s*\d)/,
      function: /\b[a-z_]\w*(?=\s*\()/i
    }), e.languages.insertBefore("protobuf", "operator", {
      map: {
        pattern: /\bmap<\s*[\w.]+\s*,\s*[\w.]+\s*>(?=\s+[a-z_]\w*\s*[=;])/i,
        alias: "class-name",
        inside: {
          punctuation: /[<>.,]/,
          builtin: t
        }
      },
      builtin: t,
      "positional-class-name": {
        pattern: /(?:\b|\B\.)[a-z_]\w*(?:\.[a-z_]\w*)*(?=\s+[a-z_]\w*\s*[=;])/i,
        alias: "class-name",
        inside: {
          punctuation: /\./
        }
      },
      annotation: {
        pattern: /(\[\s*)[a-z_]\w*(?=\s*=)/i,
        lookbehind: !0
      }
    });
  }(e);
}

protobuf.displayName = "protobuf", protobuf.aliases = [];
var psl_1 = psl;

function psl(e) {
  e.languages.psl = {
    comment: {
      pattern: /#.*/,
      greedy: !0
    },
    string: {
      pattern: /"(?:\\.|[^\\"])*"/,
      greedy: !0,
      inside: {
        symbol: /\\[ntrbA-Z"\\]/
      }
    },
    "heredoc-string": {
      pattern: /<<<([a-zA-Z_]\w*)[\r\n](?:.*[\r\n])*?\1\b/,
      alias: "string",
      greedy: !0
    },
    keyword: /\b(?:__multi|__single|case|default|do|else|elsif|exit|export|for|foreach|function|if|last|line|local|next|requires|return|switch|until|while|word)\b/,
    constant: /\b(?:ALARM|CHART_ADD_GRAPH|CHART_DELETE_GRAPH|CHART_DESTROY|CHART_LOAD|CHART_PRINT|EOF|OFFLINE|OK|PSL_PROF_LOG|R_CHECK_HORIZ|R_CHECK_VERT|R_CLICKER|R_COLUMN|R_FRAME|R_ICON|R_LABEL|R_LABEL_CENTER|R_LIST_MULTIPLE|R_LIST_MULTIPLE_ND|R_LIST_SINGLE|R_LIST_SINGLE_ND|R_MENU|R_POPUP|R_POPUP_SCROLLED|R_RADIO_HORIZ|R_RADIO_VERT|R_ROW|R_SCALE_HORIZ|R_SCALE_VERT|R_SEP_HORIZ|R_SEP_VERT|R_SPINNER|R_TEXT_FIELD|R_TEXT_FIELD_LABEL|R_TOGGLE|TRIM_LEADING|TRIM_LEADING_AND_TRAILING|TRIM_REDUNDANT|TRIM_TRAILING|VOID|WARN)\b/,
    boolean: /\b(?:FALSE|False|NO|No|TRUE|True|YES|Yes|false|no|true|yes)\b/,
    variable: /\b(?:PslDebug|errno|exit_status)\b/,
    builtin: {
      pattern: /\b(?:PslExecute|PslFunctionCall|PslFunctionExists|PslSetOptions|_snmp_debug|acos|add_diary|annotate|annotate_get|ascii_to_ebcdic|asctime|asin|atan|atexit|batch_set|blackout|cat|ceil|chan_exists|change_state|close|code_cvt|cond_signal|cond_wait|console_type|convert_base|convert_date|convert_locale_date|cos|cosh|create|date|dcget_text|destroy|destroy_lock|dget_text|difference|dump_hist|ebcdic_to_ascii|encrypt|event_archive|event_catalog_get|event_check|event_query|event_range_manage|event_range_query|event_report|event_schedule|event_trigger|event_trigger2|execute|exists|exp|fabs|file|floor|fmod|fopen|fseek|ftell|full_discovery|get|get_chan_info|get_ranges|get_text|get_vars|getenv|gethostinfo|getpid|getpname|grep|history|history_get_retention|in_transition|index|int|internal|intersection|is_var|isnumber|join|kill|length|lines|lock|lock_info|log|log10|loge|matchline|msg_check|msg_get_format|msg_get_severity|msg_printf|msg_sprintf|ntharg|nthargf|nthline|nthlinef|num_bytes|num_consoles|pconfig|popen|poplines|pow|print|printf|proc_exists|process|random|read|readln|refresh_parameters|remote_check|remote_close|remote_event_query|remote_event_trigger|remote_file_send|remote_open|remove|replace|rindex|sec_check_priv|sec_store_get|sec_store_set|set|set_alarm_ranges|set_locale|share|sin|sinh|sleep|snmp_agent_config|snmp_agent_start|snmp_agent_stop|snmp_close|snmp_config|snmp_get|snmp_get_next|snmp_h_get|snmp_h_get_next|snmp_h_set|snmp_open|snmp_set|snmp_trap_ignore|snmp_trap_listen|snmp_trap_raise_std_trap|snmp_trap_receive|snmp_trap_register_im|snmp_trap_send|snmp_walk|sopen|sort|splitline|sprintf|sqrt|srandom|str_repeat|strcasecmp|subset|substr|system|tail|tan|tanh|text_domain|time|tmpnam|tolower|toupper|trace_psl_process|trim|union|unique|unlock|unset|va_arg|va_start|write)\b/,
      alias: "builtin-function"
    },
    "foreach-variable": {
      pattern: /(\bforeach\s+(?:(?:\w+\b|"(?:\\.|[^\\"])*")\s+){0,2})[_a-zA-Z]\w*(?=\s*\()/,
      lookbehind: !0,
      greedy: !0
    },
    function: /\b[_a-z]\w*\b(?=\s*\()/i,
    number: /\b(?:0x[0-9a-f]+|\d+(?:\.\d+)?)\b/i,
    operator: /--|\+\+|&&=?|\|\|=?|<<=?|>>=?|[=!]~|[-+*/%&|^!=<>]=?|\.|[:?]/,
    punctuation: /[(){}\[\];,]/
  };
}

psl.displayName = "psl", psl.aliases = [];
var pug_1 = pug;

function pug(e) {
  !function (e) {
    e.languages.pug = {
      comment: {
        pattern: /(^([\t ]*))\/\/.*(?:(?:\r?\n|\r)\2[\t ].+)*/m,
        lookbehind: !0
      },
      "multiline-script": {
        pattern: /(^([\t ]*)script\b.*\.[\t ]*)(?:(?:\r?\n|\r(?!\n))(?:\2[\t ].+|\s*?(?=\r?\n|\r)))+/m,
        lookbehind: !0,
        inside: e.languages.javascript
      },
      filter: {
        pattern: /(^([\t ]*)):.+(?:(?:\r?\n|\r(?!\n))(?:\2[\t ].+|\s*?(?=\r?\n|\r)))+/m,
        lookbehind: !0,
        inside: {
          "filter-name": {
            pattern: /^:[\w-]+/,
            alias: "variable"
          },
          text: /\S[\s\S]*/
        }
      },
      "multiline-plain-text": {
        pattern: /(^([\t ]*)[\w\-#.]+\.[\t ]*)(?:(?:\r?\n|\r(?!\n))(?:\2[\t ].+|\s*?(?=\r?\n|\r)))+/m,
        lookbehind: !0
      },
      markup: {
        pattern: /(^[\t ]*)<.+/m,
        lookbehind: !0,
        inside: e.languages.markup
      },
      doctype: {
        pattern: /((?:^|\n)[\t ]*)doctype(?: .+)?/,
        lookbehind: !0
      },
      "flow-control": {
        pattern: /(^[\t ]*)(?:case|default|each|else|if|unless|when|while)\b(?: .+)?/m,
        lookbehind: !0,
        inside: {
          each: {
            pattern: /^each .+? in\b/,
            inside: {
              keyword: /\b(?:each|in)\b/,
              punctuation: /,/
            }
          },
          branch: {
            pattern: /^(?:case|default|else|if|unless|when|while)\b/,
            alias: "keyword"
          },
          rest: e.languages.javascript
        }
      },
      keyword: {
        pattern: /(^[\t ]*)(?:append|block|extends|include|prepend)\b.+/m,
        lookbehind: !0
      },
      mixin: [{
        pattern: /(^[\t ]*)mixin .+/m,
        lookbehind: !0,
        inside: {
          keyword: /^mixin/,
          function: /\w+(?=\s*\(|\s*$)/,
          punctuation: /[(),.]/
        }
      }, {
        pattern: /(^[\t ]*)\+.+/m,
        lookbehind: !0,
        inside: {
          name: {
            pattern: /^\+\w+/,
            alias: "function"
          },
          rest: e.languages.javascript
        }
      }],
      script: {
        pattern: /(^[\t ]*script(?:(?:&[^(]+)?\([^)]+\))*[\t ]).+/m,
        lookbehind: !0,
        inside: e.languages.javascript
      },
      "plain-text": {
        pattern: /(^[\t ]*(?!-)[\w\-#.]*[\w\-](?:(?:&[^(]+)?\([^)]+\))*\/?[\t ]).+/m,
        lookbehind: !0
      },
      tag: {
        pattern: /(^[\t ]*)(?!-)[\w\-#.]*[\w\-](?:(?:&[^(]+)?\([^)]+\))*\/?:?/m,
        lookbehind: !0,
        inside: {
          attributes: [{
            pattern: /&[^(]+\([^)]+\)/,
            inside: e.languages.javascript
          }, {
            pattern: /\([^)]+\)/,
            inside: {
              "attr-value": {
                pattern: /(=\s*(?!\s))(?:\{[^}]*\}|[^,)\r\n]+)/,
                lookbehind: !0,
                inside: e.languages.javascript
              },
              "attr-name": /[\w-]+(?=\s*!?=|\s*[,)])/,
              punctuation: /[!=(),]+/
            }
          }],
          punctuation: /:/,
          "attr-id": /#[\w\-]+/,
          "attr-class": /\.[\w\-]+/
        }
      },
      code: [{
        pattern: /(^[\t ]*(?:-|!?=)).+/m,
        lookbehind: !0,
        inside: e.languages.javascript
      }],
      punctuation: /[.\-!=|]+/
    };

    for (var t = /(^([\t ]*)):<filter_name>(?:(?:\r?\n|\r(?!\n))(?:\2[\t ].+|\s*?(?=\r?\n|\r)))+/.source, r = [{
      filter: "atpl",
      language: "twig"
    }, {
      filter: "coffee",
      language: "coffeescript"
    }, "ejs", "handlebars", "less", "livescript", "markdown", {
      filter: "sass",
      language: "scss"
    }, "stylus"], n = {}, a = 0, o = r.length; a < o; a++) {
      var i = r[a];
      i = "string" == typeof i ? {
        filter: i,
        language: i
      } : i, e.languages[i.language] && (n["filter-" + i.filter] = {
        pattern: RegExp(t.replace("<filter_name>", function () {
          return i.filter;
        }), "m"),
        lookbehind: !0,
        inside: {
          "filter-name": {
            pattern: /^:[\w-]+/,
            alias: "variable"
          },
          text: {
            pattern: /\S[\s\S]*/,
            alias: [i.language, "language-" + i.language],
            inside: e.languages[i.language]
          }
        }
      });
    }

    e.languages.insertBefore("pug", "filter", n);
  }(e);
}

pug.displayName = "pug", pug.aliases = [];
var puppet_1 = puppet;

function puppet(e) {
  !function (e) {
    e.languages.puppet = {
      heredoc: [{
        pattern: /(@\("([^"\r\n\/):]+)"(?:\/[nrts$uL]*)?\).*(?:\r?\n|\r))(?:.*(?:\r?\n|\r(?!\n)))*?[ \t]*(?:\|[ \t]*)?(?:-[ \t]*)?\2/,
        lookbehind: !0,
        alias: "string",
        inside: {
          punctuation: /(?=\S).*\S(?= *$)/
        }
      }, {
        pattern: /(@\(([^"\r\n\/):]+)(?:\/[nrts$uL]*)?\).*(?:\r?\n|\r))(?:.*(?:\r?\n|\r(?!\n)))*?[ \t]*(?:\|[ \t]*)?(?:-[ \t]*)?\2/,
        lookbehind: !0,
        greedy: !0,
        alias: "string",
        inside: {
          punctuation: /(?=\S).*\S(?= *$)/
        }
      }, {
        pattern: /@\("?(?:[^"\r\n\/):]+)"?(?:\/[nrts$uL]*)?\)/,
        alias: "string",
        inside: {
          punctuation: {
            pattern: /(\().+?(?=\))/,
            lookbehind: !0
          }
        }
      }],
      "multiline-comment": {
        pattern: /(^|[^\\])\/\*[\s\S]*?\*\//,
        lookbehind: !0,
        greedy: !0,
        alias: "comment"
      },
      regex: {
        pattern: /((?:\bnode\s+|[~=\(\[\{,]\s*|[=+]>\s*|^\s*))\/(?:[^\/\\]|\\[\s\S])+\/(?:[imx]+\b|\B)/,
        lookbehind: !0,
        greedy: !0,
        inside: {
          "extended-regex": {
            pattern: /^\/(?:[^\/\\]|\\[\s\S])+\/[im]*x[im]*$/,
            inside: {
              comment: /#.*/
            }
          }
        }
      },
      comment: {
        pattern: /(^|[^\\])#.*/,
        lookbehind: !0,
        greedy: !0
      },
      string: {
        pattern: /(["'])(?:\$\{(?:[^'"}]|(["'])(?:(?!\2)[^\\]|\\[\s\S])*\2)+\}|\$(?!\{)|(?!\1)[^\\$]|\\[\s\S])*\1/,
        greedy: !0,
        inside: {
          "double-quoted": {
            pattern: /^"[\s\S]*"$/,
            inside: {}
          }
        }
      },
      variable: {
        pattern: /\$(?:::)?\w+(?:::\w+)*/,
        inside: {
          punctuation: /::/
        }
      },
      "attr-name": /(?:\b\w+|\*)(?=\s*=>)/,
      function: [{
        pattern: /(\.)(?!\d)\w+/,
        lookbehind: !0
      }, /\b(?:contain|debug|err|fail|include|info|notice|realize|require|tag|warning)\b|\b(?!\d)\w+(?=\()/],
      number: /\b(?:0x[a-f\d]+|\d+(?:\.\d+)?(?:e-?\d+)?)\b/i,
      boolean: /\b(?:false|true)\b/,
      keyword: /\b(?:application|attr|case|class|consumes|default|define|else|elsif|function|if|import|inherits|node|private|produces|type|undef|unless)\b/,
      datatype: {
        pattern: /\b(?:Any|Array|Boolean|Callable|Catalogentry|Class|Collection|Data|Default|Enum|Float|Hash|Integer|NotUndef|Numeric|Optional|Pattern|Regexp|Resource|Runtime|Scalar|String|Struct|Tuple|Type|Undef|Variant)\b/,
        alias: "symbol"
      },
      operator: /=[=~>]?|![=~]?|<(?:<\|?|[=~|-])?|>[>=]?|->?|~>|\|>?>?|[*\/%+?]|\b(?:and|in|or)\b/,
      punctuation: /[\[\]{}().,;]|:+/
    };
    var t = [{
      pattern: /(^|[^\\])\$\{(?:[^'"{}]|\{[^}]*\}|(["'])(?:(?!\2)[^\\]|\\[\s\S])*\2)+\}/,
      lookbehind: !0,
      inside: {
        "short-variable": {
          pattern: /(^\$\{)(?!\w+\()(?:::)?\w+(?:::\w+)*/,
          lookbehind: !0,
          alias: "variable",
          inside: {
            punctuation: /::/
          }
        },
        delimiter: {
          pattern: /^\$/,
          alias: "variable"
        },
        rest: e.languages.puppet
      }
    }, {
      pattern: /(^|[^\\])\$(?:::)?\w+(?:::\w+)*/,
      lookbehind: !0,
      alias: "variable",
      inside: {
        punctuation: /::/
      }
    }];
    e.languages.puppet.heredoc[0].inside.interpolation = t, e.languages.puppet.string.inside["double-quoted"].inside.interpolation = t;
  }(e);
}

puppet.displayName = "puppet", puppet.aliases = [];
var pure_1 = pure;

function pure(e) {
  !function (e) {
    e.languages.pure = {
      comment: [{
        pattern: /(^|[^\\])\/\*[\s\S]*?\*\//,
        lookbehind: !0
      }, {
        pattern: /(^|[^\\:])\/\/.*/,
        lookbehind: !0
      }, /#!.+/],
      "inline-lang": {
        pattern: /%<[\s\S]+?%>/,
        greedy: !0,
        inside: {
          lang: {
            pattern: /(^%< *)-\*-.+?-\*-/,
            lookbehind: !0,
            alias: "comment"
          },
          delimiter: {
            pattern: /^%<.*|%>$/,
            alias: "punctuation"
          }
        }
      },
      string: {
        pattern: /"(?:\\.|[^"\\\r\n])*"/,
        greedy: !0
      },
      number: {
        pattern: /((?:\.\.)?)(?:\b(?:inf|nan)\b|\b0x[\da-f]+|(?:\b(?:0b)?\d+(?:\.\d+)?|\B\.\d+)(?:e[+-]?\d+)?L?)/i,
        lookbehind: !0
      },
      keyword: /\b(?:NULL|ans|break|bt|case|catch|cd|clear|const|def|del|dump|else|end|exit|extern|false|force|help|if|infix[lr]?|interface|let|ls|mem|namespace|nonfix|of|otherwise|outfix|override|postfix|prefix|private|public|pwd|quit|run|save|show|stats|then|throw|trace|true|type|underride|using|when|with)\b/,
      function: /\b(?:abs|add_(?:addr|constdef|(?:fundef|interface|macdef|typedef)(?:_at)?|vardef)|all|any|applp?|arity|bigintp?|blob(?:_crc|_size|p)?|boolp?|byte_c?string(?:_pointer)?|byte_(?:matrix|pointer)|calloc|cat|catmap|ceil|char[ps]?|check_ptrtag|chr|clear_sentry|clearsym|closurep?|cmatrixp?|cols?|colcat(?:map)?|colmap|colrev|colvector(?:p|seq)?|complex(?:_float_(?:matrix|pointer)|_matrix(?:_view)?|_pointer|p)?|conj|cookedp?|cst|cstring(?:_(?:dup|list|vector))?|curry3?|cyclen?|del_(?:constdef|fundef|interface|macdef|typedef|vardef)|delete|diag(?:mat)?|dim|dmatrixp?|do|double(?:_matrix(?:_view)?|_pointer|p)?|dowith3?|drop|dropwhile|eval(?:cmd)?|exactp|filter|fix|fixity|flip|float(?:_matrix|_pointer)|floor|fold[lr]1?|frac|free|funp?|functionp?|gcd|get(?:_(?:byte|constdef|double|float|fundef|int(?:64)?|interface(?:_typedef)?|long|macdef|pointer|ptrtag|sentry|short|string|typedef|vardef))?|globsym|hash|head|id|im|imatrixp?|index|inexactp|infp|init|insert|int(?:_matrix(?:_view)?|_pointer|p)?|int64_(?:matrix|pointer)|integerp?|iteraten?|iterwhile|join|keys?|lambdap?|last(?:err(?:pos)?)?|lcd|list[2p]?|listmap|make_ptrtag|malloc|map|matcat|matrixp?|max|member|min|nanp|nargs|nmatrixp?|null|numberp?|ord|pack(?:ed)?|pointer(?:_cast|_tag|_type|p)?|pow|pred|ptrtag|put(?:_(?:byte|double|float|int(?:64)?|long|pointer|short|string))?|rationalp?|re|realp?|realloc|recordp?|redim|reduce(?:_with)?|refp?|repeatn?|reverse|rlistp?|round|rows?|rowcat(?:map)?|rowmap|rowrev|rowvector(?:p|seq)?|same|scan[lr]1?|sentry|sgn|short_(?:matrix|pointer)|slice|smatrixp?|sort|split|str|strcat|stream|stride|string(?:_(?:dup|list|vector)|p)?|subdiag(?:mat)?|submat|subseq2?|substr|succ|supdiag(?:mat)?|symbolp?|tail|take|takewhile|thunkp?|transpose|trunc|tuplep?|typep|ubyte|uint(?:64)?|ulong|uncurry3?|unref|unzip3?|update|ushort|vals?|varp?|vector(?:p|seq)?|void|zip3?|zipwith3?)\b/,
      special: {
        pattern: /\b__[a-z]+__\b/i,
        alias: "builtin"
      },
      operator: /(?:[!"#$%&'*+,\-.\/:<=>?@\\^`|~\u00a1-\u00bf\u00d7-\u00f7\u20d0-\u2bff]|\b_+\b)+|\b(?:and|div|mod|not|or)\b/,
      punctuation: /[(){}\[\];,|]/
    };
    var t = /%< *-\*- *<lang>\d* *-\*-[\s\S]+?%>/.source;
    ["c", {
      lang: "c++",
      alias: "cpp"
    }, "fortran"].forEach(function (r) {
      var n = r;

      if ("string" != typeof r && (n = r.alias, r = r.lang), e.languages[n]) {
        var a = {};
        a["inline-lang-" + n] = {
          pattern: RegExp(t.replace("<lang>", r.replace(/([.+*?\/\\(){}\[\]])/g, "\\$1")), "i"),
          inside: e.util.clone(e.languages.pure["inline-lang"].inside)
        }, a["inline-lang-" + n].inside.rest = e.util.clone(e.languages[n]), e.languages.insertBefore("pure", "inline-lang", a);
      }
    }), e.languages.c && (e.languages.pure["inline-lang"].inside.rest = e.util.clone(e.languages.c));
  }(e);
}

pure.displayName = "pure", pure.aliases = [];
var purebasic_1 = purebasic;

function purebasic(e) {
  e.languages.purebasic = e.languages.extend("clike", {
    comment: /;.*/,
    keyword: /\b(?:align|and|as|break|calldebugger|case|compilercase|compilerdefault|compilerelse|compilerelseif|compilerendif|compilerendselect|compilererror|compilerif|compilerselect|continue|data|datasection|debug|debuglevel|declare|declarec|declarecdll|declaredll|declaremodule|default|define|dim|disableasm|disabledebugger|disableexplicit|else|elseif|enableasm|enabledebugger|enableexplicit|end|enddatasection|enddeclaremodule|endenumeration|endif|endimport|endinterface|endmacro|endmodule|endprocedure|endselect|endstructure|endstructureunion|endwith|enumeration|extends|fakereturn|for|foreach|forever|global|gosub|goto|if|import|importc|includebinary|includefile|includepath|interface|macro|module|newlist|newmap|next|not|or|procedure|procedurec|procedurecdll|proceduredll|procedurereturn|protected|prototype|prototypec|read|redim|repeat|restore|return|runtime|select|shared|static|step|structure|structureunion|swap|threaded|to|until|wend|while|with|xincludefile|xor)\b/i,
    function: /\b\w+(?:\.\w+)?\s*(?=\()/,
    number: /(?:\$[\da-f]+|\b-?(?:\d+(?:\.\d+)?|\.\d+)(?:e[+-]?\d+)?)\b/i,
    operator: /(?:@\*?|\?|\*)\w+|-[>-]?|\+\+?|!=?|<<?=?|>>?=?|==?|&&?|\|?\||[~^%?*/@]/
  }), e.languages.insertBefore("purebasic", "keyword", {
    tag: /#\w+\$?/,
    asm: {
      pattern: /(^[\t ]*)!.*/m,
      lookbehind: !0,
      alias: "tag",
      inside: {
        comment: /;.*/,
        string: {
          pattern: /(["'`])(?:\\.|(?!\1)[^\\\r\n])*\1/,
          greedy: !0
        },
        "label-reference-anonymous": {
          pattern: /(!\s*j[a-z]+\s+)@[fb]/i,
          lookbehind: !0,
          alias: "fasm-label"
        },
        "label-reference-addressed": {
          pattern: /(!\s*j[a-z]+\s+)[A-Z._?$@][\w.?$@~#]*/i,
          lookbehind: !0,
          alias: "fasm-label"
        },
        keyword: [/\b(?:extern|global)\b[^;\r\n]*/i, /\b(?:CPU|DEFAULT|FLOAT)\b.*/],
        function: {
          pattern: /^([\t ]*!\s*)[\da-z]+(?=\s|$)/im,
          lookbehind: !0
        },
        "function-inline": {
          pattern: /(:\s*)[\da-z]+(?=\s)/i,
          lookbehind: !0,
          alias: "function"
        },
        label: {
          pattern: /^([\t ]*!\s*)[A-Za-z._?$@][\w.?$@~#]*(?=:)/m,
          lookbehind: !0,
          alias: "fasm-label"
        },
        register: /\b(?:st\d|[xyz]mm\d\d?|[cdt]r\d|r\d\d?[bwd]?|[er]?[abcd]x|[abcd][hl]|[er]?(?:bp|di|si|sp)|[cdefgs]s|mm\d+)\b/i,
        number: /(?:\b|-|(?=\$))(?:0[hx](?:[\da-f]*\.)?[\da-f]+(?:p[+-]?\d+)?|\d[\da-f]+[hx]|\$\d[\da-f]*|0[oq][0-7]+|[0-7]+[oq]|0[by][01]+|[01]+[by]|0[dt]\d+|(?:\d+(?:\.\d+)?|\.\d+)(?:\.?e[+-]?\d+)?[dt]?)\b/i,
        operator: /[\[\]*+\-/%<>=&|$!,.:]/
      }
    }
  }), delete e.languages.purebasic["class-name"], delete e.languages.purebasic.boolean, e.languages.pbfasm = e.languages.purebasic;
}

purebasic.displayName = "purebasic", purebasic.aliases = [];
var refractorHaskell = haskell_1,
    purescript_1 = purescript;

function purescript(e) {
  e.register(refractorHaskell), e.languages.purescript = e.languages.extend("haskell", {
    keyword: /\b(?:ado|case|class|data|derive|do|else|forall|if|in|infixl|infixr|instance|let|module|newtype|of|primitive|then|type|where)\b|∀/,
    "import-statement": {
      pattern: /(^[\t ]*)import\s+[A-Z][\w']*(?:\.[A-Z][\w']*)*(?:\s+as\s+[A-Z][\w']*(?:\.[A-Z][\w']*)*)?(?:\s+hiding\b)?/m,
      lookbehind: !0,
      inside: {
        keyword: /\b(?:as|hiding|import)\b/,
        punctuation: /\./
      }
    },
    builtin: /\b(?:absurd|add|ap|append|apply|between|bind|bottom|clamp|compare|comparing|compose|conj|const|degree|discard|disj|div|eq|flap|flip|gcd|identity|ifM|join|lcm|liftA1|liftM1|map|max|mempty|min|mod|mul|negate|not|notEq|one|otherwise|recip|show|sub|top|unit|unless|unlessM|void|when|whenM|zero)\b/,
    operator: [e.languages.haskell.operator[0], e.languages.haskell.operator[2], /[\xa2-\xa6\xa8\xa9\xac\xae-\xb1\xb4\xb8\xd7\xf7\u02c2-\u02c5\u02d2-\u02df\u02e5-\u02eb\u02ed\u02ef-\u02ff\u0375\u0384\u0385\u03f6\u0482\u058d-\u058f\u0606-\u0608\u060b\u060e\u060f\u06de\u06e9\u06fd\u06fe\u07f6\u07fe\u07ff\u09f2\u09f3\u09fa\u09fb\u0af1\u0b70\u0bf3-\u0bfa\u0c7f\u0d4f\u0d79\u0e3f\u0f01-\u0f03\u0f13\u0f15-\u0f17\u0f1a-\u0f1f\u0f34\u0f36\u0f38\u0fbe-\u0fc5\u0fc7-\u0fcc\u0fce\u0fcf\u0fd5-\u0fd8\u109e\u109f\u1390-\u1399\u166d\u17db\u1940\u19de-\u19ff\u1b61-\u1b6a\u1b74-\u1b7c\u1fbd\u1fbf-\u1fc1\u1fcd-\u1fcf\u1fdd-\u1fdf\u1fed-\u1fef\u1ffd\u1ffe\u2044\u2052\u207a-\u207c\u208a-\u208c\u20a0-\u20bf\u2100\u2101\u2103-\u2106\u2108\u2109\u2114\u2116-\u2118\u211e-\u2123\u2125\u2127\u2129\u212e\u213a\u213b\u2140-\u2144\u214a-\u214d\u214f\u218a\u218b\u2190-\u2307\u230c-\u2328\u232b-\u2426\u2440-\u244a\u249c-\u24e9\u2500-\u2767\u2794-\u27c4\u27c7-\u27e5\u27f0-\u2982\u2999-\u29d7\u29dc-\u29fb\u29fe-\u2b73\u2b76-\u2b95\u2b97-\u2bff\u2ce5-\u2cea\u2e50\u2e51\u2e80-\u2e99\u2e9b-\u2ef3\u2f00-\u2fd5\u2ff0-\u2ffb\u3004\u3012\u3013\u3020\u3036\u3037\u303e\u303f\u309b\u309c\u3190\u3191\u3196-\u319f\u31c0-\u31e3\u3200-\u321e\u322a-\u3247\u3250\u3260-\u327f\u328a-\u32b0\u32c0-\u33ff\u4dc0-\u4dff\ua490-\ua4c6\ua700-\ua716\ua720\ua721\ua789\ua78a\ua828-\ua82b\ua836-\ua839\uaa77-\uaa79\uab5b\uab6a\uab6b\ufb29\ufbb2-\ufbc1\ufdfc\ufdfd\ufe62\ufe64-\ufe66\ufe69\uff04\uff0b\uff1c-\uff1e\uff3e\uff40\uff5c\uff5e\uffe0-\uffe6\uffe8-\uffee\ufffc\ufffd]/]
  }), e.languages.purs = e.languages.purescript;
}

purescript.displayName = "purescript", purescript.aliases = ["purs"];
var python_1 = python;

function python(e) {
  e.languages.python = {
    comment: {
      pattern: /(^|[^\\])#.*/,
      lookbehind: !0,
      greedy: !0
    },
    "string-interpolation": {
      pattern: /(?:f|fr|rf)(?:("""|''')[\s\S]*?\1|("|')(?:\\.|(?!\2)[^\\\r\n])*\2)/i,
      greedy: !0,
      inside: {
        interpolation: {
          pattern: /((?:^|[^{])(?:\{\{)*)\{(?!\{)(?:[^{}]|\{(?!\{)(?:[^{}]|\{(?!\{)(?:[^{}])+\})+\})+\}/,
          lookbehind: !0,
          inside: {
            "format-spec": {
              pattern: /(:)[^:(){}]+(?=\}$)/,
              lookbehind: !0
            },
            "conversion-option": {
              pattern: /![sra](?=[:}]$)/,
              alias: "punctuation"
            },
            rest: null
          }
        },
        string: /[\s\S]+/
      }
    },
    "triple-quoted-string": {
      pattern: /(?:[rub]|br|rb)?("""|''')[\s\S]*?\1/i,
      greedy: !0,
      alias: "string"
    },
    string: {
      pattern: /(?:[rub]|br|rb)?("|')(?:\\.|(?!\1)[^\\\r\n])*\1/i,
      greedy: !0
    },
    function: {
      pattern: /((?:^|\s)def[ \t]+)[a-zA-Z_]\w*(?=\s*\()/g,
      lookbehind: !0
    },
    "class-name": {
      pattern: /(\bclass\s+)\w+/i,
      lookbehind: !0
    },
    decorator: {
      pattern: /(^[\t ]*)@\w+(?:\.\w+)*/m,
      lookbehind: !0,
      alias: ["annotation", "punctuation"],
      inside: {
        punctuation: /\./
      }
    },
    keyword: /\b(?:_(?=\s*:)|and|as|assert|async|await|break|case|class|continue|def|del|elif|else|except|exec|finally|for|from|global|if|import|in|is|lambda|match|nonlocal|not|or|pass|print|raise|return|try|while|with|yield)\b/,
    builtin: /\b(?:__import__|abs|all|any|apply|ascii|basestring|bin|bool|buffer|bytearray|bytes|callable|chr|classmethod|cmp|coerce|compile|complex|delattr|dict|dir|divmod|enumerate|eval|execfile|file|filter|float|format|frozenset|getattr|globals|hasattr|hash|help|hex|id|input|int|intern|isinstance|issubclass|iter|len|list|locals|long|map|max|memoryview|min|next|object|oct|open|ord|pow|property|range|raw_input|reduce|reload|repr|reversed|round|set|setattr|slice|sorted|staticmethod|str|sum|super|tuple|type|unichr|unicode|vars|xrange|zip)\b/,
    boolean: /\b(?:False|None|True)\b/,
    number: /\b0(?:b(?:_?[01])+|o(?:_?[0-7])+|x(?:_?[a-f0-9])+)\b|(?:\b\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\B\.\d+(?:_\d+)*)(?:e[+-]?\d+(?:_\d+)*)?j?(?!\w)/i,
    operator: /[-+%=]=?|!=|:=|\*\*?=?|\/\/?=?|<[<=>]?|>[=>]?|[&|^~]/,
    punctuation: /[{}[\];(),.:]/
  }, e.languages.python["string-interpolation"].inside.interpolation.inside.rest = e.languages.python, e.languages.py = e.languages.python;
}

python.displayName = "python", python.aliases = ["py"];
var q_1 = q$1;

function q$1(e) {
  e.languages.q = {
    string: /"(?:\\.|[^"\\\r\n])*"/,
    comment: [{
      pattern: /([\t )\]}])\/.*/,
      lookbehind: !0,
      greedy: !0
    }, {
      pattern: /(^|\r?\n|\r)\/[\t ]*(?:(?:\r?\n|\r)(?:.*(?:\r?\n|\r(?!\n)))*?(?:\\(?=[\t ]*(?:\r?\n|\r))|$)|\S.*)/,
      lookbehind: !0,
      greedy: !0
    }, {
      pattern: /^\\[\t ]*(?:\r?\n|\r)[\s\S]+/m,
      greedy: !0
    }, {
      pattern: /^#!.+/m,
      greedy: !0
    }],
    symbol: /`(?::\S+|[\w.]*)/,
    datetime: {
      pattern: /0N[mdzuvt]|0W[dtz]|\d{4}\.\d\d(?:m|\.\d\d(?:T(?:\d\d(?::\d\d(?::\d\d(?:[.:]\d\d\d)?)?)?)?)?[dz]?)|\d\d:\d\d(?::\d\d(?:[.:]\d\d\d)?)?[uvt]?/,
      alias: "number"
    },
    number: /\b(?![01]:)(?:0N[hje]?|0W[hj]?|0[wn]|0x[\da-fA-F]+|\d+(?:\.\d*)?(?:e[+-]?\d+)?[hjfeb]?)/,
    keyword: /\\\w+\b|\b(?:abs|acos|aj0?|all|and|any|asc|asin|asof|atan|attr|avgs?|binr?|by|ceiling|cols|cor|cos|count|cov|cross|csv|cut|delete|deltas|desc|dev|differ|distinct|div|do|dsave|ej|enlist|eval|except|exec|exit|exp|fby|fills|first|fkeys|flip|floor|from|get|getenv|group|gtime|hclose|hcount|hdel|hopen|hsym|iasc|identity|idesc|if|ij|in|insert|inter|inv|keys?|last|like|list|ljf?|load|log|lower|lsq|ltime|ltrim|mavg|maxs?|mcount|md5|mdev|med|meta|mins?|mmax|mmin|mmu|mod|msum|neg|next|not|null|or|over|parse|peach|pj|plist|prds?|prev|prior|rand|rank|ratios|raze|read0|read1|reciprocal|reval|reverse|rload|rotate|rsave|rtrim|save|scan|scov|sdev|select|set|setenv|show|signum|sin|sqrt|ssr?|string|sublist|sums?|sv|svar|system|tables|tan|til|trim|txf|type|uj|ungroup|union|update|upper|upsert|value|var|views?|vs|wavg|where|while|within|wj1?|wsum|ww|xasc|xbar|xcols?|xdesc|xexp|xgroup|xkey|xlog|xprev|xrank)\b/,
    adverb: {
      pattern: /['\/\\]:?|\beach\b/,
      alias: "function"
    },
    verb: {
      pattern: /(?:\B\.\B|\b[01]:|<[=>]?|>=?|[:+\-*%,!?~=|$&#@^]):?|\b_\b:?/,
      alias: "operator"
    },
    punctuation: /[(){}\[\];.]/
  };
}

q$1.displayName = "q", q$1.aliases = [];
var qml_1 = qml;

function qml(e) {
  !function (e) {
    for (var t = /"(?:\\.|[^\\"\r\n])*"|'(?:\\.|[^\\'\r\n])*'/.source, r = /\/\/.*(?!.)|\/\*(?:[^*]|\*(?!\/))*\*\//.source, n = /(?:[^\\()[\]{}"'/]|<string>|\/(?![*/])|<comment>|\(<expr>*\)|\[<expr>*\]|\{<expr>*\}|\\[\s\S])/.source.replace(/<string>/g, function () {
      return t;
    }).replace(/<comment>/g, function () {
      return r;
    }), a = 0; a < 2; a++) {
      n = n.replace(/<expr>/g, function () {
        return n;
      });
    }

    n = n.replace(/<expr>/g, "[^\\s\\S]"), e.languages.qml = {
      comment: {
        pattern: /\/\/.*|\/\*[\s\S]*?\*\//,
        greedy: !0
      },
      "javascript-function": {
        pattern: RegExp(/((?:^|;)[ \t]*)function\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*\(<js>*\)\s*\{<js>*\}/.source.replace(/<js>/g, function () {
          return n;
        }), "m"),
        lookbehind: !0,
        greedy: !0,
        alias: "language-javascript",
        inside: e.languages.javascript
      },
      "class-name": {
        pattern: /((?:^|[:;])[ \t]*)(?!\d)\w+(?=[ \t]*\{|[ \t]+on\b)/m,
        lookbehind: !0
      },
      property: [{
        pattern: /((?:^|[;{])[ \t]*)(?!\d)\w+(?:\.\w+)*(?=[ \t]*:)/m,
        lookbehind: !0
      }, {
        pattern: /((?:^|[;{])[ \t]*)property[ \t]+(?!\d)\w+(?:\.\w+)*[ \t]+(?!\d)\w+(?:\.\w+)*(?=[ \t]*:)/m,
        lookbehind: !0,
        inside: {
          keyword: /^property/,
          property: /\w+(?:\.\w+)*/
        }
      }],
      "javascript-expression": {
        pattern: RegExp(/(:[ \t]*)(?![\s;}[])(?:(?!$|[;}])<js>)+/.source.replace(/<js>/g, function () {
          return n;
        }), "m"),
        lookbehind: !0,
        greedy: !0,
        alias: "language-javascript",
        inside: e.languages.javascript
      },
      string: {
        pattern: /"(?:\\.|[^\\"\r\n])*"/,
        greedy: !0
      },
      keyword: /\b(?:as|import|on)\b/,
      punctuation: /[{}[\]:;,]/
    };
  }(e);
}

qml.displayName = "qml", qml.aliases = [];
var qore_1 = qore;

function qore(e) {
  e.languages.qore = e.languages.extend("clike", {
    comment: {
      pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|(?:\/\/|#).*)/,
      lookbehind: !0
    },
    string: {
      pattern: /("|')(?:\\[\s\S]|(?!\1)[^\\])*\1/,
      greedy: !0
    },
    keyword: /\b(?:abstract|any|assert|binary|bool|boolean|break|byte|case|catch|char|class|code|const|continue|data|default|do|double|else|enum|extends|final|finally|float|for|goto|hash|if|implements|import|inherits|instanceof|int|interface|long|my|native|new|nothing|null|object|our|own|private|reference|rethrow|return|short|soft(?:bool|date|float|int|list|number|string)|static|strictfp|string|sub|super|switch|synchronized|this|throw|throws|transient|try|void|volatile|while)\b/,
    boolean: /\b(?:false|true)\b/i,
    function: /\$?\b(?!\d)\w+(?=\()/,
    number: /\b(?:0b[01]+|0x(?:[\da-f]*\.)?[\da-fp\-]+|(?:\d+(?:\.\d+)?|\.\d+)(?:e\d+)?[df]|(?:\d+(?:\.\d+)?|\.\d+))\b/i,
    operator: {
      pattern: /(^|[^.])(?:\+[+=]?|-[-=]?|[!=](?:==?|~)?|>>?=?|<(?:=>?|<=?)?|&[&=]?|\|[|=]?|[*\/%^]=?|[~?])/,
      lookbehind: !0
    },
    variable: /\$(?!\d)\w+\b/
  });
}

qore.displayName = "qore", qore.aliases = [];
var qsharp_1 = qsharp;

function qsharp(e) {
  !function (e) {
    function t(e, t) {
      return e.replace(/<<(\d+)>>/g, function (e, r) {
        return "(?:" + t[+r] + ")";
      });
    }

    function r(e, r, n) {
      return RegExp(t(e, r), n || "");
    }

    var n = RegExp("\\b(?:" + ("Adj BigInt Bool Ctl Double false Int One Pauli PauliI PauliX PauliY PauliZ Qubit Range Result String true Unit Zero" + " " + "Adjoint adjoint apply as auto body borrow borrowing Controlled controlled distribute elif else fail fixup for function if in internal intrinsic invert is let mutable namespace new newtype open operation repeat return self set until use using while within").trim().replace(/ /g, "|") + ")\\b"),
        a = t(/<<0>>(?:\s*\.\s*<<0>>)*/.source, [/\b[A-Za-z_]\w*\b/.source]),
        o = {
      keyword: n,
      punctuation: /[<>()?,.:[\]]/
    },
        i = /"(?:\\.|[^\\"])*"/.source;
    e.languages.qsharp = e.languages.extend("clike", {
      comment: /\/\/.*/,
      string: [{
        pattern: r(/(^|[^$\\])<<0>>/.source, [i]),
        lookbehind: !0,
        greedy: !0
      }],
      "class-name": [{
        pattern: r(/(\b(?:as|open)\s+)<<0>>(?=\s*(?:;|as\b))/.source, [a]),
        lookbehind: !0,
        inside: o
      }, {
        pattern: r(/(\bnamespace\s+)<<0>>(?=\s*\{)/.source, [a]),
        lookbehind: !0,
        inside: o
      }],
      keyword: n,
      number: /(?:\b0(?:x[\da-f]+|b[01]+|o[0-7]+)|(?:\B\.\d+|\b\d+(?:\.\d*)?)(?:e[-+]?\d+)?)l?\b/i,
      operator: /\band=|\bor=|\band\b|\bnot\b|\bor\b|<[-=]|[-=]>|>>>=?|<<<=?|\^\^\^=?|\|\|\|=?|&&&=?|w\/=?|~~~|[*\/+\-^=!%]=?/,
      punctuation: /::|[{}[\];(),.:]/
    }), e.languages.insertBefore("qsharp", "number", {
      range: {
        pattern: /\.\./,
        alias: "operator"
      }
    });

    var s = function (e, t) {
      for (var r = 0; r < t; r++) {
        e = e.replace(/<<self>>/g, function () {
          return "(?:" + e + ")";
        });
      }

      return e.replace(/<<self>>/g, "[^\\s\\S]");
    }(t(/\{(?:[^"{}]|<<0>>|<<self>>)*\}/.source, [i]), 2);

    e.languages.insertBefore("qsharp", "string", {
      "interpolation-string": {
        pattern: r(/\$"(?:\\.|<<0>>|[^\\"{])*"/.source, [s]),
        greedy: !0,
        inside: {
          interpolation: {
            pattern: r(/((?:^|[^\\])(?:\\\\)*)<<0>>/.source, [s]),
            lookbehind: !0,
            inside: {
              punctuation: /^\{|\}$/,
              expression: {
                pattern: /[\s\S]+/,
                alias: "language-qsharp",
                inside: e.languages.qsharp
              }
            }
          },
          string: /[\s\S]+/
        }
      }
    });
  }(e), e.languages.qs = e.languages.qsharp;
}

qsharp.displayName = "qsharp", qsharp.aliases = ["qs"];
var r_1 = r$1;

function r$1(e) {
  e.languages.r = {
    comment: /#.*/,
    string: {
      pattern: /(['"])(?:\\.|(?!\1)[^\\\r\n])*\1/,
      greedy: !0
    },
    "percent-operator": {
      pattern: /%[^%\s]*%/,
      alias: "operator"
    },
    boolean: /\b(?:FALSE|TRUE)\b/,
    ellipsis: /\.\.(?:\.|\d+)/,
    number: [/\b(?:Inf|NaN)\b/, /(?:\b0x[\dA-Fa-f]+(?:\.\d*)?|\b\d+(?:\.\d*)?|\B\.\d+)(?:[EePp][+-]?\d+)?[iL]?/],
    keyword: /\b(?:NA|NA_character_|NA_complex_|NA_integer_|NA_real_|NULL|break|else|for|function|if|in|next|repeat|while)\b/,
    operator: /->?>?|<(?:=|<?-)?|[>=!]=?|::?|&&?|\|\|?|[+*\/^$@~]/,
    punctuation: /[(){}\[\],;]/
  };
}

r$1.displayName = "r", r$1.aliases = [];
var refractorScheme = scheme_1,
    racket_1 = racket;

function racket(e) {
  e.register(refractorScheme), e.languages.racket = e.languages.extend("scheme", {
    "lambda-parameter": {
      pattern: /([(\[]lambda\s+[(\[])[^()\[\]'\s]+/,
      lookbehind: !0
    }
  }), e.languages.insertBefore("racket", "string", {
    lang: {
      pattern: /^#lang.+/m,
      greedy: !0,
      alias: "keyword"
    }
  }), e.languages.rkt = e.languages.racket;
}

racket.displayName = "racket", racket.aliases = ["rkt"];
var reason_1 = reason;

function reason(e) {
  e.languages.reason = e.languages.extend("clike", {
    string: {
      pattern: /"(?:\\(?:\r\n|[\s\S])|[^\\\r\n"])*"/,
      greedy: !0
    },
    "class-name": /\b[A-Z]\w*/,
    keyword: /\b(?:and|as|assert|begin|class|constraint|do|done|downto|else|end|exception|external|for|fun|function|functor|if|in|include|inherit|initializer|lazy|let|method|module|mutable|new|nonrec|object|of|open|or|private|rec|sig|struct|switch|then|to|try|type|val|virtual|when|while|with)\b/,
    operator: /\.{3}|:[:=]|\|>|->|=(?:==?|>)?|<=?|>=?|[|^?'#!~`]|[+\-*\/]\.?|\b(?:asr|land|lor|lsl|lsr|lxor|mod)\b/
  }), e.languages.insertBefore("reason", "class-name", {
    char: {
      pattern: /'(?:\\x[\da-f]{2}|\\o[0-3][0-7][0-7]|\\\d{3}|\\.|[^'\\\r\n])'/,
      greedy: !0
    },
    constructor: /\b[A-Z]\w*\b(?!\s*\.)/,
    label: {
      pattern: /\b[a-z]\w*(?=::)/,
      alias: "symbol"
    }
  }), delete e.languages.reason.function;
}

reason.displayName = "reason", reason.aliases = [];
var regex_1 = regex;

function regex(e) {
  !function (e) {
    var t = {
      pattern: /\\[\\(){}[\]^$+*?|.]/,
      alias: "escape"
    },
        r = /\\(?:x[\da-fA-F]{2}|u[\da-fA-F]{4}|u\{[\da-fA-F]+\}|0[0-7]{0,2}|[123][0-7]{2}|c[a-zA-Z]|.)/,
        n = "(?:[^\\\\-]|" + r.source + ")",
        a = RegExp(n + "-" + n),
        o = {
      pattern: /(<|')[^<>']+(?=[>']$)/,
      lookbehind: !0,
      alias: "variable"
    };
    e.languages.regex = {
      "char-class": {
        pattern: /((?:^|[^\\])(?:\\\\)*)\[(?:[^\\\]]|\\[\s\S])*\]/,
        lookbehind: !0,
        inside: {
          "char-class-negation": {
            pattern: /(^\[)\^/,
            lookbehind: !0,
            alias: "operator"
          },
          "char-class-punctuation": {
            pattern: /^\[|\]$/,
            alias: "punctuation"
          },
          range: {
            pattern: a,
            inside: {
              escape: r,
              "range-punctuation": {
                pattern: /-/,
                alias: "operator"
              }
            }
          },
          "special-escape": t,
          "char-set": {
            pattern: /\\[wsd]|\\p\{[^{}]+\}/i,
            alias: "class-name"
          },
          escape: r
        }
      },
      "special-escape": t,
      "char-set": {
        pattern: /\.|\\[wsd]|\\p\{[^{}]+\}/i,
        alias: "class-name"
      },
      backreference: [{
        pattern: /\\(?![123][0-7]{2})[1-9]/,
        alias: "keyword"
      }, {
        pattern: /\\k<[^<>']+>/,
        alias: "keyword",
        inside: {
          "group-name": o
        }
      }],
      anchor: {
        pattern: /[$^]|\\[ABbGZz]/,
        alias: "function"
      },
      escape: r,
      group: [{
        pattern: /\((?:\?(?:<[^<>']+>|'[^<>']+'|[>:]|<?[=!]|[idmnsuxU]+(?:-[idmnsuxU]+)?:?))?/,
        alias: "punctuation",
        inside: {
          "group-name": o
        }
      }, {
        pattern: /\)/,
        alias: "punctuation"
      }],
      quantifier: {
        pattern: /(?:[+*?]|\{\d+(?:,\d*)?\})[?+]?/,
        alias: "number"
      },
      alternation: {
        pattern: /\|/,
        alias: "keyword"
      }
    };
  }(e);
}

regex.displayName = "regex", regex.aliases = [];
var rego_1 = rego;

function rego(e) {
  e.languages.rego = {
    comment: /#.*/,
    property: {
      pattern: /(^|[^\\.])(?:"(?:\\.|[^\\"\r\n])*"|`[^`]*`|\b[a-z_]\w*\b)(?=\s*:(?!=))/i,
      lookbehind: !0,
      greedy: !0
    },
    string: {
      pattern: /(^|[^\\])"(?:\\.|[^\\"\r\n])*"|`[^`]*`/,
      lookbehind: !0,
      greedy: !0
    },
    keyword: /\b(?:as|default|else|import|not|null|package|set(?=\s*\()|some|with)\b/,
    boolean: /\b(?:false|true)\b/,
    function: {
      pattern: /\b[a-z_]\w*\b(?:\s*\.\s*\b[a-z_]\w*\b)*(?=\s*\()/i,
      inside: {
        namespace: /\b\w+\b(?=\s*\.)/,
        punctuation: /\./
      }
    },
    number: /-?\b\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i,
    operator: /[-+*/%|&]|[<>:=]=?|!=|\b_\b/,
    punctuation: /[,;.\[\]{}()]/
  };
}

rego.displayName = "rego", rego.aliases = [];
var renpy_1 = renpy;

function renpy(e) {
  e.languages.renpy = {
    comment: {
      pattern: /(^|[^\\])#.+/,
      lookbehind: !0
    },
    string: {
      pattern: /("""|''')[\s\S]+?\1|("|')(?:\\.|(?!\2)[^\\])*\2|(?:^#?(?:(?:[0-9a-fA-F]){3}|[0-9a-fA-F]{6})$)/m,
      greedy: !0
    },
    function: /\b[a-z_]\w*(?=\()/i,
    property: /\b(?:Update|UpdateVersion|action|activate_sound|adv_nvl_transition|after_load_transition|align|alpha|alt|anchor|antialias|area|auto|background|bar_invert|bar_resizing|bar_vertical|black_color|bold|bottom_bar|bottom_gutter|bottom_margin|bottom_padding|box_reverse|box_wrap|can_update|caret|child|color|crop|default_afm_enable|default_afm_time|default_fullscreen|default_text_cps|developer|directory_name|drag_handle|drag_joined|drag_name|drag_raise|draggable|dragged|drop_shadow|drop_shadow_color|droppable|dropped|easein|easeout|edgescroll|end_game_transition|end_splash_transition|enter_replay_transition|enter_sound|enter_transition|enter_yesno_transition|executable_name|exit_replay_transition|exit_sound|exit_transition|exit_yesno_transition|fadein|fadeout|first_indent|first_spacing|fit_first|focus|focus_mask|font|foreground|game_main_transition|get_installed_packages|google_play_key|google_play_salt|ground|has_music|has_sound|has_voice|height|help|hinting|hover|hover_background|hover_color|hover_sound|hovered|hyperlink_functions|idle|idle_color|image_style|include_update|insensitive|insensitive_background|insensitive_color|inside|intra_transition|italic|justify|kerning|keyboard_focus|language|layer_clipping|layers|layout|left_bar|left_gutter|left_margin|left_padding|length|line_leading|line_overlap_split|line_spacing|linear|main_game_transition|main_menu_music|maximum|min_width|minimum|minwidth|modal|mouse|mousewheel|name|narrator_menu|newline_indent|nvl_adv_transition|offset|order_reverse|outlines|overlay_functions|pos|position|prefix|radius|range|rest_indent|right_bar|right_gutter|right_margin|right_padding|rotate|rotate_pad|ruby_style|sample_sound|save_directory|say_attribute_transition|screen_height|screen_width|scrollbars|selected_hover|selected_hover_color|selected_idle|selected_idle_color|selected_insensitive|show_side_image|show_two_window|side_spacing|side_xpos|side_ypos|size|size_group|slow_cps|slow_cps_multiplier|spacing|strikethrough|subpixel|text_align|text_style|text_xpos|text_y_fudge|text_ypos|thumb|thumb_offset|thumb_shadow|thumbnail_height|thumbnail_width|time|top_bar|top_gutter|top_margin|top_padding|translations|underline|unscrollable|update|value|version|version_name|version_tuple|vertical|width|window_hide_transition|window_icon|window_left_padding|window_show_transition|window_title|windows_icon|xadjustment|xalign|xanchor|xanchoraround|xaround|xcenter|xfill|xinitial|xmargin|xmaximum|xminimum|xoffset|xofsset|xpadding|xpos|xsize|xzoom|yadjustment|yalign|yanchor|yanchoraround|yaround|ycenter|yfill|yinitial|ymargin|ymaximum|yminimum|yoffset|ypadding|ypos|ysize|ysizexysize|yzoom|zoom|zorder)\b/,
    tag: /\b(?:bar|block|button|buttoscreenn|drag|draggroup|fixed|frame|grid|[hv]box|hotbar|hotspot|image|imagebutton|imagemap|input|key|label|menu|mm_menu_frame|mousearea|nvl|parallel|screen|self|side|tag|text|textbutton|timer|vbar|viewport|window)\b|\$/,
    keyword: /\b(?:None|add|adjustment|alignaround|allow|angle|animation|around|as|assert|behind|box_layout|break|build|cache|call|center|changed|child_size|choice|circles|class|clear|clicked|clipping|clockwise|config|contains|continue|corner1|corner2|counterclockwise|def|default|define|del|delay|disabled|disabled_text|dissolve|elif|else|event|except|exclude|exec|expression|fade|finally|for|from|function|global|gm_root|has|hide|id|if|import|in|init|is|jump|knot|lambda|left|less_rounded|mm_root|movie|music|null|on|onlayer|pass|pause|persistent|play|print|python|queue|raise|random|renpy|repeat|return|right|rounded_window|scene|scope|set|show|slow|slow_abortable|slow_done|sound|stop|store|style|style_group|substitute|suffix|theme|transform|transform_anchor|transpose|try|ui|unhovered|updater|use|voice|while|widget|widget_hover|widget_selected|widget_text|yield)\b/,
    boolean: /\b(?:[Ff]alse|[Tt]rue)\b/,
    number: /(?:\b(?:0[bo])?(?:(?:\d|0x[\da-f])[\da-f]*(?:\.\d*)?)|\B\.\d+)(?:e[+-]?\d+)?j?/i,
    operator: /[-+%=]=?|!=|\*\*?=?|\/\/?=?|<[<=>]?|>[=>]?|[&|^~]|\b(?:and|at|not|or|with)\b/,
    punctuation: /[{}[\];(),.:]/
  }, e.languages.rpy = e.languages.renpy;
}

renpy.displayName = "renpy", renpy.aliases = ["rpy"];
var rest_1 = rest;

function rest(e) {
  e.languages.rest = {
    table: [{
      pattern: /(^[\t ]*)(?:\+[=-]+)+\+(?:\r?\n|\r)(?:\1[+|].+[+|](?:\r?\n|\r))+\1(?:\+[=-]+)+\+/m,
      lookbehind: !0,
      inside: {
        punctuation: /\||(?:\+[=-]+)+\+/
      }
    }, {
      pattern: /(^[\t ]*)=+ [ =]*=(?:(?:\r?\n|\r)\1.+)+(?:\r?\n|\r)\1=+ [ =]*=(?=(?:\r?\n|\r){2}|\s*$)/m,
      lookbehind: !0,
      inside: {
        punctuation: /[=-]+/
      }
    }],
    "substitution-def": {
      pattern: /(^[\t ]*\.\. )\|(?:[^|\s](?:[^|]*[^|\s])?)\| [^:]+::/m,
      lookbehind: !0,
      inside: {
        substitution: {
          pattern: /^\|(?:[^|\s]|[^|\s][^|]*[^|\s])\|/,
          alias: "attr-value",
          inside: {
            punctuation: /^\||\|$/
          }
        },
        directive: {
          pattern: /( )(?! )[^:]+::/,
          lookbehind: !0,
          alias: "function",
          inside: {
            punctuation: /::$/
          }
        }
      }
    },
    "link-target": [{
      pattern: /(^[\t ]*\.\. )\[[^\]]+\]/m,
      lookbehind: !0,
      alias: "string",
      inside: {
        punctuation: /^\[|\]$/
      }
    }, {
      pattern: /(^[\t ]*\.\. )_(?:`[^`]+`|(?:[^:\\]|\\.)+):/m,
      lookbehind: !0,
      alias: "string",
      inside: {
        punctuation: /^_|:$/
      }
    }],
    directive: {
      pattern: /(^[\t ]*\.\. )[^:]+::/m,
      lookbehind: !0,
      alias: "function",
      inside: {
        punctuation: /::$/
      }
    },
    comment: {
      pattern: /(^[\t ]*\.\.)(?:(?: .+)?(?:(?:\r?\n|\r).+)+| .+)(?=(?:\r?\n|\r){2}|$)/m,
      lookbehind: !0
    },
    title: [{
      pattern: /^(([!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~])\2+)(?:\r?\n|\r).+(?:\r?\n|\r)\1$/m,
      inside: {
        punctuation: /^[!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~]+|[!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~]+$/,
        important: /.+/
      }
    }, {
      pattern: /(^|(?:\r?\n|\r){2}).+(?:\r?\n|\r)([!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~])\2+(?=\r?\n|\r|$)/,
      lookbehind: !0,
      inside: {
        punctuation: /[!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~]+$/,
        important: /.+/
      }
    }],
    hr: {
      pattern: /((?:\r?\n|\r){2})([!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~])\2{3,}(?=(?:\r?\n|\r){2})/,
      lookbehind: !0,
      alias: "punctuation"
    },
    field: {
      pattern: /(^[\t ]*):[^:\r\n]+:(?= )/m,
      lookbehind: !0,
      alias: "attr-name"
    },
    "command-line-option": {
      pattern: /(^[\t ]*)(?:[+-][a-z\d]|(?:--|\/)[a-z\d-]+)(?:[ =](?:[a-z][\w-]*|<[^<>]+>))?(?:, (?:[+-][a-z\d]|(?:--|\/)[a-z\d-]+)(?:[ =](?:[a-z][\w-]*|<[^<>]+>))?)*(?=(?:\r?\n|\r)? {2,}\S)/im,
      lookbehind: !0,
      alias: "symbol"
    },
    "literal-block": {
      pattern: /::(?:\r?\n|\r){2}([ \t]+)(?![ \t]).+(?:(?:\r?\n|\r)\1.+)*/,
      inside: {
        "literal-block-punctuation": {
          pattern: /^::/,
          alias: "punctuation"
        }
      }
    },
    "quoted-literal-block": {
      pattern: /::(?:\r?\n|\r){2}([!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~]).*(?:(?:\r?\n|\r)\1.*)*/,
      inside: {
        "literal-block-punctuation": {
          pattern: /^(?:::|([!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~])\1*)/m,
          alias: "punctuation"
        }
      }
    },
    "list-bullet": {
      pattern: /(^[\t ]*)(?:[*+\-•‣⁃]|\(?(?:\d+|[a-z]|[ivxdclm]+)\)|(?:\d+|[a-z]|[ivxdclm]+)\.)(?= )/im,
      lookbehind: !0,
      alias: "punctuation"
    },
    "doctest-block": {
      pattern: /(^[\t ]*)>>> .+(?:(?:\r?\n|\r).+)*/m,
      lookbehind: !0,
      inside: {
        punctuation: /^>>>/
      }
    },
    inline: [{
      pattern: /(^|[\s\-:\/'"<(\[{])(?::[^:]+:`.*?`|`.*?`:[^:]+:|(\*\*?|``?|\|)(?!\s)(?:(?!\2).)*\S\2(?=[\s\-.,:;!?\\\/'")\]}]|$))/m,
      lookbehind: !0,
      inside: {
        bold: {
          pattern: /(^\*\*).+(?=\*\*$)/,
          lookbehind: !0
        },
        italic: {
          pattern: /(^\*).+(?=\*$)/,
          lookbehind: !0
        },
        "inline-literal": {
          pattern: /(^``).+(?=``$)/,
          lookbehind: !0,
          alias: "symbol"
        },
        role: {
          pattern: /^:[^:]+:|:[^:]+:$/,
          alias: "function",
          inside: {
            punctuation: /^:|:$/
          }
        },
        "interpreted-text": {
          pattern: /(^`).+(?=`$)/,
          lookbehind: !0,
          alias: "attr-value"
        },
        substitution: {
          pattern: /(^\|).+(?=\|$)/,
          lookbehind: !0,
          alias: "attr-value"
        },
        punctuation: /\*\*?|``?|\|/
      }
    }],
    link: [{
      pattern: /\[[^\[\]]+\]_(?=[\s\-.,:;!?\\\/'")\]}]|$)/,
      alias: "string",
      inside: {
        punctuation: /^\[|\]_$/
      }
    }, {
      pattern: /(?:\b[a-z\d]+(?:[_.:+][a-z\d]+)*_?_|`[^`]+`_?_|_`[^`]+`)(?=[\s\-.,:;!?\\\/'")\]}]|$)/i,
      alias: "string",
      inside: {
        punctuation: /^_?`|`$|`?_?_$/
      }
    }],
    punctuation: {
      pattern: /(^[\t ]*)(?:\|(?= |$)|(?:---?|—|\.\.|__)(?= )|\.\.$)/m,
      lookbehind: !0
    }
  };
}

rest.displayName = "rest", rest.aliases = [];
var rip_1 = rip;

function rip(e) {
  e.languages.rip = {
    comment: {
      pattern: /#.*/,
      greedy: !0
    },
    char: {
      pattern: /\B`[^\s`'",.:;#\/\\()<>\[\]{}]\b/,
      greedy: !0
    },
    string: {
      pattern: /("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
      greedy: !0
    },
    regex: {
      pattern: /(^|[^/])\/(?!\/)(?:\[[^\n\r\]]*\]|\\.|[^/\\\r\n\[])+\/(?=\s*(?:$|[\r\n,.;})]))/,
      lookbehind: !0,
      greedy: !0
    },
    keyword: /(?:=>|->)|\b(?:case|catch|class|else|exit|finally|if|raise|return|switch|try)\b/,
    builtin: /@|\bSystem\b/,
    boolean: /\b(?:false|true)\b/,
    date: /\b\d{4}-\d{2}-\d{2}\b/,
    time: /\b\d{2}:\d{2}:\d{2}\b/,
    datetime: /\b\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\b/,
    symbol: /:[^\d\s`'",.:;#\/\\()<>\[\]{}][^\s`'",.:;#\/\\()<>\[\]{}]*/,
    number: /[+-]?\b(?:\d+\.\d+|\d+)\b/,
    punctuation: /(?:\.{2,3})|[`,.:;=\/\\()<>\[\]{}]/,
    reference: /[^\d\s`'",.:;#\/\\()<>\[\]{}][^\s`'",.:;#\/\\()<>\[\]{}]*/
  };
}

rip.displayName = "rip", rip.aliases = [];
var roboconf_1 = roboconf;

function roboconf(e) {
  e.languages.roboconf = {
    comment: /#.*/,
    keyword: {
      pattern: /(^|\s)(?:(?:external|import)\b|(?:facet|instance of)(?=[ \t]+[\w-]+[ \t]*\{))/,
      lookbehind: !0
    },
    component: {
      pattern: /[\w-]+(?=[ \t]*\{)/,
      alias: "variable"
    },
    property: /[\w.-]+(?=[ \t]*:)/,
    value: {
      pattern: /(=[ \t]*(?![ \t]))[^,;]+/,
      lookbehind: !0,
      alias: "attr-value"
    },
    optional: {
      pattern: /\(optional\)/,
      alias: "builtin"
    },
    wildcard: {
      pattern: /(\.)\*/,
      lookbehind: !0,
      alias: "operator"
    },
    punctuation: /[{},.;:=]/
  };
}

roboconf.displayName = "roboconf", roboconf.aliases = [];
var robotframework_1 = robotframework;

function robotframework(e) {
  !function (e) {
    var t = {
      pattern: /(^[ \t]*| {2}|\t)#.*/m,
      lookbehind: !0,
      greedy: !0
    },
        r = {
      pattern: /((?:^|[^\\])(?:\\{2})*)[$@&%]\{(?:[^{}\r\n]|\{[^{}\r\n]*\})*\}/,
      lookbehind: !0,
      inside: {
        punctuation: /^[$@&%]\{|\}$/
      }
    };

    function n(e, n) {
      var a = {
        "section-header": {
          pattern: /^ ?\*{3}.+?\*{3}/,
          alias: "keyword"
        }
      };

      for (var o in n) {
        a[o] = n[o];
      }

      return a.tag = {
        pattern: /([\r\n](?: {2}|\t)[ \t]*)\[[-\w]+\]/,
        lookbehind: !0,
        inside: {
          punctuation: /\[|\]/
        }
      }, a.variable = r, a.comment = t, {
        pattern: RegExp(/^ ?\*{3}[ \t]*<name>[ \t]*\*{3}(?:.|[\r\n](?!\*{3}))*/.source.replace(/<name>/g, function () {
          return e;
        }), "im"),
        alias: "section",
        inside: a
      };
    }

    var a = {
      pattern: /(\[Documentation\](?: {2}|\t)[ \t]*)(?![ \t]|#)(?:.|(?:\r\n?|\n)[ \t]*\.{3})+/,
      lookbehind: !0,
      alias: "string"
    },
        o = {
      pattern: /([\r\n] ?)(?!#)(?:\S(?:[ \t]\S)*)+/,
      lookbehind: !0,
      alias: "function",
      inside: {
        variable: r
      }
    },
        i = {
      pattern: /([\r\n](?: {2}|\t)[ \t]*)(?!\[|\.{3}|#)(?:\S(?:[ \t]\S)*)+/,
      lookbehind: !0,
      inside: {
        variable: r
      }
    };
    e.languages.robotframework = {
      settings: n("Settings", {
        documentation: {
          pattern: /([\r\n] ?Documentation(?: {2}|\t)[ \t]*)(?![ \t]|#)(?:.|(?:\r\n?|\n)[ \t]*\.{3})+/,
          lookbehind: !0,
          alias: "string"
        },
        property: {
          pattern: /([\r\n] ?)(?!\.{3}|#)(?:\S(?:[ \t]\S)*)+/,
          lookbehind: !0
        }
      }),
      variables: n("Variables"),
      "test-cases": n("Test Cases", {
        "test-name": o,
        documentation: a,
        property: i
      }),
      keywords: n("Keywords", {
        "keyword-name": o,
        documentation: a,
        property: i
      }),
      tasks: n("Tasks", {
        "task-name": o,
        documentation: a,
        property: i
      }),
      comment: t
    }, e.languages.robot = e.languages.robotframework;
  }(e);
}

robotframework.displayName = "robotframework", robotframework.aliases = [];
var rust_1 = rust;

function rust(e) {
  !function (e) {
    for (var t = /\/\*(?:[^*/]|\*(?!\/)|\/(?!\*)|<self>)*\*\//.source, r = 0; r < 2; r++) {
      t = t.replace(/<self>/g, function () {
        return t;
      });
    }

    t = t.replace(/<self>/g, function () {
      return /[^\s\S]/.source;
    }), e.languages.rust = {
      comment: [{
        pattern: RegExp(/(^|[^\\])/.source + t),
        lookbehind: !0,
        greedy: !0
      }, {
        pattern: /(^|[^\\:])\/\/.*/,
        lookbehind: !0,
        greedy: !0
      }],
      string: {
        pattern: /b?"(?:\\[\s\S]|[^\\"])*"|b?r(#*)"(?:[^"]|"(?!\1))*"\1/,
        greedy: !0
      },
      char: {
        pattern: /b?'(?:\\(?:x[0-7][\da-fA-F]|u\{(?:[\da-fA-F]_*){1,6}\}|.)|[^\\\r\n\t'])'/,
        greedy: !0
      },
      attribute: {
        pattern: /#!?\[(?:[^\[\]"]|"(?:\\[\s\S]|[^\\"])*")*\]/,
        greedy: !0,
        alias: "attr-name",
        inside: {
          string: null
        }
      },
      "closure-params": {
        pattern: /([=(,:]\s*|\bmove\s*)\|[^|]*\||\|[^|]*\|(?=\s*(?:\{|->))/,
        lookbehind: !0,
        greedy: !0,
        inside: {
          "closure-punctuation": {
            pattern: /^\||\|$/,
            alias: "punctuation"
          },
          rest: null
        }
      },
      "lifetime-annotation": {
        pattern: /'\w+/,
        alias: "symbol"
      },
      "fragment-specifier": {
        pattern: /(\$\w+:)[a-z]+/,
        lookbehind: !0,
        alias: "punctuation"
      },
      variable: /\$\w+/,
      "function-definition": {
        pattern: /(\bfn\s+)\w+/,
        lookbehind: !0,
        alias: "function"
      },
      "type-definition": {
        pattern: /(\b(?:enum|struct|trait|type|union)\s+)\w+/,
        lookbehind: !0,
        alias: "class-name"
      },
      "module-declaration": [{
        pattern: /(\b(?:crate|mod)\s+)[a-z][a-z_\d]*/,
        lookbehind: !0,
        alias: "namespace"
      }, {
        pattern: /(\b(?:crate|self|super)\s*)::\s*[a-z][a-z_\d]*\b(?:\s*::(?:\s*[a-z][a-z_\d]*\s*::)*)?/,
        lookbehind: !0,
        alias: "namespace",
        inside: {
          punctuation: /::/
        }
      }],
      keyword: [/\b(?:Self|abstract|as|async|await|become|box|break|const|continue|crate|do|dyn|else|enum|extern|final|fn|for|if|impl|in|let|loop|macro|match|mod|move|mut|override|priv|pub|ref|return|self|static|struct|super|trait|try|type|typeof|union|unsafe|unsized|use|virtual|where|while|yield)\b/, /\b(?:bool|char|f(?:32|64)|[ui](?:8|16|32|64|128|size)|str)\b/],
      function: /\b[a-z_]\w*(?=\s*(?:::\s*<|\())/,
      macro: {
        pattern: /\b\w+!/,
        alias: "property"
      },
      constant: /\b[A-Z_][A-Z_\d]+\b/,
      "class-name": /\b[A-Z]\w*\b/,
      namespace: {
        pattern: /(?:\b[a-z][a-z_\d]*\s*::\s*)*\b[a-z][a-z_\d]*\s*::(?!\s*<)/,
        inside: {
          punctuation: /::/
        }
      },
      number: /\b(?:0x[\dA-Fa-f](?:_?[\dA-Fa-f])*|0o[0-7](?:_?[0-7])*|0b[01](?:_?[01])*|(?:(?:\d(?:_?\d)*)?\.)?\d(?:_?\d)*(?:[Ee][+-]?\d+)?)(?:_?(?:f32|f64|[iu](?:8|16|32|64|size)?))?\b/,
      boolean: /\b(?:false|true)\b/,
      punctuation: /->|\.\.=|\.{1,3}|::|[{}[\];(),:]/,
      operator: /[-+*\/%!^]=?|=[=>]?|&[&=]?|\|[|=]?|<<?=?|>>?=?|[@?]/
    }, e.languages.rust["closure-params"].inside.rest = e.languages.rust, e.languages.rust.attribute.inside.string = e.languages.rust.string;
  }(e);
}

rust.displayName = "rust", rust.aliases = [];
var sas_1 = sas;

function sas(e) {
  !function (e) {
    var t = /(?:"(?:""|[^"])*"(?!")|'(?:''|[^'])*'(?!'))/.source,
        r = /\b(?:\d[\da-f]*x|\d+(?:\.\d+)?(?:e[+-]?\d+)?)\b/i,
        n = {
      pattern: RegExp(t + "[bx]"),
      alias: "number"
    },
        a = {
      pattern: /&[a-z_]\w*/i
    },
        o = {
      pattern: /((?:^|\s|=|\())%(?:ABORT|BY|CMS|COPY|DISPLAY|DO|ELSE|END|EVAL|GLOBAL|GO|GOTO|IF|INC|INCLUDE|INDEX|INPUT|KTRIM|LENGTH|LET|LIST|LOCAL|PUT|QKTRIM|QSCAN|QSUBSTR|QSYSFUNC|QUPCASE|RETURN|RUN|SCAN|SUBSTR|SUPERQ|SYMDEL|SYMEXIST|SYMGLOBL|SYMLOCAL|SYSCALL|SYSEVALF|SYSEXEC|SYSFUNC|SYSGET|SYSRPUT|THEN|TO|TSO|UNQUOTE|UNTIL|UPCASE|WHILE|WINDOW)\b/i,
      lookbehind: !0,
      alias: "keyword"
    },
        i = {
      pattern: /(^|\s)(?:proc\s+\w+|data(?!=)|quit|run)\b/i,
      alias: "keyword",
      lookbehind: !0
    },
        s = [/\/\*[\s\S]*?\*\//, {
      pattern: /(^[ \t]*|;\s*)\*[^;]*;/m,
      lookbehind: !0
    }],
        l = {
      pattern: RegExp(t),
      greedy: !0
    },
        c = /[$%@.(){}\[\];,\\]/,
        u = {
      pattern: /%?\b\w+(?=\()/,
      alias: "keyword"
    },
        d = {
      function: u,
      "arg-value": {
        pattern: /(=\s*)[A-Z\.]+/i,
        lookbehind: !0
      },
      operator: /=/,
      "macro-variable": a,
      arg: {
        pattern: /[A-Z]+/i,
        alias: "keyword"
      },
      number: r,
      "numeric-constant": n,
      punctuation: c,
      string: l
    },
        p = {
      pattern: /\b(?:format|put)\b=?[\w'$.]+/i,
      inside: {
        keyword: /^(?:format|put)(?==)/i,
        equals: /=/,
        format: {
          pattern: /(?:\w|\$\d)+\.\d?/,
          alias: "number"
        }
      }
    },
        g = {
      pattern: /\b(?:format|put)\s+[\w']+(?:\s+[$.\w]+)+(?=;)/i,
      inside: {
        keyword: /^(?:format|put)/i,
        format: {
          pattern: /[\w$]+\.\d?/,
          alias: "number"
        }
      }
    },
        m = {
      pattern: /((?:^|\s)=?)(?:catname|checkpoint execute_always|dm|endsas|filename|footnote|%include|libname|%list|lock|missing|options|page|resetline|%run|sasfile|skip|sysecho|title\d?)\b/i,
      lookbehind: !0,
      alias: "keyword"
    },
        f = {
      pattern: /(^|\s)(?:submit(?:\s+(?:load|norun|parseonly))?|endsubmit)\b/i,
      lookbehind: !0,
      alias: "keyword"
    },
        h = /aStore|accessControl|aggregation|audio|autotune|bayesianNetClassifier|bioMedImage|boolRule|builtins|cardinality|cdm|clustering|conditionalRandomFields|configuration|copula|countreg|dataDiscovery|dataPreprocess|dataSciencePilot|dataStep|decisionTree|deduplication|deepLearn|deepNeural|deepRnn|ds2|ecm|entityRes|espCluster|explainModel|factmac|fastKnn|fcmpact|fedSql|freqTab|gVarCluster|gam|gleam|graphSemiSupLearn|hiddenMarkovModel|hyperGroup|ica|image|iml|kernalPca|langModel|ldaTopic|loadStreams|mbc|mixed|mlTools|modelPublishing|network|neuralNet|nmf|nonParametricBayes|nonlinear|optNetwork|optimization|panel|pca|percentile|phreg|pls|qkb|qlim|quantreg|recommend|regression|reinforcementLearn|robustPca|ruleMining|sampling|sandwich|sccasl|search(?:Analytics)?|sentimentAnalysis|sequence|session(?:Prop)?|severity|simSystem|simple|smartData|sparkEmbeddedProcess|sparseML|spatialreg|spc|stabilityMonitoring|svDataDescription|svm|table|text(?:Filters|Frequency|Mining|Parse|Rule(?:Develop|Score)|Topic|Util)|timeData|transpose|tsInfo|tsReconcile|uniTimeSeries|varReduce/.source,
        b = {
      pattern: RegExp(/(^|\s)(?:action\s+)?(?:<act>)\.[a-z]+\b[^;]+/.source.replace(/<act>/g, function () {
        return h;
      }), "i"),
      lookbehind: !0,
      inside: {
        keyword: RegExp(/(?:<act>)\.[a-z]+\b/.source.replace(/<act>/g, function () {
          return h;
        }), "i"),
        action: {
          pattern: /(?:action)/i,
          alias: "keyword"
        },
        comment: s,
        function: u,
        "arg-value": d["arg-value"],
        operator: d.operator,
        argument: d.arg,
        number: r,
        "numeric-constant": n,
        punctuation: c,
        string: l
      }
    },
        y = {
      pattern: /((?:^|\s)=?)(?:after|analysis|and|array|barchart|barwidth|begingraph|by|call|cas|cbarline|cfill|class(?:lev)?|close|column|computed?|contains|continue|data(?==)|define|delete|describe|document|do\s+over|do|dol|drop|dul|else|end(?:comp|source)?|entryTitle|eval(?:uate)?|exec(?:ute)?|exit|file(?:name)?|fill(?:attrs)?|flist|fnc|function(?:list)?|global|goto|group(?:by)?|headline|headskip|histogram|if|infile|keep|keylabel|keyword|label|layout|leave|legendlabel|length|libname|loadactionset|merge|midpoints|_?null_|name|noobs|nowd|ods|options|or|otherwise|out(?:put)?|over(?:lay)?|plot|print|put|raise|ranexp|rannor|rbreak|retain|return|select|session|sessref|set|source|statgraph|sum|summarize|table|temp|terminate|then\s+do|then|title\d?|to|var|when|where|xaxisopts|y2axisopts|yaxisopts)\b/i,
      lookbehind: !0
    };
    e.languages.sas = {
      datalines: {
        pattern: /^([ \t]*)(?:cards|(?:data)?lines);[\s\S]+?^[ \t]*;/im,
        lookbehind: !0,
        alias: "string",
        inside: {
          keyword: {
            pattern: /^(?:cards|(?:data)?lines)/i
          },
          punctuation: /;/
        }
      },
      "proc-sql": {
        pattern: /(^proc\s+(?:fed)?sql(?:\s+[\w|=]+)?;)[\s\S]+?(?=^(?:proc\s+\w+|data|quit|run);|(?![\s\S]))/im,
        lookbehind: !0,
        inside: {
          sql: {
            pattern: RegExp(/^[ \t]*(?:select|alter\s+table|(?:create|describe|drop)\s+(?:index|table(?:\s+constraints)?|view)|create\s+unique\s+index|insert\s+into|update)(?:<str>|[^;"'])+;/.source.replace(/<str>/g, function () {
              return t;
            }), "im"),
            alias: "language-sql",
            inside: e.languages.sql
          },
          "global-statements": m,
          "sql-statements": {
            pattern: /(^|\s)(?:disconnect\s+from|begin|commit|exec(?:ute)?|reset|rollback|validate)\b/i,
            lookbehind: !0,
            alias: "keyword"
          },
          number: r,
          "numeric-constant": n,
          punctuation: c,
          string: l
        }
      },
      "proc-groovy": {
        pattern: /(^proc\s+groovy(?:\s+[\w|=]+)?;)[\s\S]+?(?=^(?:proc\s+\w+|data|quit|run);|(?![\s\S]))/im,
        lookbehind: !0,
        inside: {
          comment: s,
          groovy: {
            pattern: RegExp(/(^[ \t]*submit(?:\s+(?:load|norun|parseonly))?)(?:<str>|[^"'])+?(?=endsubmit;)/.source.replace(/<str>/g, function () {
              return t;
            }), "im"),
            lookbehind: !0,
            alias: "language-groovy",
            inside: e.languages.groovy
          },
          keyword: y,
          "submit-statement": f,
          "global-statements": m,
          number: r,
          "numeric-constant": n,
          punctuation: c,
          string: l
        }
      },
      "proc-lua": {
        pattern: /(^proc\s+lua(?:\s+[\w|=]+)?;)[\s\S]+?(?=^(?:proc\s+\w+|data|quit|run);|(?![\s\S]))/im,
        lookbehind: !0,
        inside: {
          comment: s,
          lua: {
            pattern: RegExp(/(^[ \t]*submit(?:\s+(?:load|norun|parseonly))?)(?:<str>|[^"'])+?(?=endsubmit;)/.source.replace(/<str>/g, function () {
              return t;
            }), "im"),
            lookbehind: !0,
            alias: "language-lua",
            inside: e.languages.lua
          },
          keyword: y,
          "submit-statement": f,
          "global-statements": m,
          number: r,
          "numeric-constant": n,
          punctuation: c,
          string: l
        }
      },
      "proc-cas": {
        pattern: /(^proc\s+cas(?:\s+[\w|=]+)?;)[\s\S]+?(?=^(?:proc\s+\w+|quit|data);|(?![\s\S]))/im,
        lookbehind: !0,
        inside: {
          comment: s,
          "statement-var": {
            pattern: /((?:^|\s)=?)saveresult\s[^;]+/im,
            lookbehind: !0,
            inside: {
              statement: {
                pattern: /^saveresult\s+\S+/i,
                inside: {
                  keyword: /^(?:saveresult)/i
                }
              },
              rest: d
            }
          },
          "cas-actions": b,
          statement: {
            pattern: /((?:^|\s)=?)(?:default|(?:un)?set|on|output|upload)[^;]+/im,
            lookbehind: !0,
            inside: d
          },
          step: i,
          keyword: y,
          function: u,
          format: p,
          altformat: g,
          "global-statements": m,
          number: r,
          "numeric-constant": n,
          punctuation: c,
          string: l
        }
      },
      "proc-args": {
        pattern: RegExp(/(^proc\s+\w+\s+)(?!\s)(?:[^;"']|<str>)+;/.source.replace(/<str>/g, function () {
          return t;
        }), "im"),
        lookbehind: !0,
        inside: d
      },
      "macro-keyword": o,
      "macro-variable": a,
      "macro-string-functions": {
        pattern: /((?:^|\s|=))%(?:BQUOTE|NRBQUOTE|NRQUOTE|NRSTR|QUOTE|STR)\(.*?(?:[^%]\))/i,
        lookbehind: !0,
        inside: {
          function: {
            pattern: /%(?:BQUOTE|NRBQUOTE|NRQUOTE|NRSTR|QUOTE|STR)/i,
            alias: "keyword"
          },
          "macro-keyword": o,
          "macro-variable": a,
          "escaped-char": {
            pattern: /%['"()<>=¬^~;,#]/
          },
          punctuation: c
        }
      },
      "macro-declaration": {
        pattern: /^%macro[^;]+(?=;)/im,
        inside: {
          keyword: /%macro/i
        }
      },
      "macro-end": {
        pattern: /^%mend[^;]+(?=;)/im,
        inside: {
          keyword: /%mend/i
        }
      },
      macro: {
        pattern: /%_\w+(?=\()/,
        alias: "keyword"
      },
      input: {
        pattern: /\binput\s[-\w\s/*.$&]+;/i,
        inside: {
          input: {
            alias: "keyword",
            pattern: /^input/i
          },
          comment: s,
          number: r,
          "numeric-constant": n
        }
      },
      "options-args": {
        pattern: /(^options)[-'"|/\\<>*+=:()\w\s]*(?=;)/im,
        lookbehind: !0,
        inside: d
      },
      "cas-actions": b,
      comment: s,
      function: u,
      format: p,
      altformat: g,
      "numeric-constant": n,
      datetime: {
        pattern: RegExp(t + "(?:dt?|t)"),
        alias: "number"
      },
      string: l,
      step: i,
      keyword: y,
      "operator-keyword": {
        pattern: /\b(?:eq|ge|gt|in|le|lt|ne|not)\b/i,
        alias: "operator"
      },
      number: r,
      operator: /\*\*?|\|\|?|!!?|¦¦?|<[>=]?|>[<=]?|[-+\/=&]|[~¬^]=?/,
      punctuation: c
    };
  }(e);
}

sas.displayName = "sas", sas.aliases = [];
var sass_1 = sass;

function sass(e) {
  !function (e) {
    e.languages.sass = e.languages.extend("css", {
      comment: {
        pattern: /^([ \t]*)\/[\/*].*(?:(?:\r?\n|\r)\1[ \t].+)*/m,
        lookbehind: !0,
        greedy: !0
      }
    }), e.languages.insertBefore("sass", "atrule", {
      "atrule-line": {
        pattern: /^(?:[ \t]*)[@+=].+/m,
        greedy: !0,
        inside: {
          atrule: /(?:@[\w-]+|[+=])/
        }
      }
    }), delete e.languages.sass.atrule;
    var t = /\$[-\w]+|#\{\$[-\w]+\}/,
        r = [/[+*\/%]|[=!]=|<=?|>=?|\b(?:and|not|or)\b/, {
      pattern: /(\s)-(?=\s)/,
      lookbehind: !0
    }];
    e.languages.insertBefore("sass", "property", {
      "variable-line": {
        pattern: /^[ \t]*\$.+/m,
        greedy: !0,
        inside: {
          punctuation: /:/,
          variable: t,
          operator: r
        }
      },
      "property-line": {
        pattern: /^[ \t]*(?:[^:\s]+ *:.*|:[^:\s].*)/m,
        greedy: !0,
        inside: {
          property: [/[^:\s]+(?=\s*:)/, {
            pattern: /(:)[^:\s]+/,
            lookbehind: !0
          }],
          punctuation: /:/,
          variable: t,
          operator: r,
          important: e.languages.sass.important
        }
      }
    }), delete e.languages.sass.property, delete e.languages.sass.important, e.languages.insertBefore("sass", "punctuation", {
      selector: {
        pattern: /^([ \t]*)\S(?:,[^,\r\n]+|[^,\r\n]*)(?:,[^,\r\n]+)*(?:,(?:\r?\n|\r)\1[ \t]+\S(?:,[^,\r\n]+|[^,\r\n]*)(?:,[^,\r\n]+)*)*/m,
        lookbehind: !0,
        greedy: !0
      }
    });
  }(e);
}

sass.displayName = "sass", sass.aliases = [];
var refractorJava = java_1,
    scala_1 = scala;

function scala(e) {
  e.register(refractorJava), e.languages.scala = e.languages.extend("java", {
    "triple-quoted-string": {
      pattern: /"""[\s\S]*?"""/,
      greedy: !0,
      alias: "string"
    },
    string: {
      pattern: /("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
      greedy: !0
    },
    keyword: /<-|=>|\b(?:abstract|case|catch|class|def|do|else|extends|final|finally|for|forSome|if|implicit|import|lazy|match|new|null|object|override|package|private|protected|return|sealed|self|super|this|throw|trait|try|type|val|var|while|with|yield)\b/,
    number: /\b0x(?:[\da-f]*\.)?[\da-f]+|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e\d+)?[dfl]?/i,
    builtin: /\b(?:Any|AnyRef|AnyVal|Boolean|Byte|Char|Double|Float|Int|Long|Nothing|Short|String|Unit)\b/,
    symbol: /'[^\d\s\\]\w*/
  }), e.languages.insertBefore("scala", "triple-quoted-string", {
    "string-interpolation": {
      pattern: /\b[a-z]\w*(?:"""(?:[^$]|\$(?:[^{]|\{(?:[^{}]|\{[^{}]*\})*\}))*?"""|"(?:[^$"\r\n]|\$(?:[^{]|\{(?:[^{}]|\{[^{}]*\})*\}))*")/i,
      greedy: !0,
      inside: {
        id: {
          pattern: /^\w+/,
          greedy: !0,
          alias: "function"
        },
        escape: {
          pattern: /\\\$"|\$[$"]/,
          greedy: !0,
          alias: "symbol"
        },
        interpolation: {
          pattern: /\$(?:\w+|\{(?:[^{}]|\{[^{}]*\})*\})/,
          greedy: !0,
          inside: {
            punctuation: /^\$\{?|\}$/,
            expression: {
              pattern: /[\s\S]+/,
              inside: e.languages.scala
            }
          }
        },
        string: /[\s\S]+/
      }
    }
  }), delete e.languages.scala["class-name"], delete e.languages.scala.function;
}

scala.displayName = "scala", scala.aliases = [];
var scss_1 = scss;

function scss(e) {
  e.languages.scss = e.languages.extend("css", {
    comment: {
      pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|\/\/.*)/,
      lookbehind: !0
    },
    atrule: {
      pattern: /@[\w-](?:\([^()]+\)|[^()\s]|\s+(?!\s))*?(?=\s+[{;])/,
      inside: {
        rule: /@[\w-]+/
      }
    },
    url: /(?:[-a-z]+-)?url(?=\()/i,
    selector: {
      pattern: /(?=\S)[^@;{}()]?(?:[^@;{}()\s]|\s+(?!\s)|#\{\$[-\w]+\})+(?=\s*\{(?:\}|\s|[^}][^:{}]*[:{][^}]))/,
      inside: {
        parent: {
          pattern: /&/,
          alias: "important"
        },
        placeholder: /%[-\w]+/,
        variable: /\$[-\w]+|#\{\$[-\w]+\}/
      }
    },
    property: {
      pattern: /(?:[-\w]|\$[-\w]|#\{\$[-\w]+\})+(?=\s*:)/,
      inside: {
        variable: /\$[-\w]+|#\{\$[-\w]+\}/
      }
    }
  }), e.languages.insertBefore("scss", "atrule", {
    keyword: [/@(?:content|debug|each|else(?: if)?|extend|for|forward|function|if|import|include|mixin|return|use|warn|while)\b/i, {
      pattern: /( )(?:from|through)(?= )/,
      lookbehind: !0
    }]
  }), e.languages.insertBefore("scss", "important", {
    variable: /\$[-\w]+|#\{\$[-\w]+\}/
  }), e.languages.insertBefore("scss", "function", {
    "module-modifier": {
      pattern: /\b(?:as|hide|show|with)\b/i,
      alias: "keyword"
    },
    placeholder: {
      pattern: /%[-\w]+/,
      alias: "selector"
    },
    statement: {
      pattern: /\B!(?:default|optional)\b/i,
      alias: "keyword"
    },
    boolean: /\b(?:false|true)\b/,
    null: {
      pattern: /\bnull\b/,
      alias: "keyword"
    },
    operator: {
      pattern: /(\s)(?:[-+*\/%]|[=!]=|<=?|>=?|and|not|or)(?=\s)/,
      lookbehind: !0
    }
  }), e.languages.scss.atrule.inside.rest = e.languages.scss;
}

scss.displayName = "scss", scss.aliases = [];
var refractorBash = bash_1,
    shellSession_1 = shellSession;

function shellSession(e) {
  e.register(refractorBash), function (e) {
    var t = [/"(?:\\[\s\S]|\$\([^)]+\)|\$(?!\()|`[^`]+`|[^"\\`$])*"/.source, /'[^']*'/.source, /\$'(?:[^'\\]|\\[\s\S])*'/.source, /<<-?\s*(["']?)(\w+)\1\s[\s\S]*?[\r\n]\2/.source].join("|");
    e.languages["shell-session"] = {
      command: {
        pattern: RegExp(/^/.source + "(?:" + /[^\s@:$#%*!/\\]+@[^\r\n@:$#%*!/\\]+(?::[^\0-\x1F$#%*?"<>:;|]+)?/.source + "|" + /[/~.][^\0-\x1F$#%*?"<>@:;|]*/.source + ")?" + /[$#%](?=\s)/.source + /(?:[^\\\r\n \t'"<$]|[ \t](?:(?!#)|#.*$)|\\(?:[^\r]|\r\n?)|\$(?!')|<(?!<)|<<str>>)+/.source.replace(/<<str>>/g, function () {
          return t;
        }), "m"),
        greedy: !0,
        inside: {
          info: {
            pattern: /^[^#$%]+/,
            alias: "punctuation",
            inside: {
              user: /^[^\s@:$#%*!/\\]+@[^\r\n@:$#%*!/\\]+/,
              punctuation: /:/,
              path: /[\s\S]+/
            }
          },
          bash: {
            pattern: /(^[$#%]\s*)\S[\s\S]*/,
            lookbehind: !0,
            alias: "language-bash",
            inside: e.languages.bash
          },
          "shell-symbol": {
            pattern: /^[$#%]/,
            alias: "important"
          }
        }
      },
      output: /.(?:.*(?:[\r\n]|.$))*/
    }, e.languages["sh-session"] = e.languages.shellsession = e.languages["shell-session"];
  }(e);
}

shellSession.displayName = "shellSession", shellSession.aliases = [];
var smali_1 = smali;

function smali(e) {
  e.languages.smali = {
    comment: /#.*/,
    string: {
      pattern: /"(?:[^\r\n\\"]|\\.)*"|'(?:[^\r\n\\']|\\(?:.|u[\da-fA-F]{4}))'/,
      greedy: !0
    },
    "class-name": {
      pattern: /(^|[^L])L(?:(?:\w+|`[^`\r\n]*`)\/)*(?:[\w$]+|`[^`\r\n]*`)(?=\s*;)/,
      lookbehind: !0,
      inside: {
        "class-name": {
          pattern: /(^L|\/)(?:[\w$]+|`[^`\r\n]*`)$/,
          lookbehind: !0
        },
        namespace: {
          pattern: /^(L)(?:(?:\w+|`[^`\r\n]*`)\/)+/,
          lookbehind: !0,
          inside: {
            punctuation: /\//
          }
        },
        builtin: /^L/
      }
    },
    builtin: [{
      pattern: /([();\[])[BCDFIJSVZ]+/,
      lookbehind: !0
    }, {
      pattern: /([\w$>]:)[BCDFIJSVZ]/,
      lookbehind: !0
    }],
    keyword: [{
      pattern: /(\.end\s+)[\w-]+/,
      lookbehind: !0
    }, {
      pattern: /(^|[^\w.-])\.(?!\d)[\w-]+/,
      lookbehind: !0
    }, {
      pattern: /(^|[^\w.-])(?:abstract|annotation|bridge|constructor|enum|final|interface|private|protected|public|runtime|static|synthetic|system|transient)(?![\w.-])/,
      lookbehind: !0
    }],
    function: {
      pattern: /(^|[^\w.-])(?:\w+|<[\w$-]+>)(?=\()/,
      lookbehind: !0
    },
    field: {
      pattern: /[\w$]+(?=:)/,
      alias: "variable"
    },
    register: {
      pattern: /(^|[^\w.-])[vp]\d(?![\w.-])/,
      lookbehind: !0,
      alias: "variable"
    },
    boolean: {
      pattern: /(^|[^\w.-])(?:false|true)(?![\w.-])/,
      lookbehind: !0
    },
    number: {
      pattern: /(^|[^/\w.-])-?(?:NAN|INFINITY|0x(?:[\dA-F]+(?:\.[\dA-F]*)?|\.[\dA-F]+)(?:p[+-]?[\dA-F]+)?|(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?)[dflst]?(?![\w.-])/i,
      lookbehind: !0
    },
    label: {
      pattern: /(:)\w+/,
      lookbehind: !0,
      alias: "property"
    },
    operator: /->|\.\.|[\[=]/,
    punctuation: /[{}(),;:]/
  };
}

smali.displayName = "smali", smali.aliases = [];
var smalltalk_1 = smalltalk;

function smalltalk(e) {
  e.languages.smalltalk = {
    comment: {
      pattern: /"(?:""|[^"])*"/,
      greedy: !0
    },
    char: {
      pattern: /\$./,
      greedy: !0
    },
    string: {
      pattern: /'(?:''|[^'])*'/,
      greedy: !0
    },
    symbol: /#[\da-z]+|#(?:-|([+\/\\*~<>=@%|&?!])\1?)|#(?=\()/i,
    "block-arguments": {
      pattern: /(\[\s*):[^\[|]*\|/,
      lookbehind: !0,
      inside: {
        variable: /:[\da-z]+/i,
        punctuation: /\|/
      }
    },
    "temporary-variables": {
      pattern: /\|[^|]+\|/,
      inside: {
        variable: /[\da-z]+/i,
        punctuation: /\|/
      }
    },
    keyword: /\b(?:new|nil|self|super)\b/,
    boolean: /\b(?:false|true)\b/,
    number: [/\d+r-?[\dA-Z]+(?:\.[\dA-Z]+)?(?:e-?\d+)?/, /\b\d+(?:\.\d+)?(?:e-?\d+)?/],
    operator: /[<=]=?|:=|~[~=]|\/\/?|\\\\|>[>=]?|[!^+\-*&|,@]/,
    punctuation: /[.;:?\[\](){}]/
  };
}

smalltalk.displayName = "smalltalk", smalltalk.aliases = [];
var refractorMarkupTemplating$3 = markupTemplating_1,
    smarty_1 = smarty;

function smarty(e) {
  e.register(refractorMarkupTemplating$3), function (e) {
    e.languages.smarty = {
      comment: {
        pattern: /^\{\*[\s\S]*?\*\}/,
        greedy: !0
      },
      "embedded-php": {
        pattern: /^\{php\}[\s\S]*?\{\/php\}/,
        greedy: !0,
        inside: {
          smarty: {
            pattern: /^\{php\}|\{\/php\}$/,
            inside: null
          },
          php: {
            pattern: /[\s\S]+/,
            alias: "language-php",
            inside: e.languages.php
          }
        }
      },
      string: [{
        pattern: /"(?:\\.|[^"\\\r\n])*"/,
        greedy: !0,
        inside: {
          interpolation: {
            pattern: /\{[^{}]*\}|`[^`]*`/,
            inside: {
              "interpolation-punctuation": {
                pattern: /^[{`]|[`}]$/,
                alias: "punctuation"
              },
              expression: {
                pattern: /[\s\S]+/,
                inside: null
              }
            }
          },
          variable: /\$\w+/
        }
      }, {
        pattern: /'(?:\\.|[^'\\\r\n])*'/,
        greedy: !0
      }],
      keyword: {
        pattern: /(^\{\/?)[a-z_]\w*\b(?!\()/i,
        lookbehind: !0,
        greedy: !0
      },
      delimiter: {
        pattern: /^\{\/?|\}$/,
        greedy: !0,
        alias: "punctuation"
      },
      number: /\b0x[\dA-Fa-f]+|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee][-+]?\d+)?/,
      variable: [/\$(?!\d)\w+/, /#(?!\d)\w+#/, {
        pattern: /(\.|->|\w\s*=)(?!\d)\w+\b(?!\()/,
        lookbehind: !0
      }, {
        pattern: /(\[)(?!\d)\w+(?=\])/,
        lookbehind: !0
      }],
      function: {
        pattern: /(\|\s*)@?[a-z_]\w*|\b[a-z_]\w*(?=\()/i,
        lookbehind: !0
      },
      "attr-name": /\b[a-z_]\w*(?=\s*=)/i,
      boolean: /\b(?:false|no|off|on|true|yes)\b/,
      punctuation: /[\[\](){}.,:`]|->/,
      operator: [/[+\-*\/%]|==?=?|[!<>]=?|&&|\|\|?/, /\bis\s+(?:not\s+)?(?:div|even|odd)(?:\s+by)?\b/, /\b(?:and|eq|gt?e|gt|lt?e|lt|mod|neq?|not|or)\b/]
    }, e.languages.smarty["embedded-php"].inside.smarty.inside = e.languages.smarty, e.languages.smarty.string[0].inside.interpolation.inside.expression.inside = e.languages.smarty;
    var t = /"(?:\\.|[^"\\\r\n])*"|'(?:\\.|[^'\\\r\n])*'/,
        r = RegExp(/\{\*[\s\S]*?\*\}/.source + "|" + /\{php\}[\s\S]*?\{\/php\}/.source + "|" + /\{(?:[^{}"']|<str>|\{(?:[^{}"']|<str>|\{(?:[^{}"']|<str>)*\})*\})*\}/.source.replace(/<str>/g, function () {
      return t.source;
    }), "g");
    e.hooks.add("before-tokenize", function (t) {
      var n = !1;
      e.languages["markup-templating"].buildPlaceholders(t, "smarty", r, function (e) {
        return "{/literal}" === e && (n = !1), !n && ("{literal}" === e && (n = !0), !0);
      });
    }), e.hooks.add("after-tokenize", function (t) {
      e.languages["markup-templating"].tokenizePlaceholders(t, "smarty");
    });
  }(e);
}

smarty.displayName = "smarty", smarty.aliases = [];
var sml_1 = sml;

function sml(e) {
  !function (e) {
    var t = /\b(?:abstype|and|andalso|as|case|datatype|do|else|end|eqtype|exception|fn|fun|functor|handle|if|in|include|infix|infixr|let|local|nonfix|of|op|open|orelse|raise|rec|sharing|sig|signature|struct|structure|then|type|val|where|while|with|withtype)\b/i;
    e.languages.sml = {
      comment: /\(\*(?:[^*(]|\*(?!\))|\((?!\*)|\(\*(?:[^*(]|\*(?!\))|\((?!\*))*\*\))*\*\)/,
      string: {
        pattern: /#?"(?:[^"\\]|\\.)*"/,
        greedy: !0
      },
      "class-name": [{
        pattern: RegExp(/((?:^|[^:]):\s*)<TERMINAL>(?:\s*(?:(?:\*|->)\s*<TERMINAL>|,\s*<TERMINAL>(?:(?=<NOT-LAST>)|(?!<NOT-LAST>)\s+<LONG-ID>)))*/.source.replace(/<NOT-LAST>/g, function () {
          return /\s*(?:[*,]|->)/.source;
        }).replace(/<TERMINAL>/g, function () {
          return /(?:'[\w']*|<LONG-ID>|\((?:[^()]|\([^()]*\))*\)|\{(?:[^{}]|\{[^{}]*\})*\})(?:\s+<LONG-ID>)*/.source;
        }).replace(/<LONG-ID>/g, function () {
          return /(?!<KEYWORD>)[a-z\d_][\w'.]*/.source;
        }).replace(/<KEYWORD>/g, function () {
          return t.source;
        }), "i"),
        lookbehind: !0,
        greedy: !0,
        inside: null
      }, {
        pattern: /((?:^|[^\w'])(?:datatype|exception|functor|signature|structure|type)\s+)[a-z_][\w'.]*/i,
        lookbehind: !0
      }],
      function: {
        pattern: /((?:^|[^\w'])fun\s+)[a-z_][\w'.]*/i,
        lookbehind: !0
      },
      keyword: t,
      variable: {
        pattern: /(^|[^\w'])'[\w']*/,
        lookbehind: !0
      },
      number: /~?\b(?:\d+(?:\.\d+)?(?:e~?\d+)?|0x[\da-f]+)\b/i,
      word: {
        pattern: /\b0w(?:\d+|x[\da-f]+)\b/i,
        alias: "constant"
      },
      boolean: /\b(?:false|true)\b/i,
      operator: /\.\.\.|:[>=:]|=>?|->|[<>]=?|[!+\-*/^#|@~]/,
      punctuation: /[(){}\[\].:,;]/
    }, e.languages.sml["class-name"][0].inside = e.languages.sml, e.languages.smlnj = e.languages.sml;
  }(e);
}

sml.displayName = "sml", sml.aliases = ["smlnj"];
var solidity_1 = solidity;

function solidity(e) {
  e.languages.solidity = e.languages.extend("clike", {
    "class-name": {
      pattern: /(\b(?:contract|enum|interface|library|new|struct|using)\s+)(?!\d)[\w$]+/,
      lookbehind: !0
    },
    keyword: /\b(?:_|anonymous|as|assembly|assert|break|calldata|case|constant|constructor|continue|contract|default|delete|do|else|emit|enum|event|external|for|from|function|if|import|indexed|inherited|interface|internal|is|let|library|mapping|memory|modifier|new|payable|pragma|private|public|pure|require|returns?|revert|selfdestruct|solidity|storage|struct|suicide|switch|this|throw|using|var|view|while)\b/,
    operator: /=>|->|:=|=:|\*\*|\+\+|--|\|\||&&|<<=?|>>=?|[-+*/%^&|<>!=]=?|[~?]/
  }), e.languages.insertBefore("solidity", "keyword", {
    builtin: /\b(?:address|bool|byte|u?int(?:8|16|24|32|40|48|56|64|72|80|88|96|104|112|120|128|136|144|152|160|168|176|184|192|200|208|216|224|232|240|248|256)?|string|bytes(?:[1-9]|[12]\d|3[0-2])?)\b/
  }), e.languages.insertBefore("solidity", "number", {
    version: {
      pattern: /([<>]=?|\^)\d+\.\d+\.\d+\b/,
      lookbehind: !0,
      alias: "number"
    }
  }), e.languages.sol = e.languages.solidity;
}

solidity.displayName = "solidity", solidity.aliases = ["sol"];
var solutionFile_1 = solutionFile;

function solutionFile(e) {
  !function (e) {
    var t = {
      pattern: /\{[\da-f]{8}-[\da-f]{4}-[\da-f]{4}-[\da-f]{4}-[\da-f]{12}\}/i,
      alias: "constant",
      inside: {
        punctuation: /[{}]/
      }
    };
    e.languages["solution-file"] = {
      comment: {
        pattern: /#.*/,
        greedy: !0
      },
      string: {
        pattern: /"[^"\r\n]*"|'[^'\r\n]*'/,
        greedy: !0,
        inside: {
          guid: t
        }
      },
      object: {
        pattern: /^([ \t]*)(?:([A-Z]\w*)\b(?=.*(?:\r\n?|\n)(?:\1[ \t].*(?:\r\n?|\n))*\1End\2(?=[ \t]*$))|End[A-Z]\w*(?=[ \t]*$))/m,
        lookbehind: !0,
        greedy: !0,
        alias: "keyword"
      },
      property: {
        pattern: /^([ \t]*)(?!\s)[^\r\n"#=()]*[^\s"#=()](?=\s*=)/m,
        lookbehind: !0,
        inside: {
          guid: t
        }
      },
      guid: t,
      number: /\b\d+(?:\.\d+)*\b/,
      boolean: /\b(?:FALSE|TRUE)\b/,
      operator: /=/,
      punctuation: /[(),]/
    }, e.languages.sln = e.languages["solution-file"];
  }(e);
}

solutionFile.displayName = "solutionFile", solutionFile.aliases = [];
var refractorMarkupTemplating$2 = markupTemplating_1,
    soy_1 = soy;

function soy(e) {
  e.register(refractorMarkupTemplating$2), function (e) {
    var t = /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
        r = /\b\d+(?:\.\d+)?(?:[eE][+-]?\d+)?\b|\b0x[\dA-F]+\b/;
    e.languages.soy = {
      comment: [/\/\*[\s\S]*?\*\//, {
        pattern: /(\s)\/\/.*/,
        lookbehind: !0,
        greedy: !0
      }],
      "command-arg": {
        pattern: /(\{+\/?\s*(?:alias|call|delcall|delpackage|deltemplate|namespace|template)\s+)\.?[\w.]+/,
        lookbehind: !0,
        alias: "string",
        inside: {
          punctuation: /\./
        }
      },
      parameter: {
        pattern: /(\{+\/?\s*@?param\??\s+)\.?[\w.]+/,
        lookbehind: !0,
        alias: "variable"
      },
      keyword: [{
        pattern: /(\{+\/?[^\S\r\n]*)(?:\\[nrt]|alias|call|case|css|default|delcall|delpackage|deltemplate|else(?:if)?|fallbackmsg|for(?:each)?|if(?:empty)?|lb|let|literal|msg|namespace|nil|@?param\??|rb|sp|switch|template|xid)/,
        lookbehind: !0
      }, /\b(?:any|as|attributes|bool|css|float|html|in|int|js|list|map|null|number|string|uri)\b/],
      delimiter: {
        pattern: /^\{+\/?|\/?\}+$/,
        alias: "punctuation"
      },
      property: /\w+(?==)/,
      variable: {
        pattern: /\$[^\W\d]\w*(?:\??(?:\.\w+|\[[^\]]+\]))*/,
        inside: {
          string: {
            pattern: t,
            greedy: !0
          },
          number: r,
          punctuation: /[\[\].?]/
        }
      },
      string: {
        pattern: t,
        greedy: !0
      },
      function: [/\w+(?=\()/, {
        pattern: /(\|[^\S\r\n]*)\w+/,
        lookbehind: !0
      }],
      boolean: /\b(?:false|true)\b/,
      number: r,
      operator: /\?:?|<=?|>=?|==?|!=|[+*/%-]|\b(?:and|not|or)\b/,
      punctuation: /[{}()\[\]|.,:]/
    }, e.hooks.add("before-tokenize", function (t) {
      var r = !1;
      e.languages["markup-templating"].buildPlaceholders(t, "soy", /\{\{.+?\}\}|\{.+?\}|\s\/\/.*|\/\*[\s\S]*?\*\//g, function (e) {
        return "{/literal}" === e && (r = !1), !r && ("{literal}" === e && (r = !0), !0);
      });
    }), e.hooks.add("after-tokenize", function (t) {
      e.languages["markup-templating"].tokenizePlaceholders(t, "soy");
    });
  }(e);
}

soy.displayName = "soy", soy.aliases = [];
var turtle_1 = turtle;

function turtle(e) {
  e.languages.turtle = {
    comment: {
      pattern: /#.*/,
      greedy: !0
    },
    "multiline-string": {
      pattern: /"""(?:(?:""?)?(?:[^"\\]|\\.))*"""|'''(?:(?:''?)?(?:[^'\\]|\\.))*'''/,
      greedy: !0,
      alias: "string",
      inside: {
        comment: /#.*/
      }
    },
    string: {
      pattern: /"(?:[^\\"\r\n]|\\.)*"|'(?:[^\\'\r\n]|\\.)*'/,
      greedy: !0
    },
    url: {
      pattern: /<(?:[^\x00-\x20<>"{}|^`\\]|\\(?:u[\da-fA-F]{4}|U[\da-fA-F]{8}))*>/,
      greedy: !0,
      inside: {
        punctuation: /[<>]/
      }
    },
    function: {
      pattern: /(?:(?![-.\d\xB7])[-.\w\xB7\xC0-\uFFFD]+)?:(?:(?![-.])(?:[-.:\w\xC0-\uFFFD]|%[\da-f]{2}|\\.)+)?/i,
      inside: {
        "local-name": {
          pattern: /([^:]*:)[\s\S]+/,
          lookbehind: !0
        },
        prefix: {
          pattern: /[\s\S]+/,
          inside: {
            punctuation: /:/
          }
        }
      }
    },
    number: /[+-]?\b\d+(?:\.\d*)?(?:e[+-]?\d+)?/i,
    punctuation: /[{}.,;()[\]]|\^\^/,
    boolean: /\b(?:false|true)\b/,
    keyword: [/(?:\ba|@prefix|@base)\b|=/, /\b(?:base|graph|prefix)\b/i],
    tag: {
      pattern: /@[a-z]+(?:-[a-z\d]+)*/i,
      inside: {
        punctuation: /@/
      }
    }
  }, e.languages.trig = e.languages.turtle;
}

turtle.displayName = "turtle", turtle.aliases = [];
var refractorTurtle = turtle_1,
    sparql_1 = sparql;

function sparql(e) {
  e.register(refractorTurtle), e.languages.sparql = e.languages.extend("turtle", {
    boolean: /\b(?:false|true)\b/i,
    variable: {
      pattern: /[?$]\w+/,
      greedy: !0
    }
  }), e.languages.insertBefore("sparql", "punctuation", {
    keyword: [/\b(?:A|ADD|ALL|AS|ASC|ASK|BNODE|BY|CLEAR|CONSTRUCT|COPY|CREATE|DATA|DEFAULT|DELETE|DESC|DESCRIBE|DISTINCT|DROP|EXISTS|FILTER|FROM|GROUP|HAVING|INSERT|INTO|LIMIT|LOAD|MINUS|MOVE|NAMED|NOT|NOW|OFFSET|OPTIONAL|ORDER|RAND|REDUCED|SELECT|SEPARATOR|SERVICE|SILENT|STRUUID|UNION|USING|UUID|VALUES|WHERE)\b/i, /\b(?:ABS|AVG|BIND|BOUND|CEIL|COALESCE|CONCAT|CONTAINS|COUNT|DATATYPE|DAY|ENCODE_FOR_URI|FLOOR|GROUP_CONCAT|HOURS|IF|IRI|isBLANK|isIRI|isLITERAL|isNUMERIC|isURI|LANG|LANGMATCHES|LCASE|MAX|MD5|MIN|MINUTES|MONTH|REGEX|REPLACE|ROUND|sameTerm|SAMPLE|SECONDS|SHA1|SHA256|SHA384|SHA512|STR|STRAFTER|STRBEFORE|STRDT|STRENDS|STRLANG|STRLEN|STRSTARTS|SUBSTR|SUM|TIMEZONE|TZ|UCASE|URI|YEAR)\b(?=\s*\()/i, /\b(?:BASE|GRAPH|PREFIX)\b/i]
  }), e.languages.rq = e.languages.sparql;
}

sparql.displayName = "sparql", sparql.aliases = ["rq"];
var splunkSpl_1 = splunkSpl;

function splunkSpl(e) {
  e.languages["splunk-spl"] = {
    comment: /`comment\("(?:\\.|[^\\"])*"\)`/,
    string: {
      pattern: /"(?:\\.|[^\\"])*"/,
      greedy: !0
    },
    keyword: /\b(?:abstract|accum|addcoltotals|addinfo|addtotals|analyzefields|anomalies|anomalousvalue|anomalydetection|append|appendcols|appendcsv|appendlookup|appendpipe|arules|associate|audit|autoregress|bin|bucket|bucketdir|chart|cluster|cofilter|collect|concurrency|contingency|convert|correlate|datamodel|dbinspect|dedup|delete|delta|diff|erex|eval|eventcount|eventstats|extract|fieldformat|fields|fieldsummary|filldown|fillnull|findtypes|folderize|foreach|format|from|gauge|gentimes|geom|geomfilter|geostats|head|highlight|history|iconify|input|inputcsv|inputlookup|iplocation|join|kmeans|kv|kvform|loadjob|localize|localop|lookup|makecontinuous|makemv|makeresults|map|mcollect|metadata|metasearch|meventcollect|mstats|multikv|multisearch|mvcombine|mvexpand|nomv|outlier|outputcsv|outputlookup|outputtext|overlap|pivot|predict|rangemap|rare|regex|relevancy|reltime|rename|replace|rest|return|reverse|rex|rtorder|run|savedsearch|script|scrub|search|searchtxn|selfjoin|sendemail|set|setfields|sichart|sirare|sistats|sitimechart|sitop|sort|spath|stats|strcat|streamstats|table|tags|tail|timechart|timewrap|top|transaction|transpose|trendline|tscollect|tstats|typeahead|typelearner|typer|union|uniq|untable|where|x11|xmlkv|xmlunescape|xpath|xyseries)\b/i,
    "operator-word": {
      pattern: /\b(?:and|as|by|not|or|xor)\b/i,
      alias: "operator"
    },
    function: /\b\w+(?=\s*\()/,
    property: /\b\w+(?=\s*=(?!=))/,
    date: {
      pattern: /\b\d{1,2}\/\d{1,2}\/\d{1,4}(?:(?::\d{1,2}){3})?\b/,
      alias: "number"
    },
    number: /\b\d+(?:\.\d+)?\b/,
    boolean: /\b(?:f|false|t|true)\b/i,
    operator: /[<>=]=?|[-+*/%|]/,
    punctuation: /[()[\],]/
  };
}

splunkSpl.displayName = "splunkSpl", splunkSpl.aliases = [];
var sqf_1 = sqf;

function sqf(e) {
  e.languages.sqf = e.languages.extend("clike", {
    string: {
      pattern: /"(?:(?:"")?[^"])*"(?!")|'(?:[^'])*'/,
      greedy: !0
    },
    keyword: /\b(?:breakOut|breakTo|call|case|catch|default|do|echo|else|execFSM|execVM|exitWith|for|forEach|forEachMember|forEachMemberAgent|forEachMemberTeam|from|goto|if|nil|preprocessFile|preprocessFileLineNumbers|private|scopeName|spawn|step|switch|then|throw|to|try|while|with)\b/i,
    boolean: /\b(?:false|true)\b/i,
    function: /\b(?:abs|accTime|acos|action|actionIDs|actionKeys|actionKeysImages|actionKeysNames|actionKeysNamesArray|actionName|actionParams|activateAddons|activatedAddons|activateKey|add3DENConnection|add3DENEventHandler|add3DENLayer|addAction|addBackpack|addBackpackCargo|addBackpackCargoGlobal|addBackpackGlobal|addCamShake|addCuratorAddons|addCuratorCameraArea|addCuratorEditableObjects|addCuratorEditingArea|addCuratorPoints|addEditorObject|addEventHandler|addForce|addForceGeneratorRTD|addGoggles|addGroupIcon|addHandgunItem|addHeadgear|addItem|addItemCargo|addItemCargoGlobal|addItemPool|addItemToBackpack|addItemToUniform|addItemToVest|addLiveStats|addMagazine|addMagazineAmmoCargo|addMagazineCargo|addMagazineCargoGlobal|addMagazineGlobal|addMagazinePool|addMagazines|addMagazineTurret|addMenu|addMenuItem|addMissionEventHandler|addMPEventHandler|addMusicEventHandler|addOwnedMine|addPlayerScores|addPrimaryWeaponItem|addPublicVariableEventHandler|addRating|addResources|addScore|addScoreSide|addSecondaryWeaponItem|addSwitchableUnit|addTeamMember|addToRemainsCollector|addTorque|addUniform|addVehicle|addVest|addWaypoint|addWeapon|addWeaponCargo|addWeaponCargoGlobal|addWeaponGlobal|addWeaponItem|addWeaponPool|addWeaponTurret|admin|agent|agents|AGLToASL|aimedAtTarget|aimPos|airDensityCurveRTD|airDensityRTD|airplaneThrottle|airportSide|AISFinishHeal|alive|all3DENEntities|allAirports|allControls|allCurators|allCutLayers|allDead|allDeadMen|allDisplays|allGroups|allMapMarkers|allMines|allMissionObjects|allow3DMode|allowCrewInImmobile|allowCuratorLogicIgnoreAreas|allowDamage|allowDammage|allowFileOperations|allowFleeing|allowGetIn|allowSprint|allPlayers|allSimpleObjects|allSites|allTurrets|allUnits|allUnitsUAV|allVariables|ammo|ammoOnPylon|animate|animateBay|animateDoor|animatePylon|animateSource|animationNames|animationPhase|animationSourcePhase|animationState|append|apply|armoryPoints|arrayIntersect|asin|ASLToAGL|ASLToATL|assert|assignAsCargo|assignAsCargoIndex|assignAsCommander|assignAsDriver|assignAsGunner|assignAsTurret|assignCurator|assignedCargo|assignedCommander|assignedDriver|assignedGunner|assignedItems|assignedTarget|assignedTeam|assignedVehicle|assignedVehicleRole|assignItem|assignTeam|assignToAirport|atan|atan2|atg|ATLToASL|attachedObject|attachedObjects|attachedTo|attachObject|attachTo|attackEnabled|backpack|backpackCargo|backpackContainer|backpackItems|backpackMagazines|backpackSpaceFor|behaviour|benchmark|binocular|blufor|boundingBox|boundingBoxReal|boundingCenter|briefingName|buildingExit|buildingPos|buldozer_EnableRoadDiag|buldozer_IsEnabledRoadDiag|buldozer_LoadNewRoads|buldozer_reloadOperMap|buttonAction|buttonSetAction|cadetMode|callExtension|camCommand|camCommit|camCommitPrepared|camCommitted|camConstuctionSetParams|camCreate|camDestroy|cameraEffect|cameraEffectEnableHUD|cameraInterest|cameraOn|cameraView|campaignConfigFile|camPreload|camPreloaded|camPrepareBank|camPrepareDir|camPrepareDive|camPrepareFocus|camPrepareFov|camPrepareFovRange|camPreparePos|camPrepareRelPos|camPrepareTarget|camSetBank|camSetDir|camSetDive|camSetFocus|camSetFov|camSetFovRange|camSetPos|camSetRelPos|camSetTarget|camTarget|camUseNVG|canAdd|canAddItemToBackpack|canAddItemToUniform|canAddItemToVest|cancelSimpleTaskDestination|canFire|canMove|canSlingLoad|canStand|canSuspend|canTriggerDynamicSimulation|canUnloadInCombat|canVehicleCargo|captive|captiveNum|cbChecked|cbSetChecked|ceil|channelEnabled|cheatsEnabled|checkAIFeature|checkVisibility|civilian|className|clear3DENAttribute|clear3DENInventory|clearAllItemsFromBackpack|clearBackpackCargo|clearBackpackCargoGlobal|clearForcesRTD|clearGroupIcons|clearItemCargo|clearItemCargoGlobal|clearItemPool|clearMagazineCargo|clearMagazineCargoGlobal|clearMagazinePool|clearOverlay|clearRadio|clearVehicleInit|clearWeaponCargo|clearWeaponCargoGlobal|clearWeaponPool|clientOwner|closeDialog|closeDisplay|closeOverlay|collapseObjectTree|collect3DENHistory|collectiveRTD|combatMode|commandArtilleryFire|commandChat|commander|commandFire|commandFollow|commandFSM|commandGetOut|commandingMenu|commandMove|commandRadio|commandStop|commandSuppressiveFire|commandTarget|commandWatch|comment|commitOverlay|compile|compileFinal|completedFSM|composeText|configClasses|configFile|configHierarchy|configName|configNull|configProperties|configSourceAddonList|configSourceMod|configSourceModList|confirmSensorTarget|connectTerminalToUAV|controlNull|controlsGroupCtrl|copyFromClipboard|copyToClipboard|copyWaypoints|cos|count|countEnemy|countFriendly|countSide|countType|countUnknown|create3DENComposition|create3DENEntity|createAgent|createCenter|createDialog|createDiaryLink|createDiaryRecord|createDiarySubject|createDisplay|createGearDialog|createGroup|createGuardedPoint|createLocation|createMarker|createMarkerLocal|createMenu|createMine|createMissionDisplay|createMPCampaignDisplay|createSimpleObject|createSimpleTask|createSite|createSoundSource|createTask|createTeam|createTrigger|createUnit|createVehicle|createVehicleCrew|createVehicleLocal|crew|ctAddHeader|ctAddRow|ctClear|ctCurSel|ctData|ctFindHeaderRows|ctFindRowHeader|ctHeaderControls|ctHeaderCount|ctRemoveHeaders|ctRemoveRows|ctrlActivate|ctrlAddEventHandler|ctrlAngle|ctrlAutoScrollDelay|ctrlAutoScrollRewind|ctrlAutoScrollSpeed|ctrlChecked|ctrlClassName|ctrlCommit|ctrlCommitted|ctrlCreate|ctrlDelete|ctrlEnable|ctrlEnabled|ctrlFade|ctrlHTMLLoaded|ctrlIDC|ctrlIDD|ctrlMapAnimAdd|ctrlMapAnimClear|ctrlMapAnimCommit|ctrlMapAnimDone|ctrlMapCursor|ctrlMapMouseOver|ctrlMapScale|ctrlMapScreenToWorld|ctrlMapWorldToScreen|ctrlModel|ctrlModelDirAndUp|ctrlModelScale|ctrlParent|ctrlParentControlsGroup|ctrlPosition|ctrlRemoveAllEventHandlers|ctrlRemoveEventHandler|ctrlScale|ctrlSetActiveColor|ctrlSetAngle|ctrlSetAutoScrollDelay|ctrlSetAutoScrollRewind|ctrlSetAutoScrollSpeed|ctrlSetBackgroundColor|ctrlSetChecked|ctrlSetDisabledColor|ctrlSetEventHandler|ctrlSetFade|ctrlSetFocus|ctrlSetFont|ctrlSetFontH1|ctrlSetFontH1B|ctrlSetFontH2|ctrlSetFontH2B|ctrlSetFontH3|ctrlSetFontH3B|ctrlSetFontH4|ctrlSetFontH4B|ctrlSetFontH5|ctrlSetFontH5B|ctrlSetFontH6|ctrlSetFontH6B|ctrlSetFontHeight|ctrlSetFontHeightH1|ctrlSetFontHeightH2|ctrlSetFontHeightH3|ctrlSetFontHeightH4|ctrlSetFontHeightH5|ctrlSetFontHeightH6|ctrlSetFontHeightSecondary|ctrlSetFontP|ctrlSetFontPB|ctrlSetFontSecondary|ctrlSetForegroundColor|ctrlSetModel|ctrlSetModelDirAndUp|ctrlSetModelScale|ctrlSetPixelPrecision|ctrlSetPosition|ctrlSetScale|ctrlSetStructuredText|ctrlSetText|ctrlSetTextColor|ctrlSetTextColorSecondary|ctrlSetTextSecondary|ctrlSetTooltip|ctrlSetTooltipColorBox|ctrlSetTooltipColorShade|ctrlSetTooltipColorText|ctrlShow|ctrlShown|ctrlText|ctrlTextHeight|ctrlTextSecondary|ctrlTextWidth|ctrlType|ctrlVisible|ctRowControls|ctRowCount|ctSetCurSel|ctSetData|ctSetHeaderTemplate|ctSetRowTemplate|ctSetValue|ctValue|curatorAddons|curatorCamera|curatorCameraArea|curatorCameraAreaCeiling|curatorCoef|curatorEditableObjects|curatorEditingArea|curatorEditingAreaType|curatorMouseOver|curatorPoints|curatorRegisteredObjects|curatorSelected|curatorWaypointCost|current3DENOperation|currentChannel|currentCommand|currentMagazine|currentMagazineDetail|currentMagazineDetailTurret|currentMagazineTurret|currentMuzzle|currentNamespace|currentTask|currentTasks|currentThrowable|currentVisionMode|currentWaypoint|currentWeapon|currentWeaponMode|currentWeaponTurret|currentZeroing|cursorObject|cursorTarget|customChat|customRadio|cutFadeOut|cutObj|cutRsc|cutText|damage|date|dateToNumber|daytime|deActivateKey|debriefingText|debugFSM|debugLog|deg|delete3DENEntities|deleteAt|deleteCenter|deleteCollection|deleteEditorObject|deleteGroup|deleteGroupWhenEmpty|deleteIdentity|deleteLocation|deleteMarker|deleteMarkerLocal|deleteRange|deleteResources|deleteSite|deleteStatus|deleteTeam|deleteVehicle|deleteVehicleCrew|deleteWaypoint|detach|detectedMines|diag_activeMissionFSMs|diag_activeScripts|diag_activeSQFScripts|diag_activeSQSScripts|diag_captureFrame|diag_captureFrameToFile|diag_captureSlowFrame|diag_codePerformance|diag_drawMode|diag_dynamicSimulationEnd|diag_enable|diag_enabled|diag_fps|diag_fpsMin|diag_frameNo|diag_lightNewLoad|diag_list|diag_log|diag_logSlowFrame|diag_mergeConfigFile|diag_recordTurretLimits|diag_setLightNew|diag_tickTime|diag_toggle|dialog|diarySubjectExists|didJIP|didJIPOwner|difficulty|difficultyEnabled|difficultyEnabledRTD|difficultyOption|direction|directSay|disableAI|disableCollisionWith|disableConversation|disableDebriefingStats|disableMapIndicators|disableNVGEquipment|disableRemoteSensors|disableSerialization|disableTIEquipment|disableUAVConnectability|disableUserInput|displayAddEventHandler|displayCtrl|displayNull|displayParent|displayRemoveAllEventHandlers|displayRemoveEventHandler|displaySetEventHandler|dissolveTeam|distance|distance2D|distanceSqr|distributionRegion|do3DENAction|doArtilleryFire|doFire|doFollow|doFSM|doGetOut|doMove|doorPhase|doStop|doSuppressiveFire|doTarget|doWatch|drawArrow|drawEllipse|drawIcon|drawIcon3D|drawLine|drawLine3D|drawLink|drawLocation|drawPolygon|drawRectangle|drawTriangle|driver|drop|dynamicSimulationDistance|dynamicSimulationDistanceCoef|dynamicSimulationEnabled|dynamicSimulationSystemEnabled|east|edit3DENMissionAttributes|editObject|editorSetEventHandler|effectiveCommander|emptyPositions|enableAI|enableAIFeature|enableAimPrecision|enableAttack|enableAudioFeature|enableAutoStartUpRTD|enableAutoTrimRTD|enableCamShake|enableCaustics|enableChannel|enableCollisionWith|enableCopilot|enableDebriefingStats|enableDiagLegend|enableDynamicSimulation|enableDynamicSimulationSystem|enableEndDialog|enableEngineArtillery|enableEnvironment|enableFatigue|enableGunLights|enableInfoPanelComponent|enableIRLasers|enableMimics|enablePersonTurret|enableRadio|enableReload|enableRopeAttach|enableSatNormalOnDetail|enableSaving|enableSentences|enableSimulation|enableSimulationGlobal|enableStamina|enableStressDamage|enableTeamSwitch|enableTraffic|enableUAVConnectability|enableUAVWaypoints|enableVehicleCargo|enableVehicleSensor|enableWeaponDisassembly|endl|endLoadingScreen|endMission|engineOn|enginesIsOnRTD|enginesPowerRTD|enginesRpmRTD|enginesTorqueRTD|entities|environmentEnabled|estimatedEndServerTime|estimatedTimeLeft|evalObjectArgument|everyBackpack|everyContainer|exec|execEditorScript|exp|expectedDestination|exportJIPMessages|eyeDirection|eyePos|face|faction|fadeMusic|fadeRadio|fadeSound|fadeSpeech|failMission|fillWeaponsFromPool|find|findCover|findDisplay|findEditorObject|findEmptyPosition|findEmptyPositionReady|findIf|findNearestEnemy|finishMissionInit|finite|fire|fireAtTarget|firstBackpack|flag|flagAnimationPhase|flagOwner|flagSide|flagTexture|fleeing|floor|flyInHeight|flyInHeightASL|fog|fogForecast|fogParams|forceAddUniform|forceAtPositionRTD|forcedMap|forceEnd|forceFlagTexture|forceFollowRoad|forceGeneratorRTD|forceMap|forceRespawn|forceSpeed|forceWalk|forceWeaponFire|forceWeatherChange|forgetTarget|format|formation|formationDirection|formationLeader|formationMembers|formationPosition|formationTask|formatText|formLeader|freeLook|fromEditor|fuel|fullCrew|gearIDCAmmoCount|gearSlotAmmoCount|gearSlotData|get3DENActionState|get3DENAttribute|get3DENCamera|get3DENConnections|get3DENEntity|get3DENEntityID|get3DENGrid|get3DENIconsVisible|get3DENLayerEntities|get3DENLinesVisible|get3DENMissionAttribute|get3DENMouseOver|get3DENSelected|getAimingCoef|getAllEnvSoundControllers|getAllHitPointsDamage|getAllOwnedMines|getAllSoundControllers|getAmmoCargo|getAnimAimPrecision|getAnimSpeedCoef|getArray|getArtilleryAmmo|getArtilleryComputerSettings|getArtilleryETA|getAssignedCuratorLogic|getAssignedCuratorUnit|getBackpackCargo|getBleedingRemaining|getBurningValue|getCameraViewDirection|getCargoIndex|getCenterOfMass|getClientState|getClientStateNumber|getCompatiblePylonMagazines|getConnectedUAV|getContainerMaxLoad|getCursorObjectParams|getCustomAimCoef|getDammage|getDescription|getDir|getDirVisual|getDLCAssetsUsage|getDLCAssetsUsageByName|getDLCs|getDLCUsageTime|getEditorCamera|getEditorMode|getEditorObjectScope|getElevationOffset|getEngineTargetRpmRTD|getEnvSoundController|getFatigue|getFieldManualStartPage|getForcedFlagTexture|getFriend|getFSMVariable|getFuelCargo|getGroupIcon|getGroupIconParams|getGroupIcons|getHideFrom|getHit|getHitIndex|getHitPointDamage|getItemCargo|getMagazineCargo|getMarkerColor|getMarkerPos|getMarkerSize|getMarkerType|getMass|getMissionConfig|getMissionConfigValue|getMissionDLCs|getMissionLayerEntities|getMissionLayers|getModelInfo|getMousePosition|getMusicPlayedTime|getNumber|getObjectArgument|getObjectChildren|getObjectDLC|getObjectMaterials|getObjectProxy|getObjectTextures|getObjectType|getObjectViewDistance|getOxygenRemaining|getPersonUsedDLCs|getPilotCameraDirection|getPilotCameraPosition|getPilotCameraRotation|getPilotCameraTarget|getPlateNumber|getPlayerChannel|getPlayerScores|getPlayerUID|getPlayerUIDOld|getPos|getPosASL|getPosASLVisual|getPosASLW|getPosATL|getPosATLVisual|getPosVisual|getPosWorld|getPylonMagazines|getRelDir|getRelPos|getRemoteSensorsDisabled|getRepairCargo|getResolution|getRotorBrakeRTD|getShadowDistance|getShotParents|getSlingLoad|getSoundController|getSoundControllerResult|getSpeed|getStamina|getStatValue|getSuppression|getTerrainGrid|getTerrainHeightASL|getText|getTotalDLCUsageTime|getTrimOffsetRTD|getUnitLoadout|getUnitTrait|getUserMFDText|getUserMFDValue|getVariable|getVehicleCargo|getWeaponCargo|getWeaponSway|getWingsOrientationRTD|getWingsPositionRTD|getWPPos|glanceAt|globalChat|globalRadio|goggles|group|groupChat|groupFromNetId|groupIconSelectable|groupIconsVisible|groupId|groupOwner|groupRadio|groupSelectedUnits|groupSelectUnit|grpNull|gunner|gusts|halt|handgunItems|handgunMagazine|handgunWeapon|handsHit|hasInterface|hasPilotCamera|hasWeapon|hcAllGroups|hcGroupParams|hcLeader|hcRemoveAllGroups|hcRemoveGroup|hcSelected|hcSelectGroup|hcSetGroup|hcShowBar|hcShownBar|headgear|hideBody|hideObject|hideObjectGlobal|hideSelection|hint|hintC|hintCadet|hintSilent|hmd|hostMission|htmlLoad|HUDMovementLevels|humidity|image|importAllGroups|importance|in|inArea|inAreaArray|incapacitatedState|independent|inflame|inflamed|infoPanel|infoPanelComponentEnabled|infoPanelComponents|infoPanels|inGameUISetEventHandler|inheritsFrom|initAmbientLife|inPolygon|inputAction|inRangeOfArtillery|insertEditorObject|intersect|is3DEN|is3DENMultiplayer|isAbleToBreathe|isAgent|isAimPrecisionEnabled|isArray|isAutoHoverOn|isAutonomous|isAutoStartUpEnabledRTD|isAutotest|isAutoTrimOnRTD|isBleeding|isBurning|isClass|isCollisionLightOn|isCopilotEnabled|isDamageAllowed|isDedicated|isDLCAvailable|isEngineOn|isEqualTo|isEqualType|isEqualTypeAll|isEqualTypeAny|isEqualTypeArray|isEqualTypeParams|isFilePatchingEnabled|isFlashlightOn|isFlatEmpty|isForcedWalk|isFormationLeader|isGroupDeletedWhenEmpty|isHidden|isInRemainsCollector|isInstructorFigureEnabled|isIRLaserOn|isKeyActive|isKindOf|isLaserOn|isLightOn|isLocalized|isManualFire|isMarkedForCollection|isMultiplayer|isMultiplayerSolo|isNil|isNull|isNumber|isObjectHidden|isObjectRTD|isOnRoad|isPipEnabled|isPlayer|isRealTime|isRemoteExecuted|isRemoteExecutedJIP|isServer|isShowing3DIcons|isSimpleObject|isSprintAllowed|isStaminaEnabled|isSteamMission|isStreamFriendlyUIEnabled|isStressDamageEnabled|isText|isTouchingGround|isTurnedOut|isTutHintsEnabled|isUAVConnectable|isUAVConnected|isUIContext|isUniformAllowed|isVehicleCargo|isVehicleRadarOn|isVehicleSensorEnabled|isWalking|isWeaponDeployed|isWeaponRested|itemCargo|items|itemsWithMagazines|join|joinAs|joinAsSilent|joinSilent|joinString|kbAddDatabase|kbAddDatabaseTargets|kbAddTopic|kbHasTopic|kbReact|kbRemoveTopic|kbTell|kbWasSaid|keyImage|keyName|knowsAbout|land|landAt|landResult|language|laserTarget|lbAdd|lbClear|lbColor|lbColorRight|lbCurSel|lbData|lbDelete|lbIsSelected|lbPicture|lbPictureRight|lbSelection|lbSetColor|lbSetColorRight|lbSetCurSel|lbSetData|lbSetPicture|lbSetPictureColor|lbSetPictureColorDisabled|lbSetPictureColorSelected|lbSetPictureRight|lbSetPictureRightColor|lbSetPictureRightColorDisabled|lbSetPictureRightColorSelected|lbSetSelectColor|lbSetSelectColorRight|lbSetSelected|lbSetText|lbSetTextRight|lbSetTooltip|lbSetValue|lbSize|lbSort|lbSortByValue|lbText|lbTextRight|lbValue|leader|leaderboardDeInit|leaderboardGetRows|leaderboardInit|leaderboardRequestRowsFriends|leaderboardRequestRowsGlobal|leaderboardRequestRowsGlobalAroundUser|leaderboardsRequestUploadScore|leaderboardsRequestUploadScoreKeepBest|leaderboardState|leaveVehicle|libraryCredits|libraryDisclaimers|lifeState|lightAttachObject|lightDetachObject|lightIsOn|lightnings|limitSpeed|linearConversion|lineBreak|lineIntersects|lineIntersectsObjs|lineIntersectsSurfaces|lineIntersectsWith|linkItem|list|listObjects|listRemoteTargets|listVehicleSensors|ln|lnbAddArray|lnbAddColumn|lnbAddRow|lnbClear|lnbColor|lnbColorRight|lnbCurSelRow|lnbData|lnbDeleteColumn|lnbDeleteRow|lnbGetColumnsPosition|lnbPicture|lnbPictureRight|lnbSetColor|lnbSetColorRight|lnbSetColumnsPos|lnbSetCurSelRow|lnbSetData|lnbSetPicture|lnbSetPictureColor|lnbSetPictureColorRight|lnbSetPictureColorSelected|lnbSetPictureColorSelectedRight|lnbSetPictureRight|lnbSetText|lnbSetTextRight|lnbSetValue|lnbSize|lnbSort|lnbSortByValue|lnbText|lnbTextRight|lnbValue|load|loadAbs|loadBackpack|loadFile|loadGame|loadIdentity|loadMagazine|loadOverlay|loadStatus|loadUniform|loadVest|local|localize|locationNull|locationPosition|lock|lockCameraTo|lockCargo|lockDriver|locked|lockedCargo|lockedDriver|lockedTurret|lockIdentity|lockTurret|lockWP|log|logEntities|logNetwork|logNetworkTerminate|lookAt|lookAtPos|magazineCargo|magazines|magazinesAllTurrets|magazinesAmmo|magazinesAmmoCargo|magazinesAmmoFull|magazinesDetail|magazinesDetailBackpack|magazinesDetailUniform|magazinesDetailVest|magazinesTurret|magazineTurretAmmo|mapAnimAdd|mapAnimClear|mapAnimCommit|mapAnimDone|mapCenterOnCamera|mapGridPosition|markAsFinishedOnSteam|markerAlpha|markerBrush|markerColor|markerDir|markerPos|markerShape|markerSize|markerText|markerType|max|members|menuAction|menuAdd|menuChecked|menuClear|menuCollapse|menuData|menuDelete|menuEnable|menuEnabled|menuExpand|menuHover|menuPicture|menuSetAction|menuSetCheck|menuSetData|menuSetPicture|menuSetValue|menuShortcut|menuShortcutText|menuSize|menuSort|menuText|menuURL|menuValue|min|mineActive|mineDetectedBy|missionConfigFile|missionDifficulty|missionName|missionNamespace|missionStart|missionVersion|modelToWorld|modelToWorldVisual|modelToWorldVisualWorld|modelToWorldWorld|modParams|moonIntensity|moonPhase|morale|move|move3DENCamera|moveInAny|moveInCargo|moveInCommander|moveInDriver|moveInGunner|moveInTurret|moveObjectToEnd|moveOut|moveTime|moveTo|moveToCompleted|moveToFailed|musicVolume|name|nameSound|nearEntities|nearestBuilding|nearestLocation|nearestLocations|nearestLocationWithDubbing|nearestObject|nearestObjects|nearestTerrainObjects|nearObjects|nearObjectsReady|nearRoads|nearSupplies|nearTargets|needReload|netId|netObjNull|newOverlay|nextMenuItemIndex|nextWeatherChange|nMenuItems|numberOfEnginesRTD|numberToDate|objectCurators|objectFromNetId|objectParent|objNull|objStatus|onBriefingGear|onBriefingGroup|onBriefingNotes|onBriefingPlan|onBriefingTeamSwitch|onCommandModeChanged|onDoubleClick|onEachFrame|onGroupIconClick|onGroupIconOverEnter|onGroupIconOverLeave|onHCGroupSelectionChanged|onMapSingleClick|onPlayerConnected|onPlayerDisconnected|onPreloadFinished|onPreloadStarted|onShowNewObject|onTeamSwitch|openCuratorInterface|openDLCPage|openDSInterface|openMap|openSteamApp|openYoutubeVideo|opfor|orderGetIn|overcast|overcastForecast|owner|param|params|parseNumber|parseSimpleArray|parseText|parsingNamespace|particlesQuality|pi|pickWeaponPool|pitch|pixelGrid|pixelGridBase|pixelGridNoUIScale|pixelH|pixelW|playableSlotsNumber|playableUnits|playAction|playActionNow|player|playerRespawnTime|playerSide|playersNumber|playGesture|playMission|playMove|playMoveNow|playMusic|playScriptedMission|playSound|playSound3D|position|positionCameraToWorld|posScreenToWorld|posWorldToScreen|ppEffectAdjust|ppEffectCommit|ppEffectCommitted|ppEffectCreate|ppEffectDestroy|ppEffectEnable|ppEffectEnabled|ppEffectForceInNVG|precision|preloadCamera|preloadObject|preloadSound|preloadTitleObj|preloadTitleRsc|primaryWeapon|primaryWeaponItems|primaryWeaponMagazine|priority|processDiaryLink|processInitCommands|productVersion|profileName|profileNamespace|profileNameSteam|progressLoadingScreen|progressPosition|progressSetPosition|publicVariable|publicVariableClient|publicVariableServer|pushBack|pushBackUnique|putWeaponPool|queryItemsPool|queryMagazinePool|queryWeaponPool|rad|radioChannelAdd|radioChannelCreate|radioChannelRemove|radioChannelSetCallSign|radioChannelSetLabel|radioVolume|rain|rainbow|random|rank|rankId|rating|rectangular|registeredTasks|registerTask|reload|reloadEnabled|remoteControl|remoteExec|remoteExecCall|remoteExecutedOwner|remove3DENConnection|remove3DENEventHandler|remove3DENLayer|removeAction|removeAll3DENEventHandlers|removeAllActions|removeAllAssignedItems|removeAllContainers|removeAllCuratorAddons|removeAllCuratorCameraAreas|removeAllCuratorEditingAreas|removeAllEventHandlers|removeAllHandgunItems|removeAllItems|removeAllItemsWithMagazines|removeAllMissionEventHandlers|removeAllMPEventHandlers|removeAllMusicEventHandlers|removeAllOwnedMines|removeAllPrimaryWeaponItems|removeAllWeapons|removeBackpack|removeBackpackGlobal|removeCuratorAddons|removeCuratorCameraArea|removeCuratorEditableObjects|removeCuratorEditingArea|removeDrawIcon|removeDrawLinks|removeEventHandler|removeFromRemainsCollector|removeGoggles|removeGroupIcon|removeHandgunItem|removeHeadgear|removeItem|removeItemFromBackpack|removeItemFromUniform|removeItemFromVest|removeItems|removeMagazine|removeMagazineGlobal|removeMagazines|removeMagazinesTurret|removeMagazineTurret|removeMenuItem|removeMissionEventHandler|removeMPEventHandler|removeMusicEventHandler|removeOwnedMine|removePrimaryWeaponItem|removeSecondaryWeaponItem|removeSimpleTask|removeSwitchableUnit|removeTeamMember|removeUniform|removeVest|removeWeapon|removeWeaponAttachmentCargo|removeWeaponCargo|removeWeaponGlobal|removeWeaponTurret|reportRemoteTarget|requiredVersion|resetCamShake|resetSubgroupDirection|resistance|resize|resources|respawnVehicle|restartEditorCamera|reveal|revealMine|reverse|reversedMouseY|roadAt|roadsConnectedTo|roleDescription|ropeAttachedObjects|ropeAttachedTo|ropeAttachEnabled|ropeAttachTo|ropeCreate|ropeCut|ropeDestroy|ropeDetach|ropeEndPosition|ropeLength|ropes|ropeUnwind|ropeUnwound|rotorsForcesRTD|rotorsRpmRTD|round|runInitScript|safeZoneH|safeZoneW|safeZoneWAbs|safeZoneX|safeZoneXAbs|safeZoneY|save3DENInventory|saveGame|saveIdentity|saveJoysticks|saveOverlay|saveProfileNamespace|saveStatus|saveVar|savingEnabled|say|say2D|say3D|score|scoreSide|screenshot|screenToWorld|scriptDone|scriptName|scriptNull|scudState|secondaryWeapon|secondaryWeaponItems|secondaryWeaponMagazine|select|selectBestPlaces|selectDiarySubject|selectedEditorObjects|selectEditorObject|selectionNames|selectionPosition|selectLeader|selectMax|selectMin|selectNoPlayer|selectPlayer|selectRandom|selectRandomWeighted|selectWeapon|selectWeaponTurret|sendAUMessage|sendSimpleCommand|sendTask|sendTaskResult|sendUDPMessage|serverCommand|serverCommandAvailable|serverCommandExecutable|serverName|serverTime|set|set3DENAttribute|set3DENAttributes|set3DENGrid|set3DENIconsVisible|set3DENLayer|set3DENLinesVisible|set3DENLogicType|set3DENMissionAttribute|set3DENMissionAttributes|set3DENModelsVisible|set3DENObjectType|set3DENSelected|setAccTime|setActualCollectiveRTD|setAirplaneThrottle|setAirportSide|setAmmo|setAmmoCargo|setAmmoOnPylon|setAnimSpeedCoef|setAperture|setApertureNew|setArmoryPoints|setAttributes|setAutonomous|setBehaviour|setBleedingRemaining|setBrakesRTD|setCameraInterest|setCamShakeDefParams|setCamShakeParams|setCamUseTI|setCaptive|setCenterOfMass|setCollisionLight|setCombatMode|setCompassOscillation|setConvoySeparation|setCuratorCameraAreaCeiling|setCuratorCoef|setCuratorEditingAreaType|setCuratorWaypointCost|setCurrentChannel|setCurrentTask|setCurrentWaypoint|setCustomAimCoef|setCustomWeightRTD|setDamage|setDammage|setDate|setDebriefingText|setDefaultCamera|setDestination|setDetailMapBlendPars|setDir|setDirection|setDrawIcon|setDriveOnPath|setDropInterval|setDynamicSimulationDistance|setDynamicSimulationDistanceCoef|setEditorMode|setEditorObjectScope|setEffectCondition|setEngineRpmRTD|setFace|setFaceAnimation|setFatigue|setFeatureType|setFlagAnimationPhase|setFlagOwner|setFlagSide|setFlagTexture|setFog|setForceGeneratorRTD|setFormation|setFormationTask|setFormDir|setFriend|setFromEditor|setFSMVariable|setFuel|setFuelCargo|setGroupIcon|setGroupIconParams|setGroupIconsSelectable|setGroupIconsVisible|setGroupId|setGroupIdGlobal|setGroupOwner|setGusts|setHideBehind|setHit|setHitIndex|setHitPointDamage|setHorizonParallaxCoef|setHUDMovementLevels|setIdentity|setImportance|setInfoPanel|setLeader|setLightAmbient|setLightAttenuation|setLightBrightness|setLightColor|setLightDayLight|setLightFlareMaxDistance|setLightFlareSize|setLightIntensity|setLightnings|setLightUseFlare|setLocalWindParams|setMagazineTurretAmmo|setMarkerAlpha|setMarkerAlphaLocal|setMarkerBrush|setMarkerBrushLocal|setMarkerColor|setMarkerColorLocal|setMarkerDir|setMarkerDirLocal|setMarkerPos|setMarkerPosLocal|setMarkerShape|setMarkerShapeLocal|setMarkerSize|setMarkerSizeLocal|setMarkerText|setMarkerTextLocal|setMarkerType|setMarkerTypeLocal|setMass|setMimic|setMousePosition|setMusicEffect|setMusicEventHandler|setName|setNameSound|setObjectArguments|setObjectMaterial|setObjectMaterialGlobal|setObjectProxy|setObjectTexture|setObjectTextureGlobal|setObjectViewDistance|setOvercast|setOwner|setOxygenRemaining|setParticleCircle|setParticleClass|setParticleFire|setParticleParams|setParticleRandom|setPilotCameraDirection|setPilotCameraRotation|setPilotCameraTarget|setPilotLight|setPiPEffect|setPitch|setPlateNumber|setPlayable|setPlayerRespawnTime|setPos|setPosASL|setPosASL2|setPosASLW|setPosATL|setPosition|setPosWorld|setPylonLoadOut|setPylonsPriority|setRadioMsg|setRain|setRainbow|setRandomLip|setRank|setRectangular|setRepairCargo|setRotorBrakeRTD|setShadowDistance|setShotParents|setSide|setSimpleTaskAlwaysVisible|setSimpleTaskCustomData|setSimpleTaskDescription|setSimpleTaskDestination|setSimpleTaskTarget|setSimpleTaskType|setSimulWeatherLayers|setSize|setSkill|setSlingLoad|setSoundEffect|setSpeaker|setSpeech|setSpeedMode|setStamina|setStaminaScheme|setStatValue|setSuppression|setSystemOfUnits|setTargetAge|setTaskMarkerOffset|setTaskResult|setTaskState|setTerrainGrid|setText|setTimeMultiplier|setTitleEffect|setToneMapping|setToneMappingParams|setTrafficDensity|setTrafficDistance|setTrafficGap|setTrafficSpeed|setTriggerActivation|setTriggerArea|setTriggerStatements|setTriggerText|setTriggerTimeout|setTriggerType|setType|setUnconscious|setUnitAbility|setUnitLoadout|setUnitPos|setUnitPosWeak|setUnitRank|setUnitRecoilCoefficient|setUnitTrait|setUnloadInCombat|setUserActionText|setUserMFDText|setUserMFDValue|setVariable|setVectorDir|setVectorDirAndUp|setVectorUp|setVehicleAmmo|setVehicleAmmoDef|setVehicleArmor|setVehicleCargo|setVehicleId|setVehicleInit|setVehicleLock|setVehiclePosition|setVehicleRadar|setVehicleReceiveRemoteTargets|setVehicleReportOwnPosition|setVehicleReportRemoteTargets|setVehicleTIPars|setVehicleVarName|setVelocity|setVelocityModelSpace|setVelocityTransformation|setViewDistance|setVisibleIfTreeCollapsed|setWantedRpmRTD|setWaves|setWaypointBehaviour|setWaypointCombatMode|setWaypointCompletionRadius|setWaypointDescription|setWaypointForceBehaviour|setWaypointFormation|setWaypointHousePosition|setWaypointLoiterRadius|setWaypointLoiterType|setWaypointName|setWaypointPosition|setWaypointScript|setWaypointSpeed|setWaypointStatements|setWaypointTimeout|setWaypointType|setWaypointVisible|setWeaponReloadingTime|setWind|setWindDir|setWindForce|setWindStr|setWingForceScaleRTD|setWPPos|show3DIcons|showChat|showCinemaBorder|showCommandingMenu|showCompass|showCuratorCompass|showGPS|showHUD|showLegend|showMap|shownArtilleryComputer|shownChat|shownCompass|shownCuratorCompass|showNewEditorObject|shownGPS|shownHUD|shownMap|shownPad|shownRadio|shownScoretable|shownUAVFeed|shownWarrant|shownWatch|showPad|showRadio|showScoretable|showSubtitles|showUAVFeed|showWarrant|showWatch|showWaypoint|showWaypoints|side|sideAmbientLife|sideChat|sideEmpty|sideEnemy|sideFriendly|sideLogic|sideRadio|sideUnknown|simpleTasks|simulationEnabled|simulCloudDensity|simulCloudOcclusion|simulInClouds|simulWeatherSync|sin|size|sizeOf|skill|skillFinal|skipTime|sleep|sliderPosition|sliderRange|sliderSetPosition|sliderSetRange|sliderSetSpeed|sliderSpeed|slingLoadAssistantShown|soldierMagazines|someAmmo|sort|soundVolume|speaker|speed|speedMode|splitString|sqrt|squadParams|stance|startLoadingScreen|stop|stopEngineRTD|stopped|str|sunOrMoon|supportInfo|suppressFor|surfaceIsWater|surfaceNormal|surfaceType|swimInDepth|switchableUnits|switchAction|switchCamera|switchGesture|switchLight|switchMove|synchronizedObjects|synchronizedTriggers|synchronizedWaypoints|synchronizeObjectsAdd|synchronizeObjectsRemove|synchronizeTrigger|synchronizeWaypoint|systemChat|systemOfUnits|tan|targetKnowledge|targets|targetsAggregate|targetsQuery|taskAlwaysVisible|taskChildren|taskCompleted|taskCustomData|taskDescription|taskDestination|taskHint|taskMarkerOffset|taskNull|taskParent|taskResult|taskState|taskType|teamMember|teamMemberNull|teamName|teams|teamSwitch|teamSwitchEnabled|teamType|terminate|terrainIntersect|terrainIntersectASL|terrainIntersectAtASL|text|textLog|textLogFormat|tg|time|timeMultiplier|titleCut|titleFadeOut|titleObj|titleRsc|titleText|toArray|toFixed|toLower|toString|toUpper|triggerActivated|triggerActivation|triggerArea|triggerAttachedVehicle|triggerAttachObject|triggerAttachVehicle|triggerDynamicSimulation|triggerStatements|triggerText|triggerTimeout|triggerTimeoutCurrent|triggerType|turretLocal|turretOwner|turretUnit|tvAdd|tvClear|tvCollapse|tvCollapseAll|tvCount|tvCurSel|tvData|tvDelete|tvExpand|tvExpandAll|tvPicture|tvPictureRight|tvSetColor|tvSetCurSel|tvSetData|tvSetPicture|tvSetPictureColor|tvSetPictureColorDisabled|tvSetPictureColorSelected|tvSetPictureRight|tvSetPictureRightColor|tvSetPictureRightColorDisabled|tvSetPictureRightColorSelected|tvSetSelectColor|tvSetText|tvSetTooltip|tvSetValue|tvSort|tvSortByValue|tvText|tvTooltip|tvValue|type|typeName|typeOf|UAVControl|uiNamespace|uiSleep|unassignCurator|unassignItem|unassignTeam|unassignVehicle|underwater|uniform|uniformContainer|uniformItems|uniformMagazines|unitAddons|unitAimPosition|unitAimPositionVisual|unitBackpack|unitIsUAV|unitPos|unitReady|unitRecoilCoefficient|units|unitsBelowHeight|unlinkItem|unlockAchievement|unregisterTask|updateDrawIcon|updateMenuItem|updateObjectTree|useAIOperMapObstructionTest|useAISteeringComponent|useAudioTimeForMoves|userInputDisabled|vectorAdd|vectorCos|vectorCrossProduct|vectorDiff|vectorDir|vectorDirVisual|vectorDistance|vectorDistanceSqr|vectorDotProduct|vectorFromTo|vectorMagnitude|vectorMagnitudeSqr|vectorModelToWorld|vectorModelToWorldVisual|vectorMultiply|vectorNormalized|vectorUp|vectorUpVisual|vectorWorldToModel|vectorWorldToModelVisual|vehicle|vehicleCargoEnabled|vehicleChat|vehicleRadio|vehicleReceiveRemoteTargets|vehicleReportOwnPosition|vehicleReportRemoteTargets|vehicles|vehicleVarName|velocity|velocityModelSpace|verifySignature|vest|vestContainer|vestItems|vestMagazines|viewDistance|visibleCompass|visibleGPS|visibleMap|visiblePosition|visiblePositionASL|visibleScoretable|visibleWatch|waitUntil|waves|waypointAttachedObject|waypointAttachedVehicle|waypointAttachObject|waypointAttachVehicle|waypointBehaviour|waypointCombatMode|waypointCompletionRadius|waypointDescription|waypointForceBehaviour|waypointFormation|waypointHousePosition|waypointLoiterRadius|waypointLoiterType|waypointName|waypointPosition|waypoints|waypointScript|waypointsEnabledUAV|waypointShow|waypointSpeed|waypointStatements|waypointTimeout|waypointTimeoutCurrent|waypointType|waypointVisible|weaponAccessories|weaponAccessoriesCargo|weaponCargo|weaponDirection|weaponInertia|weaponLowered|weapons|weaponsItems|weaponsItemsCargo|weaponState|weaponsTurret|weightRTD|west|WFSideText|wind|windDir|windRTD|windStr|wingsForcesRTD|worldName|worldSize|worldToModel|worldToModelVisual|worldToScreen)\b/i,
    number: /(?:\$|\b0x)[\da-f]+\b|(?:\B\.\d+|\b\d+(?:\.\d+)?)(?:e[+-]?\d+)?\b/i,
    operator: /##|>>|&&|\|\||[!=<>]=?|[-+*/%#^]|\b(?:and|mod|not|or)\b/i,
    "magic-variable": {
      pattern: /\b(?:this|thisList|thisTrigger|_exception|_fnc_scriptName|_fnc_scriptNameParent|_forEachIndex|_this|_thisEventHandler|_thisFSM|_thisScript|_x)\b/i,
      alias: "keyword"
    },
    constant: /\bDIK(?:_[a-z\d]+)+\b/i
  }), e.languages.insertBefore("sqf", "string", {
    macro: {
      pattern: /(^[ \t]*)#[a-z](?:[^\r\n\\]|\\(?:\r\n|[\s\S]))*/im,
      lookbehind: !0,
      greedy: !0,
      alias: "property",
      inside: {
        directive: {
          pattern: /#[a-z]+\b/i,
          alias: "keyword"
        },
        comment: e.languages.sqf.comment
      }
    }
  }), delete e.languages.sqf["class-name"];
}

sqf.displayName = "sqf", sqf.aliases = [];
var squirrel_1 = squirrel;

function squirrel(e) {
  e.languages.squirrel = e.languages.extend("clike", {
    comment: [e.languages.clike.comment[0], {
      pattern: /(^|[^\\:])(?:\/\/|#).*/,
      lookbehind: !0,
      greedy: !0
    }],
    string: {
      pattern: /(^|[^\\"'@])(?:@"(?:[^"]|"")*"(?!")|"(?:[^\\\r\n"]|\\.)*")/,
      lookbehind: !0,
      greedy: !0
    },
    "class-name": {
      pattern: /(\b(?:class|enum|extends|instanceof)\s+)\w+(?:\.\w+)*/,
      lookbehind: !0,
      inside: {
        punctuation: /\./
      }
    },
    keyword: /\b(?:__FILE__|__LINE__|base|break|case|catch|class|clone|const|constructor|continue|default|delete|else|enum|extends|for|foreach|function|if|in|instanceof|local|null|resume|return|static|switch|this|throw|try|typeof|while|yield)\b/,
    number: /\b(?:0x[0-9a-fA-F]+|\d+(?:\.(?:\d+|[eE][+-]?\d+))?)\b/,
    operator: /\+\+|--|<=>|<[-<]|>>>?|&&?|\|\|?|[-+*/%!=<>]=?|[~^]|::?/,
    punctuation: /[(){}\[\],;.]/
  }), e.languages.insertBefore("squirrel", "string", {
    char: {
      pattern: /(^|[^\\"'])'(?:[^\\']|\\(?:[xuU][0-9a-fA-F]{0,8}|[\s\S]))'/,
      lookbehind: !0,
      greedy: !0
    }
  }), e.languages.insertBefore("squirrel", "operator", {
    "attribute-punctuation": {
      pattern: /<\/|\/>/,
      alias: "important"
    },
    lambda: {
      pattern: /@(?=\()/,
      alias: "operator"
    }
  });
}

squirrel.displayName = "squirrel", squirrel.aliases = [];
var stan_1 = stan;

function stan(e) {
  !function (e) {
    var t = /\b(?:algebra_solver|algebra_solver_newton|integrate_1d|integrate_ode|integrate_ode_bdf|integrate_ode_rk45|map_rect|ode_(?:adams|bdf|ckrk|rk45)(?:_tol)?|ode_adjoint_tol_ctl|reduce_sum|reduce_sum_static)\b/;
    e.languages.stan = {
      comment: /\/\/.*|\/\*[\s\S]*?\*\/|#(?!include).*/,
      string: {
        pattern: /"[\x20\x21\x23-\x5B\x5D-\x7E]*"/,
        greedy: !0
      },
      directive: {
        pattern: /^([ \t]*)#include\b.*/m,
        lookbehind: !0,
        alias: "property"
      },
      "function-arg": {
        pattern: RegExp("(" + t.source + /\s*\(\s*/.source + ")" + /[a-zA-Z]\w*/.source),
        lookbehind: !0,
        alias: "function"
      },
      constraint: {
        pattern: /(\b(?:int|matrix|real|row_vector|vector)\s*)<[^<>]*>/,
        lookbehind: !0,
        inside: {
          expression: {
            pattern: /(=\s*)\S(?:\S|\s+(?!\s))*?(?=\s*(?:>$|,\s*\w+\s*=))/,
            lookbehind: !0,
            inside: null
          },
          property: /\b[a-z]\w*(?=\s*=)/i,
          operator: /=/,
          punctuation: /^<|>$|,/
        }
      },
      keyword: [{
        pattern: /\bdata(?=\s*\{)|\b(?:functions|generated|model|parameters|quantities|transformed)\b/,
        alias: "program-block"
      }, /\b(?:array|break|cholesky_factor_corr|cholesky_factor_cov|complex|continue|corr_matrix|cov_matrix|data|else|for|if|in|increment_log_prob|int|matrix|ordered|positive_ordered|print|real|reject|return|row_vector|simplex|target|unit_vector|vector|void|while)\b/, t],
      function: /\b[a-z]\w*(?=\s*\()/i,
      number: /(?:\b\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\B\.\d+(?:_\d+)*)(?:E[+-]?\d+(?:_\d+)*)?i?(?!\w)/i,
      boolean: /\b(?:false|true)\b/,
      operator: /<-|\.[*/]=?|\|\|?|&&|[!=<>+\-*/]=?|['^%~?:]/,
      punctuation: /[()\[\]{},;]/
    }, e.languages.stan.constraint.inside.expression.inside = e.languages.stan;
  }(e);
}

stan.displayName = "stan", stan.aliases = [];
var stylus_1 = stylus;

function stylus(e) {
  !function (e) {
    var t = {
      pattern: /(\b\d+)(?:%|[a-z]+)/,
      lookbehind: !0
    },
        r = {
      pattern: /(^|[^\w.-])-?(?:\d+(?:\.\d+)?|\.\d+)/,
      lookbehind: !0
    },
        n = {
      comment: {
        pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|\/\/.*)/,
        lookbehind: !0
      },
      url: {
        pattern: /\burl\((["']?).*?\1\)/i,
        greedy: !0
      },
      string: {
        pattern: /("|')(?:(?!\1)[^\\\r\n]|\\(?:\r\n|[\s\S]))*\1/,
        greedy: !0
      },
      interpolation: null,
      func: null,
      important: /\B!(?:important|optional)\b/i,
      keyword: {
        pattern: /(^|\s+)(?:(?:else|for|if|return|unless)(?=\s|$)|@[\w-]+)/,
        lookbehind: !0
      },
      hexcode: /#[\da-f]{3,6}/i,
      color: [/\b(?:AliceBlue|AntiqueWhite|Aqua|Aquamarine|Azure|Beige|Bisque|Black|BlanchedAlmond|Blue|BlueViolet|Brown|BurlyWood|CadetBlue|Chartreuse|Chocolate|Coral|CornflowerBlue|Cornsilk|Crimson|Cyan|DarkBlue|DarkCyan|DarkGoldenRod|DarkGr[ae]y|DarkGreen|DarkKhaki|DarkMagenta|DarkOliveGreen|DarkOrange|DarkOrchid|DarkRed|DarkSalmon|DarkSeaGreen|DarkSlateBlue|DarkSlateGr[ae]y|DarkTurquoise|DarkViolet|DeepPink|DeepSkyBlue|DimGr[ae]y|DodgerBlue|FireBrick|FloralWhite|ForestGreen|Fuchsia|Gainsboro|GhostWhite|Gold|GoldenRod|Gr[ae]y|Green|GreenYellow|HoneyDew|HotPink|IndianRed|Indigo|Ivory|Khaki|Lavender|LavenderBlush|LawnGreen|LemonChiffon|LightBlue|LightCoral|LightCyan|LightGoldenRodYellow|LightGr[ae]y|LightGreen|LightPink|LightSalmon|LightSeaGreen|LightSkyBlue|LightSlateGr[ae]y|LightSteelBlue|LightYellow|Lime|LimeGreen|Linen|Magenta|Maroon|MediumAquaMarine|MediumBlue|MediumOrchid|MediumPurple|MediumSeaGreen|MediumSlateBlue|MediumSpringGreen|MediumTurquoise|MediumVioletRed|MidnightBlue|MintCream|MistyRose|Moccasin|NavajoWhite|Navy|OldLace|Olive|OliveDrab|Orange|OrangeRed|Orchid|PaleGoldenRod|PaleGreen|PaleTurquoise|PaleVioletRed|PapayaWhip|PeachPuff|Peru|Pink|Plum|PowderBlue|Purple|Red|RosyBrown|RoyalBlue|SaddleBrown|Salmon|SandyBrown|SeaGreen|SeaShell|Sienna|Silver|SkyBlue|SlateBlue|SlateGr[ae]y|Snow|SpringGreen|SteelBlue|Tan|Teal|Thistle|Tomato|Transparent|Turquoise|Violet|Wheat|White|WhiteSmoke|Yellow|YellowGreen)\b/i, {
        pattern: /\b(?:hsl|rgb)\(\s*\d{1,3}\s*,\s*\d{1,3}%?\s*,\s*\d{1,3}%?\s*\)\B|\b(?:hsl|rgb)a\(\s*\d{1,3}\s*,\s*\d{1,3}%?\s*,\s*\d{1,3}%?\s*,\s*(?:0|0?\.\d+|1)\s*\)\B/i,
        inside: {
          unit: t,
          number: r,
          function: /[\w-]+(?=\()/,
          punctuation: /[(),]/
        }
      }],
      entity: /\\[\da-f]{1,8}/i,
      unit: t,
      boolean: /\b(?:false|true)\b/,
      operator: [/~|[+!\/%<>?=]=?|[-:]=|\*[*=]?|\.{2,3}|&&|\|\||\B-\B|\b(?:and|in|is(?: a| defined| not|nt)?|not|or)\b/],
      number: r,
      punctuation: /[{}()\[\];:,]/
    };
    n.interpolation = {
      pattern: /\{[^\r\n}:]+\}/,
      alias: "variable",
      inside: {
        delimiter: {
          pattern: /^\{|\}$/,
          alias: "punctuation"
        },
        rest: n
      }
    }, n.func = {
      pattern: /[\w-]+\([^)]*\).*/,
      inside: {
        function: /^[^(]+/,
        rest: n
      }
    }, e.languages.stylus = {
      "atrule-declaration": {
        pattern: /(^[ \t]*)@.+/m,
        lookbehind: !0,
        inside: {
          atrule: /^@[\w-]+/,
          rest: n
        }
      },
      "variable-declaration": {
        pattern: /(^[ \t]*)[\w$-]+\s*.?=[ \t]*(?:\{[^{}]*\}|\S.*|$)/m,
        lookbehind: !0,
        inside: {
          variable: /^\S+/,
          rest: n
        }
      },
      statement: {
        pattern: /(^[ \t]*)(?:else|for|if|return|unless)[ \t].+/m,
        lookbehind: !0,
        inside: {
          keyword: /^\S+/,
          rest: n
        }
      },
      "property-declaration": {
        pattern: /((?:^|\{)([ \t]*))(?:[\w-]|\{[^}\r\n]+\})+(?:\s*:\s*|[ \t]+)(?!\s)[^{\r\n]*(?:;|[^{\r\n,]$(?!(?:\r?\n|\r)(?:\{|\2[ \t])))/m,
        lookbehind: !0,
        inside: {
          property: {
            pattern: /^[^\s:]+/,
            inside: {
              interpolation: n.interpolation
            }
          },
          rest: n
        }
      },
      selector: {
        pattern: /(^[ \t]*)(?:(?=\S)(?:[^{}\r\n:()]|::?[\w-]+(?:\([^)\r\n]*\)|(?![\w-]))|\{[^}\r\n]+\})+)(?:(?:\r?\n|\r)(?:\1(?:(?=\S)(?:[^{}\r\n:()]|::?[\w-]+(?:\([^)\r\n]*\)|(?![\w-]))|\{[^}\r\n]+\})+)))*(?:,$|\{|(?=(?:\r?\n|\r)(?:\{|\1[ \t])))/m,
        lookbehind: !0,
        inside: {
          interpolation: n.interpolation,
          comment: n.comment,
          punctuation: /[{},]/
        }
      },
      func: n.func,
      string: n.string,
      comment: {
        pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|\/\/.*)/,
        lookbehind: !0,
        greedy: !0
      },
      interpolation: n.interpolation,
      punctuation: /[{}()\[\];:.]/
    };
  }(e);
}

stylus.displayName = "stylus", stylus.aliases = [];
var swift_1 = swift;

function swift(e) {
  e.languages.swift = {
    comment: {
      pattern: /(^|[^\\:])(?:\/\/.*|\/\*(?:[^/*]|\/(?!\*)|\*(?!\/)|\/\*(?:[^*]|\*(?!\/))*\*\/)*\*\/)/,
      lookbehind: !0,
      greedy: !0
    },
    "string-literal": [{
      pattern: RegExp(/(^|[^"#])/.source + "(?:" + /"(?:\\(?:\((?:[^()]|\([^()]*\))*\)|\r\n|[^(])|[^\\\r\n"])*"/.source + "|" + /"""(?:\\(?:\((?:[^()]|\([^()]*\))*\)|[^(])|[^\\"]|"(?!""))*"""/.source + ")" + /(?!["#])/.source),
      lookbehind: !0,
      greedy: !0,
      inside: {
        interpolation: {
          pattern: /(\\\()(?:[^()]|\([^()]*\))*(?=\))/,
          lookbehind: !0,
          inside: null
        },
        "interpolation-punctuation": {
          pattern: /^\)|\\\($/,
          alias: "punctuation"
        },
        punctuation: /\\(?=[\r\n])/,
        string: /[\s\S]+/
      }
    }, {
      pattern: RegExp(/(^|[^"#])(#+)/.source + "(?:" + /"(?:\\(?:#+\((?:[^()]|\([^()]*\))*\)|\r\n|[^#])|[^\\\r\n])*?"/.source + "|" + /"""(?:\\(?:#+\((?:[^()]|\([^()]*\))*\)|[^#])|[^\\])*?"""/.source + ")\\2"),
      lookbehind: !0,
      greedy: !0,
      inside: {
        interpolation: {
          pattern: /(\\#+\()(?:[^()]|\([^()]*\))*(?=\))/,
          lookbehind: !0,
          inside: null
        },
        "interpolation-punctuation": {
          pattern: /^\)|\\#+\($/,
          alias: "punctuation"
        },
        string: /[\s\S]+/
      }
    }],
    directive: {
      pattern: RegExp(/#/.source + "(?:" + /(?:elseif|if)\b/.source + "(?:[ \t]*" + /(?:![ \t]*)?(?:\b\w+\b(?:[ \t]*\((?:[^()]|\([^()]*\))*\))?|\((?:[^()]|\([^()]*\))*\))(?:[ \t]*(?:&&|\|\|))?/.source + ")+|" + /(?:else|endif)\b/.source + ")"),
      alias: "property",
      inside: {
        "directive-name": /^#\w+/,
        boolean: /\b(?:false|true)\b/,
        number: /\b\d+(?:\.\d+)*\b/,
        operator: /!|&&|\|\||[<>]=?/,
        punctuation: /[(),]/
      }
    },
    literal: {
      pattern: /#(?:colorLiteral|column|dsohandle|file(?:ID|Literal|Path)?|function|imageLiteral|line)\b/,
      alias: "constant"
    },
    "other-directive": {
      pattern: /#\w+\b/,
      alias: "property"
    },
    attribute: {
      pattern: /@\w+/,
      alias: "atrule"
    },
    "function-definition": {
      pattern: /(\bfunc\s+)\w+/,
      lookbehind: !0,
      alias: "function"
    },
    label: {
      pattern: /\b(break|continue)\s+\w+|\b[a-zA-Z_]\w*(?=\s*:\s*(?:for|repeat|while)\b)/,
      lookbehind: !0,
      alias: "important"
    },
    keyword: /\b(?:Any|Protocol|Self|Type|actor|as|assignment|associatedtype|associativity|async|await|break|case|catch|class|continue|convenience|default|defer|deinit|didSet|do|dynamic|else|enum|extension|fallthrough|fileprivate|final|for|func|get|guard|higherThan|if|import|in|indirect|infix|init|inout|internal|is|isolated|lazy|left|let|lowerThan|mutating|none|nonisolated|nonmutating|open|operator|optional|override|postfix|precedencegroup|prefix|private|protocol|public|repeat|required|rethrows|return|right|safe|self|set|some|static|struct|subscript|super|switch|throw|throws|try|typealias|unowned|unsafe|var|weak|where|while|willSet)\b/,
    boolean: /\b(?:false|true)\b/,
    nil: {
      pattern: /\bnil\b/,
      alias: "constant"
    },
    "short-argument": /\$\d+\b/,
    omit: {
      pattern: /\b_\b/,
      alias: "keyword"
    },
    number: /\b(?:[\d_]+(?:\.[\de_]+)?|0x[a-f0-9_]+(?:\.[a-f0-9p_]+)?|0b[01_]+|0o[0-7_]+)\b/i,
    "class-name": /\b[A-Z](?:[A-Z_\d]*[a-z]\w*)?\b/,
    function: /\b[a-z_]\w*(?=\s*\()/i,
    constant: /\b(?:[A-Z_]{2,}|k[A-Z][A-Za-z_]+)\b/,
    operator: /[-+*/%=!<>&|^~?]+|\.[.\-+*/%=!<>&|^~?]+/,
    punctuation: /[{}[\]();,.:\\]/
  }, e.languages.swift["string-literal"].forEach(function (t) {
    t.inside.interpolation.inside = e.languages.swift;
  });
}

swift.displayName = "swift", swift.aliases = [];
var systemd_1 = systemd;

function systemd(e) {
  !function (e) {
    var t = {
      pattern: /^[;#].*/m,
      greedy: !0
    },
        r = /"(?:[^\r\n"\\]|\\(?:[^\r]|\r\n?))*"(?!\S)/.source;
    e.languages.systemd = {
      comment: t,
      section: {
        pattern: /^\[[^\n\r\[\]]*\](?=[ \t]*$)/m,
        greedy: !0,
        inside: {
          punctuation: /^\[|\]$/,
          "section-name": {
            pattern: /[\s\S]+/,
            alias: "selector"
          }
        }
      },
      key: {
        pattern: /^[^\s=]+(?=[ \t]*=)/m,
        greedy: !0,
        alias: "attr-name"
      },
      value: {
        pattern: RegExp(/(=[ \t]*(?!\s))/.source + "(?:" + r + '|(?=[^"\r\n]))(?:' + /[^\s\\]/.source + '|[ \t]+(?:(?![ \t"])|' + r + ")|" + /\\[\r\n]+(?:[#;].*[\r\n]+)*(?![#;])/.source + ")*"),
        lookbehind: !0,
        greedy: !0,
        alias: "attr-value",
        inside: {
          comment: t,
          quoted: {
            pattern: RegExp(/(^|\s)/.source + r),
            lookbehind: !0,
            greedy: !0
          },
          punctuation: /\\$/m,
          boolean: {
            pattern: /^(?:false|no|off|on|true|yes)$/,
            greedy: !0
          }
        }
      },
      punctuation: /=/
    };
  }(e);
}

systemd.displayName = "systemd", systemd.aliases = [];
var t4Templating_1 = t4Templating;

function t4Templating(e) {
  !function (e) {
    function t(e, t, r) {
      return {
        pattern: RegExp("<#" + e + "[\\s\\S]*?#>"),
        alias: "block",
        inside: {
          delimiter: {
            pattern: RegExp("^<#" + e + "|#>$"),
            alias: "important"
          },
          content: {
            pattern: /[\s\S]+/,
            inside: t,
            alias: r
          }
        }
      };
    }

    e.languages["t4-templating"] = Object.defineProperty({}, "createT4", {
      value: function value(r) {
        var n = e.languages[r],
            a = "language-" + r;
        return {
          block: {
            pattern: /<#[\s\S]+?#>/,
            inside: {
              directive: t("@", {
                "attr-value": {
                  pattern: /=(?:("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|[^\s'">=]+)/,
                  inside: {
                    punctuation: /^=|^["']|["']$/
                  }
                },
                keyword: /\b\w+(?=\s)/,
                "attr-name": /\b\w+/
              }),
              expression: t("=", n, a),
              "class-feature": t("\\+", n, a),
              standard: t("", n, a)
            }
          }
        };
      }
    });
  }(e);
}

t4Templating.displayName = "t4Templating", t4Templating.aliases = [];
var refractorT4Templating$1 = t4Templating_1,
    refractorCsharp = csharp_1,
    t4Cs_1 = t4Cs;

function t4Cs(e) {
  e.register(refractorT4Templating$1), e.register(refractorCsharp), e.languages.t4 = e.languages["t4-cs"] = e.languages["t4-templating"].createT4("csharp");
}

t4Cs.displayName = "t4Cs", t4Cs.aliases = [];
var refractorBasic = basic_1,
    vbnet_1 = vbnet;

function vbnet(e) {
  e.register(refractorBasic), e.languages.vbnet = e.languages.extend("basic", {
    comment: [{
      pattern: /(?:!|REM\b).+/i,
      inside: {
        keyword: /^REM/i
      }
    }, {
      pattern: /(^|[^\\:])'.*/,
      lookbehind: !0,
      greedy: !0
    }],
    string: {
      pattern: /(^|[^"])"(?:""|[^"])*"(?!")/,
      lookbehind: !0,
      greedy: !0
    },
    keyword: /(?:\b(?:ADDHANDLER|ADDRESSOF|ALIAS|AND|ANDALSO|AS|BEEP|BLOAD|BOOLEAN|BSAVE|BYREF|BYTE|BYVAL|CALL(?: ABSOLUTE)?|CASE|CATCH|CBOOL|CBYTE|CCHAR|CDATE|CDBL|CDEC|CHAIN|CHAR|CHDIR|CINT|CLASS|CLEAR|CLNG|CLOSE|CLS|COBJ|COM|COMMON|CONST|CONTINUE|CSBYTE|CSHORT|CSNG|CSTR|CTYPE|CUINT|CULNG|CUSHORT|DATA|DATE|DECIMAL|DECLARE|DEF(?: FN| SEG|DBL|INT|LNG|SNG|STR)|DEFAULT|DELEGATE|DIM|DIRECTCAST|DO|DOUBLE|ELSE|ELSEIF|END|ENUM|ENVIRON|ERASE|ERROR|EVENT|EXIT|FALSE|FIELD|FILES|FINALLY|FOR(?: EACH)?|FRIEND|FUNCTION|GET|GETTYPE|GETXMLNAMESPACE|GLOBAL|GOSUB|GOTO|HANDLES|IF|IMPLEMENTS|IMPORTS|IN|INHERITS|INPUT|INTEGER|INTERFACE|IOCTL|IS|ISNOT|KEY|KILL|LET|LIB|LIKE|LINE INPUT|LOCATE|LOCK|LONG|LOOP|LSET|ME|MKDIR|MOD|MODULE|MUSTINHERIT|MUSTOVERRIDE|MYBASE|MYCLASS|NAME|NAMESPACE|NARROWING|NEW|NEXT|NOT|NOTHING|NOTINHERITABLE|NOTOVERRIDABLE|OBJECT|OF|OFF|ON(?: COM| ERROR| KEY| TIMER)?|OPEN|OPERATOR|OPTION(?: BASE)?|OPTIONAL|OR|ORELSE|OUT|OVERLOADS|OVERRIDABLE|OVERRIDES|PARAMARRAY|PARTIAL|POKE|PRIVATE|PROPERTY|PROTECTED|PUBLIC|PUT|RAISEEVENT|READ|READONLY|REDIM|REM|REMOVEHANDLER|RESTORE|RESUME|RETURN|RMDIR|RSET|RUN|SBYTE|SELECT(?: CASE)?|SET|SHADOWS|SHARED|SHELL|SHORT|SINGLE|SLEEP|STATIC|STEP|STOP|STRING|STRUCTURE|SUB|SWAP|SYNCLOCK|SYSTEM|THEN|THROW|TIMER|TO|TROFF|TRON|TRUE|TRY|TRYCAST|TYPE|TYPEOF|UINTEGER|ULONG|UNLOCK|UNTIL|USHORT|USING|VIEW PRINT|WAIT|WEND|WHEN|WHILE|WIDENING|WITH|WITHEVENTS|WRITE|WRITEONLY|XOR)|\B(?:#CONST|#ELSE|#ELSEIF|#END|#IF))(?:\$|\b)/i,
    punctuation: /[,;:(){}]/
  });
}

vbnet.displayName = "vbnet", vbnet.aliases = [];
var refractorT4Templating = t4Templating_1,
    refractorVbnet = vbnet_1,
    t4Vb_1 = t4Vb;

function t4Vb(e) {
  e.register(refractorT4Templating), e.register(refractorVbnet), e.languages["t4-vb"] = e.languages["t4-templating"].createT4("vbnet");
}

t4Vb.displayName = "t4Vb", t4Vb.aliases = [];
var yaml_1 = yaml;

function yaml(e) {
  !function (e) {
    var t = /[*&][^\s[\]{},]+/,
        r = /!(?:<[\w\-%#;/?:@&=+$,.!~*'()[\]]+>|(?:[a-zA-Z\d-]*!)?[\w\-%#;/?:@&=+$.~*'()]+)?/,
        n = "(?:" + r.source + "(?:[ \t]+" + t.source + ")?|" + t.source + "(?:[ \t]+" + r.source + ")?)",
        a = /(?:[^\s\x00-\x08\x0e-\x1f!"#%&'*,\-:>?@[\]`{|}\x7f-\x84\x86-\x9f\ud800-\udfff\ufffe\uffff]|[?:-]<PLAIN>)(?:[ \t]*(?:(?![#:])<PLAIN>|:<PLAIN>))*/.source.replace(/<PLAIN>/g, function () {
      return /[^\s\x00-\x08\x0e-\x1f,[\]{}\x7f-\x84\x86-\x9f\ud800-\udfff\ufffe\uffff]/.source;
    }),
        o = /"(?:[^"\\\r\n]|\\.)*"|'(?:[^'\\\r\n]|\\.)*'/.source;

    function i(e, t) {
      t = (t || "").replace(/m/g, "") + "m";
      var r = /([:\-,[{]\s*(?:\s<<prop>>[ \t]+)?)(?:<<value>>)(?=[ \t]*(?:$|,|\]|\}|(?:[\r\n]\s*)?#))/.source.replace(/<<prop>>/g, function () {
        return n;
      }).replace(/<<value>>/g, function () {
        return e;
      });
      return RegExp(r, t);
    }

    e.languages.yaml = {
      scalar: {
        pattern: RegExp(/([\-:]\s*(?:\s<<prop>>[ \t]+)?[|>])[ \t]*(?:((?:\r?\n|\r)[ \t]+)\S[^\r\n]*(?:\2[^\r\n]+)*)/.source.replace(/<<prop>>/g, function () {
          return n;
        })),
        lookbehind: !0,
        alias: "string"
      },
      comment: /#.*/,
      key: {
        pattern: RegExp(/((?:^|[:\-,[{\r\n?])[ \t]*(?:<<prop>>[ \t]+)?)<<key>>(?=\s*:\s)/.source.replace(/<<prop>>/g, function () {
          return n;
        }).replace(/<<key>>/g, function () {
          return "(?:" + a + "|" + o + ")";
        })),
        lookbehind: !0,
        greedy: !0,
        alias: "atrule"
      },
      directive: {
        pattern: /(^[ \t]*)%.+/m,
        lookbehind: !0,
        alias: "important"
      },
      datetime: {
        pattern: i(/\d{4}-\d\d?-\d\d?(?:[tT]|[ \t]+)\d\d?:\d{2}:\d{2}(?:\.\d*)?(?:[ \t]*(?:Z|[-+]\d\d?(?::\d{2})?))?|\d{4}-\d{2}-\d{2}|\d\d?:\d{2}(?::\d{2}(?:\.\d*)?)?/.source),
        lookbehind: !0,
        alias: "number"
      },
      boolean: {
        pattern: i(/false|true/.source, "i"),
        lookbehind: !0,
        alias: "important"
      },
      null: {
        pattern: i(/null|~/.source, "i"),
        lookbehind: !0,
        alias: "important"
      },
      string: {
        pattern: i(o),
        lookbehind: !0,
        greedy: !0
      },
      number: {
        pattern: i(/[+-]?(?:0x[\da-f]+|0o[0-7]+|(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?|\.inf|\.nan)/.source, "i"),
        lookbehind: !0
      },
      tag: r,
      important: t,
      punctuation: /---|[:[\]{}\-,|>?]|\.\.\./
    }, e.languages.yml = e.languages.yaml;
  }(e);
}

yaml.displayName = "yaml", yaml.aliases = ["yml"];
var refractorYaml = yaml_1,
    tap_1 = tap;

function tap(e) {
  e.register(refractorYaml), e.languages.tap = {
    fail: /not ok[^#{\n\r]*/,
    pass: /ok[^#{\n\r]*/,
    pragma: /pragma [+-][a-z]+/,
    bailout: /bail out!.*/i,
    version: /TAP version \d+/i,
    plan: /\b\d+\.\.\d+(?: +#.*)?/,
    subtest: {
      pattern: /# Subtest(?:: .*)?/,
      greedy: !0
    },
    punctuation: /[{}]/,
    directive: /#.*/,
    yamlish: {
      pattern: /(^[ \t]*)---[\s\S]*?[\r\n][ \t]*\.\.\.$/m,
      lookbehind: !0,
      inside: e.languages.yaml,
      alias: "language-yaml"
    }
  };
}

tap.displayName = "tap", tap.aliases = [];
var tcl_1 = tcl;

function tcl(e) {
  e.languages.tcl = {
    comment: {
      pattern: /(^|[^\\])#.*/,
      lookbehind: !0
    },
    string: {
      pattern: /"(?:[^"\\\r\n]|\\(?:\r\n|[\s\S]))*"/,
      greedy: !0
    },
    variable: [{
      pattern: /(\$)(?:::)?(?:[a-zA-Z0-9]+::)*\w+/,
      lookbehind: !0
    }, {
      pattern: /(\$)\{[^}]+\}/,
      lookbehind: !0
    }, {
      pattern: /(^[\t ]*set[ \t]+)(?:::)?(?:[a-zA-Z0-9]+::)*\w+/m,
      lookbehind: !0
    }],
    function: {
      pattern: /(^[\t ]*proc[ \t]+)\S+/m,
      lookbehind: !0
    },
    builtin: [{
      pattern: /(^[\t ]*)(?:break|class|continue|error|eval|exit|for|foreach|if|proc|return|switch|while)\b/m,
      lookbehind: !0
    }, /\b(?:else|elseif)\b/],
    scope: {
      pattern: /(^[\t ]*)(?:global|upvar|variable)\b/m,
      lookbehind: !0,
      alias: "constant"
    },
    keyword: {
      pattern: /(^[\t ]*|\[)(?:Safe_Base|Tcl|after|append|apply|array|auto_(?:execok|import|load|mkindex|qualify|reset)|automkindex_old|bgerror|binary|catch|cd|chan|clock|close|concat|dde|dict|encoding|eof|exec|expr|fblocked|fconfigure|fcopy|file(?:event|name)?|flush|gets|glob|history|http|incr|info|interp|join|lappend|lassign|lindex|linsert|list|llength|load|lrange|lrepeat|lreplace|lreverse|lsearch|lset|lsort|math(?:func|op)|memory|msgcat|namespace|open|package|parray|pid|pkg_mkIndex|platform|puts|pwd|re_syntax|read|refchan|regexp|registry|regsub|rename|scan|seek|set|socket|source|split|string|subst|tcl(?:_endOfWord|_findLibrary|startOf(?:Next|Previous)Word|test|vars|wordBreak(?:After|Before))|tell|time|tm|trace|unknown|unload|unset|update|uplevel|vwait)\b/m,
      lookbehind: !0
    },
    operator: /!=?|\*\*?|==|&&?|\|\|?|<[=<]?|>[=>]?|[-+~\/%?^]|\b(?:eq|in|ne|ni)\b/,
    punctuation: /[{}()\[\]]/
  };
}

tcl.displayName = "tcl", tcl.aliases = [];
var textile_1 = textile;

function textile(e) {
  !function (e) {
    var t = /\([^|()\n]+\)|\[[^\]\n]+\]|\{[^}\n]+\}/.source,
        r = /\)|\((?![^|()\n]+\))/.source;

    function n(e, n) {
      return RegExp(e.replace(/<MOD>/g, function () {
        return "(?:" + t + ")";
      }).replace(/<PAR>/g, function () {
        return "(?:" + r + ")";
      }), n || "");
    }

    var a = {
      css: {
        pattern: /\{[^{}]+\}/,
        inside: {
          rest: e.languages.css
        }
      },
      "class-id": {
        pattern: /(\()[^()]+(?=\))/,
        lookbehind: !0,
        alias: "attr-value"
      },
      lang: {
        pattern: /(\[)[^\[\]]+(?=\])/,
        lookbehind: !0,
        alias: "attr-value"
      },
      punctuation: /[\\\/]\d+|\S/
    },
        o = e.languages.textile = e.languages.extend("markup", {
      phrase: {
        pattern: /(^|\r|\n)\S[\s\S]*?(?=$|\r?\n\r?\n|\r\r)/,
        lookbehind: !0,
        inside: {
          "block-tag": {
            pattern: n(/^[a-z]\w*(?:<MOD>|<PAR>|[<>=])*\./.source),
            inside: {
              modifier: {
                pattern: n(/(^[a-z]\w*)(?:<MOD>|<PAR>|[<>=])+(?=\.)/.source),
                lookbehind: !0,
                inside: a
              },
              tag: /^[a-z]\w*/,
              punctuation: /\.$/
            }
          },
          list: {
            pattern: n(/^[*#]+<MOD>*\s+\S.*/.source, "m"),
            inside: {
              modifier: {
                pattern: n(/(^[*#]+)<MOD>+/.source),
                lookbehind: !0,
                inside: a
              },
              punctuation: /^[*#]+/
            }
          },
          table: {
            pattern: n(/^(?:(?:<MOD>|<PAR>|[<>=^~])+\.\s*)?(?:\|(?:(?:<MOD>|<PAR>|[<>=^~_]|[\\/]\d+)+\.|(?!(?:<MOD>|<PAR>|[<>=^~_]|[\\/]\d+)+\.))[^|]*)+\|/.source, "m"),
            inside: {
              modifier: {
                pattern: n(/(^|\|(?:\r?\n|\r)?)(?:<MOD>|<PAR>|[<>=^~_]|[\\/]\d+)+(?=\.)/.source),
                lookbehind: !0,
                inside: a
              },
              punctuation: /\||^\./
            }
          },
          inline: {
            pattern: n(/(^|[^a-zA-Z\d])(\*\*|__|\?\?|[*_%@+\-^~])<MOD>*.+?\2(?![a-zA-Z\d])/.source),
            lookbehind: !0,
            inside: {
              bold: {
                pattern: n(/(^(\*\*?)<MOD>*).+?(?=\2)/.source),
                lookbehind: !0
              },
              italic: {
                pattern: n(/(^(__?)<MOD>*).+?(?=\2)/.source),
                lookbehind: !0
              },
              cite: {
                pattern: n(/(^\?\?<MOD>*).+?(?=\?\?)/.source),
                lookbehind: !0,
                alias: "string"
              },
              code: {
                pattern: n(/(^@<MOD>*).+?(?=@)/.source),
                lookbehind: !0,
                alias: "keyword"
              },
              inserted: {
                pattern: n(/(^\+<MOD>*).+?(?=\+)/.source),
                lookbehind: !0
              },
              deleted: {
                pattern: n(/(^-<MOD>*).+?(?=-)/.source),
                lookbehind: !0
              },
              span: {
                pattern: n(/(^%<MOD>*).+?(?=%)/.source),
                lookbehind: !0
              },
              modifier: {
                pattern: n(/(^\*\*|__|\?\?|[*_%@+\-^~])<MOD>+/.source),
                lookbehind: !0,
                inside: a
              },
              punctuation: /[*_%?@+\-^~]+/
            }
          },
          "link-ref": {
            pattern: /^\[[^\]]+\]\S+$/m,
            inside: {
              string: {
                pattern: /(^\[)[^\]]+(?=\])/,
                lookbehind: !0
              },
              url: {
                pattern: /(^\])\S+$/,
                lookbehind: !0
              },
              punctuation: /[\[\]]/
            }
          },
          link: {
            pattern: n(/"<MOD>*[^"]+":.+?(?=[^\w/]?(?:\s|$))/.source),
            inside: {
              text: {
                pattern: n(/(^"<MOD>*)[^"]+(?=")/.source),
                lookbehind: !0
              },
              modifier: {
                pattern: n(/(^")<MOD>+/.source),
                lookbehind: !0,
                inside: a
              },
              url: {
                pattern: /(:).+/,
                lookbehind: !0
              },
              punctuation: /[":]/
            }
          },
          image: {
            pattern: n(/!(?:<MOD>|<PAR>|[<>=])*(?![<>=])[^!\s()]+(?:\([^)]+\))?!(?::.+?(?=[^\w/]?(?:\s|$)))?/.source),
            inside: {
              source: {
                pattern: n(/(^!(?:<MOD>|<PAR>|[<>=])*)(?![<>=])[^!\s()]+(?:\([^)]+\))?(?=!)/.source),
                lookbehind: !0,
                alias: "url"
              },
              modifier: {
                pattern: n(/(^!)(?:<MOD>|<PAR>|[<>=])+/.source),
                lookbehind: !0,
                inside: a
              },
              url: {
                pattern: /(:).+/,
                lookbehind: !0
              },
              punctuation: /[!:]/
            }
          },
          footnote: {
            pattern: /\b\[\d+\]/,
            alias: "comment",
            inside: {
              punctuation: /\[|\]/
            }
          },
          acronym: {
            pattern: /\b[A-Z\d]+\([^)]+\)/,
            inside: {
              comment: {
                pattern: /(\()[^()]+(?=\))/,
                lookbehind: !0
              },
              punctuation: /[()]/
            }
          },
          mark: {
            pattern: /\b\((?:C|R|TM)\)/,
            alias: "comment",
            inside: {
              punctuation: /[()]/
            }
          }
        }
      }
    }),
        i = o.phrase.inside,
        s = {
      inline: i.inline,
      link: i.link,
      image: i.image,
      footnote: i.footnote,
      acronym: i.acronym,
      mark: i.mark
    };
    o.tag.pattern = /<\/?(?!\d)[a-z0-9]+(?:\s+[^\s>\/=]+(?:=(?:("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|[^\s'">=]+))?)*\s*\/?>/i;
    var l = i.inline.inside;
    l.bold.inside = s, l.italic.inside = s, l.inserted.inside = s, l.deleted.inside = s, l.span.inside = s;
    var c = i.table.inside;
    c.inline = s.inline, c.link = s.link, c.image = s.image, c.footnote = s.footnote, c.acronym = s.acronym, c.mark = s.mark;
  }(e);
}

textile.displayName = "textile", textile.aliases = [];
var toml_1 = toml;

function toml(e) {
  !function (e) {
    var t = /(?:[\w-]+|'[^'\n\r]*'|"(?:\\.|[^\\"\r\n])*")/.source;

    function r(e) {
      return e.replace(/__/g, function () {
        return t;
      });
    }

    e.languages.toml = {
      comment: {
        pattern: /#.*/,
        greedy: !0
      },
      table: {
        pattern: RegExp(r(/(^[\t ]*\[\s*(?:\[\s*)?)__(?:\s*\.\s*__)*(?=\s*\])/.source), "m"),
        lookbehind: !0,
        greedy: !0,
        alias: "class-name"
      },
      key: {
        pattern: RegExp(r(/(^[\t ]*|[{,]\s*)__(?:\s*\.\s*__)*(?=\s*=)/.source), "m"),
        lookbehind: !0,
        greedy: !0,
        alias: "property"
      },
      string: {
        pattern: /"""(?:\\[\s\S]|[^\\])*?"""|'''[\s\S]*?'''|'[^'\n\r]*'|"(?:\\.|[^\\"\r\n])*"/,
        greedy: !0
      },
      date: [{
        pattern: /\b\d{4}-\d{2}-\d{2}(?:[T\s]\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:\d{2})?)?\b/i,
        alias: "number"
      }, {
        pattern: /\b\d{2}:\d{2}:\d{2}(?:\.\d+)?\b/,
        alias: "number"
      }],
      number: /(?:\b0(?:x[\da-zA-Z]+(?:_[\da-zA-Z]+)*|o[0-7]+(?:_[0-7]+)*|b[10]+(?:_[10]+)*))\b|[-+]?\b\d+(?:_\d+)*(?:\.\d+(?:_\d+)*)?(?:[eE][+-]?\d+(?:_\d+)*)?\b|[-+]?\b(?:inf|nan)\b/,
      boolean: /\b(?:false|true)\b/,
      punctuation: /[.,=[\]{}]/
    };
  }(e);
}

toml.displayName = "toml", toml.aliases = [];
var tremor_1 = tremor;

function tremor(e) {
  !function (e) {
    e.languages.tremor = {
      comment: {
        pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|(?:--|\/\/|#).*)/,
        lookbehind: !0
      },
      "interpolated-string": null,
      extractor: {
        pattern: /\b[a-z_]\w*\|(?:[^\r\n\\|]|\\(?:\r\n|[\s\S]))*\|/i,
        greedy: !0,
        inside: {
          regex: {
            pattern: /(^re)\|[\s\S]+/,
            lookbehind: !0
          },
          function: /^\w+/,
          value: /\|[\s\S]+/
        }
      },
      identifier: {
        pattern: /`[^`]*`/,
        greedy: !0
      },
      function: /\b[a-z_]\w*(?=\s*(?:::\s*<|\())\b/,
      keyword: /\b(?:args|as|by|case|config|connect|connector|const|copy|create|default|define|deploy|drop|each|emit|end|erase|event|flow|fn|for|from|group|having|insert|into|intrinsic|let|links|match|merge|mod|move|of|operator|patch|pipeline|recur|script|select|set|sliding|state|stream|to|tumbling|update|use|when|where|window|with)\b/,
      boolean: /\b(?:false|null|true)\b/i,
      number: /\b(?:0b[01_]*|0x[0-9a-fA-F_]*|\d[\d_]*(?:\.\d[\d_]*)?(?:[Ee][+-]?[\d_]+)?)\b/,
      "pattern-punctuation": {
        pattern: /%(?=[({[])/,
        alias: "punctuation"
      },
      operator: /[-+*\/%~!^]=?|=[=>]?|&[&=]?|\|[|=]?|<<?=?|>>?>?=?|(?:absent|and|not|or|present|xor)\b/,
      punctuation: /::|[;\[\]()\{\},.:]/
    };
    var t = /#\{(?:[^"{}]|\{[^{}]*\}|"(?:[^"\\\r\n]|\\(?:\r\n|[\s\S]))*")*\}/.source;
    e.languages.tremor["interpolated-string"] = {
      pattern: RegExp(/(^|[^\\])/.source + '(?:"""(?:' + /[^"\\#]|\\[\s\S]|"(?!"")|#(?!\{)/.source + "|" + t + ')*"""|"(?:' + /[^"\\\r\n#]|\\(?:\r\n|[\s\S])|#(?!\{)/.source + "|" + t + ')*")'),
      lookbehind: !0,
      greedy: !0,
      inside: {
        interpolation: {
          pattern: RegExp(t),
          inside: {
            punctuation: /^#\{|\}$/,
            expression: {
              pattern: /[\s\S]+/,
              inside: e.languages.tremor
            }
          }
        },
        string: /[\s\S]+/
      }
    }, e.languages.troy = e.languages.tremor, e.languages.trickle = e.languages.tremor;
  }(e);
}

tremor.displayName = "tremor", tremor.aliases = [];
var refractorJsx = jsx_1,
    refractorTypescript = typescript_1,
    tsx_1 = tsx;

function tsx(e) {
  e.register(refractorJsx), e.register(refractorTypescript), function (e) {
    var t = e.util.clone(e.languages.typescript);
    e.languages.tsx = e.languages.extend("jsx", t), delete e.languages.tsx.parameter, delete e.languages.tsx["literal-property"];
    var r = e.languages.tsx.tag;
    r.pattern = RegExp(/(^|[^\w$]|(?=<\/))/.source + "(?:" + r.pattern.source + ")", r.pattern.flags), r.lookbehind = !0;
  }(e);
}

tsx.displayName = "tsx", tsx.aliases = [];
var refractorMarkupTemplating$1 = markupTemplating_1,
    tt2_1 = tt2;

function tt2(e) {
  e.register(refractorMarkupTemplating$1), function (e) {
    e.languages.tt2 = e.languages.extend("clike", {
      comment: /#.*|\[%#[\s\S]*?%\]/,
      keyword: /\b(?:BLOCK|CALL|CASE|CATCH|CLEAR|DEBUG|DEFAULT|ELSE|ELSIF|END|FILTER|FINAL|FOREACH|GET|IF|IN|INCLUDE|INSERT|LAST|MACRO|META|NEXT|PERL|PROCESS|RAWPERL|RETURN|SET|STOP|SWITCH|TAGS|THROW|TRY|UNLESS|USE|WHILE|WRAPPER)\b/,
      punctuation: /[[\]{},()]/
    }), e.languages.insertBefore("tt2", "number", {
      operator: /=[>=]?|!=?|<=?|>=?|&&|\|\|?|\b(?:and|not|or)\b/,
      variable: {
        pattern: /\b[a-z]\w*(?:\s*\.\s*(?:\d+|\$?[a-z]\w*))*\b/i
      }
    }), e.languages.insertBefore("tt2", "keyword", {
      delimiter: {
        pattern: /^(?:\[%|%%)-?|-?%\]$/,
        alias: "punctuation"
      }
    }), e.languages.insertBefore("tt2", "string", {
      "single-quoted-string": {
        pattern: /'[^\\']*(?:\\[\s\S][^\\']*)*'/,
        greedy: !0,
        alias: "string"
      },
      "double-quoted-string": {
        pattern: /"[^\\"]*(?:\\[\s\S][^\\"]*)*"/,
        greedy: !0,
        alias: "string",
        inside: {
          variable: {
            pattern: /\$(?:[a-z]\w*(?:\.(?:\d+|\$?[a-z]\w*))*)/i
          }
        }
      }
    }), delete e.languages.tt2.string, e.hooks.add("before-tokenize", function (t) {
      e.languages["markup-templating"].buildPlaceholders(t, "tt2", /\[%[\s\S]+?%\]/g);
    }), e.hooks.add("after-tokenize", function (t) {
      e.languages["markup-templating"].tokenizePlaceholders(t, "tt2");
    });
  }(e);
}

tt2.displayName = "tt2", tt2.aliases = [];
var refractorMarkupTemplating = markupTemplating_1,
    twig_1 = twig;

function twig(e) {
  e.register(refractorMarkupTemplating), e.languages.twig = {
    comment: /^\{#[\s\S]*?#\}$/,
    "tag-name": {
      pattern: /(^\{%-?\s*)\w+/,
      lookbehind: !0,
      alias: "keyword"
    },
    delimiter: {
      pattern: /^\{[{%]-?|-?[%}]\}$/,
      alias: "punctuation"
    },
    string: {
      pattern: /("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
      inside: {
        punctuation: /^['"]|['"]$/
      }
    },
    keyword: /\b(?:even|if|odd)\b/,
    boolean: /\b(?:false|null|true)\b/,
    number: /\b0x[\dA-Fa-f]+|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee][-+]?\d+)?/,
    operator: [{
      pattern: /(\s)(?:and|b-and|b-or|b-xor|ends with|in|is|matches|not|or|same as|starts with)(?=\s)/,
      lookbehind: !0
    }, /[=<>]=?|!=|\*\*?|\/\/?|\?:?|[-+~%|]/],
    punctuation: /[()\[\]{}:.,]/
  }, e.hooks.add("before-tokenize", function (t) {
    if ("twig" === t.language) {
      e.languages["markup-templating"].buildPlaceholders(t, "twig", /\{(?:#[\s\S]*?#|%[\s\S]*?%|\{[\s\S]*?\})\}/g);
    }
  }), e.hooks.add("after-tokenize", function (t) {
    e.languages["markup-templating"].tokenizePlaceholders(t, "twig");
  });
}

twig.displayName = "twig", twig.aliases = [];
var typoscript_1 = typoscript;

function typoscript(e) {
  !function (e) {
    var t = /\b(?:ACT|ACTIFSUB|CARRAY|CASE|CLEARGIF|COA|COA_INT|CONSTANTS|CONTENT|CUR|EDITPANEL|EFFECT|EXT|FILE|FLUIDTEMPLATE|FORM|FRAME|FRAMESET|GIFBUILDER|GMENU|GMENU_FOLDOUT|GMENU_LAYERS|GP|HMENU|HRULER|HTML|IENV|IFSUB|IMAGE|IMGMENU|IMGMENUITEM|IMGTEXT|IMG_RESOURCE|INCLUDE_TYPOSCRIPT|JSMENU|JSMENUITEM|LLL|LOAD_REGISTER|NO|PAGE|RECORDS|RESTORE_REGISTER|TEMPLATE|TEXT|TMENU|TMENUITEM|TMENU_LAYERS|USER|USER_INT|_GIFBUILDER|global|globalString|globalVar)\b/;
    e.languages.typoscript = {
      comment: [{
        pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
        lookbehind: !0
      }, {
        pattern: /(^|[^\\:= \t]|(?:^|[^= \t])[ \t]+)\/\/.*/,
        lookbehind: !0,
        greedy: !0
      }, {
        pattern: /(^|[^"'])#.*/,
        lookbehind: !0,
        greedy: !0
      }],
      function: [{
        pattern: /<INCLUDE_TYPOSCRIPT:\s*source\s*=\s*(?:"[^"\r\n]*"|'[^'\r\n]*')\s*>/,
        inside: {
          string: {
            pattern: /"[^"\r\n]*"|'[^'\r\n]*'/,
            inside: {
              keyword: t
            }
          },
          keyword: {
            pattern: /INCLUDE_TYPOSCRIPT/
          }
        }
      }, {
        pattern: /@import\s*(?:"[^"\r\n]*"|'[^'\r\n]*')/,
        inside: {
          string: /"[^"\r\n]*"|'[^'\r\n]*'/
        }
      }],
      string: {
        pattern: /^([^=]*=[< ]?)(?:(?!\]\n).)*/,
        lookbehind: !0,
        inside: {
          function: /\{\$.*\}/,
          keyword: t,
          number: /^\d+$/,
          punctuation: /[,|:]/
        }
      },
      keyword: t,
      number: {
        pattern: /\b\d+\s*[.{=]/,
        inside: {
          operator: /[.{=]/
        }
      },
      tag: {
        pattern: /\.?[-\w\\]+\.?/,
        inside: {
          punctuation: /\./
        }
      },
      punctuation: /[{}[\];(),.:|]/,
      operator: /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/
    }, e.languages.tsconfig = e.languages.typoscript;
  }(e);
}

typoscript.displayName = "typoscript", typoscript.aliases = ["tsconfig"];
var unrealscript_1 = unrealscript;

function unrealscript(e) {
  e.languages.unrealscript = {
    comment: /\/\/.*|\/\*[\s\S]*?\*\//,
    string: {
      pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
      greedy: !0
    },
    category: {
      pattern: /(\b(?:(?:autoexpand|hide|show)categories|var)\s*\()[^()]+(?=\))/,
      lookbehind: !0,
      greedy: !0,
      alias: "property"
    },
    metadata: {
      pattern: /(\w\s*)<\s*\w+\s*=[^<>|=\r\n]+(?:\|\s*\w+\s*=[^<>|=\r\n]+)*>/,
      lookbehind: !0,
      greedy: !0,
      inside: {
        property: /\b\w+(?=\s*=)/,
        operator: /=/,
        punctuation: /[<>|]/
      }
    },
    macro: {
      pattern: /`\w+/,
      alias: "property"
    },
    "class-name": {
      pattern: /(\b(?:class|enum|extends|interface|state(?:\(\))?|struct|within)\s+)\w+/,
      lookbehind: !0
    },
    keyword: /\b(?:abstract|actor|array|auto|autoexpandcategories|bool|break|byte|case|class|classgroup|client|coerce|collapsecategories|config|const|continue|default|defaultproperties|delegate|dependson|deprecated|do|dontcollapsecategories|editconst|editinlinenew|else|enum|event|exec|export|extends|final|float|for|forcescriptorder|foreach|function|goto|guid|hidecategories|hidedropdown|if|ignores|implements|inherits|input|int|interface|iterator|latent|local|material|name|native|nativereplication|noexport|nontransient|noteditinlinenew|notplaceable|operator|optional|out|pawn|perobjectconfig|perobjectlocalized|placeable|postoperator|preoperator|private|protected|reliable|replication|return|server|showcategories|simulated|singular|state|static|string|struct|structdefault|structdefaultproperties|switch|texture|transient|travel|unreliable|until|var|vector|while|within)\b/,
    function: /\b[a-z_]\w*(?=\s*\()/i,
    boolean: /\b(?:false|true)\b/,
    number: /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
    operator: />>|<<|--|\+\+|\*\*|[-+*/~!=<>$@]=?|&&?|\|\|?|\^\^?|[?:%]|\b(?:ClockwiseFrom|Cross|Dot)\b/,
    punctuation: /[()[\]{};,.]/
  }, e.languages.uc = e.languages.uscript = e.languages.unrealscript;
}

unrealscript.displayName = "unrealscript", unrealscript.aliases = ["uc", "uscript"];
var uorazor_1 = uorazor;

function uorazor(e) {
  e.languages.uorazor = {
    "comment-hash": {
      pattern: /#.*/,
      alias: "comment",
      greedy: !0
    },
    "comment-slash": {
      pattern: /\/\/.*/,
      alias: "comment",
      greedy: !0
    },
    string: {
      pattern: /("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
      inside: {
        punctuation: /^['"]|['"]$/
      },
      greedy: !0
    },
    "source-layers": {
      pattern: /\b(?:arms|backpack|blue|bracelet|cancel|clear|cloak|criminal|earrings|enemy|facialhair|friend|friendly|gloves|gray|grey|ground|hair|head|innerlegs|innertorso|innocent|lefthand|middletorso|murderer|neck|nonfriendly|onehandedsecondary|outerlegs|outertorso|pants|red|righthand|ring|self|shirt|shoes|talisman|waist)\b/i,
      alias: "function"
    },
    "source-commands": {
      pattern: /\b(?:alliance|attack|cast|clearall|clearignore|clearjournal|clearlist|clearsysmsg|createlist|createtimer|dclick|dclicktype|dclickvar|dress|dressconfig|drop|droprelloc|emote|getlabel|guild|gumpclose|gumpresponse|hotkey|ignore|lasttarget|lift|lifttype|menu|menuresponse|msg|org|organize|organizer|overhead|pause|poplist|potion|promptresponse|pushlist|removelist|removetimer|rename|restock|say|scav|scavenger|script|setability|setlasttarget|setskill|settimer|setvar|sysmsg|target|targetloc|targetrelloc|targettype|undress|unignore|unsetvar|useobject|useonce|useskill|usetype|virtue|wait|waitforgump|waitformenu|waitforprompt|waitforstat|waitforsysmsg|waitfortarget|walk|wfsysmsg|wft|whisper|yell)\b/,
      alias: "function"
    },
    "tag-name": {
      pattern: /(^\{%-?\s*)\w+/,
      lookbehind: !0,
      alias: "keyword"
    },
    delimiter: {
      pattern: /^\{[{%]-?|-?[%}]\}$/,
      alias: "punctuation"
    },
    function: /\b(?:atlist|close|closest|count|counter|counttype|dead|dex|diffhits|diffmana|diffstam|diffweight|find|findbuff|finddebuff|findlayer|findtype|findtypelist|followers|gumpexists|hidden|hits|hp|hue|human|humanoid|ingump|inlist|insysmessage|insysmsg|int|invul|lhandempty|list|listexists|mana|maxhits|maxhp|maxmana|maxstam|maxweight|monster|mounted|name|next|noto|paralyzed|poisoned|position|prev|previous|queued|rand|random|rhandempty|skill|stam|str|targetexists|timer|timerexists|varexist|warmode|weight)\b/,
    keyword: /\b(?:and|as|break|continue|else|elseif|endfor|endif|endwhile|for|if|loop|not|or|replay|stop|while)\b/,
    boolean: /\b(?:false|null|true)\b/,
    number: /\b0x[\dA-Fa-f]+|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee][-+]?\d+)?/,
    operator: [{
      pattern: /(\s)(?:and|b-and|b-or|b-xor|ends with|in|is|matches|not|or|same as|starts with)(?=\s)/,
      lookbehind: !0
    }, /[=<>]=?|!=|\*\*?|\/\/?|\?:?|[-+~%|]/],
    punctuation: /[()\[\]{}:.,]/
  };
}

uorazor.displayName = "uorazor", uorazor.aliases = [];
var uri_1 = uri;

function uri(e) {
  e.languages.uri = {
    scheme: {
      pattern: /^[a-z][a-z0-9+.-]*:/im,
      greedy: !0,
      inside: {
        "scheme-delimiter": /:$/
      }
    },
    fragment: {
      pattern: /#[\w\-.~!$&'()*+,;=%:@/?]*/,
      inside: {
        "fragment-delimiter": /^#/
      }
    },
    query: {
      pattern: /\?[\w\-.~!$&'()*+,;=%:@/?]*/,
      inside: {
        "query-delimiter": {
          pattern: /^\?/,
          greedy: !0
        },
        "pair-delimiter": /[&;]/,
        pair: {
          pattern: /^[^=][\s\S]*/,
          inside: {
            key: /^[^=]+/,
            value: {
              pattern: /(^=)[\s\S]+/,
              lookbehind: !0
            }
          }
        }
      }
    },
    authority: {
      pattern: RegExp(/^\/\//.source + /(?:[\w\-.~!$&'()*+,;=%:]*@)?/.source + "(?:" + /\[(?:[0-9a-fA-F:.]{2,48}|v[0-9a-fA-F]+\.[\w\-.~!$&'()*+,;=]+)\]/.source + "|" + /[\w\-.~!$&'()*+,;=%]*/.source + ")" + /(?::\d*)?/.source, "m"),
      inside: {
        "authority-delimiter": /^\/\//,
        "user-info-segment": {
          pattern: /^[\w\-.~!$&'()*+,;=%:]*@/,
          inside: {
            "user-info-delimiter": /@$/,
            "user-info": /^[\w\-.~!$&'()*+,;=%:]+/
          }
        },
        "port-segment": {
          pattern: /:\d*$/,
          inside: {
            "port-delimiter": /^:/,
            port: /^\d+/
          }
        },
        host: {
          pattern: /[\s\S]+/,
          inside: {
            "ip-literal": {
              pattern: /^\[[\s\S]+\]$/,
              inside: {
                "ip-literal-delimiter": /^\[|\]$/,
                "ipv-future": /^v[\s\S]+/,
                "ipv6-address": /^[\s\S]+/
              }
            },
            "ipv4-address": /^(?:(?:[03-9]\d?|[12]\d{0,2})\.){3}(?:[03-9]\d?|[12]\d{0,2})$/
          }
        }
      }
    },
    path: {
      pattern: /^[\w\-.~!$&'()*+,;=%:@/]+/m,
      inside: {
        "path-separator": /\//
      }
    }
  }, e.languages.url = e.languages.uri;
}

uri.displayName = "uri", uri.aliases = ["url"];
var v_1 = v$1;

function v$1(e) {
  !function (e) {
    var t = {
      pattern: /[\s\S]+/,
      inside: null
    };
    e.languages.v = e.languages.extend("clike", {
      string: {
        pattern: /r?(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
        alias: "quoted-string",
        greedy: !0,
        inside: {
          interpolation: {
            pattern: /((?:^|[^\\])(?:\\{2})*)\$(?:\{[^{}]*\}|\w+(?:\.\w+(?:\([^\(\)]*\))?|\[[^\[\]]+\])*)/,
            lookbehind: !0,
            inside: {
              "interpolation-variable": {
                pattern: /^\$\w[\s\S]*$/,
                alias: "variable"
              },
              "interpolation-punctuation": {
                pattern: /^\$\{|\}$/,
                alias: "punctuation"
              },
              "interpolation-expression": t
            }
          }
        }
      },
      "class-name": {
        pattern: /(\b(?:enum|interface|struct|type)\s+)(?:C\.)?\w+/,
        lookbehind: !0
      },
      keyword: /(?:\b(?:__global|as|asm|assert|atomic|break|chan|const|continue|defer|else|embed|enum|fn|for|go(?:to)?|if|import|in|interface|is|lock|match|module|mut|none|or|pub|return|rlock|select|shared|sizeof|static|struct|type(?:of)?|union|unsafe)|\$(?:else|for|if)|#(?:flag|include))\b/,
      number: /\b(?:0x[a-f\d]+(?:_[a-f\d]+)*|0b[01]+(?:_[01]+)*|0o[0-7]+(?:_[0-7]+)*|\d+(?:_\d+)*(?:\.\d+(?:_\d+)*)?)\b/i,
      operator: /~|\?|[*\/%^!=]=?|\+[=+]?|-[=-]?|\|[=|]?|&(?:=|&|\^=?)?|>(?:>=?|=)?|<(?:<=?|=|-)?|:=|\.\.\.?/,
      builtin: /\b(?:any(?:_float|_int)?|bool|byte(?:ptr)?|charptr|f(?:32|64)|i(?:8|16|64|128|nt)|rune|size_t|string|u(?:16|32|64|128)|voidptr)\b/
    }), t.inside = e.languages.v, e.languages.insertBefore("v", "string", {
      char: {
        pattern: /`(?:\\`|\\?[^`]{1,2})`/,
        alias: "rune"
      }
    }), e.languages.insertBefore("v", "operator", {
      attribute: {
        pattern: /(^[\t ]*)\[(?:deprecated|direct_array_access|flag|inline|live|ref_only|typedef|unsafe_fn|windows_stdcall)\]/m,
        lookbehind: !0,
        alias: "annotation",
        inside: {
          punctuation: /[\[\]]/,
          keyword: /\w+/
        }
      },
      generic: {
        pattern: /<\w+>(?=\s*[\)\{])/,
        inside: {
          punctuation: /[<>]/,
          "class-name": /\w+/
        }
      }
    }), e.languages.insertBefore("v", "function", {
      "generic-function": {
        pattern: /\b\w+\s*<\w+>(?=\()/,
        inside: {
          function: /^\w+/,
          generic: {
            pattern: /<\w+>/,
            inside: e.languages.v.generic.inside
          }
        }
      }
    });
  }(e);
}

v$1.displayName = "v", v$1.aliases = [];
var vala_1 = vala;

function vala(e) {
  e.languages.vala = e.languages.extend("clike", {
    "class-name": [{
      pattern: /\b[A-Z]\w*(?:\.\w+)*\b(?=(?:\?\s+|\*?\s+\*?)\w)/,
      inside: {
        punctuation: /\./
      }
    }, {
      pattern: /(\[)[A-Z]\w*(?:\.\w+)*\b/,
      lookbehind: !0,
      inside: {
        punctuation: /\./
      }
    }, {
      pattern: /(\b(?:class|interface)\s+[A-Z]\w*(?:\.\w+)*\s*:\s*)[A-Z]\w*(?:\.\w+)*\b/,
      lookbehind: !0,
      inside: {
        punctuation: /\./
      }
    }, {
      pattern: /((?:\b(?:class|enum|interface|new|struct)\s+)|(?:catch\s+\())[A-Z]\w*(?:\.\w+)*\b/,
      lookbehind: !0,
      inside: {
        punctuation: /\./
      }
    }],
    keyword: /\b(?:abstract|as|assert|async|base|bool|break|case|catch|char|class|const|construct|continue|default|delegate|delete|do|double|dynamic|else|ensures|enum|errordomain|extern|finally|float|for|foreach|get|if|in|inline|int|int16|int32|int64|int8|interface|internal|is|lock|long|namespace|new|null|out|override|owned|params|private|protected|public|ref|requires|return|set|short|signal|sizeof|size_t|ssize_t|static|string|struct|switch|this|throw|throws|try|typeof|uchar|uint|uint16|uint32|uint64|uint8|ulong|unichar|unowned|ushort|using|value|var|virtual|void|volatile|weak|while|yield)\b/i,
    function: /\b\w+(?=\s*\()/,
    number: /(?:\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?)(?:f|u?l?)?/i,
    operator: /\+\+|--|&&|\|\||<<=?|>>=?|=>|->|~|[+\-*\/%&^|=!<>]=?|\?\??|\.\.\./,
    punctuation: /[{}[\];(),.:]/,
    constant: /\b[A-Z0-9_]+\b/
  }), e.languages.insertBefore("vala", "string", {
    "raw-string": {
      pattern: /"""[\s\S]*?"""/,
      greedy: !0,
      alias: "string"
    },
    "template-string": {
      pattern: /@"[\s\S]*?"/,
      greedy: !0,
      inside: {
        interpolation: {
          pattern: /\$(?:\([^)]*\)|[a-zA-Z]\w*)/,
          inside: {
            delimiter: {
              pattern: /^\$\(?|\)$/,
              alias: "punctuation"
            },
            rest: e.languages.vala
          }
        },
        string: /[\s\S]+/
      }
    }
  }), e.languages.insertBefore("vala", "keyword", {
    regex: {
      pattern: /\/(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[imsx]{0,4}(?=\s*(?:$|[\r\n,.;})\]]))/,
      greedy: !0,
      inside: {
        "regex-source": {
          pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
          lookbehind: !0,
          alias: "language-regex",
          inside: e.languages.regex
        },
        "regex-delimiter": /^\//,
        "regex-flags": /^[a-z]+$/
      }
    }
  });
}

vala.displayName = "vala", vala.aliases = [];
var velocity_1 = velocity;

function velocity(e) {
  !function (e) {
    e.languages.velocity = e.languages.extend("markup", {});
    var t = {
      variable: {
        pattern: /(^|[^\\](?:\\\\)*)\$!?(?:[a-z][\w-]*(?:\([^)]*\))?(?:\.[a-z][\w-]*(?:\([^)]*\))?|\[[^\]]+\])*|\{[^}]+\})/i,
        lookbehind: !0,
        inside: {}
      },
      string: {
        pattern: /"[^"]*"|'[^']*'/,
        greedy: !0
      },
      number: /\b\d+\b/,
      boolean: /\b(?:false|true)\b/,
      operator: /[=!<>]=?|[+*/%-]|&&|\|\||\.\.|\b(?:eq|g[et]|l[et]|n(?:e|ot))\b/,
      punctuation: /[(){}[\]:,.]/
    };
    t.variable.inside = {
      string: t.string,
      function: {
        pattern: /([^\w-])[a-z][\w-]*(?=\()/,
        lookbehind: !0
      },
      number: t.number,
      boolean: t.boolean,
      punctuation: t.punctuation
    }, e.languages.insertBefore("velocity", "comment", {
      unparsed: {
        pattern: /(^|[^\\])#\[\[[\s\S]*?\]\]#/,
        lookbehind: !0,
        greedy: !0,
        inside: {
          punctuation: /^#\[\[|\]\]#$/
        }
      },
      "velocity-comment": [{
        pattern: /(^|[^\\])#\*[\s\S]*?\*#/,
        lookbehind: !0,
        greedy: !0,
        alias: "comment"
      }, {
        pattern: /(^|[^\\])##.*/,
        lookbehind: !0,
        greedy: !0,
        alias: "comment"
      }],
      directive: {
        pattern: /(^|[^\\](?:\\\\)*)#@?(?:[a-z][\w-]*|\{[a-z][\w-]*\})(?:\s*\((?:[^()]|\([^()]*\))*\))?/i,
        lookbehind: !0,
        inside: {
          keyword: {
            pattern: /^#@?(?:[a-z][\w-]*|\{[a-z][\w-]*\})|\bin\b/,
            inside: {
              punctuation: /[{}]/
            }
          },
          rest: t
        }
      },
      variable: t.variable
    }), e.languages.velocity.tag.inside["attr-value"].inside.rest = e.languages.velocity;
  }(e);
}

velocity.displayName = "velocity", velocity.aliases = [];
var verilog_1 = verilog;

function verilog(e) {
  e.languages.verilog = {
    comment: {
      pattern: /\/\/.*|\/\*[\s\S]*?\*\//,
      greedy: !0
    },
    string: {
      pattern: /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/,
      greedy: !0
    },
    "kernel-function": {
      pattern: /\B\$\w+\b/,
      alias: "property"
    },
    constant: /\B`\w+\b/,
    function: /\b\w+(?=\()/,
    keyword: /\b(?:alias|and|assert|assign|assume|automatic|before|begin|bind|bins|binsof|bit|break|buf|bufif0|bufif1|byte|case|casex|casez|cell|chandle|class|clocking|cmos|config|const|constraint|context|continue|cover|covergroup|coverpoint|cross|deassign|default|defparam|design|disable|dist|do|edge|else|end|endcase|endclass|endclocking|endconfig|endfunction|endgenerate|endgroup|endinterface|endmodule|endpackage|endprimitive|endprogram|endproperty|endsequence|endspecify|endtable|endtask|enum|event|expect|export|extends|extern|final|first_match|for|force|foreach|forever|fork|forkjoin|function|generate|genvar|highz0|highz1|if|iff|ifnone|ignore_bins|illegal_bins|import|incdir|include|initial|inout|input|inside|instance|int|integer|interface|intersect|join|join_any|join_none|large|liblist|library|local|localparam|logic|longint|macromodule|matches|medium|modport|module|nand|negedge|new|nmos|nor|noshowcancelled|not|notif0|notif1|null|or|output|package|packed|parameter|pmos|posedge|primitive|priority|program|property|protected|pull0|pull1|pulldown|pullup|pulsestyle_ondetect|pulsestyle_onevent|pure|rand|randc|randcase|randsequence|rcmos|real|realtime|ref|reg|release|repeat|return|rnmos|rpmos|rtran|rtranif0|rtranif1|scalared|sequence|shortint|shortreal|showcancelled|signed|small|solve|specify|specparam|static|string|strong0|strong1|struct|super|supply0|supply1|table|tagged|task|this|throughout|time|timeprecision|timeunit|tran|tranif0|tranif1|tri|tri0|tri1|triand|trior|trireg|type|typedef|union|unique|unsigned|use|uwire|var|vectored|virtual|void|wait|wait_order|wand|weak0|weak1|while|wildcard|wire|with|within|wor|xnor|xor)\b/,
    important: /\b(?:always|always_comb|always_ff|always_latch)\b(?: *@)?/,
    number: /\B##?\d+|(?:\b\d+)?'[odbh] ?[\da-fzx_?]+|\b(?:\d*[._])?\d+(?:e[-+]?\d+)?/i,
    operator: /[-+{}^~%*\/?=!<>&|]+/,
    punctuation: /[[\];(),.:]/
  };
}

verilog.displayName = "verilog", verilog.aliases = [];
var vhdl_1 = vhdl;

function vhdl(e) {
  e.languages.vhdl = {
    comment: /--.+/,
    "vhdl-vectors": {
      pattern: /\b[oxb]"[\da-f_]+"|"[01uxzwlh-]+"/i,
      alias: "number"
    },
    "quoted-function": {
      pattern: /"\S+?"(?=\()/,
      alias: "function"
    },
    string: /"(?:[^\\"\r\n]|\\(?:\r\n|[\s\S]))*"/,
    constant: /\b(?:library|use)\b/i,
    keyword: /\b(?:'active|'ascending|'base|'delayed|'driving|'driving_value|'event|'high|'image|'instance_name|'last_active|'last_event|'last_value|'left|'leftof|'length|'low|'path_name|'pos|'pred|'quiet|'range|'reverse_range|'right|'rightof|'simple_name|'stable|'succ|'transaction|'val|'value|access|after|alias|all|architecture|array|assert|attribute|begin|block|body|buffer|bus|case|component|configuration|constant|disconnect|downto|else|elsif|end|entity|exit|file|for|function|generate|generic|group|guarded|if|impure|in|inertial|inout|is|label|library|linkage|literal|loop|map|new|next|null|of|on|open|others|out|package|port|postponed|procedure|process|pure|range|record|register|reject|report|return|select|severity|shared|signal|subtype|then|to|transport|type|unaffected|units|until|use|variable|wait|when|while|with)\b/i,
    boolean: /\b(?:false|true)\b/i,
    function: /\w+(?=\()/,
    number: /'[01uxzwlh-]'|\b(?:\d+#[\da-f_.]+#|\d[\d_.]*)(?:e[-+]?\d+)?/i,
    operator: /[<>]=?|:=|[-+*/&=]|\b(?:abs|and|mod|nand|nor|not|or|rem|rol|ror|sla|sll|sra|srl|xnor|xor)\b/i,
    punctuation: /[{}[\];(),.:]/
  };
}

vhdl.displayName = "vhdl", vhdl.aliases = [];
var vim_1 = vim;

function vim(e) {
  e.languages.vim = {
    string: /"(?:[^"\\\r\n]|\\.)*"|'(?:[^'\r\n]|'')*'/,
    comment: /".*/,
    function: /\b\w+(?=\()/,
    keyword: /\b(?:N|Next|P|Print|X|XMLent|XMLns|ab|abbreviate|abc|abclear|abo|aboveleft|al|all|ar|arga|argadd|argd|argdelete|argdo|arge|argedit|argg|argglobal|argl|arglocal|args|argu|argument|as|ascii|b|bN|bNext|ba|bad|badd|ball|bd|bdelete|be|bel|belowright|bf|bfirst|bl|blast|bm|bmodified|bn|bnext|bo|botright|bp|bprevious|br|brea|break|breaka|breakadd|breakd|breakdel|breakl|breaklist|brewind|bro|browse|bufdo|buffer|buffers|bun|bunload|bw|bwipeout|c|cN|cNext|cNfcNfile|ca|cabbrev|cabc|cabclear|cad|caddb|caddbuffer|caddexpr|caddf|caddfile|cal|call|cat|catch|cb|cbuffer|cc|ccl|cclose|cd|ce|center|cex|cexpr|cf|cfile|cfir|cfirst|cg|cgetb|cgetbuffer|cgete|cgetexpr|cgetfile|change|changes|chd|chdir|che|checkpath|checkt|checktime|cl|cla|clast|clist|clo|close|cmapc|cmapclear|cn|cnew|cnewer|cnext|cnf|cnfile|cnorea|cnoreabbrev|co|col|colder|colo|colorscheme|comc|comclear|comp|compiler|con|conf|confirm|continue|cope|copen|copy|cp|cpf|cpfile|cprevious|cq|cquit|cr|crewind|cu|cuna|cunabbrev|cunmap|cw|cwindow|d|debugg|debuggreedy|delc|delcommand|delete|delf|delfunction|delm|delmarks|di|diffg|diffget|diffoff|diffpatch|diffpu|diffput|diffsplit|diffthis|diffu|diffupdate|dig|digraphs|display|dj|djump|dl|dlist|dr|drop|ds|dsearch|dsp|dsplit|e|earlier|echoe|echoerr|echom|echomsg|echon|edit|el|else|elsei|elseif|em|emenu|en|endf|endfo|endfor|endfun|endfunction|endif|endt|endtry|endw|endwhile|ene|enew|ex|exi|exit|exu|exusage|f|file|files|filetype|fin|fina|finally|find|fini|finish|fir|first|fix|fixdel|fo|fold|foldc|foldclose|foldd|folddoc|folddoclosed|folddoopen|foldo|foldopen|for|fu|fun|function|go|goto|gr|grep|grepa|grepadd|h|ha|hardcopy|help|helpf|helpfind|helpg|helpgrep|helpt|helptags|hid|hide|his|history|ia|iabbrev|iabc|iabclear|if|ij|ijump|il|ilist|imapc|imapclear|in|inorea|inoreabbrev|isearch|isp|isplit|iu|iuna|iunabbrev|iunmap|j|join|ju|jumps|k|kee|keepalt|keepj|keepjumps|keepmarks|l|lN|lNext|lNf|lNfile|la|lad|laddb|laddbuffer|laddexpr|laddf|laddfile|lan|language|last|later|lb|lbuffer|lc|lcd|lch|lchdir|lcl|lclose|left|lefta|leftabove|let|lex|lexpr|lf|lfile|lfir|lfirst|lg|lgetb|lgetbuffer|lgete|lgetexpr|lgetfile|lgr|lgrep|lgrepa|lgrepadd|lh|lhelpgrep|list|ll|lla|llast|lli|llist|lm|lmak|lmake|lmap|lmapc|lmapclear|ln|lne|lnew|lnewer|lnext|lnf|lnfile|lnoremap|lo|loadview|loc|lockmarks|lockv|lockvar|lol|lolder|lop|lopen|lp|lpf|lpfile|lprevious|lr|lrewind|ls|lt|ltag|lu|lunmap|lv|lvimgrep|lvimgrepa|lvimgrepadd|lw|lwindow|m|ma|mak|make|mark|marks|mat|match|menut|menutranslate|mk|mkexrc|mks|mksession|mksp|mkspell|mkv|mkvie|mkview|mkvimrc|mod|mode|move|mz|mzf|mzfile|mzscheme|n|nbkey|new|next|nmapc|nmapclear|noh|nohlsearch|norea|noreabbrev|nu|number|nun|nunmap|o|omapc|omapclear|on|only|open|opt|options|ou|ounmap|p|pc|pclose|pe|ped|pedit|perl|perld|perldo|po|pop|popu|popup|pp|ppop|pre|preserve|prev|previous|print|prof|profd|profdel|profile|promptf|promptfind|promptr|promptrepl|ps|psearch|ptN|ptNext|pta|ptag|ptf|ptfirst|ptj|ptjump|ptl|ptlast|ptn|ptnext|ptp|ptprevious|ptr|ptrewind|pts|ptselect|pu|put|pw|pwd|py|pyf|pyfile|python|q|qa|qall|quit|quita|quitall|r|read|rec|recover|red|redi|redir|redo|redr|redraw|redraws|redrawstatus|reg|registers|res|resize|ret|retab|retu|return|rew|rewind|ri|right|rightb|rightbelow|ru|rub|ruby|rubyd|rubydo|rubyf|rubyfile|runtime|rv|rviminfo|sN|sNext|sa|sal|sall|san|sandbox|sargument|sav|saveas|sb|sbN|sbNext|sba|sball|sbf|sbfirst|sbl|sblast|sbm|sbmodified|sbn|sbnext|sbp|sbprevious|sbr|sbrewind|sbuffer|scrip|scripte|scriptencoding|scriptnames|se|set|setf|setfiletype|setg|setglobal|setl|setlocal|sf|sfind|sfir|sfirst|sh|shell|sign|sil|silent|sim|simalt|sl|sla|slast|sleep|sm|smagic|smap|smapc|smapclear|sme|smenu|sn|snext|sni|sniff|sno|snomagic|snor|snoremap|snoreme|snoremenu|so|sor|sort|source|sp|spe|spelld|spelldump|spellgood|spelli|spellinfo|spellr|spellrepall|spellu|spellundo|spellw|spellwrong|split|spr|sprevious|sre|srewind|st|sta|stag|star|startg|startgreplace|startinsert|startr|startreplace|stj|stjump|stop|stopi|stopinsert|sts|stselect|sun|sunhide|sunm|sunmap|sus|suspend|sv|sview|syncbind|t|tN|tNext|ta|tab|tabN|tabNext|tabc|tabclose|tabd|tabdo|tabe|tabedit|tabf|tabfind|tabfir|tabfirst|tabl|tablast|tabm|tabmove|tabn|tabnew|tabnext|tabo|tabonly|tabp|tabprevious|tabr|tabrewind|tabs|tag|tags|tc|tcl|tcld|tcldo|tclf|tclfile|te|tearoff|tf|tfirst|th|throw|tj|tjump|tl|tlast|tm|tmenu|tn|tnext|to|topleft|tp|tprevious|tr|trewind|try|ts|tselect|tu|tunmenu|u|una|unabbreviate|undo|undoj|undojoin|undol|undolist|unh|unhide|unlet|unlo|unlockvar|unm|unmap|up|update|ve|verb|verbose|version|vert|vertical|vi|vie|view|vim|vimgrep|vimgrepa|vimgrepadd|visual|viu|viusage|vmapc|vmapclear|vne|vnew|vs|vsplit|vu|vunmap|w|wN|wNext|wa|wall|wh|while|win|winc|wincmd|windo|winp|winpos|winsize|wn|wnext|wp|wprevious|wq|wqa|wqall|write|ws|wsverb|wv|wviminfo|x|xa|xall|xit|xm|xmap|xmapc|xmapclear|xme|xmenu|xn|xnoremap|xnoreme|xnoremenu|xu|xunmap|y|yank)\b/,
    builtin: /\b(?:acd|ai|akm|aleph|allowrevins|altkeymap|ambiwidth|ambw|anti|antialias|arab|arabic|arabicshape|ari|arshape|autochdir|autocmd|autoindent|autoread|autowrite|autowriteall|aw|awa|background|backspace|backup|backupcopy|backupdir|backupext|backupskip|balloondelay|ballooneval|balloonexpr|bdir|bdlay|beval|bex|bexpr|bg|bh|bin|binary|biosk|bioskey|bk|bkc|bomb|breakat|brk|browsedir|bs|bsdir|bsk|bt|bufhidden|buflisted|buftype|casemap|ccv|cdpath|cedit|cfu|ch|charconvert|ci|cin|cindent|cink|cinkeys|cino|cinoptions|cinw|cinwords|clipboard|cmdheight|cmdwinheight|cmp|cms|columns|com|comments|commentstring|compatible|complete|completefunc|completeopt|consk|conskey|copyindent|cot|cpo|cpoptions|cpt|cscopepathcomp|cscopeprg|cscopequickfix|cscopetag|cscopetagorder|cscopeverbose|cspc|csprg|csqf|cst|csto|csverb|cuc|cul|cursorcolumn|cursorline|cwh|debug|deco|def|define|delcombine|dex|dg|dict|dictionary|diff|diffexpr|diffopt|digraph|dip|dir|directory|dy|ea|ead|eadirection|eb|ed|edcompatible|ef|efm|ei|ek|enc|encoding|endofline|eol|ep|equalalways|equalprg|errorbells|errorfile|errorformat|esckeys|et|eventignore|expandtab|exrc|fcl|fcs|fdc|fde|fdi|fdl|fdls|fdm|fdn|fdo|fdt|fen|fenc|fencs|fex|ff|ffs|fileencoding|fileencodings|fileformat|fileformats|fillchars|fk|fkmap|flp|fml|fmr|foldcolumn|foldenable|foldexpr|foldignore|foldlevel|foldlevelstart|foldmarker|foldmethod|foldminlines|foldnestmax|foldtext|formatexpr|formatlistpat|formatoptions|formatprg|fp|fs|fsync|ft|gcr|gd|gdefault|gfm|gfn|gfs|gfw|ghr|gp|grepformat|grepprg|gtl|gtt|guicursor|guifont|guifontset|guifontwide|guiheadroom|guioptions|guipty|guitablabel|guitabtooltip|helpfile|helpheight|helplang|hf|hh|hi|hidden|highlight|hk|hkmap|hkmapp|hkp|hl|hlg|hls|hlsearch|ic|icon|iconstring|ignorecase|im|imactivatekey|imak|imc|imcmdline|imd|imdisable|imi|iminsert|ims|imsearch|inc|include|includeexpr|incsearch|inde|indentexpr|indentkeys|indk|inex|inf|infercase|insertmode|invacd|invai|invakm|invallowrevins|invaltkeymap|invanti|invantialias|invar|invarab|invarabic|invarabicshape|invari|invarshape|invautochdir|invautoindent|invautoread|invautowrite|invautowriteall|invaw|invawa|invbackup|invballooneval|invbeval|invbin|invbinary|invbiosk|invbioskey|invbk|invbl|invbomb|invbuflisted|invcf|invci|invcin|invcindent|invcompatible|invconfirm|invconsk|invconskey|invcopyindent|invcp|invcscopetag|invcscopeverbose|invcst|invcsverb|invcuc|invcul|invcursorcolumn|invcursorline|invdeco|invdelcombine|invdg|invdiff|invdigraph|invdisable|invea|inveb|inved|invedcompatible|invek|invendofline|inveol|invequalalways|inverrorbells|invesckeys|invet|invex|invexpandtab|invexrc|invfen|invfk|invfkmap|invfoldenable|invgd|invgdefault|invguipty|invhid|invhidden|invhk|invhkmap|invhkmapp|invhkp|invhls|invhlsearch|invic|invicon|invignorecase|invim|invimc|invimcmdline|invimd|invincsearch|invinf|invinfercase|invinsertmode|invis|invjoinspaces|invjs|invlazyredraw|invlbr|invlinebreak|invlisp|invlist|invloadplugins|invlpl|invlz|invma|invmacatsui|invmagic|invmh|invml|invmod|invmodeline|invmodifiable|invmodified|invmore|invmousef|invmousefocus|invmousehide|invnu|invnumber|invodev|invopendevice|invpaste|invpi|invpreserveindent|invpreviewwindow|invprompt|invpvw|invreadonly|invremap|invrestorescreen|invrevins|invri|invrightleft|invrightleftcmd|invrl|invrlc|invro|invrs|invru|invruler|invsb|invsc|invscb|invscrollbind|invscs|invsecure|invsft|invshellslash|invshelltemp|invshiftround|invshortname|invshowcmd|invshowfulltag|invshowmatch|invshowmode|invsi|invsm|invsmartcase|invsmartindent|invsmarttab|invsmd|invsn|invsol|invspell|invsplitbelow|invsplitright|invspr|invsr|invssl|invsta|invstartofline|invstmp|invswapfile|invswf|invta|invtagbsearch|invtagrelative|invtagstack|invtbi|invtbidi|invtbs|invtermbidi|invterse|invtextauto|invtextmode|invtf|invtgst|invtildeop|invtimeout|invtitle|invto|invtop|invtr|invttimeout|invttybuiltin|invttyfast|invtx|invvb|invvisualbell|invwa|invwarn|invwb|invweirdinvert|invwfh|invwfw|invwildmenu|invwinfixheight|invwinfixwidth|invwiv|invwmnu|invwrap|invwrapscan|invwrite|invwriteany|invwritebackup|invws|isf|isfname|isi|isident|isk|iskeyword|isprint|joinspaces|js|key|keymap|keymodel|keywordprg|km|kmp|kp|langmap|langmenu|laststatus|lazyredraw|lbr|lcs|linebreak|lines|linespace|lisp|lispwords|listchars|loadplugins|lpl|lsp|lz|macatsui|magic|makeef|makeprg|matchpairs|matchtime|maxcombine|maxfuncdepth|maxmapdepth|maxmem|maxmempattern|maxmemtot|mco|mef|menuitems|mfd|mh|mis|mkspellmem|ml|mls|mm|mmd|mmp|mmt|modeline|modelines|modifiable|modified|more|mouse|mousef|mousefocus|mousehide|mousem|mousemodel|mouses|mouseshape|mouset|mousetime|mp|mps|msm|mzq|mzquantum|nf|noacd|noai|noakm|noallowrevins|noaltkeymap|noanti|noantialias|noar|noarab|noarabic|noarabicshape|noari|noarshape|noautochdir|noautoindent|noautoread|noautowrite|noautowriteall|noaw|noawa|nobackup|noballooneval|nobeval|nobin|nobinary|nobiosk|nobioskey|nobk|nobl|nobomb|nobuflisted|nocf|noci|nocin|nocindent|nocompatible|noconfirm|noconsk|noconskey|nocopyindent|nocp|nocscopetag|nocscopeverbose|nocst|nocsverb|nocuc|nocul|nocursorcolumn|nocursorline|nodeco|nodelcombine|nodg|nodiff|nodigraph|nodisable|noea|noeb|noed|noedcompatible|noek|noendofline|noeol|noequalalways|noerrorbells|noesckeys|noet|noex|noexpandtab|noexrc|nofen|nofk|nofkmap|nofoldenable|nogd|nogdefault|noguipty|nohid|nohidden|nohk|nohkmap|nohkmapp|nohkp|nohls|noic|noicon|noignorecase|noim|noimc|noimcmdline|noimd|noincsearch|noinf|noinfercase|noinsertmode|nois|nojoinspaces|nojs|nolazyredraw|nolbr|nolinebreak|nolisp|nolist|noloadplugins|nolpl|nolz|noma|nomacatsui|nomagic|nomh|noml|nomod|nomodeline|nomodifiable|nomodified|nomore|nomousef|nomousefocus|nomousehide|nonu|nonumber|noodev|noopendevice|nopaste|nopi|nopreserveindent|nopreviewwindow|noprompt|nopvw|noreadonly|noremap|norestorescreen|norevins|nori|norightleft|norightleftcmd|norl|norlc|noro|nors|noru|noruler|nosb|nosc|noscb|noscrollbind|noscs|nosecure|nosft|noshellslash|noshelltemp|noshiftround|noshortname|noshowcmd|noshowfulltag|noshowmatch|noshowmode|nosi|nosm|nosmartcase|nosmartindent|nosmarttab|nosmd|nosn|nosol|nospell|nosplitbelow|nosplitright|nospr|nosr|nossl|nosta|nostartofline|nostmp|noswapfile|noswf|nota|notagbsearch|notagrelative|notagstack|notbi|notbidi|notbs|notermbidi|noterse|notextauto|notextmode|notf|notgst|notildeop|notimeout|notitle|noto|notop|notr|nottimeout|nottybuiltin|nottyfast|notx|novb|novisualbell|nowa|nowarn|nowb|noweirdinvert|nowfh|nowfw|nowildmenu|nowinfixheight|nowinfixwidth|nowiv|nowmnu|nowrap|nowrapscan|nowrite|nowriteany|nowritebackup|nows|nrformats|numberwidth|nuw|odev|oft|ofu|omnifunc|opendevice|operatorfunc|opfunc|osfiletype|pa|para|paragraphs|paste|pastetoggle|patchexpr|patchmode|path|pdev|penc|pex|pexpr|pfn|ph|pheader|pi|pm|pmbcs|pmbfn|popt|preserveindent|previewheight|previewwindow|printdevice|printencoding|printexpr|printfont|printheader|printmbcharset|printmbfont|printoptions|prompt|pt|pumheight|pvh|pvw|qe|quoteescape|readonly|remap|report|restorescreen|revins|rightleft|rightleftcmd|rl|rlc|ro|rs|rtp|ruf|ruler|rulerformat|runtimepath|sbo|sc|scb|scr|scroll|scrollbind|scrolljump|scrolloff|scrollopt|scs|sect|sections|secure|sel|selection|selectmode|sessionoptions|sft|shcf|shellcmdflag|shellpipe|shellquote|shellredir|shellslash|shelltemp|shelltype|shellxquote|shiftround|shiftwidth|shm|shortmess|shortname|showbreak|showcmd|showfulltag|showmatch|showmode|showtabline|shq|si|sidescroll|sidescrolloff|siso|sj|slm|smartcase|smartindent|smarttab|smc|smd|softtabstop|sol|spc|spell|spellcapcheck|spellfile|spelllang|spellsuggest|spf|spl|splitbelow|splitright|sps|sr|srr|ss|ssl|ssop|stal|startofline|statusline|stl|stmp|su|sua|suffixes|suffixesadd|sw|swapfile|swapsync|swb|swf|switchbuf|sws|sxq|syn|synmaxcol|syntax|t_AB|t_AF|t_AL|t_CS|t_CV|t_Ce|t_Co|t_Cs|t_DL|t_EI|t_F1|t_F2|t_F3|t_F4|t_F5|t_F6|t_F7|t_F8|t_F9|t_IE|t_IS|t_K1|t_K3|t_K4|t_K5|t_K6|t_K7|t_K8|t_K9|t_KA|t_KB|t_KC|t_KD|t_KE|t_KF|t_KG|t_KH|t_KI|t_KJ|t_KK|t_KL|t_RI|t_RV|t_SI|t_Sb|t_Sf|t_WP|t_WS|t_ZH|t_ZR|t_al|t_bc|t_cd|t_ce|t_cl|t_cm|t_cs|t_da|t_db|t_dl|t_fs|t_k1|t_k2|t_k3|t_k4|t_k5|t_k6|t_k7|t_k8|t_k9|t_kB|t_kD|t_kI|t_kN|t_kP|t_kb|t_kd|t_ke|t_kh|t_kl|t_kr|t_ks|t_ku|t_le|t_mb|t_md|t_me|t_mr|t_ms|t_nd|t_op|t_se|t_so|t_sr|t_te|t_ti|t_ts|t_ue|t_us|t_ut|t_vb|t_ve|t_vi|t_vs|t_xs|tabline|tabpagemax|tabstop|tagbsearch|taglength|tagrelative|tagstack|tal|tb|tbi|tbidi|tbis|tbs|tenc|term|termbidi|termencoding|terse|textauto|textmode|textwidth|tgst|thesaurus|tildeop|timeout|timeoutlen|title|titlelen|titleold|titlestring|toolbar|toolbariconsize|top|tpm|tsl|tsr|ttimeout|ttimeoutlen|ttm|tty|ttybuiltin|ttyfast|ttym|ttymouse|ttyscroll|ttytype|tw|tx|uc|ul|undolevels|updatecount|updatetime|ut|vb|vbs|vdir|verbosefile|vfile|viewdir|viewoptions|viminfo|virtualedit|visualbell|vop|wak|warn|wb|wc|wcm|wd|weirdinvert|wfh|wfw|whichwrap|wi|wig|wildchar|wildcharm|wildignore|wildmenu|wildmode|wildoptions|wim|winaltkeys|window|winfixheight|winfixwidth|winheight|winminheight|winminwidth|winwidth|wiv|wiw|wm|wmh|wmnu|wmw|wop|wrap|wrapmargin|wrapscan|writeany|writebackup|writedelay|ww)\b/,
    number: /\b(?:0x[\da-f]+|\d+(?:\.\d+)?)\b/i,
    operator: /\|\||&&|[-+.]=?|[=!](?:[=~][#?]?)?|[<>]=?[#?]?|[*\/%?]|\b(?:is(?:not)?)\b/,
    punctuation: /[{}[\](),;:]/
  };
}

vim.displayName = "vim", vim.aliases = [];
var visualBasic_1 = visualBasic;

function visualBasic(e) {
  e.languages["visual-basic"] = {
    comment: {
      pattern: /(?:['‘’]|REM\b)(?:[^\r\n_]|_(?:\r\n?|\n)?)*/i,
      inside: {
        keyword: /^REM/i
      }
    },
    directive: {
      pattern: /#(?:Const|Else|ElseIf|End|ExternalChecksum|ExternalSource|If|Region)(?:\b_[ \t]*(?:\r\n?|\n)|.)+/i,
      alias: "property",
      greedy: !0
    },
    string: {
      pattern: /\$?["“”](?:["“”]{2}|[^"“”])*["“”]C?/i,
      greedy: !0
    },
    date: {
      pattern: /#[ \t]*(?:\d+([/-])\d+\1\d+(?:[ \t]+(?:\d+[ \t]*(?:AM|PM)|\d+:\d+(?::\d+)?(?:[ \t]*(?:AM|PM))?))?|\d+[ \t]*(?:AM|PM)|\d+:\d+(?::\d+)?(?:[ \t]*(?:AM|PM))?)[ \t]*#/i,
      alias: "number"
    },
    number: /(?:(?:\b\d+(?:\.\d+)?|\.\d+)(?:E[+-]?\d+)?|&[HO][\dA-F]+)(?:[FRD]|U?[ILS])?/i,
    boolean: /\b(?:False|Nothing|True)\b/i,
    keyword: /\b(?:AddHandler|AddressOf|Alias|And(?:Also)?|As|Boolean|ByRef|Byte|ByVal|Call|Case|Catch|C(?:Bool|Byte|Char|Date|Dbl|Dec|Int|Lng|Obj|SByte|Short|Sng|Str|Type|UInt|ULng|UShort)|Char|Class|Const|Continue|Currency|Date|Decimal|Declare|Default|Delegate|Dim|DirectCast|Do|Double|Each|Else(?:If)?|End(?:If)?|Enum|Erase|Error|Event|Exit|Finally|For|Friend|Function|Get(?:Type|XMLNamespace)?|Global|GoSub|GoTo|Handles|If|Implements|Imports|In|Inherits|Integer|Interface|Is|IsNot|Let|Lib|Like|Long|Loop|Me|Mod|Module|Must(?:Inherit|Override)|My(?:Base|Class)|Namespace|Narrowing|New|Next|Not(?:Inheritable|Overridable)?|Object|Of|On|Operator|Option(?:al)?|Or(?:Else)?|Out|Overloads|Overridable|Overrides|ParamArray|Partial|Private|Property|Protected|Public|RaiseEvent|ReadOnly|ReDim|RemoveHandler|Resume|Return|SByte|Select|Set|Shadows|Shared|short|Single|Static|Step|Stop|String|Structure|Sub|SyncLock|Then|Throw|To|Try|TryCast|Type|TypeOf|U(?:Integer|Long|Short)|Until|Using|Variant|Wend|When|While|Widening|With(?:Events)?|WriteOnly|Xor)\b/i,
    operator: /[+\-*/\\^<=>&#@$%!]|\b_(?=[ \t]*[\r\n])/,
    punctuation: /[{}().,:?]/
  }, e.languages.vb = e.languages["visual-basic"], e.languages.vba = e.languages["visual-basic"];
}

visualBasic.displayName = "visualBasic", visualBasic.aliases = [];
var warpscript_1 = warpscript;

function warpscript(e) {
  e.languages.warpscript = {
    comment: /#.*|\/\/.*|\/\*[\s\S]*?\*\//,
    string: {
      pattern: /"(?:[^"\\\r\n]|\\.)*"|'(?:[^'\\\r\n]|\\.)*'|<'(?:[^\\']|'(?!>)|\\.)*'>/,
      greedy: !0
    },
    variable: /\$\S+/,
    macro: {
      pattern: /@\S+/,
      alias: "property"
    },
    keyword: /\b(?:BREAK|CHECKMACRO|CONTINUE|CUDF|DEFINED|DEFINEDMACRO|EVAL|FAIL|FOR|FOREACH|FORSTEP|IFT|IFTE|MSGFAIL|NRETURN|RETHROW|RETURN|SWITCH|TRY|UDF|UNTIL|WHILE)\b/,
    number: /[+-]?\b(?:NaN|Infinity|\d+(?:\.\d*)?(?:[Ee][+-]?\d+)?|0x[\da-fA-F]+|0b[01]+)\b/,
    boolean: /\b(?:F|T|false|true)\b/,
    punctuation: /<%|%>|[{}[\]()]/,
    operator: /==|&&?|\|\|?|\*\*?|>>>?|<<|[<>!~]=?|[-/%^]|\+!?|\b(?:AND|NOT|OR)\b/
  };
}

warpscript.displayName = "warpscript", warpscript.aliases = [];
var wasm_1 = wasm;

function wasm(e) {
  e.languages.wasm = {
    comment: [/\(;[\s\S]*?;\)/, {
      pattern: /;;.*/,
      greedy: !0
    }],
    string: {
      pattern: /"(?:\\[\s\S]|[^"\\])*"/,
      greedy: !0
    },
    keyword: [{
      pattern: /\b(?:align|offset)=/,
      inside: {
        operator: /=/
      }
    }, {
      pattern: /\b(?:(?:f32|f64|i32|i64)(?:\.(?:abs|add|and|ceil|clz|const|convert_[su]\/i(?:32|64)|copysign|ctz|demote\/f64|div(?:_[su])?|eqz?|extend_[su]\/i32|floor|ge(?:_[su])?|gt(?:_[su])?|le(?:_[su])?|load(?:(?:8|16|32)_[su])?|lt(?:_[su])?|max|min|mul|neg?|nearest|or|popcnt|promote\/f32|reinterpret\/[fi](?:32|64)|rem_[su]|rot[lr]|shl|shr_[su]|sqrt|store(?:8|16|32)?|sub|trunc(?:_[su]\/f(?:32|64))?|wrap\/i64|xor))?|memory\.(?:grow|size))\b/,
      inside: {
        punctuation: /\./
      }
    }, /\b(?:anyfunc|block|br(?:_if|_table)?|call(?:_indirect)?|data|drop|elem|else|end|export|func|get_(?:global|local)|global|if|import|local|loop|memory|module|mut|nop|offset|param|result|return|select|set_(?:global|local)|start|table|tee_local|then|type|unreachable)\b/],
    variable: /\$[\w!#$%&'*+\-./:<=>?@\\^`|~]+/,
    number: /[+-]?\b(?:\d(?:_?\d)*(?:\.\d(?:_?\d)*)?(?:[eE][+-]?\d(?:_?\d)*)?|0x[\da-fA-F](?:_?[\da-fA-F])*(?:\.[\da-fA-F](?:_?[\da-fA-D])*)?(?:[pP][+-]?\d(?:_?\d)*)?)\b|\binf\b|\bnan(?::0x[\da-fA-F](?:_?[\da-fA-D])*)?\b/,
    punctuation: /[()]/
  };
}

wasm.displayName = "wasm", wasm.aliases = [];
var webIdl_1 = webIdl;

function webIdl(e) {
  !function (e) {
    var t = /(?:\B-|\b_|\b)[A-Za-z][\w-]*(?![\w-])/.source,
        r = "(?:" + /\b(?:unsigned\s+)?long\s+long(?![\w-])/.source + "|" + /\b(?:unrestricted|unsigned)\s+[a-z]+(?![\w-])/.source + "|" + /(?!(?:unrestricted|unsigned)\b)/.source + t + /(?:\s*<(?:[^<>]|<[^<>]*>)*>)?/.source + ")" + /(?:\s*\?)?/.source,
        n = {};

    for (var a in e.languages["web-idl"] = {
      comment: {
        pattern: /\/\/.*|\/\*[\s\S]*?\*\//,
        greedy: !0
      },
      string: {
        pattern: /"[^"]*"/,
        greedy: !0
      },
      namespace: {
        pattern: RegExp(/(\bnamespace\s+)/.source + t),
        lookbehind: !0
      },
      "class-name": [{
        pattern: /(^|[^\w-])(?:iterable|maplike|setlike)\s*<(?:[^<>]|<[^<>]*>)*>/,
        lookbehind: !0,
        inside: n
      }, {
        pattern: RegExp(/(\b(?:attribute|const|deleter|getter|optional|setter)\s+)/.source + r),
        lookbehind: !0,
        inside: n
      }, {
        pattern: RegExp("(" + /\bcallback\s+/.source + t + /\s*=\s*/.source + ")" + r),
        lookbehind: !0,
        inside: n
      }, {
        pattern: RegExp(/(\btypedef\b\s*)/.source + r),
        lookbehind: !0,
        inside: n
      }, {
        pattern: RegExp(/(\b(?:callback|dictionary|enum|interface(?:\s+mixin)?)\s+)(?!(?:interface|mixin)\b)/.source + t),
        lookbehind: !0
      }, {
        pattern: RegExp(/(:\s*)/.source + t),
        lookbehind: !0
      }, RegExp(t + /(?=\s+(?:implements|includes)\b)/.source), {
        pattern: RegExp(/(\b(?:implements|includes)\s+)/.source + t),
        lookbehind: !0
      }, {
        pattern: RegExp(r + "(?=" + /\s*(?:\.{3}\s*)?/.source + t + /\s*[(),;=]/.source + ")"),
        inside: n
      }],
      builtin: /\b(?:ArrayBuffer|BigInt64Array|BigUint64Array|ByteString|DOMString|DataView|Float32Array|Float64Array|FrozenArray|Int16Array|Int32Array|Int8Array|ObservableArray|Promise|USVString|Uint16Array|Uint32Array|Uint8Array|Uint8ClampedArray)\b/,
      keyword: [/\b(?:async|attribute|callback|const|constructor|deleter|dictionary|enum|getter|implements|includes|inherit|interface|mixin|namespace|null|optional|or|partial|readonly|required|setter|static|stringifier|typedef|unrestricted)\b/, /\b(?:any|bigint|boolean|byte|double|float|iterable|long|maplike|object|octet|record|sequence|setlike|short|symbol|undefined|unsigned|void)\b/],
      boolean: /\b(?:false|true)\b/,
      number: {
        pattern: /(^|[^\w-])-?(?:0x[0-9a-f]+|(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?|NaN|Infinity)(?![\w-])/i,
        lookbehind: !0
      },
      operator: /\.{3}|[=:?<>-]/,
      punctuation: /[(){}[\].,;]/
    }, e.languages["web-idl"]) {
      "class-name" !== a && (n[a] = e.languages["web-idl"][a]);
    }

    e.languages.webidl = e.languages["web-idl"];
  }(e);
}

webIdl.displayName = "webIdl", webIdl.aliases = [];
var wiki_1 = wiki;

function wiki(e) {
  e.languages.wiki = e.languages.extend("markup", {
    "block-comment": {
      pattern: /(^|[^\\])\/\*[\s\S]*?\*\//,
      lookbehind: !0,
      alias: "comment"
    },
    heading: {
      pattern: /^(=+)[^=\r\n].*?\1/m,
      inside: {
        punctuation: /^=+|=+$/,
        important: /.+/
      }
    },
    emphasis: {
      pattern: /('{2,5}).+?\1/,
      inside: {
        "bold-italic": {
          pattern: /(''''').+?(?=\1)/,
          lookbehind: !0,
          alias: ["bold", "italic"]
        },
        bold: {
          pattern: /(''')[^'](?:.*?[^'])?(?=\1)/,
          lookbehind: !0
        },
        italic: {
          pattern: /('')[^'](?:.*?[^'])?(?=\1)/,
          lookbehind: !0
        },
        punctuation: /^''+|''+$/
      }
    },
    hr: {
      pattern: /^-{4,}/m,
      alias: "punctuation"
    },
    url: [/ISBN +(?:97[89][ -]?)?(?:\d[ -]?){9}[\dx]\b|(?:PMID|RFC) +\d+/i, /\[\[.+?\]\]|\[.+?\]/],
    variable: [/__[A-Z]+__/, /\{{3}.+?\}{3}/, /\{\{.+?\}\}/],
    symbol: [/^#redirect/im, /~{3,5}/],
    "table-tag": {
      pattern: /((?:^|[|!])[|!])[^|\r\n]+\|(?!\|)/m,
      lookbehind: !0,
      inside: {
        "table-bar": {
          pattern: /\|$/,
          alias: "punctuation"
        },
        rest: e.languages.markup.tag.inside
      }
    },
    punctuation: /^(?:\{\||\|\}|\|-|[*#:;!|])|\|\||!!/m
  }), e.languages.insertBefore("wiki", "tag", {
    nowiki: {
      pattern: /<(nowiki|pre|source)\b[^>]*>[\s\S]*?<\/\1>/i,
      inside: {
        tag: {
          pattern: /<(?:nowiki|pre|source)\b[^>]*>|<\/(?:nowiki|pre|source)>/i,
          inside: e.languages.markup.tag.inside
        }
      }
    }
  });
}

wiki.displayName = "wiki", wiki.aliases = [];
var wolfram_1 = wolfram;

function wolfram(e) {
  e.languages.wolfram = {
    comment: /\(\*(?:\(\*(?:[^*]|\*(?!\)))*\*\)|(?!\(\*)[\s\S])*?\*\)/,
    string: {
      pattern: /"(?:\\.|[^"\\\r\n])*"/,
      greedy: !0
    },
    keyword: /\b(?:Abs|AbsArg|Accuracy|Block|Do|For|Function|If|Manipulate|Module|Nest|NestList|None|Return|Switch|Table|Which|While)\b/,
    context: {
      pattern: /\b\w+`+\w*/,
      alias: "class-name"
    },
    blank: {
      pattern: /\b\w+_\b/,
      alias: "regex"
    },
    "global-variable": {
      pattern: /\$\w+/,
      alias: "variable"
    },
    boolean: /\b(?:False|True)\b/,
    number: /(?:\b(?=\d)|\B(?=\.))(?:0[bo])?(?:(?:\d|0x[\da-f])[\da-f]*(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?j?\b/i,
    operator: /\/\.|;|=\.|\^=|\^:=|:=|<<|>>|<\||\|>|:>|\|->|->|<-|@@@|@@|@|\/@|=!=|===|==|=|\+|-|\^|\[\/-+%=\]=?|!=|\*\*?=?|\/\/?=?|<[<=>]?|>[=>]?|[&|^~]/,
    punctuation: /[{}[\];(),.:]/
  }, e.languages.mathematica = e.languages.wolfram, e.languages.wl = e.languages.wolfram, e.languages.nb = e.languages.wolfram;
}

wolfram.displayName = "wolfram", wolfram.aliases = ["mathematica", "wl", "nb"];
var wren_1 = wren;

function wren(e) {
  e.languages.wren = {
    comment: [{
      pattern: /\/\*(?:[^*/]|\*(?!\/)|\/(?!\*)|\/\*(?:[^*/]|\*(?!\/)|\/(?!\*)|\/\*(?:[^*/]|\*(?!\/)|\/(?!\*))*\*\/)*\*\/)*\*\//,
      greedy: !0
    }, {
      pattern: /(^|[^\\:])\/\/.*/,
      lookbehind: !0,
      greedy: !0
    }],
    "triple-quoted-string": {
      pattern: /"""[\s\S]*?"""/,
      greedy: !0,
      alias: "string"
    },
    "string-literal": null,
    hashbang: {
      pattern: /^#!\/.+/,
      greedy: !0,
      alias: "comment"
    },
    attribute: {
      pattern: /#!?[ \t\u3000]*\w+/,
      alias: "keyword"
    },
    "class-name": [{
      pattern: /(\bclass\s+)\w+/,
      lookbehind: !0
    }, /\b[A-Z][a-z\d_]*\b/],
    constant: /\b[A-Z][A-Z\d_]*\b/,
    null: {
      pattern: /\bnull\b/,
      alias: "keyword"
    },
    keyword: /\b(?:as|break|class|construct|continue|else|for|foreign|if|import|in|is|return|static|super|this|var|while)\b/,
    boolean: /\b(?:false|true)\b/,
    number: /\b(?:0x[\da-f]+|\d+(?:\.\d+)?(?:e[+-]?\d+)?)\b/i,
    function: /\b[a-z_]\w*(?=\s*[({])/i,
    operator: /<<|>>|[=!<>]=?|&&|\|\||[-+*/%~^&|?:]|\.{2,3}/,
    punctuation: /[\[\](){}.,;]/
  }, e.languages.wren["string-literal"] = {
    pattern: /(^|[^\\"])"(?:[^\\"%]|\\[\s\S]|%(?!\()|%\((?:[^()]|\((?:[^()]|\([^)]*\))*\))*\))*"/,
    lookbehind: !0,
    greedy: !0,
    inside: {
      interpolation: {
        pattern: /((?:^|[^\\])(?:\\{2})*)%\((?:[^()]|\((?:[^()]|\([^)]*\))*\))*\)/,
        lookbehind: !0,
        inside: {
          expression: {
            pattern: /^(%\()[\s\S]+(?=\)$)/,
            lookbehind: !0,
            inside: e.languages.wren
          },
          "interpolation-punctuation": {
            pattern: /^%\(|\)$/,
            alias: "punctuation"
          }
        }
      },
      string: /[\s\S]+/
    }
  };
}

wren.displayName = "wren", wren.aliases = [];
var xeora_1 = xeora;

function xeora(e) {
  !function (e) {
    e.languages.xeora = e.languages.extend("markup", {
      constant: {
        pattern: /\$(?:DomainContents|PageRenderDuration)\$/,
        inside: {
          punctuation: {
            pattern: /\$/
          }
        }
      },
      variable: {
        pattern: /\$@?(?:#+|[-+*~=^])?[\w.]+\$/,
        inside: {
          punctuation: {
            pattern: /[$.]/
          },
          operator: {
            pattern: /#+|[-+*~=^@]/
          }
        }
      },
      "function-inline": {
        pattern: /\$F:[-\w.]+\?[-\w.]+(?:,(?:(?:@[-#]*\w+\.[\w+.]\.*)*\|)*(?:(?:[\w+]|[-#*.~^]+[\w+]|=\S)(?:[^$=]|=+[^=])*=*|(?:@[-#]*\w+\.[\w+.]\.*)+(?:(?:[\w+]|[-#*~^][-#*.~^]*[\w+]|=\S)(?:[^$=]|=+[^=])*=*)?)?)?\$/,
        inside: {
          variable: {
            pattern: /(?:[,|])@?(?:#+|[-+*~=^])?[\w.]+/,
            inside: {
              punctuation: {
                pattern: /[,.|]/
              },
              operator: {
                pattern: /#+|[-+*~=^@]/
              }
            }
          },
          punctuation: {
            pattern: /\$\w:|[$:?.,|]/
          }
        },
        alias: "function"
      },
      "function-block": {
        pattern: /\$XF:\{[-\w.]+\?[-\w.]+(?:,(?:(?:@[-#]*\w+\.[\w+.]\.*)*\|)*(?:(?:[\w+]|[-#*.~^]+[\w+]|=\S)(?:[^$=]|=+[^=])*=*|(?:@[-#]*\w+\.[\w+.]\.*)+(?:(?:[\w+]|[-#*~^][-#*.~^]*[\w+]|=\S)(?:[^$=]|=+[^=])*=*)?)?)?\}:XF\$/,
        inside: {
          punctuation: {
            pattern: /[$:{}?.,|]/
          }
        },
        alias: "function"
      },
      "directive-inline": {
        pattern: /\$\w(?:#\d+\+?)?(?:\[[-\w.]+\])?:[-\/\w.]+\$/,
        inside: {
          punctuation: {
            pattern: /\$(?:\w:|C(?:\[|#\d))?|[:{[\]]/,
            inside: {
              tag: {
                pattern: /#\d/
              }
            }
          }
        },
        alias: "function"
      },
      "directive-block-open": {
        pattern: /\$\w+:\{|\$\w(?:#\d+\+?)?(?:\[[-\w.]+\])?:[-\w.]+:\{(?:![A-Z]+)?/,
        inside: {
          punctuation: {
            pattern: /\$(?:\w:|C(?:\[|#\d))?|[:{[\]]/,
            inside: {
              tag: {
                pattern: /#\d/
              }
            }
          },
          attribute: {
            pattern: /![A-Z]+$/,
            inside: {
              punctuation: {
                pattern: /!/
              }
            },
            alias: "keyword"
          }
        },
        alias: "function"
      },
      "directive-block-separator": {
        pattern: /\}:[-\w.]+:\{/,
        inside: {
          punctuation: {
            pattern: /[:{}]/
          }
        },
        alias: "function"
      },
      "directive-block-close": {
        pattern: /\}:[-\w.]+\$/,
        inside: {
          punctuation: {
            pattern: /[:{}$]/
          }
        },
        alias: "function"
      }
    }), e.languages.insertBefore("inside", "punctuation", {
      variable: e.languages.xeora["function-inline"].inside.variable
    }, e.languages.xeora["function-block"]), e.languages.xeoracube = e.languages.xeora;
  }(e);
}

xeora.displayName = "xeora", xeora.aliases = ["xeoracube"];
var xmlDoc_1 = xmlDoc;

function xmlDoc(e) {
  !function (e) {
    function t(t, r) {
      e.languages[t] && e.languages.insertBefore(t, "comment", {
        "doc-comment": r
      });
    }

    var r = e.languages.markup.tag,
        n = {
      pattern: /\/\/\/.*/,
      greedy: !0,
      alias: "comment",
      inside: {
        tag: r
      }
    },
        a = {
      pattern: /'''.*/,
      greedy: !0,
      alias: "comment",
      inside: {
        tag: r
      }
    };
    t("csharp", n), t("fsharp", n), t("vbnet", a);
  }(e);
}

xmlDoc.displayName = "xmlDoc", xmlDoc.aliases = [];
var xojo_1 = xojo;

function xojo(e) {
  e.languages.xojo = {
    comment: {
      pattern: /(?:'|\/\/|Rem\b).+/i,
      greedy: !0
    },
    string: {
      pattern: /"(?:""|[^"])*"/,
      greedy: !0
    },
    number: [/(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:E[+-]?\d+)?/i, /&[bchou][a-z\d]+/i],
    directive: {
      pattern: /#(?:Else|ElseIf|Endif|If|Pragma)\b/i,
      alias: "property"
    },
    keyword: /\b(?:AddHandler|App|Array|As(?:signs)?|Auto|Boolean|Break|By(?:Ref|Val)|Byte|Call|Case|Catch|CFStringRef|CGFloat|Class|Color|Const|Continue|CString|Currency|CurrentMethodName|Declare|Delegate|Dim|Do(?:uble|wnTo)?|Each|Else(?:If)?|End|Enumeration|Event|Exception|Exit|Extends|False|Finally|For|Function|Get|GetTypeInfo|Global|GOTO|If|Implements|In|Inherits|Int(?:8|16|32|64|eger|erface)?|Lib|Loop|Me|Module|Next|Nil|Object|Optional|OSType|ParamArray|Private|Property|Protected|PString|Ptr|Raise(?:Event)?|ReDim|RemoveHandler|Return|Select(?:or)?|Self|Set|Shared|Short|Single|Soft|Static|Step|String|Sub|Super|Text|Then|To|True|Try|Ubound|UInt(?:8|16|32|64|eger)?|Until|Using|Var(?:iant)?|Wend|While|WindowPtr|WString)\b/i,
    operator: /<[=>]?|>=?|[+\-*\/\\^=]|\b(?:AddressOf|And|Ctype|IsA?|Mod|New|Not|Or|WeakAddressOf|Xor)\b/i,
    punctuation: /[.,;:()]/
  };
}

xojo.displayName = "xojo", xojo.aliases = [];
var xquery_1 = xquery;

function xquery(e) {
  !function (e) {
    e.languages.xquery = e.languages.extend("markup", {
      "xquery-comment": {
        pattern: /\(:[\s\S]*?:\)/,
        greedy: !0,
        alias: "comment"
      },
      string: {
        pattern: /(["'])(?:\1\1|(?!\1)[\s\S])*\1/,
        greedy: !0
      },
      extension: {
        pattern: /\(#.+?#\)/,
        alias: "symbol"
      },
      variable: /\$[-\w:]+/,
      axis: {
        pattern: /(^|[^-])(?:ancestor(?:-or-self)?|attribute|child|descendant(?:-or-self)?|following(?:-sibling)?|parent|preceding(?:-sibling)?|self)(?=::)/,
        lookbehind: !0,
        alias: "operator"
      },
      "keyword-operator": {
        pattern: /(^|[^:-])\b(?:and|castable as|div|eq|except|ge|gt|idiv|instance of|intersect|is|le|lt|mod|ne|or|union)\b(?=$|[^:-])/,
        lookbehind: !0,
        alias: "operator"
      },
      keyword: {
        pattern: /(^|[^:-])\b(?:as|ascending|at|base-uri|boundary-space|case|cast as|collation|construction|copy-namespaces|declare|default|descending|else|empty (?:greatest|least)|encoding|every|external|for|function|if|import|in|inherit|lax|let|map|module|namespace|no-inherit|no-preserve|option|order(?: by|ed|ing)?|preserve|return|satisfies|schema|some|stable|strict|strip|then|to|treat as|typeswitch|unordered|validate|variable|version|where|xquery)\b(?=$|[^:-])/,
        lookbehind: !0
      },
      function: /[\w-]+(?::[\w-]+)*(?=\s*\()/,
      "xquery-element": {
        pattern: /(element\s+)[\w-]+(?::[\w-]+)*/,
        lookbehind: !0,
        alias: "tag"
      },
      "xquery-attribute": {
        pattern: /(attribute\s+)[\w-]+(?::[\w-]+)*/,
        lookbehind: !0,
        alias: "attr-name"
      },
      builtin: {
        pattern: /(^|[^:-])\b(?:attribute|comment|document|element|processing-instruction|text|xs:(?:ENTITIES|ENTITY|ID|IDREFS?|NCName|NMTOKENS?|NOTATION|Name|QName|anyAtomicType|anyType|anyURI|base64Binary|boolean|byte|date|dateTime|dayTimeDuration|decimal|double|duration|float|gDay|gMonth|gMonthDay|gYear|gYearMonth|hexBinary|int|integer|language|long|negativeInteger|nonNegativeInteger|nonPositiveInteger|normalizedString|positiveInteger|short|string|time|token|unsigned(?:Byte|Int|Long|Short)|untyped(?:Atomic)?|yearMonthDuration))\b(?=$|[^:-])/,
        lookbehind: !0
      },
      number: /\b\d+(?:\.\d+)?(?:E[+-]?\d+)?/,
      operator: [/[+*=?|@]|\.\.?|:=|!=|<[=<]?|>[=>]?/, {
        pattern: /(\s)-(?=\s)/,
        lookbehind: !0
      }],
      punctuation: /[[\](){},;:/]/
    }), e.languages.xquery.tag.pattern = /<\/?(?!\d)[^\s>\/=$<%]+(?:\s+[^\s>\/=]+(?:=(?:("|')(?:\\[\s\S]|\{(?!\{)(?:\{(?:\{[^{}]*\}|[^{}])*\}|[^{}])+\}|(?!\1)[^\\])*\1|[^\s'">=]+))?)*\s*\/?>/, e.languages.xquery.tag.inside["attr-value"].pattern = /=(?:("|')(?:\\[\s\S]|\{(?!\{)(?:\{(?:\{[^{}]*\}|[^{}])*\}|[^{}])+\}|(?!\1)[^\\])*\1|[^\s'">=]+)/, e.languages.xquery.tag.inside["attr-value"].inside.punctuation = /^="|"$/, e.languages.xquery.tag.inside["attr-value"].inside.expression = {
      pattern: /\{(?!\{)(?:\{(?:\{[^{}]*\}|[^{}])*\}|[^{}])+\}/,
      inside: e.languages.xquery,
      alias: "language-xquery"
    };

    var t = function t(e) {
      return "string" == typeof e ? e : "string" == typeof e.content ? e.content : e.content.map(t).join("");
    },
        r = function r(n) {
      for (var a = [], o = 0; o < n.length; o++) {
        var i = n[o],
            s = !1;

        if ("string" != typeof i && ("tag" === i.type && i.content[0] && "tag" === i.content[0].type ? "</" === i.content[0].content[0].content ? a.length > 0 && a[a.length - 1].tagName === t(i.content[0].content[1]) && a.pop() : "/>" === i.content[i.content.length - 1].content || a.push({
          tagName: t(i.content[0].content[1]),
          openedBraces: 0
        }) : !(a.length > 0 && "punctuation" === i.type && "{" === i.content) || n[o + 1] && "punctuation" === n[o + 1].type && "{" === n[o + 1].content || n[o - 1] && "plain-text" === n[o - 1].type && "{" === n[o - 1].content ? a.length > 0 && a[a.length - 1].openedBraces > 0 && "punctuation" === i.type && "}" === i.content ? a[a.length - 1].openedBraces-- : "comment" !== i.type && (s = !0) : a[a.length - 1].openedBraces++), (s || "string" == typeof i) && a.length > 0 && 0 === a[a.length - 1].openedBraces) {
          var l = t(i);
          o < n.length - 1 && ("string" == typeof n[o + 1] || "plain-text" === n[o + 1].type) && (l += t(n[o + 1]), n.splice(o + 1, 1)), o > 0 && ("string" == typeof n[o - 1] || "plain-text" === n[o - 1].type) && (l = t(n[o - 1]) + l, n.splice(o - 1, 1), o--), /^\s+$/.test(l) ? n[o] = l : n[o] = new e.Token("plain-text", l, null, l);
        }

        i.content && "string" != typeof i.content && r(i.content);
      }
    };

    e.hooks.add("after-tokenize", function (e) {
      "xquery" === e.language && r(e.tokens);
    });
  }(e);
}

xquery.displayName = "xquery", xquery.aliases = [];
var yang_1 = yang;

function yang(e) {
  e.languages.yang = {
    comment: /\/\*[\s\S]*?\*\/|\/\/.*/,
    string: {
      pattern: /"(?:[^\\"]|\\.)*"|'[^']*'/,
      greedy: !0
    },
    keyword: {
      pattern: /(^|[{};\r\n][ \t]*)[a-z_][\w.-]*/i,
      lookbehind: !0
    },
    namespace: {
      pattern: /(\s)[a-z_][\w.-]*(?=:)/i,
      lookbehind: !0
    },
    boolean: /\b(?:false|true)\b/,
    operator: /\+/,
    punctuation: /[{};:]/
  };
}

yang.displayName = "yang", yang.aliases = [];
var zig_1 = zig;

function zig(e) {
  !function (e) {
    function t(e) {
      return function () {
        return e;
      };
    }

    var r = /\b(?:align|allowzero|and|anyframe|anytype|asm|async|await|break|cancel|catch|comptime|const|continue|defer|else|enum|errdefer|error|export|extern|fn|for|if|inline|linksection|nakedcc|noalias|nosuspend|null|or|orelse|packed|promise|pub|resume|return|stdcallcc|struct|suspend|switch|test|threadlocal|try|undefined|union|unreachable|usingnamespace|var|volatile|while)\b/,
        n = "\\b(?!" + r.source + ")(?!\\d)\\w+\\b",
        a = /align\s*\((?:[^()]|\([^()]*\))*\)/.source,
        o = "(?!\\s)(?:!?\\s*(?:" + /(?:\?|\bpromise->|(?:\[[^[\]]*\]|\*(?!\*)|\*\*)(?:\s*<ALIGN>|\s*const\b|\s*volatile\b|\s*allowzero\b)*)/.source.replace(/<ALIGN>/g, t(a)) + "\\s*)*" + /(?:\bpromise\b|(?:\berror\.)?<ID>(?:\.<ID>)*(?!\s+<ID>))/.source.replace(/<ID>/g, t(n)) + ")+";
    e.languages.zig = {
      comment: [{
        pattern: /\/\/[/!].*/,
        alias: "doc-comment"
      }, /\/{2}.*/],
      string: [{
        pattern: /(^|[^\\@])c?"(?:[^"\\\r\n]|\\.)*"/,
        lookbehind: !0,
        greedy: !0
      }, {
        pattern: /([\r\n])([ \t]+c?\\{2}).*(?:(?:\r\n?|\n)\2.*)*/,
        lookbehind: !0,
        greedy: !0
      }],
      char: {
        pattern: /(^|[^\\])'(?:[^'\\\r\n]|[\uD800-\uDFFF]{2}|\\(?:.|x[a-fA-F\d]{2}|u\{[a-fA-F\d]{1,6}\}))'/,
        lookbehind: !0,
        greedy: !0
      },
      builtin: /\B@(?!\d)\w+(?=\s*\()/,
      label: {
        pattern: /(\b(?:break|continue)\s*:\s*)\w+\b|\b(?!\d)\w+\b(?=\s*:\s*(?:\{|while\b))/,
        lookbehind: !0
      },
      "class-name": [/\b(?!\d)\w+(?=\s*=\s*(?:(?:extern|packed)\s+)?(?:enum|struct|union)\s*[({])/, {
        pattern: RegExp(/(:\s*)<TYPE>(?=\s*(?:<ALIGN>\s*)?[=;,)])|<TYPE>(?=\s*(?:<ALIGN>\s*)?\{)/.source.replace(/<TYPE>/g, t(o)).replace(/<ALIGN>/g, t(a))),
        lookbehind: !0,
        inside: null
      }, {
        pattern: RegExp(/(\)\s*)<TYPE>(?=\s*(?:<ALIGN>\s*)?;)/.source.replace(/<TYPE>/g, t(o)).replace(/<ALIGN>/g, t(a))),
        lookbehind: !0,
        inside: null
      }],
      "builtin-type": {
        pattern: /\b(?:anyerror|bool|c_u?(?:int|long|longlong|short)|c_longdouble|c_void|comptime_(?:float|int)|f(?:16|32|64|128)|[iu](?:8|16|32|64|128|size)|noreturn|type|void)\b/,
        alias: "keyword"
      },
      keyword: r,
      function: /\b(?!\d)\w+(?=\s*\()/,
      number: /\b(?:0b[01]+|0o[0-7]+|0x[a-fA-F\d]+(?:\.[a-fA-F\d]*)?(?:[pP][+-]?[a-fA-F\d]+)?|\d+(?:\.\d*)?(?:[eE][+-]?\d+)?)\b/,
      boolean: /\b(?:false|true)\b/,
      operator: /\.[*?]|\.{2,3}|[-=]>|\*\*|\+\+|\|\||(?:<<|>>|[-+*]%|[-+*/%^&|<>!=])=?|[?~]/,
      punctuation: /[.:,;(){}[\]]/
    }, e.languages.zig["class-name"].forEach(function (t) {
      null === t.inside && (t.inside = e.languages.zig);
    });
  }(e);
}

zig.displayName = "zig", zig.aliases = [];
var refractor = core,
    refractor_1 = refractor;
refractor.register(abap_1), refractor.register(abnf_1), refractor.register(actionscript_1), refractor.register(ada_1), refractor.register(agda_1), refractor.register(al_1), refractor.register(antlr4_1), refractor.register(apacheconf_1), refractor.register(apex_1), refractor.register(apl_1), refractor.register(applescript_1), refractor.register(aql_1), refractor.register(arduino_1), refractor.register(arff_1), refractor.register(asciidoc_1), refractor.register(asm6502_1), refractor.register(asmatmel_1), refractor.register(aspnet_1), refractor.register(autohotkey_1), refractor.register(autoit_1), refractor.register(avisynth_1), refractor.register(avroIdl_1), refractor.register(bash_1), refractor.register(basic_1), refractor.register(batch_1), refractor.register(bbcode_1), refractor.register(bicep_1), refractor.register(birb_1), refractor.register(bison_1), refractor.register(bnf_1), refractor.register(brainfuck_1), refractor.register(brightscript_1), refractor.register(bro_1), refractor.register(bsl_1), refractor.register(c_1), refractor.register(cfscript_1), refractor.register(chaiscript_1), refractor.register(cil_1), refractor.register(clojure_1), refractor.register(cmake_1), refractor.register(cobol_1), refractor.register(coffeescript_1), refractor.register(concurnas_1), refractor.register(coq_1), refractor.register(cpp_1), refractor.register(crystal_1), refractor.register(csharp_1), refractor.register(cshtml_1), refractor.register(csp_1), refractor.register(cssExtras_1), refractor.register(csv_1), refractor.register(cypher_1), refractor.register(d_1), refractor.register(dart_1), refractor.register(dataweave_1), refractor.register(dax_1), refractor.register(dhall_1), refractor.register(diff_1), refractor.register(django_1), refractor.register(dnsZoneFile_1), refractor.register(docker_1), refractor.register(dot_1), refractor.register(ebnf_1), refractor.register(editorconfig_1), refractor.register(eiffel_1), refractor.register(ejs_1), refractor.register(elixir_1), refractor.register(elm_1), refractor.register(erb_1), refractor.register(erlang_1), refractor.register(etlua_1), refractor.register(excelFormula_1), refractor.register(factor_1), refractor.register(_false), refractor.register(firestoreSecurityRules_1), refractor.register(flow_1), refractor.register(fortran_1), refractor.register(fsharp_1), refractor.register(ftl_1), refractor.register(gap_1), refractor.register(gcode_1), refractor.register(gdscript_1), refractor.register(gedcom_1), refractor.register(gherkin_1), refractor.register(git_1), refractor.register(glsl_1), refractor.register(gml_1), refractor.register(gn_1), refractor.register(goModule_1), refractor.register(go_1), refractor.register(graphql_1), refractor.register(groovy_1), refractor.register(haml_1), refractor.register(handlebars_1), refractor.register(haskell_1), refractor.register(haxe_1), refractor.register(hcl_1), refractor.register(hlsl_1), refractor.register(hoon_1), refractor.register(hpkp_1), refractor.register(hsts_1), refractor.register(http_1), refractor.register(ichigojam_1), refractor.register(icon_1), refractor.register(icuMessageFormat_1), refractor.register(idris_1), refractor.register(iecst_1), refractor.register(ignore_1), refractor.register(inform7_1), refractor.register(ini_1), refractor.register(io_1), refractor.register(j_1), refractor.register(java_1), refractor.register(javadoc_1), refractor.register(javadoclike_1), refractor.register(javastacktrace_1), refractor.register(jexl_1), refractor.register(jolie_1), refractor.register(jq_1), refractor.register(jsExtras_1), refractor.register(jsTemplates_1), refractor.register(jsdoc_1), refractor.register(json_1), refractor.register(json5_1), refractor.register(jsonp_1), refractor.register(jsstacktrace_1), refractor.register(jsx_1), refractor.register(julia_1), refractor.register(keepalived_1), refractor.register(keyman_1), refractor.register(kotlin_1), refractor.register(kumir_1), refractor.register(kusto_1), refractor.register(latex_1), refractor.register(latte_1), refractor.register(less_1), refractor.register(lilypond_1), refractor.register(liquid_1), refractor.register(lisp_1), refractor.register(livescript_1), refractor.register(llvm_1), refractor.register(log_1), refractor.register(lolcode_1), refractor.register(lua_1), refractor.register(magma_1), refractor.register(makefile_1), refractor.register(markdown_1), refractor.register(markupTemplating_1), refractor.register(matlab_1), refractor.register(maxscript_1), refractor.register(mel_1), refractor.register(mermaid_1), refractor.register(mizar_1), refractor.register(mongodb_1), refractor.register(monkey_1), refractor.register(moonscript_1), refractor.register(n1ql_1), refractor.register(n4js_1), refractor.register(nand2tetrisHdl_1), refractor.register(naniscript_1), refractor.register(nasm_1), refractor.register(neon_1), refractor.register(nevod_1), refractor.register(nginx_1), refractor.register(nim_1), refractor.register(nix_1), refractor.register(nsis_1), refractor.register(objectivec_1), refractor.register(ocaml_1), refractor.register(opencl_1), refractor.register(openqasm_1), refractor.register(oz_1), refractor.register(parigp_1), refractor.register(parser_1), refractor.register(pascal_1), refractor.register(pascaligo_1), refractor.register(pcaxis_1), refractor.register(peoplecode_1), refractor.register(perl_1), refractor.register(phpExtras_1), refractor.register(php_1), refractor.register(phpdoc_1), refractor.register(plsql_1), refractor.register(powerquery_1), refractor.register(powershell_1), refractor.register(processing_1), refractor.register(prolog_1), refractor.register(promql_1), refractor.register(properties_1), refractor.register(protobuf_1), refractor.register(psl_1), refractor.register(pug_1), refractor.register(puppet_1), refractor.register(pure_1), refractor.register(purebasic_1), refractor.register(purescript_1), refractor.register(python_1), refractor.register(q_1), refractor.register(qml_1), refractor.register(qore_1), refractor.register(qsharp_1), refractor.register(r_1), refractor.register(racket_1), refractor.register(reason_1), refractor.register(regex_1), refractor.register(rego_1), refractor.register(renpy_1), refractor.register(rest_1), refractor.register(rip_1), refractor.register(roboconf_1), refractor.register(robotframework_1), refractor.register(ruby_1), refractor.register(rust_1), refractor.register(sas_1), refractor.register(sass_1), refractor.register(scala_1), refractor.register(scheme_1), refractor.register(scss_1), refractor.register(shellSession_1), refractor.register(smali_1), refractor.register(smalltalk_1), refractor.register(smarty_1), refractor.register(sml_1), refractor.register(solidity_1), refractor.register(solutionFile_1), refractor.register(soy_1), refractor.register(sparql_1), refractor.register(splunkSpl_1), refractor.register(sqf_1), refractor.register(sql_1), refractor.register(squirrel_1), refractor.register(stan_1), refractor.register(stylus_1), refractor.register(swift_1), refractor.register(systemd_1), refractor.register(t4Cs_1), refractor.register(t4Templating_1), refractor.register(t4Vb_1), refractor.register(tap_1), refractor.register(tcl_1), refractor.register(textile_1), refractor.register(toml_1), refractor.register(tremor_1), refractor.register(tsx_1), refractor.register(tt2_1), refractor.register(turtle_1), refractor.register(twig_1), refractor.register(typescript_1), refractor.register(typoscript_1), refractor.register(unrealscript_1), refractor.register(uorazor_1), refractor.register(uri_1), refractor.register(v_1), refractor.register(vala_1), refractor.register(vbnet_1), refractor.register(velocity_1), refractor.register(verilog_1), refractor.register(vhdl_1), refractor.register(vim_1), refractor.register(visualBasic_1), refractor.register(warpscript_1), refractor.register(wasm_1), refractor.register(webIdl_1), refractor.register(wiki_1), refractor.register(wolfram_1), refractor.register(wren_1), refractor.register(xeora_1), refractor.register(xmlDoc_1), refractor.register(xojo_1), refractor.register(xquery_1), refractor.register(yaml_1), refractor.register(yang_1), refractor.register(zig_1);
var highlighter = highlight$1(refractor_1, defaultStyle);
highlighter.supportedLanguages = supportedLanguages;

var SyntaxHighlighter = highlighter,
    EditorJsDataParser = function EditorJsDataParser(e, t) {
  var r, n;

  switch (e.type) {
    case "header":
      switch (e.data.level) {
        case 1:
          return jsx$1("h1", {
            dangerouslySetInnerHTML: {
              __html: e.data.text
            }
          }, t);

        case 2:
          return jsx$1("h2", {
            dangerouslySetInnerHTML: {
              __html: e.data.text
            }
          }, t);

        case 3:
          return jsx$1("h3", {
            dangerouslySetInnerHTML: {
              __html: e.data.text
            }
          }, t);

        case 4:
          return jsx$1("h4", {
            dangerouslySetInnerHTML: {
              __html: e.data.text
            }
          }, t);

        case 5:
          return jsx$1("h5", {
            dangerouslySetInnerHTML: {
              __html: e.data.text
            }
          }, t);

        case 6:
          return jsx$1("h6", {
            dangerouslySetInnerHTML: {
              __html: e.data.text
            }
          }, t);

        default:
          return jsx$1("p", {
            dangerouslySetInnerHTML: {
              __html: e.data.text
            }
          }, t);
      }

    case "paragraph":
      return jsx$1("p", {
        dangerouslySetInnerHTML: {
          __html: e.data.text
        }
      }, t);

    case "delimiter":
      return jsx$1("hr", {}, t);

    case "image":
      return jsx$1("img", {
        alt: e.data.caption,
        className: "img-fluid",
        src: null === (n = null === (r = null == e ? void 0 : e.data) || void 0 === r ? void 0 : r.file) || void 0 === n ? void 0 : n.url,
        title: e.data.caption
      }, t);

    case "list":
      return Array.isArray(e.data.items) ? "ordered" === e.data.style ? jsx$1("div", {
        dangerouslySetInnerHTML: {
          __html: ReactDOMServer.renderToString(function (e) {
            return jsx$1("ul", _assign$({
              style: {
                marginLeft: "2em",
                whiteSpace: "pre-line"
              }
            }, {
              children: e.data.items.map(function (e, t) {
                return Array.isArray(e.items) && e.items.length > 0 ? jsxs("li", {
                  children: [jsx$1(Fragment$1, {
                    children: e.content
                  }, t), jsx$1("ol", _assign$({
                    style: {
                      margin: "10px 0"
                    }
                  }, {
                    children: e.items.map(function (e, t) {
                      return jsx$1("li", {
                        dangerouslySetInnerHTML: {
                          __html: e.content
                        }
                      }, "".concat(t, "-item"));
                    })
                  }))]
                }, "".concat(t, "-item")) : jsx$1("li", {
                  dangerouslySetInnerHTML: {
                    __html: e.content
                  }
                }, "".concat(t, "-item"));
              })
            }), t);
          }(e))
        }
      }, t) : jsx$1("div", {
        dangerouslySetInnerHTML: {
          __html: ReactDOMServer.renderToString(function (e) {
            return jsx$1("ul", _assign$({
              style: {
                marginLeft: "2em",
                whiteSpace: "pre-line"
              }
            }, {
              children: e.data.items.map(function (e, t) {
                return Array.isArray(e.items) && e.items.length > 0 ? jsxs("li", {
                  children: [jsx$1(Fragment$1, {
                    children: e.content
                  }, t), jsx$1("ul", _assign$({
                    style: {
                      margin: "10px 0"
                    }
                  }, {
                    children: e.items.map(function (e, t) {
                      return jsx$1("li", {
                        dangerouslySetInnerHTML: {
                          __html: e.content
                        }
                      }, "".concat(t, "-item"));
                    })
                  }))]
                }, "".concat(t, "-item")) : jsx$1("li", {
                  dangerouslySetInnerHTML: {
                    __html: e.content
                  }
                }, "".concat(t, "-item"));
              })
            }), t);
          }(e))
        }
      }, t) : (console.warn("Failed to parse `list` without `items`.\nBlock:", e), null);

    case "code":
      return jsx$1(SyntaxHighlighter, _assign$({
        language: "typescript"
      }, {
        children: e.data.code
      }), t);

    case "quote":
      return jsxs("blockquote", {
        children: [" ", jsx$1("p", {
          dangerouslySetInnerHTML: {
            __html: e.data.text
          }
        })]
      }, t);

    case "raw":
      return null == e.data.html || "" === e.data.html ? (console.warn("Failed to parse `raw` without `html`.\nBlock:", e), null) : jsx$1("div", {
        dangerouslySetInnerHTML: {
          __html: e.data.html
        }
      }, t);

    default:
      return console.log("Unknown block type", e.type), console.log(e), null;
  }
},
    EditorJs = function EditorJs(e) {
  var t = createReactEditorJS(),
      r = useRef({}),
      n = useState(!1),
      a = n[0],
      o = n[1];
  return useEffect(function () {
    r.current = {
      fontFamily: require("editorjs-inline-font-family-tool"),
      fontSize: require("editorjs-inline-font-size-tool"),
      color: {
        class: require("editorjs-text-color-plugin"),
        inlineToolbar: !0,
        config: {
          colorCollections: ["#0258FF", "#5AC58D", "#FF1300", "#EC7878", "#9C27B0", "#673AB7", "#3F51B5", "#0070FF", "#03A9F4", "#00BCD4", "#4CAF50", "#8BC34A", "#CDDC39", "#FFF"],
          defaultColor: "#FF1300",
          type: "text"
        }
      },
      paragraph: {
        class: require("editorjs-paragraph-with-alignment"),
        inlineToolbar: !0
      },
      header: {
        class: require("@editorjs/header"),
        inlineToolbar: !0
      }
    }, o(!0);
  }, []), a ? jsx$1(t, _assign$({
    tools: r.current,
    minHeight: 0
  }, e)) : jsx$1(Fragment, {
    children: "Loading..."
  });
},
    FormHeading = function FormHeading(e) {
  var t = e.data,
      r = useTheme$4(),
      n = t.description,
      a = t.title;
  return jsxs(Root$A, {
    children: [jsx$1(Text, _assign$({
      variant: "h4"
    }, {
      children: a
    })), jsx$1(Text, _assign$({
      variant: "heading",
      color: "text.secondary",
      sx: {
        fontWeight: r.typography.fontWeightRegular,
        pt: 1.5
      }
    }, {
      children: n
    }))]
  });
},
    Root$A = styled$2("div")(function (e) {
  return e.theme, {
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center"
  };
}),
    FormSeparator = function FormSeparator(e) {
  var t = e.data,
      r = t.description,
      n = t.title;
  return jsxs(Box, _assign$({
    mt: 2
  }, {
    children: [jsx$1(Text, _assign$({
      rich: !0
    }, {
      children: n
    })), jsx$1(Text, _assign$({
      rich: !0
    }, {
      children: r
    }))]
  }));
},
    FormInput = function FormInput(e) {
  var t = e.data,
      r = t.id,
      n = t.label,
      a = t.name,
      o = t.placeholder,
      i = t.type,
      s = t.width,
      l = t.description,
      c = t.isMultiline,
      u = t.helperText,
      d = t.isRequired,
      p = t.defaultValue,
      g = t.pattern,
      m = useFormContext(),
      f = useTheme$4(),
      h = useMediaQuery(f.breakpoints.up("sm")),
      b = useController({
    name: a,
    control: null == m ? void 0 : m.control,
    rules: {
      required: d,
      pattern: g
    },
    defaultValue: p
  }),
      y = b.field,
      v = y.onChange,
      _ = y.onBlur,
      T = y.name,
      E = y.value,
      S = y.ref,
      x = b.fieldState.invalid;
  return jsxs(FormControl, _assign$({
    variant: "standard",
    margin: "normal",
    sx: {
      width: h ? getFormFieldWidth(null != s ? s : "full") : "100%"
    },
    error: x
  }, {
    children: [jsx$1(FormLabel, _assign$({
      required: d
    }, {
      children: n
    })), jsx$1(FormHelperText, _assign$({
      sx: {
        color: f.palette.primary.light,
        pt: .5
      }
    }, {
      children: l
    })), jsx$1(OutlinedInput, {
      value: E,
      type: i,
      name: T,
      placeholder: o,
      sx: {
        width: "100%"
      },
      multiline: c,
      rows: c ? 5 : 0,
      onChange: v,
      onBlur: _,
      inputRef: S
    }), jsx$1(FormHelperText, {
      children: u
    })]
  }), r);
},
    FormDropdown = function FormDropdown(e) {
  var t = e.data,
      r = t.name,
      n = t.label,
      a = t.width,
      o = t.items,
      i = t.isRequired,
      s = t.id,
      l = t.defaultValue,
      c = useFormContext(),
      u = useTheme$4(),
      d = useMediaQuery(u.breakpoints.up("sm")),
      p = useController({
    name: r,
    control: null == c ? void 0 : c.control,
    rules: {
      required: i
    },
    defaultValue: l
  }),
      g = p.field,
      m = g.onChange,
      f = g.onBlur,
      h = g.name,
      b = g.value,
      y = g.ref,
      v = p.fieldState.invalid;
  return jsxs(FormControl, _assign$({
    variant: "standard",
    margin: "normal",
    sx: {
      width: d ? getFormFieldWidth(null != a ? a : "full") : "100%"
    },
    error: v
  }, {
    children: [jsx$1(FormLabel, _assign$({
      required: i
    }, {
      children: n
    })), jsx$1(NativeSelect, _assign$({
      name: h,
      value: b,
      variant: "outlined",
      onChange: m,
      onBlur: f,
      inputRef: y
    }, {
      children: o.map(function (e) {
        return jsx$1("option", _assign$({
          value: e.id
        }, {
          children: e.label
        }), e.id);
      })
    }))]
  }), s);
},
    FormCheckbox = function FormCheckbox(e) {
  var t = e.data,
      r = t.id,
      n = t.label,
      a = t.name,
      o = t.width,
      i = t.isRequired,
      s = t.defaultValue,
      l = useFormContext().control,
      c = useTheme$4(),
      u = useMediaQuery(c.breakpoints.up("sm")),
      d = useController({
    name: a,
    control: l,
    rules: {
      required: i
    },
    defaultValue: s
  }),
      p = d.field,
      g = p.onChange,
      m = p.onBlur,
      f = p.name,
      h = p.value,
      b = d.fieldState.invalid;
  return jsx$1(FormControl, _assign$({
    variant: "standard",
    sx: {
      width: u ? getFormFieldWidth(null != o ? o : "full") : "100%"
    },
    error: b
  }, {
    children: jsx$1(FormControlLabel, {
      value: h,
      name: f,
      control: jsx$1(StyledCheckbox, {
        size: "small"
      }),
      label: n,
      onChange: g,
      onBlur: m,
      sx: {
        color: c.palette.text.secondary,
        fontWeight: c.typography.fontWeightMedium
      }
    }, r)
  }), r);
},
    StyledCheckbox = styled$2(Checkbox)(function () {
  return {
    "& .MuiIconButton-label": {
      fontSize: 24,
      border: "1px solid #bbbbbb",
      width: 20,
      height: 20,
      borderRadius: 3,
      "& .MuiSvgIcon-root": {
        fill: "#fff"
      }
    }
  };
}),
    FormRadioGroup = function FormRadioGroup(e) {
  var t = e.data,
      r = t.id,
      n = t.label,
      a = t.name,
      o = t.items,
      i = t.width,
      s = t.isRequired,
      l = t.defaultValue,
      c = useFormContext().control,
      u = useTheme$4(),
      d = useMediaQuery(u.breakpoints.up("sm")),
      p = useController({
    name: a,
    control: c,
    rules: {
      required: s
    },
    defaultValue: null != l ? l : null
  }),
      g = p.field,
      m = g.onChange,
      f = g.onBlur,
      h = g.name,
      b = g.value,
      y = p.fieldState.invalid;
  return jsxs(FormControl, _assign$({
    variant: "standard",
    margin: "normal",
    component: "fieldset",
    sx: {
      width: d ? getFormFieldWidth(null != i ? i : "full") : "100%"
    },
    error: y
  }, {
    children: [jsx$1(FormLabel, _assign$({
      component: "legend"
    }, {
      children: n
    })), jsx$1(RadioGroup, _assign$({
      name: h,
      value: b,
      onChange: m,
      onBlur: f
    }, {
      children: null == o ? void 0 : o.map(function (e) {
        var t = e.id,
            r = e.label;
        return jsx$1(FormControlLabel, {
          value: t,
          control: jsx$1(Radio, {}),
          label: r,
          sx: {
            color: u.palette.text.secondary,
            fontWeight: u.typography.fontWeightMedium
          }
        }, t);
      })
    }))]
  }), r);
},
    FormCheckboxGroup = function FormCheckboxGroup(e) {
  var t = e.data,
      r = t.id,
      n = t.label,
      a = t.items,
      o = t.width,
      i = useTheme$4(),
      s = useMediaQuery(i.breakpoints.up("sm"));
  return jsxs(FormControl, _assign$({
    variant: "standard",
    margin: "normal",
    sx: {
      width: s ? getFormFieldWidth(null != o ? o : "full") : "100%"
    }
  }, {
    children: [jsx$1(FormLabel, _assign$({
      component: "legend"
    }, {
      children: n
    })), jsx$1(FormGroup, {
      children: null == a ? void 0 : a.map(function (e) {
        return jsx$1(FormCheckbox, {
          data: e
        }, e.id);
      })
    })]
  }), r);
},
    FormButtonGroup = function FormButtonGroup(e) {
  var t,
      r = e.data;
  return jsx$1(Root$z, {
    children: null === (t = null == r ? void 0 : r.buttons) || void 0 === t ? void 0 : t.map(function (e) {
      return jsx$1(Button, _assign$({
        size: "large",
        variant: "solid" === e.variant ? "contained" : "outlined",
        type: "submit",
        fullWidth: !0,
        endIcon: jsx$1(CmsImage, {
          media: null == e ? void 0 : e.icon
        })
      }, {
        children: e.text
      }), e.id);
    })
  });
},
    Root$z = styled$2(Box)(function (e) {
  return e.theme, {
    textAlign: "center",
    display: "flex",
    padding: "1rem 0rem"
  };
}),
    FormHubSpot = function FormHubSpot(e) {
  var t = e.data.script,
      r = "".concat(t.split("<script>")[0], "<script>setTimeout(()=> {").concat(t.split("<script>")[1].split("<\/script>")[0], "}, 1000)<\/script>");
  return jsx$1(InnerHtml, {
    html: r,
    width: "100%"
  });
},
    Form = function Form(_a) {
  var _b,
      _c,
      form = _a.form,
      onChange = _a.onChange,
      customFormData = useRef({
    apiURL: "",
    successMessage: "",
    failureMessage: "",
    redirectURL: "",
    hiddenFormFields: {},
    requestConfig: {}
  }),
      formType = useRef({
    type: null,
    data: null
  }),
      _d = useState(FormSubmitStatus.Idle),
      formSubmitStatus = _d[0],
      setFormSubmitStatus = _d[1],
      _e = useState(""),
      errorMessage = _e[0],
      setErrorMessage = _e[1],
      login = usePublicAuth().login,
      entries = new Map(form.sections.reduce(flattenControlsHavingNameProperty, []).filter(function (e) {
    return "name" in e;
  }).map(function (e) {
    var t = e.defaultValue;
    return [e.name, t];
  })),
      methods = useForm({
    defaultValues: Object.fromEntries(entries)
  }),
      watchAllFields = methods.watch(),
      _onSubmit = function _onSubmit(formValues) {
    var hiddenFormFields = customFormData.current.hiddenFormFields,
        _payload = _assign$({
      id: form.id,
      name: form.name,
      formValues: formValues
    }, methods),
        onResponse = function onResponse(e) {
      null != e.error ? (setFormSubmitStatus(FormSubmitStatus.Failure), setErrorMessage(e.error), null != onChange && onChange(_assign$(_assign$({}, _payload), {
        submitStatus: FormSubmitStatus.Failure
      }))) : (setFormSubmitStatus(FormSubmitStatus.Success), formType.current.type === FormType.PublicSignupForm && login(watchAllFields.user_email, watchAllFields.password), null != onChange && onChange(_assign$(_assign$({}, _payload), {
        submitStatus: FormSubmitStatus.Success
      })));
    };

    if ("" !== customFormData.current.apiURL) {
      setFormSubmitStatus(FormSubmitStatus.Loading);
      var _hiddenFormFields_1 = {};
      null != hiddenFormFields && Object.keys(hiddenFormFields).forEach(function (key) {
        try {
          var func = eval(hiddenFormFields[key]),
              fn = new Function(hiddenFormFields[key].split("{")[1].split("}")[0].trim());
          _hiddenFormFields_1[key] = fn();
        } catch (e) {
          _hiddenFormFields_1[key] = hiddenFormFields[key];
        }
      }), formType.current.type === FormType.PublicSignupForm && publicSignUp(formValues).then(onResponse).catch(function (e) {
        console.log(e), setFormSubmitStatus(FormSubmitStatus.Failure);
      }), formType.current.type === FormType.CustomForm && null != customFormData.current.apiURL && postFormData(customFormData.current.apiURL, _assign$(_assign$({}, formValues), _hiddenFormFields_1)).then(onResponse).catch(function (e) {
        console.log(e), setFormSubmitStatus(FormSubmitStatus.Failure);
      });
    }

    null != onChange && onChange(_payload);
  },
      renderFormComponent = function renderFormComponent(e) {
    if (null == (null == e ? void 0 : e.__component)) return jsx$1(Fragment, {});
    var t = formComponents[e.__component];
    return Object.values(FormType).includes(e.__component) && (formType.current.type = e.__component, formType.current.data = e), null == t ? jsx$1(Fragment, {}) : jsx$1(t, {
      data: _assign$(_assign$({}, e), {
        dropShadow: form.dropShadow
      })
    }, "".concat(e.__component).concat(e.id));
  },
      renderNonFormComponent = function renderNonFormComponent(e) {
    if (null == (null == e ? void 0 : e.__component)) return jsx$1(Fragment, {});
    var t = nonFormComponents[e.__component];
    return null == t ? jsx$1(Fragment, {}) : jsx$1(t, {
      data: _assign$(_assign$({}, e), {
        dropShadow: form.dropShadow
      })
    }, "".concat(e.__component).concat(e.id));
  },
      formRootComponent = jsx$1("form", _assign$({
    onSubmit: methods.handleSubmit(_onSubmit)
  }, {
    children: null === (_b = null == form ? void 0 : form.sections) || void 0 === _b ? void 0 : _b.map(renderFormComponent)
  })),
      nonFormRootComponent = null === (_c = null == form ? void 0 : form.sections) || void 0 === _c ? void 0 : _c.map(renderNonFormComponent);

  if (useEffect(function () {
    null != onChange && onChange(_assign$({
      id: form.id,
      name: form.name
    }, methods));
  }, [watchAllFields]), useEffect(function () {
    if (formType.current.type === FormType.PublicSignupForm && (customFormData.current = {
      apiURL: null,
      successMessage: "{&quot;time&quot;:1649232205500,&quot;blocks&quot;:[{&quot;id&quot;:&quot;-7LgWaGSdv&quot;,&quot;type&quot;:&quot;paragraph&quot;,&quot;data&quot;:{&quot;text&quot;:&quot;Sign up success&quot;}}],&quot;version&quot;:&quot;2.22.2&quot;}",
      failureMessage: "{&quot;time&quot;:1649232210210,&quot;blocks&quot;:[{&quot;id&quot;:&quot;dWsxqQitDs&quot;,&quot;type&quot;:&quot;paragraph&quot;,&quot;data&quot;:{&quot;text&quot;:&quot;Signup failure, please try again&quot;}}],&quot;version&quot;:&quot;2.22.2&quot;}",
      redirectURL: null,
      hiddenFormFields: null
    }), formType.current.type === FormType.CustomForm) {
      var e = formType.current.data;
      customFormData.current = {
        apiURL: e.apiURL,
        successMessage: e.successMessage,
        failureMessage: e.failureMessage,
        redirectURL: e.redirectURL,
        hiddenFormFields: e.hiddenFormFields
      };
    }
  }, [formType.current]), formSubmitStatus === FormSubmitStatus.Loading) return jsxs(FormProvider, _assign$({}, methods, {
    children: [formSubmitStatus === FormSubmitStatus.Loading && jsx$1(FormOverlay, {
      children: jsx$1(CircularProgress$2, {})
    }), formRootComponent]
  }));

  if (formSubmitStatus === FormSubmitStatus.Success) {
    var redirectURL = (null == customFormData ? void 0 : customFormData.current).redirectURL;
    return "" === redirectURL && null == redirectURL || (window.location.href = redirectURL), jsxs(FormProvider, _assign$({}, methods, {
      children: [nonFormRootComponent, jsx$1(Alert, _assign$({
        severity: "success"
      }, {
        children: jsx$1(Text, _assign$({
          rich: !0
        }, {
          children: customFormData.current.successMessage
        }))
      }))]
    }));
  }

  return formSubmitStatus === FormSubmitStatus.Failure ? jsxs(FormProvider, _assign$({}, methods, {
    children: [nonFormRootComponent, "" !== errorMessage && jsx$1(Alert, _assign$({
      severity: "error"
    }, {
      children: jsx$1(Text, {
        children: errorMessage
      })
    }))]
  })) : jsx$1(FormProvider, _assign$({}, methods, {
    children: formRootComponent
  }));
},
    nonFormComponents = {
  "forms.form-heading": FormHeading
},
    formComponents = _assign$(_assign$({}, nonFormComponents), {
  "forms.form-separator": FormSeparator,
  "forms.form-input": FormInput,
  "forms.form-dropdown": FormDropdown,
  "forms.form-checkbox": FormCheckbox,
  "forms.form-radio-group": FormRadioGroup,
  "forms.form-checkbox-group": FormCheckboxGroup,
  "forms.form-button-group": FormButtonGroup,
  "forms.hub-spot-form": FormHubSpot
}),
    FormOverlay = styled$2(Box)(function (e) {
  return e.theme, {
    position: "absolute",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(255,255,255,0.5)",
    left: 0,
    top: 0,
    bottom: 0,
    right: 0,
    zIndex: 1
  };
});

function _extends$e() {
  return _extends$e = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];

      for (var n in r) {
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
    }

    return e;
  }, _extends$e.apply(this, arguments);
}

function _objectWithoutPropertiesLoose$4(e, t) {
  if (null == e) return {};
  var r,
      n,
      a = {},
      o = Object.keys(e);

  for (n = 0; n < o.length; n++) {
    r = o[n], t.indexOf(r) >= 0 || (a[r] = e[r]);
  }

  return a;
}

var propTypes = {
  exports: {}
},
    reactIs = {
  exports: {}
},
    reactIs_production_min = {},
    b = "function" == typeof Symbol && Symbol.for,
    c = b ? Symbol.for("react.element") : 60103,
    d = b ? Symbol.for("react.portal") : 60106,
    e = b ? Symbol.for("react.fragment") : 60107,
    f = b ? Symbol.for("react.strict_mode") : 60108,
    g = b ? Symbol.for("react.profiler") : 60114,
    h = b ? Symbol.for("react.provider") : 60109,
    k = b ? Symbol.for("react.context") : 60110,
    l = b ? Symbol.for("react.async_mode") : 60111,
    m = b ? Symbol.for("react.concurrent_mode") : 60111,
    n = b ? Symbol.for("react.forward_ref") : 60112,
    p = b ? Symbol.for("react.suspense") : 60113,
    q = b ? Symbol.for("react.suspense_list") : 60120,
    r = b ? Symbol.for("react.memo") : 60115,
    t = b ? Symbol.for("react.lazy") : 60116,
    v = b ? Symbol.for("react.block") : 60121,
    w = b ? Symbol.for("react.fundamental") : 60117,
    x = b ? Symbol.for("react.responder") : 60118,
    y = b ? Symbol.for("react.scope") : 60119;

function z(a) {
  if ("object" == typeof a && null !== a) {
    var o = a.$$typeof;

    switch (o) {
      case c:
        switch (a = a.type) {
          case l:
          case m:
          case e:
          case g:
          case f:
          case p:
            return a;

          default:
            switch (a = a && a.$$typeof) {
              case k:
              case n:
              case t:
              case r:
              case h:
                return a;

              default:
                return o;
            }

        }

      case d:
        return o;
    }
  }
}

function A(e) {
  return z(e) === m;
}

reactIs_production_min.AsyncMode = l, reactIs_production_min.ConcurrentMode = m, reactIs_production_min.ContextConsumer = k, reactIs_production_min.ContextProvider = h, reactIs_production_min.Element = c, reactIs_production_min.ForwardRef = n, reactIs_production_min.Fragment = e, reactIs_production_min.Lazy = t, reactIs_production_min.Memo = r, reactIs_production_min.Portal = d, reactIs_production_min.Profiler = g, reactIs_production_min.StrictMode = f, reactIs_production_min.Suspense = p, reactIs_production_min.isAsyncMode = function (e) {
  return A(e) || z(e) === l;
}, reactIs_production_min.isConcurrentMode = A, reactIs_production_min.isContextConsumer = function (e) {
  return z(e) === k;
}, reactIs_production_min.isContextProvider = function (e) {
  return z(e) === h;
}, reactIs_production_min.isElement = function (e) {
  return "object" == typeof e && null !== e && e.$$typeof === c;
}, reactIs_production_min.isForwardRef = function (e) {
  return z(e) === n;
}, reactIs_production_min.isFragment = function (t) {
  return z(t) === e;
}, reactIs_production_min.isLazy = function (e) {
  return z(e) === t;
}, reactIs_production_min.isMemo = function (e) {
  return z(e) === r;
}, reactIs_production_min.isPortal = function (e) {
  return z(e) === d;
}, reactIs_production_min.isProfiler = function (e) {
  return z(e) === g;
}, reactIs_production_min.isStrictMode = function (e) {
  return z(e) === f;
}, reactIs_production_min.isSuspense = function (e) {
  return z(e) === p;
}, reactIs_production_min.isValidElementType = function (a) {
  return "string" == typeof a || "function" == typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" == typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
}, reactIs_production_min.typeOf = z;
var reactIs_development = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

"production" !== process.env.NODE_ENV && function () {
  var e = "function" == typeof Symbol && Symbol.for,
      t = e ? Symbol.for("react.element") : 60103,
      r = e ? Symbol.for("react.portal") : 60106,
      n = e ? Symbol.for("react.fragment") : 60107,
      a = e ? Symbol.for("react.strict_mode") : 60108,
      o = e ? Symbol.for("react.profiler") : 60114,
      i = e ? Symbol.for("react.provider") : 60109,
      s = e ? Symbol.for("react.context") : 60110,
      l = e ? Symbol.for("react.async_mode") : 60111,
      c = e ? Symbol.for("react.concurrent_mode") : 60111,
      u = e ? Symbol.for("react.forward_ref") : 60112,
      d = e ? Symbol.for("react.suspense") : 60113,
      p = e ? Symbol.for("react.suspense_list") : 60120,
      g = e ? Symbol.for("react.memo") : 60115,
      m = e ? Symbol.for("react.lazy") : 60116,
      f = e ? Symbol.for("react.block") : 60121,
      h = e ? Symbol.for("react.fundamental") : 60117,
      b = e ? Symbol.for("react.responder") : 60118,
      y = e ? Symbol.for("react.scope") : 60119;

  function v(e) {
    if ("object" == typeof e && null !== e) {
      var p = e.$$typeof;

      switch (p) {
        case t:
          var f = e.type;

          switch (f) {
            case l:
            case c:
            case n:
            case o:
            case a:
            case d:
              return f;

            default:
              var h = f && f.$$typeof;

              switch (h) {
                case s:
                case u:
                case m:
                case g:
                case i:
                  return h;

                default:
                  return p;
              }

          }

        case r:
          return p;
      }
    }
  }

  var _ = l,
      T = c,
      E = s,
      S = i,
      x = t,
      w = u,
      C = n,
      k = m,
      $ = g,
      R = r,
      A = o,
      I = a,
      N = d,
      P = !1;

  function O(e) {
    return v(e) === c;
  }

  reactIs_development.AsyncMode = _, reactIs_development.ConcurrentMode = T, reactIs_development.ContextConsumer = E, reactIs_development.ContextProvider = S, reactIs_development.Element = x, reactIs_development.ForwardRef = w, reactIs_development.Fragment = C, reactIs_development.Lazy = k, reactIs_development.Memo = $, reactIs_development.Portal = R, reactIs_development.Profiler = A, reactIs_development.StrictMode = I, reactIs_development.Suspense = N, reactIs_development.isAsyncMode = function (e) {
    return P || (P = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), O(e) || v(e) === l;
  }, reactIs_development.isConcurrentMode = O, reactIs_development.isContextConsumer = function (e) {
    return v(e) === s;
  }, reactIs_development.isContextProvider = function (e) {
    return v(e) === i;
  }, reactIs_development.isElement = function (e) {
    return "object" == typeof e && null !== e && e.$$typeof === t;
  }, reactIs_development.isForwardRef = function (e) {
    return v(e) === u;
  }, reactIs_development.isFragment = function (e) {
    return v(e) === n;
  }, reactIs_development.isLazy = function (e) {
    return v(e) === m;
  }, reactIs_development.isMemo = function (e) {
    return v(e) === g;
  }, reactIs_development.isPortal = function (e) {
    return v(e) === r;
  }, reactIs_development.isProfiler = function (e) {
    return v(e) === o;
  }, reactIs_development.isStrictMode = function (e) {
    return v(e) === a;
  }, reactIs_development.isSuspense = function (e) {
    return v(e) === d;
  }, reactIs_development.isValidElementType = function (e) {
    return "string" == typeof e || "function" == typeof e || e === n || e === c || e === o || e === a || e === d || e === p || "object" == typeof e && null !== e && (e.$$typeof === m || e.$$typeof === g || e.$$typeof === i || e.$$typeof === s || e.$$typeof === u || e.$$typeof === h || e.$$typeof === b || e.$$typeof === y || e.$$typeof === f);
  }, reactIs_development.typeOf = v;
}(), "production" === process.env.NODE_ENV ? reactIs.exports = reactIs_production_min : reactIs.exports = reactIs_development
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
;
var getOwnPropertySymbols = Object.getOwnPropertySymbols,
    hasOwnProperty = Object.prototype.hasOwnProperty,
    propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(e) {
  if (null == e) throw new TypeError("Object.assign cannot be called with null or undefined");
  return Object(e);
}

function shouldUseNative() {
  try {
    if (!Object.assign) return !1;
    var e = new String("abc");
    if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;

    for (var t = {}, r = 0; r < 10; r++) {
      t["_" + String.fromCharCode(r)] = r;
    }

    var n = Object.getOwnPropertyNames(t).map(function (e) {
      return t[e];
    });
    if ("0123456789" !== n.join("")) return !1;
    var a = {};
    return "abcdefghijklmnopqrst".split("").forEach(function (e) {
      a[e] = e;
    }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, a)).join("");
  } catch (e) {
    return !1;
  }
}

var objectAssign = shouldUseNative() ? Object.assign : function (e, t) {
  for (var r, n, a = toObject(e), o = 1; o < arguments.length; o++) {
    for (var i in r = Object(arguments[o])) {
      hasOwnProperty.call(r, i) && (a[i] = r[i]);
    }

    if (getOwnPropertySymbols) {
      n = getOwnPropertySymbols(r);

      for (var s = 0; s < n.length; s++) {
        propIsEnumerable.call(r, n[s]) && (a[n[s]] = r[n[s]]);
      }
    }
  }

  return a;
},
    ReactPropTypesSecret$3 = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED",
    ReactPropTypesSecret_1 = ReactPropTypesSecret$3,
    has$2 = Function.call.bind(Object.prototype.hasOwnProperty),
    printWarning$1 = function printWarning$1() {};

if ("production" !== process.env.NODE_ENV) {
  var ReactPropTypesSecret$2 = ReactPropTypesSecret_1,
      loggedTypeFailures = {},
      has$1 = has$2;

  printWarning$1 = function printWarning$1(e) {
    var t = "Warning: " + e;
    "undefined" != typeof console && console.error(t);

    try {
      throw new Error(t);
    } catch (e) {}
  };
}

function checkPropTypes$1(e, t, r, n, a) {
  if ("production" !== process.env.NODE_ENV) for (var o in e) {
    if (has$1(e, o)) {
      var i;

      try {
        if ("function" != typeof e[o]) {
          var s = Error((n || "React class") + ": " + r + " type `" + o + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[o] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
          throw s.name = "Invariant Violation", s;
        }

        i = e[o](t, o, n, r, null, ReactPropTypesSecret$2);
      } catch (e) {
        i = e;
      }

      if (!i || i instanceof Error || printWarning$1((n || "React class") + ": type specification of " + r + " `" + o + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof i + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), i instanceof Error && !(i.message in loggedTypeFailures)) {
        loggedTypeFailures[i.message] = !0;
        var l = a ? a() : "";
        printWarning$1("Failed " + r + " type: " + i.message + (null != l ? l : ""));
      }
    }
  }
}

checkPropTypes$1.resetWarningCache = function () {
  "production" !== process.env.NODE_ENV && (loggedTypeFailures = {});
};

var checkPropTypes_1 = checkPropTypes$1,
    ReactIs$1 = reactIs.exports,
    assign$1 = objectAssign,
    ReactPropTypesSecret$1 = ReactPropTypesSecret_1,
    has = has$2,
    checkPropTypes = checkPropTypes_1,
    printWarning = function printWarning() {};

function emptyFunctionThatReturnsNull() {
  return null;
}

"production" !== process.env.NODE_ENV && (printWarning = function printWarning(e) {
  var t = "Warning: " + e;
  "undefined" != typeof console && console.error(t);

  try {
    throw new Error(t);
  } catch (e) {}
});

var factoryWithTypeCheckers = function factoryWithTypeCheckers(e, t) {
  var r = "function" == typeof Symbol && Symbol.iterator;
  var n = "<<anonymous>>",
      a = {
    array: l("array"),
    bigint: l("bigint"),
    bool: l("boolean"),
    func: l("function"),
    number: l("number"),
    object: l("object"),
    string: l("string"),
    symbol: l("symbol"),
    any: s(emptyFunctionThatReturnsNull),
    arrayOf: function arrayOf(e) {
      return s(function (t, r, n, a, o) {
        if ("function" != typeof e) return new i("Property `" + o + "` of component `" + n + "` has invalid PropType notation inside arrayOf.");
        var s = t[r];
        if (!Array.isArray(s)) return new i("Invalid " + a + " `" + o + "` of type `" + d(s) + "` supplied to `" + n + "`, expected an array.");

        for (var l = 0; l < s.length; l++) {
          var c = e(s, l, n, a, o + "[" + l + "]", ReactPropTypesSecret$1);
          if (c instanceof Error) return c;
        }

        return null;
      });
    },
    element: s(function (t, r, n, a, o) {
      var s = t[r];
      return e(s) ? null : new i("Invalid " + a + " `" + o + "` of type `" + d(s) + "` supplied to `" + n + "`, expected a single ReactElement.");
    }),
    elementType: s(function (e, t, r, n, a) {
      var o = e[t];
      return ReactIs$1.isValidElementType(o) ? null : new i("Invalid " + n + " `" + a + "` of type `" + d(o) + "` supplied to `" + r + "`, expected a single ReactElement type.");
    }),
    instanceOf: function instanceOf(e) {
      return s(function (t, r, a, o, s) {
        if (!(t[r] instanceof e)) {
          var l = e.name || n;
          return new i("Invalid " + o + " `" + s + "` of type `" + (((c = t[r]).constructor && c.constructor.name ? c.constructor.name : n) + "` supplied to `") + a + "`, expected instance of `" + l + "`.");
        }

        var c;
        return null;
      });
    },
    node: s(function (e, t, r, n, a) {
      return u(e[t]) ? null : new i("Invalid " + n + " `" + a + "` supplied to `" + r + "`, expected a ReactNode.");
    }),
    objectOf: function objectOf(e) {
      return s(function (t, r, n, a, o) {
        if ("function" != typeof e) return new i("Property `" + o + "` of component `" + n + "` has invalid PropType notation inside objectOf.");
        var s = t[r],
            l = d(s);
        if ("object" !== l) return new i("Invalid " + a + " `" + o + "` of type `" + l + "` supplied to `" + n + "`, expected an object.");

        for (var c in s) {
          if (has(s, c)) {
            var u = e(s, c, n, a, o + "." + c, ReactPropTypesSecret$1);
            if (u instanceof Error) return u;
          }
        }

        return null;
      });
    },
    oneOf: function oneOf(e) {
      if (!Array.isArray(e)) return "production" !== process.env.NODE_ENV && printWarning(arguments.length > 1 ? "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])." : "Invalid argument supplied to oneOf, expected an array."), emptyFunctionThatReturnsNull;

      function t(t, r, n, a, s) {
        for (var l = t[r], c = 0; c < e.length; c++) {
          if (o(l, e[c])) return null;
        }

        var u = JSON.stringify(e, function (e, t) {
          return "symbol" === p(t) ? String(t) : t;
        });
        return new i("Invalid " + a + " `" + s + "` of value `" + String(l) + "` supplied to `" + n + "`, expected one of " + u + ".");
      }

      return s(t);
    },
    oneOfType: function oneOfType(e) {
      if (!Array.isArray(e)) return "production" !== process.env.NODE_ENV && printWarning("Invalid argument supplied to oneOfType, expected an instance of array."), emptyFunctionThatReturnsNull;

      for (var t = 0; t < e.length; t++) {
        var r = e[t];
        if ("function" != typeof r) return printWarning("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + g(r) + " at index " + t + "."), emptyFunctionThatReturnsNull;
      }

      return s(function (t, r, n, a, o) {
        for (var s = [], l = 0; l < e.length; l++) {
          var c = (0, e[l])(t, r, n, a, o, ReactPropTypesSecret$1);
          if (null == c) return null;
          c.data && has(c.data, "expectedType") && s.push(c.data.expectedType);
        }

        return new i("Invalid " + a + " `" + o + "` supplied to `" + n + "`" + (s.length > 0 ? ", expected one of type [" + s.join(", ") + "]" : "") + ".");
      });
    },
    shape: function shape(e) {
      return s(function (t, r, n, a, o) {
        var s = t[r],
            l = d(s);
        if ("object" !== l) return new i("Invalid " + a + " `" + o + "` of type `" + l + "` supplied to `" + n + "`, expected `object`.");

        for (var u in e) {
          var g = e[u];
          if ("function" != typeof g) return c(n, a, o, u, p(g));
          var m = g(s, u, n, a, o + "." + u, ReactPropTypesSecret$1);
          if (m) return m;
        }

        return null;
      });
    },
    exact: function exact(e) {
      return s(function (t, r, n, a, o) {
        var s = t[r],
            l = d(s);
        if ("object" !== l) return new i("Invalid " + a + " `" + o + "` of type `" + l + "` supplied to `" + n + "`, expected `object`.");
        var u = assign$1({}, t[r], e);

        for (var g in u) {
          var m = e[g];
          if (has(e, g) && "function" != typeof m) return c(n, a, o, g, p(m));
          if (!m) return new i("Invalid " + a + " `" + o + "` key `" + g + "` supplied to `" + n + "`.\nBad object: " + JSON.stringify(t[r], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(e), null, "  "));
          var f = m(s, g, n, a, o + "." + g, ReactPropTypesSecret$1);
          if (f) return f;
        }

        return null;
      });
    }
  };

  function o(e, t) {
    return e === t ? 0 !== e || 1 / e == 1 / t : e != e && t != t;
  }

  function i(e, t) {
    this.message = e, this.data = t && "object" == typeof t ? t : {}, this.stack = "";
  }

  function s(e) {
    if ("production" !== process.env.NODE_ENV) var r = {},
        a = 0;

    function o(o, s, l, c, u, d, p) {
      if (c = c || n, d = d || l, p !== ReactPropTypesSecret$1) {
        if (t) {
          var g = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
          throw g.name = "Invariant Violation", g;
        }

        if ("production" !== process.env.NODE_ENV && "undefined" != typeof console) {
          var m = c + ":" + l;
          !r[m] && a < 3 && (printWarning("You are manually calling a React.PropTypes validation function for the `" + d + "` prop on `" + c + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), r[m] = !0, a++);
        }
      }

      return null == s[l] ? o ? null === s[l] ? new i("The " + u + " `" + d + "` is marked as required in `" + c + "`, but its value is `null`.") : new i("The " + u + " `" + d + "` is marked as required in `" + c + "`, but its value is `undefined`.") : null : e(s, l, c, u, d);
    }

    var s = o.bind(null, !1);
    return s.isRequired = o.bind(null, !0), s;
  }

  function l(e) {
    return s(function (t, r, n, a, o, s) {
      var l = t[r];
      return d(l) !== e ? new i("Invalid " + a + " `" + o + "` of type `" + p(l) + "` supplied to `" + n + "`, expected `" + e + "`.", {
        expectedType: e
      }) : null;
    });
  }

  function c(e, t, r, n, a) {
    return new i((e || "React class") + ": " + t + " type `" + r + "." + n + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + a + "`.");
  }

  function u(t) {
    switch (typeof t) {
      case "number":
      case "string":
      case "undefined":
        return !0;

      case "boolean":
        return !t;

      case "object":
        if (Array.isArray(t)) return t.every(u);
        if (null === t || e(t)) return !0;

        var n = function (e) {
          var t = e && (r && e[r] || e["@@iterator"]);
          if ("function" == typeof t) return t;
        }(t);

        if (!n) return !1;
        var a,
            o = n.call(t);

        if (n !== t.entries) {
          for (; !(a = o.next()).done;) {
            if (!u(a.value)) return !1;
          }
        } else for (; !(a = o.next()).done;) {
          var i = a.value;
          if (i && !u(i[1])) return !1;
        }

        return !0;

      default:
        return !1;
    }
  }

  function d(e) {
    var t = typeof e;
    return Array.isArray(e) ? "array" : e instanceof RegExp ? "object" : function (e, t) {
      return "symbol" === e || !!t && ("Symbol" === t["@@toStringTag"] || "function" == typeof Symbol && t instanceof Symbol);
    }(t, e) ? "symbol" : t;
  }

  function p(e) {
    if (null == e) return "" + e;
    var t = d(e);

    if ("object" === t) {
      if (e instanceof Date) return "date";
      if (e instanceof RegExp) return "regexp";
    }

    return t;
  }

  function g(e) {
    var t = p(e);

    switch (t) {
      case "array":
      case "object":
        return "an " + t;

      case "boolean":
      case "date":
      case "regexp":
        return "a " + t;

      default:
        return t;
    }
  }

  return i.prototype = Error.prototype, a.checkPropTypes = checkPropTypes, a.resetWarningCache = checkPropTypes.resetWarningCache, a.PropTypes = a, a;
},
    ReactPropTypesSecret = ReactPropTypesSecret_1;

function emptyFunction() {}

function emptyFunctionWithReset() {}

emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function factoryWithThrowingShims() {
  function e(e, t, r, n, a, o) {
    if (o !== ReactPropTypesSecret) {
      var i = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
      throw i.name = "Invariant Violation", i;
    }
  }

  function t() {
    return e;
  }

  e.isRequired = e;
  var r = {
    array: e,
    bigint: e,
    bool: e,
    func: e,
    number: e,
    object: e,
    string: e,
    symbol: e,
    any: e,
    arrayOf: t,
    element: e,
    elementType: e,
    instanceOf: t,
    node: e,
    objectOf: t,
    oneOf: t,
    oneOfType: t,
    shape: t,
    exact: t,
    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };
  return r.PropTypes = r, r;
};

if ("production" !== process.env.NODE_ENV) {
  var ReactIs = reactIs.exports,
      throwOnDirectAccess = !0;
  propTypes.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
} else propTypes.exports = factoryWithThrowingShims();

var PropTypes = propTypes.exports;

function _extends$d() {
  return _extends$d = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];

      for (var n in r) {
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
    }

    return e;
  }, _extends$d.apply(this, arguments);
}

function isHostComponent(e) {
  return "string" == typeof e;
}

function chainPropTypes(e, t) {
  return "production" === process.env.NODE_ENV ? function () {
    return null;
  } : function () {
    return e.apply(void 0, arguments) || t.apply(void 0, arguments);
  };
}

function _extends$c() {
  return _extends$c = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];

      for (var n in r) {
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
    }

    return e;
  }, _extends$c.apply(this, arguments);
}

function isPlainObject(e) {
  return null !== e && "object" == typeof e && e.constructor === Object;
}

function deepmerge(e, t) {
  var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    clone: !0
  };
  var n = r.clone ? _extends$c({}, e) : e;
  return isPlainObject(e) && isPlainObject(t) && Object.keys(t).forEach(function (a) {
    "__proto__" !== a && (isPlainObject(t[a]) && a in e && isPlainObject(e[a]) ? n[a] = deepmerge(e[a], t[a], r) : n[a] = t[a]);
  }), n;
}

function isClassComponent$1(e) {
  var _e$prototype = e.prototype,
      t = _e$prototype === void 0 ? {} : _e$prototype;
  return Boolean(t.isReactComponent);
}

function acceptingRef(e, t, r, n, a) {
  var o = e[t],
      i = a || t;
  if (null == o || "undefined" == typeof window) return null;
  var s;
  var l = o.type;
  return "function" != typeof l || isClassComponent$1(l) || (s = "Did you accidentally use a plain function component for an element instead?"), void 0 !== s ? new Error("Invalid ".concat(n, " `").concat(i, "` supplied to `").concat(r, "`. Expected an element that can hold a ref. ").concat(s, " For more information see https://mui.com/r/caveat-with-refs-guide")) : null;
}

var elementAcceptingRef = chainPropTypes(PropTypes.element, acceptingRef);
elementAcceptingRef.isRequired = chainPropTypes(PropTypes.element.isRequired, acceptingRef);
var elementAcceptingRef$1 = elementAcceptingRef;

function isClassComponent(e) {
  var _e$prototype2 = e.prototype,
      t = _e$prototype2 === void 0 ? {} : _e$prototype2;
  return Boolean(t.isReactComponent);
}

function elementTypeAcceptingRef(e, t, r, n, a) {
  var o = e[t],
      i = a || t;
  if (null == o || "undefined" == typeof window) return null;
  var s;
  return "function" != typeof o || isClassComponent(o) || (s = "Did you accidentally provide a plain function component instead?"), void 0 !== s ? new Error("Invalid ".concat(n, " `").concat(i, "` supplied to `").concat(r, "`. Expected an element type that can hold a ref. ").concat(s, " For more information see https://mui.com/r/caveat-with-refs-guide")) : null;
}

var elementTypeAcceptingRef$1 = chainPropTypes(PropTypes.elementType, elementTypeAcceptingRef);
var specialProperty = "exact-prop: ​";

function exactProp(e) {
  return "production" === process.env.NODE_ENV ? e : _extends$c({}, e, _defineProperty2({}, specialProperty, function (t) {
    var r = Object.keys(t).filter(function (t) {
      return !e.hasOwnProperty(t);
    });
    return r.length > 0 ? new Error("The following props are not supported: ".concat(r.map(function (e) {
      return "`".concat(e, "`");
    }).join(", "), ". Please remove them.")) : null;
  }));
}

function formatMuiErrorMessage(e) {
  var t = "https://mui.com/production-error/?code=" + e;

  for (var _e28 = 1; _e28 < arguments.length; _e28 += 1) {
    t += "&args[]=" + encodeURIComponent(arguments[_e28]);
  }

  return "Minified MUI error #" + e + "; visit " + t + " for the full message.";
}

var fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;

function getFunctionName(e) {
  var t = "".concat(e).match(fnNameMatchRegex);
  return t && t[1] || "";
}

function getFunctionComponentName(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  return e.displayName || e.name || getFunctionName(e) || t;
}

function getWrappedName(e, t, r) {
  var n = getFunctionComponentName(t);
  return e.displayName || ("" !== n ? "".concat(r, "(").concat(n, ")") : r);
}

function getDisplayName(e) {
  if (null != e) {
    if ("string" == typeof e) return e;
    if ("function" == typeof e) return getFunctionComponentName(e, "Component");
    if ("object" == typeof e) switch (e.$$typeof) {
      case reactIs$1.exports.ForwardRef:
        return getWrappedName(e, e.render, "ForwardRef");

      case reactIs$1.exports.Memo:
        return getWrappedName(e, e.type, "memo");

      default:
        return;
    }
  }
}

function HTMLElementType(e, t, r, n, a) {
  if ("production" === process.env.NODE_ENV) return null;
  var o = e[t],
      i = a || t;
  return null == o ? null : o && 1 !== o.nodeType ? new Error("Invalid ".concat(n, " `").concat(i, "` supplied to `").concat(r, "`. Expected an HTMLElement.")) : null;
}

var refType = PropTypes.oneOfType([PropTypes.func, PropTypes.object]);
var refType$1 = refType;

function capitalize(e) {
  if ("string" != typeof e) throw new Error("production" !== process.env.NODE_ENV ? "MUI: `capitalize(string)` expects a string argument." : formatMuiErrorMessage(7));
  return e.charAt(0).toUpperCase() + e.slice(1);
}

function createChainedFunction() {
  for (var _len4 = arguments.length, e = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    e[_key4] = arguments[_key4];
  }

  return e.reduce(function (e, t) {
    return null == t ? e : function () {
      for (var _len5 = arguments.length, r = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        r[_key5] = arguments[_key5];
      }

      e.apply(this, r), t.apply(this, r);
    };
  }, function () {});
}

function debounce(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 166;
  var r;

  function n() {
    var _this9 = this;

    for (var _len6 = arguments.length, n = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
      n[_key6] = arguments[_key6];
    }

    clearTimeout(r), r = setTimeout(function () {
      e.apply(_this9, n);
    }, t);
  }

  return n.clear = function () {
    clearTimeout(r);
  }, n;
}

function deprecatedPropType(e, t) {
  return "production" === process.env.NODE_ENV ? function () {
    return null;
  } : function (e, r, n, a, o) {
    var i = n || "<<anonymous>>",
        s = o || r;
    return void 0 !== e[r] ? new Error("The ".concat(a, " `").concat(s, "` of `").concat(i, "` is deprecated. ").concat(t)) : null;
  };
}

function isMuiElement(e, t) {
  return React.isValidElement(e) && -1 !== t.indexOf(e.type.muiName);
}

function ownerDocument(e) {
  return e && e.ownerDocument || document;
}

function ownerWindow(e) {
  return ownerDocument(e).defaultView || window;
}

function requirePropFactory(e, t) {
  if ("production" === process.env.NODE_ENV) return function () {
    return null;
  };
  var r = t ? _extends$c({}, t.propTypes) : null;
  return function (t) {
    return function (n, a, o, i, s) {
      var c = s || a,
          u = null == r ? void 0 : r[c];

      if (u) {
        for (var _len7 = arguments.length, l = new Array(_len7 > 5 ? _len7 - 5 : 0), _key7 = 5; _key7 < _len7; _key7++) {
          l[_key7 - 5] = arguments[_key7];
        }

        var _e29 = u.apply(void 0, [n, a, o, i, s].concat(l));

        if (_e29) return _e29;
      }

      return void 0 === n[a] || n[t] ? null : new Error("The prop `".concat(c, "` of `").concat(e, "` can only be used together with the `").concat(t, "` prop."));
    };
  };
}

function setRef(e, t) {
  "function" == typeof e ? e(t) : e && (e.current = t);
}

var useEnhancedEffect = "undefined" != typeof window ? React.useLayoutEffect : React.useEffect;
var useEnhancedEffect$1 = useEnhancedEffect;
var globalId = 0;

function useGlobalId(e) {
  var _React$useState = React.useState(e),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      t = _React$useState2[0],
      r = _React$useState2[1],
      n = e || t;

  return React.useEffect(function () {
    null == t && (globalId += 1, r("mui-".concat(globalId)));
  }, [t]), n;
}

var maybeReactUseId = React.useId;

function useId(e) {
  if (void 0 !== maybeReactUseId) {
    var _t17 = maybeReactUseId();

    return null != e ? e : _t17;
  }

  return useGlobalId(e);
}

function unsupportedProp(e, t, r, n, a) {
  if ("production" === process.env.NODE_ENV) return null;
  var o = a || t;
  return void 0 !== e[t] ? new Error("The prop `".concat(o, "` is not supported. Please remove it.")) : null;
}

function useControlled(_ref15) {
  var e = _ref15.controlled,
      t = _ref15.default,
      r = _ref15.name,
      _ref15$state = _ref15.state,
      n = _ref15$state === void 0 ? "value" : _ref15$state;

  var _React$useRef = React.useRef(void 0 !== e),
      a = _React$useRef.current,
      _React$useState3 = React.useState(t),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      o = _React$useState4[0],
      i = _React$useState4[1],
      s = a ? e : o;

  if ("production" !== process.env.NODE_ENV) {
    React.useEffect(function () {
      a !== (void 0 !== e) && console.error(["MUI: A component is changing the ".concat(a ? "" : "un", "controlled ").concat(n, " state of ").concat(r, " to be ").concat(a ? "un" : "", "controlled."), "Elements should not switch from uncontrolled to controlled (or vice versa).", "Decide between using a controlled or uncontrolled ".concat(r, " element for the lifetime of the component."), "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join("\n"));
    }, [n, r, e]);

    var _React$useRef2 = React.useRef(t),
        _o9 = _React$useRef2.current;

    React.useEffect(function () {
      a || _o9 === t || console.error(["MUI: A component is changing the default ".concat(n, " state of an uncontrolled ").concat(r, " after being initialized. To suppress this warning opt to use a controlled ").concat(r, ".")].join("\n"));
    }, [JSON.stringify(t)]);
  }

  return [s, React.useCallback(function (e) {
    a || i(e);
  }, [])];
}

function useEventCallback(e) {
  var t = React.useRef(e);
  return useEnhancedEffect$1(function () {
    t.current = e;
  }), React.useCallback(function () {
    return (0, t.current).apply(void 0, arguments);
  }, []);
}

function useForkRef(e, t) {
  return React.useMemo(function () {
    return null == e && null == t ? null : function (r) {
      setRef(e, r), setRef(t, r);
    };
  }, [e, t]);
}

var hadKeyboardEvent = !0,
    hadFocusVisibleRecently = !1,
    hadFocusVisibleRecentlyTimeout;
var inputTypesWhitelist = {
  text: !0,
  search: !0,
  url: !0,
  tel: !0,
  email: !0,
  password: !0,
  number: !0,
  date: !0,
  month: !0,
  week: !0,
  time: !0,
  datetime: !0,
  "datetime-local": !0
};

function focusTriggersKeyboardModality(e) {
  var t = e.type,
      r = e.tagName;
  return !("INPUT" !== r || !inputTypesWhitelist[t] || e.readOnly) || "TEXTAREA" === r && !e.readOnly || !!e.isContentEditable;
}

function handleKeyDown(e) {
  e.metaKey || e.altKey || e.ctrlKey || (hadKeyboardEvent = !0);
}

function handlePointerDown() {
  hadKeyboardEvent = !1;
}

function handleVisibilityChange() {
  "hidden" === this.visibilityState && hadFocusVisibleRecently && (hadKeyboardEvent = !0);
}

function prepare(e) {
  e.addEventListener("keydown", handleKeyDown, !0), e.addEventListener("mousedown", handlePointerDown, !0), e.addEventListener("pointerdown", handlePointerDown, !0), e.addEventListener("touchstart", handlePointerDown, !0), e.addEventListener("visibilitychange", handleVisibilityChange, !0);
}

function isFocusVisible(e) {
  var t = e.target;

  try {
    return t.matches(":focus-visible");
  } catch (e) {}

  return hadKeyboardEvent || focusTriggersKeyboardModality(t);
}

function useIsFocusVisible() {
  var e = React.useCallback(function (e) {
    null != e && prepare(e.ownerDocument);
  }, []),
      t = React.useRef(!1);
  return {
    isFocusVisibleRef: t,
    onFocus: function onFocus(e) {
      return !!isFocusVisible(e) && (t.current = !0, !0);
    },
    onBlur: function onBlur() {
      return !!t.current && (hadFocusVisibleRecently = !0, window.clearTimeout(hadFocusVisibleRecentlyTimeout), hadFocusVisibleRecentlyTimeout = window.setTimeout(function () {
        hadFocusVisibleRecently = !1;
      }, 100), t.current = !1, !0);
    },
    ref: e
  };
}

function getScrollbarSize(e) {
  var t = e.documentElement.clientWidth;
  return Math.abs(window.innerWidth - t);
}

function getTypeByValue(e) {
  var t = typeof e;

  switch (t) {
    case "number":
      return Number.isNaN(e) ? "NaN" : Number.isFinite(e) ? e !== Math.floor(e) ? "float" : "number" : "Infinity";

    case "object":
      return null === e ? "null" : e.constructor.name;

    default:
      return t;
  }
}

function ponyfillIsInteger(e) {
  return "number" == typeof e && isFinite(e) && Math.floor(e) === e;
}

var isInteger = Number.isInteger || ponyfillIsInteger;

function requiredInteger(e, t, r, n) {
  var a = e[t];

  if (null == a || !isInteger(a)) {
    var _e30 = getTypeByValue(a);

    return new RangeError("Invalid ".concat(n, " `").concat(t, "` of type `").concat(_e30, "` supplied to `").concat(r, "`, expected `integer`."));
  }

  return null;
}

function validator(e, t) {
  for (var _len8 = arguments.length, r = new Array(_len8 > 2 ? _len8 - 2 : 0), _key8 = 2; _key8 < _len8; _key8++) {
    r[_key8 - 2] = arguments[_key8];
  }

  return void 0 === e[t] ? null : requiredInteger.apply(void 0, [e, t].concat(r));
}

function validatorNoop() {
  return null;
}

validator.isRequired = requiredInteger, validatorNoop.isRequired = validatorNoop;
var integerPropType = "production" === process.env.NODE_ENV ? validatorNoop : validator;

function resolveProps(e, t) {
  var r = _extends$c({}, t);

  return Object.keys(e).forEach(function (t) {
    void 0 === r[t] && (r[t] = e[t]);
  }), r;
}

function _objectWithoutPropertiesLoose$3(e, t) {
  if (null == e) return {};
  var r,
      n,
      a = {},
      o = Object.keys(e);

  for (n = 0; n < o.length; n++) {
    r = o[n], t.indexOf(r) >= 0 || (a[r] = e[r]);
  }

  return a;
}

function composeClasses(e, t, r) {
  var n = {};
  return Object.keys(e).forEach(function (a) {
    n[a] = e[a].reduce(function (e, n) {
      return n && (r && r[n] && e.push(r[n]), e.push(t(n))), e;
    }, []).join(" ");
  }), n;
}

var defaultGenerator = function defaultGenerator(e) {
  return e;
},
    createClassNameGenerator = function createClassNameGenerator() {
  var e = defaultGenerator;
  return {
    configure: function configure(t) {
      e = t;
    },
    generate: function generate(t) {
      return e(t);
    },
    reset: function reset() {
      e = defaultGenerator;
    }
  };
},
    ClassNameGenerator = createClassNameGenerator();

var ClassNameGenerator$1 = ClassNameGenerator;
var globalStateClassesMapping = {
  active: "Mui-active",
  checked: "Mui-checked",
  completed: "Mui-completed",
  disabled: "Mui-disabled",
  error: "Mui-error",
  expanded: "Mui-expanded",
  focused: "Mui-focused",
  focusVisible: "Mui-focusVisible",
  required: "Mui-required",
  selected: "Mui-selected"
};

function generateUtilityClass(e, t) {
  return globalStateClassesMapping[t] || "".concat(ClassNameGenerator$1.generate(e), "-").concat(t);
}

function generateUtilityClasses(e, t) {
  var r = {};
  return t.forEach(function (t) {
    r[t] = generateUtilityClass(e, t);
  }), r;
}

function getBackdropUtilityClass(e) {
  return generateUtilityClass("MuiBackdrop", e);
}

generateUtilityClasses("MuiBackdrop", ["root", "invisible"]);

var _excluded$G = ["classes", "className", "invisible", "component", "components", "componentsProps", "theme"],
    useUtilityClasses$l = function useUtilityClasses$l(e) {
  var t = e.classes,
      r = e.invisible;
  return composeClasses({
    root: ["root", r && "invisible"]
  }, getBackdropUtilityClass, t);
},
    BackdropUnstyled = React.forwardRef(function (e, t) {
  var r = e.classes,
      n = e.className,
      _e$invisible = e.invisible,
      a = _e$invisible === void 0 ? !1 : _e$invisible,
      _e$component = e.component,
      o = _e$component === void 0 ? "div" : _e$component,
      _e$components = e.components,
      i = _e$components === void 0 ? {} : _e$components,
      _e$componentsProps = e.componentsProps,
      s = _e$componentsProps === void 0 ? {} : _e$componentsProps,
      l = e.theme,
      c = _objectWithoutPropertiesLoose$3(e, _excluded$G),
      u = _extends$d({}, e, {
    classes: r,
    invisible: a
  }),
      d = useUtilityClasses$l(u),
      p = i.Root || o,
      g = s.root || {};

  return jsx$1(p, _extends$d({
    "aria-hidden": !0
  }, g, !isHostComponent(p) && {
    as: o,
    ownerState: _extends$d({}, u, g.ownerState),
    theme: l
  }, {
    ref: t
  }, c, {
    className: clsx(d.root, g.className, n)
  }));
});

function getContainer$1(e) {
  return "function" == typeof e ? e() : e;
}

"production" !== process.env.NODE_ENV && (BackdropUnstyled.propTypes = {
  children: PropTypes.node,
  classes: PropTypes.object,
  className: PropTypes.string,
  component: PropTypes.elementType,
  components: PropTypes.shape({
    Root: PropTypes.elementType
  }),
  componentsProps: PropTypes.shape({
    root: PropTypes.object
  }),
  invisible: PropTypes.bool
});
var Portal = React.forwardRef(function (e, t) {
  var r = e.children,
      n = e.container,
      _e$disablePortal = e.disablePortal,
      a = _e$disablePortal === void 0 ? !1 : _e$disablePortal,
      _React$useState5 = React.useState(null),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      o = _React$useState6[0],
      i = _React$useState6[1],
      s = useForkRef(React.isValidElement(r) ? r.ref : null, t);

  return useEnhancedEffect$1(function () {
    a || i(getContainer$1(n) || document.body);
  }, [n, a]), useEnhancedEffect$1(function () {
    if (o && !a) return setRef(t, o), function () {
      setRef(t, null);
    };
  }, [t, o, a]), a ? React.isValidElement(r) ? React.cloneElement(r, {
    ref: s
  }) : r : o ? ReactDOM.createPortal(r, o) : o;
});

function isOverflowing(e) {
  var t = ownerDocument(e);
  return t.body === e ? ownerWindow(e).innerWidth > t.documentElement.clientWidth : e.scrollHeight > e.clientHeight;
}

function ariaHidden(e, t) {
  t ? e.setAttribute("aria-hidden", "true") : e.removeAttribute("aria-hidden");
}

function getPaddingRight(e) {
  return parseInt(ownerWindow(e).getComputedStyle(e).paddingRight, 10) || 0;
}

function ariaHiddenSiblings(e, t, r) {
  var n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var a = arguments.length > 4 ? arguments[4] : undefined;
  var o = [t, r].concat(_toConsumableArray(n)),
      i = ["TEMPLATE", "SCRIPT", "STYLE"];
  [].forEach.call(e.children, function (e) {
    -1 === o.indexOf(e) && -1 === i.indexOf(e.tagName) && ariaHidden(e, a);
  });
}

function findIndexOf(e, t) {
  var r = -1;
  return e.some(function (e, n) {
    return !!t(e) && (r = n, !0);
  }), r;
}

function handleContainer(e, t) {
  var r = [],
      n = e.container;

  if (!t.disableScrollLock) {
    if (isOverflowing(n)) {
      var _e32 = getScrollbarSize(ownerDocument(n));

      r.push({
        value: n.style.paddingRight,
        property: "padding-right",
        el: n
      }), n.style.paddingRight = "".concat(getPaddingRight(n) + _e32, "px");

      var _t19 = ownerDocument(n).querySelectorAll(".mui-fixed");

      [].forEach.call(_t19, function (t) {
        r.push({
          value: t.style.paddingRight,
          property: "padding-right",
          el: t
        }), t.style.paddingRight = "".concat(getPaddingRight(t) + _e32, "px");
      });
    }

    var _e31 = n.parentElement,
        _t18 = ownerWindow(n),
        a = "HTML" === (null == _e31 ? void 0 : _e31.nodeName) && "scroll" === _t18.getComputedStyle(_e31).overflowY ? _e31 : n;

    r.push({
      value: a.style.overflow,
      property: "overflow",
      el: a
    }, {
      value: a.style.overflowX,
      property: "overflow-x",
      el: a
    }, {
      value: a.style.overflowY,
      property: "overflow-y",
      el: a
    }), a.style.overflow = "hidden";
  }

  return function () {
    r.forEach(function (_ref16) {
      var e = _ref16.value,
          t = _ref16.el,
          r = _ref16.property;
      e ? t.style.setProperty(r, e) : t.style.removeProperty(r);
    });
  };
}

function getHiddenSiblings(e) {
  var t = [];
  return [].forEach.call(e.children, function (e) {
    "true" === e.getAttribute("aria-hidden") && t.push(e);
  }), t;
}

"production" !== process.env.NODE_ENV && (Portal.propTypes = {
  children: PropTypes.node,
  container: PropTypes.oneOfType([HTMLElementType, PropTypes.func]),
  disablePortal: PropTypes.bool
}), "production" !== process.env.NODE_ENV && (Portal.propTypes = exactProp(Portal.propTypes));

var ModalManager = /*#__PURE__*/function () {
  function ModalManager() {
    _classCallCheck(this, ModalManager);

    this.containers = void 0, this.modals = void 0, this.modals = [], this.containers = [];
  }

  _createClass(ModalManager, [{
    key: "add",
    value: function add(e, t) {
      var r = this.modals.indexOf(e);
      if (-1 !== r) return r;
      r = this.modals.length, this.modals.push(e), e.modalRef && ariaHidden(e.modalRef, !1);
      var n = getHiddenSiblings(t);
      ariaHiddenSiblings(t, e.mount, e.modalRef, n, !0);
      var a = findIndexOf(this.containers, function (e) {
        return e.container === t;
      });
      return -1 !== a ? (this.containers[a].modals.push(e), r) : (this.containers.push({
        modals: [e],
        container: t,
        restore: null,
        hiddenSiblings: n
      }), r);
    }
  }, {
    key: "mount",
    value: function mount(e, t) {
      var r = findIndexOf(this.containers, function (t) {
        return -1 !== t.modals.indexOf(e);
      }),
          n = this.containers[r];
      n.restore || (n.restore = handleContainer(n, t));
    }
  }, {
    key: "remove",
    value: function remove(e) {
      var t = this.modals.indexOf(e);
      if (-1 === t) return t;
      var r = findIndexOf(this.containers, function (t) {
        return -1 !== t.modals.indexOf(e);
      }),
          n = this.containers[r];
      if (n.modals.splice(n.modals.indexOf(e), 1), this.modals.splice(t, 1), 0 === n.modals.length) n.restore && n.restore(), e.modalRef && ariaHidden(e.modalRef, !0), ariaHiddenSiblings(n.container, e.mount, e.modalRef, n.hiddenSiblings, !1), this.containers.splice(r, 1);else {
        var _e33 = n.modals[n.modals.length - 1];
        _e33.modalRef && ariaHidden(_e33.modalRef, !1);
      }
      return t;
    }
  }, {
    key: "isTopModal",
    value: function isTopModal(e) {
      return this.modals.length > 0 && this.modals[this.modals.length - 1] === e;
    }
  }]);

  return ModalManager;
}();

var candidatesSelector = ["input", "select", "textarea", "a[href]", "button", "[tabindex]", "audio[controls]", "video[controls]", '[contenteditable]:not([contenteditable="false"])'].join(",");

function getTabIndex(e) {
  var t = parseInt(e.getAttribute("tabindex"), 10);
  return Number.isNaN(t) ? "true" === e.contentEditable || ("AUDIO" === e.nodeName || "VIDEO" === e.nodeName || "DETAILS" === e.nodeName) && null === e.getAttribute("tabindex") ? 0 : e.tabIndex : t;
}

function isNonTabbableRadio(e) {
  if ("INPUT" !== e.tagName || "radio" !== e.type) return !1;
  if (!e.name) return !1;

  var t = function t(_t20) {
    return e.ownerDocument.querySelector("input[type=\"radio\"]".concat(_t20));
  };

  var r = t("[name=\"".concat(e.name, "\"]:checked"));
  return r || (r = t("[name=\"".concat(e.name, "\"]"))), r !== e;
}

function isNodeMatchingSelectorFocusable(e) {
  return !(e.disabled || "INPUT" === e.tagName && "hidden" === e.type || isNonTabbableRadio(e));
}

function defaultGetTabbable(e) {
  var t = [],
      r = [];
  return Array.from(e.querySelectorAll(candidatesSelector)).forEach(function (e, n) {
    var a = getTabIndex(e);
    -1 !== a && isNodeMatchingSelectorFocusable(e) && (0 === a ? t.push(e) : r.push({
      documentOrder: n,
      tabIndex: a,
      node: e
    }));
  }), r.sort(function (e, t) {
    return e.tabIndex === t.tabIndex ? e.documentOrder - t.documentOrder : e.tabIndex - t.tabIndex;
  }).map(function (e) {
    return e.node;
  }).concat(t);
}

function defaultIsEnabled() {
  return !0;
}

function Unstable_TrapFocus(e) {
  var t = e.children,
      _e$disableAutoFocus = e.disableAutoFocus,
      r = _e$disableAutoFocus === void 0 ? !1 : _e$disableAutoFocus,
      _e$disableEnforceFocu = e.disableEnforceFocus,
      n = _e$disableEnforceFocu === void 0 ? !1 : _e$disableEnforceFocu,
      _e$disableRestoreFocu = e.disableRestoreFocus,
      a = _e$disableRestoreFocu === void 0 ? !1 : _e$disableRestoreFocu,
      _e$getTabbable = e.getTabbable,
      o = _e$getTabbable === void 0 ? defaultGetTabbable : _e$getTabbable,
      _e$isEnabled = e.isEnabled,
      i = _e$isEnabled === void 0 ? defaultIsEnabled : _e$isEnabled,
      s = e.open,
      l = React.useRef(),
      c = React.useRef(null),
      u = React.useRef(null),
      d = React.useRef(null),
      p = React.useRef(null),
      g = React.useRef(!1),
      m = React.useRef(null),
      f = useForkRef(t.ref, m),
      h = React.useRef(null);
  React.useEffect(function () {
    s && m.current && (g.current = !r);
  }, [r, s]), React.useEffect(function () {
    if (!s || !m.current) return;
    var e = ownerDocument(m.current);
    return m.current.contains(e.activeElement) || (m.current.hasAttribute("tabIndex") || ("production" !== process.env.NODE_ENV && console.error(["MUI: The modal content node does not accept focus.", 'For the benefit of assistive technologies, the tabIndex of the node is being set to "-1".'].join("\n")), m.current.setAttribute("tabIndex", -1)), g.current && m.current.focus()), function () {
      a || (d.current && d.current.focus && (l.current = !0, d.current.focus()), d.current = null);
    };
  }, [s]), React.useEffect(function () {
    if (!s || !m.current) return;

    var e = ownerDocument(m.current),
        t = function t(_t22) {
      var r = m.current;
      if (null !== r) if (e.hasFocus() && !n && i() && !l.current) {
        if (!r.contains(e.activeElement)) {
          if (_t22 && p.current !== _t22.target || e.activeElement !== p.current) p.current = null;else if (null !== p.current) return;
          if (!g.current) return;
          var _n13 = [];

          if (e.activeElement !== c.current && e.activeElement !== u.current || (_n13 = o(m.current)), _n13.length > 0) {
            var a, s;

            var _e34 = Boolean((null == (a = h.current) ? void 0 : a.shiftKey) && "Tab" === (null == (s = h.current) ? void 0 : s.key)),
                _t21 = _n13[0],
                _r17 = _n13[_n13.length - 1];

            _e34 ? _r17.focus() : _t21.focus();
          } else r.focus();
        }
      } else l.current = !1;
    },
        r = function r(t) {
      h.current = t, !n && i() && "Tab" === t.key && e.activeElement === m.current && t.shiftKey && (l.current = !0, u.current.focus());
    };

    e.addEventListener("focusin", t), e.addEventListener("keydown", r, !0);
    var a = setInterval(function () {
      "BODY" === e.activeElement.tagName && t();
    }, 50);
    return function () {
      clearInterval(a), e.removeEventListener("focusin", t), e.removeEventListener("keydown", r, !0);
    };
  }, [r, n, a, i, s, o]);

  var b = function b(e) {
    null === d.current && (d.current = e.relatedTarget), g.current = !0;
  };

  return jsxs(React.Fragment, {
    children: [jsx$1("div", {
      tabIndex: 0,
      onFocus: b,
      ref: c,
      "data-test": "sentinelStart"
    }), React.cloneElement(t, {
      ref: f,
      onFocus: function onFocus(e) {
        null === d.current && (d.current = e.relatedTarget), g.current = !0, p.current = e.target;
        var r = t.props.onFocus;
        r && r(e);
      }
    }), jsx$1("div", {
      tabIndex: 0,
      onFocus: b,
      ref: u,
      "data-test": "sentinelEnd"
    })]
  });
}

function getModalUtilityClass(e) {
  return generateUtilityClass("MuiModal", e);
}

"production" !== process.env.NODE_ENV && (Unstable_TrapFocus.propTypes = {
  children: elementAcceptingRef$1,
  disableAutoFocus: PropTypes.bool,
  disableEnforceFocus: PropTypes.bool,
  disableRestoreFocus: PropTypes.bool,
  getTabbable: PropTypes.func,
  isEnabled: PropTypes.func,
  open: PropTypes.bool.isRequired
}), "production" !== process.env.NODE_ENV && (Unstable_TrapFocus.propTypes = exactProp(Unstable_TrapFocus.propTypes)), generateUtilityClasses("MuiModal", ["root", "hidden"]);

var _excluded$F = ["BackdropComponent", "BackdropProps", "children", "classes", "className", "closeAfterTransition", "component", "components", "componentsProps", "container", "disableAutoFocus", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "disableScrollLock", "hideBackdrop", "keepMounted", "manager", "onBackdropClick", "onClose", "onKeyDown", "open", "theme", "onTransitionEnter", "onTransitionExited"],
    useUtilityClasses$k = function useUtilityClasses$k(e) {
  var t = e.open,
      r = e.exited,
      n = e.classes;
  return composeClasses({
    root: ["root", !t && r && "hidden"]
  }, getModalUtilityClass, n);
};

function getContainer(e) {
  return "function" == typeof e ? e() : e;
}

function getHasTransition(e) {
  return !!e.children && e.children.props.hasOwnProperty("in");
}

var defaultManager = new ModalManager(),
    ModalUnstyled = React.forwardRef(function (e, t) {
  var r = e.BackdropComponent,
      n = e.BackdropProps,
      a = e.children,
      o = e.classes,
      i = e.className,
      _e$closeAfterTransiti = e.closeAfterTransition,
      s = _e$closeAfterTransiti === void 0 ? !1 : _e$closeAfterTransiti,
      _e$component2 = e.component,
      l = _e$component2 === void 0 ? "div" : _e$component2,
      _e$components2 = e.components,
      c = _e$components2 === void 0 ? {} : _e$components2,
      _e$componentsProps2 = e.componentsProps,
      u = _e$componentsProps2 === void 0 ? {} : _e$componentsProps2,
      d = e.container,
      _e$disableAutoFocus2 = e.disableAutoFocus,
      p = _e$disableAutoFocus2 === void 0 ? !1 : _e$disableAutoFocus2,
      _e$disableEnforceFocu2 = e.disableEnforceFocus,
      g = _e$disableEnforceFocu2 === void 0 ? !1 : _e$disableEnforceFocu2,
      _e$disableEscapeKeyDo = e.disableEscapeKeyDown,
      m = _e$disableEscapeKeyDo === void 0 ? !1 : _e$disableEscapeKeyDo,
      _e$disablePortal2 = e.disablePortal,
      f = _e$disablePortal2 === void 0 ? !1 : _e$disablePortal2,
      _e$disableRestoreFocu2 = e.disableRestoreFocus,
      h = _e$disableRestoreFocu2 === void 0 ? !1 : _e$disableRestoreFocu2,
      _e$disableScrollLock = e.disableScrollLock,
      b = _e$disableScrollLock === void 0 ? !1 : _e$disableScrollLock,
      _e$hideBackdrop = e.hideBackdrop,
      y = _e$hideBackdrop === void 0 ? !1 : _e$hideBackdrop,
      _e$keepMounted = e.keepMounted,
      v = _e$keepMounted === void 0 ? !1 : _e$keepMounted,
      _e$manager = e.manager,
      _ = _e$manager === void 0 ? defaultManager : _e$manager,
      T = e.onBackdropClick,
      E = e.onClose,
      S = e.onKeyDown,
      x = e.open,
      w = e.theme,
      C = e.onTransitionEnter,
      k = e.onTransitionExited,
      $ = _objectWithoutPropertiesLoose$3(e, _excluded$F),
      _React$useState7 = React.useState(!0),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      R = _React$useState8[0],
      A = _React$useState8[1],
      I = React.useRef({}),
      N = React.useRef(null),
      P = React.useRef(null),
      O = useForkRef(P, t),
      D = getHasTransition(e),
      L = function L() {
    return I.current.modalRef = P.current, I.current.mountNode = N.current, I.current;
  },
      M = function M() {
    _.mount(L(), {
      disableScrollLock: b
    }), P.current.scrollTop = 0;
  },
      F = useEventCallback(function () {
    var e = getContainer(d) || ownerDocument(N.current).body;
    _.add(L(), e), P.current && M();
  }),
      j = React.useCallback(function () {
    return _.isTopModal(L());
  }, [_]),
      B = useEventCallback(function (e) {
    N.current = e, e && (x && j() ? M() : ariaHidden(P.current, !0));
  }),
      U = React.useCallback(function () {
    _.remove(L());
  }, [_]);

  React.useEffect(function () {
    return function () {
      U();
    };
  }, [U]), React.useEffect(function () {
    x ? F() : D && s || U();
  }, [x, U, D, s, F]);

  var G = _extends$d({}, e, {
    classes: o,
    closeAfterTransition: s,
    disableAutoFocus: p,
    disableEnforceFocus: g,
    disableEscapeKeyDown: m,
    disablePortal: f,
    disableRestoreFocus: h,
    disableScrollLock: b,
    exited: R,
    hideBackdrop: y,
    keepMounted: v
  }),
      q = useUtilityClasses$k(G);

  if (!v && !x && (!D || R)) return null;

  var H = function H() {
    A(!1), C && C();
  },
      z = function z() {
    A(!0), k && k(), s && U();
  },
      W = {};

  void 0 === a.props.tabIndex && (W.tabIndex = "-1"), D && (W.onEnter = createChainedFunction(H, a.props.onEnter), W.onExited = createChainedFunction(z, a.props.onExited));
  var V = c.Root || l,
      Y = u.root || {};
  return jsx$1(Portal, {
    ref: B,
    container: d,
    disablePortal: f,
    children: jsxs(V, _extends$d({
      role: "presentation"
    }, Y, !isHostComponent(V) && {
      as: l,
      ownerState: _extends$d({}, G, Y.ownerState),
      theme: w
    }, $, {
      ref: O,
      onKeyDown: function onKeyDown(e) {
        S && S(e), "Escape" === e.key && j() && (m || (e.stopPropagation(), E && E(e, "escapeKeyDown")));
      },
      className: clsx(q.root, Y.className, i),
      children: [!y && r ? jsx$1(r, _extends$d({
        open: x,
        onClick: function onClick(e) {
          e.target === e.currentTarget && (T && T(e), E && E(e, "backdropClick"));
        }
      }, n)) : null, jsx$1(Unstable_TrapFocus, {
        disableEnforceFocus: g,
        disableAutoFocus: p,
        disableRestoreFocus: h,
        isEnabled: j,
        open: x,
        children: React.cloneElement(a, W)
      })]
    }))
  });
});
/** @license MUI v5.4.4
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function styled$1(e, t) {
  var r = emStyled(e, t);
  return "production" !== process.env.NODE_ENV ? function () {
    var n = "string" == typeof e ? "\"".concat(e, "\"") : "component";

    for (var _len9 = arguments.length, t = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
      t[_key9] = arguments[_key9];
    }

    return 0 === t.length ? console.error(["MUI: Seems like you called `styled(".concat(n, ")()` without a `style` argument."), 'You must provide a `styles` argument: `styled("div")(styleYouForgotToPass)`.'].join("\n")) : t.some(function (e) {
      return void 0 === e;
    }) && console.error("MUI: the styled(".concat(n, ")(...args) API requires all its args to be defined.")), r.apply(void 0, t);
  } : r;
}

"production" !== process.env.NODE_ENV && (ModalUnstyled.propTypes = {
  BackdropComponent: PropTypes.elementType,
  BackdropProps: PropTypes.object,
  children: elementAcceptingRef$1.isRequired,
  classes: PropTypes.object,
  className: PropTypes.string,
  closeAfterTransition: PropTypes.bool,
  component: PropTypes.elementType,
  components: PropTypes.shape({
    Root: PropTypes.elementType
  }),
  componentsProps: PropTypes.shape({
    root: PropTypes.object
  }),
  container: PropTypes.oneOfType([HTMLElementType, PropTypes.func]),
  disableAutoFocus: PropTypes.bool,
  disableEnforceFocus: PropTypes.bool,
  disableEscapeKeyDown: PropTypes.bool,
  disablePortal: PropTypes.bool,
  disableRestoreFocus: PropTypes.bool,
  disableScrollLock: PropTypes.bool,
  hideBackdrop: PropTypes.bool,
  keepMounted: PropTypes.bool,
  onBackdropClick: PropTypes.func,
  onClose: PropTypes.func,
  onKeyDown: PropTypes.func,
  open: PropTypes.bool.isRequired
}), createCache({
  key: "css",
  prepend: !0
}), "production" !== process.env.NODE_ENV && (PropTypes.node, PropTypes.bool), "production" !== process.env.NODE_ENV && (PropTypes.object, PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.func]));
var responsivePropType = "production" !== process.env.NODE_ENV ? PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.object, PropTypes.array]) : {};

function _extends$b() {
  return _extends$b = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];

      for (var n in r) {
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
    }

    return e;
  }, _extends$b.apply(this, arguments);
}

function merge(e, t) {
  return t ? deepmerge(e, t, {
    clone: !1
  }) : e;
}

var values$1 = {
  xs: 0,
  sm: 600,
  md: 900,
  lg: 1200,
  xl: 1536
},
    defaultBreakpoints = {
  keys: ["xs", "sm", "md", "lg", "xl"],
  up: function up(e) {
    return "@media (min-width:".concat(values$1[e], "px)");
  }
};

function handleBreakpoints(e, t, r) {
  var n = e.theme || {};

  if (Array.isArray(t)) {
    var _e35 = n.breakpoints || defaultBreakpoints;

    return t.reduce(function (n, a, o) {
      return n[_e35.up(_e35.keys[o])] = r(t[o]), n;
    }, {});
  }

  if ("object" == typeof t) {
    var _e36 = n.breakpoints || defaultBreakpoints;

    return Object.keys(t).reduce(function (n, a) {
      if (-1 !== Object.keys(_e36.values || values$1).indexOf(a)) {
        n[_e36.up(a)] = r(t[a], a);
      } else {
        var _e37 = a;
        n[_e37] = t[_e37];
      }

      return n;
    }, {});
  }

  return r(t);
}

function createEmptyBreakpointObject() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var t;
  return (null == e || null == (t = e.keys) ? void 0 : t.reduce(function (t, r) {
    return t[e.up(r)] = {}, t;
  }, {})) || {};
}

function removeUnusedBreakpoints(e, t) {
  return e.reduce(function (e, t) {
    var r = e[t];
    return (!r || 0 === Object.keys(r).length) && delete e[t], e;
  }, t);
}

function computeBreakpointsBase(e, t) {
  if ("object" != typeof e) return {};
  var r = {},
      n = Object.keys(t);
  return Array.isArray(e) ? n.forEach(function (t, n) {
    n < e.length && (r[t] = !0);
  }) : n.forEach(function (t) {
    null != e[t] && (r[t] = !0);
  }), r;
}

function resolveBreakpointValues(_ref17) {
  var e = _ref17.values,
      t = _ref17.breakpoints,
      r = _ref17.base;
  var n = r || computeBreakpointsBase(e, t),
      a = Object.keys(n);
  if (0 === a.length) return e;
  var o;
  return a.reduce(function (t, r, n) {
    return Array.isArray(e) ? (t[r] = null != e[n] ? e[n] : e[o], o = n) : (t[r] = null != e[r] ? e[r] : e[o] || e, o = r), t;
  }, {});
}

function getPath(e, t) {
  return t && "string" == typeof t ? t.split(".").reduce(function (e, t) {
    return e && e[t] ? e[t] : null;
  }, e) : null;
}

function getValue$1(e, t, r) {
  var n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : r;
  var a;
  return a = "function" == typeof e ? e(r) : Array.isArray(e) ? e[r] || n : getPath(e, r) || n, t && (a = t(a)), a;
}

function style$1(e) {
  var t = e.prop,
      _e$cssProperty = e.cssProperty,
      r = _e$cssProperty === void 0 ? e.prop : _e$cssProperty,
      n = e.themeKey,
      a = e.transform,
      o = function o(e) {
    if (null == e[t]) return null;
    var o = e[t],
        i = getPath(e.theme, n) || {};
    return handleBreakpoints(e, o, function (e) {
      var n = getValue$1(i, a, e);
      return e === n && "string" == typeof e && (n = getValue$1(i, a, "".concat(t).concat("default" === e ? "" : capitalize(e)), e)), !1 === r ? n : _defineProperty2({}, r, n);
    });
  };

  return o.propTypes = "production" !== process.env.NODE_ENV ? _defineProperty2({}, t, responsivePropType) : {}, o.filterProps = [t], o;
}

function compose() {
  for (var _len10 = arguments.length, e = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
    e[_key10] = arguments[_key10];
  }

  var t = e.reduce(function (e, t) {
    return t.filterProps.forEach(function (r) {
      e[r] = t;
    }), e;
  }, {}),
      r = function r(e) {
    return Object.keys(e).reduce(function (r, n) {
      return t[n] ? merge(r, t[n](e)) : r;
    }, {});
  };

  return r.propTypes = "production" !== process.env.NODE_ENV ? e.reduce(function (e, t) {
    return Object.assign(e, t.propTypes);
  }, {}) : {}, r.filterProps = e.reduce(function (e, t) {
    return e.concat(t.filterProps);
  }, []), r;
}

function memoize(e) {
  var t = {};
  return function (r) {
    return void 0 === t[r] && (t[r] = e(r)), t[r];
  };
}

var properties = {
  m: "margin",
  p: "padding"
},
    directions = {
  t: "Top",
  r: "Right",
  b: "Bottom",
  l: "Left",
  x: ["Left", "Right"],
  y: ["Top", "Bottom"]
},
    aliases = {
  marginX: "mx",
  marginY: "my",
  paddingX: "px",
  paddingY: "py"
},
    getCssProperties = memoize(function (e) {
  if (e.length > 2) {
    if (!aliases[e]) return [e];
    e = aliases[e];
  }

  var _e$split5 = e.split(""),
      _e$split6 = _slicedToArray(_e$split5, 2),
      t = _e$split6[0],
      r = _e$split6[1],
      n = properties[t],
      a = directions[r] || "";

  return Array.isArray(a) ? a.map(function (e) {
    return n + e;
  }) : [n + a];
}),
    marginKeys = ["m", "mt", "mr", "mb", "ml", "mx", "my", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "marginInline", "marginInlineStart", "marginInlineEnd", "marginBlock", "marginBlockStart", "marginBlockEnd"],
    paddingKeys = ["p", "pt", "pr", "pb", "pl", "px", "py", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY", "paddingInline", "paddingInlineStart", "paddingInlineEnd", "paddingBlock", "paddingBlockStart", "paddingBlockEnd"],
    spacingKeys = [].concat(marginKeys, paddingKeys);

function createUnaryUnit(e, t, r, n) {
  var a = getPath(e, t) || r;
  return "number" == typeof a ? function (e) {
    return "string" == typeof e ? e : ("production" !== process.env.NODE_ENV && "number" != typeof e && console.error("MUI: Expected ".concat(n, " argument to be a number or a string, got ").concat(e, ".")), a * e);
  } : Array.isArray(a) ? function (e) {
    return "string" == typeof e ? e : ("production" !== process.env.NODE_ENV && (Number.isInteger(e) ? e > a.length - 1 && console.error(["MUI: The value provided (".concat(e, ") overflows."), "The supported values are: ".concat(JSON.stringify(a), "."), "".concat(e, " > ").concat(a.length - 1, ", you need to add the missing values.")].join("\n")) : console.error(["MUI: The `theme.".concat(t, "` array type cannot be combined with non integer values.You should either use an integer value that can be used as index, or define the `theme.").concat(t, "` as a number.")].join("\n"))), a[e]);
  } : "function" == typeof a ? a : ("production" !== process.env.NODE_ENV && console.error(["MUI: The `theme.".concat(t, "` value (").concat(a, ") is invalid."), "It should be a number, an array or a function."].join("\n")), function () {});
}

function createUnarySpacing(e) {
  return createUnaryUnit(e, "spacing", 8, "spacing");
}

function getValue(e, t) {
  if ("string" == typeof t || null == t) return t;
  var r = e(Math.abs(t));
  return t >= 0 ? r : "number" == typeof r ? -r : "-".concat(r);
}

function getStyleFromPropValue(e, t) {
  return function (r) {
    return e.reduce(function (e, n) {
      return e[n] = getValue(t, r), e;
    }, {});
  };
}

function resolveCssProperty(e, t, r, n) {
  if (-1 === t.indexOf(r)) return null;
  var a = getStyleFromPropValue(getCssProperties(r), n);
  return handleBreakpoints(e, e[r], a);
}

function style(e, t) {
  var r = createUnarySpacing(e.theme);
  return Object.keys(e).map(function (n) {
    return resolveCssProperty(e, t, n, r);
  }).reduce(merge, {});
}

function spacing(e) {
  return style(e, spacingKeys);
}

function getBorder(e) {
  return "number" != typeof e ? e : "".concat(e, "px solid");
}

"production" === process.env.NODE_ENV || marginKeys.reduce(function (e, t) {
  return e[t] = responsivePropType, e;
}, {}), "production" === process.env.NODE_ENV || paddingKeys.reduce(function (e, t) {
  return e[t] = responsivePropType, e;
}, {}), spacing.propTypes = "production" !== process.env.NODE_ENV ? spacingKeys.reduce(function (e, t) {
  return e[t] = responsivePropType, e;
}, {}) : {}, spacing.filterProps = spacingKeys;

var border = style$1({
  prop: "border",
  themeKey: "borders",
  transform: getBorder
}),
    borderTop = style$1({
  prop: "borderTop",
  themeKey: "borders",
  transform: getBorder
}),
    borderRight = style$1({
  prop: "borderRight",
  themeKey: "borders",
  transform: getBorder
}),
    borderBottom = style$1({
  prop: "borderBottom",
  themeKey: "borders",
  transform: getBorder
}),
    borderLeft = style$1({
  prop: "borderLeft",
  themeKey: "borders",
  transform: getBorder
}),
    borderColor = style$1({
  prop: "borderColor",
  themeKey: "palette"
}),
    borderTopColor = style$1({
  prop: "borderTopColor",
  themeKey: "palette"
}),
    borderRightColor = style$1({
  prop: "borderRightColor",
  themeKey: "palette"
}),
    borderBottomColor = style$1({
  prop: "borderBottomColor",
  themeKey: "palette"
}),
    borderLeftColor = style$1({
  prop: "borderLeftColor",
  themeKey: "palette"
}),
    borderRadius = function borderRadius(e) {
  if (void 0 !== e.borderRadius && null !== e.borderRadius) {
    var _t23 = createUnaryUnit(e.theme, "shape.borderRadius", 4, "borderRadius"),
        _r18 = function _r18(e) {
      return {
        borderRadius: getValue(_t23, e)
      };
    };

    return handleBreakpoints(e, e.borderRadius, _r18);
  }

  return null;
};

borderRadius.propTypes = "production" !== process.env.NODE_ENV ? {
  borderRadius: responsivePropType
} : {}, borderRadius.filterProps = ["borderRadius"];
var borders = compose(border, borderTop, borderRight, borderBottom, borderLeft, borderColor, borderTopColor, borderRightColor, borderBottomColor, borderLeftColor, borderRadius),
    displayPrint = style$1({
  prop: "displayPrint",
  cssProperty: !1,
  transform: function transform(e) {
    return {
      "@media print": {
        display: e
      }
    };
  }
}),
    displayRaw = style$1({
  prop: "display"
}),
    overflow = style$1({
  prop: "overflow"
}),
    textOverflow = style$1({
  prop: "textOverflow"
}),
    visibility = style$1({
  prop: "visibility"
}),
    whiteSpace = style$1({
  prop: "whiteSpace"
});
var display = compose(displayPrint, displayRaw, overflow, textOverflow, visibility, whiteSpace);

var flexBasis = style$1({
  prop: "flexBasis"
}),
    flexDirection = style$1({
  prop: "flexDirection"
}),
    flexWrap = style$1({
  prop: "flexWrap"
}),
    justifyContent = style$1({
  prop: "justifyContent"
}),
    alignItems = style$1({
  prop: "alignItems"
}),
    alignContent$1 = style$1({
  prop: "alignContent"
}),
    order = style$1({
  prop: "order"
}),
    flex = style$1({
  prop: "flex"
}),
    flexGrow = style$1({
  prop: "flexGrow"
}),
    flexShrink = style$1({
  prop: "flexShrink"
}),
    alignSelf = style$1({
  prop: "alignSelf"
}),
    justifyItems = style$1({
  prop: "justifyItems"
}),
    justifySelf = style$1({
  prop: "justifySelf"
}),
    flexbox = compose(flexBasis, flexDirection, flexWrap, justifyContent, alignItems, alignContent$1, order, flex, flexGrow, flexShrink, alignSelf, justifyItems, justifySelf),
    gap = function gap(e) {
  if (void 0 !== e.gap && null !== e.gap) {
    var _t24 = createUnaryUnit(e.theme, "spacing", 8, "gap"),
        _r19 = function _r19(e) {
      return {
        gap: getValue(_t24, e)
      };
    };

    return handleBreakpoints(e, e.gap, _r19);
  }

  return null;
};

gap.propTypes = "production" !== process.env.NODE_ENV ? {
  gap: responsivePropType
} : {}, gap.filterProps = ["gap"];

var columnGap = function columnGap(e) {
  if (void 0 !== e.columnGap && null !== e.columnGap) {
    var _t25 = createUnaryUnit(e.theme, "spacing", 8, "columnGap"),
        _r20 = function _r20(e) {
      return {
        columnGap: getValue(_t25, e)
      };
    };

    return handleBreakpoints(e, e.columnGap, _r20);
  }

  return null;
};

columnGap.propTypes = "production" !== process.env.NODE_ENV ? {
  columnGap: responsivePropType
} : {}, columnGap.filterProps = ["columnGap"];

var rowGap = function rowGap(e) {
  if (void 0 !== e.rowGap && null !== e.rowGap) {
    var _t26 = createUnaryUnit(e.theme, "spacing", 8, "rowGap"),
        _r21 = function _r21(e) {
      return {
        rowGap: getValue(_t26, e)
      };
    };

    return handleBreakpoints(e, e.rowGap, _r21);
  }

  return null;
};

rowGap.propTypes = "production" !== process.env.NODE_ENV ? {
  rowGap: responsivePropType
} : {}, rowGap.filterProps = ["rowGap"];
var gridColumn = style$1({
  prop: "gridColumn"
}),
    gridRow = style$1({
  prop: "gridRow"
}),
    gridAutoFlow = style$1({
  prop: "gridAutoFlow"
}),
    gridAutoColumns = style$1({
  prop: "gridAutoColumns"
}),
    gridAutoRows = style$1({
  prop: "gridAutoRows"
}),
    gridTemplateColumns = style$1({
  prop: "gridTemplateColumns"
}),
    gridTemplateRows = style$1({
  prop: "gridTemplateRows"
}),
    gridTemplateAreas = style$1({
  prop: "gridTemplateAreas"
}),
    gridArea = style$1({
  prop: "gridArea"
}),
    grid = compose(gap, columnGap, rowGap, gridColumn, gridRow, gridAutoFlow, gridAutoColumns, gridAutoRows, gridTemplateColumns, gridTemplateRows, gridTemplateAreas, gridArea),
    color = style$1({
  prop: "color",
  themeKey: "palette"
}),
    bgcolor = style$1({
  prop: "bgcolor",
  cssProperty: "backgroundColor",
  themeKey: "palette"
}),
    backgroundColor = style$1({
  prop: "backgroundColor",
  themeKey: "palette"
}),
    palette = compose(color, bgcolor, backgroundColor),
    position = style$1({
  prop: "position"
}),
    zIndex$1 = style$1({
  prop: "zIndex",
  themeKey: "zIndex"
}),
    top = style$1({
  prop: "top"
}),
    right = style$1({
  prop: "right"
}),
    bottom = style$1({
  prop: "bottom"
}),
    left = style$1({
  prop: "left"
});
var positions = compose(position, zIndex$1, top, right, bottom, left);
var boxShadow = style$1({
  prop: "boxShadow",
  themeKey: "shadows"
});

function transform(e) {
  return e <= 1 && 0 !== e ? 100 * e + "%" : e;
}

var width = style$1({
  prop: "width",
  transform: transform
}),
    maxWidth = function maxWidth(e) {
  if (void 0 !== e.maxWidth && null !== e.maxWidth) {
    var _t27 = function _t27(t) {
      var r, n, a;
      return {
        maxWidth: (null == (r = e.theme) || null == (n = r.breakpoints) || null == (a = n.values) ? void 0 : a[t]) || values$1[t] || transform(t)
      };
    };

    return handleBreakpoints(e, e.maxWidth, _t27);
  }

  return null;
};

maxWidth.filterProps = ["maxWidth"];
var minWidth = style$1({
  prop: "minWidth",
  transform: transform
}),
    height = style$1({
  prop: "height",
  transform: transform
}),
    maxHeight = style$1({
  prop: "maxHeight",
  transform: transform
}),
    minHeight = style$1({
  prop: "minHeight",
  transform: transform
});
style$1({
  prop: "size",
  cssProperty: "width",
  transform: transform
}), style$1({
  prop: "size",
  cssProperty: "height",
  transform: transform
});
var boxSizing = style$1({
  prop: "boxSizing"
}),
    sizing = compose(width, maxWidth, minWidth, height, maxHeight, minHeight, boxSizing),
    fontFamily = style$1({
  prop: "fontFamily",
  themeKey: "typography"
}),
    fontSize = style$1({
  prop: "fontSize",
  themeKey: "typography"
}),
    fontStyle = style$1({
  prop: "fontStyle",
  themeKey: "typography"
}),
    fontWeight = style$1({
  prop: "fontWeight",
  themeKey: "typography"
}),
    letterSpacing = style$1({
  prop: "letterSpacing"
}),
    textTransform = style$1({
  prop: "textTransform"
}),
    lineHeight = style$1({
  prop: "lineHeight"
}),
    textAlign = style$1({
  prop: "textAlign"
}),
    typographyVariant = style$1({
  prop: "typography",
  cssProperty: !1,
  themeKey: "typography"
}),
    typography = compose(typographyVariant, fontFamily, fontSize, fontStyle, fontWeight, letterSpacing, lineHeight, textAlign, textTransform),
    filterPropsMapping = {
  borders: borders.filterProps,
  display: display.filterProps,
  flexbox: flexbox.filterProps,
  grid: grid.filterProps,
  positions: positions.filterProps,
  palette: palette.filterProps,
  shadows: boxShadow.filterProps,
  sizing: sizing.filterProps,
  spacing: spacing.filterProps,
  typography: typography.filterProps
},
    styleFunctionMapping = {
  borders: borders,
  display: display,
  flexbox: flexbox,
  grid: grid,
  positions: positions,
  palette: palette,
  shadows: boxShadow,
  sizing: sizing,
  spacing: spacing,
  typography: typography
},
    propToStyleFunction = Object.keys(filterPropsMapping).reduce(function (e, t) {
  return filterPropsMapping[t].forEach(function (r) {
    e[r] = styleFunctionMapping[t];
  }), e;
}, {});

function objectsHaveSameKeys() {
  for (var _len11 = arguments.length, e = new Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
    e[_key11] = arguments[_key11];
  }

  var t = e.reduce(function (e, t) {
    return e.concat(Object.keys(t));
  }, []),
      r = new Set(t);
  return e.every(function (e) {
    return r.size === Object.keys(e).length;
  });
}

function callIfFn(e, t) {
  return "function" == typeof e ? e(t) : e;
}

function unstable_createStyleFunctionSx() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : styleFunctionMapping;
  var t = Object.keys(e).reduce(function (t, r) {
    return e[r].filterProps.forEach(function (n) {
      t[n] = e[r];
    }), t;
  }, {});

  function r(e, r, n) {
    var _a10;

    var a = (_a10 = {}, _defineProperty2(_a10, e, r), _defineProperty2(_a10, "theme", n), _a10),
        o = t[e];
    return o ? o(a) : _defineProperty2({}, e, r);
  }

  return function e(n) {
    var _ref21 = n || {},
        a = _ref21.sx,
        _ref21$theme = _ref21.theme,
        o = _ref21$theme === void 0 ? {} : _ref21$theme;

    if (!a) return null;

    function i(n) {
      var a = n;
      if ("function" == typeof n) a = n(o);else if ("object" != typeof n) return n;
      if (!a) return null;
      var i = createEmptyBreakpointObject(o.breakpoints),
          s = Object.keys(i);
      var l = i;
      return Object.keys(a).forEach(function (n) {
        var i = callIfFn(a[n], o);
        if (null != i) if ("object" == typeof i) {
          if (t[n]) l = merge(l, r(n, i, o));else {
            var _t28 = handleBreakpoints({
              theme: o
            }, i, function (e) {
              return _defineProperty2({}, n, e);
            });

            objectsHaveSameKeys(_t28, i) ? l[n] = e({
              sx: i,
              theme: o
            }) : l = merge(l, _t28);
          }
        } else l = merge(l, r(n, i, o));
      }), removeUnusedBreakpoints(s, l);
    }

    return Array.isArray(a) ? a.map(i) : i(a);
  };
}

var styleFunctionSx = unstable_createStyleFunctionSx();
styleFunctionSx.filterProps = ["sx"];
var defaultStyleFunctionSx = styleFunctionSx;

function _objectWithoutPropertiesLoose$2(e, t) {
  if (null == e) return {};
  var r,
      n,
      a = {},
      o = Object.keys(e);

  for (n = 0; n < o.length; n++) {
    r = o[n], t.indexOf(r) >= 0 || (a[r] = e[r]);
  }

  return a;
}

var _excluded$E = ["sx"],
    splitProps = function splitProps(e) {
  var t = {
    systemProps: {},
    otherProps: {}
  };
  return Object.keys(e).forEach(function (r) {
    propToStyleFunction[r] ? t.systemProps[r] = e[r] : t.otherProps[r] = e[r];
  }), t;
};

function extendSxProp(e) {
  var t = e.sx,
      r = _objectWithoutPropertiesLoose$2(e, _excluded$E),
      _splitProps = splitProps(r),
      n = _splitProps.systemProps,
      a = _splitProps.otherProps;

  var o;
  return o = Array.isArray(t) ? [n].concat(_toConsumableArray(t)) : "function" == typeof t ? function () {
    var r = t.apply(void 0, arguments);
    return isPlainObject(r) ? _extends$b({}, n, r) : n;
  } : _extends$b({}, n, t), _extends$b({}, a, {
    sx: o
  });
}

var _excluded$D = ["values", "unit", "step"],
    sortBreakpointsValues = function sortBreakpointsValues(e) {
  var t = Object.keys(e).map(function (t) {
    return {
      key: t,
      val: e[t]
    };
  }) || [];
  return t.sort(function (e, t) {
    return e.val - t.val;
  }), t.reduce(function (e, t) {
    return _extends$b({}, e, _defineProperty2({}, t.key, t.val));
  }, {});
};

function createBreakpoints(e) {
  var _e$values = e.values,
      t = _e$values === void 0 ? {
    xs: 0,
    sm: 600,
    md: 900,
    lg: 1200,
    xl: 1536
  } : _e$values,
      _e$unit = e.unit,
      r = _e$unit === void 0 ? "px" : _e$unit,
      _e$step = e.step,
      n = _e$step === void 0 ? 5 : _e$step,
      a = _objectWithoutPropertiesLoose$2(e, _excluded$D),
      o = sortBreakpointsValues(t),
      i = Object.keys(o);

  function s(e) {
    return "@media (min-width:".concat("number" == typeof t[e] ? t[e] : e).concat(r, ")");
  }

  function l(e) {
    return "@media (max-width:".concat(("number" == typeof t[e] ? t[e] : e) - n / 100).concat(r, ")");
  }

  function c(e, a) {
    var o = i.indexOf(a);
    return "@media (min-width:".concat("number" == typeof t[e] ? t[e] : e).concat(r, ") and (max-width:").concat((-1 !== o && "number" == typeof t[i[o]] ? t[i[o]] : a) - n / 100).concat(r, ")");
  }

  return _extends$b({
    keys: i,
    values: o,
    up: s,
    down: l,
    between: c,
    only: function only(e) {
      return i.indexOf(e) + 1 < i.length ? c(e, i[i.indexOf(e) + 1]) : s(e);
    },
    not: function not(e) {
      var t = i.indexOf(e);
      return 0 === t ? s(i[1]) : t === i.length - 1 ? l(i[t]) : c(e, i[i.indexOf(e) + 1]).replace("@media", "@media not all and");
    },
    unit: r
  }, a);
}

var shape = {
  borderRadius: 4
};

function createSpacing() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8;
  if (e.mui) return e;

  var t = createUnarySpacing({
    spacing: e
  }),
      r = function r() {
    for (var _len12 = arguments.length, e = new Array(_len12), _key12 = 0; _key12 < _len12; _key12++) {
      e[_key12] = arguments[_key12];
    }

    "production" !== process.env.NODE_ENV && (e.length <= 4 || console.error("MUI: Too many arguments provided, expected between 0 and 4, got ".concat(e.length)));
    return (0 === e.length ? [1] : e).map(function (e) {
      var r = t(e);
      return "number" == typeof r ? "".concat(r, "px") : r;
    }).join(" ");
  };

  return r.mui = !0, r;
}

var _excluded$C = ["breakpoints", "palette", "spacing", "shape"];

function createTheme$1() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _e$breakpoints = e.breakpoints,
      r = _e$breakpoints === void 0 ? {} : _e$breakpoints,
      _e$palette = e.palette,
      n = _e$palette === void 0 ? {} : _e$palette,
      a = e.spacing,
      _e$shape = e.shape,
      o = _e$shape === void 0 ? {} : _e$shape,
      i = _objectWithoutPropertiesLoose$2(e, _excluded$C),
      s = createBreakpoints(r),
      l = createSpacing(a);

  var c = deepmerge({
    breakpoints: s,
    direction: "ltr",
    components: {},
    palette: _extends$b({
      mode: "light"
    }, n),
    spacing: l,
    shape: _extends$b({}, shape, o)
  }, i);

  for (var _len13 = arguments.length, t = new Array(_len13 > 1 ? _len13 - 1 : 0), _key13 = 1; _key13 < _len13; _key13++) {
    t[_key13 - 1] = arguments[_key13];
  }

  return c = t.reduce(function (e, t) {
    return deepmerge(e, t);
  }, c), c;
}

var ThemeContext = React.createContext(null);
"production" !== process.env.NODE_ENV && (ThemeContext.displayName = "ThemeContext");
var ThemeContext$1 = ThemeContext;

function useTheme$3() {
  var e = React.useContext(ThemeContext$1);
  return "production" !== process.env.NODE_ENV && React.useDebugValue(e), e;
}

function isObjectEmpty(e) {
  return 0 === Object.keys(e).length;
}

function useTheme$2() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var t = useTheme$3();
  return !t || isObjectEmpty(t) ? e : t;
}

var systemDefaultTheme$1 = createTheme$1();

function useTheme$1() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : systemDefaultTheme$1;
  return useTheme$2(e);
}

var _excluded$B = ["variant"];

function isEmpty$1(e) {
  return 0 === e.length;
}

function propsToClassKey(e) {
  var t = e.variant,
      r = _objectWithoutPropertiesLoose$2(e, _excluded$B);

  var n = t || "";
  return Object.keys(r).sort().forEach(function (t) {
    n += "color" === t ? isEmpty$1(n) ? e[t] : capitalize(e[t]) : "".concat(isEmpty$1(n) ? t : capitalize(t)).concat(capitalize(e[t].toString()));
  }), n;
}

var _excluded$A = ["name", "slot", "skipVariantsResolver", "skipSx", "overridesResolver"],
    _excluded2$1 = ["theme"],
    _excluded3 = ["theme"];

function isEmpty(e) {
  return 0 === Object.keys(e).length;
}

var getStyleOverrides = function getStyleOverrides(e, t) {
  return t.components && t.components[e] && t.components[e].styleOverrides ? t.components[e].styleOverrides : null;
},
    getVariantStyles = function getVariantStyles(e, t) {
  var r = [];
  t && t.components && t.components[e] && t.components[e].variants && (r = t.components[e].variants);
  var n = {};
  return r.forEach(function (e) {
    var t = propsToClassKey(e.props);
    n[t] = e.style;
  }), n;
},
    variantsResolver = function variantsResolver(e, t, r, n) {
  var a, o;
  var _e$ownerState = e.ownerState,
      i = _e$ownerState === void 0 ? {} : _e$ownerState,
      s = [],
      l = null == r || null == (a = r.components) || null == (o = a[n]) ? void 0 : o.variants;
  return l && l.forEach(function (r) {
    var n = !0;
    Object.keys(r.props).forEach(function (t) {
      i[t] !== r.props[t] && e[t] !== r.props[t] && (n = !1);
    }), n && s.push(t[propsToClassKey(r.props)]);
  }), s;
};

function shouldForwardProp(e) {
  return "ownerState" !== e && "theme" !== e && "sx" !== e && "as" !== e;
}

var systemDefaultTheme = createTheme$1(),
    lowercaseFirstLetter = function lowercaseFirstLetter(e) {
  return e.charAt(0).toLowerCase() + e.slice(1);
};

function createStyled() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _e$defaultTheme = e.defaultTheme,
      t = _e$defaultTheme === void 0 ? systemDefaultTheme : _e$defaultTheme,
      _e$rootShouldForwardP = e.rootShouldForwardProp,
      r = _e$rootShouldForwardP === void 0 ? shouldForwardProp : _e$rootShouldForwardP,
      _e$slotShouldForwardP = e.slotShouldForwardProp,
      n = _e$slotShouldForwardP === void 0 ? shouldForwardProp : _e$slotShouldForwardP,
      _e$styleFunctionSx = e.styleFunctionSx,
      a = _e$styleFunctionSx === void 0 ? defaultStyleFunctionSx : _e$styleFunctionSx;
  return function (e) {
    var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var i = o.name,
        s = o.slot,
        l = o.skipVariantsResolver,
        c = o.skipSx,
        u = o.overridesResolver,
        d = _objectWithoutPropertiesLoose$2(o, _excluded$A),
        p = void 0 !== l ? l : s && "Root" !== s || !1,
        g = c || !1;

    var m;
    "production" !== process.env.NODE_ENV && i && (m = "".concat(i, "-").concat(lowercaseFirstLetter(s || "Root")));
    var f = shouldForwardProp;
    "Root" === s ? f = r : s && (f = n);

    var h = styled$1(e, _extends$b({
      shouldForwardProp: f,
      label: m
    }, d)),
        b = function b(r) {
      for (var _len14 = arguments.length, n = new Array(_len14 > 1 ? _len14 - 1 : 0), _key14 = 1; _key14 < _len14; _key14++) {
        n[_key14 - 1] = arguments[_key14];
      }

      var o = n ? n.map(function (e) {
        return "function" == typeof e && e.__emotion_real !== e ? function (r) {
          var n = r.theme,
              a = _objectWithoutPropertiesLoose$2(r, _excluded2$1);

          return e(_extends$b({
            theme: isEmpty(n) ? t : n
          }, a));
        } : e;
      }) : [];
      var l = r;
      i && u && o.push(function (e) {
        var r = isEmpty(e.theme) ? t : e.theme,
            n = getStyleOverrides(i, r);

        if (n) {
          var _t29 = {};
          return Object.entries(n).forEach(function (_ref23) {
            var _ref24 = _slicedToArray(_ref23, 2),
                r = _ref24[0],
                n = _ref24[1];

            _t29[r] = "function" == typeof n ? n(e) : n;
          }), u(e, _t29);
        }

        return null;
      }), i && !p && o.push(function (e) {
        var r = isEmpty(e.theme) ? t : e.theme;
        return variantsResolver(e, getVariantStyles(i, r), r, i);
      }), g || o.push(function (e) {
        var r = isEmpty(e.theme) ? t : e.theme;
        return a(_extends$b({}, e, {
          theme: r
        }));
      });
      var c = o.length - n.length;

      if (Array.isArray(r) && c > 0) {
        var _e38 = new Array(c).fill("");

        l = [].concat(_toConsumableArray(r), _toConsumableArray(_e38)), l.raw = [].concat(_toConsumableArray(r.raw), _toConsumableArray(_e38));
      } else "function" == typeof r && r.__emotion_real !== r && (l = function l(e) {
        var n = e.theme,
            a = _objectWithoutPropertiesLoose$2(e, _excluded3);

        return r(_extends$b({
          theme: isEmpty(n) ? t : n
        }, a));
      });

      var d = h.apply(void 0, [l].concat(_toConsumableArray(o)));

      if ("production" !== process.env.NODE_ENV) {
        var _t30;

        i && (_t30 = "".concat(i).concat(s || "")), void 0 === _t30 && (_t30 = "Styled(".concat(getDisplayName(e), ")")), d.displayName = _t30;
      }

      return d;
    };

    return h.withConfig && (b.withConfig = h.withConfig), b;
  };
}

function getThemeProps(e) {
  var t = e.theme,
      r = e.name,
      n = e.props;
  return t && t.components && t.components[r] && t.components[r].defaultProps ? resolveProps(t.components[r].defaultProps, n) : n;
}

function useThemeProps$1(_ref25) {
  var e = _ref25.props,
      t = _ref25.name,
      r = _ref25.defaultTheme;
  return getThemeProps({
    theme: useTheme$1(r),
    name: t,
    props: e
  });
}

function clamp(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  return "production" !== process.env.NODE_ENV && (e < t || e > r) && console.error("MUI: The value provided ".concat(e, " is out of range [").concat(t, ", ").concat(r, "].")), Math.min(Math.max(t, e), r);
}

function hexToRgb(e) {
  e = e.substr(1);
  var t = new RegExp(".{1,".concat(e.length >= 6 ? 2 : 1, "}"), "g");
  var r = e.match(t);
  return r && 1 === r[0].length && (r = r.map(function (e) {
    return e + e;
  })), r ? "rgb".concat(4 === r.length ? "a" : "", "(").concat(r.map(function (e, t) {
    return t < 3 ? parseInt(e, 16) : Math.round(parseInt(e, 16) / 255 * 1e3) / 1e3;
  }).join(", "), ")") : "";
}

function decomposeColor(e) {
  if (e.type) return e;
  if ("#" === e.charAt(0)) return decomposeColor(hexToRgb(e));
  var t = e.indexOf("("),
      r = e.substring(0, t);
  if (-1 === ["rgb", "rgba", "hsl", "hsla", "color"].indexOf(r)) throw new Error("production" !== process.env.NODE_ENV ? "MUI: Unsupported `".concat(e, "` color.\nThe following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().") : formatMuiErrorMessage(9, e));
  var n,
      a = e.substring(t + 1, e.length - 1);

  if ("color" === r) {
    if (a = a.split(" "), n = a.shift(), 4 === a.length && "/" === a[3].charAt(0) && (a[3] = a[3].substr(1)), -1 === ["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].indexOf(n)) throw new Error("production" !== process.env.NODE_ENV ? "MUI: unsupported `".concat(n, "` color space.\nThe following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020.") : formatMuiErrorMessage(10, n));
  } else a = a.split(",");

  return a = a.map(function (e) {
    return parseFloat(e);
  }), {
    type: r,
    values: a,
    colorSpace: n
  };
}

function recomposeColor(e) {
  var t = e.type,
      r = e.colorSpace;
  var n = e.values;
  return -1 !== t.indexOf("rgb") ? n = n.map(function (e, t) {
    return t < 3 ? parseInt(e, 10) : e;
  }) : -1 !== t.indexOf("hsl") && (n[1] = "".concat(n[1], "%"), n[2] = "".concat(n[2], "%")), n = -1 !== t.indexOf("color") ? "".concat(r, " ").concat(n.join(" ")) : "".concat(n.join(", ")), "".concat(t, "(").concat(n, ")");
}

function hslToRgb(e) {
  e = decomposeColor(e);

  var _e39 = e,
      t = _e39.values,
      r = t[0],
      n = t[1] / 100,
      a = t[2] / 100,
      o = n * Math.min(a, 1 - a),
      i = function i(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (e + r / 30) % 12;
    return a - o * Math.max(Math.min(t - 3, 9 - t, 1), -1);
  };

  var s = "rgb";
  var l = [Math.round(255 * i(0)), Math.round(255 * i(8)), Math.round(255 * i(4))];
  return "hsla" === e.type && (s += "a", l.push(t[3])), recomposeColor({
    type: s,
    values: l
  });
}

function getLuminance(e) {
  var t = "hsl" === (e = decomposeColor(e)).type ? decomposeColor(hslToRgb(e)).values : e.values;
  return t = t.map(function (t) {
    return "color" !== e.type && (t /= 255), t <= .03928 ? t / 12.92 : Math.pow((t + .055) / 1.055, 2.4);
  }), Number((.2126 * t[0] + .7152 * t[1] + .0722 * t[2]).toFixed(3));
}

function getContrastRatio(e, t) {
  var r = getLuminance(e),
      n = getLuminance(t);
  return (Math.max(r, n) + .05) / (Math.min(r, n) + .05);
}

function alpha(e, t) {
  return e = decomposeColor(e), t = clamp(t), "rgb" !== e.type && "hsl" !== e.type || (e.type += "a"), "color" === e.type ? e.values[3] = "/".concat(t) : e.values[3] = t, recomposeColor(e);
}

function darken(e, t) {
  if (e = decomposeColor(e), t = clamp(t), -1 !== e.type.indexOf("hsl")) e.values[2] *= 1 - t;else if (-1 !== e.type.indexOf("rgb") || -1 !== e.type.indexOf("color")) for (var _r22 = 0; _r22 < 3; _r22 += 1) {
    e.values[_r22] *= 1 - t;
  }
  return recomposeColor(e);
}

function lighten(e, t) {
  if (e = decomposeColor(e), t = clamp(t), -1 !== e.type.indexOf("hsl")) e.values[2] += (100 - e.values[2]) * t;else if (-1 !== e.type.indexOf("rgb")) for (var _r23 = 0; _r23 < 3; _r23 += 1) {
    e.values[_r23] += (255 - e.values[_r23]) * t;
  } else if (-1 !== e.type.indexOf("color")) for (var _r24 = 0; _r24 < 3; _r24 += 1) {
    e.values[_r24] += (1 - e.values[_r24]) * t;
  }
  return recomposeColor(e);
}

function createMixins(e, t, r) {
  var _toolbar;

  return _extends$e({
    toolbar: (_toolbar = {
      minHeight: 56
    }, _defineProperty2(_toolbar, "".concat(e.up("xs"), " and (orientation: landscape)"), {
      minHeight: 48
    }), _defineProperty2(_toolbar, e.up("sm"), {
      minHeight: 64
    }), _toolbar)
  }, r);
}

var common = {
  black: "#000",
  white: "#fff"
},
    grey = {
  50: "#fafafa",
  100: "#f5f5f5",
  200: "#eeeeee",
  300: "#e0e0e0",
  400: "#bdbdbd",
  500: "#9e9e9e",
  600: "#757575",
  700: "#616161",
  800: "#424242",
  900: "#212121",
  A100: "#f5f5f5",
  A200: "#eeeeee",
  A400: "#bdbdbd",
  A700: "#616161"
},
    purple = {
  50: "#f3e5f5",
  100: "#e1bee7",
  200: "#ce93d8",
  300: "#ba68c8",
  400: "#ab47bc",
  500: "#9c27b0",
  600: "#8e24aa",
  700: "#7b1fa2",
  800: "#6a1b9a",
  900: "#4a148c",
  A100: "#ea80fc",
  A200: "#e040fb",
  A400: "#d500f9",
  A700: "#aa00ff"
},
    red = {
  50: "#ffebee",
  100: "#ffcdd2",
  200: "#ef9a9a",
  300: "#e57373",
  400: "#ef5350",
  500: "#f44336",
  600: "#e53935",
  700: "#d32f2f",
  800: "#c62828",
  900: "#b71c1c",
  A100: "#ff8a80",
  A200: "#ff5252",
  A400: "#ff1744",
  A700: "#d50000"
};
var red$1 = red;
var orange = {
  50: "#fff3e0",
  100: "#ffe0b2",
  200: "#ffcc80",
  300: "#ffb74d",
  400: "#ffa726",
  500: "#ff9800",
  600: "#fb8c00",
  700: "#f57c00",
  800: "#ef6c00",
  900: "#e65100",
  A100: "#ffd180",
  A200: "#ffab40",
  A400: "#ff9100",
  A700: "#ff6d00"
},
    blue = {
  50: "#e3f2fd",
  100: "#bbdefb",
  200: "#90caf9",
  300: "#64b5f6",
  400: "#42a5f5",
  500: "#2196f3",
  600: "#1e88e5",
  700: "#1976d2",
  800: "#1565c0",
  900: "#0d47a1",
  A100: "#82b1ff",
  A200: "#448aff",
  A400: "#2979ff",
  A700: "#2962ff"
},
    lightBlue = {
  50: "#e1f5fe",
  100: "#b3e5fc",
  200: "#81d4fa",
  300: "#4fc3f7",
  400: "#29b6f6",
  500: "#03a9f4",
  600: "#039be5",
  700: "#0288d1",
  800: "#0277bd",
  900: "#01579b",
  A100: "#80d8ff",
  A200: "#40c4ff",
  A400: "#00b0ff",
  A700: "#0091ea"
},
    green = {
  50: "#e8f5e9",
  100: "#c8e6c9",
  200: "#a5d6a7",
  300: "#81c784",
  400: "#66bb6a",
  500: "#4caf50",
  600: "#43a047",
  700: "#388e3c",
  800: "#2e7d32",
  900: "#1b5e20",
  A100: "#b9f6ca",
  A200: "#69f0ae",
  A400: "#00e676",
  A700: "#00c853"
},
    _excluded$z = ["mode", "contrastThreshold", "tonalOffset"],
    light = {
  text: {
    primary: "rgba(0, 0, 0, 0.87)",
    secondary: "rgba(0, 0, 0, 0.6)",
    disabled: "rgba(0, 0, 0, 0.38)"
  },
  divider: "rgba(0, 0, 0, 0.12)",
  background: {
    paper: common.white,
    default: common.white
  },
  action: {
    active: "rgba(0, 0, 0, 0.54)",
    hover: "rgba(0, 0, 0, 0.04)",
    hoverOpacity: .04,
    selected: "rgba(0, 0, 0, 0.08)",
    selectedOpacity: .08,
    disabled: "rgba(0, 0, 0, 0.26)",
    disabledBackground: "rgba(0, 0, 0, 0.12)",
    disabledOpacity: .38,
    focus: "rgba(0, 0, 0, 0.12)",
    focusOpacity: .12,
    activatedOpacity: .12
  }
},
    dark = {
  text: {
    primary: common.white,
    secondary: "rgba(255, 255, 255, 0.7)",
    disabled: "rgba(255, 255, 255, 0.5)",
    icon: "rgba(255, 255, 255, 0.5)"
  },
  divider: "rgba(255, 255, 255, 0.12)",
  background: {
    paper: "#121212",
    default: "#121212"
  },
  action: {
    active: common.white,
    hover: "rgba(255, 255, 255, 0.08)",
    hoverOpacity: .08,
    selected: "rgba(255, 255, 255, 0.16)",
    selectedOpacity: .16,
    disabled: "rgba(255, 255, 255, 0.3)",
    disabledBackground: "rgba(255, 255, 255, 0.12)",
    disabledOpacity: .38,
    focus: "rgba(255, 255, 255, 0.12)",
    focusOpacity: .12,
    activatedOpacity: .24
  }
};

function addLightOrDark(e, t, r, n) {
  var a = n.light || n,
      o = n.dark || 1.5 * n;
  e[t] || (e.hasOwnProperty(r) ? e[t] = e[r] : "light" === t ? e.light = lighten(e.main, a) : "dark" === t && (e.dark = darken(e.main, o)));
}

function getDefaultPrimary() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "light";
  return "dark" === e ? {
    main: blue[200],
    light: blue[50],
    dark: blue[400]
  } : {
    main: blue[700],
    light: blue[400],
    dark: blue[800]
  };
}

function getDefaultSecondary() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "light";
  return "dark" === e ? {
    main: purple[200],
    light: purple[50],
    dark: purple[400]
  } : {
    main: purple[500],
    light: purple[300],
    dark: purple[700]
  };
}

function getDefaultError() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "light";
  return "dark" === e ? {
    main: red$1[500],
    light: red$1[300],
    dark: red$1[700]
  } : {
    main: red$1[700],
    light: red$1[400],
    dark: red$1[800]
  };
}

function getDefaultInfo() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "light";
  return "dark" === e ? {
    main: lightBlue[400],
    light: lightBlue[300],
    dark: lightBlue[700]
  } : {
    main: lightBlue[700],
    light: lightBlue[500],
    dark: lightBlue[900]
  };
}

function getDefaultSuccess() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "light";
  return "dark" === e ? {
    main: green[400],
    light: green[300],
    dark: green[700]
  } : {
    main: green[800],
    light: green[500],
    dark: green[900]
  };
}

function getDefaultWarning() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "light";
  return "dark" === e ? {
    main: orange[400],
    light: orange[300],
    dark: orange[700]
  } : {
    main: "#ed6c02",
    light: orange[500],
    dark: orange[900]
  };
}

function createPalette(e) {
  var _e$mode = e.mode,
      t = _e$mode === void 0 ? "light" : _e$mode,
      _e$contrastThreshold = e.contrastThreshold,
      r = _e$contrastThreshold === void 0 ? 3 : _e$contrastThreshold,
      _e$tonalOffset = e.tonalOffset,
      n = _e$tonalOffset === void 0 ? .2 : _e$tonalOffset,
      a = _objectWithoutPropertiesLoose$4(e, _excluded$z),
      o = e.primary || getDefaultPrimary(t),
      i = e.secondary || getDefaultSecondary(t),
      s = e.error || getDefaultError(t),
      l = e.info || getDefaultInfo(t),
      c = e.success || getDefaultSuccess(t),
      u = e.warning || getDefaultWarning(t);

  function d(e) {
    var t = getContrastRatio(e, dark.text.primary) >= r ? dark.text.primary : light.text.primary;

    if ("production" !== process.env.NODE_ENV) {
      var _r25 = getContrastRatio(e, t);

      _r25 < 3 && console.error(["MUI: The contrast ratio of ".concat(_r25, ":1 for ").concat(t, " on ").concat(e), "falls below the WCAG recommended absolute minimum contrast ratio of 3:1.", "https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast"].join("\n"));
    }

    return t;
  }

  var p = function p(_ref26) {
    var e = _ref26.color,
        t = _ref26.name,
        _ref26$mainShade = _ref26.mainShade,
        r = _ref26$mainShade === void 0 ? 500 : _ref26$mainShade,
        _ref26$lightShade = _ref26.lightShade,
        a = _ref26$lightShade === void 0 ? 300 : _ref26$lightShade,
        _ref26$darkShade = _ref26.darkShade,
        o = _ref26$darkShade === void 0 ? 700 : _ref26$darkShade;
    if (!(e = _extends$e({}, e)).main && e[r] && (e.main = e[r]), !e.hasOwnProperty("main")) throw new Error("production" !== process.env.NODE_ENV ? "MUI: The color".concat(t ? " (".concat(t, ")") : "", " provided to augmentColor(color) is invalid.\nThe color object needs to have a `main` property or a `").concat(r, "` property.") : formatMuiErrorMessage(11, t ? " (".concat(t, ")") : "", r));
    if ("string" != typeof e.main) throw new Error("production" !== process.env.NODE_ENV ? "MUI: The color".concat(t ? " (".concat(t, ")") : "", " provided to augmentColor(color) is invalid.\n`color.main` should be a string, but `").concat(JSON.stringify(e.main), "` was provided instead.\n\nDid you intend to use one of the following approaches?\n\nimport { green } from \"@mui/material/colors\";\n\nconst theme1 = createTheme({ palette: {\n  primary: green,\n} });\n\nconst theme2 = createTheme({ palette: {\n  primary: { main: green[500] },\n} });") : formatMuiErrorMessage(12, t ? " (".concat(t, ")") : "", JSON.stringify(e.main)));
    return addLightOrDark(e, "light", a, n), addLightOrDark(e, "dark", o, n), e.contrastText || (e.contrastText = d(e.main)), e;
  },
      g = {
    dark: dark,
    light: light
  };

  "production" !== process.env.NODE_ENV && (g[t] || console.error("MUI: The palette mode `".concat(t, "` is not supported.")));
  return deepmerge(_extends$e({
    common: common,
    mode: t,
    primary: p({
      color: o,
      name: "primary"
    }),
    secondary: p({
      color: i,
      name: "secondary",
      mainShade: "A400",
      lightShade: "A200",
      darkShade: "A700"
    }),
    error: p({
      color: s,
      name: "error"
    }),
    warning: p({
      color: u,
      name: "warning"
    }),
    info: p({
      color: l,
      name: "info"
    }),
    success: p({
      color: c,
      name: "success"
    }),
    grey: grey,
    contrastThreshold: r,
    getContrastText: d,
    augmentColor: p,
    tonalOffset: n
  }, g[t]), a);
}

var _excluded$y = ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"];

function round(e) {
  return Math.round(1e5 * e) / 1e5;
}

var caseAllCaps = {
  textTransform: "uppercase"
},
    defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';

function createTypography(e, t) {
  var r = "function" == typeof t ? t(e) : t,
      _r$fontFamily = r.fontFamily,
      n = _r$fontFamily === void 0 ? defaultFontFamily : _r$fontFamily,
      _r$fontSize = r.fontSize,
      a = _r$fontSize === void 0 ? 14 : _r$fontSize,
      _r$fontWeightLight = r.fontWeightLight,
      o = _r$fontWeightLight === void 0 ? 300 : _r$fontWeightLight,
      _r$fontWeightRegular = r.fontWeightRegular,
      i = _r$fontWeightRegular === void 0 ? 400 : _r$fontWeightRegular,
      _r$fontWeightMedium = r.fontWeightMedium,
      s = _r$fontWeightMedium === void 0 ? 500 : _r$fontWeightMedium,
      _r$fontWeightBold = r.fontWeightBold,
      l = _r$fontWeightBold === void 0 ? 700 : _r$fontWeightBold,
      _r$htmlFontSize = r.htmlFontSize,
      c = _r$htmlFontSize === void 0 ? 16 : _r$htmlFontSize,
      u = r.allVariants,
      d = r.pxToRem,
      p = _objectWithoutPropertiesLoose$4(r, _excluded$y);

  "production" !== process.env.NODE_ENV && ("number" != typeof a && console.error("MUI: `fontSize` is required to be a number."), "number" != typeof c && console.error("MUI: `htmlFontSize` is required to be a number."));

  var g = a / 14,
      m = d || function (e) {
    return e / c * g + "rem";
  },
      f = function f(e, t, r, a, o) {
    return _extends$e({
      fontFamily: n,
      fontWeight: e,
      fontSize: m(t),
      lineHeight: r
    }, n === defaultFontFamily ? {
      letterSpacing: "".concat(round(a / t), "em")
    } : {}, o, u);
  },
      h = {
    h1: f(o, 96, 1.167, -1.5),
    h2: f(o, 60, 1.2, -.5),
    h3: f(i, 48, 1.167, 0),
    h4: f(i, 34, 1.235, .25),
    h5: f(i, 24, 1.334, 0),
    h6: f(s, 20, 1.6, .15),
    subtitle1: f(i, 16, 1.75, .15),
    subtitle2: f(s, 14, 1.57, .1),
    body1: f(i, 16, 1.5, .15),
    body2: f(i, 14, 1.43, .15),
    button: f(s, 14, 1.75, .4, caseAllCaps),
    caption: f(i, 12, 1.66, .4),
    overline: f(i, 12, 2.66, 1, caseAllCaps)
  };

  return deepmerge(_extends$e({
    htmlFontSize: c,
    pxToRem: m,
    fontFamily: n,
    fontSize: a,
    fontWeightLight: o,
    fontWeightRegular: i,
    fontWeightMedium: s,
    fontWeightBold: l
  }, h), p, {
    clone: !1
  });
}

var shadowKeyUmbraOpacity = .2,
    shadowKeyPenumbraOpacity = .14,
    shadowAmbientShadowOpacity = .12;

function createShadow() {
  return ["".concat(arguments.length <= 0 ? undefined : arguments[0], "px ").concat(arguments.length <= 1 ? undefined : arguments[1], "px ").concat(arguments.length <= 2 ? undefined : arguments[2], "px ").concat(arguments.length <= 3 ? undefined : arguments[3], "px rgba(0,0,0,").concat(shadowKeyUmbraOpacity, ")"), "".concat(arguments.length <= 4 ? undefined : arguments[4], "px ").concat(arguments.length <= 5 ? undefined : arguments[5], "px ").concat(arguments.length <= 6 ? undefined : arguments[6], "px ").concat(arguments.length <= 7 ? undefined : arguments[7], "px rgba(0,0,0,").concat(shadowKeyPenumbraOpacity, ")"), "".concat(arguments.length <= 8 ? undefined : arguments[8], "px ").concat(arguments.length <= 9 ? undefined : arguments[9], "px ").concat(arguments.length <= 10 ? undefined : arguments[10], "px ").concat(arguments.length <= 11 ? undefined : arguments[11], "px rgba(0,0,0,").concat(shadowAmbientShadowOpacity, ")")].join(",");
}

var shadows = ["none", createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)],
    _excluded$x = ["duration", "easing", "delay"],
    easing = {
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
},
    duration = {
  shortest: 150,
  shorter: 200,
  short: 250,
  standard: 300,
  complex: 375,
  enteringScreen: 225,
  leavingScreen: 195
};

function formatMs(e) {
  return "".concat(Math.round(e), "ms");
}

function getAutoHeightDuration(e) {
  if (!e) return 0;
  var t = e / 36;
  return Math.round(10 * (4 + 15 * Math.pow(t, .25) + t / 5));
}

function createTransitions(e) {
  var t = _extends$e({}, easing, e.easing),
      r = _extends$e({}, duration, e.duration);

  return _extends$e({
    getAutoHeightDuration: getAutoHeightDuration,
    create: function create() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ["all"];
      var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var _n$duration = n.duration,
          a = _n$duration === void 0 ? r.standard : _n$duration,
          _n$easing = n.easing,
          o = _n$easing === void 0 ? t.easeInOut : _n$easing,
          _n$delay = n.delay,
          i = _n$delay === void 0 ? 0 : _n$delay,
          s = _objectWithoutPropertiesLoose$4(n, _excluded$x);

      if ("production" !== process.env.NODE_ENV) {
        var _t31 = function _t31(e) {
          return "string" == typeof e;
        },
            _r26 = function _r26(e) {
          return !isNaN(parseFloat(e));
        };

        _t31(e) || Array.isArray(e) || console.error('MUI: Argument "props" must be a string or Array.'), _r26(a) || _t31(a) || console.error("MUI: Argument \"duration\" must be a number or a string but found ".concat(a, ".")), _t31(o) || console.error('MUI: Argument "easing" must be a string.'), _r26(i) || _t31(i) || console.error('MUI: Argument "delay" must be a number or a string.'), 0 !== Object.keys(s).length && console.error("MUI: Unrecognized argument(s) [".concat(Object.keys(s).join(","), "]."));
      }

      return (Array.isArray(e) ? e : [e]).map(function (e) {
        return "".concat(e, " ").concat("string" == typeof a ? a : formatMs(a), " ").concat(o, " ").concat("string" == typeof i ? i : formatMs(i));
      }).join(",");
    }
  }, e, {
    easing: t,
    duration: r
  });
}

var zIndex = {
  mobileStepper: 1e3,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
},
    _excluded$w = ["breakpoints", "mixins", "spacing", "palette", "transitions", "typography", "shape"];

function createTheme() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _e$mixins = e.mixins,
      r = _e$mixins === void 0 ? {} : _e$mixins,
      _e$palette2 = e.palette,
      n = _e$palette2 === void 0 ? {} : _e$palette2,
      _e$transitions = e.transitions,
      a = _e$transitions === void 0 ? {} : _e$transitions,
      _e$typography = e.typography,
      o = _e$typography === void 0 ? {} : _e$typography,
      i = _objectWithoutPropertiesLoose$4(e, _excluded$w),
      s = createPalette(n),
      l = createTheme$1(e);

  var c = deepmerge(l, {
    mixins: createMixins(l.breakpoints, l.spacing, r),
    palette: s,
    shadows: shadows.slice(),
    typography: createTypography(s, o),
    transitions: createTransitions(a),
    zIndex: _extends$e({}, zIndex)
  });

  for (var _len15 = arguments.length, t = new Array(_len15 > 1 ? _len15 - 1 : 0), _key15 = 1; _key15 < _len15; _key15++) {
    t[_key15 - 1] = arguments[_key15];
  }

  if (c = deepmerge(c, i), c = t.reduce(function (e, t) {
    return deepmerge(e, t);
  }, c), "production" !== process.env.NODE_ENV) {
    var _e40 = ["active", "checked", "completed", "disabled", "error", "expanded", "focused", "focusVisible", "required", "selected"],
        _t32 = function _t32(t, r) {
      var n;

      for (n in t) {
        var _a11 = t[n];

        if (-1 !== _e40.indexOf(n) && Object.keys(_a11).length > 0) {
          if ("production" !== process.env.NODE_ENV) {
            var _e41 = generateUtilityClass("", n);

            console.error(["MUI: The `".concat(r, "` component increases the CSS specificity of the `").concat(n, "` internal state."), "You can not override it like this: ", JSON.stringify(t, null, 2), "", "Instead, you need to use the '&.".concat(_e41, "' syntax:"), JSON.stringify({
              root: _defineProperty2({}, "&.".concat(_e41), _a11)
            }, null, 2), "", "https://mui.com/r/state-classes-guide"].join("\n"));
          }

          t[n] = {};
        }
      }
    };

    Object.keys(c.components).forEach(function (e) {
      var r = c.components[e].styleOverrides;
      r && 0 === e.indexOf("Mui") && _t32(r, e);
    });
  }

  return c;
}

var defaultTheme = createTheme();

function useThemeProps(_ref27) {
  var e = _ref27.props,
      t = _ref27.name;
  return useThemeProps$1({
    props: e,
    name: t,
    defaultTheme: defaultTheme
  });
}

var rootShouldForwardProp = function rootShouldForwardProp(e) {
  return shouldForwardProp(e) && "classes" !== e;
},
    styled = createStyled({
  defaultTheme: defaultTheme,
  rootShouldForwardProp: rootShouldForwardProp
});

function getSvgIconUtilityClass(e) {
  return generateUtilityClass("MuiSvgIcon", e);
}

generateUtilityClasses("MuiSvgIcon", ["root", "colorPrimary", "colorSecondary", "colorAction", "colorError", "colorDisabled", "fontSizeInherit", "fontSizeSmall", "fontSizeMedium", "fontSizeLarge"]);

var _excluded$v = ["children", "className", "color", "component", "fontSize", "htmlColor", "inheritViewBox", "titleAccess", "viewBox"],
    useUtilityClasses$j = function useUtilityClasses$j(e) {
  var t = e.color,
      r = e.fontSize,
      n = e.classes;
  return composeClasses({
    root: ["root", "inherit" !== t && "color".concat(capitalize(t)), "fontSize".concat(capitalize(r))]
  }, getSvgIconUtilityClass, n);
},
    SvgIconRoot = styled("svg", {
  name: "MuiSvgIcon",
  slot: "Root",
  overridesResolver: function overridesResolver(e, t) {
    var r = e.ownerState;
    return [t.root, "inherit" !== r.color && t["color".concat(capitalize(r.color))], t["fontSize".concat(capitalize(r.fontSize))]];
  }
})(function (_ref28) {
  var e = _ref28.theme,
      t = _ref28.ownerState;
  var r, n, a, o, i, s, l, c, u, d, p, g, m, f, h, b, y;
  return {
    userSelect: "none",
    width: "1em",
    height: "1em",
    display: "inline-block",
    fill: "currentColor",
    flexShrink: 0,
    transition: null == (r = e.transitions) || null == (n = r.create) ? void 0 : n.call(r, "fill", {
      duration: null == (a = e.transitions) || null == (o = a.duration) ? void 0 : o.shorter
    }),
    fontSize: {
      inherit: "inherit",
      small: (null == (i = e.typography) || null == (s = i.pxToRem) ? void 0 : s.call(i, 20)) || "1.25rem",
      medium: (null == (l = e.typography) || null == (c = l.pxToRem) ? void 0 : c.call(l, 24)) || "1.5rem",
      large: (null == (u = e.typography) || null == (d = u.pxToRem) ? void 0 : d.call(u, 35)) || "2.1875"
    }[t.fontSize],
    color: null != (p = null == (g = e.palette) || null == (m = g[t.color]) ? void 0 : m.main) ? p : {
      action: null == (f = e.palette) || null == (h = f.action) ? void 0 : h.active,
      disabled: null == (b = e.palette) || null == (y = b.action) ? void 0 : y.disabled,
      inherit: void 0
    }[t.color]
  };
}),
    SvgIcon = React.forwardRef(function (e, t) {
  var r = useThemeProps({
    props: e,
    name: "MuiSvgIcon"
  }),
      n = r.children,
      a = r.className,
      _r$color = r.color,
      o = _r$color === void 0 ? "inherit" : _r$color,
      _r$component = r.component,
      i = _r$component === void 0 ? "svg" : _r$component,
      _r$fontSize2 = r.fontSize,
      s = _r$fontSize2 === void 0 ? "medium" : _r$fontSize2,
      l = r.htmlColor,
      _r$inheritViewBox = r.inheritViewBox,
      c = _r$inheritViewBox === void 0 ? !1 : _r$inheritViewBox,
      u = r.titleAccess,
      _r$viewBox = r.viewBox,
      d = _r$viewBox === void 0 ? "0 0 24 24" : _r$viewBox,
      p = _objectWithoutPropertiesLoose$4(r, _excluded$v),
      g = _extends$e({}, r, {
    color: o,
    component: i,
    fontSize: s,
    inheritViewBox: c,
    viewBox: d
  }),
      m = {};

  c || (m.viewBox = d);
  var f = useUtilityClasses$j(g);
  return jsxs(SvgIconRoot, _extends$e({
    as: i,
    className: clsx(f.root, a),
    ownerState: g,
    focusable: "false",
    color: l,
    "aria-hidden": !u || void 0,
    role: u ? "img" : void 0,
    ref: t
  }, m, p, {
    children: [n, u ? jsx$1("title", {
      children: u
    }) : null]
  }));
});

function createSvgIcon$1(e, t) {
  var r = function r(_r27, n) {
    return jsx$1(SvgIcon, _extends$e({
      "data-testid": "".concat(t, "Icon"),
      ref: n
    }, _r27, {
      children: e
    }));
  };

  return "production" !== process.env.NODE_ENV && (r.displayName = "".concat(t, "Icon")), r.muiName = SvgIcon.muiName, React.memo(React.forwardRef(r));
}

function getCircularProgressUtilityClass(e) {
  return generateUtilityClass("MuiCircularProgress", e);
}

"production" !== process.env.NODE_ENV && (SvgIcon.propTypes = {
  children: PropTypes.node,
  classes: PropTypes.object,
  className: PropTypes.string,
  color: PropTypes.oneOfType([PropTypes.oneOf(["inherit", "action", "disabled", "primary", "secondary", "error", "info", "success", "warning"]), PropTypes.string]),
  component: PropTypes.elementType,
  fontSize: PropTypes.oneOfType([PropTypes.oneOf(["inherit", "large", "medium", "small"]), PropTypes.string]),
  htmlColor: PropTypes.string,
  inheritViewBox: PropTypes.bool,
  shapeRendering: PropTypes.string,
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  titleAccess: PropTypes.string,
  viewBox: PropTypes.string
}), SvgIcon.muiName = "SvgIcon", generateUtilityClasses("MuiCircularProgress", ["root", "determinate", "indeterminate", "colorPrimary", "colorSecondary", "svg", "circle", "circleDeterminate", "circleIndeterminate", "circleDisableShrink"]);
var _excluded$u = ["className", "color", "disableShrink", "size", "style", "thickness", "value", "variant"];

var _$1 = function _$1(e) {
  return e;
},
    _t$1,
    _t2$1,
    _t3$1,
    _t4$1;

var SIZE = 44,
    circularRotateKeyframe = keyframes(_t$1 || (_t$1 = _$1(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n"]))))),
    circularDashKeyframe = keyframes(_t2$1 || (_t2$1 = _$1(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  0% {\n    stroke-dasharray: 1px, 200px;\n    stroke-dashoffset: 0;\n  }\n\n  50% {\n    stroke-dasharray: 100px, 200px;\n    stroke-dashoffset: -15px;\n  }\n\n  100% {\n    stroke-dasharray: 100px, 200px;\n    stroke-dashoffset: -125px;\n  }\n"]))))),
    useUtilityClasses$i = function useUtilityClasses$i(e) {
  var t = e.classes,
      r = e.variant,
      n = e.color,
      a = e.disableShrink;
  return composeClasses({
    root: ["root", r, "color".concat(capitalize(n))],
    svg: ["svg"],
    circle: ["circle", "circle".concat(capitalize(r)), a && "circleDisableShrink"]
  }, getCircularProgressUtilityClass, t);
},
    CircularProgressRoot = styled("span", {
  name: "MuiCircularProgress",
  slot: "Root",
  overridesResolver: function overridesResolver(e, t) {
    var r = e.ownerState;
    return [t.root, t[r.variant], t["color".concat(capitalize(r.color))]];
  }
})(function (_ref29) {
  var e = _ref29.ownerState,
      t = _ref29.theme;
  return _extends$e({
    display: "inline-block"
  }, "determinate" === e.variant && {
    transition: t.transitions.create("transform")
  }, "inherit" !== e.color && {
    color: t.palette[e.color].main
  });
}, function (_ref30) {
  var e = _ref30.ownerState;
  return "indeterminate" === e.variant && css$2(_t3$1 || (_t3$1 = _$1(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      animation: ", " 1.4s linear infinite;\n    "])), 0)), circularRotateKeyframe);
}),
    CircularProgressSVG = styled("svg", {
  name: "MuiCircularProgress",
  slot: "Svg",
  overridesResolver: function overridesResolver(e, t) {
    return t.svg;
  }
})({
  display: "block"
}),
    CircularProgressCircle = styled("circle", {
  name: "MuiCircularProgress",
  slot: "Circle",
  overridesResolver: function overridesResolver(e, t) {
    var r = e.ownerState;
    return [t.circle, t["circle".concat(capitalize(r.variant))], r.disableShrink && t.circleDisableShrink];
  }
})(function (_ref31) {
  var e = _ref31.ownerState,
      t = _ref31.theme;
  return _extends$e({
    stroke: "currentColor"
  }, "determinate" === e.variant && {
    transition: t.transitions.create("stroke-dashoffset")
  }, "indeterminate" === e.variant && {
    strokeDasharray: "80px, 200px",
    strokeDashoffset: 0
  });
}, function (_ref32) {
  var e = _ref32.ownerState;
  return "indeterminate" === e.variant && !e.disableShrink && css$2(_t4$1 || (_t4$1 = _$1(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n      animation: ", " 1.4s ease-in-out infinite;\n    "])), 0)), circularDashKeyframe);
}),
    CircularProgress = React.forwardRef(function (e, t) {
  var r = useThemeProps({
    props: e,
    name: "MuiCircularProgress"
  }),
      n = r.className,
      _r$color2 = r.color,
      a = _r$color2 === void 0 ? "primary" : _r$color2,
      _r$disableShrink = r.disableShrink,
      o = _r$disableShrink === void 0 ? !1 : _r$disableShrink,
      _r$size = r.size,
      i = _r$size === void 0 ? 40 : _r$size,
      s = r.style,
      _r$thickness = r.thickness,
      l = _r$thickness === void 0 ? 3.6 : _r$thickness,
      _r$value = r.value,
      c = _r$value === void 0 ? 0 : _r$value,
      _r$variant = r.variant,
      u = _r$variant === void 0 ? "indeterminate" : _r$variant,
      d = _objectWithoutPropertiesLoose$4(r, _excluded$u),
      p = _extends$e({}, r, {
    color: a,
    disableShrink: o,
    size: i,
    thickness: l,
    value: c,
    variant: u
  }),
      g = useUtilityClasses$i(p),
      m = {},
      f = {},
      h = {};

  if ("determinate" === u) {
    var _e42 = 2 * Math.PI * ((SIZE - l) / 2);

    m.strokeDasharray = _e42.toFixed(3), h["aria-valuenow"] = Math.round(c), m.strokeDashoffset = "".concat(((100 - c) / 100 * _e42).toFixed(3), "px"), f.transform = "rotate(-90deg)";
  }

  return jsx$1(CircularProgressRoot, _extends$e({
    className: clsx(g.root, n),
    style: _extends$e({
      width: i,
      height: i
    }, f, s),
    ownerState: p,
    ref: t,
    role: "progressbar"
  }, h, d, {
    children: jsx$1(CircularProgressSVG, {
      className: g.svg,
      ownerState: p,
      viewBox: "".concat(SIZE / 2, " ").concat(SIZE / 2, " ").concat(SIZE, " ").concat(SIZE),
      children: jsx$1(CircularProgressCircle, {
        className: g.circle,
        style: m,
        ownerState: p,
        cx: SIZE,
        cy: SIZE,
        r: (SIZE - l) / 2,
        fill: "none",
        strokeWidth: l
      })
    })
  }));
});

"production" !== process.env.NODE_ENV && (CircularProgress.propTypes = {
  classes: PropTypes.object,
  className: PropTypes.string,
  color: PropTypes.oneOfType([PropTypes.oneOf(["inherit", "primary", "secondary", "error", "info", "success", "warning"]), PropTypes.string]),
  disableShrink: chainPropTypes(PropTypes.bool, function (e) {
    return e.disableShrink && e.variant && "indeterminate" !== e.variant ? new Error("MUI: You have provided the `disableShrink` prop with a variant other than `indeterminate`. This will have no effect.") : null;
  }),
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  style: PropTypes.object,
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  thickness: PropTypes.number,
  value: PropTypes.number,
  variant: PropTypes.oneOf(["determinate", "indeterminate"])
});

var CircularProgress$1 = CircularProgress,
    BrokenImageIcon = createSvgIcon$1(jsx$1("path", {
  d: "M21 5v6.59l-2.29-2.3c-.39-.39-1.03-.39-1.42 0L14 12.59 10.71 9.3a.9959.9959 0 0 0-1.41 0L6 12.59 3 9.58V5c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2zm-3 6.42 3 3.01V19c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2v-6.58l2.29 2.29c.39.39 1.02.39 1.41 0l3.3-3.3 3.29 3.29c.39.39 1.02.39 1.41 0l3.3-3.28z"
}), "BrokenImageIcon"),
    Img = styled$2("img")({
  "@keyframes materialize": {
    "0%": {
      filter: "saturate(20%) contrast(50%) brightness(120%)"
    },
    "75%": {
      filter: "saturate(60%) contrast(100%) brightness(100%)"
    },
    "100%": {
      filter: "saturate(100%) contrast(100%) brightness(100%)"
    }
  }
}),
    Image = function Image(e) {
  var t = e.src,
      r = e.alt,
      n = void 0 === r ? "" : r,
      a = e.height,
      o = void 0 === a ? "100%" : a,
      i = e.width,
      s = void 0 === i ? "100%" : i,
      l = e.position,
      c = void 0 === l ? "absolute" : l,
      u = e.fit,
      d = void 0 === u ? "cover" : u,
      p = e.showLoading,
      g = void 0 !== p && p,
      m = e.errorIcon,
      f = void 0 === m || m,
      h = e.bgColor,
      b = void 0 === h ? "inherit" : h,
      y = e.duration,
      v = e.delay,
      _ = e.className,
      T = void 0 === _ ? "" : _,
      E = e.wrapperClassName,
      S = void 0 === E ? "" : E,
      x = e.iconWrapperClassName,
      w = void 0 === x ? "" : x,
      C = e.style,
      k = e.iconWrapperStyle,
      $ = e.wrapperStyle,
      R = e.onLoad,
      A = e.onError,
      I = React.useState(!1),
      N = I[0],
      P = I[1],
      O = React.useState(!1),
      D = O[0],
      L = O[1],
      M = {
    root: _assign$({
      width: s,
      height: o,
      display: "flex",
      position: c,
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: b
    }, $),
    image: _assign$({
      width: "100%",
      height: "100%",
      objectFit: d
    }, C),
    icons: _assign$({
      width: "100%",
      marginLeft: "-100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      opacity: N ? 0 : 1
    }, k)
  },
      F = "boolean" != typeof f && f || jsx$1(BrokenImageIcon, {
    style: {
      fontSize: 56,
      color: "#bdbdbd"
    }
  }),
      j = "boolean" != typeof g && g || jsx$1(CircularProgress$1, {
    size: 56,
    thickness: 6
  });
  return jsx$1(FadeIn, _assign$({
    delay: v,
    transitionDuration: y
  }, {
    children: jsxs("div", _assign$({
      style: M.root,
      className: "mui-image-wrapper ".concat(S)
    }, {
      children: [jsx$1(Img, {
        src: t,
        alt: n,
        style: M.image,
        className: "mui-image-img ".concat(T),
        onLoad: function onLoad() {
          P(!0), L(!1), null != R && R();
        },
        onError: function onError() {
          L(!0), P(!1), null != A && A();
        }
      }), (Boolean(g) || Boolean(f)) && jsxs("div", _assign$({
        style: M.icons,
        className: "mui-image-iconWrapper ".concat(w)
      }, {
        children: [Boolean(f) && D && F, Boolean(g) && !D && !N && j]
      }))]
    }))
  }));
},
    ImageContainer = function ImageContainer(e) {
  var t = e.children;
  return jsx$1(Root$y, {
    children: t
  });
},
    Root$y = styled$2(Box)(function (e) {
  return e.theme, {
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    "& > div": {
      height: "100%"
    },
    "& img": {
      objectFit: "cover !important",
      objectPosition: "0 0"
    }
  };
});

function InnerHtml(e) {
  var t = e.html;
  e.dangerouslySetInnerHTML;

  var r = __rest$1(e, ["html", "dangerouslySetInnerHTML"]),
      n = useRef(null);

  return useEffect(function () {
    if (!t || null == n.current) throw "html prop cant't be null";
    var e = document.createRange().createContextualFragment(t);
    n.current.innerHTML = "", n.current.appendChild(e);
  }, [t, n]), jsx$1(Box, _assign$({}, r, {
    ref: n
  }));
}

var InlineSVG = function InlineSVG(e) {
  return jsx$1(InlineSVG$1, _assign$({}, e));
},
    Loader = function Loader() {
  return jsx$1("svg", _assign$({
    viewBox: "0 0 38 38",
    className: "animate-spin h-5 w-5 stroke-current text-black-600 mr-2",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx$1("g", _assign$({
      fill: "none",
      fillRule: "evenodd"
    }, {
      children: jsxs("g", _assign$({
        transform: "translate(1 1)",
        strokeWidth: "2"
      }, {
        children: [jsx$1("circle", {
          strokeOpacity: ".5",
          cx: "18",
          cy: "18",
          r: "18"
        }), jsx$1("path", _assign$({
          d: "M36 18c0-9.94-8.06-18-18-18"
        }, {
          children: jsx$1("animateTransform", {
            attributeName: "transform",
            type: "rotate",
            from: "0 18 18",
            to: "360 18 18",
            dur: "1s",
            repeatCount: "indefinite"
          })
        }))]
      }))
    }))
  }));
},
    MediaPlayer = function MediaPlayer(e) {
  var t = e.url,
      r = e.width,
      n = e.height,
      a = e.controls,
      o = e.playing;
  return jsx$1(ReactPlayer, {
    url: t,
    width: r,
    height: n,
    controls: a,
    playing: o,
    style: {
      position: "absolute",
      top: 0,
      bottom: 0
    }
  });
},
    DefaultContext = {
  color: void 0,
  size: void 0,
  className: void 0,
  style: void 0,
  attr: void 0
},
    IconContext = React__default.createContext && React__default.createContext(DefaultContext),
    _assign = function __assign() {
  return _assign = Object.assign || function (e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      for (var a in t = arguments[r]) {
        Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
      }
    }

    return e;
  }, _assign.apply(this, arguments);
},
    __rest = function __rest(e, t) {
  var r = {};

  for (var n in e) {
    Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  }

  if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
    var a = 0;

    for (n = Object.getOwnPropertySymbols(e); a < n.length; a++) {
      t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
    }
  }

  return r;
};

function Tree2Element(e) {
  return e && e.map(function (e, t) {
    return React__default.createElement(e.tag, _assign({
      key: t
    }, e.attr), Tree2Element(e.child));
  });
}

function GenIcon(e) {
  return function (t) {
    return React__default.createElement(IconBase, _assign({
      attr: _assign({}, e.attr)
    }, t), Tree2Element(e.child));
  };
}

function IconBase(e) {
  var t = function t(_t33) {
    var r,
        n = e.attr,
        a = e.size,
        o = e.title,
        i = __rest(e, ["attr", "size", "title"]),
        s = a || _t33.size || "1em";

    return _t33.className && (r = _t33.className), e.className && (r = (r ? r + " " : "") + e.className), React__default.createElement("svg", _assign({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, _t33.attr, n, i, {
      className: r,
      style: _assign(_assign({
        color: e.color || _t33.color
      }, _t33.style), e.style),
      height: s,
      width: s,
      xmlns: "http://www.w3.org/2000/svg"
    }), o && React__default.createElement("title", null, o), e.children);
  };

  return void 0 !== IconContext ? React__default.createElement(IconContext.Consumer, null, function (e) {
    return t(e);
  }) : t(DefaultContext);
}

function IoArrowForwardCircleSharp(e) {
  return GenIcon({
    tag: "svg",
    attr: {
      viewBox: "0 0 512 512"
    },
    child: [{
      tag: "path",
      attr: {
        d: "M464 256c0-114.87-93.13-208-208-208S48 141.13 48 256s93.13 208 208 208 208-93.13 208-208zm-224 80.09L303.58 272H154v-32h149.58L240 175.91l22.71-22.54L364.54 256 262.7 358.63z"
      }
    }]
  })(e);
}

function IoBatteryFull(e) {
  return GenIcon({
    tag: "svg",
    attr: {
      viewBox: "0 0 512 512"
    },
    child: [{
      tag: "rect",
      attr: {
        width: "400",
        height: "224",
        x: "32",
        y: "144",
        fill: "none",
        strokeLinecap: "square",
        strokeMiterlimit: "10",
        strokeWidth: "32",
        rx: "45.7",
        ry: "45.7"
      }
    }, {
      tag: "rect",
      attr: {
        width: "292.63",
        height: "114.14",
        x: "85.69",
        y: "198.93",
        strokeLinecap: "square",
        strokeMiterlimit: "10",
        strokeWidth: "32",
        rx: "4",
        ry: "4"
      }
    }, {
      tag: "path",
      attr: {
        fill: "none",
        strokeLinecap: "round",
        strokeMiterlimit: "10",
        strokeWidth: "32",
        d: "M480 218.67v74.66"
      }
    }]
  })(e);
}

function IoCellular(e) {
  return GenIcon({
    tag: "svg",
    attr: {
      viewBox: "0 0 512 512"
    },
    child: [{
      tag: "path",
      attr: {
        d: "M472 432h-48a24 24 0 01-24-24V104a24 24 0 0124-24h48a24 24 0 0124 24v304a24 24 0 01-24 24zm-128 0h-48a24 24 0 01-24-24V184a24 24 0 0124-24h48a24 24 0 0124 24v224a24 24 0 01-24 24zm-128 0h-48a24 24 0 01-24-24V248a24 24 0 0124-24h48a24 24 0 0124 24v160a24 24 0 01-24 24zm-128 0H40a24 24 0 01-24-24v-96a24 24 0 0124-24h48a24 24 0 0124 24v96a24 24 0 01-24 24z"
      }
    }]
  })(e);
}

function IoIosWifi(e) {
  return GenIcon({
    tag: "svg",
    attr: {
      viewBox: "0 0 512 512"
    },
    child: [{
      tag: "path",
      attr: {
        d: "M256 96c-81.5 0-163 33.6-221.5 88.3-3.3 3-3.4 8.1-.3 11.4l26.7 27.9c3.1 3.3 8.3 3.4 11.6.3 23.3-21.6 49.9-38.8 79.3-51 33-13.8 68.1-20.7 104.3-20.7s71.3 7 104.3 20.7c29.4 12.3 56 29.4 79.3 51 3.3 3.1 8.5 3 11.6-.3l26.7-27.9c3.1-3.2 3-8.3-.3-11.4C419 129.6 337.5 96 256 96z"
      }
    }, {
      tag: "path",
      attr: {
        d: "M113.2 277.5l28.6 28.3c3.1 3 8 3.2 11.2.3 28.3-25.1 64.6-38.9 102.9-38.9s74.6 13.7 102.9 38.9c3.2 2.9 8.1 2.7 11.2-.3l28.6-28.3c3.3-3.3 3.2-8.6-.3-11.7-37.5-33.9-87.6-54.6-142.5-54.6s-105 20.7-142.5 54.6c-3.3 3.1-3.4 8.4-.1 11.7zM256 324.2c-23.4 0-44.6 9.8-59.4 25.5-3 3.2-2.9 8.1.2 11.2l53.4 52.7c3.2 3.2 8.4 3.2 11.6 0l53.4-52.7c3.1-3.1 3.2-8 .2-11.2-14.8-15.6-36-25.5-59.4-25.5z"
      }
    }]
  })(e);
}

function IoMdClose(e) {
  return GenIcon({
    tag: "svg",
    attr: {
      viewBox: "0 0 512 512"
    },
    child: [{
      tag: "path",
      attr: {
        d: "M405 136.798L375.202 107 256 226.202 136.798 107 107 136.798 226.202 256 107 375.202 136.798 405 256 285.798 375.202 405 405 375.202 285.798 256z"
      }
    }]
  })(e);
}

var PHONE_HEIGHT = 432,
    PHONE_BORDER_SIZE = 8,
    STATUS_BAR_HEIGHT = 24,
    EMAIL_APP_TOP_BAR_HEIGHT = 18,
    EMAIL_APP_BOTTOM_NAV_HEIGHT = 44,
    EMAIL_APP_BODY_HEIGHT = PHONE_HEIGHT - STATUS_BAR_HEIGHT - EMAIL_APP_TOP_BAR_HEIGHT - EMAIL_APP_BOTTOM_NAV_HEIGHT - 2 * PHONE_BORDER_SIZE,
    Phone = function Phone(e) {
  var t = e.showStatusBar,
      r = void 0 === t || t,
      n = e.showPhoneEmailShell,
      a = void 0 !== n && n,
      o = e.children,
      i = __rest$1(e, ["showStatusBar", "showPhoneEmailShell", "children"]),
      s = useTime({
    format: void 0
  }),
      l = s.minutes,
      c = s.hours;

  return jsxs(PhoneShell, _assign$({}, i, {
    children: [r && jsxs(StatusBar, {
      children: [jsxs(StatusBarTime, {
        children: [jsx$1("span", {
          children: c
        }), ":", jsx$1("span", {
          children: l < 10 ? "0".concat(l) : l
        })]
      }), jsxs(StatusBarIcons, {
        children: [jsx$1(IoCellular, {
          size: 10
        }), jsx$1(IoIosWifi, {
          size: 10
        }), jsx$1(IoBatteryFull, {
          size: 11
        })]
      })]
    }), a && jsx$1(EmailAppTopNav, {
      children: jsx$1(Image, {
        src: "/images/phone-email-app-top-bar.svg",
        alt: "phone-email-app-top-bar",
        width: 201,
        height: 19
      })
    }), jsx$1(EmailAppBody, {
      children: o
    }), a && jsx$1(EmailAppBottomBar, {
      children: jsx$1(Image, {
        src: "/images/phone-email-app-bottom-nav.svg",
        alt: "phone-email-app-bottom-nav",
        width: 201,
        height: 44
      })
    })]
  }));
},
    PhoneShell = styled$2(Card)(function (e) {
  return {
    backgroundColor: e.theme.palette.background.default,
    borderRadius: "20px",
    border: "".concat(PHONE_BORDER_SIZE, "px solid #FAFAFA"),
    display: "flex",
    flexDirection: "column",
    height: PHONE_HEIGHT,
    position: "relative",
    width: 200
  };
}),
    StatusBar = styled$2(Box)(function (e) {
  var t = e.theme;
  return {
    alignItems: "center",
    borderRadius: "20px 20px 0 0",
    display: "flex",
    height: STATUS_BAR_HEIGHT,
    justifyContent: "space-between",
    padding: t.spacing(.75, 1)
  };
}),
    StatusBarTime = styled$2(Box)(function (e) {
  return e.theme, {
    fontSize: 8,
    fontWeight: 600
  };
}),
    StatusBarIcons = styled$2(Box)(function (e) {
  return e.theme, {
    display: "flex",
    fontSize: 10,
    gap: "4px"
  };
}),
    EmailAppTopNav = styled$2(Box)(function (e) {
  var t = e.theme;
  return {
    backgroundColor: t.palette.background.default,
    borderBottom: "1px solid ".concat(t.palette.grey[200]),
    height: EMAIL_APP_TOP_BAR_HEIGHT
  };
}),
    EmailAppBody = styled$2(Box)(function (e) {
  return e.theme, {
    overflowY: "auto",
    height: EMAIL_APP_BODY_HEIGHT
  };
}),
    EmailAppBottomBar = styled$2(Box)(function (e) {
  var t = e.theme;
  return {
    borderTop: "1px solid ".concat(t.palette.grey[200]),
    height: EMAIL_APP_BOTTOM_NAV_HEIGHT
  };
}),
    SegmentScript = function SegmentScript(e) {
  var t = e.writeKey;
  return jsx$1("script", {
    dangerouslySetInnerHTML: {
      __html: '!function(){var analytics=window.analytics=window.analytics||[];if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error("Segment snippet included twice.");else{analytics.invoked=!0;analytics.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","debug","page","once","off","on","addSourceMiddleware","addIntegrationMiddleware","setAnonymousId","addDestinationMiddleware"];analytics.factory=function(e){return function(){var t=Array.prototype.slice.call(arguments);t.unshift(e);analytics.push(t);return analytics}};for(var e=0;e<analytics.methods.length;e++){var key=analytics.methods[e];analytics[key]=analytics.factory(key)}analytics.load=function(key,e){var t=document.createElement("script");t.type="text/javascript";t.async=!0;t.src="https://cdn.segment.com/analytics.js/v1/" + key + "/analytics.min.js";var n=document.getElementsByTagName("script")[0];n.parentNode.insertBefore(t,n);analytics._loadOptions=e};analytics._writeKey="'.concat(t, '";;analytics.SNIPPET_VERSION="4.15.3";\n                    analytics.load("').concat(t, '");\n                    analytics.page();\n                    }}();')
    }
  });
};

function _extends$a() {
  return _extends$a = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];

      for (var n in r) {
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
    }

    return e;
  }, _extends$a.apply(this, arguments);
}

function _objectWithoutPropertiesLoose$1(e, t) {
  if (null == e) return {};
  var r,
      n,
      a = {},
      o = Object.keys(e);

  for (n = 0; n < o.length; n++) {
    r = o[n], t.indexOf(r) >= 0 || (a[r] = e[r]);
  }

  return a;
}

function useTheme() {
  var e = useTheme$1(defaultTheme);
  return "production" !== process.env.NODE_ENV && React.useDebugValue(e), e;
}

var MuiPickersAdapterContext = React.createContext(null);

function LocalizationProvider(e) {
  var t = e.children,
      r = e.dateAdapter,
      n = e.dateFormats,
      a = e.dateLibInstance,
      o = e.locale,
      i = React.useMemo(function () {
    return new r({
      locale: o,
      formats: n,
      instance: a
    });
  }, [r, o, n, a]),
      s = React.useMemo(function () {
    return {
      minDate: i.date("1900-01-01T00:00:00.000"),
      maxDate: i.date("2099-12-31T00:00:00.000")
    };
  }, [i]),
      l = React.useMemo(function () {
    return {
      utils: i,
      defaultDates: s
    };
  }, [s, i]);
  return jsx$1(MuiPickersAdapterContext.Provider, {
    value: l,
    children: t
  });
}

function useLocalizationContext() {
  var e = React.useContext(MuiPickersAdapterContext);
  if (null === e) throw new Error("production" !== process.env.NODE_ENV ? "Can not find utils in context. It looks like you forgot to wrap your component in LocalizationProvider, or pass dateAdapter prop directly." : formatMuiErrorMessage(13));
  return e;
}

function useUtils() {
  return useLocalizationContext().utils;
}

function useDefaultDates() {
  return useLocalizationContext().defaultDates;
}

function useNow() {
  var e = useUtils();
  return React.useRef(e.date()).current;
}

"production" !== process.env.NODE_ENV && (MuiPickersAdapterContext.displayName = "MuiPickersAdapterContext"), "production" !== process.env.NODE_ENV && (LocalizationProvider.propTypes = {
  children: PropTypes.node,
  dateAdapter: PropTypes.func.isRequired,
  dateFormats: PropTypes.shape({
    dayOfMonth: PropTypes.string,
    fullDate: PropTypes.string,
    fullDateTime: PropTypes.string,
    fullDateTime12h: PropTypes.string,
    fullDateTime24h: PropTypes.string,
    fullDateWithWeekday: PropTypes.string,
    fullTime: PropTypes.string,
    fullTime12h: PropTypes.string,
    fullTime24h: PropTypes.string,
    hours12h: PropTypes.string,
    hours24h: PropTypes.string,
    keyboardDate: PropTypes.string,
    keyboardDateTime: PropTypes.string,
    keyboardDateTime12h: PropTypes.string,
    keyboardDateTime24h: PropTypes.string,
    minutes: PropTypes.string,
    month: PropTypes.string,
    monthAndDate: PropTypes.string,
    monthAndYear: PropTypes.string,
    monthShort: PropTypes.string,
    normalDate: PropTypes.string,
    normalDateWithWeekday: PropTypes.string,
    seconds: PropTypes.string,
    shortDate: PropTypes.string,
    weekday: PropTypes.string,
    weekdayShort: PropTypes.string,
    year: PropTypes.string
  }),
  dateLibInstance: PropTypes.any,
  locale: PropTypes.oneOfType([PropTypes.object, PropTypes.string])
});

var _excluded$t = ["openTo", "views", "minDate", "maxDate"],
    isYearOnlyView = function isYearOnlyView(e) {
  return 1 === e.length && "year" === e[0];
},
    isYearAndMonthViews = function isYearAndMonthViews(e) {
  return 2 === e.length && -1 !== e.indexOf("month") && -1 !== e.indexOf("year");
},
    getFormatAndMaskByViews = function getFormatAndMaskByViews(e, t) {
  return isYearOnlyView(e) ? {
    mask: "____",
    inputFormat: t.formats.year
  } : isYearAndMonthViews(e) ? {
    disableMaskedInput: !0,
    inputFormat: t.formats.monthAndYear
  } : {
    mask: "__/__/____",
    inputFormat: t.formats.keyboardDate
  };
};

function useDatePickerDefaultizedProps(e, t) {
  var _e$openTo = e.openTo,
      r = _e$openTo === void 0 ? "day" : _e$openTo,
      _e$views = e.views,
      n = _e$views === void 0 ? ["year", "day"] : _e$views,
      a = e.minDate,
      o = e.maxDate,
      i = _objectWithoutPropertiesLoose$1(e, _excluded$t);

  var s = useUtils(),
      l = useDefaultDates();
  return useThemeProps({
    props: _extends$a({
      views: n,
      openTo: r,
      minDate: null != a ? a : l.minDate,
      maxDate: null != o ? o : l.maxDate
    }, getFormatAndMaskByViews(n, s), i),
    name: t
  });
}

function getTypographyUtilityClass(e) {
  return generateUtilityClass("MuiTypography", e);
}

generateUtilityClasses("MuiTypography", ["root", "h1", "h2", "h3", "h4", "h5", "h6", "subtitle1", "subtitle2", "body1", "body2", "inherit", "button", "caption", "overline", "alignLeft", "alignRight", "alignCenter", "alignJustify", "noWrap", "gutterBottom", "paragraph"]);

var _excluded$s = ["align", "className", "component", "gutterBottom", "noWrap", "paragraph", "variant", "variantMapping"],
    useUtilityClasses$h = function useUtilityClasses$h(e) {
  var t = e.align,
      r = e.gutterBottom,
      n = e.noWrap,
      a = e.paragraph,
      o = e.variant,
      i = e.classes;
  return composeClasses({
    root: ["root", o, "inherit" !== e.align && "align".concat(capitalize(t)), r && "gutterBottom", n && "noWrap", a && "paragraph"]
  }, getTypographyUtilityClass, i);
},
    TypographyRoot = styled("span", {
  name: "MuiTypography",
  slot: "Root",
  overridesResolver: function overridesResolver(e, t) {
    var r = e.ownerState;
    return [t.root, r.variant && t[r.variant], "inherit" !== r.align && t["align".concat(capitalize(r.align))], r.noWrap && t.noWrap, r.gutterBottom && t.gutterBottom, r.paragraph && t.paragraph];
  }
})(function (_ref33) {
  var e = _ref33.theme,
      t = _ref33.ownerState;
  return _extends$e({
    margin: 0
  }, t.variant && e.typography[t.variant], "inherit" !== t.align && {
    textAlign: t.align
  }, t.noWrap && {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  }, t.gutterBottom && {
    marginBottom: "0.35em"
  }, t.paragraph && {
    marginBottom: 16
  });
}),
    defaultVariantMapping = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  h6: "h6",
  subtitle1: "h6",
  subtitle2: "h6",
  body1: "p",
  body2: "p",
  inherit: "p"
},
    colorTransformations = {
  primary: "primary.main",
  textPrimary: "text.primary",
  secondary: "secondary.main",
  textSecondary: "text.secondary",
  error: "error.main"
},
    transformDeprecatedColors = function transformDeprecatedColors(e) {
  return colorTransformations[e] || e;
},
    Typography = React.forwardRef(function (e, t) {
  var r = useThemeProps({
    props: e,
    name: "MuiTypography"
  }),
      n = transformDeprecatedColors(r.color),
      a = extendSxProp(_extends$e({}, r, {
    color: n
  })),
      _a$align = a.align,
      o = _a$align === void 0 ? "inherit" : _a$align,
      i = a.className,
      s = a.component,
      _a$gutterBottom = a.gutterBottom,
      l = _a$gutterBottom === void 0 ? !1 : _a$gutterBottom,
      _a$noWrap = a.noWrap,
      c = _a$noWrap === void 0 ? !1 : _a$noWrap,
      _a$paragraph = a.paragraph,
      u = _a$paragraph === void 0 ? !1 : _a$paragraph,
      _a$variant = a.variant,
      d = _a$variant === void 0 ? "body1" : _a$variant,
      _a$variantMapping = a.variantMapping,
      p = _a$variantMapping === void 0 ? defaultVariantMapping : _a$variantMapping,
      g = _objectWithoutPropertiesLoose$4(a, _excluded$s),
      m = _extends$e({}, a, {
    align: o,
    color: n,
    className: i,
    component: s,
    gutterBottom: l,
    noWrap: c,
    paragraph: u,
    variant: d,
    variantMapping: p
  }),
      f = s || (u ? "p" : p[d] || defaultVariantMapping[d]) || "span",
      h = useUtilityClasses$h(m);

  return jsx$1(TypographyRoot, _extends$e({
    as: f,
    ref: t,
    ownerState: m,
    className: clsx(h.root, i)
  }, g));
});

"production" !== process.env.NODE_ENV && (Typography.propTypes = {
  align: PropTypes.oneOf(["center", "inherit", "justify", "left", "right"]),
  children: PropTypes.node,
  classes: PropTypes.object,
  className: PropTypes.string,
  component: PropTypes.elementType,
  gutterBottom: PropTypes.bool,
  noWrap: PropTypes.bool,
  paragraph: PropTypes.bool,
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  variant: PropTypes.oneOfType([PropTypes.oneOf(["body1", "body2", "button", "caption", "h1", "h2", "h3", "h4", "h5", "h6", "inherit", "overline", "subtitle1", "subtitle2"]), PropTypes.string]),
  variantMapping: PropTypes.object
});
var Typography$1 = Typography;
var GridContext = React.createContext();

function getGridUtilityClass(e) {
  return generateUtilityClass("MuiGrid", e);
}

"production" !== process.env.NODE_ENV && (GridContext.displayName = "GridContext");
var SPACINGS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
    DIRECTIONS = ["column-reverse", "column", "row-reverse", "row"],
    WRAPS = ["nowrap", "wrap-reverse", "wrap"],
    GRID_SIZES = ["auto", !0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
    gridClasses = generateUtilityClasses("MuiGrid", ["root", "container", "item", "zeroMinWidth"].concat(_toConsumableArray(SPACINGS.map(function (e) {
  return "spacing-xs-".concat(e);
})), _toConsumableArray(DIRECTIONS.map(function (e) {
  return "direction-xs-".concat(e);
})), _toConsumableArray(WRAPS.map(function (e) {
  return "wrap-xs-".concat(e);
})), _toConsumableArray(GRID_SIZES.map(function (e) {
  return "grid-xs-".concat(e);
})), _toConsumableArray(GRID_SIZES.map(function (e) {
  return "grid-sm-".concat(e);
})), _toConsumableArray(GRID_SIZES.map(function (e) {
  return "grid-md-".concat(e);
})), _toConsumableArray(GRID_SIZES.map(function (e) {
  return "grid-lg-".concat(e);
})), _toConsumableArray(GRID_SIZES.map(function (e) {
  return "grid-xl-".concat(e);
})))),
    _excluded$r = ["className", "columns", "columnSpacing", "component", "container", "direction", "item", "lg", "md", "rowSpacing", "sm", "spacing", "wrap", "xl", "xs", "zeroMinWidth"];

function getOffset(e) {
  var t = parseFloat(e);
  return "".concat(t).concat(String(e).replace(String(t), "") || "px");
}

function generateGrid(_ref34) {
  var e = _ref34.theme,
      t = _ref34.ownerState;
  var r;
  return e.breakpoints.keys.reduce(function (n, a) {
    var o = {};
    if (t[a] && (r = t[a]), !r) return n;
    if (!0 === r) o = {
      flexBasis: 0,
      flexGrow: 1,
      maxWidth: "100%"
    };else if ("auto" === r) o = {
      flexBasis: "auto",
      flexGrow: 0,
      flexShrink: 0,
      maxWidth: "none",
      width: "auto"
    };else {
      var i = resolveBreakpointValues({
        values: t.columns,
        breakpoints: e.breakpoints.values
      }),
          s = "object" == typeof i ? i[a] : i;
      if (null == s) return n;

      var _l4 = Math.round(r / s * 1e8) / 1e6 + "%";

      var _c4 = {};

      if (t.container && t.item && 0 !== t.columnSpacing) {
        var _r28 = e.spacing(t.columnSpacing);

        if ("0px" !== _r28) {
          var _e43 = "calc(".concat(_l4, " + ").concat(getOffset(_r28), ")");

          _c4 = {
            flexBasis: _e43,
            maxWidth: _e43
          };
        }
      }

      o = _extends$e({
        flexBasis: _l4,
        flexGrow: 0,
        maxWidth: _l4
      }, _c4);
    }
    return 0 === e.breakpoints.values[a] ? Object.assign(n, o) : n[e.breakpoints.up(a)] = o, n;
  }, {});
}

function generateDirection(_ref35) {
  var e = _ref35.theme,
      t = _ref35.ownerState;
  return handleBreakpoints({
    theme: e
  }, resolveBreakpointValues({
    values: t.direction,
    breakpoints: e.breakpoints.values
  }), function (e) {
    var t = {
      flexDirection: e
    };
    return 0 === e.indexOf("column") && (t["& > .".concat(gridClasses.item)] = {
      maxWidth: "none"
    }), t;
  });
}

function generateRowGap(_ref36) {
  var e = _ref36.theme,
      t = _ref36.ownerState;
  var r = t.container,
      n = t.rowSpacing;
  var a = {};

  if (r && 0 !== n) {
    var _t34 = resolveBreakpointValues({
      values: n,
      breakpoints: e.breakpoints.values
    });

    a = handleBreakpoints({
      theme: e
    }, _t34, function (t) {
      var r = e.spacing(t);
      return "0px" !== r ? _defineProperty2({
        marginTop: "-".concat(getOffset(r))
      }, "& > .".concat(gridClasses.item), {
        paddingTop: getOffset(r)
      }) : {};
    });
  }

  return a;
}

function generateColumnGap(_ref38) {
  var e = _ref38.theme,
      t = _ref38.ownerState;
  var r = t.container,
      n = t.columnSpacing;
  var a = {};

  if (r && 0 !== n) {
    var _t35 = resolveBreakpointValues({
      values: n,
      breakpoints: e.breakpoints.values
    });

    a = handleBreakpoints({
      theme: e
    }, _t35, function (t) {
      var r = e.spacing(t);
      return "0px" !== r ? _defineProperty2({
        width: "calc(100% + ".concat(getOffset(r), ")"),
        marginLeft: "-".concat(getOffset(r))
      }, "& > .".concat(gridClasses.item), {
        paddingLeft: getOffset(r)
      }) : {};
    });
  }

  return a;
}

function resolveSpacingClasses(e, t) {
  var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  if (!t || !e || e <= 0) return [];
  if ("string" == typeof e && !Number.isNaN(Number(e)) || "number" == typeof e) return [r["spacing-xs-".concat(String(e))] || "spacing-xs-".concat(String(e))];
  var n = e.xs,
      a = e.sm,
      o = e.md,
      i = e.lg,
      s = e.xl;
  return [Number(n) > 0 && (r["spacing-xs-".concat(String(n))] || "spacing-xs-".concat(String(n))), Number(a) > 0 && (r["spacing-sm-".concat(String(a))] || "spacing-sm-".concat(String(a))), Number(o) > 0 && (r["spacing-md-".concat(String(o))] || "spacing-md-".concat(String(o))), Number(i) > 0 && (r["spacing-lg-".concat(String(i))] || "spacing-lg-".concat(String(i))), Number(s) > 0 && (r["spacing-xl-".concat(String(s))] || "spacing-xl-".concat(String(s)))];
}

var GridRoot = styled("div", {
  name: "MuiGrid",
  slot: "Root",
  overridesResolver: function overridesResolver(e, t) {
    var _e$ownerState2 = e.ownerState,
        r = _e$ownerState2.container,
        n = _e$ownerState2.direction,
        a = _e$ownerState2.item,
        o = _e$ownerState2.lg,
        i = _e$ownerState2.md,
        s = _e$ownerState2.sm,
        l = _e$ownerState2.spacing,
        c = _e$ownerState2.wrap,
        u = _e$ownerState2.xl,
        d = _e$ownerState2.xs,
        p = _e$ownerState2.zeroMinWidth;
    return [t.root, r && t.container, a && t.item, p && t.zeroMinWidth].concat(_toConsumableArray(resolveSpacingClasses(l, r, t)), ["row" !== n && t["direction-xs-".concat(String(n))], "wrap" !== c && t["wrap-xs-".concat(String(c))], !1 !== d && t["grid-xs-".concat(String(d))], !1 !== s && t["grid-sm-".concat(String(s))], !1 !== i && t["grid-md-".concat(String(i))], !1 !== o && t["grid-lg-".concat(String(o))], !1 !== u && t["grid-xl-".concat(String(u))]]);
  }
})(function (_ref40) {
  var e = _ref40.ownerState;
  return _extends$e({
    boxSizing: "border-box"
  }, e.container && {
    display: "flex",
    flexWrap: "wrap",
    width: "100%"
  }, e.item && {
    margin: 0
  }, e.zeroMinWidth && {
    minWidth: 0
  }, "wrap" !== e.wrap && {
    flexWrap: e.wrap
  });
}, generateDirection, generateRowGap, generateColumnGap, generateGrid),
    useUtilityClasses$g = function useUtilityClasses$g(e) {
  var t = e.classes,
      r = e.container,
      n = e.direction,
      a = e.item,
      o = e.lg,
      i = e.md,
      s = e.sm,
      l = e.spacing,
      c = e.wrap,
      u = e.xl,
      d = e.xs,
      p = e.zeroMinWidth;
  return composeClasses({
    root: ["root", r && "container", a && "item", p && "zeroMinWidth"].concat(_toConsumableArray(resolveSpacingClasses(l, r)), ["row" !== n && "direction-xs-".concat(String(n)), "wrap" !== c && "wrap-xs-".concat(String(c)), !1 !== d && "grid-xs-".concat(String(d)), !1 !== s && "grid-sm-".concat(String(s)), !1 !== i && "grid-md-".concat(String(i)), !1 !== o && "grid-lg-".concat(String(o)), !1 !== u && "grid-xl-".concat(String(u))])
  }, getGridUtilityClass, t);
},
    Grid = React.forwardRef(function (e, t) {
  var r = extendSxProp(useThemeProps({
    props: e,
    name: "MuiGrid"
  })),
      n = r.className,
      a = r.columns,
      o = r.columnSpacing,
      _r$component2 = r.component,
      i = _r$component2 === void 0 ? "div" : _r$component2,
      _r$container = r.container,
      s = _r$container === void 0 ? !1 : _r$container,
      _r$direction = r.direction,
      l = _r$direction === void 0 ? "row" : _r$direction,
      _r$item = r.item,
      c = _r$item === void 0 ? !1 : _r$item,
      _r$lg = r.lg,
      u = _r$lg === void 0 ? !1 : _r$lg,
      _r$md = r.md,
      d = _r$md === void 0 ? !1 : _r$md,
      p = r.rowSpacing,
      _r$sm = r.sm,
      g = _r$sm === void 0 ? !1 : _r$sm,
      _r$spacing = r.spacing,
      m = _r$spacing === void 0 ? 0 : _r$spacing,
      _r$wrap = r.wrap,
      f = _r$wrap === void 0 ? "wrap" : _r$wrap,
      _r$xl = r.xl,
      h = _r$xl === void 0 ? !1 : _r$xl,
      _r$xs = r.xs,
      b = _r$xs === void 0 ? !1 : _r$xs,
      _r$zeroMinWidth = r.zeroMinWidth,
      y = _r$zeroMinWidth === void 0 ? !1 : _r$zeroMinWidth,
      v = _objectWithoutPropertiesLoose$4(r, _excluded$r),
      _ = p || m,
      T = o || m,
      E = React.useContext(GridContext),
      S = a || E || 12,
      x = _extends$e({}, r, {
    columns: S,
    container: s,
    direction: l,
    item: c,
    lg: u,
    md: d,
    sm: g,
    rowSpacing: _,
    columnSpacing: T,
    wrap: f,
    xl: h,
    xs: b,
    zeroMinWidth: y
  }),
      w = useUtilityClasses$g(x);

  return C = jsx$1(GridRoot, _extends$e({
    ownerState: x,
    className: clsx(w.root, n),
    as: i,
    ref: t
  }, v)), 12 !== S ? jsx$1(GridContext.Provider, {
    value: S,
    children: C
  }) : C;
  var C;
});

if ("production" !== process.env.NODE_ENV && (Grid.propTypes = {
  children: PropTypes.node,
  classes: PropTypes.object,
  className: PropTypes.string,
  columns: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.number), PropTypes.number, PropTypes.object]),
  columnSpacing: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])), PropTypes.number, PropTypes.object, PropTypes.string]),
  component: PropTypes.elementType,
  container: PropTypes.bool,
  direction: PropTypes.oneOfType([PropTypes.oneOf(["column-reverse", "column", "row-reverse", "row"]), PropTypes.arrayOf(PropTypes.oneOf(["column-reverse", "column", "row-reverse", "row"])), PropTypes.object]),
  item: PropTypes.bool,
  lg: PropTypes.oneOfType([PropTypes.oneOf(["auto"]), PropTypes.number, PropTypes.bool]),
  md: PropTypes.oneOfType([PropTypes.oneOf(["auto"]), PropTypes.number, PropTypes.bool]),
  rowSpacing: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])), PropTypes.number, PropTypes.object, PropTypes.string]),
  sm: PropTypes.oneOfType([PropTypes.oneOf(["auto"]), PropTypes.number, PropTypes.bool]),
  spacing: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])), PropTypes.number, PropTypes.object, PropTypes.string]),
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  wrap: PropTypes.oneOf(["nowrap", "wrap-reverse", "wrap"]),
  xl: PropTypes.oneOfType([PropTypes.oneOf(["auto"]), PropTypes.number, PropTypes.bool]),
  xs: PropTypes.oneOfType([PropTypes.oneOf(["auto"]), PropTypes.number, PropTypes.bool]),
  zeroMinWidth: PropTypes.bool
}), "production" !== process.env.NODE_ENV) {
  var _e44 = requirePropFactory("Grid", Grid);

  Grid.propTypes = _extends$e({}, Grid.propTypes, {
    direction: _e44("container"),
    lg: _e44("item"),
    md: _e44("item"),
    sm: _e44("item"),
    spacing: _e44("container"),
    wrap: _e44("container"),
    xs: _e44("item"),
    zeroMinWidth: _e44("item")
  });
}

var Grid$1 = Grid;

function _extends$9() {
  return _extends$9 = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];

      for (var n in r) {
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
    }

    return e;
  }, _extends$9.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(e, t) {
  if (null == e) return {};
  var r,
      n,
      a = {},
      o = Object.keys(e);

  for (n = 0; n < o.length; n++) {
    r = o[n], t.indexOf(r) >= 0 || (a[r] = e[r]);
  }

  return a;
}

function _setPrototypeOf(e, t) {
  return _setPrototypeOf = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  }, _setPrototypeOf(e, t);
}

function _inheritsLoose(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, _setPrototypeOf(e, t);
}

function hasClass(e, t) {
  return e.classList ? !!t && e.classList.contains(t) : -1 !== (" " + (e.className.baseVal || e.className) + " ").indexOf(" " + t + " ");
}

function addClass(e, t) {
  e.classList ? e.classList.add(t) : hasClass(e, t) || ("string" == typeof e.className ? e.className = e.className + " " + t : e.setAttribute("class", (e.className && e.className.baseVal || "") + " " + t));
}

function replaceClassName(e, t) {
  return e.replace(new RegExp("(^|\\s)" + t + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}

function removeClass$1(e, t) {
  e.classList ? e.classList.remove(t) : "string" == typeof e.className ? e.className = replaceClassName(e.className, t) : e.setAttribute("class", replaceClassName(e.className && e.className.baseVal || "", t));
}

var config = {
  disabled: !1
},
    timeoutsShape = "production" !== process.env.NODE_ENV ? PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
  enter: PropTypes.number,
  exit: PropTypes.number,
  appear: PropTypes.number
}).isRequired]) : null,
    classNamesShape = "production" !== process.env.NODE_ENV ? PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
  enter: PropTypes.string,
  exit: PropTypes.string,
  active: PropTypes.string
}), PropTypes.shape({
  enter: PropTypes.string,
  enterDone: PropTypes.string,
  enterActive: PropTypes.string,
  exit: PropTypes.string,
  exitDone: PropTypes.string,
  exitActive: PropTypes.string
})]) : null,
    TransitionGroupContext = React__default.createContext(null),
    UNMOUNTED = "unmounted",
    EXITED = "exited",
    ENTERING = "entering",
    ENTERED = "entered",
    EXITING = "exiting",
    Transition = function (e) {
  function t(t, r) {
    var n;
    n = e.call(this, t, r) || this;
    var a,
        o = r && !r.isMounting ? t.enter : t.appear;
    return n.appearStatus = null, t.in ? o ? (a = EXITED, n.appearStatus = ENTERING) : a = ENTERED : a = t.unmountOnExit || t.mountOnEnter ? UNMOUNTED : EXITED, n.state = {
      status: a
    }, n.nextCallback = null, n;
  }

  _inheritsLoose(t, e), t.getDerivedStateFromProps = function (e, t) {
    return e.in && t.status === UNMOUNTED ? {
      status: EXITED
    } : null;
  };
  var r = t.prototype;
  return r.componentDidMount = function () {
    this.updateStatus(!0, this.appearStatus);
  }, r.componentDidUpdate = function (e) {
    var t = null;

    if (e !== this.props) {
      var r = this.state.status;
      this.props.in ? r !== ENTERING && r !== ENTERED && (t = ENTERING) : r !== ENTERING && r !== ENTERED || (t = EXITING);
    }

    this.updateStatus(!1, t);
  }, r.componentWillUnmount = function () {
    this.cancelNextCallback();
  }, r.getTimeouts = function () {
    var e,
        t,
        r,
        n = this.props.timeout;
    return e = t = r = n, null != n && "number" != typeof n && (e = n.exit, t = n.enter, r = void 0 !== n.appear ? n.appear : t), {
      exit: e,
      enter: t,
      appear: r
    };
  }, r.updateStatus = function (e, t) {
    void 0 === e && (e = !1), null !== t ? (this.cancelNextCallback(), t === ENTERING ? this.performEnter(e) : this.performExit()) : this.props.unmountOnExit && this.state.status === EXITED && this.setState({
      status: UNMOUNTED
    });
  }, r.performEnter = function (e) {
    var t = this,
        r = this.props.enter,
        n = this.context ? this.context.isMounting : e,
        a = this.props.nodeRef ? [n] : [ReactDOM__default.findDOMNode(this), n],
        o = a[0],
        i = a[1],
        s = this.getTimeouts(),
        l = n ? s.appear : s.enter;
    !e && !r || config.disabled ? this.safeSetState({
      status: ENTERED
    }, function () {
      t.props.onEntered(o);
    }) : (this.props.onEnter(o, i), this.safeSetState({
      status: ENTERING
    }, function () {
      t.props.onEntering(o, i), t.onTransitionEnd(l, function () {
        t.safeSetState({
          status: ENTERED
        }, function () {
          t.props.onEntered(o, i);
        });
      });
    }));
  }, r.performExit = function () {
    var e = this,
        t = this.props.exit,
        r = this.getTimeouts(),
        n = this.props.nodeRef ? void 0 : ReactDOM__default.findDOMNode(this);
    t && !config.disabled ? (this.props.onExit(n), this.safeSetState({
      status: EXITING
    }, function () {
      e.props.onExiting(n), e.onTransitionEnd(r.exit, function () {
        e.safeSetState({
          status: EXITED
        }, function () {
          e.props.onExited(n);
        });
      });
    })) : this.safeSetState({
      status: EXITED
    }, function () {
      e.props.onExited(n);
    });
  }, r.cancelNextCallback = function () {
    null !== this.nextCallback && (this.nextCallback.cancel(), this.nextCallback = null);
  }, r.safeSetState = function (e, t) {
    t = this.setNextCallback(t), this.setState(e, t);
  }, r.setNextCallback = function (e) {
    var t = this,
        r = !0;
    return this.nextCallback = function (n) {
      r && (r = !1, t.nextCallback = null, e(n));
    }, this.nextCallback.cancel = function () {
      r = !1;
    }, this.nextCallback;
  }, r.onTransitionEnd = function (e, t) {
    this.setNextCallback(t);
    var r = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM__default.findDOMNode(this),
        n = null == e && !this.props.addEndListener;

    if (r && !n) {
      if (this.props.addEndListener) {
        var a = this.props.nodeRef ? [this.nextCallback] : [r, this.nextCallback],
            o = a[0],
            i = a[1];
        this.props.addEndListener(o, i);
      }

      null != e && setTimeout(this.nextCallback, e);
    } else setTimeout(this.nextCallback, 0);
  }, r.render = function () {
    var e = this.state.status;
    if (e === UNMOUNTED) return null;
    var t = this.props,
        r = t.children;
    t.in, t.mountOnEnter, t.unmountOnExit, t.appear, t.enter, t.exit, t.timeout, t.addEndListener, t.onEnter, t.onEntering, t.onEntered, t.onExit, t.onExiting, t.onExited, t.nodeRef;

    var n = _objectWithoutPropertiesLoose(t, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);

    return React__default.createElement(TransitionGroupContext.Provider, {
      value: null
    }, "function" == typeof r ? r(e, n) : React__default.cloneElement(React__default.Children.only(r), n));
  }, t;
}(React__default.Component);

function noop$1() {}

Transition.contextType = TransitionGroupContext, Transition.propTypes = "production" !== process.env.NODE_ENV ? {
  nodeRef: PropTypes.shape({
    current: "undefined" == typeof Element ? PropTypes.any : function (e, t, r, n, a, o) {
      var i = e[t];
      return PropTypes.instanceOf(i && "ownerDocument" in i ? i.ownerDocument.defaultView.Element : Element)(e, t, r, n, a, o);
    }
  }),
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,
  in: PropTypes.bool,
  mountOnEnter: PropTypes.bool,
  unmountOnExit: PropTypes.bool,
  appear: PropTypes.bool,
  enter: PropTypes.bool,
  exit: PropTypes.bool,
  timeout: function timeout(e) {
    var t = timeoutsShape;
    e.addEndListener || (t = t.isRequired);

    for (var r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), a = 1; a < r; a++) {
      n[a - 1] = arguments[a];
    }

    return t.apply(void 0, [e].concat(n));
  },
  addEndListener: PropTypes.func,
  onEnter: PropTypes.func,
  onEntering: PropTypes.func,
  onEntered: PropTypes.func,
  onExit: PropTypes.func,
  onExiting: PropTypes.func,
  onExited: PropTypes.func
} : {}, Transition.defaultProps = {
  in: !1,
  mountOnEnter: !1,
  unmountOnExit: !1,
  appear: !1,
  enter: !0,
  exit: !0,
  onEnter: noop$1,
  onEntering: noop$1,
  onEntered: noop$1,
  onExit: noop$1,
  onExiting: noop$1,
  onExited: noop$1
}, Transition.UNMOUNTED = UNMOUNTED, Transition.EXITED = EXITED, Transition.ENTERING = ENTERING, Transition.ENTERED = ENTERED, Transition.EXITING = EXITING;

var Transition$1 = Transition,
    _addClass = function _addClass(e, t) {
  return e && t && t.split(" ").forEach(function (t) {
    return addClass(e, t);
  });
},
    removeClass = function removeClass(e, t) {
  return e && t && t.split(" ").forEach(function (t) {
    return removeClass$1(e, t);
  });
},
    CSSTransition = function (e) {
  function t() {
    for (var t, r = arguments.length, n = new Array(r), a = 0; a < r; a++) {
      n[a] = arguments[a];
    }

    return (t = e.call.apply(e, [this].concat(n)) || this).appliedClasses = {
      appear: {},
      enter: {},
      exit: {}
    }, t.onEnter = function (e, r) {
      var n = t.resolveArguments(e, r),
          a = n[0],
          o = n[1];
      t.removeClasses(a, "exit"), t.addClass(a, o ? "appear" : "enter", "base"), t.props.onEnter && t.props.onEnter(e, r);
    }, t.onEntering = function (e, r) {
      var n = t.resolveArguments(e, r),
          a = n[0],
          o = n[1] ? "appear" : "enter";
      t.addClass(a, o, "active"), t.props.onEntering && t.props.onEntering(e, r);
    }, t.onEntered = function (e, r) {
      var n = t.resolveArguments(e, r),
          a = n[0],
          o = n[1] ? "appear" : "enter";
      t.removeClasses(a, o), t.addClass(a, o, "done"), t.props.onEntered && t.props.onEntered(e, r);
    }, t.onExit = function (e) {
      var r = t.resolveArguments(e)[0];
      t.removeClasses(r, "appear"), t.removeClasses(r, "enter"), t.addClass(r, "exit", "base"), t.props.onExit && t.props.onExit(e);
    }, t.onExiting = function (e) {
      var r = t.resolveArguments(e)[0];
      t.addClass(r, "exit", "active"), t.props.onExiting && t.props.onExiting(e);
    }, t.onExited = function (e) {
      var r = t.resolveArguments(e)[0];
      t.removeClasses(r, "exit"), t.addClass(r, "exit", "done"), t.props.onExited && t.props.onExited(e);
    }, t.resolveArguments = function (e, r) {
      return t.props.nodeRef ? [t.props.nodeRef.current, e] : [e, r];
    }, t.getClassNames = function (e) {
      var r = t.props.classNames,
          n = "string" == typeof r,
          a = n ? "" + (n && r ? r + "-" : "") + e : r[e];
      return {
        baseClassName: a,
        activeClassName: n ? a + "-active" : r[e + "Active"],
        doneClassName: n ? a + "-done" : r[e + "Done"]
      };
    }, t;
  }

  _inheritsLoose(t, e);

  var r = t.prototype;
  return r.addClass = function (e, t, r) {
    var n = this.getClassNames(t)[r + "ClassName"],
        a = this.getClassNames("enter").doneClassName;
    "appear" === t && "done" === r && a && (n += " " + a), "active" === r && e && e.scrollTop, n && (this.appliedClasses[t][r] = n, _addClass(e, n));
  }, r.removeClasses = function (e, t) {
    var r = this.appliedClasses[t],
        n = r.base,
        a = r.active,
        o = r.done;
    this.appliedClasses[t] = {}, n && removeClass(e, n), a && removeClass(e, a), o && removeClass(e, o);
  }, r.render = function () {
    var e = this.props;
    e.classNames;

    var t = _objectWithoutPropertiesLoose(e, ["classNames"]);

    return React__default.createElement(Transition$1, _extends$9({}, t, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  }, t;
}(React__default.Component);

CSSTransition.defaultProps = {
  classNames: ""
}, CSSTransition.propTypes = "production" !== process.env.NODE_ENV ? _extends$9({}, Transition$1.propTypes, {
  classNames: classNamesShape,
  onEnter: PropTypes.func,
  onEntering: PropTypes.func,
  onEntered: PropTypes.func,
  onExit: PropTypes.func,
  onExiting: PropTypes.func,
  onExited: PropTypes.func
}) : {};
var CSSTransition$1 = CSSTransition;

function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}

function getChildMapping(e, t) {
  var r = Object.create(null);
  return e && Children.map(e, function (e) {
    return e;
  }).forEach(function (e) {
    r[e.key] = function (e) {
      return t && isValidElement(e) ? t(e) : e;
    }(e);
  }), r;
}

function mergeChildMappings(e, t) {
  function r(r) {
    return r in t ? t[r] : e[r];
  }

  e = e || {}, t = t || {};
  var n,
      a = Object.create(null),
      o = [];

  for (var i in e) {
    i in t ? o.length && (a[i] = o, o = []) : o.push(i);
  }

  var s = {};

  for (var l in t) {
    if (a[l]) for (n = 0; n < a[l].length; n++) {
      var c = a[l][n];
      s[a[l][n]] = r(c);
    }
    s[l] = r(l);
  }

  for (n = 0; n < o.length; n++) {
    s[o[n]] = r(o[n]);
  }

  return s;
}

function getProp(e, t, r) {
  return null != r[t] ? r[t] : e.props[t];
}

function getInitialChildMapping(e, t) {
  return getChildMapping(e.children, function (r) {
    return cloneElement(r, {
      onExited: t.bind(null, r),
      in: !0,
      appear: getProp(r, "appear", e),
      enter: getProp(r, "enter", e),
      exit: getProp(r, "exit", e)
    });
  });
}

function getNextChildMapping(e, t, r) {
  var n = getChildMapping(e.children),
      a = mergeChildMappings(t, n);
  return Object.keys(a).forEach(function (o) {
    var i = a[o];

    if (isValidElement(i)) {
      var s = (o in t),
          l = (o in n),
          c = t[o],
          u = isValidElement(c) && !c.props.in;
      !l || s && !u ? l || !s || u ? l && s && isValidElement(c) && (a[o] = cloneElement(i, {
        onExited: r.bind(null, i),
        in: c.props.in,
        exit: getProp(i, "exit", e),
        enter: getProp(i, "enter", e)
      })) : a[o] = cloneElement(i, {
        in: !1
      }) : a[o] = cloneElement(i, {
        onExited: r.bind(null, i),
        in: !0,
        exit: getProp(i, "exit", e),
        enter: getProp(i, "enter", e)
      });
    }
  }), a;
}

var values = Object.values || function (e) {
  return Object.keys(e).map(function (t) {
    return e[t];
  });
},
    defaultProps = {
  component: "div",
  childFactory: function childFactory(e) {
    return e;
  }
},
    TransitionGroup = function (e) {
  function t(t, r) {
    var n,
        a = (n = e.call(this, t, r) || this).handleExited.bind(_assertThisInitialized(n));
    return n.state = {
      contextValue: {
        isMounting: !0
      },
      handleExited: a,
      firstRender: !0
    }, n;
  }

  _inheritsLoose(t, e);

  var r = t.prototype;
  return r.componentDidMount = function () {
    this.mounted = !0, this.setState({
      contextValue: {
        isMounting: !1
      }
    });
  }, r.componentWillUnmount = function () {
    this.mounted = !1;
  }, t.getDerivedStateFromProps = function (e, t) {
    var r = t.children,
        n = t.handleExited;
    return {
      children: t.firstRender ? getInitialChildMapping(e, n) : getNextChildMapping(e, r, n),
      firstRender: !1
    };
  }, r.handleExited = function (e, t) {
    var r = getChildMapping(this.props.children);
    e.key in r || (e.props.onExited && e.props.onExited(t), this.mounted && this.setState(function (t) {
      var r = _extends$9({}, t.children);

      return delete r[e.key], {
        children: r
      };
    }));
  }, r.render = function () {
    var e = this.props,
        t = e.component,
        r = e.childFactory,
        n = _objectWithoutPropertiesLoose(e, ["component", "childFactory"]),
        a = this.state.contextValue,
        o = values(this.state.children).map(r);

    return delete n.appear, delete n.enter, delete n.exit, null === t ? React__default.createElement(TransitionGroupContext.Provider, {
      value: a
    }, o) : React__default.createElement(TransitionGroupContext.Provider, {
      value: a
    }, React__default.createElement(t, n, o));
  }, t;
}(React__default.Component);

TransitionGroup.propTypes = "production" !== process.env.NODE_ENV ? {
  component: PropTypes.any,
  children: PropTypes.node,
  appear: PropTypes.bool,
  enter: PropTypes.bool,
  exit: PropTypes.bool,
  childFactory: PropTypes.func
} : {}, TransitionGroup.defaultProps = defaultProps;
var TransitionGroup$1 = TransitionGroup;

function Ripple(e) {
  var t = e.className,
      r = e.classes,
      _e$pulsate = e.pulsate,
      n = _e$pulsate === void 0 ? !1 : _e$pulsate,
      a = e.rippleX,
      o = e.rippleY,
      i = e.rippleSize,
      s = e.in,
      l = e.onExited,
      c = e.timeout,
      _React$useState9 = React.useState(!1),
      _React$useState10 = _slicedToArray(_React$useState9, 2),
      u = _React$useState10[0],
      d = _React$useState10[1],
      p = clsx(t, r.ripple, r.rippleVisible, n && r.ripplePulsate),
      g = {
    width: i,
    height: i,
    top: -i / 2 + o,
    left: -i / 2 + a
  },
      m = clsx(r.child, u && r.childLeaving, n && r.childPulsate);

  return s || u || d(!0), React.useEffect(function () {
    if (!s && null != l) {
      var _e45 = setTimeout(l, c);

      return function () {
        clearTimeout(_e45);
      };
    }
  }, [l, s, c]), jsx$1("span", {
    className: p,
    style: g,
    children: jsx$1("span", {
      className: m
    })
  });
}

"production" !== process.env.NODE_ENV && (Ripple.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  in: PropTypes.bool,
  onExited: PropTypes.func,
  pulsate: PropTypes.bool,
  rippleSize: PropTypes.number,
  rippleX: PropTypes.number,
  rippleY: PropTypes.number,
  timeout: PropTypes.number.isRequired
});
var touchRippleClasses = generateUtilityClasses("MuiTouchRipple", ["root", "ripple", "rippleVisible", "ripplePulsate", "child", "childLeaving", "childPulsate"]),
    _excluded$q = ["center", "classes", "className"];

var _ = function _(e) {
  return e;
},
    _t,
    _t2,
    _t3,
    _t4;

var DURATION = 550,
    DELAY_RIPPLE = 80,
    enterKeyframe = keyframes(_t || (_t = _(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  0% {\n    transform: scale(0);\n    opacity: 0.1;\n  }\n\n  100% {\n    transform: scale(1);\n    opacity: 0.3;\n  }\n"]))))),
    exitKeyframe = keyframes(_t2 || (_t2 = _(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  0% {\n    opacity: 1;\n  }\n\n  100% {\n    opacity: 0;\n  }\n"]))))),
    pulsateKeyframe = keyframes(_t3 || (_t3 = _(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  0% {\n    transform: scale(1);\n  }\n\n  50% {\n    transform: scale(0.92);\n  }\n\n  100% {\n    transform: scale(1);\n  }\n"]))))),
    TouchRippleRoot = styled("span", {
  name: "MuiTouchRipple",
  slot: "Root"
})({
  overflow: "hidden",
  pointerEvents: "none",
  position: "absolute",
  zIndex: 0,
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  borderRadius: "inherit"
}),
    TouchRippleRipple = styled(Ripple, {
  name: "MuiTouchRipple",
  slot: "Ripple"
})(_t4 || (_t4 = _(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  opacity: 0;\n  position: absolute;\n\n  &.", " {\n    opacity: 0.3;\n    transform: scale(1);\n    animation-name: ", ";\n    animation-duration: ", "ms;\n    animation-timing-function: ", ";\n  }\n\n  &.", " {\n    animation-duration: ", "ms;\n  }\n\n  & .", " {\n    opacity: 1;\n    display: block;\n    width: 100%;\n    height: 100%;\n    border-radius: 50%;\n    background-color: currentColor;\n  }\n\n  & .", " {\n    opacity: 0;\n    animation-name: ", ";\n    animation-duration: ", "ms;\n    animation-timing-function: ", ";\n  }\n\n  & .", " {\n    position: absolute;\n    /* @noflip */\n    left: 0px;\n    top: 0;\n    animation-name: ", ";\n    animation-duration: 2500ms;\n    animation-timing-function: ", ";\n    animation-iteration-count: infinite;\n    animation-delay: 200ms;\n  }\n"])), 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0)), touchRippleClasses.rippleVisible, enterKeyframe, DURATION, function (_ref41) {
  var e = _ref41.theme;
  return e.transitions.easing.easeInOut;
}, touchRippleClasses.ripplePulsate, function (_ref42) {
  var e = _ref42.theme;
  return e.transitions.duration.shorter;
}, touchRippleClasses.child, touchRippleClasses.childLeaving, exitKeyframe, DURATION, function (_ref43) {
  var e = _ref43.theme;
  return e.transitions.easing.easeInOut;
}, touchRippleClasses.childPulsate, pulsateKeyframe, function (_ref44) {
  var e = _ref44.theme;
  return e.transitions.easing.easeInOut;
}),
    TouchRipple = React.forwardRef(function (e, t) {
  var r = useThemeProps({
    props: e,
    name: "MuiTouchRipple"
  }),
      _r$center = r.center,
      n = _r$center === void 0 ? !1 : _r$center,
      _r$classes = r.classes,
      a = _r$classes === void 0 ? {} : _r$classes,
      o = r.className,
      i = _objectWithoutPropertiesLoose$4(r, _excluded$q),
      _React$useState11 = React.useState([]),
      _React$useState12 = _slicedToArray(_React$useState11, 2),
      s = _React$useState12[0],
      l = _React$useState12[1],
      c = React.useRef(0),
      u = React.useRef(null);

  React.useEffect(function () {
    u.current && (u.current(), u.current = null);
  }, [s]);
  var d = React.useRef(!1),
      p = React.useRef(null),
      g = React.useRef(null),
      m = React.useRef(null);
  React.useEffect(function () {
    return function () {
      clearTimeout(p.current);
    };
  }, []);
  var f = React.useCallback(function (e) {
    var t = e.pulsate,
        r = e.rippleX,
        n = e.rippleY,
        o = e.rippleSize,
        i = e.cb;
    l(function (e) {
      return [].concat(_toConsumableArray(e), [jsx$1(TouchRippleRipple, {
        classes: {
          ripple: clsx(a.ripple, touchRippleClasses.ripple),
          rippleVisible: clsx(a.rippleVisible, touchRippleClasses.rippleVisible),
          ripplePulsate: clsx(a.ripplePulsate, touchRippleClasses.ripplePulsate),
          child: clsx(a.child, touchRippleClasses.child),
          childLeaving: clsx(a.childLeaving, touchRippleClasses.childLeaving),
          childPulsate: clsx(a.childPulsate, touchRippleClasses.childPulsate)
        },
        timeout: DURATION,
        pulsate: t,
        rippleX: r,
        rippleY: n,
        rippleSize: o
      }, c.current)]);
    }), c.current += 1, u.current = i;
  }, [a]),
      h = React.useCallback(function () {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var r = arguments.length > 2 ? arguments[2] : undefined;
    var _t$pulsate = t.pulsate,
        a = _t$pulsate === void 0 ? !1 : _t$pulsate,
        _t$center = t.center,
        o = _t$center === void 0 ? n || t.pulsate : _t$center,
        _t$fakeElement = t.fakeElement,
        i = _t$fakeElement === void 0 ? !1 : _t$fakeElement;
    if ("mousedown" === e.type && d.current) return void (d.current = !1);
    "touchstart" === e.type && (d.current = !0);
    var s = i ? null : m.current,
        l = s ? s.getBoundingClientRect() : {
      width: 0,
      height: 0,
      left: 0,
      top: 0
    };
    var c, u, h;
    if (o || 0 === e.clientX && 0 === e.clientY || !e.clientX && !e.touches) c = Math.round(l.width / 2), u = Math.round(l.height / 2);else {
      var _ref45 = e.touches ? e.touches[0] : e,
          _t36 = _ref45.clientX,
          _r29 = _ref45.clientY;

      c = Math.round(_t36 - l.left), u = Math.round(_r29 - l.top);
    }
    if (o) h = Math.sqrt((2 * Math.pow(l.width, 2) + Math.pow(l.height, 2)) / 3), h % 2 == 0 && (h += 1);else {
      var _e46 = 2 * Math.max(Math.abs((s ? s.clientWidth : 0) - c), c) + 2,
          _t37 = 2 * Math.max(Math.abs((s ? s.clientHeight : 0) - u), u) + 2;

      h = Math.sqrt(Math.pow(_e46, 2) + Math.pow(_t37, 2));
    }
    e.touches ? null === g.current && (g.current = function () {
      f({
        pulsate: a,
        rippleX: c,
        rippleY: u,
        rippleSize: h,
        cb: r
      });
    }, p.current = setTimeout(function () {
      g.current && (g.current(), g.current = null);
    }, DELAY_RIPPLE)) : f({
      pulsate: a,
      rippleX: c,
      rippleY: u,
      rippleSize: h,
      cb: r
    });
  }, [n, f]),
      b = React.useCallback(function () {
    h({}, {
      pulsate: !0
    });
  }, [h]),
      y = React.useCallback(function (e, t) {
    if (clearTimeout(p.current), "touchend" === e.type && g.current) return g.current(), g.current = null, void (p.current = setTimeout(function () {
      y(e, t);
    }));
    g.current = null, l(function (e) {
      return e.length > 0 ? e.slice(1) : e;
    }), u.current = t;
  }, []);
  return React.useImperativeHandle(t, function () {
    return {
      pulsate: b,
      start: h,
      stop: y
    };
  }, [b, h, y]), jsx$1(TouchRippleRoot, _extends$e({
    className: clsx(a.root, touchRippleClasses.root, o),
    ref: m
  }, i, {
    children: jsx$1(TransitionGroup$1, {
      component: null,
      exit: !0,
      children: s
    })
  }));
});

function getButtonBaseUtilityClass(e) {
  return generateUtilityClass("MuiButtonBase", e);
}

"production" !== process.env.NODE_ENV && (TouchRipple.propTypes = {
  center: PropTypes.bool,
  classes: PropTypes.object,
  className: PropTypes.string
});

var buttonBaseClasses = generateUtilityClasses("MuiButtonBase", ["root", "disabled", "focusVisible"]),
    _excluded$p = ["action", "centerRipple", "children", "className", "component", "disabled", "disableRipple", "disableTouchRipple", "focusRipple", "focusVisibleClassName", "LinkComponent", "onBlur", "onClick", "onContextMenu", "onDragLeave", "onFocus", "onFocusVisible", "onKeyDown", "onKeyUp", "onMouseDown", "onMouseLeave", "onMouseUp", "onTouchEnd", "onTouchMove", "onTouchStart", "tabIndex", "TouchRippleProps", "touchRippleRef", "type"],
    useUtilityClasses$f = function useUtilityClasses$f(e) {
  var t = e.disabled,
      r = e.focusVisible,
      n = e.focusVisibleClassName,
      a = e.classes,
      o = composeClasses({
    root: ["root", t && "disabled", r && "focusVisible"]
  }, getButtonBaseUtilityClass, a);
  return r && n && (o.root += " ".concat(n)), o;
},
    ButtonBaseRoot = styled("button", {
  name: "MuiButtonBase",
  slot: "Root",
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})((_styled = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  boxSizing: "border-box",
  WebkitTapHighlightColor: "transparent",
  backgroundColor: "transparent",
  outline: 0,
  border: 0,
  margin: 0,
  borderRadius: 0,
  padding: 0,
  cursor: "pointer",
  userSelect: "none",
  verticalAlign: "middle",
  MozAppearance: "none",
  WebkitAppearance: "none",
  textDecoration: "none",
  color: "inherit",
  "&::-moz-focus-inner": {
    borderStyle: "none"
  }
}, _defineProperty2(_styled, "&.".concat(buttonBaseClasses.disabled), {
  pointerEvents: "none",
  cursor: "default"
}), _defineProperty2(_styled, "@media print", {
  colorAdjust: "exact"
}), _styled)),
    ButtonBase = React.forwardRef(function (e, t) {
  var r = useThemeProps({
    props: e,
    name: "MuiButtonBase"
  }),
      n = r.action,
      _r$centerRipple = r.centerRipple,
      a = _r$centerRipple === void 0 ? !1 : _r$centerRipple,
      o = r.children,
      i = r.className,
      _r$component3 = r.component,
      s = _r$component3 === void 0 ? "button" : _r$component3,
      _r$disabled = r.disabled,
      l = _r$disabled === void 0 ? !1 : _r$disabled,
      _r$disableRipple = r.disableRipple,
      c = _r$disableRipple === void 0 ? !1 : _r$disableRipple,
      _r$disableTouchRipple = r.disableTouchRipple,
      u = _r$disableTouchRipple === void 0 ? !1 : _r$disableTouchRipple,
      _r$focusRipple = r.focusRipple,
      d = _r$focusRipple === void 0 ? !1 : _r$focusRipple,
      _r$LinkComponent = r.LinkComponent,
      p = _r$LinkComponent === void 0 ? "a" : _r$LinkComponent,
      g = r.onBlur,
      m = r.onClick,
      f = r.onContextMenu,
      h = r.onDragLeave,
      b = r.onFocus,
      y = r.onFocusVisible,
      v = r.onKeyDown,
      _ = r.onKeyUp,
      T = r.onMouseDown,
      E = r.onMouseLeave,
      S = r.onMouseUp,
      x = r.onTouchEnd,
      w = r.onTouchMove,
      C = r.onTouchStart,
      _r$tabIndex = r.tabIndex,
      k = _r$tabIndex === void 0 ? 0 : _r$tabIndex,
      $ = r.TouchRippleProps,
      R = r.touchRippleRef,
      A = r.type,
      I = _objectWithoutPropertiesLoose$4(r, _excluded$p),
      N = React.useRef(null),
      P = React.useRef(null),
      O = useForkRef(P, R),
      _useIsFocusVisible = useIsFocusVisible(),
      D = _useIsFocusVisible.isFocusVisibleRef,
      L = _useIsFocusVisible.onFocus,
      M = _useIsFocusVisible.onBlur,
      F = _useIsFocusVisible.ref,
      _React$useState13 = React.useState(!1),
      _React$useState14 = _slicedToArray(_React$useState13, 2),
      j = _React$useState14[0],
      B = _React$useState14[1];

  function U(e, t) {
    var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : u;
    return useEventCallback(function (n) {
      t && t(n);
      return !r && P.current && P.current[e](n), !0;
    });
  }

  l && j && B(!1), React.useImperativeHandle(n, function () {
    return {
      focusVisible: function focusVisible() {
        B(!0), N.current.focus();
      }
    };
  }, []), React.useEffect(function () {
    j && d && !c && P.current.pulsate();
  }, [c, d, j]);

  var G = U("start", T),
      q = U("stop", f),
      H = U("stop", h),
      z = U("stop", S),
      W = U("stop", function (e) {
    j && e.preventDefault(), E && E(e);
  }),
      V = U("start", C),
      Y = U("stop", x),
      K = U("stop", w),
      X = U("stop", function (e) {
    M(e), !1 === D.current && B(!1), g && g(e);
  }, !1),
      Z = useEventCallback(function (e) {
    N.current || (N.current = e.currentTarget), L(e), !0 === D.current && (B(!0), y && y(e)), b && b(e);
  }),
      Q = function Q() {
    var e = N.current;
    return s && "button" !== s && !("A" === e.tagName && e.href);
  },
      J = React.useRef(!1),
      ee = useEventCallback(function (e) {
    d && !J.current && j && P.current && " " === e.key && (J.current = !0, P.current.stop(e, function () {
      P.current.start(e);
    })), e.target === e.currentTarget && Q() && " " === e.key && e.preventDefault(), v && v(e), e.target === e.currentTarget && Q() && "Enter" === e.key && !l && (e.preventDefault(), m && m(e));
  }),
      te = useEventCallback(function (e) {
    d && " " === e.key && P.current && j && !e.defaultPrevented && (J.current = !1, P.current.stop(e, function () {
      P.current.pulsate(e);
    })), _ && _(e), m && e.target === e.currentTarget && Q() && " " === e.key && !e.defaultPrevented && m(e);
  });

  var re = s;
  "button" === re && (I.href || I.to) && (re = p);
  var ne = {};
  "button" === re ? (ne.type = void 0 === A ? "button" : A, ne.disabled = l) : (I.href || I.to || (ne.role = "button"), l && (ne["aria-disabled"] = l));

  var ae = useForkRef(F, N),
      oe = useForkRef(t, ae),
      _React$useState15 = React.useState(!1),
      _React$useState16 = _slicedToArray(_React$useState15, 2),
      ie = _React$useState16[0],
      se = _React$useState16[1];

  React.useEffect(function () {
    se(!0);
  }, []);
  var le = ie && !c && !l;
  "production" !== process.env.NODE_ENV && React.useEffect(function () {
    le && !P.current && console.error(["MUI: The `component` prop provided to ButtonBase is invalid.", "Please make sure the children prop is rendered in this custom component."].join("\n"));
  }, [le]);

  var ce = _extends$e({}, r, {
    centerRipple: a,
    component: s,
    disabled: l,
    disableRipple: c,
    disableTouchRipple: u,
    focusRipple: d,
    tabIndex: k,
    focusVisible: j
  }),
      ue = useUtilityClasses$f(ce);

  return jsxs(ButtonBaseRoot, _extends$e({
    as: re,
    className: clsx(ue.root, i),
    ownerState: ce,
    onBlur: X,
    onClick: m,
    onContextMenu: q,
    onFocus: Z,
    onKeyDown: ee,
    onKeyUp: te,
    onMouseDown: G,
    onMouseLeave: W,
    onMouseUp: z,
    onDragLeave: H,
    onTouchEnd: Y,
    onTouchMove: K,
    onTouchStart: V,
    ref: oe,
    tabIndex: l ? -1 : k,
    type: A
  }, ne, I, {
    children: [o, le ? jsx$1(TouchRipple, _extends$e({
      ref: O,
      center: a
    }, $)) : null]
  }));
});

function getIconButtonUtilityClass(e) {
  return generateUtilityClass("MuiIconButton", e);
}

"production" !== process.env.NODE_ENV && (ButtonBase.propTypes = {
  action: refType$1,
  centerRipple: PropTypes.bool,
  children: PropTypes.node,
  classes: PropTypes.object,
  className: PropTypes.string,
  component: elementTypeAcceptingRef$1,
  disabled: PropTypes.bool,
  disableRipple: PropTypes.bool,
  disableTouchRipple: PropTypes.bool,
  focusRipple: PropTypes.bool,
  focusVisibleClassName: PropTypes.string,
  href: PropTypes.any,
  LinkComponent: PropTypes.elementType,
  onBlur: PropTypes.func,
  onClick: PropTypes.func,
  onContextMenu: PropTypes.func,
  onDragLeave: PropTypes.func,
  onFocus: PropTypes.func,
  onFocusVisible: PropTypes.func,
  onKeyDown: PropTypes.func,
  onKeyUp: PropTypes.func,
  onMouseDown: PropTypes.func,
  onMouseLeave: PropTypes.func,
  onMouseUp: PropTypes.func,
  onTouchEnd: PropTypes.func,
  onTouchMove: PropTypes.func,
  onTouchStart: PropTypes.func,
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  tabIndex: PropTypes.number,
  TouchRippleProps: PropTypes.object,
  touchRippleRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.shape({
      pulsate: PropTypes.func.isRequired,
      start: PropTypes.func.isRequired,
      stop: PropTypes.func.isRequired
    })
  })]),
  type: PropTypes.oneOfType([PropTypes.oneOf(["button", "reset", "submit"]), PropTypes.string])
});

var iconButtonClasses = generateUtilityClasses("MuiIconButton", ["root", "disabled", "colorInherit", "colorPrimary", "colorSecondary", "edgeStart", "edgeEnd", "sizeSmall", "sizeMedium", "sizeLarge"]),
    _excluded$o = ["edge", "children", "className", "color", "disabled", "disableFocusRipple", "size"],
    useUtilityClasses$e = function useUtilityClasses$e(e) {
  var t = e.classes,
      r = e.disabled,
      n = e.color,
      a = e.edge,
      o = e.size;
  return composeClasses({
    root: ["root", r && "disabled", "default" !== n && "color".concat(capitalize(n)), a && "edge".concat(capitalize(a)), "size".concat(capitalize(o))]
  }, getIconButtonUtilityClass, t);
},
    IconButtonRoot = styled(ButtonBase, {
  name: "MuiIconButton",
  slot: "Root",
  overridesResolver: function overridesResolver(e, t) {
    var r = e.ownerState;
    return [t.root, "default" !== r.color && t["color".concat(capitalize(r.color))], r.edge && t["edge".concat(capitalize(r.edge))], t["size".concat(capitalize(r.size))]];
  }
})(function (_ref46) {
  var e = _ref46.theme,
      t = _ref46.ownerState;
  return _extends$e({
    textAlign: "center",
    flex: "0 0 auto",
    fontSize: e.typography.pxToRem(24),
    padding: 8,
    borderRadius: "50%",
    overflow: "visible",
    color: e.palette.action.active,
    transition: e.transitions.create("background-color", {
      duration: e.transitions.duration.shortest
    })
  }, !t.disableRipple && {
    "&:hover": {
      backgroundColor: alpha(e.palette.action.active, e.palette.action.hoverOpacity),
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    }
  }, "start" === t.edge && {
    marginLeft: "small" === t.size ? -3 : -12
  }, "end" === t.edge && {
    marginRight: "small" === t.size ? -3 : -12
  });
}, function (_ref47) {
  var e = _ref47.theme,
      t = _ref47.ownerState;
  return _extends$e({}, "inherit" === t.color && {
    color: "inherit"
  }, "inherit" !== t.color && "default" !== t.color && _extends$e({
    color: e.palette[t.color].main
  }, !t.disableRipple && {
    "&:hover": {
      backgroundColor: alpha(e.palette[t.color].main, e.palette.action.hoverOpacity),
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    }
  }), "small" === t.size && {
    padding: 5,
    fontSize: e.typography.pxToRem(18)
  }, "large" === t.size && {
    padding: 12,
    fontSize: e.typography.pxToRem(28)
  }, _defineProperty2({}, "&.".concat(iconButtonClasses.disabled), {
    backgroundColor: "transparent",
    color: e.palette.action.disabled
  }));
}),
    IconButton = React.forwardRef(function (e, t) {
  var r = useThemeProps({
    props: e,
    name: "MuiIconButton"
  }),
      _r$edge = r.edge,
      n = _r$edge === void 0 ? !1 : _r$edge,
      a = r.children,
      o = r.className,
      _r$color3 = r.color,
      i = _r$color3 === void 0 ? "default" : _r$color3,
      _r$disabled2 = r.disabled,
      s = _r$disabled2 === void 0 ? !1 : _r$disabled2,
      _r$disableFocusRipple = r.disableFocusRipple,
      l = _r$disableFocusRipple === void 0 ? !1 : _r$disableFocusRipple,
      _r$size2 = r.size,
      c = _r$size2 === void 0 ? "medium" : _r$size2,
      u = _objectWithoutPropertiesLoose$4(r, _excluded$o),
      d = _extends$e({}, r, {
    edge: n,
    color: i,
    disabled: s,
    disableFocusRipple: l,
    size: c
  }),
      p = useUtilityClasses$e(d);

  return jsx$1(IconButtonRoot, _extends$e({
    className: clsx(p.root, o),
    centerRipple: !0,
    focusRipple: !l,
    disabled: s,
    ref: t,
    ownerState: d
  }, u, {
    children: a
  }));
});

"production" !== process.env.NODE_ENV && (IconButton.propTypes = {
  children: chainPropTypes(PropTypes.node, function (e) {
    return React.Children.toArray(e.children).some(function (e) {
      return React.isValidElement(e) && e.props.onClick;
    }) ? new Error(["MUI: You are providing an onClick event listener to a child of a button element.", "Prefer applying it to the IconButton directly.", "This guarantees that the whole <button> will be responsive to click events."].join("\n")) : null;
  }),
  classes: PropTypes.object,
  className: PropTypes.string,
  color: PropTypes.oneOfType([PropTypes.oneOf(["inherit", "default", "primary", "secondary", "error", "info", "success", "warning"]), PropTypes.string]),
  disabled: PropTypes.bool,
  disableFocusRipple: PropTypes.bool,
  disableRipple: PropTypes.bool,
  edge: PropTypes.oneOf(["end", "start", !1]),
  size: PropTypes.oneOfType([PropTypes.oneOf(["small", "medium", "large"]), PropTypes.string]),
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});

var IconButton$1 = IconButton,
    utils = Object.freeze({
  __proto__: null,
  capitalize: capitalize,
  createChainedFunction: createChainedFunction,
  createSvgIcon: createSvgIcon$1,
  debounce: debounce,
  deprecatedPropType: deprecatedPropType,
  isMuiElement: isMuiElement,
  ownerDocument: ownerDocument,
  ownerWindow: ownerWindow,
  requirePropFactory: requirePropFactory,
  setRef: setRef,
  unstable_useEnhancedEffect: useEnhancedEffect$1,
  unstable_useId: useId,
  unsupportedProp: unsupportedProp,
  useControlled: useControlled,
  useEventCallback: useEventCallback,
  useForkRef: useForkRef,
  useIsFocusVisible: useIsFocusVisible,
  unstable_ClassNameGenerator: ClassNameGenerator$1
}),
    PenIcon = createSvgIcon$1(jsx$1("path", {
  d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
}), "Pen"),
    CalendarIcon = createSvgIcon$1(jsx$1("path", {
  d: "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
}), "Calendar"),
    ClockIcon = createSvgIcon$1(jsxs(React.Fragment, {
  children: [jsx$1("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
  }), jsx$1("path", {
    d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
  })]
}), "Clock"),
    _ClockIcon,
    _CalendarIcon,
    _PenIcon;

var classes$5 = generateUtilityClasses("PrivatePickersToolbar", ["root", "dateTitleContainer"]),
    PickersToolbarRoot = styled("div")(function (_ref48) {
  var e = _ref48.theme,
      t = _ref48.ownerState;
  return _extends$a({
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "space-between",
    padding: e.spacing(2, 3)
  }, t.isLandscape && {
    height: "auto",
    maxWidth: 160,
    padding: 16,
    justifyContent: "flex-start",
    flexWrap: "wrap"
  });
}),
    PickersToolbarGrid = styled(Grid$1)({
  flex: 1
}),
    getViewTypeIcon = function getViewTypeIcon(e) {
  return "clock" === e ? _ClockIcon || (_ClockIcon = jsx$1(ClockIcon, {
    color: "inherit"
  })) : _CalendarIcon || (_CalendarIcon = jsx$1(CalendarIcon, {
    color: "inherit"
  }));
};

function defaultGetKeyboardInputSwitchingButtonText(e, t) {
  return e ? "text input view is open, go to ".concat(t, " view") : "".concat(t, " view is open, go to text input view");
}

var PickersToolbar = React.forwardRef(function (e, t) {
  var r = e.children,
      n = e.className,
      _e$getMobileKeyboardI = e.getMobileKeyboardInputViewButtonText,
      a = _e$getMobileKeyboardI === void 0 ? defaultGetKeyboardInputSwitchingButtonText : _e$getMobileKeyboardI,
      o = e.isLandscape,
      i = e.isMobileKeyboardViewOpen,
      _e$landscapeDirection = e.landscapeDirection,
      s = _e$landscapeDirection === void 0 ? "column" : _e$landscapeDirection,
      l = e.penIconClassName,
      c = e.toggleMobileKeyboardView,
      u = e.toolbarTitle,
      _e$viewType = e.viewType,
      d = _e$viewType === void 0 ? "calendar" : _e$viewType,
      p = e;
  return jsxs(PickersToolbarRoot, {
    ref: t,
    className: clsx(classes$5.root, n),
    ownerState: p,
    children: [jsx$1(Typography$1, {
      color: "text.secondary",
      variant: "overline",
      children: u
    }), jsxs(PickersToolbarGrid, {
      container: !0,
      justifyContent: "space-between",
      className: classes$5.dateTitleContainer,
      direction: o ? s : "row",
      alignItems: o ? "flex-start" : "flex-end",
      children: [r, jsx$1(IconButton$1, {
        onClick: c,
        className: l,
        color: "inherit",
        "aria-label": a(i, d),
        children: i ? getViewTypeIcon(d) : _PenIcon || (_PenIcon = jsx$1(PenIcon, {
          color: "inherit"
        }))
      })]
    })]
  });
}),
    _excluded$n = ["date", "isLandscape", "isMobileKeyboardViewOpen", "onChange", "toggleMobileKeyboardView", "toolbarFormat", "toolbarPlaceholder", "toolbarTitle", "views"],
    classes$4 = generateUtilityClasses("PrivateDatePickerToolbar", ["penIcon"]),
    DatePickerToolbarRoot = styled(PickersToolbar)(_defineProperty2({}, "& .".concat(classes$4.penIcon), {
  position: "relative",
  top: 4
})),
    DatePickerToolbarTitle = styled(Typography$1)(function (_ref49) {
  var e = _ref49.ownerState;
  return _extends$a({}, e.isLandscape && {
    margin: "auto 16px auto auto"
  });
}),
    DatePickerToolbar = React.forwardRef(function (e, t) {
  var r = e.date,
      n = e.isLandscape,
      a = e.isMobileKeyboardViewOpen,
      o = e.toggleMobileKeyboardView,
      i = e.toolbarFormat,
      _e$toolbarPlaceholder = e.toolbarPlaceholder,
      s = _e$toolbarPlaceholder === void 0 ? "––" : _e$toolbarPlaceholder,
      _e$toolbarTitle = e.toolbarTitle,
      l = _e$toolbarTitle === void 0 ? "Select date" : _e$toolbarTitle,
      c = e.views,
      u = _objectWithoutPropertiesLoose$1(e, _excluded$n),
      d = useUtils(),
      p = React.useMemo(function () {
    return r ? i ? d.formatByString(r, i) : isYearOnlyView(c) ? d.format(r, "year") : isYearAndMonthViews(c) ? d.format(r, "month") : /en/.test(d.getCurrentLocaleCode()) ? d.format(r, "normalDateWithWeekday") : d.format(r, "normalDate") : s;
  }, [r, i, s, d, c]),
      g = e;

  return jsx$1(DatePickerToolbarRoot, _extends$a({
    ref: t,
    toolbarTitle: l,
    isMobileKeyboardViewOpen: a,
    toggleMobileKeyboardView: o,
    isLandscape: n,
    penIconClassName: classes$4.penIcon,
    ownerState: g
  }, u, {
    children: jsx$1(DatePickerToolbarTitle, {
      variant: "h4",
      align: n ? "left" : "center",
      ownerState: g,
      children: p
    })
  }));
}),
    DAY_SIZE = 36,
    DAY_MARGIN = 2,
    DIALOG_WIDTH = 320,
    VIEW_HEIGHT = 358,
    WrapperVariantContext = React.createContext(null),
    IsStaticVariantContext = React.createContext(!1),
    _excluded$m = ["displayStaticWrapperAs"];

function getStaticWrapperUtilityClass(e) {
  return generateUtilityClass("MuiPickerStaticWrapper", e);
}

generateUtilityClasses("MuiPickerStaticWrapper", ["root"]);

var useUtilityClasses$d = function useUtilityClasses$d(e) {
  var t = e.classes;
  return composeClasses({
    root: ["root"]
  }, getStaticWrapperUtilityClass, t);
},
    PickerStaticWrapperRoot = styled("div", {
  name: "MuiPickerStaticWrapper",
  slot: "Root",
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})(function (_ref50) {
  var e = _ref50.theme;
  return {
    overflow: "hidden",
    minWidth: DIALOG_WIDTH,
    display: "flex",
    flexDirection: "column",
    backgroundColor: e.palette.background.paper
  };
});

function PickerStaticWrapper(e) {
  var t = useThemeProps({
    props: e,
    name: "MuiPickerStaticWrapper"
  }),
      r = t.displayStaticWrapperAs,
      n = _objectWithoutPropertiesLoose$1(t, _excluded$m),
      a = useUtilityClasses$d(t);

  return jsx$1(IsStaticVariantContext.Provider, {
    value: !0,
    children: jsx$1(WrapperVariantContext.Provider, {
      value: r,
      children: jsx$1(PickerStaticWrapperRoot, _extends$a({
        className: a.root
      }, n))
    })
  });
}

function arrayIncludes(e, t) {
  return Array.isArray(t) ? t.every(function (t) {
    return -1 !== e.indexOf(t);
  }) : -1 !== e.indexOf(t);
}

var onSpaceOrEnter = function onSpaceOrEnter(e, t) {
  return function (r) {
    "Enter" !== r.key && " " !== r.key || (e(), r.preventDefault(), r.stopPropagation()), t && t(r);
  };
},
    pipe = function pipe() {
  for (var _len16 = arguments.length, e = new Array(_len16), _key16 = 0; _key16 < _len16; _key16++) {
    e[_key16] = arguments[_key16];
  }

  return e.reduceRight(function (e, t) {
    return function () {
      return t(e.apply(void 0, arguments));
    };
  }, function (e) {
    return e;
  });
};

function createDelegatedEventHandler(e, t) {
  return function (r) {
    e(r), t && t(r);
  };
}

function useViews(_ref51) {
  var e = _ref51.onChange,
      t = _ref51.onViewChange,
      r = _ref51.openTo,
      n = _ref51.view,
      a = _ref51.views;
  var o, i;

  var _useControlled = useControlled({
    name: "Picker",
    state: "view",
    controlled: n,
    default: r && arrayIncludes(a, r) ? r : a[0]
  }),
      _useControlled2 = _slicedToArray(_useControlled, 2),
      s = _useControlled2[0],
      l = _useControlled2[1],
      c = null != (o = a[a.indexOf(s) - 1]) ? o : null,
      u = null != (i = a[a.indexOf(s) + 1]) ? i : null,
      d = React.useCallback(function (e) {
    l(e), t && t(e);
  }, [l, t]),
      p = React.useCallback(function () {
    u && d(u);
  }, [u, d]);

  return {
    handleChangeAndOpenNext: React.useCallback(function (t, r) {
      var n = "finish" === r,
          a = n && Boolean(u) ? "partial" : r;
      e(t, a), n && p();
    }, [u, e, p]),
    nextView: u,
    previousView: c,
    openNext: p,
    openView: s,
    setOpenView: d
  };
}

var CLOCK_WIDTH = 220,
    CLOCK_HOUR_WIDTH = 36,
    clockCenter = {
  x: CLOCK_WIDTH / 2,
  y: CLOCK_WIDTH / 2
},
    baseClockPoint = {
  x: clockCenter.x,
  y: 0
},
    cx = baseClockPoint.x - clockCenter.x,
    cy = baseClockPoint.y - clockCenter.y,
    rad2deg = function rad2deg(e) {
  return e * (180 / Math.PI);
},
    getAngleValue = function getAngleValue(e, t, r) {
  var n = t - clockCenter.x,
      a = r - clockCenter.y,
      o = Math.atan2(cx, cy) - Math.atan2(n, a);
  var i = rad2deg(o);
  i = Math.round(i / e) * e, i %= 360;
  var s = Math.pow(n, 2) + Math.pow(a, 2);
  return {
    value: Math.floor(i / e) || 0,
    distance: Math.sqrt(s)
  };
},
    getMinutes = function getMinutes(e, t) {
  var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var n = 6 * r;

  var _getAngleValue = getAngleValue(n, e, t),
      a = _getAngleValue.value;

  return a = a * r % 60, a;
},
    getHours$1 = function getHours$1(e, t, r) {
  var _getAngleValue2 = getAngleValue(30, e, t),
      n = _getAngleValue2.value,
      a = _getAngleValue2.distance;

  var o = n || 12;
  return r ? o %= 12 : a < CLOCK_WIDTH / 2 - CLOCK_HOUR_WIDTH && (o += 12, o %= 24), o;
},
    _excluded$l = ["className", "hasSelected", "isInner", "type", "value"],
    ClockPointerRoot = styled("div")(function (_ref52) {
  var e = _ref52.theme,
      t = _ref52.ownerState;
  return _extends$a({
    width: 2,
    backgroundColor: e.palette.primary.main,
    position: "absolute",
    left: "calc(50% - 1px)",
    bottom: "50%",
    transformOrigin: "center bottom 0px"
  }, t.toAnimateTransform && {
    transition: e.transitions.create(["transform", "height"])
  });
}),
    ClockPointerThumb = styled("div")(function (_ref53) {
  var e = _ref53.theme,
      t = _ref53.ownerState;
  return _extends$a({
    width: 4,
    height: 4,
    backgroundColor: e.palette.primary.contrastText,
    borderRadius: "50%",
    position: "absolute",
    top: -21,
    left: "calc(50% - ".concat(CLOCK_HOUR_WIDTH / 2, "px)"),
    border: "".concat((CLOCK_HOUR_WIDTH - 4) / 2, "px solid ").concat(e.palette.primary.main),
    boxSizing: "content-box"
  }, t.hasSelected && {
    backgroundColor: e.palette.primary.main
  });
});

var ClockPointer = /*#__PURE__*/function (_React$Component) {
  _inherits(ClockPointer, _React$Component);

  var _super = _createSuper(ClockPointer);

  function ClockPointer() {
    var _this10;

    _classCallCheck(this, ClockPointer);

    for (var _len17 = arguments.length, e = new Array(_len17), _key17 = 0; _key17 < _len17; _key17++) {
      e[_key17] = arguments[_key17];
    }

    _this10 = _super.call.apply(_super, [this].concat(e)), _this10.state = {
      toAnimateTransform: !1,
      previousType: void 0
    };
    return _this10;
  }

  _createClass(ClockPointer, [{
    key: "render",
    value: function render() {
      var e = this.props,
          t = e.className,
          r = e.isInner,
          n = e.type,
          a = e.value,
          o = _objectWithoutPropertiesLoose$1(e, _excluded$l),
          i = _extends$a({}, this.props, this.state);

      return jsx$1(ClockPointerRoot, _extends$a({
        style: function () {
          var e = 360 / ("hours" === n ? 12 : 60) * a;
          return "hours" === n && a > 12 && (e -= 360), {
            height: Math.round((r ? .26 : .4) * CLOCK_WIDTH),
            transform: "rotateZ(".concat(e, "deg)")
          };
        }(),
        className: t,
        ownerState: i
      }, o, {
        children: jsx$1(ClockPointerThumb, {
          ownerState: i
        })
      }));
    }
  }]);

  return ClockPointer;
}(React.Component);

var _ClockPin, _Typography, _Typography2;

ClockPointer.getDerivedStateFromProps = function (e, t) {
  return e.type !== t.previousType ? {
    toAnimateTransform: !0,
    previousType: e.type
  } : {
    toAnimateTransform: !1,
    previousType: e.type
  };
};

var ClockRoot = styled("div")(function (_ref54) {
  var e = _ref54.theme;
  return {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    margin: e.spacing(2)
  };
}),
    ClockClock = styled("div")({
  backgroundColor: "rgba(0,0,0,.07)",
  borderRadius: "50%",
  height: 220,
  width: 220,
  flexShrink: 0,
  position: "relative",
  pointerEvents: "none"
}),
    ClockSquareMask = styled("div")({
  width: "100%",
  height: "100%",
  position: "absolute",
  pointerEvents: "auto",
  outline: 0,
  touchAction: "none",
  userSelect: "none",
  "@media (pointer: fine)": {
    cursor: "pointer",
    borderRadius: "50%"
  },
  "&:active": {
    cursor: "move"
  }
}),
    ClockPin = styled("div")(function (_ref55) {
  var e = _ref55.theme;
  return {
    width: 6,
    height: 6,
    borderRadius: "50%",
    backgroundColor: e.palette.primary.main,
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)"
  };
}),
    ClockAmButton = styled(IconButton$1)(function (_ref56) {
  var e = _ref56.theme,
      t = _ref56.ownerState;
  return _extends$a({
    zIndex: 1,
    position: "absolute",
    bottom: t.ampmInClock ? 64 : 8,
    left: 8
  }, "am" === t.meridiemMode && {
    backgroundColor: e.palette.primary.main,
    color: e.palette.primary.contrastText,
    "&:hover": {
      backgroundColor: e.palette.primary.light
    }
  });
}),
    ClockPmButton = styled(IconButton$1)(function (_ref57) {
  var e = _ref57.theme,
      t = _ref57.ownerState;
  return _extends$a({
    zIndex: 1,
    position: "absolute",
    bottom: t.ampmInClock ? 64 : 8,
    right: 8
  }, "pm" === t.meridiemMode && {
    backgroundColor: e.palette.primary.main,
    color: e.palette.primary.contrastText,
    "&:hover": {
      backgroundColor: e.palette.primary.light
    }
  });
});

function Clock(e) {
  var t = e.ampm,
      r = e.ampmInClock,
      n = e.autoFocus,
      a = e.children,
      o = e.date,
      i = e.getClockLabelText,
      s = e.handleMeridiemChange,
      l = e.isTimeDisabled,
      c = e.meridiemMode,
      _e$minutesStep = e.minutesStep,
      u = _e$minutesStep === void 0 ? 1 : _e$minutesStep,
      d = e.onChange,
      p = e.selectedId,
      g = e.type,
      m = e.value,
      f = e,
      h = useUtils(),
      b = React.useContext(WrapperVariantContext),
      y = React.useRef(!1),
      v = l(m, g),
      _ = !t && "hours" === g && (m < 1 || m > 12),
      T = function T(e, t) {
    l(e, g) || d(e, t);
  },
      E = function E(e, r) {
    var n = e.offsetX,
        a = e.offsetY;

    if (void 0 === n) {
      var _t38 = e.target.getBoundingClientRect();

      n = e.changedTouches[0].clientX - _t38.left, a = e.changedTouches[0].clientY - _t38.top;
    }

    var o = "seconds" === g || "minutes" === g ? getMinutes(n, a, u) : getHours$1(n, a, Boolean(t));
    T(o, r);
  },
      S = React.useMemo(function () {
    return "hours" === g || m % 5 == 0;
  }, [g, m]),
      x = "minutes" === g ? u : 1,
      w = React.useRef(null);

  useEnhancedEffect$1(function () {
    n && w.current.focus();
  }, [n]);
  return jsxs(ClockRoot, {
    children: [jsxs(ClockClock, {
      children: [jsx$1(ClockSquareMask, {
        onTouchMove: function onTouchMove(e) {
          y.current = !0, E(e, "shallow");
        },
        onTouchEnd: function onTouchEnd(e) {
          y.current && (E(e, "finish"), y.current = !1);
        },
        onMouseUp: function onMouseUp(e) {
          y.current && (y.current = !1), E(e.nativeEvent, "finish");
        },
        onMouseMove: function onMouseMove(e) {
          e.buttons > 0 && E(e.nativeEvent, "shallow");
        }
      }), !v && jsxs(React.Fragment, {
        children: [_ClockPin || (_ClockPin = jsx$1(ClockPin, {})), o && jsx$1(ClockPointer, {
          type: g,
          value: m,
          isInner: _,
          hasSelected: S
        })]
      }), jsx$1("div", {
        "aria-activedescendant": p,
        "aria-label": i(g, o, h),
        ref: w,
        role: "listbox",
        onKeyDown: function onKeyDown(e) {
          if (!y.current) switch (e.key) {
            case "Home":
              T(0, "partial"), e.preventDefault();
              break;

            case "End":
              T("minutes" === g ? 59 : 23, "partial"), e.preventDefault();
              break;

            case "ArrowUp":
              T(m + x, "partial"), e.preventDefault();
              break;

            case "ArrowDown":
              T(m - x, "partial"), e.preventDefault();
          }
        },
        tabIndex: 0,
        children: a
      })]
    }), t && ("desktop" === b || r) && jsxs(React.Fragment, {
      children: [jsx$1(ClockAmButton, {
        onClick: function onClick() {
          return s("am");
        },
        disabled: null === c,
        ownerState: f,
        children: _Typography || (_Typography = jsx$1(Typography$1, {
          variant: "caption",
          children: "AM"
        }))
      }), jsx$1(ClockPmButton, {
        disabled: null === c,
        onClick: function onClick() {
          return s("pm");
        },
        ownerState: f,
        children: _Typography2 || (_Typography2 = jsx$1(Typography$1, {
          variant: "caption",
          children: "PM"
        }))
      })]
    })]
  });
}

var _excluded$k = ["className", "disabled", "index", "inner", "label", "selected"],
    classes$3 = generateUtilityClasses("PrivateClockNumber", ["selected", "disabled"]),
    ClockNumberRoot = styled("span")(function (_ref58) {
  var _extends$a2;

  var e = _ref58.theme,
      t = _ref58.ownerState;
  return _extends$a((_extends$a2 = {
    height: CLOCK_HOUR_WIDTH,
    width: CLOCK_HOUR_WIDTH,
    position: "absolute",
    left: "calc((100% - ".concat(CLOCK_HOUR_WIDTH, "px) / 2)"),
    display: "inline-flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "50%",
    color: e.palette.text.primary,
    fontFamily: e.typography.fontFamily,
    "&:focused": {
      backgroundColor: e.palette.background.paper
    }
  }, _defineProperty2(_extends$a2, "&.".concat(classes$3.selected), {
    color: e.palette.primary.contrastText
  }), _defineProperty2(_extends$a2, "&.".concat(classes$3.disabled), {
    pointerEvents: "none",
    color: e.palette.text.disabled
  }), _extends$a2), t.inner && _extends$a({}, e.typography.body2, {
    color: e.palette.text.secondary
  }));
});

function ClockNumber(e) {
  var t = e.className,
      r = e.disabled,
      n = e.index,
      a = e.inner,
      o = e.label,
      i = e.selected,
      s = _objectWithoutPropertiesLoose$1(e, _excluded$k),
      l = e,
      c = n % 12 / 12 * Math.PI * 2 - Math.PI / 2,
      u = (CLOCK_WIDTH - CLOCK_HOUR_WIDTH - 2) / 2 * (a ? .65 : 1),
      d = Math.round(Math.cos(c) * u),
      p = Math.round(Math.sin(c) * u);

  return jsx$1(ClockNumberRoot, _extends$a({
    className: clsx(t, i && classes$3.selected, r && classes$3.disabled),
    "aria-disabled": !!r || void 0,
    "aria-selected": !!i || void 0,
    role: "option",
    style: {
      transform: "translate(".concat(d, "px, ").concat(p + (CLOCK_WIDTH - CLOCK_HOUR_WIDTH) / 2, "px")
    },
    ownerState: l
  }, s, {
    children: o
  }));
}

var getHourNumbers = function getHourNumbers(_ref59) {
  var e = _ref59.ampm,
      t = _ref59.date,
      r = _ref59.getClockNumberText,
      n = _ref59.isDisabled,
      a = _ref59.selectedId,
      o = _ref59.utils;

  var i = t ? o.getHours(t) : null,
      s = [],
      l = e ? 12 : 23,
      c = function c(t) {
    return null !== i && (e ? 12 === t ? 12 === i || 0 === i : i === t || i - 12 === t : i === t);
  };

  for (var _t39 = e ? 1 : 0; _t39 <= l; _t39 += 1) {
    var _i8 = _t39.toString();

    0 === _t39 && (_i8 = "00");

    var _l5 = !e && (0 === _t39 || _t39 > 12);

    _i8 = o.formatNumber(_i8);

    var _u2 = c(_t39);

    s.push(jsx$1(ClockNumber, {
      id: _u2 ? a : void 0,
      index: _t39,
      inner: _l5,
      selected: _u2,
      disabled: n(_t39),
      label: _i8,
      "aria-label": r(_i8)
    }, _t39));
  }

  return s;
},
    getMinutesNumbers = function getMinutesNumbers(_ref60) {
  var e = _ref60.utils,
      t = _ref60.value,
      r = _ref60.isDisabled,
      n = _ref60.getClockNumberText,
      a = _ref60.selectedId;
  var o = e.formatNumber;
  return [[5, o("05")], [10, o("10")], [15, o("15")], [20, o("20")], [25, o("25")], [30, o("30")], [35, o("35")], [40, o("40")], [45, o("45")], [50, o("50")], [55, o("55")], [0, o("00")]].map(function (_ref61, i) {
    var _ref62 = _slicedToArray(_ref61, 2),
        e = _ref62[0],
        o = _ref62[1];

    var s = e === t;
    return jsx$1(ClockNumber, {
      label: o,
      id: s ? a : void 0,
      index: i + 1,
      inner: !1,
      disabled: r(e),
      selected: s,
      "aria-label": n(o)
    }, e);
  });
};

var ArrowLeftIcon = createSvgIcon$1(jsx$1("path", {
  d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
}), "ArrowLeft"),
    ArrowRightIcon = createSvgIcon$1(jsx$1("path", {
  d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
}), "ArrowRight");

var _excluded$j = ["children", "className", "components", "componentsProps", "isLeftDisabled", "isLeftHidden", "isRightDisabled", "isRightHidden", "leftArrowButtonText", "onLeftClick", "onRightClick", "rightArrowButtonText"],
    PickersArrowSwitcherRoot = styled("div")({
  display: "flex"
}),
    PickersArrowSwitcherSpacer = styled("div")(function (_ref63) {
  var e = _ref63.theme;
  return {
    width: e.spacing(3)
  };
}),
    PickersArrowSwitcherButton = styled(IconButton$1)(function (_ref64) {
  var e = _ref64.ownerState;
  return _extends$a({}, e.hidden && {
    visibility: "hidden"
  });
}),
    PickersArrowSwitcher = React.forwardRef(function (e, t) {
  var r = e.children,
      n = e.className,
      _e$components3 = e.components,
      a = _e$components3 === void 0 ? {} : _e$components3,
      _e$componentsProps3 = e.componentsProps,
      o = _e$componentsProps3 === void 0 ? {} : _e$componentsProps3,
      i = e.isLeftDisabled,
      s = e.isLeftHidden,
      l = e.isRightDisabled,
      c = e.isRightHidden,
      u = e.leftArrowButtonText,
      d = e.onLeftClick,
      p = e.onRightClick,
      g = e.rightArrowButtonText,
      m = _objectWithoutPropertiesLoose$1(e, _excluded$j),
      f = "rtl" === useTheme().direction,
      h = o.leftArrowButton || {},
      b = a.LeftArrowIcon || ArrowLeftIcon,
      y = o.rightArrowButton || {},
      v = a.RightArrowIcon || ArrowRightIcon,
      _ = e;

  return jsxs(PickersArrowSwitcherRoot, _extends$a({
    ref: t,
    className: n,
    ownerState: _
  }, m, {
    children: [jsx$1(PickersArrowSwitcherButton, _extends$a({
      as: a.LeftArrowButton,
      size: "small",
      "aria-label": u,
      title: u,
      disabled: i,
      edge: "end",
      onClick: d
    }, h, {
      className: h.className,
      ownerState: _extends$a({}, _, h, {
        hidden: s
      }),
      children: jsx$1(f ? v : b, {})
    })), r ? jsx$1(Typography$1, {
      variant: "subtitle1",
      component: "span",
      children: r
    }) : jsx$1(PickersArrowSwitcherSpacer, {
      ownerState: _
    }), jsx$1(PickersArrowSwitcherButton, _extends$a({
      as: a.RightArrowButton,
      size: "small",
      "aria-label": g,
      title: g,
      edge: "start",
      disabled: l,
      onClick: p
    }, y, {
      className: y.className,
      ownerState: _extends$a({}, _, y, {
        hidden: c
      }),
      children: jsx$1(f ? b : v, {})
    }))]
  }));
}),
    getMeridiem = function getMeridiem(e, t) {
  return e ? t.getHours(e) >= 12 ? "pm" : "am" : null;
},
    convertValueToMeridiem = function convertValueToMeridiem(e, t, r) {
  if (r) {
    if ((e >= 12 ? "pm" : "am") !== t) return "am" === t ? e - 12 : e + 12;
  }

  return e;
},
    convertToMeridiem = function convertToMeridiem(e, t, r, n) {
  var a = convertValueToMeridiem(n.getHours(e), t, r);
  return n.setHours(e, a);
};

function getSecondsInDay(e, t) {
  return 3600 * t.getHours(e) + 60 * t.getMinutes(e) + t.getSeconds(e);
}

var createIsAfterIgnoreDatePart = function createIsAfterIgnoreDatePart(e, t) {
  return function (r, n) {
    return e ? t.isAfter(r, n) : getSecondsInDay(r, t) > getSecondsInDay(n, t);
  };
};

function useNextMonthDisabled(e, _ref65) {
  var t = _ref65.disableFuture,
      r = _ref65.maxDate;
  var n = useUtils();
  return React.useMemo(function () {
    var a = n.date(),
        o = n.startOfMonth(t && n.isBefore(a, r) ? a : r);
    return !n.isAfter(o, e);
  }, [t, r, e, n]);
}

function usePreviousMonthDisabled(e, _ref66) {
  var t = _ref66.disablePast,
      r = _ref66.minDate;
  var n = useUtils();
  return React.useMemo(function () {
    var a = n.date(),
        o = n.startOfMonth(t && n.isAfter(a, r) ? a : r);
    return !n.isBefore(o, e);
  }, [t, r, e, n]);
}

function useMeridiemMode(e, t, r) {
  var n = useUtils();
  return {
    meridiemMode: getMeridiem(e, n),
    handleMeridiemChange: React.useCallback(function (a) {
      var o = convertToMeridiem(e, a, Boolean(t), n);
      r(o, "partial");
    }, [t, e, r, n])
  };
}

function getClockPickerUtilityClass(e) {
  return generateUtilityClass("MuiClockPicker", e);
}

generateUtilityClasses("MuiClockPicker", ["arrowSwitcher"]);

var useUtilityClasses$c = function useUtilityClasses$c(e) {
  var t = e.classes;
  return composeClasses({
    arrowSwitcher: ["arrowSwitcher"]
  }, getClockPickerUtilityClass, t);
},
    ClockPickerArrowSwitcher = styled(PickersArrowSwitcher, {
  name: "MuiClockPicker",
  slot: "ArrowSwitcher",
  overridesResolver: function overridesResolver(e, t) {
    return t.arrowSwitcher;
  }
})({
  position: "absolute",
  right: 12,
  top: 15
}),
    defaultGetClockLabelText = function defaultGetClockLabelText(e, t, r) {
  return "Select ".concat(e, ". ").concat(null === t ? "No time selected" : "Selected time is ".concat(r.format(t, "fullTime")));
},
    defaultGetMinutesClockNumberText = function defaultGetMinutesClockNumberText(e) {
  return "".concat(e, " minutes");
},
    defaultGetHoursClockNumberText = function defaultGetHoursClockNumberText(e) {
  return "".concat(e, " hours");
},
    defaultGetSecondsClockNumberText = function defaultGetSecondsClockNumberText(e) {
  return "".concat(e, " seconds");
};

function ClockPicker(e) {
  var t = useThemeProps({
    props: e,
    name: "MuiClockPicker"
  }),
      _t$ampm = t.ampm,
      r = _t$ampm === void 0 ? !1 : _t$ampm,
      _t$ampmInClock = t.ampmInClock,
      n = _t$ampmInClock === void 0 ? !1 : _t$ampmInClock,
      a = t.autoFocus,
      o = t.components,
      i = t.componentsProps,
      s = t.date,
      _t$disableIgnoringDat = t.disableIgnoringDatePartForTimeValidation,
      l = _t$disableIgnoringDat === void 0 ? !1 : _t$disableIgnoringDat,
      _t$getClockLabelText = t.getClockLabelText,
      c = _t$getClockLabelText === void 0 ? defaultGetClockLabelText : _t$getClockLabelText,
      _t$getHoursClockNumbe = t.getHoursClockNumberText,
      u = _t$getHoursClockNumbe === void 0 ? defaultGetHoursClockNumberText : _t$getHoursClockNumbe,
      _t$getMinutesClockNum = t.getMinutesClockNumberText,
      d = _t$getMinutesClockNum === void 0 ? defaultGetMinutesClockNumberText : _t$getMinutesClockNum,
      _t$getSecondsClockNum = t.getSecondsClockNumberText,
      p = _t$getSecondsClockNum === void 0 ? defaultGetSecondsClockNumberText : _t$getSecondsClockNum,
      _t$leftArrowButtonTex = t.leftArrowButtonText,
      g = _t$leftArrowButtonTex === void 0 ? "open previous view" : _t$leftArrowButtonTex,
      m = t.maxTime,
      f = t.minTime,
      _t$minutesStep = t.minutesStep,
      h = _t$minutesStep === void 0 ? 1 : _t$minutesStep,
      b = t.nextViewAvailable,
      y = t.onChange,
      v = t.openNextView,
      _ = t.openPreviousView,
      T = t.previousViewAvailable,
      _t$rightArrowButtonTe = t.rightArrowButtonText,
      E = _t$rightArrowButtonTe === void 0 ? "open next view" : _t$rightArrowButtonTe,
      S = t.shouldDisableTime,
      x = t.showViewSwitcher,
      w = t.view,
      C = useNow(),
      k = useUtils(),
      $ = k.setSeconds(k.setMinutes(k.setHours(C, 0), 0), 0),
      R = s || $,
      _useMeridiemMode = useMeridiemMode(R, r, y),
      A = _useMeridiemMode.meridiemMode,
      I = _useMeridiemMode.handleMeridiemChange,
      N = React.useCallback(function (e, t) {
    if (null === s) return !1;

    var n = function n(r) {
      var n = createIsAfterIgnoreDatePart(l, k);
      return Boolean(f && n(f, r("end")) || m && n(r("start"), m) || S && S(e, t));
    };

    switch (t) {
      case "hours":
        {
          var _t40 = convertValueToMeridiem(e, A, r);

          return n(function (e) {
            return pipe(function (e) {
              return k.setHours(e, _t40);
            }, function (t) {
              return k.setMinutes(t, "start" === e ? 0 : 59);
            }, function (t) {
              return k.setSeconds(t, "start" === e ? 0 : 59);
            })(s);
          });
        }

      case "minutes":
        return n(function (t) {
          return pipe(function (t) {
            return k.setMinutes(t, e);
          }, function (e) {
            return k.setSeconds(e, "start" === t ? 0 : 59);
          })(s);
        });

      case "seconds":
        return n(function () {
          return k.setSeconds(s, e);
        });

      default:
        throw new Error("not supported");
    }
  }, [r, s, l, m, A, f, S, k]),
      P = useId(),
      O = React.useMemo(function () {
    switch (w) {
      case "hours":
        {
          var _e47 = function _e47(e, t) {
            var n = convertValueToMeridiem(e, A, r);
            y(k.setHours(R, n), t);
          };

          return {
            onChange: _e47,
            value: k.getHours(R),
            children: getHourNumbers({
              date: s,
              utils: k,
              ampm: r,
              onChange: _e47,
              getClockNumberText: u,
              isDisabled: function isDisabled(e) {
                return N(e, "hours");
              },
              selectedId: P
            })
          };
        }

      case "minutes":
        {
          var _e48 = k.getMinutes(R),
              _t41 = function _t41(e, t) {
            y(k.setMinutes(R, e), t);
          };

          return {
            value: _e48,
            onChange: _t41,
            children: getMinutesNumbers({
              utils: k,
              value: _e48,
              onChange: _t41,
              getClockNumberText: d,
              isDisabled: function isDisabled(e) {
                return N(e, "minutes");
              },
              selectedId: P
            })
          };
        }

      case "seconds":
        {
          var _e49 = k.getSeconds(R),
              _t42 = function _t42(e, t) {
            y(k.setSeconds(R, e), t);
          };

          return {
            value: _e49,
            onChange: _t42,
            children: getMinutesNumbers({
              utils: k,
              value: _e49,
              onChange: _t42,
              getClockNumberText: p,
              isDisabled: function isDisabled(e) {
                return N(e, "seconds");
              },
              selectedId: P
            })
          };
        }

      default:
        throw new Error("You must provide the type for ClockView");
    }
  }, [w, k, s, r, u, d, p, A, y, R, N, P]),
      D = t,
      L = useUtilityClasses$c(D);

  return jsxs(React.Fragment, {
    children: [x && jsx$1(ClockPickerArrowSwitcher, {
      className: L.arrowSwitcher,
      leftArrowButtonText: g,
      rightArrowButtonText: E,
      components: o,
      componentsProps: i,
      onLeftClick: _,
      onRightClick: v,
      isLeftDisabled: T,
      isRightDisabled: b,
      ownerState: D
    }), jsx$1(Clock, _extends$a({
      autoFocus: a,
      date: s,
      ampmInClock: n,
      type: w,
      ampm: r,
      getClockLabelText: c,
      minutesStep: h,
      isTimeDisabled: N,
      meridiemMode: A,
      handleMeridiemChange: I,
      selectedId: P
    }, O))]
  });
}

"production" !== process.env.NODE_ENV && (ClockPicker.propTypes = {
  ampm: PropTypes.bool,
  ampmInClock: PropTypes.bool,
  autoFocus: PropTypes.bool,
  classes: PropTypes.object,
  components: PropTypes.shape({
    LeftArrowButton: PropTypes.elementType,
    LeftArrowIcon: PropTypes.elementType,
    RightArrowButton: PropTypes.elementType,
    RightArrowIcon: PropTypes.elementType
  }),
  componentsProps: PropTypes.shape({
    leftArrowButton: PropTypes.object,
    rightArrowButton: PropTypes.object
  }),
  date: PropTypes.any,
  disableIgnoringDatePartForTimeValidation: PropTypes.bool,
  getClockLabelText: PropTypes.func,
  getHoursClockNumberText: PropTypes.func,
  getMinutesClockNumberText: PropTypes.func,
  getSecondsClockNumberText: PropTypes.func,
  leftArrowButtonText: PropTypes.string,
  maxTime: PropTypes.any,
  minTime: PropTypes.any,
  minutesStep: PropTypes.number,
  nextViewAvailable: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  openNextView: PropTypes.func.isRequired,
  openPreviousView: PropTypes.func.isRequired,
  previousViewAvailable: PropTypes.bool.isRequired,
  rightArrowButtonText: PropTypes.string,
  shouldDisableTime: PropTypes.func,
  showViewSwitcher: PropTypes.bool,
  view: PropTypes.oneOf(["hours", "minutes", "seconds"]).isRequired
});

var _excluded$i = ["disabled", "onSelect", "selected", "value"],
    classes$2 = generateUtilityClasses("PrivatePickersMonth", ["root", "selected"]),
    PickersMonthRoot = styled(Typography$1)(function (_ref67) {
  var e = _ref67.theme;
  return _extends$a({
    flex: "1 0 33.33%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "unset",
    backgroundColor: "transparent",
    border: 0,
    outline: 0
  }, e.typography.subtitle1, _defineProperty2({
    margin: "8px 0",
    height: 36,
    borderRadius: 18,
    cursor: "pointer",
    "&:focus, &:hover": {
      backgroundColor: alpha(e.palette.action.active, e.palette.action.hoverOpacity)
    },
    "&:disabled": {
      pointerEvents: "none",
      color: e.palette.text.secondary
    }
  }, "&.".concat(classes$2.selected), {
    color: e.palette.primary.contrastText,
    backgroundColor: e.palette.primary.main,
    "&:focus, &:hover": {
      backgroundColor: e.palette.primary.dark
    }
  }));
}),
    PickersMonth = function PickersMonth(e) {
  var t = e.disabled,
      r = e.onSelect,
      n = e.selected,
      a = e.value,
      o = _objectWithoutPropertiesLoose$1(e, _excluded$i),
      i = function i() {
    r(a);
  };

  return jsx$1(PickersMonthRoot, _extends$a({
    component: "button",
    className: clsx(classes$2.root, n && classes$2.selected),
    tabIndex: t ? -1 : 0,
    onClick: i,
    onKeyDown: onSpaceOrEnter(i),
    color: n ? "primary" : void 0,
    variant: n ? "h5" : "subtitle1",
    disabled: t
  }, o));
},
    _excluded$h = ["className", "date", "disabled", "disableFuture", "disablePast", "maxDate", "minDate", "onChange", "onMonthChange", "readOnly"];

function getMonthPickerUtilityClass(e) {
  return generateUtilityClass("MuiMonthPicker", e);
}

generateUtilityClasses("MuiMonthPicker", ["root"]);

var useUtilityClasses$b = function useUtilityClasses$b(e) {
  var t = e.classes;
  return composeClasses({
    root: ["root"]
  }, getMonthPickerUtilityClass, t);
},
    MonthPickerRoot = styled("div", {
  name: "MuiMonthPicker",
  slot: "Root",
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})({
  width: 310,
  display: "flex",
  flexWrap: "wrap",
  alignContent: "stretch",
  margin: "0 4px"
}),
    MonthPicker = React.forwardRef(function (e, t) {
  var r = useThemeProps({
    props: e,
    name: "MuiMonthPicker"
  }),
      n = r.className,
      a = r.date,
      o = r.disabled,
      i = r.disableFuture,
      s = r.disablePast,
      l = r.maxDate,
      c = r.minDate,
      u = r.onChange,
      d = r.onMonthChange,
      p = r.readOnly,
      g = _objectWithoutPropertiesLoose$1(r, _excluded$h),
      m = r,
      f = useUtilityClasses$b(m),
      h = useUtils(),
      b = useNow(),
      y = h.getMonth(a || b),
      v = function v(e) {
    var t = h.startOfMonth(s && h.isAfter(b, c) ? b : c),
        r = h.startOfMonth(i && h.isBefore(b, l) ? b : l),
        n = h.isBefore(e, t),
        a = h.isAfter(e, r);
    return n || a;
  },
      _ = function _(e) {
    if (p) return;
    var t = h.setMonth(a || b, e);
    u(t, "finish"), d && d(t);
  };

  return jsx$1(MonthPickerRoot, _extends$a({
    ref: t,
    className: clsx(f.root, n),
    ownerState: m
  }, g, {
    children: h.getMonthArray(a || b).map(function (e) {
      var t = h.getMonth(e),
          r = h.format(e, "monthShort");
      return jsx$1(PickersMonth, {
        value: t,
        selected: t === y,
        onSelect: _,
        disabled: o || v(e),
        children: r
      }, r);
    })
  }));
});

"production" !== process.env.NODE_ENV && (MonthPicker.propTypes = {
  classes: PropTypes.object,
  className: PropTypes.string,
  date: PropTypes.any,
  disabled: PropTypes.bool,
  disableFuture: PropTypes.bool,
  disablePast: PropTypes.bool,
  maxDate: PropTypes.any.isRequired,
  minDate: PropTypes.any.isRequired,
  onChange: PropTypes.func.isRequired,
  onMonthChange: PropTypes.func,
  readOnly: PropTypes.bool,
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});

var findClosestEnabledDate = function findClosestEnabledDate(_ref68) {
  var e = _ref68.date,
      t = _ref68.disableFuture,
      r = _ref68.disablePast,
      n = _ref68.maxDate,
      a = _ref68.minDate,
      o = _ref68.shouldDisableDate,
      i = _ref68.utils;
  var s = i.startOfDay(i.date());
  r && i.isBefore(a, s) && (a = s), t && i.isAfter(n, s) && (n = s);
  var l = e,
      c = e;

  for (i.isBefore(e, a) && (l = i.date(a), c = null), i.isAfter(e, n) && (c && (c = i.date(n)), l = null); l || c;) {
    if (l && i.isAfter(l, n) && (l = null), c && i.isBefore(c, a) && (c = null), l) {
      if (!o(l)) return l;
      l = i.addDays(l, 1);
    }

    if (c) {
      if (!o(c)) return c;
      c = i.addDays(c, -1);
    }
  }

  return s;
};

function parsePickerInputValue(e, t) {
  var r = e.date(t);
  return e.isValid(r) ? r : null;
}

var validateDate$1 = function validateDate$1(e, t, _ref69) {
  var r = _ref69.disablePast,
      n = _ref69.disableFuture,
      a = _ref69.minDate,
      o = _ref69.maxDate,
      i = _ref69.shouldDisableDate;
  var s = e.date(),
      l = e.date(t);
  if (null === l) return null;

  switch (!0) {
    case !e.isValid(t):
      return "invalidDate";

    case Boolean(i && i(l)):
      return "shouldDisableDate";

    case Boolean(n && e.isAfterDay(l, s)):
      return "disableFuture";

    case Boolean(r && e.isBeforeDay(l, s)):
      return "disablePast";

    case Boolean(a && e.isBeforeDay(l, a)):
      return "minDate";

    case Boolean(o && e.isAfterDay(l, o)):
      return "maxDate";

    default:
      return null;
  }
},
    createCalendarStateReducer = function createCalendarStateReducer(e, t, r) {
  return function (n, a) {
    switch (a.type) {
      case "changeMonth":
        return _extends$a({}, n, {
          slideDirection: a.direction,
          currentMonth: a.newMonth,
          isMonthSwitchingAnimating: !e
        });

      case "finishMonthSwitchingAnimation":
        return _extends$a({}, n, {
          isMonthSwitchingAnimating: !1
        });

      case "changeFocusedDay":
        {
          if (null !== n.focusedDay && r.isSameDay(a.focusedDay, n.focusedDay)) return n;
          var o = Boolean(a.focusedDay) && !t && !r.isSameMonth(n.currentMonth, a.focusedDay);
          return _extends$a({}, n, {
            focusedDay: a.focusedDay,
            isMonthSwitchingAnimating: o && !e,
            currentMonth: o ? r.startOfMonth(a.focusedDay) : n.currentMonth,
            slideDirection: r.isAfterDay(a.focusedDay, n.currentMonth) ? "left" : "right"
          });
        }

      default:
        throw new Error("missing support");
    }
  };
};

function useCalendarState(_ref70) {
  var e = _ref70.date,
      t = _ref70.defaultCalendarMonth,
      r = _ref70.disableFuture,
      n = _ref70.disablePast,
      _ref70$disableSwitchT = _ref70.disableSwitchToMonthOnDayFocus,
      a = _ref70$disableSwitchT === void 0 ? !1 : _ref70$disableSwitchT,
      o = _ref70.maxDate,
      i = _ref70.minDate,
      s = _ref70.onMonthChange,
      l = _ref70.reduceAnimations,
      c = _ref70.shouldDisableDate;
  var u;

  var d = useNow(),
      p = useUtils(),
      g = React.useRef(createCalendarStateReducer(Boolean(l), a, p)).current,
      _React$useReducer = React.useReducer(g, {
    isMonthSwitchingAnimating: !1,
    focusedDay: e || d,
    currentMonth: p.startOfMonth(null != (u = null != e ? e : t) ? u : d),
    slideDirection: "left"
  }),
      _React$useReducer2 = _slicedToArray(_React$useReducer, 2),
      m = _React$useReducer2[0],
      f = _React$useReducer2[1],
      h = React.useCallback(function (e) {
    f(_extends$a({
      type: "changeMonth"
    }, e)), s && s(e.newMonth);
  }, [s]),
      b = React.useCallback(function (e) {
    var t = null != e ? e : d;
    p.isSameMonth(t, m.currentMonth) || h({
      newMonth: p.startOfMonth(t),
      direction: p.isAfterDay(t, m.currentMonth) ? "left" : "right"
    });
  }, [m.currentMonth, h, d, p]),
      y = React.useCallback(function (e) {
    return null !== validateDate$1(p, e, {
      disablePast: n,
      disableFuture: r,
      minDate: i,
      maxDate: o,
      shouldDisableDate: c
    });
  }, [r, n, o, i, c, p]),
      v = React.useCallback(function () {
    f({
      type: "finishMonthSwitchingAnimation"
    });
  }, []),
      _ = React.useCallback(function (e) {
    y(e) || f({
      type: "changeFocusedDay",
      focusedDay: e
    });
  }, [y]);

  return {
    calendarState: m,
    changeMonth: b,
    changeFocusedDay: _,
    isDateDisabled: y,
    onMonthSwitchingAnimationEnd: v,
    handleChangeMonth: h
  };
}

var reflow = function reflow(e) {
  return e.scrollTop;
};

function getTransitionProps(e, t) {
  var r, n;
  var a = e.timeout,
      o = e.easing,
      _e$style = e.style,
      i = _e$style === void 0 ? {} : _e$style;
  return {
    duration: null != (r = i.transitionDuration) ? r : "number" == typeof a ? a : a[t.mode] || 0,
    easing: null != (n = i.transitionTimingFunction) ? n : "object" == typeof o ? o[t.mode] : o,
    delay: i.transitionDelay
  };
}

var _excluded$g = ["addEndListener", "appear", "children", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"],
    styles$1 = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  }
},
    Fade$1 = React.forwardRef(function (e, t) {
  var r = useTheme(),
      n = {
    enter: r.transitions.duration.enteringScreen,
    exit: r.transitions.duration.leavingScreen
  },
      a = e.addEndListener,
      _e$appear = e.appear,
      o = _e$appear === void 0 ? !0 : _e$appear,
      i = e.children,
      s = e.easing,
      l = e.in,
      c = e.onEnter,
      u = e.onEntered,
      d = e.onEntering,
      p = e.onExit,
      g = e.onExited,
      m = e.onExiting,
      f = e.style,
      _e$timeout = e.timeout,
      h = _e$timeout === void 0 ? n : _e$timeout,
      _e$TransitionComponen = e.TransitionComponent,
      b = _e$TransitionComponen === void 0 ? Transition$1 : _e$TransitionComponen,
      y = _objectWithoutPropertiesLoose$4(e, _excluded$g),
      v = React.useRef(null),
      _ = useForkRef(i.ref, t),
      T = useForkRef(v, _),
      E = function E(e) {
    return function (t) {
      if (e) {
        var _r30 = v.current;
        void 0 === t ? e(_r30) : e(_r30, t);
      }
    };
  },
      S = E(d),
      x = E(function (e, t) {
    reflow(e);
    var n = getTransitionProps({
      style: f,
      timeout: h,
      easing: s
    }, {
      mode: "enter"
    });
    e.style.webkitTransition = r.transitions.create("opacity", n), e.style.transition = r.transitions.create("opacity", n), c && c(e, t);
  }),
      w = E(u),
      C = E(m),
      k = E(function (e) {
    var t = getTransitionProps({
      style: f,
      timeout: h,
      easing: s
    }, {
      mode: "exit"
    });
    e.style.webkitTransition = r.transitions.create("opacity", t), e.style.transition = r.transitions.create("opacity", t), p && p(e);
  }),
      $ = E(g);

  return jsx$1(b, _extends$e({
    appear: o,
    in: l,
    nodeRef: v,
    onEnter: x,
    onEntered: w,
    onEntering: S,
    onExit: k,
    onExited: $,
    onExiting: C,
    addEndListener: function addEndListener(e) {
      a && a(v.current, e);
    },
    timeout: h
  }, y, {
    children: function children(e, t) {
      return React.cloneElement(i, _extends$e({
        style: _extends$e({
          opacity: 0,
          visibility: "exited" !== e || l ? void 0 : "hidden"
        }, styles$1[e], f, i.props.style),
        ref: T
      }, t));
    }
  }));
});
"production" !== process.env.NODE_ENV && (Fade$1.propTypes = {
  addEndListener: PropTypes.func,
  appear: PropTypes.bool,
  children: elementAcceptingRef$1.isRequired,
  easing: PropTypes.oneOfType([PropTypes.shape({
    enter: PropTypes.string,
    exit: PropTypes.string
  }), PropTypes.string]),
  in: PropTypes.bool,
  onEnter: PropTypes.func,
  onEntered: PropTypes.func,
  onEntering: PropTypes.func,
  onExit: PropTypes.func,
  onExited: PropTypes.func,
  onExiting: PropTypes.func,
  style: PropTypes.object,
  timeout: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })])
});

var classes$1 = generateUtilityClasses("PrivatePickersFadeTransitionGroup", ["root"]),
    animationDuration = 500,
    PickersFadeTransitionGroupRoot = styled(TransitionGroup$1)({
  display: "block",
  position: "relative"
}),
    PickersFadeTransitionGroup = function PickersFadeTransitionGroup(_ref71) {
  var e = _ref71.children,
      t = _ref71.className,
      r = _ref71.reduceAnimations,
      n = _ref71.transKey;
  return r ? e : jsx$1(PickersFadeTransitionGroupRoot, {
    className: clsx(classes$1.root, t),
    children: jsx$1(Fade$1, {
      appear: !1,
      mountOnEnter: !0,
      unmountOnExit: !0,
      timeout: {
        appear: animationDuration,
        enter: animationDuration / 2,
        exit: 0
      },
      children: e
    }, n)
  });
},
    _excluded$f = ["allowSameDateSelection", "autoFocus", "className", "day", "disabled", "disableHighlightToday", "disableMargin", "hidden", "isAnimating", "onClick", "onDayFocus", "onDaySelect", "onFocus", "onKeyDown", "outsideCurrentMonth", "selected", "showDaysOutsideCurrentMonth", "children", "today"];

function getPickersDayUtilityClass(e) {
  return generateUtilityClass("MuiPickersDay", e);
}

var pickersDayClasses = generateUtilityClasses("MuiPickersDay", ["root", "dayWithMargin", "dayOutsideMonth", "hiddenDaySpacingFiller", "today", "selected", "disabled"]),
    useUtilityClasses$a = function useUtilityClasses$a(e) {
  var t = e.selected,
      r = e.disableMargin,
      n = e.disableHighlightToday,
      a = e.today,
      o = e.outsideCurrentMonth,
      i = e.showDaysOutsideCurrentMonth,
      s = e.classes;
  return composeClasses({
    root: ["root", t && "selected", !r && "dayWithMargin", !n && a && "today", o && i && "dayOutsideMonth"],
    hiddenDaySpacingFiller: ["hiddenDaySpacingFiller"]
  }, getPickersDayUtilityClass, s);
},
    styleArg = function styleArg(_ref72) {
  var _extends$a4;

  var e = _ref72.theme,
      t = _ref72.ownerState;
  return _extends$a({}, e.typography.caption, (_extends$a4 = {
    width: DAY_SIZE,
    height: DAY_SIZE,
    borderRadius: "50%",
    padding: 0,
    backgroundColor: e.palette.background.paper,
    color: e.palette.text.primary,
    "&:hover": {
      backgroundColor: alpha(e.palette.action.active, e.palette.action.hoverOpacity)
    },
    "&:focus": _defineProperty2({
      backgroundColor: alpha(e.palette.action.active, e.palette.action.hoverOpacity)
    }, "&.".concat(pickersDayClasses.selected), {
      willChange: "background-color",
      backgroundColor: e.palette.primary.dark
    })
  }, _defineProperty2(_extends$a4, "&.".concat(pickersDayClasses.selected), {
    color: e.palette.primary.contrastText,
    backgroundColor: e.palette.primary.main,
    fontWeight: e.typography.fontWeightMedium,
    transition: e.transitions.create("background-color", {
      duration: e.transitions.duration.short
    }),
    "&:hover": {
      willChange: "background-color",
      backgroundColor: e.palette.primary.dark
    }
  }), _defineProperty2(_extends$a4, "&.".concat(pickersDayClasses.disabled), {
    color: e.palette.text.disabled
  }), _extends$a4), !t.disableMargin && {
    margin: "0 ".concat(DAY_MARGIN, "px")
  }, t.outsideCurrentMonth && t.showDaysOutsideCurrentMonth && {
    color: e.palette.text.secondary
  }, !t.disableHighlightToday && t.today && _defineProperty2({}, "&:not(.".concat(pickersDayClasses.selected, ")"), {
    border: "1px solid ".concat(e.palette.text.secondary)
  }));
},
    overridesResolver$1 = function overridesResolver$1(e, t) {
  var r = e.ownerState;
  return [t.root, !r.disableMargin && t.dayWithMargin, !r.disableHighlightToday && r.today && t.today, !r.outsideCurrentMonth && r.showDaysOutsideCurrentMonth && t.dayOutsideMonth, r.outsideCurrentMonth && !r.showDaysOutsideCurrentMonth && t.hiddenDaySpacingFiller];
},
    PickersDayRoot = styled(ButtonBase, {
  name: "MuiPickersDay",
  slot: "Root",
  overridesResolver: overridesResolver$1
})(styleArg),
    PickersDayFiller = styled("div", {
  name: "MuiPickersDay",
  slot: "Root",
  overridesResolver: overridesResolver$1
})(function (_ref74) {
  var e = _ref74.theme,
      t = _ref74.ownerState;
  return _extends$a({}, styleArg({
    theme: e,
    ownerState: t
  }), {
    visibility: "hidden"
  });
}),
    noop = function noop() {},
    PickersDay = React.forwardRef(function (e, t) {
  var r = useThemeProps({
    props: e,
    name: "MuiPickersDay"
  }),
      _r$allowSameDateSelec = r.allowSameDateSelection,
      n = _r$allowSameDateSelec === void 0 ? !1 : _r$allowSameDateSelec,
      _r$autoFocus = r.autoFocus,
      a = _r$autoFocus === void 0 ? !1 : _r$autoFocus,
      o = r.className,
      i = r.day,
      _r$disabled3 = r.disabled,
      s = _r$disabled3 === void 0 ? !1 : _r$disabled3,
      _r$disableHighlightTo = r.disableHighlightToday,
      l = _r$disableHighlightTo === void 0 ? !1 : _r$disableHighlightTo,
      _r$disableMargin = r.disableMargin,
      c = _r$disableMargin === void 0 ? !1 : _r$disableMargin,
      u = r.isAnimating,
      d = r.onClick,
      _r$onDayFocus = r.onDayFocus,
      p = _r$onDayFocus === void 0 ? noop : _r$onDayFocus,
      g = r.onDaySelect,
      m = r.onFocus,
      f = r.onKeyDown,
      h = r.outsideCurrentMonth,
      _r$selected = r.selected,
      b = _r$selected === void 0 ? !1 : _r$selected,
      _r$showDaysOutsideCur = r.showDaysOutsideCurrentMonth,
      y = _r$showDaysOutsideCur === void 0 ? !1 : _r$showDaysOutsideCur,
      v = r.children,
      _r$today = r.today,
      _ = _r$today === void 0 ? !1 : _r$today,
      T = _objectWithoutPropertiesLoose$1(r, _excluded$f),
      E = _extends$a({}, r, {
    allowSameDateSelection: n,
    autoFocus: a,
    disabled: s,
    disableHighlightToday: l,
    disableMargin: c,
    selected: b,
    showDaysOutsideCurrentMonth: y,
    today: _
  }),
      S = useUtilityClasses$a(E),
      x = useUtils(),
      w = React.useRef(null),
      C = useForkRef(w, t);

  useEnhancedEffect$1(function () {
    !a || s || u || h || w.current.focus();
  }, [a, s, u, h]);
  var k = useTheme();
  return h && !y ? jsx$1(PickersDayFiller, {
    className: clsx(S.root, S.hiddenDaySpacingFiller, o),
    ownerState: E
  }) : jsx$1(PickersDayRoot, _extends$a({
    className: clsx(S.root, o),
    ownerState: E,
    ref: C,
    centerRipple: !0,
    disabled: s,
    "aria-label": v ? void 0 : x.format(i, "fullDate"),
    tabIndex: b ? 0 : -1,
    onFocus: function onFocus(e) {
      p && p(i), m && m(e);
    },
    onKeyDown: function onKeyDown(e) {
      switch (void 0 !== f && f(e), e.key) {
        case "ArrowUp":
          p(x.addDays(i, -7)), e.preventDefault();
          break;

        case "ArrowDown":
          p(x.addDays(i, 7)), e.preventDefault();
          break;

        case "ArrowLeft":
          p(x.addDays(i, "ltr" === k.direction ? -1 : 1)), e.preventDefault();
          break;

        case "ArrowRight":
          p(x.addDays(i, "ltr" === k.direction ? 1 : -1)), e.preventDefault();
          break;

        case "Home":
          p(x.startOfWeek(i)), e.preventDefault();
          break;

        case "End":
          p(x.endOfWeek(i)), e.preventDefault();
          break;

        case "PageUp":
          p(x.getNextMonth(i)), e.preventDefault();
          break;

        case "PageDown":
          p(x.getPreviousMonth(i)), e.preventDefault();
      }
    },
    onClick: function onClick(e) {
      !n && b || (s || g(i, "finish"), d && d(e));
    }
  }, T, {
    children: v || x.format(i, "dayOfMonth")
  }));
}),
    areDayPropsEqual = function areDayPropsEqual(e, t) {
  return e.autoFocus === t.autoFocus && e.isAnimating === t.isAnimating && e.today === t.today && e.disabled === t.disabled && e.selected === t.selected && e.disableMargin === t.disableMargin && e.showDaysOutsideCurrentMonth === t.showDaysOutsideCurrentMonth && e.disableHighlightToday === t.disableHighlightToday && e.className === t.className && e.outsideCurrentMonth === t.outsideCurrentMonth && e.onDayFocus === t.onDayFocus && e.onDaySelect === t.onDaySelect;
};

"production" !== process.env.NODE_ENV && (PickersDay.propTypes = {
  allowSameDateSelection: PropTypes.bool,
  autoFocus: PropTypes.bool,
  children: PropTypes.node,
  classes: PropTypes.object,
  className: PropTypes.string,
  day: PropTypes.any.isRequired,
  disabled: PropTypes.bool,
  disableHighlightToday: PropTypes.bool,
  disableMargin: PropTypes.bool,
  hidden: PropTypes.bool,
  isAnimating: PropTypes.bool,
  onClick: PropTypes.func,
  onDayFocus: PropTypes.func,
  onDaySelect: PropTypes.func.isRequired,
  onFocus: PropTypes.func,
  onKeyDown: PropTypes.func,
  outsideCurrentMonth: PropTypes.bool.isRequired,
  selected: PropTypes.bool,
  showDaysOutsideCurrentMonth: PropTypes.bool,
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  today: PropTypes.bool
});
var PickersDay$1 = React.memo(PickersDay, areDayPropsEqual);

var _excluded$e = ["children", "className", "reduceAnimations", "slideDirection", "transKey"],
    classes = generateUtilityClasses("PrivatePickersSlideTransition", ["root", "slideEnter-left", "slideEnter-right", "slideEnterActive", "slideEnterActive", "slideExit", "slideExitActiveLeft-left", "slideExitActiveLeft-right"]),
    slideAnimationDuration = 350,
    PickersSlideTransitionRoot = styled(TransitionGroup$1)(function (_ref75) {
  var _ref76;

  var e = _ref75.theme;
  var t = e.transitions.create("transform", {
    duration: slideAnimationDuration,
    easing: "cubic-bezier(0.35, 0.8, 0.4, 1)"
  });
  return _ref76 = {
    display: "block",
    position: "relative",
    overflowX: "hidden",
    "& > *": {
      position: "absolute",
      top: 0,
      right: 0,
      left: 0
    }
  }, _defineProperty2(_ref76, "& .".concat(classes["slideEnter-left"]), {
    willChange: "transform",
    transform: "translate(100%)",
    zIndex: 1
  }), _defineProperty2(_ref76, "& .".concat(classes["slideEnter-right"]), {
    willChange: "transform",
    transform: "translate(-100%)",
    zIndex: 1
  }), _defineProperty2(_ref76, "& .".concat(classes.slideEnterActive), {
    transform: "translate(0%)",
    transition: t
  }), _defineProperty2(_ref76, "& .".concat(classes.slideExit), {
    transform: "translate(0%)"
  }), _defineProperty2(_ref76, "& .".concat(classes["slideExitActiveLeft-left"]), {
    willChange: "transform",
    transform: "translate(-100%)",
    transition: t,
    zIndex: 0
  }), _defineProperty2(_ref76, "& .".concat(classes["slideExitActiveLeft-right"]), {
    willChange: "transform",
    transform: "translate(100%)",
    transition: t,
    zIndex: 0
  }), _ref76;
}),
    PickersSlideTransition = function PickersSlideTransition(e) {
  var t = e.children,
      r = e.className,
      n = e.reduceAnimations,
      a = e.slideDirection,
      o = e.transKey,
      i = _objectWithoutPropertiesLoose$1(e, _excluded$e);

  if (n) return jsx$1("div", {
    className: clsx(classes.root, r),
    children: t
  });
  var s = {
    exit: classes.slideExit,
    enterActive: classes.slideEnterActive,
    enter: classes["slideEnter-".concat(a)],
    exitActive: classes["slideExitActiveLeft-".concat(a)]
  };
  return jsx$1(PickersSlideTransitionRoot, {
    className: clsx(classes.root, r),
    childFactory: function childFactory(e) {
      return React.cloneElement(e, {
        classNames: s
      });
    },
    children: jsx$1(CSSTransition$1, _extends$a({
      mountOnEnter: !0,
      unmountOnExit: !0,
      timeout: slideAnimationDuration,
      classNames: s
    }, i, {
      children: t
    }), o)
  });
};

var _span$2;

var weeksContainerHeight = 6 * (DAY_SIZE + 4 * DAY_MARGIN),
    PickersCalendarDayHeader = styled("div")({
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
}),
    PickersCalendarWeekDayLabel = styled(Typography$1)(function (_ref77) {
  var e = _ref77.theme;
  return {
    width: 36,
    height: 40,
    margin: "0 2px",
    textAlign: "center",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: e.palette.text.secondary
  };
}),
    PickersCalendarLoadingContainer = styled("div")({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  minHeight: weeksContainerHeight
}),
    PickersCalendarSlideTransition = styled(PickersSlideTransition)({
  minHeight: weeksContainerHeight
}),
    PickersCalendarWeekContainer = styled("div")({
  overflow: "hidden"
}),
    PickersCalendarWeek = styled("div")({
  margin: "".concat(DAY_MARGIN, "px 0"),
  display: "flex",
  justifyContent: "center"
});

function PickersCalendar(e) {
  var t = e.allowSameDateSelection,
      r = e.autoFocus,
      n = e.onFocusedDayChange,
      a = e.className,
      o = e.currentMonth,
      i = e.date,
      s = e.disabled,
      l = e.disableHighlightToday,
      c = e.focusedDay,
      u = e.isDateDisabled,
      d = e.isMonthSwitchingAnimating,
      p = e.loading,
      g = e.onChange,
      m = e.onMonthSwitchingAnimationEnd,
      f = e.readOnly,
      h = e.reduceAnimations,
      b = e.renderDay,
      _e$renderLoading = e.renderLoading,
      y = _e$renderLoading === void 0 ? function () {
    return _span$2 || (_span$2 = jsx$1("span", {
      children: "..."
    }));
  } : _e$renderLoading,
      v = e.showDaysOutsideCurrentMonth,
      _ = e.slideDirection,
      T = e.TransitionProps,
      E = useNow(),
      S = useUtils(),
      x = React.useCallback(function (e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "finish";
    if (f) return;
    var r = Array.isArray(i) ? e : S.mergeDateAndTime(e, i || E);
    g(r, t);
  }, [i, E, g, f, S]),
      w = S.getMonth(o),
      C = (Array.isArray(i) ? i : [i]).filter(Boolean).map(function (e) {
    return e && S.startOfDay(e);
  }),
      k = w,
      $ = React.useMemo(function () {
    return React.createRef();
  }, [k]);
  return jsxs(React.Fragment, {
    children: [jsx$1(PickersCalendarDayHeader, {
      children: S.getWeekdays().map(function (e, t) {
        return jsx$1(PickersCalendarWeekDayLabel, {
          "aria-hidden": !0,
          variant: "caption",
          children: e.charAt(0).toUpperCase()
        }, e + t.toString());
      })
    }), p ? jsx$1(PickersCalendarLoadingContainer, {
      children: y()
    }) : jsx$1(PickersCalendarSlideTransition, _extends$a({
      transKey: k,
      onExited: m,
      reduceAnimations: h,
      slideDirection: _,
      className: a
    }, T, {
      nodeRef: $,
      children: jsx$1(PickersCalendarWeekContainer, {
        ref: $,
        role: "grid",
        children: S.getWeekArray(o).map(function (e) {
          return jsx$1(PickersCalendarWeek, {
            role: "row",
            children: e.map(function (e) {
              var a = {
                key: null == e ? void 0 : e.toString(),
                day: e,
                isAnimating: d,
                disabled: s || u(e),
                allowSameDateSelection: t,
                autoFocus: r && null !== c && S.isSameDay(e, c),
                today: S.isSameDay(e, E),
                outsideCurrentMonth: S.getMonth(e) !== w,
                selected: C.some(function (t) {
                  return t && S.isSameDay(t, e);
                }),
                disableHighlightToday: l,
                showDaysOutsideCurrentMonth: v,
                onDayFocus: n,
                onDaySelect: x
              };
              return b ? b(e, C, a) : jsx$1("div", {
                role: "cell",
                children: jsx$1(PickersDay$1, _extends$a({}, a))
              }, a.key);
            })
          }, "week-".concat(e[0]));
        })
      })
    }))]
  });
}

var ArrowDropDownIcon = createSvgIcon$1(jsx$1("path", {
  d: "M7 10l5 5 5-5z"
}), "ArrowDropDown");
var PickersCalendarHeaderRoot = styled("div")({
  display: "flex",
  alignItems: "center",
  marginTop: 16,
  marginBottom: 8,
  paddingLeft: 24,
  paddingRight: 12,
  maxHeight: 30,
  minHeight: 30
}),
    PickersCalendarHeaderLabel = styled("div")(function (_ref78) {
  var e = _ref78.theme;
  return _extends$a({
    display: "flex",
    maxHeight: 30,
    overflow: "hidden",
    alignItems: "center",
    cursor: "pointer",
    marginRight: "auto"
  }, e.typography.body1, {
    fontWeight: e.typography.fontWeightMedium
  });
}),
    PickersCalendarHeaderLabelItem = styled("div")({
  marginRight: 6
}),
    PickersCalendarHeaderSwitchViewButton = styled(IconButton$1)({
  marginRight: "auto"
}),
    PickersCalendarHeaderSwitchView = styled(ArrowDropDownIcon)(function (_ref79) {
  var e = _ref79.theme,
      t = _ref79.ownerState;
  return _extends$a({
    willChange: "transform",
    transition: e.transitions.create("transform"),
    transform: "rotate(0deg)"
  }, "year" === t.openView && {
    transform: "rotate(180deg)"
  });
});

function getSwitchingViewAriaText(e) {
  return "year" === e ? "year view is open, switch to calendar view" : "calendar view is open, switch to year view";
}

function PickersCalendarHeader(e) {
  var _e$components4 = e.components,
      t = _e$components4 === void 0 ? {} : _e$components4,
      _e$componentsProps4 = e.componentsProps,
      r = _e$componentsProps4 === void 0 ? {} : _e$componentsProps4,
      n = e.currentMonth,
      a = e.disabled,
      o = e.disableFuture,
      i = e.disablePast,
      _e$getViewSwitchingBu = e.getViewSwitchingButtonText,
      s = _e$getViewSwitchingBu === void 0 ? getSwitchingViewAriaText : _e$getViewSwitchingBu,
      _e$leftArrowButtonTex = e.leftArrowButtonText,
      l = _e$leftArrowButtonTex === void 0 ? "Previous month" : _e$leftArrowButtonTex,
      c = e.maxDate,
      u = e.minDate,
      d = e.onMonthChange,
      p = e.onViewChange,
      g = e.openView,
      m = e.reduceAnimations,
      _e$rightArrowButtonTe = e.rightArrowButtonText,
      f = _e$rightArrowButtonTe === void 0 ? "Next month" : _e$rightArrowButtonTe,
      h = e.views,
      b = useUtils(),
      y = r.switchViewButton || {},
      v = useNextMonthDisabled(n, {
    disableFuture: o || a,
    maxDate: c
  }),
      _ = usePreviousMonthDisabled(n, {
    disablePast: i || a,
    minDate: u
  });

  if (1 === h.length && "year" === h[0]) return null;
  var T = e;
  return jsxs(PickersCalendarHeaderRoot, {
    ownerState: T,
    children: [jsxs(PickersCalendarHeaderLabel, {
      role: "presentation",
      onClick: function onClick() {
        if (1 !== h.length && p && !a) if (2 === h.length) p(h.find(function (e) {
          return e !== g;
        }) || h[0]);else {
          var _e50 = 0 !== h.indexOf(g) ? 0 : 1;

          p(h[_e50]);
        }
      },
      ownerState: T,
      children: [jsx$1(PickersFadeTransitionGroup, {
        reduceAnimations: m,
        transKey: b.format(n, "month"),
        children: jsx$1(PickersCalendarHeaderLabelItem, {
          "aria-live": "polite",
          ownerState: T,
          children: b.format(n, "month")
        })
      }), jsx$1(PickersFadeTransitionGroup, {
        reduceAnimations: m,
        transKey: b.format(n, "year"),
        children: jsx$1(PickersCalendarHeaderLabelItem, {
          "aria-live": "polite",
          ownerState: T,
          children: b.format(n, "year")
        })
      }), h.length > 1 && !a && jsx$1(PickersCalendarHeaderSwitchViewButton, _extends$a({
        size: "small",
        as: t.SwitchViewButton,
        "aria-label": s(g)
      }, y, {
        children: jsx$1(PickersCalendarHeaderSwitchView, {
          as: t.SwitchViewIcon,
          ownerState: T
        })
      }))]
    }), jsx$1(Fade$1, {
      in: "day" === g,
      children: jsx$1(PickersArrowSwitcher, {
        leftArrowButtonText: l,
        rightArrowButtonText: f,
        components: t,
        componentsProps: r,
        onLeftClick: function onLeftClick() {
          return d(b.getPreviousMonth(n), "right");
        },
        onRightClick: function onRightClick() {
          return d(b.getNextMonth(n), "left");
        },
        isLeftDisabled: _,
        isRightDisabled: v
      })
    })]
  });
}

function getPickersYearUtilityClass(e) {
  return generateUtilityClass("PrivatePickersYear", e);
}

var pickersYearClasses = generateUtilityClasses("PrivatePickersYear", ["root", "modeMobile", "modeDesktop", "yearButton", "disabled", "selected"]),
    useUtilityClasses$9 = function useUtilityClasses$9(e) {
  var t = e.wrapperVariant,
      r = e.disabled,
      n = e.selected,
      a = e.classes;
  return composeClasses({
    root: ["root", t && "mode".concat(capitalize(t))],
    yearButton: ["yearButton", r && "disabled", n && "selected"]
  }, getPickersYearUtilityClass, a);
},
    PickersYearRoot = styled("div")(function (_ref80) {
  var e = _ref80.ownerState;
  return _extends$a({
    flexBasis: "33.3%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }, "desktop" === (null == e ? void 0 : e.wrapperVariant) && {
    flexBasis: "25%"
  });
}),
    PickersYearButton = styled("button")(function (_ref81) {
  var _extends$a5;

  var e = _ref81.theme;
  return _extends$a({
    color: "unset",
    backgroundColor: "transparent",
    border: 0,
    outline: 0
  }, e.typography.subtitle1, (_extends$a5 = {
    margin: "8px 0",
    height: 36,
    width: 72,
    borderRadius: 18,
    cursor: "pointer",
    "&:focus, &:hover": {
      backgroundColor: alpha(e.palette.action.active, e.palette.action.hoverOpacity)
    }
  }, _defineProperty2(_extends$a5, "&.".concat(pickersYearClasses.disabled), {
    color: e.palette.text.secondary
  }), _defineProperty2(_extends$a5, "&.".concat(pickersYearClasses.selected), {
    color: e.palette.primary.contrastText,
    backgroundColor: e.palette.primary.main,
    "&:focus, &:hover": {
      backgroundColor: e.palette.primary.dark
    }
  }), _extends$a5));
}),
    PickersYear = React.forwardRef(function (e, t) {
  var r = e.autoFocus,
      n = e.className,
      a = e.children,
      o = e.disabled,
      i = e.onClick,
      s = e.onKeyDown,
      l = e.selected,
      c = e.value,
      u = React.useRef(null),
      d = useForkRef(u, t),
      p = _extends$a({}, e, {
    wrapperVariant: React.useContext(WrapperVariantContext)
  }),
      g = useUtilityClasses$9(p);

  return React.useEffect(function () {
    r && u.current.focus();
  }, [r]), jsx$1(PickersYearRoot, {
    className: clsx(g.root, n),
    ownerState: p,
    children: jsx$1(PickersYearButton, {
      ref: d,
      disabled: o,
      type: "button",
      tabIndex: l ? 0 : -1,
      onClick: function onClick(e) {
        return i(e, c);
      },
      onKeyDown: function onKeyDown(e) {
        return s(e, c);
      },
      className: g.yearButton,
      ownerState: p,
      children: a
    })
  });
});

function getYearPickerUtilityClass(e) {
  return generateUtilityClass("MuiYearPicker", e);
}

generateUtilityClasses("MuiYearPicker", ["root"]);

var useUtilityClasses$8 = function useUtilityClasses$8(e) {
  var t = e.classes;
  return composeClasses({
    root: ["root"]
  }, getYearPickerUtilityClass, t);
},
    YearPickerRoot = styled("div", {
  name: "MuiYearPicker",
  slot: "Root",
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})({
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  overflowY: "auto",
  height: "100%",
  margin: "0 4px"
}),
    YearPicker = React.forwardRef(function (e, t) {
  var r = useThemeProps({
    props: e,
    name: "MuiYearPicker"
  }),
      n = r.autoFocus,
      a = r.className,
      o = r.date,
      i = r.disabled,
      s = r.disableFuture,
      l = r.disablePast,
      c = r.isDateDisabled,
      u = r.maxDate,
      d = r.minDate,
      p = r.onChange,
      g = r.onFocusedDayChange,
      m = r.onYearChange,
      f = r.readOnly,
      h = r.shouldDisableYear,
      b = r,
      y = useUtilityClasses$8(b),
      v = useNow(),
      _ = useTheme(),
      T = useUtils(),
      E = o || v,
      S = T.getYear(E),
      x = React.useContext(WrapperVariantContext),
      w = React.useRef(null),
      _React$useState17 = React.useState(S),
      _React$useState18 = _slicedToArray(_React$useState17, 2),
      C = _React$useState18[0],
      k = _React$useState18[1],
      $ = function $(e, t) {
    var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "finish";
    if (f) return;

    var n = function n(e) {
      p(e, r), g && g(e || v), m && m(e);
    },
        a = T.setYear(E, t);

    if (c(a)) {
      n(findClosestEnabledDate({
        utils: T,
        date: a,
        minDate: d,
        maxDate: u,
        disablePast: Boolean(l),
        disableFuture: Boolean(s),
        shouldDisableDate: c
      }) || v);
    } else n(a);
  },
      R = React.useCallback(function (e) {
    c(T.setYear(E, e)) || k(e);
  }, [E, c, T]),
      A = "desktop" === x ? 4 : 3,
      I = function I(e, t) {
    switch (e.key) {
      case "ArrowUp":
        R(t - A), e.preventDefault();
        break;

      case "ArrowDown":
        R(t + A), e.preventDefault();
        break;

      case "ArrowLeft":
        R(t + ("ltr" === _.direction ? -1 : 1)), e.preventDefault();
        break;

      case "ArrowRight":
        R(t + ("ltr" === _.direction ? 1 : -1)), e.preventDefault();
    }
  };

  return jsx$1(YearPickerRoot, {
    ref: t,
    className: clsx(y.root, a),
    ownerState: b,
    children: T.getYearRange(d, u).map(function (e) {
      var t = T.getYear(e),
          r = t === S;
      return jsx$1(PickersYear, {
        selected: r,
        value: t,
        onClick: $,
        onKeyDown: I,
        autoFocus: n && t === C,
        ref: r ? w : void 0,
        disabled: i || l && T.isBeforeYear(e, v) || s && T.isAfterYear(e, v) || h && h(e),
        children: T.format(e, "year")
      }, T.format(e, "year"));
    })
  });
});

"production" !== process.env.NODE_ENV && (YearPicker.propTypes = {
  autoFocus: PropTypes.bool,
  classes: PropTypes.object,
  className: PropTypes.string,
  date: PropTypes.any,
  disabled: PropTypes.bool,
  disableFuture: PropTypes.bool,
  disablePast: PropTypes.bool,
  isDateDisabled: PropTypes.func.isRequired,
  maxDate: PropTypes.any.isRequired,
  minDate: PropTypes.any.isRequired,
  onChange: PropTypes.func.isRequired,
  onFocusedDayChange: PropTypes.func,
  onYearChange: PropTypes.func,
  readOnly: PropTypes.bool,
  shouldDisableYear: PropTypes.func
});
var PickerView = styled("div")({
  overflowX: "hidden",
  width: DIALOG_WIDTH,
  maxHeight: VIEW_HEIGHT,
  display: "flex",
  flexDirection: "column",
  margin: "0 auto"
});

var _span$1;

var _excluded$d = ["autoFocus", "onViewChange", "date", "disableFuture", "disablePast", "defaultCalendarMonth", "loading", "maxDate", "minDate", "onChange", "onMonthChange", "reduceAnimations", "renderLoading", "shouldDisableDate", "shouldDisableYear", "view", "views", "openTo", "className"];

function getCalendarPickerUtilityClass(e) {
  return generateUtilityClass("MuiCalendarPicker", e);
}

generateUtilityClasses("MuiCalendarPicker", ["root", "viewTransitionContainer"]);

var useUtilityClasses$7 = function useUtilityClasses$7(e) {
  var t = e.classes;
  return composeClasses({
    root: ["root"],
    viewTransitionContainer: ["viewTransitionContainer"]
  }, getCalendarPickerUtilityClass, t);
},
    CalendarPickerRoot = styled(PickerView, {
  name: "MuiCalendarPicker",
  slot: "Root",
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})({
  display: "flex",
  flexDirection: "column"
}),
    CalendarPickerViewTransitionContainer = styled(PickersFadeTransitionGroup, {
  name: "MuiCalendarPicker",
  slot: "ViewTransitionContainer",
  overridesResolver: function overridesResolver(e, t) {
    return t.viewTransitionContainer;
  }
})({
  overflowY: "auto"
}),
    defaultReduceAnimations = "undefined" != typeof navigator && /(android)/i.test(navigator.userAgent),
    CalendarPicker = React.forwardRef(function (e, t) {
  var r = useThemeProps({
    props: e,
    name: "MuiCalendarPicker"
  }),
      n = r.autoFocus,
      a = r.onViewChange,
      o = r.date,
      _r$disableFuture = r.disableFuture,
      i = _r$disableFuture === void 0 ? !1 : _r$disableFuture,
      _r$disablePast = r.disablePast,
      s = _r$disablePast === void 0 ? !1 : _r$disablePast,
      l = r.defaultCalendarMonth,
      _r$loading = r.loading,
      c = _r$loading === void 0 ? !1 : _r$loading,
      u = r.maxDate,
      d = r.minDate,
      p = r.onChange,
      g = r.onMonthChange,
      _r$reduceAnimations = r.reduceAnimations,
      m = _r$reduceAnimations === void 0 ? defaultReduceAnimations : _r$reduceAnimations,
      _r$renderLoading = r.renderLoading,
      f = _r$renderLoading === void 0 ? function () {
    return _span$1 || (_span$1 = jsx$1("span", {
      children: "..."
    }));
  } : _r$renderLoading,
      h = r.shouldDisableDate,
      b = r.shouldDisableYear,
      y = r.view,
      _r$views = r.views,
      v = _r$views === void 0 ? ["year", "day"] : _r$views,
      _r$openTo = r.openTo,
      _ = _r$openTo === void 0 ? "day" : _r$openTo,
      T = r.className,
      E = _objectWithoutPropertiesLoose$1(r, _excluded$d),
      S = useUtils(),
      x = useDefaultDates(),
      w = null != d ? d : x.minDate,
      C = null != u ? u : x.maxDate,
      _useViews = useViews({
    view: y,
    views: v,
    openTo: _,
    onChange: p,
    onViewChange: a
  }),
      k = _useViews.openView,
      $ = _useViews.setOpenView,
      _useCalendarState = useCalendarState({
    date: o,
    defaultCalendarMonth: l,
    reduceAnimations: m,
    onMonthChange: g,
    minDate: w,
    maxDate: C,
    shouldDisableDate: h,
    disablePast: s,
    disableFuture: i
  }),
      R = _useCalendarState.calendarState,
      A = _useCalendarState.changeFocusedDay,
      I = _useCalendarState.changeMonth,
      N = _useCalendarState.isDateDisabled,
      P = _useCalendarState.handleChangeMonth,
      O = _useCalendarState.onMonthSwitchingAnimationEnd;

  React.useEffect(function () {
    if (o && N(o)) {
      var _e51 = findClosestEnabledDate({
        utils: S,
        date: o,
        minDate: w,
        maxDate: C,
        disablePast: s,
        disableFuture: i,
        shouldDisableDate: N
      });

      p(_e51, "partial");
    }
  }, []), React.useEffect(function () {
    o && I(o);
  }, [o]);
  var D = r,
      L = useUtilityClasses$7(D),
      M = {
    className: T,
    date: o,
    disabled: E.disabled,
    disablePast: s,
    disableFuture: i,
    onChange: p,
    minDate: w,
    maxDate: C,
    onMonthChange: g,
    readOnly: E.readOnly
  };
  return jsxs(CalendarPickerRoot, {
    ref: t,
    className: clsx(L.root, T),
    ownerState: D,
    children: [jsx$1(PickersCalendarHeader, _extends$a({}, E, {
      views: v,
      openView: k,
      currentMonth: R.currentMonth,
      onViewChange: $,
      onMonthChange: function onMonthChange(e, t) {
        return P({
          newMonth: e,
          direction: t
        });
      },
      minDate: w,
      maxDate: C,
      disablePast: s,
      disableFuture: i,
      reduceAnimations: m
    })), jsx$1(CalendarPickerViewTransitionContainer, {
      reduceAnimations: m,
      className: L.viewTransitionContainer,
      transKey: k,
      ownerState: D,
      children: jsxs("div", {
        children: ["year" === k && jsx$1(YearPicker, _extends$a({}, E, {
          autoFocus: n,
          date: o,
          onChange: p,
          minDate: w,
          maxDate: C,
          disableFuture: i,
          disablePast: s,
          isDateDisabled: N,
          shouldDisableYear: b,
          onFocusedDayChange: A
        })), "month" === k && jsx$1(MonthPicker, _extends$a({}, M)), "day" === k && jsx$1(PickersCalendar, _extends$a({}, E, R, {
          autoFocus: n,
          onMonthSwitchingAnimationEnd: O,
          onFocusedDayChange: A,
          reduceAnimations: m,
          date: o,
          onChange: p,
          isDateDisabled: N,
          loading: c,
          renderLoading: f
        }))]
      })
    })]
  });
});

"production" !== process.env.NODE_ENV && (CalendarPicker.propTypes = {
  autoFocus: PropTypes.bool,
  classes: PropTypes.object,
  className: PropTypes.string,
  date: PropTypes.any,
  defaultCalendarMonth: PropTypes.any,
  disabled: PropTypes.bool,
  disableFuture: PropTypes.bool,
  disablePast: PropTypes.bool,
  loading: PropTypes.bool,
  maxDate: PropTypes.any,
  minDate: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  onMonthChange: PropTypes.func,
  onViewChange: PropTypes.func,
  openTo: PropTypes.oneOf(["day", "month", "year"]),
  readOnly: PropTypes.bool,
  reduceAnimations: PropTypes.bool,
  renderLoading: PropTypes.func,
  shouldDisableDate: PropTypes.func,
  shouldDisableYear: PropTypes.func,
  view: PropTypes.oneOf(["day", "month", "year"]),
  views: PropTypes.arrayOf(PropTypes.oneOf(["day", "month", "year"]).isRequired)
});
var FormControlContext = React.createContext();

function useFormControl() {
  return React.useContext(FormControlContext);
}

function getInputAdornmentUtilityClass(e) {
  return generateUtilityClass("MuiInputAdornment", e);
}

"production" !== process.env.NODE_ENV && (FormControlContext.displayName = "FormControlContext");
var inputAdornmentClasses = generateUtilityClasses("MuiInputAdornment", ["root", "filled", "standard", "outlined", "positionStart", "positionEnd", "disablePointerEvents", "hiddenLabel", "sizeSmall"]);

var _span;

var _excluded$c = ["children", "className", "component", "disablePointerEvents", "disableTypography", "position", "variant"],
    overridesResolver = function overridesResolver(e, t) {
  var r = e.ownerState;
  return [t.root, t["position".concat(capitalize(r.position))], !0 === r.disablePointerEvents && t.disablePointerEvents, t[r.variant]];
},
    useUtilityClasses$6 = function useUtilityClasses$6(e) {
  var t = e.classes,
      r = e.disablePointerEvents,
      n = e.hiddenLabel,
      a = e.position,
      o = e.size,
      i = e.variant;
  return composeClasses({
    root: ["root", r && "disablePointerEvents", a && "position".concat(capitalize(a)), i, n && "hiddenLabel", o && "size".concat(capitalize(o))]
  }, getInputAdornmentUtilityClass, t);
},
    InputAdornmentRoot = styled("div", {
  name: "MuiInputAdornment",
  slot: "Root",
  overridesResolver: overridesResolver
})(function (_ref82) {
  var e = _ref82.theme,
      t = _ref82.ownerState;
  return _extends$e({
    display: "flex",
    height: "0.01em",
    maxHeight: "2em",
    alignItems: "center",
    whiteSpace: "nowrap",
    color: e.palette.action.active
  }, "filled" === t.variant && _defineProperty2({}, "&.".concat(inputAdornmentClasses.positionStart, "&:not(.").concat(inputAdornmentClasses.hiddenLabel, ")"), {
    marginTop: 16
  }), "start" === t.position && {
    marginRight: 8
  }, "end" === t.position && {
    marginLeft: 8
  }, !0 === t.disablePointerEvents && {
    pointerEvents: "none"
  });
}),
    InputAdornment = React.forwardRef(function (e, t) {
  var r = useThemeProps({
    props: e,
    name: "MuiInputAdornment"
  }),
      n = r.children,
      a = r.className,
      _r$component4 = r.component,
      o = _r$component4 === void 0 ? "div" : _r$component4,
      _r$disablePointerEven = r.disablePointerEvents,
      i = _r$disablePointerEven === void 0 ? !1 : _r$disablePointerEven,
      _r$disableTypography = r.disableTypography,
      s = _r$disableTypography === void 0 ? !1 : _r$disableTypography,
      l = r.position,
      c = r.variant,
      u = _objectWithoutPropertiesLoose$4(r, _excluded$c),
      d = useFormControl() || {};

  var p = c;
  c && d.variant && "production" !== process.env.NODE_ENV && c === d.variant && console.error("MUI: The `InputAdornment` variant infers the variant prop you do not have to provide one."), d && !p && (p = d.variant);

  var g = _extends$e({}, r, {
    hiddenLabel: d.hiddenLabel,
    size: d.size,
    disablePointerEvents: i,
    position: l,
    variant: p
  }),
      m = useUtilityClasses$6(g);

  return jsx$1(FormControlContext.Provider, {
    value: null,
    children: jsx$1(InputAdornmentRoot, _extends$e({
      as: o,
      ownerState: g,
      className: clsx(m.root, a),
      ref: t
    }, u, {
      children: "string" != typeof n || s ? jsxs(React.Fragment, {
        children: ["start" === l ? _span || (_span = jsx$1("span", {
          className: "notranslate",
          children: "​"
        })) : null, n]
      }) : jsx$1(Typography$1, {
        color: "text.secondary",
        children: n
      })
    }))
  });
});

"production" !== process.env.NODE_ENV && (InputAdornment.propTypes = {
  children: PropTypes.node,
  classes: PropTypes.object,
  className: PropTypes.string,
  component: PropTypes.elementType,
  disablePointerEvents: PropTypes.bool,
  disableTypography: PropTypes.bool,
  position: PropTypes.oneOf(["end", "start"]).isRequired,
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  variant: PropTypes.oneOf(["filled", "outlined", "standard"])
});
var InputAdornment$1 = InputAdornment;

var useRifm = function useRifm(e) {
  var _useReducer = useReducer(function (e) {
    return e + 1;
  }, 0),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      t = _useReducer2[1],
      r = useRef(null),
      n = e.replace,
      a = e.append,
      o = n ? n(e.format(e.value)) : e.format(e.value),
      i = useRef(!1);

  return "production" !== process.env.NODE_ENV && "undefined" == typeof window || useLayoutEffect(function () {
    if (null == r.current) return;

    var _r$current = _slicedToArray(r.current, 5),
        i = _r$current[0],
        s = _r$current[1],
        l = _r$current[2],
        c = _r$current[3],
        u = _r$current[4];

    r.current = null;

    var d = c && u,
        p = i.slice(s.selectionStart).search(e.accept || /\d/g),
        g = -1 !== p ? p : 0,
        m = function m(t) {
      return (t.match(e.accept || /\d/g) || []).join("");
    },
        f = m(i.substr(0, s.selectionStart)),
        h = function h(e) {
      var t = 0,
          r = 0;

      for (var _n14 = 0; _n14 !== f.length; ++_n14) {
        var _a12 = e.indexOf(f[_n14], t) + 1,
            _o10 = m(e).indexOf(f[_n14], r) + 1;

        _o10 - r > 1 && (_a12 = t, _o10 = r), r = Math.max(_o10, r), t = Math.max(t, _a12);
      }

      return t;
    };

    if (!0 === e.mask && l && !u) {
      var _e52 = h(i);

      var _t43 = m(i.substr(_e52))[0];
      _e52 = i.indexOf(_t43, _e52), i = "".concat(i.substr(0, _e52)).concat(i.substr(_e52 + 1));
    }

    var b = e.format(i);
    null == a || s.selectionStart !== i.length || u || (l ? b = a(b) : "" === m(b.slice(-1)) && (b = b.slice(0, -1)));
    var y = n ? n(b) : b;
    return o === y ? t() : e.onChange(y), function () {
      var t = h(b);
      if (null != e.mask && (l || c && !d)) for (; b[t] && "" === m(b[t]);) {
        t += 1;
      }
      s.selectionStart = s.selectionEnd = t + (d ? 1 + g : 0);
    };
  }), useEffect(function () {
    var e = function e(_e53) {
      "Delete" === _e53.code && (i.current = !0);
    },
        t = function t(e) {
      "Delete" === e.code && (i.current = !1);
    };

    return document.addEventListener("keydown", e), document.addEventListener("keyup", t), function () {
      document.removeEventListener("keydown", e), document.removeEventListener("keyup", t);
    };
  }, []), {
    value: null != r.current ? r.current[0] : o,
    onChange: function onChange(n) {
      if ("production" !== process.env.NODE_ENV) {
        if ("number" === n.target.type) return void console.error("Rifm does not support input type=number, use type=tel instead.");
        if ("date" === n.target.type) return void console.error("Rifm does not support input type=date.");
      }

      var a = n.target.value;

      if (r.current = [a, n.target, a.length > o.length, i.current, o === e.format(a)], "production" !== process.env.NODE_ENV) {
        var _t44 = e.format(a);

        a !== _t44 && a.toLowerCase() === _t44.toLowerCase() && console.warn("Case enforcement does not work with format. Please use replace={value => value.toLowerCase()} instead");
      }

      t();
    }
  };
};

function getTextFieldAriaText(e, t) {
  return e && t.isValid(t.date(e)) ? "Choose date, selected date is ".concat(t.format(t.date(e), "fullDate")) : "Choose date";
}

var getDisplayDate = function getDisplayDate(e, t, r) {
  var n = e.date(t);
  return null === t ? "" : e.isValid(n) ? e.formatByString(n, r) : "";
},
    MASK_USER_INPUT_SYMBOL = "_",
    staticDateWith2DigitTokens = "2019-11-21T22:30:00.000",
    staticDateWith1DigitTokens = "2019-01-01T09:00:00.000";

function checkMaskIsValidForCurrentFormat(e, t, r, n) {
  var a = n.formatByString(n.date(staticDateWith1DigitTokens), t).replace(r, MASK_USER_INPUT_SYMBOL),
      o = n.formatByString(n.date(staticDateWith2DigitTokens), t).replace(r, "_") === e && a === e;
  return o || "luxon" === n.lib || "production" === process.env.NODE_ENV || console.warn("The mask \"".concat(e, "\" you passed is not valid for the format used ").concat(t, ". Falling down to uncontrolled not-masked input.")), o;
}

var maskedDateFormatter = function maskedDateFormatter(e, t) {
  return function (r) {
    return r.split("").map(function (n, a) {
      if (t.lastIndex = 0, a > e.length - 1) return "";
      var o = e[a],
          i = e[a + 1],
          s = t.test(n) ? n : "",
          l = o === MASK_USER_INPUT_SYMBOL ? s : o + s;
      return a === r.length - 1 && i && i !== MASK_USER_INPUT_SYMBOL ? l ? l + i : "" : l;
    }).join("");
  };
};

function useMaskedInput(_ref84) {
  var _ref84$acceptRegex = _ref84.acceptRegex,
      e = _ref84$acceptRegex === void 0 ? /[\d]/gi : _ref84$acceptRegex,
      t = _ref84.disabled,
      r = _ref84.disableMaskedInput,
      n = _ref84.ignoreInvalidInputs,
      a = _ref84.inputFormat,
      o = _ref84.inputProps,
      i = _ref84.label,
      s = _ref84.mask,
      l = _ref84.onChange,
      c = _ref84.rawValue,
      u = _ref84.readOnly,
      d = _ref84.rifmFormatter,
      p = _ref84.TextFieldProps,
      g = _ref84.validationError;

  var m = useUtils(),
      _React$useState19 = React.useState(!1),
      _React$useState20 = _slicedToArray(_React$useState19, 2),
      f = _React$useState20[0],
      h = _React$useState20[1],
      b = m.getFormatHelperText(a),
      y = React.useMemo(function () {
    return !(!s || r) && checkMaskIsValidForCurrentFormat(s, a, e, m);
  }, [e, r, a, s, m]),
      v = React.useMemo(function () {
    return y && s ? maskedDateFormatter(s, e) : function (e) {
      return e;
    };
  }, [e, s, y]),
      _ = getDisplayDate(m, c, a),
      _React$useState21 = React.useState(_),
      _React$useState22 = _slicedToArray(_React$useState21, 2),
      T = _React$useState22[0],
      E = _React$useState22[1],
      S = React.useRef(_);

  React.useEffect(function () {
    S.current = _;
  }, [_]);
  var x = !f,
      w = S.current !== _;
  x && w && (null === c || m.isValid(c)) && _ !== T && E(_);

  var C = function C(e) {
    var t = "" === e || e === s ? "" : e;
    E(t);
    var r = null === t ? null : m.parse(t, a);
    n && !m.isValid(r) || l(r, t || void 0);
  },
      k = useRifm({
    value: T,
    onChange: C,
    format: d || v
  });

  return _extends$a({
    label: i,
    disabled: t,
    error: g,
    inputProps: _extends$a({}, y ? k : {
      value: T,
      onChange: function onChange(e) {
        C(e.currentTarget.value);
      }
    }, {
      disabled: t,
      placeholder: b,
      readOnly: u,
      type: y ? "tel" : "text"
    }, o, {
      onFocus: createDelegatedEventHandler(function () {
        h(!0);
      }, null == o ? void 0 : o.onFocus),
      onBlur: createDelegatedEventHandler(function () {
        h(!1);
      }, null == o ? void 0 : o.onBlur)
    })
  }, p);
}

var _excluded$b = ["components", "disableOpenPicker", "getOpenDialogAriaText", "InputAdornmentProps", "InputProps", "inputRef", "openPicker", "OpenPickerButtonProps", "renderInput"],
    KeyboardDateInput = React.forwardRef(function (e, t) {
  var _e$components5 = e.components,
      r = _e$components5 === void 0 ? {} : _e$components5,
      n = e.disableOpenPicker,
      _e$getOpenDialogAriaT = e.getOpenDialogAriaText,
      a = _e$getOpenDialogAriaT === void 0 ? getTextFieldAriaText : _e$getOpenDialogAriaT,
      o = e.InputAdornmentProps,
      i = e.InputProps,
      s = e.inputRef,
      l = e.openPicker,
      c = e.OpenPickerButtonProps,
      u = e.renderInput,
      d = _objectWithoutPropertiesLoose$1(e, _excluded$b),
      p = useUtils(),
      g = useMaskedInput(d),
      m = (null == o ? void 0 : o.position) || "end",
      f = r.OpenPickerIcon || CalendarIcon;

  return u(_extends$a({
    ref: t,
    inputRef: s
  }, g, {
    InputProps: _extends$a({}, i, _defineProperty2({}, "".concat(m, "Adornment"), n ? void 0 : jsx$1(InputAdornment$1, _extends$a({
      position: m
    }, o, {
      children: jsx$1(IconButton$1, _extends$a({
        edge: m,
        disabled: d.disabled || d.readOnly,
        "aria-label": a(d.rawValue, p)
      }, c, {
        onClick: l,
        children: jsx$1(f, {})
      }))
    }))))
  }));
});

function getOrientation() {
  return "undefined" == typeof window ? "portrait" : window.screen && window.screen.orientation && window.screen.orientation.angle ? 90 === Math.abs(window.screen.orientation.angle) ? "landscape" : "portrait" : window.orientation && 90 === Math.abs(Number(window.orientation)) ? "landscape" : "portrait";
}

function useIsLandscape(e, t) {
  var _React$useState23 = React.useState(getOrientation),
      _React$useState24 = _slicedToArray(_React$useState23, 2),
      r = _React$useState24[0],
      n = _React$useState24[1];

  if (useEnhancedEffect$1(function () {
    var e = function e() {
      n(getOrientation());
    };

    return window.addEventListener("orientationchange", e), function () {
      window.removeEventListener("orientationchange", e);
    };
  }, []), arrayIncludes(e, ["hours", "minutes", "seconds"])) return !1;
  return "landscape" === (t || r);
}

"production" !== process.env.NODE_ENV && (KeyboardDateInput.propTypes = {
  acceptRegex: PropTypes.instanceOf(RegExp),
  getOpenDialogAriaText: PropTypes.func,
  mask: PropTypes.string,
  OpenPickerButtonProps: PropTypes.object,
  renderInput: PropTypes.func.isRequired,
  rifmFormatter: PropTypes.func
});

var _excluded$a = ["autoFocus", "className", "date", "DateInputProps", "isMobileKeyboardViewOpen", "onDateChange", "onViewChange", "openTo", "orientation", "showToolbar", "toggleMobileKeyboardView", "ToolbarComponent", "toolbarFormat", "toolbarPlaceholder", "toolbarTitle", "views"],
    MobileKeyboardInputView = styled("div")({
  padding: "16px 24px"
}),
    PickerRoot = styled("div")(function (_ref85) {
  var e = _ref85.ownerState;
  return _extends$a({
    display: "flex",
    flexDirection: "column"
  }, e.isLandscape && {
    flexDirection: "row"
  });
}),
    MobileKeyboardTextFieldProps = {
  fullWidth: !0
},
    isDatePickerView = function isDatePickerView(e) {
  return "year" === e || "month" === e || "day" === e;
},
    isTimePickerView = function isTimePickerView(e) {
  return "hours" === e || "minutes" === e || "seconds" === e;
};

function Picker(e) {
  var t = e.autoFocus,
      r = e.date,
      n = e.DateInputProps,
      a = e.isMobileKeyboardViewOpen,
      o = e.onDateChange,
      i = e.onViewChange,
      s = e.openTo,
      l = e.orientation,
      c = e.showToolbar,
      u = e.toggleMobileKeyboardView,
      _e$ToolbarComponent = e.ToolbarComponent,
      d = _e$ToolbarComponent === void 0 ? function () {
    return null;
  } : _e$ToolbarComponent,
      p = e.toolbarFormat,
      g = e.toolbarPlaceholder,
      m = e.toolbarTitle,
      f = e.views,
      h = _objectWithoutPropertiesLoose$1(e, _excluded$a),
      b = useIsLandscape(f, l),
      y = React.useContext(WrapperVariantContext),
      v = void 0 === c ? "desktop" !== y : c,
      _ = React.useCallback(function (e, t) {
    o(e, y, t);
  }, [o, y]),
      T = React.useCallback(function (e) {
    a && u(), i && i(e);
  }, [a, i, u]),
      _useViews2 = useViews({
    view: void 0,
    views: f,
    openTo: s,
    onChange: _,
    onViewChange: T
  }),
      E = _useViews2.openView,
      S = _useViews2.nextView,
      x = _useViews2.previousView,
      w = _useViews2.setOpenView,
      C = _useViews2.handleChangeAndOpenNext;

  return jsxs(PickerRoot, {
    ownerState: {
      isLandscape: b
    },
    children: [v && jsx$1(d, _extends$a({}, h, {
      views: f,
      isLandscape: b,
      date: r,
      onChange: _,
      setOpenView: w,
      openView: E,
      toolbarTitle: m,
      toolbarFormat: p,
      toolbarPlaceholder: g,
      isMobileKeyboardViewOpen: a,
      toggleMobileKeyboardView: u
    })), jsx$1(PickerView, {
      children: a ? jsx$1(MobileKeyboardInputView, {
        children: jsx$1(KeyboardDateInput, _extends$a({}, n, {
          ignoreInvalidInputs: !0,
          disableOpenPicker: !0,
          TextFieldProps: MobileKeyboardTextFieldProps
        }))
      }) : jsxs(React.Fragment, {
        children: [isDatePickerView(E) && jsx$1(CalendarPicker, _extends$a({
          autoFocus: t,
          date: r,
          onViewChange: w,
          onChange: C,
          view: E,
          views: f.filter(isDatePickerView)
        }, h)), isTimePickerView(E) && jsx$1(ClockPicker, _extends$a({}, h, {
          autoFocus: t,
          date: r,
          view: E,
          onChange: C,
          openNextView: function openNextView() {
            return w(S);
          },
          openPreviousView: function openPreviousView() {
            return w(x);
          },
          nextViewAvailable: !S,
          previousViewAvailable: !x || isDatePickerView(x),
          showViewSwitcher: "desktop" === y
        }))]
      })
    })]
  });
}

function isSameDateOrTimeError(e, t) {
  return e === t;
}

function useValidation(e, t) {
  var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : isSameDateOrTimeError;
  var n = e.value,
      a = e.onError,
      o = useUtils(),
      i = React.useRef(null),
      s = t(o, n, e);
  return React.useEffect(function () {
    a && !r(s, i.current) && a(s, n), i.current = s;
  }, [r, a, i, s, n]), s;
}

function useDateValidation(e) {
  return useValidation(e, validateDate$1, isSameDateOrTimeError);
}

function useOpenState(_ref86) {
  var e = _ref86.open,
      t = _ref86.onOpen,
      r = _ref86.onClose;

  var n = React.useRef("boolean" == typeof e).current,
      _React$useState25 = React.useState(!1),
      _React$useState26 = _slicedToArray(_React$useState25, 2),
      a = _React$useState26[0],
      o = _React$useState26[1];

  React.useEffect(function () {
    if (n) {
      if ("boolean" != typeof e) throw new Error("You must not mix controlling and uncontrolled mode for `open` prop");
      o(e);
    }
  }, [n, e]);
  return {
    isOpen: a,
    setIsOpen: React.useCallback(function (e) {
      n || o(e), e && t && t(), !e && r && r();
    }, [n, t, r])
  };
}

function usePickerState(e, t) {
  var r = e.disableCloseOnSelect,
      n = e.onAccept,
      a = e.onChange,
      o = e.value,
      i = useUtils(),
      _useOpenState = useOpenState(e),
      s = _useOpenState.isOpen,
      l = _useOpenState.setIsOpen;

  function c(e) {
    return {
      committed: e,
      draft: e
    };
  }

  var u = t.parseInput(i, o),
      _React$useReducer3 = React.useReducer(function (e, t) {
    switch (t.type) {
      case "reset":
        return c(t.payload);

      case "update":
        return _extends$a({}, e, {
          draft: t.payload
        });

      default:
        return e;
    }
  }, u, c),
      _React$useReducer4 = _slicedToArray(_React$useReducer3, 2),
      d = _React$useReducer4[0],
      p = _React$useReducer4[1];

  t.areValuesEqual(i, d.committed, u) || p({
    type: "reset",
    payload: u
  });

  var _React$useState27 = React.useState(d.committed),
      _React$useState28 = _slicedToArray(_React$useState27, 2),
      g = _React$useState28[0],
      m = _React$useState28[1],
      _React$useState29 = React.useState(!1),
      _React$useState30 = _slicedToArray(_React$useState29, 2),
      f = _React$useState30[0],
      h = _React$useState30[1],
      b = React.useCallback(function (e, t) {
    a(e), t && (l(!1), m(e), n && n(e));
  }, [n, a, l]),
      y = React.useMemo(function () {
    return {
      open: s,
      onClear: function onClear() {
        return b(t.emptyValue, !0);
      },
      onAccept: function onAccept() {
        return b(d.draft, !0);
      },
      onDismiss: function onDismiss() {
        return b(g, !0);
      },
      onSetToday: function onSetToday() {
        var e = i.date();
        p({
          type: "update",
          payload: e
        }), b(e, !r);
      }
    };
  }, [b, r, s, i, d.draft, t.emptyValue, g]),
      v = {
    pickerProps: React.useMemo(function () {
      return {
        date: d.draft,
        isMobileKeyboardViewOpen: f,
        toggleMobileKeyboardView: function toggleMobileKeyboardView() {
          return h(!f);
        },
        onDateChange: function onDateChange(e, t) {
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "partial";

          if (p({
            type: "update",
            payload: e
          }), "partial" === n && b(e, !1), "finish" === n) {
            b(e, !(null != r ? r : "mobile" === t));
          }
        }
      };
    }, [b, r, f, d.draft]),
    inputProps: React.useMemo(function () {
      return {
        onChange: a,
        open: s,
        rawValue: o,
        openPicker: function openPicker() {
          return l(!0);
        }
      };
    }, [a, s, o, l]),
    wrapperProps: y
  };

  return React.useDebugValue(v, function () {
    return {
      MuiPickerState: {
        pickerDraft: d,
        other: v
      }
    };
  }), v;
}

var _excluded$9 = ["ToolbarComponent", "value", "onChange", "displayStaticWrapperAs"],
    valueManager = {
  emptyValue: null,
  parseInput: parsePickerInputValue,
  areValuesEqual: function areValuesEqual(e, t, r) {
    return e.isEqual(t, r);
  }
},
    StaticDatePicker$1 = React.forwardRef(function (e, t) {
  var r = useDatePickerDefaultizedProps(e, "MuiStaticDatePicker"),
      n = null !== useDateValidation(r),
      _usePickerState = usePickerState(r, valueManager),
      a = _usePickerState.pickerProps,
      o = _usePickerState.inputProps,
      _r$ToolbarComponent = r.ToolbarComponent,
      i = _r$ToolbarComponent === void 0 ? DatePickerToolbar : _r$ToolbarComponent,
      _r$displayStaticWrapp = r.displayStaticWrapperAs,
      s = _r$displayStaticWrapp === void 0 ? "mobile" : _r$displayStaticWrapp,
      l = _objectWithoutPropertiesLoose$1(r, _excluded$9),
      c = _extends$a({}, o, l, {
    ref: t,
    validationError: n
  });

  return jsx$1(PickerStaticWrapper, {
    displayStaticWrapperAs: s,
    children: jsx$1(Picker, _extends$a({}, a, {
      toolbarTitle: r.label || r.toolbarTitle,
      ToolbarComponent: i,
      DateInputProps: c
    }, l))
  });
});
"production" !== process.env.NODE_ENV && (StaticDatePicker$1.propTypes = {
  acceptRegex: PropTypes.instanceOf(RegExp),
  allowSameDateSelection: PropTypes.bool,
  autoFocus: PropTypes.bool,
  className: PropTypes.string,
  components: PropTypes.shape({
    LeftArrowButton: PropTypes.elementType,
    LeftArrowIcon: PropTypes.elementType,
    OpenPickerIcon: PropTypes.elementType,
    RightArrowButton: PropTypes.elementType,
    RightArrowIcon: PropTypes.elementType,
    SwitchViewButton: PropTypes.elementType,
    SwitchViewIcon: PropTypes.elementType
  }),
  componentsProps: PropTypes.shape({
    leftArrowButton: PropTypes.object,
    rightArrowButton: PropTypes.object,
    switchViewButton: PropTypes.object
  }),
  defaultCalendarMonth: PropTypes.any,
  disableCloseOnSelect: PropTypes.bool,
  disabled: PropTypes.bool,
  disableFuture: PropTypes.bool,
  disableHighlightToday: PropTypes.bool,
  disableMaskedInput: PropTypes.bool,
  disableOpenPicker: PropTypes.bool,
  disablePast: PropTypes.bool,
  displayStaticWrapperAs: PropTypes.oneOf(["desktop", "mobile"]),
  getOpenDialogAriaText: PropTypes.func,
  getViewSwitchingButtonText: PropTypes.func,
  ignoreInvalidInputs: PropTypes.bool,
  InputAdornmentProps: PropTypes.object,
  inputFormat: PropTypes.string,
  InputProps: PropTypes.object,
  inputRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.object
  })]),
  key: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  label: PropTypes.node,
  leftArrowButtonText: PropTypes.string,
  loading: PropTypes.bool,
  mask: PropTypes.string,
  maxDate: PropTypes.any,
  minDate: PropTypes.any,
  onAccept: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  onClose: PropTypes.func,
  onError: PropTypes.func,
  onMonthChange: PropTypes.func,
  onOpen: PropTypes.func,
  onViewChange: PropTypes.func,
  onYearChange: PropTypes.func,
  open: PropTypes.bool,
  OpenPickerButtonProps: PropTypes.object,
  openTo: PropTypes.oneOf(["day", "month", "year"]),
  orientation: PropTypes.oneOf(["landscape", "portrait"]),
  readOnly: PropTypes.bool,
  reduceAnimations: PropTypes.bool,
  renderDay: PropTypes.func,
  renderInput: PropTypes.func.isRequired,
  renderLoading: PropTypes.func,
  rifmFormatter: PropTypes.func,
  rightArrowButtonText: PropTypes.string,
  shouldDisableDate: PropTypes.func,
  shouldDisableYear: PropTypes.func,
  showDaysOutsideCurrentMonth: PropTypes.bool,
  showToolbar: PropTypes.bool,
  ToolbarComponent: PropTypes.elementType,
  toolbarFormat: PropTypes.string,
  toolbarPlaceholder: PropTypes.node,
  toolbarTitle: PropTypes.node,
  value: PropTypes.oneOfType([PropTypes.any, PropTypes.instanceOf(Date), PropTypes.number, PropTypes.string]),
  views: PropTypes.arrayOf(PropTypes.oneOf(["day", "month", "year"]).isRequired)
});
var MuiStaticDatePicker = StaticDatePicker$1;

function toInteger(e) {
  if (null === e || !0 === e || !1 === e) return NaN;
  var t = Number(e);
  return isNaN(t) ? t : t < 0 ? Math.ceil(t) : Math.floor(t);
}

function requiredArgs(e, t) {
  if (t.length < e) throw new TypeError(e + " argument" + (e > 1 ? "s" : "") + " required, but only " + t.length + " present");
}

function toDate(e) {
  requiredArgs(1, arguments);
  var t = Object.prototype.toString.call(e);
  return e instanceof Date || "object" == typeof e && "[object Date]" === t ? new Date(e.getTime()) : "number" == typeof e || "[object Number]" === t ? new Date(e) : ("string" != typeof e && "[object String]" !== t || "undefined" == typeof console || (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"), console.warn(new Error().stack)), new Date(NaN));
}

function addDays(e, t) {
  requiredArgs(2, arguments);
  var r = toDate(e),
      n = toInteger(t);
  return isNaN(n) ? new Date(NaN) : n ? (r.setDate(r.getDate() + n), r) : r;
}

function addMilliseconds(e, t) {
  requiredArgs(2, arguments);
  var r = toDate(e).getTime(),
      n = toInteger(t);
  return new Date(r + n);
}

function addSeconds(e, t) {
  requiredArgs(2, arguments);
  var r = toInteger(t);
  return addMilliseconds(e, 1e3 * r);
}

var MILLISECONDS_IN_MINUTE$4 = 6e4;

function addMinutes(e, t) {
  requiredArgs(2, arguments);
  var r = toInteger(t);
  return addMilliseconds(e, r * MILLISECONDS_IN_MINUTE$4);
}

var MILLISECONDS_IN_HOUR$3 = 36e5;

function addHours(e, t) {
  requiredArgs(2, arguments);
  var r = toInteger(t);
  return addMilliseconds(e, r * MILLISECONDS_IN_HOUR$3);
}

function addWeeks(e, t) {
  requiredArgs(2, arguments);
  var r = toInteger(t),
      n = 7 * r;
  return addDays(e, n);
}

function addMonths(e, t) {
  requiredArgs(2, arguments);
  var r = toDate(e),
      n = toInteger(t);
  if (isNaN(n)) return new Date(NaN);
  if (!n) return r;
  var a = r.getDate(),
      o = new Date(r.getTime());
  o.setMonth(r.getMonth() + n + 1, 0);
  var i = o.getDate();
  return a >= i ? o : (r.setFullYear(o.getFullYear(), o.getMonth(), a), r);
}

function addYears(e, t) {
  requiredArgs(2, arguments);
  var r = toInteger(t);
  return addMonths(e, 12 * r);
}

function differenceInCalendarYears(e, t) {
  requiredArgs(2, arguments);
  var r = toDate(e),
      n = toDate(t);
  return r.getFullYear() - n.getFullYear();
}

function compareAsc(e, t) {
  requiredArgs(2, arguments);
  var r = toDate(e),
      n = toDate(t),
      a = r.getTime() - n.getTime();
  return a < 0 ? -1 : a > 0 ? 1 : a;
}

function differenceInYears(e, t) {
  requiredArgs(2, arguments);
  var r = toDate(e),
      n = toDate(t),
      a = compareAsc(r, n),
      o = Math.abs(differenceInCalendarYears(r, n));
  r.setFullYear("1584"), n.setFullYear("1584");
  var i = compareAsc(r, n) === -a,
      s = a * (o - i);
  return 0 === s ? 0 : s;
}

function differenceInCalendarMonths(e, t) {
  requiredArgs(2, arguments);
  var r = toDate(e),
      n = toDate(t),
      a = r.getFullYear() - n.getFullYear(),
      o = r.getMonth() - n.getMonth();
  return 12 * a + o;
}

function differenceInMonths(e, t) {
  requiredArgs(2, arguments);
  var r = toDate(e),
      n = toDate(t),
      a = compareAsc(r, n),
      o = Math.abs(differenceInCalendarMonths(r, n));
  r.setMonth(r.getMonth() - a * o);
  var i = compareAsc(r, n) === -a,
      s = a * (o - i);
  return 0 === s ? 0 : s;
}

function differenceInQuarters(e, t) {
  requiredArgs(2, arguments);
  var r = differenceInMonths(e, t) / 3;
  return r > 0 ? Math.floor(r) : Math.ceil(r);
}

var MILLISECONDS_IN_MINUTE$3 = 6e4;

function getDateMillisecondsPart(e) {
  return e.getTime() % MILLISECONDS_IN_MINUTE$3;
}

function getTimezoneOffsetInMilliseconds(e) {
  var t = new Date(e.getTime()),
      r = Math.ceil(t.getTimezoneOffset());
  t.setSeconds(0, 0);
  var n = r > 0 ? (MILLISECONDS_IN_MINUTE$3 + getDateMillisecondsPart(t)) % MILLISECONDS_IN_MINUTE$3 : getDateMillisecondsPart(t);
  return r * MILLISECONDS_IN_MINUTE$3 + n;
}

function startOfDay(e) {
  requiredArgs(1, arguments);
  var t = toDate(e);
  return t.setHours(0, 0, 0, 0), t;
}

var MILLISECONDS_IN_DAY$1 = 864e5;

function differenceInCalendarDays(e, t) {
  requiredArgs(2, arguments);
  var r = startOfDay(e),
      n = startOfDay(t),
      a = r.getTime() - getTimezoneOffsetInMilliseconds(r),
      o = n.getTime() - getTimezoneOffsetInMilliseconds(n);
  return Math.round((a - o) / MILLISECONDS_IN_DAY$1);
}

function compareLocalAsc(e, t) {
  var r = e.getFullYear() - t.getFullYear() || e.getMonth() - t.getMonth() || e.getDate() - t.getDate() || e.getHours() - t.getHours() || e.getMinutes() - t.getMinutes() || e.getSeconds() - t.getSeconds() || e.getMilliseconds() - t.getMilliseconds();
  return r < 0 ? -1 : r > 0 ? 1 : r;
}

function differenceInDays(e, t) {
  requiredArgs(2, arguments);
  var r = toDate(e),
      n = toDate(t),
      a = compareLocalAsc(r, n),
      o = Math.abs(differenceInCalendarDays(r, n));
  r.setDate(r.getDate() - a * o);
  var i = compareLocalAsc(r, n) === -a,
      s = a * (o - i);
  return 0 === s ? 0 : s;
}

function differenceInWeeks(e, t) {
  requiredArgs(2, arguments);
  var r = differenceInDays(e, t) / 7;
  return r > 0 ? Math.floor(r) : Math.ceil(r);
}

function differenceInMilliseconds(e, t) {
  requiredArgs(2, arguments);
  var r = toDate(e),
      n = toDate(t);
  return r.getTime() - n.getTime();
}

var MILLISECONDS_IN_HOUR$2 = 36e5;

function differenceInHours(e, t) {
  requiredArgs(2, arguments);
  var r = differenceInMilliseconds(e, t) / MILLISECONDS_IN_HOUR$2;
  return r > 0 ? Math.floor(r) : Math.ceil(r);
}

var MILLISECONDS_IN_MINUTE$2 = 6e4;

function differenceInMinutes(e, t) {
  requiredArgs(2, arguments);
  var r = differenceInMilliseconds(e, t) / MILLISECONDS_IN_MINUTE$2;
  return r > 0 ? Math.floor(r) : Math.ceil(r);
}

function differenceInSeconds(e, t) {
  requiredArgs(2, arguments);
  var r = differenceInMilliseconds(e, t) / 1e3;
  return r > 0 ? Math.floor(r) : Math.ceil(r);
}

function eachDayOfInterval(e, t) {
  requiredArgs(1, arguments);
  var r = e || {},
      n = toDate(r.start),
      a = toDate(r.end),
      o = a.getTime();
  if (!(n.getTime() <= o)) throw new RangeError("Invalid interval");
  var i = [],
      s = n;
  s.setHours(0, 0, 0, 0);
  var l = t && "step" in t ? Number(t.step) : 1;
  if (l < 1 || isNaN(l)) throw new RangeError("`options.step` must be a number greater than 1");

  for (; s.getTime() <= o;) {
    i.push(toDate(s)), s.setDate(s.getDate() + l), s.setHours(0, 0, 0, 0);
  }

  return i;
}

function endOfDay(e) {
  requiredArgs(1, arguments);
  var t = toDate(e);
  return t.setHours(23, 59, 59, 999), t;
}

function endOfWeek(e, t) {
  requiredArgs(1, arguments);
  var r = t || {},
      n = r.locale,
      a = n && n.options && n.options.weekStartsOn,
      o = null == a ? 0 : toInteger(a),
      i = null == r.weekStartsOn ? o : toInteger(r.weekStartsOn);
  if (!(i >= 0 && i <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var s = toDate(e),
      l = s.getDay(),
      c = 6 + (l < i ? -7 : 0) - (l - i);
  return s.setDate(s.getDate() + c), s.setHours(23, 59, 59, 999), s;
}

function endOfYear(e) {
  requiredArgs(1, arguments);
  var t = toDate(e),
      r = t.getFullYear();
  return t.setFullYear(r + 1, 0, 0), t.setHours(23, 59, 59, 999), t;
}

function isValid(e) {
  requiredArgs(1, arguments);
  var t = toDate(e);
  return !isNaN(t);
}

var formatDistanceLocale = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
};

function formatDistance(e, t, r) {
  var n;
  return r = r || {}, n = "string" == typeof formatDistanceLocale[e] ? formatDistanceLocale[e] : 1 === t ? formatDistanceLocale[e].one : formatDistanceLocale[e].other.replace("{{count}}", t), r.addSuffix ? r.comparison > 0 ? "in " + n : n + " ago" : n;
}

function buildFormatLongFn(e) {
  return function (t) {
    var r = t || {},
        n = r.width ? String(r.width) : e.defaultWidth;
    return e.formats[n] || e.formats[e.defaultWidth];
  };
}

var dateFormats = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
},
    timeFormats = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
},
    dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
},
    formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: "full"
  })
},
    formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
};

function formatRelative(e, t, r, n) {
  return formatRelativeLocale[e];
}

function buildLocalizeFn(e) {
  return function (t, r) {
    var n,
        a = r || {};

    if ("formatting" === (a.context ? String(a.context) : "standalone") && e.formattingValues) {
      var o = e.defaultFormattingWidth || e.defaultWidth,
          i = a.width ? String(a.width) : o;
      n = e.formattingValues[i] || e.formattingValues[o];
    } else {
      var s = e.defaultWidth,
          l = a.width ? String(a.width) : e.defaultWidth;
      n = e.values[l] || e.values[s];
    }

    return n[e.argumentCallback ? e.argumentCallback(t) : t];
  };
}

var eraValues = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
},
    quarterValues = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
},
    monthValues = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
},
    dayValues = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
},
    dayPeriodValues = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
},
    formattingDayPeriodValues = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
};

function ordinalNumber(e, t) {
  var r = Number(e),
      n = r % 100;
  if (n > 20 || n < 10) switch (n % 10) {
    case 1:
      return r + "st";

    case 2:
      return r + "nd";

    case 3:
      return r + "rd";
  }
  return r + "th";
}

var localize = {
  ordinalNumber: ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: "wide",
    argumentCallback: function argumentCallback(e) {
      return Number(e) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: "wide"
  })
};

function buildMatchPatternFn(e) {
  return function (t, r) {
    var n = String(t),
        a = r || {},
        o = n.match(e.matchPattern);
    if (!o) return null;
    var i = o[0],
        s = n.match(e.parsePattern);
    if (!s) return null;
    var l = e.valueCallback ? e.valueCallback(s[0]) : s[0];
    return {
      value: l = a.valueCallback ? a.valueCallback(l) : l,
      rest: n.slice(i.length)
    };
  };
}

function buildMatchFn(e) {
  return function (t, r) {
    var n = String(t),
        a = r || {},
        o = a.width,
        i = o && e.matchPatterns[o] || e.matchPatterns[e.defaultMatchWidth],
        s = n.match(i);
    if (!s) return null;
    var l,
        c = s[0],
        u = o && e.parsePatterns[o] || e.parsePatterns[e.defaultParseWidth];
    return l = "[object Array]" === Object.prototype.toString.call(u) ? findIndex(u, function (e) {
      return e.test(c);
    }) : findKey(u, function (e) {
      return e.test(c);
    }), l = e.valueCallback ? e.valueCallback(l) : l, {
      value: l = a.valueCallback ? a.valueCallback(l) : l,
      rest: n.slice(c.length)
    };
  };
}

function findKey(e, t) {
  for (var r in e) {
    if (e.hasOwnProperty(r) && t(e[r])) return r;
  }
}

function findIndex(e, t) {
  for (var r = 0; r < e.length; r++) {
    if (t(e[r])) return r;
  }
}

var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i,
    parseOrdinalNumberPattern = /\d+/i,
    matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
},
    parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
},
    matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
},
    parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
},
    matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
},
    parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
},
    matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
},
    parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
},
    matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
},
    parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
},
    match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function valueCallback(e) {
      return parseInt(e, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: "any",
    valueCallback: function valueCallback(e) {
      return e + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: "any"
  })
},
    locale = {
  code: "en-US",
  formatDistance: formatDistance,
  formatLong: formatLong,
  formatRelative: formatRelative,
  localize: localize,
  match: match,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
},
    defaultLocale = locale;

function subMilliseconds(e, t) {
  requiredArgs(2, arguments);
  var r = toInteger(t);
  return addMilliseconds(e, -r);
}

function addLeadingZeros(e, t) {
  for (var r = e < 0 ? "-" : "", n = Math.abs(e).toString(); n.length < t;) {
    n = "0" + n;
  }

  return r + n;
}

var formatters$2 = {
  y: function y(e, t) {
    var r = e.getUTCFullYear(),
        n = r > 0 ? r : 1 - r;
    return addLeadingZeros("yy" === t ? n % 100 : n, t.length);
  },
  M: function M(e, t) {
    var r = e.getUTCMonth();
    return "M" === t ? String(r + 1) : addLeadingZeros(r + 1, 2);
  },
  d: function d(e, t) {
    return addLeadingZeros(e.getUTCDate(), t.length);
  },
  a: function a(e, t) {
    var r = e.getUTCHours() / 12 >= 1 ? "pm" : "am";

    switch (t) {
      case "a":
      case "aa":
      case "aaa":
        return r.toUpperCase();

      case "aaaaa":
        return r[0];

      default:
        return "am" === r ? "a.m." : "p.m.";
    }
  },
  h: function h(e, t) {
    return addLeadingZeros(e.getUTCHours() % 12 || 12, t.length);
  },
  H: function H(e, t) {
    return addLeadingZeros(e.getUTCHours(), t.length);
  },
  m: function m(e, t) {
    return addLeadingZeros(e.getUTCMinutes(), t.length);
  },
  s: function s(e, t) {
    return addLeadingZeros(e.getUTCSeconds(), t.length);
  },
  S: function S(e, t) {
    var r = t.length,
        n = e.getUTCMilliseconds();
    return addLeadingZeros(Math.floor(n * Math.pow(10, r - 3)), t.length);
  }
},
    MILLISECONDS_IN_DAY = 864e5;

function getUTCDayOfYear(e) {
  requiredArgs(1, arguments);
  var t = toDate(e),
      r = t.getTime();
  t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
  var n = t.getTime(),
      a = r - n;
  return Math.floor(a / MILLISECONDS_IN_DAY) + 1;
}

function startOfUTCISOWeek(e) {
  requiredArgs(1, arguments);
  var t = 1,
      r = toDate(e),
      n = r.getUTCDay(),
      a = (n < t ? 7 : 0) + n - t;
  return r.setUTCDate(r.getUTCDate() - a), r.setUTCHours(0, 0, 0, 0), r;
}

function getUTCISOWeekYear(e) {
  requiredArgs(1, arguments);
  var t = toDate(e),
      r = t.getUTCFullYear(),
      n = new Date(0);
  n.setUTCFullYear(r + 1, 0, 4), n.setUTCHours(0, 0, 0, 0);
  var a = startOfUTCISOWeek(n),
      o = new Date(0);
  o.setUTCFullYear(r, 0, 4), o.setUTCHours(0, 0, 0, 0);
  var i = startOfUTCISOWeek(o);
  return t.getTime() >= a.getTime() ? r + 1 : t.getTime() >= i.getTime() ? r : r - 1;
}

function startOfUTCISOWeekYear(e) {
  requiredArgs(1, arguments);
  var t = getUTCISOWeekYear(e),
      r = new Date(0);
  r.setUTCFullYear(t, 0, 4), r.setUTCHours(0, 0, 0, 0);
  var n = startOfUTCISOWeek(r);
  return n;
}

var MILLISECONDS_IN_WEEK$1 = 6048e5;

function getUTCISOWeek(e) {
  requiredArgs(1, arguments);
  var t = toDate(e),
      r = startOfUTCISOWeek(t).getTime() - startOfUTCISOWeekYear(t).getTime();
  return Math.round(r / MILLISECONDS_IN_WEEK$1) + 1;
}

function startOfUTCWeek(e, t) {
  requiredArgs(1, arguments);
  var r = t || {},
      n = r.locale,
      a = n && n.options && n.options.weekStartsOn,
      o = null == a ? 0 : toInteger(a),
      i = null == r.weekStartsOn ? o : toInteger(r.weekStartsOn);
  if (!(i >= 0 && i <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var s = toDate(e),
      l = s.getUTCDay(),
      c = (l < i ? 7 : 0) + l - i;
  return s.setUTCDate(s.getUTCDate() - c), s.setUTCHours(0, 0, 0, 0), s;
}

function getUTCWeekYear(e, t) {
  requiredArgs(1, arguments);
  var r = toDate(e, t),
      n = r.getUTCFullYear(),
      a = t || {},
      o = a.locale,
      i = o && o.options && o.options.firstWeekContainsDate,
      s = null == i ? 1 : toInteger(i),
      l = null == a.firstWeekContainsDate ? s : toInteger(a.firstWeekContainsDate);
  if (!(l >= 1 && l <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var c = new Date(0);
  c.setUTCFullYear(n + 1, 0, l), c.setUTCHours(0, 0, 0, 0);
  var u = startOfUTCWeek(c, t),
      d = new Date(0);
  d.setUTCFullYear(n, 0, l), d.setUTCHours(0, 0, 0, 0);
  var p = startOfUTCWeek(d, t);
  return r.getTime() >= u.getTime() ? n + 1 : r.getTime() >= p.getTime() ? n : n - 1;
}

function startOfUTCWeekYear(e, t) {
  requiredArgs(1, arguments);
  var r = t || {},
      n = r.locale,
      a = n && n.options && n.options.firstWeekContainsDate,
      o = null == a ? 1 : toInteger(a),
      i = null == r.firstWeekContainsDate ? o : toInteger(r.firstWeekContainsDate),
      s = getUTCWeekYear(e, t),
      l = new Date(0);
  l.setUTCFullYear(s, 0, i), l.setUTCHours(0, 0, 0, 0);
  var c = startOfUTCWeek(l, t);
  return c;
}

var MILLISECONDS_IN_WEEK = 6048e5;

function getUTCWeek(e, t) {
  requiredArgs(1, arguments);
  var r = toDate(e),
      n = startOfUTCWeek(r, t).getTime() - startOfUTCWeekYear(r, t).getTime();
  return Math.round(n / MILLISECONDS_IN_WEEK) + 1;
}

var dayPeriodEnum = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
},
    formatters = {
  G: function G(e, t, r) {
    var n = e.getUTCFullYear() > 0 ? 1 : 0;

    switch (t) {
      case "G":
      case "GG":
      case "GGG":
        return r.era(n, {
          width: "abbreviated"
        });

      case "GGGGG":
        return r.era(n, {
          width: "narrow"
        });

      default:
        return r.era(n, {
          width: "wide"
        });
    }
  },
  y: function y(e, t, r) {
    if ("yo" === t) {
      var n = e.getUTCFullYear(),
          a = n > 0 ? n : 1 - n;
      return r.ordinalNumber(a, {
        unit: "year"
      });
    }

    return formatters$2.y(e, t);
  },
  Y: function Y(e, t, r, n) {
    var a = getUTCWeekYear(e, n),
        o = a > 0 ? a : 1 - a;
    return "YY" === t ? addLeadingZeros(o % 100, 2) : "Yo" === t ? r.ordinalNumber(o, {
      unit: "year"
    }) : addLeadingZeros(o, t.length);
  },
  R: function R(e, t) {
    return addLeadingZeros(getUTCISOWeekYear(e), t.length);
  },
  u: function u(e, t) {
    return addLeadingZeros(e.getUTCFullYear(), t.length);
  },
  Q: function Q(e, t, r) {
    var n = Math.ceil((e.getUTCMonth() + 1) / 3);

    switch (t) {
      case "Q":
        return String(n);

      case "QQ":
        return addLeadingZeros(n, 2);

      case "Qo":
        return r.ordinalNumber(n, {
          unit: "quarter"
        });

      case "QQQ":
        return r.quarter(n, {
          width: "abbreviated",
          context: "formatting"
        });

      case "QQQQQ":
        return r.quarter(n, {
          width: "narrow",
          context: "formatting"
        });

      default:
        return r.quarter(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  q: function q(e, t, r) {
    var n = Math.ceil((e.getUTCMonth() + 1) / 3);

    switch (t) {
      case "q":
        return String(n);

      case "qq":
        return addLeadingZeros(n, 2);

      case "qo":
        return r.ordinalNumber(n, {
          unit: "quarter"
        });

      case "qqq":
        return r.quarter(n, {
          width: "abbreviated",
          context: "standalone"
        });

      case "qqqqq":
        return r.quarter(n, {
          width: "narrow",
          context: "standalone"
        });

      default:
        return r.quarter(n, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  M: function M(e, t, r) {
    var n = e.getUTCMonth();

    switch (t) {
      case "M":
      case "MM":
        return formatters$2.M(e, t);

      case "Mo":
        return r.ordinalNumber(n + 1, {
          unit: "month"
        });

      case "MMM":
        return r.month(n, {
          width: "abbreviated",
          context: "formatting"
        });

      case "MMMMM":
        return r.month(n, {
          width: "narrow",
          context: "formatting"
        });

      default:
        return r.month(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  L: function L(e, t, r) {
    var n = e.getUTCMonth();

    switch (t) {
      case "L":
        return String(n + 1);

      case "LL":
        return addLeadingZeros(n + 1, 2);

      case "Lo":
        return r.ordinalNumber(n + 1, {
          unit: "month"
        });

      case "LLL":
        return r.month(n, {
          width: "abbreviated",
          context: "standalone"
        });

      case "LLLLL":
        return r.month(n, {
          width: "narrow",
          context: "standalone"
        });

      default:
        return r.month(n, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  w: function w(e, t, r, n) {
    var a = getUTCWeek(e, n);
    return "wo" === t ? r.ordinalNumber(a, {
      unit: "week"
    }) : addLeadingZeros(a, t.length);
  },
  I: function I(e, t, r) {
    var n = getUTCISOWeek(e);
    return "Io" === t ? r.ordinalNumber(n, {
      unit: "week"
    }) : addLeadingZeros(n, t.length);
  },
  d: function d(e, t, r) {
    return "do" === t ? r.ordinalNumber(e.getUTCDate(), {
      unit: "date"
    }) : formatters$2.d(e, t);
  },
  D: function D(e, t, r) {
    var n = getUTCDayOfYear(e);
    return "Do" === t ? r.ordinalNumber(n, {
      unit: "dayOfYear"
    }) : addLeadingZeros(n, t.length);
  },
  E: function E(e, t, r) {
    var n = e.getUTCDay();

    switch (t) {
      case "E":
      case "EE":
      case "EEE":
        return r.day(n, {
          width: "abbreviated",
          context: "formatting"
        });

      case "EEEEE":
        return r.day(n, {
          width: "narrow",
          context: "formatting"
        });

      case "EEEEEE":
        return r.day(n, {
          width: "short",
          context: "formatting"
        });

      default:
        return r.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  e: function e(_e54, t, r, n) {
    var a = _e54.getUTCDay(),
        o = (a - n.weekStartsOn + 8) % 7 || 7;

    switch (t) {
      case "e":
        return String(o);

      case "ee":
        return addLeadingZeros(o, 2);

      case "eo":
        return r.ordinalNumber(o, {
          unit: "day"
        });

      case "eee":
        return r.day(a, {
          width: "abbreviated",
          context: "formatting"
        });

      case "eeeee":
        return r.day(a, {
          width: "narrow",
          context: "formatting"
        });

      case "eeeeee":
        return r.day(a, {
          width: "short",
          context: "formatting"
        });

      default:
        return r.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  c: function c(e, t, r, n) {
    var a = e.getUTCDay(),
        o = (a - n.weekStartsOn + 8) % 7 || 7;

    switch (t) {
      case "c":
        return String(o);

      case "cc":
        return addLeadingZeros(o, t.length);

      case "co":
        return r.ordinalNumber(o, {
          unit: "day"
        });

      case "ccc":
        return r.day(a, {
          width: "abbreviated",
          context: "standalone"
        });

      case "ccccc":
        return r.day(a, {
          width: "narrow",
          context: "standalone"
        });

      case "cccccc":
        return r.day(a, {
          width: "short",
          context: "standalone"
        });

      default:
        return r.day(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  i: function i(e, t, r) {
    var n = e.getUTCDay(),
        a = 0 === n ? 7 : n;

    switch (t) {
      case "i":
        return String(a);

      case "ii":
        return addLeadingZeros(a, t.length);

      case "io":
        return r.ordinalNumber(a, {
          unit: "day"
        });

      case "iii":
        return r.day(n, {
          width: "abbreviated",
          context: "formatting"
        });

      case "iiiii":
        return r.day(n, {
          width: "narrow",
          context: "formatting"
        });

      case "iiiiii":
        return r.day(n, {
          width: "short",
          context: "formatting"
        });

      default:
        return r.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  a: function a(e, t, r) {
    var n = e.getUTCHours() / 12 >= 1 ? "pm" : "am";

    switch (t) {
      case "a":
      case "aa":
      case "aaa":
        return r.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        });

      case "aaaaa":
        return r.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });

      default:
        return r.dayPeriod(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  b: function b(e, t, r) {
    var n,
        a = e.getUTCHours();

    switch (n = 12 === a ? dayPeriodEnum.noon : 0 === a ? dayPeriodEnum.midnight : a / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
      case "bbb":
        return r.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        });

      case "bbbbb":
        return r.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });

      default:
        return r.dayPeriod(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  B: function B(e, t, r) {
    var n,
        a = e.getUTCHours();

    switch (n = a >= 17 ? dayPeriodEnum.evening : a >= 12 ? dayPeriodEnum.afternoon : a >= 4 ? dayPeriodEnum.morning : dayPeriodEnum.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return r.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        });

      case "BBBBB":
        return r.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });

      default:
        return r.dayPeriod(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  h: function h(e, t, r) {
    if ("ho" === t) {
      var n = e.getUTCHours() % 12;
      return 0 === n && (n = 12), r.ordinalNumber(n, {
        unit: "hour"
      });
    }

    return formatters$2.h(e, t);
  },
  H: function H(e, t, r) {
    return "Ho" === t ? r.ordinalNumber(e.getUTCHours(), {
      unit: "hour"
    }) : formatters$2.H(e, t);
  },
  K: function K(e, t, r) {
    var n = e.getUTCHours() % 12;
    return "Ko" === t ? r.ordinalNumber(n, {
      unit: "hour"
    }) : addLeadingZeros(n, t.length);
  },
  k: function k(e, t, r) {
    var n = e.getUTCHours();
    return 0 === n && (n = 24), "ko" === t ? r.ordinalNumber(n, {
      unit: "hour"
    }) : addLeadingZeros(n, t.length);
  },
  m: function m(e, t, r) {
    return "mo" === t ? r.ordinalNumber(e.getUTCMinutes(), {
      unit: "minute"
    }) : formatters$2.m(e, t);
  },
  s: function s(e, t, r) {
    return "so" === t ? r.ordinalNumber(e.getUTCSeconds(), {
      unit: "second"
    }) : formatters$2.s(e, t);
  },
  S: function S(e, t) {
    return formatters$2.S(e, t);
  },
  X: function X(e, t, r, n) {
    var a = (n._originalDate || e).getTimezoneOffset();
    if (0 === a) return "Z";

    switch (t) {
      case "X":
        return formatTimezoneWithOptionalMinutes(a);

      case "XXXX":
      case "XX":
        return formatTimezone(a);

      default:
        return formatTimezone(a, ":");
    }
  },
  x: function x(e, t, r, n) {
    var a = (n._originalDate || e).getTimezoneOffset();

    switch (t) {
      case "x":
        return formatTimezoneWithOptionalMinutes(a);

      case "xxxx":
      case "xx":
        return formatTimezone(a);

      default:
        return formatTimezone(a, ":");
    }
  },
  O: function O(e, t, r, n) {
    var a = (n._originalDate || e).getTimezoneOffset();

    switch (t) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + formatTimezoneShort(a, ":");

      default:
        return "GMT" + formatTimezone(a, ":");
    }
  },
  z: function z(e, t, r, n) {
    var a = (n._originalDate || e).getTimezoneOffset();

    switch (t) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + formatTimezoneShort(a, ":");

      default:
        return "GMT" + formatTimezone(a, ":");
    }
  },
  t: function t(e, _t45, r, n) {
    var a = n._originalDate || e;
    return addLeadingZeros(Math.floor(a.getTime() / 1e3), _t45.length);
  },
  T: function T(e, t, r, n) {
    return addLeadingZeros((n._originalDate || e).getTime(), t.length);
  }
};

function formatTimezoneShort(e, t) {
  var r = e > 0 ? "-" : "+",
      n = Math.abs(e),
      a = Math.floor(n / 60),
      o = n % 60;
  if (0 === o) return r + String(a);
  var i = t || "";
  return r + String(a) + i + addLeadingZeros(o, 2);
}

function formatTimezoneWithOptionalMinutes(e, t) {
  return e % 60 == 0 ? (e > 0 ? "-" : "+") + addLeadingZeros(Math.abs(e) / 60, 2) : formatTimezone(e, t);
}

function formatTimezone(e, t) {
  var r = t || "",
      n = e > 0 ? "-" : "+",
      a = Math.abs(e);
  return n + addLeadingZeros(Math.floor(a / 60), 2) + r + addLeadingZeros(a % 60, 2);
}

var formatters$1 = formatters;

function dateLongFormatter(e, t) {
  switch (e) {
    case "P":
      return t.date({
        width: "short"
      });

    case "PP":
      return t.date({
        width: "medium"
      });

    case "PPP":
      return t.date({
        width: "long"
      });

    default:
      return t.date({
        width: "full"
      });
  }
}

function timeLongFormatter(e, t) {
  switch (e) {
    case "p":
      return t.time({
        width: "short"
      });

    case "pp":
      return t.time({
        width: "medium"
      });

    case "ppp":
      return t.time({
        width: "long"
      });

    default:
      return t.time({
        width: "full"
      });
  }
}

function dateTimeLongFormatter(e, t) {
  var r,
      n = e.match(/(P+)(p+)?/),
      a = n[1],
      o = n[2];
  if (!o) return dateLongFormatter(e, t);

  switch (a) {
    case "P":
      r = t.dateTime({
        width: "short"
      });
      break;

    case "PP":
      r = t.dateTime({
        width: "medium"
      });
      break;

    case "PPP":
      r = t.dateTime({
        width: "long"
      });
      break;

    default:
      r = t.dateTime({
        width: "full"
      });
  }

  return r.replace("{{date}}", dateLongFormatter(a, t)).replace("{{time}}", timeLongFormatter(o, t));
}

var longFormatters$2 = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
},
    longFormatters$3 = longFormatters$2,
    protectedDayOfYearTokens = ["D", "DD"],
    protectedWeekYearTokens = ["YY", "YYYY"];

function isProtectedDayOfYearToken(e) {
  return -1 !== protectedDayOfYearTokens.indexOf(e);
}

function isProtectedWeekYearToken(e) {
  return -1 !== protectedWeekYearTokens.indexOf(e);
}

function throwProtectedError(e) {
  if ("YYYY" === e) throw new RangeError("Use `yyyy` instead of `YYYY` for formatting years; see: https://git.io/fxCyr");
  if ("YY" === e) throw new RangeError("Use `yy` instead of `YY` for formatting years; see: https://git.io/fxCyr");
  if ("D" === e) throw new RangeError("Use `d` instead of `D` for formatting days of the month; see: https://git.io/fxCyr");
  if ("DD" === e) throw new RangeError("Use `dd` instead of `DD` for formatting days of the month; see: https://git.io/fxCyr");
}

var formattingTokensRegExp$1 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g,
    longFormattingTokensRegExp$1 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g,
    escapedStringRegExp$1 = /^'([^]*?)'?$/,
    doubleQuoteRegExp$1 = /''/g,
    unescapedLatinCharacterRegExp$1 = /[a-zA-Z]/;

function format(e, t, r) {
  requiredArgs(2, arguments);
  var n = String(t),
      a = r || {},
      o = a.locale || defaultLocale,
      i = o.options && o.options.firstWeekContainsDate,
      s = null == i ? 1 : toInteger(i),
      l = null == a.firstWeekContainsDate ? s : toInteger(a.firstWeekContainsDate);
  if (!(l >= 1 && l <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var c = o.options && o.options.weekStartsOn,
      u = null == c ? 0 : toInteger(c),
      d = null == a.weekStartsOn ? u : toInteger(a.weekStartsOn);
  if (!(d >= 0 && d <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!o.localize) throw new RangeError("locale must contain localize property");
  if (!o.formatLong) throw new RangeError("locale must contain formatLong property");
  var p = toDate(e);
  if (!isValid(p)) throw new RangeError("Invalid time value");
  var g = getTimezoneOffsetInMilliseconds(p),
      m = subMilliseconds(p, g),
      f = {
    firstWeekContainsDate: l,
    weekStartsOn: d,
    locale: o,
    _originalDate: p
  },
      h = n.match(longFormattingTokensRegExp$1).map(function (e) {
    var t = e[0];
    return "p" === t || "P" === t ? (0, longFormatters$3[t])(e, o.formatLong, f) : e;
  }).join("").match(formattingTokensRegExp$1).map(function (e) {
    if ("''" === e) return "'";
    var t = e[0];
    if ("'" === t) return cleanEscapedString$1(e);
    var r = formatters$1[t];
    if (r) return !a.useAdditionalWeekYearTokens && isProtectedWeekYearToken(e) && throwProtectedError(e), !a.useAdditionalDayOfYearTokens && isProtectedDayOfYearToken(e) && throwProtectedError(e), r(m, e, o.localize, f);
    if (t.match(unescapedLatinCharacterRegExp$1)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + t + "`");
    return e;
  }).join("");
  return h;
}

function cleanEscapedString$1(e) {
  return e.match(escapedStringRegExp$1)[1].replace(doubleQuoteRegExp$1, "'");
}

function getHours(e) {
  requiredArgs(1, arguments);
  var t = toDate(e),
      r = t.getHours();
  return r;
}

function getSeconds(e) {
  requiredArgs(1, arguments);
  var t = toDate(e),
      r = t.getSeconds();
  return r;
}

function getYear(e) {
  requiredArgs(1, arguments);
  var t = toDate(e),
      r = t.getFullYear();
  return r;
}

function isAfter(e, t) {
  requiredArgs(2, arguments);
  var r = toDate(e),
      n = toDate(t);
  return r.getTime() > n.getTime();
}

function isBefore(e, t) {
  requiredArgs(2, arguments);
  var r = toDate(e),
      n = toDate(t);
  return r.getTime() < n.getTime();
}

function isEqual(e, t) {
  requiredArgs(2, arguments);
  var r = toDate(e),
      n = toDate(t);
  return r.getTime() === n.getTime();
}

function isSameDay(e, t) {
  requiredArgs(2, arguments);
  var r = startOfDay(e),
      n = startOfDay(t);
  return r.getTime() === n.getTime();
}

function isSameYear(e, t) {
  requiredArgs(2, arguments);
  var r = toDate(e),
      n = toDate(t);
  return r.getFullYear() === n.getFullYear();
}

function isSameMonth(e, t) {
  requiredArgs(2, arguments);
  var r = toDate(e),
      n = toDate(t);
  return r.getFullYear() === n.getFullYear() && r.getMonth() === n.getMonth();
}

function startOfHour(e) {
  requiredArgs(1, arguments);
  var t = toDate(e);
  return t.setMinutes(0, 0, 0), t;
}

function isSameHour(e, t) {
  requiredArgs(2, arguments);
  var r = startOfHour(e),
      n = startOfHour(t);
  return r.getTime() === n.getTime();
}

function assign(e, t) {
  if (null == e) throw new TypeError("assign requires that input parameter not be null or undefined");

  for (var r in t = t || {}) {
    t.hasOwnProperty(r) && (e[r] = t[r]);
  }

  return e;
}

function setUTCDay(e, t, r) {
  requiredArgs(2, arguments);
  var n = r || {},
      a = n.locale,
      o = a && a.options && a.options.weekStartsOn,
      i = null == o ? 0 : toInteger(o),
      s = null == n.weekStartsOn ? i : toInteger(n.weekStartsOn);
  if (!(s >= 0 && s <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var l = toDate(e),
      c = toInteger(t),
      u = l.getUTCDay(),
      d = c % 7,
      p = (d + 7) % 7,
      g = (p < s ? 7 : 0) + c - u;
  return l.setUTCDate(l.getUTCDate() + g), l;
}

function setUTCISODay(e, t) {
  requiredArgs(2, arguments);
  var r = toInteger(t);
  r % 7 == 0 && (r -= 7);
  var n = 1,
      a = toDate(e),
      o = a.getUTCDay(),
      i = r % 7,
      s = (i + 7) % 7,
      l = (s < n ? 7 : 0) + r - o;
  return a.setUTCDate(a.getUTCDate() + l), a;
}

function setUTCISOWeek(e, t) {
  requiredArgs(2, arguments);
  var r = toDate(e),
      n = toInteger(t),
      a = getUTCISOWeek(r) - n;
  return r.setUTCDate(r.getUTCDate() - 7 * a), r;
}

function setUTCWeek(e, t, r) {
  requiredArgs(2, arguments);
  var n = toDate(e),
      a = toInteger(t),
      o = getUTCWeek(n, r) - a;
  return n.setUTCDate(n.getUTCDate() - 7 * o), n;
}

var MILLISECONDS_IN_HOUR$1 = 36e5,
    MILLISECONDS_IN_MINUTE$1 = 6e4,
    MILLISECONDS_IN_SECOND = 1e3,
    numericPatterns = {
  month: /^(1[0-2]|0?\d)/,
  date: /^(3[0-1]|[0-2]?\d)/,
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  week: /^(5[0-3]|[0-4]?\d)/,
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  hour11h: /^(1[0-1]|0?\d)/,
  hour12h: /^(1[0-2]|0?\d)/,
  minute: /^[0-5]?\d/,
  second: /^[0-5]?\d/,
  singleDigit: /^\d/,
  twoDigits: /^\d{1,2}/,
  threeDigits: /^\d{1,3}/,
  fourDigits: /^\d{1,4}/,
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  twoDigitsSigned: /^-?\d{1,2}/,
  threeDigitsSigned: /^-?\d{1,3}/,
  fourDigitsSigned: /^-?\d{1,4}/
},
    timezonePatterns = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};

function parseNumericPattern(e, t, r) {
  var n = t.match(e);
  if (!n) return null;
  var a = parseInt(n[0], 10);
  return {
    value: r ? r(a) : a,
    rest: t.slice(n[0].length)
  };
}

function parseTimezonePattern(e, t) {
  var r = t.match(e);
  if (!r) return null;
  if ("Z" === r[0]) return {
    value: 0,
    rest: t.slice(1)
  };
  var n = "+" === r[1] ? 1 : -1,
      a = r[2] ? parseInt(r[2], 10) : 0,
      o = r[3] ? parseInt(r[3], 10) : 0,
      i = r[5] ? parseInt(r[5], 10) : 0;
  return {
    value: n * (a * MILLISECONDS_IN_HOUR$1 + o * MILLISECONDS_IN_MINUTE$1 + i * MILLISECONDS_IN_SECOND),
    rest: t.slice(r[0].length)
  };
}

function parseAnyDigitsSigned(e, t) {
  return parseNumericPattern(numericPatterns.anyDigitsSigned, e, t);
}

function parseNDigits(e, t, r) {
  switch (e) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigit, t, r);

    case 2:
      return parseNumericPattern(numericPatterns.twoDigits, t, r);

    case 3:
      return parseNumericPattern(numericPatterns.threeDigits, t, r);

    case 4:
      return parseNumericPattern(numericPatterns.fourDigits, t, r);

    default:
      return parseNumericPattern(new RegExp("^\\d{1," + e + "}"), t, r);
  }
}

function parseNDigitsSigned(e, t, r) {
  switch (e) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigitSigned, t, r);

    case 2:
      return parseNumericPattern(numericPatterns.twoDigitsSigned, t, r);

    case 3:
      return parseNumericPattern(numericPatterns.threeDigitsSigned, t, r);

    case 4:
      return parseNumericPattern(numericPatterns.fourDigitsSigned, t, r);

    default:
      return parseNumericPattern(new RegExp("^-?\\d{1," + e + "}"), t, r);
  }
}

function dayPeriodEnumToHours(e) {
  switch (e) {
    case "morning":
      return 4;

    case "evening":
      return 17;

    case "pm":
    case "noon":
    case "afternoon":
      return 12;

    default:
      return 0;
  }
}

function normalizeTwoDigitYear(e, t) {
  var r,
      n = t > 0,
      a = n ? t : 1 - t;
  if (a <= 50) r = e || 100;else {
    var o = a + 50;
    r = e + 100 * Math.floor(o / 100) - (e >= o % 100 ? 100 : 0);
  }
  return n ? r : 1 - r;
}

var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
    DAYS_IN_MONTH_LEAP_YEAR = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

function isLeapYearIndex$1(e) {
  return e % 400 == 0 || e % 4 == 0 && e % 100 != 0;
}

var parsers = {
  G: {
    priority: 140,
    parse: function parse(e, t, r, n) {
      switch (t) {
        case "G":
        case "GG":
        case "GGG":
          return r.era(e, {
            width: "abbreviated"
          }) || r.era(e, {
            width: "narrow"
          });

        case "GGGGG":
          return r.era(e, {
            width: "narrow"
          });

        default:
          return r.era(e, {
            width: "wide"
          }) || r.era(e, {
            width: "abbreviated"
          }) || r.era(e, {
            width: "narrow"
          });
      }
    },
    set: function set(e, t, r, n) {
      return t.era = r, e.setUTCFullYear(r, 0, 1), e.setUTCHours(0, 0, 0, 0), e;
    },
    incompatibleTokens: ["R", "u", "t", "T"]
  },
  y: {
    priority: 130,
    parse: function parse(e, t, r, n) {
      var a = function a(e) {
        return {
          year: e,
          isTwoDigitYear: "yy" === t
        };
      };

      switch (t) {
        case "y":
          return parseNDigits(4, e, a);

        case "yo":
          return r.ordinalNumber(e, {
            unit: "year",
            valueCallback: a
          });

        default:
          return parseNDigits(t.length, e, a);
      }
    },
    validate: function validate(e, t, r) {
      return t.isTwoDigitYear || t.year > 0;
    },
    set: function set(e, t, r, n) {
      var a = e.getUTCFullYear();

      if (r.isTwoDigitYear) {
        var o = normalizeTwoDigitYear(r.year, a);
        return e.setUTCFullYear(o, 0, 1), e.setUTCHours(0, 0, 0, 0), e;
      }

      var i = "era" in t && 1 !== t.era ? 1 - r.year : r.year;
      return e.setUTCFullYear(i, 0, 1), e.setUTCHours(0, 0, 0, 0), e;
    },
    incompatibleTokens: ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]
  },
  Y: {
    priority: 130,
    parse: function parse(e, t, r, n) {
      var a = function a(e) {
        return {
          year: e,
          isTwoDigitYear: "YY" === t
        };
      };

      switch (t) {
        case "Y":
          return parseNDigits(4, e, a);

        case "Yo":
          return r.ordinalNumber(e, {
            unit: "year",
            valueCallback: a
          });

        default:
          return parseNDigits(t.length, e, a);
      }
    },
    validate: function validate(e, t, r) {
      return t.isTwoDigitYear || t.year > 0;
    },
    set: function set(e, t, r, n) {
      var a = getUTCWeekYear(e, n);

      if (r.isTwoDigitYear) {
        var o = normalizeTwoDigitYear(r.year, a);
        return e.setUTCFullYear(o, 0, n.firstWeekContainsDate), e.setUTCHours(0, 0, 0, 0), startOfUTCWeek(e, n);
      }

      var i = "era" in t && 1 !== t.era ? 1 - r.year : r.year;
      return e.setUTCFullYear(i, 0, n.firstWeekContainsDate), e.setUTCHours(0, 0, 0, 0), startOfUTCWeek(e, n);
    },
    incompatibleTokens: ["y", "R", "u", "Q", "q", "M", "L", "I", "d", "D", "i", "t", "T"]
  },
  R: {
    priority: 130,
    parse: function parse(e, t, r, n) {
      return parseNDigitsSigned("R" === t ? 4 : t.length, e);
    },
    set: function set(e, t, r, n) {
      var a = new Date(0);
      return a.setUTCFullYear(r, 0, 4), a.setUTCHours(0, 0, 0, 0), startOfUTCISOWeek(a);
    },
    incompatibleTokens: ["G", "y", "Y", "u", "Q", "q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]
  },
  u: {
    priority: 130,
    parse: function parse(e, t, r, n) {
      return parseNDigitsSigned("u" === t ? 4 : t.length, e);
    },
    set: function set(e, t, r, n) {
      return e.setUTCFullYear(r, 0, 1), e.setUTCHours(0, 0, 0, 0), e;
    },
    incompatibleTokens: ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]
  },
  Q: {
    priority: 120,
    parse: function parse(e, t, r, n) {
      switch (t) {
        case "Q":
        case "QQ":
          return parseNDigits(t.length, e);

        case "Qo":
          return r.ordinalNumber(e, {
            unit: "quarter"
          });

        case "QQQ":
          return r.quarter(e, {
            width: "abbreviated",
            context: "formatting"
          }) || r.quarter(e, {
            width: "narrow",
            context: "formatting"
          });

        case "QQQQQ":
          return r.quarter(e, {
            width: "narrow",
            context: "formatting"
          });

        default:
          return r.quarter(e, {
            width: "wide",
            context: "formatting"
          }) || r.quarter(e, {
            width: "abbreviated",
            context: "formatting"
          }) || r.quarter(e, {
            width: "narrow",
            context: "formatting"
          });
      }
    },
    validate: function validate(e, t, r) {
      return t >= 1 && t <= 4;
    },
    set: function set(e, t, r, n) {
      return e.setUTCMonth(3 * (r - 1), 1), e.setUTCHours(0, 0, 0, 0), e;
    },
    incompatibleTokens: ["Y", "R", "q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]
  },
  q: {
    priority: 120,
    parse: function parse(e, t, r, n) {
      switch (t) {
        case "q":
        case "qq":
          return parseNDigits(t.length, e);

        case "qo":
          return r.ordinalNumber(e, {
            unit: "quarter"
          });

        case "qqq":
          return r.quarter(e, {
            width: "abbreviated",
            context: "standalone"
          }) || r.quarter(e, {
            width: "narrow",
            context: "standalone"
          });

        case "qqqqq":
          return r.quarter(e, {
            width: "narrow",
            context: "standalone"
          });

        default:
          return r.quarter(e, {
            width: "wide",
            context: "standalone"
          }) || r.quarter(e, {
            width: "abbreviated",
            context: "standalone"
          }) || r.quarter(e, {
            width: "narrow",
            context: "standalone"
          });
      }
    },
    validate: function validate(e, t, r) {
      return t >= 1 && t <= 4;
    },
    set: function set(e, t, r, n) {
      return e.setUTCMonth(3 * (r - 1), 1), e.setUTCHours(0, 0, 0, 0), e;
    },
    incompatibleTokens: ["Y", "R", "Q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]
  },
  M: {
    priority: 110,
    parse: function parse(e, t, r, n) {
      var a = function a(e) {
        return e - 1;
      };

      switch (t) {
        case "M":
          return parseNumericPattern(numericPatterns.month, e, a);

        case "MM":
          return parseNDigits(2, e, a);

        case "Mo":
          return r.ordinalNumber(e, {
            unit: "month",
            valueCallback: a
          });

        case "MMM":
          return r.month(e, {
            width: "abbreviated",
            context: "formatting"
          }) || r.month(e, {
            width: "narrow",
            context: "formatting"
          });

        case "MMMMM":
          return r.month(e, {
            width: "narrow",
            context: "formatting"
          });

        default:
          return r.month(e, {
            width: "wide",
            context: "formatting"
          }) || r.month(e, {
            width: "abbreviated",
            context: "formatting"
          }) || r.month(e, {
            width: "narrow",
            context: "formatting"
          });
      }
    },
    validate: function validate(e, t, r) {
      return t >= 0 && t <= 11;
    },
    set: function set(e, t, r, n) {
      return e.setUTCMonth(r, 1), e.setUTCHours(0, 0, 0, 0), e;
    },
    incompatibleTokens: ["Y", "R", "q", "Q", "L", "w", "I", "D", "i", "e", "c", "t", "T"]
  },
  L: {
    priority: 110,
    parse: function parse(e, t, r, n) {
      var a = function a(e) {
        return e - 1;
      };

      switch (t) {
        case "L":
          return parseNumericPattern(numericPatterns.month, e, a);

        case "LL":
          return parseNDigits(2, e, a);

        case "Lo":
          return r.ordinalNumber(e, {
            unit: "month",
            valueCallback: a
          });

        case "LLL":
          return r.month(e, {
            width: "abbreviated",
            context: "standalone"
          }) || r.month(e, {
            width: "narrow",
            context: "standalone"
          });

        case "LLLLL":
          return r.month(e, {
            width: "narrow",
            context: "standalone"
          });

        default:
          return r.month(e, {
            width: "wide",
            context: "standalone"
          }) || r.month(e, {
            width: "abbreviated",
            context: "standalone"
          }) || r.month(e, {
            width: "narrow",
            context: "standalone"
          });
      }
    },
    validate: function validate(e, t, r) {
      return t >= 0 && t <= 11;
    },
    set: function set(e, t, r, n) {
      return e.setUTCMonth(r, 1), e.setUTCHours(0, 0, 0, 0), e;
    },
    incompatibleTokens: ["Y", "R", "q", "Q", "M", "w", "I", "D", "i", "e", "c", "t", "T"]
  },
  w: {
    priority: 100,
    parse: function parse(e, t, r, n) {
      switch (t) {
        case "w":
          return parseNumericPattern(numericPatterns.week, e);

        case "wo":
          return r.ordinalNumber(e, {
            unit: "week"
          });

        default:
          return parseNDigits(t.length, e);
      }
    },
    validate: function validate(e, t, r) {
      return t >= 1 && t <= 53;
    },
    set: function set(e, t, r, n) {
      return startOfUTCWeek(setUTCWeek(e, r, n), n);
    },
    incompatibleTokens: ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "i", "t", "T"]
  },
  I: {
    priority: 100,
    parse: function parse(e, t, r, n) {
      switch (t) {
        case "I":
          return parseNumericPattern(numericPatterns.week, e);

        case "Io":
          return r.ordinalNumber(e, {
            unit: "week"
          });

        default:
          return parseNDigits(t.length, e);
      }
    },
    validate: function validate(e, t, r) {
      return t >= 1 && t <= 53;
    },
    set: function set(e, t, r, n) {
      return startOfUTCISOWeek(setUTCISOWeek(e, r, n), n);
    },
    incompatibleTokens: ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]
  },
  d: {
    priority: 90,
    parse: function parse(e, t, r, n) {
      switch (t) {
        case "d":
          return parseNumericPattern(numericPatterns.date, e);

        case "do":
          return r.ordinalNumber(e, {
            unit: "date"
          });

        default:
          return parseNDigits(t.length, e);
      }
    },
    validate: function validate(e, t, r) {
      var n = isLeapYearIndex$1(e.getUTCFullYear()),
          a = e.getUTCMonth();
      return n ? t >= 1 && t <= DAYS_IN_MONTH_LEAP_YEAR[a] : t >= 1 && t <= DAYS_IN_MONTH[a];
    },
    set: function set(e, t, r, n) {
      return e.setUTCDate(r), e.setUTCHours(0, 0, 0, 0), e;
    },
    incompatibleTokens: ["Y", "R", "q", "Q", "w", "I", "D", "i", "e", "c", "t", "T"]
  },
  D: {
    priority: 90,
    parse: function parse(e, t, r, n) {
      switch (t) {
        case "D":
        case "DD":
          return parseNumericPattern(numericPatterns.dayOfYear, e);

        case "Do":
          return r.ordinalNumber(e, {
            unit: "date"
          });

        default:
          return parseNDigits(t.length, e);
      }
    },
    validate: function validate(e, t, r) {
      return isLeapYearIndex$1(e.getUTCFullYear()) ? t >= 1 && t <= 366 : t >= 1 && t <= 365;
    },
    set: function set(e, t, r, n) {
      return e.setUTCMonth(0, r), e.setUTCHours(0, 0, 0, 0), e;
    },
    incompatibleTokens: ["Y", "R", "q", "Q", "M", "L", "w", "I", "d", "E", "i", "e", "c", "t", "T"]
  },
  E: {
    priority: 90,
    parse: function parse(e, t, r, n) {
      switch (t) {
        case "E":
        case "EE":
        case "EEE":
          return r.day(e, {
            width: "abbreviated",
            context: "formatting"
          }) || r.day(e, {
            width: "short",
            context: "formatting"
          }) || r.day(e, {
            width: "narrow",
            context: "formatting"
          });

        case "EEEEE":
          return r.day(e, {
            width: "narrow",
            context: "formatting"
          });

        case "EEEEEE":
          return r.day(e, {
            width: "short",
            context: "formatting"
          }) || r.day(e, {
            width: "narrow",
            context: "formatting"
          });

        default:
          return r.day(e, {
            width: "wide",
            context: "formatting"
          }) || r.day(e, {
            width: "abbreviated",
            context: "formatting"
          }) || r.day(e, {
            width: "short",
            context: "formatting"
          }) || r.day(e, {
            width: "narrow",
            context: "formatting"
          });
      }
    },
    validate: function validate(e, t, r) {
      return t >= 0 && t <= 6;
    },
    set: function set(e, t, r, n) {
      return (e = setUTCDay(e, r, n)).setUTCHours(0, 0, 0, 0), e;
    },
    incompatibleTokens: ["D", "i", "e", "c", "t", "T"]
  },
  e: {
    priority: 90,
    parse: function parse(e, t, r, n) {
      var a = function a(e) {
        var t = 7 * Math.floor((e - 1) / 7);
        return (e + n.weekStartsOn + 6) % 7 + t;
      };

      switch (t) {
        case "e":
        case "ee":
          return parseNDigits(t.length, e, a);

        case "eo":
          return r.ordinalNumber(e, {
            unit: "day",
            valueCallback: a
          });

        case "eee":
          return r.day(e, {
            width: "abbreviated",
            context: "formatting"
          }) || r.day(e, {
            width: "short",
            context: "formatting"
          }) || r.day(e, {
            width: "narrow",
            context: "formatting"
          });

        case "eeeee":
          return r.day(e, {
            width: "narrow",
            context: "formatting"
          });

        case "eeeeee":
          return r.day(e, {
            width: "short",
            context: "formatting"
          }) || r.day(e, {
            width: "narrow",
            context: "formatting"
          });

        default:
          return r.day(e, {
            width: "wide",
            context: "formatting"
          }) || r.day(e, {
            width: "abbreviated",
            context: "formatting"
          }) || r.day(e, {
            width: "short",
            context: "formatting"
          }) || r.day(e, {
            width: "narrow",
            context: "formatting"
          });
      }
    },
    validate: function validate(e, t, r) {
      return t >= 0 && t <= 6;
    },
    set: function set(e, t, r, n) {
      return (e = setUTCDay(e, r, n)).setUTCHours(0, 0, 0, 0), e;
    },
    incompatibleTokens: ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "c", "t", "T"]
  },
  c: {
    priority: 90,
    parse: function parse(e, t, r, n) {
      var a = function a(e) {
        var t = 7 * Math.floor((e - 1) / 7);
        return (e + n.weekStartsOn + 6) % 7 + t;
      };

      switch (t) {
        case "c":
        case "cc":
          return parseNDigits(t.length, e, a);

        case "co":
          return r.ordinalNumber(e, {
            unit: "day",
            valueCallback: a
          });

        case "ccc":
          return r.day(e, {
            width: "abbreviated",
            context: "standalone"
          }) || r.day(e, {
            width: "short",
            context: "standalone"
          }) || r.day(e, {
            width: "narrow",
            context: "standalone"
          });

        case "ccccc":
          return r.day(e, {
            width: "narrow",
            context: "standalone"
          });

        case "cccccc":
          return r.day(e, {
            width: "short",
            context: "standalone"
          }) || r.day(e, {
            width: "narrow",
            context: "standalone"
          });

        default:
          return r.day(e, {
            width: "wide",
            context: "standalone"
          }) || r.day(e, {
            width: "abbreviated",
            context: "standalone"
          }) || r.day(e, {
            width: "short",
            context: "standalone"
          }) || r.day(e, {
            width: "narrow",
            context: "standalone"
          });
      }
    },
    validate: function validate(e, t, r) {
      return t >= 0 && t <= 6;
    },
    set: function set(e, t, r, n) {
      return (e = setUTCDay(e, r, n)).setUTCHours(0, 0, 0, 0), e;
    },
    incompatibleTokens: ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "e", "t", "T"]
  },
  i: {
    priority: 90,
    parse: function parse(e, t, r, n) {
      var a = function a(e) {
        return 0 === e ? 7 : e;
      };

      switch (t) {
        case "i":
        case "ii":
          return parseNDigits(t.length, e);

        case "io":
          return r.ordinalNumber(e, {
            unit: "day"
          });

        case "iii":
          return r.day(e, {
            width: "abbreviated",
            context: "formatting",
            valueCallback: a
          }) || r.day(e, {
            width: "short",
            context: "formatting",
            valueCallback: a
          }) || r.day(e, {
            width: "narrow",
            context: "formatting",
            valueCallback: a
          });

        case "iiiii":
          return r.day(e, {
            width: "narrow",
            context: "formatting",
            valueCallback: a
          });

        case "iiiiii":
          return r.day(e, {
            width: "short",
            context: "formatting",
            valueCallback: a
          }) || r.day(e, {
            width: "narrow",
            context: "formatting",
            valueCallback: a
          });

        default:
          return r.day(e, {
            width: "wide",
            context: "formatting",
            valueCallback: a
          }) || r.day(e, {
            width: "abbreviated",
            context: "formatting",
            valueCallback: a
          }) || r.day(e, {
            width: "short",
            context: "formatting",
            valueCallback: a
          }) || r.day(e, {
            width: "narrow",
            context: "formatting",
            valueCallback: a
          });
      }
    },
    validate: function validate(e, t, r) {
      return t >= 1 && t <= 7;
    },
    set: function set(e, t, r, n) {
      return (e = setUTCISODay(e, r, n)).setUTCHours(0, 0, 0, 0), e;
    },
    incompatibleTokens: ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "E", "e", "c", "t", "T"]
  },
  a: {
    priority: 80,
    parse: function parse(e, t, r, n) {
      switch (t) {
        case "a":
        case "aa":
        case "aaa":
          return r.dayPeriod(e, {
            width: "abbreviated",
            context: "formatting"
          }) || r.dayPeriod(e, {
            width: "narrow",
            context: "formatting"
          });

        case "aaaaa":
          return r.dayPeriod(e, {
            width: "narrow",
            context: "formatting"
          });

        default:
          return r.dayPeriod(e, {
            width: "wide",
            context: "formatting"
          }) || r.dayPeriod(e, {
            width: "abbreviated",
            context: "formatting"
          }) || r.dayPeriod(e, {
            width: "narrow",
            context: "formatting"
          });
      }
    },
    set: function set(e, t, r, n) {
      return e.setUTCHours(dayPeriodEnumToHours(r), 0, 0, 0), e;
    },
    incompatibleTokens: ["b", "B", "H", "K", "k", "t", "T"]
  },
  b: {
    priority: 80,
    parse: function parse(e, t, r, n) {
      switch (t) {
        case "b":
        case "bb":
        case "bbb":
          return r.dayPeriod(e, {
            width: "abbreviated",
            context: "formatting"
          }) || r.dayPeriod(e, {
            width: "narrow",
            context: "formatting"
          });

        case "bbbbb":
          return r.dayPeriod(e, {
            width: "narrow",
            context: "formatting"
          });

        default:
          return r.dayPeriod(e, {
            width: "wide",
            context: "formatting"
          }) || r.dayPeriod(e, {
            width: "abbreviated",
            context: "formatting"
          }) || r.dayPeriod(e, {
            width: "narrow",
            context: "formatting"
          });
      }
    },
    set: function set(e, t, r, n) {
      return e.setUTCHours(dayPeriodEnumToHours(r), 0, 0, 0), e;
    },
    incompatibleTokens: ["a", "B", "H", "K", "k", "t", "T"]
  },
  B: {
    priority: 80,
    parse: function parse(e, t, r, n) {
      switch (t) {
        case "B":
        case "BB":
        case "BBB":
          return r.dayPeriod(e, {
            width: "abbreviated",
            context: "formatting"
          }) || r.dayPeriod(e, {
            width: "narrow",
            context: "formatting"
          });

        case "BBBBB":
          return r.dayPeriod(e, {
            width: "narrow",
            context: "formatting"
          });

        default:
          return r.dayPeriod(e, {
            width: "wide",
            context: "formatting"
          }) || r.dayPeriod(e, {
            width: "abbreviated",
            context: "formatting"
          }) || r.dayPeriod(e, {
            width: "narrow",
            context: "formatting"
          });
      }
    },
    set: function set(e, t, r, n) {
      return e.setUTCHours(dayPeriodEnumToHours(r), 0, 0, 0), e;
    },
    incompatibleTokens: ["a", "b", "t", "T"]
  },
  h: {
    priority: 70,
    parse: function parse(e, t, r, n) {
      switch (t) {
        case "h":
          return parseNumericPattern(numericPatterns.hour12h, e);

        case "ho":
          return r.ordinalNumber(e, {
            unit: "hour"
          });

        default:
          return parseNDigits(t.length, e);
      }
    },
    validate: function validate(e, t, r) {
      return t >= 1 && t <= 12;
    },
    set: function set(e, t, r, n) {
      var a = e.getUTCHours() >= 12;
      return a && r < 12 ? e.setUTCHours(r + 12, 0, 0, 0) : a || 12 !== r ? e.setUTCHours(r, 0, 0, 0) : e.setUTCHours(0, 0, 0, 0), e;
    },
    incompatibleTokens: ["H", "K", "k", "t", "T"]
  },
  H: {
    priority: 70,
    parse: function parse(e, t, r, n) {
      switch (t) {
        case "H":
          return parseNumericPattern(numericPatterns.hour23h, e);

        case "Ho":
          return r.ordinalNumber(e, {
            unit: "hour"
          });

        default:
          return parseNDigits(t.length, e);
      }
    },
    validate: function validate(e, t, r) {
      return t >= 0 && t <= 23;
    },
    set: function set(e, t, r, n) {
      return e.setUTCHours(r, 0, 0, 0), e;
    },
    incompatibleTokens: ["a", "b", "h", "K", "k", "t", "T"]
  },
  K: {
    priority: 70,
    parse: function parse(e, t, r, n) {
      switch (t) {
        case "K":
          return parseNumericPattern(numericPatterns.hour11h, e);

        case "Ko":
          return r.ordinalNumber(e, {
            unit: "hour"
          });

        default:
          return parseNDigits(t.length, e);
      }
    },
    validate: function validate(e, t, r) {
      return t >= 0 && t <= 11;
    },
    set: function set(e, t, r, n) {
      return e.getUTCHours() >= 12 && r < 12 ? e.setUTCHours(r + 12, 0, 0, 0) : e.setUTCHours(r, 0, 0, 0), e;
    },
    incompatibleTokens: ["a", "b", "h", "H", "k", "t", "T"]
  },
  k: {
    priority: 70,
    parse: function parse(e, t, r, n) {
      switch (t) {
        case "k":
          return parseNumericPattern(numericPatterns.hour24h, e);

        case "ko":
          return r.ordinalNumber(e, {
            unit: "hour"
          });

        default:
          return parseNDigits(t.length, e);
      }
    },
    validate: function validate(e, t, r) {
      return t >= 1 && t <= 24;
    },
    set: function set(e, t, r, n) {
      var a = r <= 24 ? r % 24 : r;
      return e.setUTCHours(a, 0, 0, 0), e;
    },
    incompatibleTokens: ["a", "b", "h", "H", "K", "t", "T"]
  },
  m: {
    priority: 60,
    parse: function parse(e, t, r, n) {
      switch (t) {
        case "m":
          return parseNumericPattern(numericPatterns.minute, e);

        case "mo":
          return r.ordinalNumber(e, {
            unit: "minute"
          });

        default:
          return parseNDigits(t.length, e);
      }
    },
    validate: function validate(e, t, r) {
      return t >= 0 && t <= 59;
    },
    set: function set(e, t, r, n) {
      return e.setUTCMinutes(r, 0, 0), e;
    },
    incompatibleTokens: ["t", "T"]
  },
  s: {
    priority: 50,
    parse: function parse(e, t, r, n) {
      switch (t) {
        case "s":
          return parseNumericPattern(numericPatterns.second, e);

        case "so":
          return r.ordinalNumber(e, {
            unit: "second"
          });

        default:
          return parseNDigits(t.length, e);
      }
    },
    validate: function validate(e, t, r) {
      return t >= 0 && t <= 59;
    },
    set: function set(e, t, r, n) {
      return e.setUTCSeconds(r, 0), e;
    },
    incompatibleTokens: ["t", "T"]
  },
  S: {
    priority: 30,
    parse: function parse(e, t, r, n) {
      return parseNDigits(t.length, e, function (e) {
        return Math.floor(e * Math.pow(10, 3 - t.length));
      });
    },
    set: function set(e, t, r, n) {
      return e.setUTCMilliseconds(r), e;
    },
    incompatibleTokens: ["t", "T"]
  },
  X: {
    priority: 10,
    parse: function parse(e, t, r, n) {
      switch (t) {
        case "X":
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, e);

        case "XX":
          return parseTimezonePattern(timezonePatterns.basic, e);

        case "XXXX":
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, e);

        case "XXXXX":
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, e);

        default:
          return parseTimezonePattern(timezonePatterns.extended, e);
      }
    },
    set: function set(e, t, r, n) {
      return t.timestampIsSet ? e : new Date(e.getTime() - r);
    },
    incompatibleTokens: ["t", "T", "x"]
  },
  x: {
    priority: 10,
    parse: function parse(e, t, r, n) {
      switch (t) {
        case "x":
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, e);

        case "xx":
          return parseTimezonePattern(timezonePatterns.basic, e);

        case "xxxx":
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, e);

        case "xxxxx":
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, e);

        default:
          return parseTimezonePattern(timezonePatterns.extended, e);
      }
    },
    set: function set(e, t, r, n) {
      return t.timestampIsSet ? e : new Date(e.getTime() - r);
    },
    incompatibleTokens: ["t", "T", "X"]
  },
  t: {
    priority: 40,
    parse: function parse(e, t, r, n) {
      return parseAnyDigitsSigned(e);
    },
    set: function set(e, t, r, n) {
      return [new Date(1e3 * r), {
        timestampIsSet: !0
      }];
    },
    incompatibleTokens: "*"
  },
  T: {
    priority: 20,
    parse: function parse(e, t, r, n) {
      return parseAnyDigitsSigned(e);
    },
    set: function set(e, t, r, n) {
      return [new Date(r), {
        timestampIsSet: !0
      }];
    },
    incompatibleTokens: "*"
  }
},
    parsers$1 = parsers,
    TIMEZONE_UNIT_PRIORITY = 10,
    formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g,
    longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g,
    escapedStringRegExp = /^'([^]*?)'?$/,
    doubleQuoteRegExp = /''/g,
    notWhitespaceRegExp = /\S/,
    unescapedLatinCharacterRegExp = /[a-zA-Z]/;

function parse(e, t, r, n) {
  requiredArgs(3, arguments);
  var a = String(e),
      o = String(t),
      i = n || {},
      s = i.locale || defaultLocale;
  if (!s.match) throw new RangeError("locale must contain match property");
  var l = s.options && s.options.firstWeekContainsDate,
      c = null == l ? 1 : toInteger(l),
      u = null == i.firstWeekContainsDate ? c : toInteger(i.firstWeekContainsDate);
  if (!(u >= 1 && u <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var d = s.options && s.options.weekStartsOn,
      p = null == d ? 0 : toInteger(d),
      g = null == i.weekStartsOn ? p : toInteger(i.weekStartsOn);
  if (!(g >= 0 && g <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if ("" === o) return "" === a ? toDate(r) : new Date(NaN);
  var m,
      f = {
    firstWeekContainsDate: u,
    weekStartsOn: g,
    locale: s
  },
      h = [{
    priority: TIMEZONE_UNIT_PRIORITY,
    set: dateToSystemTimezone,
    index: 0
  }],
      b = o.match(longFormattingTokensRegExp).map(function (e) {
    var t = e[0];
    return "p" === t || "P" === t ? (0, longFormatters$3[t])(e, s.formatLong, f) : e;
  }).join("").match(formattingTokensRegExp),
      y = [];

  for (m = 0; m < b.length; m++) {
    var v = b[m];
    !i.useAdditionalWeekYearTokens && isProtectedWeekYearToken(v) && throwProtectedError(v), !i.useAdditionalDayOfYearTokens && isProtectedDayOfYearToken(v) && throwProtectedError(v);
    var _ = v[0],
        T = parsers$1[_];

    if (T) {
      var E = T.incompatibleTokens;

      if (Array.isArray(E)) {
        for (var S = void 0, x = 0; x < y.length; x++) {
          var w = y[x].token;

          if (-1 !== E.indexOf(w) || w === _) {
            S = y[x];
            break;
          }
        }

        if (S) throw new RangeError("The format string mustn't contain `".concat(S.fullToken, "` and `").concat(v, "` at the same time"));
      } else if ("*" === T.incompatibleTokens && y.length) throw new RangeError("The format string mustn't contain `".concat(v, "` and any other token at the same time"));

      y.push({
        token: _,
        fullToken: v
      });
      var C = T.parse(a, v, s.match, f);
      if (!C) return new Date(NaN);
      h.push({
        priority: T.priority,
        set: T.set,
        validate: T.validate,
        value: C.value,
        index: h.length
      }), a = C.rest;
    } else {
      if (_.match(unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + _ + "`");
      if ("''" === v ? v = "'" : "'" === _ && (v = cleanEscapedString(v)), 0 !== a.indexOf(v)) return new Date(NaN);
      a = a.slice(v.length);
    }
  }

  if (a.length > 0 && notWhitespaceRegExp.test(a)) return new Date(NaN);
  var k = h.map(function (e) {
    return e.priority;
  }).sort(function (e, t) {
    return t - e;
  }).filter(function (e, t, r) {
    return r.indexOf(e) === t;
  }).map(function (e) {
    return h.filter(function (t) {
      return t.priority === e;
    }).reverse();
  }).map(function (e) {
    return e[0];
  }),
      $ = toDate(r);
  if (isNaN($)) return new Date(NaN);
  var R = subMilliseconds($, getTimezoneOffsetInMilliseconds($)),
      A = {};

  for (m = 0; m < k.length; m++) {
    var I = k[m];
    if (I.validate && !I.validate(R, I.value, f)) return new Date(NaN);
    var N = I.set(R, A, I.value, f);
    N[0] ? (R = N[0], assign(A, N[1])) : R = N;
  }

  return R;
}

function dateToSystemTimezone(e, t) {
  if (t.timestampIsSet) return e;
  var r = new Date(0);
  return r.setFullYear(e.getUTCFullYear(), e.getUTCMonth(), e.getUTCDate()), r.setHours(e.getUTCHours(), e.getUTCMinutes(), e.getUTCSeconds(), e.getUTCMilliseconds()), r;
}

function cleanEscapedString(e) {
  return e.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}

function setHours(e, t) {
  requiredArgs(2, arguments);
  var r = toDate(e),
      n = toInteger(t);
  return r.setHours(n), r;
}

function setMinutes(e, t) {
  requiredArgs(2, arguments);
  var r = toDate(e),
      n = toInteger(t);
  return r.setMinutes(n), r;
}

function getDaysInMonth(e) {
  requiredArgs(1, arguments);
  var t = toDate(e),
      r = t.getFullYear(),
      n = t.getMonth(),
      a = new Date(0);
  return a.setFullYear(r, n + 1, 0), a.setHours(0, 0, 0, 0), a.getDate();
}

function setMonth(e, t) {
  requiredArgs(2, arguments);
  var r = toDate(e),
      n = toInteger(t),
      a = r.getFullYear(),
      o = r.getDate(),
      i = new Date(0);
  i.setFullYear(a, n, 15), i.setHours(0, 0, 0, 0);
  var s = getDaysInMonth(i);
  return r.setMonth(n, Math.min(o, s)), r;
}

function getDay(e) {
  requiredArgs(1, arguments);
  var t = toDate(e),
      r = t.getDay();
  return r;
}

function setSeconds(e, t) {
  requiredArgs(2, arguments);
  var r = toDate(e),
      n = toInteger(t);
  return r.setSeconds(n), r;
}

function setYear(e, t) {
  requiredArgs(2, arguments);
  var r = toDate(e),
      n = toInteger(t);
  return isNaN(r) ? new Date(NaN) : (r.setFullYear(n), r);
}

function startOfMonth(e) {
  requiredArgs(1, arguments);
  var t = toDate(e);
  return t.setDate(1), t.setHours(0, 0, 0, 0), t;
}

function endOfMonth(e) {
  requiredArgs(1, arguments);
  var t = toDate(e),
      r = t.getMonth();
  return t.setFullYear(t.getFullYear(), r + 1, 0), t.setHours(23, 59, 59, 999), t;
}

function startOfWeek(e, t) {
  requiredArgs(1, arguments);
  var r = t || {},
      n = r.locale,
      a = n && n.options && n.options.weekStartsOn,
      o = null == a ? 0 : toInteger(a),
      i = null == r.weekStartsOn ? o : toInteger(r.weekStartsOn);
  if (!(i >= 0 && i <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var s = toDate(e),
      l = s.getDay(),
      c = (l < i ? 7 : 0) + l - i;
  return s.setDate(s.getDate() - c), s.setHours(0, 0, 0, 0), s;
}

function startOfYear(e) {
  requiredArgs(1, arguments);
  var t = toDate(e),
      r = new Date(0);
  return r.setFullYear(t.getFullYear(), 0, 1), r.setHours(0, 0, 0, 0), r;
}

var MILLISECONDS_IN_HOUR = 36e5,
    MILLISECONDS_IN_MINUTE = 6e4,
    DEFAULT_ADDITIONAL_DIGITS = 2,
    patterns = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
},
    dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/,
    timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/,
    timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;

function parseISO(e, t) {
  requiredArgs(1, arguments);
  var r = t || {},
      n = null == r.additionalDigits ? DEFAULT_ADDITIONAL_DIGITS : toInteger(r.additionalDigits);
  if (2 !== n && 1 !== n && 0 !== n) throw new RangeError("additionalDigits must be 0, 1 or 2");
  if ("string" != typeof e && "[object String]" !== Object.prototype.toString.call(e)) return new Date(NaN);
  var a,
      o = splitDateString(e);

  if (o.date) {
    var i = parseYear(o.date, n);
    a = parseDate(i.restDateString, i.year);
  }

  if (isNaN(a) || !a) return new Date(NaN);
  var s,
      l = a.getTime(),
      c = 0;
  if (o.time && (c = parseTime(o.time), isNaN(c) || null === c)) return new Date(NaN);

  if (!o.timezone) {
    var u = new Date(l + c),
        d = new Date(u.getUTCFullYear(), u.getUTCMonth(), u.getUTCDate(), u.getUTCHours(), u.getUTCMinutes(), u.getUTCSeconds(), u.getUTCMilliseconds());
    return d.setFullYear(u.getUTCFullYear()), d;
  }

  return s = parseTimezone(o.timezone), isNaN(s) ? new Date(NaN) : new Date(l + c + s);
}

function splitDateString(e) {
  var t,
      r = {},
      n = e.split(patterns.dateTimeDelimiter);

  if (/:/.test(n[0]) ? (r.date = null, t = n[0]) : (r.date = n[0], t = n[1], patterns.timeZoneDelimiter.test(r.date) && (r.date = e.split(patterns.timeZoneDelimiter)[0], t = e.substr(r.date.length, e.length))), t) {
    var a = patterns.timezone.exec(t);
    a ? (r.time = t.replace(a[1], ""), r.timezone = a[1]) : r.time = t;
  }

  return r;
}

function parseYear(e, t) {
  var r = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + t) + "})|(\\d{2}|[+-]\\d{" + (2 + t) + "})$)"),
      n = e.match(r);
  if (!n) return {
    year: null
  };
  var a = n[1] && parseInt(n[1]),
      o = n[2] && parseInt(n[2]);
  return {
    year: null == o ? a : 100 * o,
    restDateString: e.slice((n[1] || n[2]).length)
  };
}

function parseDate(e, t) {
  if (null === t) return null;
  var r = e.match(dateRegex);
  if (!r) return null;
  var n = !!r[4],
      a = parseDateUnit(r[1]),
      o = parseDateUnit(r[2]) - 1,
      i = parseDateUnit(r[3]),
      s = parseDateUnit(r[4]),
      l = parseDateUnit(r[5]) - 1;
  if (n) return validateWeekDate(t, s, l) ? dayOfISOWeekYear(t, s, l) : new Date(NaN);
  var c = new Date(0);
  return validateDate(t, o, i) && validateDayOfYearDate(t, a) ? (c.setUTCFullYear(t, o, Math.max(a, i)), c) : new Date(NaN);
}

function parseDateUnit(e) {
  return e ? parseInt(e) : 1;
}

function parseTime(e) {
  var t = e.match(timeRegex);
  if (!t) return null;
  var r = parseTimeUnit(t[1]),
      n = parseTimeUnit(t[2]),
      a = parseTimeUnit(t[3]);
  return validateTime(r, n, a) ? r * MILLISECONDS_IN_HOUR + n * MILLISECONDS_IN_MINUTE + 1e3 * a : NaN;
}

function parseTimeUnit(e) {
  return e && parseFloat(e.replace(",", ".")) || 0;
}

function parseTimezone(e) {
  if ("Z" === e) return 0;
  var t = e.match(timezoneRegex);
  if (!t) return 0;
  var r = "+" === t[1] ? -1 : 1,
      n = parseInt(t[2]),
      a = t[3] && parseInt(t[3]) || 0;
  return validateTimezone(n, a) ? r * (n * MILLISECONDS_IN_HOUR + a * MILLISECONDS_IN_MINUTE) : NaN;
}

function dayOfISOWeekYear(e, t, r) {
  var n = new Date(0);
  n.setUTCFullYear(e, 0, 4);
  var a = 7 * (t - 1) + r + 1 - (n.getUTCDay() || 7);
  return n.setUTCDate(n.getUTCDate() + a), n;
}

var daysInMonths = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

function isLeapYearIndex(e) {
  return e % 400 == 0 || e % 4 == 0 && e % 100;
}

function validateDate(e, t, r) {
  return t >= 0 && t <= 11 && r >= 1 && r <= (daysInMonths[t] || (isLeapYearIndex(e) ? 29 : 28));
}

function validateDayOfYearDate(e, t) {
  return t >= 1 && t <= (isLeapYearIndex(e) ? 366 : 365);
}

function validateWeekDate(e, t, r) {
  return t >= 1 && t <= 53 && r >= 0 && r <= 6;
}

function validateTime(e, t, r) {
  return 24 === e ? 0 === t && 0 === r : r >= 0 && r < 60 && t >= 0 && t < 60 && e >= 0 && e < 25;
}

function validateTimezone(e, t) {
  return t >= 0 && t <= 59;
}

function formatISO(e, t) {
  if (arguments.length < 1) throw new TypeError("1 argument required, but only ".concat(arguments.length, " present"));
  var r = toDate(e);
  if (!isValid(r)) throw new RangeError("Invalid time value");
  var n = t || {},
      a = null == n.format ? "extended" : String(n.format),
      o = null == n.representation ? "complete" : String(n.representation);
  if ("extended" !== a && "basic" !== a) throw new RangeError("format must be 'extended' or 'basic'");
  if ("date" !== o && "time" !== o && "complete" !== o) throw new RangeError("representation must be 'date', 'time', or 'complete'");
  var i = "",
      s = "",
      l = "extended" === a ? "-" : "",
      c = "extended" === a ? ":" : "";

  if ("time" !== o) {
    var u = addLeadingZeros(r.getDate(), 2),
        d = addLeadingZeros(r.getMonth() + 1, 2),
        p = addLeadingZeros(r.getFullYear(), 4);
    i = "".concat(p).concat(l).concat(d).concat(l).concat(u);
  }

  if ("date" !== o) {
    var g = r.getTimezoneOffset();

    if (0 !== g) {
      var m = Math.abs(g),
          f = addLeadingZeros(Math.floor(m / 60), 2),
          h = addLeadingZeros(m % 60, 2),
          b = g < 0 ? "+" : "-";
      s = "".concat(b).concat(f, ":").concat(h);
    } else s = "Z";

    var y = addLeadingZeros(r.getHours(), 2),
        v = addLeadingZeros(r.getMinutes(), 2),
        _ = addLeadingZeros(r.getSeconds(), 2),
        T = "" === i ? "" : "T",
        E = [y, v, _].join(c);

    i = "".concat(i).concat(T).concat(E).concat(s);
  }

  return i;
}

function isWithinInterval(e, t) {
  requiredArgs(2, arguments);
  var r = t || {},
      n = toDate(e).getTime(),
      a = toDate(r.start).getTime(),
      o = toDate(r.end).getTime();
  if (!(a <= o)) throw new RangeError("Invalid interval");
  return n >= a && n <= o;
}

var longFormatters$1 = {
  exports: {}
};
!function (e, t) {
  function r(e, t) {
    switch (e) {
      case "P":
        return t.date({
          width: "short"
        });

      case "PP":
        return t.date({
          width: "medium"
        });

      case "PPP":
        return t.date({
          width: "long"
        });

      default:
        return t.date({
          width: "full"
        });
    }
  }

  function n(e, t) {
    switch (e) {
      case "p":
        return t.time({
          width: "short"
        });

      case "pp":
        return t.time({
          width: "medium"
        });

      case "ppp":
        return t.time({
          width: "long"
        });

      default:
        return t.time({
          width: "full"
        });
    }
  }

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var a = {
    p: n,
    P: function P(e, t) {
      var a,
          o = e.match(/(P+)(p+)?/),
          i = o[1],
          s = o[2];
      if (!s) return r(e, t);

      switch (i) {
        case "P":
          a = t.dateTime({
            width: "short"
          });
          break;

        case "PP":
          a = t.dateTime({
            width: "medium"
          });
          break;

        case "PPP":
          a = t.dateTime({
            width: "long"
          });
          break;

        default:
          a = t.dateTime({
            width: "full"
          });
      }

      return a.replace("{{date}}", r(i, t)).replace("{{time}}", n(s, t));
    }
  },
      o = a;
  t.default = o, e.exports = t.default;
}(longFormatters$1, longFormatters$1.exports);

var longFormatters = getDefaultExportFromCjs(longFormatters$1.exports),
    defaultFormats = {
  dayOfMonth: "d",
  fullDate: "PP",
  fullDateWithWeekday: "PPPP",
  fullDateTime: "PP p",
  fullDateTime12h: "PP hh:mm aaa",
  fullDateTime24h: "PP HH:mm",
  fullTime: "p",
  fullTime12h: "hh:mm aaa",
  fullTime24h: "HH:mm",
  hours12h: "hh",
  hours24h: "HH",
  keyboardDate: "P",
  keyboardDateTime: "P p",
  keyboardDateTime12h: "P hh:mm aaa",
  keyboardDateTime24h: "P HH:mm",
  minutes: "mm",
  month: "LLLL",
  monthAndDate: "MMMM d",
  monthAndYear: "LLLL yyyy",
  monthShort: "MMM",
  weekday: "EEEE",
  weekdayShort: "EEE",
  normalDate: "d MMMM",
  normalDateWithWeekday: "EEE, MMM d",
  seconds: "ss",
  shortDate: "MMM d",
  year: "yyyy"
},
    DateFnsUtils = function DateFnsUtils(e) {
  var t = this,
      r = void 0 === e ? {} : e,
      n = r.locale,
      a = r.formats;
  this.lib = "date-fns", this.is12HourCycleInCurrentLocale = function () {
    return !t.locale || /a/.test(t.locale.formatLong.time());
  }, this.getFormatHelperText = function (e) {
    var r = t.locale || defaultLocale;
    return e.match(/P+p+|P+|p+|''|'(''|[^'])+('|$)|./g).map(function (e) {
      var t = e[0];
      return "p" === t || "P" === t ? (0, longFormatters[t])(e, r.formatLong, {}) : e;
    }).join("").replace(/(aaa|aa|a)/g, "(a|p)m").toLocaleLowerCase();
  }, this.parseISO = function (e) {
    return parseISO(e);
  }, this.toISO = function (e) {
    return formatISO(e, {
      format: "extended"
    });
  }, this.getCurrentLocaleCode = function () {
    var e;
    return (null === (e = t.locale) || void 0 === e ? void 0 : e.code) || "en-US";
  }, this.addSeconds = function (e, t) {
    return addSeconds(e, t);
  }, this.addMinutes = function (e, t) {
    return addMinutes(e, t);
  }, this.addHours = function (e, t) {
    return addHours(e, t);
  }, this.addDays = function (e, t) {
    return addDays(e, t);
  }, this.addWeeks = function (e, t) {
    return addWeeks(e, t);
  }, this.addMonths = function (e, t) {
    return addMonths(e, t);
  }, this.isValid = function (e) {
    return isValid(t.date(e));
  }, this.getDiff = function (e, r, n) {
    switch (n) {
      case "years":
        return differenceInYears(e, t.date(r));

      case "quarters":
        return differenceInQuarters(e, t.date(r));

      case "months":
        return differenceInMonths(e, t.date(r));

      case "weeks":
        return differenceInWeeks(e, t.date(r));

      case "days":
        return differenceInDays(e, t.date(r));

      case "hours":
        return differenceInHours(e, t.date(r));

      case "minutes":
        return differenceInMinutes(e, t.date(r));

      case "seconds":
        return differenceInSeconds(e, t.date(r));

      default:
        return differenceInMilliseconds(e, t.date(r));
    }
  }, this.isAfter = function (e, t) {
    return isAfter(e, t);
  }, this.isBefore = function (e, t) {
    return isBefore(e, t);
  }, this.startOfDay = function (e) {
    return startOfDay(e);
  }, this.endOfDay = function (e) {
    return endOfDay(e);
  }, this.getHours = function (e) {
    return getHours(e);
  }, this.setHours = function (e, t) {
    return setHours(e, t);
  }, this.setMinutes = function (e, t) {
    return setMinutes(e, t);
  }, this.getSeconds = function (e) {
    return getSeconds(e);
  }, this.setSeconds = function (e, t) {
    return setSeconds(e, t);
  }, this.isSameDay = function (e, t) {
    return isSameDay(e, t);
  }, this.isSameMonth = function (e, t) {
    return isSameMonth(e, t);
  }, this.isSameYear = function (e, t) {
    return isSameYear(e, t);
  }, this.isSameHour = function (e, t) {
    return isSameHour(e, t);
  }, this.startOfMonth = function (e) {
    return startOfMonth(e);
  }, this.endOfMonth = function (e) {
    return endOfMonth(e);
  }, this.startOfWeek = function (e) {
    return startOfWeek(e, {
      locale: t.locale
    });
  }, this.endOfWeek = function (e) {
    return endOfWeek(e, {
      locale: t.locale
    });
  }, this.getYear = function (e) {
    return getYear(e);
  }, this.setYear = function (e, t) {
    return setYear(e, t);
  }, this.date = function (e) {
    return void 0 === e ? new Date() : null === e ? null : new Date(e);
  }, this.toJsDate = function (e) {
    return e;
  }, this.parse = function (e, r) {
    return "" === e ? null : parse(e, r, new Date(), {
      locale: t.locale
    });
  }, this.format = function (e, r) {
    return t.formatByString(e, t.formats[r]);
  }, this.formatByString = function (e, r) {
    return format(e, r, {
      locale: t.locale
    });
  }, this.isEqual = function (e, t) {
    return null === e && null === t || isEqual(e, t);
  }, this.isNull = function (e) {
    return null === e;
  }, this.isAfterDay = function (e, t) {
    return isAfter(e, endOfDay(t));
  }, this.isBeforeDay = function (e, t) {
    return isBefore(e, startOfDay(t));
  }, this.isBeforeYear = function (e, t) {
    return isBefore(e, startOfYear(t));
  }, this.isAfterYear = function (e, t) {
    return isAfter(e, endOfYear(t));
  }, this.isWithinRange = function (e, t) {
    return isWithinInterval(e, {
      start: t[0],
      end: t[1]
    });
  }, this.formatNumber = function (e) {
    return e;
  }, this.getMinutes = function (e) {
    return e.getMinutes();
  }, this.getMonth = function (e) {
    return e.getMonth();
  }, this.getDaysInMonth = function (e) {
    return getDaysInMonth(e);
  }, this.setMonth = function (e, t) {
    return setMonth(e, t);
  }, this.getMeridiemText = function (e) {
    return "am" === e ? "AM" : "PM";
  }, this.getNextMonth = function (e) {
    return addMonths(e, 1);
  }, this.getPreviousMonth = function (e) {
    return addMonths(e, -1);
  }, this.getMonthArray = function (e) {
    for (var r = [startOfYear(e)]; r.length < 12;) {
      var n = r[r.length - 1];
      r.push(t.getNextMonth(n));
    }

    return r;
  }, this.mergeDateAndTime = function (e, r) {
    return t.setSeconds(t.setMinutes(t.setHours(e, t.getHours(r)), t.getMinutes(r)), t.getSeconds(r));
  }, this.getWeekdays = function () {
    var e = new Date();
    return eachDayOfInterval({
      start: startOfWeek(e, {
        locale: t.locale
      }),
      end: endOfWeek(e, {
        locale: t.locale
      })
    }).map(function (e) {
      return t.formatByString(e, "EEEEEE");
    });
  }, this.getWeekArray = function (e) {
    for (var r = startOfWeek(startOfMonth(e), {
      locale: t.locale
    }), n = endOfWeek(endOfMonth(e), {
      locale: t.locale
    }), a = 0, o = r, i = [], s = null; isBefore(o, n);) {
      var l = Math.floor(a / 7);
      i[l] = i[l] || [];
      var c = getDay(o);
      s !== c && (s = c, i[l].push(o), a += 1), o = addDays(o, 1);
    }

    return i;
  }, this.getYearRange = function (e, t) {
    for (var r = startOfYear(e), n = endOfYear(t), a = [], o = r; isBefore(o, n);) {
      a.push(o), o = addYears(o, 1);
    }

    return a;
  }, this.locale = n, this.formats = Object.assign({}, defaultFormats, a);
},
    StaticDatePicker = function StaticDatePicker(e) {
  return jsx$1(LocalizationProvider, _assign$({
    dateAdapter: DateFnsUtils
  }, {
    children: jsx$1(MuiStaticDatePicker, _assign$({}, e))
  }));
},
    StaticTimePicker = function StaticTimePicker(e) {
  var t = e.value,
      r = e.minTime,
      n = e.maxTime,
      a = e.intervalInMinutes,
      o = e.onChange,
      i = useTheme$4(),
      s = useMemo(function () {
    return Array(Math.trunc(differenceInMinutes$1(n, r) / a)).fill(null).map(function (e, t) {
      return t;
    }).map(function (e) {
      return addMinutes$1(r, e * a);
    });
  }, [n, r, a]);
  return jsx$1(Root$x, {
    children: s.map(function (e) {
      var r = isSameHour$1(e, t) && isSameMinute(e, t);
      return jsx$1(Button, _assign$({
        onClick: function onClick() {
          return o(e);
        },
        variant: r ? "contained" : "outlined",
        size: "small",
        sx: {
          backgroundColor: r ? i.palette.primary.main : i.palette.grey.A100,
          border: 0,
          fontSize: i.typography.body2.fontSize,
          fontWeight: i.typography.fontWeightRegular,
          height: 27,
          margin: i.spacing(1, 1.2),
          width: 72,
          whiteSpace: "pre"
        }
      }, {
        children: format$1(e, "h:mm a")
      }), e.toString());
    })
  });
},
    Root$x = styled$2(Box)(function (e) {
  return {
    margin: e.theme.spacing(-1, -1.2)
  };
}),
    TextFieldSubmitCombo = function TextFieldSubmitCombo(e) {
  var t = e.startAdornment,
      r = e.width,
      n = e.elevation,
      a = e.onSubmit,
      o = __rest$1(e, ["startAdornment", "width", "elevation", "onSubmit"]),
      i = useTheme$4();

  return jsxs(Paper$1, _assign$({
    component: "form",
    sx: {
      p: i.spacing(1),
      display: "flex",
      alignItems: "center",
      width: r
    },
    elevation: n
  }, {
    children: [t, jsx$1(InputBase, _assign$({
      sx: _assign$(_assign$({}, i.typography.h6), {
        ml: .5,
        flex: 1
      })
    }, o)), jsx$1(IconButton$2, _assign$({
      onClick: a,
      sx: {
        p: "10px"
      },
      "aria-label": "directions"
    }, {
      children: jsx$1(IoArrowForwardCircleSharp, {
        size: 30
      })
    }))]
  }));
},
    VisualTag = function VisualTag(e) {
  return jsx$1(Root$w, _assign$({}, e, {
    children: jsx$1("img", {
      src: e.image,
      width: 20,
      height: 20
    })
  }));
},
    Root$w = styled$2(Box)(function (e) {
  var t = e.theme;
  return {
    background: t.palette.primary.main,
    borderRadius: "50%",
    margin: 10,
    height: 30,
    width: 30,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    boxShadow: "0 0 1px 1px ".concat(hexToRgba(t.palette.primary.main, 1)),
    transform: "scale(1)",
    animation: "pulse 2s infinite",
    "@keyframes pulse": {
      "0%": {
        transform: "scale(0.95)",
        boxShadow: "0 0 0 0px ".concat(hexToRgba(t.palette.primary.main, .7))
      },
      "70%": {
        transform: "scale(1)",
        boxShadow: "0 0 0 10px ".concat(hexToRgba(t.palette.primary.main, 0))
      },
      "100%": {
        transform: "scale(0.95)",
        boxShadow: "0 0 0 20px ".concat(hexToRgba(t.palette.primary.main, 0))
      }
    }
  };
}),
    AudioTestimonialGroup = function AudioTestimonialGroup(e) {
  var t = e.data,
      r = useTheme$4(),
      n = useMediaQuery(r.breakpoints.down("md")),
      a = useMediaQuery(r.breakpoints.down("sm")),
      o = t.title,
      i = t.description,
      s = t.AudioTestimonialItem,
      l = React__default.useRef([]);
  l.current = s.map(function (e, t) {
    return React__default.createRef();
  });

  var c = function c(e) {
    var t,
        r,
        n = "";
    return s.length === e ? (n += null === (t = s[0]) || void 0 === t ? void 0 : t.author, n += ", ", n += s[0].company) : (n += null === (r = s[e]) || void 0 === r ? void 0 : r.author, n += ", ", n += s[e].company), jsx$1(Fragment, {
      children: jsxs(Text, _assign$({
        variant: "body1"
      }, {
        children: ["Next: ", n]
      }))
    });
  },
      u = function u(e, t) {
    return null == l.current[t] ? jsx$1(Fragment, {}) : jsxs(AudioPlayer, {
      children: [jsx$1(AudioVisualizers, {
        imageFile: e.authorProfileImage,
        songFile: e.audio,
        ref: l.current[t],
        onClick: function onClick() {
          return function (e) {
            var t, r, n, a, o, i, s;
            void 0 === (null === (t = e.current) || void 0 === t ? void 0 : t.duration) || isNaN(null === (r = null == e ? void 0 : e.current) || void 0 === r ? void 0 : r.duration) || void 0 === (null === (n = null == e ? void 0 : e.current) || void 0 === n ? void 0 : n.paused) || ((null === (a = e.current) || void 0 === a ? void 0 : a.duration) > 0 && (null === (o = null == e ? void 0 : e.current) || void 0 === o ? void 0 : o.paused) ? null === (i = e.current) || void 0 === i || i.play() : null === (s = e.current) || void 0 === s || s.pause());
          }(l.current[t]);
        }
      }), console.log(l.current[t]), jsx$1(AudioPlayerRing, {
        variant: "outlined"
      }), jsx$1(AudioDuration, {
        className: "outer-ring",
        variant: "body1",
        color: r.palette.text.secondary
      })]
    });
  };

  return jsx$1(Fragment, {
    children: jsx$1(Root$v, {
      children: jsxs(Container, {
        children: [jsx$1(Text, _assign$({
          variant: "h3",
          fontWeight: r.typography.fontWeightSemiBold,
          gutterBottom: !0,
          rich: !0
        }, {
          children: o
        })), "" !== i && jsx$1(Text, _assign$({
          fontWeight: r.typography.fontWeightBold,
          paddingBottom: r.spacing(1),
          color: r.palette.text.secondary,
          variant: "h5",
          rich: !0
        }, {
          children: i
        })), jsx$1(Box, {
          children: s.length >= 1 && jsx$1(Slider, _assign$({}, sliderSettings, {
            children: s.map(function (e, t) {
              return jsxs(SliderItem, _assign$({
                direction: n ? "row" : "column"
              }, {
                children: [jsxs(Grid$2, _assign$({
                  container: !0
                }, {
                  children: [jsx$1(Grid$2, _assign$({
                    item: !0,
                    xs: 5,
                    sm: 12,
                    md: 12
                  }, {
                    children: u(e, t)
                  })), jsx$1(Grid$2, _assign$({
                    item: !0,
                    xs: 7,
                    sm: 12,
                    md: 12
                  }, {
                    children: jsxs(ReviewerDetails, {
                      children: [jsx$1(Text, _assign$({
                        variant: "h6",
                        fontWeight: r.typography.fontWeightSemiBold
                      }, {
                        children: e.author
                      })), jsx$1(Text, _assign$({
                        variant: "body1",
                        gutterBottom: !0
                      }, {
                        children: e.company
                      })), jsx$1(Text, _assign$({
                        variant: "body1"
                      }, {
                        children: e.location
                      }))]
                    })
                  }))]
                })), a && jsx$1(Grid$2, _assign$({
                  item: !0,
                  xs: 12
                }, {
                  children: jsx$1(NextItem, {
                    children: c(++t)
                  })
                }))]
              }), t);
            })
          }))
        })]
      })
    })
  });
},
    Root$v = styled$2(Box)(function (e) {
  var t = e.theme;
  return {
    marginBottom: t.spacing(10),
    marginTop: t.spacing(10),
    textAlign: "center",
    background: "#fff",
    justifyContent: "center",
    alignItems: "center",
    "& .slick-prev:before": {
      color: "#8290A1"
    },
    "& .slick-next:before": {
      color: "#8290A1"
    },
    "& .slick-dots li.slick-active button:before": {
      color: colors.blue[600]
    },
    "& .slick-dots li button:before": {
      color: colors.blue[600],
      fontSize: t.spacing(2.5)
    }
  };
}),
    SliderItem = styled$2(Stack$2)(function (e) {
  var t,
      r = e.theme;
  return (t = {})[r.breakpoints.up("xs")] = {
    marginTop: r.spacing(7)
  }, t;
}),
    AudioPlayer = styled$2(Box)(function (e) {
  return e.theme, {
    position: "relative"
  };
}),
    AudioPlayerRing = styled$2(Card)(function (e) {
  var t = e.theme;
  return "\n  position: absolute;\n  left: 0;\n  right:0;\n  margin: 0 auto;\n  background: transparent;\n  border-color: #8290A1;\n  border-radius: 50%;\n  pointer-events: none;\n  overflow: visible;\n  ".concat(t.breakpoints.down("sm"), " {\n    height: 96px;\n    width: 96px;\n    top: 41px;\n  }\n  ").concat(t.breakpoints.up("sm"), " {\n    height: 145px;\n    width: 145px;\n    top:30px;\n  }\n  ").concat(t.breakpoints.up("md"), ' {\n    height: 160px;\n    width: 160px;\n    top:36px;\n  }\n\n  &::before {\n    position: absolute;\n    top: -12px;\n    left: 49%;\n    content: "";\n    height: 18px;\n    width: 1px;\n    background: #8290A1;\n    overflow: visible;\n  }\n  ');
}),
    AudioDuration = styled$2(Text)(function (e) {
  return e.theme, {
    "&.outer-ring": {
      position: "absolute",
      top: 0,
      left: 0,
      right: 0
    }
  };
}),
    sliderSettings = {
  arrows: !0,
  dots: !0,
  infinite: !1,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 4,
  initialSlide: 0,
  responsive: [{
    breakpoint: 1023,
    settings: {
      slidesToShow: 3,
      slidesToScroll: 3,
      infinite: !1,
      dots: !1
    }
  }, {
    breakpoint: 899,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 2,
      initialSlide: 2,
      dots: !1,
      arrows: !0
    }
  }, {
    breakpoint: 599,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: !0,
      arrows: !1
    }
  }]
},
    ReviewerDetails = styled$2(Box)(function (e) {
  var t,
      r = e.theme;
  return (t = {
    color: colors.grey[600],
    textAlign: "left",
    marginLeft: "auto",
    marginRight: "auto"
  })[r.breakpoints.down("sm")] = {
    marginTop: "50px"
  }, t[r.breakpoints.only("sm")] = {
    marginTop: "30px",
    width: 147
  }, t[r.breakpoints.up("md")] = {
    width: 162
  }, t;
}),
    NextItem = styled$2(Box)(function (e) {
  return e.theme, {
    color: colors.grey[600]
  };
}),
    NotificationBanner = function NotificationBanner(e) {
  var t,
      r = e.storageKey,
      n = e.data,
      a = e.onClose,
      o = e.children,
      i = __rest$1(e, ["storageKey", "data", "onClose", "children"]),
      s = useTheme$4(),
      l = useLocalstorageState(r, null),
      c = l[0],
      u = l[1],
      d = null !== (t = null == c ? void 0 : c.data.color) && void 0 !== t ? t : s.palette.primary.main,
      p = _assign$({
    backgroundColor: d,
    color: s.palette.getContrastText(d)
  }, i),
      g = function g() {
    u({
      data: n,
      hidden: !0
    }), null != a && a();
  };

  return useEffect(function () {
    var e;
    n.show && (null == c ? void 0 : c.data.title) !== n.title ? u({
      data: n,
      hidden: !1
    }) : u({
      data: _assign$(_assign$({}, null == c ? void 0 : c.data), n),
      hidden: null === (e = null == c ? void 0 : c.hidden) || void 0 === e || e
    });
  }, [r, n, u]), null == (null == c ? void 0 : c.data.show) || (null == c ? void 0 : c.data.show) ? null == c || (null == c ? void 0 : c.hidden) ? jsx$1(Fragment, {}) : jsx$1(Root$u, _assign$({
    sx: p
  }, null != o ? {
    children: jsx$1(Container, {
      children: jsxs(Stack$2, _assign$({
        direction: "row",
        alignItems: "center",
        justifyContent: "space-between",
        columnGap: 2
      }, {
        children: [jsx$1(IconButton$2, _assign$({
          onClick: g,
          size: "small",
          color: "inherit"
        }, {
          children: jsx$1(IoMdClose, {
            fontSize: 18
          })
        })), o]
      }))
    })
  } : {
    children: jsx$1(Container, {
      children: jsxs(Stack$2, _assign$({
        direction: "row",
        alignItems: "center",
        justifyContent: "space-between",
        columnGap: 2
      }, {
        children: [jsx$1(Text, _assign$({
          rich: !0,
          variant: "subtitle2"
        }, {
          children: null == c ? void 0 : c.data.title
        })), jsx$1(IconButton$2, _assign$({
          onClick: g,
          size: "small",
          color: "inherit"
        }, {
          children: jsx$1(IoMdClose, {
            fontSize: 18
          })
        }))]
      }))
    })
  })) : jsx$1(Fragment, {});
},
    Root$u = styled$2(Box)(function (e) {
  return {
    padding: e.theme.spacing(.5)
  };
}),
    AppLinkNotificationBanner = function AppLinkNotificationBanner(e) {
  var t = e.data,
      r = e.storageKey,
      n = useTheme$4(),
      a = useButtonStyles().getVariant,
      o = t.id,
      i = t.logo,
      s = t.title,
      l = t.description,
      c = t.rating,
      u = t.showRating,
      d = t.styles,
      p = t.textButtons,
      g = t.imageButtons,
      m = t.color,
      f = t.theme,
      h = null != m && "" !== m ? m : n.palette.background.default,
      b = function b(e) {
    return {
      link: e,
      key: null == e ? void 0 : e.id,
      href: null == e ? void 0 : e.url,
      target: void 0 !== (null == e ? void 0 : e.newTab) && (null == e ? void 0 : e.newTab) ? "_blank" : "_self",
      rel: "noreferrer"
    };
  };

  return jsx$1(Root$t, _assign$({
    sx: d,
    className: appLinkNotificationBannerClasess.root
  }, {
    children: jsx$1(NotificationBanner, _assign$({
      data: {
        id: o,
        show: !0,
        title: s,
        color: h
      },
      storageKey: r,
      py: 1
    }, {
      children: jsxs(Grid$2, _assign$({
        container: !0,
        spacing: 2,
        flexWrap: "wrap",
        alignItems: "center"
      }, {
        children: [null == i ? jsx$1(Fragment, {}) : jsx$1(Grid$2, _assign$({
          item: !0
        }, {
          children: jsx$1(Logo, _assign$({
            className: appLinkNotificationBannerClasess.logo
          }, {
            children: jsx$1(Media, {
              media: i
            })
          }))
        })), jsx$1(Grid$2, _assign$({
          item: !0,
          flex: 1
        }, {
          children: jsx$1(Grid$2, _assign$({
            item: !0,
            xs: !0,
            container: !0,
            direction: "column",
            spacing: 2
          }, {
            children: jsxs(Grid$2, _assign$({
              item: !0,
              xs: !0
            }, {
              children: [jsx$1(Text, _assign$({
                rich: !0,
                variant: "subtitle2",
                className: appLinkNotificationBannerClasess.title
              }, {
                children: s
              })), jsx$1(Text, _assign$({
                rich: !0,
                variant: "caption",
                className: appLinkNotificationBannerClasess.description
              }, {
                children: l
              })), u ? jsx$1(StarRating, {
                defaultValue: c,
                readOnly: !0
              }) : jsx$1(Fragment, {})]
            }))
          }))
        })), null == p && null == g ? jsx$1(Fragment, {}) : jsxs(Grid$2, _assign$({
          item: !0,
          alignItems: "center",
          display: "flex",
          gap: 1,
          className: appLinkNotificationBannerClasess.buttons
        }, {
          children: [null == g ? void 0 : g.map(function (e) {
            return createElement$1(Link, _assign$({}, b(e), {
              key: e.id
            }), jsx$1(Badge, _assign$({
              className: "".concat(appLinkNotificationBannerClasess.button, " ").concat(appLinkNotificationBannerClasess.imageButton)
            }, {
              children: jsx$1(Media, {
                media: e.media
              })
            })));
          }), null == p ? void 0 : p.map(function (e) {
            return createElement$1(Link, _assign$({}, b(e), {
              key: e.id
            }), function (e) {
              var t,
                  r,
                  o,
                  i = {
                variant: a(e.variant),
                size: "small",
                sx: (t = {
                  px: 2,
                  textTransform: "none"
                }, t["&.".concat(buttonClasses.root)] = {}, t),
                className: "".concat(appLinkNotificationBannerClasess.button, " ").concat(appLinkNotificationBannerClasess.textButton)
              };
              return "solid" === e.variant && (i.sx = _assign$(_assign$({}, i.sx), {
                lineHeight: 1.2,
                color: h
              }), "inverted" === f && (i.sx = _assign$(_assign$({}, i.sx), ((r = {
                backgroundColor: n.palette.getContrastText(h)
              })["&.".concat(buttonClasses.root, ":hover")] = {
                backgroundColor: darken$1(n.palette.getContrastText(h), .1)
              }, r)))), "outlined" === e.variant && (i.sx = _assign$(_assign$({}, i.sx), {
                lineHeight: 1
              }), "inverted" === f && (i.sx = _assign$(_assign$({}, i.sx), ((o = {
                borderColor: n.palette.getContrastText(h),
                color: n.palette.getContrastText(h)
              })["&.".concat(buttonClasses.root, ":hover")] = {
                borderColor: n.palette.getContrastText(h),
                backgroundColor: darken$1(h, .2)
              }, o)))), jsx$1(Button, _assign$({}, i, {
                children: e.text
              }));
            }(e));
          })]
        }))]
      }))
    }))
  }));
},
    Logo = styled$2(Paper$1)(function (e) {
  return e.theme, {
    height: 50,
    overflow: "hidden",
    width: 50
  };
}),
    Root$t = styled$2(Box)(function (e) {
  return e.theme, {};
}),
    StarRating = styled$2(Rating)(function (e) {
  return e.theme, {
    fontSize: "0.825rem",
    marginLeft: NaN
  };
}),
    Badge = styled$2(ButtonBase$1)(function (e) {
  return e.theme, {
    maxHeight: 20,
    maxWidth: 128
  };
}),
    ArrowForwardIosSharp = {},
    interopRequireDefault$1 = {
  exports: {}
},
    module;

module = interopRequireDefault$1, module.exports = function (e) {
  return e && e.__esModule ? e : {
    default: e
  };
}, module.exports.__esModule = !0, module.exports.default = module.exports;
var createSvgIcon = {},
    require$$0 = getAugmentedNamespace(utils);
!function (e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function get() {
      return t.createSvgIcon;
    }
  });
  var t = require$$0;
}(createSvgIcon);
var _interopRequireDefault$1 = interopRequireDefault$1.exports;
Object.defineProperty(ArrowForwardIosSharp, "__esModule", {
  value: !0
});

var default_1$1 = ArrowForwardIosSharp.default = void 0,
    _createSvgIcon$1 = _interopRequireDefault$1(createSvgIcon),
    _jsxRuntime$1 = require$$2,
    _default$1 = (0, _createSvgIcon$1.default)((0, _jsxRuntime$1.jsx)("path", {
  d: "M6.23 20.23 8 22l10-10L8 2 6.23 3.77 14.46 12z"
}), "ArrowForwardIosSharp");

function getCollapseUtilityClass(e) {
  return generateUtilityClass("MuiCollapse", e);
}

default_1$1 = ArrowForwardIosSharp.default = _default$1, generateUtilityClasses("MuiCollapse", ["root", "horizontal", "vertical", "entered", "hidden", "wrapper", "wrapperInner"]);

var _excluded$8 = ["addEndListener", "children", "className", "collapsedSize", "component", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "orientation", "style", "timeout", "TransitionComponent"],
    useUtilityClasses$5 = function useUtilityClasses$5(e) {
  var t = e.orientation,
      r = e.classes;
  return composeClasses({
    root: ["root", "".concat(t)],
    entered: ["entered"],
    hidden: ["hidden"],
    wrapper: ["wrapper", "".concat(t)],
    wrapperInner: ["wrapperInner", "".concat(t)]
  }, getCollapseUtilityClass, r);
},
    CollapseRoot = styled("div", {
  name: "MuiCollapse",
  slot: "Root",
  overridesResolver: function overridesResolver(e, t) {
    var r = e.ownerState;
    return [t.root, t[r.orientation], "entered" === r.state && t.entered, "exited" === r.state && !r.in && "0px" === r.collapsedSize && t.hidden];
  }
})(function (_ref87) {
  var e = _ref87.theme,
      t = _ref87.ownerState;
  return _extends$e({
    height: 0,
    overflow: "hidden",
    transition: e.transitions.create("height")
  }, "horizontal" === t.orientation && {
    height: "auto",
    width: 0,
    transition: e.transitions.create("width")
  }, "entered" === t.state && _extends$e({
    height: "auto",
    overflow: "visible"
  }, "horizontal" === t.orientation && {
    width: "auto"
  }), "exited" === t.state && !t.in && "0px" === t.collapsedSize && {
    visibility: "hidden"
  });
}),
    CollapseWrapper = styled("div", {
  name: "MuiCollapse",
  slot: "Wrapper",
  overridesResolver: function overridesResolver(e, t) {
    return t.wrapper;
  }
})(function (_ref88) {
  var e = _ref88.ownerState;
  return _extends$e({
    display: "flex",
    width: "100%"
  }, "horizontal" === e.orientation && {
    width: "auto",
    height: "100%"
  });
}),
    CollapseWrapperInner = styled("div", {
  name: "MuiCollapse",
  slot: "WrapperInner",
  overridesResolver: function overridesResolver(e, t) {
    return t.wrapperInner;
  }
})(function (_ref89) {
  var e = _ref89.ownerState;
  return _extends$e({
    width: "100%"
  }, "horizontal" === e.orientation && {
    width: "auto",
    height: "100%"
  });
}),
    Collapse = React.forwardRef(function (e, t) {
  var r = useThemeProps({
    props: e,
    name: "MuiCollapse"
  }),
      n = r.addEndListener,
      a = r.children,
      o = r.className,
      _r$collapsedSize = r.collapsedSize,
      i = _r$collapsedSize === void 0 ? "0px" : _r$collapsedSize,
      s = r.component,
      l = r.easing,
      c = r.in,
      u = r.onEnter,
      d = r.onEntered,
      p = r.onEntering,
      g = r.onExit,
      m = r.onExited,
      f = r.onExiting,
      _r$orientation = r.orientation,
      h = _r$orientation === void 0 ? "vertical" : _r$orientation,
      b = r.style,
      _r$timeout = r.timeout,
      y = _r$timeout === void 0 ? duration.standard : _r$timeout,
      _r$TransitionComponen = r.TransitionComponent,
      v = _r$TransitionComponen === void 0 ? Transition$1 : _r$TransitionComponen,
      _ = _objectWithoutPropertiesLoose$4(r, _excluded$8),
      T = _extends$e({}, r, {
    orientation: h,
    collapsedSize: i
  }),
      E = useUtilityClasses$5(T),
      S = useTheme(),
      x = React.useRef(),
      w = React.useRef(null),
      C = React.useRef(),
      k = "number" == typeof i ? "".concat(i, "px") : i,
      $ = "horizontal" === h,
      R = $ ? "width" : "height";

  React.useEffect(function () {
    return function () {
      clearTimeout(x.current);
    };
  }, []);

  var A = React.useRef(null),
      I = useForkRef(t, A),
      N = function N(e) {
    return function (t) {
      if (e) {
        var _r31 = A.current;
        void 0 === t ? e(_r31) : e(_r31, t);
      }
    };
  },
      P = function P() {
    return w.current ? w.current[$ ? "clientWidth" : "clientHeight"] : 0;
  },
      O = N(function (e, t) {
    w.current && $ && (w.current.style.position = "absolute"), e.style[R] = k, u && u(e, t);
  }),
      D = N(function (e, t) {
    var r = P();
    w.current && $ && (w.current.style.position = "");

    var _getTransitionProps = getTransitionProps({
      style: b,
      timeout: y,
      easing: l
    }, {
      mode: "enter"
    }),
        n = _getTransitionProps.duration,
        a = _getTransitionProps.easing;

    if ("auto" === y) {
      var _t46 = S.transitions.getAutoHeightDuration(r);

      e.style.transitionDuration = "".concat(_t46, "ms"), C.current = _t46;
    } else e.style.transitionDuration = "string" == typeof n ? n : "".concat(n, "ms");

    e.style[R] = "".concat(r, "px"), e.style.transitionTimingFunction = a, p && p(e, t);
  }),
      L = N(function (e, t) {
    e.style[R] = "auto", d && d(e, t);
  }),
      M = N(function (e) {
    e.style[R] = "".concat(P(), "px"), g && g(e);
  }),
      F = N(m),
      j = N(function (e) {
    var t = P(),
        _getTransitionProps2 = getTransitionProps({
      style: b,
      timeout: y,
      easing: l
    }, {
      mode: "exit"
    }),
        r = _getTransitionProps2.duration,
        n = _getTransitionProps2.easing;

    if ("auto" === y) {
      var _r32 = S.transitions.getAutoHeightDuration(t);

      e.style.transitionDuration = "".concat(_r32, "ms"), C.current = _r32;
    } else e.style.transitionDuration = "string" == typeof r ? r : "".concat(r, "ms");

    e.style[R] = k, e.style.transitionTimingFunction = n, f && f(e);
  });

  return jsx$1(v, _extends$e({
    in: c,
    onEnter: O,
    onEntered: L,
    onEntering: D,
    onExit: M,
    onExited: F,
    onExiting: j,
    addEndListener: function addEndListener(e) {
      "auto" === y && (x.current = setTimeout(e, C.current || 0)), n && n(A.current, e);
    },
    nodeRef: A,
    timeout: "auto" === y ? null : y
  }, _, {
    children: function children(e, t) {
      return jsx$1(CollapseRoot, _extends$e({
        as: s,
        className: clsx(E.root, o, {
          entered: E.entered,
          exited: !c && "0px" === k && E.hidden
        }[e]),
        style: _extends$e(_defineProperty2({}, $ ? "minWidth" : "minHeight", k), b),
        ownerState: _extends$e({}, T, {
          state: e
        }),
        ref: I
      }, t, {
        children: jsx$1(CollapseWrapper, {
          ownerState: _extends$e({}, T, {
            state: e
          }),
          className: E.wrapper,
          ref: w,
          children: jsx$1(CollapseWrapperInner, {
            ownerState: _extends$e({}, T, {
              state: e
            }),
            className: E.wrapperInner,
            children: a
          })
        })
      }));
    }
  }));
});

function getPaperUtilityClass(e) {
  return generateUtilityClass("MuiPaper", e);
}

"production" !== process.env.NODE_ENV && (Collapse.propTypes = {
  addEndListener: PropTypes.func,
  children: PropTypes.node,
  classes: PropTypes.object,
  className: PropTypes.string,
  collapsedSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  component: elementTypeAcceptingRef$1,
  easing: PropTypes.oneOfType([PropTypes.shape({
    enter: PropTypes.string,
    exit: PropTypes.string
  }), PropTypes.string]),
  in: PropTypes.bool,
  onEnter: PropTypes.func,
  onEntered: PropTypes.func,
  onEntering: PropTypes.func,
  onExit: PropTypes.func,
  onExited: PropTypes.func,
  onExiting: PropTypes.func,
  orientation: PropTypes.oneOf(["horizontal", "vertical"]),
  style: PropTypes.object,
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  timeout: PropTypes.oneOfType([PropTypes.oneOf(["auto"]), PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })])
}), Collapse.muiSupportAuto = !0, generateUtilityClasses("MuiPaper", ["root", "rounded", "outlined", "elevation", "elevation0", "elevation1", "elevation2", "elevation3", "elevation4", "elevation5", "elevation6", "elevation7", "elevation8", "elevation9", "elevation10", "elevation11", "elevation12", "elevation13", "elevation14", "elevation15", "elevation16", "elevation17", "elevation18", "elevation19", "elevation20", "elevation21", "elevation22", "elevation23", "elevation24"]);

var _excluded$7 = ["className", "component", "elevation", "square", "variant"],
    getOverlayAlpha = function getOverlayAlpha(e) {
  var t;
  return t = e < 1 ? 5.11916 * Math.pow(e, 2) : 4.5 * Math.log(e + 1) + 2, (t / 100).toFixed(2);
},
    useUtilityClasses$4 = function useUtilityClasses$4(e) {
  var t = e.square,
      r = e.elevation,
      n = e.variant,
      a = e.classes;
  return composeClasses({
    root: ["root", n, !t && "rounded", "elevation" === n && "elevation".concat(r)]
  }, getPaperUtilityClass, a);
},
    PaperRoot = styled("div", {
  name: "MuiPaper",
  slot: "Root",
  overridesResolver: function overridesResolver(e, t) {
    var r = e.ownerState;
    return [t.root, t[r.variant], !r.square && t.rounded, "elevation" === r.variant && t["elevation".concat(r.elevation)]];
  }
})(function (_ref90) {
  var e = _ref90.theme,
      t = _ref90.ownerState;
  return _extends$e({
    backgroundColor: e.palette.background.paper,
    color: e.palette.text.primary,
    transition: e.transitions.create("box-shadow")
  }, !t.square && {
    borderRadius: e.shape.borderRadius
  }, "outlined" === t.variant && {
    border: "1px solid ".concat(e.palette.divider)
  }, "elevation" === t.variant && _extends$e({
    boxShadow: e.shadows[t.elevation]
  }, "dark" === e.palette.mode && {
    backgroundImage: "linear-gradient(".concat(alpha("#fff", getOverlayAlpha(t.elevation)), ", ").concat(alpha("#fff", getOverlayAlpha(t.elevation)), ")")
  }));
}),
    Paper = React.forwardRef(function (e, t) {
  var r = useThemeProps({
    props: e,
    name: "MuiPaper"
  }),
      n = r.className,
      _r$component5 = r.component,
      a = _r$component5 === void 0 ? "div" : _r$component5,
      _r$elevation = r.elevation,
      o = _r$elevation === void 0 ? 1 : _r$elevation,
      _r$square = r.square,
      i = _r$square === void 0 ? !1 : _r$square,
      _r$variant2 = r.variant,
      s = _r$variant2 === void 0 ? "elevation" : _r$variant2,
      l = _objectWithoutPropertiesLoose$4(r, _excluded$7),
      c = _extends$e({}, r, {
    component: a,
    elevation: o,
    square: i,
    variant: s
  }),
      u = useUtilityClasses$4(c);

  if ("production" !== process.env.NODE_ENV) {
    void 0 === useTheme().shadows[o] && console.error(["MUI: The elevation provided <Paper elevation={".concat(o, "}> is not available in the theme."), "Please make sure that `theme.shadows[".concat(o, "]` is defined.")].join("\n"));
  }

  return jsx$1(PaperRoot, _extends$e({
    as: a,
    ownerState: c,
    className: clsx(u.root, n),
    ref: t
  }, l));
});

"production" !== process.env.NODE_ENV && (Paper.propTypes = {
  children: PropTypes.node,
  classes: PropTypes.object,
  className: PropTypes.string,
  component: PropTypes.elementType,
  elevation: chainPropTypes(integerPropType, function (e) {
    var t = e.elevation,
        r = e.variant;
    return t > 0 && "outlined" === r ? new Error("MUI: Combining `elevation={".concat(t, "}` with `variant=\"").concat(r, "\"` has no effect. Either use `elevation={0}` or use a different `variant`.")) : null;
  }),
  square: PropTypes.bool,
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  variant: PropTypes.oneOfType([PropTypes.oneOf(["elevation", "outlined"]), PropTypes.string])
});
var AccordionContext = React.createContext({});

function getAccordionUtilityClass(e) {
  return generateUtilityClass("MuiAccordion", e);
}

"production" !== process.env.NODE_ENV && (AccordionContext.displayName = "AccordionContext");

var accordionClasses = generateUtilityClasses("MuiAccordion", ["root", "rounded", "expanded", "disabled", "gutters", "region"]),
    _excluded$6 = ["children", "className", "defaultExpanded", "disabled", "disableGutters", "expanded", "onChange", "square", "TransitionComponent", "TransitionProps"],
    useUtilityClasses$3 = function useUtilityClasses$3(e) {
  var t = e.classes,
      r = e.square,
      n = e.expanded,
      a = e.disabled,
      o = e.disableGutters;
  return composeClasses({
    root: ["root", !r && "rounded", n && "expanded", a && "disabled", !o && "gutters"],
    region: ["region"]
  }, getAccordionUtilityClass, t);
},
    AccordionRoot = styled(Paper, {
  name: "MuiAccordion",
  slot: "Root",
  overridesResolver: function overridesResolver(e, t) {
    var r = e.ownerState;
    return [_defineProperty2({}, "& .".concat(accordionClasses.region), t.region), t.root, !r.square && t.rounded, !r.disableGutters && t.gutters];
  }
})(function (_ref92) {
  var _ref93;

  var e = _ref92.theme;
  var t = {
    duration: e.transitions.duration.shortest
  };
  return _ref93 = {
    position: "relative",
    transition: e.transitions.create(["margin"], t),
    overflowAnchor: "none",
    "&:before": {
      position: "absolute",
      left: 0,
      top: -1,
      right: 0,
      height: 1,
      content: '""',
      opacity: 1,
      backgroundColor: e.palette.divider,
      transition: e.transitions.create(["opacity", "background-color"], t)
    },
    "&:first-of-type": {
      "&:before": {
        display: "none"
      }
    }
  }, _defineProperty2(_ref93, "&.".concat(accordionClasses.expanded), {
    "&:before": {
      opacity: 0
    },
    "&:first-of-type": {
      marginTop: 0
    },
    "&:last-of-type": {
      marginBottom: 0
    },
    "& + &": {
      "&:before": {
        display: "none"
      }
    }
  }), _defineProperty2(_ref93, "&.".concat(accordionClasses.disabled), {
    backgroundColor: e.palette.action.disabledBackground
  }), _ref93;
}, function (_ref94) {
  var e = _ref94.theme,
      t = _ref94.ownerState;
  return _extends$e({}, !t.square && {
    borderRadius: 0,
    "&:first-of-type": {
      borderTopLeftRadius: e.shape.borderRadius,
      borderTopRightRadius: e.shape.borderRadius
    },
    "&:last-of-type": {
      borderBottomLeftRadius: e.shape.borderRadius,
      borderBottomRightRadius: e.shape.borderRadius,
      "@supports (-ms-ime-align: auto)": {
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0
      }
    }
  }, !t.disableGutters && _defineProperty2({}, "&.".concat(accordionClasses.expanded), {
    margin: "16px 0"
  }));
}),
    Accordion$2 = React.forwardRef(function (e, t) {
  var r = useThemeProps({
    props: e,
    name: "MuiAccordion"
  }),
      n = r.children,
      a = r.className,
      _r$defaultExpanded = r.defaultExpanded,
      o = _r$defaultExpanded === void 0 ? !1 : _r$defaultExpanded,
      _r$disabled4 = r.disabled,
      i = _r$disabled4 === void 0 ? !1 : _r$disabled4,
      _r$disableGutters = r.disableGutters,
      s = _r$disableGutters === void 0 ? !1 : _r$disableGutters,
      l = r.expanded,
      c = r.onChange,
      _r$square2 = r.square,
      u = _r$square2 === void 0 ? !1 : _r$square2,
      _r$TransitionComponen2 = r.TransitionComponent,
      d = _r$TransitionComponen2 === void 0 ? Collapse : _r$TransitionComponen2,
      p = r.TransitionProps,
      g = _objectWithoutPropertiesLoose$4(r, _excluded$6),
      _useControlled3 = useControlled({
    controlled: l,
    default: o,
    name: "Accordion",
    state: "expanded"
  }),
      _useControlled4 = _slicedToArray(_useControlled3, 2),
      m = _useControlled4[0],
      f = _useControlled4[1],
      h = React.useCallback(function (e) {
    f(!m), c && c(e, !m);
  }, [m, c, f]),
      _React$Children$toArr = React.Children.toArray(n),
      _React$Children$toArr2 = _toArray(_React$Children$toArr),
      b = _React$Children$toArr2[0],
      y = _React$Children$toArr2.slice(1),
      v = React.useMemo(function () {
    return {
      expanded: m,
      disabled: i,
      disableGutters: s,
      toggle: h
    };
  }, [m, i, s, h]),
      _ = _extends$e({}, r, {
    square: u,
    disabled: i,
    disableGutters: s,
    expanded: m
  }),
      T = useUtilityClasses$3(_);

  return jsxs(AccordionRoot, _extends$e({
    className: clsx(T.root, a),
    ref: t,
    ownerState: _,
    square: u
  }, g, {
    children: [jsx$1(AccordionContext.Provider, {
      value: v,
      children: b
    }), jsx$1(d, _extends$e({
      in: m,
      timeout: "auto"
    }, p, {
      children: jsx$1("div", {
        "aria-labelledby": b.props.id,
        id: b.props["aria-controls"],
        role: "region",
        className: T.region,
        children: y
      })
    }))]
  }));
});

"production" !== process.env.NODE_ENV && (Accordion$2.propTypes = {
  children: chainPropTypes(PropTypes.node.isRequired, function (e) {
    var t = React.Children.toArray(e.children)[0];
    return reactIs$1.exports.isFragment(t) ? new Error("MUI: The Accordion doesn't accept a Fragment as a child. Consider providing an array instead.") : React.isValidElement(t) ? null : new Error("MUI: Expected the first child of Accordion to be a valid element.");
  }),
  classes: PropTypes.object,
  className: PropTypes.string,
  defaultExpanded: PropTypes.bool,
  disabled: PropTypes.bool,
  disableGutters: PropTypes.bool,
  expanded: PropTypes.bool,
  onChange: PropTypes.func,
  square: PropTypes.bool,
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  TransitionComponent: PropTypes.elementType,
  TransitionProps: PropTypes.object
});
var MuiAccordion = Accordion$2;

function getAccordionSummaryUtilityClass(e) {
  return generateUtilityClass("MuiAccordionSummary", e);
}

var accordionSummaryClasses = generateUtilityClasses("MuiAccordionSummary", ["root", "expanded", "focusVisible", "disabled", "gutters", "contentGutters", "content", "expandIconWrapper"]),
    _excluded$5 = ["children", "className", "expandIcon", "focusVisibleClassName", "onClick"],
    useUtilityClasses$2 = function useUtilityClasses$2(e) {
  var t = e.classes,
      r = e.expanded,
      n = e.disabled,
      a = e.disableGutters;
  return composeClasses({
    root: ["root", r && "expanded", n && "disabled", !a && "gutters"],
    focusVisible: ["focusVisible"],
    content: ["content", r && "expanded", !a && "contentGutters"],
    expandIconWrapper: ["expandIconWrapper", r && "expanded"]
  }, getAccordionSummaryUtilityClass, t);
},
    AccordionSummaryRoot = styled(ButtonBase, {
  name: "MuiAccordionSummary",
  slot: "Root",
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})(function (_ref96) {
  var _extends$e4;

  var e = _ref96.theme,
      t = _ref96.ownerState;
  var r = {
    duration: e.transitions.duration.shortest
  };
  return _extends$e((_extends$e4 = {
    display: "flex",
    minHeight: 48,
    padding: e.spacing(0, 2),
    transition: e.transitions.create(["min-height", "background-color"], r)
  }, _defineProperty2(_extends$e4, "&.".concat(accordionSummaryClasses.focusVisible), {
    backgroundColor: e.palette.action.focus
  }), _defineProperty2(_extends$e4, "&.".concat(accordionSummaryClasses.disabled), {
    opacity: e.palette.action.disabledOpacity
  }), _defineProperty2(_extends$e4, "&:hover:not(.".concat(accordionSummaryClasses.disabled, ")"), {
    cursor: "pointer"
  }), _extends$e4), !t.disableGutters && _defineProperty2({}, "&.".concat(accordionSummaryClasses.expanded), {
    minHeight: 64
  }));
}),
    AccordionSummaryContent = styled("div", {
  name: "MuiAccordionSummary",
  slot: "Content",
  overridesResolver: function overridesResolver(e, t) {
    return t.content;
  }
})(function (_ref98) {
  var e = _ref98.theme,
      t = _ref98.ownerState;
  return _extends$e({
    display: "flex",
    flexGrow: 1,
    margin: "12px 0"
  }, !t.disableGutters && _defineProperty2({
    transition: e.transitions.create(["margin"], {
      duration: e.transitions.duration.shortest
    })
  }, "&.".concat(accordionSummaryClasses.expanded), {
    margin: "20px 0"
  }));
}),
    AccordionSummaryExpandIconWrapper = styled("div", {
  name: "MuiAccordionSummary",
  slot: "ExpandIconWrapper",
  overridesResolver: function overridesResolver(e, t) {
    return t.expandIconWrapper;
  }
})(function (_ref100) {
  var e = _ref100.theme;
  return _defineProperty2({
    display: "flex",
    color: e.palette.action.active,
    transform: "rotate(0deg)",
    transition: e.transitions.create("transform", {
      duration: e.transitions.duration.shortest
    })
  }, "&.".concat(accordionSummaryClasses.expanded), {
    transform: "rotate(180deg)"
  });
}),
    AccordionSummary$1 = React.forwardRef(function (e, t) {
  var r = useThemeProps({
    props: e,
    name: "MuiAccordionSummary"
  }),
      n = r.children,
      a = r.className,
      o = r.expandIcon,
      i = r.focusVisibleClassName,
      s = r.onClick,
      l = _objectWithoutPropertiesLoose$4(r, _excluded$5),
      _React$useContext = React.useContext(AccordionContext),
      _React$useContext$dis = _React$useContext.disabled,
      c = _React$useContext$dis === void 0 ? !1 : _React$useContext$dis,
      u = _React$useContext.disableGutters,
      d = _React$useContext.expanded,
      p = _React$useContext.toggle,
      g = _extends$e({}, r, {
    expanded: d,
    disabled: c,
    disableGutters: u
  }),
      m = useUtilityClasses$2(g);

  return jsxs(AccordionSummaryRoot, _extends$e({
    focusRipple: !1,
    disableRipple: !0,
    disabled: c,
    component: "div",
    "aria-expanded": d,
    className: clsx(m.root, a),
    focusVisibleClassName: clsx(m.focusVisible, i),
    onClick: function onClick(e) {
      p && p(e), s && s(e);
    },
    ref: t,
    ownerState: g
  }, l, {
    children: [jsx$1(AccordionSummaryContent, {
      className: m.content,
      ownerState: g,
      children: n
    }), o && jsx$1(AccordionSummaryExpandIconWrapper, {
      className: m.expandIconWrapper,
      ownerState: g,
      children: o
    })]
  }));
});

"production" !== process.env.NODE_ENV && (AccordionSummary$1.propTypes = {
  children: PropTypes.node,
  classes: PropTypes.object,
  className: PropTypes.string,
  expandIcon: PropTypes.node,
  focusVisibleClassName: PropTypes.string,
  onClick: PropTypes.func,
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});
var MuiAccordionSummary = AccordionSummary$1;

function getAccordionDetailsUtilityClass(e) {
  return generateUtilityClass("MuiAccordionDetails", e);
}

generateUtilityClasses("MuiAccordionDetails", ["root"]);

var _excluded$4 = ["className"],
    useUtilityClasses$1 = function useUtilityClasses$1(e) {
  var t = e.classes;
  return composeClasses({
    root: ["root"]
  }, getAccordionDetailsUtilityClass, t);
},
    AccordionDetailsRoot = styled("div", {
  name: "MuiAccordionDetails",
  slot: "Root",
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})(function (_ref102) {
  var e = _ref102.theme;
  return {
    padding: e.spacing(1, 2, 2)
  };
}),
    AccordionDetails$1 = React.forwardRef(function (e, t) {
  var r = useThemeProps({
    props: e,
    name: "MuiAccordionDetails"
  }),
      n = r.className,
      a = _objectWithoutPropertiesLoose$4(r, _excluded$4),
      o = r,
      i = useUtilityClasses$1(o);

  return jsx$1(AccordionDetailsRoot, _extends$e({
    className: clsx(i.root, n),
    ref: t,
    ownerState: o
  }, a));
});

"production" !== process.env.NODE_ENV && (AccordionDetails$1.propTypes = {
  children: PropTypes.node,
  classes: PropTypes.object,
  className: PropTypes.string,
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});

var MuiAccordionDetails = AccordionDetails$1,
    AccordianGroup = function AccordianGroup(e) {
  var t = e.data,
      r = t.title,
      n = t.items,
      a = useTheme$4(),
      o = React__default.useState(0),
      i = o[0],
      s = o[1],
      l = function l(e) {
    return function (t, r) {
      s(e), s(!!r && e);
    };
  };

  return jsx$1(Root$s, _assign$({
    sx: t.styles
  }, {
    children: jsxs(Container, _assign$({
      sx: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center"
      }
    }, {
      children: [void 0 !== r && jsx$1(Box, _assign$({
        sx: {
          textAlign: "center",
          padding: a.spacing(3, 0),
          paddingTop: 0
        }
      }, {
        children: jsx$1(Title$3, _assign$({
          rich: !0,
          className: accordianGroupClasses.title
        }, {
          children: r
        }))
      })), jsx$1(ContentBox$3, _assign$({
        className: accordianGroupClasses.items
      }, {
        children: (null == n ? void 0 : n.length) > 0 && (null == n ? void 0 : n.map(function (e, t) {
          return jsxs(React__default.Fragment, {
            children: [jsxs(Accordion$1, _assign$({
              expanded: i === t,
              onChange: l(t)
            }, {
              children: [jsx$1(AccordionSummary, _assign$({
                "aria-controls": "panel1d-content",
                id: "panel1d-header"
              }, {
                children: jsx$1(Text, _assign$({
                  fontWeight: a.typography.fontWeightMedium,
                  color: i === t ? a.palette.primary.main : a.palette.common.black,
                  fontSize: "1.25rem",
                  className: accordianGroupItemClasses.title
                }, {
                  children: e.heading
                }))
              })), jsx$1(Divider, {
                variant: "middle",
                sx: {
                  marginX: a.spacing(3),
                  backgroundColor: a.palette.divider
                }
              }), jsx$1(AccordionDetails, {
                children: jsx$1(Text, _assign$({
                  variant: "heading",
                  fontWeight: a.typography.fontWeightMedium,
                  className: accordianGroupItemClasses.description
                }, {
                  children: e.description
                }))
              })]
            })), t < n.length - 1 && t !== i && jsx$1(Divider, {
              className: "bottomDivider",
              variant: "middle",
              sx: {
                marginX: a.spacing(3),
                backgroundColor: a.palette.divider
              }
            })]
          }, t);
        }))
      }))]
    }))
  }));
},
    Root$s = styled$2(Box)(function (e) {
  var t,
      r = e.theme;
  return (t = {
    padding: r.spacing(10, 0, 5, 0)
  })[r.breakpoints.up("md")] = {
    padding: r.spacing(8, 0, 8, 0)
  }, t[".".concat(accordianGroupClasses.title, " h2")] = _assign$(_assign$({}, r.typography.h2), {
    fontWeight: r.typography.fontWeightSemiBold
  }), t;
}),
    Title$3 = styled$2(Text)(function (e) {
  var t = e.theme;
  return _assign$(_assign$({}, t.typography.h5), {
    fontWeight: 600
  });
}),
    ContentBox$3 = styled$2(Box)(function (e) {
  var t = e.theme;
  return {
    justifyContent: "center",
    marginTop: t.spacing(4),
    maxWidth: t.spacing(110)
  };
}),
    AccordionDetails = styled$2(MuiAccordionDetails)(function (e) {
  var t = e.theme;
  return {
    padding: t.spacing(2, 7),
    color: t.palette.text.secondary,
    fontFamily: t.typography.fontFamily,
    paddingLeft: t.spacing(14)
  };
}),
    AccordionSummary = styled$2(function (e) {
  return jsx$1(MuiAccordionSummary, _assign$({
    expandIcon: jsx$1(default_1$1, {
      sx: {
        fontSize: "1.3rem"
      }
    })
  }, e));
})(function (e) {
  var t = e.theme;
  return {
    padding: t.spacing(1.25, 5),
    fontFamily: t.typography.fontFamily,
    flexDirection: "row-reverse",
    "& .MuiAccordionSummary-expandIconWrapper": {
      marginTop: t.spacing(2),
      alignSelf: "flex-Start"
    },
    "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
      transform: "rotate(90deg)"
    },
    "& .MuiAccordionSummary-content": {
      marginLeft: t.spacing(1.5)
    }
  };
}),
    Accordion$1 = styled$2(function (e) {
  return jsx$1(MuiAccordion, _assign$({
    disableGutters: !0,
    elevation: 0,
    square: !0
  }, e));
})(function (e) {
  var t = e.theme;
  return {
    borderTop: 0,
    borderBottom: 0,
    borderLeft: "2px solid ".concat(t.palette.divider),
    borderRight: "2px solid ".concat(t.palette.divider),
    "&:first-child": {
      borderTopLeftRadius: t.spacing(2),
      borderTopRightRadius: t.spacing(2),
      borderTop: "2px solid ".concat(t.palette.divider)
    },
    "&:last-child": {
      borderBottomLeftRadius: t.spacing(2),
      borderBottomRightRadius: t.spacing(2),
      borderBottom: "2px solid ".concat(t.palette.divider)
    },
    "&:before": {
      display: "none"
    },
    "& .MuiSvgIcon-root": {
      color: t.palette.primary.main
    }
  };
}),
    Article = function Article(e) {
  var t = e.data,
      r = useTheme$4();
  return jsx$1(Root$r, _assign$({
    sx: t.styles
  }, {
    children: jsxs(Container, _assign$({
      sx: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center"
      }
    }, {
      children: [jsx$1(Box, _assign$({
        sx: {
          textAlign: "center",
          padding: r.spacing(3, 0),
          paddingTop: 0
        },
        className: articleClasses.title
      }, {
        children: jsx$1(Title$2, _assign$({
          rich: !0
        }, {
          children: t.title
        }))
      })), jsx$1(Box, _assign$({
        sx: {
          textAlign: "left",
          padding: r.spacing(3, 0),
          paddingTop: 0
        },
        className: articleClasses.description
      }, {
        children: jsx$1(Text, _assign$({
          rich: !0
        }, {
          children: t.description
        }))
      })), jsx$1(ContentBox$2, _assign$({
        className: "".concat(articleClasses.content, "Root")
      }, {
        children: jsx$1(Stack$2, _assign$({
          direction: "column",
          columnGap: 1
        }, {
          children: t.content.map(function (e, t) {
            return jsxs(Stack$2, _assign$({
              direction: "row",
              columnGap: 1,
              mb: 4
            }, {
              children: [null != e.media && jsx$1(Box, _assign$({
                className: articleClasses.media
              }, {
                children: jsx$1(Media, {
                  media: e.media
                })
              })), jsx$1(Box, _assign$({
                className: articleClasses.content
              }, {
                children: jsx$1(Text, _assign$({
                  rich: !0
                }, {
                  children: e.item
                }))
              }))]
            }), t);
          })
        }))
      }))]
    }))
  }));
},
    Root$r = styled$2(Box)(function (e) {
  var t,
      r,
      n,
      a = e.theme;
  return (t = {
    padding: a.spacing(10, 0, 5, 0)
  })[a.breakpoints.up("md")] = {
    padding: a.spacing(8, 0, 8, 0)
  }, t[".".concat(articleClasses.title, " h1")] = _assign$(_assign$({}, a.typography.h4), ((r = {})[a.breakpoints.up("md")] = _assign$({}, a.typography.h3), r)), t[".".concat(articleClasses.content, " h1")] = _assign$(_assign$({}, a.typography.h4), ((n = {})[a.breakpoints.up("md")] = _assign$({}, a.typography.h3), n)), t[".".concat(articleClasses.content, " h2")] = _assign$({}, a.typography.h6), t;
}),
    Title$2 = styled$2(Text)(function (e) {
  var t = e.theme;
  return _assign$({}, t.typography.h3);
}),
    ContentBox$2 = styled$2(Box)(function (e) {
  return e.theme, {
    display: "flex",
    justifyContent: "center"
  };
}),
    ArticleColumnsGroup = function ArticleColumnsGroup(e) {
  var t = e.data,
      r = useTheme$4(),
      n = useMediaQuery(r.breakpoints.up("md"));
  return jsx$1(Root$q, _assign$({
    sx: t.styles
  }, {
    children: jsxs(Container, _assign$({
      sx: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center"
      }
    }, {
      children: [jsx$1(Box, _assign$({
        sx: {
          textAlign: "center",
          padding: r.spacing(3, 0),
          paddingTop: 0
        },
        className: articleColumnsGroupClasses.title
      }, {
        children: jsx$1(Title$1, _assign$({
          rich: !0
        }, {
          children: t.title
        }))
      })), jsx$1(Box, _assign$({
        sx: {
          textAlign: "left",
          padding: r.spacing(3, 0),
          paddingTop: 0
        },
        className: articleColumnsGroupClasses.description
      }, {
        children: jsx$1(Text, _assign$({
          rich: !0
        }, {
          children: t.description
        }))
      })), jsx$1(ContentBox$1, _assign$({
        className: "".concat(articleColumnsGroupClasses.columns, "Root")
      }, {
        children: jsx$1(Stack$2, _assign$({
          alignItems: "flex-start",
          justifyContent: "center",
          flexDirection: n ? "row" : "column",
          pb: 4.5
        }, {
          children: t.columns.map(function (e, t) {
            return jsx$1(Box, _assign$({
              className: "".concat(articleColumnsGroupClasses.column, "-").concat(t)
            }, {
              children: jsx$1(Article, {
                data: e
              })
            }), t);
          })
        }))
      }))]
    }))
  }));
},
    Root$q = styled$2(Box)(function (e) {
  var t,
      r,
      n = e.theme;
  return (t = {
    padding: n.spacing(10, 0, 5, 0)
  })[n.breakpoints.up("md")] = {
    padding: n.spacing(8, 0, 8, 0)
  }, t[".".concat(articleColumnsGroupClasses.title, " h1")] = _assign$(_assign$({}, n.typography.h4), ((r = {})[n.breakpoints.up("md")] = _assign$({}, n.typography.h3), r)), t;
}),
    Title$1 = styled$2(Text)(function (e) {
  var t = e.theme;
  return _assign$({}, t.typography.h3);
}),
    ContentBox$1 = styled$2(Box)(function (e) {
  return e.theme, {
    display: "flex",
    justifyContent: "center"
  };
});

function BiCheckCircle(e) {
  return GenIcon({
    tag: "svg",
    attr: {
      viewBox: "0 0 24 24"
    },
    child: [{
      tag: "path",
      attr: {
        d: "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
      }
    }, {
      tag: "path",
      attr: {
        d: "M9.999 13.587 7.7 11.292l-1.412 1.416 3.713 3.705 6.706-6.706-1.414-1.414z"
      }
    }]
  })(e);
}

function BiDollarCircle(e) {
  return GenIcon({
    tag: "svg",
    attr: {
      viewBox: "0 0 24 24"
    },
    child: [{
      tag: "path",
      attr: {
        d: "M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8z"
      }
    }, {
      tag: "path",
      attr: {
        d: "M12 11c-2 0-2-.63-2-1s.7-1 2-1 1.39.64 1.4 1h2A3 3 0 0 0 13 7.12V6h-2v1.09C9 7.42 8 8.71 8 10c0 1.12.52 3 4 3 2 0 2 .68 2 1s-.62 1-2 1c-1.84 0-2-.86-2-1H8c0 .92.66 2.55 3 2.92V18h2v-1.08c2-.34 3-1.63 3-2.92 0-1.12-.52-3-4-3z"
      }
    }]
  })(e);
}

function BiTime(e) {
  return GenIcon({
    tag: "svg",
    attr: {
      viewBox: "0 0 24 24"
    },
    child: [{
      tag: "path",
      attr: {
        d: "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
      }
    }, {
      tag: "path",
      attr: {
        d: "M13 7h-2v6h6v-2h-4z"
      }
    }]
  })(e);
}

var EmailConfirmation = function EmailConfirmation(e) {
  var t = e.senderAvatarColor,
      r = e.senderAvatarIcon,
      n = e.senderName,
      a = e.receiverName,
      o = e.title,
      i = e.body;
  e.actionNames;
  var s = useTheme$4();
  return jsxs(Fragment, {
    children: [jsx$1(EmailHeader, _assign$({
      dense: !0
    }, {
      children: jsxs(ListItem, _assign$({
        secondaryAction: jsx$1(Text, _assign$({
          component: "span"
        }, {
          children: format$1(new Date(), "h:mma")
        })),
        sx: {
          paddingX: 0
        }
      }, {
        children: [jsx$1(ListItemAvatar, {
          children: jsx$1(BusinessIconAvatar$2, _assign$({
            sx: {
              backgroundColor: hexToRgba(t, "0.2")
            },
            alt: n,
            color: t
          }, {
            children: jsx$1(CmsImage, {
              media: r,
              height: 20,
              width: 20
            })
          }))
        }), jsx$1(ListItemText, {
          primary: n,
          secondary: "To: ".concat(a)
        })]
      }))
    })), jsx$1(Divider, {
      variant: "middle",
      sx: {
        marginX: s.spacing(1)
      }
    }), jsxs(EmailBody$2, {
      children: [jsx$1(EmailBodyContent, {
        children: jsx$1(Text, _assign$({
          variant: "subtitle3"
        }, {
          children: o
        }))
      }), i]
    })]
  });
},
    BusinessIconAvatar$2 = styled$2(Avatar)(function (e) {
  var t = e.theme;
  return {
    "& svg": {
      fill: e.color,
      height: 20,
      position: "relative",
      top: t.spacing(.25)
    }
  };
}),
    EmailHeader = styled$2(List)(function (e) {
  var t = e.theme;
  return {
    "& .MuiListItem-root": {
      padding: t.spacing(0, 1)
    },
    "& .MuiListItemAvatar-root": {
      minWidth: 32
    },
    "& .MuiAvatar-root": {
      width: 24,
      height: 24
    },
    "& .MuiListItemText-root": {
      margin: 0
    },
    "& .MuiListItemText-primary": {
      fontSize: t.typography.caption3.fontSize
    },
    "& .MuiListItemText-secondary": {
      fontSize: t.typography.caption3.fontSize
    },
    "& .MuiListItemSecondaryAction-root": {
      right: t.spacing(1),
      top: "15%"
    },
    "& .MuiListItemSecondaryAction-root .MuiTypography-root": {
      fontSize: t.typography.pxToRem(7)
    }
  };
}),
    EmailBody$2 = styled$2(Box)(function (e) {
  return e.theme, {};
}),
    EmailBodyContent = styled$2(Box)(function (e) {
  return {
    padding: e.theme.spacing(1)
  };
}),
    BookingEmailConfirmation = function BookingEmailConfirmation(e) {
  var t = e.data,
      r = useTheme$4(),
      n = null === (null == t ? void 0 : t.senderAvatarColor) || "" === (null == t ? void 0 : t.senderAvatarColor) ? r.palette.primary.main : "#".concat(null == t ? void 0 : t.senderAvatarColor);
  return jsx$1(EmailConfirmation, {
    senderAvatarColor: n,
    senderAvatarIcon: null == t ? void 0 : t.senderAvatarIcon,
    senderName: null == t ? void 0 : t.senderName,
    receiverName: null == t ? void 0 : t.receiverName,
    title: null == t ? void 0 : t.emailTitle,
    body: jsxs(EmailBody$1, {
      children: [jsxs(EmailBodyContent, {
        children: [jsx$1(Box, {
          children: jsx$1(BiCheckCircle, {
            color: r.palette.primary.main,
            size: 22
          })
        }), jsx$1(Text, _assign$({
          variant: "caption",
          color: "primary",
          sx: {
            whiteSpace: "nowrap"
          }
        }, {
          children: format$1(null == t ? void 0 : t.bookingDateTime, "EEE, d LLLL h:mma")
        }))]
      }), jsx$1(Divider, {
        variant: "middle",
        sx: {
          marginX: r.spacing(1)
        }
      }), jsxs(EmailBodyContent, {
        children: [jsx$1(Text, _assign$({
          variant: "caption",
          fontWeight: r.typography.fontWeightSemiBold
        }, {
          children: null == t ? void 0 : t.serviceName
        })), jsxs(List, _assign$({
          dense: !0
        }, {
          children: [jsxs(ListItem, {
            children: [jsx$1(ListItemIcon, {
              children: jsx$1(BiTime, {
                size: 11
              })
            }), jsx$1(ListItemText, {
              primary: "".concat(null == t ? void 0 : t.serviceDurationInMinutes, " min")
            })]
          }), jsxs(ListItem, {
            children: [jsx$1(ListItemIcon, {
              children: jsx$1(BiDollarCircle, {
                size: 11
              })
            }), jsx$1(ListItemText, {
              primary: "$".concat(null == t ? void 0 : t.serviceHourlyPricing, "/hr")
            })]
          })]
        })), jsx$1(Text, _assign$({
          variant: "caption2",
          color: "textSecondary",
          component: "div"
        }, {
          children: null == t ? void 0 : t.serviceDescription
        }))]
      })]
    })
  });
},
    EmailBody$1 = styled$2(Box)(function (e) {
  var t = e.theme;
  return {
    textAlign: "center",
    "& .MuiList-root": {
      display: "flex",
      justifyContent: "center",
      margin: t.spacing(0, -1)
    },
    "& .MuiListItem-root": {
      margin: t.spacing(0, 1),
      padding: 0,
      width: "auto",
      whiteSpace: "pre"
    },
    "& .MuiListItemIcon-root": {
      color: t.palette.primary.main,
      minWidth: 15.5
    },
    "& .MuiListItemText-primary": {
      fontSize: t.typography.caption2.fontSize
    }
  };
}),
    BookingServiceDetails = function BookingServiceDetails(e) {
  var t = e.data,
      r = __rest$1(e, ["data"]),
      n = useTheme$4(),
      a = useMediaQuery(n.breakpoints.up("sm")),
      o = {
    color: null === (null == t ? void 0 : t.businessIconColor) || "" === (null == t ? void 0 : t.businessIconColor) ? n.palette.primary.main : "#".concat(null == t ? void 0 : t.businessIconColor),
    size: a ? 14 : 20
  };

  return jsxs(Box, _assign$({}, r, {
    children: [jsx$1(BusinessDetails, _assign$({
      dense: !0
    }, {
      children: jsxs(ListItem, _assign$({
        sx: {
          paddingX: 0
        }
      }, {
        children: [jsx$1(ListItemAvatar, {
          children: jsx$1(BusinessIconAvatar$1, _assign$({
            sx: {
              backgroundColor: hexToRgba(o.color, "0.2")
            },
            alt: null == t ? void 0 : t.businessName,
            styleProps: {
              iconColor: o.color,
              iconSize: o.size
            }
          }, {
            children: jsx$1(CmsImage, {
              media: null == t ? void 0 : t.businessIcon,
              height: o.size,
              width: o.size
            })
          }))
        }), jsx$1(ListItemText, {
          primary: null == t ? void 0 : t.businessName,
          secondary: null == t ? void 0 : t.businessLocation
        })]
      }))
    })), jsx$1(Text, _assign$({
      variant: "h6"
    }, {
      children: null == t ? void 0 : t.serviceName
    })), jsxs(ServiceDetails, _assign$({
      dense: !0
    }, {
      children: [jsxs(ListItem, {
        children: [jsx$1(ListItemIcon, _assign$({
          sx: {
            minWidth: 22,
            color: n.palette.primary.main
          }
        }, {
          children: jsx$1(BiTime, {
            size: 15
          })
        })), jsx$1(ListItemText, {
          secondary: "".concat(null == t ? void 0 : t.serviceDurationInMinutes, " min")
        })]
      }), jsxs(ListItem, {
        children: [jsx$1(ListItemIcon, _assign$({
          sx: {
            minWidth: 22,
            color: n.palette.primary.main
          }
        }, {
          children: jsx$1(BiDollarCircle, {
            size: 15
          })
        })), jsx$1(ListItemText, {
          secondary: "$".concat(null == t ? void 0 : t.serviceHourlyPricing, "/hr")
        })]
      })]
    })), jsx$1(Text, _assign$({
      variant: "body2",
      color: "textSecondary",
      lineHeight: 1.8
    }, {
      children: null == t ? void 0 : t.serviceDescription
    }))]
  }));
},
    BusinessDetails = styled$2(List)(function (e) {
  var t,
      r,
      n,
      a,
      o = e.theme;
  return {
    padding: 0,
    paddingBottom: o.spacing(1),
    "& .MuiListItem-root": {
      alignItems: "flex-start"
    },
    "& .MuiListItemText-root": {
      marginTop: 0
    },
    "& .MuiListItemAvatar-root": (t = {
      marginTop: o.spacing(.4),
      minWidth: 48
    }, t[o.breakpoints.up("sm")] = {
      minWidth: 32
    }, t),
    "& .MuiAvatar-root": (r = {
      width: 36,
      height: 36
    }, r[o.breakpoints.up("sm")] = {
      width: 20,
      height: 20
    }, r),
    "& .MuiListItemText-primary": (n = {}, n[o.breakpoints.up("sm")] = {
      fontSize: o.typography.caption.fontSize
    }, n),
    "& .MuiListItemText-secondary": (a = {}, a[o.breakpoints.up("sm")] = {
      fontSize: o.typography.caption.fontSize
    }, a)
  };
}),
    ServiceDetails = styled$2(List)(function (e) {
  var t,
      r = e.theme;
  return (t = {
    display: "flex",
    margin: r.spacing(0, -1)
  })[r.breakpoints.up("sm")] = {
    flexDirection: "column"
  }, t["& .MuiListItem-root"] = {
    margin: r.spacing(0, 1),
    padding: 0,
    width: "auto",
    whiteSpace: "pre"
  }, t;
}),
    BusinessIconAvatar$1 = styled$2(Avatar)(function (e) {
  var t = e.theme,
      r = e.styleProps;
  return {
    "& svg": {
      fill: r.iconColor,
      height: r.iconSize,
      position: "relative",
      top: t.spacing(.25)
    }
  };
}),
    BookingWidget = function BookingWidget(e) {
  var t = e.data,
      r = e.onDone,
      n = useTheme$4(),
      a = useMediaQuery(n.breakpoints.up("sm")),
      o = useState(new Date()),
      i = o[0],
      s = o[1],
      l = useState(new Date()),
      c = l[0],
      u = l[1],
      d = useState(0),
      p = d[0],
      g = d[1],
      m = useSpringRef(),
      f = useTransition(p, {
    ref: m,
    keys: null,
    from: {
      opacity: 0,
      transform: "translate3d(100%,0,0)"
    },
    enter: {
      opacity: 1,
      transform: "translate3d(0%,0,0)"
    },
    leave: {
      opacity: 0,
      transform: "translate3d(-50%,0,0)"
    }
  }),
      h = useCallback(function (e) {
    s(e), g(function (e) {
      return (e + 1) % 2;
    });
  }, []),
      b = useCallback(function (e) {
    if (u(e), null !== i && null !== e) return r({
      bookingDateTime: new Date(null == i ? void 0 : i.getFullYear(), null == i ? void 0 : i.getMonth(), null == i ? void 0 : i.getDate(), null == e ? void 0 : e.getHours(), null == e ? void 0 : e.getMinutes())
    });
  }, [r, i]),
      y = function y() {
    g(function (e) {
      return (e + 1) % 2;
    });
  };

  useEffect(function () {
    m.start();
  }, [p]);
  var v = [function (e) {
    var r,
        a = e.style;
    return jsx$1(animated.div, _assign$({
      style: _assign$(_assign$({}, a), {
        backgroundColor: n.palette.background.default
      })
    }, {
      children: (r = null === (null == t ? void 0 : t.maximumMonths) ? 3 : null == t ? void 0 : t.maximumMonths, jsxs(Box, _assign$({
        position: "absolute"
      }, {
        children: [jsxs(CardContent, _assign$({
          sx: {
            padding: n.spacing(2, 3, 1),
            position: "relative"
          }
        }, {
          children: [jsx$1(Text, _assign$({
            variant: "subtitle1",
            fontWeight: n.typography.fontWeightSemiBold
          }, {
            children: "Select a date"
          })), jsx$1(DatePickerTodayLink, _assign$({
            onClick: function onClick() {
              return h(new Date());
            },
            underline: "none",
            variant: "caption"
          }, {
            children: "Today"
          }))]
        })), jsx$1(CardContent, _assign$({
          sx: {
            padding: 0
          }
        }, {
          children: jsx$1(StaticDatePicker, {
            displayStaticWrapperAs: "desktop",
            value: i,
            onChange: h,
            minDate: new Date(),
            maxDate: lastDayOfMonth(addMonths$1(new Date(), r - 1)),
            renderInput: function renderInput(e) {
              return jsx$1(TextField, _assign$({}, e));
            }
          })
        }))]
      })))
    }));
  }, function (e) {
    var r = e.style;
    return jsx$1(animated.div, _assign$({
      style: _assign$(_assign$({}, r), {
        backgroundColor: n.palette.background.default
      })
    }, {
      children: jsxs(Box, _assign$({
        position: "absolute"
      }, {
        children: [jsxs(CardContent, _assign$({
          sx: {
            alignItems: "center",
            display: "flex",
            justifyContent: "space-between",
            padding: n.spacing(2, 3, 1)
          }
        }, {
          children: [jsx$1(Text, _assign$({
            variant: "subtitle1",
            fontWeight: n.typography.fontWeightSemiBold
          }, {
            children: "Select a time"
          })), jsx$1(Link, _assign$({
            onClick: y,
            variant: "caption",
            underline: "always"
          }, {
            children: void 0 !== i && format$1(i, "EEEE, MMMM d")
          }))]
        })), jsx$1(CardContent, _assign$({
          sx: {
            padding: n.spacing(2, 3)
          }
        }, {
          children: jsx$1(StaticTimePicker, {
            value: c,
            intervalInMinutes: null == t ? void 0 : t.serviceDurationInMinutes,
            minTime: fromUnixTime(getUnixTime(new Date(2012, 1, 29, 7, 0, 0))),
            maxTime: fromUnixTime(getUnixTime(new Date(2012, 1, 29, 20, 0, 0))),
            onChange: b
          })
        }))]
      }))
    }));
  }];
  return jsx$1(Root$p, _assign$({
    elevation: 24
  }, {
    children: jsxs(Grid$2, _assign$({
      container: !0,
      spacing: 0
    }, {
      children: [jsx$1(Grid$2, _assign$({
        item: !0,
        xs: 12,
        sm: 5
      }, {
        children: jsxs(Box, _assign$({
          sx: {
            alignContent: "stretch",
            display: "flex",
            height: "100%"
          }
        }, {
          children: [jsx$1(CardContent, _assign$({
            sx: {
              minHeight: {
                sm: 353
              },
              padding: n.spacing(2, 3)
            }
          }, {
            children: jsx$1(BookingServiceDetails, {
              data: t
            })
          })), a && jsx$1(Divider, {
            orientation: "vertical",
            flexItem: !0
          })]
        }))
      })), jsxs(Grid$2, _assign$({
        item: !0,
        xs: 12,
        sm: 7
      }, {
        children: [!a && jsx$1(Divider, {
          sx: {
            width: "100%"
          }
        }), jsx$1(Box, _assign$({
          sx: {
            minHeight: 400,
            overflow: "hidden"
          }
        }, {
          children: f(function (e, t) {
            return jsx$1(v[t], {
              style: e
            });
          })
        }))]
      }))]
    }))
  }));
},
    Root$p = styled$2(Card)(function (e) {
  var t,
      r = e.theme;
  return e.styleProps, (t = {
    borderRadius: 8,
    maxWidth: 326
  })[r.breakpoints.up("sm")] = {
    maxWidth: 560
  }, t["& .MuiCalendarPicker-root"] = {
    maxHeight: 320,
    margin: r.spacing(0, .5)
  }, t['& .MuiCalendarPicker-root [role="presentation"]'] = {
    fontSize: r.typography.body2.fontSize,
    justifyContent: "center",
    width: 180
  }, t['& .MuiCalendarPicker-root [role="presentation"] .MuiButtonBase-root'] = {
    display: "none"
  }, t['& .MuiCalendarPicker-root [role="presentation"] + div'] = {
    position: "absolute",
    left: r.spacing(2),
    top: 65,
    width: 196
  }, t['& .MuiCalendarPicker-root [role="presentation"] + div .MuiButtonBase-root:nth-of-type(2)'] = {
    position: "absolute",
    right: 0
  }, t;
}),
    DatePickerTodayLink = styled$2(Link)(function (e) {
  var t = e.theme;
  return {
    position: "absolute",
    right: t.spacing(3.5),
    top: t.spacing(2.25),
    fontSize: t.typography.body2.fontSize
  };
}),
    bookingHeroCTAMessageFormatter = function bookingHeroCTAMessageFormatter(e, t) {
  var r, n;
  return template_1(null === (r = null == e ? void 0 : e.heroCTA) || void 0 === r ? void 0 : r.smsContent)({
    a: null === (n = null == e ? void 0 : e.widget) || void 0 === n ? void 0 : n.serviceName,
    b: format$1(t.bookingDateTime, "do MMM yyyy"),
    c: format$1(t.bookingDateTime, "h:mm a")
  });
},
    CookieConsent = function CookieConsent(e) {
  var t = e.title,
      r = e.acceptButtonText,
      n = useTheme$4(),
      a = useMediaQuery(n.breakpoints.between("md", "lg")),
      o = useMediaQuery(n.breakpoints.up("lg"));
  return jsx$1(CookieConsentBar, _assign$({
    location: "bottom",
    buttonText: r,
    cookieName: "gosite_cookie_opt_in",
    cookieValue: "yes",
    contentStyle: {
      flex: 1,
      maxWidth: "1000px",
      padding: n.spacing(2.5),
      margin: 0,
      color: n.palette.common.black
    },
    style: {
      background: n.palette.common.white,
      boxShadow: "0 -1px 3px #eaf0f6",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column",
      borderTop: "1px solid #cbd6e2"
    },
    buttonStyle: {
      background: "#0058ff",
      color: n.palette.common.white,
      fontSize: "13px",
      borderRadius: "3px",
      padding: n.spacing(1.25, 2),
      marginBottom: "30px",
      transform: a ? "translateX(19rem)" : o ? "translateX(27rem)" : "none"
    },
    expires: 150
  }, {
    children: jsx$1(Text, _assign$({
      rich: !0,
      variant: "caption",
      sx: {
        a: {
          textDecoration: "none"
        }
      }
    }, {
      children: t
    }))
  }));
};

function BsPhone(e) {
  return GenIcon({
    tag: "svg",
    attr: {
      fill: "currentColor",
      viewBox: "0 0 16 16"
    },
    child: [{
      tag: "path",
      attr: {
        d: "M11 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h6zM5 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H5z"
      }
    }, {
      tag: "path",
      attr: {
        d: "M8 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
      }
    }]
  })(e);
}

function BsUpload(e) {
  return GenIcon({
    tag: "svg",
    attr: {
      fill: "currentColor",
      viewBox: "0 0 16 16"
    },
    child: [{
      tag: "path",
      attr: {
        d: "M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"
      }
    }, {
      tag: "path",
      attr: {
        d: "M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708l3-3z"
      }
    }]
  })(e);
}

var DownloadMobileApp = function DownloadMobileApp(e) {
  var t = e.data,
      r = t.label,
      n = t.title,
      a = t.description,
      o = t.media,
      i = t.agreementText,
      s = t.inputPlaceholderText,
      l = t.submitButtonText,
      c = t.appDownloadLinks,
      u = useAnalytics$1(),
      d = useTheme$4(),
      p = useState(),
      g = p[0],
      m = p[1],
      f = useState(null),
      h = f[0],
      b = f[1],
      y = useState(),
      v = y[0],
      _ = y[1];
  return jsx$1(Container, _assign$({
    maxWidth: "lg"
  }, {
    children: jsxs(Grid$2, _assign$({
      container: !0,
      spacing: 0,
      sx: {
        justifyContent: "center",
        alignItems: "center"
      }
    }, {
      children: [jsx$1(Grid$2, _assign$({
        item: !0,
        sm: 6
      }, {
        children: jsx$1(CmsImage, {
          media: o
        })
      })), jsxs(Grid$2, _assign$({
        item: !0,
        sm: 6
      }, {
        children: [jsx$1(Chip, {
          label: r
        }), jsxs("div", {
          children: [jsx$1(Text, _assign$({
            variant: "h3",
            sx: {
              pt: 1.4
            }
          }, {
            children: n
          })), jsx$1(Text, _assign$({
            variant: "body1",
            sx: {
              py: 1.25,
              color: d.palette.text.secondary
            }
          }, {
            children: a
          }))]
        }), null !== h ? jsx$1("div", {
          children: function (e, t) {
            return 200 === e ? jsx$1(ThankyouText, {
              children: Object.values(t)
            }) : jsx$1(Alert, _assign$({
              severity: "error",
              sx: {
                marginBottom: "1.6rem",
                width: "fit-content"
              }
            }, {
              children: Object.values(t)
            }));
          }(v, h)
        }) : jsxs(PhoneWrapper, {
          children: [jsx$1(PhoneNumberField, {
            placeholder: s,
            InputProps: {
              endAdornment: jsx$1(BsPhone, {
                color: "#d1d7dd",
                fontSize: "25px"
              })
            },
            onChange: function onChange(e) {
              return function (e) {
                m(e.target.value);
              }(e);
            },
            variant: "outlined",
            onClick: function onClick() {
              null == u || u.track("mkt_enter_phone_number", {});
            }
          }), jsx$1(GetAppButton, _assign$({
            onClick: function onClick() {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (e) {
                  switch (e.label) {
                    case 0:
                      return [4, __awaiter(void 0, void 0, void 0, function () {
                        var e, t, r;
                        return __generator(this, function (n) {
                          switch (n.label) {
                            case 0:
                              return e = {
                                phone: g,
                                message: "Download mobile app"
                              }, null == u || u.track("mkt_submit_phone_numer", {
                                phoneNumber: g
                              }), [4, sendSMS(e)];

                            case 1:
                              return [4, (t = n.sent()).json()];

                            case 2:
                              return r = n.sent(), b(r), _(t.status), [2];
                          }
                        });
                      })];

                    case 1:
                      return [2, e.sent()];
                  }
                });
              });
            }
          }, {
            children: l
          }))]
        }), c.map(function (e) {
          return jsx$1(DownloadButton, _assign$({
            component: Button,
            link: e,
            onChange: function onChange(t) {
              return function (e) {
                -1 !== e.url.indexOf("apple") ? null == u || u.track("mkt_to_ios_appstore_phmodal", {}) : null == u || u.track("mkt_to_google_play_phmodal", {});
              }(e);
            }
          }, {
            children: jsx$1(CmsImage, {
              media: e.media,
              width: 122,
              height: 36
            })
          }), e.id);
        }), jsx$1(Text, _assign$({
          variant: "caption2",
          sx: {
            pt: 3.75,
            color: d.palette.primary.light,
            display: "block"
          }
        }, {
          children: jsx$1(Markdown, {
            children: i
          })
        }))]
      }))]
    }))
  }));
},
    GetAppButton = styled$2(Button)(function (e) {
  var t,
      r = e.theme;
  return (t = {
    background: "#5ac58d",
    color: r.palette.common.white,
    marginLeft: r.spacing(2.25),
    padding: r.spacing(1.6, 2.8),
    "&:hover": {
      background: "#5ac58d"
    }
  })[r.breakpoints.down("md")] = {
    marginLeft: r.spacing(0),
    marginTop: r.spacing(2.25)
  }, t;
}),
    DownloadButton = styled$2(Link)(function (e) {
  return {
    padding: e.theme.spacing(0, 1.75, 0, 0),
    "&:hover": {
      background: "none"
    }
  };
}),
    PhoneWrapper = styled$2("div")(function (e) {
  var t,
      r = e.theme;
  return (t = {
    display: "flex",
    alignItems: "center",
    padding: r.spacing(2.75, 0)
  })[r.breakpoints.down("md")] = {
    flexDirection: "column",
    alignItems: "normal"
  }, t;
}),
    PhoneNumberField = styled$2(TextField)(function (e) {
  var t,
      r = e.theme;
  return (t = {
    width: "50%",
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#e3eaf0"
      },
      "&:hover fieldset": {
        borderColor: "#e3eaf0"
      },
      "&.Mui-focused fieldset": {
        borderColor: "#e3eaf0"
      }
    },
    "& .MuiOutlinedInput-input": {
      padding: r.spacing(1.6, 1.75)
    },
    input: {
      "&::placeholder": {
        fontSize: r.spacing(1.6)
      }
    }
  })[r.breakpoints.down("md")] = {
    width: "100%"
  }, t;
}),
    ThankyouText = styled$2("p")(function (e) {
  var t = e.theme;
  return {
    fontSize: t.spacing(2.25),
    color: t.palette.text.secondary
  };
}),
    FeatureColumnsGroup = function FeatureColumnsGroup(e) {
  var t = e.data,
      r = t.title,
      n = t.description,
      a = t.features,
      o = t.gridProperties,
      i = t.styles,
      s = t.itemVariant,
      l = function l(e) {
    return jsxs(ContentCard, _assign$({
      variant: null != s ? s : "outlined",
      className: "".concat(featureColumnClasses.root, " ").concat(featureColumnsGroupClasses.item),
      sx: e.styles,
      styleProps: e
    }, {
      children: [jsx$1(Media, {
        media: e.icon,
        width: 48
      }), jsxs(Stack$2, _assign$({
        mt: 4,
        gap: 2
      }, {
        children: [jsx$1(Text, _assign$({
          className: featureColumnClasses.title
        }, {
          children: e.title
        })), jsx$1(Text, _assign$({
          className: featureColumnClasses.description
        }, {
          children: e.description
        }))]
      }))]
    }), e.id);
  };

  return jsx$1(Root$o, _assign$({
    className: featureColumnsGroupClasses.root,
    sx: i
  }, {
    children: jsxs(Container, {
      children: [jsxs(Stack$2, _assign$({
        gap: 2
      }, {
        children: [jsx$1(Text, _assign$({
          rich: !0,
          className: featureColumnsGroupClasses.title,
          gutterBottom: !0
        }, {
          children: r
        })), jsx$1(Text, _assign$({
          rich: !0,
          className: featureColumnsGroupClasses.description
        }, {
          children: n
        }))]
      })), jsx$1(Stack$2, _assign$({
        flexWrap: "wrap",
        direction: "row",
        justifyContent: "center",
        alignItems: "stretch",
        gap: 4,
        mt: 6,
        className: featureColumnsGroupClasses.items
      }, o, {
        children: a.map(l)
      }))]
    })
  }));
},
    Root$o = styled$2("div")(function (e) {
  var t,
      r,
      n = e.theme;
  return (t = {
    textAlign: "center",
    margin: n.spacing(10, 0)
  })[".".concat(featureColumnsGroupClasses.title, " h2")] = _assign$({}, n.typography.h2), t[".".concat(featureColumnsGroupClasses.description, " p")] = _assign$(_assign$({}, n.typography.heading), {
    fontWeight: n.typography.fontWeightRegular
  }), t[n.breakpoints.down("md")] = ((r = {})[".".concat(featureColumnsGroupClasses.title, " h2")] = _assign$({}, n.typography.h4), r), t[".".concat(featureColumnClasses.title)] = _assign$(_assign$({}, n.typography.h6), {
    fontWeight: n.typography.fontWeightSemiBold
  }), t;
}),
    alignContent = function alignContent(e) {
  return "left" === e ? "start" : "right" === e ? "end" : "center";
},
    ContentCard = styled$2(Paper$1)(function (e) {
  var t,
      r,
      n = e.theme,
      a = e.styleProps;
  return (t = {
    borderRadius: n.spacing(1.5),
    display: "flex",
    width: "100%",
    flexDirection: "column",
    alignItems: alignContent(null == a ? void 0 : a.contentAlignment),
    textAlign: null !== (r = null == a ? void 0 : a.contentAlignment) && void 0 !== r ? r : "center",
    padding: n.spacing(3.5, 3)
  })[n.breakpoints.up("md")] = {
    width: 280
  }, t["&.".concat(paperClasses.outlined)] = {
    borderColor: colors.grey[200],
    borderWidth: 2
  }, t;
}),
    FeatureRowBody = function FeatureRowBody(e) {
  var t = e.data,
      r = t.label,
      n = t.title,
      a = t.description,
      o = t.link;
  return jsx$1(Fragment, {
    children: jsxs(FeatureGroup, {
      children: [null !== r && jsx$1(Chip, {
        label: r
      }), jsx$1(RowTitle, _assign$({
        variant: "h3"
      }, {
        children: n
      })), jsx$1(RowSubTitle, _assign$({
        variant: "heading",
        color: "text.secondary",
        pt: 3
      }, {
        children: a
      })), void 0 !== (null == o ? void 0 : o.text) && jsx$1(Button, _assign$({
        color: "primary",
        variant: "outlined",
        sx: {
          mt: 4
        }
      }, {
        children: null == o ? void 0 : o.text
      }))]
    })
  });
},
    RowTitle = styled$2(Typography$2)(function (e) {
  return {
    padding: e.theme.spacing(3, 0)
  };
}),
    RowSubTitle = styled$2(Typography$2)(function (e) {
  return {
    fontWeight: e.theme.typography.fontWeightRegular
  };
}),
    FeatureGroup = styled$2(Box)(function (e) {
  var t;
  return (t = {
    textAlign: "left",
    width: "335px"
  })[e.theme.breakpoints.up("md")] = {
    width: "540px"
  }, t;
}),
    FeatureRowsGroup = function FeatureRowsGroup(e) {
  var t = e.data.features,
      r = useMediaQuery("(max-width:896px)");
  return jsx$1(Box, _assign$({
    sx: {
      perspective: "300px"
    }
  }, {
    children: t.map(function (e, t) {
      return jsx$1(Root$n, _assign$({
        RootstyleProps: {
          horizontalAlignment: e.mediaHorizontalAlignment
        }
      }, {
        children: jsx$1(Container, _assign$({
          maxWidth: "lg",
          sx: {
            paddingX: 0
          }
        }, {
          children: jsxs(Grid$2, _assign$({
            container: !0
          }, {
            children: [jsx$1(FeatureContainer, _assign$({
              item: !0,
              sm: 12,
              md: (e.mediaHorizontalAlignment, 6),
              styleProps: {
                horizontalAlignment: e.mediaHorizontalAlignment
              }
            }, {
              children: jsx$1(ContentBox, {
                children: r || "right" === e.mediaHorizontalAlignment ? jsx$1(FeatureRowBody, {
                  data: e
                }) : jsx$1(CmsImage, {
                  media: e.media
                })
              })
            })), jsx$1(FeatureContainer, _assign$({
              item: !0,
              sm: 12,
              md: (e.mediaHorizontalAlignment, 6),
              styleProps: {
                horizontalAlignment: e.mediaHorizontalAlignment
              }
            }, {
              children: jsx$1(ContentBox, {
                children: r || "right" === e.mediaHorizontalAlignment ? jsx$1(CmsImage, {
                  media: e.media
                }) : jsx$1(FeatureRowBody, {
                  data: e
                })
              })
            }))]
          }))
        }))
      }), t);
    })
  }));
},
    Root$n = styled$2(Box)(function (e) {
  var t,
      r = e.theme;
  return e.RootstyleProps, {
    display: "flex",
    "& .MuiContainer-root": (t = {}, t[r.breakpoints.up("md")] = {
      padding: 0
    }, t)
  };
}),
    ContentBox = styled$2(Box)(function (e) {
  return {
    padding: e.theme.spacing(0, 3)
  };
}),
    FeatureContainer = styled$2(Grid$2)(function (e) {
  var t,
      r = e.theme;
  return e.styleProps, (t = {
    alignItems: "center",
    display: "flex",
    width: "-webkit-fill-available"
  })[r.breakpoints.up("lg")] = {}, t;
}),
    FeatureWide = function FeatureWide(e) {
  var t = e.data,
      r = useTheme$4();
  return jsx$1(Container, {
    children: jsxs(Root$m, {
      children: [jsxs(Box, _assign$({
        textAlign: "center"
      }, {
        children: [jsx$1(PrimaryMediaContainer$1, {
          children: "top" === t.primaryMediaVerticalAlignment && jsx$1(CmsImage, {
            media: t.primaryMedia
          })
        }), jsx$1(Text, _assign$({
          variant: "h5",
          sx: {
            marginBottom: r.spacing(4),
            marginTop: r.spacing(2)
          }
        }, {
          children: t.title
        })), jsx$1(Text, _assign$({
          variant: "body1",
          sx: {
            marginBottom: r.spacing(4),
            marginTop: r.spacing(2)
          }
        }, {
          children: t.subtitle
        }))]
      })), jsx$1(MediaListContainer, {
        children: t.mediaList.map(function (e, t) {
          return jsx$1(Box, _assign$({
            padding: 1.25
          }, {
            children: jsx$1(CmsImage, {
              media: e
            }, t)
          }), t);
        })
      }), jsx$1(PrimaryMediaContainer$1, {
        children: "bottom" === t.primaryMediaVerticalAlignment && jsx$1(CmsImage, {
          media: t.primaryMedia
        })
      }), jsx$1(Divider, {
        variant: "middle",
        sx: {
          marginX: r.spacing(1),
          paddingTop: r.spacing(10)
        }
      })]
    })
  });
},
    Root$m = styled$2(Box)(function (e) {
  return {
    padding: e.theme.spacing(10, 0, 10, 0)
  };
}),
    MediaListContainer = styled$2(Box)(function (e) {
  return {
    display: "flex",
    justifyContent: "space-around",
    flexWrap: "wrap",
    alignItems: "center",
    paddingTop: e.theme.spacing(2)
  };
}),
    PrimaryMediaContainer$1 = styled$2(Box)(function (e) {
  return {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    paddingTop: e.theme.spacing(2)
  };
}),
    FooterBottom = function FooterBottom(e) {
  var t = e.data,
      r = t.logo,
      n = t.copyrightText,
      a = t.legalTextLink,
      o = t.locationText,
      i = t.termsAndConditionsLink,
      s = t.manageCookiesLinkText,
      l = e.doesSiteHaveTermlyConsentBanner,
      c = void 0 !== l && l,
      u = useTheme$4(),
      d = useMediaQuery(u.breakpoints.down("md"));
  return jsxs(Root$l, {
    children: [null !== r && jsx$1(Link, _assign$({
      link: r
    }, {
      children: jsx$1(CmsImage, {
        media: null == r ? void 0 : r.media
      })
    })), jsx$1(Divider, {
      sx: {
        marginTop: u.spacing(3.25),
        marginBottom: u.spacing(2)
      }
    }), jsx$1(BottomRow, {
      children: jsxs(Grid$2, _assign$({
        container: !0,
        spacing: 2,
        sx: {
          justifyContent: {
            xs: "center",
            md: "space-between"
          }
        }
      }, {
        children: [d && jsx$1(Grid$2, _assign$({
          item: !0,
          xs: 12,
          sx: {
            textAlign: "center",
            mb: u.spacing(1),
            mt: u.spacing(4)
          }
        }, {
          children: jsx$1(Text, {
            children: o
          })
        })), jsx$1(Grid$2, _assign$({
          item: !0
        }, {
          children: jsx$1(Text, {
            children: n
          })
        })), !d && jsx$1(Grid$2, _assign$({
          item: !0
        }, {
          children: jsx$1(Text, {
            children: o
          })
        })), jsx$1(Grid$2, _assign$({
          item: !0
        }, {
          children: jsxs(Grid$2, _assign$({
            container: !0,
            spacing: 2
          }, {
            children: [jsx$1(Grid$2, _assign$({
              item: !0
            }, {
              children: jsx$1(Link, _assign$({
                link: a
              }, {
                children: jsx$1(Text, {
                  children: null == a ? void 0 : a.text
                })
              }))
            })), jsx$1(Grid$2, _assign$({
              item: !0
            }, {
              children: jsx$1(Link, _assign$({
                link: i
              }, {
                children: jsx$1(Text, {
                  children: null == i ? void 0 : i.text
                })
              }))
            })), c && jsx$1(Grid$2, _assign$({
              item: !0
            }, {
              children: jsx$1(Link, _assign$({
                className: "termly-cookie-preference-button",
                onClick: function onClick() {
                  return globalThis.window.displayPreferenceModal();
                }
              }, {
                children: jsx$1(Text, {
                  children: s
                })
              }))
            }))]
          }))
        }))]
      }))
    })]
  });
},
    Root$l = styled$2(Box)(function (e) {
  var t,
      r = e.theme;
  return (t = {
    paddingTop: r.spacing(6.36)
  })[r.breakpoints.up("md")] = {
    paddingTop: r.spacing(16)
  }, t;
}),
    BottomRow = styled$2(Box)(function (e) {
  var t = e.theme;
  return {
    "& .MuiTypography-root": _assign$(_assign$({}, t.typography.body2), {
      color: t.palette.common.white
    })
  };
}),
    Footer = function Footer(e) {
  var t = e.data,
      r = t.items,
      n = t.itemsLayout,
      a = t.styles,
      o = t.columns,
      i = t.socialLinks,
      s = t.appLinks,
      l = t.appLinksHeading,
      c = t.socialLinksHeading,
      u = t.complianceLogos,
      d = useTheme$4(),
      p = function p(e, t) {
    if (null != e && "" !== e && (null == e ? void 0 : e.length) > 0) {
      var r,
          n = e.split(",").map(function (e) {
        return Number(e.trim());
      }),
          a = [],
          o = [];
      return n.map(function (e) {
        for (var n = __spreadArray([], a, !0), i = 0; i < e; i++) {
          a = __spreadArray(__spreadArray([], a, !0), [t[a.length]], !1);
        }

        return r = a.length > 0 ? a.filter(function (e) {
          return !n.includes(e);
        }) : a, o.push(r), e;
      }), o;
    }

    return [t];
  },
      g = function g(e) {
    return "#" !== e.url ? jsx$1(Link, _assign$({
      link: e
    }, {
      children: jsx$1(ItemLink, {
        children: e.text
      })
    })) : jsx$1(Fragment, {});
  },
      m = function m(e) {
    return jsxs(Box, {
      children: [(null !== e.title || "" !== e.title) && jsx$1(InnerTitle, {
        children: jsx$1(NestedTitle, {
          children: e.title
        })
      }), e.links.map(function (e) {
        return jsx$1(Item, {
          children: "#" === e.url || " " === e.url ? jsx$1(ItemText, {
            children: e.text
          }) : g(e)
        }, e.id);
      })]
    }, e.id);
  },
      f = function f(e) {
    return jsxs(Box, _assign$({
      pt: 4
    }, {
      children: [jsx$1(Title, _assign$({
        variant: "h6"
      }, {
        children: null == e ? void 0 : e.title
      })), jsx$1(Stack$2, _assign$({
        direction: {
          xs: "column",
          sm: "row"
        },
        spacing: {
          md: 8
        }
      }, {
        children: p(e.nestedItemsLayout, e.nestedItems).map(function (e, t) {
          return jsx$1(Box, _assign$({
            flex: 1
          }, {
            children: e.map(m)
          }), t);
        })
      }))]
    }), e.id);
  },
      h = function h(e) {
    return jsx$1(Box, _assign$({
      sx: {
        display: "flex",
        gap: 2,
        alignItems: "center",
        py: d.spacing(2)
      }
    }, {
      children: null == e ? void 0 : e.map(function (e) {
        return jsx$1(SocialLinks, {
          children: jsx$1(Link, _assign$({
            link: e
          }, {
            children: jsx$1(CmsImage, {
              media: e.media
            })
          }))
        }, e.id);
      })
    }));
  };

  return jsx$1(Root$k, _assign$({
    sx: a
  }, {
    children: jsxs(Container, _assign$({
      disableGutters: !0
    }, {
      children: [jsxs(Grid$2, _assign$({
        container: !0,
        columnSpacing: 8
      }, {
        children: [jsx$1(Grid$2, _assign$({
          item: !0,
          lg: 9
        }, {
          children: jsx$1(Stack$2, null != o ? _assign$({
            direction: "row",
            gap: 2
          }, {
            children: o.map(function (e) {
              return jsx$1(Item, {
                children: jsxs(Box, _assign$({
                  mb: 4
                }, {
                  children: [jsx$1(Text, _assign$({
                    variant: "heading",
                    color: "primary.contrastText",
                    component: "p"
                  }, {
                    children: e.title
                  })), e.links.map(function (e) {
                    return jsx$1(Item, {
                      children: "#" === e.url ? jsx$1(Item, {
                        children: e.text
                      }) : jsx$1(Link, _assign$({
                        link: e
                      }, {
                        children: jsx$1(Item, {
                          children: e.text
                        })
                      }))
                    }, e.id);
                  })]
                }))
              }, e.id);
            })
          }) : _assign$({
            direction: {
              xs: "column",
              sm: "row"
            },
            spacing: {
              md: 8
            }
          }, {
            children: p(n, r).map(function (e, t) {
              return jsx$1(Box, _assign$({
                flex: 1
              }, {
                children: e.map(f)
              }), t);
            })
          }))
        })), jsx$1(Grid$2, _assign$({
          item: !0,
          lg: 3
        }, {
          children: jsxs(Stack$2, _assign$({
            gap: 4,
            pt: 4
          }, {
            children: [jsxs(Box, {
              children: [jsx$1(Title, _assign$({
                variant: "h6"
              }, {
                children: l
              })), h(s)]
            }), jsxs(Box, {
              children: [jsx$1(Title, _assign$({
                variant: "h6"
              }, {
                children: c
              })), h(i)]
            }), jsx$1(Box, {
              children: jsx$1(Box, _assign$({
                sx: {
                  display: "flex",
                  gap: 2,
                  alignItems: "center",
                  pt: 2
                }
              }, {
                children: null == u ? void 0 : u.map(function (e) {
                  return jsx$1(Media, {
                    media: e.media
                  }, e.id);
                })
              }))
            })]
          }))
        }))]
      })), jsx$1(FooterBottom, _assign$({}, e))]
    }))
  }));
},
    Root$k = styled$2("footer")(function (e) {
  var t,
      r = e.theme;
  return (t = {
    padding: r.spacing(8, 3),
    backgroundColor: "#051325"
  })[r.breakpoints.up("md")] = {
    padding: r.spacing(10, 9, 8, 9)
  }, t["& a"] = {
    textDecoration: "none"
  }, t["& .MuiDivider-root"] = {
    borderColor: "rgba(222, 228, 231, 0.1)"
  }, t;
}),
    Item = styled$2(Box)(function (e) {
  var t,
      r = e.theme;
  return (t = {
    "& a": _assign$(_assign$({}, r.typography.body1), {
      color: "#ABB4B9"
    }),
    whiteSpace: "pre",
    padding: r.spacing(1, 0)
  })[r.breakpoints.down("sm")] = {
    lineHeight: r.typography.pxToRem(19.6)
  }, t;
}),
    ItemLink = styled$2(Text)(function (e) {
  var t = e.theme;
  return _assign$(_assign$({}, t.typography.body1), {
    transition: "transform 250ms",
    color: t.palette.primary.light,
    "&:hover": {
      transform: "translateX(15px);",
      color: t.palette.primary.contrastText
    }
  });
}),
    ItemText = styled$2(Text)(function (e) {
  var t = e.theme;
  return _assign$({}, t.typography.subtitle2);
}),
    Title = styled$2(Text)(function (e) {
  var t,
      r = e.theme;
  return _assign$(_assign$({}, r.typography.h6), ((t = {
    fontWeight: r.typography.fontWeightBold,
    color: r.palette.primary.contrastText,
    paddingTop: r.spacing(2.8)
  })[r.breakpoints.down("sm")] = {
    paddingTop: r.spacing(2.8)
  }, t));
}),
    NestedTitle = styled$2(Text)(function (e) {
  var t,
      r = e.theme;
  return _assign$(_assign$({}, r.typography.caption), ((t = {
    fontWeight: r.typography.fontWeightBold
  })[r.breakpoints.down("sm")] = {
    lineHeight: r.typography.pxToRem(16.4),
    fontSize: r.typography.pxToRem(12)
  }, t.color = colors.grey[400], t));
}),
    InnerTitle = styled$2(Box)(function (e) {
  var t,
      r = e.theme;
  return (t = {
    paddingTop: r.spacing(1.75)
  })[r.breakpoints.down("sm")] = {
    padding: r.spacing(1.5, 0)
  }, t;
}),
    SocialLinks = styled$2(Box)(function (e) {
  return e.theme, {
    transition: "transform 250ms",
    "&:hover": {
      transform: "translateX(3px);"
    }
  };
}),
    FormCustom = function FormCustom(e) {
  return e.data, jsx$1(Fragment, {});
},
    FormPart = function FormPart(e) {
  var t = e.data,
      r = e.onChange,
      n = t.description,
      a = t.form,
      o = t.footerContent,
      i = t.title,
      s = t.styles;
  return jsxs(Root$j, _assign$({
    className: "GoSiteFormSection-formPart",
    sx: s
  }, {
    children: [null != i && jsx$1(Text, _assign$({
      rich: !0
    }, {
      children: i
    })), null != n && jsx$1(Text, _assign$({
      my: 1.5,
      rich: !0
    }, {
      children: n
    })), null != a && jsx$1(Form, {
      form: a,
      onChange: r
    }), null != o && jsx$1(Text, _assign$({
      rich: !0,
      my: 1.5
    }, {
      children: o
    }))]
  }));
},
    Root$j = styled$2(Box)(function (e) {
  return e.theme, {};
}),
    FormSection = function FormSection(e) {
  var t = e.data,
      r = e.onChange,
      n = t.formParts,
      a = t.styles;
  return jsx$1(Root$i, _assign$({
    className: "GositeFormSection-root",
    sx: a
  }, {
    children: jsx$1(Container, {
      children: jsx$1(Stack$2, _assign$({
        direction: {
          xs: "column",
          md: "row"
        }
      }, {
        children: n.map(function (e) {
          return jsx$1(FormPart, {
            data: e,
            onChange: r
          }, e.id);
        })
      }))
    })
  }));
},
    Root$i = styled$2(Box)(function (e) {
  return e.theme, {
    position: "relative"
  };
}),
    HeroBody = function HeroBody(e) {
  var t = e.data,
      r = e.renderHeroCtaContent,
      n = e.bodyStyle;
  return jsxs(Root$h, _assign$({
    sx: n
  }, {
    children: [jsxs(Label, {
      children: [jsx$1(Image, {
        src: "/images/booking.svg",
        alt: "booking",
        width: "22",
        height: "22"
      }), jsx$1(Typography$2, _assign$({
        variant: "h6",
        color: "primary",
        sx: {
          textTransform: "uppercase"
        }
      }, {
        children: t.body.label
      }))]
    }), jsxs(Box, _assign$({
      textAlign: "center"
    }, {
      children: [jsx$1(HeroTitle, {
        children: t.body.title
      }), r]
    }))]
  }));
},
    Root$h = styled$2(Box)(function (e) {
  var t,
      r = e.theme;
  return (t = {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    padding: r.spacing(4)
  })[r.breakpoints.up("md")] = {
    height: "100%"
  }, t[r.breakpoints.up("lg")] = {
    padding: r.spacing(10.75)
  }, t;
}),
    Label = styled$2(Box)(function (e) {
  return {
    alignItems: "center",
    display: "flex",
    gap: e.theme.spacing(1.25),
    justifyContent: "center"
  };
}),
    HeroTitle = styled$2(Typography$2)(function (e) {
  var t = e.theme;
  return _assign$(_assign$({}, t.typography.h4), {
    paddingTop: t.spacing(3)
  });
}),
    HeroCta = function HeroCta(e) {
  var t = e.data,
      r = e.onSubmit,
      n = useTheme$4(),
      a = useState(null),
      o = a[0],
      i = a[1],
      s = useCallback(function (e) {
    i(e.target.value);
  }, []),
      l = useCallback(function () {
    var e = null != o && validator$1.isMobilePhone(o.toString());
    null != o && e && r(o);
  }, [r, o]);
  return jsxs(Box, _assign$({
    p: 4,
    textAlign: "center"
  }, {
    children: [jsx$1(Text, _assign$({
      variant: "body2",
      color: "primary"
    }, {
      children: null == t ? void 0 : t.title
    })), jsx$1(Box, _assign$({
      py: 2
    }, {
      children: jsx$1(TextFieldSubmitCombo, {
        placeholder: null == t ? void 0 : t.textFieldPlaceholder,
        inputProps: {
          "aria-label": null == t ? void 0 : t.textFieldPlaceholder
        },
        onChange: s,
        onSubmit: l
      })
    })), jsx$1(Text, _assign$({
      variant: "subtitle1",
      color: "primary",
      fontWeight: n.typography.fontWeightSemiBold,
      sx: {
        textDecoration: "underline"
      }
    }, {
      children: null == t ? void 0 : t.continueLinkText
    }))]
  }));
};

function _extends$8() {
  return _extends$8 = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];

      for (var n in r) {
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
    }

    return e;
  }, _extends$8.apply(this, arguments);
}

var MailAtComponent = function MailAtComponent(_ref103) {
  var _ref103$styles = _ref103.styles,
      e = _ref103$styles === void 0 ? {} : _ref103$styles,
      t = _objectWithoutProperties2(_ref103, _excluded4);

  return React__default.createElement("svg", _extends$8({
    width: "48",
    height: "48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, t), React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 24C2 11.85 11.85 2 24 2s22 9.85 22 22v4a2 2 0 11-4 0v-4c0-9.941-8.059-18-18-18S6 14.059 6 24s8.059 18 18 18a2 2 0 110 4C11.85 46 2 36.15 2 24z",
    fill: "#000"
  }), React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33 14a2 2 0 012 2v12c0 1.482 1.383 3 3.5 3s3.5-1.518 3.5-3a2 2 0 114 0c0 4.041-3.541 7-7.5 7S31 32.041 31 28V16a2 2 0 012-2z",
    fill: "#000"
  }), React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 24c0-6.075 4.925-11 11-11s11 4.925 11 11-4.925 11-11 11-11-4.925-11-11zm11-7a7 7 0 100 14 7 7 0 000-14z",
    fill: "#000"
  }));
};

function _extends$7() {
  return _extends$7 = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];

      for (var n in r) {
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
    }

    return e;
  }, _extends$7.apply(this, arguments);
}

var RightArrowComponent = function RightArrowComponent(_ref104) {
  var _ref104$styles = _ref104.styles,
      e = _ref104$styles === void 0 ? {} : _ref104$styles,
      t = _objectWithoutProperties2(_ref104, _excluded5);

  return React__default.createElement("svg", _extends$7({
    xmlns: "http://www.w3.org/2000/svg",
    width: "12",
    height: "11",
    viewBox: "0 0 12 12",
    fill: "none"
  }, t), React__default.createElement("path", {
    fill: "#082244",
    fillRule: "evenodd",
    d: "M43.219 25.85a2.58 2.58 0 000-3.7L28.552 7.767a2.704 2.704 0 00-3.771 0 2.58 2.58 0 000 3.699L37.562 24 24.781 36.535a2.58 2.58 0 000 3.699 2.704 2.704 0 003.771 0L43.22 25.849z",
    clipRule: "evenodd",
    className: (e.color082244 || "color082244") + " " + (e.svgShape || "svgShape")
  }), React__default.createElement("path", {
    fill: "#082244",
    fillRule: "evenodd",
    d: "M4 24c0 1.668 1.178 3 2.631 3H38.37C39.81 27 41 25.657 41 24c0-1.668-1.178-3-2.631-3H6.63C5.19 21 4 22.343 4 24z",
    clipRule: "evenodd",
    className: (e.color082244 || "color082244") + " " + (e.svgShape || "svgShape")
  }));
};

function _extends$6() {
  return _extends$6 = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];

      for (var n in r) {
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
    }

    return e;
  }, _extends$6.apply(this, arguments);
}

var SmartPhoneComponent = function SmartPhoneComponent(_ref105) {
  var _ref105$styles = _ref105.styles,
      e = _ref105$styles === void 0 ? {} : _ref105$styles,
      t = _objectWithoutProperties2(_ref105, _excluded6);

  return React__default.createElement("svg", _extends$6({
    width: "48",
    height: "48",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, t), React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 7a5 5 0 015-5h18a5 5 0 015 5v34a5 5 0 01-5 5H15a5 5 0 01-5-5V7zm5-1a1 1 0 00-1 1v34a1 1 0 001 1h18a1 1 0 001-1V7a1 1 0 00-1-1H15z",
    fill: "#082244"
  }), React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 40a3 3 0 100-6 3 3 0 000 6zM20 10a2 2 0 012-2h4a2 2 0 110 4h-4a2 2 0 01-2-2z",
    fill: "#082244"
  }));
};

function _extends$5() {
  return _extends$5 = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];

      for (var n in r) {
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
    }

    return e;
  }, _extends$5.apply(this, arguments);
}

var LinktextIconComponent = function LinktextIconComponent(_ref106) {
  var _ref106$styles = _ref106.styles,
      e = _ref106$styles === void 0 ? {} : _ref106$styles,
      t = _objectWithoutProperties2(_ref106, _excluded7);

  return React__default.createElement("svg", _extends$5({
    width: "48",
    height: "48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, t), React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46 24c0-12.15-9.85-22-22-22S2 11.85 2 24s9.85 22 22 22 22-9.85 22-22zM24 6c9.941 0 18 8.059 18 18s-8.059 18-18 18S6 33.941 6 24 14.059 6 24 6z",
    fill: "#082244"
  }), React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 24a6 6 0 10-12 0 6 6 0 0012 0zm-6-2a2 2 0 110 4 2 2 0 010-4zM24 9a2 2 0 00-2 2v2a2 2 0 104 0v-2a2 2 0 00-2-2zM39 24a2 2 0 00-2-2h-2a2 2 0 100 4h2a2 2 0 002-2zM15 24a2 2 0 00-2-2h-2a2 2 0 100 4h2a2 2 0 002-2zM16.414 13.586a2 2 0 10-2.828 2.828L15 17.828A2 2 0 1017.828 15l-1.414-1.414z",
    fill: "#082244"
  }), React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.828 13.586a2 2 0 010 2.828l-5.414 5.414A2 2 0 1126.586 19L32 13.586a2 2 0 012.828 0z",
    fill: "#082244"
  }));
};

function _extends$4() {
  return _extends$4 = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];

      for (var n in r) {
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
    }

    return e;
  }, _extends$4.apply(this, arguments);
}

var DownloadComponent = function DownloadComponent(_ref107) {
  var _ref107$styles = _ref107.styles,
      e = _ref107$styles === void 0 ? {} : _ref107$styles,
      t = _objectWithoutProperties2(_ref107, _excluded8);

  return React__default.createElement("svg", _extends$4({
    width: "48",
    height: "48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, t), React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.586 33.414a2 2 0 002.828 0l11-11a2 2 0 10-2.828-2.828L24 29.172l-9.586-9.586a2 2 0 10-2.828 2.828l11 11z",
    fill: "#082244"
  }), React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 20a2 2 0 012 2v18.991C6 41.551 6.451 42 7.006 42h33.987C41.55 42 42 41.551 42 40.991V22a2 2 0 114 0v18.991A5.005 5.005 0 0140.993 46H7.008A5.007 5.007 0 012 40.991V22a2 2 0 012-2z",
    fill: "#082244"
  }), React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 4v24a2 2 0 11-4 0V4a2 2 0 114 0z",
    fill: "#082244"
  }));
};

function _extends$3() {
  return _extends$3 = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];

      for (var n in r) {
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
    }

    return e;
  }, _extends$3.apply(this, arguments);
}

var ChevronDownComponent$1 = function ChevronDownComponent$1(_ref108) {
  var _ref108$styles = _ref108.styles,
      e = _ref108$styles === void 0 ? {} : _ref108$styles,
      t = _objectWithoutProperties2(_ref108, _excluded9);

  return React__default.createElement("svg", _extends$3({
    width: "48",
    height: "48",
    xmlns: "http://www.w3.org/2000/svg"
  }, t), React__default.createElement("path", {
    d: "M231.245 342.502L0 111.254l55.617-55.627C86.206 25.032 111.797 0 112.487 0c.689 0 79.863 78.609 175.942 174.686l174.69 174.686 174.689-174.686C733.887 78.609 813.06 0 813.75 0c.69 0 26.281 25.032 56.87 55.627l55.617 55.627-231.245 231.248C567.807 469.688 463.464 573.75 463.119 573.75c-.346 0-104.688-104.062-231.873-231.248z",
    fill: "currentColor"
  }));
};

function _extends$2() {
  return _extends$2 = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];

      for (var n in r) {
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
    }

    return e;
  }, _extends$2.apply(this, arguments);
}

var InfoComponent = function InfoComponent(_ref109) {
  var _ref109$styles = _ref109.styles,
      e = _ref109$styles === void 0 ? {} : _ref109$styles,
      t = _objectWithoutProperties2(_ref109, _excluded10);

  return React__default.createElement("svg", _extends$2({
    width: "15",
    height: "15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, t), React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 5a.625.625 0 100-1.25.625.625 0 000 1.25z",
    fill: "#0357FF"
  }), React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.625 7.5a6.875 6.875 0 1113.75 0 6.875 6.875 0 01-13.75 0zM7.5 1.875a5.625 5.625 0 100 11.25 5.625 5.625 0 000-11.25z",
    fill: "#0357FF"
  }), React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 5.938c.345 0 .625.28.625.625v4.062a.625.625 0 11-1.25 0V6.562c0-.345.28-.625.625-.625z",
    fill: "#0357FF"
  }));
},
    MailAt = function MailAt(e) {
  return jsx$1(SvgIcon$1, _assign$({}, e, {
    component: MailAtComponent,
    viewBox: "0 0 48 48"
  }));
},
    RightArrow = function RightArrow(e) {
  return jsx$1(SvgIcon$1, _assign$({}, e, {
    component: RightArrowComponent,
    viewBox: "0 0 48 48"
  }));
},
    SmartPhone = function SmartPhone(e) {
  return jsx$1(SvgIcon$1, _assign$({}, e, {
    component: SmartPhoneComponent,
    viewBox: "0 0 48 48"
  }));
},
    LinktextIcon = function LinktextIcon(e) {
  return jsx$1(SvgIcon$1, _assign$({}, e, {
    component: LinktextIconComponent,
    viewBox: "0 0 48 48"
  }));
},
    Download = function Download(e) {
  return jsx$1(SvgIcon$1, _assign$({}, e, {
    component: DownloadComponent,
    viewBox: "0 0 48 48"
  }));
},
    ChevronDown$1 = function ChevronDown$1(e) {
  return jsx$1(SvgIcon$1, _assign$({}, e, {
    component: ChevronDownComponent$1,
    viewBox: "0 0 926.23699 573.74994"
  }));
},
    InfoIcon = function InfoIcon(e) {
  return jsx$1(SvgIcon$1, _assign$({}, e, {
    component: InfoComponent
  }));
},
    HeroMain = function HeroMain(e) {
  var t = e.data,
      r = useTheme$4(),
      n = useAnalytics$1(),
      a = useMediaQuery(r.breakpoints.up("sm")),
      o = useMediaQuery(r.breakpoints.up("lg")),
      i = t.description,
      s = t.title,
      l = t.badges,
      c = t.storeLinks,
      u = t.backgroundImage,
      d = t.buttonLinks,
      p = function p(e) {
    switch (e.variant) {
      case "outlined":
        return "outlined";

      case "solid":
        return "contained";

      default:
        return "text";
    }
  },
      g = function g(e) {
    return o && e + 1 < l.length ? jsx$1(Divider, {
      orientation: "vertical",
      sx: {
        borderColor: r.palette.text.secondary,
        height: r.spacing(4),
        marginX: r.spacing(3)
      }
    }) : jsx$1(Fragment, {});
  },
      m = function m(e) {
    return {
      link: e,
      key: null == e ? void 0 : e.id,
      href: null == e ? void 0 : e.url,
      target: void 0 !== (null == e ? void 0 : e.newTab) && (null == e ? void 0 : e.newTab) ? "_blank" : "_self",
      rel: "noreferrer"
    };
  };

  return jsxs(Root$g, {
    children: [jsx$1(Container, {
      children: jsx$1(Grid$2, _assign$({
        container: !0,
        spacing: 0
      }, {
        children: jsxs(Grid$2, _assign$({
          item: !0,
          lg: 7
        }, {
          children: [jsx$1(Grid$2, _assign$({
            container: !0,
            alignItems: o ? "center" : "flex-start",
            flexDirection: o ? "row" : "column",
            rowSpacing: o ? 0 : 2
          }, {
            children: l.length > 0 && (null == l ? void 0 : l.map(function (e, t) {
              return jsxs(React__default.Fragment, {
                children: [jsx$1(Grid$2, _assign$({
                  item: !0
                }, {
                  children: jsx$1(CmsImage, {
                    media: e
                  }, t)
                })), g(t)]
              }, t);
            }))
          })), jsxs(Box, _assign$({
            py: 4
          }, {
            children: [jsx$1(Text, _assign$({
              variant: "h2",
              color: "background.default",
              mb: 3
            }, {
              children: jsx$1(RichText, {
                children: s
              })
            })), jsx$1(Text, _assign$({
              variant: "heading",
              color: "background.default",
              fontWeight: r.typography.fontWeightMedium
            }, {
              children: i
            }))]
          })), jsxs(Grid$2, _assign$({
            container: !0,
            alignItems: "center",
            spacing: 4
          }, {
            children: [jsx$1(Grid$2, _assign$({
              item: !0,
              xs: a ? void 0 : 12
            }, {
              children: jsx$1(Grid$2, _assign$({
                container: !0,
                spacing: 2,
                alignItems: "center"
              }, {
                children: d.length > 0 && (null == d ? void 0 : d.map(function (e, t) {
                  return jsx$1(Grid$2, _assign$({
                    item: !0,
                    xs: a ? void 0 : 12
                  }, {
                    children: jsx$1(Link, _assign$({}, m(e), {
                      children: jsx$1(Button, _assign$({
                        variant: p(e),
                        fullWidth: !o,
                        size: "large",
                        sx: {
                          height: 51,
                          minWidth: 240,
                          justifyContent: "space-between"
                        },
                        endIcon: 0 === t && jsx$1(RightArrow, {
                          color: "primary",
                          onClick: function onClick() {
                            null == n || n.track("free_trial_action", {
                              event: "Start free trial"
                            });
                          }
                        })
                      }, {
                        children: e.text
                      }))
                    }))
                  }), e.id);
                }))
              }))
            })), jsx$1(Grid$2, _assign$({
              item: !0
            }, {
              children: jsx$1(Grid$2, _assign$({
                container: !0,
                spacing: 2,
                alignItems: "center"
              }, {
                children: c.length > 0 && (null == c ? void 0 : c.map(function (e) {
                  return jsx$1(Grid$2, _assign$({
                    item: !0,
                    display: "flex",
                    alignItems: "center"
                  }, {
                    children: jsx$1(Link, _assign$({
                      link: e,
                      onClick: function onClick() {
                        var t;
                        t = e.title, null == n || n.track("app_play_store_action", {
                          storeName: t
                        });
                      }
                    }, {
                      children: jsx$1(CmsImage, {
                        media: e.media
                      })
                    }))
                  }), e.id);
                }))
              }))
            }))]
          }))]
        }))
      }))
    }), jsx$1(BackgroundMedia, {
      children: jsx$1(CmsImage, {
        media: u
      })
    })]
  });
},
    Root$g = styled$2(Box)(function (e) {
  var t,
      r = e.theme;
  return (t = {
    position: "relative",
    padding: r.spacing(12, 0),
    minHeight: 720,
    width: "100%",
    paddingTop: 100
  })[r.breakpoints.up("md")] = {
    paddingTop: r.spacing(22)
  }, t;
}),
    BackgroundMedia = styled$2(Box)(function (e) {
  return e.theme, {
    width: "100%",
    height: "100%",
    position: "absolute",
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    zIndex: -1,
    display: "flex",
    alignItems: "flex-end",
    "& > div": {
      height: "100%",
      objectFit: "cover",
      width: "100%"
    },
    "& img": {
      objectPosition: "center bottom ",
      objectFit: "inherit !important"
    }
  };
}),
    HeroOverview1 = function HeroOverview1(e) {
  var t = e.data,
      r = useTheme$4(),
      n = useButtonStyles().getVariant,
      a = t.buttonLinks,
      o = t.backgroundImage,
      i = t.contentWidth,
      s = t.description,
      l = t.primaryMediaVerticalAlignment,
      c = t.primaryMedia,
      u = t.styles,
      d = t.showDivider,
      p = t.textAlign,
      g = t.title,
      m = function m(e) {
    return {
      link: e,
      key: null == e ? void 0 : e.id,
      href: null == e ? void 0 : e.url,
      target: void 0 !== (null == e ? void 0 : e.newTab) && (null == e ? void 0 : e.newTab) ? "_blank" : "_self",
      rel: "noreferrer"
    };
  },
      f = useMediaQuery(r.breakpoints.up("sm"));

  return jsx$1(Root$f, _assign$({
    sx: _assign$(_assign$({}, u), {
      textAlign: p
    })
  }, {
    children: jsxs(Container, {
      children: [jsx$1(Grid$2, _assign$({
        container: !0,
        spacing: 0,
        justifyContent: "center"
      }, {
        children: jsx$1(Grid$2, _assign$({
          item: !0,
          lg: contentWidthMapToGridLayout[i]
        }, {
          children: jsxs(Box, {
            children: [jsx$1(PrimaryMediaContainer, {
              children: "top" === l && jsx$1(CmsImage, {
                media: c
              })
            }), jsx$1(Text, _assign$({
              rich: !0,
              variant: "h2",
              gutterBottom: !0,
              fontWeight: r.typography.fontWeightBold,
              fontSize: r.typography.pxToRem(48),
              color: r.palette.text.primary
            }, {
              children: g
            })), jsx$1(Text, _assign$({
              rich: !0,
              variant: "body1",
              fontSize: r.typography.pxToRem(18),
              lineHeight: r.typography.pxToRem(30),
              color: r.palette.text.secondary
            }, {
              children: s
            })), jsx$1(Grid$2, _assign$({
              container: !0,
              spacing: 2,
              justifyContent: p,
              marginTop: 2,
              marginBottom: 2
            }, {
              children: a.length > 0 && (null == a ? void 0 : a.map(function (e) {
                return jsx$1(Grid$2, _assign$({
                  item: !0,
                  xs: f ? void 0 : 12
                }, {
                  children: jsx$1(Link, _assign$({}, m(e), {
                    children: jsx$1(Button, _assign$({
                      variant: n(e.variant),
                      size: "large",
                      sx: {
                        height: 51,
                        justifyContent: "space-between"
                      },
                      endIcon: jsx$1(RightArrow, {
                        pathColor: "contained" === n(e.variant) ? r.palette.common.white : r.palette.primary.main
                      })
                    }, {
                      children: e.text
                    }))
                  }))
                }), e.id);
              }))
            })), jsx$1(PrimaryMediaContainer, {
              children: "bottom" === l && jsx$1(CmsImage, {
                media: c
              })
            })]
          })
        }))
      })), d && jsx$1(Divider, {
        variant: "middle",
        sx: {
          marginX: r.spacing(1),
          paddingTop: r.spacing(10)
        }
      }), null != o && jsx$1(BackgroundMedia$1, {
        backgroundMedia: o
      })]
    })
  }));
},
    contentWidthMapToGridLayout = {
  medium: 6,
  large: 8,
  full: 12
},
    Root$f = styled$2(Box)(function (e) {
  return {
    padding: e.theme.spacing(10, 0, 10, 0)
  };
}),
    PrimaryMediaContainer = styled$2(Box)(function (e) {
  return {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    paddingTop: e.theme.spacing(2)
  };
}),
    HeroSignUpForm = function HeroSignUpForm(e) {
  var t = e.data,
      r = e.onSubmit,
      n = useTheme$4(),
      a = React__default.useState(""),
      o = a[0],
      i = a[1],
      s = useCallback(function (e) {
    i(e.target.value);
  }, []),
      l = useCallback(function () {
    if (validator$1.isEmail(o)) return r(o);
  }, [r, o]);
  return jsx$1(Root$e, {
    children: jsxs(StyledCard$1, _assign$({
      elevation: 24
    }, {
      children: [jsxs(Content$1, _assign$({
        textAlign: "center"
      }, {
        children: [jsx$1(CmsImage, {
          media: t.icon,
          component: "img",
          height: 22,
          width: 22
        }), jsx$1(Text, _assign$({
          variant: "h5",
          fontWeight: n.typography.fontWeightBold,
          sx: {
            marginBottom: n.spacing(4),
            marginTop: n.spacing(2)
          }
        }, {
          children: t.title
        })), jsx$1(TextFieldSubmitCombo, {
          placeholder: "Your email",
          inputProps: {
            "aria-label": "your email address"
          },
          onChange: s,
          onSubmit: l,
          elevation: 6,
          startAdornment: jsx$1(TextFieldSubmitComboStartAdornment, {
            children: jsx$1(MailAt, {
              fontSize: "small",
              color: "primary"
            })
          })
        })]
      })), jsx$1(ImageContainer, {
        children: jsx$1(CmsImage, {
          media: t.backgroundMedia
        })
      })]
    }))
  });
},
    Root$e = styled$2(Box)(function (e) {
  var t,
      r,
      n = e.theme;
  return {
    paddingLeft: n.spacing(2),
    "& .MuiCard-root": (t = {
      borderRadius: 0,
      borderTopLeftRadius: 3 * Number(n.shape.borderRadius),
      borderBottomLeftRadius: 3 * Number(n.shape.borderRadius),
      height: 436
    }, t[n.breakpoints.up("md")] = {
      height: 457
    }, t["& form"] = (r = {}, r[n.breakpoints.up("md")] = {
      width: 432
    }, r), t)
  };
}),
    StyledCard$1 = styled$2(Card)(function (e) {
  return e.theme, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    position: "relative"
  };
}),
    Content$1 = styled$2(Box)(function (e) {
  return e.theme, {
    position: "relative",
    zIndex: 1
  };
}),
    TextFieldSubmitComboStartAdornment = styled$2(Box)(function (e) {
  return {
    alignItems: "center",
    display: "flex",
    justifyContent: "center",
    padding: e.theme.spacing(1)
  };
}),
    HeroTestimonial = function HeroTestimonial(e) {
  var t = e.data,
      r = React__default.useState(!1),
      n = r[0],
      a = r[1],
      o = validator$1.isURL(null == t ? void 0 : t.videoUrl),
      i = function i() {
    return a(!1);
  };

  return jsxs(Fragment, {
    children: [jsxs(Root$d, _assign$({
      onClick: function onClick() {
        return a(!0);
      },
      sx: {
        cursor: o ? "pointer" : "default"
      }
    }, {
      children: [jsxs(Box, _assign$({
        display: "flex"
      }, {
        children: [jsx$1(VideoLengthText, {
          children: null == t ? void 0 : t.videoLength
        }), jsx$1(CmsImage, {
          media: null == t ? void 0 : t.videoIcon,
          width: 60,
          height: 40
        })]
      })), jsxs(Box, _assign$({
        textAlign: "left",
        justifyContent: "center",
        display: "flex",
        flexDirection: "column",
        pl: 1.2
      }, {
        children: [jsx$1(Text, _assign$({
          fontWeight: 600,
          fontSize: 12,
          width: 200
        }, {
          children: null == t ? void 0 : t.title
        })), jsx$1(Text, _assign$({
          fontWeight: 400,
          fontSize: 10,
          width: 200,
          color: "textSecondary"
        }, {
          children: null == t ? void 0 : t.subtitle
        }))]
      }))]
    })), o && jsx$1(Modal$1, _assign$({
      open: n,
      onClose: i,
      onBackdropClick: i,
      "aria-labelledby": "parent-modal-title",
      "aria-describedby": "parent-modal-description",
      sx: {
        display: "flex",
        alignItems: "center"
      }
    }, {
      children: jsxs(Box, _assign$({
        sx: {
          width: "100vw"
        }
      }, {
        children: [jsx$1(CloseIconButtonRoot, _assign$({
          onClick: i
        }, {
          children: jsx$1(Image, {
            src: "/images/close.svg",
            alt: "Close",
            width: 20,
            height: 20
          })
        })), jsx$1(VideoPlayerRoot, {
          children: jsx$1(MediaPlayer, {
            url: null == t ? void 0 : t.videoUrl,
            width: "100%",
            height: "100%",
            controls: !1,
            playing: !0
          })
        })]
      }))
    }))]
  });
},
    Root$d = styled$2(Box)(function (e) {
  return {
    alignItems: "center",
    display: "flex",
    paddingTop: e.theme.spacing(3)
  };
}),
    CloseIconButtonRoot = styled$2(IconButton$2)(function (e) {
  return e.theme, {
    top: 0,
    right: 0,
    position: "absolute",
    zIndex: 999
  };
}),
    VideoPlayerRoot = styled$2(Box)(function (e) {
  return e.theme, {
    position: "relative",
    paddingTop: "56.25%"
  };
}),
    VideoLengthText = styled$2(Box)(function (e) {
  var t = e.theme;
  return _assign$(_assign$({}, t.typography.caption2), {
    alignSelf: "center",
    color: t.palette.primary.main,
    display: "flex",
    marginRight: 8,
    position: "relative",
    zIndex: 1,
    "&:after": {
      backgroundColor: t.palette.primary.main,
      content: '""',
      height: 1,
      margin: "-1px 0 0 4px",
      position: "absolute",
      left: "100%",
      top: "50%",
      width: 8
    }
  });
}),
    MessengerWidgetBody = function MessengerWidgetBody(e) {
  var t = useTheme$4(),
      r = e.data,
      n = useState(!1),
      a = n[0],
      o = n[1],
      i = useTransition(a, _assign$(_assign$({}, MESSENGER_CHAT_BUBBLE_ANIMATION_CONFIG), {
    reverse: !a,
    onRest: function onRest() {
      return o(!a);
    }
  }));
  return jsx$1(Root$c, {
    children: null == r ? void 0 : r.map(function (e, r) {
      return jsxs(Box, {
        children: [jsx$1(ListItem, _assign$({
          sx: {
            justifyContent: "incoming" === e.type ? "flex-start" : "flex-end",
            alignItems: "incoming" === e.type ? "flex-start" : "flex-end"
          }
        }, {
          children: jsx$1(ListItemText, {
            primary: e.message,
            sx: {
              padding: t.spacing(2, 3),
              borderRadius: t.spacing(5),
              maxWidth: 308,
              flex: "none",
              background: "incoming" === e.type ? "#EDF1F6" : "#C0F06B"
            }
          })
        })), !0 === e.isLoading && jsx$1(ListItem, {
          children: i(function (e, t) {
            return t && jsx$1(animated.div, _assign$({
              style: _assign$(_assign$({}, e), {
                width: "100%"
              })
            }, {
              children: jsx$1(Box, {
                children: jsx$1(Image, {
                  src: "/images/typing-indicator.svg",
                  alt: "bubble",
                  width: "70",
                  height: "40"
                })
              })
            }));
          })
        })]
      }, r);
    })
  });
},
    Root$c = styled$2(List)(function (e) {
  return {
    "& .MuiListItemText-primary": {
      fontSize: e.theme.spacing(1.75)
    }
  };
}),
    MessengerEmailConfirmation = function MessengerEmailConfirmation(e) {
  var t = e.data,
      r = useTheme$4(),
      n = null === (null == t ? void 0 : t.senderAvatarColor) || "" === (null == t ? void 0 : t.senderAvatarColor) ? r.palette.primary.main : "#".concat(null == t ? void 0 : t.senderAvatarColor);
  return jsx$1(EmailConfirmation, {
    senderAvatarColor: n,
    senderAvatarIcon: null == t ? void 0 : t.senderAvatarIcon,
    senderName: null == t ? void 0 : t.senderName,
    receiverName: null == t ? void 0 : t.receiverName,
    title: null == t ? void 0 : t.emailTitle,
    body: jsxs(Fragment, {
      children: [jsxs(EmailBody, {
        children: [jsx$1(EmailBodyContent, {
          children: jsx$1(Text, _assign$({
            paragraph: !0,
            variant: "caption",
            color: "black"
          }, {
            children: null == t ? void 0 : t.emailContent
          }))
        }), jsx$1(Divider, {
          variant: "middle",
          sx: {
            marginX: r.spacing(1)
          }
        })]
      }), jsx$1(StyledList, {
        children: jsx$1(MessengerWidgetBody, {
          data: t.messengerItems
        })
      })]
    })
  });
},
    EmailBody = styled$2(Box)(function (e) {
  var t = e.theme;
  return {
    textAlign: "center",
    "& .MuiList-root": {
      display: "flex",
      justifyContent: "center",
      margin: t.spacing(0, -1)
    },
    "& .MuiListItem-root": {
      padding: 0,
      width: "auto",
      whiteSpace: "pre"
    },
    "& .MuiListItemIcon-root": {
      color: t.palette.primary.main,
      minWidth: 15.5
    },
    "& .MuiListItemText-primary": {
      fontSize: t.typography.caption2.fontSize
    },
    "& .MuiTypography-root": {
      marginBottom: 0,
      textAlign: "left"
    }
  };
}),
    StyledList = styled$2(List)(function (e) {
  return {
    "& .MuiListItemText-primary": {
      fontSize: "7px"
    },
    "& .MuiListItem-root": {
      padding: "0"
    },
    "& .MuiListItemText-root": {
      maxWidth: "130px",
      padding: e.theme.spacing(1, 2)
    },
    "& .MuiList-root": {
      padding: 0
    }
  };
}),
    ReviewConfirmationWidget = function ReviewConfirmationWidget(e) {
  var t = e.data,
      r = useTheme$4(),
      n = t.senderAvatarColor,
      a = t.senderAvatarIcon,
      o = t.senderName,
      i = t.receiverName,
      s = t.emailTitle,
      l = t.emailContent,
      c = t.reviewStars,
      u = t.reviewTexts[c - 1].reviewText,
      d = null == n || "" === n ? r.palette.primary.main : "#".concat(n),
      p = new Date(),
      g = "".concat(p.getMonth(), "/").concat(p.getDate(), "/").concat(p.getFullYear());
  return jsx$1(EmailConfirmation, {
    senderAvatarColor: d,
    senderAvatarIcon: a,
    senderName: o,
    receiverName: i,
    title: s,
    body: jsxs(ReviewEmailBodyContent, {
      children: [jsxs(Paper$1, _assign$({
        variant: "outlined"
      }, {
        children: [jsx$1(Text, _assign$({
          variant: "caption2",
          color: "textSecondary",
          component: "div"
        }, {
          children: g
        })), jsx$1(Rating, {
          readOnly: !0,
          name: "simple-controlled",
          value: c,
          size: "large"
        }), jsx$1(Text, _assign$({
          variant: "caption2",
          color: "textSecondary",
          component: "div"
        }, {
          children: u
        }))]
      })), jsx$1(Paper$1, _assign$({
        elevation: 0,
        sx: {
          background: "#EDF1F6",
          marginTop: 1
        }
      }, {
        children: jsx$1(Text, _assign$({
          variant: "caption2",
          color: "textSecondary",
          component: "div"
        }, {
          children: l
        }))
      }))]
    })
  });
},
    ReviewEmailBodyContent = styled$2(Box)(function (e) {
  var t = e.theme;
  return {
    padding: t.spacing(1),
    "& .MuiPaper-root": {
      padding: t.spacing(1)
    },
    "& .MuiRating-root": {
      width: "100%",
      justifyContent: "space-between"
    },
    "& .MuiTypography-root": {
      color: "black"
    }
  };
}),
    HeroWidgetInteractionResult = function HeroWidgetInteractionResult(e) {
  var t,
      r = e.widgetType,
      n = e.data,
      a = e.widgetPayload;
  return jsx$1(Phone, _assign$({
    elevation: 24,
    showPhoneEmailShell: !0
  }, {
    children: (t = featureDemoComponents[r], jsx$1(t, {
      data: _assign$(_assign$({}, n), a)
    }))
  }));
},
    featureDemoComponents = {
  booking: BookingEmailConfirmation,
  "contact-hub": BookingEmailConfirmation,
  "email-campaign": BookingEmailConfirmation,
  invoices: BookingEmailConfirmation,
  messenger: MessengerEmailConfirmation,
  payment: BookingEmailConfirmation,
  placement: BookingEmailConfirmation,
  reviews: ReviewConfirmationWidget,
  sites: BookingEmailConfirmation
};

function FiArrowRight(e) {
  return GenIcon({
    tag: "svg",
    attr: {
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    child: [{
      tag: "line",
      attr: {
        x1: "5",
        y1: "12",
        x2: "19",
        y2: "12"
      }
    }, {
      tag: "polyline",
      attr: {
        points: "12 5 19 12 12 19"
      }
    }]
  })(e);
}

function FiCheck(e) {
  return GenIcon({
    tag: "svg",
    attr: {
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    child: [{
      tag: "polyline",
      attr: {
        points: "20 6 9 17 4 12"
      }
    }]
  })(e);
}

function FiMenu(e) {
  return GenIcon({
    tag: "svg",
    attr: {
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    child: [{
      tag: "line",
      attr: {
        x1: "3",
        y1: "12",
        x2: "21",
        y2: "12"
      }
    }, {
      tag: "line",
      attr: {
        x1: "3",
        y1: "6",
        x2: "21",
        y2: "6"
      }
    }, {
      tag: "line",
      attr: {
        x1: "3",
        y1: "18",
        x2: "21",
        y2: "18"
      }
    }]
  })(e);
}

function FiPhone(e) {
  return GenIcon({
    tag: "svg",
    attr: {
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    child: [{
      tag: "path",
      attr: {
        d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
      }
    }]
  })(e);
}

function FiSun(e) {
  return GenIcon({
    tag: "svg",
    attr: {
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    child: [{
      tag: "circle",
      attr: {
        cx: "12",
        cy: "12",
        r: "5"
      }
    }, {
      tag: "line",
      attr: {
        x1: "12",
        y1: "1",
        x2: "12",
        y2: "3"
      }
    }, {
      tag: "line",
      attr: {
        x1: "12",
        y1: "21",
        x2: "12",
        y2: "23"
      }
    }, {
      tag: "line",
      attr: {
        x1: "4.22",
        y1: "4.22",
        x2: "5.64",
        y2: "5.64"
      }
    }, {
      tag: "line",
      attr: {
        x1: "18.36",
        y1: "18.36",
        x2: "19.78",
        y2: "19.78"
      }
    }, {
      tag: "line",
      attr: {
        x1: "1",
        y1: "12",
        x2: "3",
        y2: "12"
      }
    }, {
      tag: "line",
      attr: {
        x1: "21",
        y1: "12",
        x2: "23",
        y2: "12"
      }
    }, {
      tag: "line",
      attr: {
        x1: "4.22",
        y1: "19.78",
        x2: "5.64",
        y2: "18.36"
      }
    }, {
      tag: "line",
      attr: {
        x1: "18.36",
        y1: "5.64",
        x2: "19.78",
        y2: "4.22"
      }
    }]
  })(e);
}

function VscCircleFilled(e) {
  return GenIcon({
    tag: "svg",
    attr: {
      viewBox: "0 0 16 16",
      fill: "currentColor"
    },
    child: [{
      tag: "path",
      attr: {
        d: "M8 4c.367 0 .721.048 1.063.145a3.943 3.943 0 0 1 1.762 1.031 3.944 3.944 0 0 1 1.03 1.762c.097.34.145.695.145 1.062 0 .367-.048.721-.145 1.063a3.94 3.94 0 0 1-1.03 1.765 4.017 4.017 0 0 1-1.762 1.031C8.72 11.953 8.367 12 8 12s-.721-.047-1.063-.14a4.056 4.056 0 0 1-1.765-1.032A4.055 4.055 0 0 1 4.14 9.062 3.992 3.992 0 0 1 4 8c0-.367.047-.721.14-1.063a4.02 4.02 0 0 1 .407-.953A4.089 4.089 0 0 1 5.98 4.546a3.94 3.94 0 0 1 .957-.401A3.89 3.89 0 0 1 8 4z"
      }
    }]
  })(e);
}

var MessengerWidget = function MessengerWidget(e) {
  var t = e.data,
      r = e.onDone,
      n = useTheme$4(),
      a = useState([]),
      o = a[0],
      i = a[1],
      s = useState(),
      l = s[0],
      c = s[1],
      u = useState(""),
      d = u[0],
      p = u[1];
  useEffect(function () {
    var e;

    if (t.messengerItems.length > 0) {
      var r = __spreadArray([], t.messengerItems, !0),
          n = __spreadArray([], r, !0).reverse().find(function (e) {
        return "outgoing" === e.type;
      });

      p(null !== (e = null == n ? void 0 : n.message) && void 0 !== e ? e : "");

      var a = t.messengerItems.findIndex(function (e) {
        var t;
        return null !== (t = e.id === (null == n ? void 0 : n.id)) && void 0 !== t ? t : "";
      }),
          o = __spreadArray([], r, !0).slice(0, a).map(function (e) {
        return _assign$(_assign$({}, e), {
          isLoading: !1
        });
      });

      i(o), c(n);
    }
  }, [l]);
  var g = useCallback(function () {
    p("");
    var e = l;
    i(function (t) {
      return __spreadArray(__spreadArray([], t, !0), [e], !1);
    });
    var n = t.messengerItems.findIndex(function (t) {
      return t.id === e.id;
    }) + 1,
        a = t.messengerItems[n];
    setTimeout(function () {
      i(function (t) {
        return t.map(function (t) {
          return t.id === e.id ? _assign$(_assign$({}, t), {
            isLoading: !1
          }) : t;
        });
      }), i(function (e) {
        return __spreadArray(__spreadArray([], e, !0), [_assign$(_assign$({}, a), {
          isLoading: !1
        })], !1);
      });
    }, 7e3), setTimeout(function () {
      i(function (t) {
        return t.map(function (t) {
          return t.id === e.id ? _assign$(_assign$({}, t), {
            isLoading: !0
          }) : t;
        });
      });
    }, 2e3), setTimeout(function () {
      return r(t);
    }, 9e3);
  }, [o]);
  return jsxs(Fragment, {
    children: [jsxs(Box, _assign$({
      sx: {
        background: "white",
        borderRadius: "16px"
      }
    }, {
      children: [jsx$1(ChatHeader, _assign$({
        dense: !0
      }, {
        children: jsxs(ListItem, _assign$({
          secondaryAction: jsx$1(IconBox, {
            children: jsx$1(FiPhone, {
              color: "#A5E342",
              size: 20
            })
          }),
          sx: {
            padding: n.spacing(2)
          }
        }, {
          children: [jsxs(ListItemAvatar, {
            children: [jsx$1(BusinessIconAvatar, {
              children: jsx$1(CmsImage, {
                media: t.senderAvatar,
                height: 40,
                width: 40
              })
            }), jsx$1(VscCircleFilled, {
              size: 20,
              fill: "#54AB31",
              style: {
                position: "absolute",
                top: 40,
                left: 40
              }
            })]
          }), jsx$1(ListItemText, {
            primary: t.senderName,
            secondary: "from ".concat(t.description)
          })]
        }))
      })), jsx$1(Divider, {
        variant: "middle",
        sx: {
          marginX: 0
        }
      }), jsx$1(ChatBody, {
        children: jsx$1(MessengerWidgetBody, {
          data: o
        })
      }), jsx$1(Divider, {
        variant: "middle",
        sx: {
          marginX: 0
        }
      }), jsx$1(ChatFooter, {
        children: jsx$1(SendMessageTextField, {
          variant: "standard",
          disabled: !0,
          multiline: !0,
          fullWidth: !0,
          placeholder: "Your Message",
          value: d,
          InputProps: {
            endAdornment: jsx$1(InputAdornment$2, _assign$({
              position: "end"
            }, {
              children: jsx$1(Chip, {
                label: "SEND",
                disabled: "" === d,
                onClick: g,
                sx: {
                  fontWeight: n.typography.fontWeightBold,
                  backgroundColor: "#C0F06B",
                  width: 71
                }
              })
            }))
          },
          id: "disabled-text"
        })
      })]
    })), jsx$1(MessengerChatButtonContainer, {
      children: jsx$1(Image, {
        src: "/images/chat-button.svg",
        alt: "bubble",
        width: "55",
        height: "55"
      })
    })]
  });
},
    MessengerChatButtonContainer = styled$2(Box)(function (e) {
  return {
    margin: e.theme.spacing(3, 0, 0, "auto"),
    width: "12%"
  };
}),
    SendMessageTextField = styled$2(TextField)(function (e) {
  return e.theme, {
    ".MuiInput-root:before": {
      border: "none"
    }
  };
}),
    BusinessIconAvatar = styled$2(Avatar)(function (e) {
  var t = e.theme;
  return {
    "& svg": {
      fill: e.color,
      height: 20,
      position: "relative",
      top: t.spacing(.25)
    }
  };
}),
    IconBox = styled$2(Box)(function (e) {
  var t = e.theme;
  return {
    backgroundColor: "#F7FDE8",
    borderRadius: "50%",
    padding: t.spacing(1.3, 1.3),
    display: "flex",
    alignItems: "center",
    margin: t.spacing(2)
  };
}),
    ChatHeader = styled$2(List)(function (e) {
  var t,
      r = e.theme;
  return (t = {})[r.breakpoints.down("md")] = {
    maxWidth: r.spacing(45)
  }, t.width = r.spacing(55), t.height = r.spacing(9), t.padding = r.spacing(0, 0), t["& .MuiListItem-root"] = {
    padding: r.spacing(0, 0)
  }, t["& .MuiListItemAvatar-root"] = {
    minWidth: 32
  }, t["& .MuiAvatar-root"] = {
    width: 40,
    height: 40,
    margin: r.spacing(2)
  }, t["& .MuiListItemText-root"] = {
    marginLeft: r.spacing(2)
  }, t["& .MuiListItemText-primary"] = {
    fontSize: r.typography.h4,
    fontWeight: r.typography.fontWeightSemiBold
  }, t["& .MuiListItemText-secondary"] = {
    fontSize: r.typography.caption2
  }, t["& .MuiListItemSecondaryAction-root"] = {
    right: 0
  }, t["& .MuiListItemSecondaryAction-root .MuiTypography-root"] = {
    fontSize: r.typography.pxToRem(7)
  }, t;
}),
    ChatBody = styled$2(Box)(function (e) {
  return e.theme, {
    minHeight: 278
  };
}),
    ChatFooter = styled$2(Box)(function (e) {
  return {
    "& textarea:disabled": {
      WebkitTextFillColor: "black"
    },
    "& .MuiInput-root": {
      padding: e.theme.spacing(1.8, 1.8)
    }
  };
}),
    ReviewWidget = function ReviewWidget(e) {
  var t = e.data,
      r = e.onDone,
      n = t.title,
      a = t.subtitle,
      o = t.defaultStars,
      i = t.minStars,
      s = t.media,
      l = i - 1,
      c = 5 - l,
      u = useTheme$4(),
      d = useState(Math.max(o, i) - l),
      p = d[0],
      g = d[1];
  return jsx$1(Root$b, _assign$({
    id: "Root"
  }, {
    children: jsxs(Card, _assign$({
      sx: {
        width: "calc(275px - ".concat(u.spacing(8), ")"),
        zIndex: 1
      }
    }, {
      children: [jsx$1(ReviewPhone, {
        elevation: 0
      }), jsxs(CardContent, {
        children: [jsx$1(Grid$2, _assign$({
          container: !0,
          spacing: 0,
          direction: "column",
          alignItems: "center",
          justifyContent: "center"
        }, {
          children: jsx$1(Avatar, _assign$({
            alt: "avatar",
            sx: {
              width: 60,
              height: 60
            }
          }, {
            children: jsx$1(CmsImage, {
              media: s
            })
          }))
        })), jsx$1(Text, _assign$({
          variant: "body2",
          sx: {
            marginTop: u.spacing(2),
            fontWeight: "700",
            textAlign: "center"
          }
        }, {
          children: n
        })), jsx$1(Text, _assign$({
          variant: "caption",
          sx: {
            marginTop: u.spacing(1),
            display: "block",
            textAlign: "center"
          }
        }, {
          children: a
        })), jsxs(Grid$2, _assign$({
          container: !0,
          spacing: 0,
          direction: "row",
          alignItems: "center",
          justifyContent: "center",
          sx: {
            marginTop: u.spacing(1)
          }
        }, {
          children: [jsx$1(Rating, {
            max: l,
            value: l,
            readOnly: !0
          }), jsx$1(Rating, {
            max: c,
            value: p,
            onChange: function onChange(e, t) {
              g(t = null != t ? t : p), r({
                reviewStars: t + l
              });
            }
          })]
        }))]
      })]
    }))
  }));
},
    Root$b = styled$2("div")(function (e) {
  var t,
      r = e.theme;
  return (t = {
    position: "relative",
    maxWidth: 326
  })[r.breakpoints.up("sm")] = {
    maxWidth: 560
  }, t["&"] = {
    background: "#F7F9FB"
  }, t.maxHeight = 330, t.padding = r.spacing(4), t.paddingTop = r.spacing(8), t.marginTop = r.spacing(16), t[r.breakpoints.down("md")] = {
    marginTop: 0
  }, t;
}),
    ReviewPhone = styled$2(Phone)(function (e) {
  var t = e.theme;
  return {
    width: 275,
    height: 1e3,
    color: "#787a7b",
    paddingLeft: t.spacing(2),
    paddingRight: t.spacing(2),
    paddingTop: t.spacing(1),
    borderRadius: 35,
    border: "15px solid #f0f4f6",
    boxShadow: "initial",
    position: "absolute",
    top: 0,
    left: 0,
    background: "transparent"
  };
}),
    reviewHeroWidgetModifierStyle = {
  showFade: !1,
  heroWidgetGridPropsCreator: function heroWidgetGridPropsCreator(e) {
    var t;
    return {
      md: 5,
      lg: 5,
      sx: (t = {
        paddingRight: 15
      }, t[e.breakpoints.down("md")] = {
        paddingRight: 0
      }, t["> div:first-child"] = {
        justifyContent: "initial"
      }, t)
    };
  },
  heroBodyGridPropsCreator: function heroBodyGridPropsCreator(e) {
    var t;
    return {
      md: 7,
      lg: 7,
      sx: (t = {
        paddingLeft: 15
      }, t[e.breakpoints.down("md")] = {
        paddingLeft: 0
      }, t.marginTop = e.spacing(16), t)
    };
  }
},
    reviewHeroCTAMessageFormatter = function reviewHeroCTAMessageFormatter(e, t) {
  var r, n;
  return template_1(null === (r = null == e ? void 0 : e.heroCTA) || void 0 === r ? void 0 : r.smsContent)({
    a: null !== (n = null == t ? void 0 : t.reviewStars) && void 0 !== n ? n : "review smsContent"
  });
},
    HeroWidgetComponent = function HeroWidgetComponent(e) {
  var t = e.data,
      r = e.widgetType,
      n = e.onSubmit,
      a = useState(!0),
      o = a[0],
      i = a[1],
      s = featureWidgetComponents[r];
  return jsx$1(Fragment, {
    children: jsx$1(WidgetContainer$1, _assign$({
      styleProps: {
        isAnimationActive: !o
      }
    }, {}, {
      children: jsx$1(s, {
        data: null == t ? void 0 : t.widget,
        onDone: function onDone(e) {
          void 0 !== n && (n(e), i(!1));
        }
      })
    }))
  });
},
    WidgetContainer$1 = styled$2(Box)(function (e) {
  var t,
      r = e.theme,
      n = e.styleProps;
  return _assign$({
    borderRadius: r.spacing(2)
  }, null !== (t = n.widgetStyle(r)) && void 0 !== t ? t : {});
}),
    heroWidgetModifierStyles = {
  reviews: reviewHeroWidgetModifierStyle
},
    featureWidgetComponents = {
  booking: BookingWidget,
  "contact-hub": BookingWidget,
  "email-campaign": BookingWidget,
  invoices: BookingWidget,
  messenger: MessengerWidget,
  payment: BookingWidget,
  placement: BookingWidget,
  reviews: ReviewWidget,
  sites: BookingWidget
},
    router = router$1,
    Hero = function Hero(e) {
  var t,
      r,
      n,
      a = e.data,
      o = useTheme$4(),
      i = router.useRouter(),
      s = useMediaQuery(o.breakpoints.up("md")),
      l = useReducer(reducer$1, initialState$3),
      c = l[0],
      u = l[1],
      d = null == a ? void 0 : a.__component.split("sections.hero-")[1],
      p = null !== (t = heroWidgetModifierStyles[d]) && void 0 !== t ? t : {},
      g = p.showFade,
      m = void 0 === g || g,
      f = p.fadeStyleCreator,
      h = void 0 === f ? function () {} : f,
      b = p.bodyStyleCreator,
      y = void 0 === b ? function () {} : b,
      v = p.heroBodyGridPropsCreator,
      _ = void 0 === v ? function () {} : v,
      T = p.heroWidgetGridPropsCreator,
      E = void 0 === T ? function () {} : T,
      S = useTransition(c.isWidgetVisible, _assign$(_assign$({}, HERO_WIDGET_ANIMATION_CONFIG), {
    reverse: !c.isWidgetVisible
  })),
      x = useTransition(c.isCallToActionVisible, _assign$(_assign$({}, HERO_CTA_CONFIG), {
    reverse: !c.isCallToActionVisible
  })),
      w = useTransition(c.isWidgetInteractionResultVisible, _assign$(_assign$({}, HERO_WIDGET_INTERACTION_RESULT_ANIMATION_CONFIG), {
    reverse: !c.isWidgetInteractionResultVisible
  })),
      C = useTransition(c.isSignUpFormVisible, _assign$(_assign$({}, HERO_SIGN_UP_FORM_ANIMATION_CONFIG), {
    reverse: !c.isSignUpFormVisible
  })),
      k = useTransition(c.isWidgetInteractionResultVisible, _assign$(_assign$({}, HERO_CTA_BUTTON_ANIMATION_CONFIG), {
    reverse: !c.isWidgetInteractionResultVisible
  })),
      $ = function $(e) {
    u({
      type: "setWidgetPayload",
      payload: e
    });
  },
      R = function R(e) {
    u({
      type: "setIsWidgetInteractionResultVisible",
      payload: !0
    }), u({
      type: "setPhoneNumber",
      payload: e
    });
    var t = A(d)(a, c.widgetPayload);
    sendSMS({
      phone: e,
      message: t
    }).catch(function () {
      return console.error("A problem occured while sending an SMS to phone number", e);
    });
  },
      A = function A(e) {
    var t,
        r = function r() {
      return "Not Yet Implemented";
    };

    return null !== (t = {
      booking: bookingHeroCTAMessageFormatter,
      "contact-hub": r,
      "email-campaign": r,
      invoices: r,
      messenger: r,
      payment: r,
      placement: r,
      reviews: reviewHeroCTAMessageFormatter,
      sites: r
    }[e]) && void 0 !== t ? t : r;
  },
      I = function I(e) {
    u({
      type: "setEmail",
      payload: e
    });
    var t = {
      email: e,
      phonenumber: c.phoneNumber,
      bookingdatetime: c.widgetPayload.bookingDateTime
    },
        r = "https://cloud.gosite.run/signup?info=" + Base64.encode(JSON.stringify(_assign$({}, t)));
    i.push(r).catch(function () {});
  },
      N = function N() {
    u({
      type: "setIsSignUpFormVisible",
      payload: !0
    });
  },
      P = function P() {
    var e, t, r;
    return jsxs(HeroCtaContainer, _assign$({
      pt: 5,
      pb: 4
    }, {
      children: [jsxs(Text, _assign$({
        variant: "body2"
      }, {
        children: [!c.isWidgetInteractionResultVisible && !c.isSignUpFormVisible && (null === (e = a.body) || void 0 === e ? void 0 : e.widgetTryOutText), c.isWidgetInteractionResultVisible && (null === (t = a.body) || void 0 === t ? void 0 : t.widgetInteractionResultText), c.isSignUpFormVisible && (null === (r = a.body) || void 0 === r ? void 0 : r.signUpText)]
      })), k(function (e, t) {
        return t && jsx$1(animated.div, _assign$({
          style: _assign$({}, e)
        }, {
          children: c.isWidgetInteractionResultVisible && jsx$1(Button, _assign$({
            variant: "outlined",
            sx: {
              mt: 2
            },
            onClick: N
          }, {
            children: a.body.ctaButtonText
          }))
        }));
      }), c.isSignUpFormVisible && jsx$1(HeroTestimonial, {
        data: null == a ? void 0 : a.testimonial
      })]
    }));
  };

  return useEffect(function () {
    u({
      type: "setIsWidgetVisible",
      payload: !0
    });
  }, []), jsx$1(Root$a, {
    children: jsx$1(Container, {
      children: jsxs(Grid$2, _assign$({
        container: !0
      }, {
        children: [jsx$1(Grid$2, _assign$({
          item: !0,
          xs: 12,
          md: 4,
          lg: 5
        }, _(o), {
          children: jsx$1(HeroBody, {
            bodyStyle: null !== (r = y(o)) && void 0 !== r ? r : {},
            data: a,
            renderHeroCtaContent: s ? P() : jsx$1(Text, _assign$({
              variant: "body2",
              pt: 5
            }, {
              children: !c.isWidgetInteractionResultVisible && !c.isSignUpFormVisible && (null === (n = a.body) || void 0 === n ? void 0 : n.widgetTryOutText)
            }))
          })
        })), jsxs(Grid$2, _assign$({
          item: !0,
          xs: 12,
          md: 8,
          lg: 7
        }, E(o), {
          children: [jsxs(WidgetContainer, {
            children: [m && x(function (e, t) {
              var r;
              return t && jsx$1(animated.div, _assign$({
                style: _assign$(_assign$({}, e), {
                  position: "absolute",
                  top: 0,
                  left: 0,
                  bottom: 0,
                  right: 0
                })
              }, {
                children: jsx$1(Fade, {
                  sx: null !== (r = h(o)) && void 0 !== r ? r : {}
                })
              }));
            }), Object.values(Feature).includes(d) && jsx$1(Fragment, {
              children: S(function (e, t) {
                return t && jsx$1(animated.div, _assign$({
                  style: _assign$(_assign$({}, e), {
                    zIndex: 1
                  })
                }, {
                  children: jsx$1(HeroWidgetComponent, {
                    data: a,
                    widgetType: d,
                    onSubmit: $
                  })
                }));
              })
            }), x(function (e, t) {
              return t && jsx$1(animated.div, _assign$({
                style: _assign$(_assign$({}, e), {
                  position: "relative",
                  zIndex: 1
                })
              }, {
                children: jsx$1(HeroCta, {
                  data: null == a ? void 0 : a.heroCTA,
                  onSubmit: R
                })
              }));
            }), w(function (e, t) {
              return t && jsx$1(animated.div, _assign$({
                style: _assign$(_assign$({}, e), {
                  position: "absolute"
                })
              }, {
                children: jsx$1(HeroWidgetInteractionResult, {
                  data: _assign$(_assign$({}, null == a ? void 0 : a.widget), null == a ? void 0 : a.email),
                  widgetPayload: c.widgetPayload,
                  widgetType: d
                })
              }));
            }), C(function (e, t) {
              return t && jsx$1(animated.div, _assign$({
                style: _assign$(_assign$({}, e), {
                  width: "100%"
                })
              }, {
                children: jsx$1(HeroSignUpForm, {
                  data: null == a ? void 0 : a.signUpForm,
                  onSubmit: I
                })
              }));
            })]
          }), !s && (c.isWidgetInteractionResultVisible || c.isSignUpFormVisible) && P()]
        }))]
      }))
    })
  });
},
    Root$a = styled$2(Box)(function (e) {
  var t;
  return (t = {
    backgroundColor: "#F7F9FB",
    alignItems: "center",
    display: "flex",
    overflow: "hidden",
    paddingTop: 100
  })[e.theme.breakpoints.up("lg")] = {
    height: 720
  }, t;
}),
    HeroCtaContainer = styled$2(Box)(function (e) {
  return e.theme, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center"
  };
}),
    WidgetContainer = styled$2(Box)(function (e) {
  var t;
  return (t = {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center"
  })[e.theme.breakpoints.down("md")] = {
    minHeight: 400
  }, t.minHeight = 600, t.position = "relative", t.transition = "min-height 1s ease-out", t;
}),
    Fade = styled$2(Box)(function () {
  return {
    background: "linear-gradient(180deg, rgba(247,249,251,1) 0%, rgba(247,249,251,1) 75%, rgba(247,249,251,0) 100%)",
    height: 600,
    width: "100%",
    zIndex: 9,
    position: "absolute",
    top: -300
  };
}),
    initialState$3 = {
  isWidgetVisible: !1,
  isCallToActionVisible: !1,
  isWidgetInteractionResultVisible: !1,
  isSignUpFormVisible: !1,
  widgetPayload: {
    bookingDateTime: new Date(),
    reviewStars: 4
  },
  phoneNumber: 123,
  email: ""
},
    reducer$1 = function reducer$1(e, t) {
  switch (t.type) {
    case "setIsWidgetVisible":
      return _assign$(_assign$({}, e), {
        isWidgetVisible: t.payload,
        isWidgetInteractionResultVisible: !1
      });

    case "setIsWidgetInteractionResultVisible":
      return _assign$(_assign$({}, e), {
        isWidgetVisible: !1,
        isCallToActionVisible: !1,
        isWidgetInteractionResultVisible: t.payload
      });

    case "setIsSignUpFormVisible":
      return _assign$(_assign$({}, e), {
        isWidgetVisible: !1,
        isCallToActionVisible: !1,
        isWidgetInteractionResultVisible: !1,
        isSignUpFormVisible: t.payload
      });

    case "setWidgetPayload":
      return _assign$(_assign$({}, e), {
        widgetPayload: t.payload,
        isCallToActionVisible: !0
      });

    case "setPhoneNumber":
      return _assign$(_assign$({}, e), {
        phoneNumber: t.payload
      });

    case "setEmail":
      return _assign$(_assign$({}, e), {
        email: t.payload
      });

    default:
      throw new Error();
  }
},
    HoverPopover$1 = {},
    interopRequireDefault = {
  exports: {}
};

!function (e) {
  e.exports = function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }, e.exports.__esModule = !0, e.exports.default = e.exports;
}(interopRequireDefault);
var _typeof = {
  exports: {}
};
!function (e) {
  function t(r) {
    return e.exports = t = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    }, e.exports.__esModule = !0, e.exports.default = e.exports, t(r);
  }

  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
}(_typeof);
var hoverWorkaround = {},
    _extends$1 = {
  exports: {}
};
!function (e) {
  function t() {
    return e.exports = t = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];

        for (var n in r) {
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
        }
      }

      return e;
    }, e.exports.__esModule = !0, e.exports.default = e.exports, t.apply(this, arguments);
  }

  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
}(_extends$1);
var defineProperty = {
  exports: {}
};
!function (e) {
  e.exports = function (e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = r, e;
  }, e.exports.__esModule = !0, e.exports.default = e.exports;
}(defineProperty);
var objectWithoutProperties = {
  exports: {}
},
    objectWithoutPropertiesLoose = {
  exports: {}
};
!function (e) {
  e.exports = function (e, t) {
    if (null == e) return {};
    var r,
        n,
        a = {},
        o = Object.keys(e);

    for (n = 0; n < o.length; n++) {
      r = o[n], t.indexOf(r) >= 0 || (a[r] = e[r]);
    }

    return a;
  }, e.exports.__esModule = !0, e.exports.default = e.exports;
}(objectWithoutPropertiesLoose), function (e) {
  var t = objectWithoutPropertiesLoose.exports;
  e.exports = function (e, r) {
    if (null == e) return {};
    var n,
        a,
        o = t(e, r);

    if (Object.getOwnPropertySymbols) {
      var i = Object.getOwnPropertySymbols(e);

      for (a = 0; a < i.length; a++) {
        n = i[a], r.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
      }
    }

    return o;
  }, e.exports.__esModule = !0, e.exports.default = e.exports;
}(objectWithoutProperties), function (e) {
  var t = interopRequireDefault.exports,
      r = _typeof.exports;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = function (e) {
    return i.forwardRef(function (t, r) {
      var a = t.PaperProps,
          l = t.style,
          c = (0, o.default)(t, s);
      return i.createElement(e, (0, n.default)({}, c, {
        ref: r,
        style: u({
          pointerEvents: "none"
        }, l),
        PaperProps: u(u({}, a), {}, {
          style: u({
            pointerEvents: "auto"
          }, null == a ? void 0 : a.style)
        })
      }));
    });
  };

  var n = t(_extends$1.exports),
      a = t(defineProperty.exports),
      o = t(objectWithoutProperties.exports),
      i = function (e, t) {
    if (!t && e && e.__esModule) return e;
    if (null === e || "object" !== r(e) && "function" != typeof e) return {
      default: e
    };
    var n = l(t);
    if (n && n.has(e)) return n.get(e);
    var a = {},
        o = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var i in e) {
      if ("default" !== i && Object.prototype.hasOwnProperty.call(e, i)) {
        var s = o ? Object.getOwnPropertyDescriptor(e, i) : null;
        s && (s.get || s.set) ? Object.defineProperty(a, i, s) : a[i] = e[i];
      }
    }

    a.default = e, n && n.set(e, a);
    return a;
  }(React__default),
      s = ["PaperProps", "style"];

  function l(e) {
    if ("function" != typeof WeakMap) return null;
    var t = new WeakMap(),
        r = new WeakMap();
    return (l = function l(e) {
      return e ? r : t;
    })(e);
  }

  function c(e, t) {
    var r = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), r.push.apply(r, n);
    }

    return r;
  }

  function u(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = null != arguments[t] ? arguments[t] : {};
      t % 2 ? c(Object(r), !0).forEach(function (t) {
        (0, a.default)(e, t, r[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : c(Object(r)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
      });
    }

    return e;
  }
}(hoverWorkaround);
var _excluded$3 = ["addEndListener", "appear", "children", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"];

function getScale(e) {
  return "scale(".concat(e, ", ").concat(Math.pow(e, 2), ")");
}

var styles = {
  entering: {
    opacity: 1,
    transform: getScale(1)
  },
  entered: {
    opacity: 1,
    transform: "none"
  }
},
    Grow = React.forwardRef(function (e, t) {
  var r = e.addEndListener,
      _e$appear2 = e.appear,
      n = _e$appear2 === void 0 ? !0 : _e$appear2,
      a = e.children,
      o = e.easing,
      i = e.in,
      s = e.onEnter,
      l = e.onEntered,
      c = e.onEntering,
      u = e.onExit,
      d = e.onExited,
      p = e.onExiting,
      g = e.style,
      _e$timeout2 = e.timeout,
      m = _e$timeout2 === void 0 ? "auto" : _e$timeout2,
      _e$TransitionComponen2 = e.TransitionComponent,
      f = _e$TransitionComponen2 === void 0 ? Transition$1 : _e$TransitionComponen2,
      h = _objectWithoutPropertiesLoose$4(e, _excluded$3),
      b = React.useRef(),
      y = React.useRef(),
      v = useTheme(),
      _ = React.useRef(null),
      T = useForkRef(a.ref, t),
      E = useForkRef(_, T),
      S = function S(e) {
    return function (t) {
      if (e) {
        var _r33 = _.current;
        void 0 === t ? e(_r33) : e(_r33, t);
      }
    };
  },
      x = S(c),
      w = S(function (e, t) {
    reflow(e);

    var _getTransitionProps3 = getTransitionProps({
      style: g,
      timeout: m,
      easing: o
    }, {
      mode: "enter"
    }),
        r = _getTransitionProps3.duration,
        n = _getTransitionProps3.delay,
        a = _getTransitionProps3.easing;

    var i;
    "auto" === m ? (i = v.transitions.getAutoHeightDuration(e.clientHeight), y.current = i) : i = r, e.style.transition = [v.transitions.create("opacity", {
      duration: i,
      delay: n
    }), v.transitions.create("transform", {
      duration: .666 * i,
      delay: n,
      easing: a
    })].join(","), s && s(e, t);
  }),
      C = S(l),
      k = S(p),
      $ = S(function (e) {
    var _getTransitionProps4 = getTransitionProps({
      style: g,
      timeout: m,
      easing: o
    }, {
      mode: "exit"
    }),
        t = _getTransitionProps4.duration,
        r = _getTransitionProps4.delay,
        n = _getTransitionProps4.easing;

    var a;
    "auto" === m ? (a = v.transitions.getAutoHeightDuration(e.clientHeight), y.current = a) : a = t, e.style.transition = [v.transitions.create("opacity", {
      duration: a,
      delay: r
    }), v.transitions.create("transform", {
      duration: .666 * a,
      delay: r || .333 * a,
      easing: n
    })].join(","), e.style.opacity = "0", e.style.transform = getScale(.75), u && u(e);
  }),
      R = S(d);

  return React.useEffect(function () {
    return function () {
      clearTimeout(b.current);
    };
  }, []), jsx$1(f, _extends$e({
    appear: n,
    in: i,
    nodeRef: _,
    onEnter: w,
    onEntered: C,
    onEntering: x,
    onExit: $,
    onExited: R,
    onExiting: k,
    addEndListener: function addEndListener(e) {
      "auto" === m && (b.current = setTimeout(e, y.current || 0)), r && r(_.current, e);
    },
    timeout: "auto" === m ? null : m
  }, h, {
    children: function children(e, t) {
      return React.cloneElement(a, _extends$e({
        style: _extends$e({
          opacity: 0,
          transform: getScale(.75),
          visibility: "exited" !== e || i ? void 0 : "hidden"
        }, styles[e], g, a.props.style),
        ref: E
      }, t));
    }
  }));
});
"production" !== process.env.NODE_ENV && (Grow.propTypes = {
  addEndListener: PropTypes.func,
  appear: PropTypes.bool,
  children: elementAcceptingRef$1.isRequired,
  easing: PropTypes.oneOfType([PropTypes.shape({
    enter: PropTypes.string,
    exit: PropTypes.string
  }), PropTypes.string]),
  in: PropTypes.bool,
  onEnter: PropTypes.func,
  onEntered: PropTypes.func,
  onEntering: PropTypes.func,
  onExit: PropTypes.func,
  onExited: PropTypes.func,
  onExiting: PropTypes.func,
  style: PropTypes.object,
  timeout: PropTypes.oneOfType([PropTypes.oneOf(["auto"]), PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })])
}), Grow.muiSupportAuto = !0;

var _excluded$2 = ["children", "components", "componentsProps", "className", "invisible", "open", "transitionDuration", "TransitionComponent"],
    extendUtilityClasses$1 = function extendUtilityClasses$1(e) {
  var t = e.classes;
  return t;
},
    BackdropRoot = styled("div", {
  name: "MuiBackdrop",
  slot: "Root",
  overridesResolver: function overridesResolver(e, t) {
    var r = e.ownerState;
    return [t.root, r.invisible && t.invisible];
  }
})(function (_ref110) {
  var e = _ref110.ownerState;
  return _extends$e({
    position: "fixed",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    right: 0,
    bottom: 0,
    top: 0,
    left: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    WebkitTapHighlightColor: "transparent"
  }, e.invisible && {
    backgroundColor: "transparent"
  });
}),
    Backdrop = React.forwardRef(function (e, t) {
  var r;

  var n = useThemeProps({
    props: e,
    name: "MuiBackdrop"
  }),
      a = n.children,
      _n$components = n.components,
      o = _n$components === void 0 ? {} : _n$components,
      _n$componentsProps = n.componentsProps,
      i = _n$componentsProps === void 0 ? {} : _n$componentsProps,
      s = n.className,
      _n$invisible = n.invisible,
      l = _n$invisible === void 0 ? !1 : _n$invisible,
      c = n.open,
      u = n.transitionDuration,
      _n$TransitionComponen = n.TransitionComponent,
      d = _n$TransitionComponen === void 0 ? Fade$1 : _n$TransitionComponen,
      p = _objectWithoutPropertiesLoose$4(n, _excluded$2),
      g = _extends$e({}, n, {
    invisible: l
  }),
      m = extendUtilityClasses$1(g);

  return jsx$1(d, _extends$e({
    in: c,
    timeout: u
  }, p, {
    children: jsx$1(BackdropUnstyled, {
      className: s,
      invisible: l,
      components: _extends$e({
        Root: BackdropRoot
      }, o),
      componentsProps: {
        root: _extends$e({}, i.root, (!o.Root || !isHostComponent(o.Root)) && {
          ownerState: _extends$e({}, null == (r = i.root) ? void 0 : r.ownerState)
        })
      },
      classes: m,
      ref: t,
      children: a
    })
  }));
});

"production" !== process.env.NODE_ENV && (Backdrop.propTypes = {
  children: PropTypes.node,
  classes: PropTypes.object,
  className: PropTypes.string,
  components: PropTypes.shape({
    Root: PropTypes.elementType
  }),
  componentsProps: PropTypes.shape({
    root: PropTypes.object
  }),
  invisible: PropTypes.bool,
  open: PropTypes.bool.isRequired,
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  transitionDuration: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })])
});

var _excluded$1 = ["BackdropComponent", "closeAfterTransition", "children", "components", "componentsProps", "disableAutoFocus", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "disableScrollLock", "hideBackdrop", "keepMounted"],
    extendUtilityClasses = function extendUtilityClasses(e) {
  return e.classes;
},
    ModalRoot = styled("div", {
  name: "MuiModal",
  slot: "Root",
  overridesResolver: function overridesResolver(e, t) {
    var r = e.ownerState;
    return [t.root, !r.open && r.exited && t.hidden];
  }
})(function (_ref111) {
  var e = _ref111.theme,
      t = _ref111.ownerState;
  return _extends$e({
    position: "fixed",
    zIndex: e.zIndex.modal,
    right: 0,
    bottom: 0,
    top: 0,
    left: 0
  }, !t.open && t.exited && {
    visibility: "hidden"
  });
}),
    ModalBackdrop = styled(Backdrop, {
  name: "MuiModal",
  slot: "Backdrop",
  overridesResolver: function overridesResolver(e, t) {
    return t.backdrop;
  }
})({
  zIndex: -1
}),
    Modal = React.forwardRef(function (e, t) {
  var r;

  var n = useThemeProps({
    name: "MuiModal",
    props: e
  }),
      _n$BackdropComponent = n.BackdropComponent,
      a = _n$BackdropComponent === void 0 ? ModalBackdrop : _n$BackdropComponent,
      _n$closeAfterTransiti = n.closeAfterTransition,
      o = _n$closeAfterTransiti === void 0 ? !1 : _n$closeAfterTransiti,
      i = n.children,
      _n$components2 = n.components,
      s = _n$components2 === void 0 ? {} : _n$components2,
      _n$componentsProps2 = n.componentsProps,
      l = _n$componentsProps2 === void 0 ? {} : _n$componentsProps2,
      _n$disableAutoFocus = n.disableAutoFocus,
      c = _n$disableAutoFocus === void 0 ? !1 : _n$disableAutoFocus,
      _n$disableEnforceFocu = n.disableEnforceFocus,
      u = _n$disableEnforceFocu === void 0 ? !1 : _n$disableEnforceFocu,
      _n$disableEscapeKeyDo = n.disableEscapeKeyDown,
      d = _n$disableEscapeKeyDo === void 0 ? !1 : _n$disableEscapeKeyDo,
      _n$disablePortal = n.disablePortal,
      p = _n$disablePortal === void 0 ? !1 : _n$disablePortal,
      _n$disableRestoreFocu = n.disableRestoreFocus,
      g = _n$disableRestoreFocu === void 0 ? !1 : _n$disableRestoreFocu,
      _n$disableScrollLock = n.disableScrollLock,
      m = _n$disableScrollLock === void 0 ? !1 : _n$disableScrollLock,
      _n$hideBackdrop = n.hideBackdrop,
      f = _n$hideBackdrop === void 0 ? !1 : _n$hideBackdrop,
      _n$keepMounted = n.keepMounted,
      h = _n$keepMounted === void 0 ? !1 : _n$keepMounted,
      b = _objectWithoutPropertiesLoose$4(n, _excluded$1),
      _React$useState31 = React.useState(!0),
      _React$useState32 = _slicedToArray(_React$useState31, 2),
      y = _React$useState32[0],
      v = _React$useState32[1],
      _ = {
    closeAfterTransition: o,
    disableAutoFocus: c,
    disableEnforceFocus: u,
    disableEscapeKeyDown: d,
    disablePortal: p,
    disableRestoreFocus: g,
    disableScrollLock: m,
    hideBackdrop: f,
    keepMounted: h
  },
      T = _extends$e({}, n, _, {
    exited: y
  }),
      E = extendUtilityClasses(T);

  return jsx$1(ModalUnstyled, _extends$e({
    components: _extends$e({
      Root: ModalRoot
    }, s),
    componentsProps: {
      root: _extends$e({}, l.root, (!s.Root || !isHostComponent(s.Root)) && {
        ownerState: _extends$e({}, null == (r = l.root) ? void 0 : r.ownerState)
      })
    },
    BackdropComponent: a,
    onTransitionEnter: function onTransitionEnter() {
      return v(!1);
    },
    onTransitionExited: function onTransitionExited() {
      return v(!0);
    },
    ref: t
  }, b, {
    classes: E
  }, _, {
    children: i
  }));
});

function getPopoverUtilityClass(e) {
  return generateUtilityClass("MuiPopover", e);
}

"production" !== process.env.NODE_ENV && (Modal.propTypes = {
  BackdropComponent: PropTypes.elementType,
  BackdropProps: PropTypes.object,
  children: elementAcceptingRef$1.isRequired,
  classes: PropTypes.object,
  closeAfterTransition: PropTypes.bool,
  components: PropTypes.shape({
    Root: PropTypes.elementType
  }),
  componentsProps: PropTypes.shape({
    root: PropTypes.object
  }),
  container: PropTypes.oneOfType([HTMLElementType, PropTypes.func]),
  disableAutoFocus: PropTypes.bool,
  disableEnforceFocus: PropTypes.bool,
  disableEscapeKeyDown: PropTypes.bool,
  disablePortal: PropTypes.bool,
  disableRestoreFocus: PropTypes.bool,
  disableScrollLock: PropTypes.bool,
  hideBackdrop: PropTypes.bool,
  keepMounted: PropTypes.bool,
  onBackdropClick: PropTypes.func,
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired,
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});
var popoverClasses = generateUtilityClasses("MuiPopover", ["root", "paper"]);
var popoverClasses$1 = popoverClasses;
var _excluded = ["onEntering"],
    _excluded2 = ["action", "anchorEl", "anchorOrigin", "anchorPosition", "anchorReference", "children", "className", "container", "elevation", "marginThreshold", "open", "PaperProps", "transformOrigin", "TransitionComponent", "transitionDuration", "TransitionProps"];

function getOffsetTop(e, t) {
  var r = 0;
  return "number" == typeof t ? r = t : "center" === t ? r = e.height / 2 : "bottom" === t && (r = e.height), r;
}

function getOffsetLeft(e, t) {
  var r = 0;
  return "number" == typeof t ? r = t : "center" === t ? r = e.width / 2 : "right" === t && (r = e.width), r;
}

function getTransformOriginValue(e) {
  return [e.horizontal, e.vertical].map(function (e) {
    return "number" == typeof e ? "".concat(e, "px") : e;
  }).join(" ");
}

function resolveAnchorEl(e) {
  return "function" == typeof e ? e() : e;
}

var useUtilityClasses = function useUtilityClasses(e) {
  var t = e.classes;
  return composeClasses({
    root: ["root"],
    paper: ["paper"]
  }, getPopoverUtilityClass, t);
},
    PopoverRoot = styled(Modal, {
  name: "MuiPopover",
  slot: "Root",
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})({}),
    PopoverPaper = styled(Paper, {
  name: "MuiPopover",
  slot: "Paper",
  overridesResolver: function overridesResolver(e, t) {
    return t.paper;
  }
})({
  position: "absolute",
  overflowY: "auto",
  overflowX: "hidden",
  minWidth: 16,
  minHeight: 16,
  maxWidth: "calc(100% - 32px)",
  maxHeight: "calc(100% - 32px)",
  outline: 0
}),
    Popover$2 = React.forwardRef(function (e, t) {
  var r = useThemeProps({
    props: e,
    name: "MuiPopover"
  }),
      n = r.action,
      a = r.anchorEl,
      _r$anchorOrigin = r.anchorOrigin,
      o = _r$anchorOrigin === void 0 ? {
    vertical: "top",
    horizontal: "left"
  } : _r$anchorOrigin,
      i = r.anchorPosition,
      _r$anchorReference = r.anchorReference,
      s = _r$anchorReference === void 0 ? "anchorEl" : _r$anchorReference,
      l = r.children,
      c = r.className,
      u = r.container,
      _r$elevation2 = r.elevation,
      d = _r$elevation2 === void 0 ? 8 : _r$elevation2,
      _r$marginThreshold = r.marginThreshold,
      p = _r$marginThreshold === void 0 ? 16 : _r$marginThreshold,
      g = r.open,
      _r$PaperProps = r.PaperProps,
      m = _r$PaperProps === void 0 ? {} : _r$PaperProps,
      _r$transformOrigin = r.transformOrigin,
      f = _r$transformOrigin === void 0 ? {
    vertical: "top",
    horizontal: "left"
  } : _r$transformOrigin,
      _r$TransitionComponen3 = r.TransitionComponent,
      h = _r$TransitionComponen3 === void 0 ? Grow : _r$TransitionComponen3,
      _r$transitionDuration = r.transitionDuration,
      b = _r$transitionDuration === void 0 ? "auto" : _r$transitionDuration,
      _r$TransitionProps = r.TransitionProps;
  _r$TransitionProps = _r$TransitionProps === void 0 ? {} : _r$TransitionProps;

  var y = _r$TransitionProps.onEntering,
      v = _objectWithoutPropertiesLoose$4(r.TransitionProps, _excluded),
      _ = _objectWithoutPropertiesLoose$4(r, _excluded2),
      T = React.useRef(),
      E = useForkRef(T, m.ref),
      S = _extends$e({}, r, {
    anchorOrigin: o,
    anchorReference: s,
    elevation: d,
    marginThreshold: p,
    PaperProps: m,
    transformOrigin: f,
    TransitionComponent: h,
    transitionDuration: b,
    TransitionProps: v
  }),
      x = useUtilityClasses(S),
      w = React.useCallback(function () {
    if ("anchorPosition" === s) return "production" !== process.env.NODE_ENV && (i || console.error('MUI: You need to provide a `anchorPosition` prop when using <Popover anchorReference="anchorPosition" />.')), i;
    var e = resolveAnchorEl(a),
        t = e && 1 === e.nodeType ? e : ownerDocument(T.current).body,
        r = t.getBoundingClientRect();

    if ("production" !== process.env.NODE_ENV) {
      var _e55 = t.getBoundingClientRect();

      "test" !== process.env.NODE_ENV && 0 === _e55.top && 0 === _e55.left && 0 === _e55.right && 0 === _e55.bottom && console.warn(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join("\n"));
    }

    return {
      top: r.top + getOffsetTop(r, o.vertical),
      left: r.left + getOffsetLeft(r, o.horizontal)
    };
  }, [a, o.horizontal, o.vertical, i, s]),
      C = React.useCallback(function (e) {
    return {
      vertical: getOffsetTop(e, f.vertical),
      horizontal: getOffsetLeft(e, f.horizontal)
    };
  }, [f.horizontal, f.vertical]),
      k = React.useCallback(function (e) {
    var t = {
      width: e.offsetWidth,
      height: e.offsetHeight
    },
        r = C(t);
    if ("none" === s) return {
      top: null,
      left: null,
      transformOrigin: getTransformOriginValue(r)
    };
    var n = w();
    var o = n.top - r.vertical,
        i = n.left - r.horizontal;
    var l = o + t.height,
        c = i + t.width,
        u = ownerWindow(resolveAnchorEl(a)),
        d = u.innerHeight - p,
        g = u.innerWidth - p;

    if (o < p) {
      var _e56 = o - p;

      o -= _e56, r.vertical += _e56;
    } else if (l > d) {
      var _e57 = l - d;

      o -= _e57, r.vertical += _e57;
    }

    if ("production" !== process.env.NODE_ENV && t.height > d && t.height && d && console.error(["MUI: The popover component is too tall.", "Some part of it can not be seen on the screen (".concat(t.height - d, "px)."), "Please consider adding a `max-height` to improve the user-experience."].join("\n")), i < p) {
      var _e58 = i - p;

      i -= _e58, r.horizontal += _e58;
    } else if (c > g) {
      var _e59 = c - g;

      i -= _e59, r.horizontal += _e59;
    }

    return {
      top: "".concat(Math.round(o), "px"),
      left: "".concat(Math.round(i), "px"),
      transformOrigin: getTransformOriginValue(r)
    };
  }, [a, s, w, C, p]),
      $ = React.useCallback(function () {
    var e = T.current;
    if (!e) return;
    var t = k(e);
    null !== t.top && (e.style.top = t.top), null !== t.left && (e.style.left = t.left), e.style.transformOrigin = t.transformOrigin;
  }, [k]);

  React.useEffect(function () {
    g && $();
  }), React.useImperativeHandle(n, function () {
    return g ? {
      updatePosition: function updatePosition() {
        $();
      }
    } : null;
  }, [g, $]), React.useEffect(function () {
    if (!g) return;
    var e = debounce(function () {
      $();
    }),
        t = ownerWindow(a);
    return t.addEventListener("resize", e), function () {
      e.clear(), t.removeEventListener("resize", e);
    };
  }, [a, g, $]);
  var R = b;
  "auto" !== b || h.muiSupportAuto || (R = void 0);
  var A = u || (a ? ownerDocument(resolveAnchorEl(a)).body : void 0);
  return jsx$1(PopoverRoot, _extends$e({
    BackdropProps: {
      invisible: !0
    },
    className: clsx(x.root, c),
    container: A,
    open: g,
    ref: t,
    ownerState: S
  }, _, {
    children: jsx$1(h, _extends$e({
      appear: !0,
      in: g,
      onEntering: function onEntering(e, t) {
        y && y(e, t), $();
      },
      timeout: R
    }, v, {
      children: jsx$1(PopoverPaper, _extends$e({
        elevation: d
      }, m, {
        ref: E,
        className: clsx(x.paper, m.className),
        children: l
      }))
    }))
  }));
});

"production" !== process.env.NODE_ENV && (Popover$2.propTypes = {
  action: refType$1,
  anchorEl: chainPropTypes(PropTypes.oneOfType([HTMLElementType, PropTypes.func]), function (e) {
    if (e.open && (!e.anchorReference || "anchorEl" === e.anchorReference)) {
      var _t47 = resolveAnchorEl(e.anchorEl);

      if (!_t47 || 1 !== _t47.nodeType) return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "It should be an Element instance but it's `".concat(_t47, "` instead.")].join("\n"));
      {
        var _e60 = _t47.getBoundingClientRect();

        if ("test" !== process.env.NODE_ENV && 0 === _e60.top && 0 === _e60.left && 0 === _e60.right && 0 === _e60.bottom) return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join("\n"));
      }
    }

    return null;
  }),
  anchorOrigin: PropTypes.shape({
    horizontal: PropTypes.oneOfType([PropTypes.oneOf(["center", "left", "right"]), PropTypes.number]).isRequired,
    vertical: PropTypes.oneOfType([PropTypes.oneOf(["bottom", "center", "top"]), PropTypes.number]).isRequired
  }),
  anchorPosition: PropTypes.shape({
    left: PropTypes.number.isRequired,
    top: PropTypes.number.isRequired
  }),
  anchorReference: PropTypes.oneOf(["anchorEl", "anchorPosition", "none"]),
  children: PropTypes.node,
  classes: PropTypes.object,
  className: PropTypes.string,
  container: PropTypes.oneOfType([HTMLElementType, PropTypes.func]),
  elevation: integerPropType,
  marginThreshold: PropTypes.number,
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired,
  PaperProps: PropTypes.shape({
    component: elementTypeAcceptingRef$1
  }),
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  transformOrigin: PropTypes.shape({
    horizontal: PropTypes.oneOfType([PropTypes.oneOf(["center", "left", "right"]), PropTypes.number]).isRequired,
    vertical: PropTypes.oneOfType([PropTypes.oneOf(["bottom", "center", "top"]), PropTypes.number]).isRequired
  }),
  TransitionComponent: PropTypes.elementType,
  transitionDuration: PropTypes.oneOfType([PropTypes.oneOf(["auto"]), PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })]),
  TransitionProps: PropTypes.object
});
var Popover$3 = Popover$2,
    Popover$1 = Object.freeze({
  __proto__: null,
  default: Popover$3,
  popoverClasses: popoverClasses$1,
  getPopoverUtilityClass: getPopoverUtilityClass
}),
    require$$4 = getAugmentedNamespace(Popover$1);
!function (e) {
  var t = interopRequireDefault.exports,
      r = _typeof.exports;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0, function (e, t) {
    if (!t && e && e.__esModule) return e;
    if (null === e || "object" !== r(e) && "function" != typeof e) return {
      default: e
    };
    var n = o(t);
    if (n && n.has(e)) return n.get(e);
    var a = {},
        i = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var s in e) {
      if ("default" !== s && Object.prototype.hasOwnProperty.call(e, s)) {
        var l = i ? Object.getOwnPropertyDescriptor(e, s) : null;
        l && (l.get || l.set) ? Object.defineProperty(a, s, l) : a[s] = e[s];
      }
    }

    a.default = e, n && n.set(e, a);
  }(React__default);
  var n = t(hoverWorkaround),
      a = t(require$$4);

  function o(e) {
    if ("function" != typeof WeakMap) return null;
    var t = new WeakMap(),
        r = new WeakMap();
    return (o = function o(e) {
      return e ? r : t;
    })(e);
  }

  var i = (0, n.default)(a.default);
  e.default = i;
}(HoverPopover$1);
var HoverPopover = getDefaultExportFromCjs(HoverPopover$1);

function _extends() {
  return _extends = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];

      for (var n in r) {
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
    }

    return e;
  }, _extends.apply(this, arguments);
}

var ChevronDownComponent = function ChevronDownComponent(_ref112) {
  var _ref112$styles = _ref112.styles,
      e = _ref112$styles === void 0 ? {} : _ref112$styles,
      t = _objectWithoutProperties2(_ref112, _excluded11);

  return React__default.createElement("svg", _extends({
    width: "48",
    height: "48",
    fill: "#0258ff",
    xmlns: "http://www.w3.org/2000/svg"
  }, t), React__default.createElement("path", {
    d: "M231.245 342.502L0 111.254l55.617-55.627C86.206 25.032 111.797 0 112.487 0c.689 0 79.863 78.609 175.942 174.686l174.69 174.686 174.689-174.686C733.887 78.609 813.06 0 813.75 0c.69 0 26.281 25.032 56.87 55.627l55.617 55.627-231.245 231.248C567.807 469.688 463.464 573.75 463.119 573.75c-.346 0-104.688-104.062-231.873-231.248z"
  }));
},
    ChevronDown = function ChevronDown(e) {
  return jsx$1(SvgIcon$1, _assign$({}, e, {
    component: ChevronDownComponent,
    viewBox: "0 0 926.23699 573.74994"
  }));
},
    BODY_FONT_FAMILY = '"Avenir Next", "Helvetica", "Arial", sans-serif',
    TITLE_FONT_FAMILY = '"Mont", "Avenir Next", "Helvetica", "Arial", sans-serif',
    themeObject = {
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1240,
      xl: 1536
    }
  },
  palette: {
    primary: {
      main: "#0258ff",
      light: "#ABB4B9",
      contrastText: "#FFFFFF"
    },
    secondary: {
      main: "#082244"
    },
    error: {
      main: red$1.A400
    },
    background: {
      default: "#fff"
    },
    text: {
      primary: "#082244",
      secondary: "#576C77"
    },
    divider: "rgba(0,0,0,0.06)",
    info: {
      main: "#0357FF"
    },
    neutral: {
      main: "#082244"
    }
  },
  typography: {
    fontFamily: BODY_FONT_FAMILY,
    fontWeightLight: 200,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightSemiBold: 600,
    fontWeightBold: 700,
    h2: {
      fontFamily: TITLE_FONT_FAMILY,
      fontWeight: 700,
      fontSize: "2.625rem"
    },
    h3: {
      fontFamily: TITLE_FONT_FAMILY,
      fontWeight: 700,
      fontSize: "2.25rem"
    },
    h4: {
      fontFamily: TITLE_FONT_FAMILY,
      fontWeight: 700,
      fontSize: "2rem"
    },
    h5: {
      fontFamily: TITLE_FONT_FAMILY,
      fontWeight: 700
    },
    h6: {
      fontFamily: TITLE_FONT_FAMILY,
      fontWeight: 700
    },
    subtitle1: {
      lineHeight: 1.6
    },
    subtitle3: {
      fontFamily: TITLE_FONT_FAMILY,
      fontWeight: 700,
      fontSize: "1rem",
      lineHeight: 1.4,
      letterSpacing: "0.00938em"
    },
    heading: {
      fontFamily: BODY_FONT_FAMILY,
      fontWeight: 700,
      fontSize: "1.125rem",
      lineHeight: 1.6,
      letterSpacing: "0.0075em"
    },
    caption2: {
      fontFamily: BODY_FONT_FAMILY,
      fontWeight: 400,
      fontSize: "0.625rem",
      lineHeight: 1.4,
      letterSpacing: "0.03333em"
    },
    caption3: {
      fontFamily: BODY_FONT_FAMILY,
      fontWeight: 400,
      fontSize: "0.5rem",
      lineHeight: 1.4,
      letterSpacing: "0.03333em"
    },
    button: {
      fontFamily: BODY_FONT_FAMILY,
      fontWeight: 700,
      letterSpacing: "0.075em"
    }
  }
},
    theme = createTheme(themeObject),
    NavigationDropDownChildItems = function NavigationDropDownChildItems(e) {
  var t = e.columns,
      r = t.id,
      n = t.links,
      a = t.nestedColumnLayout,
      o = t.title,
      i = function i(e) {
    return jsx$1(ColumnRoot$1, _assign$({
      link: e
    }, {
      children: jsxs(Stack$2, _assign$({
        direction: "row",
        spacing: 1,
        alignItems: "center",
        paddingLeft: 1
      }, {
        children: [null !== e.icon && jsx$1(Box, _assign$({
          display: "flex",
          justifyContent: "center"
        }, {
          children: jsx$1(CmsImage, {
            media: e.icon,
            width: 24,
            height: 24
          })
        })), jsxs(LinkContent$2, _assign$({
          isIconPresent: null !== e.icon
        }, {
          children: [jsx$1(LinkColumnTitle$1, _assign$({
            padding: 2,
            pb: null != e.subtitle && "" !== e.subtitle ? 0 : 2,
            component: "h6"
          }, {
            children: e.title
          })), null != e.subtitle && "" !== e.subtitle && jsx$1(LinkSubTitle$2, _assign$({
            pl: 2
          }, {
            children: e.subtitle
          }))]
        }))]
      }))
    }));
  };

  return jsxs(Root$9, {
    children: [null != o && "" !== o && jsx$1(LinkTitle$2, _assign$({
      component: "h5",
      padding: theme.spacing(2)
    }, {
      children: o
    })), function (e) {
      if (null != a && "" !== a) {
        for (var t = JSON.parse(JSON.stringify(e)), r = a.split(","), o = [], s = 0; s < r.length; s++) {
          if (t.length > 0 && "0" !== r[s]) {
            var l = r[s],
                c = t.slice(0, Number(l));
            t = t.splice(Number(l), t.length), o.push(c);
          }
        }

        return t.length > 0 && o.push(t), jsx$1(Stack$2, _assign$({
          direction: "row",
          spacing: 2
        }, {
          children: o.map(function (e, t) {
            return jsx$1(Stack$2, {
              children: null == e ? void 0 : e.map(function (e) {
                return i(e);
              })
            }, t);
          })
        }));
      }

      return jsx$1(Fragment, {
        children: null == n ? void 0 : n.map(function (e) {
          return i(e);
        })
      });
    }(n)]
  }, r);
},
    Root$9 = styled$2(Box)(function (e) {
  return e.theme, {};
}),
    ColumnRoot$1 = styled$2(Link)(function (e) {
  var t = e.theme;
  return {
    display: "flex",
    textDecoration: "none",
    color: colors.grey[900],
    "&:hover": {
      h6: {
        color: t.palette.primary.main
      },
      background: colors.grey[100],
      borderRadius: t.spacing(1)
    }
  };
}),
    LinkContent$2 = styled$2("div")(function (e) {
  return e.theme, e.isIconPresent, {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-evenly"
  };
}),
    LinkTitle$2 = styled$2(Text)(function (e) {
  var t = e.theme;
  return _assign$(_assign$({}, t.typography.caption), {
    fontWeight: t.typography.fontWeightBold,
    textDecoration: "none"
  });
}),
    LinkColumnTitle$1 = styled$2(Text)(function (e) {
  var t = e.theme;
  return _assign$(_assign$({}, t.typography.subtitle2), {
    fontWeight: t.typography.fontWeightSemiBold,
    "&:hover": {
      color: t.palette.primary.main
    }
  });
}),
    LinkSubTitle$2 = styled$2(Text)(function (e) {
  var t = e.theme;
  return _assign$(_assign$({}, t.typography.caption), {
    fontWeight: t.typography.fontWeightMedium,
    color: t.palette.text.secondary
  });
}),
    NavigationLinks = function NavigationLinks(e) {
  var t = e.data,
      r = e.navbarLinks,
      n = e.pageContext,
      a = e.isNavbarBackgroundSolid,
      o = useTheme$4(),
      i = useState(r),
      s = i[0],
      l = i[1],
      c = {
    navbar: t,
    pageContext: n,
    theme: o,
    params: {
      isNavbarBackgroundSolid: a
    }
  },
      u = getUtmParams();
  useEffect(function () {
    var e = __spreadArray([], s, !0);

    e.forEach(function (e) {
      var t, r;

      if (null == (null == e ? void 0 : e.url) || "" === u || (null == e ? void 0 : e.url.includes(u)) || (e.url = e.url.includes("?") ? "".concat(e.url, "&").concat(u) : "".concat(e.url, "?").concat(u)), (null === (t = null == e ? void 0 : e.columns) || void 0 === t ? void 0 : t.length) > 0 && "" !== u) {
        var n = null === (r = e.columns) || void 0 === r ? void 0 : r.forEach(function (e) {
          var t, r;
          return null != (null == e ? void 0 : e.links) && (null === (t = null == e ? void 0 : e.links) || void 0 === t ? void 0 : t.length) > 0 && (null === (r = e.links) || void 0 === r || r.forEach(function (e) {
            var t;
            return null == (null == e ? void 0 : e.url) || (null === (t = null == e ? void 0 : e.url) || void 0 === t ? void 0 : t.includes(u)) || (e.url = e.url.includes("?") ? "".concat(e.url, "&").concat(u) : "".concat(e.url, "?").concat(u)), e.url;
          })), e;
        });
        return n;
      }
    }), l(__spreadArray([], e, !0));
  }, [u]);
  return jsx$1(Stack$2, _assign$({
    flexDirection: "row"
  }, {
    children: s.map(function (e, t) {
      var r;
      return (null === (r = e.columns) || void 0 === r ? void 0 : r.length) > 0 ? function (e, t) {
        return jsx$1(PopupState, _assign$({
          variant: "popover",
          popupId: "demo-popup-popover"
        }, {
          children: function children(t) {
            var r;
            return jsxs(Box, _assign$({
              sx: e.styles
            }, {
              children: [jsxs(MenuLink, _assign$({}, bindHover(t), {
                sx: {
                  alignItems: "center",
                  color: getNavbarLinkColor(c),
                  display: "flex"
                }
              }, {
                children: [e.title, jsx$1(ChevronDown, {
                  pathColor: getNavbarLinkColor(c),
                  sx: {
                    fontSize: 12,
                    marginLeft: o.spacing(1)
                  }
                })]
              }), e.id), jsx$1(Popover, _assign$({}, bindPopover(t), {
                anchorReference: (null == e ? void 0 : e.columns.length) > 1 ? "anchorPosition" : void 0,
                anchorPosition: {
                  top: 70,
                  left: 900
                },
                anchorOrigin: {
                  vertical: "bottom",
                  horizontal: "center"
                },
                transformOrigin: {
                  vertical: "top",
                  horizontal: "center"
                }
              }, {
                children: jsx$1(Box, _assign$({
                  style: {
                    width: "auto"
                  }
                }, {
                  children: jsx$1(Stack$2, _assign$({
                    direction: "row",
                    divider: jsx$1(Divider, {
                      orientation: "vertical",
                      variant: "middle",
                      flexItem: !0
                    }),
                    spacing: 2
                  }, {
                    children: null === (r = null == e ? void 0 : e.columns) || void 0 === r ? void 0 : r.map(function (e) {
                      return jsx$1(NavigationDropDownChildItems, {
                        columns: e
                      }, e.id);
                    })
                  }))
                }))
              }))]
            }));
          }
        }), t);
      }(e, t) : jsx$1(MenuLink, _assign$({
        href: e.url,
        color: getNavbarLinkColor(c)
      }, {
        children: e.title
      }));
    })
  }));
},
    MenuLink = styled$2(Link)(function (e) {
  var t = e.theme;
  return {
    fontSize: t.typography.subtitle2.fontSize,
    fontWeight: t.typography.fontWeightSemiBold,
    letterSpacing: 0,
    padding: t.spacing(2),
    "&:hover": {
      color: t.palette.primary.main
    },
    position: "relative",
    mt: "10px"
  };
}),
    Popover = styled$2(function (e) {
  return jsx$1(HoverPopover, _assign$({}, e, {
    PaperProps: {
      style: {
        boxShadow: "\n          0 1px 2px rgba(0,0,0,0.07), \n          0 2px 4px rgba(0,0,0,0.07), \n          0 4px 8px rgba(0,0,0,0.07), \n          0 8px 16px rgba(0,0,0,0.07),\n          0 16px 32px rgba(0,0,0,0.07), \n          0 32px 64px rgba(0,0,0,0.07)\n        ",
        position: "absolute",
        top: 60
      }
    }
  }));
})(function (e) {
  var t,
      r = e.theme;
  return (t = {})[".".concat(paperClasses.root)] = {
    padding: r.spacing(2),
    borderRadius: r.spacing(1)
  }, t;
}),
    initialState$2 = {
  sections: [],
  outputBlockHtmlList: []
},
    Context$1 = React__default.createContext(_assign$(_assign$({}, initialState$2), {
  editorJsInstances: [],
  addEditorJsInstance: function addEditorJsInstance() {
    return 0;
  },
  saveAllEditorJsInstanceChanges: function saveAllEditorJsInstanceChanges() {
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (e) {
        switch (e.label) {
          case 0:
            return [4, new Promise(function (e) {
              return e();
            })];

          case 1:
            return e.sent(), [2];
        }
      });
    });
  },
  updateSections: function updateSections() {
    return null;
  }
})),
    useHeroSites = function useHeroSites() {
  return useContext(Context$1);
},
    ProductCta = function ProductCta(e) {
  var t = e.data,
      r = useTheme$4(),
      n = router.useRouter(),
      a = useAnalytics$1();
  return jsx$1(Root$8, {
    children: jsxs(StyledCard, _assign$({
      elevation: 24
    }, {
      children: [jsxs(Content, _assign$({
        maxWidth: "600px"
      }, {
        children: [jsx$1(Text, _assign$({
          fontWeight: r.typography.fontWeightBold,
          paddingBottom: r.spacing(2.5),
          color: "primary",
          variant: "subtitle2"
        }, {
          children: t.coverSubtitle
        })), jsx$1(Text, _assign$({
          variant: "h4",
          paddingBottom: r.spacing(1.25),
          margin: "0"
        }, {
          children: t.title
        })), jsx$1(Text, _assign$({
          variant: "caption2",
          padding: r.spacing(1.25),
          margin: "0"
        }, {
          children: t.subtitle
        })), "" !== t.buttonText && jsx$1(Button, _assign$({
          variant: "contained",
          sx: {
            mt: 2
          },
          onClick: function onClick() {
            return e = t.url, null == a || a.track("mkt_start_free_trial_footer", {
              text: e
            }), void n.push(e).catch(function () {});
            var e;
          },
          endIcon: jsx$1(RightArrow, {
            fontSize: "large",
            color: "primary"
          })
        }, {
          children: jsx$1(Text, _assign$({
            variant: "button",
            padding: r.spacing(.5),
            borderRadius: r.spacing(.8),
            textAlign: "left"
          }, {
            children: t.buttonText
          }))
        }))]
      })), jsx$1(BoxCmsImageContainer, {
        children: jsx$1(CmsImage, {
          media: t.backgroundImage
        })
      })]
    }))
  });
},
    Root$8 = styled$2(Box)(function (e) {
  var t,
      r = e.theme;
  return {
    "& .MuiCard-root": (t = {
      borderRadius: r.spacing(2.5)
    }, t[r.breakpoints.between("md", "lg")] = {
      boxShadow: "none",
      margin: r.spacing(7, 0, 11, 0),
      borderRadius: "0"
    }, t)
  };
}),
    StyledCard = styled$2(Card)(function (e) {
  var t,
      r = e.theme;
  return (t = {
    position: "relative",
    margin: r.spacing(0, "auto"),
    marginBottom: r.spacing(11),
    maxWidth: "75rem",
    minHeight: "25rem",
    height: "400px"
  })[r.breakpoints.down("md")] = {
    margin: r.spacing(8, 2, 11, 2)
  }, t;
}),
    BoxCmsImageContainer = styled$2(Box)(function (e) {
  var t;
  return (t = {
    width: "100%"
  })[e.theme.breakpoints.down("md")] = {
    display: "none"
  }, t;
}),
    Content = styled$2(Box)(function (e) {
  var t,
      r = e.theme;
  return (t = {
    position: "absolute",
    zIndex: 1,
    display: "flex",
    flexDirection: "column",
    textAlign: "center",
    alignItems: "center",
    padding: "40px",
    top: "50%",
    left: "0",
    transform: "translateY(-50%)"
  })[r.breakpoints.up("md")] = {
    padding: r.spacing(10, 10),
    textAlign: "left",
    alignItems: "start"
  }, t;
}),
    Testimonial = function Testimonial(e) {
  var t = e.data,
      r = useAnalytics$1(),
      n = t.label,
      a = t.quote,
      o = t.ctaButton,
      i = t.figure,
      s = router.useRouter();
  return jsxs(Fragment, {
    children: [jsx$1(Wrapper$3, {
      children: jsx$1(Container, _assign$({
        maxWidth: "lg"
      }, {
        children: jsxs(TestimonialContainer, _assign$({
          container: !0,
          spacing: 0
        }, {
          children: [jsx$1(Grid$2, _assign$({
            item: !0,
            sm: 8
          }, {
            children: jsxs(TextContainer, {
              children: [jsx$1(Text, _assign$({
                variant: "subtitle2"
              }, {
                children: n
              })), jsx$1(Text, _assign$({
                variant: "h4"
              }, {
                children: a
              })), o.map(function (e) {
                return jsxs(TestimonialCta, _assign$({
                  variant: "contained",
                  onClick: function onClick() {
                    return __awaiter(void 0, void 0, void 0, function () {
                      return __generator(this, function (t) {
                        switch (t.label) {
                          case 0:
                            return [4, s.push(e.url)];

                          case 1:
                            return [2, t.sent()];
                        }
                      });
                    });
                  }
                }, {
                  children: [e.text, "    ", jsx$1(FiArrowRight, {
                    size: 20,
                    onClick: function onClick() {
                      return t = e.text, void (null == r || r.track("mkt_to_blogpost", {
                        title: t
                      }));
                      var t;
                    }
                  })]
                }), e.id);
              })]
            })
          })), jsx$1(Grid$2, _assign$({
            item: !0,
            sm: 4,
            sx: {
              display: "flex",
              justifyContent: "center",
              alignItems: "center"
            }
          }, {
            children: jsxs(FigureContainer, {
              children: [jsx$1(CmsImage, {
                media: i.captionImage,
                width: 185,
                height: 176
              }), jsx$1(Text, _assign$({
                variant: "caption"
              }, {
                children: i.caption
              }))]
            })
          }))]
        }))
      }))
    }), jsx$1(BottomBackground, {})]
  });
},
    Wrapper$3 = styled$2(Box)(function (e) {
  return {
    marginBottom: e.theme.spacing(6),
    background: "#f7f9fb",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  };
}),
    TestimonialContainer = styled$2(Grid$2)(function (e) {
  var t,
      r = e.theme;
  return (t = {
    padding: r.spacing(7.5, 6, 10.2, 6)
  })[r.breakpoints.down("md")] = {
    alignItem: "center",
    justifyContent: "center",
    flexDirection: "column-reverse",
    paddingBottom: r.spacing(6.25)
  }, t;
}),
    TextContainer = styled$2("div")(function (e) {
  var t;
  return (t = {})[e.theme.breakpoints.down("md")] = {
    textAlign: "center"
  }, t;
}),
    TestimonialCta = styled$2(Button)(function (e) {
  var t = e.theme;
  return {
    color: t.palette.common.white,
    textTransform: "uppercase",
    background: "#5ac58d",
    fontSize: t.spacing(1.75),
    padding: t.spacing(1.6, 3.3),
    borderRadius: t.spacing(.75),
    boxShadow: "none",
    "&:hover": {
      background: "#5ac58d",
      boxShadow: "none"
    }
  };
}),
    BottomBackground = styled$2("div")(function (e) {
  return {
    position: "relative",
    background: "#f7f9fb",
    "&:after": {
      content: '""',
      position: "absolute",
      background: "#f7f9fb",
      width: "100%",
      height: "78px",
      top: e.theme.spacing(-10.5),
      right: 0,
      transform: "skewY(-3deg)",
      zIndex: 1
    }
  };
}),
    FigureContainer = styled$2("div")(function (e) {
  var t = e.theme;
  return {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    "& .name": {
      color: "#8290a2",
      fontSize: t.spacing(2),
      fontWeight: t.typography.fontWeightBold,
      paddingTop: t.spacing(2.25)
    }
  };
}),
    Sections = function Sections(e) {
  var t = e.sections,
      r = e.preview,
      n = e.onChanges;
  console.log("sections is ", t);
  var a = [],
      o = useCallback(function (e) {
    void 0 !== e && a.push(e);
  }, []);
  return useEffect(function () {
    null != n && n(a);
  }, [o]), jsxs(Fragment, {
    children: [r && jsx$1(PreviewModeBanner, {}), null == t ? void 0 : t.map(function (e) {
      return jsx$1(PageSection, {
        data: e,
        onChange: o
      }, "".concat(e.__component).concat(e.id));
    })]
  });
},
    PageSection = function PageSection(e) {
  var t = e.data,
      r = e.onChange;
  if (null === t.__component || "" === t.__component) return jsx$1(Fragment, {});
  if (t.__component.includes(Section.Form)) return jsx$1(FormSection, {
    data: t,
    onChange: r
  });
  var n = sectionComponents[t.__component];
  return jsx$1(n, {
    data: t
  });
},
    PreviewModeBanner = function PreviewModeBanner() {
  var e = router.useRouter();
  return jsx$1(Alert, _assign$({
    action: jsx$1(Link, _assign$({
      href: "/api/exit-preview?redirect=".concat(e.asPath),
      color: "inherit"
    }, {
      children: "Turn off"
    }))
  }, {
    children: "Preview mode is on"
  }));
},
    heroSectionComponents = {
  "sections.hero": Hero,
  "sections.hero-main": HeroMain,
  "sections.hero-booking": Hero,
  "sections.hero-messenger": Hero,
  "sections.hero-reviews": Hero
},
    sectionComponents = _assign$(_assign$({}, heroSectionComponents), {
  "sections.feature-columns-group": FeatureColumnsGroup,
  "sections.feature-rows-group": FeatureRowsGroup,
  "sections.product-cta": ProductCta,
  "sections.feature-wide": FeatureWide,
  "sections.testimonial": Testimonial,
  "sections.download-mobile-app": DownloadMobileApp,
  "sections.form": FormSection,
  "sections.form-section": FormSection
}),
    getSectionId = function getSectionId(e) {
  return "".concat(e.__component, "-").concat(e.id);
},
    initialState$1 = {
  analytics: null
},
    Context = React__default.createContext(_assign$({}, initialState$1)),
    useAnalytics = function useAnalytics() {
  return useContext(Context);
},
    Navbar = function Navbar(e) {
  var t = e.data,
      r = e.navbarLinks,
      n = e.pageContext,
      a = useAnalytics().analytics,
      o = useTheme$4(),
      i = useButton().getVariant,
      s = useState(!1),
      l = s[0],
      c = s[1],
      u = useMediaQuery(o.breakpoints.down("lg")),
      d = t.buttons,
      p = t.displayLinks,
      g = {
    navbar: t,
    pageContext: n,
    theme: o,
    params: {
      isNavbarBackgroundSolid: l
    }
  },
      m = function m(e) {
    var t,
        r = {
      link: e,
      key: e.id,
      href: e.url,
      target: void 0 !== e.newTab && e.newTab ? "_blank" : "_self",
      rel: "noreferrer"
    };
    return "text" === i(e.variant) ? jsx$1(TextLink, _assign$({
      onClick: function onClick() {
        return t = e.text, void (null == a || a.track("mkt_clicked_sign_in", {
          actionTitle: t
        }));
        var t;
      },
      color: getNavbarLinkColor(g)
    }, r, {
      children: e.text
    })) : jsx$1(Link, _assign$({}, r, {
      onClick: function onClick() {
        return t = e.text, void (null == a || a.track("mkt_click_signup", {
          actionTitle: t
        }));
        var t;
      }
    }, {
      children: jsx$1(Box, _assign$({
        sx: {
          color: getNavbarButtonColor(g)
        }
      }, {
        children: jsx$1(Button, _assign$({
          variant: i(e.variant),
          color: "primary",
          size: "medium",
          sx: (t = {
            fontSize: o.typography.pxToRem(14)
          }, t["& .".concat(svgIconClasses.root)] = {
            fontSize: o.typography.body1.fontSize
          }, t)
        }, {
          children: e.text
        }))
      }))
    }));
  };

  return useEffect(function () {
    var e = function e() {
      window.scrollY >= 38 ? c(!0) : c(!1);
    };

    return window.addEventListener("scroll", e), function () {
      return window.removeEventListener("scroll", e);
    };
  }, []), u ? jsx$1(MobileNavMenu, {
    data: t,
    navbarLinks: r,
    pageContext: n
  }) : jsx$1(Root$7, _assign$({
    position: l ? "fixed" : n.slug.includes("kitchen") ? "static" : "fixed",
    isBackgroundSolid: l,
    className: headerClasses.root
  }, {
    children: jsx$1(Container, {
      children: jsxs(Toolbar, {
        children: [jsxs(Grid$2, _assign$({
          container: !0,
          alignItems: "center",
          width: "auto",
          flexGrow: 1,
          columnSpacing: 5
        }, {
          children: [jsx$1(Grid$2, _assign$({
            item: !0,
            className: headerClasses.logo
          }, {
            children: null !== t.logo && jsx$1(Link, _assign$({
              link: t.logo,
              display: "flex"
            }, {
              children: jsx$1(CmsImage, {
                media: getLogo(g)
              })
            }))
          })), jsx$1(Grid$2, _assign$({
            item: !0,
            flexGrow: 1,
            className: headerClasses.navbarLinks
          }, {
            children: p && (null == n ? void 0 : n.displayNavbarLinks) && jsx$1(NavigationLinks, {
              data: t,
              navbarLinks: r,
              pageContext: n,
              isNavbarBackgroundSolid: l
            })
          }))]
        })), jsx$1(Grid$2, _assign$({
          container: !0,
          alignItems: "center",
          width: "auto",
          columnSpacing: 4,
          className: headerClasses.buttonLinks
        }, {
          children: null == d ? void 0 : d.map(function (e) {
            return jsx$1(Grid$2, _assign$({
              item: !0,
              className: headerClasses.buttonLink
            }, {
              children: m(e)
            }), e.id);
          })
        }))]
      })
    })
  }));
},
    Root$7 = styled$2(AppBar)(function (e) {
  var t,
      r,
      n = e.theme,
      a = e.isBackgroundSolid;
  return (t = {
    background: a ? n.palette.background.default : "none",
    boxShadow: a ? "0 0 3px 0 rgb(0 0 0 / 22%)" : "none",
    top: a ? "0px" : "auto"
  })["& .".concat(containerClasses.maxWidthLg)] = {
    maxWidth: 1234
  }, t["& .".concat(toolbarClasses.root)] = ((r = {
    paddingTop: n.spacing(2),
    paddingBottom: n.spacing(2.5)
  })[n.breakpoints.up("sm")] = {
    paddingLeft: 0,
    paddingRight: 0
  }, r), t;
}),
    getLogo = function getLogo(e) {
  var t = e.navbar,
      r = e.pageContext;

  if (!e.params.isNavbarBackgroundSolid) {
    if ("inverted" === (null == r ? void 0 : r.navbarTheme)) return t.logoInverted;
    if ("inverted" !== (null == r ? void 0 : r.navbarTheme)) return t.logo.media;
    if ("inverted" === t.defaultNavbarTheme) return t.logoInverted;
  }

  return t.logo.media;
},
    getNavbarLinkColor = function getNavbarLinkColor(e) {
  var t = e.navbar,
      r = e.pageContext,
      n = e.theme;

  if (e.params.isNavbarBackgroundSolid) {
    if ("inverted" === (null == r ? void 0 : r.navbarTheme)) return n.palette.text.primary;
    if ("inverted" === t.defaultNavbarTheme) return n.palette.text.primary;
  } else {
    if ("inverted" === (null == r ? void 0 : r.navbarTheme)) return n.palette.common.white;
    if ("inverted" === t.defaultNavbarTheme) return n.palette.common.white;
  }

  return n.palette.text.primary;
},
    getNavbarButtonColor = function getNavbarButtonColor(e) {
  var t = e.navbar,
      r = e.pageContext,
      n = e.theme;

  if (e.params.isNavbarBackgroundSolid) {
    if ("inverted" === (null == r ? void 0 : r.navbarTheme)) return n.palette.common.black;
    if ("inverted" === t.defaultNavbarTheme) return n.palette.common.black;
  } else {
    if ("inverted" === (null == r ? void 0 : r.navbarTheme)) return n.palette.common.white;
    if ("inverted" === t.defaultNavbarTheme) return n.palette.common.white;
  }

  return n.palette.common.black;
},
    TextLink = styled$2(Link)(function (e) {
  var t = e.theme;
  return {
    fontWeight: t.typography.fontWeightSemiBold,
    fontSize: t.typography.subtitle2.fontSize,
    "&:hover": {
      color: t.palette.primary.main
    }
  };
});

function MdExpandLess(e) {
  return GenIcon({
    tag: "svg",
    attr: {
      viewBox: "0 0 24 24"
    },
    child: [{
      tag: "path",
      attr: {
        fill: "none",
        d: "M0 0h24v24H0z"
      }
    }, {
      tag: "path",
      attr: {
        d: "M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"
      }
    }]
  })(e);
}

function MdExpandMore(e) {
  return GenIcon({
    tag: "svg",
    attr: {
      viewBox: "0 0 24 24"
    },
    child: [{
      tag: "path",
      attr: {
        fill: "none",
        d: "M0 0h24v24H0z"
      }
    }, {
      tag: "path",
      attr: {
        d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
      }
    }]
  })(e);
}

function MdOutlineKeyboardArrowDown(e) {
  return GenIcon({
    tag: "svg",
    attr: {
      viewBox: "0 0 24 24"
    },
    child: [{
      tag: "path",
      attr: {
        fill: "none",
        d: "M0 0h24v24H0V0z"
      }
    }, {
      tag: "path",
      attr: {
        d: "M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"
      }
    }]
  })(e);
}

var ScrollTrigger = {
  exports: {}
};
!function (e) {
  function t(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
    }
  }

  function r(e, r, n) {
    return r && t(e.prototype, r), n && t(e, n), e;
  }
  /*!
     * Observer 3.10.4
     * https://greensock.com
     *
     * @license Copyright 2008-2022, GreenSock. All rights reserved.
     * Subject to the terms at https://greensock.com/standard-license or for
     * Club GreenSock members, the agreement issued with that membership.
     * @author: Jack Doyle, jack@greensock.com
    */


  var n,
      a,
      o,
      i,
      s,
      l,
      c,
      u,
      d,
      p,
      g,
      m,
      f = function f() {
    return n || "undefined" != typeof window && (n = window.gsap) && n.registerPlugin && n;
  },
      h = 1,
      b = [],
      y = [],
      v = [],
      _ = Date.now,
      T = function T(e, t) {
    return t;
  },
      E = function E() {
    var e = d.core,
        t = e.bridge || {},
        r = e._scrollers,
        n = e._proxies;
    r.push.apply(r, y), n.push.apply(n, v), y = r, v = n, T = function T(e, r) {
      return t[e](r);
    };
  },
      S = function S(e, t) {
    return ~v.indexOf(e) && v[v.indexOf(e) + 1][t];
  },
      x = function x(e) {
    return !!~p.indexOf(e);
  },
      w = function w(e, t, r, n, a) {
    return e.addEventListener(t, r, {
      passive: !n,
      capture: !!a
    });
  },
      C = function C(e, t, r, n) {
    return e.removeEventListener(t, r, !!n);
  },
      k = "scrollLeft",
      $ = "scrollTop",
      R = function R() {
    return g && g.isPressed || y.cache++;
  },
      A = function A(e, t) {
    var r = function r(n) {
      if (n || 0 === n) {
        h && (o.history.scrollRestoration = "manual");
        var a = g && g.isPressed;
        n = r.v = Math.round(n) || (g && g.iOS ? 1 : 0), e(n), r.cacheID = y.cache, a && T("ss", n);
      } else (t || y.cache !== r.cacheID || T("ref")) && (r.cacheID = y.cache, r.v = e());

      return r.v + r.offset;
    };

    return r.offset = 0, e && r;
  },
      I = {
    s: k,
    p: "left",
    p2: "Left",
    os: "right",
    os2: "Right",
    d: "width",
    d2: "Width",
    a: "x",
    sc: A(function (e) {
      return arguments.length ? o.scrollTo(e, N.sc()) : o.pageXOffset || i[k] || s[k] || l[k] || 0;
    })
  },
      N = {
    s: $,
    p: "top",
    p2: "Top",
    os: "bottom",
    os2: "Bottom",
    d: "height",
    d2: "Height",
    a: "y",
    op: I,
    sc: A(function (e) {
      return arguments.length ? o.scrollTo(I.sc(), e) : o.pageYOffset || i[$] || s[$] || l[$] || 0;
    })
  },
      P = function P(e) {
    return n.utils.toArray(e)[0] || ("string" == typeof e && !1 !== n.config().nullTargetWarn ? console.warn("Element not found:", e) : null);
  },
      O = function O(e, t) {
    var r = t.s,
        n = t.sc,
        a = y.indexOf(e),
        o = n === N.sc ? 1 : 2;
    return !~a && (a = y.push(e) - 1), y[a + o] || (y[a + o] = A(S(e, r), !0) || (x(e) ? n : A(function (t) {
      return arguments.length ? e[r] = t : e[r];
    })));
  },
      D = function D(e, t, r) {
    var n = e,
        a = e,
        o = _(),
        i = o,
        s = t || 50,
        l = Math.max(500, 3 * s),
        c = function c(e, t) {
      var l = _();

      t || l - o > s ? (a = n, n = e, i = o, o = l) : r ? n += e : n = a + (e - a) / (l - i) * (o - i);
    },
        u = function u(e) {
      var t = i,
          s = a,
          u = _();

      return (e || 0 === e) && e !== n && c(e), o === i || u - i > l ? 0 : (n + (r ? s : -s)) / ((r ? u : o) - t) * 1e3;
    };

    return {
      update: c,
      reset: function reset() {
        a = n = r ? 0 : n, i = o = 0;
      },
      getVelocity: u
    };
  },
      L = function L(e, t) {
    return t && !e._gsapAllow && e.preventDefault(), e.changedTouches ? e.changedTouches[0] : e;
  },
      M = function M(e) {
    var t = Math.max.apply(Math, e),
        r = Math.min.apply(Math, e);
    return Math.abs(t) >= Math.abs(r) ? t : r;
  },
      F = function F() {
    (d = n.core.globals().ScrollTrigger) && d.core && E();
  },
      j = function j(e) {
    return (n = e || f()) && "undefined" != typeof document && document.body && (o = window, i = document, s = i.documentElement, l = i.body, p = [o, i, s, l], n.utils.clamp, u = "onpointerenter" in l ? "pointer" : "mouse", c = B.isTouch = o.matchMedia && o.matchMedia("(hover: none), (pointer: coarse)").matches ? 1 : "ontouchstart" in o || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0 ? 2 : 0, m = B.eventTypes = ("ontouchstart" in s ? "touchstart,touchmove,touchcancel,touchend" : "onpointerdown" in s ? "pointerdown,pointermove,pointercancel,pointerup" : "mousedown,mousemove,mouseup,mouseup").split(","), setTimeout(function () {
      return h = 0;
    }, 500), F(), a = 1), a;
  };

  I.op = N, y.cache = 0;

  var B = function () {
    function e(e) {
      this.init(e);
    }

    return e.prototype.init = function (e) {
      a || j(n) || console.warn("Please gsap.registerPlugin(Observer)"), d || F();
      var t = e.tolerance,
          r = e.dragMinimum,
          p = e.type,
          f = e.target,
          h = e.lineHeight,
          y = e.debounce,
          v = e.preventDefault,
          T = e.onStop,
          E = e.onStopDelay,
          S = e.ignore,
          k = e.wheelSpeed,
          $ = e.event,
          A = e.onDragStart,
          B = e.onDragEnd,
          U = e.onDrag,
          G = e.onPress,
          q = e.onRelease,
          H = e.onRight,
          z = e.onLeft,
          W = e.onUp,
          V = e.onDown,
          Y = e.onChangeX,
          K = e.onChangeY,
          X = e.onChange,
          Z = e.onToggleX,
          Q = e.onToggleY,
          J = e.onHover,
          ee = e.onHoverEnd,
          te = e.onMove,
          re = e.ignoreCheck,
          ne = e.isNormalizer,
          ae = e.onGestureStart,
          oe = e.onGestureEnd,
          ie = e.onWheel,
          se = e.onEnable,
          le = e.onDisable,
          ce = e.onClick,
          ue = e.scrollSpeed,
          de = e.capture,
          pe = e.allowClicks,
          ge = e.lockAxis,
          me = e.onLockAxis;
      this.target = f = P(f) || s, this.vars = e, S && (S = n.utils.toArray(S)), t = t || 0, r = r || 0, k = k || 1, ue = ue || 1, p = p || "wheel,touch,pointer", y = !1 !== y, h || (h = parseFloat(o.getComputedStyle(l).lineHeight) || 22);

      var fe,
          he,
          be,
          ye,
          ve,
          _e,
          Te,
          Ee = this,
          Se = 0,
          xe = 0,
          we = O(f, I),
          Ce = O(f, N),
          ke = we(),
          $e = Ce(),
          Re = ~p.indexOf("touch") && !~p.indexOf("pointer") && "pointerdown" === m[0],
          Ae = x(f),
          Ie = f.ownerDocument || i,
          Ne = [0, 0, 0],
          Pe = [0, 0, 0],
          Oe = 0,
          De = function De() {
        return Oe = _();
      },
          Le = function Le(e, t) {
        return (Ee.event = e) && S && ~S.indexOf(e.target) || t && Re && "touch" !== e.pointerType || re && re(e, t);
      },
          Me = function Me() {
        Ee._vx.reset(), Ee._vy.reset(), he.pause(), T && T(Ee);
      },
          Fe = function Fe() {
        var e = Ee.deltaX = M(Ne),
            r = Ee.deltaY = M(Pe),
            n = Math.abs(e) >= t,
            a = Math.abs(r) >= t;
        X && (n || a) && X(Ee, e, r, Ne, Pe), n && (H && Ee.deltaX > 0 && H(Ee), z && Ee.deltaX < 0 && z(Ee), Y && Y(Ee), Z && Ee.deltaX < 0 != Se < 0 && Z(Ee), Se = Ee.deltaX, Ne[0] = Ne[1] = Ne[2] = 0), a && (V && Ee.deltaY > 0 && V(Ee), W && Ee.deltaY < 0 && W(Ee), K && K(Ee), Q && Ee.deltaY < 0 != xe < 0 && Q(Ee), xe = Ee.deltaY, Pe[0] = Pe[1] = Pe[2] = 0), (ye || be) && (te && te(Ee), me && _e && me(Ee), be && (U(Ee), be = !1), ye = _e = !1), ve && (ie(Ee), ve = !1), fe = 0;
      },
          je = function je(e, t, r) {
        Ne[r] += e, Pe[r] += t, Ee._vx.update(e), Ee._vy.update(t), y ? fe || (fe = requestAnimationFrame(Fe)) : Fe();
      },
          Be = function Be(e, t) {
        "y" !== Te && (Ne[2] += e, Ee._vx.update(e, !0)), "x" !== Te && (Pe[2] += t, Ee._vy.update(t, !0)), ge && !Te && (Ee.axis = Te = Math.abs(e) > Math.abs(t) ? "x" : "y", _e = !0), y ? fe || (fe = requestAnimationFrame(Fe)) : Fe();
      },
          Ue = function Ue(e) {
        if (!Le(e, 1)) {
          var t = (e = L(e, v)).clientX,
              n = e.clientY,
              a = t - Ee.x,
              o = n - Ee.y,
              i = Ee.isDragging;
          Ee.x = t, Ee.y = n, (i || Math.abs(Ee.startX - t) >= r || Math.abs(Ee.startY - n) >= r) && (U && (be = !0), i || (Ee.isDragging = !0), Be(a, o), i || A && A(Ee));
        }
      },
          Ge = Ee.onPress = function (e) {
        Le(e, 1) || (Ee.axis = Te = null, he.pause(), Ee.isPressed = !0, e = L(e), Se = xe = 0, Ee.startX = Ee.x = e.clientX, Ee.startY = Ee.y = e.clientY, Ee._vx.reset(), Ee._vy.reset(), w(ne ? f : Ie, m[1], Ue, v, !0), Ee.deltaX = Ee.deltaY = 0, G && G(Ee));
      },
          qe = function qe(e) {
        if (!Le(e, 1)) {
          C(ne ? f : Ie, m[1], Ue, !0);
          var t = Ee.isDragging && (Math.abs(Ee.x - Ee.startX) > 3 || Math.abs(Ee.y - Ee.startY) > 3),
              r = L(e);
          t || (Ee._vx.reset(), Ee._vy.reset(), v && pe && n.delayedCall(.08, function () {
            if (_() - Oe > 300 && !e.defaultPrevented) if (e.target.click) e.target.click();else if (Ie.createEvent) {
              var t = Ie.createEvent("MouseEvents");
              t.initMouseEvent("click", !0, !0, o, 1, r.screenX, r.screenY, r.clientX, r.clientY, !1, !1, !1, !1, 0, null), e.target.dispatchEvent(t);
            }
          })), Ee.isDragging = Ee.isGesturing = Ee.isPressed = !1, T && !ne && he.restart(!0), B && t && B(Ee), q && q(Ee, t);
        }
      },
          He = function He(e) {
        return e.touches && e.touches.length > 1 && (Ee.isGesturing = !0) && ae(e, Ee.isDragging);
      },
          ze = function ze() {
        return (Ee.isGesturing = !1) || oe(Ee);
      },
          We = function We(e) {
        if (!Le(e)) {
          var t = we(),
              r = Ce();
          je((t - ke) * ue, (r - $e) * ue, 1), ke = t, $e = r, T && he.restart(!0);
        }
      },
          Ve = function Ve(e) {
        if (!Le(e)) {
          e = L(e, v), ie && (ve = !0);
          var t = (1 === e.deltaMode ? h : 2 === e.deltaMode ? o.innerHeight : 1) * k;
          je(e.deltaX * t, e.deltaY * t, 0), T && !ne && he.restart(!0);
        }
      },
          Ye = function Ye(e) {
        if (!Le(e)) {
          var t = e.clientX,
              r = e.clientY,
              n = t - Ee.x,
              a = r - Ee.y;
          Ee.x = t, Ee.y = r, ye = !0, (n || a) && Be(n, a);
        }
      },
          Ke = function Ke(e) {
        Ee.event = e, J(Ee);
      },
          Xe = function Xe(e) {
        Ee.event = e, ee(Ee);
      },
          Ze = function Ze(e) {
        return Le(e) || L(e, v) && ce(Ee);
      };

      he = Ee._dc = n.delayedCall(E || .25, Me).pause(), Ee.deltaX = Ee.deltaY = 0, Ee._vx = D(0, 50, !0), Ee._vy = D(0, 50, !0), Ee.scrollX = we, Ee.scrollY = Ce, Ee.isDragging = Ee.isGesturing = Ee.isPressed = !1, Ee.enable = function (e) {
        return Ee.isEnabled || (w(Ae ? Ie : f, "scroll", R), p.indexOf("scroll") >= 0 && w(Ae ? Ie : f, "scroll", We, v, de), p.indexOf("wheel") >= 0 && w(f, "wheel", Ve, v, de), (p.indexOf("touch") >= 0 && c || p.indexOf("pointer") >= 0) && (w(f, m[0], Ge, v, de), w(Ie, m[2], qe), w(Ie, m[3], qe), pe && w(f, "click", De, !1, !0), ce && w(f, "click", Ze), ae && w(Ie, "gesturestart", He), oe && w(Ie, "gestureend", ze), J && w(f, u + "enter", Ke), ee && w(f, u + "leave", Xe), te && w(f, u + "move", Ye)), Ee.isEnabled = !0, e && e.type && Ge(e), se && se(Ee)), Ee;
      }, Ee.disable = function () {
        Ee.isEnabled && (b.filter(function (e) {
          return e !== Ee && x(e.target);
        }).length || C(Ae ? Ie : f, "scroll", R), Ee.isPressed && (Ee._vx.reset(), Ee._vy.reset(), C(ne ? f : Ie, m[1], Ue, !0)), C(Ae ? Ie : f, "scroll", We, de), C(f, "wheel", Ve, de), C(f, m[0], Ge, de), C(Ie, m[2], qe), C(Ie, m[3], qe), C(f, "click", De, !0), C(f, "click", Ze), C(Ie, "gesturestart", He), C(Ie, "gestureend", ze), C(f, u + "enter", Ke), C(f, u + "leave", Xe), C(f, u + "move", Ye), Ee.isEnabled = Ee.isPressed = Ee.isDragging = !1, le && le(Ee));
      }, Ee.kill = function () {
        Ee.disable();
        var e = b.indexOf(Ee);
        e >= 0 && b.splice(e, 1), g === Ee && (g = 0);
      }, b.push(Ee), ne && x(f) && (g = Ee), Ee.enable($);
    }, r(e, [{
      key: "velocityX",
      get: function get() {
        return this._vx.getVelocity();
      }
    }, {
      key: "velocityY",
      get: function get() {
        return this._vy.getVelocity();
      }
    }]), e;
  }();

  B.version = "3.10.4", B.create = function (e) {
    return new B(e);
  }, B.register = j, B.getAll = function () {
    return b.slice();
  }, B.getById = function (e) {
    return b.filter(function (t) {
      return t.vars.id === e;
    })[0];
  }, f() && n.registerPlugin(B);
  /*!
     * ScrollTrigger 3.10.4
     * https://greensock.com
     *
     * @license Copyright 2008-2022, GreenSock. All rights reserved.
     * Subject to the terms at https://greensock.com/standard-license or for
     * Club GreenSock members, the agreement issued with that membership.
     * @author: Jack Doyle, jack@greensock.com
    */

  var U,
      G,
      q,
      H,
      z,
      W,
      V,
      Y,
      K,
      X,
      Z,
      Q,
      J,
      ee,
      te,
      re,
      ne,
      ae,
      oe,
      ie,
      se,
      le,
      ce,
      ue,
      de,
      pe,
      ge,
      me,
      fe,
      he,
      be,
      ye,
      ve,
      _e = 1,
      Te = Date.now,
      Ee = Te(),
      Se = 0,
      xe = 0,
      we = function we() {
    return ee = 1;
  },
      Ce = function Ce() {
    return ee = 0;
  },
      ke = function ke(e) {
    return e;
  },
      $e = function $e(e) {
    return Math.round(1e5 * e) / 1e5 || 0;
  },
      Re = function Re() {
    return "undefined" != typeof window;
  },
      Ae = function Ae() {
    return U || Re() && (U = window.gsap) && U.registerPlugin && U;
  },
      Ie = function Ie(e) {
    return !!~V.indexOf(e);
  },
      Ne = function Ne(e) {
    return S(e, "getBoundingClientRect") || (Ie(e) ? function () {
      return tr.width = q.innerWidth, tr.height = q.innerHeight, tr;
    } : function () {
      return ut(e);
    });
  },
      Pe = function Pe(e, t, r) {
    var n = r.d,
        a = r.d2,
        o = r.a;
    return (o = S(e, "getBoundingClientRect")) ? function () {
      return o()[n];
    } : function () {
      return (t ? q["inner" + a] : e["client" + a]) || 0;
    };
  },
      Oe = function Oe(e, t) {
    return !t || ~v.indexOf(e) ? Ne(e) : function () {
      return tr;
    };
  },
      De = function De(e, t) {
    var r = t.s,
        n = t.d2,
        a = t.d,
        o = t.a;
    return (r = "scroll" + n) && (o = S(e, r)) ? o() - Ne(e)()[a] : Ie(e) ? (z[r] || W[r]) - (q["inner" + n] || z["client" + n] || W["client" + n]) : e[r] - e["offset" + n];
  },
      Le = function Le(e, t) {
    for (var r = 0; r < oe.length; r += 3) {
      (!t || ~t.indexOf(oe[r + 1])) && e(oe[r], oe[r + 1], oe[r + 2]);
    }
  },
      Me = function Me(e) {
    return "string" == typeof e;
  },
      Fe = function Fe(e) {
    return "function" == typeof e;
  },
      je = function je(e) {
    return "number" == typeof e;
  },
      Be = function Be(e) {
    return "object" == typeof e;
  },
      Ue = function Ue(e) {
    return Fe(e) && e();
  },
      Ge = function Ge(e, t) {
    return function () {
      var r = Ue(e),
          n = Ue(t);
      return function () {
        Ue(r), Ue(n);
      };
    };
  },
      qe = function qe(e, t, r) {
    return e && e.progress(t ? 0 : 1) && r && e.pause();
  },
      He = function He(e, t) {
    if (e.enabled) {
      var r = t(e);
      r && r.totalTime && (e.callbackAnimation = r);
    }
  },
      ze = Math.abs,
      We = "left",
      Ve = "top",
      Ye = "right",
      Ke = "bottom",
      Xe = "width",
      Ze = "height",
      Qe = "Right",
      Je = "Left",
      et = "Top",
      tt = "Bottom",
      rt = "padding",
      nt = "margin",
      at = "Width",
      ot = "Height",
      it = "px",
      st = function st(e) {
    return q.getComputedStyle(e);
  },
      lt = function lt(e) {
    var t = st(e).position;
    e.style.position = "absolute" === t || "fixed" === t ? t : "relative";
  },
      ct = function ct(e, t) {
    for (var r in t) {
      r in e || (e[r] = t[r]);
    }

    return e;
  },
      ut = function ut(e, t) {
    var r = t && "matrix(1, 0, 0, 1, 0, 0)" !== st(e)[te] && U.to(e, {
      x: 0,
      y: 0,
      xPercent: 0,
      yPercent: 0,
      rotation: 0,
      rotationX: 0,
      rotationY: 0,
      scale: 1,
      skewX: 0,
      skewY: 0
    }).progress(1),
        n = e.getBoundingClientRect();
    return r && r.progress(0).kill(), n;
  },
      dt = function dt(e, t) {
    var r = t.d2;
    return e["offset" + r] || e["client" + r] || 0;
  },
      pt = function pt(e) {
    var t,
        r = [],
        n = e.labels,
        a = e.duration();

    for (t in n) {
      r.push(n[t] / a);
    }

    return r;
  },
      gt = function gt(e) {
    return function (t) {
      return U.utils.snap(pt(e), t);
    };
  },
      mt = function mt(e) {
    var t = U.utils.snap(e),
        r = Array.isArray(e) && e.slice(0).sort(function (e, t) {
      return e - t;
    });
    return r ? function (e, n, a) {
      var o;
      if (void 0 === a && (a = .001), !n) return t(e);

      if (n > 0) {
        for (e -= a, o = 0; o < r.length; o++) {
          if (r[o] >= e) return r[o];
        }

        return r[o - 1];
      }

      for (o = r.length, e += a; o--;) {
        if (r[o] <= e) return r[o];
      }

      return r[0];
    } : function (r, n, a) {
      void 0 === a && (a = .001);
      var o = t(r);
      return !n || Math.abs(o - r) < a || o - r < 0 == n < 0 ? o : t(n < 0 ? r - e : r + e);
    };
  },
      ft = function ft(e) {
    return function (t, r) {
      return mt(pt(e))(t, r.direction);
    };
  },
      ht = function ht(e, t, r, n) {
    return r.split(",").forEach(function (r) {
      return e(t, r, n);
    });
  },
      bt = function bt(e, t, r, n, a) {
    return e.addEventListener(t, r, {
      passive: !n,
      capture: !!a
    });
  },
      yt = function yt(e, t, r, n) {
    return e.removeEventListener(t, r, !!n);
  },
      vt = function vt(e, t, r) {
    return r && r.wheelHandler && e(t, "wheel", r);
  },
      _t = {
    startColor: "green",
    endColor: "red",
    indent: 0,
    fontSize: "16px",
    fontWeight: "normal"
  },
      Tt = {
    toggleActions: "play",
    anticipatePin: 0
  },
      Et = {
    top: 0,
    left: 0,
    center: .5,
    bottom: 1,
    right: 1
  },
      St = function St(e, t) {
    if (Me(e)) {
      var r = e.indexOf("="),
          n = ~r ? +(e.charAt(r - 1) + 1) * parseFloat(e.substr(r + 1)) : 0;
      ~r && (e.indexOf("%") > r && (n *= t / 100), e = e.substr(0, r - 1)), e = n + (e in Et ? Et[e] * t : ~e.indexOf("%") ? parseFloat(e) * t / 100 : parseFloat(e) || 0);
    }

    return e;
  },
      xt = function xt(e, t, r, n, a, o, i, s) {
    var l = a.startColor,
        c = a.endColor,
        u = a.fontSize,
        d = a.indent,
        p = a.fontWeight,
        g = H.createElement("div"),
        m = Ie(r) || "fixed" === S(r, "pinType"),
        f = -1 !== e.indexOf("scroller"),
        h = m ? W : r,
        b = -1 !== e.indexOf("start"),
        y = b ? l : c,
        v = "border-color:" + y + ";font-size:" + u + ";color:" + y + ";font-weight:" + p + ";pointer-events:none;white-space:nowrap;font-family:sans-serif,Arial;z-index:1000;padding:4px 8px;border-width:0;border-style:solid;";
    return v += "position:" + ((f || s) && m ? "fixed;" : "absolute;"), (f || s || !m) && (v += (n === N ? Ye : Ke) + ":" + (o + parseFloat(d)) + "px;"), i && (v += "box-sizing:border-box;text-align:left;width:" + i.offsetWidth + "px;"), g._isStart = b, g.setAttribute("class", "gsap-marker-" + e + (t ? " marker-" + t : "")), g.style.cssText = v, g.innerText = t || 0 === t ? e + "-" + t : e, h.children[0] ? h.insertBefore(g, h.children[0]) : h.appendChild(g), g._offset = g["offset" + n.op.d2], wt(g, 0, n, b), g;
  },
      wt = function wt(e, t, r, n) {
    var a = {
      display: "block"
    },
        o = r[n ? "os2" : "p2"],
        i = r[n ? "p2" : "os2"];
    e._isFlipped = n, a[r.a + "Percent"] = n ? -100 : 0, a[r.a] = n ? "1px" : 0, a["border" + o + at] = 1, a["border" + i + at] = 0, a[r.p] = t + "px", U.set(e, a);
  },
      Ct = [],
      kt = {},
      $t = function $t() {
    return Te() - Se > 34 && Wt();
  },
      Rt = function Rt() {
    (!ce || !ce.isPressed || ce.startX > W.clientWidth) && (y.cache++, fe || (fe = requestAnimationFrame(Wt)), Se || Mt("scrollStart"), Se = Te());
  },
      At = function At() {
    pe = q.innerWidth, de = q.innerHeight;
  },
      It = function It() {
    y.cache++, !J && !le && !H.fullscreenElement && !H.webkitFullscreenElement && (!ue || pe !== q.innerWidth || Math.abs(q.innerHeight - de) > .25 * q.innerHeight) && Y.restart(!0);
  },
      Nt = {},
      Pt = [],
      Ot = [],
      Dt = function Dt(e) {
    var t,
        r = U.ticker.frame,
        n = [],
        a = 0;

    if (be !== r || _e) {
      for (Bt(); a < Ot.length; a += 4) {
        (t = q.matchMedia(Ot[a]).matches) !== Ot[a + 3] && (Ot[a + 3] = t, t ? n.push(a) : Bt(1, Ot[a]) || Fe(Ot[a + 2]) && Ot[a + 2]());
      }

      for (jt(), a = 0; a < n.length; a++) {
        t = n[a], he = Ot[t], Ot[t + 2] = Ot[t + 1](e);
      }

      he = 0, G && qt(0, 1), be = r, Mt("matchMedia");
    }
  },
      Lt = function e() {
    return yt(ir, "scrollEnd", e) || qt(!0);
  },
      Mt = function Mt(e) {
    return Nt[e] && Nt[e].map(function (e) {
      return e();
    }) || Pt;
  },
      Ft = [],
      jt = function jt(e) {
    for (var t = 0; t < Ft.length; t += 5) {
      e && Ft[t + 4] !== e || (Ft[t].style.cssText = Ft[t + 1], Ft[t].getBBox && Ft[t].setAttribute("transform", Ft[t + 2] || ""), Ft[t + 3].uncache = 1);
    }
  },
      Bt = function Bt(e, t) {
    var r;

    for (re = 0; re < Ct.length; re++) {
      r = Ct[re], t && r.media !== t || (e ? r.kill(1) : r.revert());
    }

    t && jt(t), t || Mt("revert");
  },
      Ut = function Ut() {
    return y.cache++ && y.forEach(function (e) {
      return "function" == typeof e && (e.rec = 0);
    });
  },
      Gt = 0,
      qt = function qt(e, t) {
    if (!Se || e) {
      ye = !0;
      var r = Mt("refreshInit");
      ie && ir.sort(), t || Bt(), Ct.slice(0).forEach(function (e) {
        return e.refresh();
      }), Ct.forEach(function (e) {
        return "max" === e.vars.end && e.setPositions(e.start, De(e.scroller, e._dir));
      }), r.forEach(function (e) {
        return e && e.render && e.render(-1);
      }), Ut(), Y.pause(), Gt++, ye = !1, Mt("refresh");
    } else bt(ir, "scrollEnd", Lt);
  },
      Ht = 0,
      zt = 1,
      Wt = function Wt() {
    if (!ye) {
      ir.isUpdating = !0, ve && ve.update(0);
      var e = Ct.length,
          t = Te(),
          r = t - Ee >= 50,
          n = e && Ct[0].scroll();

      if (zt = Ht > n ? -1 : 1, Ht = n, r && (Se && !ee && t - Se > 200 && (Se = 0, Mt("scrollEnd")), Z = Ee, Ee = t), zt < 0) {
        for (re = e; re-- > 0;) {
          Ct[re] && Ct[re].update(0, r);
        }

        zt = 1;
      } else for (re = 0; re < e; re++) {
        Ct[re] && Ct[re].update(0, r);
      }

      ir.isUpdating = !1;
    }

    fe = 0;
  },
      Vt = [We, Ve, Ke, Ye, nt + tt, nt + Qe, nt + et, nt + Je, "display", "flexShrink", "float", "zIndex", "gridColumnStart", "gridColumnEnd", "gridRowStart", "gridRowEnd", "gridArea", "justifySelf", "alignSelf", "placeSelf", "order"],
      Yt = Vt.concat([Xe, Ze, "boxSizing", "max" + at, "max" + ot, "position", nt, rt, rt + et, rt + Qe, rt + tt, rt + Je]),
      Kt = function Kt(e, t, r) {
    Qt(r);
    var n = e._gsap;
    if (n.spacerIsNative) Qt(n.spacerState);else if (e.parentNode === t) {
      var a = t.parentNode;
      a && (a.insertBefore(e, t), a.removeChild(t));
    }
  },
      Xt = function Xt(e, t, r, n) {
    if (e.parentNode !== t) {
      for (var a, o = Vt.length, i = t.style, s = e.style; o--;) {
        i[a = Vt[o]] = r[a];
      }

      i.position = "absolute" === r.position ? "absolute" : "relative", "inline" === r.display && (i.display = "inline-block"), s[Ke] = s[Ye] = i.flexBasis = "auto", i.overflow = "visible", i.boxSizing = "border-box", i[Xe] = dt(e, I) + it, i[Ze] = dt(e, N) + it, i[rt] = s[nt] = s[Ve] = s[We] = "0", Qt(n), s[Xe] = s["max" + at] = r[Xe], s[Ze] = s["max" + ot] = r[Ze], s[rt] = r[rt], e.parentNode.insertBefore(t, e), t.appendChild(e);
    }
  },
      Zt = /([A-Z])/g,
      Qt = function Qt(e) {
    if (e) {
      var t,
          r,
          n = e.t.style,
          a = e.length,
          o = 0;

      for ((e.t._gsap || U.core.getCache(e.t)).uncache = 1; o < a; o += 2) {
        r = e[o + 1], t = e[o], r ? n[t] = r : n[t] && n.removeProperty(t.replace(Zt, "-$1").toLowerCase());
      }
    }
  },
      Jt = function Jt(e) {
    for (var t = Yt.length, r = e.style, n = [], a = 0; a < t; a++) {
      n.push(Yt[a], r[Yt[a]]);
    }

    return n.t = e, n;
  },
      er = function er(e, t, r) {
    for (var n, a = [], o = e.length, i = r ? 8 : 0; i < o; i += 2) {
      n = e[i], a.push(n, n in t ? t[n] : e[i + 1]);
    }

    return a.t = e.t, a;
  },
      tr = {
    left: 0,
    top: 0
  },
      rr = function rr(e, t, r, n, a, o, i, s, l, c, u, d, p) {
    Fe(e) && (e = e(s)), Me(e) && "max" === e.substr(0, 3) && (e = d + ("=" === e.charAt(4) ? St("0" + e.substr(3), r) : 0));
    var g,
        m,
        f,
        h = p ? p.time() : 0;
    if (p && p.seek(0), je(e)) i && wt(i, r, n, !0);else {
      Fe(t) && (t = t(s));

      var b,
          y,
          v,
          _,
          T = e.split(" ");

      f = P(t) || W, (b = ut(f) || {}) && (b.left || b.top) || "none" !== st(f).display || (_ = f.style.display, f.style.display = "block", b = ut(f), _ ? f.style.display = _ : f.style.removeProperty("display")), y = St(T[0], b[n.d]), v = St(T[1] || "0", r), e = b[n.p] - l[n.p] - c + y + a - v, i && wt(i, v, n, r - v < 20 || i._isStart && v > 20), r -= r - v;
    }

    if (o) {
      var E = e + r,
          S = o._isStart;
      g = "scroll" + n.d2, wt(o, E, n, S && E > 20 || !S && (u ? Math.max(W[g], z[g]) : o.parentNode[g]) <= E + 1), u && (l = ut(i), u && (o.style[n.op.p] = l[n.op.p] - n.op.m - o._offset + it));
    }

    return p && f && (g = ut(f), p.seek(d), m = ut(f), p._caScrollDist = g[n.p] - m[n.p], e = e / p._caScrollDist * d), p && p.seek(h), p ? e : Math.round(e);
  },
      nr = /(webkit|moz|length|cssText|inset)/i,
      ar = function ar(e, t, r, n) {
    if (e.parentNode !== t) {
      var a,
          o,
          i = e.style;

      if (t === W) {
        for (a in e._stOrig = i.cssText, o = st(e)) {
          +a || nr.test(a) || !o[a] || "string" != typeof i[a] || "0" === a || (i[a] = o[a]);
        }

        i.top = r, i.left = n;
      } else i.cssText = e._stOrig;

      U.core.getCache(e).uncache = 1, t.appendChild(e);
    }
  },
      or = function or(e, t) {
    var r,
        n,
        a = O(e, t),
        o = "_scroll" + t.p2,
        i = function t(i, s, l, c, u) {
      var d = t.tween,
          p = s.onComplete,
          g = {};
      return l = l || a(), u = c && u || 0, c = c || i - l, d && d.kill(), r = Math.round(l), s[o] = i, s.modifiers = g, g[o] = function (e) {
        return (e = $e(a())) !== r && e !== n && Math.abs(e - r) > 2 && Math.abs(e - n) > 2 ? (d.kill(), t.tween = 0) : e = l + c * d.ratio + u * d.ratio * d.ratio, n = r, r = $e(e);
      }, s.onComplete = function () {
        t.tween = 0, p && p.call(d);
      }, d = t.tween = U.to(e, s);
    };

    return e[o] = a, a.wheelHandler = function () {
      return i.tween && i.tween.kill() && (i.tween = 0);
    }, bt(e, "wheel", a.wheelHandler), i;
  },
      ir = function () {
    function e(t, r) {
      G || e.register(U) || console.warn("Please gsap.registerPlugin(ScrollTrigger)"), this.init(t, r);
    }

    return e.prototype.init = function (t, r) {
      if (this.progress = this.start = 0, this.vars && this.kill(!0, !0), xe) {
        var n,
            a,
            o,
            i,
            s,
            l,
            c,
            u,
            d,
            p,
            g,
            m,
            f,
            h,
            b,
            y,
            _,
            T,
            E,
            x,
            w,
            C,
            k,
            $,
            R,
            A,
            D,
            L,
            M,
            F,
            j,
            B,
            G,
            V,
            Y,
            Q,
            te,
            ne,
            ae = t = ct(Me(t) || je(t) || t.nodeType ? {
          trigger: t
        } : t, Tt),
            oe = ae.onUpdate,
            le = ae.toggleClass,
            ce = ae.id,
            ue = ae.onToggle,
            de = ae.onRefresh,
            pe = ae.scrub,
            ge = ae.trigger,
            fe = ae.pin,
            be = ae.pinSpacing,
            Ee = ae.invalidateOnRefresh,
            we = ae.anticipatePin,
            Ce = ae.onScrubComplete,
            Re = ae.onSnapComplete,
            Ae = ae.once,
            Ne = ae.snap,
            Le = ae.pinReparent,
            Ue = ae.pinSpacer,
            Ge = ae.containerAnimation,
            We = ae.fastScrollEnd,
            Ve = ae.preventOverlaps,
            Ye = t.horizontal || t.containerAnimation && !1 !== t.horizontal ? I : N,
            Ke = !pe && 0 !== pe,
            pt = P(t.scroller || q),
            ht = U.core.getCache(pt),
            vt = Ie(pt),
            Et = "fixed" === ("pinType" in t ? t.pinType : S(pt, "pinType") || vt && "fixed"),
            wt = [t.onEnter, t.onLeave, t.onEnterBack, t.onLeaveBack],
            $t = Ke && t.toggleActions.split(" "),
            At = "markers" in t ? t.markers : Tt.markers,
            Nt = vt ? 0 : parseFloat(st(pt)["border" + Ye.p2 + at]) || 0,
            Pt = this,
            Ot = t.onRefreshInit && function () {
          return t.onRefreshInit(Pt);
        },
            Dt = Pe(pt, vt, Ye),
            Mt = Oe(pt, vt),
            Ft = 0,
            jt = 0,
            Bt = O(pt, Ye);

        if (Pt.media = he, Pt._dir = Ye, we *= 45, Pt.scroller = pt, Pt.scroll = Ge ? Ge.time.bind(Ge) : Bt, i = Bt(), Pt.vars = t, r = r || t.animation, "refreshPriority" in t && (ie = 1, -9999 === t.refreshPriority && (ve = Pt)), ht.tweenScroll = ht.tweenScroll || {
          top: or(pt, N),
          left: or(pt, I)
        }, Pt.tweenTo = n = ht.tweenScroll[Ye.p], Pt.scrubDuration = function (e) {
          (j = je(e) && e) ? F ? F.duration(e) : F = U.to(r, {
            ease: "expo",
            totalProgress: "+=0.001",
            duration: j,
            paused: !0,
            onComplete: function onComplete() {
              return Ce && Ce(Pt);
            }
          }) : (F && F.progress(1).kill(), F = 0);
        }, r && (r.vars.lazy = !1, r._initted || !1 !== r.vars.immediateRender && !1 !== t.immediateRender && r.render(0, !0, !0), Pt.animation = r.pause(), r.scrollTrigger = Pt, Pt.scrubDuration(pe), L = 0, ce || (ce = r.vars.id)), Ct.push(Pt), Ne && (Be(Ne) && !Ne.push || (Ne = {
          snapTo: Ne
        }), "scrollBehavior" in W.style && U.set(vt ? [W, z] : pt, {
          scrollBehavior: "auto"
        }), o = Fe(Ne.snapTo) ? Ne.snapTo : "labels" === Ne.snapTo ? gt(r) : "labelsDirectional" === Ne.snapTo ? ft(r) : !1 !== Ne.directional ? function (e, t) {
          return mt(Ne.snapTo)(e, Te() - jt < 500 ? 0 : t.direction);
        } : U.utils.snap(Ne.snapTo), B = Ne.duration || {
          min: .1,
          max: 2
        }, B = Be(B) ? X(B.min, B.max) : X(B, B), G = U.delayedCall(Ne.delay || j / 2 || .1, function () {
          var e = Bt(),
              t = Te() - jt < 500,
              a = n.tween;
          if (!(t || Math.abs(Pt.getVelocity()) < 10) || a || ee || Ft === e) Pt.isActive && Ft !== e && G.restart(!0);else {
            var i = (e - l) / f,
                s = r && !Ke ? r.totalProgress() : i,
                u = t ? 0 : (s - M) / (Te() - Z) * 1e3 || 0,
                d = U.utils.clamp(-i, 1 - i, ze(u / 2) * u / .185),
                p = i + (!1 === Ne.inertia ? 0 : d),
                g = X(0, 1, o(p, Pt)),
                m = Math.round(l + g * f),
                h = Ne,
                b = h.onStart,
                y = h.onInterrupt,
                v = h.onComplete;

            if (e <= c && e >= l && m !== e) {
              if (a && !a._initted && a.data <= ze(m - e)) return;
              !1 === Ne.inertia && (d = g - i), n(m, {
                duration: B(ze(.185 * Math.max(ze(p - s), ze(g - s)) / u / .05 || 0)),
                ease: Ne.ease || "power3",
                data: ze(m - e),
                onInterrupt: function onInterrupt() {
                  return G.restart(!0) && y && y(Pt);
                },
                onComplete: function onComplete() {
                  Pt.update(), Ft = Bt(), L = M = r && !Ke ? r.totalProgress() : Pt.progress, Re && Re(Pt), v && v(Pt);
                }
              }, e, d * f, m - e - d * f), b && b(Pt, n.tween);
            }
          }
        }).pause()), ce && (kt[ce] = Pt), (ne = (ge = Pt.trigger = P(ge || fe)) && ge._gsap && ge._gsap.stRevert) && (ne = ne(Pt)), fe = !0 === fe ? ge : P(fe), Me(le) && (le = {
          targets: ge,
          className: le
        }), fe && (!1 === be || be === nt || (be = !(!be && "flex" === st(fe.parentNode).display) && rt), Pt.pin = fe, !1 !== t.force3D && U.set(fe, {
          force3D: !0
        }), (a = U.core.getCache(fe)).spacer ? h = a.pinState : (Ue && ((Ue = P(Ue)) && !Ue.nodeType && (Ue = Ue.current || Ue.nativeElement), a.spacerIsNative = !!Ue, Ue && (a.spacerState = Jt(Ue))), a.spacer = _ = Ue || H.createElement("div"), _.classList.add("pin-spacer"), ce && _.classList.add("pin-spacer-" + ce), a.pinState = h = Jt(fe)), Pt.spacer = _ = a.spacer, D = st(fe), k = D[be + Ye.os2], E = U.getProperty(fe), x = U.quickSetter(fe, Ye.a, it), Xt(fe, _, D), y = Jt(fe)), At) {
          m = Be(At) ? ct(At, _t) : _t, p = xt("scroller-start", ce, pt, Ye, m, 0), g = xt("scroller-end", ce, pt, Ye, m, 0, p), T = p["offset" + Ye.op.d2];
          var Ut = P(S(pt, "content") || pt);
          u = this.markerStart = xt("start", ce, Ut, Ye, m, T, 0, Ge), d = this.markerEnd = xt("end", ce, Ut, Ye, m, T, 0, Ge), Ge && (te = U.quickSetter([u, d], Ye.a, it)), Et || v.length && !0 === S(pt, "fixedMarkers") || (lt(vt ? W : pt), U.set([p, g], {
            force3D: !0
          }), R = U.quickSetter(p, Ye.a, it), A = U.quickSetter(g, Ye.a, it));
        }

        if (Ge) {
          var Gt = Ge.vars.onUpdate,
              qt = Ge.vars.onUpdateParams;
          Ge.eventCallback("onUpdate", function () {
            Pt.update(0, 0, 1), Gt && Gt.apply(qt || []);
          });
        }

        Pt.previous = function () {
          return Ct[Ct.indexOf(Pt) - 1];
        }, Pt.next = function () {
          return Ct[Ct.indexOf(Pt) + 1];
        }, Pt.revert = function (e) {
          var t = !1 !== e || !Pt.enabled,
              n = J;
          t !== Pt.isReverted && (t && (Pt.scroll.rec || !J || !ye || (Pt.scroll.rec = Bt()), Y = Math.max(Bt(), Pt.scroll.rec || 0), V = Pt.progress, Q = r && r.progress()), u && [u, d, p, g].forEach(function (e) {
            return e.style.display = t ? "none" : "block";
          }), t && (J = 1), Pt.update(t), J = n, fe && (t ? Kt(fe, _, h) : (!Le || !Pt.isActive) && Xt(fe, _, st(fe), $)), Pt.isReverted = t);
        }, Pt.refresh = function (a, o) {
          if (!J && Pt.enabled || o) if (fe && a && Se) bt(e, "scrollEnd", Lt);else {
            !ye && Ot && Ot(Pt), J = 1, jt = Te(), n.tween && (n.tween.kill(), n.tween = 0), F && F.pause(), Ee && r && r.time(-.01, !0).invalidate(), Pt.isReverted || Pt.revert();

            for (var m, v, T, S, x, k, R, A, D, L, M = Dt(), j = Mt(), B = Ge ? Ge.duration() : De(pt, Ye), q = 0, H = 0, z = t.end, K = t.endTrigger || ge, X = t.start || (0 !== t.start && ge ? fe ? "0 0" : "0 100%" : 0), Z = Pt.pinnedContainer = t.pinnedContainer && P(t.pinnedContainer), ee = ge && Math.max(0, Ct.indexOf(Pt)) || 0, te = ee; te--;) {
              (k = Ct[te]).end || k.refresh(0, 1) || (J = 1), !(R = k.pin) || R !== ge && R !== fe || k.isReverted || (L || (L = []), L.unshift(k), k.revert()), k !== Ct[te] && (ee--, te--);
            }

            for (Fe(X) && (X = X(Pt)), l = rr(X, ge, M, Ye, Bt(), u, p, Pt, j, Nt, Et, B, Ge) || (fe ? -.001 : 0), Fe(z) && (z = z(Pt)), Me(z) && !z.indexOf("+=") && (~z.indexOf(" ") ? z = (Me(X) ? X.split(" ")[0] : "") + z : (q = St(z.substr(2), M), z = Me(X) ? X : l + q, K = ge)), c = Math.max(l, rr(z || (K ? "100% 0" : B), K, M, Ye, Bt() + q, d, g, Pt, j, Nt, Et, B, Ge)) || -.001, f = c - l || (l -= .01) && .001, q = 0, te = ee; te--;) {
              (R = (k = Ct[te]).pin) && k.start - k._pinPush < l && !Ge && k.end > 0 && (m = k.end - k.start, R !== ge && R !== Z || je(X) || (q += m * (1 - k.progress)), R === fe && (H += m));
            }

            if (l += q, c += q, Pt._pinPush = H, u && q && ((m = {})[Ye.a] = "+=" + q, Z && (m[Ye.p] = "-=" + Bt()), U.set([u, d], m)), fe) m = st(fe), S = Ye === N, T = Bt(), w = parseFloat(E(Ye.a)) + H, !B && c > 1 && ((vt ? W : pt).style["overflow-" + Ye.a] = "scroll"), Xt(fe, _, m), y = Jt(fe), v = ut(fe, !0), A = Et && O(pt, S ? I : N)(), be && (($ = [be + Ye.os2, f + H + it]).t = _, (te = be === rt ? dt(fe, Ye) + f + H : 0) && $.push(Ye.d, te + it), Qt($), Et && Bt(Y)), Et && ((x = {
              top: v.top + (S ? T - l : A) + it,
              left: v.left + (S ? A : T - l) + it,
              boxSizing: "border-box",
              position: "fixed"
            })[Xe] = x["max" + at] = Math.ceil(v.width) + it, x[Ze] = x["max" + ot] = Math.ceil(v.height) + it, x[nt] = x[nt + et] = x[nt + Qe] = x[nt + tt] = x[nt + Je] = "0", x[rt] = m[rt], x[rt + et] = m[rt + et], x[rt + Qe] = m[rt + Qe], x[rt + tt] = m[rt + tt], x[rt + Je] = m[rt + Je], b = er(h, x, Le)), r ? (D = r._initted, se(1), r.render(r.duration(), !0, !0), C = E(Ye.a) - w + f + H, f !== C && Et && b.splice(b.length - 2, 2), r.render(0, !0, !0), D || r.invalidate(), se(0)) : C = f;else if (ge && Bt() && !Ge) for (v = ge.parentNode; v && v !== W;) {
              v._pinOffset && (l -= v._pinOffset, c -= v._pinOffset), v = v.parentNode;
            }
            L && L.forEach(function (e) {
              return e.revert(!1);
            }), Pt.start = l, Pt.end = c, i = s = Bt(), Ge || (i < Y && Bt(Y), Pt.scroll.rec = 0), Pt.revert(!1), G && (Ft = -1, Pt.isActive && Bt(l + f * V), G.restart(!0)), J = 0, r && Ke && (r._initted || Q) && r.progress() !== Q && r.progress(Q, !0).render(r.time(), !0, !0), (V !== Pt.progress || Ge) && (r && !Ke && r.totalProgress(V, !0), Pt.progress = V, Pt.update(0, 0, 1)), fe && be && (_._pinOffset = Math.round(Pt.progress * C)), de && de(Pt);
          }
        }, Pt.getVelocity = function () {
          return (Bt() - s) / (Te() - Z) * 1e3 || 0;
        }, Pt.endAnimation = function () {
          qe(Pt.callbackAnimation), r && (F ? F.progress(1) : r.paused() ? Ke || qe(r, Pt.direction < 0, 1) : qe(r, r.reversed()));
        }, Pt.labelToScroll = function (e) {
          return r && r.labels && (l || Pt.refresh() || l) + r.labels[e] / r.duration() * f || 0;
        }, Pt.getTrailing = function (e) {
          var t = Ct.indexOf(Pt),
              r = Pt.direction > 0 ? Ct.slice(0, t).reverse() : Ct.slice(t + 1);
          return (Me(e) ? r.filter(function (t) {
            return t.vars.preventOverlaps === e;
          }) : r).filter(function (e) {
            return Pt.direction > 0 ? e.end <= l : e.start >= c;
          });
        }, Pt.update = function (e, t, a) {
          if (!Ge || a || e) {
            var o,
                u,
                d,
                g,
                m,
                h,
                v,
                T = Pt.scroll(),
                E = e ? 0 : (T - l) / f,
                S = E < 0 ? 0 : E > 1 ? 1 : E || 0,
                $ = Pt.progress;

            if (t && (s = i, i = Ge ? Bt() : T, Ne && (M = L, L = r && !Ke ? r.totalProgress() : S)), we && !S && fe && !J && !_e && Se && l < T + (T - s) / (Te() - Z) * we && (S = 1e-4), S !== $ && Pt.enabled) {
              if (g = (m = (o = Pt.isActive = !!S && S < 1) != (!!$ && $ < 1)) || !!S != !!$, Pt.direction = S > $ ? 1 : -1, Pt.progress = S, g && !J && (u = S && !$ ? 0 : 1 === S ? 1 : 1 === $ ? 2 : 3, Ke && (d = !m && "none" !== $t[u + 1] && $t[u + 1] || $t[u], v = r && ("complete" === d || "reset" === d || d in r))), Ve && (m || v) && (v || pe || !r) && (Fe(Ve) ? Ve(Pt) : Pt.getTrailing(Ve).forEach(function (e) {
                return e.endAnimation();
              })), Ke || (!F || J || _e ? r && r.totalProgress(S, !!J) : ((Ge || ve && ve !== Pt) && F.render(F._dp._time - F._start), F.resetTo ? F.resetTo("totalProgress", S, r._tTime / r._tDur) : (F.vars.totalProgress = S, F.invalidate().restart()))), fe) if (e && be && (_.style[be + Ye.os2] = k), Et) {
                if (g) {
                  if (h = !e && S > $ && c + 1 > T && T + 1 >= De(pt, Ye), Le) if (e || !o && !h) ar(fe, _);else {
                    var I = ut(fe, !0),
                        P = T - l;
                    ar(fe, W, I.top + (Ye === N ? P : 0) + it, I.left + (Ye === N ? 0 : P) + it);
                  }
                  Qt(o || h ? b : y), C !== f && S < 1 && o || x(w + (1 !== S || h ? 0 : C));
                }
              } else x($e(w + C * S));
              Ne && !n.tween && !J && !_e && G.restart(!0), le && (m || Ae && S && (S < 1 || !me)) && K(le.targets).forEach(function (e) {
                return e.classList[o || Ae ? "add" : "remove"](le.className);
              }), oe && !Ke && !e && oe(Pt), g && !J ? (Ke && (v && ("complete" === d ? r.pause().totalProgress(1) : "reset" === d ? r.restart(!0).pause() : "restart" === d ? r.restart(!0) : r[d]()), oe && oe(Pt)), !m && me || (ue && m && He(Pt, ue), wt[u] && He(Pt, wt[u]), Ae && (1 === S ? Pt.kill(!1, 1) : wt[u] = 0), m || wt[u = 1 === S ? 1 : 3] && He(Pt, wt[u])), We && !o && Math.abs(Pt.getVelocity()) > (je(We) ? We : 2500) && (qe(Pt.callbackAnimation), F ? F.progress(1) : qe(r, !S, 1))) : Ke && oe && !J && oe(Pt);
            }

            if (A) {
              var O = Ge ? T / Ge.duration() * (Ge._caScrollDist || 0) : T;
              R(O + (p._isFlipped ? 1 : 0)), A(O);
            }

            te && te(-T / Ge.duration() * (Ge._caScrollDist || 0));
          }
        }, Pt.enable = function (t, r) {
          Pt.enabled || (Pt.enabled = !0, bt(pt, "resize", It), bt(vt ? H : pt, "scroll", Rt), Ot && bt(e, "refreshInit", Ot), !1 !== t && (Pt.progress = V = 0, i = s = Ft = Bt()), !1 !== r && Pt.refresh());
        }, Pt.getTween = function (e) {
          return e && n ? n.tween : F;
        }, Pt.setPositions = function (e, t) {
          fe && (w += e - l, C += t - e - f), Pt.start = l = e, Pt.end = c = t, f = t - e, Pt.update();
        }, Pt.disable = function (t, r) {
          if (Pt.enabled && (!1 !== t && Pt.revert(), Pt.enabled = Pt.isActive = !1, r || F && F.pause(), Y = 0, a && (a.uncache = 1), Ot && yt(e, "refreshInit", Ot), G && (G.pause(), n.tween && n.tween.kill() && (n.tween = 0)), !vt)) {
            for (var o = Ct.length; o--;) {
              if (Ct[o].scroller === pt && Ct[o] !== Pt) return;
            }

            yt(pt, "resize", It), yt(pt, "scroll", Rt);
          }
        }, Pt.kill = function (e, n) {
          Pt.disable(e, n), F && !n && F.kill(), ce && delete kt[ce];
          var o = Ct.indexOf(Pt);
          o >= 0 && Ct.splice(o, 1), o === re && zt > 0 && re--, o = 0, Ct.forEach(function (e) {
            return e.scroller === Pt.scroller && (o = 1);
          }), o || (Pt.scroll.rec = 0), r && (r.scrollTrigger = null, e && r.render(-1), n || r.kill()), u && [u, d, p, g].forEach(function (e) {
            return e.parentNode && e.parentNode.removeChild(e);
          }), ve === Pt && (ve = 0), fe && (a && (a.uncache = 1), o = 0, Ct.forEach(function (e) {
            return e.pin === fe && o++;
          }), o || (a.spacer = 0)), t.onKill && t.onKill(Pt);
        }, Pt.enable(!1, !1), ne && ne(Pt), r && r.add && !f ? U.delayedCall(.01, function () {
          return l || c || Pt.refresh();
        }) && (f = .01) && (l = c = 0) : Pt.refresh();
      } else this.update = this.refresh = this.kill = ke;
    }, e.register = function (t) {
      return G || (U = t || Ae(), Re() && window.document && e.enable(), G = xe), G;
    }, e.defaults = function (e) {
      if (e) for (var t in e) {
        Tt[t] = e[t];
      }
      return Tt;
    }, e.disable = function (e, t) {
      xe = 0, Ct.forEach(function (r) {
        return r[t ? "kill" : "disable"](e);
      }), yt(q, "wheel", Rt), yt(H, "scroll", Rt), clearInterval(Q), yt(H, "touchcancel", ke), yt(W, "touchstart", ke), ht(yt, H, "pointerdown,touchstart,mousedown", we), ht(yt, H, "pointerup,touchend,mouseup", Ce), Y.kill(), Le(yt);

      for (var r = 0; r < y.length; r += 3) {
        vt(yt, y[r], y[r + 1]), vt(yt, y[r], y[r + 2]);
      }
    }, e.enable = function () {
      if (q = window, H = document, z = H.documentElement, W = H.body, U && (K = U.utils.toArray, X = U.utils.clamp, se = U.core.suppressOverwrites || ke, U.core.globals("ScrollTrigger", e), W)) {
        xe = 1, B.register(U), e.isTouch = B.isTouch, ge = B.isTouch && /(iPad|iPhone|iPod|Mac)/g.test(navigator.userAgent), bt(q, "wheel", Rt), V = [q, H, z, W], e.matchMedia({
          "(orientation: portrait)": function orientationPortrait() {
            return At(), At;
          }
        }), bt(H, "scroll", Rt);
        var t,
            r,
            n = W.style,
            a = n.borderTopStyle;

        for (n.borderTopStyle = "solid", t = ut(W), N.m = Math.round(t.top + N.sc()) || 0, I.m = Math.round(t.left + I.sc()) || 0, a ? n.borderTopStyle = a : n.removeProperty("border-top-style"), Q = setInterval($t, 250), U.delayedCall(.5, function () {
          return _e = 0;
        }), bt(H, "touchcancel", ke), bt(W, "touchstart", ke), ht(bt, H, "pointerdown,touchstart,mousedown", we), ht(bt, H, "pointerup,touchend,mouseup", Ce), te = U.utils.checkPrefix("transform"), Yt.push(te), G = Te(), Y = U.delayedCall(.2, qt).pause(), oe = [H, "visibilitychange", function () {
          var e = q.innerWidth,
              t = q.innerHeight;
          H.hidden ? (ne = e, ae = t) : ne === e && ae === t || It();
        }, H, "DOMContentLoaded", qt, q, "load", qt, q, "resize", It], Le(bt), Ct.forEach(function (e) {
          return e.enable(0, 1);
        }), r = 0; r < y.length; r += 3) {
          vt(yt, y[r], y[r + 1]), vt(yt, y[r], y[r + 2]);
        }
      }
    }, e.config = function (t) {
      "limitCallbacks" in t && (me = !!t.limitCallbacks);
      var r = t.syncInterval;
      r && clearInterval(Q) || (Q = r) && setInterval($t, r), "ignoreMobileResize" in t && (ue = 1 === e.isTouch && t.ignoreMobileResize), "autoRefreshEvents" in t && (Le(yt) || Le(bt, t.autoRefreshEvents || "none"), le = -1 === (t.autoRefreshEvents + "").indexOf("resize"));
    }, e.scrollerProxy = function (e, t) {
      var r = P(e),
          n = y.indexOf(r),
          a = Ie(r);
      ~n && y.splice(n, a ? 6 : 2), t && (a ? v.unshift(q, t, W, t, z, t) : v.unshift(r, t));
    }, e.matchMedia = function (e) {
      var t, r, n, a, o;

      for (r in e) {
        n = Ot.indexOf(r), a = e[r], he = r, "all" === r ? a() : (t = q.matchMedia(r)) && (t.matches && (o = a()), ~n ? (Ot[n + 1] = Ge(Ot[n + 1], a), Ot[n + 2] = Ge(Ot[n + 2], o)) : (n = Ot.length, Ot.push(r, a, o), t.addListener ? t.addListener(Dt) : t.addEventListener("change", Dt)), Ot[n + 3] = t.matches), he = 0;
      }

      return Ot;
    }, e.clearMatchMedia = function (e) {
      e || (Ot.length = 0), (e = Ot.indexOf(e)) >= 0 && Ot.splice(e, 4);
    }, e.isInViewport = function (e, t, r) {
      var n = (Me(e) ? P(e) : e).getBoundingClientRect(),
          a = n[r ? Xe : Ze] * t || 0;
      return r ? n.right - a > 0 && n.left + a < q.innerWidth : n.bottom - a > 0 && n.top + a < q.innerHeight;
    }, e.positionInViewport = function (e, t, r) {
      Me(e) && (e = P(e));
      var n = e.getBoundingClientRect(),
          a = n[r ? Xe : Ze],
          o = null == t ? a / 2 : t in Et ? Et[t] * a : ~t.indexOf("%") ? parseFloat(t) * a / 100 : parseFloat(t) || 0;
      return r ? (n.left + o) / q.innerWidth : (n.top + o) / q.innerHeight;
    }, e;
  }();

  ir.version = "3.10.4", ir.saveStyles = function (e) {
    return e ? K(e).forEach(function (e) {
      if (e && e.style) {
        var t = Ft.indexOf(e);
        t >= 0 && Ft.splice(t, 5), Ft.push(e, e.style.cssText, e.getBBox && e.getAttribute("transform"), U.core.getCache(e), he);
      }
    }) : Ft;
  }, ir.revert = function (e, t) {
    return Bt(!e, t);
  }, ir.create = function (e, t) {
    return new ir(e, t);
  }, ir.refresh = function (e) {
    return e ? It() : (G || ir.register()) && qt(!0);
  }, ir.update = Wt, ir.clearScrollMemory = Ut, ir.maxScroll = function (e, t) {
    return De(e, t ? I : N);
  }, ir.getScrollFunc = function (e, t) {
    return O(P(e), t ? I : N);
  }, ir.getById = function (e) {
    return kt[e];
  }, ir.getAll = function () {
    return Ct.filter(function (e) {
      return "ScrollSmoother" !== e.vars.id;
    });
  }, ir.isScrolling = function () {
    return !!Se;
  }, ir.snapDirectional = mt, ir.addEventListener = function (e, t) {
    var r = Nt[e] || (Nt[e] = []);
    ~r.indexOf(t) || r.push(t);
  }, ir.removeEventListener = function (e, t) {
    var r = Nt[e],
        n = r && r.indexOf(t);
    n >= 0 && r.splice(n, 1);
  }, ir.batch = function (e, t) {
    var r,
        n = [],
        a = {},
        o = t.interval || .016,
        i = t.batchMax || 1e9,
        s = function s(e, t) {
      var r = [],
          n = [],
          a = U.delayedCall(o, function () {
        t(r, n), r = [], n = [];
      }).pause();
      return function (e) {
        r.length || a.restart(!0), r.push(e.trigger), n.push(e), i <= r.length && a.progress(1);
      };
    };

    for (r in t) {
      a[r] = "on" === r.substr(0, 2) && Fe(t[r]) && "onRefreshInit" !== r ? s(r, t[r]) : t[r];
    }

    return Fe(i) && (i = i(), bt(ir, "refresh", function () {
      return i = t.batchMax();
    })), K(e).forEach(function (e) {
      var t = {};

      for (r in a) {
        t[r] = a[r];
      }

      t.trigger = e, n.push(ir.create(t));
    }), n;
  };

  var sr,
      lr = function lr(e, t, r, n) {
    return t > n ? e(n) : t < 0 && e(0), r > n ? (n - t) / (r - t) : r < 0 ? t / (t - r) : 1;
  },
      cr = function e(t, r) {
    !0 === r ? t.style.removeProperty("touch-action") : t.style.touchAction = !0 === r ? "auto" : r ? "pan-" + r + (B.isTouch ? " pinch-zoom" : "") : "none", t === z && e(W, r);
  },
      ur = {
    auto: 1,
    scroll: 1
  },
      dr = function dr(e) {
    var t,
        r = e.event,
        n = e.target,
        a = e.axis,
        o = (r.changedTouches ? r.changedTouches[0] : r).target,
        i = o._gsap || U.core.getCache(o),
        s = Te();

    if (!i._isScrollT || s - i._isScrollT > 2e3) {
      for (; o && o.scrollHeight <= o.clientHeight;) {
        o = o.parentNode;
      }

      i._isScroll = o && !Ie(o) && o !== n && (ur[(t = st(o)).overflowY] || ur[t.overflowX]), i._isScrollT = s;
    }

    (i._isScroll || "x" === a) && (r._gsapAllow = !0);
  },
      pr = function pr(e, t, r, n) {
    return B.create({
      target: e,
      capture: !0,
      debounce: !1,
      lockAxis: !0,
      type: t,
      onWheel: n = n && dr,
      onPress: n,
      onDrag: n,
      onScroll: n,
      onEnable: function onEnable() {
        return r && bt(H, B.eventTypes[0], mr, !1, !0);
      },
      onDisable: function onDisable() {
        return yt(H, B.eventTypes[0], mr, !0);
      }
    });
  },
      gr = /(input|label|select|textarea)/i,
      mr = function mr(e) {
    var t = gr.test(e.target.tagName);
    (t || sr) && (e._gsapAllow = !0, sr = t);
  },
      fr = function fr(e) {
    Be(e) || (e = {}), e.preventDefault = e.isNormalizer = e.allowClicks = !0, e.type || (e.type = "wheel,touch"), e.debounce = !!e.debounce, e.id = e.id || "normalizer";

    var t,
        r,
        n,
        a,
        o,
        i,
        s,
        l,
        c = e,
        u = c.normalizeScrollX,
        d = c.momentum,
        p = c.allowNestedScroll,
        g = P(e.target) || z,
        m = U.core.globals().ScrollSmoother,
        f = ge && (e.content && P(e.content) || m && m.get() && m.get().content()),
        h = O(g, N),
        b = O(g, I),
        v = 1,
        _ = (B.isTouch && q.visualViewport ? q.visualViewport.scale * q.visualViewport.width : q.outerWidth) / q.innerWidth,
        T = 0,
        E = Fe(d) ? function () {
      return d(t);
    } : function () {
      return d || 2.8;
    },
        S = pr(g, e.type, !0, p),
        x = function x() {
      return n = !1;
    },
        w = ke,
        C = ke,
        k = function k() {
      r = De(g, N), C = X(ge ? 1 : 0, r), u && (w = X(0, De(g, I))), a = Gt;
    },
        $ = function $() {
      if (n) {
        requestAnimationFrame(x);
        var e = $e(t.deltaY / 2),
            r = C(h.v - e);
        return f && r !== h.v + h.offset && (h.offset = r - h.v, f.style.transform = "translateY(" + -h.offset + "px)", f._gsap && (f._gsap.y = -h.offset + "px"), h.cacheID = y.cache, Wt()), !0;
      }

      f && (f.style.transform = "translateY(0px)", h.offset = h.cacheID = 0, f._gsap && (f._gsap.y = "0px")), n = !0;
    },
        R = function R() {
      k(), o.isActive() && o.vars.scrollY > r && (h() > r ? o.progress(1) && h(r) : o.resetTo("scrollY", r));
    };

    return e.ignoreCheck = function (e) {
      return ge && "touchmove" === e.type && $() || v > 1.05 && "touchstart" !== e.type || t.isGesturing || e.touches && e.touches.length > 1;
    }, e.onPress = function () {
      var e = v;
      v = $e((q.visualViewport && q.visualViewport.scale || 1) / _), o.pause(), e !== v && cr(g, v > 1.01 || !u && "x"), n = !1, i = b(), s = h(), k(), a = Gt;
    }, e.onRelease = e.onGestureStart = function (e, t) {
      if (f && (f.style.transform = "translateY(0px)", h.offset = h.cacheID = 0, f._gsap && (f._gsap.y = "0px")), t) {
        y.cache++;
        var n,
            a,
            i = E();
        u && (a = (n = b()) + .05 * i * -e.velocityX / .227, i *= lr(b, n, a, De(g, I)), o.vars.scrollX = w(a)), a = (n = h()) + .05 * i * -e.velocityY / .227, i *= lr(h, n, a, De(g, N)), o.vars.scrollY = C(a), o.invalidate().duration(i).play(.01), (ge && o.vars.scrollY >= r || n >= r - 1) && U.to({}, {
          onUpdate: R,
          duration: i
        });
      } else l.restart(!0);
    }, e.onWheel = function () {
      o._ts && o.pause(), Te() - T > 1e3 && (a = 0, T = Te());
    }, e.onChange = function (e, t, r, n, o) {
      Gt !== a && k(), t && u && b(w(n[2] === t ? i + (e.startX - e.x) : b() + t - n[1])), r && h(C(o[2] === r ? s + (e.startY - e.y) : h() + r - o[1])), Wt();
    }, e.onEnable = function () {
      cr(g, !u && "x"), bt(q, "resize", R), S.enable();
    }, e.onDisable = function () {
      cr(g, !0), yt(q, "resize", R), S.kill();
    }, (t = new B(e)).iOS = ge, ge && !h() && h(1), l = t._dc, o = U.to(t, {
      ease: "power4",
      paused: !0,
      scrollX: u ? "+=0.1" : "+=0",
      scrollY: "+=0.1",
      onComplete: l.vars.onComplete
    }), t;
  };

  ir.sort = function (e) {
    return Ct.sort(e || function (e, t) {
      return -1e6 * (e.vars.refreshPriority || 0) + e.start - (t.start + -1e6 * (t.vars.refreshPriority || 0));
    });
  }, ir.observe = function (e) {
    return new B(e);
  }, ir.normalizeScroll = function (e) {
    if (void 0 === e) return ce;
    if (!0 === e && ce) return ce.enable();
    if (!1 === e) return ce && ce.kill();
    var t = e instanceof B ? e : fr(e);
    return ce && ce.target === t.target && ce.kill(), Ie(t.target) && (ce = t), t;
  }, ir.core = {
    _getVelocityProp: D,
    _inputObserver: pr,
    _scrollers: y,
    _proxies: v,
    bridge: {
      ss: function ss() {
        Se || Mt("scrollStart"), Se = Te();
      },
      ref: function ref() {
        return J;
      }
    }
  }, Ae() && U.registerPlugin(ir), e.ScrollTrigger = ir, e.default = ir, "undefined" == typeof window || window !== e ? Object.defineProperty(e, "__esModule", {
    value: !0
  }) : delete window.default;
}(ScrollTrigger.exports), gsap.registerPlugin(ScrollTrigger.exports.ScrollTrigger);

var MobileNavMenu = function MobileNavMenu(e) {
  var t,
      r = e.data,
      n = e.navbarLinks,
      a = e.pageContext,
      o = useAnalytics$1(),
      i = useButton().getVariant,
      s = useTheme$4(),
      l = useState(!1),
      c = l[0],
      u = l[1],
      d = useState(!1),
      p = d[0],
      g = d[1],
      m = useState(!1),
      f = m[0],
      h = m[1],
      b = useState(null),
      y = b[0],
      v = b[1],
      _ = useRef(null),
      T = {
    navbar: r,
    pageContext: a,
    theme: s,
    params: {
      isNavbarBackgroundSolid: c
    }
  },
      E = function E(e) {
    null == o || o.track("mkt_clicked_sign_in", {
      title: e
    });
  },
      S = function S(e, t) {
    return jsxs(Box, _assign$({
      sx: e.styles
    }, {
      children: [jsxs(ListItem, _assign$({
        disablePadding: !0,
        onClick: function onClick() {
          return function (e) {
            v(e), h(!f);
          }(t);
        }
      }, {
        children: [jsx$1(ListItemButton, _assign$({
          sx: {
            paddingY: s.spacing(2)
          }
        }, {
          children: jsx$1(LinkRootTitle, {
            children: e.title
          })
        })), jsx$1(Stack$2, _assign$({
          alignItems: "center",
          width: 55
        }, {
          children: y === t && f ? jsx$1(MdExpandLess, {
            size: 30,
            fill: s.palette.primary.main
          }) : jsx$1(MdExpandMore, {
            size: 30
          })
        }))]
      })), jsx$1(Divider, {
        variant: "middle"
      }), jsx$1(Collapse$1, _assign$({
        in: y === t && f,
        timeout: "auto",
        unmountOnExit: !0
      }, {
        children: jsx$1(List, _assign$({
          sx: {
            paddingX: 1.2
          }
        }, {
          children: jsx$1(Stack$2, _assign$({
            divider: jsx$1(Divider, {
              orientation: "horizontal",
              flexItem: !0,
              variant: "middle"
            }),
            spacing: 2
          }, {
            children: e.columns.map(function (e) {
              return jsxs(Box, {
                children: [null != e.title && "" !== e.title && jsx$1(LinkTitle$1, _assign$({
                  component: "h5",
                  padding: s.spacing(2)
                }, {
                  children: e.title
                })), null == e ? void 0 : e.links.map(function (e, t) {
                  return function (e, t) {
                    return jsx$1(ColumnRoot, _assign$({
                      link: e
                    }, {
                      children: jsxs(Stack$2, _assign$({
                        direction: "row",
                        alignItems: "center",
                        marginX: 2,
                        minWidth: 295
                      }, {
                        children: [null !== e.icon && jsx$1(Box, _assign$({
                          display: "flex",
                          justifyContent: "center",
                          paddingLeft: 2
                        }, {
                          children: jsx$1(CmsImage, {
                            media: e.icon,
                            width: 24,
                            height: 24
                          })
                        })), jsxs(LinkContent$1, {
                          children: [jsx$1(LinkColumnTitle, _assign$({
                            padding: 2,
                            pb: null != e.subtitle && "" !== e.subtitle ? 0 : 2,
                            component: "h6"
                          }, {
                            children: e.title
                          })), null != e.subtitle && "" !== e.subtitle && jsx$1(LinkSubTitle$1, _assign$({
                            pl: 2
                          }, {
                            children: e.subtitle
                          }))]
                        })]
                      }))
                    }), t);
                  }(e, t);
                })]
              }, e.id);
            })
          }))
        }))
      }))]
    }), e.id);
  };

  return useEffect(function () {
    var e = function e() {
      window.scrollY >= 25 ? u(!0) : u(!1);
    };

    window.addEventListener("scroll", e);
    var t = null;
    return setTimeout(function () {
      t = gentlySlideUpNavbar();
    }, 500), function () {
      null == t || t.clear(), window.removeEventListener("scroll", e);
    };
  }, []), jsxs(Root$6, _assign$({
    ref: _,
    position: a.slug.includes("kitchen") ? "static" : "fixed",
    sx: {
      background: c ? s.palette.common.white : "none",
      boxShadow: c ? "0 0 3px 0 rgb(0 0 0 / 22%)" : "none"
    },
    isBackgroundSolid: c
  }, {
    children: [jsxs(Grid$2, _assign$({
      container: !0,
      justifyContent: "space-between",
      paddingLeft: 2,
      alignItems: "center"
    }, {
      children: [jsx$1(Link, _assign$({
        link: r.logo
      }, {
        children: jsx$1(CmsImage, {
          media: getLogo(T),
          width: 100,
          height: 32,
          component: "img"
        })
      })), jsx$1(IconButton$2, _assign$({
        onClick: function onClick() {
          g(!0);
        }
      }, {
        children: jsx$1(AnimatedMenuIcon, {
          open: p,
          variant: 3,
          color: getNavbarButtonColor(T)
        })
      }))]
    })), jsx$1(Drawer, _assign$({
      anchor: "top",
      open: p,
      onClose: function onClose() {
        g(!1);
      },
      elevation: 0,
      transitionDuration: 500,
      sx: (t = {}, t["& .".concat(backdropClasses.root)] = {
        backgroundColor: "rgba(0, 0, 0, 0)"
      }, t["& .".concat(paperClasses.root)] = {
        height: "calc(100vh - 60px)",
        top: 60
      }, t)
    }, {
      children: jsxs(List, _assign$({
        sx: {
          display: "flex",
          flexDirection: "column",
          height: "100%",
          justifyContent: "space-between"
        }
      }, {
        children: [jsxs(Stack$2, {
          children: [n.map(function (e, t) {
            var r;
            return (null === (r = null == e ? void 0 : e.columns) || void 0 === r ? void 0 : r.length) >= 1 ? S(e, t) : function (e, t) {
              return jsxs(React__default.Fragment, {
                children: [jsx$1(Link, _assign$({
                  href: e.url,
                  color: s.palette.common.black
                }, {
                  children: jsx$1(ListItem, _assign$({
                    disablePadding: !0
                  }, {
                    children: jsx$1(ListItemButton, _assign$({
                      sx: {
                        paddingY: s.spacing(2)
                      }
                    }, {
                      children: jsx$1(LinkRootTitle, {
                        children: e.title
                      })
                    }))
                  }))
                })), jsx$1(Divider, {
                  variant: "middle"
                })]
              }, e.id);
            }(e);
          }), r.buttons.filter(function (e) {
            return "link" === e.variant;
          }).map(function (e, t) {
            return jsxs(React__default.Fragment, {
              children: [jsx$1(ListItem, _assign$({
                disablePadding: !0
              }, {
                children: jsx$1(ListItemButton, _assign$({
                  sx: {
                    paddingY: s.spacing(2)
                  }
                }, {
                  children: jsx$1(Link, _assign$({
                    link: e,
                    sx: {
                      color: s.palette.text.primary
                    },
                    onClick: function onClick() {
                      return E(e.text);
                    }
                  }, {
                    children: jsx$1(LinkRootTitle, {
                      children: e.text
                    })
                  }), e.id)
                }))
              })), t >= 1 && jsx$1(Divider, {
                variant: "middle"
              })]
            }, e.id);
          })]
        }), jsx$1(Stack$2, _assign$({
          sx: {
            boxShadow: "0px -2px 6px rgba(0, 0, 0, 0.05)"
          }
        }, {
          children: r.buttons.filter(function (e) {
            return "solid" === e.variant || "outlined" === e.variant;
          }).map(function (e) {
            var t;
            return jsx$1(React__default.Fragment, {
              children: jsx$1(Link, _assign$({
                link: e,
                sx: {
                  color: s.palette.text.primary,
                  margin: s.spacing(1.25, 3)
                },
                onClick: function onClick() {
                  return E(e.text);
                }
              }, {
                children: jsx$1(Button, _assign$({
                  variant: i(e.variant),
                  color: "primary",
                  size: "large",
                  fullWidth: !0,
                  sx: (t = {
                    fontSize: s.typography.pxToRem(14)
                  }, t["& .".concat(svgIconClasses.root)] = {
                    fontSize: s.typography.body1.fontSize
                  }, t)
                }, {
                  children: e.text
                }))
              }), e.id)
            }, e.id);
          })
        }))]
      }))
    }))]
  }));
},
    gentlySlideUpNavbar = function gentlySlideUpNavbar() {
  var e = document.querySelector(".".concat(appLinkNotificationBannerClasess.root));
  if (null == e) return null;
  var t = gsap.timeline({
    scrollTrigger: {
      trigger: "body",
      start: "top top",
      end: "".concat(e.clientHeight, "px"),
      scrub: !0
    }
  });
  return t.to(document.querySelector(".".concat(appBarClasses.root)), {
    y: -e.clientHeight
  }), t;
},
    Root$6 = styled$2(AppBar)(function (e) {
  var t = e.theme;
  return e.isBackgroundSolid, {
    padding: t.spacing(2, 1),
    top: "auto"
  };
}),
    ColumnRoot = styled$2(Link)(function (e) {
  var t = e.theme;
  return {
    display: "flex",
    textDecoration: "none",
    color: colors.grey[900],
    "&:hover": {
      h6: {
        color: t.palette.info.main
      },
      background: "#f7f9fb",
      borderRadius: "6px"
    }
  };
}),
    LinkContent$1 = styled$2("div")(function (e) {
  return e.theme, {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-evenly"
  };
}),
    LinkColumnTitle = styled$2(Text)(function (e) {
  var t = e.theme;
  return _assign$(_assign$({}, t.typography.subtitle3), {
    fontWeight: 550,
    fontSize: t.typography.pxToRem(14),
    "&:focus": {
      color: t.palette.info.main
    },
    "&:hover": {
      color: t.palette.info.main
    }
  });
}),
    LinkRootTitle = styled$2(Text)(function (e) {
  var t = e.theme;
  return _assign$(_assign$({}, t.typography.subtitle2), {
    fontWeight: t.typography.fontWeightSemiBold,
    "&:focus": {
      color: t.palette.info.main
    },
    "&:hover": {
      color: t.palette.info.main
    }
  });
}),
    LinkSubTitle$1 = styled$2(Text)(function (e) {
  var t = e.theme;
  return _assign$(_assign$({}, t.typography.caption), {
    fontWeight: t.typography.fontWeightMedium,
    color: t.palette.text.secondary
  });
}),
    LinkTitle$1 = styled$2(Text)(function (e) {
  var t = e.theme;
  return _assign$(_assign$({}, t.typography.heading), {
    textDecoration: "none",
    fontSize: t.typography.pxToRem(12)
  });
}),
    Layout = function Layout(e) {
  var t = e.children,
      r = e.global,
      n = e.pageContext,
      a = useTheme$4(),
      o = useMediaQuery(a.breakpoints.up("md")),
      i = r.navbar,
      s = r.navbarLinks,
      l = r.footer;
  null !== n.primaryColor && "" !== n.primaryColor && (themeObject.palette.primary.main = n.primaryColor);
  var c = createTheme$2(themeObject);
  return jsxs(ThemeProvider, _assign$({
    theme: c
  }, {
    children: [jsxs(Fragment, {
      children: [jsx$1(o ? Navbar : MobileNavMenu, {
        data: i,
        navbarLinks: s,
        pageContext: n
      }), t]
    }), jsx$1(Footer, {
      data: l
    })]
  }));
},
    MediaCarousel = function MediaCarousel(e) {
  var t = e.data,
      r = t.title,
      n = t.description;
  return jsx$1(Root$5, _assign$({
    sx: t.styles,
    className: mediaCarouselClasses.root
  }, {
    children: jsxs(Container, {
      children: [jsx$1(Box, _assign$({
        className: mediaCarouselClasses.title
      }, {
        children: jsx$1(Text, _assign$({
          rich: !0
        }, {
          children: r
        }))
      })), jsx$1(Box, _assign$({
        className: mediaCarouselClasses.description
      }, {
        children: jsx$1(Text, _assign$({
          rich: !0
        }, {
          children: n
        }))
      })), jsx$1(Slider, _assign$({}, t.sliderSettings, {
        children: t.carouselItems.map(function (e, r) {
          return jsxs(React__default.Fragment, {
            children: [jsx$1(MediaContainer, _assign$({
              className: mediaCarouselClasses.media
            }, {
              children: jsx$1(Media, {
                media: e.media,
                embeddedMedia: e.embeddedMedia,
                mediaStyle: e.styles,
                autoplay: t.autoplay
              })
            })), null != e.caption && jsx$1(Box, {
              children: jsx$1(Text, _assign$({
                rich: !0,
                variant: "body1"
              }, {
                children: e.caption
              }))
            })]
          }, r);
        })
      }))]
    })
  }));
},
    Root$5 = styled$2(Box)(function (e) {
  var t,
      r,
      n = e.theme;
  return (t = {
    marginBottom: n.spacing(10),
    marginTop: n.spacing(10),
    textAlign: "center",
    background: "#fff",
    justifyContent: "center",
    alignItems: "center"
  })[".".concat(mediaCarouselClasses.title)] = {
    "& h2": _assign$(_assign$({}, n.typography.h4), (r = {}, r[n.breakpoints.up("md")] = _assign$({}, n.typography.h3), r)),
    paddingBottom: "10px"
  }, t[".".concat(mediaCarouselClasses.description)] = {
    padingBottom: "30px"
  }, t["& .slick-prev:before"] = {
    color: "#0357ff"
  }, t["& .slick-next:before"] = {
    color: "#0357ff"
  }, t["& .slick-dots li.slick-active button:before"] = {
    color: "#0357ff"
  }, t["& .slick-dots li button:before"] = {
    color: "#0357ff",
    fontSize: n.spacing(2.5)
  }, t["& .slick-dots"] = {
    bottom: "-50px"
  }, t;
}),
    MediaContainer = styled$2(Box)(function () {
  return {
    margin: "25px"
  };
}),
    sliderSettingsProps = {
  arrows: !1,
  dots: !0,
  infinite: !1,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  initialSlide: 0,
  responsive: [{
    breakpoint: 1023,
    settings: {
      slidesToShow: 3,
      slidesToScroll: 3,
      infinite: !1,
      dots: !1
    }
  }, {
    breakpoint: 899,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 2,
      initialSlide: 2,
      dots: !1,
      arrows: !0
    }
  }, {
    breakpoint: 599,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: !0,
      arrows: !1
    }
  }]
},
    NavbarFeatureCta = function NavbarFeatureCta(e) {
  var t = e.data,
      r = t.id,
      n = t.title,
      a = t.subtitle,
      o = t.buttonText,
      i = t.media,
      s = t.url,
      l = router.useRouter();
  return jsxs(Root$4, {
    children: [jsx$1(ImageBox, {
      children: jsx$1(CmsImage, {
        media: i
      })
    }), jsxs(TextWrapper, {
      children: [jsx$1(TitleText, {
        children: n
      }), jsx$1(SubtitleText, {
        children: a
      })]
    }), jsx$1(CtaButton$1, _assign$({
      onClick: function onClick() {
        return __awaiter(void 0, void 0, void 0, function () {
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, l.push(s)];

              case 1:
                return [2, e.sent()];
            }
          });
        });
      }
    }, {
      children: o
    }))]
  }, r);
},
    Root$4 = styled$2(Box)(function (e) {
  var t = e.theme;
  return {
    padding: t.spacing(.1),
    lineHeight: t.spacing(6),
    background: "#fbfcff",
    textAlign: "center",
    height: "100%"
  };
}),
    ImageBox = styled$2(Box)(function (e) {
  var t = e.theme;
  return {
    width: 470,
    marginTop: t.spacing(-1),
    marginRight: t.spacing(1)
  };
}),
    TitleText = styled$2(Text)(function (e) {
  var t = e.theme;
  return _assign$(_assign$({}, t.typography.h6), {
    maxWidth: "50%",
    lineHeight: t.spacing(3.5),
    fontWeight: t.typography.fontWeightBold
  });
}),
    SubtitleText = styled$2(Text)(function (e) {
  var t = e.theme;
  return _assign$(_assign$({}, t.typography.heading), {
    maxWidth: "90%",
    marginTop: t.spacing(1.5),
    lineHeight: t.spacing(3),
    fontWeight: t.typography.fontWeightMedium,
    color: t.palette.text.secondary
  });
}),
    CtaButton$1 = styled$2(Button)(function (e) {
  var t = e.theme;
  return {
    "& .MuiButton-root": {
      borderWidth: 0
    },
    fontSize: t.typography.button.fontSize,
    fontWeight: t.typography.fontWeightBold,
    marginTop: t.spacing(3),
    padding: t.spacing(5, 3),
    backgroundColor: t.palette.background.default,
    letterSpacing: 0,
    color: "#0058ff",
    border: "1px solid #dbe3eb",
    "&:hover": {
      backgroundColor: t.palette.primary.main,
      color: t.palette.background.default
    }
  };
}),
    TextWrapper = styled$2("div")(function (e) {
  return {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    marginTop: e.theme.spacing(-17)
  };
}),
    NavigationChildItems = function NavigationChildItems(e) {
  var t = e.item,
      r = e.isStandalone;
  return jsxs(Root$3, _assign$({
    link: t,
    linkstyleprops: {
      subtitle: t.subtitle
    },
    isStandalone: r
  }, {
    children: [null !== t.icon && jsx$1(CmsImage, {
      media: t.icon,
      width: 24,
      height: 24
    }), jsxs(LinkContent, _assign$({
      isIconPresent: null !== t.icon
    }, {
      children: [jsx$1(LinkTitle, _assign$({
        isStandalone: r,
        component: "h6"
      }, {
        children: t.title
      })), jsx$1(LinkSubTitle, {
        children: t.subtitle
      })]
    }))]
  }), t.id);
},
    getStyles = function getStyles(e) {
  if (null !== e) return {
    background: "#f7f9fb",
    borderRadius: "6px",
    padding: "12px, 10px"
  };
},
    Root$3 = styled$2(Link)(function (e) {
  var t = e.theme,
      r = e.linkstyleprops;
  return {
    display: "flex",
    textDecoration: "none",
    padding: !0 === e.isStandalone ? t.spacing(1.4, 2) : t.spacing(1.7, 1.5),
    "&:hover": _assign$({
      h6: {
        color: t.palette.primary.main
      }
    }, getStyles(null == r ? void 0 : r.subtitle))
  };
}),
    LinkContent = styled$2("div")(function (e) {
  var t = e.theme;
  return {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-evenly",
    padding: e.isIconPresent ? t.spacing(.25, 2) : t.spacing(0)
  };
}),
    LinkTitle = styled$2(Text)(function (e) {
  var t = e.theme,
      r = e.isStandalone;
  return _assign$(_assign$({}, t.typography[r ? "body1" : "subtitle3"]), {
    fontWeight: r ? t.typography.fontWeightSemiBold : t.typography.fontWeightBold,
    fontSize: r ? t.typography.body1.fontSize : t.typography.pxToRem(15),
    color: r ? t.palette.text.primary : colors.grey[800],
    "&:hover": {
      color: t.palette.primary.main
    }
  });
}),
    LinkSubTitle = styled$2(Text)(function (e) {
  var t = e.theme;
  return _assign$(_assign$({}, t.typography.caption), {
    fontWeight: t.typography.fontWeightMedium,
    color: t.palette.text.secondary
  });
}),
    PageScript = function PageScript(e) {
  var t = e.data,
      r = e.timeout,
      n = void 0 === r ? 1e3 : r,
      a = t.script.replace(/(\r\n|\n|\r)/gm, "").split("<script").filter(function (e) {
    return "" !== e;
  }).map(function (e) {
    return e.includes("<\/script>") ? "<script".concat(e) : e;
  }).map(function (e) {
    return getScript(e, n);
  }).join("");
  return jsx$1(InnerHtml, {
    html: a,
    width: "100%"
  });
},
    getScript = function getScript(e, t) {
  if (!e.includes("<script")) return e;

  if (e.includes("<script ")) {
    var r = e.split("<script "),
        n = (s = r[0], (l = r[1]).split(">")),
        a = n[0],
        o = n[1];
    e = "".concat(s, "<script ").concat(a, ">setTimeout(()=> {").concat(o.split("</script")[0], "}, ").concat(t, ")<\/script>");
  } else {
    var i = e.split("<script>"),
        s = i[0],
        l = i[1];
    e = "".concat(s, "<script>setTimeout(()=> {").concat(l.split("<\/script>")[0], "}, ").concat(t, ")<\/script>");
  }

  return e;
},
    ExpandMore = {},
    _interopRequireDefault = interopRequireDefault$1.exports;

Object.defineProperty(ExpandMore, "__esModule", {
  value: !0
});

var default_1 = ExpandMore.default = void 0,
    _createSvgIcon = _interopRequireDefault(createSvgIcon),
    _jsxRuntime = require$$2,
    _default = (0, _createSvgIcon.default)((0, _jsxRuntime.jsx)("path", {
  d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), "ExpandMore");

default_1 = ExpandMore.default = _default;

var PricingPlan = function PricingPlan(e) {
  var t,
      r,
      n,
      a = e.sku,
      o = a.title,
      i = a.subtitle,
      s = a.description,
      l = a.includedLocations,
      c = a.includedUsers,
      u = a.maxLocationCount,
      d = a.maxUserCount,
      p = a.popularPlan,
      g = a.disable,
      m = a.showCheckBoxes,
      f = a.includedTools,
      h = a.popularPlanText,
      b = a.customizePlanText,
      y = a.billingCycle,
      v = a.price,
      _ = a.hidePrice,
      T = a.currency,
      E = a.pricingCycle,
      S = a.addOnPrice,
      x = a.memberPrice,
      w = a.locationPrice,
      C = a.contactSalesButton,
      k = a.freeTrialButton,
      $ = a.isComingSoon,
      R = a.waitListButton,
      A = a.hasSecondaryButton,
      I = a.secondaryButton,
      N = a.optionalProductsTitle,
      P = a.includedProductsTitle,
      O = a.footerContent,
      D = a.optionalProducts,
      L = a.includedProducts,
      M = a.maxTools,
      F = useTheme$4(),
      j = useButton().getVariant,
      B = React__default.useState(!1),
      U = B[0],
      G = B[1],
      q = React__default.useState(!1),
      H = q[0],
      z = q[1],
      W = "#898989",
      V = {
    includedLocations: l,
    includedUsers: c,
    maxLocationCount: u,
    maxUserCount: d,
    popularPlan: p,
    includedTools: f,
    billingCycle: y,
    price: v,
    currency: T,
    pricingCycle: E,
    addOnPrice: S,
    memberPrice: x,
    locationPrice: w
  },
      Y = function Y(t) {
    return jsx$1(SkuButton, _assign$({
      color: "primary",
      disabled: g,
      variant: j(t.variant),
      fullWidth: !0,
      onClick: function onClick(r) {
        var n;
        null != e.onClickButton && e.onClickButton(r, {
          redirectUrl: t.url,
          newTab: null !== (n = t.newTab) && void 0 !== n && n,
          sku: e.sku
        });
      }
    }, {
      children: t.text
    }));
  };

  return jsxs(Root$2, _assign$({
    className: "".concat(pricingPlanClasses.root, " ").concat(p ? pricingPlanClasses.popular : ""),
    sx: _assign$({
      border: p ? "2px solid #0258ff" : ""
    }, e.styles)
  }, {
    children: [p && jsx$1(PopularPlan, _assign$({
      className: pricingPlanClasses.popularPlanTag,
      sx: {
        backgroundColor: g ? W : ""
      }
    }, {
      children: jsx$1(Text, _assign$({
        variant: "subtitle3",
        sx: {
          fontWeight: F.typography.fontWeightBold,
          fontFamily: BODY_FONT_FAMILY,
          fontSize: "11.2894px"
        }
      }, {
        children: h
      }))
    })), jsx$1(PlanTitle, _assign$({
      rich: !0,
      className: pricingPlanClasses.title,
      sx: {
        color: g ? W : ""
      }
    }, {
      children: o
    })), jsx$1(Divider, {
      sx: {
        border: "1px solid ".concat(p && !g ? F.palette.primary.main : "#DDDDDD")
      },
      color: p && !g ? F.palette.primary.main : ""
    }), jsxs(Stack$2, _assign$({
      p: 3,
      gap: 3,
      className: pricingPlanClasses.body
    }, {
      children: [jsx$1(Text, _assign$({
        rich: !0,
        variant: "subtitle3",
        sx: {
          fontWeight: F.typography.fontWeightRegular,
          fontFamily: BODY_FONT_FAMILY
        },
        className: pricingPlanClasses.subtitle
      }, {
        children: i
      })), jsx$1(Box, _assign$({
        className: classNames(pricingPlanClasses.price, (t = {}, t[pricingPlanClasses.noPrice] = _, t)),
        display: "flex",
        alignItems: _ ? "center" : "flex-end"
      }, {
        children: function () {
          if (_) return jsx$1(Text, _assign$({
            color: "primary",
            variant: "h5",
            sx: {
              color: g ? W : ""
            }
          }, {
            children: b
          }));
          var e = v.toFixed(2).split("."),
              t = e[0],
              r = e[1];
          return jsxs(Fragment, {
            children: [jsxs(Text, _assign$({
              sx: {
                fontWeight: F.typography.fontWeightSemiBold,
                fontFamily: TITLE_FONT_FAMILY,
                fontSize: "72px",
                color: g ? W : "#0357FF",
                display: "flex",
                lineHeight: "60px"
              }
            }, {
              children: [jsx$1(Text, _assign$({
                variant: "h5",
                fontWeight: F.typography.fontWeightSemiBold,
                sx: {
                  color: "inherit",
                  lineHeight: "inherit"
                }
              }, {
                children: T
              })), jsx$1(Text, _assign$({
                sx: {
                  fontWeight: 500,
                  fontSize: "72px"
                }
              }, {
                children: t
              })), jsx$1(Text, _assign$({
                component: "span",
                variant: "h5",
                sx: {
                  position: "relative",
                  fontWeight: 400
                }
              }, {
                children: r
              }))]
            })), jsxs(Text, _assign$({
              variant: "h6",
              sx: {
                fontWeight: F.typography.fontWeightRegular,
                fontFamily: BODY_FONT_FAMILY,
                lineHeight: 3.5
              }
            }, {
              children: ["/", "annually" === E ? "yr" : E.substring(0, 2)]
            }))]
          });
        }()
      })), jsx$1(Description, _assign$({
        rich: !0,
        template: V,
        className: pricingPlanClasses.description
      }, {
        children: s
      })), jsx$1(Stack$2, _assign$({
        gap: 1,
        className: pricingPlanClasses.buttons
      }, {
        children: (r = jsx$1(Fragment, {}), n = jsx$1(Fragment, {}), A && null != I && (n = Y(I)), r = $ ? Y(R) : e.locations > u || e.users > d ? Y(C) : Y(k), jsxs(Fragment, {
          children: [r, n]
        }))
      })), jsxs(Stack$2, _assign$({
        gap: 1
      }, {
        children: [jsx$1(Text, _assign$({
          rich: !0,
          className: pricingPlanClasses.includedProductsTitle
        }, {
          children: P
        })), jsx$1(Box, _assign$({
          className: pricingPlanClasses.optionalProducts
        }, {
          children: null == L || 0 === (null == L ? void 0 : L.length) ? jsx$1(Fragment, {}) : jsx$1(Fragment, {
            children: L.map(function (e, t) {
              return jsxs(Accordion, _assign$({
                expanded: U === t,
                onChange: (r = t, function (e, t) {
                  G(!!t && r);
                }),
                className: pricingPlanClasses.product
              }, {
                children: [jsx$1(AccordionSummary$2, _assign$({
                  expandIcon: jsx$1(default_1, {})
                }, {
                  children: jsxs(Stack$2, _assign$({
                    direction: "row",
                    columnGap: 1
                  }, {
                    children: [null !== e.icon && jsx$1(CmsImage, {
                      media: e.icon
                    }), jsx$1(Text, _assign$({
                      sx: {
                        fontSize: F.typography.subtitle2.fontSize,
                        fontWeight: F.typography.fontWeightBold,
                        fontFamily: TITLE_FONT_FAMILY,
                        color: "#0357FF",
                        paddingBottom: "1px"
                      }
                    }, {
                      children: e.name
                    }))]
                  }))
                })), jsx$1(AccordionDetails$2, _assign$({
                  sx: {
                    marginLeft: F.spacing(2)
                  }
                }, {
                  children: jsx$1(Text, _assign$({
                    rich: !0,
                    variant: "subtitle2",
                    sx: {
                      fontWeight: F.typography.fontWeightRegular,
                      fontFamily: BODY_FONT_FAMILY
                    }
                  }, {
                    children: e.description
                  }))
                }))]
              }), e.id);
              var r;
            })
          })
        }))]
      })), jsxs(Stack$2, _assign$({
        gap: 1
      }, {
        children: [jsx$1(Text, _assign$({
          rich: !0,
          className: pricingPlanClasses.optionalProductsTitle
        }, {
          children: N
        })), jsx$1(Box, _assign$({
          className: pricingPlanClasses.optionalProducts
        }, {
          children: null == D || 0 === (null == D ? void 0 : D.length) ? jsx$1(Fragment, {}) : jsx$1(Fragment, {
            children: D.map(function (t, r) {
              return jsxs(Accordion, _assign$({
                expanded: H === r,
                onChange: (n = r, function (e, t) {
                  z(!!t && n);
                }),
                className: pricingPlanClasses.product
              }, {
                children: [jsxs(AccordionSummary$2, _assign$({
                  expandIcon: jsx$1(default_1, {
                    sx: {
                      color: t.selected || !m ? "#0357FF" : "".concat(W, " !important")
                    }
                  })
                }, {
                  children: [jsxs(Stack$2, _assign$({
                    direction: "row",
                    columnGap: 1
                  }, {
                    children: [null !== t.icon && jsx$1(CmsImage, {
                      media: t.icon,
                      styles: {
                        filter: t.selected || !m ? "" : "brightness(0) saturate(100%) invert(58%) sepia(12%) saturate(457%) hue-rotate(173deg) brightness(94%) contrast(93%)"
                      }
                    }), jsx$1(Text, _assign$({
                      sx: {
                        fontSize: F.typography.subtitle2.fontSize,
                        fontWeight: F.typography.fontWeightBold,
                        fontFamily: TITLE_FONT_FAMILY,
                        color: t.selected || !m ? "#0357FF" : W,
                        paddingBottom: t.selected || !m ? "1px" : ""
                      }
                    }, {
                      children: t.name
                    }))]
                  })), jsx$1(Checkbox, {
                    disabled: t.disabled,
                    disableRipple: !0,
                    size: "medium",
                    color: "primary",
                    icon: jsx$1(BpIcon, {}),
                    checked: t.selected,
                    checkedIcon: jsx$1(BpCheckedIcon, {}),
                    onChange: function onChange(r) {
                      return n = r, a = t.id, o = r.target.checked, void (null != e.onChangeProductCheckbox && e.onChangeProductCheckbox(n, {
                        sku: e.sku,
                        productId: a,
                        selected: o,
                        maxTools: M
                      }));
                      var n, a, o;
                    },
                    sx: {
                      display: "flex",
                      justifyContent: "flex-end",
                      py: 0
                    }
                  })]
                })), jsx$1(AccordionDetails$2, _assign$({
                  sx: {
                    marginLeft: F.spacing(2)
                  }
                }, {
                  children: jsx$1(Text, _assign$({
                    rich: !0,
                    variant: "subtitle2",
                    sx: {
                      fontWeight: F.typography.fontWeightRegular,
                      fontFamily: BODY_FONT_FAMILY
                    }
                  }, {
                    children: t.description
                  }))
                }))]
              }), t.id);
              var n;
            })
          })
        }))]
      })), jsx$1(FooterContent, _assign$({
        className: pricingPlanClasses.footerContent,
        rich: !0,
        template: V
      }, {
        children: O
      }))]
    }))]
  }));
},
    Root$2 = styled$2(Box)(function (e) {
  return {
    position: "relative",
    width: "288px",
    borderRadius: e.theme.spacing(1),
    border: "2px solid #DDDDDD"
  };
}),
    PlanTitle = styled$2(Text)(function (e) {
  var t = e.theme;
  return _assign$(_assign$({}, t.typography.h5), {
    padding: t.spacing(2, 3)
  });
}),
    SkuButton = styled$2(Button)(function (e) {
  return e.theme, {
    fontSize: 14,
    height: 58
  };
}),
    Accordion = styled$2(function (e) {
  return jsx$1(Accordion$3, _assign$({
    disableGutters: !0,
    elevation: 0,
    square: !0
  }, e));
})(function (e) {
  var t,
      r = e.theme;
  return (t = {
    border: 0,
    padding: 0,
    "& .MuiSvgIcon-root": {
      color: r.palette.primary.main
    },
    "& .MuiPaper-root": {
      padding: 0
    }
  })["& .".concat(accordionSummaryClasses$1.content)] = {
    display: "flex",
    alignItems: "center",
    height: "auto",
    gap: r.spacing(1),
    justifyContent: "space-between"
  }, t;
}),
    FooterContent = styled$2(Text)(function (e) {
  var t = e.theme;
  return _assign$({}, t.typography.subtitle1);
}),
    PopularPlan = styled$2(Box)(function (e) {
  var t = e.theme;
  return {
    position: "absolute",
    minWidth: 136,
    paddingLeft: t.spacing(2),
    paddingRight: t.spacing(2),
    backgroundColor: t.palette.primary.main,
    color: "#fff",
    display: "flex",
    justifyContent: "center",
    height: "25px",
    alignItems: "center",
    top: "-12px",
    left: "76px",
    borderRadius: t.spacing(.5)
  };
}),
    BpIcon = styled$2("span")(function (e) {
  var t = e.theme;
  return {
    borderRadius: 4,
    width: 20,
    height: 20,
    boxShadow: "dark" === t.palette.mode ? "0 0 0 1px rgb(16 22 26 / 40%)" : "inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)",
    backgroundImage: "dark" === t.palette.mode ? "linear-gradient(180deg,hsla(0,0%,100%,.05),hsla(0,0%,100%,0))" : "linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))",
    ".Mui-focusVisible &": {
      outline: "2px auto rgba(19,124,189,.6)",
      outlineOffset: 2
    },
    "input:hover ~ &": {
      backgroundColor: "dark" === t.palette.mode ? "#30404d" : "#ebf1f5"
    },
    "input:disabled ~ &": {
      boxShadow: "none",
      background: "dark" === t.palette.mode ? "rgba(57,75,89,.5)" : "rgba(206,217,224,.5)"
    }
  };
}),
    BpCheckedIcon = styled$2(BpIcon)({
  backgroundColor: "#0258ff",
  backgroundImage: "linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))",
  "&:before": {
    display: "block",
    width: 20,
    height: 20,
    backgroundImage: "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
    content: '""'
  },
  "input:hover ~ &": {
    backgroundColor: "#0258ff"
  }
}),
    Description = styled$2(Text)(function (e) {
  return {
    fontWeight: e.theme.typography.fontWeightSemiBold,
    fontFamily: BODY_FONT_FAMILY
  };
}),
    _a,
    PricingTable = function PricingTable(e) {
  var t,
      r = e.data,
      n = e.priceParams,
      a = e.defaultSubscription,
      o = e.onChangeSubscription,
      i = e.onChangePricingSkuProductCheckbox,
      s = e.onChangeSliderCommitted,
      l = e.onClickPricingPlanButton,
      c = e.updatePriceMethod,
      u = __rest$1(e, ["data", "priceParams", "defaultSubscription", "onChangeSubscription", "onChangePricingSkuProductCheckbox", "onChangeSliderCommitted", "onClickPricingPlanButton", "updatePriceMethod"]),
      d = useMediaQuery(theme.breakpoints.down("md")),
      p = useReducer(reducer, initialState, function () {
    return _assign$(_assign$({}, initialState), {
      data: r,
      priceParams: n,
      defaultSubscription: a,
      updatePriceMethod: null != c ? c : getUpdatedPrice
    });
  }),
      g = p[0],
      m = p[1],
      f = function f(e, t) {
    e.preventDefault();
    var r = g.data.find(function (e) {
      return e.name === t;
    });
    null != o && null != r && o(e, {
      subscription: r
    }), null != t && m({
      type: "setSelectedSubscription",
      payload: t
    });
  },
      h = function h(e, t) {
    if (null != l && null != t) {
      var r = g.data.map(function (e) {
        return e.selected ? _assign$(_assign$({}, e), {
          skus: e.skus.map(function (e) {
            return _assign$(_assign$({}, e), {
              selected: String(t.sku.id) === String(e.id)
            });
          })
        }) : e;
      }),
          n = _assign$(_assign$({}, t), {
        data: r,
        priceParams: g.priceParams
      });

      l(e, n);
    }
  },
      b = function b(e, t) {
    var r = t.sku,
        n = t.productId,
        a = t.selected,
        o = t.maxTools;
    null != i && i(e, {
      sku: r,
      productId: n
    }), m({
      type: "setSelectedProduct",
      payload: {
        skuId: null == r ? void 0 : r.id,
        productId: n,
        selected: a,
        maxTools: o
      }
    });
  };

  return useEffect(function () {
    m({
      type: "setSubscriptions",
      payload: {
        data: r,
        defaultSubscription: a,
        priceParams: n
      }
    });
  }, [r, a, n]), useEffect(function () {
    null != n && n.length > 0 && m({
      type: "setPriceParams",
      payload: n.map(function (e) {
        var t;
        return _assign$(_assign$({}, e), {
          value: null !== (t = e.value) && void 0 !== t ? t : 1
        });
      })
    });
  }, [n, m]), jsxs(Stack$2, _assign$({
    gap: 2
  }, u, {
    className: "".concat(null !== (t = u.className) && void 0 !== t ? t : "", " ").concat(pricingTableClasses.root)
  }, {
    children: [jsx$1(Grid$2, _assign$({
      container: !0,
      justifyContent: "center"
    }, {
      children: function () {
        var e, t, n;
        return jsx$1(ToggleButtonGroup, _assign$({
          variant: "pill",
          value: null !== (n = null === (t = g.data.find(function (e) {
            return e.selected;
          })) || void 0 === t ? void 0 : t.name) && void 0 !== n ? n : a,
          exclusive: !0,
          onChange: f,
          sx: (e = {
            height: 49
          }, e[".".concat(toggleButtonClasses.root)] = {
            fontWeight: theme.typography.fontWeightMedium,
            textTransform: "none"
          }, e)
        }, {
          children: r.map(function (e, t) {
            return jsx$1(ToggleButton, _assign$({
              value: e.name,
              "aria-label": "left aligned"
            }, {
              children: jsxs(Stack$2, _assign$({
                direction: "row",
                gap: 1
              }, {
                children: [jsx$1(Text, _assign$({
                  rich: !0,
                  sx: {
                    fontWeight: theme.typography.fontWeightSemiBold
                  }
                }, {
                  children: e.title
                })), null != e.discount && jsx$1(Chip, {
                  sx: {
                    color: theme.palette.primary.main,
                    fontWeight: theme.typography.fontWeightBold,
                    paddingTop: "2px"
                  },
                  size: "small",
                  label: "SAVE ".concat(e.discount, "% ")
                })]
              }))
            }), t);
          })
        }));
      }()
    })), jsx$1(Grid$2, _assign$({
      container: !0,
      gap: 3,
      direction: "row",
      justifyContent: "center"
    }, {
      children: function () {
        var e;
        return jsx$1(Fragment, {
          children: (null === (e = g.priceParams) || void 0 === e ? void 0 : e.length) > 0 && g.priceParams.map(function (e, t) {
            return jsxs(Box, _assign$({
              width: 250
            }, {
              children: [jsxs(Stack$2, _assign$({
                direction: "row",
                justifyContent: "space-between"
              }, {
                children: [jsxs(Box, _assign$({
                  display: "flex"
                }, {
                  children: [jsx$1(Text, {
                    children: e.name
                  }), !d && null != e.description && jsx$1(CustomTooltip, _assign$({
                    title: e.description,
                    arrow: !0,
                    placement: "right"
                  }, {
                    children: jsx$1(Box, {
                      children: jsx$1(InfoIcon, {
                        sx: {
                          marginLeft: theme.spacing(1),
                          paddingTop: theme.spacing(.5)
                        }
                      })
                    })
                  }))]
                })), jsx$1(Text, _assign$({
                  sx: {
                    fontWeight: theme.typography.fontWeightBold
                  }
                }, {
                  children: e.value
                }))]
              })), jsx$1(SelectionSlider, {
                "aria-label": e.name,
                min: e.min,
                max: e.max,
                step: e.step,
                value: e.value,
                onChange: function onChange(t) {
                  return function (e, t) {
                    var r = Number(e.target.value);
                    m({
                      type: "setPriceParamValue",
                      payload: {
                        name: t,
                        value: r
                      }
                    });
                  }(t, e.name);
                },
                onChangeCommitted: function onChangeCommitted(t) {
                  return r = t, n = e, void (null != s && s(r, {
                    priceParam: n
                  }));
                  var r, n;
                }
              })]
            }), t);
          })
        });
      }()
    })), jsx$1(Grid$2, _assign$({
      container: !0,
      columnGap: 4,
      rowGap: 4,
      justifyContent: "center"
    }, {
      children: function () {
        var e;
        return 0 === g.data.length ? jsx$1(Fragment, {}) : jsx$1(Fragment, {
          children: null === (e = g.data.find(function (e) {
            return e.selected;
          })) || void 0 === e ? void 0 : e.skus.map(function (e, t) {
            var r, n, a, o;
            return jsx$1(PricingPlan, {
              sku: e,
              onClickButton: h,
              onChangeProductCheckbox: b,
              locations: null !== (n = null === (r = g.priceParams.find(function (e) {
                return "Locations" === e.name;
              })) || void 0 === r ? void 0 : r.value) && void 0 !== n ? n : 1,
              users: null !== (o = null === (a = g.priceParams.find(function (e) {
                return "Users" === e.name;
              })) || void 0 === a ? void 0 : a.value) && void 0 !== o ? o : 1
            }, t);
          })
        });
      }()
    }))]
  }));
},
    reducer = function reducer(e, t) {
  var r = function r(t, _r34) {
    return null != _r34 && (null == _r34 ? void 0 : _r34.length) > 0 && (null == _r34 ? void 0 : _r34.some(function (e) {
      return e.name === t;
    })) ? _r34.find(function (e) {
      return e.name === t;
    }) : e.priceParams.find(function (e) {
      return e.name === t;
    });
  },
      n = function n(e) {
    return e.optionalProducts.map(function (e) {
      var t = e;
      return "selected" in e || (t.selected = !1), "disabled" in e || (t.disabled = !1), t;
    });
  },
      a = function a(r) {
    if ("setSubscriptions" !== t.type) return [];
    var a = t.payload.priceParams;
    return r.skus.map(function (t) {
      var o,
          i,
          s,
          l,
          c,
          u = {
        discount: null !== (o = r.discount) && void 0 !== o ? o : 0,
        sku: _assign$(_assign$({}, t), {
          optionalProducts: n(t)
        }),
        locations: null !== (s = null === (i = a.find(function (e) {
          return "Locations" === e.name;
        })) || void 0 === i ? void 0 : i.value) && void 0 !== s ? s : 1,
        users: null !== (c = null === (l = a.find(function (e) {
          return "Users" === e.name;
        })) || void 0 === l ? void 0 : l.value) && void 0 !== c ? c : 1
      },
          d = e.updatePriceMethod(u),
          p = d.hidePrice,
          g = d.price;
      return _assign$(_assign$({}, _assign$(_assign$({}, t), {
        optionalProducts: n(t)
      })), {
        price: g,
        hidePrice: p
      });
    });
  },
      o = function o(t) {
    var n,
        a,
        o,
        i = r("Locations", t.priceParams),
        s = r("Users", t.priceParams),
        l = {
      discount: null !== (n = t.subscription.discount) && void 0 !== n ? n : 0,
      sku: t.sku,
      locations: null !== (a = null == i ? void 0 : i.value) && void 0 !== a ? a : 1,
      users: null !== (o = null == s ? void 0 : s.value) && void 0 !== o ? o : 1
    },
        c = e.updatePriceMethod(l),
        u = c.hidePrice,
        d = c.price,
        p = t.sku.optionalProducts;

    if (null != t.sku.maxTools) {
      var g = p.filter(function (e) {
        return e.selected;
      });
      p = g.length >= t.sku.maxTools ? p.map(function (e) {
        return _assign$(_assign$({}, e), {
          disabled: !e.selected
        });
      }) : p.map(function (e) {
        return _assign$(_assign$({}, e), {
          disabled: !1
        });
      });
    }

    return _assign$(_assign$({}, t.sku), {
      optionalProducts: p,
      price: d,
      hidePrice: u
    });
  };

  switch (t.type) {
    case "setSubscriptions":
      return _assign$(_assign$({}, e), {
        data: function () {
          if ("setSubscriptions" !== t.type) return [];
          var e = t.payload,
              r = e.data,
              n = e.defaultSubscription;
          return null != n && r.some(function (e) {
            return e.name.includes(n);
          }) ? r.map(function (e) {
            return _assign$(_assign$({}, e), {
              selected: e.name === n,
              skus: a(e)
            });
          }) : r.map(function (e, t) {
            return _assign$(_assign$({}, e), {
              selected: 0 === t,
              skus: a(e)
            });
          });
        }()
      });

    case "setSelectedSubscription":
      return _assign$(_assign$({}, e), {
        data: e.data.map(function (e) {
          return _assign$(_assign$({}, e), {
            selected: e.name === t.payload,
            skus: e.skus.map(function (t) {
              return o({
                subscription: e,
                sku: t
              });
            })
          });
        })
      });

    case "setPriceParams":
      return _assign$(_assign$({}, e), {
        data: e.data.map(function (e) {
          return _assign$(_assign$({}, e), {
            skus: e.skus.map(function (t) {
              return o({
                subscription: e,
                sku: t
              });
            })
          });
        }),
        priceParams: t.payload
      });

    case "setPriceParamValue":
      return _assign$(_assign$({}, e), {
        data: e.data.map(function (r) {
          return _assign$(_assign$({}, r), {
            skus: r.skus.map(function (n) {
              return o({
                subscription: r,
                sku: n,
                priceParams: e.priceParams.map(function (e) {
                  return t.payload.name === e.name ? _assign$(_assign$({}, e), {
                    value: t.payload.value
                  }) : e;
                })
              });
            })
          });
        }),
        priceParams: e.priceParams.map(function (e) {
          return t.payload.name === e.name ? _assign$(_assign$({}, e), {
            value: t.payload.value
          }) : e;
        })
      });

    case "setSelectedProduct":
      return _assign$(_assign$({}, e), {
        data: e.data.map(function (e) {
          return e.selected ? _assign$(_assign$({}, e), {
            skus: e.skus.map(function (r) {
              return t.payload.skuId === r.id ? _assign$(_assign$({}, r), o({
                subscription: e,
                sku: _assign$(_assign$({}, r), {
                  optionalProducts: r.optionalProducts.map(function (e) {
                    return e.id === t.payload.productId ? _assign$(_assign$({}, e), {
                      selected: t.payload.selected
                    }) : e;
                  })
                })
              })) : r;
            })
          }) : e;
        })
      });

    default:
      return e;
  }
},
    initialState = {
  data: [],
  priceParams: [],
  updatePriceMethod: function updatePriceMethod() {
    return {
      hidePrice: !1,
      price: 0
    };
  }
},
    SelectionSlider = styled$2(Slider$1)(function (e) {
  return e.theme, {
    "& .MuiSlider-thumb": {
      color: "#fff"
    }
  };
}),
    CustomTooltip = styled$2(function (e) {
  var t = e.className,
      r = __rest$1(e, ["className"]);

  return jsx$1(Tooltip, _assign$({}, r, {
    classes: {
      popper: t
    }
  }));
})((_a = {}, _a["& .".concat(tooltipClasses.tooltip)] = {
  maxWidth: 200,
  boxShadow: theme.shadows[1],
  fontSize: 11,
  fontFamily: BODY_FONT_FAMILY
}, _a));

function HiArrowLeft(e) {
  return GenIcon({
    tag: "svg",
    attr: {
      viewBox: "0 0 20 20",
      fill: "currentColor"
    },
    child: [{
      tag: "path",
      attr: {
        fillRule: "evenodd",
        d: "M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z",
        clipRule: "evenodd"
      }
    }]
  })(e);
}

function HiArrowRight(e) {
  return GenIcon({
    tag: "svg",
    attr: {
      viewBox: "0 0 20 20",
      fill: "currentColor"
    },
    child: [{
      tag: "path",
      attr: {
        fillRule: "evenodd",
        d: "M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z",
        clipRule: "evenodd"
      }
    }]
  })(e);
}

function HiOutlineEye(e) {
  return GenIcon({
    tag: "svg",
    attr: {
      fill: "none",
      viewBox: "0 0 24 24",
      stroke: "currentColor"
    },
    child: [{
      tag: "path",
      attr: {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
      }
    }, {
      tag: "path",
      attr: {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
      }
    }]
  })(e);
}

var Reviews = function Reviews(e) {
  var t = e.data,
      r = useTheme$4(),
      n = {
    dots: !0,
    infinite: !0,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    variableWidth: !0,
    initialSlide: 1,
    nextArrow: jsx$1(function (e) {
      var t = e.onClick;
      return jsx$1(ArrowWrapper$1, _assign$({
        onClick: t
      }, {
        children: jsx$1(HiArrowRight, {})
      }));
    }, {
      onClick: void 0
    }),
    prevArrow: jsx$1(function (e) {
      var t = e.onClick;
      return jsx$1(ArrowWrapper$1, _assign$({
        onClick: t
      }, {
        children: jsx$1(HiArrowLeft, {})
      }));
    }, {
      onClick: void 0
    }),
    responsive: [{
      breakpoint: 1024,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 3
      }
    }, {
      breakpoint: 900,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        arrows: !1
      }
    }, {
      breakpoint: 411,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: !1
      }
    }]
  };
  return jsx$1(Root$1, {
    children: jsx$1(ReviewSlider$1, _assign$({}, n, {
      sx: {
        display: "flex",
        alignItems: "center"
      }
    }, {
      children: t.items.map(function (e, t) {
        return jsx$1(Wrapper$2, _assign$({
          maxWidth: "md",
          sx: {
            paddingX: 1
          },
          disableGutters: !0
        }, {
          children: jsx$1(TestimonialItem, _assign$({
            variant: "outlined"
          }, {
            children: jsxs(CardContent, {
              children: [null != e.stars && jsx$1(Rating, {
                sx: {
                  pt: 3.75
                },
                name: "read-only",
                value: e.stars,
                readOnly: !0
              }), jsx$1(FeatureTitle, _assign$({
                rich: !0,
                sx: {
                  paddingTop: 6
                }
              }, {
                children: e.quote
              })), null != e.author && jsx$1(Text, _assign$({
                rich: !0,
                variant: "body1",
                color: r.palette.text.primary,
                fontWeight: r.typography.fontWeightSemiBold,
                fontSize: "30px",
                sx: {
                  paddingTop: 2,
                  textAlign: "left"
                }
              }, {
                children: e.author
              })), null != e.company && jsx$1(Text, _assign$({
                rich: !0,
                variant: "subtitle2",
                color: "#8290A1",
                sx: {
                  textAlign: "left",
                  paddingBottom: 3
                }
              }, {
                children: e.company
              })), null != e.profilePhoto && jsx$1(Avatar, _assign$({
                alt: "avatar"
              }, {
                children: jsx$1(CmsImage, {
                  media: e.profilePhoto
                })
              }))]
            })
          }), e.id)
        }), e.id);
      })
    }))
  });
},
    ReviewSlider$1 = styled$2(Slider)(function (e) {
  return {
    "& .slick-slider": {
      display: "flex"
    },
    "& .slick-track": {
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    },
    "& .slick-dots li.slick-active button:before": {
      color: "#0357FF"
    },
    "& .slick-dots li button:before": {
      color: "#DBE3EB",
      fontSize: e.theme.spacing(2.5)
    }
  };
}),
    ArrowWrapper$1 = styled$2(Box)(function (e) {
  return e.theme, {
    background: "#FFFFFF",
    borderRadius: "4px",
    padding: "80px",
    cursor: "pointer"
  };
}),
    Wrapper$2 = styled$2(Container)(function (e) {
  var t;
  return (t = {})[e.theme.breakpoints.down("md")] = {
    paddingLeft: "28px !important",
    paddingRight: "8px important"
  }, t;
}),
    Root$1 = styled$2(Container)(function (e) {
  var t,
      r = e.theme;
  return (t = {
    paddingTop: r.spacing(12),
    paddingBottom: r.spacing(12)
  })[r.breakpoints.down("md")] = {
    paddingLeft: 0,
    paddingRight: 0
  }, t[r.breakpoints.up("md")] = {
    "& .react-multi-carousel-item": {
      width: "300px !important"
    }
  }, t["& .MuiRating-root"] = {
    color: colors.blue[900]
  }, t;
}),
    TestimonialItem = styled$2(Card)(function (e) {
  var t,
      r = e.theme;
  return (t = {
    borderRadius: 10,
    borderColor: colors.blue.A700,
    minHeight: 277
  })[r.breakpoints.up("md")] = {
    width: 278
  }, t[r.breakpoints.down("md")] = {
    width: "88vw"
  }, t["& .".concat(cardContentClasses.root)] = {
    padding: r.spacing(3)
  }, t;
}),
    FeatureTitle = styled$2(Text)(function (e) {
  return {
    padding: e.theme.spacing(1.25, 0, 1, 0)
  };
});

function FaYelp(e) {
  return GenIcon({
    tag: "svg",
    attr: {
      viewBox: "0 0 384 512"
    },
    child: [{
      tag: "path",
      attr: {
        d: "M42.9 240.32l99.62 48.61c19.2 9.4 16.2 37.51-4.5 42.71L30.5 358.45a22.79 22.79 0 0 1-28.21-19.6 197.16 197.16 0 0 1 9-85.32 22.8 22.8 0 0 1 31.61-13.21zm44 239.25a199.45 199.45 0 0 0 79.42 32.11A22.78 22.78 0 0 0 192.94 490l3.9-110.82c.7-21.3-25.5-31.91-39.81-16.1l-74.21 82.4a22.82 22.82 0 0 0 4.09 34.09zm145.34-109.92l58.81 94a22.93 22.93 0 0 0 34 5.5 198.36 198.36 0 0 0 52.71-67.61A23 23 0 0 0 364.17 370l-105.42-34.26c-20.31-6.5-37.81 15.8-26.51 33.91zm148.33-132.23a197.44 197.44 0 0 0-50.41-69.31 22.85 22.85 0 0 0-34 4.4l-62 91.92c-11.9 17.7 4.7 40.61 25.2 34.71L366 268.63a23 23 0 0 0 14.61-31.21zM62.11 30.18a22.86 22.86 0 0 0-9.9 32l104.12 180.44c11.7 20.2 42.61 11.9 42.61-11.4V22.88a22.67 22.67 0 0 0-24.5-22.8 320.37 320.37 0 0 0-112.33 30.1z"
      }
    }]
  })(e);
}

function AiOutlineArrowLeft(e) {
  return GenIcon({
    tag: "svg",
    attr: {
      viewBox: "0 0 1024 1024"
    },
    child: [{
      tag: "path",
      attr: {
        d: "M872 474H286.9l350.2-304c5.6-4.9 2.2-14-5.2-14h-88.5c-3.9 0-7.6 1.4-10.5 3.9L155 487.8a31.96 31.96 0 0 0 0 48.3L535.1 866c1.5 1.3 3.3 2 5.2 2h91.5c7.4 0 10.8-9.2 5.2-14L286.9 550H872c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z"
      }
    }]
  })(e);
}

function AiOutlineArrowRight(e) {
  return GenIcon({
    tag: "svg",
    attr: {
      viewBox: "0 0 1024 1024"
    },
    child: [{
      tag: "path",
      attr: {
        d: "M869 487.8L491.2 159.9c-2.9-2.5-6.6-3.9-10.5-3.9h-88.5c-7.4 0-10.8 9.2-5.2 14l350.2 304H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h585.1L386.9 854c-5.6 4.9-2.2 14 5.2 14h91.5c1.9 0 3.8-.7 5.2-2L869 536.2a32.07 32.07 0 0 0 0-48.4z"
      }
    }]
  })(e);
}

function AiOutlineDesktop(e) {
  return GenIcon({
    tag: "svg",
    attr: {
      viewBox: "0 0 1024 1024"
    },
    child: [{
      tag: "path",
      attr: {
        d: "M928 140H96c-17.7 0-32 14.3-32 32v496c0 17.7 14.3 32 32 32h380v112H304c-8.8 0-16 7.2-16 16v48c0 4.4 3.6 8 8 8h432c4.4 0 8-3.6 8-8v-48c0-8.8-7.2-16-16-16H548V700h380c17.7 0 32-14.3 32-32V172c0-17.7-14.3-32-32-32zm-40 488H136V212h752v416z"
      }
    }]
  })(e);
}

function AiOutlineMobile(e) {
  return GenIcon({
    tag: "svg",
    attr: {
      viewBox: "0 0 1024 1024"
    },
    child: [{
      tag: "path",
      attr: {
        d: "M744 62H280c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h464c35.3 0 64-28.7 64-64V126c0-35.3-28.7-64-64-64zm-8 824H288V134h448v752zM472 784a40 40 0 1 0 80 0 40 40 0 1 0-80 0z"
      }
    }]
  })(e);
}

var SitesPageElements = {
  SectionHeader: function SectionHeader(e) {
    var t = e.title,
        r = e.description,
        n = e.edit,
        a = void 0 === n || n,
        o = e.id,
        i = e.isMobileScreen,
        s = e.isPreviewOn,
        l = useTheme$4(),
        c = useHeroSites().addEditorJsInstance,
        u = i ? "24px" : "34px",
        d = i ? "36.4px" : "47.6px";
    return jsxs(Stack$2, _assign$({
      sx: {
        textAlign: "center"
      },
      pb: 7
    }, {
      children: [jsx$1(Text, _assign$({
        variant: "subtitle2",
        color: l.palette.primary.main,
        fontWeight: l.typography.fontWeightSemiBold,
        fontFamily: l.typography.fontFamily
      }, {
        children: t
      })), a ? jsxs(CommonRoot, {
        children: [jsx$1(EditorJs, {
          showTag: s,
          editorInstance: c,
          holder: o,
          reinitializeOnPropsChange: !0,
          data: {
            blocks: [{
              type: "paragraph",
              data: {
                text: '<font face="Futura" class="sectionClass" style="line-height: ' + d + "; font-size: " + u + '">' + r + "</font>",
                alignment: "center"
              }
            }]
          },
          onChange: function onChange() {}
        }), !s && jsx$1(VisualTag, {
          image: "images/gosite-sites-text-tag.svg",
          sx: {
            position: "absolute",
            top: i ? "-30px" : "-15px",
            left: i ? "-20px" : "-50px"
          }
        })]
      }) : jsx$1(Text, _assign$({
        variant: "h4",
        fontFamily: l.typography.fontFamily,
        mt: 5
      }, {
        children: r
      }))]
    }));
  },
  SectionHero: function SectionHero(e) {
    var t = e.title,
        r = e.description,
        n = e.edit,
        a = void 0 === n || n,
        o = e.id,
        i = e.isMobileScreen,
        s = e.isPreviewOn,
        l = useTheme$4(),
        c = useHeroSites().addEditorJsInstance,
        u = i ? "38px" : "62px";
    return jsxs(Stack$2, _assign$({
      sx: {
        textAlign: "center"
      },
      spacing: i ? 1 : 3
    }, {
      children: [a ? jsxs(CommonRoot, {
        children: [jsx$1(EditorJs, {
          showTag: s,
          editorInstance: c,
          holder: o,
          reinitializeOnPropsChange: !0,
          data: {
            blocks: [{
              type: "paragraph",
              data: {
                text: '<font size="' + u + '" face="Futura" class="heroClass" style="line-height: ' + (i ? "41.8px" : "72px") + "; font-size: " + u + '">' + t + "</font>",
                alignment: "center"
              }
            }]
          },
          onChange: function onChange() {}
        }), !s && jsx$1(VisualTag, {
          image: "images/gosite-sites-text-tag.svg",
          sx: {
            position: "absolute",
            top: "-15px",
            left: i ? "-25px" : "-30px"
          }
        })]
      }) : jsx$1(Text, _assign$({
        variant: i ? "h2" : "h4",
        fontFamily: l.typography.fontFamily,
        fontWeight: l.typography.fontWeightBold
      }, {
        children: t
      })), jsx$1(Text, _assign$({
        variant: "subtitle2",
        color: l.palette.primary.main,
        fontFamily: l.typography.fontFamily,
        fontWeight: l.typography.fontWeightBold
      }, {
        children: r
      }))]
    }));
  },
  NextArrow: function NextArrow(e) {
    var t = e.onClick,
        r = e.arrowStyle;
    return jsx$1(ArrowWrapper, _assign$({
      onClick: t,
      style: _assign$({}, r)
    }, {
      children: jsx$1(AiOutlineArrowRight, {})
    }));
  },
  PrevArrow: function PrevArrow(e) {
    var t = e.onClick,
        r = e.arrowStyle;
    return jsx$1(ArrowWrapper, _assign$({
      onClick: t,
      style: _assign$({}, r)
    }, {
      children: jsx$1(AiOutlineArrowLeft, {})
    }));
  }
},
    CommonRoot = styled$2(Box)(function (e) {
  return {
    margin: "0 auto",
    maxWidth: "initial",
    position: "relative",
    fontFamily: e.theme.typography.fontFamily
  };
}),
    ArrowWrapper = styled$2(Box)(function () {
  return {
    background: "#FFFFFF",
    borderRadius: "4px",
    padding: "10px",
    cursor: "pointer"
  };
}),
    SitesPageSections = {
  Header: function Header(e) {
    var t = e.data,
        r = e.isMobileView,
        n = e.isPreviewOn,
        a = useTheme$4(),
        o = useRef(null),
        i = useState(""),
        s = i[0],
        l = i[1],
        c = useDeviceDetect().isMobile,
        u = !0 === r || c;
    return jsx$1(HeaderRoot, _assign$({
      sx: {
        flexDirection: "row"
      }
    }, {
      children: jsx$1(AppBar, _assign$({
        position: "sticky",
        color: "inherit"
      }, {
        children: jsxs(Toolbar, _assign$({
          sx: {
            justifyContent: "space-between",
            minHeight: "0 !important"
          },
          disableGutters: !0
        }, {
          children: ["" === s && jsx$1(Tooltip, _assign$({
            title: jsxs(Fragment, {
              children: [jsx$1("input", {
                ref: o,
                hidden: !0,
                type: "file",
                accept: "image/*",
                style: {
                  display: "none"
                },
                onChange: function onChange(e) {
                  return function (e) {
                    l(URL.createObjectURL(e.target.files[0]));
                  }(e);
                }
              }), jsx$1(Button, _assign$({
                onClick: function onClick() {
                  var e;
                  return null === (e = null == o ? void 0 : o.current) || void 0 === e ? void 0 : e.click();
                },
                sx: {
                  textTransform: "initial"
                },
                startIcon: jsx$1(BsUpload, {
                  fill: a.palette.text.primary
                })
              }, {
                children: jsx$1(Text, _assign$({
                  color: "#0357FF"
                }, {
                  children: "Upload your logo"
                }))
              }))]
            }),
            arrow: !0,
            leaveDelay: 5e4,
            componentsProps: {
              tooltip: {
                sx: {
                  bgcolor: a.palette.common.white,
                  "& .MuiTooltip-arrow": {
                    color: a.palette.common.white
                  }
                }
              }
            }
          }, {
            children: jsxs(HeaderButton, _assign$({
              sx: {
                margin: u ? 0 : a.spacing(1, 2)
              }
            }, {
              children: [jsx$1(Text, _assign$({
                variant: "heading",
                fontWeight: 700,
                sx: {
                  fontSize: u ? "12px" : "18px"
                }
              }, {
                children: t.logotext
              })), !1 === n && jsx$1(VisualTag, {
                image: "images/gosite-sites-image-tag.svg",
                sx: {
                  position: "absolute",
                  right: "-40px"
                }
              })]
            }))
          })), "" !== s && jsx$1("img", {
            src: s,
            alt: "logo",
            height: 48
          }), jsxs(Box, _assign$({
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center"
          }, {
            children: [!0 === n && !u && jsx$1(Stack$2, _assign$({
              spacing: 4,
              direction: "row"
            }, {
              children: t.menuList.map(function (e) {
                return jsx$1(Text, _assign$({
                  variant: "caption",
                  fontFamily: a.typography.fontFamily,
                  fontWeight: a.typography.fontWeightSemiBold
                }, {
                  children: e.text
                }), e.id);
              })
            })), jsx$1(IconButton$2, _assign$({
              edge: "end",
              color: "inherit",
              "aria-label": "menu",
              sx: {
                backgroundColor: "#A5E342",
                borderRadius: "0%",
                padding: 2,
                ml: 4,
                mr: 0
              }
            }, {
              children: jsx$1(FiMenu, {})
            }))]
          }))]
        }))
      }))
    }));
  },
  Footer: function Footer(e) {
    var t = e.data;
    e.isMobileView;
    var r = useTheme$4();
    return jsx$1(Box, _assign$({
      textAlign: "center",
      sx: {
        padding: r.spacing(5, 2),
        background: r.palette.primary.dark
      }
    }, {
      children: t.text.map(function (e) {
        return jsx$1(Text, _assign$({
          color: "common.white"
        }, {
          children: e.text
        }), e.id);
      })
    }));
  },
  Hero: function Hero(e) {
    var t = e.data,
        r = e.isMobileView,
        n = e.isPreviewOn,
        a = t.ctaButton,
        o = t.description,
        i = t.title,
        s = t.edit,
        l = void 0 === s || s,
        c = useDeviceDetect().isMobile,
        u = !0 === r || c;
    return jsxs(HeroRoot, _assign$({
      sx: {
        paddingTop: u ? "200px" : "120px"
      }
    }, {
      children: [jsx$1(HeroBackground, {
        children: jsx$1("img", {
          src: u ? "/images/gosite-sites-hero-mobile.svg" : !0 === n ? "/images/gosite-sites-preview-hero.png" : "/images/gosite-sites-hero-desktop.png",
          width: "100%",
          height: u ? "550px" : "333px",
          alt: "background",
          style: {
            objectFit: "cover"
          }
        })
      }), jsx$1(HeroCard, _assign$({
        sx: {
          maxWidth: !0 === r || c ? 256 : 400
        },
        elevation: 6
      }, {
        children: jsxs(CardContent, {
          children: [jsx$1(SitesPageElements.SectionHero, {
            isPreviewOn: n,
            title: i,
            description: o,
            id: "GoSiteSitesWidget-hero",
            isMobileScreen: !0 === r || c,
            edit: l,
            ctaButton: a
          }), jsx$1(Stack$2, _assign$({
            direction: !0 === r || c ? "column" : "row",
            gap: 1,
            justifyContent: "center"
          }, {
            children: a.map(function (e) {
              return jsx$1(CtaButton, _assign$({
                variant: e.variant,
                size: "large",
                sx: {
                  backgroundColor: "contained" === e.variant ? "#A5E342 !important" : "",
                  borderColor: "outlined" === e.variant ? "common.black" : "",
                  "&:hover": {
                    backgroundColor: "contained" === e.variant ? "#A5E342 !important" : "transparent !important",
                    borderColor: "black !important"
                  }
                },
                startIcon: jsx$1("img", {
                  src: e.icon,
                  width: 16,
                  height: 16,
                  alt: e.alt
                })
              }, {
                children: jsx$1(Text, _assign$({
                  variant: "caption",
                  color: "common.black",
                  ml: 1,
                  lineHeight: 0,
                  whiteSpace: "nowrap"
                }, {
                  children: e.text
                }))
              }), e.id);
            })
          }))]
        })
      }))]
    }));
  },
  Services: function Services(e) {
    var t = e.data,
        r = e.isMobileView,
        n = e.isPreviewOn,
        a = useTheme$4(),
        o = t.title,
        i = t.description,
        s = t.serviceList,
        l = useDeviceDetect().isMobile;
    return jsx$1(Box, _assign$({
      sx: {
        background: a.palette.background.default,
        padding: a.spacing(6, 0)
      }
    }, {
      children: jsxs(Container, _assign$({
        maxWidth: "lg"
      }, {
        children: [jsx$1(SitesPageElements.SectionHeader, {
          isPreviewOn: n,
          title: o,
          description: i,
          id: "GoSiteSitesWidget-services",
          isMobileScreen: !0 === r || l
        }), jsx$1(List, _assign$({
          disablePadding: !0,
          sx: {
            display: "grid",
            gridTemplateColumns: !0 === r || l ? "repeat(1, 1fr)" : "repeat(2, 1fr)"
          }
        }, {
          children: s.map(function (e) {
            return jsxs(ListItem, {
              children: [jsx$1(ListItemIcon, {
                children: jsx$1(FiCheck, {
                  stroke: a.palette.primary.main,
                  strokeWidth: "4px"
                })
              }), jsx$1(ListItemText, {
                primary: jsx$1(Text, _assign$({
                  variant: "heading",
                  fontWeight: a.typography.fontWeightRegular,
                  pl: 2
                }, {
                  children: e.text
                }))
              })]
            }, e.id);
          })
        }))]
      }))
    }));
  },
  AboutUs: function AboutUs(e) {
    var t = e.data,
        r = e.isMobileView,
        n = e.isPreviewOn,
        a = useTheme$4(),
        o = t.title,
        i = t.description,
        s = t.aboutUs,
        l = useDeviceDetect().isMobile;
    return jsxs(Container, _assign$({
      maxWidth: "lg",
      sx: {
        padding: a.spacing(7, 2)
      }
    }, {
      children: [jsx$1(SitesPageElements.SectionHeader, {
        isPreviewOn: n,
        title: o,
        description: i,
        id: "GoSiteSitesWidget-aboutus",
        isMobileScreen: !0 === r || l
      }), jsx$1(Stack$2, _assign$({
        spacing: 2,
        direction: !0 === r || l ? "column" : "row",
        justifyContent: "center"
      }, {
        children: s.map(function (e) {
          return jsx$1(List, _assign$({
            sx: {
              width: "100%"
            }
          }, {
            children: jsxs(ListItem, _assign$({
              sx: {
                flexDirection: "column",
                textAlign: "center"
              }
            }, {
              children: [jsx$1(ListItemIcon, {
                children: jsx$1("img", {
                  src: e.icon,
                  height: 32,
                  width: 32,
                  alt: "icon"
                })
              }), jsx$1(ListItemText, {
                primary: e.title,
                secondary: jsx$1("div", {
                  children: e.description.map(function (e) {
                    return jsxs(Box, _assign$({
                      display: "flex",
                      alignItems: "center"
                    }, {
                      children: [jsx$1(FiCheck, {
                        stroke: a.palette.primary.main
                      }), jsx$1(Text, _assign$({
                        variant: "subtitle2",
                        color: "black",
                        pl: 2
                      }, {
                        children: e.text
                      }))]
                    }), e.id);
                  })
                }),
                secondaryTypographyProps: {
                  display: "flex",
                  justifyContent: "center",
                  paddingTop: 1
                },
                primaryTypographyProps: {
                  fontWeight: a.typography.fontWeightSemiBold,
                  width: !0 === r || l ? "initial" : 144
                }
              })]
            }))
          }), e.id);
        })
      }))]
    }));
  },
  Reviews: function Reviews(e) {
    var t = e.data,
        r = e.isMobileView,
        n = e.isPreviewOn,
        a = useTheme$4(),
        o = useState(),
        i = o[0],
        s = o[1],
        l = t.title,
        c = t.description,
        u = t.customerReviews,
        d = t.imageList,
        p = useDeviceDetect().isMobile;
    return jsxs(Fragment, {
      children: [jsx$1(ReviewSlider, _assign$({}, _assign$(_assign$({}, reviewsSliderSettings), imageGallerySliderSettings), {
        sx: {
          display: "flex",
          alignItems: "center",
          padding: a.spacing(7, 0)
        }
      }, {
        children: d.map(function (e) {
          return jsx$1(Box, _assign$({
            margin: 1
          }, {
            children: jsx$1("img", {
              src: e.image,
              alt: "carousal"
            })
          }), e.id);
        })
      })), jsxs("div", _assign$({
        style: {
          background: a.palette.background.default,
          padding: a.spacing(7, 3)
        }
      }, {
        children: [jsx$1(SitesPageElements.SectionHeader, {
          isPreviewOn: n,
          title: l,
          description: c,
          id: "GoSiteSitesWidget-reviews",
          isMobileScreen: !0 === r || p
        }), jsx$1(Container, _assign$({
          maxWidth: "lg",
          sx: {
            paddingY: !0 === r || p ? 0 : a.spacing(7)
          }
        }, {
          children: jsx$1(ReviewSlider, _assign$({}, reviewsSliderSettings, {
            sx: {
              display: "flex",
              alignItems: "center"
            }
          }, {
            children: u.map(function (e) {
              var t = e.id,
                  r = e.text,
                  n = e.customerName,
                  o = e.date,
                  l = e.rating;
              return jsxs(Container, _assign$({
                maxWidth: "md"
              }, {
                children: [jsx$1(StyledRating, {
                  name: "read-only",
                  value: l,
                  readOnly: !0,
                  size: "small"
                }), jsx$1(Text, _assign$({
                  variant: "h6",
                  fontWeight: a.typography.fontWeightRegular,
                  mb: 3,
                  mt: 1
                }, {
                  children: r.length > 60 ? jsxs(Fragment, {
                    children: [i === t ? r : "".concat(String(r.slice(0, 90)), "..."), i !== t && jsxs(Box, _assign$({
                      display: "flex",
                      alignItems: "center",
                      color: a.palette.primary.light,
                      sx: {
                        cursor: "pointer",
                        mt: .5
                      }
                    }, {
                      children: [jsx$1(Text, _assign$({
                        onClick: function onClick() {
                          return function (e) {
                            s(e !== i ? e : null);
                          }(t);
                        }
                      }, {
                        children: "Read More"
                      })), jsx$1(MdOutlineKeyboardArrowDown, {})]
                    }))]
                  }) : r
                })), jsx$1(Text, _assign$({
                  variant: "subtitle1"
                }, {
                  children: n
                })), jsxs(Text, _assign$({
                  variant: "subtitle2",
                  color: a.palette.primary.light
                }, {
                  children: [o, jsx$1(FaYelp, {})]
                }))]
              }), t);
            })
          }))
        }))]
      }))]
    });
  },
  ContactUs: function ContactUs(e) {
    var t = e.data,
        r = e.isMobileView,
        n = e.isPreviewOn,
        a = useTheme$4(),
        o = useDeviceDetect().isMobile,
        i = t.title,
        s = t.description,
        l = t.chatDescription,
        c = t.startChatButtonText,
        u = t.contactDetail;
    return jsxs(Grid$2, _assign$({
      container: !0
    }, {
      children: [jsxs(Grid$2, _assign$({
        item: !0,
        xs: 12,
        md: !0 === r || o ? 12 : 6,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        sx: {
          padding: a.spacing(7, 3),
          background: a.palette.common.white
        }
      }, {
        children: [jsx$1(Box, _assign$({
          width: "100%"
        }, {
          children: jsx$1(SitesPageElements.SectionHeader, {
            isPreviewOn: n,
            title: i,
            description: s,
            id: "GoSiteSitesWidget-contactus",
            isMobileScreen: !0 === r || o
          })
        })), jsx$1(Box, _assign$({
          display: "flex",
          justifyContent: "center",
          textAlign: "center"
        }, {
          children: jsx$1(Text, _assign$({
            variant: "heading",
            fontWeight: a.typography.fontWeightRegular
          }, {
            children: l
          }))
        })), jsx$1(Button, _assign$({
          startIcon: jsx$1("img", {
            src: "/images/gosite-sites-bubble-rounded.svg",
            alt: "start-chat"
          }),
          sx: {
            background: "#A5E342 !important",
            color: a.palette.primary.dark,
            padding: a.spacing(1.5, 3),
            borderRadius: a.spacing(4),
            marginTop: a.spacing(8)
          },
          fullWidth: (!0 === r || o) && !0
        }, {
          children: c
        }))]
      })), jsx$1(Grid$2, _assign$({
        item: !0,
        xs: 12,
        md: !0 === r || o ? 12 : 6,
        sx: {
          background: a.palette.background.paper,
          padding: a.spacing(8, 2)
        }
      }, {
        children: jsx$1(Stack$2, _assign$({
          textAlign: !0 === r || o ? "left" : "center",
          spacing: 6
        }, {
          children: u.map(function (e) {
            return jsxs(Box, {
              children: [jsxs(Text, _assign$({
                variant: "body2",
                fontWeight: a.typography.fontWeightBold,
                color: a.palette.primary.light
              }, {
                children: [e.label, null != e.chipText && jsx$1(Chip, {
                  sx: {
                    background: "white",
                    color: "red",
                    borderRadius: "0.2rem",
                    marginLeft: "0.5rem"
                  },
                  label: e.chipText
                })]
              })), jsx$1(Text, _assign$({
                variant: "heading",
                fontWeight: a.typography.fontWeightRegular,
                mt: 3
              }, {
                children: e.text
              })), Object.keys(e).some(function (e) {
                return "operatingHours" === e;
              }) && jsx$1(Fragment, {
                children: null == e ? void 0 : e.operatingHours.map(function (e) {
                  var t = e.id,
                      n = e.day,
                      i = e.time,
                      s = e.highlightWorkingday;
                  return jsx$1(Container, _assign$({
                    maxWidth: "xs"
                  }, {
                    children: jsxs(Grid$2, _assign$({
                      container: !0,
                      sx: {
                        color: !0 === s ? "text.primary" : a.palette.text.secondary,
                        whiteSpace: "pre-line"
                      },
                      justifyContent: !0 === r || o ? "" : "center",
                      pt: 1
                    }, {
                      children: [jsx$1(Grid$2, _assign$({
                        item: !0,
                        xs: 6,
                        md: 6,
                        textAlign: "left"
                      }, {
                        children: jsx$1(Text, {
                          children: n
                        })
                      })), jsx$1(Grid$2, _assign$({
                        item: !0,
                        xs: 6,
                        md: 6,
                        textAlign: "left"
                      }, {
                        children: jsx$1(Text, {
                          children: i
                        })
                      }))]
                    }))
                  }), t);
                })
              })]
            }, e.id);
          })
        }))
      }))]
    }));
  }
},
    HeaderRoot = styled$2(Box)(function (e) {
  return e.theme, {
    display: "flex",
    flexGrow: 1,
    height: 56,
    position: "relative",
    zIndex: 1
  };
}),
    HeaderButton = styled$2(Button)(function (e) {
  return {
    position: "relative",
    textTransform: "inherit",
    color: e.theme.palette.common.black,
    border: "1px solid transparent",
    "&:hover": {
      border: "2px dashed #0357FF"
    }
  };
}),
    CtaButton = styled$2(Button)(function (e) {
  return {
    borderWidth: "1px !important",
    height: 44,
    borderRadius: 24,
    marginTop: e.theme.spacing(2)
  };
}),
    HeroRoot = styled$2(Box)(function (e) {
  var t;
  return (t = {
    background: "#F7FCE8",
    marginTop: -100,
    position: "relative",
    paddingBottom: 120,
    display: "flex",
    justifyContent: "center"
  })[e.theme.breakpoints.up("md")] = {
    background: "#F7FCE8",
    marginTop: 0
  }, t;
}),
    HeroCard = styled$2(Card)(function (e) {
  return e.theme, {
    overflow: "visible",
    position: "relative",
    zIndex: 1,
    padding: 24
  };
}),
    HeroBackground = styled$2(Box)(function (e) {
  return e.theme, {
    overflow: "hidden",
    position: "absolute",
    left: 0,
    right: 0,
    top: 0,
    height: 333
  };
}),
    StyledRating = styled$2(Rating)(function (e) {
  return {
    "& .MuiRating-iconFilled": {
      color: e.theme.palette.primary.main
    }
  };
}),
    ReviewSlider = styled$2(Slider)(function (e) {
  return e.theme, {
    "& .slick-slider": {
      display: "flex"
    },
    "& .slick-track": {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "2000px !important"
    },
    "& .slick-dots": {
      bottom: "-76px"
    },
    "& .slick-dots li button:before": {
      color: "#A5E342",
      opacity: "0.25",
      fontSize: "12px"
    },
    "& .slick-dots li.slick-active button:before": {
      opacity: "unset"
    }
  };
}),
    reviewsSliderSettings = {
  dots: !0,
  infinite: !1,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 3,
  variableWidth: !0,
  initialSlide: 1,
  nextArrow: jsx$1(SitesPageElements.NextArrow, {
    onClick: void 0,
    arrowStyle: {}
  }),
  prevArrow: jsx$1(SitesPageElements.PrevArrow, {
    onClick: void 0,
    arrowStyle: {}
  }),
  responsive: [{
    breakpoint: 1024,
    settings: {
      slidesToShow: 3,
      slidesToScroll: 3
    }
  }, {
    breakpoint: 900,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: !1
    }
  }]
},
    nextArrowStyle = {
  position: "absolute",
  zIndex: 1,
  left: "1rem"
},
    prevArrowStyle = {
  position: "absolute",
  zIndex: 1,
  right: "1rem"
},
    imageGallerySliderSettings = {
  dots: !1,
  slidesToShow: 3,
  slidesToScroll: 3,
  initialSlide: 0,
  nextArrow: jsx$1(SitesPageElements.NextArrow, {
    onClick: void 0,
    arrowStyle: prevArrowStyle
  }),
  prevArrow: jsx$1(SitesPageElements.PrevArrow, {
    onClick: void 0,
    arrowStyle: nextArrowStyle
  })
},
    SitesPage = function SitesPage(e) {
  var t = e.themeColor,
      r = e.isPreviewOn,
      n = e.isMobileView,
      a = void 0 !== n && n;
  useEffect(function () {
    var e = document.createElement("link");
    e.rel = "stylesheet", e.href = "https://fonts.googleapis.com/css2?family=Spartan", e.onload = function () {
      return document.body.classList.add("wf-active");
    }, document.head.appendChild(e);
  }, []);
  var o = createTheme$2({
    palette: {
      primary: {
        main: "#A5E342",
        dark: "#375218",
        light: "#4E7A18"
      },
      background: {
        paper: "#F7F9FB",
        default: "#F7FCE8"
      },
      text: {
        primary: "#082244",
        secondary: "#8290A1"
      }
    },
    typography: {
      fontFamily: "Spartan",
      fontWeightSemiBold: 600,
      subtitle2: {},
      heading: {},
      subtitle3: {},
      caption2: {},
      caption3: {}
    }
  }),
      i = {};
  null != t && "" !== t && (i.palette = {
    primary: {
      main: "light" === t ? "#A5E342" : "#375218"
    }
  });
  var s = createTheme$2(o, i),
      l = SitesPageSections.AboutUs,
      c = SitesPageSections.ContactUs,
      u = SitesPageSections.Footer,
      d = SitesPageSections.Header,
      p = SitesPageSections.Hero,
      g = SitesPageSections.Reviews,
      m = {
    "sites-header": d,
    "sites-hero": p,
    "sites-services": SitesPageSections.Services,
    "sites-about-us": l,
    "sites-reviews": g,
    "sites-contact-us": c,
    "sites-footer": u
  };
  return jsx$1(ThemeProvider, _assign$({
    theme: s
  }, {
    children: SITES_PAGE_DATA.sections.map(function (e) {
      var t = m[e.__component];
      return jsx$1(t, {
        data: e,
        isPreviewOn: r,
        isMobileView: a
      });
    })
  }));
},
    BrowserMockup = function BrowserMockup() {
  return jsx$1(StyledBox, {});
},
    StyledBox = styled$2(Box)(function (e) {
  return e.theme, {
    borderTop: "2em solid rgba(230, 230, 230, 0.7)",
    position: "relative",
    borderRadius: "3px 3px 0 0",
    flex: 1,
    "::before": {
      display: "block",
      position: "absolute",
      content: '""',
      top: "-1.25em",
      left: "1em",
      width: "0.5em",
      height: "0.5em",
      borderRadius: "50%",
      backgroundColor: "#a9a9a9 ",
      boxShadow: "0 0 0 2px #a9a9a9 , 1.5em 0 0 2px #a9a9a9 , 3em 0 0 2px #a9a9a9 "
    }
  };
}),
    SitesWidgetPreviewToolbar = function SitesWidgetPreviewToolbar(e) {
  var t = e.onClose,
      r = e.onClickPreviewMode,
      n = e.previewMode,
      a = __rest$1(e, ["onClose", "onClickPreviewMode", "previewMode"]),
      o = useTheme$4(),
      i = useMediaQuery(o.breakpoints.up("md")),
      s = function s(e) {
    r(e);
  };

  return jsxs(Wrapper$1, _assign$({}, a, {
    children: [jsx$1(Link, {
      children: jsx$1("img", i ? {
        src: "/images/gosite-sites-logo.svg",
        width: 100,
        height: 32
      } : {
        src: "/images/gosite-sites-logo.svg",
        width: 88,
        height: 28
      })
    }), jsxs(Stack$2, _assign$({
      direction: "row",
      spacing: {
        xs: 1,
        md: 2
      }
    }, {
      children: [jsx$1(Button, _assign$({
        onClick: t
      }, {
        children: "Close"
      })), i ? jsxs(IconWrapper$1, _assign$({
        display: "flex",
        sx: {
          border: "1px solid #DBE3EB"
        }
      }, {
        children: [jsx$1(IconButton$2, _assign$({
          "aria-label": "Dekstop",
          sx: {
            color: "desktop" === n ? colors.blue[700] : "#8290A2",
            background: "desktop" === n ? o.palette.common.white : colors.grey[200],
            borderRadius: "0"
          },
          onClick: function onClick() {
            return s("desktop");
          }
        }, {
          children: jsx$1(AiOutlineDesktop, {
            size: i ? "22" : "15"
          })
        })), jsx$1(Divider, {
          orientation: "vertical",
          variant: "fullWidth",
          flexItem: !0,
          color: o.palette.common.white
        }), jsx$1(IconButton$2, _assign$({
          "aria-label": "Phone",
          sx: {
            color: "mobile" === n ? colors.blue[700] : "#8290A2",
            background: "mobile" === n ? o.palette.common.white : colors.grey[200],
            borderRadius: "0"
          },
          onClick: function onClick() {
            return s("mobile");
          }
        }, {
          children: jsx$1(AiOutlineMobile, {
            size: i ? "22" : "15"
          })
        }))]
      })) : jsx$1(Fragment, {}), jsx$1(Button, _assign$({
        variant: "contained",
        size: i ? "medium" : "small"
      }, {
        children: "Claim Website"
      }))]
    }))]
  }));
},
    Wrapper$1 = styled$2(Box)(function (e) {
  var t,
      r = e.theme;
  return (t = {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    margin: r.spacing(2, 3)
  })[r.breakpoints.down("md")] = {
    padding: r.spacing(1, 1)
  }, t;
}),
    IconWrapper$1 = styled$2(Box)(function (e) {
  var t = e.theme;
  return {
    border: "1px solid ".concat(hexToRgba(t.palette.common.white, .5))
  };
});

function RiMoonClearLine(e) {
  return GenIcon({
    tag: "svg",
    attr: {
      viewBox: "0 0 24 24"
    },
    child: [{
      tag: "g",
      attr: {},
      child: [{
        tag: "path",
        attr: {
          fill: "none",
          d: "M0 0h24v24H0z"
        }
      }, {
        tag: "path",
        attr: {
          fillRule: "nonzero",
          d: "M10 6a8 8 0 0 0 11.955 6.956C21.474 18.03 17.2 22 12 22 6.477 22 2 17.523 2 12c0-5.2 3.97-9.474 9.044-9.955A7.963 7.963 0 0 0 10 6zm-6 6a8 8 0 0 0 8 8 8.006 8.006 0 0 0 6.957-4.045c-.316.03-.636.045-.957.045-5.523 0-10-4.477-10-10 0-.321.015-.64.045-.957A8.006 8.006 0 0 0 4 12zm14.164-9.709L19 2.5v1l-.836.209a2 2 0 0 0-1.455 1.455L16.5 6h-1l-.209-.836a2 2 0 0 0-1.455-1.455L13 3.5v-1l.836-.209A2 2 0 0 0 15.29.836L15.5 0h1l.209.836a2 2 0 0 0 1.455 1.455zm5 5L24 7.5v1l-.836.209a2 2 0 0 0-1.455 1.455L21.5 11h-1l-.209-.836a2 2 0 0 0-1.455-1.455L18 8.5v-1l.836-.209a2 2 0 0 0 1.455-1.455L20.5 5h1l.209.836a2 2 0 0 0 1.455 1.455z"
        }
      }]
    }]
  })(e);
}

var SitesWidgetToolbar = function SitesWidgetToolbar(e) {
  var t = e.onClickThemeToggle,
      r = e.onClickPreview,
      n = e.onClickPreviewMode,
      a = e.onDone,
      o = __rest$1(e, ["onClickThemeToggle", "onClickPreview", "onClickPreviewMode", "onDone"]),
      i = useTheme$4(),
      s = useMediaQuery(i.breakpoints.up("md")),
      l = useState("light"),
      c = l[0],
      u = l[1],
      d = useState("desktop"),
      p = d[0],
      g = d[1];

  return jsx$1(Wrapper, _assign$({}, o, {
    children: jsxs(Grid$2, _assign$({
      container: !0
    }, {
      children: [jsxs(Grid$2, _assign$({
        item: !0,
        xs: 6,
        md: 6,
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between"
      }, {
        children: [jsxs(IconWrapper, _assign$({
          sx: {
            borderRadius: 12
          }
        }, {
          children: [jsx$1(IconButton$2, _assign$({
            "aria-label": "Sun",
            className: "".concat("light" === c ? "active" : ""),
            onClick: function onClick() {
              u("light"), t("light");
            }
          }, {
            children: jsx$1(FiSun, {})
          })), jsx$1(IconButton$2, _assign$({
            "aria-label": "Moon",
            className: "".concat("dark" === c ? "active" : ""),
            onClick: function onClick() {
              u("dark"), t("dark");
            }
          }, {
            children: jsx$1(RiMoonClearLine, {})
          }))]
        })), s ? jsxs(IconWrapper, {
          children: [jsx$1(IconButton$2, _assign$({
            "aria-label": "Dekstop",
            className: "".concat("desktop" === p ? "active" : ""),
            onClick: function onClick() {
              g("desktop"), n("desktop");
            }
          }, {
            children: jsx$1(AiOutlineDesktop, {})
          })), jsx$1(Divider, {
            orientation: "vertical",
            variant: "fullWidth",
            flexItem: !0,
            sx: {
              borderColor: getColorInStatus("inactive", i)
            }
          }), jsx$1(IconButton$2, _assign$({
            "aria-label": "Phone",
            className: "".concat("mobile" === p ? "active" : ""),
            onClick: function onClick() {
              g("mobile"), n("mobile");
            }
          }, {
            children: jsx$1(AiOutlineMobile, {})
          }))]
        }) : jsx$1(Fragment, {}), jsx$1(IconWrapper, s ? {
          children: jsx$1(Button, _assign$({
            onClick: function onClick() {
              return r();
            },
            variant: "outlined",
            startIcon: jsx$1(HiOutlineEye, {
              color: i.palette.common.white
            }),
            sx: {
              color: i.palette.common.white,
              textTransform: "none",
              fontWeight: i.typography.fontWeightSemiBold
            }
          }, {
            children: "Preview"
          }))
        } : {
          children: jsx$1(IconButton$2, _assign$({
            sx: {
              paddingX: 1
            },
            "aria-label": "Preview",
            onClick: function onClick() {
              return r();
            }
          }, {
            children: jsx$1(HiOutlineEye, {
              color: i.palette.common.white
            })
          }))
        })]
      })), jsx$1(Grid$2, _assign$({
        item: !0,
        xs: 6,
        md: 6,
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-end",
        alignItems: "center",
        spacing: {
          xs: 1.5,
          md: 3
        }
      }, {
        children: jsx$1(IconWrapper, {
          children: jsx$1(Button, _assign$({
            size: "medium",
            sx: {
              paddingY: "8px !important"
            },
            onClick: function onClick() {
              return a();
            }
          }, {
            children: jsx$1(Text, _assign$({
              color: "white",
              fontSize: 14,
              fontWeight: i.typography.fontWeightBold
            }, {
              children: " Done editing "
            }))
          }))
        })
      }))]
    }))
  }));
},
    getColorInStatus = function getColorInStatus(e, t) {
  return "active" === e ? t.palette.common.white : hexToRgba(t.palette.common.white, .5);
},
    Wrapper = styled$2(Box)(function (e) {
  var t = e.theme;
  return {
    padding: t.spacing(1, 2),
    background: t.palette.primary.main,
    justifyContent: "space-between",
    borderRadius: "32px",
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
  };
}),
    IconWrapper = styled$2(Box)(function (e) {
  var t,
      r = e.theme;
  return (t = {
    marginLeft: 8,
    border: "1px solid ".concat(getColorInStatus("inactive", r)),
    borderRadius: 2,
    display: "flex",
    alignItems: "center",
    overflow: "hidden"
  })["& .".concat(iconButtonClasses$1.root)] = {
    borderRadius: 0,
    color: getColorInStatus("inactive", r)
  }, t["& .".concat(iconButtonClasses$1.root, ".active")] = {
    color: getColorInStatus("active", r)
  }, t;
}),
    SitesWidget = function SitesWidget(e) {
  var t = __rest$1(e, []),
      r = useState("desktop"),
      n = r[0],
      a = r[1],
      o = useState(!1),
      i = o[0],
      s = o[1],
      l = useState("none"),
      c = l[0],
      u = l[1],
      d = useState("light"),
      p = d[0],
      g = d[1],
      m = useDeviceDetect().isMobile;

  return useEffect(function () {
    setTimeout(function () {
      var e = document.querySelectorAll(".codex-editor__redactor");
      e.forEach(function (e) {
        e.style.marginRight = "0";
      }), e.forEach(function (e) {
        var t = e.getElementsByTagName("font");
        null != t[0] && ("heroClass" === t[0].getAttribute("class") ? (t[0].style.fontSize = "mobile" === n || m ? "38px" : "62px", t[0].style.lineHeight = "mobile" === n || m ? "41.8px" : "72px") : (t[0].style.fontSize = "mobile" === n || m ? "24px" : "34px", t[0].style.lineHeight = "mobile" === n || m ? "36.4px" : "47.6px"));
      });
    }, 100);
  }, [n]), useEffect(function () {
    var e;
    setTimeout(function () {
      u("block");
    }, 2500), setTimeout(function () {
      var t = document.querySelectorAll(".codex-editor");
      i ? (e = $(".GoSiteSitesWidget-mainContent").children(), t.forEach(function (e) {
        e.style.pointerEvents = "none";
      }), $(".GoSiteSitesWidget-previewRoot").empty(), $(".GoSiteSitesWidget-previewRoot").append(e)) : (a("desktop"), $(".GoSiteSitesWidget-mainContent").append(e), t.forEach(function (e) {
        e.style.pointerEvents = "initial";
      }));
    }, 100);
  }, [i]), jsxs(Root, {
    children: [jsxs(Container, _assign$({
      sx: {
        width: {
          md: "mobile" === n ? 500 : "100%"
        }
      }
    }, {
      children: [jsx$1(BrowserMockup, {}), jsx$1(MainContent, _assign$({
        className: "GoSiteSitesWidget-mainContent",
        sx: {
          border: m || "mobile" === n ? "none" : "24px solid #dce3ea"
        }
      }, {
        children: jsx$1(SitesPage, {
          themeColor: p,
          isPreviewOn: i,
          isMobileView: "mobile" === n
        })
      })), jsx$1(ToolBar, _assign$({}, t, {
        onClickPreview: function onClickPreview() {
          return s(!0);
        },
        onClickPreviewMode: a,
        onClickThemeToggle: g,
        className: "GoSiteSitesWidget-toolbar",
        sx: {
          display: c
        }
      }))]
    })), jsxs(Dialog, _assign$({
      open: i,
      fullScreen: !0
    }, {
      children: [jsx$1(SitesWidgetPreviewToolbar, {
        onClose: function onClose() {
          s(!1);
        },
        previewMode: n,
        onClickPreviewMode: a,
        className: "GositeSitesWidget-previewToolbar"
      }), jsx$1(Container, _assign$({
        sx: {
          width: {
            md: "mobile" === n ? 450 : "100%"
          }
        }
      }, {
        children: jsx$1(PreviewRoot, {
          className: "GoSiteSitesWidget-previewRoot"
        })
      }))]
    }))]
  });
},
    Root = styled$2(Box)(function (e) {
  var t;
  return (t = {
    ".ce-toolbar": {
      display: "none"
    }
  })[e.theme.breakpoints.up("md")] = {
    marginLeft: "100px"
  }, t["& .ce-toolbar"] = {
    display: "none"
  }, t;
}),
    MainContent = styled$2(Box)(function (e) {
  return e.theme, {
    height: 900,
    overflowY: "auto"
  };
}),
    PreviewRoot = styled$2(Box)(function () {
  return {
    height: 900
  };
}),
    ToolBar = styled$2(SitesWidgetToolbar)(function (e) {
  return {
    position: "absolute",
    margin: e.theme.spacing(2),
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 1,
    boxShadow: "0 1px 2px rgba(0,0,0,0.07), \n                0 2px 4px rgba(0,0,0,0.07), \n                0 4px 8px rgba(0,0,0,0.07), \n                0 8px 16px rgba(0,0,0,0.07),\n                0 16px 32px rgba(0,0,0,0.07), \n                0 32px 64px rgba(0,0,0,0.07)"
  };
}),
    TestimonialsGroup = function TestimonialsGroup(e) {
  var t = e.data,
      r = useState(0),
      n = r[0],
      a = r[1],
      o = t.testimonials[n];
  return jsxs("section", _assign$({
    className: "text-center text-lg bg-gray-200 pt-12 pb-16"
  }, {
    children: [jsx$1("h2", _assign$({
      className: "title mb-4"
    }, {
      children: t.title
    })), jsx$1("p", _assign$({
      className: "text-gray-700 mb-4"
    }, {
      children: t.description
    })), jsx$1(Link, _assign$({
      link: t.link
    }, {
      children: jsx$1("span", _assign$({
        className: "with-arrow text-blue-700 hover:underline"
      }, {
        children: t.link.text
      }))
    })), jsxs("div", _assign$({
      className: "max-w-5xl w-8/12 sm:w-8/12 bg-white shadow-md sm:shadow-xl mx-auto flex flex-col sm:flex-row mt-10 text-left"
    }, {
      children: [jsx$1("div", _assign$({
        className: "w-full md:w-4/12 flex-shrink-0"
      }, {
        children: jsx$1(CmsImage, {
          media: o.picture
        })
      })), jsxs("div", _assign$({
        className: "px-4 py-4 sm:px-12 sm:pt-12 sm:pb-4 flex flex-col justify-between"
      }, {
        children: [jsxs("div", {
          children: [jsx$1(CmsImage, {
            width: 120,
            height: 33,
            media: o.logo
          }), jsxs("p", _assign$({
            className: "italic mb-6"
          }, {
            children: ['"', o.text, '"']
          })), jsx$1("p", _assign$({
            className: "font-bold text-base sm:text-sm"
          }, {
            children: o.authorName
          })), jsx$1("p", _assign$({
            className: "text-base sm:text-sm"
          }, {
            children: o.authorTitle
          }))]
        }), jsx$1(Link, _assign$({
          link: {
            url: o.link,
            text: "",
            newTab: !1,
            id: 0
          }
        }, {
          children: jsx$1("span", _assign$({
            className: "uppercase tracking-wide text-blue-700 hover:underline  with-arrow sm:self-end mt-6 sm:mt-0"
          }, {
            children: "Read story"
          }))
        }))]
      }))]
    })), t.testimonials.length > 1 && jsx$1("div", _assign$({
      className: "flex flex-row gap-4 mt-10 justify-center"
    }, {
      children: t.testimonials.map(function (e, t) {
        return jsx$1("button", {
          onClick: function onClick() {
            return a(t);
          },
          className: classNames("rounded-full h-3 w-3", {
            "bg-gray-500": t !== n,
            "bg-primary-600": t === n
          })
        }, e.id);
      })
    })), jsx$1("div", _assign$({
      className: "flex flex-row flex-wrap items-center gap-6 sm:gap-20 justify-center mt-10 px-6 sm:px-0 "
    }, {
      children: t.logos.map(function (e) {
        return jsx$1(CmsImage, {
          width: 120,
          height: 33,
          media: e.logo
        }, e.id);
      })
    }))]
  }));
};

export { AccordianGroup, AnimatedMenuIcon, AppLinkNotificationBanner, Article, ArticleColumnsGroup, AudioTestimonialGroup, AudioVisualizers, BODY_FONT_FAMILY, BackgroundMedia$1 as BackgroundMedia, BookingEmailConfirmation, BookingServiceDetails, BookingWidget, BrowserMockup, Button, ChatBody, ChatFooter, ChevronDown$1 as ChevronDown, CmsImage, CookieConsent, Download, DownloadMobileApp, EditorJs, EditorJsDataParser, EmailBody$2 as EmailBody, EmailBodyContent, EmailConfirmation, Feature, FeatureColumnsGroup, FeatureRowBody, FeatureRowsGroup, FeatureWide, Footer, FooterBottom, Form, FormButtonGroup, FormCheckbox, FormCheckboxGroup, FormCustom, FormDropdown, FormHeading, FormHubSpot, FormInput, FormPart, FormRadioGroup, FormSection, FormSeparator, FormSubmitStatus, FormType, HERO_CTA_BUTTON_ANIMATION_CONFIG, HERO_CTA_CONFIG, HERO_SIGN_UP_FORM_ANIMATION_CONFIG, HERO_WIDGET_ANIMATION_CONFIG, HERO_WIDGET_INTERACTION_RESULT_ANIMATION_CONFIG, Hero, HeroBody, HeroCta, HeroMain, HeroOverview1, HeroSignUpForm, HeroTestimonial, HeroWidgetComponent, HeroWidgetInteractionResult, Image, ImageContainer, InfoIcon, InlineSVG, InnerHtml, Layout, Link, LinktextIcon, Loader, MEDIA_FORMATS, MESSENGER_CHAT_BUBBLE_ANIMATION_CONFIG, MailAt, Media, MediaCarousel, MediaPlayer, MessengerEmailConfirmation, MessengerWidget, MessengerWidgetBody, MobileNavMenu, Navbar, NavbarFeatureCta, NavigationChildItems, NavigationLinks, NotificationBanner, PageScript, Phone, PricingTable, ProductCta, ReviewConfirmationWidget, ReviewEmailBodyContent, ReviewWidget, Reviews, RichText, RightArrow, SITES_PAGE_DATA, Section, Sections, SegmentScript, SitesPage, SitesWidget, SitesWidgetPreviewToolbar, SitesWidgetToolbar, SmartPhone, StaticDatePicker, StaticTimePicker, SvgIcon$1 as SvgIcon, TITLE_FONT_FAMILY, Testimonial, TestimonialsGroup, Text, TextFieldSubmitCombo, ToggleButtonGroup, VisualTag, accordianGroupClasses, accordianGroupItemClasses, animatedMenuIconClasses, appLinkNotificationBannerClasess, articleClasses, articleColumnsGroupClasses, bookingHeroCTAMessageFormatter, downloadMobileAppClasses, engagementEmailBodyClasses, featureColumnClasses, featureColumnsGroupClasses, featureOverviewClasses, featureRowBodyClasses, flattenControlsHavingNameProperty, getComponentClassNamesObject, getFormFieldWidth, getLogo, getNavbarButtonColor, getNavbarLinkColor, getSectionId, getStrapiMedia, getUpdatedPrice, getUtmParams, headerClasses, heroBusinessClasses, heroCTAClasses, heroClasses, heroMainClasses, heroSectionComponents, heroWidgetModifierStyles, mediaCarouselClasses, messengerEmailConfirmationClasses, pricingPlanClasses, pricingTableClasses, productCTAClasses, projectName, reviewEmailConfirmationClasses, reviewHeroCTAMessageFormatter, reviewHeroWidgetModifierStyle, sectionComponents, sliderSettings, sliderSettingsProps, tabPanelItemClasses, tabPanelViewClasses, testimonial2Classes, testimonial3Classes, testimonialColumnsGroupClasses, testimonialTabItemClasses, textClasses, theme, themeObject, useAnalytics$1 as useAnalytics, useButton, useButtonStyles, useDeviceDetect, usePricing, usePublicAuth };